/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Dashboard = __webpack_require__(174);
	
	var _ProgramacionIGMensual = __webpack_require__(617);
	
	var _ProgramacionIGMensual2 = _interopRequireDefault(_ProgramacionIGMensual);
	
	var _ProgramacionIGSemanal = __webpack_require__(637);
	
	var _ProgramacionAIMensual = __webpack_require__(732);
	
	var _ProgramacionAIMensual2 = _interopRequireDefault(_ProgramacionAIMensual);
	
	var _ProgramacionAISemanal = __webpack_require__(739);
	
	var _ProgramacionAISemanal2 = _interopRequireDefault(_ProgramacionAISemanal);
	
	var _nominaIG = __webpack_require__(753);
	
	var _DetalleProgramacionIG = __webpack_require__(958);
	
	var _DetalleProgramacionAG = __webpack_require__(960);
	
	var _ProgramacionPublicada = __webpack_require__(961);
	
	var _MantenedorHospedajes = __webpack_require__(967);
	
	var _PaymentPartnersIndex = __webpack_require__(973);
	
	var _PaymentPartnersIndex2 = _interopRequireDefault(_PaymentPartnersIndex);
	
	var _AsignacionFondos = __webpack_require__(1020);
	
	var _RevisionRendiciones = __webpack_require__(1029);
	
	var _DetailsRendicion = __webpack_require__(1032);
	
	var _PanelDatosActa = __webpack_require__(1037);
	
	var _ConsolidadosDisponibles = __webpack_require__(1042);
	
	var _RevisionArchivoFinal = __webpack_require__(1046);
	
	var _MantenedorLocales = __webpack_require__(1059);
	
	var _MantenedorLocales2 = _interopRequireDefault(_MantenedorLocales);
	
	var _LiderDetalles = __webpack_require__(1060);
	
	var _StockStores = __webpack_require__(1064);
	
	var _MantenedorPersonal = __webpack_require__(1073);
	
	var _mantenedorCorreos = __webpack_require__(1081);
	
	var _captadoresZonas = __webpack_require__(1083);
	
	var _producciones = __webpack_require__(1087);
	
	var _MantenedorDistancias = __webpack_require__(1091);
	
	var _usuariosPendientes = __webpack_require__(1096);
	
	var _usuariosPendientes2 = _interopRequireDefault(_usuariosPendientes);
	
	var _CalendarMaintainer = __webpack_require__(1098);
	
	var _MantenedorDiferencias = __webpack_require__(1105);
	
	var _MantenedorResumenMensual = __webpack_require__(1114);
	
	var _InventariosFacturacion = __webpack_require__(1121);
	
	var _PeticionOC = __webpack_require__(1125);
	
	var _ServiciosRealizados = __webpack_require__(1130);
	
	var _MisFacturas = __webpack_require__(1133);
	
	var _ManagementOC = __webpack_require__(1137);
	
	var _BillingServices = __webpack_require__(1146);
	
	var _ReporteInventario = __webpack_require__(1150);
	
	var _FondosAsignados = __webpack_require__(1159);
	
	var _DetalleFondo = __webpack_require__(1163);
	
	var _index = __webpack_require__(1172);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _registro = __webpack_require__(1182);
	
	var _OperadoresPendientes = __webpack_require__(1187);
	
	var _Global = __webpack_require__(1192);
	
	var _fcmService = __webpack_require__(1195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = window.jQuery = __webpack_require__(1197);
	__webpack_require__(1199);
	// Librerias
	
	// LOGISTICA
	
	// PROVEEDORES
	
	// TREASURY
	
	// ANALISIS
	
	// ADMIN
	
	// FACTURACION
	
	// OPERACIONES TERRENO
	
	// EMERGENCY COVID
	
	// MODULO OPERADORES
	
	// NOTIFICACIONES
	
	
	/** ************************************************************* **/
	/** ************************ DASHBOARD ************************** **/
	/** ************************************************************* **/
	
	var mainDashboardDOM = document.getElementById('react-main-dashboard');
	if (mainDashboardDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_Dashboard.Dashboard, {
	        perms: window.laravelPerms,
	        idClient: window.laravelIdClient,
	        dateIndicator: window.laravelDateIndicator,
	        stockPending: false
	        //stockPending={window.laravelStockPending}
	    }), mainDashboardDOM);
	}
	
	var globalNotificationDOM = document.getElementById('global-notification');
	if (globalNotificationDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_Global.Global, null), globalNotificationDOM);
	}
	
	if (window.fcmConfig) {
	    (0, _fcmService.initFcm)(window.fcmConfig);
	}
	
	/** ************************************************************* **/
	/** ************************ LOGISTICA ************************** **/
	/** ************************************************************* **/
	
	/** PROGRAMACION IG MENSUAL **/
	var programacionIGMensualDOM = document.getElementById('react-programacionIG-mensual');
	if (programacionIGMensualDOM) {
	    var clientes = window.laravelClientes.filter(function (cliente) {
	        return cliente.activo;
	    });
	    _reactDom2.default.render(_react2.default.createElement(_ProgramacionIGMensual2.default, {
	        puedeModificar: window.laravelPuedeModificarInventarios,
	        puedeAgregar: window.laravelPuedeAgregarInventarios,
	        clientes: clientes
	    }), programacionIGMensualDOM);
	}
	
	/** PROGRAMACION IG SEMANAL **/
	var programacionIGSemanalDOM = document.getElementById('react-programacionIG-semanal');
	if (programacionIGSemanalDOM) {
	    /** SE FILTRAN CLIENTES EN INVENTARIO SEMANAL **/
	    var lideresOtros = window.laravelLideres.filter(function (lider) {
	        return lider.id === 990 || lider.id === 466 || lider.id === 10 || lider.id === 286 || lider.id === 33 || lider.id === 35 || lider.id === 62 || lider.id === 39 || lider.id === 37 || lider.id === 38 || lider.id === 40 || lider.id === 36 || lider.id === 1059 || lider.id === 1061 || lider.id === 66 || lider.id === 54 || lider.id === 41;
	    });
	    var _clientes = window.laravelClientes.filter(function (cliente) {
	        return cliente.activo;
	    });
	
	    _reactDom2.default.render(_react2.default.createElement(_ProgramacionIGSemanal.ProgramacionIGSemanal, {
	        puedeModificar: window.laravelPuedeModificarInventarios,
	        puedeModificarCaptador: window.laravelPuedeModificarCaptador,
	        puedeCambiarLiderSupervisor: window.laravelPuedeCambiarLiderSupervisor,
	        puedeModificarDotaciones: window.laravelPuedeModicarDotaciones,
	        puedeAprobarCambiosNominas: window.laravelPuedeAprobarCambiosNominas,
	        puedeAprobarAumentoDotacion: window.laravelPuedeAprobarAumentoDotacion,
	        puedeEditarStock: window.laravelPuedeModificarStock,
	        canEditStatusService: window.laravelCanEditStatusService,
	        puedeValidarComentarios: window.laravelPuedeValidarComentarios,
	        clientes: _clientes,
	        lideresOtros: lideresOtros,
	        lideres: window.laravelLideres,
	        supervisores: window.laravelSupervisores,
	        captadores: window.laravelCaptadores,
	        idUser: window.laravelidUser,
	        regiones: window.laravelRegiones
	    }), programacionIGSemanalDOM);
	}
	
	/** PROGRAMACIÓN AI MENSUAL */
	var programacionAIMensualDOM = document.getElementById('react-programacionAI-mensual');
	if (programacionAIMensualDOM) {
	    /** IMPORANTE: POR EL MOMENTO SOLO SE MUESTRAN AUDITORIAS DE FCV **/
	    _reactDom2.default.render(_react2.default.createElement(_ProgramacionAIMensual2.default, {
	        puedeModificar: window.laravelPuedeModificarAuditorias,
	        puedeAgregar: window.laravelPuedeAgregarAuditorias,
	        clientes: window.laravelClientes,
	        auditores: window.laravelAuditores
	    }), programacionAIMensualDOM);
	}
	
	/** PROGRAMACION AI SEMANAL **/
	var programacionAISemanalDOM = document.getElementById('react-programacionAI-semanal');
	if (programacionAISemanalDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_ProgramacionAISemanal2.default, {
	        puedeModificar: window.laravelPuedeModificarAuditorias,
	        puedeRevisar: laravelPuedeRevisarAuditorias,
	        puedeRevisarCliente: laravelPuedeRevisarCliente,
	        puedeRevisarCantidadMuestras: laravelPuedeRevisarCantidadMuestras,
	        puedeVerExcelFacturacion: laravelpuedeVerExcelFacturacion,
	        clientes: window.laravelClientes,
	        auditores: window.laravelAuditores,
	        fcv: window.laravelFcv
	    }), programacionAISemanalDOM);
	}
	
	/** PUBLICACION PROGRAMACION IG **/
	var programacionPublicada = document.getElementById('react-programacionIG-publicados');
	if (programacionPublicada) {
	    var _clientes2 = window.laravelClientes.filter(function (cliente) {
	        return cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SMU' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'BLX' || cliente.nombreCorto === 'RDS' || cliente.nombreCorto === 'WAL';
	    });
	    _reactDom2.default.render(_react2.default.createElement(_ProgramacionPublicada.ProgramacionPublicada, {
	        clientes: _clientes2
	    }), programacionPublicada);
	}
	
	/** NOMINAS **/
	var mantenedorNominaIGDOM = document.getElementById('react-nominaIG-nominaIG');
	if (mantenedorNominaIGDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_nominaIG.NominaIG, {
	        nomina: window.laravelNomina,
	        comunas: window.laravelComunas,
	        permisos: window.laravelPermisos,
	        bancos: window.laravelBancos,
	        tipoCuentas: window.laravelTipoCuentas
	    }), mantenedorNominaIGDOM);
	}
	
	/** DETALLES PROGRAMACION IG **/
	var mantenedorDetallesIG = document.getElementById('react-programacionIG-detalles');
	if (mantenedorDetallesIG) {
	    // let clientes = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB'
	    //     || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI'
	    //     || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA'
	    //     || cliente.nombreCorto === 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX'
	    //     || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP'
	    // );
	
	    _reactDom2.default.render(_react2.default.createElement(_DetalleProgramacionIG.DetalleProgramacionIG, {
	        clientes: window.laravelClientes,
	        regiones: window.laravelRegiones,
	        fechaInicio: window.laravelFechaInicio,
	        fechaFin: window.laravelFechaFin
	    }), mantenedorDetallesIG);
	}
	
	/** ************************************************************* **/
	/** ****************** ADMNINISTRACION ************************** **/
	/** ************************************************************* **/
	
	/** MANTENEDOR LOCALES **/
	var mantenedorLocalesDOM = document.getElementById('react-mantenedor-locales');
	if (mantenedorLocalesDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorLocales2.default, {
	        clientes: window.laravelClientes,
	        jornadas: window.laravelJornadas,
	        formatoLocales: window.laravelFormatoLocales,
	        comunas: window.laravelComunas
	    }), mantenedorLocalesDOM);
	}
	
	/** MANTENEDOR STOCK **/
	var stockStoresDOM = document.getElementById('react-mantenedor-stock');
	if (stockStoresDOM) {
	    var clients = window.laravelClientes.filter(function (cliente) {
	        return cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'BLX' || cliente.nombreCorto === 'RDS' || cliente.nombreCorto === 'LIQ' || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA' || cliente.nombreCorto == 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX' || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP' || cliente.nombreCorto === 'FAH';
	    });
	
	    _reactDom2.default.render(_react2.default.createElement(_StockStores.StockStores, {
	        clients: clients,
	        canShowSelect: window.laravelShowSelectClient
	    }), stockStoresDOM);
	}
	
	/** MANTENEDOR LIDERES **/
	var verLiderDetalle = document.getElementById('react-detalles-lider');
	
	if (verLiderDetalle) {
	    _reactDom2.default.render(_react2.default.createElement(_LiderDetalles.LiderDetalles, null), verLiderDetalle);
	}
	
	/** MANTENEDOR VALORES DISTANCIAS **/
	var verMantenedorDistancias = document.getElementById('react-mantenedor-distancias');
	
	if (verMantenedorDistancias) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorDistancias.MantenedorDistancias, null), verMantenedorDistancias);
	}
	
	/** MANTENEDOR USUARIOS **/
	var personalIndexDOM = document.getElementById('react-personal-index');
	if (personalIndexDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorPersonal.MantenedorPersonal, {
	        clientes: window.laravelClientes,
	        perms: window.laravelPerms,
	        documentationStatus: window.laravelDocumentationStatus
	    }), personalIndexDOM);
	}
	
	var correosDOM = document.getElementById('react-mantenedor-clientes');
	if (correosDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_mantenedorCorreos.MantenedorCorreos, {
	        clientes: window.laravelClientes
	    }), correosDOM);
	}
	
	/** MANTENEDOR PRODUCCIONES **/
	var mantenedorProducciones = document.getElementById('react-producciones');
	
	if (mantenedorProducciones) {
	    var _clientes3 = window.laravelClientes.filter(function (cliente) {
	        return cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'CID';
	    });
	    _reactDom2.default.render(_react2.default.createElement(_producciones.MantenedorProducciones, {
	        clientes: _clientes3
	    }), mantenedorProducciones);
	}
	
	/** USUARIOS PENDIENTES DESDE INVENTARIOS **/
	var mantenedorUsuariosPendientes = document.getElementById('react-usuariosPendientes');
	if (mantenedorUsuariosPendientes) {
	    _reactDom2.default.render(_react2.default.createElement(_usuariosPendientes2.default, {
	        clientes: window.laravelClientes
	    }), mantenedorUsuariosPendientes);
	}
	
	/** MANTENEDOR CAPTADORES POR ZONA **/
	var mantenedorCaptadoresZonas = document.getElementById('react-captadoresZonas');
	if (mantenedorCaptadoresZonas) {
	    _reactDom2.default.render(_react2.default.createElement(_captadoresZonas.MantenedorCaptadoresZonas, {
	        captadores: window.laravelCaptadores,
	        comunas: window.laravelComunas
	    }), mantenedorCaptadoresZonas);
	}
	
	/** CALENDAR MANTAINER **/
	var calendarMaintainer = document.getElementById('react-calendar-maintainer');
	if (calendarMaintainer) {
	    _reactDom2.default.render(_react2.default.createElement(_CalendarMaintainer.CalendarMaintainer, {
	        months: window.laravelMonths
	    }), calendarMaintainer);
	}
	/** ************************************************************* **/
	/** ******************** FACTURACION **************************** **/
	/** ************************************************************* **/
	
	/** REVISIÓN UNIDADES A FACTURAR **/
	var mantenedorDiferencias = document.getElementById('react-inventarios-diferencias');
	if (mantenedorDiferencias) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorDiferencias.MantenedorDiferencias, {
	        meses: window.laravelMeses,
	        permisos: window.laravelPermisos
	    }), mantenedorDiferencias);
	}
	
	/** REVISION AUDITORIAS A FACTURAR **/
	var mantenedorResumenMensual = document.getElementById('react-resumen-auditorias');
	
	if (mantenedorResumenMensual) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorResumenMensual.MantenedorResumenMensual, {
	        meses: window.laravelMeses,
	        permisos: window.laravelPermisos
	    }), mantenedorResumenMensual);
	}
	
	/** REVISION INVENTARIOS A FACTURAR (OTROS CLIENTES) **/
	var mantenedorInventariosFacturacion = document.getElementById('react-aprobacion-facturacion');
	
	if (mantenedorInventariosFacturacion) {
	    _reactDom2.default.render(_react2.default.createElement(_InventariosFacturacion.InventariosFacturacion, {
	        meses: window.laravelMeses,
	        clientes: window.laravelClientes,
	        permisos: window.laravelPermisos
	    }), mantenedorInventariosFacturacion);
	}
	
	/** MANTENEDOR GENERACION ORDEN DE COMPRA (PUC - SB) **/
	var mantenedorPeticionOC = document.getElementById('react-peticion-oc');
	
	if (mantenedorPeticionOC) {
	    _reactDom2.default.render(_react2.default.createElement(_PeticionOC.PeticionOC, {
	        inventarios: window.laravelInventarios,
	        cliente: window.laravelCliente,
	        sumaUnidades: window.laravelSumaUnidades,
	        valorBruto: window.laravelValorBruto,
	        valorNeto: window.laravelValorNeto,
	        fechaInicial: window.laravelFechaInicial,
	        fechaFinal: window.laravelFechaFinal
	        //permisos = {window.laravelPermisos}
	    }), mantenedorPeticionOC);
	}
	
	/** MANTENEDOR SERVICIOS REALIZADOS (PUC - SB) **/
	var mantenedorServiciosRealizados = document.getElementById('react-servicios-realizados');
	
	if (mantenedorServiciosRealizados) {
	    _reactDom2.default.render(_react2.default.createElement(_ServiciosRealizados.ServiciosRealizados, {
	        meses: window.laravelMeses
	        //clientes = {window.laravelClientes}
	        , permisos: window.laravelPermisos,
	        cliente: window.laravelCliente
	    }), mantenedorServiciosRealizados);
	}
	
	/** MANTENEDOR LISTADO DE FACTURAS **/
	var mantenedorFacturasFCV = document.getElementById('react-facturas-fcv');
	
	if (mantenedorFacturasFCV) {
	    _reactDom2.default.render(_react2.default.createElement(_MisFacturas.MisFacturas, {
	        cliente: window.laravelCliente
	    }), mantenedorFacturasFCV);
	}
	/** MANAGEMENT OC **/
	var managementOC = document.getElementById('react-management-oc');
	if (managementOC) {
	    _reactDom2.default.render(_react2.default.createElement(_ManagementOC.ManagementOC, {
	        idBillingRequest: window.laravelIdBillingRequest,
	        idClient: window.laravelIdClient,
	        perms: window.laravelPerms
	    }), managementOC);
	}
	/** BILLING SERVICES LIST FSB GROUP **/
	var billingServices = document.getElementById('react-billing-services');
	if (billingServices) {
	    _reactDom2.default.render(_react2.default.createElement(_BillingServices.BillingServices, {
	        monthsDate: window.laravelMonths
	    }), billingServices);
	}
	/** ************************************************************* **/
	/** ******************** ANALISIS ******************************* **/
	/** ************************************************************* **/
	
	/** MANTENEDOR RESULTADO INVENTARIO **/
	var datosActaInventarioDOM = document.getElementById('react-datos-acta-inventario-fcv');
	if (datosActaInventarioDOM) {
	    _reactDom2.default.render(_react2.default.createElement(_PanelDatosActa.PanelDatosActa, {
	        idInventario: window.laravelIdInventario,
	        puedeEditar: window.laravelpuedeEditar
	    }), datosActaInventarioDOM);
	}
	/** MANTENEDOR CONSOLIDADOS IRD VENCIMIENTO **/
	var mantenedorConsolidadosAud = document.getElementById('react-consolidados-auditorias');
	
	if (mantenedorConsolidadosAud) {
	    _reactDom2.default.render(_react2.default.createElement(_ConsolidadosDisponibles.ConsolidadosDisponibles, {
	        meses: window.laravelMeses,
	        tipos: window.laravelTipos
	    }), mantenedorConsolidadosAud);
	}
	
	/** MANTENEDOR REVISION AUDITORIAS **/
	var verRevisionArchivoFinal = document.getElementById('react-revision-archivo-final');
	
	if (verRevisionArchivoFinal) {
	    _reactDom2.default.render(_react2.default.createElement(_RevisionArchivoFinal.RevisionArchivoFinal, {
	        idAuditoria: window.laravelAuditoria,
	        fcv: window.laravelFcv
	    }), verRevisionArchivoFinal);
	}
	
	/** DETALLES PROGRAMACION AG **/
	var mantenedorDetallesAG = document.getElementById('react-programacionAG-detalles');
	if (mantenedorDetallesAG) {
	    var _clientes4 = window.laravelClientes.filter(function (cliente) {
	        return cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA' || cliente.nombreCorto === 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX' || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP';
	    });
	
	    _reactDom2.default.render(_react2.default.createElement(_DetalleProgramacionAG.DetalleProgramacionAG, {
	        clientes: _clientes4,
	        regiones: window.laravelRegiones,
	        fechaInicio: window.laravelFechaInicio,
	        fechaFin: window.laravelFechaFin
	    }), mantenedorDetallesAG);
	}
	/** ************************************************************* **/
	/** ****************** OPERACIONES TERRENO ********************** **/
	/** ************************************************************* **/
	
	/** REPORTES DESARROLLO INVENTARIOS **/
	var verReporteInventario = document.getElementById('react-reporte-inventario');
	
	if (verReporteInventario) {
	    _reactDom2.default.render(_react2.default.createElement(_ReporteInventario.ReporteInventario, {
	        idInventario: window.laravelIdInventario,
	        nomina: window.laravelNomina
	    }), verReporteInventario);
	}
	/** MIS FONDOS OPERARIO **/
	var verFondosAsignados = document.getElementById('react-fondos-asignados');
	
	if (verFondosAsignados) {
	    _reactDom2.default.render(_react2.default.createElement(_FondosAsignados.FondosAsignados, null), verFondosAsignados);
	}
	
	/** Detalle Fondo **/
	var verDetalleFondo = document.getElementById('react-detalle-fondo');
	
	if (verDetalleFondo) {
	    _reactDom2.default.render(_react2.default.createElement(_DetalleFondo.DetalleFondo, {
	        idRendicion: window.idRendicion,
	        idLider: window.idLider,
	        fechaInicial: window.fechaInicial,
	        fechaFinal: window.fechaFinal
	    }), verDetalleFondo);
	}
	/** ************************************************************* **/
	/** ********************* CONTABILIDAD ************************** **/
	/** ************************************************************* **/
	
	/** PAYMENT PARTNERS **/
	var paymentPartners = document.getElementById('react-payment-partners');
	if (paymentPartners) {
	    _reactDom2.default.render(_react2.default.createElement(_PaymentPartnersIndex2.default, {
	        recruiters: window.laravelRecruiters,
	        clients: window.laravelClients
	    }), paymentPartners);
	}
	
	/** MANTENEDOR ASIGNACION DE FONDOS SUPERVISORES **/
	var verFondos = document.getElementById('react-fondos-rendiciones');
	
	if (verFondos) {
	    _reactDom2.default.render(_react2.default.createElement(_AsignacionFondos.AsignacionFondos, null), verFondos);
	}
	/** REVISAR RENDICIONES **/
	var verRevisionRendiciones = document.getElementById('react-revision-rendiciones');
	if (verRevisionRendiciones) {
	    _reactDom2.default.render(_react2.default.createElement(_RevisionRendiciones.RevisionRendiciones, null), verRevisionRendiciones);
	}
	
	/** DETALLE RENDICION **/
	var verDetalleRendicion = document.getElementById('react-revision-detalle');
	if (verDetalleRendicion) {
	    _reactDom2.default.render(_react2.default.createElement(_DetailsRendicion.DetailsRendicion, {
	        rendicion: window.laravelRendicion,
	        gastos: window.laravelGastos
	    }), verDetalleRendicion);
	}
	/** ************************************************************* **/
	/** ********************* PROVEEDORES *************************** **/
	/** ************************************************************* **/
	
	/** MANTENEDOR HOSPEDAJES **/
	var verMantenedorHospedajes = document.getElementById('react-mantenedor-hospedajes');
	
	if (verMantenedorHospedajes) {
	    _reactDom2.default.render(_react2.default.createElement(_MantenedorHospedajes.MantenedorHospedajes, null), verMantenedorHospedajes);
	}
	/** ***************************************************************** **/
	/** ********************* EMERGENCY COVID *************************** **/
	/** ***************************************************************** **/
	var showCollectivePermission = document.getElementById('react-covid-collective-permission');
	if (showCollectivePermission) {
	    _reactDom2.default.render(_react2.default.createElement(_index2.default, null), showCollectivePermission);
	}
	
	/** MODULO DE OPERADORES **/
	//REGISTRO
	var verRegistroOperador = document.getElementById('react-registro-operador');
	
	if (verRegistroOperador) {
	    _reactDom2.default.render(_react2.default.createElement(_registro.RegistroOperador, {
	        usuario: window.laravelUsuario,
	        rm: window.laravelRM }), verRegistroOperador);
	}
	
	/** MODULO DE ADMINISTRACION DE REGISTRADORES PENDIENTES **/
	//CONFIRMAR REGISTRO
	
	var verOperadoresPendientes = document.getElementById('react-operadores-pendientes');
	
	if (verOperadoresPendientes) {
	    _reactDom2.default.render(_react2.default.createElement(_OperadoresPendientes.OperadoresPendientes, {
	        captadores: window.laravelCaptadores,
	        operadores: window.laravelOperadores }), verOperadoresPendientes);
	}
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "boot-client.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(5);
	var ReactChildren = __webpack_require__(14);
	var ReactDOMFactories = __webpack_require__(22);
	var ReactElement = __webpack_require__(16);
	var ReactPropTypes = __webpack_require__(23);
	var ReactVersion = __webpack_require__(31);
	
	var createReactClass = __webpack_require__(32);
	var onlyChild = __webpack_require__(34);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	
	var canDefineProperty = __webpack_require__(10);
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var lowPriorityWarning = __webpack_require__(13);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(15);
	var ReactElement = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(9);
	var traverseAllChildren = __webpack_require__(19);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(10);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var getIteratorFn = __webpack_require__(20);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(21);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(16),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(24);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(25);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(26);
	var assign = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(28);
	var has = __webpack_require__(29);
	var checkPropTypes = __webpack_require__(30);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(27);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(5),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(16),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	var factory = __webpack_require__(33);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactElement = __webpack_require__(16);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(36);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactDefaultInjection = __webpack_require__(41);
	var ReactMount = __webpack_require__(165);
	var ReactReconciler = __webpack_require__(62);
	var ReactUpdates = __webpack_require__(59);
	var ReactVersion = __webpack_require__(170);
	
	var findDOMNode = __webpack_require__(171);
	var getHostComponentFromComposite = __webpack_require__(172);
	var renderSubtreeIntoContainer = __webpack_require__(173);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var DOMProperty = __webpack_require__(39);
	var ReactDOMComponentFlags = __webpack_require__(40);
	
	var invariant = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(42);
	var BeforeInputEventPlugin = __webpack_require__(43);
	var ChangeEventPlugin = __webpack_require__(58);
	var DefaultEventPluginOrder = __webpack_require__(71);
	var EnterLeaveEventPlugin = __webpack_require__(72);
	var HTMLDOMPropertyConfig = __webpack_require__(77);
	var ReactComponentBrowserEnvironment = __webpack_require__(78);
	var ReactDOMComponent = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactDOMEmptyComponent = __webpack_require__(136);
	var ReactDOMTreeTraversal = __webpack_require__(137);
	var ReactDOMTextComponent = __webpack_require__(138);
	var ReactDefaultBatchingStrategy = __webpack_require__(139);
	var ReactEventListener = __webpack_require__(140);
	var ReactInjection = __webpack_require__(143);
	var ReactReconcileTransaction = __webpack_require__(144);
	var SVGDOMPropertyConfig = __webpack_require__(152);
	var SelectEventPlugin = __webpack_require__(153);
	var SimpleEventPlugin = __webpack_require__(154);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(51);
	var FallbackCompositionState = __webpack_require__(52);
	var SyntheticCompositionEvent = __webpack_require__(55);
	var SyntheticInputEvent = __webpack_require__(57);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(47);
	
	var accumulateInto = __webpack_require__(49);
	var forEachAccumulated = __webpack_require__(50);
	var warning = __webpack_require__(8);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var EventPluginRegistry = __webpack_require__(46);
	var EventPluginUtils = __webpack_require__(47);
	var ReactErrorUtils = __webpack_require__(48);
	
	var accumulateInto = __webpack_require__(49);
	var forEachAccumulated = __webpack_require__(50);
	var invariant = __webpack_require__(12);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactErrorUtils = __webpack_require__(48);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(53);
	
	var getTextContentAccessor = __webpack_require__(54);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(53);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(59);
	var SyntheticEvent = __webpack_require__(56);
	
	var inputValueTracking = __webpack_require__(67);
	var getEventTarget = __webpack_require__(68);
	var isEventSupported = __webpack_require__(69);
	var isTextInputElement = __webpack_require__(70);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(60);
	var PooledClass = __webpack_require__(53);
	var ReactFeatureFlags = __webpack_require__(61);
	var ReactReconciler = __webpack_require__(62);
	var Transaction = __webpack_require__(66);
	
	var invariant = __webpack_require__(12);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(53);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(65);
	
	var warning = __webpack_require__(8);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(64);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(37);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(37);
	var SyntheticMouseEvent = __webpack_require__(73);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(74);
	var ViewportMetrics = __webpack_require__(75);
	
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	var getEventTarget = __webpack_require__(68);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(79);
	var ReactDOMIDOperations = __webpack_require__(90);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(80);
	var Danger = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactInstrumentation = __webpack_require__(65);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(83);
	var setInnerHTML = __webpack_require__(82);
	var setTextContent = __webpack_require__(84);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(81);
	var setInnerHTML = __webpack_require__(82);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(83);
	var setTextContent = __webpack_require__(84);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var DOMNamespaces = __webpack_require__(81);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(83);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var escapeTextContentForBrowser = __webpack_require__(85);
	var setInnerHTML = __webpack_require__(82);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var DOMLazyTree = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createNodesFromMarkup = __webpack_require__(87);
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(12);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createArrayFromMixed = __webpack_require__(88);
	var getMarkupWrap = __webpack_require__(89);
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(37);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(92);
	var CSSPropertyOperations = __webpack_require__(94);
	var DOMLazyTree = __webpack_require__(80);
	var DOMNamespaces = __webpack_require__(81);
	var DOMProperty = __webpack_require__(39);
	var DOMPropertyOperations = __webpack_require__(102);
	var EventPluginHub = __webpack_require__(45);
	var EventPluginRegistry = __webpack_require__(46);
	var ReactBrowserEventEmitter = __webpack_require__(104);
	var ReactDOMComponentFlags = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactDOMInput = __webpack_require__(107);
	var ReactDOMOption = __webpack_require__(110);
	var ReactDOMSelect = __webpack_require__(111);
	var ReactDOMTextarea = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMultiChild = __webpack_require__(113);
	var ReactServerRenderingTransaction = __webpack_require__(132);
	
	var emptyFunction = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(85);
	var invariant = __webpack_require__(12);
	var isEventSupported = __webpack_require__(69);
	var shallowEqual = __webpack_require__(121);
	var inputValueTracking = __webpack_require__(67);
	var validateDOMNesting = __webpack_require__(135);
	var warning = __webpack_require__(8);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(37);
	
	var focusNode = __webpack_require__(93);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(95);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactInstrumentation = __webpack_require__(65);
	
	var camelizeStyleName = __webpack_require__(96);
	var dangerousStyleValue = __webpack_require__(98);
	var hyphenateStyleName = __webpack_require__(99);
	var memoizeStringOnly = __webpack_require__(101);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(97);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(95);
	var warning = __webpack_require__(8);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(100);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactInstrumentation = __webpack_require__(65);
	
	var quoteAttributeValueForBrowser = __webpack_require__(103);
	var warning = __webpack_require__(8);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(85);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(46);
	var ReactEventEmitterMixin = __webpack_require__(105);
	var ViewportMetrics = __webpack_require__(75);
	
	var getVendorPrefixedEventName = __webpack_require__(106);
	var isEventSupported = __webpack_require__(69);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(102);
	var LinkedValueUtils = __webpack_require__(108);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactPropTypesSecret = __webpack_require__(109);
	var propTypesFactory = __webpack_require__(24);
	
	var React = __webpack_require__(3);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactDOMSelect = __webpack_require__(111);
	
	var warning = __webpack_require__(8);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(108);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(59);
	
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(108);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactInstanceMap = __webpack_require__(115);
	var ReactInstrumentation = __webpack_require__(65);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactReconciler = __webpack_require__(62);
	var ReactChildReconciler = __webpack_require__(116);
	
	var emptyFunction = __webpack_require__(9);
	var flattenChildren = __webpack_require__(131);
	var invariant = __webpack_require__(12);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(62);
	
	var instantiateReactComponent = __webpack_require__(118);
	var KeyEscapeUtils = __webpack_require__(126);
	var shouldUpdateReactComponent = __webpack_require__(122);
	var traverseAllChildren = __webpack_require__(127);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(130);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(119);
	var ReactEmptyComponent = __webpack_require__(123);
	var ReactHostComponent = __webpack_require__(124);
	
	var getNextDebugID = __webpack_require__(125);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactErrorUtils = __webpack_require__(48);
	var ReactInstanceMap = __webpack_require__(115);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactNodeTypes = __webpack_require__(120);
	var ReactReconciler = __webpack_require__(62);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var shallowEqual = __webpack_require__(121);
	var shouldUpdateReactComponent = __webpack_require__(122);
	var warning = __webpack_require__(8);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var React = __webpack_require__(3);
	
	var invariant = __webpack_require__(12);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(128);
	
	var getIteratorFn = __webpack_require__(129);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(126);
	var traverseAllChildren = __webpack_require__(127);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(130);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(53);
	var Transaction = __webpack_require__(66);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactServerUpdateQueue = __webpack_require__(133);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(134);
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(115);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(37);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(79);
	var DOMLazyTree = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(37);
	
	var escapeTextContentForBrowser = __webpack_require__(85);
	var invariant = __webpack_require__(12);
	var validateDOMNesting = __webpack_require__(135);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(59);
	var Transaction = __webpack_require__(66);
	
	var emptyFunction = __webpack_require__(9);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(141);
	var ExecutionEnvironment = __webpack_require__(51);
	var PooledClass = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(59);
	
	var getEventTarget = __webpack_require__(68);
	var getUnboundedScrollPosition = __webpack_require__(142);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	var EventPluginHub = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(47);
	var ReactComponentEnvironment = __webpack_require__(114);
	var ReactEmptyComponent = __webpack_require__(123);
	var ReactBrowserEventEmitter = __webpack_require__(104);
	var ReactHostComponent = __webpack_require__(124);
	var ReactUpdates = __webpack_require__(59);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(60);
	var PooledClass = __webpack_require__(53);
	var ReactBrowserEventEmitter = __webpack_require__(104);
	var ReactInputSelection = __webpack_require__(145);
	var ReactInstrumentation = __webpack_require__(65);
	var Transaction = __webpack_require__(66);
	var ReactUpdateQueue = __webpack_require__(134);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(146);
	
	var containsNode = __webpack_require__(148);
	var focusNode = __webpack_require__(93);
	var getActiveElement = __webpack_require__(151);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var getNodeForCharacterOffset = __webpack_require__(147);
	var getTextContentAccessor = __webpack_require__(54);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(149);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(150);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactInputSelection = __webpack_require__(145);
	var SyntheticEvent = __webpack_require__(56);
	
	var getActiveElement = __webpack_require__(151);
	var isTextInputElement = __webpack_require__(70);
	var shallowEqual = __webpack_require__(121);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var EventListener = __webpack_require__(141);
	var EventPropagators = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(37);
	var SyntheticAnimationEvent = __webpack_require__(155);
	var SyntheticClipboardEvent = __webpack_require__(156);
	var SyntheticEvent = __webpack_require__(56);
	var SyntheticFocusEvent = __webpack_require__(157);
	var SyntheticKeyboardEvent = __webpack_require__(158);
	var SyntheticMouseEvent = __webpack_require__(73);
	var SyntheticDragEvent = __webpack_require__(161);
	var SyntheticTouchEvent = __webpack_require__(162);
	var SyntheticTransitionEvent = __webpack_require__(163);
	var SyntheticUIEvent = __webpack_require__(74);
	var SyntheticWheelEvent = __webpack_require__(164);
	
	var emptyFunction = __webpack_require__(9);
	var getEventCharCode = __webpack_require__(159);
	var invariant = __webpack_require__(12);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(74);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(74);
	
	var getEventCharCode = __webpack_require__(159);
	var getEventKey = __webpack_require__(160);
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(159);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(73);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(74);
	
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(73);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var DOMLazyTree = __webpack_require__(80);
	var DOMProperty = __webpack_require__(39);
	var React = __webpack_require__(3);
	var ReactBrowserEventEmitter = __webpack_require__(104);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactDOMContainerInfo = __webpack_require__(166);
	var ReactDOMFeatureFlags = __webpack_require__(167);
	var ReactFeatureFlags = __webpack_require__(61);
	var ReactInstanceMap = __webpack_require__(115);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMarkupChecksum = __webpack_require__(168);
	var ReactReconciler = __webpack_require__(62);
	var ReactUpdateQueue = __webpack_require__(134);
	var ReactUpdates = __webpack_require__(59);
	
	var emptyObject = __webpack_require__(11);
	var instantiateReactComponent = __webpack_require__(118);
	var invariant = __webpack_require__(12);
	var setInnerHTML = __webpack_require__(82);
	var shouldUpdateReactComponent = __webpack_require__(122);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(135);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(169);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(38);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(37);
	var ReactInstanceMap = __webpack_require__(115);
	
	var getHostComponentFromComposite = __webpack_require__(172);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(120);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(165);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dashboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Dashboard = __webpack_require__(315);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _homeService = __webpack_require__(460);
	
	var _homeService2 = _interopRequireDefault(_homeService);
	
	var _PanelIndicators = __webpack_require__(479);
	
	var _ModalActa = __webpack_require__(609);
	
	var _ModalActa2 = _interopRequireDefault(_ModalActa);
	
	var _ModalActaCliente = __webpack_require__(610);
	
	var _ModalActaCliente2 = _interopRequireDefault(_ModalActaCliente);
	
	var _ModalImagenes = __webpack_require__(612);
	
	var _ModalImagenes2 = _interopRequireDefault(_ModalImagenes);
	
	var _ModalChecklist = __webpack_require__(613);
	
	var _ModalChecklist2 = _interopRequireDefault(_ModalChecklist);
	
	var _ReporteRuta = __webpack_require__(614);
	
	var _ReporteRuta2 = _interopRequireDefault(_ReporteRuta);
	
	var _ModalInventarios = __webpack_require__(616);
	
	var _ModalInventarios2 = _interopRequireDefault(_ModalInventarios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// moment
	
	
	_moment2.default.locale('es');
	// css
	
	// modal
	
	// notify
	
	// service
	
	// components
	
	var Dashboard = exports.Dashboard = function (_Component) {
	    _inherits(Dashboard, _Component);
	
	    function Dashboard(props) {
	        _classCallCheck(this, Dashboard);
	
	        var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	        _this.state = {
	            indicators: [],
	            summaryIndicatorsRange: [],
	            summaryIndicatorsMonth: [],
	            summaryIndicatorsYear: [],
	            idClient: _this.props.idClient,
	            dateIndicator: (0, _moment2.default)(new Date(_this.props.dateIndicator)),
	            showModalStockLoad: _this.props.stockPending,
	            fechaInicialSeleccionada: (0, _moment2.default)().subtract(1, 'days'),
	            fechaFinalSeleccionada: (0, _moment2.default)().endOf('week'),
	            sinFiltro: true,
	            showModalActa: false,
	            showModalActaCliente: false,
	            showModalImagenes: false,
	            showModalChecklist: false,
	            invActa: "",
	            dataActa: [],
	            today: (0, _moment2.default)(new Date()),
	            showArriendo: _this.props.perms.permDBS,
	            cargandoMes: false,
	            cargandoYear: false,
	            cargandoData: false
	        };
	        _this.openModalActa = function (idInventario) {
	            _this.setState({
	                showModalActa: true,
	                invActa: idInventario
	            });
	        };
	
	        _this.openModalActaCliente = function (idInventario) {
	            _this.setState({
	                showModalActaCliente: true,
	                invActa: idInventario
	            });
	        };
	
	        _this.openModalImagenes = function (idInventario) {
	            _this.setState({
	                showModalImagenes: true,
	                invActa: idInventario
	            });
	        };
	
	        _this.openModalChecklist = function (idInventario) {
	            _this.setState({
	                showModalChecklist: true,
	                invActa: idInventario
	            });
	        };
	
	        _this.setFiltro = function (filtros) {
	            var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            var clientes = filtros.map(function (f) {
	                return f.client_name;
	            });
	            var clientesUnicos = clientes.filter(function (item, i, ar) {
	                return ar.indexOf(item) === i;
	            });
	            if (bool) {
	                _this.fetchIndicators();
	                _this.fetchSummaryIndicatorsMonth();
	                _this.fetchSummaryIndicatorsYear();
	            } else if (filtros.length > 0) {
	                _this.summaryFiltros(clientesUnicos);
	                _this.summaryFiltrosMonth(clientesUnicos);
	                _this.summaryFiltrosYear(clientesUnicos);
	                _this.setState({ sinFiltro: false });
	            }
	        };
	
	        _this.summaryFiltros = function (clientes) {
	            var dateIndicator = _this.state.dateIndicator;
	
	            _homeService2.default.client.indicators.getManagementIndicators(clientes, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD')).then(function (response) {
	                _this.setState({
	                    summaryIndicatorsRange: response.summaryIndicators
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.summaryFiltrosMonth = function (clientes) {
	            var dateIndicator = _this.state.dateIndicator;
	
	            _this.setState({ cargandoMes: true });
	            _homeService2.default.client.indicators.getSummaryIndicatorsPeriod(clientes, dateIndicator.format('YYYY-MM-DD'), false).then(function (summaryIndicatorsMonth) {
	                _this.setState({ summaryIndicatorsMonth: summaryIndicatorsMonth, cargandoMes: false });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.summaryFiltrosYear = function (clientes) {
	            var dateIndicator = _this.state.dateIndicator;
	
	            _this.setState({ cargandoYear: true });
	            _homeService2.default.client.indicators.getSummaryIndicatorsPeriod(clientes, dateIndicator.format('YYYY-00-00'), true).then(function (summaryIndicatorsYear) {
	                _this.setState({ summaryIndicatorsYear: summaryIndicatorsYear, cargandoYear: false });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.fetchIndicators = function () {
	            var _this$state = _this.state,
	                idClient = _this$state.idClient,
	                dateIndicator = _this$state.dateIndicator;
	
	            _this.setState({ cargandoData: true });
	            _homeService2.default.client.indicators.getManagementIndicators(idClient, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD')).then(function (response) {
	                _this.setState({
	                    indicators: response.indicatorsResource,
	                    summaryIndicatorsRange: response.summaryIndicators,
	                    cargandoData: false
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.fetchSummaryIndicatorsMonth = function () {
	            var _this$state2 = _this.state,
	                idClient = _this$state2.idClient,
	                dateIndicator = _this$state2.dateIndicator;
	
	            _this.setState({ cargandoMes: true });
	            _homeService2.default.client.indicators.getSummaryIndicatorsPeriod(idClient, dateIndicator.format('YYYY-MM-DD'), false).then(function (summaryIndicatorsMonth) {
	                _this.setState({ summaryIndicatorsMonth: summaryIndicatorsMonth, cargandoMes: false });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.fetchSummaryIndicatorsYear = function () {
	            var _this$state3 = _this.state,
	                idClient = _this$state3.idClient,
	                dateIndicator = _this$state3.dateIndicator;
	
	            _this.setState({ cargandoYear: true });
	            _homeService2.default.client.indicators.getSummaryIndicatorsPeriod(idClient, dateIndicator.format('YYYY-MM-DD'), true).then(function (summaryIndicatorsYear) {
	                _this.setState({ summaryIndicatorsYear: summaryIndicatorsYear, cargandoYear: false });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.getStats = function () {
	            var _this$state4 = _this.state,
	                idClient = _this$state4.idClient,
	                dateIndicator = _this$state4.dateIndicator;
	            //this.setState({ cargandoData: true })
	
	            _homeService2.default.client.indicators.getStats(idClient, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD')).then(function (response) {
	                _this.setState(function (prevState) {
	                    var indicatorsActualizados = prevState.indicators.map(function (indicator) {
	                        var nuevoAvance = response.find(function (a) {
	                            return a.idInventario === indicator.inv;
	                        });
	                        if (nuevoAvance) {
	                            return _extends({}, indicator, { avance: nuevoAvance });
	                        }
	                        return indicator;
	                    });
	                    return {
	                        indicators: indicatorsActualizados,
	                        cargandoData: false
	                    };
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.cancelModalStockLoad = function () {
	            _this.setState({ showModalStockLoad: false });
	        };
	
	        _this.cancelModalArriendo = function () {
	            _this.setState({ showArriendo: false });
	        };
	
	        _this.cancelModalActa = function () {
	            _this.setState({
	                showModalActa: false,
	                invActa: "",
	                dataActa: []
	            });
	        };
	
	        _this.cancelModalActaCliente = function () {
	            _this.setState({
	                showModalActaCliente: false,
	                invActa: "",
	                dataActa: []
	            });
	        };
	
	        _this.cancelModalImagenes = function () {
	            _this.setState({
	                showModalImagenes: false,
	                invActa: "",
	                dataActa: []
	            });
	        };
	
	        _this.cancelModalChecklist = function () {
	            _this.setState({
	                showModalChecklist: false,
	                invActa: "",
	                dataActa: []
	            });
	        };
	
	        _this.dayBefore = function () {
	            var _this$state5 = _this.state,
	                dateIndicator = _this$state5.dateIndicator,
	                today = _this$state5.today;
	
	            _this.setState({
	                sinFiltro: true,
	                dateIndicator: dateIndicator.add(1, 'days')
	            }, function () {
	                _this.fetchIndicators();
	                _this.fetchSummaryIndicatorsMonth();
	                _this.fetchSummaryIndicatorsYear();
	                // if (dateIndicator.format('M') != today.format('M')) {
	                //     this.fetchSummaryIndicatorsMonth();
	                // }
	                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
	                //     this.fetchSummaryIndicatorsYear();
	                // }
	            });
	        };
	
	        _this.dayAfter = function () {
	            var _this$state6 = _this.state,
	                dateIndicator = _this$state6.dateIndicator,
	                today = _this$state6.today;
	
	            _this.setState({
	                sinFiltro: true,
	                dateIndicator: dateIndicator.subtract(1, 'days')
	            }, function () {
	                _this.fetchIndicators();
	                _this.fetchSummaryIndicatorsMonth();
	                _this.fetchSummaryIndicatorsYear();
	                // if (dateIndicator.format('M') != today.format('M')) {
	                //     this.fetchSummaryIndicatorsMonth();
	                // }
	                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
	                //     this.fetchSummaryIndicatorsYear();
	                // }
	            });
	        };
	
	        _this.selectDay = function (e) {
	            var _this$state7 = _this.state,
	                dateIndicator = _this$state7.dateIndicator,
	                today = _this$state7.today;
	
	            _this.setState({
	                sinFiltro: true,
	                dateIndicator: (0, _moment2.default)(new Date(e.target.value + "T00:00:00"))
	            }, function () {
	                _this.fetchIndicators();
	                _this.fetchSummaryIndicatorsMonth();
	                _this.fetchSummaryIndicatorsYear();
	                // if (dateIndicator.format('M') != today.format('M')) {
	                //     this.fetchSummaryIndicatorsMonth();
	                // }
	                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
	                //     this.fetchSummaryIndicatorsYear();
	                // }
	            });
	        };
	
	        _this.showNotifyStock = function () {
	            if (_this.props.stockPending) _this.refs.notificator.error("Carga de stock", "Atención debe cargar stock teóricos de locales", 4 * 2000);
	        };
	
	        _this.previewActa = function (inventario) {
	            //console.log(inventario)
	            _homeService2.default.acta.indicators.getActaPreview(inventario).then(function (dataActa) {
	                _this.setState({ dataActa: dataActa });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.verActa = function (inventario) {
	            _homeService2.default.acta.indicators.showActa(inventario).then(function (dataActa) {
	                _this.setState({ dataActa: dataActa });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.get_Imagenes = function (inventario) {
	            _homeService2.default.acta.indicators.getImagenes(inventario).then(function (dataActa) {
	                _this.setState({ dataActa: dataActa });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.get_Checklist = function (inventario) {
	            _homeService2.default.acta.indicators.getChecklist(inventario).then(function (dataActa) {
	                _this.setState({ dataActa: dataActa });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Dashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.perms.showManagementIndicators == true) {
	                this.fetchSummaryIndicatorsMonth();
	                this.fetchSummaryIndicatorsYear();
	            }
	            //this.showNotifyStock();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                showModalStockLoad = _state.showModalStockLoad,
	                dateIndicator = _state.dateIndicator,
	                idClient = _state.idClient,
	                indicators = _state.indicators,
	                summaryIndicatorsRange = _state.summaryIndicatorsRange,
	                summaryIndicatorsMonth = _state.summaryIndicatorsMonth,
	                summaryIndicatorsYear = _state.summaryIndicatorsYear,
	                showModalActa = _state.showModalActa,
	                invActa = _state.invActa,
	                dataActa = _state.dataActa,
	                today = _state.today,
	                showArriendo = _state.showArriendo,
	                showModalActaCliente = _state.showModalActaCliente,
	                showModalImagenes = _state.showModalImagenes,
	                showModalChecklist = _state.showModalChecklist,
	                cargandoMes = _state.cargandoMes,
	                cargandoYear = _state.cargandoYear,
	                cargandoData = _state.cargandoData;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid ' + _Dashboard2.default.Dashboard_container },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                this.props.perms.reporte_ruta && _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'end', height: '10px', marginTop: '15px' } },
	                    _react2.default.createElement(_ModalInventarios2.default, { hoy: today }),
	                    _react2.default.createElement(_ReporteRuta2.default, { fechaInicio: today })
	                ),
	                this.props.perms.showStockUpdateModal ? _react2.default.createElement(ModalStockLoad, {
	                    showModal: showModalStockLoad,
	                    cancelModal: this.cancelModalStockLoad
	                }) : null,
	                showModalActa ? _react2.default.createElement(_ModalActa2.default, {
	                    showModal: showModalActa,
	                    cancelModal: this.cancelModalActa,
	                    previewActa: this.previewActa,
	                    idInventario: invActa,
	                    indicators: dataActa
	                }) : null,
	                showModalActaCliente ? _react2.default.createElement(_ModalActaCliente2.default, {
	                    showModal: showModalActaCliente,
	                    cancelModal: this.cancelModalActaCliente,
	                    previewActa: this.verActa,
	                    idInventario: invActa,
	                    indicators: dataActa,
	                    id_file: indicators
	                }) : null,
	                showModalImagenes ? _react2.default.createElement(_ModalImagenes2.default, {
	                    showModal: showModalImagenes,
	                    cancelModal: this.cancelModalImagenes,
	                    imagenes: this.get_Imagenes,
	                    idInventario: invActa,
	                    indicators: dataActa,
	                    id_file: indicators
	                }) : null,
	                showModalChecklist ? _react2.default.createElement(_ModalChecklist2.default, {
	                    showModal: showModalChecklist,
	                    cancelModal: this.cancelModalChecklist,
	                    checklist: this.get_Checklist,
	                    idInventario: invActa,
	                    indicators: dataActa,
	                    id_file: indicators
	                }) : null,
	                this.props.perms.showManagementIndicators ? _react2.default.createElement(_PanelIndicators.PanelIndicators, {
	                    fetchIndicators: this.fetchIndicators,
	                    getStats: this.getStats,
	                    day: this.state.dateIndicator,
	                    dateTitle: dateIndicator.format('LL'),
	                    dateDay: dateIndicator.format('dddd'),
	                    dateInit: dateIndicator.format('YYYY-MM-DD'),
	                    dateYear: dateIndicator.format('YYYY-00-00'),
	                    idClient: idClient,
	                    indicators: indicators,
	                    summaryIndicatorsRange: summaryIndicatorsRange,
	                    summaryIndicatorsMonth: summaryIndicatorsMonth,
	                    summaryIndicatorsYear: summaryIndicatorsYear,
	                    dayBefore: this.dayBefore,
	                    dayAfter: this.dayAfter,
	                    selectDay: this.selectDay,
	                    showOtherData: this.props.perms.showOtherData,
	                    permissions: this.props.perms.dashboardSEI,
	                    desvio: this.props.perms.desvio,
	                    perms: this.props.perms,
	                    fcv: this.props.perms.permFCV,
	                    reportar: this.props.perms.reportar,
	                    comentarioDashboard: this.props.perms.comentarioDashboard,
	                    setFiltro: this.setFiltro.bind(this),
	                    sinFiltro: this.state.sinFiltro,
	                    openModalActa: this.openModalActa.bind(this),
	                    openModalActaCliente: this.openModalActaCliente.bind(this),
	                    openModalImagenes: this.openModalImagenes.bind(this),
	                    openModalChecklist: this.openModalChecklist.bind(this),
	                    admin: this.props.perms.admin,
	                    cargandoMes: cargandoMes,
	                    cargandoYear: cargandoYear,
	                    cargandoData: cargandoData
	                    //allFilters={this.allFilters.bind(this)}
	                }) : null
	            );
	        }
	    }]);
	
	    return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	    dateIndicator: _react.PropTypes.string.isRequired,
	    stockPending: _react.PropTypes.bool.isRequired,
	    idClient: _react.PropTypes.string.isRequired,
	    perms: _react.PropTypes.object.isRequired
	};
	
	var ModalStockLoad = function ModalStockLoad(_ref) {
	    var showModal = _ref.showModal,
	        cancelModal = _ref.cancelModal;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: showModal, onHide: cancelModal },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Carga stock de locales'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Le recordamos que debe actualizar el stock de locales.'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-success', href: '/admin/actualizar-stock', target: '_blank' },
	                'Ir ahora'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-warning', onClick: cancelModal },
	                'Ahora no'
	            )
	        )
	    );
	};
	
	var ModalArriendoDBS = function ModalArriendoDBS(_ref2) {
	    var showModal = _ref2.showModal,
	        cancelModal = _ref2.cancelModal;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: showModal, onHide: cancelModal },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Arriendo de Equipos'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Le recordamos que esta semana tiene arriendo de equipos.'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-success', href: '/arriendo-equipos/dbs/cliente', target: '_blank' },
	                'Ir ahora'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-warning', onClick: cancelModal },
	                'Ahora no'
	            )
	        )
	    );
	};
	
	/*const ModalActa = ({ showModal, cancelModal }) => (
	    <Modal show={true} onHide={cancelModal}>
	        <Modal.Header closeButton>
	            <Modal.Title>Acta Inventario IG</Modal.Title>
	        </Modal.Header>
	        <Modal.Body>
	            <div className="container" style={{ width: 'auto' }}>
	                <div className="row">
	                    <div >
	                        <div id="accordion">
	                            <div className="card">
	                                <div className="card-header" id="headingOne">
	                                    <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
	                                        Resumen Inventario
	                                    </button>
	                                </div>
	                                <div id="collapseOne" className="collapse in" aria-labelledby="headingOne" data-parent="#accordion">
	                                    <div className="card-body">
	                                        <div className="panel-body">
	                                            <ul className="list-group">
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Cliente
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>FARMACIA CRUZ VERDE</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Local (CECO)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>261</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Fecha IG
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Dotación Presupuestada
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Dotación Efectiva
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Hora LLegada
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Supervisor SEI
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-6'>
	                                                            Químico Farmacéutico
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                            </ul>
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                            <div className="card">
	                                <div className="card-header" id="headingTwo">
	                                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
	                                        Horarios
	                                    </button>
	                                </div>
	                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
	                                    <div className="card-body">
	                                        <div className="panel-body">
	                                            <ul className="list-group">
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>

	                                                        </label>
	                                                        <label style={{ width: '100px' }}>FECHA</label>
	                                                        <label className='pull-right'>HORA</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Inicio Conteo
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>08:54</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Fin Conteo
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Horas Conteo
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}></label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Inicio Revisión Grilla
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Fin Proceso
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Horas Revisión
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}></label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Total Horas Inventario
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}></label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Validación Código Grilla
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}></label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '250px' }}>
	                                                            Inicio Auditoria
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                            </ul>
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                            <div className="card">
	                                <div className="card-header" id="headingThree">
	                                    <h5 className="mb-0">
	                                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
	                                            Indicadores de Gestión de Inventario
	                                        </button>
	                                    </h5>
	                                </div>
	                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
	                                    <div className="card-body">
	                                        <div className="panel-body">
	                                            <ul className="list-group">
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Unidades Teóricas (Mapro Inicial)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>13.960</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Unidades Físicas Inventariadas (Mapro Final)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>14.120</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Unidades Diferencia Neta
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>160</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Unidades Diferencia Absoluto
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>469</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Inventario Teórico Valorizado
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>150.301.505</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Inventario Físico Valorizado
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>150.584.055</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Diferencia de Inventario Valorizada
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>282.550</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Total SKU (Códigos internos) efectivos local
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>4.223</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Total Items inventariados (escaneos)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>5.179</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Cantidad PTT Inventariadas
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>564</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Cantidad PTT Nulas
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>0</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Total Unidades No Inventariables
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>0</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label className='col-md-9'>
	                                                            Total Valorizado No Inventariables
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>65.950</label>
	                                                    </div>
	                                                </li>
	                                            </ul>
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                            <div className="card">
	                                <div className="card-header" id="headingFour">
	                                    <h5 className="mb-0">
	                                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
	                                            Indicadores de Auditoría Cliente
	                                        </button>
	                                    </h5>
	                                </div>
	                                <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordion">
	                                    <div className="card-body">
	                                        <div className="panel-body">
	                                            <ul className="list-group">
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>

	                                                        </label>
	                                                        <label style={{ width: '100px' }}>Cantidad</label>
	                                                        <label className='pull-right'>%</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Cantidad de Items AUDITADOS Cliente
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>2.158</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>42.80</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Cantidad de Patentes Auditadas Cliente
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>231</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Total unidades NETO corregidas AUDITORIA
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal', textAlign: 'left' }}>-2</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Total unidades ABS corregidas AUDITORIA
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>8</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Total ITEMS Corregidos AUDITORIAS (% Error SEI)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>1</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            Total ITEMS Corregidos AUDITORIAS (% Error QF CV)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>7</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>5.10</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            % Variacion Ajuste Neto (Grilla)
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}></label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.10</label>
	                                                    </div>
	                                                </li>
	                                                <li className="list-group-item">
	                                                    <div>
	                                                        <label style={{ width: '380px' }}>
	                                                            % Summary
	                                                        </label>
	                                                        <label style={{ fontWeight: 'normal' }}>0</label>
	                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
	                                                    </div>
	                                                </li>
	                                            </ul>
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </Modal.Body>
	    </Modal>
	)*/

	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Dashboard.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(177)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(176)(module)))

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 178,
		"./af.js": 178,
		"./ar": 179,
		"./ar-dz": 180,
		"./ar-dz.js": 180,
		"./ar-kw": 181,
		"./ar-kw.js": 181,
		"./ar-ly": 182,
		"./ar-ly.js": 182,
		"./ar-ma": 183,
		"./ar-ma.js": 183,
		"./ar-ps": 184,
		"./ar-ps.js": 184,
		"./ar-sa": 185,
		"./ar-sa.js": 185,
		"./ar-tn": 186,
		"./ar-tn.js": 186,
		"./ar.js": 179,
		"./az": 187,
		"./az.js": 187,
		"./be": 188,
		"./be.js": 188,
		"./bg": 189,
		"./bg.js": 189,
		"./bm": 190,
		"./bm.js": 190,
		"./bn": 191,
		"./bn-bd": 192,
		"./bn-bd.js": 192,
		"./bn.js": 191,
		"./bo": 193,
		"./bo.js": 193,
		"./br": 194,
		"./br.js": 194,
		"./bs": 195,
		"./bs.js": 195,
		"./ca": 196,
		"./ca.js": 196,
		"./cs": 197,
		"./cs.js": 197,
		"./cv": 198,
		"./cv.js": 198,
		"./cy": 199,
		"./cy.js": 199,
		"./da": 200,
		"./da.js": 200,
		"./de": 201,
		"./de-at": 202,
		"./de-at.js": 202,
		"./de-ch": 203,
		"./de-ch.js": 203,
		"./de.js": 201,
		"./dv": 204,
		"./dv.js": 204,
		"./el": 205,
		"./el.js": 205,
		"./en-au": 206,
		"./en-au.js": 206,
		"./en-ca": 207,
		"./en-ca.js": 207,
		"./en-gb": 208,
		"./en-gb.js": 208,
		"./en-ie": 209,
		"./en-ie.js": 209,
		"./en-il": 210,
		"./en-il.js": 210,
		"./en-in": 211,
		"./en-in.js": 211,
		"./en-nz": 212,
		"./en-nz.js": 212,
		"./en-sg": 213,
		"./en-sg.js": 213,
		"./eo": 214,
		"./eo.js": 214,
		"./es": 215,
		"./es-do": 216,
		"./es-do.js": 216,
		"./es-mx": 217,
		"./es-mx.js": 217,
		"./es-us": 218,
		"./es-us.js": 218,
		"./es.js": 215,
		"./et": 219,
		"./et.js": 219,
		"./eu": 220,
		"./eu.js": 220,
		"./fa": 221,
		"./fa.js": 221,
		"./fi": 222,
		"./fi.js": 222,
		"./fil": 223,
		"./fil.js": 223,
		"./fo": 224,
		"./fo.js": 224,
		"./fr": 225,
		"./fr-ca": 226,
		"./fr-ca.js": 226,
		"./fr-ch": 227,
		"./fr-ch.js": 227,
		"./fr.js": 225,
		"./fy": 228,
		"./fy.js": 228,
		"./ga": 229,
		"./ga.js": 229,
		"./gd": 230,
		"./gd.js": 230,
		"./gl": 231,
		"./gl.js": 231,
		"./gom-deva": 232,
		"./gom-deva.js": 232,
		"./gom-latn": 233,
		"./gom-latn.js": 233,
		"./gu": 234,
		"./gu.js": 234,
		"./he": 235,
		"./he.js": 235,
		"./hi": 236,
		"./hi.js": 236,
		"./hr": 237,
		"./hr.js": 237,
		"./hu": 238,
		"./hu.js": 238,
		"./hy-am": 239,
		"./hy-am.js": 239,
		"./id": 240,
		"./id.js": 240,
		"./is": 241,
		"./is.js": 241,
		"./it": 242,
		"./it-ch": 243,
		"./it-ch.js": 243,
		"./it.js": 242,
		"./ja": 244,
		"./ja.js": 244,
		"./jv": 245,
		"./jv.js": 245,
		"./ka": 246,
		"./ka.js": 246,
		"./kk": 247,
		"./kk.js": 247,
		"./km": 248,
		"./km.js": 248,
		"./kn": 249,
		"./kn.js": 249,
		"./ko": 250,
		"./ko.js": 250,
		"./ku": 251,
		"./ku-kmr": 252,
		"./ku-kmr.js": 252,
		"./ku.js": 251,
		"./ky": 253,
		"./ky.js": 253,
		"./lb": 254,
		"./lb.js": 254,
		"./lo": 255,
		"./lo.js": 255,
		"./lt": 256,
		"./lt.js": 256,
		"./lv": 257,
		"./lv.js": 257,
		"./me": 258,
		"./me.js": 258,
		"./mi": 259,
		"./mi.js": 259,
		"./mk": 260,
		"./mk.js": 260,
		"./ml": 261,
		"./ml.js": 261,
		"./mn": 262,
		"./mn.js": 262,
		"./mr": 263,
		"./mr.js": 263,
		"./ms": 264,
		"./ms-my": 265,
		"./ms-my.js": 265,
		"./ms.js": 264,
		"./mt": 266,
		"./mt.js": 266,
		"./my": 267,
		"./my.js": 267,
		"./nb": 268,
		"./nb.js": 268,
		"./ne": 269,
		"./ne.js": 269,
		"./nl": 270,
		"./nl-be": 271,
		"./nl-be.js": 271,
		"./nl.js": 270,
		"./nn": 272,
		"./nn.js": 272,
		"./oc-lnc": 273,
		"./oc-lnc.js": 273,
		"./pa-in": 274,
		"./pa-in.js": 274,
		"./pl": 275,
		"./pl.js": 275,
		"./pt": 276,
		"./pt-br": 277,
		"./pt-br.js": 277,
		"./pt.js": 276,
		"./ro": 278,
		"./ro.js": 278,
		"./ru": 279,
		"./ru.js": 279,
		"./sd": 280,
		"./sd.js": 280,
		"./se": 281,
		"./se.js": 281,
		"./si": 282,
		"./si.js": 282,
		"./sk": 283,
		"./sk.js": 283,
		"./sl": 284,
		"./sl.js": 284,
		"./sq": 285,
		"./sq.js": 285,
		"./sr": 286,
		"./sr-cyrl": 287,
		"./sr-cyrl.js": 287,
		"./sr.js": 286,
		"./ss": 288,
		"./ss.js": 288,
		"./sv": 289,
		"./sv.js": 289,
		"./sw": 290,
		"./sw.js": 290,
		"./ta": 291,
		"./ta.js": 291,
		"./te": 292,
		"./te.js": 292,
		"./tet": 293,
		"./tet.js": 293,
		"./tg": 294,
		"./tg.js": 294,
		"./th": 295,
		"./th.js": 295,
		"./tk": 296,
		"./tk.js": 296,
		"./tl-ph": 297,
		"./tl-ph.js": 297,
		"./tlh": 298,
		"./tlh.js": 298,
		"./tr": 299,
		"./tr.js": 299,
		"./tzl": 300,
		"./tzl.js": 300,
		"./tzm": 301,
		"./tzm-latn": 302,
		"./tzm-latn.js": 302,
		"./tzm.js": 301,
		"./ug-cn": 303,
		"./ug-cn.js": 303,
		"./uk": 304,
		"./uk.js": 304,
		"./ur": 305,
		"./ur.js": 305,
		"./uz": 306,
		"./uz-latn": 307,
		"./uz-latn.js": 307,
		"./uz.js": 306,
		"./vi": 308,
		"./vi.js": 308,
		"./x-pseudo": 309,
		"./x-pseudo.js": 309,
		"./yo": 310,
		"./yo.js": 310,
		"./zh-cn": 311,
		"./zh-cn.js": 311,
		"./zh-hk": 312,
		"./zh-hk.js": 312,
		"./zh-mo": 313,
		"./zh-mo.js": 313,
		"./zh-tw": 314,
		"./zh-tw.js": 314
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 177;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(175)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Dashboard_jumbotron":"Dashboard__Dashboard_jumbotron___bxA9F","Dashboard_container":"Dashboard__Dashboard_container___2qukx"};

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(402);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(411);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(405);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(412);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(415);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(437);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(443);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(445);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(453);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(454);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(455);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(457);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(458);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(321);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(322);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(373);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(324);
	__webpack_require__(368);
	module.exports = __webpack_require__(372).f('iterator');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(325)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(328)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(326);
	var defined = __webpack_require__(327);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(329);
	var $export = __webpack_require__(330);
	var redefine = __webpack_require__(346);
	var hide = __webpack_require__(335);
	var Iterators = __webpack_require__(347);
	var $iterCreate = __webpack_require__(348);
	var setToStringTag = __webpack_require__(364);
	var getPrototypeOf = __webpack_require__(366);
	var ITERATOR = __webpack_require__(365)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(331);
	var core = __webpack_require__(332);
	var ctx = __webpack_require__(333);
	var hide = __webpack_require__(335);
	var has = __webpack_require__(345);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(334);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(336);
	var createDesc = __webpack_require__(344);
	module.exports = __webpack_require__(340) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(337);
	var IE8_DOM_DEFINE = __webpack_require__(339);
	var toPrimitive = __webpack_require__(343);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(340) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(338);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(340) && !__webpack_require__(341)(function () {
	  return Object.defineProperty(__webpack_require__(342)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(341)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(338);
	var document = __webpack_require__(331).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(338);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(335);


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(349);
	var descriptor = __webpack_require__(344);
	var setToStringTag = __webpack_require__(364);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(335)(IteratorPrototype, __webpack_require__(365)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(337);
	var dPs = __webpack_require__(350);
	var enumBugKeys = __webpack_require__(362);
	var IE_PROTO = __webpack_require__(359)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(342)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(363).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(336);
	var anObject = __webpack_require__(337);
	var getKeys = __webpack_require__(351);
	
	module.exports = __webpack_require__(340) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(352);
	var enumBugKeys = __webpack_require__(362);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(345);
	var toIObject = __webpack_require__(353);
	var arrayIndexOf = __webpack_require__(356)(false);
	var IE_PROTO = __webpack_require__(359)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(354);
	var defined = __webpack_require__(327);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(355);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(353);
	var toLength = __webpack_require__(357);
	var toAbsoluteIndex = __webpack_require__(358);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(326);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(326);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(360)('keys');
	var uid = __webpack_require__(361);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(332);
	var global = __webpack_require__(331);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(329) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(331).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(336).f;
	var has = __webpack_require__(345);
	var TAG = __webpack_require__(365)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(360)('wks');
	var uid = __webpack_require__(361);
	var Symbol = __webpack_require__(331).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(345);
	var toObject = __webpack_require__(367);
	var IE_PROTO = __webpack_require__(359)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(327);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(369);
	var global = __webpack_require__(331);
	var hide = __webpack_require__(335);
	var Iterators = __webpack_require__(347);
	var TO_STRING_TAG = __webpack_require__(365)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(370);
	var step = __webpack_require__(371);
	var Iterators = __webpack_require__(347);
	var toIObject = __webpack_require__(353);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(328)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(365);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(374), __esModule: true };

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(375);
	__webpack_require__(385);
	__webpack_require__(386);
	__webpack_require__(387);
	module.exports = __webpack_require__(332).Symbol;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(331);
	var has = __webpack_require__(345);
	var DESCRIPTORS = __webpack_require__(340);
	var $export = __webpack_require__(330);
	var redefine = __webpack_require__(346);
	var META = __webpack_require__(376).KEY;
	var $fails = __webpack_require__(341);
	var shared = __webpack_require__(360);
	var setToStringTag = __webpack_require__(364);
	var uid = __webpack_require__(361);
	var wks = __webpack_require__(365);
	var wksExt = __webpack_require__(372);
	var wksDefine = __webpack_require__(377);
	var enumKeys = __webpack_require__(378);
	var isArray = __webpack_require__(381);
	var anObject = __webpack_require__(337);
	var isObject = __webpack_require__(338);
	var toObject = __webpack_require__(367);
	var toIObject = __webpack_require__(353);
	var toPrimitive = __webpack_require__(343);
	var createDesc = __webpack_require__(344);
	var _create = __webpack_require__(349);
	var gOPNExt = __webpack_require__(382);
	var $GOPD = __webpack_require__(384);
	var $GOPS = __webpack_require__(379);
	var $DP = __webpack_require__(336);
	var $keys = __webpack_require__(351);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(383).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(380).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(329)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(335)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(361)('meta');
	var isObject = __webpack_require__(338);
	var has = __webpack_require__(345);
	var setDesc = __webpack_require__(336).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(341)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(331);
	var core = __webpack_require__(332);
	var LIBRARY = __webpack_require__(329);
	var wksExt = __webpack_require__(372);
	var defineProperty = __webpack_require__(336).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(351);
	var gOPS = __webpack_require__(379);
	var pIE = __webpack_require__(380);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(355);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(353);
	var gOPN = __webpack_require__(383).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(352);
	var hiddenKeys = __webpack_require__(362).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(380);
	var createDesc = __webpack_require__(344);
	var toIObject = __webpack_require__(353);
	var toPrimitive = __webpack_require__(343);
	var has = __webpack_require__(345);
	var IE8_DOM_DEFINE = __webpack_require__(339);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(340) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 385 */
/***/ (function(module, exports) {



/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(377)('asyncIterator');


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(377)('observable');


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(389);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(393);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(321);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(390), __esModule: true };

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(391);
	module.exports = __webpack_require__(332).Object.setPrototypeOf;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(330);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(392).set });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(338);
	var anObject = __webpack_require__(337);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(333)(Function.call, __webpack_require__(384).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(395);
	var $Object = __webpack_require__(332).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(330);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(349) });


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(397);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(398), __esModule: true };

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(399);
	module.exports = __webpack_require__(332).Object.assign;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(330);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(400) });


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(340);
	var getKeys = __webpack_require__(351);
	var gOPS = __webpack_require__(379);
	var pIE = __webpack_require__(380);
	var toObject = __webpack_require__(367);
	var IObject = __webpack_require__(354);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(341)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(404));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(406));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(407));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(410));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(408));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(409));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var _on = _interopRequireDefault(__webpack_require__(404));
	
	var _off = _interopRequireDefault(__webpack_require__(406));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(414)();
	}


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(28);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(417);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(420);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(423);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(421);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(440);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(441);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(405);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(442);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(408);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(422);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(418);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(418);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(417);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(421);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(422);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(411);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(424);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(433);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(412);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(437);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(425));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(427));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(429));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(430));
	
	var _properties = __webpack_require__(431);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(432));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(426));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(428));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(425));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(434));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(436));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(435));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(435));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(438);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(411);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(404);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(406);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(411));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(444);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(404);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(431);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(447);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(448), __esModule: true };

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(449);
	module.exports = __webpack_require__(332).Object.entries;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(330);
	var $entries = __webpack_require__(450)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(340);
	var getKeys = __webpack_require__(351);
	var toIObject = __webpack_require__(353);
	var isEnum = __webpack_require__(380).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(447);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var React = __webpack_require__(2);
	
	
	var Notify = React.createClass({
		displayName: "Notify",
		key: 0,
		getInitialState: function() {
			return {};
		},
		success: function(title, msg, time) {
			this.addNotify(title, msg, time, 'success');
		},
		error: function(title, msg, time) {
			this.addNotify(title, msg, time, 'error');
		},
		info: function(title, msg, time) {
			this.addNotify(title, msg, time, 'info');
		},
		addNotify: function(title, msg, time, theme) {
			var key         = this.key++;
			this.state[key] = { title: title, msg: msg, time: time, theme: theme };
			this.setState(this.state);
			this.countToHide(time, key);
		},
		countToHide: function(duration, key) {
			var that = this;
			setTimeout(function() {
				that.hideNotification(key);
			}, duration);
		},
		hideNotification: function(key) {
			delete this.state[key];
			this.setState(this.state);
		},
		render: function() {
			var keys  = Object.keys(this.state);
			var state = this.state;
			var hide  = this.hideNotification;
			var el    = keys.map(function(key) {
				return React.createElement(Item, {
							id: key,
							key: key,
							theme: state[key].theme,
							hideNotification: hide,
							title: state[key].title,
							msg: state[key].msg
						}
				)
			});
			return (React.createElement("div", { className: "notify-container" }, el));
		}
	});
	
	var Item = React.createClass({
		displayName: "Item",
		hideNotification: function() {
			this.props.hideNotification(this.props.id);
		},
		render: function() {
			return (
					React.createElement("div", { className: "notify-item " + this.props.theme, onClick: this.hideNotification },
							React.createElement("p", { className: "notify-title" }, this.props.title),
	
							React.createElement("p", { className: "notify-body" }, this.props.msg)
					)
			)
		}
	});
	module.exports = Notify;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	var axiosRaw = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response.message);
	    } else {
	        return Promise.resolve(response.data);
	    }
	});
	
	axiosRaw.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response);
	    } else {
	        return Promise.resolve(response);
	    }
	});
	
	exports.default = {
	    client: {
	        indicators: {
	            getManagementIndicators: function getManagementIndicators(idClient, initDate, finishDate) {
	                return axios.get('/api/indicators/' + idClient + '/search?init_date=' + initDate + '&finish_date=' + finishDate);
	            },
	            getSummaryIndicatorsPeriod: function getSummaryIndicatorsPeriod(idClient, period, year) {
	                return axios.get('/api/indicators/' + idClient + '/summary-search?month=' + period + '&year=' + year);
	            },
	            getStats: function getStats(idClient, initDate, finishDate) {
	                return axios.get('/api/indicators/' + idClient + '/get-stats?init_date=' + initDate + '&finish_date=' + finishDate);
	            }
	        }
	    },
	
	    acta: {
	        indicators: {
	            getActaPreview: function getActaPreview(idInventario) {
	                return axios.get('/api/preview-acta/' + idInventario);
	            },
	            showActa: function showActa(idInventario) {
	                return axios.get('/api/show-acta/' + idInventario);
	            },
	            getImagenes: function getImagenes(idInventario) {
	                return axios.get('/api/get-imagenes/' + idInventario);
	            },
	            getChecklist: function getChecklist(idInventario) {
	                return axios.get('/api/get-checklist/' + idInventario);
	            }
	        }
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "homeService.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(462);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(463);
	var utils = __webpack_require__(464);
	var dispatchRequest = __webpack_require__(465);
	var InterceptorManager = __webpack_require__(474);
	var isAbsoluteURL = __webpack_require__(475);
	var combineURLs = __webpack_require__(476);
	var bind = __webpack_require__(477);
	var transformData = __webpack_require__(469);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	module.exports.Axios = Axios;
	
	// Expose properties from defaultInstance
	axios.defaults = defaultInstance.defaults;
	axios.interceptors = defaultInstance.interceptors;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(478);
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isStream(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function processContentTypeHeader(val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(466);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(466);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	var buildURL = __webpack_require__(467);
	var parseHeaders = __webpack_require__(468);
	var transformData = __webpack_require__(469);
	var isURLSameOrigin = __webpack_require__(470);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(471);
	var settle = __webpack_require__(472);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	  var loadEvent = 'onreadystatechange';
	  var xDomain = false;
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	  if (("production") !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	    loadEvent = 'onload';
	    xDomain = true;
	    request.onprogress = function handleProgress() {};
	    request.ontimeout = function handleTimeout() {};
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request[loadEvent] = function handleLoad() {
	    if (!request || (request.readyState !== 4 && !xDomain)) {
	      return;
	    }
	
	    // The request errored out and we didn't get a response, this will be
	    // handled by onerror instead
	    if (request.status === 0) {
	      return;
	    }
	
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config,
	      request: request
	    };
	
	    settle(resolve, reject, response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle timeout
	  request.ontimeout = function handleTimeout() {
	    var err = new Error('timeout of ' + config.timeout + 'ms exceeded');
	    err.timeout = config.timeout;
	    err.code = 'ECONNABORTED';
	    reject(err);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(473);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  // Handle progress if needed
	  if (config.progress) {
	    if (config.method === 'post' || config.method === 'put') {
	      request.upload.addEventListener('progress', config.progress);
	    } else if (config.method === 'get') {
	      request.addEventListener('progress', config.progress);
	    }
	  }
	
	  if (requestData === undefined) {
	    requestData = null;
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(response);
	  }
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(464);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelIndicators = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowIndicators = __webpack_require__(480);
	
	var _RowSummaryIndicators = __webpack_require__(607);
	
	var _PanelIndicators = __webpack_require__(487);
	
	var _PanelIndicators2 = _interopRequireDefault(_PanelIndicators);
	
	var _HeaderFiltro = __webpack_require__(608);
	
	var _HeaderFiltro2 = _interopRequireDefault(_HeaderFiltro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// components
	
	// css
	
	
	var PanelIndicators = exports.PanelIndicators = function (_Component) {
	    _inherits(PanelIndicators, _Component);
	
	    function PanelIndicators(props) {
	        _classCallCheck(this, PanelIndicators);
	
	        var _this = _possibleConstructorReturn(this, (PanelIndicators.__proto__ || Object.getPrototypeOf(PanelIndicators)).call(this, props));
	
	        _this.state = {
	            indicadores: [],
	            sinIndicadores: false
	        };
	        _this.actualizarAvances = _this.actualizarAvances.bind(_this);
	        _this.handleActualizarClick = _this.handleActualizarClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(PanelIndicators, [{
	        key: 'actualizarAvances',
	        value: function actualizarAvances() {
	            this.props.getStats();
	        }
	    }, {
	        key: 'handleActualizarClick',
	        value: function handleActualizarClick() {
	            this.actualizarAvances();
	        }
	    }, {
	        key: 'actualizarFiltro',
	        value: function actualizarFiltro(filtros) {
	            var arrayFinal = [];
	            var filtrados = filtros.filter(function (aux) {
	                return aux.seleccionado == true;
	            });
	            if (filtrados.length == 0) {
	                this.setState({
	                    indicadores: arrayFinal,
	                    sinIndicadores: true
	                });
	                this.props.setFiltro(arrayFinal);
	            } else {
	                for (var i = 0; i < this.props.indicators.length; i++) {
	                    for (var j = 0; j < filtrados.length; j++) {
	                        if (this.props.indicators[i].client_name == filtrados[j].texto) {
	                            arrayFinal.push(this.props.indicators[i]);
	                        }
	                    }
	                }
	                this.setState({
	                    indicadores: arrayFinal,
	                    sinIndicadores: false
	                });
	                if (filtros.length == filtrados.length) {
	                    this.props.setFiltro(arrayFinal, true);
	                } else {
	                    this.props.setFiltro(arrayFinal);
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.fetchIndicators();
	            // Espera 30 segundos antes de ejecutar por primera vez
	            this.timeout = setTimeout(function () {
	                _this2.actualizarAvances();
	                // Luego se repite cada 30 segundos
	                _this2.interval = setInterval(function () {
	                    _this2.actualizarAvances();
	                }, 300000);
	            }, 15000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.timeout);
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel-primary', style: { maxHeight: 'calc(95vh - 100px)', overflowY: 'auto' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-heading' },
	                    'Indicadores de Gesti\xF3n Inventarios, ',
	                    this.props.dateDay,
	                    ' ',
	                    this.props.dateTitle,
	                    _react2.default.createElement('span', { className: 'pull-right glyphicon glyphicon glyphicon glyphicon glyphicon-chevron-right', onClick: this.props.dayBefore }),
	                    _react2.default.createElement('span', { className: 'pull-right glyphicon glyphicon glyphicon glyphicon glyphicon-chevron-left', onClick: this.props.dayAfter }),
	                    _react2.default.createElement('input', { className: _PanelIndicators2.default.inputDate, type: 'date', value: new Date(this.props.day).toISOString().slice(0, 10), onChange: this.props.selectDay }),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'btn btn-sm btn-primary pull-right',
	                            onClick: this.handleActualizarClick,
	                            style: { marginRight: '10px' }
	                        },
	                        'Actualizar Avance',
	                        _react2.default.createElement('span', { style: { padding: '2px' }, className: 'glyphicon glyphicon-signal' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body ' + _PanelIndicators2.default.PanelIndicators_panelBody },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-striped table-hover no-margin table-condensed ' + _PanelIndicators2.default.PanelIndicators },
	                            _react2.default.createElement(
	                                'thead',
	                                { style: { position: 'sticky', top: '0px', zIndex: '1', backgroundColor: 'white' } },
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    this.props.perms.backups ? _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Backups'
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { colSpan: this.props.permissions ? 2 : 1 },
	                                        'Reporte'
	                                    ),
	                                    /* {this.props.admin == true ? null : */_react2.default.createElement(
	                                        'th',
	                                        null,
	                                        _react2.default.createElement(_HeaderFiltro2.default, { nombre: 'Cliente',
	                                            indicators: this.props.indicators,
	                                            actualizarFiltro: this.actualizarFiltro.bind(this),
	                                            sinFiltro: this.props.sinFiltro
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'CE'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thStoreName },
	                                        'Nombre'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thSupervisorName },
	                                        'Supervisor'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thItemsQuantity },
	                                        'Dotaci\xF3n'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thItemsQuantity },
	                                        'Conteo Unidades'
	                                    ),
	                                    this.props.desvio ? _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thItemsQuantity },
	                                        'Desv. Stock'
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thTime },
	                                        'Horas IG'
	                                    ),
	                                    this.props.permissions ? _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Nota Conteo'
	                                    ) : null,
	                                    this.props.permissions ? _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Nota Pres.'
	                                    ) : null,
	                                    this.props.permissions ? _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Nota Super.'
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Nota Promedio'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { minWidth: '50px' } },
	                                        'Error SEI %'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Estand. SEI %'
	                                    ),
	                                    this.props.showOtherData ? _react2.default.createElement(
	                                        'th',
	                                        { style: { whiteSpace: 'nowrap' } },
	                                        'Varianza %'
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thPttRevRate },
	                                        'Tiempo Revisi\xF3n'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thPttRevRate },
	                                        '% Rev. Patentes'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thItemsRevRate },
	                                        '% Rev. Items'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thQfErrorRate, style: { minWidth: '45px' } },
	                                        'Error JL %'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thClientStandardRate, style: { minWidth: '60px' } },
	                                        'Estand. Cliente %'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thDiffCLP },
	                                        'Dif. Neta MM $'
	                                    ),
	                                    this.props.permissions ? _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thButtonDownload },
	                                        'Acta'
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thButtonDownload },
	                                        this.props.permissions ? "Acta PDF" : "Acta"
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thButtonDownload },
	                                        'Checklist'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thButtonDownload },
	                                        'IMG'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { className: _PanelIndicators2.default.PanelIndicators_thButtonDownload },
	                                        'Zip'
	                                    ),
	                                    _react2.default.createElement('th', { className: _PanelIndicators2.default.PanelIndicators_thButtonPUC }),
	                                    _react2.default.createElement('th', null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                this.props.cargandoData == true ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        { colSpan: '23', className: 'text-center' },
	                                        'Cargando...'
	                                    )
	                                ) : this.props.indicators.length === 0 ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        { colSpan: '23', className: 'text-center' },
	                                        'Sin indicadores'
	                                    )
	                                ) : this.props.sinFiltro || this.state.indicadores.length == 0 && !this.state.sinIndicadores || this.state.indicadores.length == this.props.indicators.length ? this.props.indicators.map(function (indicator, index) {
	                                    return _react2.default.createElement(_RowIndicators.RowIndicators, {
	                                        key: indicator.inv,
	                                        indicator: indicator,
	                                        showOtherData: _this3.props.showOtherData,
	                                        permissions: _this3.props.permissions,
	                                        perms: _this3.props.perms,
	                                        fcv: _this3.props.fcv,
	                                        unDesviadas: _this3.props.desvio,
	                                        reportar: _this3.props.reportar,
	                                        date: _this3.state.date,
	                                        comentarioDashboard: _this3.props.comentarioDashboard,
	                                        openModalActa: _this3.props.openModalActa,
	                                        openModalActaCliente: _this3.props.openModalActaCliente,
	                                        openModalImagenes: _this3.props.openModalImagenes,
	                                        openModalChecklist: _this3.props.openModalChecklist,
	                                        admin: _this3.props.admin
	                                    });
	                                }) : this.state.sinIndicadores ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        { colSpan: '23', className: 'text-center' },
	                                        'Sin indicadores'
	                                    )
	                                ) : this.state.indicadores.map(function (indicator, index) {
	                                    return _react2.default.createElement(_RowIndicators.RowIndicators, {
	                                        key: indicator.inv,
	                                        indicator: indicator,
	                                        showOtherData: _this3.props.showOtherData,
	                                        permissions: _this3.props.permissions,
	                                        perms: _this3.props.perms,
	                                        fcv: _this3.props.fcv,
	                                        unDesviadas: _this3.props.desvio,
	                                        reportar: _this3.props.reportar,
	                                        date: _this3.state.date,
	                                        comentarioDashboard: _this3.props.comentarioDashboard,
	                                        openModalActa: _this3.props.openModalActa,
	                                        openModalActaCliente: _this3.props.openModalActaCliente,
	                                        openModalImagenes: _this3.props.openModalImagenes,
	                                        openModalChecklist: _this3.props.openModalChecklist,
	                                        admin: _this3.props.admin
	                                    });
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'tfoot',
	                                { style: { backgroundColor: 'white' } },
	                                _react2.default.createElement(_RowSummaryIndicators.RowSummaryIndicators, {
	                                    summaryIndicators: this.props.summaryIndicatorsRange,
	                                    title: 'Resumen Turno',
	                                    linkDownloadData: '/inventarios/descargar-consolidado?client=' + this.props.idClient + '&fechaInicio=' + this.props.dateInit + '&fechaFin=' + this.props.dateInit + '&orden=desc',
	                                    showOtherData: this.props.showOtherData,
	                                    permissions: this.props.permissions,
	                                    fcv: this.props.fcv,
	                                    fsb: this.props.perms.permFSB,
	                                    unDesviadas: this.props.desvio,
	                                    reportar: this.props.reportar,
	                                    admin: this.props.admin
	                                }),
	                                _react2.default.createElement(_RowSummaryIndicators.RowSummaryIndicators, {
	                                    summaryIndicators: this.props.summaryIndicatorsMonth,
	                                    title: 'Resumen Mes Actual',
	                                    linkDownloadData: '/inventarios/descargar-consolidado?client=' + this.props.idClient + '&mes=' + this.props.dateInit + '&orden=desc',
	                                    showOtherData: this.props.showOtherData,
	                                    permissions: this.props.permissions,
	                                    fcv: this.props.fcv,
	                                    fsb: this.props.perms.permFSB,
	                                    unDesviadas: this.props.desvio,
	                                    reportar: this.props.reportar,
	                                    admin: this.props.admin,
	                                    cargando: this.props.cargandoMes
	                                }),
	                                _react2.default.createElement(_RowSummaryIndicators.RowSummaryIndicators, {
	                                    summaryIndicators: this.props.summaryIndicatorsYear,
	                                    title: 'Resumen A\xF1o Actual',
	                                    linkDownloadData: '/inventarios/descargar-consolidado?client=' + this.props.idClient + '&mes=' + this.props.dateYear + '&orden=desc',
	                                    showOtherData: this.props.showOtherData,
	                                    permissions: this.props.permissions,
	                                    fcv: this.props.fcv,
	                                    fsb: this.props.perms.permFSB,
	                                    unDesviadas: this.props.desvio,
	                                    reportar: this.props.reportar,
	                                    admin: this.props.admin,
	                                    cargando: this.props.cargandoYear
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PanelIndicators;
	}(_react.Component);
	
	PanelIndicators.propTypes = {
	    indicators: _react.PropTypes.array.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelIndicators.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowIndicators = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(481);
	
	var _PanelIndicators = __webpack_require__(487);
	
	var _PanelIndicators2 = _interopRequireDefault(_PanelIndicators);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _ButtonArchivoPUC = __webpack_require__(489);
	
	var _ButtonArchivoPUC2 = _interopRequireDefault(_ButtonArchivoPUC);
	
	var _ComentarioIG = __webpack_require__(490);
	
	var _ComentarioIG2 = _interopRequireDefault(_ComentarioIG);
	
	var _ModalBloqueo = __webpack_require__(606);
	
	var _ModalBloqueo2 = _interopRequireDefault(_ModalBloqueo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowIndicators = exports.RowIndicators = function (_Component) {
	    _inherits(RowIndicators, _Component);
	
	    function RowIndicators(props) {
	        _classCallCheck(this, RowIndicators);
	
	        var _this = _possibleConstructorReturn(this, (RowIndicators.__proto__ || Object.getPrototypeOf(RowIndicators)).call(this, props));
	
	        _this.abrirModalBloqueo = function (idUsuario, clientName, nombre) {
	            _this.setState({
	                showModalBloqueo: true,
	                selectedClient: clientName,
	                selectedUserId: idUsuario,
	                selectedUser: nombre
	            });
	        };
	
	        _this.cerrarModalBloqueo = function () {
	            _this.setState({ showModalBloqueo: false });
	        };
	
	        _this.state = {
	            date: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
	            interval: 0,
	            atrasado: false,
	            iniciado: false,
	            showModalBloqueo: false,
	            selectedClient: null,
	            selectedUserId: null,
	            selectedUser: null
	        };
	        return _this;
	    }
	
	    _createClass(RowIndicators, [{
	        key: 'timer',
	        value: function timer(newDateObj) {
	            var _this2 = this;
	
	            var today = new Date();
	            var yyyy = today.getFullYear();
	            var mm = today.getMonth() + 1; // Months start at 0!
	            var dd = today.getDate();
	
	            if (dd < 10) dd = '0' + dd;
	            if (mm < 10) mm = '0' + mm;
	
	            var formattedToday = yyyy + '-' + mm + '-' + dd;
	            var hoy = new Date(formattedToday).getTime();
	            var prog = new Date(this.props.indicator.fecha).getTime();
	            if (hoy == prog) {
	                //&& this.props.indicator.leader != " Suspendido" 
	                if (this.props.indicator.inv_report == 0 && this.props.indicator.leader != " Suspendido" && this.props.indicator.client_name != "SMU") {
	                    var interval = setInterval(function () {
	                        _this2.setState({ date: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) });
	                        if (_this2.state.date >= _this2.props.indicator.horario) {
	                            _this2.setState({
	                                timer: 1
	                            });
	                            _v2.default.reportes.getReporte(_this2.props.indicator.inv).then(function (resp) {
	                                if (resp == false && _this2.state.date >= newDateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })) {
	                                    _this2.setState({
	                                        atrasado: true
	                                    });
	                                }
	                                if (resp == true && _this2.state.date >= newDateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })) {
	                                    _this2.setState({
	                                        atrasado: false,
	                                        iniciado: true
	                                    });
	                                    clearInterval(_this2.state.interval);
	                                }
	                            }).catch(function (err) {
	                                console.log(err);
	                            });
	                        }
	                    }, 30000);
	                    this.setState({ interval: interval });
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var newDateObj = new Date(new Date().toDateString() + ' ' + this.props.indicator.horario);
	            newDateObj.setMinutes(newDateObj.getMinutes() + 10);
	            this.timer(newDateObj);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                showModalBloqueo = _state.showModalBloqueo,
	                selectedClient = _state.selectedClient,
	                selectedUserId = _state.selectedUserId,
	                selectedUser = _state.selectedUser;
	
	            var cargatxt = this.props.perms.cargatxt != null ? this.props.perms.cargatxt : false;
	            //console.log(this.state.date, this.props.indicator.horario, this.state.atrasado)
	            //console.log(this.state.fecha, this.props.indicator.fecha)
	            var totales = {
	                cantError: 0,
	                conteo: 0
	            };
	            //let desvio = aInt(this.props.indicator.indicator.diff_counted_informed) < 0 ? (aInt(this.props.indicator.indicator.diff_counted_informed) * -1) : aInt(this.props.indicator.indicator.diff_counted_informed)
	            //let desviacion = this.props.indicator.stock_teorico * 0.002 < desvio ? <td><strong style={{ color: 'red' }}>{this.props.indicator.indicator.diff_counted_informed}</strong></td> : <td>{this.props.indicator.indicator.diff_counted_informed}</td>
	            var totalConteo = aInt(this.props.indicator.indicator.units_counted);
	            var tdVariance = this.props.permissions ? parseFloat(this.props.indicator.indicator.variance).toFixed(1) > 0.1 || parseFloat(this.props.indicator.indicator.variance).toFixed(1) < -0.1 ? _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.indicator.variance
	                )
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                this.props.indicator.indicator.variance
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                this.props.indicator.indicator.variance
	            );
	            var tdTiempoConteo = this.props.indicator.indicator.ig_hours ? this.props.indicator.indicator.tiempo_conteo ? this.props.indicator.indicator.tiempo_conteo <= '00:30:00' ? _react2.default.createElement(
	                'td',
	                { className: this.props.permissions && this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.bajoRevision ? _PanelIndicators2.default.tooltip : '' },
	                _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.indicator.tiempo_conteo
	                ),
	                this.props.permissions && this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.bajoRevision && _react2.default.createElement(
	                    'span',
	                    { className: _PanelIndicators2.default.tooltiptext },
	                    this.props.indicator.indicator.incumplimientos_sei.bajoRevision.observacion ? this.props.indicator.indicator.incumplimientos_sei.bajoRevision.observacion : 'Sin observaciones aún...'
	                )
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                this.props.indicator.indicator.tiempo_conteo
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                'Sin Registro'
	            ) : _react2.default.createElement('td', null);
	            var tdFCVConteo = this.props.indicator.indicator.ig_hours ? this.props.indicator.indicator.tiempo_conteo ? _react2.default.createElement(
	                'td',
	                null,
	                this.props.indicator.indicator.tiempo_conteo
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                'Sin Registro'
	            ) : _react2.default.createElement('td', null);
	            var tdNotaConteo = parseFloat(this.props.indicator.indicator.nota_conteo).toFixed(1) <= 6.0 ? _react2.default.createElement(
	                'td',
	                { className: _PanelIndicators2.default.tooltip },
	                _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.indicator.nota_conteo
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: _PanelIndicators2.default.tooltiptext, style: { width: '400px', whiteSpace: 'normal' } },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Incumplimiento: '
	                    ),
	                    this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaConteo && this.props.indicator.indicator.incumplimientos_sei.notaConteo.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaConteo.observacion : 'Sin observaciones aún...'
	                )
	            ) : _react2.default.createElement(
	                'td',
	                null,
	                this.props.indicator.indicator.nota_conteo
	            );
	
	            var liderNombre = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Titular : null;
	            var liderCantError = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.CantError : null;
	            var liderError = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Error : null;
	            var liderConteo = this.props.indicator.indicator.tooltip_lider ? this.props.indicator.indicator.tooltip_lider.Conteo : null;
	            totales.cantError += !isNaN(parseInt(liderCantError)) ? parseInt(liderCantError) : 0;
	            totales.conteo += !isNaN(parseInt(liderConteo)) ? parseInt(liderConteo) : 0;
	
	            var span = this.props.indicator.indicator.tooltip_titulares ? _react2.default.createElement(
	                'span',
	                { className: _PanelIndicators2.default.tooltiptext },
	                this.props.indicator.client_name == 'CID' ? this.props.admin ? "Error ITEMS corregidos" : "Error Patentes corregidas" : null,
	                this.props.indicator.client_name == 'CID' && _react2.default.createElement('br', null),
	                this.props.indicator.client_name,
	                ' - ',
	                this.props.indicator.store_number,
	                ' - ',
	                this.props.indicator.store_name,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'table',
	                    { style: {
	                            fontSize: '12px',
	                            width: '100%'
	                        } },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement('th', { className: _PanelIndicators2.default.PanelIndicators_thTitulos }),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PanelIndicators2.default.PanelIndicators_thTitulos },
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PanelIndicators2.default.PanelIndicators_thTitulos },
	                                'Cant.Error'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PanelIndicators2.default.PanelIndicators_thTitulos },
	                                'Error'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PanelIndicators2.default.PanelIndicators_thTitulos },
	                                'Conteo'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PanelIndicators2.default.PanelIndicators_thTitulos },
	                                'EXP'
	                            ),
	                            this.props.perms.canBlock && _react2.default.createElement('th', { className: _PanelIndicators2.default.PanelIndicators_thTitulos })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_tdLiderName },
	                                liderNombre
	                            ),
	                            _react2.default.createElement('td', { className: _PanelIndicators2.default.PanelIndicators_tdLiderName }),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_tdLiderStats },
	                                liderCantError
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_tdLiderStats },
	                                liderError
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_tdLiderStats },
	                                miles(liderConteo)
	                            )
	                        ),
	                        this.props.indicator.indicator.tooltip_titulares.map(function (titular, index) {
	                            totales.cantError += !isNaN(parseInt(titular.CantError)) ? parseInt(titular.CantError) : 0;
	                            totales.conteo += !isNaN(parseInt(titular.Conteo)) ? parseInt(titular.Conteo) : 0;
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdName },
	                                    titular.Titular
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdName },
	                                    titular.Comuna
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdStats },
	                                    titular.CantError
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdStats },
	                                    titular.Error
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdStats },
	                                    miles(titular.Conteo)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PanelIndicators2.default.PanelIndicators_tdStats },
	                                    titular.EXP
	                                ),
	                                _this3.props.perms.canBlock && _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-danger btn-xs',
	                                            onClick: function onClick() {
	                                                return _this3.abrirModalBloqueo(titular.idUsuario, _this3.props.indicator.client_name, titular.Titular);
	                                            },
	                                            style: { display: 'flex', maxHeight: '8px', maxWidth: '8px', alignItems: 'center', justifyContent: 'center' } },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ban-circle' })
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'tfoot',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            { style: { borderTop: '1px solid white' } },
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totalesName },
	                                'Otros:'
	                            ),
	                            _react2.default.createElement('td', { className: _PanelIndicators2.default.PanelIndicators_totales }),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                '0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                '0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                miles(totalConteo - totales.conteo)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                '0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totalesName },
	                                'Totales:'
	                            ),
	                            _react2.default.createElement('td', { className: _PanelIndicators2.default.PanelIndicators_totales }),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                totales.cantError
	                            ),
	                            _react2.default.createElement('td', { className: _PanelIndicators2.default.PanelIndicators_totales }),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _PanelIndicators2.default.PanelIndicators_totales },
	                                this.props.indicator.indicator.units_counted
	                            ),
	                            _react2.default.createElement('td', { className: _PanelIndicators2.default.PanelIndicators_totales })
	                        )
	                    )
	                ),
	                this.props.permissions && this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.errorOperadores && _react2.default.createElement(
	                    'div',
	                    { style: { whiteSpace: 'normal' } },
	                    this.props.indicator.indicator.incumplimientos_sei.errorOperadores.operadores && this.props.indicator.indicator.incumplimientos_sei.errorOperadores.operadores.map(function (operador) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: operador.id, style: { marginLeft: '5px', marginBottom: '5px' } },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                operador.usuario.nombre1,
	                                ' ',
	                                operador.usuario.apellidoPaterno
	                            ),
	                            ' - ',
	                            'Error: ',
	                            operador.porcentaje_error,
	                            '%',
	                            ' - ',
	                            'Cantidad: ',
	                            operador.cantidad,
	                            _react2.default.createElement('br', null),
	                            'Comentario:',
	                            ' ',
	                            operador.comentario || 'Sin comentario'
	                        );
	                    })
	                )
	            ) : null;
	            var spanNomina = this.props.indicator.indicator.tooltip_nomina ? _react2.default.createElement(
	                'span',
	                { className: _PanelIndicators2.default.tooltiptextCECO },
	                'Prod.Sugerida: ',
	                this.props.indicator.indicator.tooltip_nomina.prod_sugerida,
	                _react2.default.createElement('br', null),
	                'Llegada inventario: ',
	                this.props.indicator.indicator.tooltip_nomina.hora_llegada,
	                _react2.default.createElement('br', null),
	                'Tot. hrs. conteo: ',
	                this.props.indicator.indicator.tooltip_nomina.total_horas_conteo,
	                _react2.default.createElement('br', null),
	                'Dotaci\xF3n: ',
	                this.props.indicator.indicator.tooltip_nomina.dotacion,
	                _react2.default.createElement('br', null),
	                'Total sala: ',
	                this.props.indicator.indicator.tooltip_nomina.total_sala,
	                _react2.default.createElement('br', null),
	                'Total bodega: ',
	                this.props.indicator.indicator.tooltip_nomina.total_bodega,
	                _react2.default.createElement('br', null),
	                'Tot. unds te\xF3rico: ',
	                this.props.indicator.indicator.tooltip_nomina.total_teorico,
	                _react2.default.createElement('br', null),
	                'Nota presentaci\xF3n: ',
	                this.props.indicator.indicator.tooltip_nomina.nota_presentacion,
	                _react2.default.createElement('br', null),
	                'Nota supervisor: ',
	                this.props.indicator.indicator.tooltip_nomina.nota_supervisor,
	                _react2.default.createElement('br', null)
	            ) : null;
	
	            var spanJL = _react2.default.createElement(
	                'span',
	                { className: _PanelIndicators2.default.tooltiptext },
	                this.props.indicator.indicator.tooltip_jl ? this.props.indicator.indicator.tooltip_jl : 'No informado'
	            );
	
	            /*let spanNomina = indicator.indicator.tooltip_nomina ?
	                <span className={style.tooltiptextCECO}>
	                    Prod.Sugerida: {miles(indicator.indicator.tooltip_nomina.prod_sugerida)}<br />
	                    Llegada inventario: {indicator.indicator.tooltip_nomina.hora_llegada}<br />
	                    Tot. hrs. conteo: {indicator.indicator.tooltip_nomina.total_horas_conteo}<br />
	                    Dotación: {indicator.indicator.tooltip_nomina.dotacion}<br />
	                    Total sala: {indicator.indicator.tooltip_nomina.total_sala}<br />
	                    Total bodega: {indicator.indicator.tooltip_nomina.total_bodega}<br />
	                    Tot. unds teórico: {indicator.indicator.tooltip_nomina.total_teorico}<br />
	                    Nota presentación: {indicator.indicator.tooltip_nomina.nota_presentacion}<br />
	                    Nota supervisor: {indicator.indicator.tooltip_nomina.nota_supervisor}<br />
	                </span> : null*/
	
	            var styleTR = this.props.indicator.es_dia ? '#fdfd96' : null;
	            styleTR = this.props.indicator.inv_especial ? "#B8F2C2" : styleTR;
	
	            //let atrasoReporte = updateTime(indicator.horario, date)
	
	            var statusReporte1 = this.props.indicator.inv_report.length >= 1 ? _react2.default.createElement(
	                'p',
	                { style: { fontSize: '12px' } },
	                '1. Iniciado: ',
	                _react2.default.createElement('br', null),
	                'Dotacion equipo: ',
	                (Number(this.props.indicator.inv_report[0].dotacion) * 100 / this.props.indicator.dotacion).toFixed(1) + "%",
	                this.props.indicator.inv_report[0].idDescripcionReportesIG == 1 ? " - Dotación completa" : this.props.indicator.inv_report[0].idDescripcionReportesIG == 2 ? " - Dotación incompleta, faltante en camino" : " - Dotación incompleta",
	                ' ',
	                _react2.default.createElement('br', null),
	                'Observaciones: ',
	                this.props.indicator.inv_report[0].comentario.length > 0 ? this.props.indicator.inv_report[0].comentario : "",
	                _react2.default.createElement('br', null),
	                this.props.comentarioDashboard ? this.props.indicator.inv_report[0].idUser ? "Reportado por: " + this.props.indicator.inv_report[0].idUser : "Usuario encargado de reportar no registrado" : null
	            ) : "Reporte aún no iniciado";
	
	            var statusReporte2 = this.props.indicator.inv_report.length >= 2 ? _react2.default.createElement(
	                'p',
	                { style: { fontSize: '12px' } },
	                '2. Avance: Uni. Teo: ',
	                miles(this.props.indicator.stock_teorico),
	                ' - Uni. Con: ',
	                miles((this.props.indicator.stock_teorico * this.props.indicator.inv_report[1].avance / 100).toFixed()),
	                ' - %Error: ',
	                this.props.indicator.inv_report[1].error + "%",
	                _react2.default.createElement('br', null),
	                'Hora:  ',
	                this.props.indicator.inv_report[1].hora,
	                ' ',
	                _react2.default.createElement('br', null),
	                '%Avance: ',
	                this.props.indicator.inv_report[1].avance + "%",
	                ' - %Auditoria: ',
	                this.props.indicator.inv_report[1].avance >= 50 && this.props.indicator.inv_report[1].auditoria < 15 ? _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.inv_report[1].auditoria + "%"
	                ) : this.props.indicator.inv_report[1].auditoria + "%",
	                '  ',
	                _react2.default.createElement('br', null),
	                'Hora termino conteo estimada: ',
	                horaEstimada(this.props.indicator.inv_report[0].hora, this.props.indicator.inv_report[1].hora, this.props.indicator.inv_report[1].avance),
	                ' ',
	                _react2.default.createElement('br', null),
	                this.props.comentarioDashboard ? this.props.indicator.inv_report[1].idUser ? "Reportado por: " + this.props.indicator.inv_report[1].idUser : "Usuario encargado de reportar no registrado" : null
	            ) : "";
	            var statusReporte3 = this.props.indicator.inv_report.length == 3 ? this.props.indicator.indicator.id_file ? _react2.default.createElement(
	                'p',
	                { style: { fontSize: '12px' } },
	                '3. Finalizado. ',
	                _react2.default.createElement('br', null),
	                'El proceso de inventario ha finalizado siendo las ',
	                this.props.indicator.inv_report[2].hora,
	                ' hrs ',
	                _react2.default.createElement('br', null),
	                'Tiempo de revision de ',
	                this.props.indicator.indicator.tiempo_conteo,
	                ' ',
	                _react2.default.createElement('br', null),
	                'Con una evaluacion total de ',
	                this.props.indicator.indicator.avg_scores,
	                ' ',
	                _react2.default.createElement('br', null),
	                'Con porcentaje de error de ',
	                this.props.indicator.indicator.sei_error,
	                '%, nivel de cumplimiento de ',
	                this.props.indicator.indicator.sei_standard,
	                '% ',
	                _react2.default.createElement('br', null),
	                'Y las siguientes obeservaciones: ',
	                this.props.indicator.deterioro ? "Si se genera deterioro" : "No se genera deterioro",
	                ' ',
	                _react2.default.createElement('br', null),
	                this.props.comentarioDashboard ? this.props.indicator.inv_report[2].idUser ? "Reportado por: " + this.props.indicator.inv_report[2].idUser : "Usuario encargado de reportar no registrado" : null
	            ) : "3. Finalizado." : "";
	
	            var spanReporte = _react2.default.createElement(
	                'span',
	                { className: _PanelIndicators2.default.tooltiptextReporte },
	                this.props.indicator.client_name + " " + this.props.indicator.store_number + " " + this.props.indicator.store_commune + " / " + this.props.indicator.leader + " - " + this.props.indicator.horario,
	                ' hrs.',
	                _react2.default.createElement('br', null),
	                'Hora inicio: ',
	                this.props.indicator.inv_report.length > 0 ? this.props.indicator.inv_report[0].hora : "Aún no iniciado",
	                _react2.default.createElement('br', null),
	                statusReporte1,
	                statusReporte2,
	                statusReporte3
	            );
	
	            var tdIGHour = _react2.default.createElement(
	                'td',
	                { className: this.props.permissions ? _PanelIndicators2.default.tooltip : '' },
	                this.props.permissions ? this.props.indicator.client_name == 'FCV' ? this.props.indicator.indicator.ig_hours >= '09:15:00' ? _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.indicator.ig_hours
	                ) : this.props.indicator.indicator.ig_hours : this.props.indicator.client_name == 'MAI' ? this.props.indicator.indicator.ig_hours >= '10:15:00' ? _react2.default.createElement(
	                    'strong',
	                    { style: { color: 'red' } },
	                    this.props.indicator.indicator.ig_hours
	                ) : this.props.indicator.indicator.ig_hours : this.props.indicator.indicator.ig_hours >= '10:00:00' ? _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.props.indicator.indicator.ig_hours
	                ) : this.props.indicator.indicator.ig_hours : this.props.indicator.indicator.ig_hours,
	                this.props.permissions && this.props.indicator.indicator.ig_hours ? _react2.default.createElement(
	                    'span',
	                    { className: _PanelIndicators2.default.tooltiptext },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.indicator.indicator.hora_inicio ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora Inicio Conteo: ',
	                            this.props.indicator.indicator.hora_inicio
	                        ) : null,
	                        this.props.indicator.indicator.hora_fin_conteo ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora Fin Conteo: ',
	                            this.props.indicator.indicator.hora_fin_conteo
	                        ) : null,
	                        this.props.indicator.indicator.fecha_grilla ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora T\xE9rmino Grilla: ',
	                            this.props.indicator.indicator.fecha_grilla
	                        ) : null,
	                        this.props.indicator.indicator.hora_inicio_revision ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora Inicio Revisi\xF3n: ',
	                            this.props.indicator.indicator.hora_inicio_revision
	                        ) : null,
	                        this.props.indicator.indicator.hora_fin_revision ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora Fin Revisi\xF3n: ',
	                            this.props.indicator.indicator.hora_fin_revision
	                        ) : null,
	                        this.props.indicator.indicator.hora_subida_archivo ? _react2.default.createElement(
	                            'p',
	                            { style: { padding: '2px' } },
	                            'Hora Fin Proceso: ',
	                            this.props.indicator.indicator.hora_subida_archivo
	                        ) : null
	                    )
	                ) : null
	            );
	
	            var cantidadDotacion = Object.values(this.props.indicator.indicator).length > 0 ? this.props.indicator.indicator.tooltip_titulares.length : '';
	            return _react2.default.createElement(
	                'tr',
	                { style: { backgroundColor: styleTR } },
	                this.props.perms.backups ? _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs',
	                            href: '/inventario/' + this.props.indicator.inv + '/backups' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-cloud' })
	                    )
	                ) : null,
	                this.props.reportar ? this.props.indicator.inv_report == 0 ? this.state.atrasado ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-danger btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : this.state.iniciado ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-default btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : this.props.indicator.inv_report.length == 1 ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : this.props.indicator.inv_report.length == 2 ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-warning btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-primary btn-xs',
	                            href: '/api/reporte/inventarios/' + this.props.indicator.inv },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-comment' }),
	                        spanReporte
	                    )
	                ) : _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.indicator.inv_report == 0 ? this.state.atrasado ? _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButtonRojo, type: 'radio', defaultChecked: true }) : this.state.iniciado ? _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButton1, type: 'radio', defaultChecked: true }) : _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButton0, type: 'radio', defaultChecked: true }) : this.props.indicator.inv_report.length == 1 ? _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButton1, type: 'radio', defaultChecked: true }) : this.props.indicator.inv_report.length == 2 ? _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButton2, type: 'radio', defaultChecked: true }) : _react2.default.createElement('input', { className: _PanelIndicators2.default.radioButton3, type: 'radio', defaultChecked: true }),
	                        spanReporte
	                    )
	                ),
	                this.props.permissions ? this.props.indicator.avance ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltipAvance },
	                    _react2.default.createElement('i', { className: 'glyphicon glyphicon-signal',
	                        style: {
	                            color: this.props.indicator.avance.online ? 'green' : 'red',
	                            cursor: 'help',
	                            fontSize: '16px'
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptextAvance,
	                            style: {
	                                minWidth: '280px',
	                                backgroundColor: '#1f1f1f',
	                                color: '#fff',
	                                padding: '5px 7px',
	                                borderRadius: '8px',
	                                fontSize: '10px',
	                                lineHeight: '1.0',
	                                boxShadow: '0 0 8px rgba(0,0,0,0.4)',
	                                textAlign: 'left'
	                            } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontWeight: 'bold', fontSize: '13px', marginBottom: '6px' } },
	                            'Avance de inventario'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    width: '100%',
	                                    height: '4px',
	                                    backgroundColor: '#333',
	                                    borderRadius: '3px',
	                                    marginBottom: '5px'
	                                } },
	                            _react2.default.createElement('div', { style: {
	                                    width: this.props.indicator.avance.por_avance_unidades + '%',
	                                    height: '100%',
	                                    backgroundColor: '#00bcd4',
	                                    borderRadius: '3px',
	                                    transition: 'width 0.5s'
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '11px', marginBottom: '8px' } },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                parseFloat(this.props.indicator.avance.por_avance_unidades).toFixed(1),
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Local'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.indicator.avance.nombre_local
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Hora de inicio programada:'
	                            ),
	                            ' ',
	                            this.props.indicator.avance.hora_inicio_programada,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Hora de inicio real:'
	                            ),
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { style: { fontWeight: 'bold' } },
	                                this.props.indicator.avance.hora_inicio_real
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Tiempo proceso:'
	                            ),
	                            ' ',
	                            this.props.indicator.avance.tiempo_transcurrido_hora_capturando,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Tiempo restante:'
	                            ),
	                            ' ',
	                            this.props.indicator.avance.tiempo_faltante_hora_captura,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Hora de t\xE9rmino aprox:'
	                            ),
	                            ' ',
	                            this.props.indicator.avance.fecha_estimada_cierre,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Dotaci\xF3n total:'
	                            ),
	                            ' ',
	                            this.props.indicator.avance.dotacion_diferencia
	                        ),
	                        _react2.default.createElement('hr', { style: { border: '0.5px solid #444', margin: '8px 0' } }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Stock te\xF3rico'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseInt(this.props.indicator.avance.cantidad_teorica).toLocaleString(),
	                                ' (100%)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Avance uni. contadas'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseInt(this.props.indicator.avance.cantidad_fisica).toLocaleString(),
	                                ' (',
	                                parseFloat(this.props.indicator.avance.por_avance_unidades).toFixed(1),
	                                '%)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Avance sala'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseFloat(this.props.indicator.avance.por_avance_sala).toFixed(1),
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Avance bodega'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseFloat(this.props.indicator.avance.por_avance_bodega).toFixed(1),
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement('hr', { style: { border: '0.5px solid #444', margin: '8px 0' } }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontWeight: 'bold', marginBottom: '4px' } },
	                            'Auditor\xEDa'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Hora de inicio'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.indicator.avance.fecha_inicio_auditoria
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Avance \xEDtems'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseFloat(this.props.indicator.avance.por_avance_auditoria).toFixed(1),
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Error'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                parseFloat(this.props.indicator.avance.por_nivel_error).toFixed(1),
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement('hr', { style: { border: '0.5px solid #444', margin: '8px 0' } }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { fontWeight: 'bold' } },
	                                'L\xEDder SEI'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.indicator.avance.nombre_lider
	                            )
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('i', { className: 'glyphicon glyphicon-signal', style: { color: 'gray' }
	                    })
	                ) : null,
	                /* this.props.admin == true ? null : */_react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.client_name
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdStoreNumber },
	                    this.props.indicator.store_number,
	                    this.props.permissions ? spanNomina : null
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdStoreName, title: this.props.indicator.store_name, style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px' } },
	                    this.props.indicator.store_name
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdSupervisorName, style: { whiteSpace: 'nowrap' } },
	                    this.props.indicator.leader
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdStoreNumber },
	                    cantidadDotacion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdRightTextTwo },
	                    this.props.indicator.indicator.units_counted
	                ),
	                this.props.unDesviadas ? _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.diff_counted_informed
	                ) : null,
	                tdIGHour,
	                this.props.permissions ? tdNotaConteo : null,
	                this.props.permissions ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    this.props.indicator.indicator.nota_presentacion,
	                    this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaPresentacion && _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptext, style: { width: '400px', whiteSpace: 'normal' } },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Incumplimiento: '
	                        ),
	                        this.props.indicator.indicator.incumplimientos_sei.notaPresentacion.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaPresentacion.observacion : 'Sin observaciones aún...'
	                    )
	                ) : null,
	                this.props.permissions ? _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    this.props.indicator.indicator.nota_supervisor,
	                    this.props.indicator.indicator.incumplimientos_sei && this.props.indicator.indicator.incumplimientos_sei.notaSupervisor && _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptext, style: { width: '400px', whiteSpace: 'normal' } },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Incumplimiento: '
	                        ),
	                        this.props.indicator.indicator.incumplimientos_sei.notaSupervisor.observacion ? this.props.indicator.indicator.incumplimientos_sei.notaSupervisor.observacion : 'Sin observaciones aún...'
	                    )
	                ) : null,
	                _react2.default.createElement(
	                    'td',
	                    { className: !this.props.permissions ? _PanelIndicators2.default.tooltip : '' },
	                    this.props.indicator.indicator.avg_scores,
	                    !this.props.permissions ? _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptext },
	                        'Nota Conteo: ',
	                        this.props.indicator.indicator.nota_conteo,
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        'Nota Presentaci\xF3n: ',
	                        this.props.indicator.indicator.nota_presentacion,
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        'Nota Supervisor: ',
	                        this.props.indicator.indicator.nota_supervisor
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    this.props.permissions ? this.props.indicator.indicator.sei_error ? parseFloat(this.props.indicator.indicator.sei_error).toFixed(1) >= 1 ? _react2.default.createElement(
	                        'strong',
	                        { style: { color: 'red' } },
	                        parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%')
	                    ) : parseFloat(this.props.indicator.indicator.sei_error).toFixed(1) < 1 ? this.props.indicator.indicator.error_operadores == true ? _react2.default.createElement(
	                        'strong',
	                        null,
	                        parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%')
	                    ) : parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%') : parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%') : null : this.props.indicator.indicator.sei_error ? parseFloat(this.props.indicator.indicator.sei_error).toFixed(1).concat('%') : null,
	                    span
	                ),
	                showModalBloqueo && _react2.default.createElement(_ModalBloqueo2.default, {
	                    show: showModalBloqueo,
	                    onClose: this.cerrarModalBloqueo,
	                    idUsuario: selectedUserId,
	                    clientName: selectedClient,
	                    usuario: selectedUser
	                }),
	                _react2.default.createElement(
	                    'td',
	                    { className: this.props.permissions ? _PanelIndicators2.default.tooltip : '' },
	                    this.props.indicator.indicator.sei_standard ? parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1) < 95 && this.props.permissions ? _react2.default.createElement(
	                        'strong',
	                        { style: { color: 'red' } },
	                        parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1).concat('%')
	                    ) : parseFloat(this.props.indicator.indicator.sei_standard).toFixed(1).concat('%') : null,
	                    this.props.permissions && Array.isArray(this.props.indicator.indicator.no_cumplidos) && this.props.indicator.indicator.no_cumplidos.length > 0 ? _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptext, style: { width: '500px', whiteSpace: 'normal' } },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Preguntas NO cumplidas'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ol',
	                            { style: { margin: 0, paddingLeft: 18 } },
	                            this.props.indicator.indicator.no_cumplidos.map(function (item, index) {
	                                var incumplimientos = _this3.props.indicator.indicator.incumplimientos_sei;
	                                var estandares = incumplimientos && incumplimientos.estandarSei && incumplimientos.estandarSei.estandares_sei;
	                                var comentario = estandares && estandares[index] ? 'Observaci\xF3n pregunta: ' + estandares[index].comentario : 'Sin observaciones aún...';
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    item,
	                                    _react2.default.createElement(
	                                        'p',
	                                        { style: { color: 'orange' } },
	                                        comentario
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement('br', null)
	                    ) : null
	                ),
	                this.props.showOtherData ? tdVariance : null,
	                this.props.permissions || this.props.fcv ? tdTiempoConteo : tdFCVConteo,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.ptt_rev_rate ? parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1) < 30 && (this.props.fcv || this.props.permissions) ? _react2.default.createElement(
	                        'strong',
	                        { style: { color: 'red' } },
	                        parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1).concat('%')
	                    ) : parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1) <= 50 && this.props.perms.permFSB ? _react2.default.createElement(
	                        'strong',
	                        { style: { color: 'red' } },
	                        parseFloat(this.props.indicator.indicator.ptt_rev_rate).toFixed(1).concat('%')
	                    ) : this.props.indicator.indicator.ptt_rev_rate.concat('%') : this.props.indicator.indicator.ptt_rev_rate
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.items_rev_rate
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltip },
	                    parseFloat(this.props.indicator.indicator.error_client).toFixed(1) > 1 ? _react2.default.createElement(
	                        'strong',
	                        { style: { color: 'red' } },
	                        this.props.indicator.indicator.error_client
	                    ) : this.props.indicator.indicator.error_client,
	                    this.props.permissions ? this.props.indicator.indicator.error_client ? spanJL : null : null
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.client_standard
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.PanelIndicators_tdRightTextTwo + ' ' + (this.props.permissions && this.props.indicator.indicator.resultado_final ? _PanelIndicators2.default.tooltipNeto : '') },
	                    this.props.indicator.indicator.difference_neto ? (this.props.indicator.indicator.difference_neto / 1000).toLocaleString("es-CL", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }) : this.props.indicator.indicator.difference_neto,
	                    this.props.permissions ? _react2.default.createElement(
	                        'span',
	                        { className: _PanelIndicators2.default.tooltiptextNeto },
	                        this.props.indicator.indicator.resultado_final
	                    ) : null
	                ),
	                this.props.permissions ? _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-primary btn-xs',
	                            href: '/inventario/' + this.props.indicator.inv + '/archivo-final', target: "_blank" },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' })
	                    )
	                ) : null,
	                _react2.default.createElement(
	                    'td',
	                    { className: _PanelIndicators2.default.tooltipInicio },
	                    this.props.indicator.indicator.id_file ? this.props.permissions ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary btn-xs'
	                            //href={`/inventario/archivo-final/${this.props.indicator.indicator.id_file}/descargar-acta`}
	                            , onClick: function onClick() {
	                                return _this3.props.openModalActa(_this3.props.indicator.inv);
	                            } },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-list' })
	                    ) : _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary btn-xs'
	                            //href={`/inventario/archivo-final/${this.props.indicator.indicator.id_file}/descargar-acta`}
	                            , onClick: function onClick() {
	                                return _this3.props.openModalActaCliente(_this3.props.indicator.inv);
	                            } },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-file' })
	                    ) : _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-warning btn-xs' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.id_file ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-info btn-xs',
	                            onClick: function onClick() {
	                                return _this3.props.openModalChecklist(_this3.props.indicator.inv);
	                            } },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' })
	                    ) : _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-warning btn-xs' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.id_file ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-info btn-xs',
	                            onClick: function onClick() {
	                                return _this3.props.openModalImagenes(_this3.props.indicator.inv);
	                            } },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-picture' })
	                    ) : _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-warning btn-xs' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.indicator.indicator.id_file ? _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs',
	                            href: '/inventario/archivo-final/' + this.props.indicator.indicator.id_file + '/descargar' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-download' })
	                    ) : _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-warning btn-xs' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    cargatxt === true && (this.props.indicator.client_name == "PUC" || this.props.indicator.client_name == "FSB") && this.props.indicator.fecha >= "2023-01-30" ? _react2.default.createElement(_ButtonArchivoPUC2.default, { indicator: this.props.indicator }) : "",
	                    ' '
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.perms.comentario_inv && _react2.default.createElement(_ComentarioIG2.default, { idInventario: this.props.indicator.inv })
	                )
	            );
	        }
	    }]);
	
	    return RowIndicators;
	}(_react.Component);
	
	var miles = function miles(number) {
	    var mil = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";
	    var decimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";
	
	    if (number == null) {
	        return null;
	    }
	    var parts = number.toString().split(".");
	    var numberPart = parts[0];
	    var decimalPart = parts[1];
	    var thousands = /\B(?=(\d{3})+(?!\d))/g;
	    return numberPart.replace(thousands, mil) + (decimalPart ? decimal + decimalPart : "");
	};
	var aInt = function aInt(number) {
	    if (number == null) {
	        return null;
	    }
	    var parts = number.toString().split(".");
	    var numberPart = parts[0];
	    var decimalPart = parts[1];
	    return Number(numberPart.concat(decimalPart));
	};
	
	var horaEstimada = function horaEstimada(horaInicio, horaAvance, avance) {
	    var partsIni = horaInicio.toString().split(":");
	    var partsAva = horaAvance.toString().split(":");
	    var horaPartIni = partsIni[0];
	    var minutosPartIni = partsIni[1];
	    var horaPartAva = partsAva[0];
	    var minutosPartAva = partsAva[1];
	    var numero1 = Number(horaPartIni) * 60 + Number(minutosPartIni);
	    var numero2 = Number(horaPartAva) * 60 + Number(minutosPartAva);
	    var minutos = numero2 < numero1 ? numero2 + 1440 - numero1 : numero2 - numero1;
	    //1440 son los minutos de 24 horas
	    var diferencia = (minutos * 100 / avance).toFixed() / 60;
	    var test = diferencia.toString().split(".");
	    var minutosEstimada = test[1] ? diferencia > 0 ? (Number(minutosPartIni) + Number("0." + test[1]) * 60).toFixed() : 60 : diferencia > 0 ? (Number(minutosPartIni) + 0).toFixed() : 60;
	    var horaEstimada = Number(horaPartIni) + Number(test[0]);
	    var horaFinal = minutosEstimada >= 60 ? horaEstimada + 1 >= 24 ? horaEstimada + 1 - 24 + ":" + (minutosEstimada - 60) : horaEstimada + 1 + ":" + (minutosEstimada - 60) : horaEstimada + 1 >= 24 ? horaEstimada + 1 - 24 + ":" + minutosEstimada : horaEstimada + 1 + ":" + minutosEstimada;
	    var horaFix = horaFinal.toString().split(":");
	    var hora = Number(horaFix[0]) + 1 < 10 ? "0" + (Number(horaFix[0]) + 1) : Number(horaFix[0]) + 1;
	    var minuto = Number(horaFix[1]) < 10 ? "0" + horaFix[1] : horaFix[1];
	    //return test;
	    return hora + ":" + minuto;
	};
	
	/*const updateTime = (horaInicio, horaActual) => {
	
	}*/

	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowIndicators.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(482);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(483);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(484);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(485)["default"];
	var toPrimitive = __webpack_require__(486);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : String(i);
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(485)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"PanelIndicators__container___2hNq8","divTitulo":"PanelIndicators__divTitulo___2hSo-","spanOrdenar":"PanelIndicators__spanOrdenar___h3G4G","menu":"PanelIndicators__menu___2pDzB","inputTexto":"PanelIndicators__inputTexto___1YaDM","contenedorValores":"PanelIndicators__contenedorValores___1SjIu","filtroColoreado":"PanelIndicators__filtroColoreado___1qCKy","PanelIndicators":"PanelIndicators__PanelIndicators___88d46","PanelIndicators_panelBody":"PanelIndicators__PanelIndicators_panelBody___1XCLC","PanelIndicators_thClient":"PanelIndicators__PanelIndicators_thClient___1ZMEc","PanelIndicators_thStoreNumber":"PanelIndicators__PanelIndicators_thStoreNumber___2-RQn","PanelIndicators_thClientName":"PanelIndicators__PanelIndicators_thClientName___2AXg6","PanelIndicators_thStoreName":"PanelIndicators__PanelIndicators_thStoreName___1JKQl","PanelIndicators_thSupervisorName":"PanelIndicators__PanelIndicators_thSupervisorName___3Qjaj","PanelIndicators_thTime":"PanelIndicators__PanelIndicators_thTime___1CTe9","PanelIndicators_thItemsQuantity":"PanelIndicators__PanelIndicators_thItemsQuantity___3rwiV","PanelIndicators_thProcessHours":"PanelIndicators__PanelIndicators_thProcessHours___3EFwH","PanelIndicators_thAvgGrades":"PanelIndicators__PanelIndicators_thAvgGrades___9gWgq","PanelIndicators_thErrorRate":"PanelIndicators__PanelIndicators_thErrorRate___2Ni01","PanelIndicators_thPttRevRate":"PanelIndicators__PanelIndicators_thPttRevRate___2NLvZ","PanelIndicators_thItemsRevRate":"PanelIndicators__PanelIndicators_thItemsRevRate___1wkiJ","PanelIndicators_thStandardRate":"PanelIndicators__PanelIndicators_thStandardRate___3l5oY","PanelIndicators_thClientStandardRate":"PanelIndicators__PanelIndicators_thClientStandardRate___2uXiM","PanelIndicators_thVarianceRate":"PanelIndicators__PanelIndicators_thVarianceRate___3Mm1G","PanelIndicators_thQfErrorRate":"PanelIndicators__PanelIndicators_thQfErrorRate___1J1NQ","PanelIndicators_thDiffCLP":"PanelIndicators__PanelIndicators_thDiffCLP___cNCs9","PanelIndicators_thButtonDownload":"PanelIndicators__PanelIndicators_thButtonDownload___MwEe9","PanelIndicators_thButtonPUC":"PanelIndicators__PanelIndicators_thButtonPUC___3F615","PanelIndicators_tdStoreNumber":"PanelIndicators__PanelIndicators_tdStoreNumber___14o2o","PanelIndicators_tdNameClient":"PanelIndicators__PanelIndicators_tdNameClient___2je2c","PanelIndicators_tdStoreName":"PanelIndicators__PanelIndicators_tdStoreName___33A-B","PanelIndicators_tdSupervisorName":"PanelIndicators__PanelIndicators_tdSupervisorName___IUMbe","PanelIndicators_tdSummaryReports":"PanelIndicators__PanelIndicators_tdSummaryReports___X4IQc","PanelIndicators_tdSummaryReportsCenter":"PanelIndicators__PanelIndicators_tdSummaryReportsCenter___2Nhxc","PanelIndicators_tdRightText":"PanelIndicators__PanelIndicators_tdRightText___3HhvO","PanelIndicators_tdRightTextTwo":"PanelIndicators__PanelIndicators_tdRightTextTwo___3VRx5","PanelIndicators_tdServiceHours":"PanelIndicators__PanelIndicators_tdServiceHours___2gFuO","PanelIndicators_tdErrorRate":"PanelIndicators__PanelIndicators_tdErrorRate___QN7zH","PanelIndicators_tdAlert":"PanelIndicators__PanelIndicators_tdAlert___39dXC","PanelIndicators_tdWarning":"PanelIndicators__PanelIndicators_tdWarning___kNrF1","PanelIndicators_tdServiceSuspend":"PanelIndicators__PanelIndicators_tdServiceSuspend___3OCJi","PanelIndicators_tdWarningRevItems":"PanelIndicators__PanelIndicators_tdWarningRevItems___27lSM","PanelIndicators_tdIndicators":"PanelIndicators__PanelIndicators_tdIndicators___IEggs","PanelIndicators_tdDiffCLP":"PanelIndicators__PanelIndicators_tdDiffCLP___1Y5Fw","PanelIndicators_tdFiles":"PanelIndicators__PanelIndicators_tdFiles___1MYoH","PanelIndicators_tdTitleSummary":"PanelIndicators__PanelIndicators_tdTitleSummary___2h0xh","tooltip":"PanelIndicators__tooltip___2s376","tooltipAvance":"PanelIndicators__tooltipAvance___ljtuj","tooltipNeto":"PanelIndicators__tooltipNeto___14H79","tooltiptextAvance":"PanelIndicators__tooltiptextAvance___3z0PF","tooltiptextNeto":"PanelIndicators__tooltiptextNeto___vIGTM","tooltiptext":"PanelIndicators__tooltiptext___avllo","tooltiptextLeft":"PanelIndicators__tooltiptextLeft___2cCg5","tooltiptextReporte":"PanelIndicators__tooltiptextReporte___1wCo_","tooltiptextCECO":"PanelIndicators__tooltiptextCECO___2Wk3A","tooltipInicio":"PanelIndicators__tooltipInicio___1bHim","tooltiptextInicio":"PanelIndicators__tooltiptextInicio___161lO","imagenStock":"PanelIndicators__imagenStock___2VcDj","PanelIndicators_tdLiderName":"PanelIndicators__PanelIndicators_tdLiderName___1obXc","PanelIndicators_tdLiderStats":"PanelIndicators__PanelIndicators_tdLiderStats___3Ch5n","PanelIndicators_tdName":"PanelIndicators__PanelIndicators_tdName___KfEF8","PanelIndicators_tdStats":"PanelIndicators__PanelIndicators_tdStats___pNekm","PanelIndicators_totales":"PanelIndicators__PanelIndicators_totales___3gq6u","PanelIndicators_totalesName":"PanelIndicators__PanelIndicators_totalesName___14K14","PanelIndicators_thTitulos":"PanelIndicators__PanelIndicators_thTitulos___JE_14","radioButton0":"PanelIndicators__radioButton0___22sig","radioButtonRojo":"PanelIndicators__radioButtonRojo___2Qb18","radioButton1":"PanelIndicators__radioButton1___1PLfU","radioButton2":"PanelIndicators__radioButton2___1i_pe","radioButton3":"PanelIndicators__radioButton3___3wnDm","inputDate":"PanelIndicators__inputDate___1xtjg"};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	var axiosRaw = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	    // Si existe un problema de red, terminar la promesa
	    if (response instanceof Error) {
	        return Promise.reject(response.message);
	    } else {
	        return Promise.resolve(response.data);
	    }
	});
	axiosRaw.interceptors.response.use(function (response) {
	    // Si existe un problema de red, terminar la promesa
	    if (response instanceof Error) {
	        return Promise.reject(response);
	    } else {
	        return Promise.resolve(response);
	    }
	});
	
	exports.default = {
	    cliente: function cliente(idCliente) {
	        return {
	            getLocales: function getLocales() {
	                return axios.get('/api/cliente/' + idCliente + '/locales');
	            },
	            getCorreos: function getCorreos() {
	                return axios.get('/api/local/' + idCliente + '/correo-nomina');
	            },
	            agregarCorreo: function agregarCorreo(datos) {
	                return axios.post('/api/local/' + idCliente + '/correo-nomina', datos);
	            },
	            quitarCorreo: function quitarCorreo(idCorreo) {
	                return axios.delete('/api/local/' + idCliente + '/correo-nomina/' + idCorreo);
	            }
	        };
	    },
	    local: {
	        nuevo: function nuevo(datos) {
	            return axios.post('/api/local', datos);
	        },
	        nuevos: function nuevos(locales) {
	            return axios.post('/api/locales', { locales: locales });
	        },
	        actualizar: function actualizar(idLocal, datos) {
	            return axios.put('/api/local/' + idLocal, datos);
	        },
	        enviarPegarStock: function enviarPegarStock(idCliente, datos) {
	            return axios.post('/api/stock/pegar', { idCliente: idCliente, datos: datos });
	        },
	        geolocalizacion: function geolocalizacion(idLocal, lat, long) {
	            return axios.post('/api/local/geolocalizacion', { idLocal: idLocal, lat: lat, long: long });
	        }
	    },
	    inventario: {
	        estadosInventarios: function estadosInventarios() {
	            return axios.get('/api/inventarios/estados');
	        },
	        updateEstado: function updateEstado(idInventario, idEstado) {
	            return axios.post('/api/inventario/update-estado', { idInventario: idInventario, idEstado: idEstado });
	        },
	        nuevo: function nuevo(datos) {
	            return axios.post('/api/inventario/nuevo', datos);
	        },
	        // boton para publicar ig semanal (modal)
	        publicarProgramacion: function publicarProgramacion(fechaInicio, fechaFin, estatus) {
	            return axios.post('/api/inventarios/publicar-programacion', { fechaInicio: fechaInicio, fechaFin: fechaFin, estatus: estatus });
	        },
	        actualizar: function actualizar(idInventario, datos) {
	            return axios.put('/api/inventario/' + idInventario, datos);
	        },
	        actualizarIgMensual: function actualizarIgMensual(idInventario, datos) {
	            return axios.put('/api/inventario/mensual/' + idInventario, datos);
	        },
	        updateStatus: function updateStatus(idService, idStatus) {
	            return axios.put('/api/inventario/' + idService + '/' + idStatus + '/cambiar-status');
	        },
	        updateDepartureTime: function updateDepartureTime(idService, departureTime) {
	            return axios.put('/api/inventario/' + idService + '/departure-time', { departureTime: departureTime });
	        },
	        eliminar: function eliminar(idInventario) {
	            return axios.delete('/api/inventario/' + idInventario);
	        },
	        // mes y cliente se usa en IG Mensual
	        getPorMesYCliente: function getPorMesYCliente(annoMesDia, idCliente) {
	            return axios.get('/api/inventarios/buscar-2-mensual?mes=' + annoMesDia + '&idCliente=' + idCliente + '&incluirConFechaPendiente=true');
	        },
	        buscar2: function buscar2(fechaInicio, fechaFin, idCliente) {
	            return axios.get('/api/inventarios/buscar-2?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin + '&idCliente=' + idCliente);
	        },
	        // utilizado en buscar de mantenedor inventarios publicados
	        buscarResumido: function buscarResumido(fechaInicio, fechaFin, idCliente) {
	            return axios.get('/api/inventarios/buscar-publicados?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin + '&idCliente=' + idCliente);
	        },
	        // utilizado en modal para publicar ig semanal
	        buscarPorPublicar: function buscarPorPublicar(fechaInicio, fechaFin, idCliente) {
	            return axios.get('/api/inventarios/buscar-por-publicar?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin + '&idCliente=' + idCliente);
	        },
	        getInventariosDif: function getInventariosDif(mes) {
	            return axios.get('/api/inventarios/buscarInv/' + mes);
	        },
	        getDetalle: function getDetalle(fechaInicio, fechaFin, cliente, region) {
	            return axios.get('/api/inventarios/detalle?cliente=' + cliente + '&region=' + region + '&fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        getAprobadosMesCliente: function getAprobadosMesCliente(mes, idCliente) {
	            return axios.get('/api/inventarios/aprobados/' + mes + '/' + idCliente);
	        },
	        getRealizadosMesCliente: function getRealizadosMesCliente(mes, idCliente) {
	            return axios.get('/api/inventarios/realizados/' + mes + '/' + idCliente);
	        },
	        getAprobadosSEIMesCliente: function getAprobadosSEIMesCliente(mes, idCliente) {
	            return axios.get('/api/inventarios/aprobados/sei/' + mes + '/' + idCliente);
	        },
	        publicarInventarios: function publicarInventarios(inventarios) {
	            return axios.post('/api/inventarios/publicar', { inventarios: inventarios });
	        },
	        obtenerDetalles: function obtenerDetalles() {
	            return axios.get('/api/inventarios/detalles-total');
	        },
	        acta: {
	            get: function get(idInventario) {
	                return axios.get('/api/inventario/' + idInventario + '/acta-fcv');
	            },
	            actualizar: function actualizar(idInventario, datos) {
	                return axios.post('/api/inventario/' + idInventario + '/acta-fcv', datos);
	            },
	            publicar: function publicar(idInventario) {
	                return axios.post('/api/inventario/' + idInventario + '/publicar-acta-fcv');
	            },
	            despublicar: function despublicar(idInventario) {
	                return axios.post('/api/inventario/' + idInventario + '/despublicar-acta-fcv');
	            },
	            reprocesar: function reprocesar(idArchivo) {
	                return axios.post('/api/inventario/archivo-final/' + idArchivo + '/reprocesar-fcv');
	            }
	        }
	    },
	    auditoria: {
	        nuevo: function nuevo(datos) {
	            return axios.post('/api/auditoria/nuevo', datos);
	        },
	        nuevaCapturaVencimiento: function nuevaCapturaVencimiento(nuevaCaptura) {
	            return axios.post('/api/captura/vencimiento/nueva', nuevaCaptura);
	        },
	        actualizar: function actualizar(idAuditoria, datos) {
	            return axios.put('/api/auditoria/' + idAuditoria, datos);
	        },
	        actualizarAprobacion: function actualizarAprobacion(idAuditoria, aprobacionCliente) {
	            return axios.post('/api/auditoria/aprobacion/' + idAuditoria, { aprobacionCliente: aprobacionCliente });
	        },
	        eliminar: function eliminar(idAuditoria) {
	            return axios.delete('/api/auditoria/' + idAuditoria);
	        },
	        getPorMesYCliente: function getPorMesYCliente(annoMesDia, idCliente) {
	            return axios.get('/api/auditoria/buscar?idCliente=' + idCliente + '&mes=' + annoMesDia + '&incluirConFechaPendiente=true&auditoriaSensores=false');
	        },
	        getPorRangoYCliente: function getPorRangoYCliente(fechaInicio, fechaFin, idCliente) {
	            return axios.get('/api/auditoria/buscar?idCliente=' + idCliente + '&fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin + '&ordenarAuditoriaSensores=true');
	        },
	        getResumenMes: function getResumenMes(mes) {
	            return axios.get('/api/auditoria/resumen/' + mes);
	        },
	        getResumenEstadoMesActual: function getResumenEstadoMesActual() {
	            return axios.get('/api/auditorias/estado-general-fcv');
	        },
	        getDetalle: function getDetalle(fechaInicio, fechaFin, cliente, region) {
	            return axios.get('/api/auditorias/detalle?cliente=' + cliente + '&region=' + region + '&fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        getRutaInicioAuditores: function getRutaInicioAuditores(fechaInicial) {
	            return axios.get('/api/auditorias/reporte-ruta?fechaInicio=' + fechaInicial);
	        }
	    },
	    nominas: {
	        usuariosPendientes: function usuariosPendientes(fechaInicio, fechaFin) {
	            return axios.get('/api/nominas/userPendientes?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        getEstado: function getEstado(idUsuario, idCliente) {
	            return axios.get('/api/personal/bloqueo-cliente?idOperador=' + idUsuario + '&idCliente=' + idCliente);
	        },
	        getPorRangoYSolicitud: function getPorRangoYSolicitud(fechaInicio, fechaFin) {
	            return axios.get('/api/nominas/solicitudes?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        getSolicitudesCambio: function getSolicitudesCambio(fechaInicio, fechaFin) {
	            return axios.get('/api/nominas/solicitud/cambio-nomina?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        getCambiosNominas: function getCambiosNominas(fechaInicio, fechaFin) {
	            return axios.get('/api/nominas/rectificada/cambio?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	        },
	        enviarNominasMasiva: function enviarNominasMasiva(data, conCorreo) {
	            return axios.post("/api/nominas/envioNominasMasiva", { 'nominas': data, conCorreo: conCorreo });
	        },
	        aprobarNominasMasiva: function aprobarNominasMasiva(data) {
	            return axios.post("/api/nominas/aprobarNominasMasiva", { 'nominas': data });
	        },
	        rectificarNominasMasiva: function rectificarNominasMasiva(data) {
	            return axios.post("/api/nominas/rectificarNominasMasiva", { 'nominas': data });
	        },
	        asignacionMasivaLider: function asignacionMasivaLider(data, cambiosNominas) {
	            return axios.post("/api/nominas/asignacionMasivaLider", { 'nominas': data, cambiosNominas: cambiosNominas });
	        }
	    },
	    nomina: function nomina(idNomina) {
	        return {
	            // utilizada por programacion IG para actualizar lider
	            actualizar: function actualizar(datos) {
	                return axios.put('/api/nomina/' + idNomina, datos);
	            },
	            actualizarEmailContacto: function actualizarEmailContacto(emailContacto) {
	                return axios.post('/api/nomina/' + idNomina + '/actualizar-email', { emailContacto: emailContacto });
	            },
	            agregarLider: function agregarLider(usuarioRUN) {
	                return axios.post('/api/nomina/' + idNomina + '/lider/' + usuarioRUN);
	            },
	            quitarLider: function quitarLider() {
	                return axios.delete('/api/nomina/' + idNomina + '/lider');
	            },
	            agregarCaptador: function agregarCaptador(idUsuario) {
	                return axios.post('/api/nomina/' + idNomina + '/captador/' + idUsuario);
	            },
	            quitarCaptador: function quitarCaptador(idUsuario) {
	                return axios.delete('/api/nomina/' + idNomina + '/captador/' + idUsuario);
	            },
	            agregarRegionesCaptador: function agregarRegionesCaptador(idCaptador, regiones) {
	                return axios.post('/api/nomina/' + idNomina + '/captador-regiones/' + idCaptador, regiones);
	            },
	            cambiarAsignadosCaptador: function cambiarAsignadosCaptador(idCaptador, payload) {
	                return axios.put('/api/nomina/' + idNomina + '/captador/' + idCaptador, payload);
	            },
	            agregarSupervisor: function agregarSupervisor(usuarioRUN) {
	                return axios.post('/api/nomina/' + idNomina + '/supervisor/' + usuarioRUN);
	            },
	            quitarSupervisor: function quitarSupervisor() {
	                return axios.delete('/api/nomina/' + idNomina + '/supervisor');
	            },
	            agregarOperador: function agregarOperador(usuarioRUN, esTitular, idCaptador) {
	                return axiosRaw.post('/api/nomina/' + idNomina + '/operador/' + usuarioRUN, { esTitular: esTitular, idCaptador: idCaptador });
	            },
	            addAlternateLeader: function addAlternateLeader(userRUN) {
	                return axiosRaw.post('/api/nomina/' + idNomina + '/alternate-leader/' + userRUN);
	            },
	            quitarOperador: function quitarOperador(usuarioRUN, esTitular) {
	                return axios.delete('/api/nomina/' + idNomina + '/operador/' + usuarioRUN + '/' + esTitular);
	            },
	            cambiarDePanel: function cambiarDePanel(usuarioRUN, esTitular, idCaptador, pendientes) {
	                return axios.post('/api/nomina/' + idNomina + '/operador/' + usuarioRUN + '/panel', { esTitular: esTitular, idCaptador: idCaptador, pendientes: pendientes });
	            },
	            lideresDisponibles: function lideresDisponibles() {
	                return axios.get('/api/nomina/' + idNomina + '/lideres-disponibles');
	            },
	            getAlternateLeaders: function getAlternateLeaders() {
	                return axios.get('/api/nomina/' + idNomina + '/alternate-leaders');
	            },
	            enviar: function enviar() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-enviar');
	            },
	            aprobar: function aprobar() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-aprobar');
	            },
	            rechazar: function rechazar() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-rechazar');
	            },
	            informar: function informar() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-informar');
	            },
	            completarSinCorreo: function completarSinCorreo() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-informar', { omitirCorreo: true });
	            },
	            disponibilidadReemplazos: function disponibilidadReemplazos() {
	                return axios.get('/api/nomina/' + idNomina + '/disponibilidad-reemplazos');
	            },
	            informarDisponibilidadReemplazos: function informarDisponibilidadReemplazos(cupos) {
	                return axios.post('/api/nomina/' + idNomina + '/informar-disponibilidad-reemplazos', { cupos: cupos });
	            },
	            rectificar: function rectificar() {
	                return axios.post('/api/nomina/' + idNomina + '/estado-rectificar');
	            },
	            historial: function historial() {
	                return axios.get('/api/nomina/' + idNomina + '/historial');
	            },
	            estadoSolicitud: function estadoSolicitud(_estadoSolicitud) {
	                return axios.post('/api/nomina/' + idNomina + '/estado-solicitud', { estadoSolicitud: _estadoSolicitud });
	            },
	            cambioEstadoSolicitud: function cambioEstadoSolicitud(operadorActual, operadorNuevo, estado) {
	                return axios.post('/api/nominas/solicitud/cambio/estado', { operadorActual: operadorActual, operadorNuevo: operadorNuevo, idNomina: idNomina, estado: estado });
	            },
	            getOperadoresDisponibles: function getOperadoresDisponibles() {
	                return axios.get('/api/nomina/' + idNomina + '/operadores/disponibles');
	            },
	            cambioNominaInformada: function cambioNominaInformada(estado) {
	                return axios.post('/api/nomina/' + idNomina + '/cambio/operadores/informados', { estado: estado });
	            },
	            quitarOperadoresMasivo: function quitarOperadoresMasivo(data) {
	                return axios.post('/api/nomina/' + idNomina + '/quitar-operador-masivo', { operadores: data });
	            },
	            operadorTitularMasivo: function operadorTitularMasivo(data) {
	                return axios.post('/api/nomina/' + idNomina + '/operador-titular-masivo', { operadores: data });
	            },
	            bloqueoLog: function bloqueoLog(idOperador) {
	                return axios.post('/api/nomina/' + idNomina + '/operador/' + idOperador + '/bloqueo-log');
	            },
	            enrocarOperadores: function enrocarOperadores(titulares, reemplazos) {
	                return axios.post('/api/nomina/' + idNomina + '/enrocar-operadores', { titulares: titulares, reemplazos: reemplazos });
	            },
	            operadorEscondido: function operadorEscondido(id) {
	                return axios.post('/api/nomina/' + idNomina + '/operador-escondido', { id: id });
	            },
	            actualizarEstadisticas: function actualizarEstadisticas(titulares, reemplazos) {
	                return axios.post('/api/nomina/' + idNomina + '/estadisticas-enroque', { titulares: titulares, reemplazos: reemplazos });
	            },
	            changeTurnoEmergencia: function changeTurnoEmergencia(status) {
	                return axios.post('/api/nomina/' + idNomina + '/turno-emergencia', { status: status });
	            },
	            changeTurnoAvanzada: function changeTurnoAvanzada(status) {
	                return axios.post('/api/nomina/' + idNomina + '/turno-avanzada', { status: status });
	            },
	            changeTurnoAvanzadaOpSolicitud: function changeTurnoAvanzadaOpSolicitud(data) {
	                return axios.post('/api/nomina/' + idNomina + '/operador/turno-avanzada-solicitud', data);
	            },
	            changeTurnoAvanzadaOp: function changeTurnoAvanzadaOp(data) {
	                return axios.post('/api/nomina/' + idNomina + '/operador/turno-avanzada', data);
	            },
	            changeTurnoAvanzadaOpHrs: function changeTurnoAvanzadaOpHrs(data) {
	                return axios.post('/api/nomina/' + idNomina + '/operador/turno-avanzada-hrs', data);
	            },
	            verPasajesLider: function verPasajesLider() {
	                return axios.get('/api/nomina/' + idNomina + '/obtener-data-pasajes');
	            },
	            subirPasajesLider: function subirPasajesLider(data) {
	                return axios.post('/api/nomina/' + idNomina + '/subir-pasajes-lider', data);
	            },
	            editarPasaje: function editarPasaje(data) {
	                return axios.post('/api/nomina/' + idNomina + '/editar-pasaje', data);
	            },
	            eliminarPasaje: function eliminarPasaje(id) {
	                return axios.post('/api/nomina/' + idNomina + '/eliminar-pasaje', { id: id });
	            },
	            quitarEscondido: function quitarEscondido(id) {
	                return axios.post('/api/nomina/' + idNomina + '/quitar-escondido', { id: id });
	            },
	            operadoresPendientesRegion: function operadoresPendientesRegion() {
	                return axios.get('/api/nomina/' + idNomina + '/operadores/pendientes-region');
	            },
	            operadorComoReemplazo: function operadorComoReemplazo(idUser, idCaptador) {
	                return axios.post('/api/nomina/' + idNomina + '/operadores/pasar-a-reemplazo', { idUser: idUser, idCaptador: idCaptador });
	            },
	            cambiarCaptador: function cambiarCaptador(idUser, idCaptador) {
	                return axios.post('/api/nomina/' + idNomina + '/operadores/cambiar-captador-log', { idUser: idUser, idCaptador: idCaptador });
	            },
	            agregarGPS: function agregarGPS(id, lat, lng) {
	                return axios.post('/api/nomina/' + idNomina + '/agregar-gps', { id: id, lat: lat, lng: lng });
	            },
	            masTiempoConfirmacion: function masTiempoConfirmacion(id, confirma) {
	                return axios.post('/api/nomina/' + idNomina + '/confirmacion-mas-tiempo', { id: id, confirma: confirma });
	            }
	
	        };
	    },
	    nominaLideresDisponibles: function nominaLideresDisponibles(idNominaNoche, idNominaDia) {
	        return {
	            lideresDisponibles: function lideresDisponibles() {
	                return axios.get('/api/nomina/' + idNominaNoche + '/' + idNominaDia + '/lideres-disponibles');
	            },
	            auditoresSMUDisponibles: function auditoresSMUDisponibles() {
	                return axios.get('/api/nomina/' + idNominaNoche + '/' + idNominaDia + '/auditoresSMU-disponibles');
	            }
	
	        };
	    },
	    geo: {
	        comunas: function comunas() {
	            return axios.get('/api/geo/comunas');
	        }
	    },
	    usuarios: {
	        fetch: function fetch(idDocumentationState) {
	            return axios.get('/api/usuarios/buscar?idDocumentationState=' + idDocumentationState);
	        },
	
	        fetchPendientes: function fetchPendientes() {
	            return axios.get('/api/usuarios/buscar-pendientes');
	        },
	        nuevoUsuario: function nuevoUsuario(datos) {
	            return axios.post('/api/usuarios/nuevo-usuario', datos);
	        },
	        nuevoOperador: function nuevoOperador(datos) {
	            return axios.post('/api/usuarios/nuevo-operador', datos);
	        },
	        registrarOperador: function registrarOperador(datos) {
	            return axios.post('/api/usuarios/registrar-operador', datos);
	        },
	        confirmarOperador: function confirmarOperador(datos) {
	            return axios.post('/api/usuarios/buscar-pendientes/nuevo', datos);
	        },
	        rechazarOperador: function rechazarOperador(datos) {
	            return axios.post('/api/usuarios/buscar-pendientes/cancel', datos);
	        }
	    },
	    usuario: function usuario(idUsuario) {
	        return {
	            get: function get() {
	                return axios.get('/api/usuario/' + idUsuario);
	            },
	            actualizar: function actualizar(datos) {
	                return axios.put('/api/usuario/' + idUsuario, datos);
	            },
	            bloquear: function bloquear() {
	                return axios.post('/api/usuario/' + idUsuario + '/bloquear');
	            },
	            desbloquear: function desbloquear() {
	                return axios.post('/api/usuario/' + idUsuario + '/desbloquear', {});
	            },
	            suspend: function suspend(idReason) {
	                return axios.post('/api/usuario/' + idUsuario + '/' + idReason + '/suspend');
	            },
	            cambiarContrasena: function cambiarContrasena(contrasena) {
	                return axios.post('/api/usuario/' + idUsuario + '/cambiar-contrasena', { contrasena: contrasena });
	            },
	            historial: function historial() {
	                return axios.get('/api/usuario/' + idUsuario + '/historial-nominas');
	            },
	            bloquearCliente: function bloquearCliente(datos) {
	                return axios.put('/api/personal/' + idUsuario + '/bloqueo-cliente', datos);
	            },
	            uploadPersonalFile: function uploadPersonalFile(data) {
	                return axios.post('/api/usuario/' + idUsuario + '/upload/personal-files', data);
	            },
	            uploadOperadorFile: function uploadOperadorFile(data) {
	                return axios.post('/api/usuario/' + idUsuario + '/upload/operator-files', data);
	            },
	            uploadFechaVenc: function uploadFechaVenc(data) {
	                return axios.post('/api/usuario/' + idUsuario + '/upload/fecha-venc-dni', data);
	            },
	            getDocumentation: function getDocumentation() {
	                return axios.get('/api/usuario/' + idUsuario + '/documentacion');
	            },
	            changeStatusDocumentation: function changeStatusDocumentation(status) {
	                return axios.post('/api/usuario/' + idUsuario + '/status-documentation', { status: status });
	            },
	            bloquearTitular: function bloquearTitular(idNomina) {
	                return axios.post('/api/usuario/' + idUsuario + '/bloquear-titular/' + idNomina);
	            }
	        };
	    },
	    documentUser: function documentUser(idFile) {
	        return {
	            isWrongFile: function isWrongFile(status) {
	                return axios.post('/api/document-user/' + idFile + '/wrong', { status: status });
	            },
	            deleteFile: function deleteFile() {
	                return axios.post('/api/document-user/' + idFile + '/delete');
	            }
	        };
	    },
	    vistaGeneral: {
	        fetch: function fetch(annoMesDia) {
	            var idCliente = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            return axios.get('/api/vista-general/nominas-inventarios?idCliente=' + idCliente + '&annoMesDia=' + annoMesDia);
	        }
	    },
	    otros: {
	        bancos: function bancos() {
	            return axios.get('/api/bancos');
	        },
	        comunas: function comunas() {
	            return axios.get('/api/comunas');
	        },
	        regiones: function regiones() {
	            return axios.get('/api/regiones');
	        },
	        zonas: function zonas() {
	            return axios.get('/api/zonas');
	        },
	        comunasZonas: function comunasZonas(zonas) {
	            return axios.post('/api/zonas/comunas', { zonas: zonas });
	        }
	    },
	    captador: function captador(idCaptador) {
	        return {
	            getZonas: function getZonas() {
	                return axios.get('/api/captador/' + idCaptador + '/zonas');
	            },
	            getFaltas: function getFaltas() {
	                return axios.get('/api/captador/' + idCaptador + '/faltas');
	            },
	            actualizarValor: function actualizarValor(zona, valor) {
	                return axios.post('/api/captador/' + idCaptador + '/valor', { zona: zona, valor: valor });
	            },
	            asociarZona: function asociarZona(zona, valor) {
	                return axios.post('/api/captador/' + idCaptador + '/zona', { zona: zona, valor: valor });
	            }
	        };
	    },
	    produccion: function produccion(idCliente, idJornada) {
	        return {
	            getProducciones: function getProducciones() {
	                return axios.get('/api/producciones/' + idCliente + '/' + idJornada);
	            },
	            actualizarProduccion: function actualizarProduccion(idProduccion, valor) {
	                return axios.post('/api/produccion/' + idProduccion + '/valor', { valor: valor });
	            }
	        };
	    },
	    inv: function inv(idInventario) {
	        return {
	            actualizarStockFCV: function actualizarStockFCV(stockFCV) {
	                return axios.post('/api/inventario/' + idInventario + '/stockFCV', { stockFCV: stockFCV });
	            },
	            actualizarAprobacionFCV: function actualizarAprobacionFCV(estado) {
	                return axios.post('/api/inventario/' + idInventario + '/aprobacion', { estado: estado });
	            },
	            actualizarAprobacionSei: function actualizarAprobacionSei(estadoSei) {
	                return axios.post('/api/inventario/' + idInventario + '/aprobacionSei', { estadoSei: estadoSei });
	            },
	            actualizarObservacion: function actualizarObservacion(observacionCliente) {
	                return axios.post('/api/inventario/' + idInventario + '/observacionCliente', { observacionCliente: observacionCliente });
	            }
	        };
	    },
	    facturacionSaldo: function facturacionSaldo() {
	        return {
	            getDetalleSaldo: function getDetalleSaldo(mes) {
	                return axios.get('/api/facturacion/saldo/' + mes);
	            },
	            generarSaldo: function generarSaldo(mes) {
	                return axios.post('/api/generar/saldo', { mes: mes });
	            },
	            generarSaldoAuditorias: function generarSaldoAuditorias(mes) {
	                return axios.post('/api/generar/saldo/auditorias', { mes: mes });
	            }
	        };
	    },
	    facturacion: function facturacion(idCliente) {
	        return {
	            generarCorreoSei: function generarCorreoSei(mes) {
	                return axios.post('/api/generar/correoSEI/' + idCliente, { mes: mes });
	            },
	            generarCorreoAud: function generarCorreoAud(mes) {
	                return axios.post('/api/generar/correoSEI/auditorias/' + idCliente, { mes: mes });
	            },
	            generarCorreoIG: function generarCorreoIG(mes, total) {
	                return axios.post('/api/generar/correoSEI/ig/aprobacion/' + idCliente, { mes: mes, total: total });
	            },
	            generarFactura: function generarFactura(mes) {
	                return axios.post('/api/generar/factura/' + idCliente, { mes: mes });
	            },
	            agregarOrdenCompra: function agregarOrdenCompra(fechaInicial, fechaFinal, numeroOC) {
	                return axios.post('/api/agregar/orden-compra/' + idCliente, { fechaInicial: fechaInicial, fechaFinal: fechaFinal, numeroOC: numeroOC });
	            },
	            serviciosRealizados: function serviciosRealizados(mes) {
	                return axios.get('/api/servicios-realizados/' + idCliente + '/' + mes);
	            },
	            getServiciosSalcobrand: function getServiciosSalcobrand(mes) {
	                return axios.get('/api/servicios/salcobrand/' + idCliente + '/' + mes);
	            },
	            generarFacturaAF: function generarFacturaAF(mes, numeroHES, fechaEmisionHES) {
	                return axios.post('/api/generar/factura/af/' + idCliente, { mes: mes, numeroHES: numeroHES, fechaEmisionHES: fechaEmisionHES });
	            },
	            disponiblesCliente: function disponiblesCliente(fechaInicio, fechaFin) {
	                return axios.get('/api/facturacion/lista/' + idCliente + '/' + fechaInicio + '/' + fechaFin);
	            },
	            serviciosCalidad: function serviciosCalidad(mes) {
	                return axios.get('/api/servicios-calidad/' + idCliente + '/' + mes);
	            },
	            getCalidadAprobados: function getCalidadAprobados(mes) {
	                return axios.get('/api/servicios-calidad/aprobados/' + idCliente + '/' + mes);
	            }
	        };
	    },
	    aud: function aud() {
	        return {
	            actualizarAprobacionFCV: function actualizarAprobacionFCV(aprobacionCliente, mes) {
	                return axios.post('/api/auditoria/aprobacion', { aprobacionCliente: aprobacionCliente, mes: mes });
	            }
	        };
	    },
	    auditorias: function auditorias() {
	        return {
	            getArchivosConsolidados: function getArchivosConsolidados(mes, tipo) {
	                return axios.get('/api/auditorias/archivosConsolidados/' + mes + '/' + tipo);
	            }
	        };
	    },
	    api: function api() {
	        return {
	            misInventariosDia: function misInventariosDia(idInventario) {
	                return axios.post('/api/misInventarios/dia', { idInventario: idInventario });
	            },
	            misReportesInventario: function misReportesInventario(idInventario) {
	                return axios.post('/api/misReportes/inventario', { idInventario: idInventario });
	            },
	            misReportesNuevo: function misReportesNuevo(idInventario, tipo, hora, dotacion, avance, error, comentario, auditoria, idDescripcionReportesIG, idDescripcionReportesLocal) {
	                return axios.post('/api/misReportes/nuevo', { idInventario: idInventario, tipo: tipo, hora: hora, dotacion: dotacion, avance: avance, error: error, comentario: comentario, auditoria: auditoria, idDescripcionReportesIG: idDescripcionReportesIG, idDescripcionReportesLocal: idDescripcionReportesLocal });
	            },
	            descripcionReportes: function descripcionReportes(tipoDescripcion, subTipoDescripcion) {
	                return axios.post('/api/descripcion/reportes', { tipoDescripcion: tipoDescripcion, subTipoDescripcion: subTipoDescripcion });
	            },
	            nuevoAnexoMarca: function nuevoAnexoMarca(idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance) {
	                return axios.post('/api/nuevo/anexoMarca', { idMarca: idMarca, estado_deterioro: estado_deterioro, sku_deterioro: sku_deterioro, estado_pago: estado_pago, foto_avance: foto_avance });
	            }
	        };
	    },
	    capturasAuditoria: function capturasAuditoria(idAuditoria) {
	        return {
	            getAuditoria: function getAuditoria() {
	                return axios.get('/api/auditoria/' + idAuditoria + '/revision');
	            },
	            actualizarDatosAuditoria: function actualizarDatosAuditoria(auditoria) {
	                return axios.post('/api/auditoria/' + idAuditoria + '/datos', auditoria);
	            },
	            actualizarIRD: function actualizarIRD(idCapturaAuditoriaIrd, capturaIRD) {
	                return axios.post('/api/captura/' + idCapturaAuditoriaIrd + '/captura-ird', capturaIRD);
	            },
	            actualizarVencimiento: function actualizarVencimiento(idCapturaAuditoriaVencimiento, capturaVencimiento) {
	                return axios.post('/api/captura/' + idCapturaAuditoriaVencimiento + '/captura-vencimiento', capturaVencimiento);
	            },
	            buscarImagenRemplazo: function buscarImagenRemplazo(idCapturaAuditoriaVencimiento, sku, lote, fecha_exp) {
	                return axios.get('/api/captura/' + idCapturaAuditoriaVencimiento + '/sku/' + sku + '/lote/' + lote + '/fecha/' + fecha_exp);
	            },
	            postRemplazoImagen: function postRemplazoImagen(idCapturaVencimientoOriginal, idArchivoImagen) {
	                return axios.post('/api/captura/imagen/remplazo', { idCapturaVencimientoOriginal: idCapturaVencimientoOriginal, idArchivoImagen: idArchivoImagen });
	            },
	            eliminarCapturaIRD: function eliminarCapturaIRD(idCapturaAuditoriaIrd) {
	                return axios.post('/api/captura/' + idCapturaAuditoriaIrd + '/captura-ird/eliminar');
	            },
	            restaurarCapturaIRD: function restaurarCapturaIRD(idCapturaAuditoriaIrd) {
	                return axios.post('/api/captura/' + idCapturaAuditoriaIrd + '/captura-ird/restaurar');
	            },
	            eliminarCapturaVencimiento: function eliminarCapturaVencimiento(idCapturaAuditoriaVencimiento) {
	                return axios.post('/api/captura/' + idAuditoria + '/' + idCapturaAuditoriaVencimiento + '/captura-vencimiento/eliminar');
	            },
	            restaurarCapturaVencimiento: function restaurarCapturaVencimiento(idCapturaAuditoriaVencimiento) {
	                return axios.post('/api/captura/' + idAuditoria + '/' + idCapturaAuditoriaVencimiento + '/captura-vencimiento/restaurar');
	            },
	            setEliminarCaptura: function setEliminarCaptura(estado) {
	                return axios.post('/api/captura/' + idAuditoria + '/eliminar/' + estado);
	            },
	            eliminarCapturasDefinitvo: function eliminarCapturasDefinitvo(estado) {
	                return axios.post('/api/captura/' + idAuditoria + '/eliminar-todo');
	            },
	            setRestaurarCaptura: function setRestaurarCaptura(estado) {
	                return axios.post('/api/captura/' + idAuditoria + '/restaurar/' + estado);
	            },
	            publicarAuditoriaVencimiento: function publicarAuditoriaVencimiento() {
	                return axios.post('/api/captura/' + idAuditoria + '/publicar-vencimiento');
	            },
	            publicarAuditoriaIrd: function publicarAuditoriaIrd() {
	                return axios.post('/api/captura/' + idAuditoria + '/publicar-ird');
	            },
	            publicarAuditoriaNoEncontrados: function publicarAuditoriaNoEncontrados() {
	                return axios.post('/api/captura/' + idAuditoria + '/publicar-no-encontrados');
	            },
	            subirNuevaImagen: function subirNuevaImagen(idCapturAuditoriaVencimiento, data) {
	                return axios.post('/api/captura/' + idCapturAuditoriaVencimiento + '/subir-imagen', data);
	            },
	            actualizarNoEncontrado: function actualizarNoEncontrado(idCapturaNoEncontrado, capturaNoEncontrado) {
	                return axios.post('/api/captura/' + idCapturaNoEncontrado + '/no-encontrado', capturaNoEncontrado);
	            },
	            eliminarCapturaNoEncontrado: function eliminarCapturaNoEncontrado(idNoEncontrado) {
	                return axios.post('/api/captura/' + idNoEncontrado + '/no-encontrado/eliminar');
	            },
	            informarResultado: function informarResultado() {
	                return axios.post('/api/auditoria/' + idAuditoria + '/informar-resultados');
	            },
	            cambiarImagen: function cambiarImagen(imagen) {
	                return axios.post('/api/auditoria/' + idAuditoria + '/cambiar-imagen-acta', imagen);
	            }
	        };
	    },
	    fondos: function fondos() {
	        return {
	            getLideres: function getLideres() {
	                return axios.get('/api/lideres');
	            },
	            getLideresInventarios: function getLideresInventarios(fechaInicio, fechaFin) {
	                return axios.get('/api/lideres/inventario?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	            },
	            getInventariosLider: function getInventariosLider(idLider, fechaInicio, fechaFin) {
	                return axios.get('/api/rendiciones/' + idLider + '/inventarios?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	            },
	            guardaFondoGeneral: function guardaFondoGeneral(idRendicion, idLider, numero_semana, datos, totales) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/fondo/guardar/todos/lider/' + idLider + '/semana/' + numero_semana, { fondos: datos, totales: totales });
	            },
	            guardaFondo: function guardaFondo(idRendicion, idLider, numero_semana, datos, totales) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/fondo/guardar/lider/' + idLider + '/semana/' + numero_semana, { fondo: datos, totales: totales });
	            },
	            guardarPasaje: function guardarPasaje(idRendicion, dia, data) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/fondo/nuevo/comprobante/pasaje/' + dia, data);
	            },
	            guardaDatosPasaje: function guardaDatosPasaje(idRendicion, idBoletoPasaje, datos) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/fondo/comprobante/pasaje/' + idBoletoPasaje, datos);
	            },
	            publicarFondos: function publicarFondos(idRendicion, numero_comprobante, total) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/comprobante/' + numero_comprobante + '/monto/' + total);
	            },
	            cerrarFondo: function cerrarFondo(idRendicion) {
	                return axios.post('/api/fondo/' + idRendicion + '/cerrar');
	            },
	            misFondos: function misFondos(fechaInicio, fechaFin) {
	                return axios.get('/api/rendiciones/mis/fondos?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	            },
	            comprobantesDeposito: function comprobantesDeposito(idRendicion) {
	                return axios.get('/api/rendiciones/' + idRendicion + '/comprobantes');
	            },
	            confirmarPasaje: function confirmarPasaje(idBoletoPasaje) {
	                return axios.get('/api/rendiciones/fondo/boleto/' + idBoletoPasaje + '/confirmar/recepcion');
	            },
	            nuevoDetalleLider: function nuevoDetalleLider(idLiderDetalle, datos) {
	                return axios.post('/api/lider/detalle/' + idLiderDetalle, datos);
	            },
	            guardaDestinos: function guardaDestinos(idComunaDistancia, idComunaOrigen, idComunaDestino, valor) {
	                return axios.post('/api/comunas/guarda/destino?idComunaDistancia=' + idComunaDistancia + '&idComunaOrigen=' + idComunaOrigen + '&idComunaDestino=' + idComunaDestino + '&valor=' + valor);
	            },
	            getCiudadesInventarios: function getCiudadesInventarios(fechaInicio, fechaFin) {
	                return axios.get('/api/ciudades/inventario?fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin);
	            },
	            guardarDetalleHospedaje: function guardarDetalleHospedaje(idRendicion, fondos, datos) {
	                return axios.post('/api/rendiciones/' + idRendicion + '/fondo/detalle/hospedaje', { fondos: fondos, datos: datos });
	            }
	        };
	    },
	    rendiciones: function rendiciones() {
	        return {
	            misRendiciones: function misRendiciones() {
	                return axios.get('/api/mis/rendiciones');
	            },
	            detalleRendicion: function detalleRendicion(idRendicion) {
	                return axios.get('/api/detalle/rendicion?idRendicion=' + idRendicion);
	            },
	            getRendiciones: function getRendiciones(idLeader, numberWeek) {
	                return axios.get('/api/rendiciones?idLeader=' + idLeader + '&numberWeek=' + numberWeek);
	            }
	        };
	    },
	    gastos: function gastos() {
	        return {
	            nuevoGasto: function nuevoGasto(idRendicion, datos) {
	                return axios.post('/api/rendicion/' + idRendicion + '/new/gasto', datos);
	            },
	            getGasto: function getGasto(idGasto) {
	                return axios.get('/api/rendicion/gasto/' + idGasto);
	            },
	            modificarGasto: function modificarGasto(idGasto, gasto) {
	                return axios.post('/api/rendicion/gasto/' + idGasto + '/modificar', gasto);
	            },
	            subirFotoGasto: function subirFotoGasto(foto) {
	                return axios.post('/api/subir/foto/gasto', foto);
	            },
	            getTipoDocumentos: function getTipoDocumentos() {
	                return axios.get('/api/tipo/documentos');
	            },
	            getTipoGastos: function getTipoGastos() {
	                return axios.get('/api/tipo/gastos');
	            },
	            rechazarGasto: function rechazarGasto(idGasto) {
	                return axios.post('/api/gasto/' + idGasto + '/rechazar');
	            },
	            aprobarGasto: function aprobarGasto(idGasto) {
	                return axios.post('/api/gasto/' + idGasto + '/aprobar');
	            }
	        };
	    },
	    hospedajes: function hospedajes() {
	        return {
	            getHospedajes: function getHospedajes() {
	                return axios.get('/api/hospedajes');
	            },
	            nuevoHospedaje: function nuevoHospedaje(datos) {
	                return axios.post('/api/hospedajes/nuevo', datos);
	            },
	            getBuscarHospedajes: function getBuscarHospedajes(idComuna) {
	                return axios.get('/api/hospedajes/buscar/' + idComuna);
	            }
	        };
	    },
	
	    comentarios: {
	        saveComentario: function saveComentario(id, datos) {
	            return axios.post('/api/comentarios/' + id + '/save', datos);
	        },
	        getComentarios: function getComentarios(idInventario) {
	            return axios.get('/api/comentarios/' + idInventario);
	        },
	        editComentario: function editComentario(id, comentario) {
	            return axios.post('/api/comentarios/' + id + '/edit', comentario);
	        }
	    },
	
	    comentariosCliente: {
	        saveComentario: function saveComentario(id, datos) {
	            return axios.post('/api/comentariosCliente/' + id + '/save', datos);
	        },
	        getComentarios: function getComentarios(idLocal) {
	            return axios.get('/api/comentariosCliente/' + idLocal);
	        },
	        editComentario: function editComentario(id, comentario) {
	            return axios.post('/api/comentariosCliente/' + id + '/edit', comentario);
	        },
	        validarComentario: function validarComentario(id) {
	            return axios.post('/api/comentariosCliente/' + id + '/validar');
	        }
	    },
	
	    logistica: {
	        getLogistica: function getLogistica(idLocal) {
	            return axios.get('/api/logistica/' + idLocal);
	        },
	        editLogistica: function editLogistica(id, logistica) {
	            return axios.post('/api/logistica/' + id + '/edit', logistica);
	        },
	        saveLogistica: function saveLogistica(id, datos) {
	            return axios.post('/api/logistica/' + id + '/save', datos);
	        },
	        deleteLogistica: function deleteLogistica(id) {
	            return axios.delete('/api/logistica/' + id + '/delete');
	        }
	    },
	
	    comentarios_inv: {
	        getComentarios: function getComentarios(idInventario) {
	            return axios.get('/api/inventario-comentario/' + idInventario);
	        },
	        saveComentario: function saveComentario(idInventario, datos) {
	            return axios.post('/api/inventario-comentario/' + idInventario, datos);
	        }
	    },
	
	    reportes: {
	        getReporte: function getReporte(idInventario) {
	            return axios.get('/api/reporte/' + idInventario);
	        }
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "v1.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var axios = _axios2.default.create();
	
	var ButtonArchivoPUC = function (_Component) {
	    _inherits(ButtonArchivoPUC, _Component);
	
	    function ButtonArchivoPUC(props) {
	        _classCallCheck(this, ButtonArchivoPUC);
	
	        var _this = _possibleConstructorReturn(this, (ButtonArchivoPUC.__proto__ || Object.getPrototypeOf(ButtonArchivoPUC)).call(this, props));
	
	        _this.state = {
	            'logs': _this.props.indicator.logs
	        };
	
	        _this.enviarArchivo = _this.enviarArchivo.bind(_this);
	        return _this;
	    }
	
	    _createClass(ButtonArchivoPUC, [{
	        key: 'enviarArchivo',
	        value: function enviarArchivo() {
	            var _this2 = this;
	
	            if (confirm("Desea enviar archivo TXT a servidor?") == true) {
	                axios.get('/api/inventario/archivo-final/' + this.props.indicator.indicator.id_file + '/archivoTXT').then(function (_ref) {
	                    var data = _ref.data,
	                        status = _ref.status;
	
	                    if (status == 200) {
	                        _this2.setState({
	                            'logs': _this2.state.logs.concat(data)
	                        });
	                    }
	                }).catch(function (error) {
	                    console.log(error);
	                });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps !== this.props && nextProps.indicator.logs.length > 0) {
	                this.setState({
	                    'logs': nextProps.indicator.logs
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.props.indicator.indicator.id_file ? this.state.logs.length > 0 ? _react2.default.createElement(
	                'button',
	                { onClick: this.enviarArchivo, className: 'btn btn-success btn-xs',
	                    title: 'Enviar archivo TXT'
	                },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' })
	            ) : _react2.default.createElement(
	                'button',
	                { onClick: this.enviarArchivo, className: 'btn btn-danger btn-xs',
	                    title: 'Enviar archivo TXT'
	                },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' })
	            ) : _react2.default.createElement(
	                'button',
	                { disabled: true, className: 'btn btn-warning btn-xs',
	                    title: 'Enviar archivo TXT'
	                },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' })
	            );
	        }
	    }]);
	
	    return ButtonArchivoPUC;
	}(_react.Component);
	
	exports.default = ButtonArchivoPUC;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ButtonArchivoPUC.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _comentariosIG = __webpack_require__(605);
	
	var css = _interopRequireWildcard(_comentariosIG);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComentarioIG = function (_Component) {
	    _inherits(ComentarioIG, _Component);
	
	    function ComentarioIG(props) {
	        _classCallCheck(this, ComentarioIG);
	
	        var _this = _possibleConstructorReturn(this, (ComentarioIG.__proto__ || Object.getPrototypeOf(ComentarioIG)).call(this, props));
	
	        _this.state = {
	            show: false,
	            idInventario: props.idInventario,
	            comentarios: [],
	            loading: false,
	            saving: false
	        };
	        return _this;
	    }
	
	    _createClass(ComentarioIG, [{
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "getComentarios",
	        value: function getComentarios() {
	            var _this2 = this;
	
	            this.setState({
	                loading: true
	            });
	            _v2.default.comentarios_inv.getComentarios(this.state.idInventario).then(function (resp) {
	                _this2.setState({
	                    comentarios: resp.comentarios,
	                    loading: false
	                });
	            }).catch(function (err) {
	                console.log("Error al cargar comentarios");
	                _this2.setState({
	                    loading: false
	                });
	            });
	        }
	    }, {
	        key: "saveComentario",
	        value: function saveComentario(comentario) {
	            var _this3 = this;
	
	            this.setState({
	                saving: true
	            });
	            _v2.default.comentarios_inv.saveComentario(this.state.idInventario, {
	                comentario: comentario
	            }).then(function (resp) {
	                _this3.setState({
	                    saving: false,
	                    comentarios: resp.comentarios
	                });
	            }).catch(function (err) {
	                console.log("Error al enviar/recibir comentario");
	                _this3.setState({
	                    saving: false
	                });
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            var _this4 = this;
	
	            if (this.state.show == true && prevState.show == false) {
	                this.setState({
	                    loading: true
	                });
	                _v2.default.comentarios_inv.getComentarios(this.state.idInventario).then(function (resp) {
	                    _this4.setState({
	                        comentarios: resp.comentarios,
	                        loading: false
	                    });
	                }).catch(function (err) {
	                    console.log("Error al enviar/recibir comentario");
	                    _this4.setState({
	                        loading: false
	                    });
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "button",
	                    { onClick: this.handleClick.bind(this) },
	                    _react2.default.createElement("i", { className: "glyphicon glyphicon-comment" })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: "left",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.state.idInventario,
	                            bsClass: css.comentarios_popover + " popover"
	                        },
	                        !this.state.loading ? _react2.default.createElement(
	                            "div",
	                            null,
	                            this.state.comentarios.map(function (registro, index) {
	                                return _react2.default.createElement(
	                                    "div",
	                                    { key: _this5.state.idInventario + "." + index, style: {
	                                            paddingLeft: 5,
	                                            paddingRight: 5
	                                        }, title: registro.created_at },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: {
	                                                fontSize: 10
	                                            } },
	                                        registro.usuario + ": "
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: {
	                                                fontSize: 12
	                                            } },
	                                        registro.comentario
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(FormText, {
	                                save: this.saveComentario.bind(this),
	                                saving: this.state.saving
	                            })
	                        ) : _react2.default.createElement(
	                            "div",
	                            { style: { padding: "20px" } },
	                            "Cargando..."
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComentarioIG;
	}(_react.Component);
	
	exports.default = ComentarioIG;
	
	var FormText = function (_React$Component) {
	    _inherits(FormText, _React$Component);
	
	    function FormText(props) {
	        _classCallCheck(this, FormText);
	
	        var _this6 = _possibleConstructorReturn(this, (FormText.__proto__ || Object.getPrototypeOf(FormText)).call(this, props));
	
	        _this6.state = {
	            defaulttext: "",
	            textarea: "",
	            visible: false,
	            rows: 5,
	            enable: true
	        };
	        _this6.handleSubmit = _this6.handleSubmit.bind(_this6);
	        _this6.handleChange = _this6.handleChange.bind(_this6);
	        _this6.handleCancelar = _this6.handleCancelar.bind(_this6);
	        return _this6;
	    }
	
	    _createClass(FormText, [{
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            e.preventDefault();
	            this.props.save(this.state.textarea.trim());
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.setState({
	                textarea: e.target.value,
	                visible: true
	            });
	            var currentRows = e.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                this.setState({ rows: currentRows });
	            }
	        }
	    }, {
	        key: "handleCancelar",
	        value: function handleCancelar() {
	            this.setState(function (state) {
	                return {
	                    textarea: state.defaulttext,
	                    visible: false
	                };
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            if (this.props.saving == false && prevProps.saving == true) {
	                this.setState({
	                    defaulttext: "",
	                    textarea: "",
	                    visible: false,
	                    rows: 5,
	                    enable: true
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: css.formulario },
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement(
	                        "div",
	                        { className: css.mytextarea },
	                        _react2.default.createElement("textarea", {
	                            disabled: this.props.saving,
	                            ref: function ref(text) {
	                                return _this7.textArea = text;
	                            },
	                            onChange: this.handleChange,
	                            value: this.state.textarea,
	                            maxLength: 200,
	                            rows: this.state.rows,
	                            type: "text"
	                        })
	                    ),
	                    this.state.visible ? _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: this.props.saving, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: this.props.saving, type: "button", onClick: this.handleCancelar, className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : null,
	                    this.props.saving && _react2.default.createElement(
	                        "div",
	                        null,
	                        "Guardando..."
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormText;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ComentarioIG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(492);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(495);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(499);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(500);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(501);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(503);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(504);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(506);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(507);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(509);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(512);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(513);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(515);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(516);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(517);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(518);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(537);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(443);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(538);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(539);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(542);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(511);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(543);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(544);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(545);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(546);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(549);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(550);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(551);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(552);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(553);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(560);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(317);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(445);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(454);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(455);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(457);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(561);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(562);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(563);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(567);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(568);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(569);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(579);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(580);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(581);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(584);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(585);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(586);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(587);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(493);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(588);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(589);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(590);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(591);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(592);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(502);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(593);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(595);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(596);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(597);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(599);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(598);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(600);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(601);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(602);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(603);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(604);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(493);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(397);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(497), __esModule: true };

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(498);
	module.exports = __webpack_require__(332).Object.values;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(330);
	var $values = __webpack_require__(450)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(501);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(505);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(503);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(418);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(503);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(508);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(509);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(511);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(510);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _capitalize = __webpack_require__(514);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(424);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(444);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(514);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(442);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(408);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(519);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(505);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(520);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(504);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(524);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(535);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(536);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(522);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(523);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(525);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(519);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(534);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(526), __esModule: true };

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(324);
	__webpack_require__(527);
	module.exports = __webpack_require__(332).Array.from;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(333);
	var $export = __webpack_require__(330);
	var toObject = __webpack_require__(367);
	var call = __webpack_require__(528);
	var isArrayIter = __webpack_require__(529);
	var toLength = __webpack_require__(357);
	var createProperty = __webpack_require__(530);
	var getIterFn = __webpack_require__(531);
	
	$export($export.S + $export.F * !__webpack_require__(533)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(337);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(347);
	var ITERATOR = __webpack_require__(365)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(336);
	var createDesc = __webpack_require__(344);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(532);
	var ITERATOR = __webpack_require__(365)('iterator');
	var Iterators = __webpack_require__(347);
	module.exports = __webpack_require__(332).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(355);
	var TAG = __webpack_require__(365)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(365)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(408);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(440);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(421);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(503);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(418);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(518);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(458);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(540);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(541);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(511);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(547);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(548);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(552);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(554);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(555);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(556);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(557);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(558);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(559);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(553);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(553);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(505);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(519);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(505);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(543);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(563);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(564);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(565);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(566);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(517);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(518);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(458);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(570);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(443);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(420);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(571);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(534);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(417);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(572);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(422);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(421);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(573);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(574);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(577);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(421);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(408));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(438));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(411));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(575));
	
	var _offset = _interopRequireDefault(__webpack_require__(573));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(576));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(577));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(578));
	
	var _style = _interopRequireDefault(__webpack_require__(424));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(411));
	
	var _style = _interopRequireDefault(__webpack_require__(424));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(438));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(403);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(438));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(408);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(569);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(582);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(583);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(321);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(582);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(586);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(517);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(520);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(496);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(503);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(518);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(594);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(458);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(535);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(596);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(597);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(598);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(419);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(416);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _createChainedFunction = __webpack_require__(456);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(443);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(520);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(561);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(568);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(596);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(597);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _ValidComponentChildren = __webpack_require__(494);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(502);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(396);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(520);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(396);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(318);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(320);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(388);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(446);
	
	var _StyleConfig = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(446);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(456);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(494);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"comentarios_popover":"comentariosIG__comentarios_popover___7MRiC","comentarios_container":"comentariosIG__comentarios_container___DrE7O","formulario":"comentariosIG__formulario___2Inlu","comentarios_mensaje":"comentariosIG__comentarios_mensaje___4lomp","nombre":"comentariosIG__nombre___2nkJf","boton":"comentariosIG__boton___33LGy","textoConTooltip":"comentariosIG__textoConTooltip___MCMI3","mytextarea":"comentariosIG__mytextarea___2-LMW","editar":"comentariosIG__editar___1Q2Dj","input_comentarios_editable":"comentariosIG__input_comentarios_editable___3W0Ae","input_comentarios_pointer":"comentariosIG__input_comentarios_pointer___2M1YJ"};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBloqueo = function (_React$Component) {
	    _inherits(ModalBloqueo, _React$Component);
	
	    function ModalBloqueo(props) {
	        _classCallCheck(this, ModalBloqueo);
	
	        var _this = _possibleConstructorReturn(this, (ModalBloqueo.__proto__ || Object.getPrototypeOf(ModalBloqueo)).call(this, props));
	
	        _this.handleTipoChange = function (e) {
	            _this.setState({ tipoBloqueo: e.target.value, mensaje: null });
	        };
	
	        _this.handleConfirmar = function () {
	            var _this$props = _this.props,
	                idUsuario = _this$props.idUsuario,
	                clientName = _this$props.clientName,
	                usuario = _this$props.usuario;
	            var tipoBloqueo = _this.state.tipoBloqueo;
	
	
	            if (!idUsuario) {
	                _this.setState({ mensaje: 'Falta el ID del usuario.' });
	                return;
	            }
	
	            _this.setState({ loading: true, mensaje: null });
	
	            var url = '';
	            var options = {
	                method: 'POST',
	                headers: { 'Content-Type': 'application/json' }
	            };
	
	            if (tipoBloqueo === 'cliente') {
	                url = 'api/personal/' + idUsuario + '/bloqueo-cliente-dashboard';
	                options.body = JSON.stringify({
	                    client_name: clientName
	                });
	            } else {
	                url = 'api/personal/' + idUsuario + '/bloqueo-cliente-todos-dashboard';
	            }
	
	            fetch(url, options).then(function (res) {
	                return res.json();
	            }).then(function () {
	                _this.setState({
	                    loading: false,
	                    mensaje: '✅ Bloqueo realizado correctamente.'
	                });
	            }).catch(function (err) {
	                console.error(err);
	                _this.setState({
	                    loading: false,
	                    mensaje: '❌ Error al realizar el bloqueo.'
	                });
	            });
	        };
	
	        _this.state = {
	            tipoBloqueo: 'cliente', // 'cliente' o 'todos'
	            loading: false,
	            mensaje: null
	        };
	        return _this;
	    }
	
	    _createClass(ModalBloqueo, [{
	        key: 'render',
	        value: function render() {
	            console.log(this.props);
	            var _props = this.props,
	                show = _props.show,
	                onClose = _props.onClose,
	                usuario = _props.usuario,
	                clientName = _props.clientName;
	            var _state = this.state,
	                tipoBloqueo = _state.tipoBloqueo,
	                loading = _state.loading,
	                mensaje = _state.mensaje;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: show, onHide: onClose },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Bloqueo de Clientes'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Selecciona el tipo de bloqueo que deseas realizar para operador(a) ',
	                        usuario,
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'radio' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement('input', {
	                                type: 'radio',
	                                value: 'cliente',
	                                checked: tipoBloqueo === 'cliente',
	                                onChange: this.handleTipoChange
	                            }),
	                            '\xA0 Bloquear solo este cliente (',
	                            clientName,
	                            ')'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'radio' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement('input', {
	                                type: 'radio',
	                                value: 'todos',
	                                checked: tipoBloqueo === 'todos',
	                                onChange: this.handleTipoChange
	                            }),
	                            '\xA0 Bloquear todos los clientes'
	                        )
	                    ),
	                    mensaje && _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'alert ' + (mensaje.includes('Error') || mensaje.includes('Falta') ? 'alert-danger' : 'alert-success'),
	                            style: { marginTop: '15px' }
	                        },
	                        mensaje
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'btn btn-warning',
	                            onClick: this.handleConfirmar,
	                            disabled: loading
	                        },
	                        loading ? 'Procesando...' : 'Confirmar Bloqueo'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: onClose },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalBloqueo;
	}(_react2.default.Component);
	
	exports.default = ModalBloqueo;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalBloqueo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowSummaryIndicators = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelIndicators = __webpack_require__(487);
	
	var _PanelIndicators2 = _interopRequireDefault(_PanelIndicators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RowSummaryIndicators = exports.RowSummaryIndicators = function RowSummaryIndicators(_ref) {
	    var summaryIndicators = _ref.summaryIndicators,
	        linkDownloadData = _ref.linkDownloadData,
	        title = _ref.title,
	        showOtherData = _ref.showOtherData,
	        permissions = _ref.permissions,
	        fcv = _ref.fcv,
	        fsb = _ref.fsb,
	        unDesviadas = _ref.unDesviadas,
	        reportar = _ref.reportar,
	        admin = _ref.admin,
	        cargando = _ref.cargando;
	    return _react2.default.createElement(
	        'tr',
	        { className: 'info' },
	        _react2.default.createElement(
	            'td',
	            { colSpan: '3', className: _PanelIndicators2.default.PanelIndicators_tdTitleSummary },
	            title
	        ),
	        admin == true ? null : _react2.default.createElement('td', null),
	        permissions ? _react2.default.createElement('td', null) : null,
	        _react2.default.createElement('td', null),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdRightText },
	            permissions ? null : cargando ? 'Cargando...' : summaryIndicators.promedio_operators
	        ),
	        permissions ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdRightText },
	            cargando ? "Cargando..." : summaryIndicators.promedio_operators
	        ) : null,
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdRightText },
	            cargando ? "" : summaryIndicators.units_total
	        ),
	        unDesviadas ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.promedio_diff_informada
	        ) : null,
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.avg_duration_process
	        ),
	        permissions ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.promedio_nota_conteo
	        ) : null,
	        permissions ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.promedio_nota_presentacion
	        ) : null,
	        permissions ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.promedio_nota_supervisor
	        ) : null,
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : permissions ? summaryIndicators.avg_scores : summaryIndicators.avg_scores ? parseFloat(summaryIndicators.avg_scores.replace(',', '.')).toFixed(1).replace('.', ',') : null
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : permissions ? summaryIndicators.avg_rate_error_sei : summaryIndicators.avg_rate_error_sei ? parseFloat(summaryIndicators.avg_rate_error_sei.replace(',', '.')).toFixed(1).replace('.', ',') : null
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : permissions ? summaryIndicators.avg_rate_standard_sei : summaryIndicators.avg_rate_standard_sei ? parseFloat(summaryIndicators.avg_rate_standard_sei.replace(',', '.')).toFixed(1).replace('.', ',') : null
	        ),
	        showOtherData ? _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.avg_rate_variance
	        ) : null,
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.promedio_grilla
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter, style: summaryIndicators.avg_rate_audit_client_ptt && parseFloat(summaryIndicators.avg_rate_audit_client_ptt).toFixed(1) < 30 && fcv ? { color: 'red' } : summaryIndicators.avg_rate_audit_client_ptt && parseFloat(summaryIndicators.avg_rate_audit_client_ptt).toFixed(1) < 50 && fsb ? { color: 'red' } : null },
	            cargando ? "" : summaryIndicators.avg_rate_audit_client_ptt
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.avg_rate_audit_client_items
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter, style: summaryIndicators.avg_rate_error_client && parseFloat(summaryIndicators.avg_rate_error_client).toFixed(1) > 1 ? { color: 'red' } : null },
	            cargando ? "" : summaryIndicators.avg_rate_error_client
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdSummaryReportsCenter },
	            cargando ? "" : summaryIndicators.avg_rate_standard_client
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _PanelIndicators2.default.PanelIndicators_tdRightText },
	            cargando ? "" : summaryIndicators.total_diff_neto ? (summaryIndicators.total_diff_neto / 1000).toLocaleString("es-CL", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }) : summaryIndicators.total_diff_neto
	        ),
	        permissions ? _react2.default.createElement('td', null) : null,
	        _react2.default.createElement('td', null),
	        _react2.default.createElement('td', null),
	        (permissions || fcv) && _react2.default.createElement('td', null),
	        _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-success btn-xs',
	                    href: linkDownloadData
	                },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-download' })
	            )
	        ),
	        _react2.default.createElement('td', null),
	        _react2.default.createElement('td', null),
	        permissions ? _react2.default.createElement('td', null) : null
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowSummaryIndicators.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelIndicators = __webpack_require__(487);
	
	var _PanelIndicators2 = _interopRequireDefault(_PanelIndicators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// css
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var HeaderFiltro = function (_React$Component) {
	    _inherits(HeaderFiltro, _React$Component);
	
	    function HeaderFiltro(props) {
	        _classCallCheck(this, HeaderFiltro);
	
	        var _this = _possibleConstructorReturn(this, (HeaderFiltro.__proto__ || Object.getPrototypeOf(HeaderFiltro)).call(this, props));
	
	        _this.state = {
	            filtering: false,
	            filtro: []
	        };
	
	        return _this;
	    }
	    // Metodos para controlar el display del menu, ocultar y mostrar los elementos
	
	
	    _createClass(HeaderFiltro, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.onClickHandler.bind(this));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.onClickHandler.bind(this));
	        }
	    }, {
	        key: 'onClickHandler',
	        value: function onClickHandler(evt) {
	            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
	            if (!this.node.contains(evt.target) && this.state.filtering) this.cerrarMenu_descartarCambios();
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            var clientes = this.props.indicators ? this.props.indicators.map(function (aux) {
	                return aux.client_name;
	            }) : [];
	            var clientesUnicos = clientes.filter(function (item, i, ar) {
	                return ar.indexOf(item) === i;
	            });
	            var clientesFiltro = clientesUnicos.map(function (aux) {
	                return {
	                    texto: aux,
	                    seleccionado: true
	                };
	            });
	            if (this.state.filtering) {
	                this.cerrarMenu_descartarCambios();
	            } else {
	                this.setState({ filtering: true });
	                if (this.props.sinFiltro) {
	                    this.setState({
	                        filtro: clientesFiltro
	                    });
	                } else if (this.state.filtro.length == 0) {
	                    this.setState({
	                        filtro: clientesFiltro
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'cerrarMenu_descartarCambios',
	        value: function cerrarMenu_descartarCambios() {
	            this.setState({
	                filtering: false,
	                filtro: []
	            });
	        }
	    }, {
	        key: 'cerrarMenu_aplicarCambios',
	        value: function cerrarMenu_aplicarCambios() {
	            // ocultar el menu e informar la actualizacion del filtro al padre
	            this.setState({ filtro: this.state.filtro, filtering: false });
	            this.props.actualizarFiltro(this.state.filtro);
	            //console.log(this.state.filtro)
	        }
	    }, {
	        key: 'onClickHandler',
	        value: function onClickHandler(evt) {
	            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
	            if (!this.node.contains(evt.target) && this.state.filtering) this.cerrarMenu_descartarCambios();
	        }
	    }, {
	        key: 'seleccionarOpcion',
	        value: function seleccionarOpcion(valorSeleccionado) {
	            this.setState({
	                filtro: this.state.filtro.map(function (opcion) {
	                    return {
	                        // si es la opcion que estamos buscando, se cambia su estado 'seleccionado', si no lo dejamos igual
	                        texto: opcion.texto,
	                        seleccionado: opcion.texto == valorSeleccionado ? !opcion.seleccionado : opcion.seleccionado
	
	                    };
	                })
	            });
	        }
	    }, {
	        key: 'estanTodosSeleccionados',
	        value: function estanTodosSeleccionados() {
	            // todos seleccionados = el total de '.selecconado=false' es cero
	            return this.state.filtro.filter(function (opc) {
	                return opc.seleccionado === false;
	            }).length === 0;
	        }
	    }, {
	        key: 'toggleTodos',
	        value: function toggleTodos() {
	            var todosSeleccionados = this.estanTodosSeleccionados();
	            this.setState({
	                filtro: this.state.filtro.map(function (opcion) {
	                    return {
	                        // si estan todos seleccionados, marcar ninguno
	                        // si falta uno por marcar, se marcan todos
	                        seleccionado: !todosSeleccionados,
	                        texto: opcion.texto
	                    };
	                })
	            });
	        }
	    }, {
	        key: 'onKeyDownInputTexto',
	        value: function onKeyDownInputTexto(evt) {
	            var _this2 = this;
	
	            // 13 = enter
	            if (evt.keyCode === 13) {
	                // tanto al texto buscado, como el de los input, se la quitan los espacios y se pone en minusculas
	                var texto = this.refInputTexto.value.trim().toLowerCase();
	
	                var filtroActualizado = this.state.filtro.map(function (opcion) {
	                    var textoOpcion = opcion.texto.trim().toLowerCase();
	
	                    // Si se realiza una "busqueda exacta" se comparan los string, de lo contrario
	                    // busca que este incluido en el texto
	                    opcion.seleccionado = _this2.props.busquedaExacta ? textoOpcion == texto : textoOpcion.includes(texto);
	                    return opcion;
	                });
	                // luego de buscar, se oculta la busqueda
	                this.refInputTexto.value = '';
	                // this.closeMe nu()
	                this.setState({ filtering: false });
	
	                // informar la actualizacion al padre
	                this.props.actualizarFiltro(filtroActualizado);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PanelIndicators2.default.container,
	                    ref: function ref(_ref) {
	                        return _this3.node = _ref;
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _PanelIndicators2.default.divTitulo,
	                        onClick: this.toggleMenu.bind(this) },
	                    this.props.nombre
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pull-right' },
	                    this.props.ordenarLista ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-sort-by-attributes ' + _PanelIndicators2.default.spanOrdenar,
	                        onClick: this.props.ordenarLista
	                    }) : null,
	                    _react2.default.createElement('span', { className: (this.estanTodosSeleccionados() ? '' : _PanelIndicators2.default.filtroColoreado) + (this.state.filtering ? ' glyphicon glyphicon-triangle-top ' : ' glyphicon glyphicon-triangle-bottom '),
	                        onClick: this.toggleMenu.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _PanelIndicators2.default.menu, style: { display: this.state.filtering ? '' : 'none' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PanelIndicators2.default.contenedorValores },
	                        this.state.filtro.map(function (opcion, index) {
	                            return _react2.default.createElement(
	                                'label',
	                                { key: index },
	                                _react2.default.createElement('input', { type: 'checkbox',
	                                    onChange: _this3.seleccionarOpcion.bind(_this3, opcion.texto),
	                                    checked: !!opcion.seleccionado
	                                }),
	                                ' ',
	                                opcion.texto
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'checkbox',
	                            onChange: this.toggleTodos.bind(this),
	                            checked: this.estanTodosSeleccionados.call(this)
	                        }),
	                        'Todos'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'btn btn-block btn-sm btn-primary',
	                            onClick: this.cerrarMenu_aplicarCambios.bind(this) },
	                        'Aceptar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderFiltro;
	}(_react2.default.Component);
	
	exports.default = HeaderFiltro;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "HeaderFiltro.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalActa = function (_React$Component) {
	    _inherits(ModalActa, _React$Component);
	
	    function ModalActa(props) {
	        _classCallCheck(this, ModalActa);
	
	        var _this = _possibleConstructorReturn(this, (ModalActa.__proto__ || Object.getPrototypeOf(ModalActa)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ModalActa, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.previewActa(this.props.idInventario);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Acta Inventario IG'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container', style: { width: 'auto' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'accordion' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-header', id: 'headingOne' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-link', 'data-toggle': 'collapse', 'data-target': '#collapseOne', 'aria-expanded': 'false', 'aria-controls': 'collapseOne' },
	                                                'Resumen Inventario'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'collapseOne', className: 'collapse', 'aria-labelledby': 'headingOne', 'data-parent': '#accordion' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card-body' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Cliente'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.cliente
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Local (CECO)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ceco
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Fecha IG'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.fecha
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Dotaci\xF3n Presupuestada'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.dot_presupuesto
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Dotaci\xF3n Efectiva'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.dot_efectiva
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Hora LLegada'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.hora_llegada
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Supervisor SEI'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.supervisor
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-6' },
	                                                                    'Qu\xEDmico Farmac\xE9utico/Jefe Local'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.administrador
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-header', id: 'headingTwo' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-link collapsed', 'data-toggle': 'collapse', 'data-target': '#collapseTwo', 'aria-expanded': 'false', 'aria-controls': 'collapseTwo' },
	                                                'Horarios'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'collapseTwo', className: 'collapse', 'aria-labelledby': 'headingTwo', 'data-parent': '#accordion' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card-body' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement('label', { style: { width: '250px' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '100px' } },
	                                                                    'FECHA'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right' },
	                                                                    'HORA'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Inicio Conteo'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.inicio_conteo_fecha
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.inicio_conteo
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Fin Conteo'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.fin_conteo_fecha
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.fin_conteo
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Horas Conteo'
	                                                                ),
	                                                                _react2.default.createElement('label', { style: { fontWeight: 'normal' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.horas_conteo
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Inicio Revisi\xF3n Grilla'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.inicio_grilla_fecha
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.inicio_grilla
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Fin Proceso'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.fin_proceso_fecha
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.fin_proceso
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Horas Revisi\xF3n'
	                                                                ),
	                                                                _react2.default.createElement('label', { style: { fontWeight: 'normal' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.revision
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'Total Horas Inventario'
	                                                                ),
	                                                                _react2.default.createElement('label', { style: { fontWeight: 'normal' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.horas_inventario
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-header', id: 'headingThree' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-link collapsed', 'data-toggle': 'collapse', 'data-target': '#collapseThree', 'aria-expanded': 'false', 'aria-controls': 'collapseThree' },
	                                                'Indicadores de Gesti\xF3n de Inventario'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'collapseThree', className: 'collapse', 'aria-labelledby': 'headingThree', 'data-parent': '#accordion' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card-body' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Unidades Te\xF3ricas (Mapro Inicial)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.unidades_teoricas
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item', style: { borderBottom: 'solid', borderBottomColor: 'black' } },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Unidades F\xEDsicas Inventariadas (Mapro Final)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.unidades_fisicas
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Unidades Diferencia Neta'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.diferencia_neta
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Unidades Diferencia Absoluto'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.diferencia_neta
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement('br', null),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Total SKU (C\xF3digos internos) efectivos local'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.total_sku
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Total Items inventariados (escaneos)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.total_items ? this.props.indicators.total_items.toLocaleString('en-US') : ""
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Cantidad PTT Inventariadas'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_inventariadas ? this.props.indicators.ptt_inventariadas.toLocaleString('en-US') : ""
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-header', id: 'headingFour' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-link collapsed', 'data-toggle': 'collapse', 'data-target': '#collapseFour', 'aria-expanded': 'false', 'aria-controls': 'collapseFour' },
	                                                'Indicadores de Auditor\xEDa Cliente'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'collapseFour', className: 'collapse', 'aria-labelledby': 'headingFour', 'data-parent': '#accordion' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card-body' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement('label', { style: { width: '380px' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '100px' } },
	                                                                    'Cantidad'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right' },
	                                                                    '%'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    'Cantidad de Items AUDITADOS Cliente'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.items_cliente ? this.props.indicators.items_cliente.toLocaleString('en-US') : ""
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    (this.props.indicators.items_cliente * 100 / this.props.indicators.total_items).toFixed(1)
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    'Cantidad de Patentes Auditadas Cliente'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.patentes_cliente ? this.props.indicators.patentes_cliente.toLocaleString('en-US') : ""
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    (this.props.indicators.patentes_cliente * 100 / this.props.indicators.ptt_inventariadas).toFixed(1)
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    'Total unidades NETO corregidas AUDITORIA'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.neto_corr_auditoria
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    '0.0'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    'Total unidades ABS corregidas AUDITORIA'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.abs_corr_auditoria
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    '0.0'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    'Total ITEMS Corregidos AUDITORIAS (% Error SEI)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.items_corr_auditoria_sei
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.porcentaje_error_sei
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '380px' } },
	                                                                    '% Variacion Ajuste Neto (Grilla)'
	                                                                ),
	                                                                _react2.default.createElement('label', { style: { fontWeight: 'normal' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.variacion_grilla
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'h4',
	                                                            null,
	                                                            'Apertura Auditor\xEDa'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement('label', { style: { width: '250px' } }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '90px' } },
	                                                                    'Items'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '50px' } },
	                                                                    'Patentes'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right' },
	                                                                    'Unidades'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'PTT auditadas QF (1001)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal', width: '90px' } },
	                                                                    this.props.indicators.ptt_qf_items
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_qf_patentes
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_qf_unidades
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'PTT auditadas A1 (1002)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal', width: '90px' } },
	                                                                    this.props.indicators.ptt_a1_items
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_a1_patentes
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_a1_unidades
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'PTT auditadas A2 (1003)'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal', width: '90px' } },
	                                                                    this.props.indicators.ptt_a2_items
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_a2_patentes
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_a2_unidades
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { width: '250px' } },
	                                                                    'PTT auditadas Sup CV'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal', width: '90px' } },
	                                                                    this.props.indicators.ptt_sup_items
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_sup_patentes
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'pull-right', style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.ptt_sup_unidades
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-header', id: 'headingFive' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-link collapsed', 'data-toggle': 'collapse', 'data-target': '#collapseFive', 'aria-expanded': 'false', 'aria-controls': 'collapseFive' },
	                                                'Evaluaci\xF3n Servicio'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'collapseFive', className: 'collapse', 'aria-labelledby': 'headingFive', 'data-parent': '#accordion' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card-body' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'panel-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { className: 'list-group' },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Evaluar presentaci\xF3n SEI'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.nota_pres
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Evaluar supervisor SEI'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.nota_sup
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Evaluar conteo'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.nota_conteo
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Promedio'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    ((parseInt(this.props.indicators.nota_pres) + parseInt(this.props.indicators.nota_sup) + parseInt(this.props.indicators.nota_conteo)) / 3).toFixed(1)
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Cumplimiento CLIENTE'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.estandar_cliente,
	                                                                    '%'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            { className: 'list-group-item' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { className: 'col-md-9' },
	                                                                    'Cumplimiento SEI'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { style: { fontWeight: 'normal' } },
	                                                                    this.props.indicators.estandar_sei,
	                                                                    '%'
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-primary', href: '/inventario/archivo-final/' + this.props.indicators.id_file + '/descargar-acta', target: '_blank' },
	                        'Descargar Acta'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalActa;
	}(_react2.default.Component);
	
	exports.default = ModalActa;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalActa.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIframe = __webpack_require__(611);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalActaCliente = function (_React$Component) {
	    _inherits(ModalActaCliente, _React$Component);
	
	    function ModalActaCliente(props) {
	        _classCallCheck(this, ModalActaCliente);
	
	        var _this = _possibleConstructorReturn(this, (ModalActaCliente.__proto__ || Object.getPrototypeOf(ModalActaCliente)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ModalActaCliente, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.previewActa(this.props.idInventario);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal, bsSize: 'large' },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Acta Inventario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%', height: '70vh', margin: 'auto' } },
	                        _react2.default.createElement('iframe', {
	                            src: this.props.indicators,
	                            width: '100%',
	                            height: '100%',
	                            style: { display: 'block', border: 'none' }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-primary', href: '/inventario/archivo-final/' + this.props.indicators.id_file + '/descargar-acta', target: '_blank' },
	                        'Descargar Acta'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalActaCliente;
	}(_react2.default.Component);
	
	exports.default = ModalActaCliente;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalActaCliente.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return call&&(typeof call==="object"||typeof call==="function")?call:self}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var React=__webpack_require__(2);var PureComponent=React.PureComponent;var PropTypes=__webpack_require__(413);var objectAssign=__webpack_require__(4);function noop(){}var Iframe=function(_PureComponent){_inherits(Iframe,_PureComponent);function Iframe(){_classCallCheck(this,Iframe);return _possibleConstructorReturn(this,(Iframe.__proto__||Object.getPrototypeOf(Iframe)).apply(this,arguments))}_createClass(Iframe,[{key:"render",value:function render(){var props={ref:"iframe",frameBorder:"0",src:this.props.url,target:"_parent",allowFullScreen:this.props.allowFullScreen||false,style:objectAssign({},{position:this.props.position||"absolute",display:this.props.display||"block",height:this.props.height||"100%",width:this.props.width||"100%"},this.props.styles||{}),height:this.props.height||"100%",name:this.props.name||"",width:this.props.width||"100%",onLoad:this.props.onLoad||noop,onMouseOver:this.props.onMouseOver||noop,onMouseOut:this.props.onMouseOut||noop};return React.createElement("iframe",objectAssign(props,this.props.id?{id:this.props.id}:{},this.props.sandbox?{sandbox:this.props.sandbox}:{},this.props.allow?{allow:this.props.allow}:{},this.props.className?{className:this.props.className}:{},this.props.title?{title:this.props.title}:{},this.props.ariaHidden?{"aria-hidden":"true"}:{}))}}]);return Iframe}(PureComponent);Iframe.propTypes={url:PropTypes.string.isRequired,id:PropTypes.string,title:PropTypes.string,className:PropTypes.string,width:PropTypes.string,position:PropTypes.string,display:PropTypes.string,name:PropTypes.string,height:PropTypes.string,onLoad:PropTypes.func,sandbox:PropTypes.string,allow:PropTypes.string,onMouseOver:PropTypes.func,onMouseOut:PropTypes.func,styles:PropTypes.object,allowFullScreen:PropTypes.bool,ariaHidden:PropTypes.bool};exports.default=Iframe;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalImagenes = function (_React$Component) {
	    _inherits(ModalImagenes, _React$Component);
	
	    function ModalImagenes(props) {
	        _classCallCheck(this, ModalImagenes);
	
	        var _this = _possibleConstructorReturn(this, (ModalImagenes.__proto__ || Object.getPrototypeOf(ModalImagenes)).call(this, props));
	
	        _this.state = {
	            selectedCategory: "inicio",
	            currentIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(ModalImagenes, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.imagenes(this.props.idInventario);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                currentIndex = _state.currentIndex,
	                selectedCategory = _state.selectedCategory;
	
	            console.log(this.props);
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal, bsSize: 'large' },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Im\xE1genes de Inventario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    !Array.isArray(this.props.indicators) ? _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%', height: '70vh', margin: 'auto', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { gap: '10px', display: 'flex', justifyContent: 'center' } },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-' + (selectedCategory === "inicio" ? "primary" : "secondary"),
	                                    onClick: function onClick() {
	                                        return _this2.setState({ selectedCategory: "inicio", currentIndex: 0 });
	                                    }
	                                },
	                                'Fotos Inicio'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-' + (selectedCategory === "cierre" ? "primary" : "secondary"),
	                                    onClick: function onClick() {
	                                        return _this2.setState({ selectedCategory: "cierre", currentIndex: 0 });
	                                    }
	                                },
	                                'Fotos Cierre'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'align-items-center',
	                                style: { height: '100%', display: 'flex', justifyContent: 'center' }
	                            },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-info',
	                                    style: { height: '40px', margin: 'auto' },
	                                    onClick: function onClick() {
	                                        return _this2.setState({
	                                            currentIndex: currentIndex - 1
	                                        });
	                                    },
	                                    disabled: currentIndex == 0
	                                },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-chevron-left', style: { verticalAlign: 'center', alignContent: 'center' } }),
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    style: {
	                                        width: '60%',
	                                        height: '100%',
	                                        display: 'flex',
	                                        alignItems: 'center',
	                                        justifyContent: 'center'
	                                    }
	                                },
	                                _react2.default.createElement('img', {
	                                    src: selectedCategory === "cierre" ? this.props.indicators.foto_cierre[currentIndex] : this.props.indicators.foto_inicio[currentIndex],
	                                    alt: 'Foto ' + (currentIndex + 1),
	                                    style: {
	                                        maxWidth: '100%',
	                                        maxHeight: '100%',
	                                        borderRadius: '8px',
	                                        border: '1px solid #ddd'
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-info',
	                                    style: { height: '40px', margin: 'auto' },
	                                    onClick: function onClick() {
	                                        return _this2.setState({
	                                            currentIndex: currentIndex + 1
	                                        });
	                                    },
	                                    disabled: currentIndex + 1 >= (selectedCategory === "cierre" ? this.props.indicators.foto_cierre.length : this.props.indicators.foto_inicio.length)
	                                },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-chevron-right', style: { verticalAlign: 'center', alignContent: 'center' } })
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center' } },
	                        'No hay im\xE1genes disponibles.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'btn btn-primary',
	                            href: '/inventario/archivo-final/' + this.props.id_file[0].indicator.id_file + '/descargar-imagenes-cliente',
	                            target: '_blank'
	                        },
	                        'Descargar Im\xE1genes'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalImagenes;
	}(_react2.default.Component);
	
	exports.default = ModalImagenes;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalImagenes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalChecklist = function (_React$Component) {
	    _inherits(ModalChecklist, _React$Component);
	
	    function ModalChecklist(props) {
	        _classCallCheck(this, ModalChecklist);
	
	        var _this = _possibleConstructorReturn(this, (ModalChecklist.__proto__ || Object.getPrototypeOf(ModalChecklist)).call(this, props));
	
	        _this.zoomIn = function () {
	            _this.setState({
	                zoom: Math.min(3, _this.state.zoom + 0.2)
	            });
	        };
	
	        _this.zoomOut = function () {
	            if (_this.state.zoom <= 1.2) {
	                _this.resetView();
	            } else {
	                _this.setState({
	                    zoom: _this.state.zoom - 0.2
	                });
	            }
	        };
	
	        _this.resetView = function () {
	            _this.setState({
	                zoom: 1,
	                translateX: 0,
	                translateY: 0
	            });
	        };
	
	        _this.rotateLeft = function () {
	            _this.setState({
	                rotation: _this.state.rotation - 90,
	                zoom: 1,
	                translateX: 0,
	                translateY: 0
	            });
	        };
	
	        _this.rotateRight = function () {
	            _this.setState({
	                rotation: _this.state.rotation + 90,
	                zoom: 1,
	                translateX: 0,
	                translateY: 0
	            });
	        };
	
	        _this.handleMouseDown = function (e) {
	            if (_this.state.zoom === 1) return;
	            _this.setState({
	                dragging: true,
	                startX: e.clientX,
	                startY: e.clientY
	            });
	        };
	
	        _this.handleMouseMove = function (e) {
	            if (!_this.state.dragging) return;
	            var dx = e.clientX - _this.state.startX;
	            var dy = e.clientY - _this.state.startY;
	            _this.setState({
	                translateX: _this.state.translateX + dx,
	                translateY: _this.state.translateY + dy,
	                startX: e.clientX,
	                startY: e.clientY
	            });
	        };
	
	        _this.handleMouseUp = function () {
	            _this.setState({ dragging: false });
	        };
	
	        _this.state = {
	            zoom: 1,
	            rotation: 0,
	            translateX: 0,
	            translateY: 0,
	            dragging: false,
	            startX: 0,
	            startY: 0
	        };
	        return _this;
	    }
	
	    _createClass(ModalChecklist, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.checklist(this.props.idInventario);
	        }
	        /* ================= ZOOM (SOLO BOTONES) ================= */
	
	        /* ================= ROTACIÓN (SIN CORTE) ================= */
	
	        /* ================= DRAG ================= */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var indicator = this.props.id_file.find(function (ind) {
	                return ind.inv == _this2.props.idInventario;
	            });
	            return _react2.default.createElement(
	                _Modal2.default,
	                {
	                    show: this.props.showModal,
	                    onHide: this.props.cancelModal,
	                    bsSize: 'large'
	                },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Checklist Inventario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                width: '100%',
	                                height: '70vh',
	                                display: 'flex',
	                                alignItems: 'center',
	                                justifyContent: 'center',
	                                backgroundColor: '#f5f5f5',
	                                overflow: 'hidden',
	                                cursor: this.state.zoom > 1 ? 'grab' : 'default'
	                            },
	                            onMouseMove: this.handleMouseMove,
	                            onMouseUp: this.handleMouseUp,
	                            onMouseLeave: this.handleMouseUp
	                        },
	                        _react2.default.createElement('img', {
	                            src: this.props.indicators,
	                            alt: 'Checklist',
	                            onMouseDown: this.handleMouseDown,
	                            draggable: false,
	                            style: {
	                                maxWidth: '100%',
	                                maxHeight: '100%',
	                                objectFit: 'contain',
	                                transform: 'translate(' + this.state.translateX + 'px, ' + this.state.translateY + 'px) ' + 'scale(' + this.state.zoom + ') rotate(' + this.state.rotation + 'deg)',
	                                transformOrigin: 'center center',
	                                transition: this.state.dragging ? 'none' : 'transform 0.25s ease'
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: this.rotateLeft },
	                        'Girar \u27F2'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: this.rotateRight },
	                        'Girar \u27F3'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: this.zoomOut },
	                        'Zoom -'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: this.zoomIn },
	                        'Zoom +'
	                    ),
	                    indicator ? _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'btn btn-primary',
	                            href: '/inventario/archivo-final/' + indicator.indicator.id_file + '/descargar-checklist',
	                            target: '_blank',
	                            rel: 'noopener noreferrer'
	                        },
	                        'Descargar Checklist'
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return ModalChecklist;
	}(_react2.default.Component);
	
	exports.default = ModalChecklist;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalChecklist.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaAuditoriaSemanal = __webpack_require__(615);
	
	var css = _interopRequireWildcard(_TablaAuditoriaSemanal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReporteRuta = function (_React$Component) {
	    _inherits(ReporteRuta, _React$Component);
	
	    function ReporteRuta(props) {
	        _classCallCheck(this, ReporteRuta);
	
	        var _this = _possibleConstructorReturn(this, (ReporteRuta.__proto__ || Object.getPrototypeOf(ReporteRuta)).call(this, props));
	
	        _this.state = {
	            visible: false,
	            data: {},
	            estado: 0
	        };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ReporteRuta, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _v2.default.auditoria.getRutaInicioAuditores(this.props.fechaInicio.format('YYYY-MM-DD')).then(function (response) {
	                _this2.setState({
	                    data: response.auditores,
	                    estado: response.estado
	                });
	            }).catch(function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _this3 = this;
	
	            if (this.props.fechaInicio.format('YYYY-MM-DD') !== prevProps.fechaInicio.format('YYYY-MM-DD')) {
	                _v2.default.auditoria.getRutaInicioAuditores(this.props.fechaInicio.format('YYYY-MM-DD')).then(function (response) {
	                    _this3.setState({
	                        data: response.auditores,
	                        estado: response.estado
	                    });
	                }).catch(function (error) {
	                    console.log(error);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var color = this.state.estado == 2 ? "btn btn-success btn-xs" : this.state.estado == 1 ? "btn btn-warning btn-xs" : "btn btn-danger btn-xs";
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { className: color, onClick: this.show, style: { margin: '15px', alignSelf: 'center' } },
	                    'Reporte Ruta'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: this.state.visible, onHide: this.hide, bsSize: 'large' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: "flex", gap: "12px", alignItems: "center" } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Reporte Inicio de Ruta Auditores, d\xEDa ',
	                                    this.props.fechaInicio.format('dddd DD MMMM YYYY')
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table' },
	                            _react2.default.createElement(
	                                'thead',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Auditor'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Estado'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Hora Inicio'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Locales Pendientes'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                Object.entries(this.state.data).map(function (_ref) {
	                                    var _ref2 = _slicedToArray(_ref, 2),
	                                        auditor = _ref2[0],
	                                        info = _ref2[1];
	
	                                    return _react2.default.createElement(
	                                        'tr',
	                                        { key: auditor },
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center' } },
	                                            auditor
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center' } },
	                                            info.estado
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center' } },
	                                            info.muestras[0] ? info.muestras[0].ird : null
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            info.pendientes.map(function (dato, index) {
	                                                return _react2.default.createElement(
	                                                    'p',
	                                                    { key: index, style: { fontSize: '12px' } },
	                                                    dato.cliente,
	                                                    ' - ',
	                                                    dato.ceco,
	                                                    ' - ',
	                                                    dato.local
	                                                );
	                                            })
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReporteRuta;
	}(_react2.default.Component);
	
	exports.default = ReporteRuta;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ReporteRuta.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"TablaAuditoriaSemanal__tableFixed___36wWT","trSeparador":"TablaAuditoriaSemanal__trSeparador___1GFI6","thCorrelativo":"TablaAuditoriaSemanal__thCorrelativo___11bpc","tdCorrelativo":"TablaAuditoriaSemanal__tdCorrelativo___2mmeO","thCorrelativo2":"TablaAuditoriaSemanal__thCorrelativo2___ayOcc","tdCorrelativo2":"TablaAuditoriaSemanal__tdCorrelativo2___1nczf","thFecha":"TablaAuditoriaSemanal__thFecha___3NUPD","tdFecha":"TablaAuditoriaSemanal__tdFecha___1Lx5i","thCliente":"TablaAuditoriaSemanal__thCliente___2KFbs","tdCliente":"TablaAuditoriaSemanal__tdCliente___1MaTK","thCeco":"TablaAuditoriaSemanal__thCeco___YcPo_","tdCeco":"TablaAuditoriaSemanal__tdCeco___L392I","thRegion":"TablaAuditoriaSemanal__thRegion___2ue6l","tdRegion":"TablaAuditoriaSemanal__tdRegion___788a3","thComuna":"TablaAuditoriaSemanal__thComuna___2LhsM","tdComuna":"TablaAuditoriaSemanal__tdComuna___1y8ed","thTurno":"TablaAuditoriaSemanal__thTurno___2iD1h","tdTurno":"TablaAuditoriaSemanal__tdTurno___F-6WN","thTienda":"TablaAuditoriaSemanal__thTienda___6BjW1","tdTienda":"TablaAuditoriaSemanal__tdTienda___1rmMs","thStock":"TablaAuditoriaSemanal__thStock___1FGqF","tdStock":"TablaAuditoriaSemanal__tdStock___cd__n","thCantidadMuestra":"TablaAuditoriaSemanal__thCantidadMuestra___2poNf","tdCantidadMuestra":"TablaAuditoriaSemanal__tdCantidadMuestra___3-_Ja","thNomina":"TablaAuditoriaSemanal__thNomina___346tF","tdNomina":"TablaAuditoriaSemanal__tdNomina___11CUo","thDotacionTotal":"TablaAuditoriaSemanal__thDotacionTotal___2qy6O","tdDotacionTotal":"TablaAuditoriaSemanal__tdDotacionTotal___2hucK","thAuditor":"TablaAuditoriaSemanal__thAuditor___2dplF","tdAuditor":"TablaAuditoriaSemanal__tdAuditor___2f7V2","thFechaInformada":"TablaAuditoriaSemanal__thFechaInformada___EXFfp","tdFechaInformada":"TablaAuditoriaSemanal__tdFechaInformada___2K30p","thRevisada":"TablaAuditoriaSemanal__thRevisada___35ssZ","tdRevisada":"TablaAuditoriaSemanal__tdRevisada___2VGjq","thDotacion":"TablaAuditoriaSemanal__thDotacion___29M07","tdDotacion":"TablaAuditoriaSemanal__tdDotacion___2pJYX","thAperturaCierre":"TablaAuditoriaSemanal__thAperturaCierre___2higF","tdAperturaCierre":"TablaAuditoriaSemanal__tdAperturaCierre___2baU-","thDireccion":"TablaAuditoriaSemanal__thDireccion___1DLFz","tdDireccion":"TablaAuditoriaSemanal__tdDireccion___meff0","thSuspendido":"TablaAuditoriaSemanal__thSuspendido___1V3kt","tdSuspendido":"TablaAuditoriaSemanal__tdSuspendido___3__NO","thObservaciones":"TablaAuditoriaSemanal__thObservaciones___oRhPv","tdObservaciones":"TablaAuditoriaSemanal__tdObservaciones___3txhH","thObservacionesCalidad":"TablaAuditoriaSemanal__thObservacionesCalidad___Ky3Bl","tdObservacionesCalidad":"TablaAuditoriaSemanal__tdObservacionesCalidad___1hT2a","thObservacionesCliente":"TablaAuditoriaSemanal__thObservacionesCliente___3vMFB","tdObservacionesCliente":"TablaAuditoriaSemanal__tdObservacionesCliente___1rD83","thLink":"TablaAuditoriaSemanal__thLink___1zrAs","tdLink":"TablaAuditoriaSemanal__tdLink___37_SG","thDescargaIrd":"TablaAuditoriaSemanal__thDescargaIrd___1s97X","tdDescargaIrd":"TablaAuditoriaSemanal__tdDescargaIrd___nE17j","thOpciones":"TablaAuditoriaSemanal__thOpciones___3efzL","tdOpciones":"TablaAuditoriaSemanal__tdOpciones___dsKjo","textoConTooltip":"TablaAuditoriaSemanal__textoConTooltip___1TUld","thArchivoFinal":"TablaAuditoriaSemanal__thArchivoFinal___168g-","tdArchivoFinal":"TablaAuditoriaSemanal__tdArchivoFinal___1JaYG"};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalInventarios = function (_React$Component) {
	    _inherits(ModalInventarios, _React$Component);
	
	    function ModalInventarios(props) {
	        _classCallCheck(this, ModalInventarios);
	
	        var _this = _possibleConstructorReturn(this, (ModalInventarios.__proto__ || Object.getPrototypeOf(ModalInventarios)).call(this, props));
	
	        _this.state = {
	            visible: false,
	            data: null
	        };
	
	        _this.show = function () {
	            _this.setState({ visible: true }, function () {
	                if (!_this.state.data || Object.keys(_this.state.data).length === 0) {
	                    _v2.default.inventario.obtenerDetalles().then(function (response) {
	                        _this.setState({
	                            data: response
	                        });
	                    }).catch(function (error) {
	                        console.log(error);
	                    });
	                }
	            });
	        };
	
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalInventarios, [{
	        key: 'render',
	        value: function render() {
	            var totalCantidad = 0;
	            var totalUnidades = 0;
	            var promedioDotMin = 0;
	            var promedioDot = 0;
	            var promedioDotMax = 0;
	            var promedioCont = 0;
	            var index = 0;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-info btn-xs', onClick: this.show, style: { marginTop: '15px', marginBottom: '15px', alignSelf: 'center', marginLeft: '5px', marginRight: '5px' } },
	                    'Servicios IG'
	                ),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { show: this.state.visible, onHide: this.hide, bsSize: 'lg', style: { maxHeight: '100vh', overflowY: 'auto' } },
	                    _react2.default.createElement(
	                        _Modal2.default.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _Modal2.default.Title,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: "flex", gap: "12px", alignItems: "center" } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Servicios IG (hasta el',
	                                    ' ',
	                                    this.props.hoy.format('D [de] MMMM, YYYY'),
	                                    ')'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Modal2.default.Body,
	                        null,
	                        this.state.data && Object.keys(this.state.data).length > 0 ? _react2.default.createElement(
	                            'table',
	                            { className: 'table' },
	                            _react2.default.createElement(
	                                'thead',
	                                { style: { position: 'sticky', top: '0px', zIndex: '1', backgroundColor: '#bde7ff' } },
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Regiones'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Cantidad IG'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Unidades Contadas'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Dotaci\xF3n M\xEDnima'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Dotaci\xF3n Promedio'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Dotaci\xF3n M\xE1xima'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                        'Promedio Conteo/Hora'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                Object.entries(this.state.data).map(function (_ref) {
	                                    var _ref2 = _slicedToArray(_ref, 2),
	                                        region = _ref2[0],
	                                        info = _ref2[1];
	
	                                    totalCantidad += Number(info.total_inventarios);
	                                    totalUnidades += Number(info.total_unidades);
	                                    promedioDotMin += Number(info.dotacion_minima);
	                                    promedioDot += Number(info.dotacion_promedio);
	                                    promedioDotMax += Number(info.dotacion_maxima);
	                                    promedioCont += Number(info.promedio_conteo_hora);
	                                    var fondo = index % 2 == 0 ? "white" : "#f5f5f5";
	                                    index++;
	                                    return _react2.default.createElement(
	                                        'tr',
	                                        { key: index, style: { backgroundColor: fondo } },
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'left', fontSize: 'small' } },
	                                            region
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Number(info.total_inventarios).toLocaleString('de-DE')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Number(info.total_unidades).toLocaleString('de-DE')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Number(info.dotacion_minima).toLocaleString('de-DE')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Math.round(Number(info.dotacion_promedio)).toLocaleString('de-DE')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Number(info.dotacion_maxima).toLocaleString('de-DE')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { alignContent: 'center', textAlign: 'center', fontSize: 'small' } },
	                                            Math.round(Number(info.promedio_conteo_hora)).toLocaleString('de-DE')
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'tfoot',
	                                { style: { position: 'sticky', bottom: '0px', zIndex: '1', backgroundColor: '#bde7ff' } },
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        'TOTALES'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        totalCantidad.toLocaleString('de-DE')
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        totalUnidades.toLocaleString('de-DE')
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        Math.round(promedioDotMin / Object.keys(this.state.data).length).toLocaleString('de-DE')
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        Math.round(promedioDot / Object.keys(this.state.data).length).toLocaleString('de-DE')
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        Math.round(promedioDotMax / Object.keys(this.state.data).length).toLocaleString('de-DE')
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        { style: { alignContent: 'center', textAlign: 'center', fontWeight: 'bold' } },
	                                        Math.round(promedioCont / Object.keys(this.state.data).length).toLocaleString('de-DE')
	                                    )
	                                )
	                            )
	                        ) : null
	                    ),
	                    _react2.default.createElement(_Modal2.default.Footer, null)
	                )
	            );
	        }
	    }]);
	
	    return ModalInventarios;
	}(_react2.default.Component);
	
	exports.default = ModalInventarios;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ModalInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _BlackBoxMensual = __webpack_require__(618);
	
	var _BlackBoxMensual2 = _interopRequireDefault(_BlackBoxMensual);
	
	var _TablaMensual = __webpack_require__(620);
	
	var _TablaMensual2 = _interopRequireDefault(_TablaMensual);
	
	var _AgregarInventario = __webpack_require__(630);
	
	var _AgregarInventario2 = _interopRequireDefault(_AgregarInventario);
	
	var _RowInventarioMensual = __webpack_require__(632);
	
	var _RowInventarioMensual2 = _interopRequireDefault(_RowInventarioMensual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	
	_moment2.default.locale('es');
	
	// Component
	
	var ProgramacionIGMensual = function (_React$Component) {
	    _inherits(ProgramacionIGMensual, _React$Component);
	
	    function ProgramacionIGMensual(props) {
	        _classCallCheck(this, ProgramacionIGMensual);
	
	        var _this = _possibleConstructorReturn(this, (ProgramacionIGMensual.__proto__ || Object.getPrototypeOf(ProgramacionIGMensual)).call(this, props));
	
	        _this.blackbox = new _BlackBoxMensual2.default(_this.props.clientes);
	
	        // mostrar en el selector, los proximos 12 meses
	        var meses = [];
	        var desface = -1;
	        for (desface; desface < 12; desface++) {
	            var mes = (0, _moment2.default)().add(desface, 'month');
	            meses.push({
	                valor: mes.format('YYYY-MM-00'),
	                texto: mes.format('MMMM  YYYY')
	            });
	        }
	        _this.state = {
	            meses: meses,
	            inventariosFiltrados: [],
	            filtros: {},
	            loading: false,
	            estados: []
	
	            // referencia a todos las entradas de fecha de los inventarios
	        };_this.rows = [];
	        return _this;
	    }
	
	    _createClass(ProgramacionIGMensual, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
	            this.rows = this.rows.filter(function (input) {
	                return input !== null;
	            });
	        }
	    }, {
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length - 1;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(nombreElemento);
	            } else if (index > ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero
	                this.rows[index % this.rows.length].focusElemento(nombreElemento);
	            } else {
	                // no es ni el ultimo, ni el primero
	                this.rows[index].focusElemento(nombreElemento);
	            }
	        }
	
	        // #### Agregar Inventarios 
	
	    }, {
	        key: 'crearGrupoInventarios',
	        value: function crearGrupoInventarios(nuevosInventarios) {
	            var _this2 = this;
	
	            var promesasFetch = [];
	            nuevosInventarios.forEach(function (nuevoInventario) {
	                // crear todos los locales (y sus nominas)
	
	                promesasFetch.push(_v2.default.inventario.nuevo({
	                    idLocal: nuevoInventario.local_idLocal,
	                    fechaProgramada: _this2.refFormularioAgregar.getOpcionesSeleccionadas().mes
	                }).then(function (inventarioCreado) {
	                    _this2.blackbox.actualizarDatosInventario(nuevoInventario.idDummy, inventarioCreado);
	                    // actualizar los datos y el state de la app
	                    // actualizar los filtros, y la lista ordenada de locales
	                    // this.setState(this.blackbox.getListaFiltradaSinOrdenar())
	                    _this2.setState(_this2.blackbox.getListaFiltrada());
	                }));
	            });
	            // en algun momento las promesas se van a cumplior, entonces actualizar el estado
	            Promise.all(promesasFetch).then(function (locales) {
	                console.log('fetch de todos los locales correcto');
	                // actualizar los filtros, y la lista ordenada de locales
	                _this2.setState(_this2.blackbox.getListaFiltrada());
	            }).catch(function (datos) {
	                // Todo: agregar bluebird para que esto no ocurra nunca
	                // todo, al fallar UNA promesa, no se cumple el resto
	                alert('error al buscar la información de los locales, (AgregarGrupoInventarios desde Excel: fetch de todos los locales correcto)');
	                // actualizar los filtros, y la lista ordenada de locales
	                _this2.setState(_this2.blackbox.getListaFiltrada());
	            });
	        }
	    }, {
	        key: 'agregarInventario',
	        value: function agregarInventario(idCliente, numeroLocal, annoMesDia) {
	            var _this3 = this;
	
	            var _blackbox$crearDummy = this.blackbox.crearDummy(idCliente, numeroLocal, annoMesDia),
	                _blackbox$crearDummy2 = _slicedToArray(_blackbox$crearDummy, 2),
	                errores = _blackbox$crearDummy2[0],
	                nuevoInventario = _blackbox$crearDummy2[1];
	
	            if (errores) return [errores, {}];
	
	            // agregar al listado
	            this.blackbox.addNuevo(nuevoInventario);
	
	            // actualizar la vista de la lista
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	
	            // cuando se agregar un inventario, se crea automaticamente (junto a su nomina)
	            _v2.default.inventario.nuevo({
	                idLocal: nuevoInventario.local_idLocal,
	                fechaProgramada: this.refFormularioAgregar.getOpcionesSeleccionadas().mes
	            }).then(function (inventarioCreado) {
	                _this3.blackbox.actualizarDatosInventario(nuevoInventario.idDummy, inventarioCreado);
	                // actualizar los datos y el state de la app
	                // actualizar los filtros, y la lista ordenada de locales
	                // this.setState(this.blackbox.getListaFiltradaSinOrdenar())
	                _this3.setState(_this3.blackbox.getListaFiltrada());
	            });
	            return [null, {}];
	        }
	        // Lista de inventarios que son "pegados desde excel"
	
	    }, {
	        key: 'agregarGrupoInventarios',
	        value: function agregarGrupoInventarios(idCliente, numerosLocales, annoMesDia) {
	            var _this4 = this;
	
	            console.log(numerosLocales);
	            var pegadoConProblemas = [];
	            // se evalua y agrega cada uno de los elementos
	            var nuevosInventarios = [];
	            numerosLocales.forEach(function (numero) {
	                var _blackbox$crearDummy3 = _this4.blackbox.crearDummy(idCliente, numero, annoMesDia),
	                    _blackbox$crearDummy4 = _slicedToArray(_blackbox$crearDummy3, 2),
	                    errores = _blackbox$crearDummy4[0],
	                    nuevoInventario = _blackbox$crearDummy4[1];
	
	                if (errores) {
	                    pegadoConProblemas.push(errores);
	                } else {
	                    // this.blackbox.addNuevo(nuevoInventario)
	                    nuevosInventarios.push(nuevoInventario);
	                }
	            });
	            // agregar el grupo completo de una vez (para hacer un poco mas rapido el proceso)
	            this.blackbox.addNuevos(nuevosInventarios);
	
	            // cuando terminen todos, se actualiza el state de la aplicacion
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	            this.crearGrupoInventarios(nuevosInventarios);
	
	            return {
	                pegadoConProblemas: pegadoConProblemas,
	                conteoTotal: numerosLocales.length,
	                conteoCorrectos: numerosLocales.length - pegadoConProblemas.length,
	                conteoProblemas: pegadoConProblemas.length
	            };
	        }
	
	        // #### Filtros
	
	    }, {
	        key: 'ordenarInventarios',
	        value: function ordenarInventarios(evt) {
	            evt.preventDefault();
	            this.blackbox.ordenarLista();
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'actualizarFiltro',
	        value: function actualizarFiltro(nombreFiltro, filtro) {
	            this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	
	        // #### Llamadas al API
	
	    }, {
	        key: 'buscarInventarios',
	        value: function buscarInventarios(annoMesDia, idCliente) {
	            var _this5 = this;
	
	            this.setState({
	                loading: true
	            });
	            _v2.default.inventario.getPorMesYCliente(annoMesDia, idCliente).then(function (inventarios) {
	                _this5.blackbox.reset();
	                inventarios.forEach(function (inventario) {
	                    // crear un dummy
	                    var nuevoInventario = _this5.blackbox.__crearDummy(annoMesDia, inventario.local_idLocal);
	                    _this5.blackbox.addFinal(nuevoInventario);
	
	                    // actualizar los datos del inventario
	                    _this5.blackbox.actualizarDatosInventario(nuevoInventario.idDummy, inventario);
	                });
	                // actualizar los filtros, y la lista ordenada de locales
	                _this5.blackbox.ordenarLista();
	                _this5.setState(_extends({}, _this5.blackbox.getListaFiltrada(), {
	                    loading: false
	                }));
	            });
	            //.catch(err=>console.error('error: ', err))
	        }
	    }, {
	        key: 'getEstadosInventarios',
	        value: function getEstadosInventarios() {
	            var _this6 = this;
	
	            _v2.default.inventario.estadosInventarios().then(function (data) {
	                _this6.setState({
	                    estados: data
	                });
	            });
	        }
	    }, {
	        key: 'updateEstadoInventario',
	        value: function updateEstadoInventario(idInventario, idEstado) {
	            var _this7 = this;
	
	            _v2.default.inventario.updateEstado(idInventario, idEstado).then(function (inventario) {
	                _this7.blackbox.updateDatosInventario(inventario);
	                _this7.setState(_this7.blackbox.getListaFiltrada());
	            });
	        }
	    }, {
	        key: 'actualizarInventario',
	        value: function actualizarInventario(idInventario, formInventario, idDummy) {
	            var _this8 = this;
	
	            // Actualizar los datos del inventario
	            _v2.default.inventario.actualizarIgMensual(idInventario, formInventario).then(function (inventarioActualizado) {
	                console.log('inventario actualizado correctamente');
	                // actualizar los datos y el state de la app
	                _this8.blackbox.actualizarDatosInventario(idDummy, inventarioActualizado);
	                // actualizar los filtros, y la lista ordenada de locales
	                _this8.setState(_this8.blackbox.getListaFiltrada());
	            });
	        }
	    }, {
	        key: 'quitarInventario',
	        value: function quitarInventario(idDummy) {
	            this.blackbox.remove(idDummy);
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'eliminarInventario',
	        value: function eliminarInventario(inventario) {
	            var _this9 = this;
	
	            _v2.default.inventario.eliminar(inventario.inv_idInventario).then(function (resp) {
	                _this9.blackbox.remove(inventario.idDummy);
	                // actualizar los filtros, y la lista ordenada de locales
	                _this9.setState(_this9.blackbox.getListaFiltrada());
	            }).catch(function (err) {
	                if (err.status == 410) {
	                    alert('Este inventario ha sido completado, no puede ser eliminado');
	                    console.log(err);
	                }
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.getEstadosInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this10 = this;
	
	            // refFormularioAgregar no esta definido antes del render
	            var opcionesSeleccionadas = this.refFormularioAgregar ? this.refFormularioAgregar.getOpcionesSeleccionadas() : {};
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Programaci\xF3n mensual IG'
	                ),
	                _react2.default.createElement(_AgregarInventario2.default, {
	                    ref: function ref(_ref) {
	                        return _this10.refFormularioAgregar = _ref;
	                    },
	                    puedeAgregar: this.props.puedeAgregar,
	                    clientes: this.props.clientes,
	                    meses: this.state.meses,
	                    agregarInventario: this.agregarInventario.bind(this),
	                    agregarGrupoInventarios: this.agregarGrupoInventarios.bind(this),
	                    buscarAuditorias: this.buscarInventarios.bind(this)
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs pull-right',
	                            href: '/inventarios/descargar-excel-por-mes?mes=' + opcionesSeleccionadas.mes + '&cliente=' + opcionesSeleccionadas.idCliente
	                        },
	                        'Exportar'
	                    ),
	                    _react2.default.createElement(
	                        _TablaMensual2.default,
	                        {
	                            filtros: this.state.filtros,
	                            actualizarFiltro: this.actualizarFiltro.bind(this),
	                            ordenarInventarios: this.ordenarInventarios.bind(this) },
	                        this.state.loading ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '11', style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Cargando...'
	                                )
	                            )
	                        ) : this.state.inventariosFiltrados.length === 0 ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '11', style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'No hay inventarios para mostrar en este periodo.'
	                                )
	                            )
	                        ) : this.state.inventariosFiltrados.map(function (inventario, index) {
	                            var mostrarSeparador = false;
	                            var sgteInventario = _this10.state.inventariosFiltrados[index + 1];
	                            if (sgteInventario) mostrarSeparador = inventario.inv_fechaProgramada !== sgteInventario.inv_fechaProgramada;
	                            return _react2.default.createElement(_RowInventarioMensual2.default
	                            // Propiedades
	                            , { estados: _this10.state.estados,
	                                puedeModificar: _this10.props.puedeModificar,
	                                key: inventario.inv_idInventario || '_dum_' + inventario.idDummy,
	                                index: index,
	                                ref: function ref(_ref2) {
	                                    return _this10.rows[index] = _ref2;
	                                },
	                                inventario: inventario,
	                                mostrarSeparador: mostrarSeparador
	                                // Metodos
	                                , focusRow: _this10.focusRow.bind(_this10),
	                                actualizarInventario: _this10.actualizarInventario.bind(_this10),
	                                quitarInventario: _this10.quitarInventario.bind(_this10),
	                                eliminarInventario: _this10.eliminarInventario.bind(_this10),
	                                updateEstadoInventario: _this10.updateEstadoInventario.bind(_this10)
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProgramacionIGMensual;
	}(_react2.default.Component);
	
	ProgramacionIGMensual.propTypes = {
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    puedeAgregar: _react2.default.PropTypes.bool.isRequired,
	    clientes: _react2.default.PropTypes.array.isRequired
	};
	
	exports.default = ProgramacionIGMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ProgramacionIGMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBox = function () {
	    function BlackBox(clientes) {
	        _classCallCheck(this, BlackBox);
	
	        this.clientes = clientes;
	        this.lista = [];
	        this.filtroFechas = [];
	        this.filtroCeco = [];
	        this.filtroRegiones = [];
	        this.filtroComunas = [];
	        this.idDummy = 1; // valor unico, sirve para identificar un dummy cuando un idInventario no ha sido fijado
	    }
	    // Todo Modificar
	
	
	    _createClass(BlackBox, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroFechas = [];
	            this.filtroCeco = [];
	            this.filtroRegiones = [];
	            this.filtroComunas = [];
	            this.idDummy = 1;
	        }
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'addNuevo',
	        value: function addNuevo(inventario) {
	            // al agregar un elemento unico, se debe ubicar: DESPUES de los inventarios sin fecha, y ANTES que los inventarios con fecha
	            // buscar el indice del primer inventario con fecha
	            var indexConFecha = this.lista.findIndex(function (inv) {
	                var dia = inv.inv_fechaProgramada.split('-')[2];
	                return dia !== '00';
	            });
	            if (indexConFecha >= 0) {
	                // se encontro el indice
	                this.lista.splice(indexConFecha, 0, inventario);
	            } else {
	                // no hay ninguno con fecha, agregar al final
	                this.lista.push(inventario);
	            }
	        }
	        // igual que el anterior, pero con un arreglo
	
	    }, {
	        key: 'addNuevos',
	        value: function addNuevos(inventarios) {
	            // al agregar un elemento unico, se debe ubicar: DESPUES de los inventarios sin fecha, y ANTES que los inventarios con fecha
	            // buscar el indice del primer inventario con fecha
	            var indexConFecha = this.lista.findIndex(function (inv) {
	                var dia = inv.inv_fechaProgramada.split('-')[2];
	                return dia !== '00';
	            });
	            if (indexConFecha >= 0) {
	                var _lista;
	
	                // se encontro el indice
	                (_lista = this.lista).splice.apply(_lista, [indexConFecha, 0].concat(_toConsumableArray(inventarios)));
	            } else {
	                // no hay ninguno con fecha, agregar al final
	                this.lista = this.lista.concat(inventarios);
	            }
	        }
	    }, {
	        key: 'addInicio',
	        value: function addInicio(inventario) {
	            // unshift agrega un elemento al inicio del array
	            this.lista.unshift(inventario);
	        }
	    }, {
	        key: 'addFinal',
	        value: function addFinal(inventario) {
	            this.lista.push(inventario);
	        }
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'remove',
	        value: function remove(idDummy) {
	            var index = this.lista.findIndex(function (inventario) {
	                return inventario.idDummy === idDummy;
	            });
	            if (index >= 0) this.lista.splice(index, 1);
	        }
	    }, {
	        key: 'yaExiste',
	        value: function yaExiste(idLocal, annoMesDia) {
	            var inventariosDelLocal = this.lista.filter(function (inventario) {
	                return inventario.idLocal === idLocal;
	            });
	            // buscar si se tiene inventarios para este local
	            if (inventariosDelLocal.length === 0) {
	                return false;
	            }
	            // buscar si alguna fecha coincide
	            var existe = false;
	            inventariosDelLocal.forEach(function (inventario) {
	                if (inventario.fechaProgramada === annoMesDia) {
	                    // se tiene el mismo local, con la misma fecha inventariado
	                    console.log('ya programado');
	                    existe = true;
	                    return true;
	                }
	            });
	            return existe;
	        }
	
	        // Metodos de alto nivel
	
	    }, {
	        key: '__crearDummy',
	        value: function __crearDummy(annoMesDia, idLocal) {
	            return {
	                idDummy: this.idDummy++, // asignar e incrementar
	                inv_idInventario: null,
	                local_idLocal: idLocal,
	                local_ceco: '-',
	                local_nombre: '',
	                inv_fechaProgramada: annoMesDia,
	                inv_stockTeorico: '0'
	            };
	        }
	    }, {
	        key: 'crearDummy',
	        value: function crearDummy(idCliente, numeroLocal, annoMesDia) {
	            // ########### Revisar Cliente ###########
	            // el usuario no selecciono uno en el formulario
	            if (idCliente === '-1' || idCliente === '' || !idCliente) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorIdCliente: 'Seleccione un Cliente'
	                }, null];
	            }
	            // dio un idCliente, pero no existe
	            var cliente = this.clientes.find(function (cliente) {
	                return cliente.idCliente == idCliente;
	            });
	            if (!cliente) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorIdCliente: 'Cliente no Existe'
	                }, null];
	            }
	
	            // ########### Revisar Local ###########
	            // revisar que el local exista
	            var local = cliente.locales.find(function (local) {
	                return local.numero == numeroLocal;
	            });
	            if (local === undefined) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorNumeroLocal: numeroLocal === '' ? 'Digite un numero de local.' : 'El local \'' + numeroLocal + '\' no existe.'
	                }, null];
	            }
	
	            // revisar que no exista en la lista
	            if (this.yaExiste(local.idLocal, annoMesDia)) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorNumeroLocal: numeroLocal + ' ya ha sido agendado esa fecha.'
	                }, null];
	            }
	
	            // ########### ok, se puede crear el inventario "vacio" ###########
	            var dummy = this.__crearDummy(annoMesDia, local.idLocal);
	            console.log(annoMesDia, numeroLocal, local, dummy);
	            return [null, dummy];
	        }
	
	        // Todo modificar el listado de clientes
	
	    }, {
	        key: 'actualizarDatosLocal',
	        value: function actualizarDatosLocal(local) {
	            // actualizar los datos del local de todos los inventarios que lo tengan
	            this.lista = this.lista.map(function (inventario) {
	                if (inventario.local.idLocal == local.idLocal) {
	
	                    inventario.local = Object.assign(inventario.local, local);
	                    // si no hay una dotacion asignada, ver la sugerida
	                    if (inventario.dotacionAsignada === null) {
	                        inventario.dotacionAsignada = local.dotacionSugerida;
	                    }
	                }
	                return inventario;
	            });
	            this.actualizarFiltros();
	        }
	        // Todo modificar el listado de clientes
	
	    }, {
	        key: 'actualizarDatosInventario',
	        value: function actualizarDatosInventario(idDummy, inventarioActualizado) {
	            this.lista = this.lista.map(function (inventario) {
	                if (inventario.idDummy == idDummy) {
	                    inventario = Object.assign(inventario, inventarioActualizado);
	                }
	                return inventario;
	            });
	        }
	    }, {
	        key: 'updateDatosInventario',
	        value: function updateDatosInventario(inventarioActualizado) {
	            this.lista = this.lista.map(function (inventario) {
	                if (inventarioActualizado.inv_idInventario == inventario.inv_idInventario) {
	                    return inventarioActualizado;
	                }
	                return inventario;
	            });
	        }
	
	        /*** ################### FILTROS ################### ***/
	
	    }, {
	        key: 'ordenarLista',
	        value: function ordenarLista() {
	            var porFechaProgramada = function porFechaProgramada(inventario) {
	                var dateA = new Date(inventario.inv_fechaProgramada);
	                if (dateA == 'Invalid Date') {
	                    var _inventario$inv_fecha = inventario.inv_fechaProgramada.split('-'),
	                        _inventario$inv_fecha2 = _slicedToArray(_inventario$inv_fecha, 3),
	                        annoA = _inventario$inv_fecha2[0],
	                        mesA = _inventario$inv_fecha2[1],
	                        diaA = _inventario$inv_fecha2[2];
	                    // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
	
	
	                    return new Date(annoA + '-' + mesA) - 1;
	                } else {
	                    return dateA;
	                }
	            };
	            var porCliente = function porCliente(inventario) {
	                return inventario.cliente_idCliente;
	            };
	            var porStockTeorico = function porStockTeorico(inventario) {
	                return inventario.inv_stockTeorico;
	            };
	
	            // ordenar por fechaprogramada, por stock teorico
	            this.lista = _lodash2.default.orderBy(this.lista, [porFechaProgramada, porCliente, porStockTeorico], ['asc', 'asc', 'desc']);
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            // ##### Filtro fechas
	            this.filtroFechas = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var momentFecha = (0, _moment2.default)(inventario.inv_fechaProgramada);
	                var valor = inventario.inv_fechaProgramada;
	                var texto = momentFecha.isValid() ? momentFecha.format('dddd DD MMMM') : '-- ' + inventario.inv_fechaProgramada + ' --';
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFechas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro CECO (ordenado por numero)
	            this.filtroCeco = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.local_ceco;
	                var texto = '' + auditoria.local_ceco;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCeco, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy(function (ob) {
	                return ob.valor.length;
	            }, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
	            .value();
	
	            // ##### Filtro Regiones (ordenado por codRegion)
	            this.filtroRegiones = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.local_cutRegion;
	                var texto = auditoria.local_region;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroRegiones, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de region
	            .value();
	
	            // ##### Filtro Comunas (ordenado por codComuna)
	            this.filtroComunas = _lodash2.default.chain(this.lista)
	            // solo dejar las comunas en las que su respectiva region este seleccionada
	            .filter(function (auditoria) {
	                return _lodash2.default.find(_this.filtroRegiones, { 'valor': auditoria.local_cutRegion, 'seleccionado': true });
	            }).map(function (auditoria) {
	                var valor = auditoria.local_cutComuna;
	                var texto = auditoria.local_comuna;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroComunas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	
	            return {
	                //inventariosFiltrados: this.lista,
	                inventariosFiltrados: _lodash2.default.chain(this.lista)
	                // Filtro por CECO
	                .filter(function (inventario) {
	                    return _lodash2.default.find(_this2.filtroCeco, { 'valor': '' + inventario.local_ceco, 'seleccionado': true });
	                })
	                // Filtro por Region
	                .filter(function (inventario) {
	                    return _lodash2.default.find(_this2.filtroRegiones, { 'valor': inventario.local_cutRegion, 'seleccionado': true });
	                })
	                // Filtro por Comuna
	                .filter(function (inventario) {
	                    return _lodash2.default.find(_this2.filtroComunas, { 'valor': inventario.local_cutComuna, 'seleccionado': true });
	                })
	                // Filtrar por Fecha (dejar de lo ultimo, ya que es la mas lenta -comparacion de strings- y la menos utilizada)
	                .filter(function (inventario) {
	                    return _lodash2.default.find(_this2.filtroFechas, { 'valor': inventario.inv_fechaProgramada, 'seleccionado': true });
	                }).value(),
	                filtros: {
	                    filtroFechas: this.filtroFechas,
	                    filtroCeco: this.filtroCeco,
	                    //filtroClientes: this.filtroClientes,
	                    filtroRegiones: this.filtroRegiones,
	                    filtroComunas: this.filtroComunas
	                }
	            };
	        }
	    }]);
	
	    return BlackBox;
	}();
	
	exports.default = BlackBox;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxMensual.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(176)(module)))

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(626);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _TablaMensual = __webpack_require__(629);
	
	var css = _interopRequireWildcard(_TablaMensual);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var TablaMensual = function (_React$Component) {
	    _inherits(TablaMensual, _React$Component);
	
	    function TablaMensual() {
	        _classCallCheck(this, TablaMensual);
	
	        return _possibleConstructorReturn(this, (TablaMensual.__proto__ || Object.getPrototypeOf(TablaMensual)).apply(this, arguments));
	    }
	
	    _createClass(TablaMensual, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _container2.default,
	                { type: _react2.default.DOM.table, className: "table table-bordered table-condensed " + css.tableFixed },
	                _react2.default.createElement(
	                    'colgroup',
	                    null,
	                    _react2.default.createElement('col', { className: css.thCorrelativo }),
	                    _react2.default.createElement('col', { className: css.thEstadoInventario }),
	                    _react2.default.createElement('col', { className: css.thFecha }),
	                    _react2.default.createElement('col', { className: css.thCliente }),
	                    _react2.default.createElement('col', { className: css.thCeco }),
	                    _react2.default.createElement('col', { className: css.thLocal }),
	                    _react2.default.createElement('col', { className: css.thRegion }),
	                    _react2.default.createElement('col', { className: css.thComuna }),
	                    _react2.default.createElement('col', { className: css.thStock }),
	                    _react2.default.createElement('col', { className: css.thEspecial }),
	                    _react2.default.createElement('col', { className: css.thOpciones })
	                ),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        _sticky2.default,
	                        {
	                            topOffset: -50,
	                            type: _react2.default.DOM.tr,
	                            stickyStyle: { top: '50px' } },
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCorrelativo },
	                            '#'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thFecha },
	                            'Estado'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thFecha },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Fecha',
	                                filtro: this.props.filtros.filtroFechas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroFechas'),
	                                ordenarLista: this.props.ordenarInventarios
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCliente },
	                            'Cliente'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCeco },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'CE',
	                                filtro: this.props.filtros.filtroCeco || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroCeco'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thLocal },
	                            'Local'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thRegion },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Regi\xF3n',
	                                filtro: this.props.filtros.filtroRegiones || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroRegiones'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thComuna },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Comuna',
	                                filtro: this.props.filtros.filtroComunas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroComunas')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thStock },
	                            'Stock'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thComuna },
	                            'Especial / Facturable'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thOpciones },
	                            'Opciones'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return TablaMensual;
	}(_react2.default.Component);
	
	TablaMensual.propTypes = {
	    // Objetos
	    filtros: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.array).isRequired,
	    // Metodos
	    actualizarFiltro: _react2.default.PropTypes.func.isRequired,
	    ordenarInventarios: _react2.default.PropTypes.func.isRequired
	};
	exports.default = TablaMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _watcher = __webpack_require__(622);
	
	var _watcher2 = _interopRequireDefault(_watcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * https://github.com/captivationsoftware/react-sticky
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Sticky = function (_React$Component) {
	    _inherits(Sticky, _React$Component);
	
	    function Sticky(props) {
	        _classCallCheck(this, Sticky);
	
	        var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /*
	     * Anytime new props are received, force re-evaluation
	     */
	
	
	    _createClass(Sticky, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            var origin = this.calculateOrigin();
	            this.setState({ origin: origin });
	
	            _watcher2.default.emit();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _watcher2.default.on(this.transition.bind(this));
	
	            var origin = this.calculateOrigin();
	            this.setState({ origin: origin });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _watcher2.default.off(this.transition.bind(this));
	        }
	
	        /*
	         * Return the distance of the scrollbar from the
	         * top of the window plus the total height of all
	         * stuck Sticky instances above this one.
	         */
	
	    }, {
	        key: 'pageOffset',
	        value: function pageOffset() {
	            return window.pageYOffset || document.documentElement.scrollTop;
	        }
	    }, {
	        key: 'cumulativeTopCorrection',
	        value: function cumulativeTopCorrection() {
	            return this.context.container.state.cumulativeTopCorrection;
	        }
	
	        /*
	         * Returns true/false depending on if this should be sticky.
	         */
	
	    }, {
	        key: 'shouldBeSticky',
	        value: function shouldBeSticky() {
	            var offset = this.pageOffset();
	            var origin = this.state.origin - this.cumulativeTopCorrection();
	            var containerNode = _reactDom2.default.findDOMNode(this.context.container);
	
	            // check conditions
	            var stickyTopConditionsMet = offset >= origin + this.props.topOffset;
	            var stickyBottomConditionsMet = offset < containerNode.getBoundingClientRect().height + origin;
	            return stickyTopConditionsMet && stickyBottomConditionsMet;
	        }
	    }, {
	        key: 'transition',
	        value: function transition() {
	            if (this.context.container) {
	                this.nextState(this.shouldBeSticky());
	            }
	        }
	
	        /*
	         * Returns the y-coordinate of the top of this element.
	         */
	
	    }, {
	        key: 'calculateOrigin',
	        value: function calculateOrigin() {
	            //let node = React.findDOMNode(this);
	            var node = _reactDom2.default.findDOMNode(this);
	
	            // Do some ugly DOM manipulation to where this element's non-sticky position would be
	            var previousPosition = node.style.position;
	            node.style.position = '';
	            var origin = node.getBoundingClientRect().top + this.pageOffset();
	            node.style.position = previousPosition;
	            return origin;
	        }
	        /*
	         * If sticky, merge this.props.stickyStyle with this.props.style.
	         * If not, just return this.props.style.
	         */
	
	    }, {
	        key: 'nextStyle',
	        value: function nextStyle(shouldBeSticky) {
	            if (shouldBeSticky) {
	                var node = _reactDom2.default.findDOMNode(this);
	                var containerNode = _reactDom2.default.findDOMNode(this.context.container);
	
	                // inherit the boundaries of the container
	                var rect = containerNode.getBoundingClientRect();
	                var style = Object.assign({}, this.props.style);
	                style.position = 'fixed';
	                style.left = rect.left;
	                style.width = rect.width;
	                style.top = this.cumulativeTopCorrection();
	
	                var bottomLimit = rect.bottom - node.getBoundingClientRect().height;
	                if (style.top > bottomLimit) style.top = bottomLimit;
	
	                // Finally, override the best-fit style with any user props
	                return Object.assign(style, this.props.stickyStyle);
	            } else {
	                return this.props.style;
	            }
	        }
	
	        /*
	         * If sticky, merge this.props.stickyClass with this.props.className.
	         * If not, just return this.props.className.
	         */
	
	    }, {
	        key: 'nextClassName',
	        value: function nextClassName(shouldBeSticky) {
	            var className = this.props.className;
	            if (shouldBeSticky) {
	                className += ' ' + this.props.stickyClass;
	            }
	            return className;
	        }
	
	        /*
	         * Transition to the next state.
	         *
	         * Updates the isSticky, style, and className state
	         * variables.
	         *
	         * If sticky state is different than the previous,
	         * fire the onStickyStateChange callback.
	         */
	
	    }, {
	        key: 'nextState',
	        value: function nextState(shouldBeSticky) {
	            var hasChanged = this.state.isSticky !== shouldBeSticky;
	
	            // Update this state
	            this.setState({
	                isSticky: shouldBeSticky,
	                style: this.nextStyle(shouldBeSticky),
	                className: this.nextClassName(shouldBeSticky)
	            });
	
	            if (hasChanged) {
	                // Update container state
	                if (this.context.container) {
	                    this.context.container.nextState({
	                        isSticky: shouldBeSticky,
	                        height: _reactDom2.default.findDOMNode(this).getBoundingClientRect().height
	                    });
	                }
	
	                // Publish sticky state change
	                this.props.onStickyStateChange(shouldBeSticky);
	            }
	        }
	
	        /*
	         * The special sauce.
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            // https://github.com/captivationsoftware/react-sticky/commit/e33c4cd873fc3399c96eead97871b2d74235f6b1#diff-18aac22485b5225ec8d6628cce48a7bf
	            // "VIEJO", commit "ES6 Update"
	            return this.props.type({
	                style: this.state.style,
	                className: this.state.className
	            }, this.props.children);
	
	            // "NUEVO", no permite cambiar el tipo de elemento
	            //return (
	            //    <div style={this.state.style} className={this.state.className}>
	            //        {this.props.children}
	            //    </div>
	            //);
	        }
	    }]);
	
	    return Sticky;
	}(_react2.default.Component);
	
	Sticky.contextTypes = {
	    type: _react2.default.PropTypes.func,
	    container: _react2.default.PropTypes.any
	
	    /*
	     * Default properties...
	     */
	};Sticky.defaultProps = {
	    type: _react2.default.DOM.div,
	    className: '',
	    style: {},
	    stickyClass: 'sticky',
	    stickyStyle: {},
	    topOffset: 0,
	    onStickyStateChange: function onStickyStateChange() {}
	};
	
	exports.default = Sticky;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "sticky.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _raf = __webpack_require__(623);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _simpleSignal = __webpack_require__(625);
	
	var _simpleSignal2 = _interopRequireDefault(_simpleSignal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signal = new _simpleSignal2.default();
	
	var handleEvent = function handleEvent() {
	    return (0, _raf2.default)(signal.emit);
	};
	
	/**
	 * Wire up event listeners
	 */
	['scroll', 'resize', 'touchmove', 'touchend'].forEach(function (evt) {
	    if (window.addEventListener) {
	        window.addEventListener(evt, handleEvent);
	    } else {
	        window.attachEvent('on' + evt, handleEvent);
	    }
	});
	
	exports.default = signal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "watcher.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(624)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = Signal;
	
	function Signal() {
	  var subscribers = [];
	  return {
	    on: function on(fn) {
	      subscribers.push(fn);
	    },
	    off: function off(fn) {
	      var index = subscribers.indexOf(fn);
	      if (index > -1) {
	        subscribers.splice(index, 1);
	      }
	    },
	    emit: function emit(val) {
	      for (var i = 0, len = subscribers.length; i < len; ++i) {
	        subscribers[i](val);
	      }
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_React$Component) {
	    _inherits(Container, _React$Component);
	
	    function Container(props) {
	        _classCallCheck(this, Container);
	
	        var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));
	
	        _this.state = {
	            topCorrection: 0,
	            cumulativeTopCorrection: 0
	        };
	        return _this;
	    }
	
	    _createClass(Container, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                container: this
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateCumulativeTopCorrection();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.updateCumulativeTopCorrection();
	        }
	    }, {
	        key: 'cumulativeTopCorrection',
	        value: function cumulativeTopCorrection() {
	            var topCorrection = 0;
	            if (this.context.container) {
	                var container = this.context.container;
	                while (container) {
	                    topCorrection += container.state.topCorrection;
	                    container = container.context.container;
	                };
	            }
	            return topCorrection;
	        }
	    }, {
	        key: 'updateCumulativeTopCorrection',
	        value: function updateCumulativeTopCorrection() {
	            var cumulativeTopCorrection = this.cumulativeTopCorrection();
	            if (cumulativeTopCorrection !== this.state.cumulativeTopCorrection) {
	                this.setState({ cumulativeTopCorrection: cumulativeTopCorrection });
	            }
	        }
	    }, {
	        key: 'nextState',
	        value: function nextState(state) {
	            var topCorrection = state.isSticky ? state.height : 0;
	            this.setState({ topCorrection: topCorrection });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var style = Object.assign({}, this.props.style || {});
	
	            var paddingTop = style.paddingTop || 0;
	            style.paddingTop = paddingTop + this.state.topCorrection;
	
	            // Mi version: hacer un pull request con esto:
	            return this.props.type({
	                style: style,
	                className: this.props.className
	            }, this.props.children);
	
	            // ORIGINAL
	            //return <div {...this.props} style={style}>
	            //    {this.props.children}
	            //</div>
	        }
	    }]);
	
	    return Container;
	}(_react2.default.Component);
	
	Container.contextTypes = {
	    container: _react2.default.PropTypes.any
	};
	
	Container.childContextTypes = {
	    container: _react2.default.PropTypes.any
	
	    // TODO: Hacer un pull request con esto
	};Container.defaultProps = {
	    type: _react2.default.DOM.div
	};
	
	exports.default = Container;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "container.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderConFiltro = __webpack_require__(628);
	
	var css = _interopRequireWildcard(_HeaderConFiltro);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	// Styles
	
	var HeaderConFiltro = function (_React$Component) {
	    _inherits(HeaderConFiltro, _React$Component);
	
	    function HeaderConFiltro(props) {
	        _classCallCheck(this, HeaderConFiltro);
	
	        var _this = _possibleConstructorReturn(this, (HeaderConFiltro.__proto__ || Object.getPrototypeOf(HeaderConFiltro)).call(this, props));
	
	        _this.state = {
	            open: false,
	            filtro: []
	        };
	        return _this;
	    }
	
	    _createClass(HeaderConFiltro, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // actualizar el filtro cuando se reciban nuevas propiedades
	            this.setState({ filtro: nextProps.filtro });
	        }
	        // Metodos para controlar el display del menu, ocultar y mostrar los elementos
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.onClickHandler.bind(this));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.onClickHandler.bind(this));
	        }
	    }, {
	        key: 'onClickHandler',
	        value: function onClickHandler(evt) {
	            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
	            if (!this.node.contains(evt.target) && this.state.open) this.cerrarMenu_descartarCambios();
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            // si el menu se oculta se descartan los cambios
	            if (this.state.open) this.cerrarMenu_descartarCambios();else this.setState({ open: true });
	        }
	    }, {
	        key: 'cerrarMenu_descartarCambios',
	        value: function cerrarMenu_descartarCambios() {
	            this.setState({
	                open: false,
	                filtro: this.props.filtro
	            });
	        }
	    }, {
	        key: 'cerrarMenu_aplicarCambios',
	        value: function cerrarMenu_aplicarCambios() {
	            // ocultar el menu e informar la actualizacion del filtro al padre
	            this.setState({ open: false });
	            this.props.actualizarFiltro(this.state.filtro);
	        }
	
	        // Elementos seleccionados
	
	    }, {
	        key: 'estanTodosSeleccionados',
	        value: function estanTodosSeleccionados() {
	            // todos seleccionados = el total de '.selecconado=false' es cero
	            return this.state.filtro.filter(function (opc) {
	                return opc.seleccionado === false;
	            }).length === 0;
	        }
	    }, {
	        key: 'toggleTodos',
	        value: function toggleTodos() {
	            var todosSeleccionados = this.estanTodosSeleccionados();
	            this.setState({
	                filtro: this.state.filtro.map(function (opcion) {
	                    return {
	                        // si estan todos seleccionados, marcar ninguno
	                        // si falta uno por marcar, se marcan todos
	                        seleccionado: !todosSeleccionados,
	                        texto: opcion.texto,
	                        valor: opcion.valor
	                    };
	                })
	            });
	        }
	    }, {
	        key: 'seleccionarOpcion',
	        value: function seleccionarOpcion(valorSeleccionado) {
	            this.setState({
	                filtro: this.state.filtro.map(function (opcion) {
	                    return {
	                        // si es la opcion que estamos buscando, se cambia su estado 'seleccionado', si no lo dejamos igual
	                        seleccionado: opcion.valor == valorSeleccionado ? !opcion.seleccionado : opcion.seleccionado,
	                        texto: opcion.texto,
	                        valor: opcion.valor
	                    };
	                })
	            });
	        }
	
	        // Se busca un elemento a travez del campo InputTexto
	
	    }, {
	        key: 'onKeyDownInputTexto',
	        value: function onKeyDownInputTexto(evt) {
	            var _this2 = this;
	
	            // 13 = enter
	            if (evt.keyCode === 13) {
	                // tanto al texto buscado, como el de los input, se la quitan los espacios y se pone en minusculas
	                var texto = this.refInputTexto.value.trim().toLowerCase();
	
	                var filtroActualizado = this.state.filtro.map(function (opcion) {
	                    var textoOpcion = opcion.texto.trim().toLowerCase();
	
	                    // Si se realiza una "busqueda exacta" se comparan los string, de lo contrario
	                    // busca que este incluido en el texto
	                    opcion.seleccionado = _this2.props.busquedaExacta ? textoOpcion == texto : textoOpcion.includes(texto);
	                    return opcion;
	                });
	                // luego de buscar, se oculta la busqueda
	                this.refInputTexto.value = '';
	                // this.closeMe nu()
	                this.setState({ open: false });
	
	                // informar la actualizacion al padre
	                this.props.actualizarFiltro(filtroActualizado);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: css.container,
	                    ref: function ref(_ref2) {
	                        return _this3.node = _ref2;
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: css.divTitulo,
	                        onClick: this.toggleMenu.bind(this) },
	                    this.props.nombre
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pull-right' },
	                    this.props.ordenarLista ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-sort-by-attributes ' + css.spanOrdenar,
	                        onClick: this.props.ordenarLista
	                    }) : null,
	                    _react2.default.createElement('span', { className: (this.estanTodosSeleccionados() ? '' : css.filtroColoreado) + (this.state.open ? ' glyphicon glyphicon-triangle-top ' : ' glyphicon glyphicon-triangle-bottom '),
	                        onClick: this.toggleMenu.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: css.menu, style: { display: this.state.open ? '' : 'none' } },
	                    _react2.default.createElement('input', { type: 'text', className: css.inputTexto,
	                        placeholder: 'Filtrar por...',
	                        ref: function ref(_ref) {
	                            return _this3.refInputTexto = _ref;
	                        },
	                        onKeyDown: this.onKeyDownInputTexto.bind(this)
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.contenedorValores },
	                        this.state.filtro.map(function (opcion, index) {
	                            return _react2.default.createElement(
	                                'label',
	                                { key: index },
	                                _react2.default.createElement('input', { type: 'checkbox',
	                                    onChange: _this3.seleccionarOpcion.bind(_this3, opcion.valor),
	                                    checked: !!opcion.seleccionado
	                                }),
	                                ' ',
	                                opcion.texto
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'checkbox',
	                            onChange: this.toggleTodos.bind(this),
	                            checked: this.estanTodosSeleccionados.call(this)
	                        }),
	                        'Todos'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'btn btn-block btn-sm btn-primary',
	                            onClick: this.cerrarMenu_aplicarCambios.bind(this) },
	                        'Aceptar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderConFiltro;
	}(_react2.default.Component);
	
	HeaderConFiltro.propTypes = {
	    nombre: PropTypes.string,
	    busquedaExacta: PropTypes.bool,
	    filtro: PropTypes.arrayOf(PropTypes.object).isRequired,
	    // Metodos
	    actualizarFiltro: PropTypes.func.isRequired,
	    ordenarLista: PropTypes.func
	};
	HeaderConFiltro.defaultProps = {
	    nombre: '[sin nombre]',
	    busquedaExacta: false,
	    ordenarLista: null
	};
	exports.default = HeaderConFiltro;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "HeaderConFiltro.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"HeaderConFiltro__container___3D6jc","divTitulo":"HeaderConFiltro__divTitulo___3EwIN","spanOrdenar":"HeaderConFiltro__spanOrdenar___2yI0C","menu":"HeaderConFiltro__menu___nr1GQ","inputTexto":"HeaderConFiltro__inputTexto___2rNoo","contenedorValores":"HeaderConFiltro__contenedorValores___2Q55Q","filtroColoreado":"HeaderConFiltro__filtroColoreado___2gAqi"};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"TablaMensual__tableFixed___2TugT","trSeparador":"TablaMensual__trSeparador___1HbFo","thCorrelativo":"TablaMensual__thCorrelativo___1ftJh","tdCorrelativo":"TablaMensual__tdCorrelativo___1Y-z5","thEstadoInventario":"TablaMensual__thEstadoInventario___3Yd7Q","tdEstadoInventario":"TablaMensual__tdEstadoInventario___B67HT","thFecha":"TablaMensual__thFecha___37k_G","tdFecha":"TablaMensual__tdFecha___2KV-u","thCliente":"TablaMensual__thCliente___2LP5g","tdCliente":"TablaMensual__tdCliente___201PV TablaMensual__thCliente___2LP5g","thCeco":"TablaMensual__thCeco___GR-Nv","tdCeco":"TablaMensual__tdCeco___gEuuj TablaMensual__thCeco___GR-Nv","thLocal":"TablaMensual__thLocal___1nhRN","tdLocal":"TablaMensual__tdLocal___2qAqW TablaMensual__thLocal___1nhRN","thZonaSei":"TablaMensual__thZonaSei___69oVf","tdZonaSei":"TablaMensual__tdZonaSei___1qEQ1 TablaMensual__thZonaSei___69oVf","thRegion":"TablaMensual__thRegion___2Jge3","tdRegion":"TablaMensual__tdRegion___3UVB1 TablaMensual__thRegion___2Jge3","thComuna":"TablaMensual__thComuna___3N08n","tdComuna":"TablaMensual__tdComuna___WyGNZ TablaMensual__thComuna___3N08n","thStock":"TablaMensual__thStock___3m3Ua","tdStock":"TablaMensual__tdStock___295qZ TablaMensual__thStock___3m3Ua","thEspecial":"TablaMensual__thEspecial___38B3U","tdEspecial":"TablaMensual__tdEspecial___3k3xR TablaMensual__thEspecial___38B3U","checkboxContainer":"TablaMensual__checkboxContainer___1iuJF","thDotacion":"TablaMensual__thDotacion___2q1C2","tdDotacion":"TablaMensual__tdDotacion___11jSG TablaMensual__thDotacion___2q1C2","thJornada":"TablaMensual__thJornada___m0YEH","tdJornada":"TablaMensual__tdJornada___2UttI TablaMensual__thJornada___m0YEH","thEstado":"TablaMensual__thEstado___1A2db","tdEstado":"TablaMensual__tdEstado___2xe9Z","thOpciones":"TablaMensual__thOpciones___3-u4J","tdOpciones":"TablaMensual__tdOpciones___3Id8R","textoConTooltip":"TablaMensual__textoConTooltip___3OU9U"};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AgregarInventario = __webpack_require__(631);
	
	var style = _interopRequireWildcard(_AgregarInventario);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	// Styles
	
	
	_moment2.default.locale('es');
	
	var AgregarInventario = function (_React$Component) {
	    _inherits(AgregarInventario, _React$Component);
	
	    function AgregarInventario(props) {
	        _classCallCheck(this, AgregarInventario);
	
	        var _this = _possibleConstructorReturn(this, (AgregarInventario.__proto__ || Object.getPrototypeOf(AgregarInventario)).call(this, props));
	
	        var valorActual = (0, _moment2.default)().format('YYYY-MM-00');
	        var mesSeleccionado = _this.props.meses.find(function (d) {
	            return d.valor === valorActual;
	        });
	        _this.state = {
	            idClienteSeleccionado: 0,
	            mesSeleccionado: mesSeleccionado.valor,
	            locales: [],
	            errores: {
	                errorIdCliente: '',
	                errorNumeroLocal: ''
	            },
	            pegados: {
	                pegadoConProblemas: [],
	                conteoTotal: 0,
	                conteoCorrectos: 0,
	                conteoProblemas: 0
	            },
	            inputPegar_error: '',
	            modoIngreso: 'manual' // 'manual'/'excel'
	        };
	        return _this;
	    }
	
	    _createClass(AgregarInventario, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // seleccionar el primer mes por defecto
	            this.props.buscarAuditorias(this.state.mesSeleccionado, this.state.idClienteSeleccionado);
	        }
	    }, {
	        key: 'setModoIngreso',
	        value: function setModoIngreso(modo) {
	            if (modo !== this.state.modoIngreso) {
	                this.setState({ modoIngreso: this.state.modoIngreso === 'manual' ? 'excel' : 'manual' });
	            }
	        }
	
	        /**
	         * Cambio en los campos del formulario
	         */
	
	    }, {
	        key: 'onSeleccionarMes',
	        value: function onSeleccionarMes(evt) {
	            var mesSeleccionado = evt.target.value;
	            // buscar los locales
	            this.props.buscarAuditorias(mesSeleccionado, this.state.idClienteSeleccionado);
	            this.setState({
	                mesSeleccionado: mesSeleccionado
	            });
	        }
	    }, {
	        key: 'onSeleccionarCliente',
	        value: function onSeleccionarCliente(event) {
	            // al seleccionar un cliente, se deben cargar los locales el el <select> de clientes
	            var idClienteSeleccionado = event.target.value;
	
	            // buscamos los locales de ese cliente
	            this.props.buscarAuditorias(this.state.mesSeleccionado, idClienteSeleccionado);
	
	            // buscamos el cliente seleccionado
	            var cliente = this.props.clientes.find(function (cliente) {
	                return cliente.idCliente == idClienteSeleccionado;
	            });
	            // lo marcados como seleccionado y mostramos la lista de locales
	            this.setState({
	                idClienteSeleccionado: idClienteSeleccionado,
	                locales: cliente ? cliente.locales : [], // mostrar la lista de locales que tiene el cliente seleccionado
	                errores: {}
	            });
	        }
	    }, {
	        key: 'inputNumeroLocalChanged',
	        value: function inputNumeroLocalChanged(evt) {
	            this.setState({
	                errores: { errorNumeroLocal: '' }
	            });
	        }
	    }, {
	        key: 'getOpcionesSeleccionadas',
	        value: function getOpcionesSeleccionadas() {
	            return {
	                idCliente: this.state.idClienteSeleccionado,
	                mes: this.state.mesSeleccionado
	            };
	        }
	        /**
	         * Agregar Locales
	         */
	
	    }, {
	        key: 'agregarLocalManualmente',
	        value: function agregarLocalManualmente(evt) {
	            evt.preventDefault();
	            if (!this.props.puedeAgregar) return alert("no tiene permisos para agregar un inventario");
	
	            var idCliente = this.inputIdCliente.value;
	            var numeroLocal = this.inputNumeroLocal.value;
	            var annoMesDia = this.inputAnnoMesDia.value;
	
	            this.inputNumeroLocal.value = '';
	
	            var _props$agregarInventa = this.props.agregarInventario(idCliente, numeroLocal, annoMesDia),
	                _props$agregarInventa2 = _slicedToArray(_props$agregarInventa, 2),
	                errores = _props$agregarInventa2[0],
	                objeto = _props$agregarInventa2[1];
	
	            this.setState({
	                errores: errores || {}
	            });
	        }
	    }, {
	        key: 'agregarLocalesAlPegar',
	        value: function agregarLocalesAlPegar(event) {
	            var _this2 = this;
	
	            event.preventDefault();
	            if (!this.props.puedeAgregar) return alert("no tiene permisos para agregar un inventario");
	
	            // validar que exista un cliente seleccionado
	            var idCliente = this.inputIdCliente.value;
	            if (idCliente === '-1') {
	                this.setState({
	                    pegados: {
	                        conteoTotal: 0,
	                        conteoCorrectos: 0,
	                        conteoProblemas: 0,
	                        pegadoConProblemas: []
	                    },
	                    errores: {
	                        errorIdCliente: 'Seleccione un Cliente'
	                    },
	                    inputPegar_error: 'Seleccione un Cliente'
	                });
	                return;
	            }
	
	            // cuando se pegue un elemento, separar separar las filas por el "line feed" '\n'
	            event.clipboardData.items[0].getAsString(function (texto) {
	                // separar cada una de las filas '\n'
	                var rows = texto.trim().split('\n');
	                // quitar las filas vacias, y separar sus valores por el caracter tabulador
	                rows = rows.filter(function (row) {
	                    return row !== '';
	                });
	                var numerosLocales = rows.map(function (row) {
	                    return row.trim().split('\t')[0];
	                });
	
	                var resultadoPegar = _this2.props.agregarGrupoInventarios(idCliente, numerosLocales, _this2.inputAnnoMesDia.value);
	                // guardar el resultado de agregar los elementos
	                _this2.setState({
	                    pegados: resultadoPegar
	                });
	                console.log('AgregarInventario.... resultado:', resultadoPegar);
	            });
	        }
	    }, {
	        key: 'limpiarProblemas',
	        value: function limpiarProblemas() {
	            this.setState({
	                pegados: {
	                    conteoTotal: 0,
	                    conteoCorrectos: 0,
	                    conteoProblemas: 0,
	                    pegadoConProblemas: []
	                },
	                inputPegar_error: ''
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'page-header', style: { marginTop: '1em' } },
	                        'Agregar locales a la programaci\xF3n:'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { marginBottom: '1em' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-offset-4 col-sm-3' },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-sm btn-default ' + (this.state.modoIngreso === 'manual' ? 'active' : ''), onClick: this.setModoIngreso.bind(this, 'manual') },
	                            'Manualmente'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-sm btn-default ' + (this.state.modoIngreso === 'excel' ? 'active' : ''), onClick: this.setModoIngreso.bind(this, 'excel') },
	                            'Desde Excel'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' + (this.state.errores.errorIdCliente ? 'has-error' : '') },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'cliente' },
	                            'Cliente'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'cliente',
	                                ref: function ref(_ref) {
	                                    return _this3.inputIdCliente = _ref;
	                                },
	                                value: this.state.idClienteSeleccionado,
	                                onChange: this.onSeleccionarCliente.bind(this)
	                            },
	                            _react2.default.createElement(
	                                'option',
	                                { value: '0' },
	                                'Todos'
	                            ),
	                            this.props.clientes.map(function (cliente, index) {
	                                //return <option key={index} value={cliente.idCliente}>{"asdas" + cliente.nombre}</option
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: cliente.idCliente },
	                                    cliente.nombreCorto + ' - ' + cliente.nombre
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'help-block', style: { position: 'absolute' } },
	                            this.state.errores.errorIdCliente
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'fechaProgramada' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'fechaProgramada',
	                                ref: function ref(_ref2) {
	                                    return _this3.inputAnnoMesDia = _ref2;
	                                },
	                                value: this.state.mesSeleccionado,
	                                onChange: this.onSeleccionarMes.bind(this) },
	                            this.props.meses.map(function (mes, i) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: i, value: mes.valor },
	                                    mes.texto
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form', onSubmit: this.agregarLocalManualmente.bind(this), style: { display: this.state.modoIngreso === 'manual' ? '' : 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 form-group ' + (this.state.errores.errorNumeroLocal ? 'has-error' : '') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'locales' },
	                                'Local'
	                            ),
	                            _react2.default.createElement('input', { className: 'form-control' /*type="number" min='1' max='9999'*/, name: 'locales',
	                                ref: function ref(_ref3) {
	                                    return _this3.inputNumeroLocal = _ref3;
	                                },
	                                onChange: this.inputNumeroLocalChanged.bind(this),
	                                disabled: this.props.puedeAgregar ? '' : 'disabled'
	                            }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'help-block', style: { position: 'absolute' } },
	                                this.state.errores.errorNumeroLocal
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-2 form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label' },
	                                '\xA0'
	                            ),
	                            _react2.default.createElement('input', { type: 'submit', className: 'form-control btn btn-primary', value: 'Agregar local',
	                                disabled: this.props.puedeAgregar ? '' : 'disabled'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: this.state.modoIngreso === 'excel' ? '' : 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 form-group ' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'locales' },
	                                'Locales'
	                            ),
	                            _react2.default.createElement('input', { className: 'form-control', type: 'text', name: 'locales', placeholder: 'pegar aca los datos de Excel',
	                                onPaste: this.agregarLocalesAlPegar.bind(this),
	                                disabled: this.props.puedeAgregar ? '' : 'disabled'
	                            }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { marginTop: '1em' } },
	                                'Abra Excel, seleccione los datos de la columna ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'CECO'
	                                ),
	                                ', ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'COPIE'
	                                ),
	                                ' el contendo y ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'PEGUELO'
	                                ),
	                                ' en la cuandro de texto.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-5 form-group ' + (this.state.pegados.conteoTotal == 0 ? 'hide' : '') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'locales' },
	                                    'Resultado'
	                                ),
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-bordered table-condensed' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'Correctos'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                this.state.pegados.conteoCorrectos
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'Con Problemas'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                this.state.pegados.conteoProblemas
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'TOTAL'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    this.state.pegados.conteoTotal
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: "col-sm-7 " },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'locales' },
	                                    'Detalle'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-xs btn-primary pull-right', tabIndex: '-1', onClick: this.limpiarProblemas.bind(this) },
	                                    'Aceptar/Ocultar'
	                                ),
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-bordered table-condensed' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'CECO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Estado'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        this.state.pegados.pegadoConProblemas.length === 0 ? _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { colSpan: '2' },
	                                                'Sin problemas detectados'
	                                            )
	                                        ) : this.state.pegados.pegadoConProblemas.map(function (error, index) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: index },
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: style.tableCell },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        error.numeroLocal
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: style.tableCell },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'small',
	                                                            null,
	                                                            error.errorIdCliente || error.errorNumeroLocal
	                                                        )
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AgregarInventario;
	}(_react2.default.Component);
	
	AgregarInventario.propTypes = {
	    puedeAgregar: _react2.default.PropTypes.bool.isRequired,
	    clientes: _react2.default.PropTypes.array.isRequired,
	    meses: _react2.default.PropTypes.array.isRequired,
	    // Metodos
	    agregarInventario: _react2.default.PropTypes.func.isRequired,
	    agregarGrupoInventarios: _react2.default.PropTypes.func.isRequired,
	    buscarAuditorias: _react2.default.PropTypes.func.isRequired
	};
	
	exports.default = AgregarInventario;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "AgregarInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableCell":"AgregarInventario__tableCell___14Olb"};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputFecha = __webpack_require__(633);
	
	var _InputFecha2 = _interopRequireDefault(_InputFecha);
	
	var _InputStock = __webpack_require__(635);
	
	var _InputStock2 = _interopRequireDefault(_InputStock);
	
	var _TablaMensual = __webpack_require__(629);
	
	var css = _interopRequireWildcard(_TablaMensual);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var RowInventarioMensual = function (_React$Component) {
	    _inherits(RowInventarioMensual, _React$Component);
	
	    function RowInventarioMensual() {
	        _classCallCheck(this, RowInventarioMensual);
	
	        return _possibleConstructorReturn(this, (RowInventarioMensual.__proto__ || Object.getPrototypeOf(RowInventarioMensual)).apply(this, arguments));
	    }
	
	    _createClass(RowInventarioMensual, [{
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            if (elemento === 'dia') {
	                this.inputFecha.focus();
	            } else if (elemento === 'stock') {
	                this.inputStock.focus();
	            }
	        }
	    }, {
	        key: 'guardarInventario',
	        value: function guardarInventario() {
	            if (!this.props.puedeModificar) return alert("no tiene permitido modificar el inventario");
	
	            var cambiosInventario = {};
	
	            // el DIA es valido, y ha cambiado?
	            var estadoInputFecha = this.inputFecha.getEstado();
	            if (estadoInputFecha.valid && estadoInputFecha.dirty) {
	                cambiosInventario.fechaProgramada = estadoInputFecha.fecha;
	            } else if (estadoInputFecha.valid === false) {
	                return console.log('fecha ' + estadoInputFecha.fecha + ' invalida');
	            }
	
	            // la DOTACION es valida y ha cambiado?
	            // let estadoInputDotacionTotal = this.inputDotacionTotal.getEstado()
	            // if (estadoInputDotacionTotal.valid && estadoInputDotacionTotal.dirty) {
	            //     cambiosInventario.dotacionAsignadaTotal = estadoInputDotacionTotal.valor
	            // } else if (estadoInputDotacionTotal.valid === false) {
	            //     return console.log(`dotacion total: ${estadoInputDotacionTotal.valor} invalida`)
	            // }
	
	            // almenos uno de los ementos debe estar "dirty" para guardar los cambios
	            if (JSON.stringify(cambiosInventario) !== "{}") {
	                console.log('cambios en el inventario ', cambiosInventario);
	                this.props.actualizarInventario(this.props.inventario.inv_idInventario, cambiosInventario, this.props.inventario.idDummy);
	            } else {
	                console.log('inventario sin cambios, no se actualiza');
	            }
	        }
	    }, {
	        key: 'cambiarInventarioEspecial',
	        value: function cambiarInventarioEspecial(checked) {
	            var data = {
	                'especial': checked
	            };
	            this.props.actualizarInventario(this.props.inventario.inv_idInventario, data, this.props.inventario.idDummy);
	        }
	    }, {
	        key: 'cambiarInventarioFacturable',
	        value: function cambiarInventarioFacturable(checked) {
	            var data = {
	                'facturable': checked
	            };
	            this.props.actualizarInventario(this.props.inventario.inv_idInventario, data, this.props.inventario.idDummy);
	        }
	    }, {
	        key: 'quitarInventario',
	        value: function quitarInventario() {
	            this.props.quitarInventario(this.props.inventario.idDummy);
	        }
	    }, {
	        key: 'eliminarInventario',
	        value: function eliminarInventario() {
	            if (!this.props.puedeModificar) return alert("no tiene permitido eliminar el inventario");
	            this.props.eliminarInventario(this.props.inventario);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var styleTR = this.props.inventario.inv_especial ? "#B8F2C2" : '';
	            return _react2.default.createElement(
	                'tr',
	                { style: { backgroundColor: styleTR }, className: this.props.mostrarSeparador ? css.trSeparador : '' },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCorrelativo },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEstadoInventario, style: { backgroundColor: this.props.inventario.inv_estado == 2 ? "#ff7777" : "" } },
	                    _react2.default.createElement(
	                        'select',
	                        { defaultValue: this.props.inventario.inv_estado, onChange: function onChange(e) {
	                                return _this2.props.updateEstadoInventario(_this2.props.inventario.inv_idInventario, e.target.value);
	                            } },
	                        this.props.estados.map(function (row) {
	                            return _react2.default.createElement(
	                                'option',
	                                { key: row.id, value: row.id },
	                                row.nombre
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    _react2.default.createElement(_InputFecha2.default, {
	                        puedeModificar: this.props.puedeModificar,
	                        ref: function ref(_ref) {
	                            return _this2.inputFecha = _ref;
	                        },
	                        diaSemana: this.props.inventario.inv_fechaProgramadaDOW,
	                        fechaConProblemas: this.props.inventario.local_topeFechaConAuditoria,
	                        fecha: this.props.inventario.inv_fechaProgramada,
	                        onGuardar: this.guardarInventario.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dia');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dia');
	                        } })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            this.props.inventario.cliente_nombreCorto
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            this.props.inventario.local_ceco
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Tipo de local: ',
	                            this.props.inventario.local_formatoLocal
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                this.props.inventario.local_nombre
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { margin: 0 } },
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            this.props.inventario.local_region
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                this.props.inventario.local_comuna
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Direcci\xF3n: ',
	                            this.props.inventario.local_direccion
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    _react2.default.createElement(_InputStock2.default, {
	                        ref: function ref(_ref2) {
	                            return _this2.inputStock = _ref2;
	                        },
	                        asignada: '' + this.props.inventario.inv_stockTeorico,
	                        tooltipText: 'Stock al ' + this.props.inventario.inv_fechaStock,
	                        onGuardar: this.guardarInventario.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'stock');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'stock');
	                        },
	                        puedeModificar: false
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEspecial },
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.checkboxContainer },
	                        _react2.default.createElement('input', { type: 'checkbox', checked: this.props.inventario.inv_especial, onChange: function onChange(e) {
	                                return _this2.cambiarInventarioEspecial(e.target.checked);
	                            } }),
	                        this.props.inventario.inv_especial && _react2.default.createElement('input', { type: 'checkbox', checked: this.props.inventario.inv_facturable, onChange: function onChange(e) {
	                                return _this2.cambiarInventarioFacturable(e.target.checked);
	                            } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOpciones },
	                    this.props.inventario.inv_idInventario ?
	                    // si esta creado, puede eliminar el inventario
	                    this.props.puedeModificar === true ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-xs btn-primary',
	                            tabIndex: '-1',
	                            onClick: this.eliminarInventario.bind(this) },
	                        'Eliminar inventario'
	                    ) : null :
	                    // si no esta creado, solo puede quitarlo de la lista
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-xs btn-danger',
	                            tabIndex: '-1',
	                            onClick: this.quitarInventario.bind(this) },
	                        'X'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowInventarioMensual;
	}(_react2.default.Component);
	
	RowInventarioMensual.propTypes = {
	    // Objetos
	    index: _react2.default.PropTypes.number.isRequired,
	    inventario: _react2.default.PropTypes.object.isRequired,
	    mostrarSeparador: _react2.default.PropTypes.bool.isRequired,
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    // Metodos
	    actualizarInventario: _react2.default.PropTypes.func.isRequired,
	    quitarInventario: _react2.default.PropTypes.func.isRequired,
	    eliminarInventario: _react2.default.PropTypes.func.isRequired,
	    focusRow: _react2.default.PropTypes.func.isRequired
	};
	RowInventarioMensual.defaultProps = {
	    mostrarSeparador: false
	};
	
	exports.default = RowInventarioMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventarioMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputFecha = __webpack_require__(634);
	
	var css = _interopRequireWildcard(_InputFecha);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Estilos
	
	
	var InputFecha = function (_React$Component) {
	    _inherits(InputFecha, _React$Component);
	
	    function InputFecha(props) {
	        _classCallCheck(this, InputFecha);
	
	        var _this = _possibleConstructorReturn(this, (InputFecha.__proto__ || Object.getPrototypeOf(InputFecha)).call(this, props));
	
	        _this.state = {
	            dia: '-',
	            mes: '-',
	            anno: '-',
	            diaDirty: false, mesDirty: false, annoDirty: false,
	            diaValid: true, mesValid: true, annoValid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputFecha, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props$fecha$split = this.props.fecha.split('-'),
	                _props$fecha$split2 = _slicedToArray(_props$fecha$split, 3),
	                anno1 = _props$fecha$split2[0],
	                mes1 = _props$fecha$split2[1],
	                dia1 = _props$fecha$split2[2];
	
	            this.setState({
	                dia: dia1,
	                mes: mes1,
	                anno: anno1,
	                diaDirty: false, mesDirty: false, annoDirty: false,
	                diaValid: true, mesValid: true, annoValid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            var _nextProps$fecha$spli = nextProps.fecha.split('-'),
	                _nextProps$fecha$spli2 = _slicedToArray(_nextProps$fecha$spli, 3),
	                anno2 = _nextProps$fecha$spli2[0],
	                mes2 = _nextProps$fecha$spli2[1],
	                dia2 = _nextProps$fecha$spli2[2];
	
	            this.setState({
	                dia: dia2,
	                mes: mes2,
	                anno: anno2,
	                diaDirty: false, mesDirty: false, annoDirty: false,
	                diaValid: true, mesValid: true, annoValid: true
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return {
	                dirty: this.state.diaDirty || this.state.mesDirty || this.state.annoDirty,
	                valid: this.state.diaValid && this.state.mesValid && this.state.annoValid,
	                fecha: this.state.anno + '-' + this.state.mes + '-' + this.state.dia
	            };
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputDia.focus();
	            this.inputDia.select();
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                //this.props.onGuardar()    // no es necesario porque se guarda cuando pierde el focus (focusRowSiguiente),
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                //this.props.onGuardar()    // no es necesario porque se guarda cuando pierde el focus (focusRowAnterior),
	                this.props.focusRowAnterior();
	            }
	        }
	    }, {
	        key: '_diaValido',
	        value: function _diaValido(dia) {
	            return dia >= 0 && dia < 32;
	        }
	    }, {
	        key: '_mesValido',
	        value: function _mesValido(mes) {
	            return mes >= 1 && mes <= 12;
	        }
	    }, {
	        key: '_yearValido',
	        value: function _yearValido(year) {
	            return year >= 1 && year <= 2026;
	        }
	    }, {
	        key: 'onDiaChange',
	        value: function onDiaChange(evt) {
	            var dia = evt.target.value;
	            var diaOriginal = this.props.fecha.split('-')[2];
	            this.setState({
	                dia: dia,
	                diaDirty: dia != diaOriginal,
	                diaValid: this._diaValido(dia)
	            });
	        }
	    }, {
	        key: 'onMesChange',
	        value: function onMesChange(evt) {
	            var mes = evt.target.value;
	            var mesOriginal = this.props.fecha.split('-')[1];
	            this.setState({
	                mes: mes,
	                mesDirty: mes != mesOriginal,
	                mesValid: this._mesValido(mes)
	            });
	        }
	    }, {
	        key: 'onYearChange',
	        value: function onYearChange(evt) {
	            var anno = evt.target.value;
	            var annoOriginal = this.props.fecha.split('-')[1];
	            this.setState({
	                anno: anno,
	                annoDirty: anno != annoOriginal,
	                annoValid: this._yearValido(anno)
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var classnameDia = this.state.diaValid ? this.state.diaDirty ? css.inputDiaDirty : css.inputDia : css.inputDiaInvalido;
	            var classnameMes = this.state.mesValid ? this.state.diaDirty ? css.inputDiaDirty : css.inputDia : css.inputDiaInvalido;
	            var classnameYear = this.state.annoValid ? this.state.annoDirty ? css.inputAnnoDirty : css.inputAnno : css.inputDiaInvalido;
	            return _react2.default.createElement(
	                'div',
	                { className: "pull-right " + css.divContenedor },
	                this.props.fechaConProblemas != null ? _react2.default.createElement(
	                    'p',
	                    { className: css.diaSemanaConError },
	                    this.props.diaSemana,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.fechaConProblemas
	                    )
	                ) : _react2.default.createElement(
	                    'p',
	                    { className: css.diaSemana },
	                    this.props.diaSemana
	                ),
	                _react2.default.createElement('input', { className: classnameDia,
	                    ref: function ref(_ref) {
	                        return _this2.inputDia = _ref;
	                    },
	                    value: this.state.dia,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onDiaChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    onFocus: function onFocus() {
	                        _this2.inputDia.select();
	                    } // seleccionar el texto cuando se hace focus
	                    , disabled: this.props.puedeModificar ? '' : 'disabled'
	                }),
	                _react2.default.createElement('input', { className: classnameMes, type: 'number',
	                    ref: function ref(_ref2) {
	                        return _this2.inputMes = _ref2;
	                    },
	                    value: this.state.mes,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onMesChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    onFocus: function onFocus() {
	                        _this2.inputMes.select();
	                    } // seleccionar el texto cuando se hace focus
	                    , disabled: this.props.puedeModificar ? '' : 'disabled'
	                }),
	                _react2.default.createElement('input', { className: classnameYear, type: 'number',
	                    ref: function ref(_ref3) {
	                        return _this2.inputYear = _ref3;
	                    },
	                    value: this.state.anno,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onYearChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    onFocus: function onFocus() {
	                        _this2.inputYear.select();
	                    } // seleccionar el texto cuando se hace focus
	                    , disabled: this.props.puedeModificar ? '' : 'disabled'
	                })
	            );
	        }
	    }]);
	
	    return InputFecha;
	}(_react2.default.Component);
	
	InputFecha.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    diaSemana: _react2.default.PropTypes.string.isRequired,
	    fecha: _react2.default.PropTypes.string.isRequired,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func.isRequired,
	    focusRowSiguiente: _react2.default.PropTypes.func.isRequired,
	    onGuardar: _react2.default.PropTypes.func.isRequired
	};
	exports.default = InputFecha;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputFecha.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputNumberAsText":"InputFecha__inputNumberAsText___3a8iN","divContenedor":"InputFecha__divContenedor___3JpAw","inputDia":"InputFecha__inputDia___Q8g_J InputFecha__inputNumberAsText___3a8iN","inputDiaDirty":"InputFecha__inputDiaDirty___11wEf InputFecha__inputDia___Q8g_J InputFecha__inputNumberAsText___3a8iN","inputDiaInvalido":"InputFecha__inputDiaInvalido___HNMY2 InputFecha__inputDia___Q8g_J InputFecha__inputNumberAsText___3a8iN","inputDiaPendiente":"InputFecha__inputDiaPendiente___3hU2L InputFecha__inputDia___Q8g_J InputFecha__inputNumberAsText___3a8iN","inputMes":"InputFecha__inputMes___2YRNl InputFecha__inputNumberAsText___3a8iN","inputAnno":"InputFecha__inputAnno___34nZ- InputFecha__inputNumberAsText___3a8iN","inputAnnoDirty":"InputFecha__inputAnnoDirty___2p06K InputFecha__inputAnno___34nZ- InputFecha__inputNumberAsText___3a8iN","diaSemana":"InputFecha__diaSemana___iOb_b","diaSemanaConError":"InputFecha__diaSemanaConError___2NTx2"};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputStock = __webpack_require__(636);
	
	var css = _interopRequireWildcard(_InputStock);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	// Estilos
	
	
	var InputStock = function (_React$Component) {
	    _inherits(InputStock, _React$Component);
	
	    function InputStock(props) {
	        _classCallCheck(this, InputStock);
	
	        var _this = _possibleConstructorReturn(this, (InputStock.__proto__ || Object.getPrototypeOf(InputStock)).call(this, props));
	
	        _this.state = {
	            valor: '-',
	            dirty: false,
	            valid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputStock, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                valor: this.props.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            this.setState({
	                valor: nextProps.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	                this.props.focusRowAnterior();
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var valorUsuario = evt.target.value;
	            this.setState({
	                valor: valorUsuario,
	                dirty: this.props.asignada != valorUsuario,
	                valid: valorUsuario >= 0
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputStock.focus();
	            this.inputStock.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var classname = this.state.valid ? this.state.dirty ? css.inputStockDirty : this.props.stockAntiguo ? css.inputStockAntiguo : css.inputStock : css.inputStockInvalida;
	            return _react2.default.createElement(
	                'div',
	                { className: css.divConTooltip },
	                _react2.default.createElement('input', {
	                    className: classname + " " + this.props.className,
	                    style: this.props.style,
	                    ref: function ref(_ref) {
	                        return _this2.inputStock = _ref;
	                    },
	                    type: 'number',
	                    value: this.state.valor,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onInputChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    onFocus: function onFocus() {
	                        _this2.inputStock.select();
	                    } // seleccionar el texto cuando se hace focus
	                    , disabled: this.props.puedeModificar ? '' : 'disabled'
	                }),
	                this.props.tooltipText ? _react2.default.createElement(
	                    'div',
	                    { className: css.tooltip },
	                    this.props.tooltipText
	                ) : null
	            );
	        }
	    }]);
	
	    return InputStock;
	}(_react2.default.Component);
	
	InputStock.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    asignada: _react2.default.PropTypes.string.isRequired,
	    //tooltipText: React.PropTypes.string,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func,
	    focusRowSiguiente: _react2.default.PropTypes.func,
	    onGuardar: _react2.default.PropTypes.func.isRequired
	};
	exports.default = InputStock;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputStock.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputStock":"InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","inputStockAntiguo":"InputStock__inputStockAntiguo___2K_bo shared__inputNumberAsText___1Qr9M","inputStockDirty":"InputStock__inputStockDirty___35yPF InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","inputStockInvalida":"InputStock__inputStockInvalida___4u772 InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","divConTooltip":"InputStock__divConTooltip___1cT0B","tooltip":"InputStock__tooltip___1XvQD"};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgramacionIGSemanal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _v3 = __webpack_require__(638);
	
	var _v4 = _interopRequireDefault(_v3);
	
	var _reactIframe = __webpack_require__(611);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	var _BlackBoxIGSemanal = __webpack_require__(639);
	
	var _BlackBoxIGSemanal2 = _interopRequireDefault(_BlackBoxIGSemanal);
	
	var _TablaSemanal = __webpack_require__(640);
	
	var _TablaSemanal2 = _interopRequireDefault(_TablaSemanal);
	
	var _RowInventarioSemanal = __webpack_require__(642);
	
	var _RowInventarioSemanal2 = _interopRequireDefault(_RowInventarioSemanal);
	
	var _SelectRange = __webpack_require__(731);
	
	var _SelectRange2 = _interopRequireDefault(_SelectRange);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _Modales = __webpack_require__(652);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//  Moment
	
	
	_moment2.default.locale("es");
	// Services
	
	// Iframe
	
	// Componentes
	
	// ReactNotify
	
	
	// Modals
	
	
	var format = "YYYY-MM-DD";
	
	var ProgramacionIGSemanal = exports.ProgramacionIGSemanal = function (_Component) {
	  _inherits(ProgramacionIGSemanal, _Component);
	
	  function ProgramacionIGSemanal(props) {
	    _classCallCheck(this, ProgramacionIGSemanal);
	
	    var _this = _possibleConstructorReturn(this, (ProgramacionIGSemanal.__proto__ || Object.getPrototypeOf(ProgramacionIGSemanal)).call(this, props));
	
	    _this.blackbox = new _BlackBoxIGSemanal2.default();
	
	    _this.state = {
	      idCliente: 0,
	      // seleccionar el mes completo
	      fechaInicialSeleccionada: (0, _moment2.default)().subtract(1, "days"),
	      fechaFinalSeleccionada: (0, _moment2.default)().endOf("week"),
	      // Inventarios y Filtros
	      filtros: {},
	      inventariosFiltrados: [],
	      cantNominasSolicitud: "",
	      cantCambiosNominas: "",
	      cantPendientesPublicacion: "",
	      opcionesLideres: props.lideres.map(function (usuario) {
	        return {
	          valor: usuario.id,
	          texto: usuario.nombre1 + " " + usuario.apellidoPaterno
	        };
	      }),
	      opcionesLideresOtros: props.lideresOtros.map(function (usuario) {
	        return {
	          valor: usuario.id,
	          texto: usuario.nombre1 + " " + usuario.apellidoPaterno
	        };
	      }),
	      opcionesSupervisores: props.supervisores.map(function (usuario) {
	        return {
	          valor: usuario.id,
	          texto: usuario.nombre1 + " " + usuario.apellidoPaterno
	        };
	      }),
	      captadoresDisponibles: props.captadores.map(function (usuario) {
	        return {
	          valor: usuario.id,
	          texto: usuario.nombre1 + " " + usuario.apellidoPaterno
	        };
	      }),
	      buttonState: { state: false, texto: "Nominas Masiva" },
	      checkNominas: [],
	      botonLider: { state: true },
	      isLoading: false
	    };
	    // referencia a todos las entradas de fecha de los inventarios
	    _this.rows = [];
	
	    _this.setStatusCheckBox = function (idNomina, status) {
	      var lista = _this.state.checkNominas.map(function (nominas) {
	        if (nominas.nominaDia.id == idNomina) {
	          return _extends({}, nominas, { nominaDia: { id: idNomina, status: status } });
	        } else if (nominas.nominaNoche.id == idNomina) {
	          return _extends({}, nominas, { nominaNoche: { id: idNomina, status: status } });
	        } else {
	          return nominas;
	        }
	      });
	      _this.setState({ checkNominas: lista });
	    };
	
	    _this.setStatusCheckBoxAll = function (status) {
	      var lista = _this.state.checkNominas.map(function (_ref, index) {
	        var nominaDia = _ref.nominaDia,
	            nominaNoche = _ref.nominaNoche;
	
	        var inventario = _this.state.inventariosFiltrados[index];
	        //let statusDia = inventario.ndia_calificacionNomina == 0 || inventario.ndia_calificacionNomina == null ? false : status;
	        //let statusNoche = inventario.nnoche_calificacionNomina == 0 || inventario.nnoche_calificacionNomina == null ? false : status;
	        //console.log(inventario)
	        if (inventario.ndia_habilitada && inventario.nnoche_habilitada) {
	          return {
	            nominaDia: { id: nominaDia.id, status: status },
	            nominaNoche: { id: nominaNoche.id, status: status }
	          };
	        } else if (inventario.ndia_habilitada) {
	          return {
	            nominaDia: { id: nominaDia.id, status: status },
	            nominaNoche: nominaNoche
	          };
	        } else if (inventario.nnoche_habilitada) {
	          return {
	            nominaDia: nominaDia, //: {id: nominaDia.id, status: status} ,
	            nominaNoche: { id: nominaNoche.id, status: status }
	          };
	        }
	      });
	      _this.setState({ checkNominas: lista });
	    };
	
	    _this.fetchNominasPendientes = function () {
	      _v2.default.nominas.getCambiosNominas(_this.state.fechaInicialSeleccionada.format(format), _this.state.fechaFinalSeleccionada.format(format)).then(function (resp) {
	        _this.setState({
	          cantCambiosNominas: resp.length
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	    _this.publicarInventarios = function () {
	      var inventarios = _this.state.inventariosFiltrados;
	      _v2.default.inventario.publicarInventarios(inventarios).then(function (resp) {
	        _this.buscarInventarios();
	      }).catch(function (error) {
	        console.log("error al publicar los inventarios", error);
	      });
	    };
	    _this.saveDepartureTime = function (idService, departureTime) {
	      _v2.default.inventario.updateDepartureTime(idService, departureTime).then(function (service) {
	        console.log("inventario actualizado correctamente");
	        _this.blackbox.actualizarInventario(service);
	        _this.setState(_this.blackbox.getListaFiltrada());
	      }).catch(function (error) {
	        console.log("error al actualizar", error);
	      });
	    };
	    _this.finishReviewLists = function (withEmail) {
	      var initDate = _this.state.fechaInicialSeleccionada.format(format);
	      var finishDate = _this.state.fechaFinalSeleccionada.format(format);
	      _v4.default.lists().finishReviewLists(initDate, finishDate, withEmail).then(console.log("ok")).catch(function (error) {
	        return console.log(error);
	      });
	    };
	    return _this;
	  }
	
	  _createClass(ProgramacionIGSemanal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (this.props.idUser == 2) {
	        this.state.fechaInicialSeleccionada = (0, _moment2.default)();
	      }
	      this.buscarInventarios(this.state.fechaInicialSeleccionada.format(format), this.state.fechaFinalSeleccionada.format(format));
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
	      this.rows = this.rows.filter(function (input) {
	        return input !== null;
	      });
	    }
	  }, {
	    key: "focusRow",
	    value: function focusRow(index, nombreElemento) {
	      var ultimoIndex = this.rows.length - 1;
	      if (index < 0) {
	        // al seleccionar "antes de la primera", se seleciona el ultimo
	        this.rows[ultimoIndex].focusElemento(nombreElemento);
	      } else if (index >= ultimoIndex) {
	        // al seleccionar "despues de la ultima", se selecciona el primero
	        this.rows[index % this.rows.length].focusElemento(nombreElemento);
	      } else {
	        // no es ni el ultimo, ni el primero
	        this.rows[index].focusElemento(nombreElemento);
	      }
	    }
	    // Metodos de los hijos
	
	  }, {
	    key: "lideresDisponibles",
	    value: function lideresDisponibles(idNominaNoche, idNominaDia) {
	      return _v2.default.nominaLideresDisponibles(idNominaNoche, idNominaDia).lideresDisponibles();
	    }
	  }, {
	    key: "auditoresSMUDisponibles",
	    value: function auditoresSMUDisponibles(idNominaNoche, idNominaDia) {
	      return _v2.default.nominaLideresDisponibles(idNominaNoche, idNominaDia).auditoresSMUDisponibles();
	    }
	  }, {
	    key: "guardarInventario",
	    value: function guardarInventario(idInventario, formInventario) {
	      var _this2 = this;
	
	      _v2.default.inventario.actualizar(idInventario, formInventario).then(function (inventarioActualizado) {
	        console.log("inventario actualizado correctamente");
	        // actualizar los datos y el state de la app
	        _this2.blackbox.actualizarInventario(inventarioActualizado);
	        // actualizar los filtros, y la lista ordenada de locales
	        _this2.setState(_this2.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
	      });
	    }
	  }, {
	    key: "guardarNomina",
	    value: function guardarNomina(idNomina, datos) {
	      var _this3 = this;
	
	      _v2.default.nomina(idNomina).actualizar(datos).then(function (inventarioActualizado) {
	        console.log("nomina actualizada correctamente");
	        // actualizar los datos y el state de la app
	        _this3.blackbox.actualizarInventario(inventarioActualizado);
	        // actualizar los filtros, y la lista ordenada de locales
	        _this3.setState(_this3.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
	      });
	    }
	  }, {
	    key: "estadoSolicitud",
	    value: function estadoSolicitud(idNomina, estado) {
	      this.guardarNomina(idNomina, estado);
	    }
	  }, {
	    key: "ordenarInventarios",
	    value: function ordenarInventarios(evt) {
	      evt.preventDefault();
	      this.blackbox.ordenarLista();
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	    // Select de Cliente seleccionado
	
	  }, {
	    key: "onSelectClienteChanged",
	    value: function onSelectClienteChanged(evt) {
	      var _this4 = this;
	
	      this.setState({
	        idCliente: evt.target.value
	      }, function () {
	        _this4.buscarInventarios();
	      });
	    }
	    // SELECT DE LIDER
	
	  }, {
	    key: "onSelectLiderChanged",
	    value: function onSelectLiderChanged(evt) {
	      this.setState({
	        idLiderMasivo: evt.target.value
	      });
	    }
	  }, {
	    key: "asignacionMasivaLider",
	    value: function asignacionMasivaLider(cambiosNominas, hideModal) {
	      var _this5 = this;
	
	      var data = [];
	      this.state.checkNominas.forEach(function (_ref2) {
	        var nominaDia = _ref2.nominaDia,
	            nominaNoche = _ref2.nominaNoche;
	
	        if (nominaDia.status && nominaNoche.status) {
	          data.push(nominaDia.id);
	          data.push(nominaNoche.id);
	        } else if (nominaDia.status) {
	          data.push(nominaDia.id);
	        } else if (nominaNoche.status) {
	          data.push(nominaNoche.id);
	        }
	      });
	
	      if (data.length == 0) {
	        console.log("No se ha seleccionado ningun inventario");
	      } else {
	        _v2.default.nominas.asignacionMasivaLider(data, cambiosNominas).then(function (response) {
	          if (response.length > 0) {
	            response.map(function (inventario) {
	              _this5.blackbox.actualizarInventario(inventario);
	            });
	            hideModal();
	          }
	          _this5.setState(_this5.blackbox.getListaFiltrada());
	        }).catch(function (error) {
	          console.log("error envio", error);
	        });
	      }
	    }
	  }, {
	    key: "onSelectRangoChanged",
	    value: function onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal) {
	      var _this6 = this;
	
	      this.setState({
	        fechaInicialSeleccionada: momentumFechaInicio,
	        fechaFinalSeleccionada: momentumFechaFinal
	      }, function () {
	        var fechaInicio = _this6.state.fechaInicialSeleccionada.format("YYYY-MM-DD");
	        var fechaFinal = _this6.state.fechaFinalSeleccionada.format("YYYY-MM-DD");
	        // se llama al metodo seleccionar semana, que hace lo mismo
	        _this6.buscarInventarios(fechaInicio, fechaFinal);
	      });
	    }
	    // Todo: recibir el idCliente desde los metodos que lo llamen
	
	  }, {
	    key: "buscarInventarios",
	    value: function buscarInventarios() {
	      var _this7 = this;
	
	      this.setState({ isLoading: true });
	      this.setState({ inventariosFiltrados: [] });
	      var idCliente = this.state.idCliente;
	      var fechaInicio = this.state.fechaInicialSeleccionada.format(format);
	      var fechaFin = this.state.fechaFinalSeleccionada.format(format);
	
	      _v2.default.inventario.buscar2(fechaInicio, fechaFin, idCliente).then(function (inventarios) {
	        _this7.blackbox.reset();
	        var filtrados = inventarios.filter(function (inventario) {
	          return inventario.cliente_nombreCorto != 'SMU AI';
	        });
	        filtrados.forEach(function (inventario) {
	          return _this7.blackbox.add(inventario);
	        });
	
	        _this7.blackbox.ordenarLista();
	        _this7.setState(_this7.blackbox.getListaFiltrada()); // {inventariosFiltrados: ...}
	        var cantidadPendientes = filtrados.filter(function (pendientes) {
	          return pendientes.inv_estadoPublicacion === 1 || pendientes.inv_estadoPublicacion === 3;
	        });
	        _this7.setState({ cantPendientesPublicacion: cantidadPendientes.length });
	        _this7.setState({ isLoading: false });
	      });
	    }
	  }, {
	    key: "actualizarFiltro",
	    value: function actualizarFiltro(nombreFiltro, filtro) {
	      this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	      // actualizar los filtros, y la lista ordenada de locales
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	  }, {
	    key: "nomina_agregarCaptador",
	    value: function nomina_agregarCaptador(idNomina, idCaptador) {
	      var _this8 = this;
	
	      _v2.default.nomina(idNomina).agregarCaptador(idCaptador).then(function (inventarioActualizado) {
	        _this8.blackbox.actualizarInventario(inventarioActualizado);
	        _this8.setState(_this8.blackbox.getListaFiltrada());
	      }).catch(function (error) {
	        console.log("error al agregar el captador", error);
	      });
	    }
	  }, {
	    key: "nomina_quitarCaptador",
	    value: function nomina_quitarCaptador(idNomina, idCaptador) {
	      var _this9 = this;
	
	      _v2.default.nomina(idNomina).quitarCaptador(idCaptador).then(function (inventarioActualizado) {
	        _this9.blackbox.actualizarInventario(inventarioActualizado);
	        _this9.setState(_this9.blackbox.getListaFiltrada());
	      }).catch(function (error) {
	        console.log("error al quitar el captador", error);
	      });
	    }
	  }, {
	    key: "nomina_cambiarAsignadosCaptador",
	    value: function nomina_cambiarAsignadosCaptador(idNomina, idCaptador, asignados) {
	      var _this10 = this;
	
	      _v2.default.nomina(idNomina).cambiarAsignadosCaptador(idCaptador, { asignados: asignados }).then(function (inventarioActualizado) {
	        _this10.blackbox.actualizarInventario(inventarioActualizado);
	        _this10.setState(_this10.blackbox.getListaFiltrada());
	      }).catch(function (error) {
	        console.log("error al asignar operadores al captador", error);
	      });
	    }
	  }, {
	    key: "nomina_agregarRegionesCaptador",
	    value: function nomina_agregarRegionesCaptador(idNomina, idCaptador, regiones) {
	      var _this11 = this;
	
	      _v2.default.nomina(idNomina).agregarRegionesCaptador(idCaptador, { regiones: regiones }).then(function (inventarioActualizado) {
	        _this11.blackbox.actualizarInventario(inventarioActualizado);
	        _this11.setState(_this11.blackbox.getListaFiltrada());
	        _this11.setState({ cerrarRegion: true });
	      }).catch(function (error) {
	        console.log("error al agregar operadores de otras regiones", error);
	      });
	    }
	
	    /*componentDidUpdate(prevProps, prevState, snapshot) {
	          if (this.state.initialChecked == false && prevProps == true) {
	              this.data = [];
	          }
	      }*/
	
	  }, {
	    key: "enviarNominaMasiva",
	    value: function enviarNominaMasiva(conCorreo) {
	      var _this12 = this;
	
	      var data = [];
	      this.state.checkNominas.forEach(function (_ref3) {
	        var nominaDia = _ref3.nominaDia,
	            nominaNoche = _ref3.nominaNoche;
	
	        if (nominaDia.status && nominaNoche.status) {
	          data.push(nominaDia.id);
	          data.push(nominaNoche.id);
	        } else if (nominaDia.status) {
	          data.push(nominaDia.id);
	        } else if (nominaNoche.status) {
	          data.push(nominaNoche.id);
	        }
	      });
	
	      if (data.length == 0) {
	        this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
	      } else {
	        this.setState({ buttonState: { state: true, texto: "Informando..." } });
	        _v2.default.nominas.enviarNominasMasiva(data, conCorreo).then(function (response) {
	          if (response.length > 0) {
	            response.map(function (inventario) {
	              _this12.blackbox.actualizarInventario(inventario);
	            });
	          }
	          _this12.setState(_this12.blackbox.getListaFiltrada());
	          _this12.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this12.refs.notificator.success('Inventarios', 'Nomina Informadas', 2 * 1000);
	        }).catch(function (error) {
	          _this12.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this12.refs.notificator.error('Inventarios', 'Error al informar nominas', 2 * 1000);
	          console.log("error envio", error);
	        });
	      }
	    }
	  }, {
	    key: "aprobarNominaMasiva",
	    value: function aprobarNominaMasiva() {
	      var _this13 = this;
	
	      var data = [];
	      this.state.checkNominas.forEach(function (_ref4) {
	        var nominaDia = _ref4.nominaDia,
	            nominaNoche = _ref4.nominaNoche;
	
	        if (nominaDia.status && nominaNoche.status) {
	          data.push(nominaDia.id);
	          data.push(nominaNoche.id);
	        } else if (nominaDia.status) {
	          data.push(nominaDia.id);
	        } else if (nominaNoche.status) {
	          data.push(nominaNoche.id);
	        }
	      });
	
	      if (data.length == 0) {
	        this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
	      } else {
	        this.setState({ buttonState: { state: true, texto: "Aprobando..." } });
	        _v2.default.nominas.aprobarNominasMasiva(data).then(function (response) {
	          if (response.length > 0) {
	            response.map(function (inventario) {
	              _this13.blackbox.actualizarInventario(inventario);
	            });
	          }
	          _this13.setState(_this13.blackbox.getListaFiltrada());
	          _this13.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this13.refs.notificator.success('Inventarios', 'Nomina Aprobadas', 3000);
	        }).catch(function (error) {
	          _this13.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this13.refs.notificator.error('Inventarios', 'Error al aprobar nominas', 3000);
	          console.log("error envio", error);
	        });
	      }
	    }
	  }, {
	    key: "rectificarNominaMasiva",
	    value: function rectificarNominaMasiva() {
	      var _this14 = this;
	
	      var data = [];
	      this.state.checkNominas.forEach(function (_ref5) {
	        var nominaDia = _ref5.nominaDia,
	            nominaNoche = _ref5.nominaNoche;
	
	        if (nominaDia.status && nominaNoche.status) {
	          data.push(nominaDia.id);
	          data.push(nominaNoche.id);
	        } else if (nominaDia.status) {
	          data.push(nominaDia.id);
	        } else if (nominaNoche.status) {
	          data.push(nominaNoche.id);
	        }
	      });
	
	      if (data.length == 0) {
	        this.refs.notificator.error('Inventarios', "No se ha seleccionado ningun inventario", 3000);
	      } else {
	        this.setState({ buttonState: { state: true, texto: "Rectificando..." } });
	        _v2.default.nominas.rectificarNominasMasiva(data).then(function (response) {
	          if (response.length > 0) {
	            response.map(function (inventario) {
	              _this14.blackbox.actualizarInventario(inventario);
	            });
	          }
	          _this14.setState(_this14.blackbox.getListaFiltrada());
	          _this14.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this14.refs.notificator.success('Inventarios', 'Nomina Rectificas.', 3000);
	        }).catch(function (error) {
	          _this14.setState({ buttonState: { state: false, texto: "Nominas Masiva" } });
	          _this14.refs.notificator.error('Inventarios', 'Error al rectificar', 3000);
	          console.log("error envio", error);
	        });
	      }
	    }
	  }, {
	    key: "updateComentarios",
	    value: function updateComentarios(idInventario, comentarios) {
	      var inventario = this.state.inventariosFiltrados.filter(function (inventario) {
	        return inventario.inv_idInventario == idInventario;
	      });
	      var inv = _extends({}, inventario[0], {
	        inv_comentarios: comentarios
	      });
	      this.blackbox.actualizarInventario(inv);
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	  }, {
	    key: "updateComentariosClientes",
	    value: function updateComentariosClientes(idLocal, comentarios) {
	      var inventario = this.state.inventariosFiltrados.filter(function (inventario) {
	        return inventario.local_idLocal == idLocal;
	      });
	      var inv = _extends({}, inventario[0], {
	        local_comentarios: comentarios
	      });
	      this.blackbox.actualizarInventario(inv);
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this15 = this;
	
	      var fechaInicial = this.state.fechaInicialSeleccionada.format(format);
	      var fechaFinal = this.state.fechaFinalSeleccionada.format(format);
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactNotify2.default, { ref: "notificator", className: ReactNotifyCSS }),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Programaci\xF3n semanal IG"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectCliente" },
	              "Cliente"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                name: "selectCliente",
	                ref: function ref(_ref6) {
	                  return _this15.inputIdCliente = _ref6;
	                },
	                value: this.state.idCliente,
	                onChange: this.onSelectClienteChanged.bind(this)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "0" },
	                "Todos"
	              ),
	              this.props.clientes.map(function (cliente, index) {
	                return _react2.default.createElement(
	                  "option",
	                  {
	                    key: index,
	                    value: cliente.idCliente
	                  },
	                  cliente.nombreCorto + " - " + cliente.nombre
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-3 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectSemana" },
	              "Rango de Fecha"
	            ),
	            _react2.default.createElement(_SelectRange2.default, {
	              startDateSelected: this.state.fechaInicialSeleccionada,
	              endDateSelected: this.state.fechaFinalSeleccionada,
	              onInit: function onInit() {
	                console.log("on init");
	              },
	              onRangeSelected: this.onSelectRangoChanged.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectCliente" },
	              "Asignaci\xF3n m\xFAltiple"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                name: "selectCliente",
	                value: this.state.idLiderMasivo,
	                onChange: this.onSelectLiderChanged.bind(this)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "" },
	                "--"
	              ),
	              this.props.lideres.map(function (usuario, index) {
	                return _react2.default.createElement(
	                  "option",
	                  {
	                    key: index,
	                    value: usuario.id
	                  },
	                  usuario.nombre1 + " " + usuario.apellidoPaterno
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-1 form-group ", style: { display: 'flex', gap: '10px', alignItems: 'center' } },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "label",
	                { className: "control-label" },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(BotonLiderMasivo, {
	                  inventariosFiltrados: this.state.checkNominas,
	                  idLiderMasivo: this.state.idLiderMasivo,
	                  liderMultiple: this.asignacionMasivaLider.bind(this),
	                  lider: this.props.lideres.find(function (usuario) {
	                    return usuario.id === parseInt(_this15.state.idLiderMasivo);
	                  }),
	                  disabled: this.state.botonLider.state
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { alignItems: 'baseline' } },
	              _react2.default.createElement(
	                "div",
	                { style: { display: 'flex', gap: '10px', alignItems: 'center' } },
	                _react2.default.createElement("input", {
	                  type: "radio",
	                  name: "suspendidos",
	                  onChange: this.actualizarFiltro.bind(this, 'filtroSuspendidos', [{ valor: false, texto: false, seleccionado: true }, { valor: true, texto: true, seleccionado: true }])
	                }),
	                " Todos"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: 'flex', gap: '10px', alignItems: 'center' } },
	                _react2.default.createElement("input", {
	                  type: "radio",
	                  name: "suspendidos",
	                  onChange: this.actualizarFiltro.bind(this, 'filtroSuspendidos', [{ valor: true, texto: true, seleccionado: true }, { valor: false, texto: false, seleccionado: false }])
	                }),
	                " Suspendidos"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundColor: 'lightblue' } },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-success btn-xs pull-right",
	              href: "/inventarios/descargar-excel-por-rango?fechaInicial=" + fechaInicial + "&fechaFinal=" + fechaFinal + "&cliente=" + this.state.idCliente
	            },
	            _react2.default.createElement("span", { className: "glyphicon glyphicon-export" }),
	            " Exportar"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-success btn-xs pull-right",
	              title: "Pulse aqu\xED para obtener planilla masiva de permisos covid19",
	              href: "/api/covid/permission/excel-download?initDate=" + fechaInicial + "&endDate=" + fechaFinal + "&idStatePayroll=5"
	            },
	            _react2.default.createElement("span", { className: "glyphicon glyphicon-export" }),
	            " Permiso Cod19"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn btn-info btn-xs pull-right",
	              target: "_blank",
	              href: "/inventarios/detalles?fechaInicio=" + fechaInicial + "&fechaFinal=" + fechaFinal
	            },
	            _react2.default.createElement("span", { className: "glyphicon glyphicon-list" }),
	            " Detalles"
	          ),
	          this.props.puedeAprobarCambiosNominas ? _react2.default.createElement(BotonCambioDotacion, {
	            fechaInicial: fechaInicial,
	            fechaFinal: fechaFinal,
	            cantCambiosNominas: this.state.cantCambiosNominas,
	            pendientes: this.fetchNominasPendientes
	          }) : null,
	          _react2.default.createElement(BotonNominaMasiva, {
	            informar: this.enviarNominaMasiva.bind(this),
	            aprobar: this.aprobarNominaMasiva.bind(this),
	            rectificar: this.rectificarNominaMasiva.bind(this),
	            disabled: this.state.buttonState.state,
	            text: this.state.buttonState.texto
	          })
	        ),
	        _react2.default.createElement(
	          _TablaSemanal2.default,
	          {
	            ordenarInventarios: this.ordenarInventarios.bind(this)
	            //initialChecked={false}
	            , handleCheckedNomina: this.setStatusCheckBoxAll.bind(this)
	            // Filtros
	            , filtros: this.state.filtros,
	            actualizarFiltro: this.actualizarFiltro.bind(this)
	          },
	          this.state.inventariosFiltrados.length === 0 ? _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { colSpan: "27", style: { textAlign: "center" } },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    padding: "60px 0",
	                    fontSize: "18px",
	                    fontWeight: "bold"
	                  }
	                },
	                this.state.isLoading ? "Cargando Inventarios..." : "No hay inventarios para mostrar en este periodo."
	              )
	            )
	          ) : this.state.inventariosFiltrados.map(function (inventario, index) {
	            var mostrarSeparador = false;
	            var sgteInventario = _this15.state.inventariosFiltrados[index + 1];
	            if (sgteInventario) mostrarSeparador = inventario.inv_fechaProgramada !== sgteInventario.inv_fechaProgramada;
	
	            //nominaDia y nominaNoche
	            var checkboxesNomina = _this15.state.checkNominas[index];
	            return _react2.default.createElement(_RowInventarioSemanal2.default
	            // Propiedades
	            , { puedeModificar: _this15.props.puedeModificar,
	              puedeModificarCaptador: _this15.props.puedeModificarCaptador,
	              puedeModificarPro: _this15.props.puedeCambiarLiderSupervisor,
	              puedeModificarDotaciones: _this15.props.puedeModificarDotaciones,
	              puedeEditarStock: _this15.props.puedeEditarStock,
	              puedeValidarComentarios: _this15.props.puedeValidarComentarios,
	              key: inventario.inv_idInventario,
	              index: index,
	              ref: function ref(_ref7) {
	                return _this15.rows[index] = _ref7;
	              },
	              inventario: inventario
	              //estado inicial checkbox nominas
	              , checkboxesNomina: checkboxesNomina,
	              setValueCheckbox: _this15.setStatusCheckBox.bind(_this15),
	              opcionesLideres: _this15.state.idCliente != 9 ? _this15.state.opcionesLideresOtros : _this15.state.opcionesLideres,
	              opcionesSupervisores: _this15.state.opcionesSupervisores,
	              captadoresDisponibles: _this15.state.captadoresDisponibles,
	              mostrarSeparador: mostrarSeparador
	              // Metodos
	              , lideresDisponibles: _this15.lideresDisponibles.bind(_this15),
	              auditoresSMUDisponibles: _this15.auditoresSMUDisponibles.bind(_this15),
	              guardarInventario: _this15.guardarInventario.bind(_this15),
	              focusRow: _this15.focusRow.bind(_this15)
	              // Metodos para modificar nomina
	              , guardarNomina: _this15.guardarNomina.bind(_this15),
	              estadoSolicitud: _this15.estadoSolicitud.bind(_this15),
	              agregarCaptador: _this15.nomina_agregarCaptador.bind(_this15),
	              quitarCaptador: _this15.nomina_quitarCaptador.bind(_this15),
	              agregarRegionesCaptador: _this15.nomina_agregarRegionesCaptador.bind(_this15),
	              cerrarRegion: _this15.state.cerrarRegion,
	              cambiarAsignados: _this15.nomina_cambiarAsignadosCaptador.bind(_this15),
	              saveDepartureTime: _this15.saveDepartureTime
	              //comentarios
	              , updateComentarios: _this15.updateComentarios.bind(_this15),
	              updateComentariosClientes: _this15.updateComentariosClientes.bind(_this15)
	            });
	          })
	        ),
	        this.props.idUser == 2 ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Estado auditorias FCV"
	          ),
	          _react2.default.createElement(_reactIframe2.default, {
	            url: "http://sig.seiconsultores.cl/auditorias/estado-general-fcv-publico",
	            width: "450px",
	            height: "450px",
	            display: "initial",
	            position: "relative",
	            allowFullScreen: true
	          })
	        ) : null
	      );
	    }
	  }]);
	
	  return ProgramacionIGSemanal;
	}(_react.Component);
	
	ProgramacionIGSemanal.propTypes = {
	  puedeModificar: _react.PropTypes.bool.isRequired,
	  puedeModificarCaptador: _react.PropTypes.bool.isRequired,
	  puedeCambiarLiderSupervisor: _react.PropTypes.bool.isRequired,
	  puedeModificarDotaciones: _react.PropTypes.bool.isRequired,
	  puedeAprobarCambiosNominas: _react.PropTypes.bool.isRequired,
	  puedeAprobarAumentoDotacion: _react.PropTypes.bool.isRequired,
	  canEditStatusService: _react.PropTypes.bool.isRequired,
	  clientes: _react.PropTypes.array.isRequired,
	  captadores: _react.PropTypes.array.isRequired,
	  supervisores: _react.PropTypes.array.isRequired,
	  lideres: _react.PropTypes.array.isRequired,
	  lideresOtros: _react.PropTypes.array.isRequired,
	  idUser: _react.PropTypes.number,
	  regiones: _react.PropTypes.array.isRequired
	};
	
	ProgramacionIGSemanal.defaultProps = {
	  puedeModificar: false
	};
	
	var BotonCambioDotacion = function BotonCambioDotacion(_ref8) {
	  var fechaInicial = _ref8.fechaInicial,
	      fechaFinal = _ref8.fechaFinal,
	      cantCambiosNominas = _ref8.cantCambiosNominas,
	      pendientes = _ref8.pendientes;
	
	  return _react2.default.createElement(
	    _Modales.ModalTrigger,
	    null,
	    function (isVisible, showModal, hideModal) {
	      return _react2.default.createElement(
	        "button",
	        { className: "btn btn-xs btn-info pull-right", onClick: showModal },
	        _react2.default.createElement("span", { className: "glyphicon glyphicon-user" }),
	        " Cambios",
	        " ",
	        cantCambiosNominas ? _react2.default.createElement(
	          "span",
	          { className: "badge" },
	          cantCambiosNominas
	        ) : null,
	        isVisible && _react2.default.createElement(_Modales.ModalCambiosNomina, {
	          fechaInicial: fechaInicial,
	          fechaFinal: fechaFinal,
	          pendientes: pendientes,
	          hideModal: hideModal
	        })
	      );
	    }
	  );
	};
	
	var BotonNominaMasiva = function BotonNominaMasiva(_ref9) {
	  var informar = _ref9.informar,
	      aprobar = _ref9.aprobar,
	      rectificar = _ref9.rectificar,
	      disabled = _ref9.disabled,
	      text = _ref9.text;
	
	
	  var number_day = (0, _moment2.default)().day();
	  return _react2.default.createElement(
	    "div",
	    { className: "btn-group pull-right" },
	    _react2.default.createElement(
	      "a",
	      {
	        className: "btn btn-warning btn-xs dropdown-toggle",
	        disabled: disabled,
	        "data-toggle": "dropdown",
	        href: "#"
	      },
	      text,
	      _react2.default.createElement("span", { className: "caret" })
	    ),
	    _react2.default.createElement(
	      "ul",
	      { className: "dropdown-menu" },
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { onClick: function onClick() {
	              return informar(true);
	            }, href: "#" },
	          "Informar"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { onClick: function onClick() {
	              return informar(false);
	            }, href: "#" },
	          "Informar (sin Correo)"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { onClick: aprobar, href: "#" },
	          "Aprobar"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { onClick: rectificar, href: "#" },
	          "Rechazar/Rectificar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProgramacionIGSemanal;
	
	var BotonLiderMasivo = function BotonLiderMasivo(_ref10) {
	  var inventariosFiltrados = _ref10.inventariosFiltrados,
	      idLiderMasivo = _ref10.idLiderMasivo,
	      liderMultiple = _ref10.liderMultiple,
	      lider = _ref10.lider,
	      disabled = _ref10.disabled;
	
	  var arr = [];
	  arr.length = 0;
	  inventariosFiltrados.forEach(function (_ref11) {
	    var nominaDia = _ref11.nominaDia,
	        nominaNoche = _ref11.nominaNoche;
	
	    if (nominaDia.status && nominaNoche.status) {
	      arr.push(nominaDia.id);
	      arr.push(nominaNoche.id);
	    } else if (nominaDia.status) {
	      arr.push(nominaDia.id);
	    } else if (nominaNoche.status) {
	      arr.push(nominaNoche.id);
	    }
	  });
	  if (arr.length > 0) {
	    return _react2.default.createElement(
	      _Modales.ModalTrigger,
	      null,
	      function (isVisible, showModal, hideModal) {
	        return _react2.default.createElement(
	          "button",
	          { className: "btn btn-md btn-success", onClick: showModal },
	          _react2.default.createElement("span", { className: "glyphicon glyphicon-ok" }),
	          isVisible && _react2.default.createElement(_Modales.ModalLiderMasivo, {
	            hideModal: hideModal,
	            totalInventarios: arr.length,
	            liderMultiple: liderMultiple,
	            idLiderMasivo: idLiderMasivo ? "" + idLiderMasivo : "",
	            lider: lider
	          })
	        );
	      }
	    );
	  } else {
	    return _react2.default.createElement(
	      _Modales.ModalTrigger,
	      null,
	      function (isVisible, showModal, hideModal) {
	        return _react2.default.createElement(
	          "button",
	          { className: "btn btn-md btn-success", onClick: showModal },
	          _react2.default.createElement("span", { className: "glyphicon glyphicon-ok" }),
	          isVisible && _react2.default.createElement(_Modales.ModalLiderMasivo0Nominas, { hideModal: hideModal })
	        );
	      }
	    );
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ProgramacionIGSemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	var axiosRaw = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	    // Si existe un problema de red, terminar la promesa
	    if (response instanceof Error) {
	        return Promise.reject(response.message);
	    } else {
	        return Promise.resolve(response.data);
	    }
	});
	axiosRaw.interceptors.response.use(function (response) {
	    // Si existe un problema de red, terminar la promesa
	    if (response instanceof Error) {
	        return Promise.reject(response);
	    } else {
	        return Promise.resolve(response);
	    }
	});
	
	exports.default = {
	    admin: {
	        calendar: {
	            getDays: function getDays(month, statusDays) {
	                return axios.get('/api/calendar/search-days?month=' + month + '&statusDays=' + statusDays);
	            },
	            updateStatusDay: function updateStatusDay(day, statusDay) {
	                return axios.put('/api/calendar/day/' + day + '/update-status', { statusDay: statusDay });
	            },
	            updateCommentDay: function updateCommentDay(day, comment) {
	                return axios.put('/api/calendar/day/' + day + '/update-comment', { comment: comment });
	            }
	        }
	    },
	    client: function client(idClient) {
	        return {
	            getEmailsBilling: function getEmailsBilling() {
	                return axios.get('/api/client/' + idClient + '/email-billing');
	            },
	            addEmailBilling: function addEmailBilling(dataEmail) {
	                return axios.post('/api/client/' + idClient + '/email-billing', dataEmail);
	            },
	            deleteEmailBilling: function deleteEmailBilling(idEmail) {
	                return axios.delete('/api/email-billing/' + idEmail);
	            }
	        };
	    },
	    billing: function billing() {
	        return {
	            getServicesByMonthAndClient: function getServicesByMonthAndClient(idClient, month) {
	                return axios.get('/api/billing/services-fsb?id_client=' + idClient + '&month=' + month + '&billable=true&calculate_totals=true&order=desc');
	            },
	            getServicesBillingFsb: function getServicesBillingFsb(idBillingRequest) {
	                return axios.get('/api/billing/services-fsb?id_billing_request=' + idBillingRequest + '&calculate_totals=true');
	            },
	            getServices: function getServices(idClient, initDate, finishDate) {
	                return axios.get('/api/billing/services?id_client=' + idClient + '&init_date=' + initDate + '&finish_date=' + finishDate);
	            },
	            setStatusPaymentService: function setStatusPaymentService(idService, statusClient) {
	                return axios.post('/api/billing/service/' + idService + '/status-client', { statusClient: statusClient });
	            },
	            setStatusPaymentAllService: function setStatusPaymentAllService(idBillingRequest, statusClient) {
	                return axios.post('/api/billing/services/status-client-all', { idBillingRequest: idBillingRequest, statusClient: statusClient });
	            },
	            getBillingRequest: function getBillingRequest(idBillingRequest) {
	                return axios.get('/api/billing/billing-request?idBillingRequest=' + idBillingRequest);
	            },
	            dischargeServices: function dischargeServices(idBillingRequest) {
	                return axios.post('/api/billing-request/' + idBillingRequest + '/discharge-services');
	            },
	            dischargeOC: function dischargeOC(idBillingRequest) {
	                return axios.post('/api/billing-request/' + idBillingRequest + '/discharge-oc');
	            },
	            assignOC: function assignOC(idBillingRequest, data) {
	                return axios.post('/api/billing-request/' + idBillingRequest + '/assign-oc', data);
	            },
	            rejectRequest: function rejectRequest(idBillingRequest, msg) {
	                return axios.post('/api/billing-request/' + idBillingRequest + '/reject-oc', { msg: msg });
	            }
	        };
	    },
	    lists: function lists() {
	        return {
	            finishReviewLists: function finishReviewLists(initDate, finishDate, withEmail) {
	                return axios.post('/api/lists/approve-review', { initDate: initDate, finishDate: finishDate, withEmail: withEmail });
	            }
	        };
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "v2.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var estadoNominas = ['-', // 0 - nunca ocurre
	'Deshabilitada', // 1 - Deshabilitada
	'Pendiente', // 2 - Pendiente
	'Recibida', // 3 - Recibida
	'Aprobada', // 4 - Aprobada
	'Informada', // 5 - Informada
	'Inform. Excel' // 6 - Informada con Excel (plataforma antigua)
	];
	var estadoConteo = ['Sin Calificación', 'Peligro', 'Precaución', 'Óptima', 'Sobre Dotación', 'Sobre Dotación Alta'];
	
	var BlackBoxIGSemanal = function () {
	    function BlackBoxIGSemanal() {
	        _classCallCheck(this, BlackBoxIGSemanal);
	
	        this.lista = [];
	        this.filtroRegiones = [];
	        this.filtroComunas = [];
	        this.filtroTurnos = [];
	        this.filtroLideres = [];
	        this.filtroSupervisores = [];
	        this.filtroCaptadores = [];
	        this.filtroCeco = [];
	        this.filtroFechas = [];
	        this.filtroHoraLider = [];
	        this.filtroNominas = [];
	        this.filtroClientes = [];
	        this.filtroNominasEstado = [];
	        this.filtroAsistencia = [];
	        this.filtroEgreso = [];
	        this.filtroUnidades = [];
	        this.filtroSuspendidos = [];
	    }
	
	    _createClass(BlackBoxIGSemanal, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroRegiones = [];
	            this.filtroComunas = [];
	            this.filtroTurnos = [];
	            this.filtroLideres = [];
	            this.filtroSupervisores = [];
	            this.filtroCaptadores = [];
	            this.filtroCeco = [];
	            this.filtroFechas = [];
	            this.filtroHoraLider = [];
	            this.filtroNominas = [];
	            this.filtroClientes = [];
	            this.filtroNominasEstado = [];
	            this.filtroAsistencia = [];
	            this.filtroEgreso = [];
	            this.filtroUnidades = [];
	            this.filtroSuspendidos = [];
	        }
	        // Todo: Optimizar
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'add',
	        value: function add(inventario) {
	            this.lista.push(inventario);
	        }
	
	        // Todo modificar el listado de clientes
	
	    }, {
	        key: 'actualizarInventario',
	        value: function actualizarInventario(inventarioActualizado) {
	            this.lista = this.lista.map(function (inventario) {
	                if (inventario.inv_idInventario == inventarioActualizado.inv_idInventario) {
	                    return inventarioActualizado;
	                }
	                return inventario;
	            });
	            this.actualizarFiltros();
	        }
	
	        /*** ################### FILTROS ################### ***/
	
	    }, {
	        key: 'ordenarLista',
	        value: function ordenarLista() {
	            var porFechaProgramada = function porFechaProgramada(inventario) {
	                var dateA = new Date(inventario.inv_fechaProgramada);
	                if (dateA == 'Invalid Date') {
	                    var _inventario$inv_fecha = inventario.inv_fechaProgramada.split('-'),
	                        _inventario$inv_fecha2 = _slicedToArray(_inventario$inv_fecha, 3),
	                        annoA = _inventario$inv_fecha2[0],
	                        mesA = _inventario$inv_fecha2[1],
	                        diaA = _inventario$inv_fecha2[2];
	                    // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
	
	
	                    return new Date(annoA + '-' + mesA) - 1;
	                } else {
	                    return dateA;
	                }
	            };
	            var porCliente = function porCliente(inventario) {
	                return inventario.cliente_idCliente;
	            };
	            var porStockTeorico = function porStockTeorico(inventario) {
	                return inventario.inv_stockTeorico;
	            };
	
	            // ordenar por fechaprogramada, y por stock
	            this.lista = _lodash2.default.orderBy(this.lista, [porFechaProgramada, porCliente, porStockTeorico], ['asc', 'asc', 'desc']);
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            // ##### Filtro fechas
	            this.filtroFechas = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var momentFecha = (0, _moment2.default)(inventario.inv_fechaProgramada);
	                var valor = inventario.inv_fechaProgramada;
	                var texto = momentFecha.isValid() ? momentFecha.format('dddd DD MMMM') : '-- ' + inventario.inv_fechaProgramada + ' --';
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFechas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Regiones
	            this.filtroRegiones = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.local_cutRegion;
	                var texto = inventario.local_region;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroRegiones, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de region
	            .value();
	
	            // ##### Filtro Comunas (ordenado por codComuna)
	            this.filtroComunas = _lodash2.default.chain(this.lista)
	            // solo dejar las comunas en las que su respectiva region este seleccionada
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this.filtroRegiones, { 'valor': inventario.local_cutRegion, 'seleccionado': true });
	            }).map(function (inventario) {
	                var valor = inventario.local_cutComuna;
	                var texto = inventario.local_comuna;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroComunas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Turnos
	            this.filtroTurnos = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.inv_idJornada;
	                var texto = inventario.inv_jornada;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroTurnos, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            this.filtroEgreso = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.store_departureTime;
	                var texto = inventario.store_departureTime;
	                var opcion = _lodash2.default.find(_this.filtroEgreso, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            this.filtroUnidades = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo';
	                var texto = inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo';
	                var opcion = _lodash2.default.find(_this.filtroUnidades, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Lideres, considerar el lider solo si la jornada de la nomina se encuentra activa
	            var lideresDia = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	
	                var valor = inventario.ndia_idLider;
	                var texto = inventario.ndia_lider; //'-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroLideres, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var lideresNoche = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	                var valor = inventario.nnoche_idLider;
	                var texto = inventario.nnoche_lider; //  '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroLideres, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroLideres = _lodash2.default.chain(lideresDia).unionBy(lideresNoche, 'valor').uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro horaLider
	            var hrsLiderDia = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	
	                var valor = inventario.ndia_hrLider;
	                var texto = inventario.ndia_hrLider; //'-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroHoraLider, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var hrsLiderNoche = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	                var valor = inventario.nnoche_hrLider;
	                var texto = inventario.nnoche_hrLider; //  '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroHoraLider, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroHoraLider = _lodash2.default.chain(hrsLiderDia).unionBy(hrsLiderNoche, 'valor').uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Supervisores, considerar el supervisor solo si la jornada de la nomina se encuentra activa
	            var supervisoresDia = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	
	                var valor = inventario.ndia_idSupervisor;
	                var texto = inventario.ndia_supervisor; //'-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroSupervisores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var supervisoresNoche = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	                var valor = inventario.nnoche_idSupervisor;
	                var texto = inventario.nnoche_supervisor; //  '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroSupervisores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroSupervisores = _lodash2.default.chain(supervisoresDia).unionBy(supervisoresNoche, 'valor').uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Captador, considerar el lider solo si la jornada de la nomina se encuentra activa
	            //const reducer = (previousValue, currentValue) => previousValue.concat(currentValue);
	
	            var captadoresDia = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).flatMap(function (inventario) {
	                return inventario.ndia_captadores;
	            }).uniqBy('idUsuario').map(function (captador) {
	                var valor = captador.idUsuario;
	                var texto = captador.nombre; // '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCaptadores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var captadoresNoche = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).flatMap(function (inventario) {
	                //let valor = inventario.nnoche_idCaptador1
	                //let texto = inventario.nnoche_captador1     // '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                //let opcion = _.find(this.filtroCaptadores, {'valor': valor})
	                //return opcion? opcion : {valor, texto, seleccionado: true}
	                return inventario.nnoche_captadores;
	            }).uniqBy('idUsuario').map(function (captador) {
	                var valor = captador.idUsuario;
	                var texto = captador.nombre; // '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCaptadores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroCaptadores = _lodash2.default.chain(captadoresDia).unionBy(captadoresNoche, 'valor').uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Numero de Local
	            this.filtroCeco = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.local_ceco;
	                var texto = '' + auditoria.local_ceco; // debe ser un string
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCeco, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy(function (op) {
	                return op.valor.length;
	            }, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
	            .value();
	
	            var nominasDia = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	
	                var valor = inventario.ndia_idEstadoNomina;
	                var texto = estadoNominas[inventario.ndia_idEstadoNomina]; //'-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroNominas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var nominasNoche = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	                var valor = inventario.nnoche_idEstadoNomina;
	                var texto = estadoNominas[inventario.nnoche_idEstadoNomina]; //  '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroNominas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroNominas = _lodash2.default.chain(nominasDia).unionBy(nominasNoche, 'valor').uniqBy('valor').sortBy('valor').value();
	
	            // ###### Filtro estado de nominas
	            var nominasDiaEstado = _lodash2.default.chain(this.lista)
	            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	
	                var valor = inventario.ndia_calificacionNomina;
	                var texto = estadoConteo[inventario.ndia_calificacionNomina]; //'-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroNominasEstado, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            var nominasNocheEstado = _lodash2.default.chain(this.lista)
	            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
	            .filter(function (inventario) {
	                return inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4';
	            }).map(function (inventario) {
	                var valor = inventario.nnoche_calificacionNomina;
	                var texto = estadoConteo[inventario.nnoche_calificacionNomina]; //  '-- NO ASIGNADO --'
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroNominasEstado, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
	            this.filtroNominasEstado = _lodash2.default.chain(nominasDiaEstado).unionBy(nominasNocheEstado, 'valor').uniqBy('valor').sortBy('valor').value();
	            var filtroAnterior = this.filtroAsistencia;
	            this.filtroAsistencia = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var titularesDia = inventario.ndia_totalTitulares.filter(function (row) {
	                    return !row.lider;
	                });
	                var titularesNoche = inventario.nnoche_totalTitulares.filter(function (row) {
	                    return !row.lider;
	                });
	                console.log('titularesDia', titularesDia);
	                console.log('titularesNoche', titularesNoche);
	                var status_asistencia_global_dia = titularesDia.length !== 0 ? titularesDia.every(function (row) {
	                    return row.estado_asistencia >= 3;
	                }) : false;
	                var status_asistencia_global_noche = titularesNoche.length !== 0 ? titularesNoche.every(function (row) {
	                    return row.estado_asistencia >= 3;
	                }) : false;
	
	                var status_asistencia_global = inventario.inv_idJornada == 2 ? status_asistencia_global_dia : inventario.inv_idJornada == 3 ? status_asistencia_global_noche : false;
	                var valor = status_asistencia_global;
	                var texto = status_asistencia_global ? 'Verde' : 'Rojo';
	                var opcion = _lodash2.default.find(filtroAnterior, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	            this.filtroSuspendidos = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var esSuspendido = false;
	                if (inventario.inv_idJornada == 2) {
	                    esSuspendido = inventario.inv_suspendido == 1 || inventario.ndia_idLider == 10;
	                } else if (inventario.inv_idJornada == 3) {
	                    esSuspendido = inventario.inv_suspendido == 1 || inventario.nnoche_idLider == 10;
	                }
	                var valor = esSuspendido;
	                var texto = esSuspendido;
	                var opcion = _lodash2.default.find(_this.filtroSuspendidos, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Clientes
	            this.filtroClientes = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.cliente_idCliente;
	                var texto = inventario.cliente_nombreCorto;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroClientes, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de cliente
	            .value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	            var data = _lodash2.default.chain(this.lista)
	            // Filtrar por Ceco
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroCeco, { 'valor': '' + inventario.local_ceco, 'seleccionado': true });
	            })
	            // Filtrar por Regiones
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroRegiones, { 'valor': inventario.local_cutRegion, 'seleccionado': true });
	            })
	            // Filtrar por Comunas
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroComunas, { 'valor': inventario.local_cutComuna, 'seleccionado': true });
	            })
	            // Filtrar por Turno
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroTurnos, { 'valor': inventario.inv_idJornada, 'seleccionado': true });
	            })
	            // Filtrar por Lideres
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar si el lider esta en la nomina_dia
	                    return _lodash2.default.find(_this2.filtroLideres, { 'valor': inventario.ndia_idLider, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
	                    return _lodash2.default.find(_this2.filtroLideres, { 'valor': inventario.nnoche_idLider, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
	                    return _lodash2.default.find(_this2.filtroLideres, { 'valor': inventario.ndia_idLider, 'seleccionado': true }) || _lodash2.default.find(_this2.filtroLideres, { 'valor': inventario.nnoche_idLider, 'seleccionado': true });
	                }
	            })
	            // Filtrar por hora lider
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar si el lider esta en la nomina_dia
	                    return _lodash2.default.find(_this2.filtroHoraLider, { 'valor': inventario.ndia_hrLider, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
	                    return _lodash2.default.find(_this2.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
	                    return _lodash2.default.find(_this2.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true }) || _lodash2.default.find(_this2.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true });
	                }
	            })
	            // Filtrar por Supervisores
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay supervisor seleccionado
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar si el supervisor esta en la nomina_dia
	                    return _lodash2.default.find(_this2.filtroSupervisores, { 'valor': inventario.ndia_idSupervisor, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', se debe buscar el supervisor en la nomina_noche
	                    return _lodash2.default.find(_this2.filtroSupervisores, { 'valor': inventario.nnoche_idSupervisor, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar el supervisor en la nomina_dia y nomina_noche
	                    return _lodash2.default.find(_this2.filtroSupervisores, { 'valor': inventario.ndia_idSupervisor, 'seleccionado': true }) || _lodash2.default.find(_this2.filtroSupervisores, { 'valor': inventario.nnoche_idSupervisor, 'seleccionado': true });
	                }
	            })
	            // Filtrar por Captadores
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar si el lider esta en la nomina_dia
	                    //return _.find(this.filtroCaptadores, {'valor': inventario.ndia_idCaptador1, 'seleccionado': true})
	                    var caps = inventario.ndia_captadores.filter(function (captador) {
	                        var result = _lodash2.default.find(_this2.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true });
	                        if (result != undefined) {
	                            return true;
	                        }
	                    });
	                    return caps.length > 0;
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
	                    var _caps = inventario.nnoche_captadores.filter(function (captador) {
	                        var result = _lodash2.default.find(_this2.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true });
	                        if (result != undefined) {
	                            return true;
	                        }
	                    });
	                    return _caps.length > 0;
	                    //return _.find(this.filtroCaptadores, {'valor': inventario.nnoche_idCaptador1, 'seleccionado': true})
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
	                    /*return _.find(this.filtroCaptadores, {'valor': inventario.ndia_idCaptador1, 'seleccionado': true})
	                        || _.find(this.filtroCaptadores, {'valor': inventario.nnoche_idCaptador1, 'seleccionado': true})*/
	                    var capsdia = inventario.ndia_captadores.filter(function (captador) {
	                        var result = _lodash2.default.find(_this2.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true });
	                        if (result != undefined) {
	                            return true;
	                        }
	                    });
	
	                    var capsnoche = inventario.nnoche_captadores.filter(function (captador) {
	                        var result = _lodash2.default.find(_this2.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true });
	                        if (result != undefined) {
	                            return true;
	                        }
	                    });
	                    return capsdia.length > 0 || capsnoche.length > 0;
	                }
	            })
	            // Filtrar por Fecha (dejar de lo ultimo, ya que es la mas lenta -comparacion de strings-)
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroFechas, { 'valor': inventario.inv_fechaProgramada, 'seleccionado': true });
	            })
	            // Filtrar por Nominas
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar nomina de dia
	                    return _lodash2.default.find(_this2.filtroNominas, { 'valor': inventario.ndia_idEstadoNomina, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', revizar nomina_noche
	                    return _lodash2.default.find(_this2.filtroNominas, { 'valor': inventario.nnoche_idEstadoNomina, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar nomina_dia y nomina_noche
	                    return _lodash2.default.find(_this2.filtroNominas, { 'valor': inventario.ndia_idEstadoNomina, 'seleccionado': true }) || _lodash2.default.find(_this2.filtroNominas, { 'valor': inventario.nnoche_idEstadoNomina, 'seleccionado': true });
	                }
	            })
	            // Filtrar por Nominas Estado
	            .filter(function (inventario) {
	                if (inventario.inv_idJornada == '1') {
	                    // la jornada no ha sido seleccionada, no hay ninguna nomina activa
	                    return true;
	                } else if (inventario.inv_idJornada == '2') {
	                    // si la jornada es de dia, revisar nomina de dia
	                    return _lodash2.default.find(_this2.filtroNominasEstado, { 'valor': inventario.ndia_calificacionNomina, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '3') {
	                    // si la jornada es 'noche', revizar nomina_noche
	                    return _lodash2.default.find(_this2.filtroNominasEstado, { 'valor': inventario.nnoche_calificacionNomina, 'seleccionado': true });
	                } else if (inventario.inv_idJornada == '4') {
	                    // si la jornada es 'dia y noche', se debe buscar nomina_dia y nomina_noche
	                    return _lodash2.default.find(_this2.filtroNominasEstado, { 'valor': inventario.ndia_calificacionNomina, 'seleccionado': true }) || _lodash2.default.find(_this2.filtroNominasEstado, { 'valor': inventario.nnoche_calificacionNomina, 'seleccionado': true });
	                }
	            })
	            // Filtrar por asistencia (VERDE / ROJO)
	            .filter(function (inventario) {
	                // Excluir al líder del cálculo de asistencia
	                var titularesDia = inventario.ndia_totalTitulares.filter(function (row) {
	                    return !row.lider;
	                });
	                var titularesNoche = inventario.nnoche_totalTitulares.filter(function (row) {
	                    return !row.lider;
	                });
	                // Recalcular estado global (igual que en actualización)
	                var status_asistencia_global_dia = titularesDia.length !== 0 && titularesDia.every(function (row) {
	                    return row.estado_asistencia >= 3;
	                });
	                var status_asistencia_global_noche = titularesNoche.length !== 0 && titularesNoche.every(function (row) {
	                    return row.estado_asistencia >= 3;
	                });
	                var status_asistencia_global = inventario.inv_idJornada == 2 ? status_asistencia_global_dia : inventario.inv_idJornada == 3 ? status_asistencia_global_noche : false;
	                return _lodash2.default.find(_this2.filtroAsistencia, {
	                    valor: status_asistencia_global,
	                    seleccionado: true
	                });
	            })
	            // Filtrar por Clientes
	            .filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroClientes, { 'valor': inventario.cliente_idCliente, 'seleccionado': true });
	            }).filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroEgreso, { 'valor': inventario.store_departureTime, 'seleccionado': true });
	            }).filter(function (inventario) {
	                return _lodash2.default.find(_this2.filtroUnidades, { 'valor': inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo', 'seleccionado': true });
	            }).filter(function (inventario) {
	                var esSuspendido = false;
	                if (inventario.inv_idJornada == 2) {
	                    esSuspendido = inventario.inv_suspendido == 1 || inventario.ndia_idLider == 10;
	                } else if (inventario.inv_idJornada == 3) {
	                    esSuspendido = inventario.inv_suspendido == 1 || inventario.nnoche_idLider == 10;
	                }
	                return _lodash2.default.find(_this2.filtroSuspendidos, { 'valor': esSuspendido, 'seleccionado': true });
	            }).value();
	
	            return {
	                inventariosFiltrados: data,
	                filtros: {
	                    filtroRegiones: this.filtroRegiones,
	                    filtroComunas: this.filtroComunas,
	                    filtroTurnos: this.filtroTurnos,
	                    filtroLideres: this.filtroLideres,
	                    filtroSupervisores: this.filtroSupervisores,
	                    filtroCaptadores: this.filtroCaptadores,
	                    filtroCeco: this.filtroCeco,
	                    filtroFechas: this.filtroFechas,
	                    filtroHoraLider: this.filtroHoraLider,
	                    filtroNominas: this.filtroNominas,
	                    filtroClientes: this.filtroClientes,
	                    filtroNominasEstado: this.filtroNominasEstado,
	                    filtroAsistencia: this.filtroAsistencia,
	                    filtroEgreso: this.filtroEgreso,
	                    filtroUnidades: this.filtroUnidades,
	                    filtroSuspendidos: this.filtroSuspendidos
	                },
	                checkNominas: data.map(function (inv) {
	                    return {
	                        //id: inv.inv_idInventario,
	                        nominaDia: { id: inv.ndia_idNomina, status: false },
	                        nominaNoche: { id: inv.nnoche_idNomina, status: false }
	                    };
	                }) //[{ id: idInventario, status: status }]
	            };
	        }
	    }]);
	
	    return BlackBoxIGSemanal;
	}();
	
	exports.default = BlackBoxIGSemanal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxIGSemanal.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(626);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _TablaSemanal = __webpack_require__(641);
	
	var css = _interopRequireWildcard(_TablaSemanal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios() {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).apply(this, arguments));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _container2.default,
	                { type: _react2.default.DOM.table, className: "table table-bordered table-condensed " + css.tableFixed },
	                _react2.default.createElement(
	                    'colgroup',
	                    null,
	                    _react2.default.createElement('col', { className: css.thCorrelativo }),
	                    _react2.default.createElement('col', { className: css.thLogistica }),
	                    _react2.default.createElement('col', { className: css.thLogistica }),
	                    _react2.default.createElement('col', { className: css.thFecha }),
	                    _react2.default.createElement('col', { className: css.thCliente }),
	                    _react2.default.createElement('col', { className: css.thCeco }),
	                    _react2.default.createElement('col', { className: css.thRegion }),
	                    _react2.default.createElement('col', { className: css.thComuna }),
	                    _react2.default.createElement('col', { className: css.thTurno }),
	                    _react2.default.createElement('col', { className: css.thTienda }),
	                    _react2.default.createElement('col', { className: css.thStock }),
	                    _react2.default.createElement('col', { className: css.thDotacionTotal }),
	                    _react2.default.createElement('col', { className: css.thUsuario }),
	                    _react2.default.createElement('col', { className: css.thHora }),
	                    _react2.default.createElement('col', { className: css.thHora }),
	                    _react2.default.createElement('col', { className: css.thUsuario }),
	                    _react2.default.createElement('col', { className: css.thUsuario }),
	                    _react2.default.createElement('col', { className: css.thHora }),
	                    _react2.default.createElement('col', { className: css.thDireccion }),
	                    _react2.default.createElement('col', { className: css.thCheckboxNomina }),
	                    _react2.default.createElement('col', { className: css.thNomina }),
	                    _react2.default.createElement('col', { className: css.thNominaEstado }),
	                    _react2.default.createElement('col', { className: css.thPatentes }),
	                    _react2.default.createElement('col', { className: css.thPda }),
	                    _react2.default.createElement('col', { className: css.thUnidadesReales }),
	                    _react2.default.createElement('col', { className: css.thArchivoFinal })
	                ),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        _sticky2.default,
	                        {
	                            topOffset: -50,
	                            type: _react2.default.DOM.tr,
	                            stickyStyle: { top: '50px' } },
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCorrelativo },
	                            '#'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thLogistica },
	                            'Log'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thInv },
	                            'INV'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thFecha },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Fecha',
	                                filtro: this.props.filtros.filtroFechas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroFechas')
	                                // se quita el boton de ordenar por dos motivos:
	                                // 1) espacio
	                                // 2) todas las listas por defecto se ordenan en la vista semanal, solo en la mensual se desordenan
	                                , ordenarLista: this.props.ordenarInventarios
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCliente },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'CL',
	                                filtro: this.props.filtros.filtroClientes || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroClientes'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCeco },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'CE',
	                                filtro: this.props.filtros.filtroCeco || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroCeco'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thRegion },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'R',
	                                filtro: this.props.filtros.filtroRegiones || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroRegiones'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thComuna },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Comuna',
	                                filtro: this.props.filtros.filtroComunas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroComunas')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thTurno },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'T',
	                                filtro: this.props.filtros.filtroTurnos || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroTurnos')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thTienda },
	                            'Tienda'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thStock },
	                            'Stock'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thDotacionTotal },
	                            'Dot.Total'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thUsuario },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Lider',
	                                filtro: this.props.filtros.filtroLideres || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroLideres')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thHora },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Hr.Lider',
	                                filtro: this.props.filtros.filtroHoraLider || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroHoraLider')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thHora },
	                            'Hr.Equipo'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thUsuario },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Supervisor',
	                                filtro: this.props.filtros.filtroSupervisores || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroSupervisores')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thUsuario },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Captador',
	                                filtro: this.props.filtros.filtroCaptadores || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroCaptadores')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thHora },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Egreso',
	                                filtro: this.props.filtros.filtroEgreso || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroEgreso')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thDireccion },
	                            'Direcci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCheckboxNomina },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                onChange: function onChange(e) {
	                                    return _this2.props.handleCheckedNomina(e.target.checked);
	                                }
	                                //checked = {this.props.initialChecked}
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thNomina },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'N\xF3mina',
	                                filtro: this.props.filtros.filtroNominas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroNominas')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thNominaEstado },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'E',
	                                filtro: this.props.filtros.filtroNominasEstado || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroNominasEstado')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thPatentes },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'R',
	                                filtro: this.props.filtros.filtroAsistencia || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroAsistencia')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thPatentes },
	                            'PTT'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thPda },
	                            'PDA'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thUnidadesReales },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'U/Con',
	                                filtro: this.props.filtros.filtroUnidades || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroUnidades')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thArchivoFinal },
	                            'Acta'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	TablaInventarios.propTypes = {
	    // Objetos
	    filtros: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.array).isRequired,
	    // Metodos
	    ordenarInventarios: _react2.default.PropTypes.func.isRequired,
	    actualizarFiltro: _react2.default.PropTypes.func.isRequired
	};
	exports.default = TablaInventarios;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaSemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"TablaSemanal__tableFixed___17mjr","trSeparador":"TablaSemanal__trSeparador___19UUw","thCorrelativo":"TablaSemanal__thCorrelativo___26G0K","tdCorrelativo":"TablaSemanal__tdCorrelativo___1ao6d","thFecha":"TablaSemanal__thFecha___2bCH3","tdFecha":"TablaSemanal__tdFecha___2ml9x","thCliente":"TablaSemanal__thCliente___2KSrj","tdCliente":"TablaSemanal__tdCliente___1iYsi","thCeco":"TablaSemanal__thCeco___3f5pJ","tdCeco":"TablaSemanal__tdCeco___2PMlW","tdTolltip":"TablaSemanal__tdTolltip___2g3zD","thRegion":"TablaSemanal__thRegion___2ix4c","tdRegion":"TablaSemanal__tdRegion___2TScE","thComuna":"TablaSemanal__thComuna___nBn0Z","tdComuna":"TablaSemanal__tdComuna___I5oWo","thTurno":"TablaSemanal__thTurno___1gXMP","tdTurno":"TablaSemanal__tdTurno___1y-nP","thTienda":"TablaSemanal__thTienda___rTppo","tdTienda":"TablaSemanal__tdTienda___2wn_q","thStock":"TablaSemanal__thStock___1ToKY","tdStock":"TablaSemanal__tdStock___1R1UF","thDotacionTotal":"TablaSemanal__thDotacionTotal___fW0xZ","tdDotacionTotal":"TablaSemanal__tdDotacionTotal___kwJff","thUsuario":"TablaSemanal__thUsuario___1-ZY0","tdUsuario":"TablaSemanal__tdUsuario___1rkxy","thDotacion":"TablaSemanal__thDotacion___1M-8G","tdDotacion":"TablaSemanal__tdDotacion___2m2KO","thHora":"TablaSemanal__thHora___3Y142","tdHora":"TablaSemanal__tdHora___2hWfM","thDireccion":"TablaSemanal__thDireccion___9fv5W","tdDireccion":"TablaSemanal__tdDireccion___2YDaQ","thCheckboxNomina":"TablaSemanal__thCheckboxNomina___h0u-v","tdCheckboxNomina":"TablaSemanal__tdCheckboxNomina___19pwp","thNomina":"TablaSemanal__thNomina___3nsRH","tdNomina":"TablaSemanal__tdNomina___3TKsL","thNominaEstado":"TablaSemanal__thNominaEstado___2HYdZ","tdNominaEstado":"TablaSemanal__tdNominaEstado___3IoyH","thLogistica":"TablaSemanal__thLogistica___3nOtA","tdLogistica":"TablaSemanal__tdLogistica___2lkQe","thInv":"TablaSemanal__thInv___3owJq","tdInv":"TablaSemanal__tdInv___9Z8wo","tdReportes":"TablaSemanal__tdReportes___PhvCc","thPatentes":"TablaSemanal__thPatentes___3swJo","tdPatentes":"TablaSemanal__tdPatentes___CrKZ4","thPda":"TablaSemanal__thPda___V0wAj","tdPda":"TablaSemanal__tdPda___2FW2m","thUnidadesReales":"TablaSemanal__thUnidadesReales___rQSnM","tdUnidadesReales":"TablaSemanal__tdUnidadesReales___3mqrs","thUnidadesTeoricas":"TablaSemanal__thUnidadesTeoricas___22Sfh","tdUnidadesTeoricas":"TablaSemanal__tdUnidadesTeoricas___2hTF9","thArchivoFinal":"TablaSemanal__thArchivoFinal___3Lz8v","tdArchivoFinal":"TablaSemanal__tdArchivoFinal___3iuPF","textoConTooltip":"TablaSemanal__textoConTooltip___Wr16z","tooltip":"TablaSemanal__tooltip___1uVF7","tooltiptext":"TablaSemanal__tooltiptext___3imGu","tooltipbox":"TablaSemanal__tooltipbox___2w3oN","nominaNuncaInformada":"TablaSemanal__nominaNuncaInformada___10-1B","tablaInfoNomina":"TablaSemanal__tablaInfoNomina___2iJTD","tablaNominaAnterior":"TablaSemanal__tablaNominaAnterior___1jbHE","mytooltip":"TablaSemanal__mytooltip___25vWC","mytooltipInside":"TablaSemanal__mytooltipInside___2J_KL","tooltipTable":"TablaSemanal__tooltipTable___1NlNm","tooltipTableInside":"TablaSemanal__tooltipTableInside___2iwwF","tooltipTableNominaAnterior":"TablaSemanal__tooltipTableNominaAnterior___2AqaN","auditoriaSMU":"TablaSemanal__auditoriaSMU___2-PYD","radioButton0":"TablaSemanal__radioButton0___1DTTG","radioButton1":"TablaSemanal__radioButton1___3yXnR","radioButton2":"TablaSemanal__radioButton2___3w0-3","radioButton3":"TablaSemanal__radioButton3___ORLP6","asistencia_0":"TablaSemanal__asistencia_0___1RKZ-","asistencia_1":"TablaSemanal__asistencia_1___2J-kk","asistencia_2":"TablaSemanal__asistencia_2___3HzEI","asistencia_3":"TablaSemanal__asistencia_3___2VAqI","asistencia_4":"TablaSemanal__asistencia_4___3IV3d","asistencia_5":"TablaSemanal__asistencia_5___QsVEl","asistencia_camino":"TablaSemanal__asistencia_camino___3mfJe","isPermisoMall_pendiente":"TablaSemanal__isPermisoMall_pendiente___2CFRd","isPermisoMall_asignado":"TablaSemanal__isPermisoMall_asignado___2EzDd","userConPermisoMall":"TablaSemanal__userConPermisoMall___3oMPq","userSinPermisoMall":"TablaSemanal__userSinPermisoMall___3i_nm","permisoMall_aceptado":"TablaSemanal__permisoMall_aceptado___2TFNC","permisoMall_rechazado":"TablaSemanal__permisoMall_rechazado___3P7N-","permisoMall_completar":"TablaSemanal__permisoMall_completar___10wxv","permisoMall_pendiente":"TablaSemanal__permisoMall_pendiente___1wYCr"};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputFecha = __webpack_require__(633);
	
	var _InputFecha2 = _interopRequireDefault(_InputFecha);
	
	var _InputHora = __webpack_require__(643);
	
	var _InputHora2 = _interopRequireDefault(_InputHora);
	
	var _InputDotacionSimple = __webpack_require__(645);
	
	var _InputDotacionSimple2 = _interopRequireDefault(_InputDotacionSimple);
	
	var _InputStock = __webpack_require__(635);
	
	var _InputStock2 = _interopRequireDefault(_InputStock);
	
	var _Select = __webpack_require__(647);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _SelectLider = __webpack_require__(649);
	
	var _SelectCaptadores = __webpack_require__(717);
	
	var _ButtonSolicitud = __webpack_require__(720);
	
	var _Modales = __webpack_require__(652);
	
	var _TablaSemanal = __webpack_require__(641);
	
	var css = _interopRequireWildcard(_TablaSemanal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Comentarios = __webpack_require__(723);
	
	var _Comentarios2 = _interopRequireDefault(_Comentarios);
	
	var _Logistica = __webpack_require__(725);
	
	var _Logistica2 = _interopRequireDefault(_Logistica);
	
	var _CheckBoxNomina = __webpack_require__(727);
	
	var _CheckBoxNomina2 = _interopRequireDefault(_CheckBoxNomina);
	
	var _ComentariosCliente = __webpack_require__(728);
	
	var _ComentariosCliente2 = _interopRequireDefault(_ComentariosCliente);
	
	var _ComentarioIG = __webpack_require__(729);
	
	var _ComentarioIG2 = _interopRequireDefault(_ComentarioIG);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var cx = _bind2.default.bind(css);
	
	var estadoNominas = ['-', // 0 - nunca ocurre
	'Deshabilitada ', // 1 - Deshabilitada
	'Pendiente ', // 2 - Pendiente
	'Recibida ', // 3 - Recibida
	'Aprobada ', // 4 - Aprobada
	'Informada ', // 5 - Informada
	'Inform. Excel ' // 6 - Informada con Excel (plataforma antigua)
	];
	var labelNominas = ['label-default', // 0 - nunca ocurre
	'label-default', // 1 - Deshabilitada
	'label-default', // 2 - Pendiente
	'label-success', // 3 - Recibida (verde)
	'label-info', // 4 - Aprobada (celeste)
	'label-primary', // 5 - Informada (azul)
	'label-primary' // 6 - Informada con Excel (plataforma antigua)
	];
	var estadoConteo = ['SC', // 0 Nómina sin calificación
	'PE', // 1 Nómina en peligro
	'PR', // 2 Nómina en precaución
	'OP', // 3 Nómina óptima
	'SD', // 4 Nómina con mucho conteo
	'SDA' // 5 Nómina con dotación demasiado alta
	];
	var labelConteo = ['label-default', 'label-danger', 'label-warning', 'label-success', 'label-info', 'label-info'];
	
	var RowInventario = function (_React$Component) {
	    _inherits(RowInventario, _React$Component);
	
	    function RowInventario() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RowInventario);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RowInventario.__proto__ || Object.getPrototypeOf(RowInventario)).call.apply(_ref, [this].concat(args))), _this), _this.cargarLideresDisponibles = function (callback) {
	            callback({ options: [], complete: false });
	            _this.props.lideresDisponibles(_this.props.inventario.nnoche_idNomina, _this.props.inventario.ndia_idNomina).then(function (usuarios) {
	                // el callback modifica el state del componente SelectLider
	                callback({
	                    options: usuarios.map(function (usuario) {
	                        return {
	                            label: usuario.nombre,
	                            value: usuario.idUsuario,
	                            enabled: usuario.disponible,
	                            blocked: usuario.bloqueado
	                        };
	                    }),
	                    complete: true
	                });
	            });
	        }, _this.cargarAuditoresSMUDisponibles = function (callback) {
	            callback({ options: [], complete: false });
	            _this.props.auditoresSMUDisponibles(_this.props.inventario.nnoche_idNomina, _this.props.inventario.ndia_idNomina).then(function (usuarios) {
	                // el callback modifica el state del componente SelectLider
	                callback({
	                    options: usuarios.map(function (usuario) {
	                        return {
	                            label: usuario.nombre,
	                            value: usuario.idUsuario,
	                            enabled: usuario.disponible
	                        };
	                    }),
	                    complete: true
	                });
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RowInventario, [{
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            if (elemento === 'dia') {
	                this.inputDia.focus();
	            } else if (elemento === 'dotacionTotal') {
	                // hace focus al primer input de la nomina que este habilitada
	                if (this.props.inventario.ndia_habilitada == "1") {
	                    this.inputDotacionDiaTotal.focus();
	                } else if (this.props.inventario.nnoche_habilitada == "1") {
	                    this.inputDotacionNocheTotal.focus();
	                }
	            } else if (elemento === 'dotacionOperadores') {
	                // hace focus al primer input de la nomina que este habilitada
	                if (this.props.inventario.ndia_habilitada == "1") {
	                    this.inputDotacionDiaOperadores.focus();
	                } else if (this.props.inventario.nnoche_habilitada == "1") {
	                    this.inputDotacionNocheOperadores.focus();
	                }
	            } else if (elemento === 'stock') {
	                this.inputStock.focus();
	            } else {
	                console.error('focusElemento(): Elemento "' + elemento + '" no encontrado');
	            }
	        }
	    }, {
	        key: 'guardarInventario',
	        value: function guardarInventario() {
	            if (!this.props.puedeModificar) return alert("no tiene permitido modificar el inventario");
	            var cambiosInventario = {};
	
	            // el DIA es valido, y ha cambiado?
	            var estadoInputDia = this.inputDia.getEstado();
	            if (estadoInputDia.valid && estadoInputDia.dirty) {
	                cambiosInventario.fechaProgramada = estadoInputDia.fecha;
	            } else if (estadoInputDia.valid === false) {
	                return console.log('fecha ' + estadoInputDia.fecha + ' invalida');
	            }
	
	            // la JORNADA es valida y ha cambiado
	            var estadoSelectJornada = this.selectJornada.getEstado();
	            if (estadoSelectJornada.dirty) cambiosInventario.idJornada = estadoSelectJornada.seleccionUsuario;
	
	            // el STOCK es valido y ha cambiado?
	            var estadoInputStock = this.inputStock.getEstado();
	            if (estadoInputStock.valid && estadoInputStock.dirty) cambiosInventario.stockTeorico = estadoInputStock.valor;
	
	            // almenos uno de los ementos debe estar "dirty" para guardar los cambios
	            if (JSON.stringify(cambiosInventario) !== "{}") {
	                this.props.guardarInventario(this.props.inventario.inv_idInventario, cambiosInventario);
	            } else {
	                console.log('inventario sin cambios, no se actualiza');
	            }
	        }
	    }, {
	        key: 'guardarNominaDia',
	        value: function guardarNominaDia(value) {
	            var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            this._guardarNomina(this.props.inventario.ndia_idNomina, {
	                inputDotacionTotal: this.inputDotacionDiaTotal.getEstado(),
	                inputDotacionOperadores: this.inputDotacionDiaOperadores.getEstado(),
	                selectLider: _extends({}, this.selectLiderDia.getEstado(), {
	                    extra: extra
	                }),
	                selectSupervisor: this.selectSupervisorDia.getEstado(),
	                inputHoraPresentacionLider: this.inputHoraPresentacionLiderDia.getEstado(),
	                inputHoraPresentacionEquipo: this.inputHoraPresentacionEquipoDia.getEstado()
	            });
	        }
	    }, {
	        key: 'guardarNominaNoche',
	        value: function guardarNominaNoche(value) {
	            var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            this._guardarNomina(this.props.inventario.nnoche_idNomina, {
	                inputDotacionTotal: this.inputDotacionNocheTotal.getEstado(),
	                inputDotacionOperadores: this.inputDotacionNocheOperadores.getEstado(),
	                selectLider: _extends({}, this.selectLiderNoche.getEstado(), {
	                    extra: extra
	                }),
	                selectSupervisor: this.selectSupervisorNoche.getEstado(),
	                inputHoraPresentacionLider: this.inputHoraPresentacionLiderNoche.getEstado(),
	                inputHoraPresentacionEquipo: this.inputHoraPresentacionEquipoNoche.getEstado()
	            });
	        }
	    }, {
	        key: 'saveDepartureTime',
	        value: function saveDepartureTime() {
	            if (this.inputDepartureTime.getEstado().dirty) this.props.saveDepartureTime(this.props.inventario.inv_idInventario, this.inputDepartureTime.getEstado().hora);
	        }
	    }, {
	        key: '_colorFila',
	        value: function _colorFila() {
	            var ubicacion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "centro";
	
	            var inv = this.props.inventario;
	            var cliente = inv.cliente_idCliente;
	            var idJornada = inv.inv_idJornada;
	            var alerta = cliente != 11 && idJornada == 2;
	            var SMUDia = cliente == 11 && idJornada == 2;
	            var recintoCerrado = inv.local_recintoCerrado;
	            var isMall = inv.local_isMall;
	            var especial = inv.inv_especial;
	            var deshabilitado = inv.inv_suspendido == 1 || inv.nnoche_idLider === 10 || inv.ndia_idLider === 10;
	            var isPeriferia = inv.local_comuna_is_periferia;
	
	            var color = "white";
	            if (deshabilitado) {
	                color = '#b8b8b8';
	            } else if (especial) color = '#B8F2C2';else if (inv.inv_auditoriaSMU) color = "#DFA0E8";else if (inv.ndia_rectificaSistema === 4 || inv.ndia_rectificaSistema === 5 || inv.nnoche_rectificaSistema === 4 || inv.nnoche_rectificaSistema === 5) color = "#7AFF72";else if (alerta) color = "#f1fc5a";else if (SMUDia) color = "#fcfaa2";else if (recintoCerrado && idJornada == 3) color = "#7EDAFF";else if (isMall) {
	                color = "#F6ABA1";
	            } else if (isPeriferia) {
	                color = "#CDA986";
	            }
	
	            return {
	                backgroundColor: color
	            };
	        }
	    }, {
	        key: '_guardarNomina',
	        value: function _guardarNomina(idNomina, estados) {
	            if (!this.props.puedeModificar) return alert("no tiene permitido modificar el inventario");
	
	            var cambiosNomina = {};
	
	            // la DOTACION es valida y ha cambiado?
	            if (estados.inputDotacionTotal.valid && estados.inputDotacionTotal.dirty) cambiosNomina.dotacionTotal = estados.inputDotacionTotal.valor;
	            if (estados.inputDotacionOperadores.valid && estados.inputDotacionOperadores.dirty) cambiosNomina.dotacionOperadores = estados.inputDotacionOperadores.valor;
	
	            // el LIDER es valido y ha cambiado? ("deberia" ser valido siempre y cuando no seleccionen la opcion "sin seleccion")
	            if (estados.selectLider.dirty) {
	                cambiosNomina.idLider = estados.selectLider.seleccionUsuario === null ? '' : estados.selectLider.seleccionUsuario;
	                if (estados.selectLider.extra && estados.selectLider.extra.suspendidoConPago !== undefined) {
	                    cambiosNomina.suspendidoConPago = estados.selectLider.extra.suspendidoConPago;
	                }
	            }
	
	            // el SUPERVISOR es valido y ha cambiado? ("deberia" ser valido siempre y cuando no seleccionen la opcion "sin seleccion")
	            if (estados.selectSupervisor.dirty) cambiosNomina.idSupervisor = estados.selectSupervisor.seleccionUsuario;
	
	            // La HORA de llegada del equipo ha cambiado?
	            if (estados.inputHoraPresentacionLider.dirty) cambiosNomina.horaPresentacionLider = estados.inputHoraPresentacionLider.hora;
	            if (estados.inputHoraPresentacionEquipo.dirty) cambiosNomina.horaPresentacionEquipo = estados.inputHoraPresentacionEquipo.hora;
	
	            // almenos uno de los ementos debe estar "dirty" para guardar los cambios
	            if (JSON.stringify(cambiosNomina) !== '{}') {
	                this.props.guardarNomina(idNomina, cambiosNomina);
	            } else {
	                console.log('nomina sin cambios, no se actualiza');
	            }
	        }
	    }, {
	        key: 'formatearTooltip',
	        value: function formatearTooltip(inv) {
	            var stocks = inv.inv_3stocks || [];
	            if (!stocks.length) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '[Stock al ',
	                        inv.inv_fechaStock,
	                        ']'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Promedio inv anteriores: ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            inv.inv_promStock
	                        )
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '[Stock al ',
	                    inv.inv_fechaStock,
	                    ']'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Promedio inv anteriores: ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        inv.inv_promStock
	                    )
	                ),
	                inv.inv_3stocks && inv.inv_3stocks.length > 0 && _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: '8px', fontSize: '12px', display: 'flex' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { fontWeight: 'bold', marginRight: '10px' } },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Conteo'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Fecha'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Operadores'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Duraci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Nota'
	                        )
	                    ),
	                    stocks.map(function (s, i) {
	                        if (!s.conteo) {
	                            return null;
	                        }
	                        return _react2.default.createElement(
	                            'div',
	                            { key: i, style: { marginRight: '15px' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                s.conteo ? Number(s.conteo).toLocaleString("es-CL") : "-"
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                s.fecha || "-"
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                s.operadores || 0
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                s.duracion || "-"
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                s.nota_conteo || "-"
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'estadoPermiso',
	        value: function estadoPermiso(permisosMall) {
	            var algunoIncompleto = permisosMall.find(function (permiso) {
	                return permiso.fecha_completado == null;
	            });
	            var estado = algunoIncompleto ? algunoIncompleto.estado : permisosMall[0].estado;
	            if (estado === 'Aprobado' || estado === 'Aceptado') {
	                return css.permisoMall_aceptado;
	            }
	
	            if (estado === 'Rechazado') {
	                return css.permisoMall_rechazado;
	            }
	
	            if (estado === 'Completar' || estado === 'Solicitado') {
	                return css.permisoMall_completar;
	            }
	
	            return css.permisoMall_pendiente;
	        }
	    }, {
	        key: 'selectColorPermiso',
	        value: function selectColorPermiso(permisosMall) {
	            var algunoIncompleto = permisosMall.find(function (permiso) {
	                return permiso.fecha_completado == null;
	            });
	            if (algunoIncompleto) {
	                return {
	                    borderRadius: '9999px',
	                    borderWidth: '1px',
	                    paddingLeft: '0.5rem',
	                    paddingRight: '0.5rem',
	                    border: '#222222',
	                    backgroundColor: algunoIncompleto.color,
	                    color: '#EEE'
	                };
	            }
	            return {
	                borderRadius: '9999px',
	                borderWidth: '1px',
	                paddingLeft: '0.5rem',
	                paddingRight: '0.5rem',
	                border: '#222222',
	                backgroundColor: permisosMall[0].color,
	                color: '#EEE'
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var inv = this.props.inventario;
	            var idJornada = inv.inv_idJornada;
	            var cliente = inv.cliente_idCliente;
	            var inventarioDia = idJornada == 2 || idJornada == 4;
	            var inventarioNoche = idJornada == 3 || idJornada == 4;
	            // puede eeditar si la nomina esta habilitada, y no esta en estado "informada"(5) o "informada excel"(6)
	            var informadaDia = inv.ndia_idEstadoNomina == 5 || inv.ndia_idEstadoNomina == 6;
	            var informadaNoche = inv.nnoche_idEstadoNomina == 5 || inv.nnoche_idEstadoNomina == 6;
	            // puede editar la NOMINA si tiene los permisos, esta habilitada, y esta no ha sido informada
	            var puedeEditarNominaDia = this.props.puedeModificarPro && inv.ndia_habilitada == "1" && !informadaDia;
	            var puedeEditarNominaNoche = this.props.puedeModificarPro && inv.nnoche_habilitada == "1" && !informadaNoche;
	            // puede editar dotacion NOMINA
	            var puedeEditarNominaDiaDot = this.props.puedeModificarDotaciones && inv.ndia_habilitada == "1" && !informadaDia;
	            var puedeEditarNominaNocheDot = this.props.puedeModificarDotaciones && inv.nnoche_habilitada == "1" && !informadaNoche;
	            // el captador se puede editar siempre que se tengan los permisos y que la nomina este habilitada
	            // let puedeEditarCaptadorDia = this.props.puedeModificar && inv.ndia_habilitada=="1"
	            // let puedeEditarCaptadorNoche = this.props.puedeModificar && inv.nnoche_habilitada=="1"
	
	            // el inventario se puede editar solo si tiene los permisos, y no hay una nomina informada
	            var puedeEditar_fecha_turno_stock = this.props.puedeModificar && !informadaDia && !informadaNoche;
	            var puedeModificarCaptador = this.props.puedeModificarCaptador && !informadaDia && !informadaNoche;
	            var puedeModificar_stock = this.props.puedeEditarStock && !informadaDia && !informadaNoche;
	            var _hrApertura = inv.local_horaApertura.split(':');
	            var txtHrApertura = 'Apertura a las ' + _hrApertura[0] + ':' + _hrApertura[1] + 'hrs';
	            var _hrCierre = inv.local_horaCierre.split(':');
	            var txtHrCierre = 'Cierre a las ' + _hrCierre[0] + ':' + _hrCierre[1] + 'hrs';
	            var notaPromedio = inv.acta_nota1 != 'sin datos' ? ((parseFloat(inv.acta_nota1) + parseFloat(inv.acta_nota2) + parseFloat(inv.acta_nota3)) / 3).toFixed(1) : null;
	            var notas = notaPromedio ? inv.acta_nota1 + ' / ' + inv.acta_nota2 + ' / ' + inv.acta_nota3 + ' / ' + notaPromedio : 'sin datos';
	
	            var isAuditoriaSMU = inv.inv_auditoriaSMU ? true : false;
	            var index = this.props.index;
	
	            var titularesDia = inv.ndia_totalTitulares.filter(function (row) {
	                return !row.lider;
	            });
	            var titularesNoche = inv.nnoche_totalTitulares.filter(function (row) {
	                return !row.lider;
	            });
	            var status_asistencia_global_dia = inventarioDia ? titularesDia.length != 0 && titularesDia.filter(function (row) {
	                return row.estado_asistencia >= 3;
	            }).length == titularesDia.length : false;
	            var status_asistencia_global_noche = inventarioNoche ? titularesNoche.length != 0 && titularesNoche.filter(function (row) {
	                return row.estado_asistencia >= 3;
	            }).length == titularesNoche.length : false;
	            var deshabilitado = inv.nnoche_idLider === 10 || inv.ndia_idLider === 10 || inv.inv_suspendido === 1;
	            var isPermisoMall = inv.local_isMall && inv.local_tipoMall.is_permiso_mall || inv.permisos_mall.length != 0;
	            var tieneAsignadoPermiso = inv.permisos_mall.length != 0;
	            return _react2.default.createElement(
	                'tr',
	                { className: this.props.mostrarSeparador ? css.trSeparador : '' },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCorrelativo },
	                    _react2.default.createElement(
	                        'p',
	                        { title: inv.inv_idInventario },
	                        this.props.index + 1
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLogistica, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_Logistica2.default, {
	                        idLocal: inv.local_idLocal,
	                        tiene: inv.local_logistica
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdInv, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_ComentarioIG2.default, { idInventario: inv.inv_idInventario, placement: 'right' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha, style: _extends({}, this._colorFila('left'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputFecha2.default, {
	                        ref: function ref(_ref2) {
	                            return _this2.inputDia = _ref2;
	                        },
	                        diaSemana: inv.inv_fechaProgramadaDOW,
	                        fechaConProblemas: inv.local_topeFechaConAuditoria,
	                        fecha: inv.inv_fechaProgramada,
	                        onGuardar: this.guardarInventario.bind(this),
	                        puedeModificar: puedeEditar_fecha_turno_stock,
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dia');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dia');
	                        } })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.mytooltip },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: isPermisoMall ? tieneAsignadoPermiso ? this.estadoPermiso(inv.permisos_mall) : css.isPermisoMall_pendiente : ''
	                            },
	                            inv.cliente_nombreCorto
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.tooltipTableNominaAnterior },
	                            _react2.default.createElement(TableNominaAnterior, {
	                                fecha: inv.nomina_anterior_fecha,
	                                turno: inv.nomina_anterior_turno,
	                                nomina: inv.nomina_anterior_stats,
	                                stats: inv.stats })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.tooltip },
	                        inv.local_ceco,
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.tooltiptext },
	                            'Lider: ',
	                            inv.ult_lider,
	                            _react2.default.createElement('br', null),
	                            'Prod.Sugerida: ',
	                            inv.local_produccionSugerida,
	                            _react2.default.createElement('br', null),
	                            'Fecha \xFAltimo inv: ',
	                            inv.acta_fecha_toma,
	                            _react2.default.createElement('br', null),
	                            'Llegada \xFAltimo inv: ',
	                            inv.acta_hora_llegada,
	                            _react2.default.createElement('br', null),
	                            'Inicio Conteo \xFAltimo inv: ',
	                            inv.acta_inicio_conteo,
	                            _react2.default.createElement('br', null),
	                            'Fin Conteo \xFAltimo inv: ',
	                            inv.acta_fin_conteo,
	                            _react2.default.createElement('br', null),
	                            'Tot. hrs. conteo : ',
	                            inv.acta_revision_grilla,
	                            _react2.default.createElement('br', null),
	                            'Duraci\xF3n revisi\xF3n: ',
	                            inv.acta_duracion_revision,
	                            _react2.default.createElement('br', null),
	                            'Fin Proceso \xFAltimo inv: ',
	                            inv.acta_fin_proceso,
	                            _react2.default.createElement('br', null),
	                            'Dot. \xFAltimo inv: ',
	                            inv.acta_dot,
	                            _react2.default.createElement('br', null),
	                            'Tot. sala \xFAltimo inv: ',
	                            inv.acta_total_sala,
	                            _react2.default.createElement('br', null),
	                            'Tot. bod. \xFAltimo inv: ',
	                            inv.acta_total_bodega,
	                            _react2.default.createElement('br', null),
	                            'Tot. unds contadas: ',
	                            inv.acta_unidades,
	                            _react2.default.createElement('br', null),
	                            'Tot. unds te\xF3rico: ',
	                            inv.acta_unidades_teorico,
	                            _react2.default.createElement('br', null),
	                            'Notas (C/P/S/X): ',
	                            notas,
	                            _react2.default.createElement('br', null),
	                            'Error SEI: ',
	                            inv.acta_error_sei,
	                            _react2.default.createElement('br', null),
	                            'Estandar SEI: ',
	                            inv.acta_estandar,
	                            _react2.default.createElement('br', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        inv.local_region
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_Comentarios2.default, {
	                        comuna: inv.local_comuna,
	                        idInventario: inv.inv_idInventario,
	                        comentarios: inv.inv_comentarios,
	                        updateComentarios: this.props.updateComentarios
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTurno, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_Select2.default, {
	                        ref: function ref(_ref3) {
	                            return _this2.selectJornada = _ref3;
	                        },
	                        onSelect: this.guardarInventario.bind(this),
	                        opciones: isAuditoriaSMU ? [{ valor: '1', texto: 'ND' }, { valor: '2', texto: 'D' }] : [{ valor: '1', texto: 'ND' }, { valor: '2', texto: 'D' }, { valor: '3', texto: 'N' }, { valor: '4', texto: 'DyN' }],
	                        seleccionada: '' + inv.inv_idJornada,
	                        puedeModificar: puedeEditar_fecha_turno_stock && !deshabilitado
	
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTienda, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Apertura: ',
	                            inv.local_horaApertura,
	                            ', Cierre:',
	                            inv.local_horaCierre
	                        )
	                    ),
	                    _react2.default.createElement(_ComentariosCliente2.default, {
	                        local: inv.local_nombre,
	                        idLocal: inv.local_idLocal,
	                        comentarios: inv.local_comentarios,
	                        updateComentarios: this.props.updateComentariosClientes,
	                        puedeValidarComentarios: this.props.puedeValidarComentarios
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputStock2.default, {
	                        ref: function ref(_ref4) {
	                            return _this2.inputStock = _ref4;
	                        },
	                        asignada: '' + inv.inv_stockTeorico // pide en string
	                        , tooltipText: this.formatearTooltip(inv),
	                        onGuardar: this.guardarInventario.bind(this),
	                        stockAntiguo: inv.inv_fechaStockAntigua,
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'stock');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'stock');
	                        },
	                        puedeModificar: puedeModificar_stock && !deshabilitado
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDotacionTotal, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputDotacionSimple2.default, {
	                        style: { display: inventarioDia ? 'block' : 'none' },
	                        className: 'pull-left',
	                        ref: function ref(_ref5) {
	                            return _this2.inputDotacionDiaTotal = _ref5;
	                        },
	                        asignada: '' + inv.ndia_dotTotal // pide un string...
	                        , onGuardar: this.guardarNominaDia.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dotacionTotal');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dotacionTotal');
	                        },
	                        puedeModificar: puedeEditarNominaDiaDot && inv.ndia_estadoDotacion == 1 && !deshabilitado,
	                        idInv: inv.inv_idInventario
	                    }),
	                    _react2.default.createElement(_InputDotacionSimple2.default, {
	                        style: { display: inventarioDia ? 'block' : 'none' },
	                        className: 'pull-right',
	                        ref: function ref(_ref6) {
	                            return _this2.inputDotacionDiaOperadores = _ref6;
	                        },
	                        asignada: '' + inv.ndia_dotOperadores // pide un string...
	                        , onGuardar: this.guardarNominaDia.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dotacionOperadores');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dotacionOperadores');
	                        },
	                        puedeModificar: puedeEditarNominaDiaDot && inv.ndia_estadoDotacion == 1 && !deshabilitado,
	                        tooltipText: inv.ndia_dotacionInformada,
	                        idInv: inv.inv_idInventario
	                    }),
	                    _react2.default.createElement(_InputDotacionSimple2.default, {
	                        style: { display: inventarioNoche ? 'block' : 'none' },
	                        className: 'pull-left',
	                        ref: function ref(_ref7) {
	                            return _this2.inputDotacionNocheTotal = _ref7;
	                        },
	                        asignada: '' + inv.nnoche_dotTotal // pide un string...
	                        , onGuardar: this.guardarNominaNoche.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dotacionTotal');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dotacionTotal');
	                        },
	                        puedeModificar: puedeEditarNominaNocheDot && inv.nnoche_estadoDotacion == 1 && !deshabilitado,
	                        idInv: inv.inv_idInventario
	                    }),
	                    _react2.default.createElement(_InputDotacionSimple2.default, {
	                        style: { display: inventarioNoche ? 'block' : 'none' },
	                        className: 'pull-right',
	                        ref: function ref(_ref8) {
	                            return _this2.inputDotacionNocheOperadores = _ref8;
	                        },
	                        asignada: '' + inv.nnoche_dotOperadores // pide un string...
	                        , onGuardar: this.guardarNominaNoche.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dotacionOperadores');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dotacionOperadores');
	                        },
	                        puedeModificar: puedeEditarNominaNocheDot && inv.nnoche_estadoDotacion == 1 && !deshabilitado,
	                        tooltipText: inv.nnoche_dotacionInformada,
	                        idInv: inv.inv_idInventario
	                    }),
	                    _react2.default.createElement(_ButtonSolicitud.ButtonSolicitud, {
	                        onGuardar: this.props.estadoSolicitud.bind(this),
	                        idNomina: inv.nnoche_idNomina,
	                        visible: inventarioNoche && inv.nnoche_estadoDotacion != 1,
	                        idEstadoDotacion: inv.nnoche_estadoDotacion
	                    }),
	                    _react2.default.createElement(_ButtonSolicitud.ButtonSolicitud, {
	                        onGuardar: this.props.estadoSolicitud.bind(this),
	                        idNomina: inv.ndia_idNomina,
	                        visible: inventarioDia && inv.ndia_estadoDotacion != 1,
	                        idEstadoDotacion: inv.ndia_estadoDotacion
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUsuario, style: _extends({}, this._colorFila('centro')) },
	                    _react2.default.createElement(_SelectLider.SelectLider, { visible: inventarioDia,
	                        editable: puedeEditarNominaDia,
	                        selectedValue: inv.ndia_idLider || '',
	                        selectedLabel: inv.ndia_lider,
	                        onOpenList: isAuditoriaSMU ? this.cargarAuditoresSMUDisponibles : this.cargarLideresDisponibles,
	                        ref: function ref(_ref9) {
	                            return _this2.selectLiderDia = _ref9;
	                        },
	                        onChange: this.guardarNominaDia.bind(this)
	                    }),
	                    _react2.default.createElement(_SelectLider.SelectLider, { visible: inventarioNoche,
	                        editable: puedeEditarNominaNoche,
	                        selectedValue: inv.nnoche_idLider || '',
	                        selectedLabel: inv.nnoche_lider,
	                        onOpenList: isAuditoriaSMU ? this.cargarAuditoresSMUDisponibles : this.cargarLideresDisponibles,
	                        ref: function ref(_ref10) {
	                            return _this2.selectLiderNoche = _ref10;
	                        },
	                        onChange: this.guardarNominaNoche.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHora, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputHora2.default, {
	                        style: { display: inventarioDia ? 'block' : 'none' },
	                        ref: function ref(_ref11) {
	                            return _this2.inputHoraPresentacionLiderDia = _ref11;
	                        },
	                        asignada: inv.ndia_hrLider,
	                        tooltipText: txtHrApertura,
	                        onGuardar: this.guardarNominaDia.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {},
	                        focusRowSiguiente: function focusRowSiguiente() {},
	                        puedeModificar: puedeEditarNominaDia && !deshabilitado
	                    }),
	                    _react2.default.createElement(_InputHora2.default, {
	                        style: { display: inventarioNoche ? 'block' : 'none' },
	                        ref: function ref(_ref12) {
	                            return _this2.inputHoraPresentacionLiderNoche = _ref12;
	                        },
	                        asignada: inv.nnoche_hrLider,
	                        tooltipText: txtHrCierre,
	                        onGuardar: this.guardarNominaNoche.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {},
	                        focusRowSiguiente: function focusRowSiguiente() {},
	                        puedeModificar: puedeEditarNominaNoche && !deshabilitado
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHora, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputHora2.default, {
	                        style: { display: inventarioDia ? 'block' : 'none' },
	                        ref: function ref(_ref13) {
	                            return _this2.inputHoraPresentacionEquipoDia = _ref13;
	                        },
	                        asignada: inv.ndia_hrEquipo,
	                        tooltipText: txtHrApertura,
	                        onGuardar: this.guardarNominaDia.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {},
	                        focusRowSiguiente: function focusRowSiguiente() {},
	                        puedeModificar: puedeEditarNominaDia && !deshabilitado
	                    }),
	                    _react2.default.createElement(_InputHora2.default, {
	                        style: { display: inventarioNoche ? 'block' : 'none' },
	                        ref: function ref(_ref14) {
	                            return _this2.inputHoraPresentacionEquipoNoche = _ref14;
	                        },
	                        asignada: inv.nnoche_hrEquipo,
	                        tooltipText: txtHrCierre,
	                        onGuardar: this.guardarNominaNoche.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {},
	                        focusRowSiguiente: function focusRowSiguiente() {},
	                        puedeModificar: puedeEditarNominaNoche && !deshabilitado
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUsuario, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_Select2.default, { style: { display: inventarioDia ? 'block' : 'none' },
	                        ref: function ref(_ref15) {
	                            return _this2.selectSupervisorDia = _ref15;
	                        },
	                        seleccionada: '' + inv.ndia_idSupervisor || '',
	                        onSelect: this.guardarNominaDia.bind(this),
	                        opciones: this.props.opcionesSupervisores,
	                        opcionNula: true,
	                        opcionNulaSeleccionable: true,
	                        puedeModificar: puedeEditarNominaDia && !deshabilitado
	                    }),
	                    _react2.default.createElement(_Select2.default, { style: { display: inventarioNoche ? 'block' : 'none' },
	                        ref: function ref(_ref16) {
	                            return _this2.selectSupervisorNoche = _ref16;
	                        },
	                        seleccionada: '' + inv.nnoche_idSupervisor || '',
	                        onSelect: this.guardarNominaNoche.bind(this),
	                        opciones: this.props.opcionesSupervisores,
	                        opcionNula: true,
	                        opcionNulaSeleccionable: true,
	                        puedeModificar: puedeEditarNominaNoche && !deshabilitado
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUsuario, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_SelectCaptadores.SelectCaptadores, {
	                        puedeEditar: puedeModificarCaptador && !deshabilitado,
	                        visible: inventarioDia,
	                        captadoresDisponibles: this.props.captadoresDisponibles,
	                        captadores: inv.ndia_captadores,
	                        agregarCaptador: this.props.agregarCaptador.bind(this, inv.ndia_idNomina),
	                        quitarCaptador: this.props.quitarCaptador.bind(this, inv.ndia_idNomina),
	                        agregarRegionesCaptador: this.props.agregarRegionesCaptador.bind(this, inv.ndia_idNomina),
	                        cerrarRegion: this.props.cerrarRegion,
	                        cambiarAsignados: this.props.cambiarAsignados.bind(this, inv.ndia_idNomina),
	                        idInventario: inv.inv_idInventario,
	                        regiones: inv.regiones
	                    }),
	                    _react2.default.createElement(_SelectCaptadores.SelectCaptadores, {
	                        puedeEditar: puedeModificarCaptador && !deshabilitado,
	                        visible: inventarioNoche,
	                        captadoresDisponibles: this.props.captadoresDisponibles,
	                        captadores: inv.nnoche_captadores,
	                        agregarCaptador: this.props.agregarCaptador.bind(this, inv.nnoche_idNomina),
	                        quitarCaptador: this.props.quitarCaptador.bind(this, inv.nnoche_idNomina),
	                        agregarRegionesCaptador: this.props.agregarRegionesCaptador.bind(this, inv.nnoche_idNomina),
	                        cerrarRegion: this.props.cerrarRegion,
	                        cambiarAsignados: this.props.cambiarAsignados.bind(this, inv.nnoche_idNomina),
	                        idInventario: inv.inv_idInventario,
	                        regiones: inv.regiones
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHora, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(_InputHora2.default, {
	                        style: { display: 'block' },
	                        ref: function ref(_ref17) {
	                            return _this2.inputDepartureTime = _ref17;
	                        },
	                        asignada: inv.store_departureTime,
	                        tooltipText: txtHrApertura,
	                        onGuardar: this.saveDepartureTime.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {},
	                        focusRowSiguiente: function focusRowSiguiente() {},
	                        puedeModificar: true && !deshabilitado
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDireccion, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inv.local_gmap_latitud && inv.local_gmap_longitud ? _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.google.com/maps/search/?api=1&query=' + inv.local_gmap_latitud + ', ' + inv.local_gmap_longitud,
	                            target: '_blank' },
	                        inv.local_direccion,
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-map-marker' })
	                    ) : inv.local_direccion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCheckboxNomina, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inventarioDia ? _react2.default.createElement(_CheckBoxNomina2.default
	                    //idInventario={inv.inv_idInventario}
	                    , { initialChecked: this.props.checkboxesNomina.nominaDia.status,
	                        setValueCheckbox: this.props.setValueCheckbox,
	                        css: cx('center-block'),
	                        idNomina: inv.ndia_idNomina,
	                        disabled: deshabilitado
	                    }) : '',
	                    inventarioNoche ? _react2.default.createElement(_CheckBoxNomina2.default
	                    //idInventario={inv.inv_idInventario}
	                    , { initialChecked: this.props.checkboxesNomina.nominaNoche.status,
	                        setValueCheckbox: this.props.setValueCheckbox,
	                        css: cx('center-block'),
	                        idNomina: inv.nnoche_idNomina,
	                        disabled: deshabilitado
	                    }) : ''
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNomina, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.mytooltip },
	                        _react2.default.createElement(
	                            'a',
	                            { href: deshabilitado ? '#' : '/nomina/' + inv.ndia_idNomina,
	                                className: cx('label', !inv.ndia_rectificada && inv.ndia_idEstadoNomina < 5 ? css.nominaNuncaInformada : "",
	                                // color depende del valor de la fechaSubida
	                                labelNominas[inv.ndia_idEstadoNomina], inventarioDia ? 'center-block' : 'hide'),
	                                target: deshabilitado ? '' : "_blank", style: { backgroundColor: inv.ndia_totalTitulares_baja > 0 ? 'red' : inv.ndia_conBaja ? 'black' : '' }
	                            },
	                            estadoNominas[inv.ndia_idEstadoNomina],
	                            inv.ndia_totalEscondidos.length > 0 ? _react2.default.createElement('span', { style: { color: 'white' }, className: 'glyphicon glyphicon-user' }) : null,
	                            inv.ndia_bloqueoDotacion == true || inv.ndia_totalTitulares_baja > 0 ? _react2.default.createElement('span', { style: { color: 'red' }, className: 'glyphicon glyphicon-lock' }) : null,
	                            inv.ndia_totalMasTiempo.length > 0 ? _react2.default.createElement('span', { style: { color: 'white' }, className: 'glyphicon glyphicon-time' }) : null
	                        ),
	                        !deshabilitado && _react2.default.createElement(
	                            'span',
	                            { className: css.tooltipTable },
	                            _react2.default.createElement(TableInfoNomina, { nomina: inv.ndia_totalTitulares, captadores: inv.ndia_captadores, stock: inv.inv_stockTeorico,
	                                localN: inv.cliente_nombreCorto, localC: inv.local_ceco, fecha: inv.inv_fechaProgramada, bajas: inv.ndia_totalDadosBaja, escondidos: inv.ndia_totalEscondidos,
	                                mensaje: inv.ndia_mensajeCorto,
	                                isPermisoMall: isPermisoMall && inv.permisos_mall.length != 0,
	                                permisosMall: inv.permisos_mall
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.mytooltip },
	                        _react2.default.createElement(
	                            'a',
	                            { href: deshabilitado ? '#' : '/nomina/' + inv.nnoche_idNomina,
	                                className: cx('label', !inv.nnoche_rectificada && inv.nnoche_idEstadoNomina < 5 ? css.nominaNuncaInformada : "",
	                                // color depende del valor de la fechaSubida
	                                labelNominas[inv.nnoche_idEstadoNomina], inventarioNoche ? 'center-block' : 'hide'),
	                                target: deshabilitado ? '' : "_blank", style: { backgroundColor: inv.nnoche_totalTitulares_baja > 0 ? 'red' : inv.nnoche_conBaja ? 'black' : '' }
	                            },
	                            estadoNominas[inv.nnoche_idEstadoNomina],
	                            inv.nnoche_totalEscondidos.length > 0 ? _react2.default.createElement('span', { style: { color: 'white' }, className: 'glyphicon glyphicon-user' }) : null,
	                            inv.nnoche_bloqueoDotacion == true ? _react2.default.createElement('span', { style: { color: 'red' }, className: 'glyphicon glyphicon-lock' }) : null,
	                            inv.nnoche_totalMasTiempo.length > 0 ? _react2.default.createElement('span', { style: { color: 'white' }, className: 'glyphicon glyphicon-time' }) : null
	                        ),
	                        !deshabilitado && _react2.default.createElement(
	                            'span',
	                            { className: css.tooltipTable },
	                            _react2.default.createElement(TableInfoNomina, { nomina: inv.nnoche_totalTitulares, captadores: inv.nnoche_captadores, stock: inv.inv_stockTeorico,
	                                localN: inv.cliente_nombreCorto, localC: inv.local_ceco, fecha: inv.inv_fechaProgramada, bajas: inv.nnoche_totalDadosBaja, escondidos: inv.nnoche_totalEscondidos,
	                                mensaje: inv.nnoche_mensajeCorto,
	                                isPermisoMall: isPermisoMall && inv.permisos_mall.length != 0,
	                                permisosMall: inv.permisos_mall
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNomina, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: cx('label',
	                                // color depende de la calificación nómina
	                                labelConteo[inv.ndia_calificacionNomina], inventarioDia ? 'center-block' : 'hide'),
	                                style: inv.ndia_calificacionNomina === 1 && inv.ndia_porcentaje > 75 ? { backgroundColor: '#fc7905', borderColor: '#fc7905' // naranjo real
	                                } : {}
	                            },
	                            inv.ndia_porcentaje ? inv.ndia_porcentaje > 400 ? "..." : inv.ndia_porcentaje : 0,
	                            '%'
	                        ),
	                        !deshabilitado && _react2.default.createElement(
	                            'span',
	                            { className: css.tooltiptext },
	                            '-',
	                            inv.ndia_mensaje,
	                            '.',
	                            _react2.default.createElement('br', null),
	                            '-Stock Promedio Local: ',
	                            inv.ndia_stockSugerido,
	                            _react2.default.createElement('br', null),
	                            '-Stock Informado: ',
	                            Number(inv.inv_stockTeorico).toLocaleString('en-US'),
	                            _react2.default.createElement('br', null),
	                            '-Conteo Sugerido: ',
	                            inv.ndia_conteoSugerido,
	                            _react2.default.createElement('br', null),
	                            '-Operadores: ',
	                            inv.ndia_totalTitulares.length + ' de ' + inv.ndia_dotOperadores,
	                            _react2.default.createElement('br', null),
	                            '-Operadores nuevos: ',
	                            inv.ndia_cantidadNuevos
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: cx('label',
	                                // color depende de la calificación de nomina
	                                labelConteo[inv.nnoche_calificacionNomina], inventarioNoche ? 'center-block' : 'hide'),
	                                style: inv.nnoche_calificacionNomina === 1 && inv.nnoche_porcentaje > 75 ? { backgroundColor: '#fc7905', borderColor: '#fc7905' // naranjo real
	                                } : {}
	                            },
	                            inv.nnoche_porcentaje ? inv.nnoche_porcentaje > 400 ? "..." : inv.nnoche_porcentaje : 0,
	                            '%'
	                        ),
	                        !deshabilitado && _react2.default.createElement(
	                            'span',
	                            null,
	                            '-',
	                            inv.nnoche_mensaje,
	                            '.',
	                            _react2.default.createElement('br', null),
	                            '-Stock Promedio Local: ',
	                            inv.nnoche_stockSugerido,
	                            _react2.default.createElement('br', null),
	                            '-Stock Informado: ',
	                            Number(inv.inv_stockTeorico).toLocaleString('en-US'),
	                            _react2.default.createElement('br', null),
	                            '-Conteo Sugerido: ',
	                            inv.nnoche_conteoSugerido,
	                            _react2.default.createElement('br', null),
	                            '-Operadores: ',
	                            inv.nnoche_totalTitulares.length + ' de ' + inv.nnoche_dotOperadores,
	                            _react2.default.createElement('br', null),
	                            '-Operadores nuevos: ',
	                            inv.nnoche_cantidadNuevos
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdReportes, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inventarioDia && _react2.default.createElement(
	                        'div',
	                        { style: { marginLeft: 'auto', marginRight: 'auto' }, className: status_asistencia_global_dia ? css.asistencia_5 : css.asistencia_0 },
	                        ' '
	                    ),
	                    inventarioNoche && _react2.default.createElement('div', { style: { marginLeft: 'auto', marginRight: 'auto' }, className: status_asistencia_global_noche ? css.asistencia_5 : css.asistencia_0 })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdPatentes, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inv.inv_patentes
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdPda, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inv.inv_pda
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadesReales, style: _extends({}, this._colorFila('centro'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    inv.inv_unidadesReales
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdArchivoFinal, style: _extends({}, this._colorFila('right'), { opacity: deshabilitado ? '50%' : '100%' }) },
	                    _react2.default.createElement(
	                        'a',
	                        { className: cx('label', 'center-block', {
	                                'label-default': inv.inv_estadoArchivoFinal == 'pendiente',
	                                'label-info': inv.inv_estadoArchivoFinal == 'por publicar',
	                                'label-primary': inv.inv_estadoArchivoFinal == 'publicado'
	                            }), href: deshabilitado ? '#' : '/inventario/' + inv.inv_idInventario + '/archivo-final', target: '_blank' },
	                        inv.inv_estadoArchivoFinal
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowInventario;
	}(_react2.default.Component);
	
	var TableInfoNomina = function TableInfoNomina(_ref18) {
	    var nomina = _ref18.nomina,
	        captadores = _ref18.captadores,
	        stock = _ref18.stock,
	        localN = _ref18.localN,
	        localC = _ref18.localC,
	        fecha = _ref18.fecha,
	        bajas = _ref18.bajas,
	        escondidos = _ref18.escondidos,
	        mensaje = _ref18.mensaje,
	        _ref18$isPermisoMall = _ref18.isPermisoMall,
	        isPermisoMall = _ref18$isPermisoMall === undefined ? false : _ref18$isPermisoMall,
	        _ref18$permisosMall = _ref18.permisosMall,
	        permisosMall = _ref18$permisosMall === undefined ? [] : _ref18$permisosMall;
	
	
	    var usuariosConPermisoMap = new Map();
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = permisosMall[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var permisoMall = _step.value;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = permisoMall.users_registrados[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var user = _step2.value;
	
	                    usuariosConPermisoMap.set(user.user_id, user);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var totales = {
	        //exp: 0,
	        //error: 0,
	        sug: 0,
	        real: 0
	    };
	
	    var onColorAsistencia = function onColorAsistencia(asistencia) {
	        if (asistencia < 2) {
	            return css.asistencia_0;
	        }
	        if (asistencia >= 2) {
	            return css.asistencia_2;
	        }
	    };
	
	    var onColorAsistencia2 = function onColorAsistencia2(asistencia) {
	        if (asistencia <= 2) {
	            return css.asistencia_0;
	        }
	        if (asistencia >= 3) {
	            return css.asistencia_3;
	        }
	
	        // if (asistencia == 4) {
	        //     return css.asistencia_4;
	        // }
	        // if (asistencia == 5) {
	        //     return css.asistencia_5;
	        // }
	    };
	
	    var onColorAsistencia3 = function onColorAsistencia3(asistencia) {
	        if (asistencia < 4) {
	            return css.asistencia_camino;
	        }
	        if (asistencia == 4) {
	            return css.asistencia_4;
	        }
	        if (asistencia == 5) {
	            return css.asistencia_5;
	        }
	    };
	
	    var nominaFiltrada = nomina.filter(function (operadorNomina) {
	        return !bajas.some(function (operadorBaja) {
	            return operadorBaja.nombreCorto === operadorNomina.nombreCorto;
	        });
	    });
	
	    var rows = nominaFiltrada.map(function (operador, index) {
	
	        var captador = captadores.find(function (captador) {
	            return captador.idUsuario == operador.captador;
	        });
	        //totales.exp += operador.experienciaComoOperador; 
	        //totales.error += operador.error,
	        var esLider = operador.lider;
	        if (!esLider) {
	            totales.sug += operador.unidadesContadas;
	            totales.real += operador.unidadesContadasReal;
	        }
	        return _react2.default.createElement(
	            'tr',
	            { key: index, style: { color: esLider ? "#10de39" : "white" } },
	            _react2.default.createElement(
	                'td',
	                null,
	                esLider ? "Líder" : index
	            ),
	            isPermisoMall ? _react2.default.createElement(
	                'td',
	                null,
	                usuariosConPermisoMap.has(operador.id) ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok ' + css.userConPermisoMall }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove ' + css.userSinPermisoMall, color: 'red' })
	            ) : null,
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.bloqueado == 1 ? "red" : operador.bloqueadoCliente ? "orange" : esLider ? "#10de39" : "white"
	                    }
	                },
	                operador.nombreCorto
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                captador ? captador.nombre : '-'
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.comuna
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.experienciaComoOperador
	            ),
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.error >= 1 ? "red" : esLider ? "#10de39" : "white"
	                    }
	                },
	                operador.error
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)
	            ),
	            operador.estado_asistencia == "-1" ? _react2.default.createElement(
	                'td',
	                { colSpan: 2 },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center', style: { backgroundColor: 'red', color: 'white', borderRadius: '20%' } },
	                    'BAJA'
	                )
	            ) : null,
	            esLider || operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia(operador.estado_asistencia) })
	            ),
	            esLider || operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia2(operador.estado_asistencia) })
	            ),
	            esLider || operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia3(operador.estado_asistencia) })
	            )
	        );
	    });
	
	    var rowsEscondidos = escondidos.map(function (operador, index) {
	
	        var captador = captadores.find(function (captador) {
	            return captador.idUsuario == operador.captador;
	        });
	        //totales.exp += operador.experienciaComoOperador; 
	        //totales.error += operador.error,
	        totales.sug += operador.unidadesContadas;
	        totales.real += operador.unidadesContadasReal;
	        return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	                'td',
	                null,
	                index + 1
	            ),
	            isPermisoMall ? _react2.default.createElement(
	                'td',
	                null,
	                usuariosConPermisoMap.has(operador.id) ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok ' + css.userConPermisoMall }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove ' + css.userSinPermisoMall, color: 'red' })
	            ) : null,
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.bloqueado == 1 ? "red" : operador.bloqueadoCliente ? "orange" : "#10c6de"
	                    }
	                },
	                operador.nombreCorto
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                captador ? captador.nombre : '-'
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.comuna
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.experienciaComoOperador
	            ),
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.error >= 1 ? "red" : "white"
	                    }
	                },
	                operador.error
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)
	            ),
	            operador.estado_asistencia == "-1" ? _react2.default.createElement(
	                'td',
	                { colSpan: 2 },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center', style: { backgroundColor: 'red', color: 'white', borderRadius: '20%' } },
	                    'BAJA'
	                )
	            ) : null,
	            operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia(operador.estado_asistencia) })
	            ),
	            operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia2(operador.estado_asistencia) })
	            ),
	            operador.estado_asistencia == "-1" ? null : _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement('div', { className: onColorAsistencia3(operador.estado_asistencia) })
	            )
	        );
	    });
	
	    var rowsBajas = bajas.map(function (operador, index) {
	
	        var captador = captadores.find(function (captador) {
	            return captador.idUsuario == operador.captador;
	        });
	        //totales.exp += operador.experienciaComoOperador; 
	        //totales.error += operador.error,
	        //totales.sug += operador.unidadesContadas;
	        //totales.real += operador.unidadesContadasReal;
	        return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	                'td',
	                null,
	                index + 1
	            ),
	            isPermisoMall ? _react2.default.createElement(
	                'td',
	                null,
	                usuariosConPermisoMap.has(operador.id) ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok ' + css.userConPermisoMall }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove ' + css.userSinPermisoMall, color: 'red' })
	            ) : null,
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.bloqueado == 1 || operador.estado_asistencia == '-1' ? "red" : operador.bloqueadoCliente ? "orange" : "white"
	                    }
	                },
	                operador.nombreCorto
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: { color: operador.estado_asistencia == '-1' ? "red" : "white" } },
	                captador ? captador.nombre : '-'
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: { color: operador.estado_asistencia == '-1' ? "red" : "white" } },
	                operador.comuna
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.experienciaComoOperador
	            ),
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.error >= 1 ? "red" : "white"
	                    }
	                },
	                operador.error
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: { textAlign: "right" } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)
	            ),
	            operador.estado_asistencia == "-1" ? _react2.default.createElement(
	                'td',
	                { colSpan: 3 },
	                _react2.default.createElement(
	                    'div',
	                    { className: css.mytooltipInside, style: { backgroundColor: 'red', color: 'white', borderRadius: '20%', width: 'full', textAlign: 'center', display: 'inline-block', position: 'relative' } },
	                    'BAJA',
	                    _react2.default.createElement(
	                        'span',
	                        { className: css.tooltipTableInside },
	                        operador.fecha_baja ? operador.fecha_baja : "Sin registro"
	                    )
	                )
	            ) : _react2.default.createElement('td', null)
	        );
	    });
	
	    return _react2.default.createElement(
	        'table',
	        { className: css.tablaInfoNomina },
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: 3 },
	                    localN + " " + localC + " - " + fecha + "  -  " + mensaje
	                )
	            ),
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    '#'
	                ),
	                isPermisoMall ? _react2.default.createElement(
	                    'th',
	                    null,
	                    'Mall'
	                ) : null,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Operador'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Captador'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Comuna'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'EXP'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Error'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "right" } },
	                    'Sug.'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "right" } },
	                    'Real'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-check' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-calendar' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-map-marker' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            rows,
	            escondidos.length > 0 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', { colSpan: 4, style: { height: '10px' } })
	            ) : null,
	            escondidos.length > 0 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: 3 },
	                    'Escondidos'
	                )
	            ) : null,
	            rowsEscondidos,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', null),
	                isPermisoMall ? _react2.default.createElement('td', null) : null,
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "right" } },
	                    new Intl.NumberFormat().format(totales.sug)
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "right" } },
	                    new Intl.NumberFormat().format(totales.real)
	                )
	            ),
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', null),
	                isPermisoMall ? _react2.default.createElement('td', null) : null,
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "right" } },
	                    new Intl.NumberFormat().format(totales.sug - stock)
	                ),
	                _react2.default.createElement('td', null)
	            )
	        ),
	        _react2.default.createElement(
	            'tfoot',
	            null,
	            bajas.length > 0 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement('td', { colSpan: 4, style: { height: '10px' } })
	            ) : null,
	            rowsBajas
	        )
	    );
	};
	
	var TableNominaAnterior = function TableNominaAnterior(_ref19) {
	    var fecha = _ref19.fecha,
	        turno = _ref19.turno,
	        nomina = _ref19.nomina,
	        stats = _ref19.stats;
	
	    var rows = stats == "sin datos" ? null : stats ? nomina.map(function (operador, index) {
	        return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.operador
	            ),
	            _react2.default.createElement(
	                'td',
	                {
	                    style: {
	                        color: operador.error >= 1 ? "red" : "white"
	                    }
	                },
	                operador.error
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: {
	                        textAlign: "right"
	                    } },
	                new Intl.NumberFormat('de-DE').format(operador.conteo)
	            )
	        );
	    }) : nomina.map(function (operador, index) {
	        return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	                'td',
	                null,
	                operador.operador
	            )
	        );
	    });
	
	    var columns = stats == "sin datos" ? null : stats ? _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            'td',
	            null,
	            'Operador'
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            'Error'
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            'Conteo'
	        )
	    ) : _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            'td',
	            null,
	            'Titulares'
	        )
	    );
	
	    var foot = stats == "sin datos" ? null : stats ? _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement('td', null),
	        _react2.default.createElement('td', null),
	        _react2.default.createElement('td', null),
	        _react2.default.createElement('td', null)
	    ) : _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement('td', null)
	    );
	    return _react2.default.createElement(
	        'table',
	        { className: css.tablaNominaAnterior },
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    fecha == "Sin datos" ? fecha : fecha + " - " + turno
	                )
	            ),
	            columns
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            rows
	        ),
	        _react2.default.createElement(
	            'tfoot',
	            null,
	            foot
	        )
	    );
	};
	
	RowInventario.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    puedeModificarDotaciones: _react2.default.PropTypes.bool.isRequired,
	    index: _react2.default.PropTypes.number.isRequired,
	    inventario: _react2.default.PropTypes.object.isRequired,
	    opcionesLideres: _react2.default.PropTypes.array.isRequired,
	    opcionesSupervisores: _react2.default.PropTypes.array.isRequired,
	    captadoresDisponibles: _react2.default.PropTypes.array.isRequired,
	    mostrarSeparador: _react2.default.PropTypes.bool.isRequired,
	    // Metodos
	    lideresDisponibles: _react2.default.PropTypes.func.isRequired,
	    guardarInventario: _react2.default.PropTypes.func.isRequired,
	    guardarNomina: _react2.default.PropTypes.func.isRequired,
	    focusRow: _react2.default.PropTypes.func.isRequired,
	    agregarCaptador: _react2.default.PropTypes.func.isRequired,
	    quitarCaptador: _react2.default.PropTypes.func.isRequired,
	    agregarRegionesCaptador: _react2.default.PropTypes.func.isRequired,
	    cambiarAsignados: _react2.default.PropTypes.func.isRequired,
	    estadoSolicitud: _react2.default.PropTypes.func,
	    saveDepartureTime: _react2.default.PropTypes.func.isRequired
	};
	RowInventario.defaultProps = {
	    mostrarSeparador: false
	};
	
	exports.default = RowInventario;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventarioSemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputHora = __webpack_require__(644);
	
	var _InputHora2 = _interopRequireDefault(_InputHora);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	// Estilos
	
	
	var InputHora = function (_React$Component) {
	    _inherits(InputHora, _React$Component);
	
	    function InputHora(props) {
	        _classCallCheck(this, InputHora);
	
	        var _this = _possibleConstructorReturn(this, (InputHora.__proto__ || Object.getPrototypeOf(InputHora)).call(this, props));
	
	        _this.state = {
	            hora: '01:01:00',
	            dirty: false
	        };
	        return _this;
	    }
	
	    _createClass(InputHora, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                hora: this.props.asignada,
	                dirty: false
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            var hora2 = nextProps.asignada;
	            this.setState({
	                hora: hora2,
	                dirty: false
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || /*evt.keyCode===40 ||*/evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.onGuardar();
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true) /*|| evt.keyCode===38*/{
	                    // flechaArriba = 38, shift+tab
	                    evt.preventDefault();
	                    this.props.onGuardar();
	                    this.props.focusRowAnterior();
	                }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            evt.preventDefault();
	            var hora = evt.target.value;
	            this.setState({
	                hora: hora,
	                dirty: this.props.asignada != hora
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputHora.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _InputHora2.default.divConTooltip },
	                _react2.default.createElement('input', {
	                    type: 'time',
	                    className: (this.state.dirty ? _InputHora2.default.inputHoraDirty : _InputHora2.default.inputHora) + ' ' + this.props.className,
	                    style: this.props.style,
	                    ref: function ref(_ref) {
	                        return _this2.inputHora = _ref;
	                    },
	                    value: this.state.hora,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onInputChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    required: true,
	                    disabled: this.props.puedeModificar ? '' : 'disabled'
	                }),
	                this.props.tooltipText ? _react2.default.createElement(
	                    'div',
	                    { className: _InputHora2.default.tooltip },
	                    this.props.tooltipText
	                ) : null
	            );
	        }
	    }]);
	
	    return InputHora;
	}(_react2.default.Component);
	
	InputHora.propTypes = {
	    // Objetos
	    asignada: _react2.default.PropTypes.string.isRequired,
	    tooltipText: _react2.default.PropTypes.string,
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func.isRequired,
	    focusRowSiguiente: _react2.default.PropTypes.func.isRequired,
	    onGuardar: _react2.default.PropTypes.func.isRequired
	};
	exports.default = InputHora;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputHora.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputHora":"InputHora__inputHora___17KqF shared__inputNumberAsText___1Qr9M","inputHoraDirty":"InputHora__inputHoraDirty___3ftDg InputHora__inputHora___17KqF shared__inputNumberAsText___1Qr9M","divConTooltip":"InputHora__divConTooltip___hEUb-","tooltip":"InputHora__tooltip___JiENs"};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(602);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _OverlayTrigger = __webpack_require__(579);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	var _InputDotacionSimple = __webpack_require__(646);
	
	var css = _interopRequireWildcard(_InputDotacionSimple);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	// Estilos
	
	
	var InputDotacionSimple = function (_React$Component) {
	    _inherits(InputDotacionSimple, _React$Component);
	
	    function InputDotacionSimple(props) {
	        _classCallCheck(this, InputDotacionSimple);
	
	        var _this = _possibleConstructorReturn(this, (InputDotacionSimple.__proto__ || Object.getPrototypeOf(InputDotacionSimple)).call(this, props));
	
	        _this.state = {
	            valor: '-',
	            dirty: false,
	            valid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputDotacionSimple, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                valor: this.props.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            var valor2 = nextProps.asignada;
	            this.setState({
	                valor: valor2,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	                this.props.focusRowAnterior();
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var valorUsuario = evt.target.value;
	            this.setState({
	                valor: valorUsuario,
	                dirty: this.props.asignada != valorUsuario,
	                valid: valorUsuario >= 0
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputStock.focus();
	            this.inputStock.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var classname = this.state.valid ? this.state.dirty ? css.inputDotacionDirty : css.inputDotacion : css.inputDotacionInvalida;
	            var input = _react2.default.createElement('input', {
	                className: classname + " " + this.props.className,
	                style: this.props.style,
	                ref: function ref(_ref) {
	                    return _this2.inputStock = _ref;
	                },
	                type: 'number',
	                value: this.state.valor,
	                onKeyDown: this.inputOnKeyDown.bind(this),
	                onChange: this.onInputChange.bind(this),
	                onBlur: function onBlur() {
	                    return _this2.props.onGuardar();
	                },
	                onFocus: function onFocus() {
	                    return _this2.inputStock.select();
	                },
	                disabled: !this.props.puedeModificar
	            });
	            {/*<OverlayTrigger
	                   placement="left"
	                   delay={0}
	                   overlay={<Tooltip id="yyy">{this.props.tooltipText}</Tooltip>}>
	                   <input
	                       className={classname + " " + this.props.className}
	                       style={this.props.style}
	                       ref={ref=>this.inputStock=ref}
	                       type="number"
	                       value={this.state.valor}
	                       onKeyDown={this.inputOnKeyDown.bind(this)}
	                       onChange={this.onInputChange.bind(this)}
	                       onBlur={()=>this.props.onGuardar()}
	                       onFocus={()=>{ this.inputStock.select() }}             // seleccionar el texto cuando se hace focus
	                       disabled={this.props.puedeModificar? '':'disabled'}
	                   />
	                </OverlayTrigger>*/}
	            if (!this.props.tooltipText) {
	                return input;
	            }
	            return _react2.default.createElement(
	                _OverlayTrigger2.default,
	                {
	                    placement: 'right',
	                    delay: 0,
	                    overlay: _react2.default.createElement(
	                        _Tooltip2.default,
	                        { id: "tooltip-" + this.props.idInv },
	                        'Dotaci\xF3n informada: ',
	                        this.props.tooltipText
	                    ) },
	                input
	            );
	        }
	    }]);
	
	    return InputDotacionSimple;
	}(_react2.default.Component);
	
	InputDotacionSimple.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    asignada: _react2.default.PropTypes.string.isRequired,
	    //tooltipText: React.PropTypes.string,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func.isRequired,
	    focusRowSiguiente: _react2.default.PropTypes.func.isRequired,
	    onGuardar: _react2.default.PropTypes.func.isRequired
	    // InputDotacionSimple.defaultProps = {
	    //     tooltipText: '..'
	    // }
	};exports.default = InputDotacionSimple;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputDotacionSimple.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputDotacion":"InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","inputDotacionDirty":"InputDotacionSimple__inputDotacionDirty___1vYs6 InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","inputDotacionInvalida":"InputDotacionSimple__inputDotacionInvalida___3fhJi InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","divConTooltip":"InputDotacionSimple__divConTooltip____kOso","tooltip":"InputDotacionSimple__tooltip___1GLLq"};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(648);
	
	var css = _interopRequireWildcard(_Select);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	// Estilos
	
	
	var Select = function (_React$Component) {
	    _inherits(Select, _React$Component);
	
	    function Select(props) {
	        _classCallCheck(this, Select);
	
	        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	        _this.state = {
	            seleccionUsuario: '-',
	            dirty: false
	        };
	        return _this;
	    }
	
	    _createClass(Select, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                seleccionUsuario: this.props.seleccionada,
	                dirty: false
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var seleccionada1 = this.props.seleccionada;
	            var seleccionada2 = nextProps.seleccionada;
	            if (seleccionada1 !== seleccionada2) {
	                // si esto cambia, entonces se debe hacer un "reset" del estado con los nuevos valores
	                this.setState({ seleccionUsuario: seleccionada2, dirty: false });
	            }
	            if (seleccionada2 !== this.state.seleccionUsuario) {
	                // si se reciben propiedades distintas al "state" actual, se reemplazan por las propiedades
	                this.setState({ seleccionUsuario: seleccionada2, dirty: false });
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var _this2 = this;
	
	            evt.preventDefault();
	            var seleccionUsuario = evt.target.value;
	            this.setState({
	                seleccionUsuario: seleccionUsuario,
	                dirty: this.props.seleccionada != seleccionUsuario
	            }, function () {
	                _this2.props.onSelect();
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'select',
	                { name: '',
	                    className: (this.state.dirty ? css.selectDirty : css.select) + ' ' + (this.props.puedeModificar ? '' : css.selectDisable) + ' ' + this.props.className,
	                    value: this.state.seleccionUsuario,
	                    onChange: this.onInputChange.bind(this),
	                    disabled: this.props.puedeModificar ? '' : 'disabled',
	                    style: this.props.style },
	                this.props.opcionNula ? _react2.default.createElement(
	                    'option',
	                    { value: '', disabled: this.props.opcionNulaSeleccionable === false },
	                    '--'
	                ) : null,
	                this.props.opciones.map(function (opcion, index) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: index, value: opcion.valor },
	                        opcion.texto
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    seleccionada: _react2.default.PropTypes.string.isRequired,
	    opciones: _react2.default.PropTypes.array.isRequired,
	    opcionNula: _react2.default.PropTypes.bool,
	    opcionNulaSeleccionable: _react2.default.PropTypes.bool,
	    // Metodos
	    onSelect: _react2.default.PropTypes.func.isRequired
	};
	Select.defaultProps = {
	    opcionNula: false,
	    opcionNulaSeleccionable: false
	};
	exports.default = Select;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Select.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"Select__select___29_c_ shared__inputNumberAsText___1Qr9M","selectDirty":"Select__selectDirty___lkTft Select__select___29_c_ shared__inputNumberAsText___1Qr9M","selectDisable":"Select__selectDisable___17kmo"};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectLider = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectLider = __webpack_require__(650);
	
	var css = _interopRequireWildcard(_SelectLider);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(652);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	// Estilos
	
	var cx = _bind2.default.bind(css);
	
	var SelectLider = exports.SelectLider = function (_React$Component) {
	    _inherits(SelectLider, _React$Component);
	
	    function SelectLider(props) {
	        _classCallCheck(this, SelectLider);
	
	        var _this = _possibleConstructorReturn(this, (SelectLider.__proto__ || Object.getPrototypeOf(SelectLider)).call(this, props));
	
	        _this.state = {
	            open: false,
	            options: [],
	            complete: false,
	            hoverIndex: null,
	            selectedLabel: '',
	            selectedValue: null,
	            dirty: false,
	            showModalSuspendido: false,
	            pendingValue: null
	            // Metodos del menu de opciones
	        };_this.__onClickHandler__ = function (evt) {
	            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
	            if (!_this.node.contains(evt.target) && _this.state.open) _this._hideOptionsList();
	            // this.cerrarMenu_descartarCambios()
	        };
	        _this._toggleOptionsList = function () {
	            if (_this.state.open) _this._hideOptionsList();else _this._openOptionsList();
	        };
	        _this._hideOptionsList = function () {
	            _this.setState({ open: false });
	        };
	        _this._openOptionsList = function () {
	            _this.setState({ open: true });
	            // retornamos un callback para que puedan cambiar el state
	            _this.props.onOpenList(function (_ref) {
	                var options = _ref.options,
	                    complete = _ref.complete;
	
	                _this.setState({ options: options, complete: complete });
	            });
	        };
	
	        // Interacciones
	        _this._selectOption = function (enabled, blocked, value) {
	            // si la opcion esta deshabilitada, no hacer nada con este evento
	            if (enabled == false) return;
	            if (blocked == true) return;
	            // si es la misma opcion que esta actualmente seleccionada, no hacer nada..
	            if (_this.state.selectedValue == value) {
	                _this.setState({ open: false });
	                return;
	            }
	            if (value == 10) {
	                _this.setState({
	                    showModalSuspendido: true,
	                    pendingValue: value,
	                    open: false
	                });
	                return;
	            }
	            var option = _this.state.options.find(function (opt) {
	                return opt.value == value;
	            });
	            _this.setState({
	                // seleccionar el 'value', modificar el 'label'
	                selectedLabel: option ? option.label : '-',
	                selectedValue: value,
	                // marcar como dirty solo si se selecciono una opcion diferente a la actualmente seleccionada
	                dirty: _this.selectedValue !== value,
	                // ocultar la lista
	                open: false
	            }, function () {
	                // informar al componente padre del cambio, solo una vez que se actualizo el state
	                _this.props.onChange(value);
	            });
	        };
	        _this._confirmarSuspendido = function () {
	            var value = _this.state.pendingValue;
	            var option = _this.state.options.find(function (opt) {
	                return opt.value == value;
	            });
	            _this.setState({
	                selectedLabel: option ? option.label : '-',
	                selectedValue: value,
	                dirty: true,
	                showModalSuspendido: false,
	                pendingValue: null
	            }, function () {
	                _this.props.onChange(value, { suspendidoConPago: true });
	            });
	        };
	        _this._cancelarSuspendido = function () {
	            var value = _this.state.pendingValue;
	            var option = _this.state.options.find(function (opt) {
	                return opt.value == value;
	            });
	            _this.setState({
	                selectedLabel: option ? option.label : '-',
	                selectedValue: value,
	                dirty: true,
	                showModalSuspendido: false,
	                pendingValue: null
	            }, function () {
	                _this.props.onChange(value, { suspendidoConPago: false });
	            });
	        };
	        _this._closeModal = function () {
	            _this.setState({
	                showModalSuspendido: false,
	                pendingValue: null
	            });
	        };
	        _this.onMouseEnterOption = function (hoverIndex) {
	            _this.setState({ hoverIndex: hoverIndex });
	        };
	        _this.onMouseLeaveOption = function () {
	            // puede haber problemas de "racing condition" con onMouseEnterOption
	            _this.setState({ hoverIndex: null });
	        };
	        return _this;
	    }
	    // cargar los elementos por defecto
	
	
	    _createClass(SelectLider, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                selectedValue: this.props.selectedValue,
	                selectedLabel: this.props.selectedLabel,
	                dirty: false
	            });
	        }
	        // actualizar los items al recibir nuevas propiedades
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var selectedValue_old = this.props.selectedValue;
	            var selectedValue_new = nextProps.selectedValue;
	            var option = this.state.options.find(function (opt) {
	                return opt.value == selectedValue_new;
	            });
	            if (selectedValue_old !== selectedValue_new) {
	                // si esto cambia, entonces se debe hacer un "reset" del estado con los nuevos valores
	                this.setState({
	                    selectedLabel: option ? option.label : nextProps.selectedLabel,
	                    selectedValue: selectedValue_new,
	                    dirty: false
	                });
	            }
	            if (selectedValue_new !== this.state.selectedValue) {
	                // si se reciben propiedades distintas al "state" actual, se reemplazan por las propiedades
	                this.setState({
	                    selectedLabel: option ? option.label : nextProps.selectedLabel,
	                    selectedValue: selectedValue_new,
	                    dirty: false
	                });
	            }
	        }
	        // Metodos para controlar el display del menu, ocultar y mostrar los elementos
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.__onClickHandler__);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.__onClickHandler__);
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return {
	                seleccionUsuario: this.state.selectedValue,
	                dirty: this.state.dirty
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: cx('select-lider', { 'hidden': this.props.visible == false }), ref: function ref(_ref2) {
	                        return _this2.node = _ref2;
	                    } },
	                this.props.editable ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('select', { 'select-dirty': this.state.dirty }),
	                            onClick: this._toggleOptionsList },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('select-text') },
	                            this.state.selectedLabel
	                        ),
	                        _react2.default.createElement('div', { className: cx('select-icon', {
	                                'arrow-up': !this.state.open,
	                                'arrow-down': this.state.open
	                            }) })
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: cx('options', { 'options-hidden': !this.state.open }) },
	                        this.state.complete ? this.state.options.map(function (opt, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { className: cx('option', 'no-select-text', {
	                                        'option-hover': _this2.state.hoverIndex == index,
	                                        'option-selected': _this2.state.selectedValue == opt.value,
	                                        'option-disabled': opt.blocked == true || opt.enabled == false
	                                    }),
	                                    key: index,
	                                    onMouseEnter: _this2.onMouseEnterOption.bind(_this2, index),
	                                    onMouseLeave: _this2.onMouseLeaveOption,
	                                    onClick: _this2._selectOption.bind(_this2, opt.enabled, opt.blocked, opt.value)
	                                },
	                                opt.label
	                            );
	                        }) : _react2.default.createElement(
	                            'li',
	                            { className: cx('option-loading', 'no-select-text') },
	                            ' cargando ...'
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: cx('select', 'select-disabled', { 'select-dirty': this.state.dirty }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('select-text') },
	                        this.state.selectedLabel
	                    )
	                ),
	                this.state.showModalSuspendido && _react2.default.createElement(_Modales.ModalSuspendidoPago, {
	                    hideModal: this._closeModal,
	                    lider: this.state.selectedValue,
	                    id: this.state.pendingValue,
	                    confirmar: this._confirmarSuspendido,
	                    cancelar: this._cancelarSuspendido
	                })
	            );
	        }
	    }]);
	
	    return SelectLider;
	}(_react2.default.Component);
	
	SelectLider.propTypes = {
	    visible: PropTypes.bool.isRequired,
	    editable: PropTypes.bool.isRequired,
	    onOpenList: PropTypes.func.isRequired,
	    onChange: PropTypes.func.isRequired,
	    selectedLabel: PropTypes.string.isRequired,
	    selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	    // arreglo: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectLider.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SELECT_WIDTH":"85px","OPTIONS_WIDTH":"100px","OPTIONS_HEIGHT":"150px","select-lider":"SelectLider__select-lider___22g9Z","hidden":"SelectLider__hidden___2eseg","select":"SelectLider__select___3xdZF","select-disabled":"SelectLider__select-disabled___1Bpc5","select-text":"SelectLider__select-text___2bwBP","select-icon":"SelectLider__select-icon___2xEUm","arrow-up":"SelectLider__arrow-up___1zF5w","arrow-down":"SelectLider__arrow-down___1y4CK","select-dirty":"SelectLider__select-dirty___CLnpZ","options":"SelectLider__options___1PJOg","options-hidden":"SelectLider__options-hidden___2px5L","option":"SelectLider__option___2McqY","no-select-text":"SelectLider__no-select-text___1QkBX","option-loading":"SelectLider__option-loading___3UIU3","option-hover":"SelectLider__option-hover___hmXN6","option-selected":"SelectLider__option-selected___5VOGT","option-disabled":"SelectLider__option-disabled___3e8cF"};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue.call(this, arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return this && this[arg] || arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(this, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, this && this[key] || key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalSuspendidoPago = exports.ModalLiderMasivo0Nominas = exports.ModalLiderMasivo = exports.ModalApproveReview = exports.ModalAdminStatusService = exports.ModalPublicacionIG = exports.ModalPublicarInventarios = exports.ModalCambiosNomina = exports.ModalSolicitudCambioNomina = exports.ModalSolicitudDotacion = exports.ModalPDALider = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.ModalMasivoNominas = ModalMasivoNominas;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _SelectRangeVirtualTable = __webpack_require__(703);
	
	var _SelectRangeVirtualTable2 = _interopRequireDefault(_SelectRangeVirtualTable);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _v3 = __webpack_require__(638);
	
	var _v4 = _interopRequireDefault(_v3);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(712);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	var css = _interopRequireWildcard(_modal);
	
	var _PanelCaptador = __webpack_require__(713);
	
	var cssOperador = _interopRequireWildcard(_PanelCaptador);
	
	var _BlackBoxAPI = __webpack_require__(714);
	
	var _BlackBoxAPI2 = _interopRequireDefault(_BlackBoxAPI);
	
	var _TablaAPI = __webpack_require__(715);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// API
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var format = 'YYYY-MM-DD';
	
	var ModalTrigger = exports.ModalTrigger = function (_Component) {
	    _inherits(ModalTrigger, _Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react.Component);
	
	var ModalPDALider = exports.ModalPDALider = function (_Component2) {
	    _inherits(ModalPDALider, _Component2);
	
	    function ModalPDALider(props) {
	        _classCallCheck(this, ModalPDALider);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalPDALider.__proto__ || Object.getPrototypeOf(ModalPDALider)).call(this, props));
	
	        _this2.blackbox = new _BlackBoxAPI2.default();
	        _this2.state = {
	            idLider: _this2.props.lideres[0]['valor'],
	            detallesFiltrados: [],
	            filtros: {},
	            fechaInicio: _this2.props.fechaInicial,
	            fechaFin: _this2.props.fechaFinal,
	            lideres: _this2.props.lideres,
	            totalDisponible: 0,
	            totalReal: 0,
	            totalNecesarias: 0,
	            totalExcedente: 0,
	            totalFaltantes: 0
	        };
	        _this2.fetchDetalle = function () {
	            _v2.default.activoFijo.getResumenPDA(_this2.state.idLider, _this2.state.fechaInicio, _this2.state.fechaFin).then(function (detalles) {
	                _this2.blackbox.reset();
	                detalles.forEach(function (detalle) {
	                    return _this2.blackbox.add(detalle);
	                });
	                _this2.blackbox.ordenarLista();
	                _this2.setState(_this2.blackbox.getListaFiltrada());
	            }).catch(function (meh) {});
	        };
	        return _this2;
	    }
	
	    _createClass(ModalPDALider, [{
	        key: 'actualizarFiltro',
	        value: function actualizarFiltro(nombreFiltro, filtro) {
	            this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalle();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPDALider'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        'table',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            { className: css.modalPDATotalesRow },
	                            _react2.default.createElement(
	                                'td',
	                                { className: css.modalPDATotales, title: 'Total de PDA que poseen los lideres' },
	                                'Total PDA en terreno: ',
	                                this.state.totalReal,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: css.modalPDATotalesBorde, title: 'Total de PDA que necesitan los lideres para los inventarios' },
	                                'Total PDA necesarias: ',
	                                this.state.totalNecesarias,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: css.modalPDATotalesBorde, title: 'Cantidad de PDA que necesitan los lideres para realizar los inventarios' },
	                                'Total PDA a suministrar: ',
	                                this.state.totalFaltantes,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: css.modalPDATotalesBorde, title: 'Cantidad de PDA extra que poseen los l\xEDderes' },
	                                'Total PDA excedente en terreno: ',
	                                this.state.totalExcedente,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: css.modalPDATotalesBorde, title: 'Cantidad de PDA disponibles en la bodega oficina' },
	                                'Total PDA disponible bodega SEI: ',
	                                this.state.totalDisponible,
	                                ' '
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(_TablaAPI.TablaAPI, {
	                        detalle: this.state.detallesFiltrados,
	                        filtros: this.state.filtros,
	                        actualizarFiltro: this.actualizarFiltro.bind(this)
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalPDALider;
	}(_react.Component);
	
	var ModalSolicitudDotacion = exports.ModalSolicitudDotacion = function (_Component3) {
	    _inherits(ModalSolicitudDotacion, _Component3);
	
	    function ModalSolicitudDotacion(props) {
	        _classCallCheck(this, ModalSolicitudDotacion);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalSolicitudDotacion.__proto__ || Object.getPrototypeOf(ModalSolicitudDotacion)).call(this, props));
	
	        _this3.state = {
	            fechaInicio: _this3.props.fechaInicial,
	            fechaFin: _this3.props.fechaFinal,
	            nominas: []
	        };
	        _this3.fetchDetalle = function () {
	            _v2.default.nominas.getPorRangoYSolicitud(_this3.state.fechaInicio, _this3.state.fechaFin).then(function (nominas) {
	                _this3.setState({ nominas: nominas });
	            }).catch(function (meh) {});
	        };
	        _this3.onClickSolicitud = function (idNomina, estado) {
	            _v2.default.nomina(idNomina).estadoSolicitud(estado).then(_this3.fetchDetalle()).catch(function (meh) {});
	        };
	
	        return _this3;
	    }
	
	    _createClass(ModalSolicitudDotacion, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalle();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalAumentoDot'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-plus-sign' }),
	                    ' Solicitudes aumento dotaci\xF3n'
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(TablaSolicitudes, {
	                        nominas: this.state.nominas,
	                        onClickSolicitud: this.onClickSolicitud
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalSolicitudDotacion;
	}(_react.Component);
	
	var ModalSolicitudCambioNomina = exports.ModalSolicitudCambioNomina = function (_Component4) {
	    _inherits(ModalSolicitudCambioNomina, _Component4);
	
	    function ModalSolicitudCambioNomina(props) {
	        _classCallCheck(this, ModalSolicitudCambioNomina);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalSolicitudCambioNomina.__proto__ || Object.getPrototypeOf(ModalSolicitudCambioNomina)).call(this, props));
	
	        _this4.state = {
	            fechaInicio: _this4.props.fechaInicial,
	            fechaFin: _this4.props.fechaFinal,
	            nominas: []
	        };
	        _this4.fetchNominasPendientes = function () {
	            _v2.default.nominas.getSolicitudesCambio(_this4.state.fechaInicio, _this4.state.fechaFin).then(function (resp) {
	                console.log(resp);
	                _this4.setState({
	                    nominas: resp
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this4.aprobarSolicitudCambio = function (idNomina, operador, operadorNuevo) {
	            _v2.default.nomina(idNomina).cambioEstadoSolicitud(operador, operadorNuevo, true).then(function (resp) {
	                _this4.fetchNominasPendientes();
	                _this4.props.pendientes();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this4.rechazarSolicitudCambio = function (idNomina, operador, operadorNuevo) {
	            _v2.default.nomina(idNomina).cambioEstadoSolicitud(operador, operadorNuevo, false).then(function (resp) {
	                _this4.fetchNominasPendientes();
	                _this4.props.pendientes();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalSolicitudCambioNomina, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchNominasPendientes();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalCambioDot'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-plus-sign' }),
	                    ' Solicitud reemplazo operador nuevo'
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(NominasPendientes, {
	                        nominas: this.state.nominas,
	                        aprobar: this.aprobarSolicitudCambio,
	                        rechazar: this.rechazarSolicitudCambio
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalSolicitudCambioNomina;
	}(_react.Component);
	
	function ModalMasivoNominas(_ref) {
	    var hideModal = _ref.hideModal,
	        informar = _ref.informar,
	        rectificar = _ref.rectificar;
	
	    var handleInformar = function handleInformar() {
	        console.log("informar");
	        hideModal();
	    };
	
	    var handleInformarSinCorreo = function handleInformarSinCorreo() {
	        console.log("informar sin correo");
	        hideModal();
	    };
	
	    var handleRectificar = function handleRectificar() {
	        console.log("rectificar");
	        hideModal();
	    };
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, dialogClassName: cx('modalEnvioNominas'), className: cx('modale') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-user' }),
	            ' Cambios en N\xF3minas Informadas'
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'button',
	                { onClick: handleInformar },
	                'Informar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { onClick: handleRectificar },
	                'Rectificar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { onClick: handleInformarSinCorreo },
	                'Informar (sin Correo)'
	            )
	        )
	    );
	}
	
	var ModalCambiosNomina = exports.ModalCambiosNomina = function (_Component5) {
	    _inherits(ModalCambiosNomina, _Component5);
	
	    function ModalCambiosNomina(props) {
	        _classCallCheck(this, ModalCambiosNomina);
	
	        var _this5 = _possibleConstructorReturn(this, (ModalCambiosNomina.__proto__ || Object.getPrototypeOf(ModalCambiosNomina)).call(this, props));
	
	        _this5.state = {
	            fechaInicio: _this5.props.fechaInicial,
	            fechaFin: _this5.props.fechaFinal,
	            nominas: [],
	            enviando: false,
	            error: ''
	        };
	        _this5.fetchNominasPendientes = function () {
	            _v2.default.nominas.getCambiosNominas(_this5.state.fechaInicio, _this5.state.fechaFin).then(function (resp) {
	                _this5.setState({
	                    nominas: resp
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this5.aprobarCambio = function (idNomina) {
	            _this5.setState({ enviando: true });
	            _v2.default.nomina(idNomina).completarSinCorreo().then(function (resp) {
	                _v2.default.nomina(idNomina).cambioNominaInformada(true).then(function (resp) {
	                    console.log("Nómina " + idNomina + "informada correctamente");
	                }).catch(function (err) {
	                    console.log(err);
	                    _this5.setState({
	                        enviando: false,
	                        error: "Ocurrió un error al aceptar los cambios, intente nuevamente"
	                    });
	                });
	                _this5.fetchNominasPendientes();
	                _this5.setState({
	                    enviando: false,
	                    error: ''
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this5.setState({
	                    enviando: false,
	                    error: err.data.idNomina
	                });
	            });
	        };
	        _this5.aprobarCambioCorreo = function (idNomina) {
	            _this5.setState({ enviando: true });
	            _v2.default.nomina(idNomina).informar().then(function (resp) {
	                _v2.default.nomina(idNomina).cambioNominaInformada(true).then(function (resp) {
	                    console.log("Nómina " + idNomina + "informada correctamente");
	                }).catch(function (err) {
	                    console.log(err);
	                    _this5.setState({
	                        enviando: false,
	                        error: "Ocurrió un error al aceptar los cambios, intente nuevamente"
	                    });
	                });
	                _this5.fetchNominasPendientes();
	                _this5.setState({
	                    enviando: false,
	                    error: ''
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this5.setState({
	                    enviando: false,
	                    error: err.data.idNomina
	                });
	            });
	        };
	        _this5.rechazarCambio = function (idNomina) {
	            _this5.setState({ enviando: true });
	            _v2.default.nomina(idNomina).cambioNominaInformada(false).then(function (resp) {
	                console.log(resp);
	                _v2.default.nomina(idNomina).rechazar();
	                _this5.fetchNominasPendientes();
	                _this5.setState({ enviando: false });
	            }).catch(function (err) {
	                console.log(err);
	                _this5.setState({ enviando: false });
	            });
	        };
	        return _this5;
	    }
	
	    _createClass(ModalCambiosNomina, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchNominasPendientes();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalCambiosNomina'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-user' }),
	                    ' Cambios en N\xF3minas Informadas'
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    this.state.error && _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger', role: 'alert' },
	                        this.state.error
	                    ),
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table table-bordered' },
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            this.state.nominas.map(function (list, index) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { className: cssModal.trSeparator },
	                                    _react2.default.createElement(Nomina, {
	                                        key: index,
	                                        nomina: list,
	                                        aprobar: _this6.aprobarCambio,
	                                        aprobarCorreo: _this6.aprobarCambioCorreo,
	                                        rechazar: _this6.rechazarCambio,
	                                        enviando: _this6.state.enviando
	                                    })
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalCambiosNomina;
	}(_react.Component);
	
	var ModalPublicarInventarios = exports.ModalPublicarInventarios = function (_Component6) {
	    _inherits(ModalPublicarInventarios, _Component6);
	
	    function ModalPublicarInventarios(props) {
	        _classCallCheck(this, ModalPublicarInventarios);
	
	        return _possibleConstructorReturn(this, (ModalPublicarInventarios.__proto__ || Object.getPrototypeOf(ModalPublicarInventarios)).call(this, props));
	    }
	
	    _createClass(ModalPublicarInventarios, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPDALider'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Publicar inventarios'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'ATENCI\xD3N, se publicar\xE1n los inventarios filtrados en programaci\xF3n IG, \xBFDesea proceder?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-warning pull-left',
	                                onClick: this.props.publicarInventario },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' }),
	                            ' Publicar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                            ' Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalPublicarInventarios;
	}(_react.Component);
	
	var ModalPublicacionIG = exports.ModalPublicacionIG = function (_Component7) {
	    _inherits(ModalPublicacionIG, _Component7);
	
	    function ModalPublicacionIG(props) {
	        _classCallCheck(this, ModalPublicacionIG);
	
	        var _this8 = _possibleConstructorReturn(this, (ModalPublicacionIG.__proto__ || Object.getPrototypeOf(ModalPublicacionIG)).call(this, props));
	
	        _this8.buscarInventarios = function () {
	            var fechaInicio = _this8.state.fechaInicialSeleccionada.format(format);
	            var fechaFin = _this8.state.fechaFinalSeleccionada.format(format);
	            _this8.setState({ inventarios: [] });
	            _v2.default.inventario.buscarPorPublicar(fechaInicio, fechaFin, 0).then(function (result) {
	                var cantidadPendientes = result.inventarios.filter(function (pendientes) {
	                    return pendientes.inv_estadoPublicacion === 1 || pendientes.inv_estadoPublicacion === 3;
	                });
	                _this8.setState({ inventarios: result.inventarios, cantidadPendientes: cantidadPendientes.length });
	            });
	        };
	
	        _this8.onSelectRangoChanged = function (momentumFechaInicio, momentumFechaFinal) {
	            _this8.setState({
	                fechaInicialSeleccionada: momentumFechaInicio,
	                fechaFinalSeleccionada: momentumFechaFinal
	            }, function () {
	                _this8.buscarInventarios();
	            });
	        };
	
	        _this8.state = {
	            fechaInicialSeleccionada: _this8.props.fechaInicial,
	            fechaFinalSeleccionada: _this8.props.fechaFinal,
	            inventarios: [],
	            cantidadPendientes: ''
	        };
	        _this8.onClickPublicar = function (estatus) {
	            var fechaInicio = _this8.state.fechaInicialSeleccionada.format(format);
	            var fechaFin = _this8.state.fechaFinalSeleccionada.format(format);
	            _v2.default.inventario.publicarProgramacion(fechaInicio, fechaFin, estatus).then(_this8.buscarInventarios).catch(function (meh) {});
	        };
	        return _this8;
	    }
	
	    _createClass(ModalPublicacionIG, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPublicacionIG'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-bookmark' }),
	                    ' Publicaci\xF3n programaci\xF3n de inventarios'
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(SelectorRango, {
	                            fechaInicial: this.state.fechaInicialSeleccionada,
	                            fechaFinal: this.state.fechaFinalSeleccionada,
	                            onSelectRangoChanged: this.onSelectRangoChanged
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6' },
	                            _react2.default.createElement(BotonDespublicar, {
	                                disabled: this.state.cantidadPendientes === this.state.inventarios.length,
	                                onClickPublicar: this.onClickPublicar
	                            }),
	                            _react2.default.createElement(BotonPublicar, {
	                                disabled: this.state.cantidadPendientes === 0,
	                                onClickPublicar: this.onClickPublicar
	                            }),
	                            _react2.default.createElement(BadgePendientes, {
	                                cantidadPendientes: this.state.cantidadPendientes
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(InventariosPublicacion, {
	                        inventarios: this.state.inventarios
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalPublicacionIG;
	}(_react.Component);
	
	var ModalAdminStatusService = exports.ModalAdminStatusService = function (_Component8) {
	    _inherits(ModalAdminStatusService, _Component8);
	
	    function ModalAdminStatusService(props) {
	        _classCallCheck(this, ModalAdminStatusService);
	
	        var _this9 = _possibleConstructorReturn(this, (ModalAdminStatusService.__proto__ || Object.getPrototypeOf(ModalAdminStatusService)).call(this, props));
	
	        _this9.state = {
	            initDate: _this9.props.initDate,
	            finishDate: _this9.props.finishDate,
	            services: [],
	            idClient: 1
	        };
	        _this9.searchServices = function () {
	            var initDate = _this9.state.initDate.format(format);
	            var finishDate = _this9.state.finishDate.format(format);
	            _v4.default.billing().getServices(_this9.state.idClient, initDate, finishDate).then(function (result) {
	                _this9.setState({ services: result.services });
	            });
	        };
	        _this9.onSelectRangeChanged = function (momentInitDate, momentFinishDate) {
	            _this9.setState({
	                initDate: momentInitDate,
	                finishDate: momentFinishDate
	            }, function () {
	                _this9.searchServices();
	            });
	        };
	        _this9.onSelectClientChanged = function (evt) {
	            var idClient = evt.target.value;
	            _this9.setState({
	                idClient: idClient
	            }, function () {
	                _this9.searchServices();
	            });
	        };
	        _this9.onChangeStatusService = function (idService, idStatus) {
	            _v2.default.inventario.updateStatus(idService, idStatus).then(function (result) {
	                _this9.searchServices();
	            });
	        };
	        return _this9;
	    }
	
	    _createClass(ModalAdminStatusService, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.searchServices();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var h5Style = {
	                color: 'peru'
	            };
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalAdminBilling'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Administraci\xF3n de estados de inventario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-11' },
	                            _react2.default.createElement(SelectorCliente, {
	                                idClienteSeleccionado: this.state.idClient,
	                                seleccionarCliente: this.onSelectClientChanged,
	                                clientes: this.props.clients
	                            }),
	                            _react2.default.createElement(SelectorRango, {
	                                fechaInicial: this.state.initDate,
	                                fechaFinal: this.state.finishDate,
	                                onSelectRangoChanged: this.onSelectRangeChanged
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(ServicesForBilling, {
	                        services: this.state.services,
	                        onChangeStatusService: this.onChangeStatusService
	                    }),
	                    _react2.default.createElement(
	                        'h5',
	                        { style: h5Style },
	                        'Para su informaci\xF3n las peticiones de ordenes de compra se env\xEDan a las 12 HRS cada d\xEDa, donde se incluyen solo los servicios en estado FACTURABLE.'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAdminStatusService;
	}(_react.Component);
	
	var ModalApproveReview = exports.ModalApproveReview = function ModalApproveReview(_ref2) {
	    var hideModal = _ref2.hideModal,
	        initDate = _ref2.initDate,
	        finishDate = _ref2.finishDate,
	        acceptAction = _ref2.acceptAction;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, dialogClassName: cx('modalApproveReview') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-info-sign' }),
	            ' Env\xEDo automatizado de n\xF3minas desde ' + initDate + ' hasta ' + finishDate
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Al aceptar la acci\xF3n se informaran las n\xF3minas del rango seleccionado, siempre y cuando se cumplan las validaciones del negocio.'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-success', onClick: function onClick() {
	                        return acceptAction(true);
	                    } },
	                'Correo'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-warning', onClick: function onClick() {
	                        return acceptAction(false);
	                    } },
	                'Sin Correo'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-secondary', onClick: hideModal },
	                'Cancelar'
	            )
	        )
	    );
	};
	
	// SELECTS
	var SelectorCliente = function SelectorCliente(_ref3) {
	    var idClienteSeleccionado = _ref3.idClienteSeleccionado,
	        seleccionarCliente = _ref3.seleccionarCliente,
	        clientes = _ref3.clientes;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4 form-group ' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label', htmlFor: 'cliente' },
	            'Clientes'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control', name: 'clientes',
	                value: idClienteSeleccionado,
	                onChange: seleccionarCliente
	            },
	            clientes.map(function (cliente) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: cliente.idCliente, value: cliente.idCliente },
	                    '' + cliente.nombreCorto
	                );
	            })
	        )
	    );
	};
	
	var SelectorRango = function SelectorRango(_ref4) {
	    var fechaInicial = _ref4.fechaInicial,
	        fechaFinal = _ref4.fechaFinal,
	        onSelectRangoChanged = _ref4.onSelectRangoChanged;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6 form-group ' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label', htmlFor: 'selectSemana' },
	            'Rango de Fecha'
	        ),
	        _react2.default.createElement(_SelectRangeVirtualTable2.default, {
	            startDateSelected: fechaInicial,
	            endDateSelected: fechaFinal,
	            onInit: function onInit() {
	                console.log("on init");
	            },
	            onRangeSelected: onSelectRangoChanged.bind(undefined)
	        })
	    );
	};
	
	var SelectStatusService = function SelectStatusService(_ref5) {
	    var service = _ref5.service,
	        onChangeStatusService = _ref5.onChangeStatusService;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: service.service_status_id,
	                onChange: function onChange(evt) {
	                    return onChangeStatusService(service.service_id, evt.target.value);
	                }
	            },
	            _react2.default.createElement(
	                'option',
	                { key: 1, value: 1 },
	                'Creado'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 2, value: 2 },
	                'Suspendido'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 3, value: 3 },
	                'Mal Realizado'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 4, value: 4 },
	                'Facturable'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 5, value: 5 },
	                'No Facturable'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 6, value: 6 },
	                'Facturaci\xF3n Especial'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 7, value: 7 },
	                'Rechazado'
	            )
	        )
	    );
	};
	
	// TABLES
	var InventariosPublicacion = function InventariosPublicacion(_ref6) {
	    var inventarios = _ref6.inventarios;
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '80%' }, className: 'row' },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref7) {
	                var height = _ref7.height,
	                    width = _ref7.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table
	                    // general
	                    ,
	                    { height: height,
	                        width: width
	                        // headers
	                        , headerHeight: 30,
	                        headerClassName: css.headerColumn
	                        // rows
	                        , rowCount: inventarios.length,
	                        rowGetter: function rowGetter(_ref8) {
	                            var index = _ref8.index;
	                            return inventarios[index];
	                        },
	                        rowHeight: 30,
	                        rowClassName: function rowClassName(_ref9) {
	                            var index = _ref9.index;
	                            return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'cliente_nombreCorto', label: 'CL',
	                        cellRenderer: function cellRenderer(_ref10) {
	                            var cellData = _ref10.cellData,
	                                columnData = _ref10.columnData,
	                                dataKey = _ref10.dataKey,
	                                rowData = _ref10.rowData,
	                                rowIndex = _ref10.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_fechaProgramadaF', label: 'Fecha',
	                        cellRenderer: function cellRenderer(_ref11) {
	                            var cellData = _ref11.cellData,
	                                columnData = _ref11.columnData,
	                                dataKey = _ref11.dataKey,
	                                rowData = _ref11.rowData,
	                                rowIndex = _ref11.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 190
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_ceco', label: 'CECO',
	                        cellRenderer: function cellRenderer(_ref12) {
	                            var cellData = _ref12.cellData,
	                                columnData = _ref12.columnData,
	                                dataKey = _ref12.dataKey,
	                                rowData = _ref12.rowData,
	                                rowIndex = _ref12.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_nombre', label: 'Local',
	                        cellRenderer: function cellRenderer(_ref13) {
	                            var cellData = _ref13.cellData,
	                                columnData = _ref13.columnData,
	                                dataKey = _ref13.dataKey,
	                                rowData = _ref13.rowData,
	                                rowIndex = _ref13.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 300
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_comuna', label: 'Comuna',
	                        cellRenderer: function cellRenderer(_ref14) {
	                            var cellData = _ref14.cellData,
	                                columnData = _ref14.columnData,
	                                dataKey = _ref14.dataKey,
	                                rowData = _ref14.rowData,
	                                rowIndex = _ref14.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 200
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_region', label: 'Region',
	                        cellRenderer: function cellRenderer(_ref15) {
	                            var cellData = _ref15.cellData,
	                                columnData = _ref15.columnData,
	                                dataKey = _ref15.dataKey,
	                                rowData = _ref15.rowData,
	                                rowIndex = _ref15.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_estadoPublicacion', label: 'Estado',
	                        cellRenderer: function cellRenderer(_ref16) {
	                            var cellData = _ref16.cellData,
	                                columnData = _ref16.columnData,
	                                dataKey = _ref16.dataKey,
	                                rowData = _ref16.rowData,
	                                rowIndex = _ref16.rowIndex;
	
	                            if (rowData[dataKey] === 2) {
	                                return _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'label label-success' },
	                                        'PUBLICADO'
	                                    )
	                                );
	                            } else if (rowData[dataKey] === 3) {
	                                return _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'label label-info' },
	                                        'MODIFICADO'
	                                    )
	                                );
	                            } else {
	                                return _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'label label-warning' },
	                                        'PENDIENTE'
	                                    )
	                                );
	                            }
	                        },
	                        width: 120
	                    })
	                );
	            }
	        )
	    );
	};
	
	var ServicesForBilling = function ServicesForBilling(_ref17) {
	    var services = _ref17.services,
	        onChangeStatusService = _ref17.onChangeStatusService;
	
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '80%' }, className: 'row' },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref18) {
	                var height = _ref18.height,
	                    width = _ref18.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table
	                    // general
	                    ,
	                    { height: height,
	                        width: width
	                        // headers
	                        , headerHeight: 30,
	                        headerClassName: css.headerColumn
	                        // rows
	                        , rowCount: services.length,
	                        rowGetter: function rowGetter(_ref19) {
	                            var index = _ref19.index;
	                            return services[index];
	                        },
	                        rowHeight: 30,
	                        rowClassName: function rowClassName(_ref20) {
	                            var index = _ref20.index;
	                            return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'service_date', label: 'Fecha',
	                        cellRenderer: function cellRenderer(_ref21) {
	                            var cellData = _ref21.cellData,
	                                columnData = _ref21.columnData,
	                                dataKey = _ref21.dataKey,
	                                rowData = _ref21.rowData,
	                                rowIndex = _ref21.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 190
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'store_ceco', label: 'CECO',
	                        cellRenderer: function cellRenderer(_ref22) {
	                            var cellData = _ref22.cellData,
	                                columnData = _ref22.columnData,
	                                dataKey = _ref22.dataKey,
	                                rowData = _ref22.rowData,
	                                rowIndex = _ref22.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'store_name', label: 'Local',
	                        cellRenderer: function cellRenderer(_ref23) {
	                            var cellData = _ref23.cellData,
	                                columnData = _ref23.columnData,
	                                dataKey = _ref23.dataKey,
	                                rowData = _ref23.rowData,
	                                rowIndex = _ref23.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 260
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'store_comuna', label: 'Comuna',
	                        cellRenderer: function cellRenderer(_ref24) {
	                            var cellData = _ref24.cellData,
	                                columnData = _ref24.columnData,
	                                dataKey = _ref24.dataKey,
	                                rowData = _ref24.rowData,
	                                rowIndex = _ref24.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 200
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'units_counted', label: 'UND',
	                        cellRenderer: function cellRenderer(_ref25) {
	                            var cellData = _ref25.cellData,
	                                columnData = _ref25.columnData,
	                                dataKey = _ref25.dataKey,
	                                rowData = _ref25.rowData,
	                                rowIndex = _ref25.rowIndex;
	                            return rowData[dataKey].toLocaleString("es-CL");
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'unit_value', label: 'FACTOR',
	                        cellRenderer: function cellRenderer(_ref26) {
	                            var cellData = _ref26.cellData,
	                                columnData = _ref26.columnData,
	                                dataKey = _ref26.dataKey,
	                                rowData = _ref26.rowData,
	                                rowIndex = _ref26.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'total_billing', label: 'TOTAL',
	                        cellRenderer: function cellRenderer(_ref27) {
	                            var cellData = _ref27.cellData,
	                                columnData = _ref27.columnData,
	                                dataKey = _ref27.dataKey,
	                                rowData = _ref27.rowData,
	                                rowIndex = _ref27.rowIndex;
	                            return rowData[dataKey].toLocaleString("es-CL", { style: "currency", currency: "CLP" });
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: '', label: 'Estado',
	                        cellRenderer: function cellRenderer(_ref28) {
	                            var cellData = _ref28.cellData,
	                                columnData = _ref28.columnData,
	                                dataKey = _ref28.dataKey,
	                                rowData = _ref28.rowData,
	                                rowIndex = _ref28.rowIndex;
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(SelectStatusService, {
	                                    service: rowData,
	                                    onChangeStatusService: onChangeStatusService
	                                })
	                            );
	                        },
	                        width: 150
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: '', label: '',
	                        cellRenderer: function cellRenderer(_ref29) {
	                            var cellData = _ref29.cellData,
	                                columnData = _ref29.columnData,
	                                dataKey = _ref29.dataKey,
	                                rowData = _ref29.rowData,
	                                rowIndex = _ref29.rowIndex;
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(ButtonIsBilling, {
	                                    service: rowData,
	                                    buttonClassName: rowData['is_billing'] ? 'btn btn-sm btn-success' : 'btn btn-sm btn-warning'
	                                })
	                            );
	                        },
	                        width: 50
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: '', label: '',
	                        cellRenderer: function cellRenderer(_ref30) {
	                            var cellData = _ref30.cellData,
	                                columnData = _ref30.columnData,
	                                dataKey = _ref30.dataKey,
	                                rowData = _ref30.rowData,
	                                rowIndex = _ref30.rowIndex;
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(ButtonOptionService, {
	                                    service: rowData,
	                                    buttonClassName: rowData['billing_request_id'] ? 'btn btn-sm btn-success' : 'btn btn-sm btn-warning'
	                                })
	                            );
	                        },
	                        width: 50
	                    })
	                );
	            }
	        )
	    );
	};
	
	var TablaSolicitudes = function TablaSolicitudes(_ref31) {
	    var nominas = _ref31.nominas,
	        onClickSolicitud = _ref31.onClickSolicitud;
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '40%' }, className: 'row' },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref32) {
	                var height = _ref32.height,
	                    width = _ref32.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table
	                    // general
	                    ,
	                    { height: height,
	                        width: width
	                        // headers
	                        , headerHeight: 30,
	                        headerClassName: css.headerColumnAumentoDot
	                        // rows
	                        , rowCount: nominas.length,
	                        rowGetter: function rowGetter(_ref33) {
	                            var index = _ref33.index;
	                            return nominas[index];
	                        },
	                        rowHeight: 30,
	                        rowClassName: function rowClassName(_ref34) {
	                            var index = _ref34.index;
	                            return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_fechaProgramadaF', label: 'FECHA',
	                        cellRenderer: function cellRenderer(_ref35) {
	                            var cellData = _ref35.cellData,
	                                columnData = _ref35.columnData,
	                                dataKey = _ref35.dataKey,
	                                rowData = _ref35.rowData,
	                                rowIndex = _ref35.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 180
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'cliente_nombreCorto', label: 'CL',
	                        cellRenderer: function cellRenderer(_ref36) {
	                            var cellData = _ref36.cellData,
	                                columnData = _ref36.columnData,
	                                dataKey = _ref36.dataKey,
	                                rowData = _ref36.rowData,
	                                rowIndex = _ref36.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_numero', label: 'CE',
	                        cellRenderer: function cellRenderer(_ref37) {
	                            var cellData = _ref37.cellData,
	                                columnData = _ref37.columnData,
	                                dataKey = _ref37.dataKey,
	                                rowData = _ref37.rowData,
	                                rowIndex = _ref37.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_region', label: 'RG',
	                        cellRenderer: function cellRenderer(_ref38) {
	                            var cellData = _ref38.cellData,
	                                columnData = _ref38.columnData,
	                                dataKey = _ref38.dataKey,
	                                rowData = _ref38.rowData,
	                                rowIndex = _ref38.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'local_nombre', label: 'TIENDA',
	                        cellRenderer: function cellRenderer(_ref39) {
	                            var cellData = _ref39.cellData,
	                                columnData = _ref39.columnData,
	                                dataKey = _ref39.dataKey,
	                                rowData = _ref39.rowData,
	                                rowIndex = _ref39.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 250
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_stock', label: 'STOCK ACTUAL',
	                        cellRenderer: function cellRenderer(_ref40) {
	                            var cellData = _ref40.cellData,
	                                columnData = _ref40.columnData,
	                                dataKey = _ref40.dataKey,
	                                rowData = _ref40.rowData,
	                                rowIndex = _ref40.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_stock_ultimo', label: 'ULTIMO CONTEO',
	                        cellRenderer: function cellRenderer(_ref41) {
	                            var cellData = _ref41.cellData,
	                                columnData = _ref41.columnData,
	                                dataKey = _ref41.dataKey,
	                                rowData = _ref41.rowData,
	                                rowIndex = _ref41.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_dot_ultimo', label: 'ULTIMA DOT.',
	                        cellRenderer: function cellRenderer(_ref42) {
	                            var cellData = _ref42.cellData,
	                                columnData = _ref42.columnData,
	                                dataKey = _ref42.dataKey,
	                                rowData = _ref42.rowData,
	                                rowIndex = _ref42.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'inv_tiempo_ultimo', label: 'HRS CONTEO',
	                        cellRenderer: function cellRenderer(_ref43) {
	                            var cellData = _ref43.cellData,
	                                columnData = _ref43.columnData,
	                                dataKey = _ref43.dataKey,
	                                rowData = _ref43.rowData,
	                                rowIndex = _ref43.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'dotacionOperadores', label: 'ACTUAL DOT.',
	                        cellRenderer: function cellRenderer(_ref44) {
	                            var cellData = _ref44.cellData,
	                                columnData = _ref44.columnData,
	                                dataKey = _ref44.dataKey,
	                                rowData = _ref44.rowData,
	                                rowIndex = _ref44.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'diferenciaSolicitud', label: 'SOLICITUD',
	                        cellRenderer: function cellRenderer(_ref45) {
	                            var cellData = _ref45.cellData,
	                                columnData = _ref45.columnData,
	                                dataKey = _ref45.dataKey,
	                                rowData = _ref45.rowData,
	                                rowIndex = _ref45.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'dotacionSolicitud', label: 'NUEVA DOT.',
	                        cellRenderer: function cellRenderer(_ref46) {
	                            var cellData = _ref46.cellData,
	                                columnData = _ref46.columnData,
	                                dataKey = _ref46.dataKey,
	                                rowData = _ref46.rowData,
	                                rowIndex = _ref46.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'comentarioDotacion', label: 'Coment.',
	                        cellRenderer: function cellRenderer(_ref47) {
	                            var cellData = _ref47.cellData,
	                                columnData = _ref47.columnData,
	                                dataKey = _ref47.dataKey,
	                                rowData = _ref47.rowData,
	                                rowIndex = _ref47.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'idNomina',
	                        cellRenderer: function cellRenderer(_ref48) {
	                            var cellData = _ref48.cellData,
	                                columnData = _ref48.columnData,
	                                dataKey = _ref48.dataKey,
	                                rowData = _ref48.rowData,
	                                rowIndex = _ref48.rowIndex;
	                            return _react2.default.createElement(BotonAprobar, {
	                                idNomina: rowData[dataKey],
	                                onClickSolicitud: onClickSolicitud,
	                                estado: 4
	                            });
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'idNomina',
	                        cellRenderer: function cellRenderer(_ref49) {
	                            var cellData = _ref49.cellData,
	                                columnData = _ref49.columnData,
	                                dataKey = _ref49.dataKey,
	                                rowData = _ref49.rowData,
	                                rowIndex = _ref49.rowIndex;
	                            return _react2.default.createElement(BotonRechazar, {
	                                idNomina: rowData[dataKey],
	                                onClickSolicitud: onClickSolicitud,
	                                estado: 5
	                            });
	                        },
	                        width: 100
	                    })
	                );
	            }
	        )
	    );
	};
	
	var Nomina = function Nomina(_ref50) {
	    var nomina = _ref50.nomina,
	        aprobar = _ref50.aprobar,
	        aprobarCorreo = _ref50.aprobarCorreo,
	        rechazar = _ref50.rechazar,
	        enviando = _ref50.enviando;
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-6 control-label' },
	                'Fecha Inv.: ',
	                nomina.inv_fechaProgramadaF
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-3 control-label' },
	                'Regi\xF3n: ',
	                nomina.local_region
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-3 control-label' },
	                'Comuna: ',
	                nomina.local_comuna
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-4 control-label' },
	                'Cliente: ',
	                nomina.cliente_nombreCorto
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-4 control-label' },
	                'CECO: ',
	                nomina.local_numero
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: 'col-md-4 control-label' },
	                'Tienda: ',
	                nomina.local_nombre
	            )
	        ),
	        nomina.cantCambiosTitular > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6' },
	            _react2.default.createElement(
	                'div',
	                { className: 'panel panel-success' },
	                _react2.default.createElement(
	                    'div',
	                    { className: cx("panel-heading", 'panelHeading') },
	                    'Dotaci\xF3n Titular'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table table-striped table-bordered table-hover table-condensed ' + cssOperador.tablaDotacion },
	                        _react2.default.createElement(
	                            'colgroup',
	                            null,
	                            _react2.default.createElement('col', { className: cssOperador.colNombreM }),
	                            _react2.default.createElement('col', { className: cssOperador.colExp }),
	                            _react2.default.createElement('col', { className: cssOperador.colError }),
	                            _react2.default.createElement('col', { className: cssOperador.colConteoReal }),
	                            _react2.default.createElement('col', { className: cssOperador.colConteo })
	                        ),
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { colSpan: 3 },
	                                    '\xA0'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { className: cssOperador.thConteoSpan, colSpan: 2 },
	                                    'Conteo'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Nombre'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Exp'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Error'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Real'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Proyecci\xF3n'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            nomina.dotacionTitular.map(function (titular, index) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { className: titular.idEstadoAprobacion === 1 ? null : cssOperador.thNuevoOperador, key: index },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        titular.nombreCorto
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        titular.experienciaComoOperador
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        titular.error
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        titular.unidadesContadasReal
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        titular.unidadesContadas
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(
	                                'tr',
	                                { key: nomina.dotacionTitular.length + 1 },
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: cssOperador.tdContNomina, colSpan: 4 },
	                                    'Tot. Conteo'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: cssOperador.tdContNomina },
	                                    nomina.sumaUnidades
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                { key: nomina.dotacionTitular.length + 2 },
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: cssOperador.tdStock, colSpan: 4 },
	                                    'Stock Inv.'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: cssOperador.tdStock },
	                                    nomina.local_stock
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                { key: nomina.dotacionTitular.length + 3 },
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: nomina.estadoDiferencia ? cssOperador.tdDifStockPositivo : cssOperador.tdDifStockNegativo, colSpan: 4 },
	                                    'Diferencia'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: nomina.estadoDiferencia ? cssOperador.tdDifStockPositivo : cssOperador.tdDifStockNegativo },
	                                    nomina.diferenciaUnidades
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: cx("col-md-12 control-label", 'labelCantidad') },
	                        'Cantidad de Cambios: ',
	                        nomina.cantCambiosTitular,
	                        ' de ',
	                        nomina.totalTitular
	                    )
	                )
	            )
	        ) : null,
	        nomina.cantCambiosReemplazo > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6' },
	            _react2.default.createElement(
	                'div',
	                { className: 'panel panel-info' },
	                _react2.default.createElement(
	                    'div',
	                    { className: cx("panel-heading", 'panelHeading') },
	                    'Dotaci\xF3n Reemplazo'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table table-striped table-bordered table-hover table-condensed ' + cssOperador.tablaDotacion },
	                        _react2.default.createElement(
	                            'colgroup',
	                            null,
	                            _react2.default.createElement('col', { className: cssOperador.colNombreM }),
	                            _react2.default.createElement('col', { className: cssOperador.colExp }),
	                            _react2.default.createElement('col', { className: cssOperador.colError }),
	                            _react2.default.createElement('col', { className: cssOperador.colConteoReal }),
	                            _react2.default.createElement('col', { className: cssOperador.colConteo })
	                        ),
	                        _react2.default.createElement(
	                            'thead',
	                            { className: cssOperador.tHeadSmall },
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { colSpan: 3 },
	                                    '\xA0'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { className: cssOperador.thConteoSpan, colSpan: 2 },
	                                    'Conteo'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Nombre'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Exp'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Error'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Real'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Proyecci\xF3n'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            nomina.dotacionReemplazo.map(function (reemplazo, index) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { className: reemplazo.idEstadoAprobacion === 1 ? null : cssOperador.thNuevoOperador, key: index },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        reemplazo.nombreCorto
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        reemplazo.experienciaComoOperador
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        reemplazo.error
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        reemplazo.unidadesContadasReal
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        reemplazo.unidadesContadas
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: cx("col-md-12 control-label", 'labelCantidad') },
	                        'Cantidad de Cambios: ',
	                        nomina.cantCambiosReemplazo,
	                        ' de ',
	                        nomina.totalReemplazo
	                    )
	                )
	            )
	        ) : null,
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-7 col-md-offset-3' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-group', role: 'group', 'aria-label': '...' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: cx("btn btn-md btn-success glyphicon glyphicon-ok", 'glyphicon'), onClick: function onClick() {
	                                return aprobar(nomina.idNomina);
	                            }, title: 'Aceptar cambio en la n\xF3mina', disabled: enviando },
	                        ' Aprobar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: cx("btn btn-md btn-primary glyphicon glyphicon-envelope", 'glyphicon'), onClick: function onClick() {
	                                return aprobarCorreo(nomina.idNomina);
	                            }, title: 'Aceptar cambio en la n\xF3mina con correo', disabled: enviando },
	                        ' Aprobar con Correo'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: cx("btn btn-md btn-danger glyphicon glyphicon-remove", 'glyphicon'), onClick: function onClick() {
	                                return rechazar(nomina.idNomina);
	                            }, title: 'Rechazar cambio en n\xF3mina', disabled: enviando },
	                        ' Rechazar'
	                    )
	                )
	            )
	        )
	    );
	};
	/* BUTTONS */
	var BotonAprobar = function BotonAprobar(_ref51) {
	    var idNomina = _ref51.idNomina,
	        estado = _ref51.estado,
	        onClickSolicitud = _ref51.onClickSolicitud;
	    return _react2.default.createElement(
	        'button',
	        { className: 'btn btn-xs btn-success', onClick: onClickSolicitud.bind(undefined, idNomina, estado) },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' })
	    );
	};
	
	var BotonRechazar = function BotonRechazar(_ref52) {
	    var idNomina = _ref52.idNomina,
	        estado = _ref52.estado,
	        onClickSolicitud = _ref52.onClickSolicitud;
	    return _react2.default.createElement(
	        'button',
	        { className: 'btn btn-xs btn-danger', onClick: onClickSolicitud.bind(undefined, idNomina, estado) },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' })
	    );
	};
	
	var BotonPublicar = function BotonPublicar(_ref53) {
	    var onClickPublicar = _ref53.onClickPublicar,
	        disabled = _ref53.disabled;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	            'button',
	            { className: 'btn btn-sm btn-success', style: { width: "100%" }, onClick: onClickPublicar.bind(undefined, 2), disabled: disabled },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-up' }),
	            ' Publicar'
	        )
	    );
	};
	
	var BotonDespublicar = function BotonDespublicar(_ref54) {
	    var onClickPublicar = _ref54.onClickPublicar,
	        disabled = _ref54.disabled;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	            'button',
	            { className: 'btn btn-sm btn-warning', style: { width: "100%" }, onClick: onClickPublicar.bind(undefined, 1), disabled: disabled },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-down' }),
	            ' Despublicar'
	        )
	    );
	};
	
	var BadgePendientes = function BadgePendientes(_ref55) {
	    var cantidadPendientes = _ref55.cantidadPendientes;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4' },
	        _react2.default.createElement(
	            'button',
	            { className: 'btn btn-sm btn-info', style: { width: "100%" }, type: 'button' },
	            'Pendientes ',
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                cantidadPendientes
	            )
	        )
	    );
	};
	
	var ButtonOptionService = function ButtonOptionService(_ref56) {
	    var service = _ref56.service,
	        buttonClassName = _ref56.buttonClassName;
	    return _react2.default.createElement(
	        'button',
	        { className: buttonClassName, style: { width: "100%" } },
	        service.billing_request_id ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' }) : _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' })
	    );
	};
	
	var ButtonIsBilling = function ButtonIsBilling(_ref57) {
	    var service = _ref57.service,
	        buttonClassName = _ref57.buttonClassName;
	    return _react2.default.createElement(
	        'button',
	        { className: buttonClassName, style: { width: "100%" } },
	        service.is_billing ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok-circle' }) : _react2.default.createElement('span', { className: 'glyphicon glyphicon-ban-circle' })
	    );
	};
	
	var ModalLiderMasivo = exports.ModalLiderMasivo = function (_React$Component) {
	    _inherits(ModalLiderMasivo, _React$Component);
	
	    function ModalLiderMasivo(props) {
	        _classCallCheck(this, ModalLiderMasivo);
	
	        var _this10 = _possibleConstructorReturn(this, (ModalLiderMasivo.__proto__ || Object.getPrototypeOf(ModalLiderMasivo)).call(this, props));
	
	        _this10.state = {
	            bloqueado: false
	        };
	        _this10.confirmar = function () {
	            _this10.setState({ bloqueado: true });
	            var cambiosNominas = {};
	            cambiosNominas.idLider = _this10.props.idLiderMasivo;
	            _this10.props.liderMultiple(cambiosNominas, _this10.props.hideModal);
	            /*.then(()=>{
	                console.log(this.props.hideModal)
	                this.setState({bloqueado: false})
	                this.props.hideModal()
	                
	            })
	            .catch(err=>{
	                console.error(err.data)
	            })*/
	        };
	        return _this10;
	    }
	
	    _createClass(ModalLiderMasivo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Favor confirmar la asignaci\xF3n m\xFAltiple'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\xBFEst\xE1 seguro de asignar un total de ',
	                        this.props.totalInventarios,
	                        ' n\xF3minas a ',
	                        this.props.lider ? this.props.lider.nombre1 : 'SIN',
	                        ' ',
	                        this.props.lider ? this.props.lider.apellidoPaterno : 'LÍDER',
	                        '?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.confirmar, disabled: this.state.bloqueado },
	                        'Agregar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalLiderMasivo;
	}(_react2.default.Component);
	
	var ModalLiderMasivo0Nominas = exports.ModalLiderMasivo0Nominas = function (_React$Component2) {
	    _inherits(ModalLiderMasivo0Nominas, _React$Component2);
	
	    function ModalLiderMasivo0Nominas(props) {
	        _classCallCheck(this, ModalLiderMasivo0Nominas);
	
	        var _this11 = _possibleConstructorReturn(this, (ModalLiderMasivo0Nominas.__proto__ || Object.getPrototypeOf(ModalLiderMasivo0Nominas)).call(this, props));
	
	        _this11.state = {
	            bloqueado: false
	        };
	        _this11.confirmarvolver = function () {
	            _this11.props.hideModal();
	            _this11.setState({ bloqueado: true });
	        };
	        return _this11;
	    }
	
	    _createClass(ModalLiderMasivo0Nominas, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'No se han seleccionado n\xF3minas'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Por favor seleccione una o m\xE1s n\xF3minas antes de asignar un l\xEDder de forma masiva'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.confirmarvolver, disabled: this.state.bloqueado },
	                        'Volver'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalLiderMasivo0Nominas;
	}(_react2.default.Component);
	
	var ModalSuspendidoPago = exports.ModalSuspendidoPago = function ModalSuspendidoPago(_ref58) {
	    var hideModal = _ref58.hideModal,
	        confirmar = _ref58.confirmar,
	        cancelar = _ref58.cancelar;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, dialogClassName: cx('modalApproveReview') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-info-sign' }),
	            ' \xBFEste inventario se suspende con pago?'
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Al aceptar, el inventario seguir\xE1 con el supervisor seleccionado pero quedar\xE1 en estado suspendido.'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-success', onClick: function onClick() {
	                        return confirmar();
	                    } },
	                'Confirmar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-danger', onClick: function onClick() {
	                        return cancelar();
	                    } },
	                'Sin pago'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-secondary', onClick: hideModal },
	                'Cerrar'
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(654);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(657);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(660);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'defaultCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	Object.defineProperty(exports, 'uniformSizeCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	Object.defineProperty(exports, 'idCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.idCellSizeCache;
	  }
	});
	
	var _Collection = __webpack_require__(664);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(672);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _Table = __webpack_require__(674);
	
	Object.defineProperty(exports, 'defaultTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Table;
	  }
	});
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortIndicator;
	  }
	});
	
	var _Grid = __webpack_require__(682);
	
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(691);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _List = __webpack_require__(693);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _List.List;
	  }
	});
	
	var _MultiGrid = __webpack_require__(695);
	
	Object.defineProperty(exports, 'MultiGrid', {
	  enumerable: true,
	  get: function get() {
	    return _MultiGrid.MultiGrid;
	  }
	});
	
	var _ScrollSync = __webpack_require__(697);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _WindowScroller = __webpack_require__(699);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowKeyStepper = exports.default = undefined;
	
	var _ArrowKeyStepper2 = __webpack_require__(655);
	
	var _ArrowKeyStepper3 = _interopRequireDefault(_ArrowKeyStepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArrowKeyStepper3.default;
	exports.ArrowKeyStepper = _ArrowKeyStepper3.default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	var ArrowKeyStepper = function (_Component) {
	  _inherits(ArrowKeyStepper, _Component);
	
	  function ArrowKeyStepper(props, context) {
	    _classCallCheck(this, ArrowKeyStepper);
	
	    var _this = _possibleConstructorReturn(this, (ArrowKeyStepper.__proto__ || Object.getPrototypeOf(ArrowKeyStepper)).call(this, props, context));
	
	    _this.state = {
	      scrollToColumn: props.scrollToColumn,
	      scrollToRow: props.scrollToRow
	    };
	
	    _this._columnStartIndex = 0;
	    _this._columnStopIndex = 0;
	    _this._rowStartIndex = 0;
	    _this._rowStopIndex = 0;
	
	    _this._onKeyDown = _this._onKeyDown.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(ArrowKeyStepper, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var scrollToColumn = nextProps.scrollToColumn;
	      var scrollToRow = nextProps.scrollToRow;
	
	
	      if (this.props.scrollToColumn !== scrollToColumn) {
	        this.setState({ scrollToColumn: scrollToColumn });
	      }
	
	      if (this.props.scrollToRow !== scrollToRow) {
	        this.setState({ scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var children = _props.children;
	      var _state = this.state;
	      var scrollToColumn = _state.scrollToColumn;
	      var scrollToRow = _state.scrollToRow;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          onKeyDown: this._onKeyDown
	        },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onKeyDown',
	    value: function _onKeyDown(event) {
	      var _props2 = this.props;
	      var columnCount = _props2.columnCount;
	      var disabled = _props2.disabled;
	      var mode = _props2.mode;
	      var rowCount = _props2.rowCount;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var _state2 = this.state;
	      var scrollToColumnPrevious = _state2.scrollToColumn;
	      var scrollToRowPrevious = _state2.scrollToRow;
	      var _state3 = this.state;
	      var scrollToColumn = _state3.scrollToColumn;
	      var scrollToRow = _state3.scrollToRow;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	      switch (event.key) {
	        case 'ArrowDown':
	          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(this._rowStopIndex + 1, rowCount - 1);
	          break;
	        case 'ArrowLeft':
	          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(this._columnStartIndex - 1, 0);
	          break;
	        case 'ArrowRight':
	          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(this._columnStopIndex + 1, columnCount - 1);
	          break;
	        case 'ArrowUp':
	          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(this._rowStartIndex - 1, 0);
	          break;
	      }
	
	      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
	        event.preventDefault();
	
	        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref) {
	      var columnStartIndex = _ref.columnStartIndex;
	      var columnStopIndex = _ref.columnStopIndex;
	      var rowStartIndex = _ref.rowStartIndex;
	      var rowStopIndex = _ref.rowStopIndex;
	
	      this._columnStartIndex = columnStartIndex;
	      this._columnStopIndex = columnStopIndex;
	      this._rowStartIndex = rowStartIndex;
	      this._rowStopIndex = rowStopIndex;
	    }
	  }]);
	
	  return ArrowKeyStepper;
	}(_react.Component);
	
	ArrowKeyStepper.defaultProps = {
	  disabled: false,
	  mode: 'edges',
	  scrollToColumn: 0,
	  scrollToRow: 0
	};
	exports.default = ArrowKeyStepper;
	 false ? ArrowKeyStepper.propTypes = {
	  children: _react.PropTypes.func.isRequired,
	  className: _react.PropTypes.string,
	  columnCount: _react.PropTypes.number.isRequired,
	  disabled: _react.PropTypes.bool.isRequired,
	  mode: _react.PropTypes.oneOf(['cells', 'edges']),
	  rowCount: _react.PropTypes.number.isRequired,
	  scrollToColumn: _react.PropTypes.number.isRequired,
	  scrollToRow: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AutoSizer = exports.default = undefined;
	
	var _AutoSizer2 = __webpack_require__(658);
	
	var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoSizer3.default;
	exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _detectElementResize = __webpack_require__(659);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Decorator component that automatically adjusts the width and height of a single child.
	 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
	 * All other properties will be passed through to the child component.
	 */
	var AutoSizer = function (_Component) {
	  _inherits(AutoSizer, _Component);
	
	  function AutoSizer(props) {
	    _classCallCheck(this, AutoSizer);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));
	
	    _this.state = {
	      height: 0,
	      width: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Delay access of parentNode until mount.
	      // This handles edge-cases where the component has already been unmounted before its ref has been set,
	      // As well as libraries like react-lite which have a slightly different lifecycle.
	      this._parentNode = this._autoSizer.parentNode;
	
	      // Defer requiring resize handler in order to support server-side rendering.
	      // See issue #41
	      this._detectElementResize = (0, _detectElementResize2.default)();
	      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	      this._onResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disableHeight = _props.disableHeight;
	      var disableWidth = _props.disableWidth;
	      var _state = this.state;
	      var height = _state.height;
	      var width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setRef,
	          style: outerStyle
	        },
	        children({ height: height, width: width })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var onResize = this.props.onResize;
	
	      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
	      // This can result in invalid style values which can result in NaN values if we don't handle them.
	      // See issue #150 for more context.
	
	      var boundingRect = this._parentNode.getBoundingClientRect();
	      var height = boundingRect.height || 0;
	      var width = boundingRect.width || 0;
	
	      var style = window.getComputedStyle(this._parentNode) || {};
	      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	      var paddingRight = parseInt(style.paddingRight, 10) || 0;
	      var paddingTop = parseInt(style.paddingTop, 10) || 0;
	      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	
	      this.setState({
	        height: height - paddingTop - paddingBottom,
	        width: width - paddingLeft - paddingRight
	      });
	
	      onResize({ height: height, width: width });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(autoSizer) {
	      this._autoSizer = autoSizer;
	    }
	  }]);
	
	  return AutoSizer;
	}(_react.Component);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {}
	};
	exports.default = AutoSizer;
	 false ? AutoSizer.propTypes = {
	  /**
	  * Function responsible for rendering children.
	  * This function should implement the following signature:
	  * ({ height, width }) => PropTypes.element
	  */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Disable dynamic :height property */
	  disableHeight: _react.PropTypes.bool,
	
	  /** Disable dynamic :width property */
	  disableWidth: _react.PropTypes.bool,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _react.PropTypes.func.isRequired
	} : void 0;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 **/
	
	function createDetectElementResize() {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = this;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        animationstring = 'animation',
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            animationstring = pfx + 'Animation';
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles() {
	    if (!document.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = document.head || document.getElementsByTagName('head')[0],
	          style = document.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) element.attachEvent('onresize', fn);else {
	      if (!element.__resizeTriggers__) {
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles();
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) resetTriggers(element);
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) element.detachEvent('onresize', fn);else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.idCellSizeCache = exports.defaultCellSizeCache = exports.CellMeasurer = exports.default = undefined;
	
	var _CellMeasurer2 = __webpack_require__(661);
	
	var _CellMeasurer3 = _interopRequireDefault(_CellMeasurer2);
	
	var _defaultCellSizeCache2 = __webpack_require__(662);
	
	var _defaultCellSizeCache3 = _interopRequireDefault(_defaultCellSizeCache2);
	
	var _idCellSizeCache2 = __webpack_require__(663);
	
	var _idCellSizeCache3 = _interopRequireDefault(_idCellSizeCache2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer3.default;
	exports.CellMeasurer = _CellMeasurer3.default;
	exports.defaultCellSizeCache = _defaultCellSizeCache3.default;
	exports.idCellSizeCache = _idCellSizeCache3.default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _defaultCellSizeCache = __webpack_require__(662);
	
	var _defaultCellSizeCache2 = _interopRequireDefault(_defaultCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Measures a Grid cell's contents by rendering them in a way that is not visible to the user.
	 * Either a fixed width or height may be provided if it is desirable to measure only in one direction.
	 */
	var CellMeasurer = function (_Component) {
	  _inherits(CellMeasurer, _Component);
	
	  function CellMeasurer(props, state) {
	    _classCallCheck(this, CellMeasurer);
	
	    var _this = _possibleConstructorReturn(this, (CellMeasurer.__proto__ || Object.getPrototypeOf(CellMeasurer)).call(this, props, state));
	
	    _this._cellSizeCache = props.cellSizeCache || new _defaultCellSizeCache2.default();
	
	    _this.getColumnWidth = _this.getColumnWidth.bind(_this);
	    _this.getRowHeight = _this.getRowHeight.bind(_this);
	    _this.resetMeasurements = _this.resetMeasurements.bind(_this);
	    _this.resetMeasurementForColumn = _this.resetMeasurementForColumn.bind(_this);
	    _this.resetMeasurementForRow = _this.resetMeasurementForRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(CellMeasurer, [{
	    key: 'getColumnWidth',
	    value: function getColumnWidth(_ref) {
	      var index = _ref.index;
	
	      var columnWidth = this._cellSizeCache.getColumnWidth(index);
	      if (columnWidth != null) {
	        return columnWidth;
	      }
	
	      var rowCount = this.props.rowCount;
	
	
	      var maxWidth = 0;
	
	      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
	        var _measureCell2 = this._measureCell({
	          clientWidth: true,
	          columnIndex: index,
	          rowIndex: rowIndex
	        });
	
	        var width = _measureCell2.width;
	
	
	        maxWidth = Math.max(maxWidth, width);
	      }
	
	      this._cellSizeCache.setColumnWidth(index, maxWidth);
	
	      return maxWidth;
	    }
	  }, {
	    key: 'getRowHeight',
	    value: function getRowHeight(_ref2) {
	      var index = _ref2.index;
	
	      var rowHeight = this._cellSizeCache.getRowHeight(index);
	      if (rowHeight != null) {
	        return rowHeight;
	      }
	
	      var columnCount = this.props.columnCount;
	
	
	      var maxHeight = 0;
	
	      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
	        var _measureCell3 = this._measureCell({
	          clientHeight: true,
	          columnIndex: columnIndex,
	          rowIndex: index
	        });
	
	        var height = _measureCell3.height;
	
	
	        maxHeight = Math.max(maxHeight, height);
	      }
	
	      this._cellSizeCache.setRowHeight(index, maxHeight);
	
	      return maxHeight;
	    }
	  }, {
	    key: 'resetMeasurementForColumn',
	    value: function resetMeasurementForColumn(columnIndex) {
	      this._cellSizeCache.clearColumnWidth(columnIndex);
	    }
	  }, {
	    key: 'resetMeasurementForRow',
	    value: function resetMeasurementForRow(rowIndex) {
	      this._cellSizeCache.clearRowHeight(rowIndex);
	    }
	  }, {
	    key: 'resetMeasurements',
	    value: function resetMeasurements() {
	      this._cellSizeCache.clearAllColumnWidths();
	      this._cellSizeCache.clearAllRowHeights();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderAndMount();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var cellSizeCache = this.props.cellSizeCache;
	
	
	      if (cellSizeCache !== nextProps.cellSizeCache) {
	        this._cellSizeCache = nextProps.cellSizeCache;
	      }
	
	      this._updateDivDimensions(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmountContainer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        getColumnWidth: this.getColumnWidth,
	        getRowHeight: this.getRowHeight,
	        resetMeasurements: this.resetMeasurements,
	        resetMeasurementForColumn: this.resetMeasurementForColumn,
	        resetMeasurementForRow: this.resetMeasurementForRow
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_getContainerNode',
	    value: function _getContainerNode(props) {
	      var container = props.container;
	
	
	      if (container) {
	        return _reactDom2.default.findDOMNode(typeof container === 'function' ? container() : container);
	      } else {
	        return document.body;
	      }
	    }
	  }, {
	    key: '_measureCell',
	    value: function _measureCell(_ref3) {
	      var _ref3$clientHeight = _ref3.clientHeight;
	      var clientHeight = _ref3$clientHeight === undefined ? false : _ref3$clientHeight;
	      var _ref3$clientWidth = _ref3.clientWidth;
	      var clientWidth = _ref3$clientWidth === undefined ? true : _ref3$clientWidth;
	      var columnIndex = _ref3.columnIndex;
	      var rowIndex = _ref3.rowIndex;
	      var cellRenderer = this.props.cellRenderer;
	
	
	      var rendered = cellRenderer({
	        columnIndex: columnIndex,
	        index: rowIndex, // Simplify List :rowRenderer use case
	        rowIndex: rowIndex
	      });
	
	      // Handle edge case where this method is called before the CellMeasurer has completed its initial render (and mounted).
	      this._renderAndMount();
	
	      // @TODO Keep an eye on this for future React updates as the interface may change:
	      // https://twitter.com/soprano/status/737316379712331776
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, rendered, this._div);
	
	      var measurements = {
	        height: clientHeight && this._div.clientHeight,
	        width: clientWidth && this._div.clientWidth
	      };
	
	      _reactDom2.default.unmountComponentAtNode(this._div);
	
	      return measurements;
	    }
	  }, {
	    key: '_renderAndMount',
	    value: function _renderAndMount() {
	      if (!this._div) {
	        this._div = document.createElement('div');
	        this._div.style.display = 'inline-block';
	        this._div.style.position = 'absolute';
	        this._div.style.visibility = 'hidden';
	        this._div.style.zIndex = -1;
	
	        this._updateDivDimensions(this.props);
	
	        this._containerNode = this._getContainerNode(this.props);
	        this._containerNode.appendChild(this._div);
	      }
	    }
	  }, {
	    key: '_unmountContainer',
	    value: function _unmountContainer() {
	      if (this._div) {
	        this._containerNode.removeChild(this._div);
	
	        this._div = null;
	      }
	
	      this._containerNode = null;
	    }
	  }, {
	    key: '_updateDivDimensions',
	    value: function _updateDivDimensions(props) {
	      var height = props.height;
	      var width = props.width;
	
	
	      if (height && height !== this._divHeight) {
	        this._divHeight = height;
	        this._div.style.height = height + 'px';
	      }
	
	      if (width && width !== this._divWidth) {
	        this._divWidth = width;
	        this._div.style.width = width + 'px';
	      }
	    }
	  }]);
	
	  return CellMeasurer;
	}(_react.Component);
	
	exports.default = CellMeasurer;
	 false ? CellMeasurer.propTypes = {
	  /**
	   * Renders a cell given its indices.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional, custom caching strategy for cell sizes.
	   */
	  cellSizeCache: _react.PropTypes.object,
	
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ getColumnWidth, getRowHeight, resetMeasurements }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * A Node, Component instance, or function that returns either.
	   * If this property is not specified the document body will be used.
	   */
	  container: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.func, _react2.default.PropTypes.node]),
	
	  /**
	   * Assign a fixed :height in order to measure dynamic text :width only.
	   */
	  height: _react.PropTypes.number,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Assign a fixed :width in order to measure dynamic text :height only.
	   */
	  width: _react.PropTypes.number
	} : void 0;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Default CellMeasurer `cellSizeCache` implementation.
	 * Permanently caches all cell sizes (identified by column and row index) unless explicitly cleared.
	 * Can be configured to handle uniform cell widths and/or heights as a way of optimizing certain use cases.
	 */
	var DefaultCellSizeCache = function () {
	  function DefaultCellSizeCache() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref$uniformRowHeight = _ref.uniformRowHeight;
	    var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
	    var _ref$uniformColumnWid = _ref.uniformColumnWidth;
	    var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
	
	    _classCallCheck(this, DefaultCellSizeCache);
	
	    this._uniformRowHeight = uniformRowHeight;
	    this._uniformColumnWidth = uniformColumnWidth;
	
	    this._cachedColumnWidth = undefined;
	    this._cachedRowHeight = undefined;
	
	    this._cachedColumnWidths = {};
	    this._cachedRowHeights = {};
	  }
	
	  _createClass(DefaultCellSizeCache, [{
	    key: "clearAllColumnWidths",
	    value: function clearAllColumnWidths() {
	      this._cachedColumnWidth = undefined;
	      this._cachedColumnWidths = {};
	    }
	  }, {
	    key: "clearAllRowHeights",
	    value: function clearAllRowHeights() {
	      this._cachedRowHeight = undefined;
	      this._cachedRowHeights = {};
	    }
	  }, {
	    key: "clearColumnWidth",
	    value: function clearColumnWidth(index) {
	      this._cachedColumnWidth = undefined;
	
	      delete this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "clearRowHeight",
	    value: function clearRowHeight(index) {
	      this._cachedRowHeight = undefined;
	
	      delete this._cachedRowHeights[index];
	    }
	  }, {
	    key: "getColumnWidth",
	    value: function getColumnWidth(index) {
	      return this._uniformColumnWidth ? this._cachedColumnWidth : this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "getRowHeight",
	    value: function getRowHeight(index) {
	      return this._uniformRowHeight ? this._cachedRowHeight : this._cachedRowHeights[index];
	    }
	  }, {
	    key: "setColumnWidth",
	    value: function setColumnWidth(index, width) {
	      this._cachedColumnWidth = width;
	      this._cachedColumnWidths[index] = width;
	    }
	  }, {
	    key: "setRowHeight",
	    value: function setRowHeight(index, height) {
	      this._cachedRowHeight = height;
	      this._cachedRowHeights[index] = height;
	    }
	  }]);
	
	  return DefaultCellSizeCache;
	}();
	
	exports.default = DefaultCellSizeCache;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = idCellSizeCache;
	
	var _defaultCellSizeCache = __webpack_require__(662);
	
	var _defaultCellSizeCache2 = _interopRequireDefault(_defaultCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Alternate CellMeasurer `cellSizeCache` implementation.
	 * Similar to `defaultCellSizeCache` except that sizes are tied to data id rather than index.
	 * Requires an index-to-id map function (passed in externally) to operate.
	 */
	function idCellSizeCache(_ref) {
	  var indexToIdMap = _ref.indexToIdMap;
	  var _ref$uniformColumnWid = _ref.uniformColumnWidth;
	  var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
	  var _ref$uniformRowHeight = _ref.uniformRowHeight;
	  var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
	
	  var cellSizeCache = new _defaultCellSizeCache2.default({
	    uniformColumnWidth: uniformColumnWidth,
	    uniformRowHeight: uniformRowHeight
	  });
	
	  return {
	    clearAllColumnWidths: function clearAllColumnWidths() {
	      cellSizeCache.clearAllColumnWidths();
	    },
	    clearAllRowHeights: function clearAllRowHeights() {
	      cellSizeCache.clearAllRowHeights();
	    },
	    clearColumnWidth: function clearColumnWidth(index) {
	      cellSizeCache.clearColumnWidth(indexToIdMap(index));
	    },
	    clearRowHeight: function clearRowHeight(index) {
	      cellSizeCache.clearRowHeight(indexToIdMap(index));
	    },
	    getColumnWidth: function getColumnWidth(index) {
	      return cellSizeCache.getColumnWidth(indexToIdMap(index));
	    },
	    getRowHeight: function getRowHeight(index) {
	      return cellSizeCache.getRowHeight(indexToIdMap(index));
	    },
	    setColumnWidth: function setColumnWidth(index, width) {
	      cellSizeCache.setColumnWidth(indexToIdMap(index), width);
	    },
	    setRowHeight: function setRowHeight(index, height) {
	      cellSizeCache.setRowHeight(indexToIdMap(index), height);
	    }
	  };
	}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = exports.default = undefined;
	
	var _Collection2 = __webpack_require__(665);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection3.default;
	exports.Collection = _Collection3.default;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionView = __webpack_require__(666);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(668);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(671);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var Collection = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection(props, context) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    return _this;
	  }
	
	  /** See Collection#recomputeCellSizesAndPositions */
	
	
	  _createClass(Collection, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = _objectWithoutProperties(this.props, []);
	
	      return _react2.default.createElement(_CollectionView2.default, _extends({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: function ref(_ref) {
	          _this2._collectionView = _ref;
	        }
	      }, props));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props;
	      var cellCount = _props.cellCount;
	      var cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter;
	      var sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref2) {
	      var align = _ref2.align;
	      var cellIndex = _ref2.cellIndex;
	      var height = _ref2.height;
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var width = _ref2.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref3) {
	      var _this3 = this;
	
	      var height = _ref3.height;
	      var isScrolling = _ref3.isScrolling;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	      var _props2 = this.props;
	      var cellGroupRenderer = _props2.cellGroupRenderer;
	      var cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref4) {
	          var index = _ref4.index;
	          return _this3._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }]);
	
	  return Collection;
	}(_react.Component);
	
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	 false ? Collection.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _react.PropTypes.number
	} : void 0;
	
	
	function defaultCellGroupRenderer(_ref5) {
	  var cellCache = _ref5.cellCache;
	  var cellRenderer = _ref5.cellRenderer;
	  var cellSizeAndPositionGetter = _ref5.cellSizeAndPositionGetter;
	  var indices = _ref5.indices;
	  var isScrolling = _ref5.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    var cellRendererProps = {
	      index: index,
	      isScrolling: isScrolling,
	      key: index,
	      style: {
	        height: cellMetadata.height,
	        left: cellMetadata.x,
	        position: 'absolute',
	        top: cellMetadata.y,
	        width: cellMetadata.width
	      }
	    };
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer(cellRendererProps);
	      }
	
	      return cellCache[index];
	    } else {
	      return cellRenderer(cellRendererProps);
	    }
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createCallbackMemoizer = __webpack_require__(667);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(412);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// @TODO It would be nice to refactor Grid to use this code as well.
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_Component) {
	  _inherits(CollectionView, _Component);
	
	  function CollectionView(props, context) {
	    _classCallCheck(this, CollectionView);
	
	    var _this = _possibleConstructorReturn(this, (CollectionView.__proto__ || Object.getPrototypeOf(CollectionView)).call(this, props, context));
	
	    _this.state = {
	      calculateSizeAndPositionDataOnNextUpdate: false,
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes callbacks only when their values have changed.
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around.
	    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  _createClass(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this.setState({
	        calculateSizeAndPositionDataOnNextUpdate: true
	      });
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var cellLayoutManager = _props.cellLayoutManager;
	      var scrollLeft = _props.scrollLeft;
	      var scrollToCell = _props.scrollToCell;
	      var scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge.height;
	      var totalWidth = _cellLayoutManager$ge.width;
	
	      // Initialize onScroll callback.
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props;
	      var height = _props2.height;
	      var scrollToAlignment = _props2.scrollToAlignment;
	      var scrollToCell = _props2.scrollToCell;
	      var width = _props2.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var cellLayoutManager = this.props.cellLayoutManager;
	
	
	      cellLayoutManager.calculateSizeAndPositionData();
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextProps.cellCount === 0 && (nextState.scrollLeft !== 0 || nextState.scrollTop !== 0)) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        nextProps.cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      if (nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        this.setState({
	          calculateSizeAndPositionDataOnNextUpdate: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var cellCount = _props3.cellCount;
	      var cellLayoutManager = _props3.cellLayoutManager;
	      var className = _props3.className;
	      var height = _props3.height;
	      var horizontalOverscanSize = _props3.horizontalOverscanSize;
	      var id = _props3.id;
	      var noContentRenderer = _props3.noContentRenderer;
	      var style = _props3.style;
	      var verticalOverscanSize = _props3.verticalOverscanSize;
	      var width = _props3.width;
	      var _state2 = this.state;
	      var isScrolling = _state2.isScrolling;
	      var scrollLeft = _state2.scrollLeft;
	      var scrollTop = _state2.scrollTop;
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge2.height;
	      var totalWidth = _cellLayoutManager$ge2.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        WebkitOverflowScrolling: 'touch',
	        width: width,
	        willChange: 'transform'
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref) {
	            _this2._scrollingContainer = _ref;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Collection', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, collectionStyle, style),
	          tabIndex: 0
	        },
	        cellCount > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            }
	          },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this3 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this3.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this3._disablePointerEventsTimeoutId = null;
	        _this3.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnSectionRenderedHelper',
	    value: function _invokeOnSectionRenderedHelper() {
	      var _props4 = this.props;
	      var cellLayoutManager = _props4.cellLayoutManager;
	      var onSectionRendered = _props4.onSectionRendered;
	
	
	      this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref2) {
	      var _this4 = this;
	
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var totalHeight = _ref2.totalHeight;
	      var totalWidth = _ref2.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref3) {
	          var scrollLeft = _ref3.scrollLeft;
	          var scrollTop = _ref3.scrollTop;
	          var _props5 = _this4.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref4) {
	      var scrollLeft = _ref4.scrollLeft;
	      var scrollTop = _ref4.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_updateScrollPositionForScrollToCell',
	    value: function _updateScrollPositionForScrollToCell() {
	      var _props6 = this.props;
	      var cellLayoutManager = _props6.cellLayoutManager;
	      var height = _props6.height;
	      var scrollToAlignment = _props6.scrollToAlignment;
	      var scrollToCell = _props6.scrollToCell;
	      var width = _props6.width;
	      var _state3 = this.state;
	      var scrollLeft = _state3.scrollLeft;
	      var scrollTop = _state3.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          this._setScrollPosition(scrollPosition);
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props7 = this.props;
	      var cellLayoutManager = _props7.cellLayoutManager;
	      var height = _props7.height;
	      var isScrollingChange = _props7.isScrollingChange;
	      var width = _props7.width;
	
	      var scrollbarSize = this._scrollbarSize;
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge3.height;
	      var totalWidth = _cellLayoutManager$ge3.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!this.state.isScrolling) {
	          isScrollingChange(true);
	        }
	
	        this.setState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    }
	  }]);
	
	  return CollectionView;
	}(_react.Component);
	
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  style: {},
	  verticalOverscanSize: 0
	};
	exports.default = CollectionView;
	 false ? CollectionView.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _react.PropTypes.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Collection element.
	   */
	  id: _react.PropTypes.string,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _react.PropTypes.number.isRequired,
	
	  isScrollingChange: _react.PropTypes.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _react.PropTypes.number,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _react.PropTypes.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCallbackMemoizer;
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback;
	    var indices = _ref.indices;
	
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(669);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter;
	  var sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Window Sections are used to group nearby cells.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This enables us to more quickly determine which cells to display in a given region of the Window.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _Section = __webpack_require__(670);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SECTION_SIZE = 100;
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
	
	    _classCallCheck(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  _createClass(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height;
	      var width = _ref.width;
	      var x = _ref.x;
	      var y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return Object.keys(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return Object.keys(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return Object.keys(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum;
	      var index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height;
	    var width = _ref.width;
	    var x = _ref.x;
	    var y = _ref.y;
	
	    _classCallCheck(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  _createClass(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	
	  return Section;
	}(); /** @rlow */
	
	
	exports.default = Section;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align;
	  var align = _ref$align === undefined ? 'auto' : _ref$align;
	  var cellOffset = _ref.cellOffset;
	  var cellSize = _ref.cellSize;
	  var containerSize = _ref.containerSize;
	  var currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = exports.default = undefined;
	
	var _ColumnSizer2 = __webpack_require__(673);
	
	var _ColumnSizer3 = _interopRequireDefault(_ColumnSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer3.default;
	exports.ColumnSizer = _ColumnSizer3.default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_Component) {
	  _inherits(ColumnSizer, _Component);
	
	  function ColumnSizer(props, context) {
	    _classCallCheck(this, ColumnSizer);
	
	    var _this = _possibleConstructorReturn(this, (ColumnSizer.__proto__ || Object.getPrototypeOf(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props;
	      var columnMaxWidth = _props.columnMaxWidth;
	      var columnMinWidth = _props.columnMinWidth;
	      var columnCount = _props.columnCount;
	      var width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var columnMaxWidth = _props2.columnMaxWidth;
	      var columnMinWidth = _props2.columnMinWidth;
	      var columnCount = _props2.columnCount;
	      var width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child && typeof child.recomputeGridSize !== 'function') {
	        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	
	  return ColumnSizer;
	}(_react.Component);
	
	exports.default = ColumnSizer;
	 false ? ColumnSizer.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _react.PropTypes.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _react.PropTypes.number,
	
	  /** Number of columns in Grid or Table child */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /** Width of Grid or Table child */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SortIndicator = exports.SortDirection = exports.Column = exports.Table = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.default = undefined;
	
	var _Table2 = __webpack_require__(675);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _defaultCellDataGetter2 = __webpack_require__(681);
	
	var _defaultCellDataGetter3 = _interopRequireDefault(_defaultCellDataGetter2);
	
	var _defaultCellRenderer2 = __webpack_require__(680);
	
	var _defaultCellRenderer3 = _interopRequireDefault(_defaultCellRenderer2);
	
	var _defaultHeaderRenderer2 = __webpack_require__(677);
	
	var _defaultHeaderRenderer3 = _interopRequireDefault(_defaultHeaderRenderer2);
	
	var _defaultRowRenderer2 = __webpack_require__(690);
	
	var _defaultRowRenderer3 = _interopRequireDefault(_defaultRowRenderer2);
	
	var _Column2 = __webpack_require__(676);
	
	var _Column3 = _interopRequireDefault(_Column2);
	
	var _SortDirection2 = __webpack_require__(679);
	
	var _SortDirection3 = _interopRequireDefault(_SortDirection2);
	
	var _SortIndicator2 = __webpack_require__(678);
	
	var _SortIndicator3 = _interopRequireDefault(_SortIndicator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table3.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter3.default;
	exports.defaultCellRenderer = _defaultCellRenderer3.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer3.default;
	exports.defaultRowRenderer = _defaultRowRenderer3.default;
	exports.Table = _Table3.default;
	exports.Column = _Column3.default;
	exports.SortDirection = _SortDirection3.default;
	exports.SortIndicator = _SortIndicator3.default;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Column = __webpack_require__(676);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(682);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _defaultRowRenderer = __webpack_require__(690);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _SortDirection = __webpack_require__(679);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var disableHeader = _props.disableHeader;
	      var gridClassName = _props.gridClassName;
	      var gridStyle = _props.gridStyle;
	      var headerHeight = _props.headerHeight;
	      var height = _props.height;
	      var id = _props.id;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var rowClassName = _props.rowClassName;
	      var rowStyle = _props.rowStyle;
	      var scrollToIndex = _props.scrollToIndex;
	      var style = _props.style;
	      var width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = disableHeader ? height : height - headerHeight;
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      _react2.default.Children.toArray(children).forEach(function (column, index) {
	        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
	
	        _this2._cachedColumnStyles[index] = _extends({}, flexStyles, {
	          overflow: 'hidden'
	        });
	      });
	
	      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactVirtualized__Table', className),
	          id: id,
	          style: style
	        },
	        !disableHeader && _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('ReactVirtualized__Table__headerRow', rowClass),
	            style: _extends({}, rowStyleObject, {
	              height: headerHeight,
	              overflow: 'hidden',
	              paddingRight: scrollbarWidth,
	              width: width
	            })
	          },
	          this._getRenderedHeaderRow()
	        ),
	        _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__Grid', gridClassName),
	          cellRenderer: this._createRow,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          id: undefined,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: function ref(_ref) {
	            _this2.Grid = _ref;
	          },
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: _extends({}, gridStyle, {
	            overflowX: 'hidden'
	          })
	        }))
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref2) {
	      var column = _ref2.column;
	      var columnIndex = _ref2.columnIndex;
	      var isScrolling = _ref2.isScrolling;
	      var rowData = _ref2.rowData;
	      var rowIndex = _ref2.rowIndex;
	      var _column$props = column.props;
	      var cellDataGetter = _column$props.cellDataGetter;
	      var cellRenderer = _column$props.cellRenderer;
	      var className = _column$props.className;
	      var columnData = _column$props.columnData;
	      var dataKey = _column$props.dataKey;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, rowData: rowData, rowIndex: rowIndex });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'Row' + rowIndex + '-Col' + columnIndex,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__rowColumn', className),
	          style: style,
	          title: title
	        },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref3) {
	      var column = _ref3.column;
	      var index = _ref3.index;
	      var _props2 = this.props;
	      var headerClassName = _props2.headerClassName;
	      var headerStyle = _props2.headerStyle;
	      var onHeaderClick = _props2.onHeaderClick;
	      var sort = _props2.sort;
	      var sortBy = _props2.sortBy;
	      var sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props;
	      var dataKey = _column$props2.dataKey;
	      var disableSort = _column$props2.disableSort;
	      var headerRenderer = _column$props2.headerRenderer;
	      var label = _column$props2.label;
	      var columnData = _column$props2.columnData;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
	        'ReactVirtualized__Table__sortableHeaderColumn': sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, headerStyle);
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var a11yProps = {};
	
	      if (sortEnabled || onHeaderClick) {
	        (function () {
	          // If this is a sortable header, clicking it should update the table data's sorting.
	          var newSortDirection = sortBy !== dataKey || sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	          var onClick = function onClick() {
	            sortEnabled && sort({
	              sortBy: dataKey,
	              sortDirection: newSortDirection
	            });
	            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey });
	          };
	
	          var onKeyDown = function onKeyDown(event) {
	            if (event.key === 'Enter' || event.key === ' ') {
	              onClick();
	            }
	          };
	
	          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
	          a11yProps.role = 'rowheader';
	          a11yProps.tabIndex = 0;
	          a11yProps.onClick = onClick;
	          a11yProps.onKeyDown = onKeyDown;
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, a11yProps, {
	          key: 'Header-Col' + index,
	          className: classNames,
	          style: style
	        }),
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref4) {
	      var _this3 = this;
	
	      var index = _ref4.rowIndex;
	      var isScrolling = _ref4.isScrolling;
	      var key = _ref4.key;
	      var style = _ref4.style;
	      var _props3 = this.props;
	      var children = _props3.children;
	      var onRowClick = _props3.onRowClick;
	      var onRowDoubleClick = _props3.onRowDoubleClick;
	      var onRowMouseOver = _props3.onRowMouseOver;
	      var onRowMouseOut = _props3.onRowMouseOut;
	      var rowClassName = _props3.rowClassName;
	      var rowGetter = _props3.rowGetter;
	      var rowRenderer = _props3.rowRenderer;
	      var rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = _react2.default.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('ReactVirtualized__Table__row', rowClass);
	      var flattenedStyle = _extends({}, style, rowStyleObject, {
	        height: this._getRowHeight(index),
	        overflow: 'hidden',
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        key: key,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: flattenedStyle
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = _extends({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getRenderedHeaderRow',
	    value: function _getRenderedHeaderRow() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var children = _props4.children;
	      var disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : _react2.default.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return rowHeight instanceof Function ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref5) {
	      var clientHeight = _ref5.clientHeight;
	      var scrollHeight = _ref5.scrollHeight;
	      var scrollTop = _ref5.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref6) {
	      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref6.rowOverscanStopIndex;
	      var rowStartIndex = _ref6.rowStartIndex;
	      var rowStopIndex = _ref6.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      var Grid = (0, _reactDom.findDOMNode)(this.Grid);
	      var clientWidth = Grid.clientWidth || 0;
	      var offsetWidth = Grid.offsetWidth || 0;
	      var scrollbarWidth = offsetWidth - clientWidth;
	
	      this.setState({ scrollbarWidth: scrollbarWidth });
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = Table;
	 false ? Table.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** One or more Columns describing the data displayed in this row */
	  children: function children(props, propName, componentName) {
	    var children = _react2.default.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].type !== _Column2.default) {
	        return new Error('Table only accepts children of type Column');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _react.PropTypes.bool,
	
	  /**
	   * Used to estimate the total height of a Table before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _react.PropTypes.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _react.PropTypes.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _react.PropTypes.string,
	
	  /** Fixed height of header row */
	  headerHeight: _react.PropTypes.number.isRequired,
	
	  /** Fixed/available height for out DOM element */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional id */
	  id: _react.PropTypes.string,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func,
	
	  /**
	  * Optional callback when a column's header is clicked.
	  * ({ columnData: any, dataKey: string }): void
	  */
	  onHeaderClick: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _react.PropTypes.object,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _react.PropTypes.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]).isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * ({ sortBy: string, sortDirection: SortDirection }): void
	   */
	  sort: _react.PropTypes.func,
	
	  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _react.PropTypes.string,
	
	  /** Table data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _defaultHeaderRenderer = __webpack_require__(677);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(680);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(681);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	exports.default = Column;
	 false ? Column.propTypes = {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _react.PropTypes.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _react.PropTypes.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _react.PropTypes.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _react.PropTypes.object,
	
	  /** Uniquely identifies the row-data attribute correspnding to this cell */
	  dataKey: _react.PropTypes.any.isRequired,
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _react.PropTypes.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _react.PropTypes.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _react.PropTypes.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _react.PropTypes.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _react.PropTypes.func.isRequired,
	
	  /** Header label for this column */
	  label: _react.PropTypes.string,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _react.PropTypes.number,
	
	  /** Minimum width of column. */
	  minWidth: _react.PropTypes.number,
	
	  /** Optional inline style to apply to cell */
	  style: _react.PropTypes.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortIndicator = __webpack_require__(678);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default table header renderer.
	 */
	function defaultHeaderRenderer(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var disableSort = _ref.disableSort;
	  var label = _ref.label;
	  var sortBy = _ref.sortBy;
	  var sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [_react2.default.createElement(
	    'span',
	    {
	      className: 'ReactVirtualized__Table__headerTruncatedText',
	      key: 'label',
	      title: label
	    },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(_react2.default.createElement(_SortIndicator2.default, {
	      key: 'SortIndicator',
	      sortDirection: sortDirection
	    }));
	  }
	
	  return children;
	}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SortDirection = __webpack_require__(679);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a Table is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
	    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: classNames,
	      width: 18,
	      height: 18,
	      viewBox: '0 0 24 24'
	    },
	    sortDirection === _SortDirection2.default.ASC ? _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' }) : _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	
	 false ? SortIndicator.propTypes = {
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	} : void 0;

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData;
	  var cellDataKey = _ref.cellDataKey;
	  var columnData = _ref.columnData;
	  var rowData = _ref.rowData;
	  var rowIndex = _ref.rowIndex;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	function defaultCellDataGetter(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var rowData = _ref.rowData;
	
	  if (rowData.get instanceof Function) {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultCellRangeRenderer = exports.Grid = exports.default = undefined;
	
	var _Grid2 = __webpack_require__(683);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultCellRangeRenderer2 = __webpack_require__(689);
	
	var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(684);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(685);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(667);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _getOverscanIndices = __webpack_require__(687);
	
	var _getOverscanIndices2 = _interopRequireDefault(_getOverscanIndices);
	
	var _scrollbarSize = __webpack_require__(412);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _updateScrollIndexHelper = __webpack_require__(688);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(689);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props, context) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes onSectionRendered callback only when start/stop row or column indices change
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around
	    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
	    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
	    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._columnWidthGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._rowHeightGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	
	    // See defaultCellRangeRenderer() for more information on the usage of these caches
	    _this._cellCache = {};
	    _this._styleCache = {};
	    return _this;
	  }
	
	  /**
	   * Pre-measure all columns and rows in a Grid.
	   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	   */
	
	
	  _createClass(Grid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props = this.props;
	      var columnCount = _props.columnCount;
	      var rowCount = _props.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      this.forceUpdate();
	    }
	
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: 'scrollToCell',
	    value: function scrollToCell(_ref2) {
	      var columnIndex = _ref2.columnIndex;
	      var rowIndex = _ref2.rowIndex;
	
	      var props = this.props;
	      this._updateScrollLeftForScrollToColumn(_extends({}, props, {
	        scrollToColumn: columnIndex
	      }));
	      this._updateScrollTopForScrollToRow(_extends({}, props, {
	        scrollToRow: rowIndex
	      }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props;
	      var scrollLeft = _props2.scrollLeft;
	      var scrollToColumn = _props2.scrollToColumn;
	      var scrollTop = _props2.scrollTop;
	      var scrollToRow = _props2.scrollToRow;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      if (scrollToColumn >= 0 || scrollToRow >= 0) {
	        this._updateScrollLeftForScrollToColumn();
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var columnCount = _props3.columnCount;
	      var height = _props3.height;
	      var rowCount = _props3.rowCount;
	      var scrollToAlignment = _props3.scrollToAlignment;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollToRow = _props3.scrollToRow;
	      var width = _props3.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	
	        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	        previousCellsCount: prevProps.columnCount,
	        previousCellSize: prevProps.columnWidth,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToColumn,
	        previousSize: prevProps.width,
	        scrollOffset: scrollLeft,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToColumn,
	        size: width,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
	          return _this2._updateScrollLeftForScrollToColumn(_extends({}, _this2.props, { scrollToColumn: scrollToColumn }));
	        }
	      });
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	        previousCellsCount: prevProps.rowCount,
	        previousCellSize: prevProps.rowHeight,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToRow,
	        previousSize: prevProps.height,
	        scrollOffset: scrollTop,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToRow,
	        size: height,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
	          return _this2._updateScrollTopForScrollToRow(_extends({}, _this2.props, { scrollToRow: scrollToRow }));
	        }
	      });
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this3 = this;
	
	      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	        if (nextProps.scrollTop != null) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this._setScrollPosition(newState);
	      }
	
	      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
	        this._styleCache = {};
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.columnCount,
	        cellSize: this.props.columnWidth,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: nextProps.columnWidth,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.rowCount,
	        cellSize: this.props.rowHeight,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: nextProps.rowHeight,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
	        }
	      });
	
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var autoContainerWidth = _props4.autoContainerWidth;
	      var autoHeight = _props4.autoHeight;
	      var className = _props4.className;
	      var containerStyle = _props4.containerStyle;
	      var height = _props4.height;
	      var id = _props4.id;
	      var noContentRenderer = _props4.noContentRenderer;
	      var style = _props4.style;
	      var tabIndex = _props4.tabIndex;
	      var width = _props4.width;
	      var isScrolling = this.state.isScrolling;
	
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref3) {
	            _this4._scrollingContainer = _ref3;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, gridStyle, style),
	          tabIndex: tabIndex
	        },
	        childrenToDisplay.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            style: _extends({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : ''
	            }, containerStyle)
	          },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer;
	      var cellRangeRenderer = props.cellRangeRenderer;
	      var columnCount = props.columnCount;
	      var height = props.height;
	      var overscanColumnCount = props.overscanColumnCount;
	      var overscanRowCount = props.overscanRowCount;
	      var rowCount = props.rowCount;
	      var width = props.width;
	      var isScrolling = state.isScrolling;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
	      var scrollDirectionVertical = state.scrollDirectionVertical;
	      var scrollLeft = state.scrollLeft;
	      var scrollTop = state.scrollTop;
	
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = (0, _getOverscanIndices2.default)({
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: this._renderedColumnStartIndex,
	          stopIndex: this._renderedColumnStopIndex
	        });
	
	        var overscanRowIndices = (0, _getOverscanIndices2.default)({
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: this._renderedRowStartIndex,
	          stopIndex: this._renderedRowStopIndex
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_debounceScrollEnded',
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_debounceScrollEndedCallback',
	    value: function _debounceScrollEndedCallback() {
	      this._disablePointerEventsTimeoutId = null;
	
	      var styleCache = this._styleCache;
	
	      // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      // Copy over the visible cell styles so avoid unnecessary re-render.
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = rowIndex + '-' + columnIndex;
	          this._styleCache[key] = styleCache[key];
	        }
	      }
	
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: '_invokeOnGridRenderedHelper',
	    value: function _invokeOnGridRenderedHelper() {
	      var onSectionRendered = this.props.onSectionRendered;
	
	
	      this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: this._columnStartIndex,
	          columnOverscanStopIndex: this._columnStopIndex,
	          columnStartIndex: this._renderedColumnStartIndex,
	          columnStopIndex: this._renderedColumnStopIndex,
	          rowOverscanStartIndex: this._rowStartIndex,
	          rowOverscanStopIndex: this._rowStopIndex,
	          rowStartIndex: this._renderedRowStartIndex,
	          rowStopIndex: this._renderedRowStopIndex
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref4) {
	      var _this5 = this;
	
	      var scrollLeft = _ref4.scrollLeft;
	      var scrollTop = _ref4.scrollTop;
	      var totalColumnsWidth = _ref4.totalColumnsWidth;
	      var totalRowsHeight = _ref4.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref5) {
	          var scrollLeft = _ref5.scrollLeft;
	          var scrollTop = _ref5.scrollTop;
	          var _props5 = _this5.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref6) {
	      var scrollLeft = _ref6.scrollLeft;
	      var scrollTop = _ref6.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapPropertyGetter',
	    value: function _wrapPropertyGetter(value) {
	      return value instanceof Function ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(size) {
	      return this._wrapPropertyGetter(size);
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var columnCount = props.columnCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToColumn = props.scrollToColumn;
	      var width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (scrollToColumn >= 0 && columnCount > 0) {
	        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
	
	        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	
	        if (scrollLeft !== calculatedScrollLeft) {
	          this._setScrollPosition({
	            scrollLeft: calculatedScrollLeft
	          });
	        }
	      }
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var height = props.height;
	      var rowCount = props.rowCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToRow = props.scrollToRow;
	      var scrollTop = state.scrollTop;
	
	
	      if (scrollToRow >= 0 && rowCount > 0) {
	        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
	
	        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	
	        if (scrollTop !== calculatedScrollTop) {
	          this._setScrollPosition({
	            scrollTop: calculatedScrollTop
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceScrollEnded();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props6 = this.props;
	      var autoHeight = _props6.autoHeight;
	      var height = _props6.height;
	      var width = _props6.width;
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	    }
	  }]);
	
	  return Grid;
	}(_react.Component);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  overscanColumnCount: 0,
	  overscanRowCount: 10,
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  style: {},
	  tabIndex: 0
	};
	exports.default = Grid;
	 false ? Grid.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _react.PropTypes.bool,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their index ranges.
	   * Should implement the following interface: ({
	   *   cellCache: Map,
	   *   cellRenderer: Function,
	   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
	   *   columnStartIndex: number,
	   *   columnStopIndex: number,
	   *   isScrolling: boolean,
	   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
	   *   rowStartIndex: number,
	   *   rowStopIndex: number,
	   *   scrollLeft: number,
	   *   scrollTop: number
	   * }): Array<PropTypes.node>
	   */
	  cellRangeRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Grid element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed column width (number) or a function that returns the width of a column given its index.
	   * Should implement the following interface: (index: number): number
	   */
	  columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: _react.PropTypes.object,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Grid element.
	   */
	  id: _react.PropTypes.string,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Grid that was just rendered.
	   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _react.PropTypes.number,
	
	  /** Horizontal offset. */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Column index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToColumn: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Row index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToRow: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /**
	   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param cellsSize Width or height of cells for the current axis
	 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
	 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
	 * @param nextCellsCount Newly updated number of rows or columns in the current axis
	 * @param nextCellsSize Newly updated width or height of cells for the current axis
	 * @param nextScrollToIndex Newly updated scroll-to-index
	 * @param scrollToIndex Scroll-to-index
	 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSize = _ref.cellSize;
	  var computeMetadataCallback = _ref.computeMetadataCallback;
	  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
	  var nextCellsCount = _ref.nextCellsCount;
	  var nextCellSize = _ref.nextCellSize;
	  var nextScrollToIndex = _ref.nextScrollToIndex;
	  var scrollToIndex = _ref.scrollToIndex;
	  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_MAX_SCROLL_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CellSizeAndPositionManager = __webpack_require__(686);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize;
	    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;
	
	    var params = _objectWithoutProperties(_ref, ['maxScrollSize']);
	
	    _classCallCheck(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  _createClass(ScalingCellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scalled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize;
	      var offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	      var totalSize = _ref3.totalSize;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex,
	        totalSize: totalSize
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize;
	      var offset = _ref5.offset;
	      var totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize;
	      var offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize;
	      var offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager = function () {
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount;
	    var cellSizeGetter = _ref.cellSizeGetter;
	    var estimatedCellSize = _ref.estimatedCellSize;
	
	    _classCallCheck(this, CellSizeAndPositionManager);
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	
	    // Cache of size and position data for cells, mapped by cell index.
	    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	    this._cellSizeAndPositionData = {};
	
	    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	    this._lastMeasuredIndex = -1;
	  }
	
	  _createClass(CellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount;
	      var estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          if (_size == null || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          }
	
	          this._cellSizeAndPositionData[i] = {
	            offset: _offset,
	            size: _size
	          };
	
	          _offset += _size;
	        }
	
	        this._lastMeasuredIndex = index;
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completedly estimated initially.
	     * As cells as measured the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	
	      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(_ref5) {
	      var high = _ref5.high;
	      var low = _ref5.low;
	      var offset = _ref5.offset;
	
	      var middle = void 0;
	      var currentOffset = void 0;
	
	      while (low <= high) {
	        middle = low + Math.floor((high - low) / 2);
	        currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(_ref6) {
	      var index = _ref6.index;
	      var offset = _ref6.offset;
	
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch({
	        high: Math.min(index, this._cellCount - 1),
	        low: Math.floor(index / 2),
	        offset: offset
	      });
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch({
	          high: lastMeasuredIndex,
	          low: 0,
	          offset: offset
	        });
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch({
	          index: lastMeasuredIndex,
	          offset: offset
	        });
	      }
	    }
	  }]);
	
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverscanIndices;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function getOverscanIndices(_ref) {
	  var cellCount = _ref.cellCount;
	  var overscanCellsCount = _ref.overscanCellsCount;
	  var scrollDirection = _ref.scrollDirection;
	  var startIndex = _ref.startIndex;
	  var stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  switch (scrollDirection) {
	    case SCROLL_DIRECTION_FORWARD:
	      overscanStartIndex = startIndex;
	      overscanStopIndex = stopIndex + overscanCellsCount;
	      break;
	    case SCROLL_DIRECTION_BACKWARD:
	      overscanStartIndex = startIndex - overscanCellsCount;
	      overscanStopIndex = stopIndex;
	      break;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 *
	 * @param cellsSize Width or height of cells for the current axis
	 * @param cellSizeAndPositionManager Manages size and position metadata of cells
	 * @param previousCellsCount Previous number of rows or columns
	 * @param previousCellsSize Previous width or height of cells
	 * @param previousScrollToIndex Previous scroll-to-index
	 * @param previousSize Previous width or height of the virtualized container
	 * @param scrollOffset Current scrollLeft or scrollTop
	 * @param scrollToIndex Scroll-to-index
	 * @param size Width or height of the virtualized container
	 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
	 */
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize;
	  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
	  var previousCellsCount = _ref.previousCellsCount;
	  var previousCellSize = _ref.previousCellSize;
	  var previousScrollToAlignment = _ref.previousScrollToAlignment;
	  var previousScrollToIndex = _ref.previousScrollToIndex;
	  var previousSize = _ref.previousSize;
	  var scrollOffset = _ref.scrollOffset;
	  var scrollToAlignment = _ref.scrollToAlignment;
	  var scrollToIndex = _ref.scrollToIndex;
	  var size = _ref.size;
	  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache;
	  var cellRenderer = _ref.cellRenderer;
	  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
	  var columnStartIndex = _ref.columnStartIndex;
	  var columnStopIndex = _ref.columnStopIndex;
	  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
	  var isScrolling = _ref.isScrolling;
	  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
	  var rowStartIndex = _ref.rowStartIndex;
	  var rowStopIndex = _ref.rowStopIndex;
	  var scrollLeft = _ref.scrollLeft;
	  var scrollTop = _ref.scrollTop;
	  var styleCache = _ref.styleCache;
	  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
	  var visibleColumnIndices = _ref.visibleColumnIndices;
	  var visibleRowIndices = _ref.visibleRowIndices;
	
	  var renderedCells = [];
	  var offsetAdjusted = verticalOffsetAdjustment || horizontalOffsetAdjustment;
	  var canCacheStyle = !isScrolling || !offsetAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = void 0;
	
	      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        style = {
	          height: rowDatum.size,
	          left: columnDatum.offset + horizontalOffsetAdjustment,
	          position: 'absolute',
	          top: rowDatum.offset + verticalOffsetAdjustment,
	          width: columnDatum.size
	        };
	
	        styleCache[key] = style;
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key];
	
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for Table.
	 */
	function defaultRowRenderer(_ref) {
	  var className = _ref.className;
	  var columns = _ref.columns;
	  var index = _ref.index;
	  var isScrolling = _ref.isScrolling;
	  var key = _ref.key;
	  var onRowClick = _ref.onRowClick;
	  var onRowDoubleClick = _ref.onRowDoubleClick;
	  var onRowMouseOver = _ref.onRowMouseOver;
	  var onRowMouseOut = _ref.onRowMouseOut;
	  var rowData = _ref.rowData;
	  var style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.role = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function () {
	        return onRowClick({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function () {
	        return onRowDoubleClick({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function () {
	        return onRowMouseOut({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function () {
	        return onRowMouseOver({ index: index, rowData: rowData });
	      };
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, a11yProps, {
	      className: className,
	      key: key,
	      style: style
	    }),
	    columns
	  );
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = exports.default = undefined;
	
	var _InfiniteLoader2 = __webpack_require__(692);
	
	var _InfiniteLoader3 = _interopRequireDefault(_InfiniteLoader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader3.default;
	exports.InfiniteLoader = _InfiniteLoader3.default;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(2);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _createCallbackMemoizer = __webpack_require__(667);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_Component) {
	  _inherits(InfiniteLoader, _Component);
	
	  function InfiniteLoader(props, context) {
	    _classCallCheck(this, InfiniteLoader);
	
	    var _this = _possibleConstructorReturn(this, (InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfiniteLoader, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var _this3 = this;
	
	      var startIndex = _ref.startIndex;
	      var stopIndex = _ref.stopIndex;
	      var _props = this.props;
	      var isRowLoaded = _props.isRowLoaded;
	      var minimumBatchSize = _props.minimumBatchSize;
	      var rowCount = _props.rowCount;
	      var threshold = _props.threshold;
	
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	
	  return InfiniteLoader;
	}(_react.Component);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	 false ? InfiniteLoader.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _react.PropTypes.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _react.PropTypes.number.isRequired
	} : void 0;
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex;
	  var lastRenderedStopIndex = _ref2.lastRenderedStopIndex;
	  var startIndex = _ref2.startIndex;
	  var stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded;
	  var minimumBatchSize = _ref3.minimumBatchSize;
	  var rowCount = _ref3.rowCount;
	  var startIndex = _ref3.startIndex;
	  var stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 *
	 * Additionally, while a Grid is scrolling the cells can be cached,
	 * So it's important to invalidate that cache by recalculating sizes
	 * before forcing a rerender.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
	
	  if (recomputeSize) {
	    recomputeSize.call(component);
	  } else {
	    component.forceUpdate();
	  }
	}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.default = undefined;
	
	var _List2 = __webpack_require__(694);
	
	var _List3 = _interopRequireDefault(_List2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Grid = __webpack_require__(682);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._cellRenderer = _this._cellRenderer.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var className = _props.className;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var scrollToIndex = _props.scrollToIndex;
	      var width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: function ref(_ref) {
	          _this2.Grid = _ref;
	        },
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	      var style = _ref2.style;
	
	      var rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);
	
	      var rowRenderer = this.props.rowRenderer;
	
	      // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(style, 'width');
	
	      var writable = _Object$getOwnPropert.writable;
	
	      if (writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer(_extends({
	        index: rowIndex,
	        style: style
	      }, rest));
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref3) {
	      var clientHeight = _ref3.clientHeight;
	      var scrollHeight = _ref3.scrollHeight;
	      var scrollTop = _ref3.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref4.rowOverscanStopIndex;
	      var rowStartIndex = _ref4.rowStartIndex;
	      var rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.defaultProps = {
	  estimatedRowSize: 30,
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = List;
	 false ? List.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: _react.PropTypes.func.isRequired,
	
	  /** Number of rows in list. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiGrid = exports.default = undefined;
	
	var _MultiGrid2 = __webpack_require__(696);
	
	var _MultiGrid3 = _interopRequireDefault(_MultiGrid2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MultiGrid3.default;
	exports.MultiGrid = _MultiGrid3.default;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(682);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders 1, 2, or 4 Grids depending on configuration.
	 * A main (body) Grid will always be rendered.
	 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
	 * If no sticky columns, only 1 sticky header Grid will be rendered.
	 * If sticky columns, 2 sticky header Grids will be rendered.
	 */
	var MultiGrid = function (_Component) {
	  _inherits(MultiGrid, _Component);
	
	  function MultiGrid(props, context) {
	    _classCallCheck(this, MultiGrid);
	
	    var _this = _possibleConstructorReturn(this, (MultiGrid.__proto__ || Object.getPrototypeOf(MultiGrid)).call(this, props, context));
	
	    _this.state = {
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
	    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
	    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
	    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
	    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
	    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
	    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
	    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
	    return _this;
	  }
	
	  /** See Grid#measureAllCells */
	
	
	  _createClass(MultiGrid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
	      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
	      this._topLeftGrid && this._topLeftGrid.measureAllCells();
	      this._topRightGrid && this._topRightGrid.measureAllCells();
	    }
	
	    /** See issue #546 */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      console.warn('MultiGrid measureAllRows() is deprecated; use measureAllCells() instead.');
	
	      this.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	      var _props = this.props;
	      var fixedColumnCount = _props.fixedColumnCount;
	      var fixedRowCount = _props.fixedRowCount;
	
	
	      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
	      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
	
	      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	      this._topRightGrid && this._topRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: rowIndex
	      });
	
	      this._leftGridWidth = null;
	      this._topGridHeight = null;
	      this._maybeCalculateCachedStyles(null, this.props);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._maybeCalculateCachedStyles(null, this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var columnWidth = _props2.columnWidth;
	      var fixedColumnCount = _props2.fixedColumnCount;
	      var fixedRowCount = _props2.fixedRowCount;
	      var rowHeight = _props2.rowHeight;
	
	
	      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
	        this._leftGridWidth = null;
	      }
	
	      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
	        this._topGridHeight = null;
	      }
	
	      this._maybeCalculateCachedStyles(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var onScroll = _props3.onScroll;
	      var onSectionRendered = _props3.onSectionRendered;
	      var scrollLeftProp = _props3.scrollLeft;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollTopProp = _props3.scrollTop;
	      var scrollToRow = _props3.scrollToRow;
	
	      var rest = _objectWithoutProperties(_props3, ['onScroll', 'onSectionRendered', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);
	
	      // scrollTop and scrollToRow props are explicitly filtered out and ignored
	
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollTop = _state.scrollTop;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: this._containerOuterStyle },
	        _react2.default.createElement(
	          'div',
	          { style: this._containerTopStyle },
	          this._renderTopLeftGrid(rest),
	          this._renderTopRightGrid(_extends({}, rest, {
	            scrollLeft: scrollLeft
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: this._containerBottomStyle },
	          this._renderBottomLeftGrid(_extends({}, rest, {
	            scrollTop: scrollTop
	          })),
	          this._renderBottomRightGrid(_extends({}, rest, {
	            onScroll: onScroll,
	            onSectionRendered: onSectionRendered,
	            scrollLeft: scrollLeft,
	            scrollToColumn: scrollToColumn,
	            scrollToRow: scrollToRow,
	            scrollTop: scrollTop
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_bottomLeftGridRef',
	    value: function _bottomLeftGridRef(ref) {
	      this._bottomLeftGrid = ref;
	    }
	  }, {
	    key: '_bottomRightGridRef',
	    value: function _bottomRightGridRef(ref) {
	      this._bottomRightGrid = ref;
	    }
	  }, {
	    key: '_cellRendererBottomLeftGrid',
	    value: function _cellRendererBottomLeftGrid(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	
	      var rest = _objectWithoutProperties(_ref2, ['rowIndex']);
	
	      var _props4 = this.props;
	      var cellRenderer = _props4.cellRenderer;
	      var fixedRowCount = _props4.fixedRowCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererBottomRightGrid',
	    value: function _cellRendererBottomRightGrid(_ref3) {
	      var columnIndex = _ref3.columnIndex;
	      var rowIndex = _ref3.rowIndex;
	
	      var rest = _objectWithoutProperties(_ref3, ['columnIndex', 'rowIndex']);
	
	      var _props5 = this.props;
	      var cellRenderer = _props5.cellRenderer;
	      var fixedColumnCount = _props5.fixedColumnCount;
	      var fixedRowCount = _props5.fixedRowCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount,
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererTopRightGrid',
	    value: function _cellRendererTopRightGrid(_ref4) {
	      var columnIndex = _ref4.columnIndex;
	
	      var rest = _objectWithoutProperties(_ref4, ['columnIndex']);
	
	      var _props6 = this.props;
	      var cellRenderer = _props6.cellRenderer;
	      var fixedColumnCount = _props6.fixedColumnCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount
	      }));
	    }
	  }, {
	    key: '_columnWidthRightGrid',
	    value: function _columnWidthRightGrid(_ref5) {
	      var index = _ref5.index;
	      var _props7 = this.props;
	      var fixedColumnCount = _props7.fixedColumnCount;
	      var columnWidth = _props7.columnWidth;
	
	
	      return columnWidth instanceof Function ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
	    }
	  }, {
	    key: '_getBottomGridHeight',
	    value: function _getBottomGridHeight(props) {
	      var height = props.height;
	
	
	      var topGridHeight = this._getTopGridHeight(props);
	
	      return height - topGridHeight;
	    }
	  }, {
	    key: '_getLeftGridWidth',
	    value: function _getLeftGridWidth(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var columnWidth = props.columnWidth;
	
	
	      if (this._leftGridWidth == null) {
	        if (columnWidth instanceof Function) {
	          var leftGridWidth = 0;
	
	          for (var index = 0; index < fixedColumnCount; index++) {
	            leftGridWidth += columnWidth({ index: index });
	          }
	
	          this._leftGridWidth = leftGridWidth;
	        } else {
	          this._leftGridWidth = columnWidth * fixedColumnCount;
	        }
	      }
	
	      return this._leftGridWidth;
	    }
	  }, {
	    key: '_getRightGridWidth',
	    value: function _getRightGridWidth(props) {
	      var width = props.width;
	
	
	      var leftGridWidth = this._getLeftGridWidth(props);
	
	      return width - leftGridWidth;
	    }
	  }, {
	    key: '_getTopGridHeight',
	    value: function _getTopGridHeight(props) {
	      var fixedRowCount = props.fixedRowCount;
	      var rowHeight = props.rowHeight;
	
	
	      if (this._topGridHeight == null) {
	        if (rowHeight instanceof Function) {
	          var topGridHeight = 0;
	
	          for (var index = 0; index < fixedRowCount; index++) {
	            topGridHeight += rowHeight({ index: index });
	          }
	
	          this._topGridHeight = topGridHeight;
	        } else {
	          this._topGridHeight = rowHeight * fixedRowCount;
	        }
	      }
	
	      return this._topGridHeight;
	    }
	
	    /**
	     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
	     * This method recalculates styles only when specific props change.
	     */
	
	  }, {
	    key: '_maybeCalculateCachedStyles',
	    value: function _maybeCalculateCachedStyles(prevProps, props) {
	      var columnWidth = props.columnWidth;
	      var height = props.height;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowHeight = props.rowHeight;
	      var style = props.style;
	      var styleBottomLeftGrid = props.styleBottomLeftGrid;
	      var styleBottomRightGrid = props.styleBottomRightGrid;
	      var styleTopLeftGrid = props.styleTopLeftGrid;
	      var styleTopRightGrid = props.styleTopRightGrid;
	      var width = props.width;
	
	
	      var firstRender = !prevProps;
	      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
	      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
	      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;
	
	      if (firstRender || sizeChange || style !== prevProps.style) {
	        this._containerOuterStyle = _extends({
	          height: height,
	          width: width
	        }, style);
	      }
	
	      if (firstRender || sizeChange || topSizeChange) {
	        this._containerTopStyle = {
	          height: this._getTopGridHeight(props),
	          position: 'relative',
	          width: width
	        };
	
	        this._containerBottomStyle = {
	          height: height - this._getTopGridHeight(props),
	          overflow: 'hidden',
	          position: 'relative',
	          width: width
	        };
	      }
	
	      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
	        this._bottomLeftGridStyle = _extends({
	          left: 0,
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute'
	        }, styleBottomLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
	        this._bottomRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          outline: 0,
	          position: 'absolute'
	        }, styleBottomRightGrid);
	      }
	
	      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
	        this._topLeftGridStyle = _extends({
	          left: 0,
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
	        this._topRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopRightGrid);
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(scrollInfo) {
	      var scrollLeft = scrollInfo.scrollLeft;
	      var scrollTop = scrollInfo.scrollTop;
	
	      this.setState({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	      var onScroll = this.props.onScroll;
	      if (onScroll) {
	        onScroll(scrollInfo);
	      }
	    }
	  }, {
	    key: '_renderBottomLeftGrid',
	    value: function _renderBottomLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowCount = props.rowCount;
	      var scrollTop = props.scrollTop;
	
	
	      if (!fixedColumnCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomLeftGrid,
	        columnCount: fixedColumnCount,
	        height: this._getBottomGridHeight(props),
	        ref: this._bottomLeftGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollTop: scrollTop,
	        style: this._bottomLeftGridStyle,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderBottomRightGrid',
	    value: function _renderBottomRightGrid(props) {
	      var columnCount = props.columnCount;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowCount = props.rowCount;
	      var scrollToColumn = props.scrollToColumn;
	      var scrollToRow = props.scrollToRow;
	
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: this._onScroll,
	        ref: this._bottomRightGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollToColumn: scrollToColumn - fixedColumnCount,
	        scrollToRow: scrollToRow - fixedRowCount,
	        style: this._bottomRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopLeftGrid',
	    value: function _renderTopLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	
	
	      if (!fixedColumnCount || !fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        columnCount: fixedColumnCount,
	        height: this._getTopGridHeight(props),
	        ref: this._topLeftGridRef,
	        rowCount: fixedRowCount,
	        style: this._topLeftGridStyle,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopRightGrid',
	    value: function _renderTopRightGrid(props) {
	      var columnCount = props.columnCount;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var scrollLeft = props.scrollLeft;
	
	
	      if (!fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererTopRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getTopGridHeight(props),
	        ref: this._topRightGridRef,
	        rowCount: fixedRowCount,
	        scrollLeft: scrollLeft,
	        style: this._topRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_rowHeightBottomGrid',
	    value: function _rowHeightBottomGrid(_ref6) {
	      var index = _ref6.index;
	      var _props8 = this.props;
	      var fixedRowCount = _props8.fixedRowCount;
	      var rowHeight = _props8.rowHeight;
	
	
	      return rowHeight instanceof Function ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
	    }
	  }, {
	    key: '_topLeftGridRef',
	    value: function _topLeftGridRef(ref) {
	      this._topLeftGrid = ref;
	    }
	  }, {
	    key: '_topRightGridRef',
	    value: function _topRightGridRef(ref) {
	      this._topRightGrid = ref;
	    }
	  }]);
	
	  return MultiGrid;
	}(_react.Component);
	
	MultiGrid.defaultProps = {
	  fixedColumnCount: 0,
	  fixedRowCount: 0,
	  style: {},
	  styleBottomLeftGrid: {},
	  styleBottomRightGrid: {},
	  styleTopLeftGrid: {},
	  styleTopRightGrid: {}
	};
	exports.default = MultiGrid;
	 false ? MultiGrid.propTypes = {
	  fixedColumnCount: _react.PropTypes.number.isRequired,
	  fixedRowCount: _react.PropTypes.number.isRequired,
	  style: _react.PropTypes.object.isRequired,
	  styleBottomLeftGrid: _react.PropTypes.object.isRequired,
	  styleBottomRightGrid: _react.PropTypes.object.isRequired,
	  styleTopLeftGrid: _react.PropTypes.object.isRequired,
	  styleTopRightGrid: _react.PropTypes.object.isRequired
	} : void 0;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = exports.default = undefined;
	
	var _ScrollSync2 = __webpack_require__(698);
	
	var _ScrollSync3 = _interopRequireDefault(_ScrollSync2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync3.default;
	exports.ScrollSync = _ScrollSync3.default;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_Component) {
	  _inherits(ScrollSync, _Component);
	
	  function ScrollSync(props, context) {
	    _classCallCheck(this, ScrollSync);
	
	    var _this = _possibleConstructorReturn(this, (ScrollSync.__proto__ || Object.getPrototypeOf(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var clientHeight = _state.clientHeight;
	      var clientWidth = _state.clientWidth;
	      var scrollHeight = _state.scrollHeight;
	      var scrollLeft = _state.scrollLeft;
	      var scrollTop = _state.scrollTop;
	      var scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight;
	      var clientWidth = _ref.clientWidth;
	      var scrollHeight = _ref.scrollHeight;
	      var scrollLeft = _ref.scrollLeft;
	      var scrollTop = _ref.scrollTop;
	      var scrollWidth = _ref.scrollWidth;
	
	      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
	    }
	  }]);
	
	  return ScrollSync;
	}(_react.Component);
	
	exports.default = ScrollSync;
	 false ? ScrollSync.propTypes = {
	  /**
	   * Function responsible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired
	} : void 0;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = exports.default = undefined;
	
	var _onScroll = __webpack_require__(700);
	
	Object.defineProperty(exports, 'IS_SCROLLING_TIMEOUT', {
	  enumerable: true,
	  get: function get() {
	    return _onScroll.IS_SCROLLING_TIMEOUT;
	  }
	});
	
	var _WindowScroller2 = __webpack_require__(701);
	
	var _WindowScroller3 = _interopRequireDefault(_WindowScroller2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller3.default;
	exports.WindowScroller = _WindowScroller3.default;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	var mountedInstances = [];
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    document.body.style.pointerEvents = originalBodyPointerEvents;
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (instance) {
	    return instance.__resetIsScrolling();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    clearTimeout(disablePointerEventsTimeoutId);
	  }
	
	  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
	}
	
	function onScrollWindow(event) {
	  if (event.currentTarget === window && originalBodyPointerEvents == null) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	  }
	  enablePointerEventsAfterDelay();
	  mountedInstances.forEach(function (instance) {
	    if (instance.scrollElement === event.currentTarget) {
	      instance.__handleWindowScrollEvent(event);
	    }
	  });
	}
	
	function registerScrollListener(component, element) {
	  if (!mountedInstances.some(function (instance) {
	    return instance.scrollElement === element;
	  })) {
	    element.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component, element) {
	  mountedInstances = mountedInstances.filter(function (instance) {
	    return instance !== component;
	  });
	  if (!mountedInstances.length) {
	    element.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      clearTimeout(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsShallowCompare = __webpack_require__(656);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _onScroll = __webpack_require__(700);
	
	var _dimensions = __webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowScroller = function (_Component) {
	  _inherits(WindowScroller, _Component);
	
	  function WindowScroller(props) {
	    _classCallCheck(this, WindowScroller);
	
	    // Handle server-side rendering case
	    var _this = _possibleConstructorReturn(this, (WindowScroller.__proto__ || Object.getPrototypeOf(WindowScroller)).call(this, props));
	
	    var height = typeof window !== 'undefined' ? (0, _dimensions.getHeight)(props.scrollElement || window) : 0;
	
	    _this.state = {
	      height: height,
	      isScrolling: false,
	      scrollTop: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this.__handleWindowScrollEvent = _this.__handleWindowScrollEvent.bind(_this);
	    _this.__resetIsScrolling = _this.__resetIsScrolling.bind(_this);
	    return _this;
	  }
	
	  // Can’t use defaultProps for scrollElement without breaking server-side rendering
	
	
	  _createClass(WindowScroller, [{
	    key: 'updatePosition',
	    value: function updatePosition(scrollElement) {
	      var onResize = this.props.onResize;
	      var height = this.state.height;
	
	
	      scrollElement = scrollElement || this.props.scrollElement || window;
	      this._positionFromTop = (0, _dimensions.getPositionFromTop)(_reactDom2.default.findDOMNode(this), scrollElement);
	
	      var newHeight = (0, _dimensions.getHeight)(scrollElement);
	      if (height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	        onResize({
	          height: newHeight
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollElement = this.props.scrollElement || window;
	
	      this.updatePosition(scrollElement);
	
	      (0, _onScroll.registerScrollListener)(this, scrollElement);
	
	      window.addEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollElement = this.props.scrollElement || window;
	      var nextScrollElement = nextProps.scrollElement || window;
	
	      if (scrollElement !== nextScrollElement) {
	        this.updatePosition(nextScrollElement);
	
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        (0, _onScroll.registerScrollListener)(this, nextScrollElement);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _onScroll.unregisterScrollListener)(this, this.props.scrollElement || window);
	
	      window.removeEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var isScrolling = _state.isScrolling;
	      var scrollTop = _state.scrollTop;
	      var height = _state.height;
	
	
	      return children({
	        height: height,
	        isScrolling: isScrolling,
	        scrollTop: scrollTop
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize(event) {
	      this.updatePosition();
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__handleWindowScrollEvent',
	    value: function __handleWindowScrollEvent(event) {
	      var onScroll = this.props.onScroll;
	
	
	      var scrollElement = this.props.scrollElement || window;
	      var scrollTop = Math.max(0, (0, _dimensions.getScrollTop)(scrollElement) - this._positionFromTop);
	
	      this.setState({
	        isScrolling: true,
	        scrollTop: scrollTop
	      });
	
	      onScroll({
	        scrollTop: scrollTop
	      });
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__resetIsScrolling',
	    value: function __resetIsScrolling() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: 'scrollElement',
	    get: function get() {
	      return this.props.scrollElement || window;
	    }
	  }]);
	
	  return WindowScroller;
	}(_react.Component);
	
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {}
	};
	exports.default = WindowScroller;
	 false ? WindowScroller.propTypes = {
	  /**
	   * Function responsible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, isScrolling, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-resize: ({ height }) */
	  onResize: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-scroll: ({ scrollTop }) */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /** Element to attach scroll event listeners. Defaults to window. */
	  scrollElement: _react.PropTypes.any
	} : void 0;

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHeight = getHeight;
	exports.getPositionFromTop = getPositionFromTop;
	exports.getScrollTop = getScrollTop;
	/**
	 * Gets the height of the element, accounting for API differences between
	 * `window` and other DOM elements.
	 */
	function getHeight(element) {
	  return element === window ? window.innerHeight : element.getBoundingClientRect().height;
	}
	
	/**
	 * Gets the vertical position of an element within its scroll container.
	 * Elements that have been “scrolled past” return negative values.
	 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
	 * In this case the body’s top position will be a negative number and this element’s top will be increased (by that amount).
	 */
	function getPositionFromTop(element, container) {
	  var offset = container === window ? 0 : getScrollTop(container);
	  var containerElement = container === window ? document.documentElement : container;
	  return element.getBoundingClientRect().top + offset - containerElement.getBoundingClientRect().top;
	}
	
	/**
	 * Gets the vertical scroll amount of the element, accounting for IE compatibility
	 * and API differences between `window` and other DOM elements.
	 */
	function getScrollTop(element) {
	  if (element === window) {
	    return 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
	  } else {
	    return element.scrollTop;
	  }
	}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDateRange = __webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	_moment2.default.locale('es');
	
	var SelectRangeVirtualTable = function (_React$Component) {
	    _inherits(SelectRangeVirtualTable, _React$Component);
	
	    function SelectRangeVirtualTable(props) {
	        _classCallCheck(this, SelectRangeVirtualTable);
	
	        var _this = _possibleConstructorReturn(this, (SelectRangeVirtualTable.__proto__ || Object.getPrototypeOf(SelectRangeVirtualTable)).call(this, props));
	
	        _this.state = {
	            visible: false,
	            startDate: _this.props.startDateSelected,
	            endDate: _this.props.endDateSelected
	        };
	
	        _this.onChangeDate = function (fechas) {
	            _this.setState({
	                startDate: fechas.startDate,
	                endDate: fechas.endDate
	            });
	        };
	        _this.toggleSelector = function () {
	            if (_this.state.visible) _this.onCancel();else _this._showSelector();
	        };
	        _this._showSelector = function () {
	            _this.setState({ visible: true });
	        };
	        _this._hideSelector = function () {
	            _this.setState({ visible: false });
	        };
	
	        _this.onAccept = function () {
	            _this._hideSelector();
	            _this.props.onRangeSelected(_this.state.startDate, _this.state.endDate);
	        };
	        _this.onCancel = function () {
	            _this._hideSelector();
	            // dejar el valor original
	            _this.setState({
	                startDate: _this.props.startDateSelected,
	                endDate: _this.props.endDateSelected
	            });
	        };
	        return _this;
	    }
	
	    _createClass(SelectRangeVirtualTable, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.state = {
	                startDate: nextProps.startDateSelected,
	                endDate: nextProps.endDateSelected
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var textoFecha = this.state.startDate.format('YYYY') === this.state.endDate.format('YYYY') ? this.state.startDate.format('dddd DD MMMM') + ', a ' + this.state.endDate.format('dddd DD MMMM') : this.state.startDate.format('dddd DD MMMM YYYY') + ', a ' + this.state.endDate.format('dddd DD MMMM YYYY');
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-10' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default',
	                            style: { width: "100%" },
	                            type: 'button',
	                            onClick: this.toggleSelector
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-left' },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-calendar' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                textoFecha
	                            ),
	                            _react2.default.createElement('span', { className: 'caret' })
	                        )
	                    ),
	                    _react2.default.createElement(_reactDateRange.DateRange, {
	                        style: { display: this.state.visible ? 'block' : 'none' },
	                        theme: {
	                            DateRange: {
	                                position: 'absolute',
	                                width: '280px',
	                                zIndex: '99999999999999999'
	                            }
	                        },
	                        startDate: this.state.startDate,
	                        endDate: this.state.endDate,
	                        onChange: this.onChangeDate,
	                        calendars: 1
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-2' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            style: { display: this.state.visible ? 'inline-block' : 'none' },
	                            className: 'btn btn-primary btn-md',
	                            onClick: this.onAccept },
	                        'Aceptar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectRangeVirtualTable;
	}(_react2.default.Component);
	
	SelectRangeVirtualTable.propTypes = {
	    // Objtos
	    startDateSelected: _react2.default.PropTypes.object.isRequired,
	    endDateSelected: _react2.default.PropTypes.object.isRequired,
	    // Funciones
	    onRangeSelected: _react2.default.PropTypes.func.isRequired
	};
	exports.default = SelectRangeVirtualTable;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectRangeVirtualTable.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _DateRangeJs = __webpack_require__(705);
	
	var _DateRangeJs2 = _interopRequireDefault(_DateRangeJs);
	
	var _CalendarJs = __webpack_require__(707);
	
	var _CalendarJs2 = _interopRequireDefault(_CalendarJs);
	
	var _defaultRangesJs = __webpack_require__(711);
	
	var _defaultRangesJs2 = _interopRequireDefault(_defaultRangesJs);
	
	exports['default'] = { DateRange: _DateRangeJs2['default'], Calendar: _CalendarJs2['default'], defaultRanges: _defaultRangesJs2['default'] };
	module.exports = exports['default'];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilsParseInputJs = __webpack_require__(706);
	
	var _utilsParseInputJs2 = _interopRequireDefault(_utilsParseInputJs);
	
	var _CalendarJs = __webpack_require__(707);
	
	var _CalendarJs2 = _interopRequireDefault(_CalendarJs);
	
	var _PredefinedRangesJs = __webpack_require__(710);
	
	var _PredefinedRangesJs2 = _interopRequireDefault(_PredefinedRangesJs);
	
	var _stylesJs = __webpack_require__(709);
	
	var _stylesJs2 = _interopRequireDefault(_stylesJs);
	
	var DateRange = (function (_Component) {
	  _inherits(DateRange, _Component);
	
	  function DateRange(props, context) {
	    _classCallCheck(this, DateRange);
	
	    _get(Object.getPrototypeOf(DateRange.prototype), 'constructor', this).call(this, props, context);
	
	    var format = props.format;
	    var linkedCalendars = props.linkedCalendars;
	    var theme = props.theme;
	
	    var startDate = (0, _utilsParseInputJs2['default'])(props.startDate, format);
	    var endDate = (0, _utilsParseInputJs2['default'])(props.endDate, format);
	
	    this.state = {
	      range: { startDate: startDate, endDate: endDate },
	      link: linkedCalendars && endDate
	    };
	
	    this.step = 0;
	    this.styles = (0, _stylesJs2['default'])(theme);
	  }
	
	  _createClass(DateRange, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var onInit = this.props.onInit;
	
	      onInit && onInit(this.state.range);
	    }
	  }, {
	    key: 'orderRange',
	    value: function orderRange(range) {
	      var startDate = range.startDate;
	      var endDate = range.endDate;
	
	      var swap = startDate.isAfter(endDate);
	
	      if (!swap) return range;
	
	      return {
	        startDate: endDate,
	        endDate: startDate
	      };
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range, source) {
	      var onChange = this.props.onChange;
	
	      range = this.orderRange(range);
	
	      this.setState({ range: range });
	
	      onChange && onChange(range, source);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(date, source) {
	      if (date.startDate && date.endDate) {
	        this.step = 0;
	        return this.setRange(date, source);
	      }
	
	      var _state$range = this.state.range;
	      var startDate = _state$range.startDate;
	      var endDate = _state$range.endDate;
	
	      var range = {
	        startDate: startDate,
	        endDate: endDate
	      };
	
	      switch (this.step) {
	        case 0:
	          range['startDate'] = date;
	          range['endDate'] = date;
	          this.step = 1;
	          break;
	
	        case 1:
	          range['endDate'] = date;
	          this.step = 0;
	          break;
	      }
	
	      this.setRange(range, source);
	    }
	  }, {
	    key: 'handleLinkChange',
	    value: function handleLinkChange(direction) {
	      var link = this.state.link;
	
	      this.setState({
	        link: link.clone().add(direction, 'months')
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // Whenever date props changes, update state with parsed variant
	      if (newProps.startDate || newProps.endDate) {
	        var format = newProps.format || this.props.format;
	        var startDate = newProps.startDate && (0, _utilsParseInputJs2['default'])(newProps.startDate, format);
	        var endDate = newProps.endDate && (0, _utilsParseInputJs2['default'])(newProps.endDate, format);
	        var oldStartDate = this.props.startDate && (0, _utilsParseInputJs2['default'])(this.props.startDate, format);
	        var oldEndDate = this.props.endDate && (0, _utilsParseInputJs2['default'])(this.props.endDate, format);
	
	        if (!startDate.isSame(oldStartDate) || !endDate.isSame(oldEndDate)) {
	          this.setRange({
	            startDate: startDate || oldStartDate,
	            endDate: endDate || oldEndDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var ranges = _props.ranges;
	      var format = _props.format;
	      var linkedCalendars = _props.linkedCalendars;
	      var style = _props.style;
	      var calendars = _props.calendars;
	      var firstDayOfWeek = _props.firstDayOfWeek;
	      var minDate = _props.minDate;
	      var maxDate = _props.maxDate;
	      var classNames = _props.classNames;
	      var onlyClasses = _props.onlyClasses;
	      var _state = this.state;
	      var range = _state.range;
	      var link = _state.link;
	      var styles = this.styles;
	
	      var classes = _extends({}, _stylesJs.defaultClasses, classNames);
	
	      return _react2['default'].createElement(
	        'div',
	        { style: onlyClasses ? undefined : _extends({}, styles['DateRange'], style), className: classes.dateRange },
	        ranges && _react2['default'].createElement(_PredefinedRangesJs2['default'], {
	          format: format,
	          ranges: ranges,
	          range: range,
	          theme: styles,
	          onSelect: this.handleSelect.bind(this),
	          onlyClasses: onlyClasses,
	          classNames: classes }),
	        (function () {
	          var _calendars = [];
	          for (var i = Number(calendars) - 1; i >= 0; i--) {
	            _calendars.push(_react2['default'].createElement(_CalendarJs2['default'], {
	              key: i,
	              offset: -i,
	              link: linkedCalendars && link,
	              linkCB: _this.handleLinkChange.bind(_this),
	              range: range,
	              format: format,
	              firstDayOfWeek: firstDayOfWeek,
	              theme: styles,
	              minDate: minDate,
	              maxDate: maxDate,
	              onlyClasses: onlyClasses,
	              classNames: classes,
	              onChange: _this.handleSelect.bind(_this) }));
	          }
	          return _calendars;
	        })()
	      );
	    }
	  }]);
	
	  return DateRange;
	})(_react.Component);
	
	DateRange.defaultProps = {
	  linkedCalendars: false,
	  theme: {},
	  format: 'DD/MM/YYYY',
	  calendars: 2,
	  onlyClasses: false,
	  classNames: {}
	};
	
	DateRange.propTypes = {
	  format: _react.PropTypes.string,
	  firstDayOfWeek: _react.PropTypes.number,
	  calendars: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  startDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  endDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  minDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  maxDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  dateLimit: _react.PropTypes.func,
	  ranges: _react.PropTypes.object,
	  linkedCalendars: _react.PropTypes.bool,
	  theme: _react.PropTypes.object,
	  onInit: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onlyClasses: _react.PropTypes.bool,
	  classNames: _react.PropTypes.object
	};
	
	exports['default'] = DateRange;
	module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = parseInput;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function parseInput(input, format) {
	  var output = null;
	
	  if (typeof input === 'undefined' || typeof input === 'null' || !input || input === '') {
	    output = (0, _moment2['default'])().startOf('day');
	  } else if (typeof input === 'string') {
	    output = (0, _moment2['default'])(input, format).startOf('day');
	  } else if (typeof input === 'function') {
	    output = parseInput(input((0, _moment2['default'])().startOf('day')), format);
	  } else if (input._isAMomentObject) {
	    output = input.startOf('day').clone();
	  }
	
	  return output;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilsParseInputJs = __webpack_require__(706);
	
	var _utilsParseInputJs2 = _interopRequireDefault(_utilsParseInputJs);
	
	var _DayCellJs = __webpack_require__(708);
	
	var _DayCellJs2 = _interopRequireDefault(_DayCellJs);
	
	var _stylesJs = __webpack_require__(709);
	
	var _stylesJs2 = _interopRequireDefault(_stylesJs);
	
	function checkRange(dayMoment, range) {
	  return dayMoment.isBetween(range['startDate'], range['endDate']) || dayMoment.isBetween(range['endDate'], range['startDate']);
	}
	
	function checkStartEdge(dayMoment, range) {
	  var startDate = range.startDate;
	
	  return dayMoment.isSame(startDate);
	}
	
	function checkEndEdge(dayMoment, range) {
	  var endDate = range.endDate;
	
	  return dayMoment.isSame(endDate);
	}
	
	function isOusideMinMax(dayMoment, minDate, maxDate, format) {
	  return minDate && dayMoment.isBefore((0, _utilsParseInputJs2['default'])(minDate, format)) || maxDate && dayMoment.isAfter((0, _utilsParseInputJs2['default'])(maxDate, format));
	}
	
	var Calendar = (function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar(props, context) {
	    _classCallCheck(this, Calendar);
	
	    _get(Object.getPrototypeOf(Calendar.prototype), 'constructor', this).call(this, props, context);
	
	    var format = props.format;
	    var range = props.range;
	    var theme = props.theme;
	    var offset = props.offset;
	    var firstDayOfWeek = props.firstDayOfWeek;
	
	    var date = (0, _utilsParseInputJs2['default'])(props.date, format);
	    var state = {
	      date: date,
	      shownDate: (range && range['endDate'] || date).clone().add(offset, 'months'),
	      firstDayOfWeek: firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek()
	    };
	
	    this.state = state;
	    this.styles = (0, _stylesJs2['default'])(theme);
	  }
	
	  _createClass(Calendar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var onInit = this.props.onInit;
	
	      onInit && onInit(this.state.date);
	    }
	  }, {
	    key: 'getShownDate',
	    value: function getShownDate() {
	      var _props = this.props;
	      var link = _props.link;
	      var offset = _props.offset;
	
	      var shownDate = link ? link.clone().add(offset, 'months') : this.state.shownDate;
	
	      return shownDate;
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(newDate) {
	      var _props2 = this.props;
	      var link = _props2.link;
	      var onChange = _props2.onChange;
	      var date = this.state.date;
	
	      onChange && onChange(newDate, Calendar);
	
	      if (!link) {
	        this.setState({ date: newDate });
	      }
	    }
	  }, {
	    key: 'changeMonth',
	    value: function changeMonth(direction, event) {
	      event.preventDefault();
	      var _props3 = this.props;
	      var link = _props3.link;
	      var linkCB = _props3.linkCB;
	
	      if (link && linkCB) {
	        return linkCB(direction);
	      }
	
	      var current = this.state.shownDate.month();
	      var newMonth = this.state.shownDate.clone().add(direction, 'months');
	
	      this.setState({
	        shownDate: newMonth
	      });
	    }
	  }, {
	    key: 'renderMonthAndYear',
	    value: function renderMonthAndYear(classes) {
	      var shownDate = this.getShownDate();
	      var month = _moment2['default'].months(shownDate.month());
	      var year = shownDate.year();
	      var styles = this.styles;
	      var onlyClasses = this.props.onlyClasses;
	
	      return _react2['default'].createElement(
	        'div',
	        { style: onlyClasses ? undefined : styles['MonthAndYear'], className: classes.monthAndYearWrapper },
	        _react2['default'].createElement(
	          'button',
	          {
	            style: onlyClasses ? undefined : _extends({}, styles['MonthButton'], { float: 'left' }),
	            className: classes.prevButton,
	            onClick: this.changeMonth.bind(this, -1) },
	          _react2['default'].createElement('i', { style: onlyClasses ? undefined : _extends({}, styles['MonthArrow'], styles['MonthArrowPrev']) })
	        ),
	        _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(
	            'span',
	            { className: classes.month },
	            month
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: classes.monthAndYearDivider },
	            ' - '
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: classes.year },
	            year
	          )
	        ),
	        _react2['default'].createElement(
	          'button',
	          {
	            style: onlyClasses ? undefined : _extends({}, styles['MonthButton'], { float: 'right' }),
	            className: classes.nextButton,
	            onClick: this.changeMonth.bind(this, +1) },
	          _react2['default'].createElement('i', { style: onlyClasses ? undefined : _extends({}, styles['MonthArrow'], styles['MonthArrowNext']) })
	        )
	      );
	    }
	  }, {
	    key: 'renderWeekdays',
	    value: function renderWeekdays(classes) {
	      var dow = this.state.firstDayOfWeek;
	      var weekdays = [];
	      var styles = this.styles;
	      var onlyClasses = this.props.onlyClasses;
	
	      for (var i = dow; i < 7 + dow; i++) {
	        var day = _moment2['default'].weekdaysMin(i);
	
	        weekdays.push(_react2['default'].createElement(
	          'span',
	          { style: onlyClasses ? undefined : styles['Weekday'], className: classes.weekDay, key: day },
	          day
	        ));
	      }
	
	      return weekdays;
	    }
	  }, {
	    key: 'renderDays',
	    value: function renderDays(classes) {
	      var _this = this;
	
	      // TODO: Split this logic into smaller chunks
	      var styles = this.styles;
	      var _props4 = this.props;
	      var range = _props4.range;
	      var minDate = _props4.minDate;
	      var maxDate = _props4.maxDate;
	      var format = _props4.format;
	      var onlyClasses = _props4.onlyClasses;
	
	      var shownDate = this.getShownDate();
	      var _state = this.state;
	      var date = _state.date;
	      var firstDayOfWeek = _state.firstDayOfWeek;
	
	      var dateUnix = date.unix();
	
	      var monthNumber = shownDate.month();
	      var dayCount = shownDate.daysInMonth();
	      var startOfMonth = shownDate.clone().startOf('month').isoWeekday();
	
	      var lastMonth = shownDate.clone().month(monthNumber - 1);
	      var lastMonthNumber = lastMonth.month();
	      var lastMonthDayCount = lastMonth.daysInMonth();
	
	      var nextMonth = shownDate.clone().month(monthNumber + 1);
	      var nextMonthNumber = nextMonth.month();
	
	      var days = [];
	
	      // Previous month's days
	      var diff = Math.abs(firstDayOfWeek - (startOfMonth + 7)) % 7;
	      for (var i = diff - 1; i >= 0; i--) {
	        var dayMoment = lastMonth.clone().date(lastMonthDayCount - i);
	        days.push({ dayMoment: dayMoment, isPassive: true });
	      }
	
	      // Current month's days
	      for (var i = 1; i <= dayCount; i++) {
	        var dayMoment = shownDate.clone().date(i);
	        days.push({ dayMoment: dayMoment });
	      }
	
	      // Next month's days
	      var remainingCells = 42 - days.length; // 42cells = 7days * 6rows
	      for (var i = 1; i <= remainingCells; i++) {
	        var dayMoment = nextMonth.clone().date(i);
	        days.push({ dayMoment: dayMoment, isPassive: true });
	      }
	
	      var today = (0, _moment2['default'])().startOf('day');
	      return days.map(function (data, index) {
	        var dayMoment = data.dayMoment;
	        var isPassive = data.isPassive;
	
	        var isSelected = !range && dayMoment.unix() === dateUnix;
	        var isInRange = range && checkRange(dayMoment, range);
	        var isStartEdge = range && checkStartEdge(dayMoment, range);
	        var isEndEdge = range && checkEndEdge(dayMoment, range);
	        var isEdge = isStartEdge || isEndEdge;
	        var isToday = today.isSame(dayMoment);
	        var isOutsideMinMax = isOusideMinMax(dayMoment, minDate, maxDate, format);
	
	        return _react2['default'].createElement(_DayCellJs2['default'], _extends({
	          onSelect: _this.handleSelect.bind(_this)
	        }, data, {
	          theme: styles,
	          isStartEdge: isStartEdge,
	          isEndEdge: isEndEdge,
	          isSelected: isSelected || isEdge,
	          isInRange: isInRange,
	          isToday: isToday,
	          key: index,
	          isPassive: isPassive || isOutsideMinMax,
	          onlyClasses: onlyClasses,
	          classNames: classes
	        }));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = this.styles;
	      var _props5 = this.props;
	      var onlyClasses = _props5.onlyClasses;
	      var classNames = _props5.classNames;
	
	      var classes = _extends({}, _stylesJs.defaultClasses, classNames);
	
	      return _react2['default'].createElement(
	        'div',
	        { style: onlyClasses ? undefined : _extends({}, styles['Calendar'], this.props.style), className: classes.calendar },
	        _react2['default'].createElement(
	          'div',
	          { className: classes.monthAndYear },
	          this.renderMonthAndYear(classes)
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: classes.weekDays },
	          this.renderWeekdays(classes)
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: classes.days },
	          this.renderDays(classes)
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	})(_react.Component);
	
	Calendar.defaultProps = {
	  format: 'DD/MM/YYYY',
	  theme: {},
	  onlyClasses: false,
	  classNames: {}
	};
	
	Calendar.propTypes = {
	  sets: _react.PropTypes.string,
	  range: _react.PropTypes.shape({
	    startDate: _react.PropTypes.object,
	    endDate: _react.PropTypes.object
	  }),
	  minDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  maxDate: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.string]),
	  date: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string, _react.PropTypes.func]),
	  format: _react.PropTypes.string.isRequired,
	  firstDayOfWeek: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  onChange: _react.PropTypes.func,
	  onInit: _react.PropTypes.func,
	  link: _react.PropTypes.oneOfType([_react.PropTypes.shape({
	    startDate: _react.PropTypes.object,
	    endDate: _react.PropTypes.object
	  }), _react.PropTypes.bool]),
	  linkCB: _react.PropTypes.func,
	  theme: _react.PropTypes.object,
	  onlyClasses: _react.PropTypes.bool,
	  classNames: _react.PropTypes.object
	};
	
	exports['default'] = Calendar;
	module.exports = exports['default'];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(401);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _stylesJs = __webpack_require__(709);
	
	var DayCell = (function (_Component) {
	  _inherits(DayCell, _Component);
	
	  function DayCell(props, context) {
	    _classCallCheck(this, DayCell);
	
	    _get(Object.getPrototypeOf(DayCell.prototype), 'constructor', this).call(this, props, context);
	
	    this.state = {
	      hover: false,
	      active: false
	    };
	
	    this.styles = this.props.theme;
	  }
	
	  _createClass(DayCell, [{
	    key: 'handleMouseEvent',
	    value: function handleMouseEvent(event) {
	      event.preventDefault();
	
	      if (this.props.isPassive) return null;
	
	      var newState = {};
	
	      switch (event.type) {
	        case 'mouseenter':
	          newState['hover'] = true;
	          break;
	
	        case 'mouseup':
	        case 'mouseleave':
	          newState['hover'] = false;
	          newState['active'] = false;
	          break;
	
	        case 'mousedown':
	          newState['active'] = true;
	          break;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(event) {
	      event.preventDefault();
	
	      if (this.props.isPassive) return null;
	
	      this.props.onSelect(this.props.dayMoment);
	    }
	  }, {
	    key: 'getStateStyles',
	    value: function getStateStyles() {
	      var _state = this.state;
	      var hover = _state.hover;
	      var active = _state.active;
	      var _props = this.props;
	      var isSelected = _props.isSelected;
	      var isInRange = _props.isInRange;
	      var isPassive = _props.isPassive;
	      var isStartEdge = _props.isStartEdge;
	      var isEndEdge = _props.isEndEdge;
	      var dayMoment = _props.dayMoment;
	      var isToday = _props.isToday;
	      var styles = this.styles;
	
	      var hoverStyle = hover ? styles['DayHover'] : {};
	      var activeStyle = active ? styles['DayActive'] : {};
	      var passiveStyle = isPassive ? styles['DayPassive'] : {};
	      var startEdgeStyle = isStartEdge ? styles['DayStartEdge'] : {};
	      var endEdgeStyle = isEndEdge ? styles['DayEndEdge'] : {};
	      var selectedStyle = isSelected ? styles['DaySelected'] : {};
	      var inRangeStyle = isInRange ? styles['DayInRange'] : {};
	      var todayStyle = isToday ? styles['DayToday'] : {};
	
	      return _extends({}, todayStyle, inRangeStyle, hoverStyle, passiveStyle, activeStyle, selectedStyle, startEdgeStyle, endEdgeStyle);
	    }
	  }, {
	    key: 'getClassNames',
	    value: function getClassNames(classes) {
	      var _classnames;
	
	      var _props2 = this.props;
	      var isSelected = _props2.isSelected;
	      var isInRange = _props2.isInRange;
	      var isPassive = _props2.isPassive;
	      var isStartEdge = _props2.isStartEdge;
	      var isEndEdge = _props2.isEndEdge;
	      var isToday = _props2.isToday;
	
	      return (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, classes.day, true), _defineProperty(_classnames, classes.dayActive, isSelected), _defineProperty(_classnames, classes.dayPassive, isPassive), _defineProperty(_classnames, classes.dayInRange, isInRange), _defineProperty(_classnames, classes.dayStartEdge, isStartEdge), _defineProperty(_classnames, classes.dayEndEdge, isEndEdge), _defineProperty(_classnames, classes.dayToday, isToday), _classnames));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var dayMoment = _props3.dayMoment;
	      var onlyClasses = _props3.onlyClasses;
	      var classNames = _props3.classNames;
	      var styles = this.styles;
	
	      var stateStyle = this.getStateStyles();
	      var classes = this.getClassNames(classNames);
	
	      return _react2['default'].createElement(
	        'span',
	        {
	          onMouseEnter: this.handleMouseEvent.bind(this),
	          onMouseLeave: this.handleMouseEvent.bind(this),
	          onMouseDown: this.handleMouseEvent.bind(this),
	          onMouseUp: this.handleMouseEvent.bind(this),
	          onClick: this.handleSelect.bind(this),
	          className: classes,
	          style: onlyClasses ? undefined : _extends({}, styles['Day'], stateStyle) },
	        dayMoment.date()
	      );
	    }
	  }]);
	
	  return DayCell;
	})(_react.Component);
	
	DayCell.defaultProps = {
	  theme: { 'Day': {} },
	  onlyClasses: false
	};
	
	DayCell.propTypes = {
	  dayMoment: _react.PropTypes.object.isRequired,
	  onSelect: _react.PropTypes.func,
	  isSelected: _react.PropTypes.bool,
	  isInRange: _react.PropTypes.bool,
	  isPassive: _react.PropTypes.bool,
	  theme: _react.PropTypes.shape({
	    Day: _react.PropTypes.object.isRequired
	  }).isRequired,
	  onlyClasses: _react.PropTypes.bool,
	  classNames: _react.PropTypes.object
	};
	
	exports['default'] = DayCell;
	module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var defaultClasses = {
	  calendar: 'rdr-Calendar',
	  dateRange: 'rdr-DateRange',
	  predefinedRanges: 'rdr-PredefinedRanges',
	  predefinedRangesItem: 'rdr-PredefinedRangesItem',
	  monthAndYear: 'rdr-MonthAndYear',
	  weekDays: 'rdr-WeekDays',
	  weekDay: 'rdr-WeekDay',
	  days: 'rdr-Days',
	  day: 'rdr-Day',
	  dayActive: 'is-selected',
	  dayPassive: 'is-passive',
	  dayInRange: 'is-inRange',
	  monthAndYearWrapper: 'rdr-MonthAndYear-innerWrapper',
	  prevButton: 'rdr-MonthAndYear-button prev',
	  nextButton: 'rdr-MonthAndYear-button next',
	  month: 'rdr-MonthAndYear-month',
	  monthAndYearDivider: 'rdr-MonthAndYear-divider',
	  year: 'rdr-MonthAndYear-year'
	};
	
	exports.defaultClasses = defaultClasses;
	var defaultTheme = {
	  DateRange: {
	    display: 'block',
	    boxSizing: 'border-box',
	    background: '#ffffff',
	    borderRadius: '2px'
	  },
	
	  Calendar: {
	    width: 280,
	    padding: 10,
	    background: '#ffffff',
	    borderRadius: '2px',
	    display: 'inline-block',
	    boxSizing: 'border-box',
	    letterSpacing: 0,
	    color: '#000000'
	  },
	
	  Day: {
	    boxSizing: 'border-box',
	    display: 'inline-block',
	    letterSpacing: 'initial',
	    textAlign: 'center',
	    fontSize: 12,
	    cursor: 'pointer',
	    transition: 'transform .1s ease'
	  },
	
	  DayPassive: {
	    opacity: 0.4,
	    cursor: 'normal'
	  },
	
	  DayHover: {
	    background: '#bdc3c7'
	  },
	
	  DayToday: {},
	
	  DayActive: {
	    background: '#95a5a6',
	    color: '#ffffff',
	    transform: 'scale(0.9)'
	  },
	
	  DaySelected: {
	    background: '#e74c3c',
	    color: '#ffffff'
	  },
	
	  DayStartEdge: {},
	
	  DayEndEdge: {},
	
	  DayInRange: {
	    background: '#34495e',
	    color: '#95a5a6'
	  },
	
	  Weekday: {
	    boxSizing: 'border-box',
	    display: 'inline-block',
	    letterSpacing: 'initial',
	    textAlign: 'center',
	    fontSize: 12,
	    fontWeight: '600',
	    marginBottom: 1
	  },
	
	  MonthAndYear: {
	    textAlign: 'center',
	    boxSizing: 'border-box',
	    fontSize: 12,
	    padding: '10px 0',
	    height: 38,
	    lineHeight: '18px'
	  },
	
	  MonthButton: {
	    display: 'block',
	    boxSizing: 'border-box',
	    height: 18,
	    width: 18,
	    padding: 0,
	    margin: '0 10px',
	    border: 'none',
	    background: '#bdc3c7',
	    boxShadow: 'none',
	    outline: 'none',
	    borderRadius: '50%'
	  },
	
	  MonthArrow: {
	    display: 'block',
	    width: 0,
	    height: 0,
	    padding: 0,
	    margin: 0,
	    border: '4px solid transparent',
	    textAlign: 'center'
	  },
	
	  MonthArrowPrev: {
	    borderRightWidth: '6px',
	    borderRightColor: '#34495e',
	    marginLeft: 1
	  },
	
	  MonthArrowNext: {
	    borderLeftWidth: '6px',
	    borderLeftColor: '#34495e',
	    marginLeft: 7
	  },
	
	  PredefinedRanges: {
	    width: 140,
	    display: 'inline-block',
	    verticalAlign: 'top'
	  },
	
	  PredefinedRangesItem: {
	    display: 'block',
	    fontSize: 12,
	    color: '#2c3e50',
	    padding: '10px 14px',
	    borderRadius: '2px',
	    background: '#ecf0f1',
	    textDecoration: 'none',
	    marginBottom: 6
	  },
	
	  PredefinedRangesItemActive: {
	    color: '#E74C3C'
	  }
	};
	
	exports['default'] = function () {
	  var customTheme = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var calendarWidth = defaultTheme.Calendar.width;
	  var calendarPadding = defaultTheme.Calendar.padding;
	  var cellMargin = defaultTheme.Day.margin || 0;
	
	  if (customTheme.Calendar && customTheme.Calendar.hasOwnProperty('width')) {
	    calendarWidth = customTheme.Calendar.width;
	  }
	
	  if (customTheme.Calendar && customTheme.Calendar.hasOwnProperty('padding')) {
	    calendarPadding = customTheme.Calendar.padding;
	  }
	
	  if (customTheme.Day && customTheme.Day.hasOwnProperty('margin')) {
	    cellMargin = customTheme.Day.margin;
	  }
	
	  var cellSize = (parseInt(calendarWidth) - parseInt(calendarPadding) * 2) / 7 - parseInt(cellMargin) * 2;
	
	  return {
	    DateRange: _extends({}, defaultTheme.DateRange, customTheme.DateRange),
	
	    Calendar: _extends({}, defaultTheme.Calendar, customTheme.Calendar),
	
	    Day: _extends({
	      width: cellSize,
	      height: cellSize,
	      lineHeight: cellSize + 'px'
	    }, defaultTheme.Day, customTheme.Day),
	
	    DayPassive: _extends({}, defaultTheme.DayPassive, customTheme.DayPassive),
	
	    DayHover: _extends({}, defaultTheme.DayHover, customTheme.DayHover),
	
	    DayToday: _extends({}, defaultTheme.DayToday, customTheme.DayToday),
	
	    DayActive: _extends({}, defaultTheme.DayActive, customTheme.DayActive),
	
	    DaySelected: _extends({}, defaultTheme.DaySelected, customTheme.DaySelected),
	
	    DayStartEdge: _extends({}, defaultTheme.DayStartEdge, customTheme.DayStartEdge),
	
	    DayEndEdge: _extends({}, defaultTheme.DayEndEdge, customTheme.DayEndEdge),
	
	    DayInRange: _extends({}, defaultTheme.DayInRange, customTheme.DayInRange),
	
	    Weekday: _extends({
	      width: cellSize,
	      height: cellSize / 2,
	      lineHeight: cellSize / 2 + 'px'
	    }, defaultTheme.Weekday, customTheme.Weekday),
	
	    MonthAndYear: _extends({}, defaultTheme.MonthAndYear, customTheme.MonthAndYear),
	
	    MonthButton: _extends({}, defaultTheme.MonthButton, customTheme.MonthButton),
	
	    MonthArrow: _extends({}, defaultTheme.MonthArrow, customTheme.MonthArrow),
	
	    MonthArrowPrev: _extends({}, defaultTheme.MonthArrowPrev, customTheme.MonthArrowPrev),
	
	    MonthArrowNext: _extends({}, defaultTheme.MonthArrowNext, customTheme.MonthArrowNext),
	
	    PredefinedRanges: _extends({}, defaultTheme.PredefinedRanges, customTheme.PredefinedRanges),
	
	    PredefinedRangesItem: _extends({}, defaultTheme.PredefinedRangesItem, customTheme.PredefinedRangesItem),
	
	    PredefinedRangesItemActive: _extends({}, defaultTheme.PredefinedRangesItemActive, customTheme.PredefinedRangesItemActive)
	  };
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilsParseInputJs = __webpack_require__(706);
	
	var _utilsParseInputJs2 = _interopRequireDefault(_utilsParseInputJs);
	
	var _stylesJs = __webpack_require__(709);
	
	var PredefinedRanges = (function (_Component) {
	  _inherits(PredefinedRanges, _Component);
	
	  function PredefinedRanges(props, context) {
	    _classCallCheck(this, PredefinedRanges);
	
	    _get(Object.getPrototypeOf(PredefinedRanges.prototype), 'constructor', this).call(this, props, context);
	
	    this.styles = this.props.theme;
	  }
	
	  _createClass(PredefinedRanges, [{
	    key: 'handleSelect',
	    value: function handleSelect(name, event) {
	      event.preventDefault();
	
	      var range = this.props.ranges[name];
	
	      this.props.onSelect({
	        startDate: (0, _utilsParseInputJs2['default'])(range['startDate']),
	        endDate: (0, _utilsParseInputJs2['default'])(range['endDate'])
	      }, PredefinedRanges);
	    }
	  }, {
	    key: 'renderRangeList',
	    value: function renderRangeList(classes) {
	      var _this = this;
	
	      var _props = this.props;
	      var ranges = _props.ranges;
	      var range = _props.range;
	      var onlyClasses = _props.onlyClasses;
	      var styles = this.styles;
	
	      return Object.keys(ranges).map((function (name) {
	        var active = (0, _utilsParseInputJs2['default'])(ranges[name].startDate).isSame(range.startDate) && (0, _utilsParseInputJs2['default'])(ranges[name].endDate).isSame(range.endDate);
	
	        var style = _extends({}, styles['PredefinedRangesItem'], active ? styles['PredefinedRangesItemActive'] : {});
	
	        return _react2['default'].createElement(
	          'a',
	          {
	            href: '#',
	            key: 'range-' + name,
	            className: classes.predefinedRangesItem + (active ? ' active' : ''),
	            style: onlyClasses ? undefined : style,
	            onClick: _this.handleSelect.bind(_this, name)
	          },
	          name
	        );
	      }).bind(this));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var style = _props2.style;
	      var onlyClasses = _props2.onlyClasses;
	      var classNames = _props2.classNames;
	      var styles = this.styles;
	
	      var classes = _extends({}, _stylesJs.defaultClasses, classNames);
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          style: onlyClasses ? undefined : _extends({}, styles['PredefinedRanges'], style),
	          className: classes.predefinedRanges
	        },
	        this.renderRangeList(classes)
	      );
	    }
	  }]);
	
	  return PredefinedRanges;
	})(_react.Component);
	
	PredefinedRanges.defaultProps = {
	  onlyClasses: false,
	  classNames: {}
	};
	
	PredefinedRanges.propTypes = {
	  ranges: _react.PropTypes.object.isRequired,
	  onlyClasses: _react.PropTypes.bool,
	  classNames: _react.PropTypes.object
	};
	
	exports['default'] = PredefinedRanges;
	module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  'Today': {
	    startDate: function startDate(now) {
	      return now;
	    },
	    endDate: function endDate(now) {
	      return now;
	    }
	  },
	
	  'Yesterday': {
	    startDate: function startDate(now) {
	      return now.add(-1, 'days');
	    },
	    endDate: function endDate(now) {
	      return now.add(-1, 'days');
	    }
	  },
	
	  'Last 7 Days': {
	    startDate: function startDate(now) {
	      return now.add(-7, 'days');
	    },
	    endDate: function endDate(now) {
	      return now;
	    }
	  },
	
	  'Last 30 Days': {
	    startDate: function startDate(now) {
	      return now.add(-30, 'days');
	    },
	    endDate: function endDate(now) {
	      return now;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modale":"modal__modale___208g_","modalAmplio":"modal__modalAmplio___2gW3-","modalEnvioNominas":"modal__modalEnvioNominas___3wr6g","modalHistorialNomina":"modal__modalHistorialNomina___1JZfp","modalAumentoDot":"modal__modalAumentoDot___7hTY8","modalCambioDot":"modal__modalCambioDot___1wnmj","modalCambiosNomina":"modal__modalCambiosNomina___3b045","modalPublicacionIG":"modal__modalPublicacionIG___3v_My","modalAdminBilling":"modal__modalAdminBilling___1IXEz","modalPDALider":"modal__modalPDALider___1x_P2","modalCantidades":"modal__modalCantidades___RC5s5","modalApproveReview":"modal__modalApproveReview___3zpNT","headerColumn":"modal__headerColumn___RWsX-","headerColumnAumentoDot":"modal__headerColumnAumentoDot___-c1v9","headerRow":"modal__headerRow___1DMt8","evenRow":"modal__evenRow___1MZld","oddRow":"modal__oddRow___3ty5B","modalPDADisponibles":"modal__modalPDADisponibles___gSm9S","modalPDATotales":"modal__modalPDATotales___3KlET","modalPDATotalesBorde":"modal__modalPDATotalesBorde___3Jx2z","modalPDATotalesRow":"modal__modalPDATotalesRow___TStbs","oprarioData":"modal__oprarioData___37teO","comentarioCambio":"modal__comentarioCambio___zFo50","btnModal":"modal__btnModal___1HGBi","glyphicon":"modal__glyphicon___j7VDH","labelCantidad":"modal__labelCantidad___23ebX","panelHeading":"modal__panelHeading___iTvps","trSeparator":"modal__trSeparator___xxIjd"};

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panelHeading_compacto":"PanelCaptador__panelHeading_compacto___3XaqJ","tablaDotacion":"PanelCaptador__tablaDotacion___2Py23","colCorrelativo":"PanelCaptador__colCorrelativo___3e2ND","colCorrelativoSEI":"PanelCaptador__colCorrelativoSEI___1cSTA","colCheckbox":"PanelCaptador__colCheckbox___3-89u","colUsuarioRUN":"PanelCaptador__colUsuarioRUN___3G97g","tdUsuarioRUN":"PanelCaptador__tdUsuarioRUN___2Q8VP","colUsuarioDV":"PanelCaptador__colUsuarioDV___M_ubF","thUsuarioDV":"PanelCaptador__thUsuarioDV___3E1oo","tdUsuarioDV":"PanelCaptador__tdUsuarioDV___3gl0G","colNombre":"PanelCaptador__colNombre___3bXRU","colNombreM":"PanelCaptador__colNombreM___BtwVv","tdNombre":"PanelCaptador__tdNombre___1GwbB","colNombreCorto":"PanelCaptador__colNombreCorto___3Wpfk","colCargo":"PanelCaptador__colCargo___2FMaA","colComuna":"PanelCaptador__colComuna___1OALL","colCaptador":"PanelCaptador__colCaptador___3CUOx","tdCaptador":"PanelCaptador__tdCaptador___2CyFi","colExp":"PanelCaptador__colExp___2abbO","colOpciones":"PanelCaptador__colOpciones___1o5VE","colIntercambio":"PanelCaptador__colIntercambio___1bHDY","colError":"PanelCaptador__colError___33hZM","thError":"PanelCaptador__thError___LekTS","tdError":"PanelCaptador__tdError___1w-cD","colConteo":"PanelCaptador__colConteo___1_a5j","colConteoReal":"PanelCaptador__colConteoReal___3-K3u","thConteo":"PanelCaptador__thConteo___3vY7d","thConteoSpan":"PanelCaptador__thConteoSpan___2U3ju","tdConteo":"PanelCaptador__tdConteo___2qF88","tdConteoBajo":"PanelCaptador__tdConteoBajo___27E_g","tdConteoReal":"PanelCaptador__tdConteoReal___Rt1VE","tdDiferencia":"PanelCaptador__tdDiferencia___kIiq7","colAsistencia":"PanelCaptador__colAsistencia___1S0O3","colRank":"PanelCaptador__colRank___bf2Eo","colSituacion":"PanelCaptador__colSituacion___159Er","colEstado":"PanelCaptador__colEstado___33qC_","colEstadoCI":"PanelCaptador__colEstadoCI___8WKtp","colPermisoMall":"PanelCaptador__colPermisoMall___m5qer","imgCentrada":"PanelCaptador__imgCentrada___18NpJ","colContNomina":"PanelCaptador__colContNomina___Al3Wr","thContNomina":"PanelCaptador__thContNomina___3kSfG","tdContNomina":"PanelCaptador__tdContNomina___2MUEz","colDifStock":"PanelCaptador__colDifStock___37s69","thDifStock":"PanelCaptador__thDifStock___20ei2","tdDifStock":"PanelCaptador__tdDifStock___3aYmc","operadorEnOtraNominaMismoDia":"PanelCaptador__operadorEnOtraNominaMismoDia___3ErU6","tdDifStockNegativo":"PanelCaptador__tdDifStockNegativo___13OKQ","tdDifStockPositivo":"PanelCaptador__tdDifStockPositivo___2xXGj","colStock":"PanelCaptador__colStock___9USbv","thStock":"PanelCaptador__thStock___df7-6","tdStock":"PanelCaptador__tdStock___1E8WZ","colAccion":"PanelCaptador__colAccion___uiOdg","thNuevoOperador":"PanelCaptador__thNuevoOperador___3Gjwv","textoConTooltip":"PanelCaptador__textoConTooltip___Q5da-","tooltip":"PanelCaptador__tooltip___AsRvI","tooltiptext":"PanelCaptador__tooltiptext___3ErWV","asistencia_0":"PanelCaptador__asistencia_0___Hb9fR","asistencia_1":"PanelCaptador__asistencia_1___2MV48","asistencia_2":"PanelCaptador__asistencia_2___PXdPa","asistencia_3":"PanelCaptador__asistencia_3___2x9jq","asistencia_4":"PanelCaptador__asistencia_4___1JctZ","asistencia_5":"PanelCaptador__asistencia_5___2O8V-","pendiente_1":"PanelCaptador__pendiente_1___3wR0W","pendiente_2":"PanelCaptador__pendiente_2___LvZFb","pendiente_3":"PanelCaptador__pendiente_3___2fWFv","aprobado_1":"PanelCaptador__aprobado_1___lS4Nu","aprobado_2":"PanelCaptador__aprobado_2___2xPag","semaforo_verde":"PanelCaptador__semaforo_verde___3d0dq","semaforo_amarillo":"PanelCaptador__semaforo_amarillo___xArUv","semaforo_rojo":"PanelCaptador__semaforo_rojo___1zTy4","semaforo_gris":"PanelCaptador__semaforo_gris___2bJi0","emoji_verde":"PanelCaptador__emoji_verde___Z2oiR","emoji_amarillo":"PanelCaptador__emoji_amarillo___3Q67x","emoji_rojo":"PanelCaptador__emoji_rojo___1eu8l","emoji_gris":"PanelCaptador__emoji_gris___38zbo","vibracion":"PanelCaptador__vibracion___raxms"};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBoxAPI = function () {
	    function BlackBoxAPI() {
	        _classCallCheck(this, BlackBoxAPI);
	
	        this.lista = [];
	        this.filtroLideres = [];
	    }
	
	    _createClass(BlackBoxAPI, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroLideres = [];
	        }
	    }, {
	        key: 'add',
	        value: function add(detalle) {
	            this.lista.push(detalle);
	        }
	        /*** ################### FILTROS ################### ***/
	
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            this.filtroLideres = _lodash2.default.chain(this.lista).map(function (detalle) {
	                var valor = detalle.codigo;
	                var texto = detalle.lider;
	                var opcion = _lodash2.default.find(_this.filtroLideres, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	        }
	    }, {
	        key: 'ordenarLista',
	        value: function ordenarLista() {
	            var porLider = function porLider(detalle) {
	                return detalle.codigo;
	            };
	            this.lista = _lodash2.default.orderBy(this.lista, [porLider], ['asc', 'asc', 'desc']);
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	            var detFiltrado = _lodash2.default.chain(this.lista).filter(function (detalle) {
	                return _lodash2.default.find(_this2.filtroLideres, { 'valor': detalle.codigo, 'seleccionado': true });
	            }).value();
	            return {
	                totalDisponible: detFiltrado[0]['disponible'],
	                totalReal: _lodash2.default.sumBy(detFiltrado, 'real'),
	                totalNecesarias: _lodash2.default.sumBy(detFiltrado, 'necesarias'),
	                totalExcedente: _lodash2.default.sumBy(detFiltrado, 'excedente'),
	                totalFaltantes: _lodash2.default.sumBy(detFiltrado, 'faltantes'),
	                detallesFiltrados: detFiltrado,
	                filtros: {
	                    filtroLideres: this.filtroLideres
	                }
	            };
	        }
	    }]);
	
	    return BlackBoxAPI;
	}();
	
	exports.default = BlackBoxAPI;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxAPI.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaAPI = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _tablaPersonal = __webpack_require__(716);
	
	var css = _interopRequireWildcard(_tablaPersonal);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Styles
	
	
	var TablaAPI = exports.TablaAPI = function (_React$Component) {
	    _inherits(TablaAPI, _React$Component);
	
	    function TablaAPI() {
	        _classCallCheck(this, TablaAPI);
	
	        return _possibleConstructorReturn(this, (TablaAPI.__proto__ || Object.getPrototypeOf(TablaAPI)).apply(this, arguments));
	    }
	
	    _createClass(TablaAPI, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '50%' }, className: 'row' },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.detalle.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.detalle[index];
	                                },
	                                rowHeight: 30,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRowAPI : index % 2 === 0 ? css.evenRowAPI : css.oddRowAPI;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'lider', label: 'Lider',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConFiltro2.default, {
	                                        nombre: 'Lider',
	                                        filtro: _this2.props.filtros.filtroLideres || [],
	                                        actualizarFiltro: _this2.props.actualizarFiltro.bind(_this2, 'filtroLideres')
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var cellData = _ref4.cellData,
	                                        columnData = _ref4.columnData,
	                                        dataKey = _ref4.dataKey,
	                                        rowData = _ref4.rowData,
	                                        rowIndex = _ref4.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 170,
	                                className: css.celdaAPILider
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'real', label: 'real lider',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var cellData = _ref5.cellData,
	                                        columnData = _ref5.columnData,
	                                        dataKey = _ref5.dataKey,
	                                        rowData = _ref5.rowData,
	                                        rowIndex = _ref5.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130,
	                                className: css.celdaAPI
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'necesarias', label: 'necesidad max',
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var cellData = _ref6.cellData,
	                                        columnData = _ref6.columnData,
	                                        dataKey = _ref6.dataKey,
	                                        rowData = _ref6.rowData,
	                                        rowIndex = _ref6.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130,
	                                className: css.celdaAPI
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'faltantes', label: 'suministrar',
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var cellData = _ref7.cellData,
	                                        columnData = _ref7.columnData,
	                                        dataKey = _ref7.dataKey,
	                                        rowData = _ref7.rowData,
	                                        rowIndex = _ref7.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130,
	                                className: css.celdaAPI
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'excedente', label: 'Excedentes',
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var cellData = _ref8.cellData,
	                                        columnData = _ref8.columnData,
	                                        dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData,
	                                        rowIndex = _ref8.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130,
	                                className: css.celdaAPI
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaAPI;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaAPI.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerRow":"tablaPersonal__headerRow___1zvyx","evenRow":"tablaPersonal__evenRow___jIrwm","oddRow":"tablaPersonal__oddRow___2h7UL","headerColumn":"tablaPersonal__headerColumn___3nXPd","headerRowAPI":"tablaPersonal__headerRowAPI___1IlFM","evenRowAPI":"tablaPersonal__evenRowAPI___1tg_k","oddRowAPI":"tablaPersonal__oddRowAPI___1x-ve","headerColumnAPI":"tablaPersonal__headerColumnAPI___2weNY","celdaAPI":"tablaPersonal__celdaAPI___3bcQL","celdaAPILider":"tablaPersonal__celdaAPILider___2bdxt"};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectCaptadores = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _BotonRegion = __webpack_require__(718);
	
	var _SelectCaptadores = __webpack_require__(719);
	
	var css = _interopRequireWildcard(_SelectCaptadores);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Styles
	
	var cx = _bind2.default.bind(css);
	
	var SelectCaptadores = exports.SelectCaptadores = function (_React$Component) {
	    _inherits(SelectCaptadores, _React$Component);
	
	    function SelectCaptadores(props) {
	        _classCallCheck(this, SelectCaptadores);
	
	        var _this = _possibleConstructorReturn(this, (SelectCaptadores.__proto__ || Object.getPrototypeOf(SelectCaptadores)).call(this, props));
	
	        _this.state = {
	            nuevoCaptadorVisible: false
	        };
	        _this.mostrar_nuevoCaptador = function () {
	            _this.setState({ nuevoCaptadorVisible: true });
	        };
	        _this.ocultar_nuevoCaptador = function () {
	            _this.setState({ nuevoCaptadorVisible: false });
	        };
	        _this.captadorSeleccionado = function (evt) {
	            var idUsuario = evt.target.value;
	            _this.props.agregarCaptador(idUsuario);
	            _this.ocultar_nuevoCaptador();
	        };
	
	        return _this;
	    }
	    /*confirmarRegion = (idCaptador, data) => {
	        let regiones = data.filter((region) => {
	            return region.status > 0
	        });
	        this.props.agregarRegionesCaptador(idCaptador, regiones)
	    }*/
	
	
	    _createClass(SelectCaptadores, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return this.props.visible ? _react2.default.createElement(
	                'div',
	                null,
	                this.props.captadores.length == 0 && this.state.nuevoCaptadorVisible == false ? _react2.default.createElement(
	                    'div',
	                    { className: cx('captador-vacio') },
	                    _react2.default.createElement('div', { className: cx('captador-vacio-texto') }),
	                    this.props.puedeEditar ? _react2.default.createElement('div', { className: cx('captador-vacio-opcion'), onClick: this.mostrar_nuevoCaptador }) : null
	                ) : null,
	                this.props.captadores.map(function (captador) {
	                    return _react2.default.createElement(Captador, {
	                        puedeEditar: _this2.props.puedeEditar,
	                        key: captador.idUsuario,
	                        nombre: captador.nombre,
	                        asignados: captador.asignados,
	                        agregarCaptador: _this2.mostrar_nuevoCaptador,
	                        quitarCaptador: _this2.props.quitarCaptador.bind(_this2, captador.idUsuario),
	                        cambiarAsignados: _this2.props.cambiarAsignados.bind(_this2, captador.idUsuario),
	                        idInventario: _this2.props.idInventario,
	                        regiones: _this2.props.regiones,
	                        idCaptador: captador.idUsuario,
	                        regionesCaptador: captador.regiones,
	                        regionesActuales: captador.regiones_actuales,
	                        agregarRegionesCaptador: _this2.props.agregarRegionesCaptador,
	                        cerrarRegion: _this2.props.cerrarRegion
	                    });
	                }),
	                _react2.default.createElement(NuevoCaptador, {
	                    visible: this.state.nuevoCaptadorVisible,
	                    captadoresDisponibles: this.props.captadoresDisponibles,
	                    ocultar_nuevoCaptador: this.ocultar_nuevoCaptador,
	                    captadorSeleccionado: this.captadorSeleccionado
	                })
	            ) : null;
	        }
	    }]);
	
	    return SelectCaptadores;
	}(_react2.default.Component);
	
	SelectCaptadores.propTypes = {
	    // objetos
	    puedeEditar: PropTypes.bool.isRequired,
	    captadoresDisponibles: PropTypes.arrayOf(PropTypes.object).isRequired,
	    // metodos
	    agregarCaptador: PropTypes.func.isRequired,
	    quitarCaptador: PropTypes.func.isRequired,
	    cambiarAsignados: PropTypes.func.isRequired
	
	    /* ############################################### SELECTOR CAPTADOR ################################################ */
	    // todo: mostrar boton de confirmacion al tratar de eliminar
	};
	var Captador = function (_React$Component2) {
	    _inherits(Captador, _React$Component2);
	
	    function Captador(props) {
	        _classCallCheck(this, Captador);
	
	        var _this3 = _possibleConstructorReturn(this, (Captador.__proto__ || Object.getPrototypeOf(Captador)).call(this, props));
	
	        _this3.state = {
	            optionsVisible: false,
	            inputAsignados: props.asignados,
	            show: false,
	            checkRegiones: props.regiones.map(function (region) {
	                return { cutRegion: region.cutRegion, status: props.regionesActuales.includes(region.cutRegion) ? 1 : 0 };
	            })
	            // Metodos del menu de opciones
	        };_this3.__onClickHandler__ = function (evt) {
	            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
	            var clickAfuera = !_this3.node.contains(evt.target) && _this3.nodeTrigger && !_this3.nodeTrigger.contains(evt.target);
	            if (clickAfuera && _this3.state.optionsVisible) _this3._hideMenu();
	        };
	        _this3.toggleMenu = function () {
	            if (_this3.state.optionsVisible) _this3._hideMenu();else _this3._showMenu();
	        };
	        _this3._showMenu = function () {
	            _this3.setState({ optionsVisible: true });
	        };
	        _this3._hideMenu = function () {
	            _this3.setState({ optionsVisible: false });
	        };
	
	        _this3.agregarCaptador = function () {
	            _this3._hideMenu();
	            _this3.props.agregarCaptador();
	        };
	        _this3.cambiarAsignados = function () {
	            if (_this3.state.inputAsignados != _this3.props.asignados) _this3.props.cambiarAsignados(_this3.state.inputAsignados);else console.log('asignado e inputAsignados son iguales, no se hace el cambio');
	        };
	        _this3._onChange = function (evt) {
	            _this3.setState({ inputAsignados: evt.target.value });
	        };
	        _this3._onKeyDown = function (evt) {
	            if (evt.keyCode === 13) {
	                _this3.cambiarAsignados();
	            }
	        };
	        _this3.toggleFormRegion = function (e) {
	            _this3.setState({
	                show: !_this3.state.show,
	                target: e.target
	            });
	        };
	        _this3.handleClose = function () {
	            _this3.setState({
	                show: false
	            });
	        };
	        _this3.filterRegiones = function () {
	            var regiones = _this3.props.regiones;
	            var listRegiones = regiones.map(function (region) {
	                return { cutRegion: region.cutRegion, status: props.regionesActuales.includes(region.cutRegion) ? 1 : 0 };
	            });
	            _this3.setState({
	                checkRegiones: listRegiones
	            });
	        };
	        _this3.setStatusButton = function (cutRegion, status) {
	            var lista = _this3.state.checkRegiones.map(function (region) {
	                if (region.cutRegion == cutRegion) {
	                    return { cutRegion: cutRegion, status: status };
	                } else {
	                    return region;
	                }
	            });
	            _this3.setState({ checkRegiones: lista });
	        };
	
	        _this3.setStatusButtonFinal = function (status) {
	            var lista = _this3.state.checkRegiones.map(function (region) {
	                if (region.status > 0) {
	                    return { cutRegion: region.cutRegion, status: status };
	                } else {
	                    return region;
	                }
	            });
	            _this3.setState({ checkRegiones: lista });
	        };
	        return _this3;
	    }
	
	    _createClass(Captador, [{
	        key: 'confirmarRegiones',
	        value: function confirmarRegiones(idCaptador, checkRegiones) {
	            this.props.agregarRegionesCaptador(idCaptador, checkRegiones);
	            this.setStatusButtonFinal(0);
	            this.handleClose();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.__onClickHandler__);
	            this.filterRegiones();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.__onClickHandler__);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                inputAsignados: nextProps.asignados,
	                checkRegiones: nextProps.regiones.map(function (region) {
	                    return { cutRegion: region.cutRegion, status: nextProps.regionesActuales.includes(region.cutRegion) ? 1 : 0 };
	                })
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var regiones = this.props.regiones;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('captador-div') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('captador-text'), onClick: this.toggleFormRegion.bind(this) },
	                        this.props.nombre
	                    ),
	                    this.props.puedeEditar && this.props.idCaptador != 1 ? _react2.default.createElement(
	                        _reactBootstrap.Overlay,
	                        {
	                            show: this.state.show,
	                            target: this.state.target,
	                            placement: 'right',
	                            onHide: this.handleClose.bind(this),
	                            rootClose: true
	                        },
	                        _react2.default.createElement(
	                            _reactBootstrap.Popover,
	                            {
	                                id: this.props.idInventario },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Seleccione las regiones'
	                            ),
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'Captador: ',
	                                this.props.nombre
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx('formulario') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('regiones') },
	                                    regiones.map(function (region, index) {
	                                        var pressed = _this4.state.checkRegiones.find(function (_ref) {
	                                            var cutRegion = _ref.cutRegion;
	                                            return region.cutRegion == cutRegion;
	                                        });
	                                        var disponible = _this4.props.regionesCaptador.includes(region.cutRegion);
	                                        var actual = _this4.props.regionesActuales.includes(region.cutRegion);
	                                        return _react2.default.createElement(_BotonRegion.BotonRegion, {
	                                            key: index,
	                                            title: region.nombre,
	                                            value: region.cutRegion,
	                                            numero: region.numero,
	                                            disponible: disponible,
	                                            actual: actual,
	                                            buttonStatus: pressed ? pressed.status > 0 ? true : false : false,
	                                            setStatusButton: _this4.setStatusButton.bind(_this4)
	                                        });
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('formulario') },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-success', onClick: function onClick() {
	                                                return _this4.confirmarRegiones(_this4.props.idCaptador, _this4.state.checkRegiones);
	                                            } },
	                                        'Confirmar'
	                                    )
	                                )
	                            )
	                        )
	                    ) : null,
	                    _react2.default.createElement('input', { className: cx('captador-ammount', {
	                            'captador-ammount-dirty': this.state.inputAsignados != this.props.asignados
	                        }),
	                        type: 'number',
	                        value: this.state.inputAsignados,
	                        onChange: this._onChange,
	                        onKeyDown: this._onKeyDown,
	                        onBlur: this.cambiarAsignados,
	                        disabled: this.props.puedeEditar == false
	                    }),
	                    this.props.puedeEditar ? _react2.default.createElement(
	                        'div',
	                        { className: cx('dots-container'),
	                            onClick: this.toggleMenu,
	                            ref: function ref(_ref2) {
	                                return _this4.nodeTrigger = _ref2;
	                            }
	                        },
	                        _react2.default.createElement('div', { className: cx('dots') })
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(_ref3) {
	                            return _this4.node = _ref3;
	                        } },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: cx('options', { 'options-hidden': this.state.optionsVisible == false }) },
	                        _react2.default.createElement(
	                            'li',
	                            { className: cx('option'), onClick: this.agregarCaptador },
	                            'Agregar Captador'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: cx('option-blankspace') },
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: cx('option'), onClick: this.props.quitarCaptador },
	                            'Quitar Captador'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Captador;
	}(_react2.default.Component);
	
	/* ################################################# NUEVO CAPTADOR ################################################# */
	
	
	var NuevoCaptador = function (_React$Component3) {
	    _inherits(NuevoCaptador, _React$Component3);
	
	    function NuevoCaptador() {
	        _classCallCheck(this, NuevoCaptador);
	
	        return _possibleConstructorReturn(this, (NuevoCaptador.__proto__ || Object.getPrototypeOf(NuevoCaptador)).apply(this, arguments));
	    }
	
	    _createClass(NuevoCaptador, [{
	        key: 'render',
	        value: function render() {
	            return this.props.visible ? _react2.default.createElement(
	                'div',
	                { className: cx('captador-nuevo') },
	                _react2.default.createElement(
	                    'select',
	                    { className: cx('captador-nuevo-select'), onChange: this.props.captadorSeleccionado },
	                    _react2.default.createElement(
	                        'option',
	                        { key: 0, value: 0 },
	                        '--'
	                    ),
	                    this.props.captadoresDisponibles.map(function (captador) {
	                        return _react2.default.createElement(
	                            'option',
	                            { key: captador.valor, value: captador.valor },
	                            captador.texto
	                        );
	                    })
	                ),
	                _react2.default.createElement('div', { className: cx('captador-nuevo-opcion'), onClick: this.props.ocultar_nuevoCaptador })
	            ) : null;
	        }
	    }]);
	
	    return NuevoCaptador;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectCaptadores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BotonRegion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectCaptadores = __webpack_require__(719);
	
	var css = _interopRequireWildcard(_SelectCaptadores);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(css);
	
	var BotonRegion = exports.BotonRegion = function (_React$Component) {
	    _inherits(BotonRegion, _React$Component);
	
	    function BotonRegion(props) {
	        _classCallCheck(this, BotonRegion);
	
	        var _this = _possibleConstructorReturn(this, (BotonRegion.__proto__ || Object.getPrototypeOf(BotonRegion)).call(this, props));
	
	        _this.state = {
	            actual: _this.props.actual,
	            clicked: _this.props.buttonStatus
	        };
	
	        _this.handleClick = function () {
	            if (_this.state.clicked == false) {
	                _this.props.setStatusButton(_this.props.value, 1);
	                _this.setState({ clicked: true, actua: _this.props.actual });
	            } else {
	                _this.props.setStatusButton(_this.props.value, 0);
	                _this.setState({ clicked: false, actual: false });
	            }
	        };
	        return _this;
	    }
	
	    _createClass(BotonRegion, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                actual: nextProps.actual,
	                clicked: nextProps.buttonStatus
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.props.disponible ? _react2.default.createElement(
	                'button',
	                { className: this.state.clicked ? this.state.actual ? cx('region-actual') : cx('region-marcada') : cx('region'),
	                    title: this.props.title,
	                    value: this.props.value,
	                    onClick: this.handleClick.bind(this)
	                },
	                this.props.numero
	            ) : _react2.default.createElement(
	                'button',
	                {
	                    className: cx('region'),
	                    title: this.props.title,
	                    value: this.props.value,
	                    disabled: true
	                },
	                this.props.numero
	            );
	        }
	    }]);
	
	    return BotonRegion;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BotonRegion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SELECT_WIDTH":"85px","OPTIONS_WIDTH":"100px","OPTIONS_HEIGHT":"150px","select-captadores":"SelectCaptadores__select-captadores___3coRc","hidden":"SelectCaptadores__hidden___1gaXt","captador-div":"SelectCaptadores__captador-div___3Tvjz","captador-disabled":"SelectCaptadores__captador-disabled___1nVOY","captador-text":"SelectCaptadores__captador-text___1nFJX","captador-ammount":"SelectCaptadores__captador-ammount___1Gmm_","captador-ammount-dirty":"SelectCaptadores__captador-ammount-dirty___d8wVi","dots-container":"SelectCaptadores__dots-container___1bxSF","dots":"SelectCaptadores__dots___2pqAF","solicitud":"SelectCaptadores__solicitud___3sM9v","options":"SelectCaptadores__options___1cNU9","options-btn-solicitud":"SelectCaptadores__options-btn-solicitud___1P7n6","options-hidden":"SelectCaptadores__options-hidden___1d-uX","option":"SelectCaptadores__option___20EgB","option-blankspace":"SelectCaptadores__option-blankspace___12qKd","captador-nuevo":"SelectCaptadores__captador-nuevo___3_wtm","captador-nuevo-select":"SelectCaptadores__captador-nuevo-select___1xw06","captador-nuevo-opcion":"SelectCaptadores__captador-nuevo-opcion___zdElj","captador-vacio":"SelectCaptadores__captador-vacio___2mw4r","captador-vacio-texto":"SelectCaptadores__captador-vacio-texto___31cMc","captador-vacio-opcion":"SelectCaptadores__captador-vacio-opcion___rohp-","formulario":"SelectCaptadores__formulario___1hIJL","regiones":"SelectCaptadores__regiones___1MDuD","region":"SelectCaptadores__region___4_Bhq","region-marcada":"SelectCaptadores__region-marcada___dYHCe","region-actual":"SelectCaptadores__region-actual___1oVCJ"};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ButtonSolicitud = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Modal3 = __webpack_require__(721);
	
	var _Modal4 = __webpack_require__(722);
	
	var _Modal5 = _interopRequireDefault(_Modal4);
	
	var _SelectCaptadores = __webpack_require__(719);
	
	var css = _interopRequireWildcard(_SelectCaptadores);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	//Componentes
	
	// Styles
	
	var cx = _bind2.default.bind(css);
	var glyphs = ['', // 0 - nunca ocurre
	'', // 1 - Deshabilitada
	'glyphicon glyphicon-plus', // 2 - Pendiente a enviar solicitud
	'glyphicon glyphicon-time', // 3 - Solicitud enviada
	'glyphicon glyphicon-ok', // 4 - Solicitud aprobada
	'glyphicon glyphicon-remove' // 5 - Solicitud rechazada
	];
	
	var ButtonSolicitud = exports.ButtonSolicitud = function (_React$Component) {
	    _inherits(ButtonSolicitud, _React$Component);
	
	    function ButtonSolicitud(props) {
	        _classCallCheck(this, ButtonSolicitud);
	
	        var _this = _possibleConstructorReturn(this, (ButtonSolicitud.__proto__ || Object.getPrototypeOf(ButtonSolicitud)).call(this, props));
	
	        _this.state = {
	            optionsVisible: false,
	            estado: '',
	            comentario: ''
	        };
	        _this.toggleMenu = function () {
	            if (_this.state.optionsVisible) _this._hideMenu();else _this._showMenu();
	        };
	        _this._showMenu = function () {
	            _this.setState({ optionsVisible: true });
	        };
	        _this._hideMenu = function () {
	            _this.setState({ optionsVisible: false });
	        };
	        _this.aceptar = function (comentario) {
	            _this.setState({
	                estado: 3,
	                optionsVisible: false,
	                comentario: comentario
	            }, function () {
	                _this.props.onGuardar(_this.props.idNomina, { estadoSolicitud: _this.state.estado, comentarioDotacion: _this.state.comentario });
	            });
	        };
	        _this.cancelar = function () {
	            _this.setState({
	                estado: 1,
	                optionsVisible: false
	            }, function () {
	                _this.props.onGuardar(_this.props.idNomina, { estadoSolicitud: _this.state.estado, comentarioDotacion: '' });
	            });
	        };
	        return _this;
	    }
	
	    _createClass(ButtonSolicitud, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return this.props.visible ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('captador-div') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('solicitud'),
	                            onClick: this.toggleMenu,
	                            ref: function ref(_ref) {
	                                return _this2.nodeTrigger = _ref;
	                            }
	                        },
	                        _react2.default.createElement('span', { className: glyphs[this.props.idEstadoDotacion] })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(_ref2) {
	                            return _this2.node = _ref2;
	                        } },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: cx('options', { 'options-hidden': this.state.optionsVisible == false }) },
	                        _react2.default.createElement(Aceptar, {
	                            aceptar: this.aceptar
	                        }),
	                        _react2.default.createElement(
	                            'li',
	                            { className: cx('option-blankspace') },
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: cx('glyphicon glyphicon-remove', 'options-btn-solicitud'), onClick: this.cancelar },
	                            'Cancelar'
	                        )
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return ButtonSolicitud;
	}(_react2.default.Component);
	
	ButtonSolicitud.propTypes = {
	    onGuardar: PropTypes.func.isRequired,
	    idNomina: PropTypes.number,
	    idEstadoDotacion: PropTypes.number
	};
	var Aceptar = function Aceptar(_ref3) {
	    var aceptar = _ref3.aceptar;
	    return _react2.default.createElement(
	        _Modal3.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'li',
	                { className: cx('glyphicon glyphicon-ok', 'options-btn-solicitud'), onClick: showModal },
	                'Aceptar',
	                isVisible && _react2.default.createElement(_Modal3.ModalComentario, {
	                    hideModal: hideModal,
	                    aceptar: aceptar
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ButtonSolicitud.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalComentario = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modal3 = __webpack_require__(722);
	
	var cssModal = _interopRequireWildcard(_Modal3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalComentario = exports.ModalComentario = function (_React$Component2) {
	    _inherits(ModalComentario, _React$Component2);
	
	    function ModalComentario(props) {
	        _classCallCheck(this, ModalComentario);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalComentario.__proto__ || Object.getPrototypeOf(ModalComentario)).call(this, props));
	
	        _this2.state = {
	            comentario: ''
	        };
	        _this2.onComentarioChange = function (evt) {
	            _this2.setState({ comentario: evt.target.value });
	        };
	        _this2.submitComentario = function () {
	            _this2.props.aceptar(_this2.state.comentario);
	            _this2.props.hideModal();
	        };
	        return _this2;
	    }
	
	    _createClass(ModalComentario, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cssModal.modale, dialogClassName: cssModal.modalAumentoDot },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Comentario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Comentario'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-10' },
	                                _react2.default.createElement('textarea', { className: 'form-control', placeholder: 'Ingrese Comentario',
	                                    value: this.state.comentario, onChange: this.onComentarioChange
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 form-group' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-primary', value: this.state.comentario, onClick: this.submitComentario },
	                                'Aceptar'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-cancel', onClick: this.props.hideModal },
	                                'Cancelar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalComentario;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modale":"Modal__modale___1h2Zu","modalAumentoDot":"Modal__modalAumentoDot___14t1q"};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _comentario = __webpack_require__(724);
	
	var css = _interopRequireWildcard(_comentario);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comentarios = function (_Component) {
	    _inherits(Comentarios, _Component);
	
	    function Comentarios(props) {
	        _classCallCheck(this, Comentarios);
	
	        var _this = _possibleConstructorReturn(this, (Comentarios.__proto__ || Object.getPrototypeOf(Comentarios)).call(this, props));
	
	        _this.state = {
	            marcado: props.comentarios.length > 0 ? true : false,
	            show: false,
	            comentarios: props.comentarios,
	            enableGet: true,
	            editando: false,
	            confirmarEditar: false,
	            checkComentarios: [],
	            checked: false
	        };
	        return _this;
	    }
	
	    _createClass(Comentarios, [{
	        key: "handleChangeCheck",
	        value: function handleChangeCheck(e) {
	            this.setState({
	                editando: true,
	                confirmarEditar: true,
	                checked: e.target.checked
	            });
	        }
	    }, {
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "updateComentarios",
	        value: function updateComentarios(comentarios) {
	            this.props.updateComentarios(this.props.idInventario, comentarios);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.comentarios !== this.props.comentarios) {
	                this.setState({
	                    comentarios: this.props.comentarios,
	                    marcado: this.props.comentarios.length > 0 ? true : false
	                });
	            }
	        }
	    }, {
	        key: "handleGetComentarios",
	        value: function handleGetComentarios() {
	            var _this2 = this;
	
	            this.setState({
	                enableGet: false
	            });
	            _v2.default.comentarios.getComentarios(this.props.idInventario).then(function (resp) {
	                _this2.updateComentarios(resp);
	                _this2.setState({
	                    enableGet: true
	                });
	            }).catch(function (err) {
	                console.log("Error al actualizar comentario");
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var styles = this.state.marcado ? { fontWeight: '900', textDecoration: 'underline' } : { fontWeight: 'normal' };
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "p",
	                    { onClick: this.handleClick.bind(this), style: styles },
	                    this.props.comuna
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: "right",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.props.idInventario,
	                            bsClass: css.comentario_popover + " popover"
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: css.comentario_container },
	                            this.state.comentarios.map(function (comentario) {
	                                return _react2.default.createElement(Comentario, { key: comentario.id,
	                                    comentario: comentario,
	                                    editable: comentario.editable,
	                                    update: _this3.updateComentarios.bind(_this3)
	                                });
	                            })
	                        ),
	                        _react2.default.createElement(FormText, {
	                            idInventario: this.props.idInventario,
	                            update: this.updateComentarios.bind(this),
	                            getComentarios: this.handleGetComentarios.bind(this),
	                            enableGet: this.state.enableGet
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Comentarios;
	}(_react.Component);
	
	exports.default = Comentarios;
	
	var Comentario = function (_React$Component) {
	    _inherits(Comentario, _React$Component);
	
	    function Comentario(props) {
	        _classCallCheck(this, Comentario);
	
	        var _this4 = _possibleConstructorReturn(this, (Comentario.__proto__ || Object.getPrototypeOf(Comentario)).call(this, props));
	
	        _this4.state = {
	            defaulttext: "",
	            input: "",
	            editando: false,
	            enable: true
	        };
	        return _this4;
	    }
	
	    _createClass(Comentario, [{
	        key: "handleClick",
	        value: function handleClick() {
	            this.setState({
	                editando: true,
	                input: this.props.comentario.texto
	            });
	        }
	    }, {
	        key: "handleChangeEditar",
	        value: function handleChangeEditar(e) {
	            this.setState({
	                input: e.target.value
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this5 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.comentarios.editComentario(this.props.comentario.id, {
	                comentario: this.state.input.trim()
	            }).then(function (resp) {
	                _this5.props.update(resp);
	                _this5.setState({
	                    defaulttext: "",
	                    input: "",
	                    editando: false,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al editar comentario");
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: css.comentario_mensaje },
	                _react2.default.createElement(
	                    "p",
	                    { className: css.nombre + " " + css.textoConTooltip },
	                    this.props.comentario.usuario + ":",
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        this.props.comentario.fecha + " ",
	                        this.props.comentario.usuario_completo
	                    )
	                ),
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit.bind(this) },
	                    this.props.editable ? this.state.editando ? _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement("input", { className: css.input_comentario_editable, name: "comentario", type: "text", value: this.state.input, onChange: this.handleChangeEditar.bind(this), autoFocus: true, required: true }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.cancelarEditar.bind(this), type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : _react2.default.createElement(
	                        "p",
	                        { onClick: this.handleClick.bind(this), className: css.input_comentario_pointer },
	                        this.props.comentario.texto
	                    ) : _react2.default.createElement(
	                        "p",
	                        null,
	                        this.props.comentario.texto
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Comentario;
	}(_react2.default.Component);
	
	var FormText = function (_React$Component2) {
	    _inherits(FormText, _React$Component2);
	
	    function FormText(props) {
	        _classCallCheck(this, FormText);
	
	        var _this6 = _possibleConstructorReturn(this, (FormText.__proto__ || Object.getPrototypeOf(FormText)).call(this, props));
	
	        _this6.state = {
	            idComentario: 0,
	            defaulttext: "",
	            textarea: "",
	            visible: false,
	            rows: 1,
	            enable: true
	        };
	        _this6.handleSubmit = _this6.handleSubmit.bind(_this6);
	        _this6.handleChange = _this6.handleChange.bind(_this6);
	        _this6.handleCancelar = _this6.handleCancelar.bind(_this6);
	        return _this6;
	    }
	
	    _createClass(FormText, [{
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this7 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.comentarios.saveComentario(this.props.idInventario, {
	                idComentario: this.state.idComentario,
	                comentario: this.state.textarea.trim()
	            }).then(function (resp) {
	                _this7.props.update(resp);
	                _this7.setState({
	                    defaulttext: "",
	                    textarea: "",
	                    visible: false,
	                    rows: 1,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al enviar/recibir comentario");
	            });
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.setState({
	                textarea: e.target.value,
	                visible: true
	            });
	            var currentRows = e.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                this.setState({ rows: currentRows });
	            }
	        }
	    }, {
	        key: "handleCancelar",
	        value: function handleCancelar() {
	            this.setState(function (state) {
	                return {
	                    textarea: state.defaulttext,
	                    visible: false
	                };
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this8 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: css.formulario },
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement(
	                        "div",
	                        { className: css.mytextarea },
	                        _react2.default.createElement("textarea", {
	                            ref: function ref(text) {
	                                return _this8.textArea = text;
	                            },
	                            onChange: this.handleChange,
	                            value: this.state.textarea,
	                            maxLength: 200,
	                            rows: this.state.rows,
	                            type: "text",
	                            name: "comentario"
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.props.enableGet, type: "button", onClick: this.props.getComentarios, className: "btn btn-primary btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-refresh" })
	                        )
	                    ),
	                    this.state.visible ? _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.handleCancelar, type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return FormText;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Comentarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"comentario_popover":"comentario__comentario_popover___2_Ye-","comentario_container":"comentario__comentario_container___PP6tk","formulario":"comentario__formulario___2WXR6","comentario_mensaje":"comentario__comentario_mensaje___1VmKr","nombre":"comentario__nombre___EFpZN","boton":"comentario__boton___2XiBA","textoConTooltip":"comentario__textoConTooltip___2PX7w","mytextarea":"comentario__mytextarea___2fDGv","editar":"comentario__editar___37I8P","input_comentario_editable":"comentario__input_comentario_editable___12xCx","input_comentario_pointer":"comentario__input_comentario_pointer___3l8AH"};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _logistica = __webpack_require__(726);
	
	var css = _interopRequireWildcard(_logistica);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logistica = function (_Component) {
	    _inherits(Logistica, _Component);
	
	    function Logistica(props) {
	        _classCallCheck(this, Logistica);
	
	        var _this = _possibleConstructorReturn(this, (Logistica.__proto__ || Object.getPrototypeOf(Logistica)).call(this, props));
	
	        _this.state = {
	            show: false,
	            tiene: _this.props.tiene,
	            logistica: [],
	            enableGet: true,
	            editando: false
	        };
	        return _this;
	    }
	
	    _createClass(Logistica, [{
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "updateLogistica",
	        value: function updateLogistica(logistica) {
	            this.setState({
	                logistica: logistica,
	                tiene: logistica.length > 0 ? true : false
	            });
	        }
	    }, {
	        key: "traerLogistica",
	        value: function traerLogistica() {
	            var _this2 = this;
	
	            this.setState({
	                enableGet: false
	            });
	            _v2.default.logistica.getLogistica(this.props.idLocal).then(function (resp) {
	                _this2.setState({
	                    logistica: resp,
	                    enableGet: true
	                });
	            }).catch(function (err) {
	                console.log("Error al traer logistica");
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.logistica !== this.props.logistica) {
	                this.setState({
	                    logistica: this.props.logistica,
	                    tiene: true
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var styles = this.state.tiene ? { color: '#337AB7', cursor: 'pointer' } : { color: '#5CB85C' };
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "p",
	                    { onClick: this.handleClick.bind(this), style: styles },
	                    this.state.tiene ? _react2.default.createElement("i", { className: "glyphicon glyphicon-info-sign", style: styles }) : _react2.default.createElement("i", { className: "glyphicon glyphicon-plus", style: styles })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: "right",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.props.idLocal,
	                            bsClass: css.logistica_popover + " popover"
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: css.logistica_container },
	                            this.state.logistica.map(function (logistica) {
	                                return _react2.default.createElement(Log, { key: logistica.id,
	                                    logistica: logistica,
	                                    update: _this3.updateLogistica.bind(_this3),
	                                    traerLogistica: _this3.traerLogistica.bind(_this3),
	                                    idLocal: _this3.props.idLocal
	                                });
	                            })
	                        ),
	                        _react2.default.createElement(FormText, {
	                            idLocal: this.props.idLocal,
	                            update: this.updateLogistica.bind(this),
	                            getLogistica: this.traerLogistica.bind(this),
	                            enableGet: this.state.enableGet
	                            //traerLogistica={this.traerLogistica.bind(this)}
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Logistica;
	}(_react.Component);
	
	exports.default = Logistica;
	
	var Log = function (_React$Component) {
	    _inherits(Log, _React$Component);
	
	    function Log(props) {
	        _classCallCheck(this, Log);
	
	        var _this4 = _possibleConstructorReturn(this, (Log.__proto__ || Object.getPrototypeOf(Log)).call(this, props));
	
	        _this4.state = {
	            defaulttext: "",
	            input: "",
	            editando: false,
	            enable: true
	        };
	        return _this4;
	    }
	
	    _createClass(Log, [{
	        key: "handleClick",
	        value: function handleClick() {
	            this.setState({
	                editando: true,
	                input: this.props.logistica.texto
	            });
	        }
	    }, {
	        key: "handleChangeEditar",
	        value: function handleChangeEditar(e) {
	            this.setState({
	                input: e.target.value
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this5 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.logistica.editLogistica(this.props.logistica.id, {
	                logistica: this.state.input.trim()
	            }).then(function (resp) {
	                _this5.props.update(resp);
	                _this5.setState({
	                    defaulttext: "",
	                    input: "",
	                    editando: false,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al editar logistica");
	            });
	        }
	    }, {
	        key: "handleDelete",
	        value: function handleDelete() {
	            var _this6 = this;
	
	            this.setState({
	                enable: false
	            });
	            _v2.default.logistica.deleteLogistica(this.props.logistica.id).then(function (resp) {
	                _this6.props.update(resp);
	                _this6.setState({
	                    defaulttext: "",
	                    input: "",
	                    editando: false,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al eliminar logistica");
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: css.logistica_mensaje },
	                _react2.default.createElement(
	                    "p",
	                    { className: css.nombre + " " + css.textoConTooltip },
	                    this.props.logistica.usuario + ":",
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        this.props.logistica.fecha + " ",
	                        this.props.logistica.usuario_completo
	                    )
	                ),
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit.bind(this) },
	                    this.props.logistica.editable ? this.state.editando ? _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement("input", { className: css.input_logistica_editable, name: "logistica", type: "text", value: this.state.input, onChange: this.handleChangeEditar.bind(this), autoFocus: true, required: true }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.cancelarEditar.bind(this), type: "button", className: "btn btn-warning btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, onClick: this.handleDelete.bind(this), type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-trash" })
	                        )
	                    ) : _react2.default.createElement(
	                        "p",
	                        { onClick: this.handleClick.bind(this), className: css.input_logistica_pointer },
	                        this.props.logistica.texto
	                    ) : _react2.default.createElement(
	                        "p",
	                        null,
	                        this.props.logistica.texto
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Log;
	}(_react2.default.Component);
	
	var FormText = function (_React$Component2) {
	    _inherits(FormText, _React$Component2);
	
	    function FormText(props) {
	        _classCallCheck(this, FormText);
	
	        var _this7 = _possibleConstructorReturn(this, (FormText.__proto__ || Object.getPrototypeOf(FormText)).call(this, props));
	
	        _this7.state = {
	            idLogistica: 0,
	            defaulttext: "",
	            textarea: "",
	            visible: false,
	            rows: 5,
	            enable: true
	        };
	        _this7.handleSubmit = _this7.handleSubmit.bind(_this7);
	        _this7.handleChange = _this7.handleChange.bind(_this7);
	        _this7.handleCancelar = _this7.handleCancelar.bind(_this7);
	        return _this7;
	    }
	
	    _createClass(FormText, [{
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this8 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.logistica.saveLogistica(this.props.idLocal, {
	                idLogistica: this.state.idLogistica,
	                logistica: this.state.textarea.trim()
	            }).then(function (resp) {
	                _this8.props.update(resp);
	                _this8.setState({
	                    defaulttext: "",
	                    textarea: "",
	                    visible: false,
	                    rows: 5,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al enviar/recibir logistica");
	            });
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.setState({
	                textarea: e.target.value,
	                visible: true
	            });
	            var currentRows = e.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                this.setState({ rows: currentRows });
	            }
	        }
	    }, {
	        key: "handleCancelar",
	        value: function handleCancelar() {
	            this.setState(function (state) {
	                return {
	                    textarea: state.defaulttext,
	                    visible: false
	                };
	            });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.props.getLogistica();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this9 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: css.formulario },
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement(
	                        "div",
	                        { className: css.mytextarea },
	                        _react2.default.createElement("textarea", {
	                            ref: function ref(text) {
	                                return _this9.textArea = text;
	                            },
	                            onChange: this.handleChange,
	                            value: this.state.textarea,
	                            maxLength: 200,
	                            rows: this.state.rows,
	                            type: "text",
	                            name: "logistica"
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.props.enableGet, type: "button", onClick: this.props.getLogistica, className: "btn btn-primary btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-refresh" })
	                        )
	                    ),
	                    this.state.visible ? _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.handleCancelar, type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return FormText;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Logistica.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"logistica_popover":"logistica__logistica_popover___AQKbX","logistica_container":"logistica__logistica_container___3NZEK","formulario":"logistica__formulario___iddGY","logistica_mensaje":"logistica__logistica_mensaje___2XNdc","nombre":"logistica__nombre___2VShv","boton":"logistica__boton___1UIey","textoConTooltip":"logistica__textoConTooltip___16kwB","mytextarea":"logistica__mytextarea___13KEY","editar":"logistica__editar___3Drb-","input_logistica_editable":"logistica__input_logistica_editable___1jXPV","input_logistica_pointer":"logistica__input_logistica_pointer___3I7jQ"};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// props { css, checked, idNomina, setValueCheckbox }
	var CheckBoxNomina = function (_React$Component) {
	    _inherits(CheckBoxNomina, _React$Component);
	
	    function CheckBoxNomina(props) {
	        _classCallCheck(this, CheckBoxNomina);
	
	        var _this = _possibleConstructorReturn(this, (CheckBoxNomina.__proto__ || Object.getPrototypeOf(CheckBoxNomina)).call(this, props));
	
	        _this.state = {
	            checked: props.initialChecked
	        };
	        return _this;
	    }
	
	    _createClass(CheckBoxNomina, [{
	        key: "updateValueCheckbox",
	        value: function updateValueCheckbox(value) {
	            this.setState({
	                checked: value
	            });
	            this.props.setValueCheckbox(this.props.idNomina, value);
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(event) {
	            var value = event.target.checked;
	            this.updateValueCheckbox(value);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.initialChecked !== this.props.initialChecked) {
	                this.updateValueCheckbox(this.props.initialChecked);
	            }
	        }
	
	        /*componentDidMount(){
	            this.updateValueCheckbox(this.props.initialChecked);
	        }*/
	
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", { type: "checkbox",
	                className: this.props.css,
	                onChange: this.handleChange.bind(this),
	                checked: this.state.checked,
	                disabled: this.props.disabled
	            });
	        }
	    }]);
	
	    return CheckBoxNomina;
	}(_react2.default.Component);
	
	exports.default = CheckBoxNomina;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "CheckBoxNomina.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _comentario = __webpack_require__(724);
	
	var css = _interopRequireWildcard(_comentario);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComentariosCliente = function (_Component) {
	    _inherits(ComentariosCliente, _Component);
	
	    function ComentariosCliente(props) {
	        _classCallCheck(this, ComentariosCliente);
	
	        var _this = _possibleConstructorReturn(this, (ComentariosCliente.__proto__ || Object.getPrototypeOf(ComentariosCliente)).call(this, props));
	
	        _this.state = {
	            marcado: props.comentarios.length > 0 ? true : false,
	            show: false,
	            comentarios: props.comentarios,
	            enableGet: true,
	            editando: false,
	            confirmarEditar: false,
	            checkComentarios: [],
	            checked: false
	        };
	        return _this;
	    }
	
	    _createClass(ComentariosCliente, [{
	        key: "handleChangeCheck",
	        value: function handleChangeCheck(e) {
	            this.setState({
	                editando: true,
	                confirmarEditar: true,
	                checked: e.target.checked
	            });
	        }
	    }, {
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "updateComentarios",
	        value: function updateComentarios(comentarios) {
	            this.props.updateComentarios(this.props.idLocal, comentarios);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.comentarios !== this.props.comentarios) {
	                this.setState({
	                    comentarios: this.props.comentarios,
	                    marcado: this.props.comentarios.length > 0 ? true : false
	                });
	            }
	        }
	    }, {
	        key: "handleGetComentarios",
	        value: function handleGetComentarios() {
	            var _this2 = this;
	
	            this.setState({
	                enableGet: false
	            });
	            _v2.default.comentariosCliente.getComentarios(this.props.idLocal).then(function (resp) {
	                console.log(resp);
	                _this2.updateComentarios(resp);
	                _this2.setState({
	                    enableGet: true
	                });
	            }).catch(function (err) {
	                console.log("Error al actualizar comentario");
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var styles = this.state.marcado ? { fontWeight: '900', textDecoration: 'underline' } : { fontWeight: 'normal' };
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "p",
	                    { onClick: this.handleClick.bind(this), style: styles },
	                    this.props.local
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: "right",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.props.idLocal,
	                            bsClass: css.comentario_popover + " popover"
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: css.comentario_container },
	                            this.state.comentarios.map(function (comentario) {
	                                return _react2.default.createElement(Comentario, { key: comentario.id,
	                                    comentario: comentario,
	                                    editable: comentario.editable,
	                                    update: _this3.updateComentarios.bind(_this3),
	                                    puedeValidarComentarios: _this3.props.puedeValidarComentarios
	                                });
	                            })
	                        ),
	                        _react2.default.createElement(FormText, {
	                            idLocal: this.props.idLocal,
	                            update: this.updateComentarios.bind(this),
	                            getComentarios: this.handleGetComentarios.bind(this),
	                            enableGet: this.state.enableGet
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComentariosCliente;
	}(_react.Component);
	
	exports.default = ComentariosCliente;
	
	var Comentario = function (_React$Component) {
	    _inherits(Comentario, _React$Component);
	
	    function Comentario(props) {
	        _classCallCheck(this, Comentario);
	
	        var _this4 = _possibleConstructorReturn(this, (Comentario.__proto__ || Object.getPrototypeOf(Comentario)).call(this, props));
	
	        _this4.state = {
	            defaulttext: "",
	            input: "",
	            editando: false,
	            enable: true,
	            validado: props.comentario.validado
	        };
	        return _this4;
	    }
	
	    _createClass(Comentario, [{
	        key: "handleClick",
	        value: function handleClick() {
	            this.setState({
	                editando: true,
	                input: this.props.comentario.texto
	            });
	        }
	    }, {
	        key: "handleChangeEditar",
	        value: function handleChangeEditar(e) {
	            this.setState({
	                input: e.target.value
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	    }, {
	        key: "handleValid",
	        value: function handleValid() {
	            var _this5 = this;
	
	            _v2.default.comentariosCliente.validarComentario(this.props.comentario.id).then(function (resp) {
	                _this5.props.update(resp);
	                _this5.setState({
	                    validado: !_this5.state.validado
	                });
	            });
	        }
	    }, {
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this6 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.comentariosCliente.editComentario(this.props.comentario.id, {
	                comentario: this.state.input.trim()
	            }).then(function (resp) {
	                _this6.props.update(resp);
	                _this6.setState({
	                    defaulttext: "",
	                    input: "",
	                    editando: false,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al editar comentario");
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: css.comentario_mensaje },
	                this.props.puedeValidarComentarios ? _react2.default.createElement(
	                    "div",
	                    { style: { marginLeft: '2px', marginRight: '2px' } },
	                    _react2.default.createElement(
	                        "button",
	                        { className: this.state.validado ? "btn btn-warning btn-xs" : "btn btn-info btn-xs", onClick: this.handleValid.bind(this), disabled: this.state.validado ? true : false },
	                        _react2.default.createElement("i", { className: this.state.validado ? "glyphicon glyphicon-eye-close" : "glyphicon glyphicon-eye-open" }),
	                        " "
	                    )
	                ) : null,
	                _react2.default.createElement(
	                    "p",
	                    { className: css.nombre + " " + css.textoConTooltip },
	                    this.props.comentario.usuario + ": ",
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        this.props.comentario.fecha + " ",
	                        this.props.comentario.usuario_completo
	                    )
	                ),
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit.bind(this) },
	                    this.props.editable ? this.state.editando ? _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement("input", { className: css.input_comentario_editable, name: "comentario", type: "text", value: this.state.input, onChange: this.handleChangeEditar.bind(this), autoFocus: true, required: true }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.cancelarEditar.bind(this), type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : _react2.default.createElement(
	                        "p",
	                        { onClick: this.handleClick.bind(this), className: css.input_comentario_pointer },
	                        this.props.comentario.texto
	                    ) : _react2.default.createElement(
	                        "p",
	                        null,
	                        this.props.comentario.texto
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Comentario;
	}(_react2.default.Component);
	
	var FormText = function (_React$Component2) {
	    _inherits(FormText, _React$Component2);
	
	    function FormText(props) {
	        _classCallCheck(this, FormText);
	
	        var _this7 = _possibleConstructorReturn(this, (FormText.__proto__ || Object.getPrototypeOf(FormText)).call(this, props));
	
	        _this7.state = {
	            idComentario: 0,
	            defaulttext: "",
	            textarea: "",
	            visible: false,
	            rows: 1,
	            enable: true
	        };
	        _this7.handleSubmit = _this7.handleSubmit.bind(_this7);
	        _this7.handleChange = _this7.handleChange.bind(_this7);
	        _this7.handleCancelar = _this7.handleCancelar.bind(_this7);
	        return _this7;
	    }
	
	    _createClass(FormText, [{
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            var _this8 = this;
	
	            e.preventDefault();
	            this.setState({
	                enable: false
	            });
	            _v2.default.comentariosCliente.saveComentario(this.props.idLocal, {
	                idComentario: this.state.idComentario,
	                comentario: this.state.textarea.trim()
	            }).then(function (resp) {
	                _this8.props.update(resp);
	                _this8.setState({
	                    defaulttext: "",
	                    textarea: "",
	                    visible: false,
	                    rows: 1,
	                    enable: true
	                });
	            }).catch(function (err) {
	                console.log("Error al enviar/recibir comentario");
	            });
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.setState({
	                textarea: e.target.value,
	                visible: true
	            });
	            var currentRows = e.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                this.setState({ rows: currentRows });
	            }
	        }
	    }, {
	        key: "handleCancelar",
	        value: function handleCancelar() {
	            this.setState(function (state) {
	                return {
	                    textarea: state.defaulttext,
	                    visible: false
	                };
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this9 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: css.formulario },
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement(
	                        "div",
	                        { className: css.mytextarea },
	                        _react2.default.createElement("textarea", {
	                            ref: function ref(text) {
	                                return _this9.textArea = text;
	                            },
	                            onChange: this.handleChange,
	                            value: this.state.textarea,
	                            maxLength: 200,
	                            rows: this.state.rows,
	                            type: "text",
	                            name: "comentario"
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.props.enableGet, type: "button", onClick: this.props.getComentarios, className: "btn btn-primary btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-refresh" })
	                        )
	                    ),
	                    this.state.visible ? _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: !this.state.enable, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { onClick: this.handleCancelar, type: "button", className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return FormText;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ComentariosCliente.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _comentariosIG = __webpack_require__(730);
	
	var css = _interopRequireWildcard(_comentariosIG);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComentarioIG = function (_Component) {
	    _inherits(ComentarioIG, _Component);
	
	    function ComentarioIG(props) {
	        _classCallCheck(this, ComentarioIG);
	
	        var _this = _possibleConstructorReturn(this, (ComentarioIG.__proto__ || Object.getPrototypeOf(ComentarioIG)).call(this, props));
	
	        _this.state = {
	            show: false,
	            idInventario: props.idInventario,
	            comentarios: [],
	            loading: false,
	            saving: false
	        };
	        return _this;
	    }
	
	    _createClass(ComentarioIG, [{
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "getComentarios",
	        value: function getComentarios() {
	            var _this2 = this;
	
	            this.setState({
	                loading: true
	            });
	            _v2.default.comentarios_inv.getComentarios(this.state.idInventario).then(function (resp) {
	                _this2.setState({
	                    comentarios: resp.comentarios,
	                    loading: false
	                });
	            }).catch(function (err) {
	                console.log("Error al cargar comentarios");
	                _this2.setState({
	                    loading: false
	                });
	            });
	        }
	    }, {
	        key: "saveComentario",
	        value: function saveComentario(comentario) {
	            var _this3 = this;
	
	            this.setState({
	                saving: true
	            });
	            _v2.default.comentarios_inv.saveComentario(this.state.idInventario, {
	                comentario: comentario
	            }).then(function (resp) {
	                _this3.setState({
	                    saving: false,
	                    comentarios: resp.comentarios
	                });
	            }).catch(function (err) {
	                console.log("Error al enviar/recibir comentario");
	                _this3.setState({
	                    saving: false
	                });
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            var _this4 = this;
	
	            if (this.state.show == true && prevState.show == false) {
	                this.setState({
	                    loading: true
	                });
	                _v2.default.comentarios_inv.getComentarios(this.state.idInventario).then(function (resp) {
	                    _this4.setState({
	                        comentarios: resp.comentarios,
	                        loading: false
	                    });
	                }).catch(function (err) {
	                    console.log("Error al enviar/recibir comentario");
	                    _this4.setState({
	                        loading: false
	                    });
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "button",
	                    { onClick: this.handleClick.bind(this) },
	                    _react2.default.createElement("i", { className: "glyphicon glyphicon-comment" })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: this.props.placement ? this.props.placement : "left",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.state.idInventario,
	                            bsClass: css.comentarios_popover + " popover"
	                        },
	                        !this.state.loading ? _react2.default.createElement(
	                            "div",
	                            null,
	                            this.state.comentarios.map(function (registro, index) {
	                                return _react2.default.createElement(
	                                    "div",
	                                    { key: _this5.state.idInventario + "." + index, style: {
	                                            paddingLeft: 5,
	                                            paddingRight: 5
	                                        }, title: registro.created_at },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: {
	                                                fontSize: 10
	                                            } },
	                                        registro.usuario + ": "
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: {
	                                                fontSize: 12
	                                            } },
	                                        registro.comentario
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(FormText, {
	                                save: this.saveComentario.bind(this),
	                                saving: this.state.saving
	                            })
	                        ) : _react2.default.createElement(
	                            "div",
	                            { style: { padding: "20px" } },
	                            "Cargando..."
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComentarioIG;
	}(_react.Component);
	
	exports.default = ComentarioIG;
	
	var FormText = function (_React$Component) {
	    _inherits(FormText, _React$Component);
	
	    function FormText(props) {
	        _classCallCheck(this, FormText);
	
	        var _this6 = _possibleConstructorReturn(this, (FormText.__proto__ || Object.getPrototypeOf(FormText)).call(this, props));
	
	        _this6.state = {
	            defaulttext: "",
	            textarea: "",
	            visible: false,
	            rows: 5,
	            enable: true
	        };
	        _this6.handleSubmit = _this6.handleSubmit.bind(_this6);
	        _this6.handleChange = _this6.handleChange.bind(_this6);
	        _this6.handleCancelar = _this6.handleCancelar.bind(_this6);
	        return _this6;
	    }
	
	    _createClass(FormText, [{
	        key: "handleSubmit",
	        value: function handleSubmit(e) {
	            e.preventDefault();
	            this.props.save(this.state.textarea.trim());
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.setState({
	                textarea: e.target.value,
	                visible: true
	            });
	            var currentRows = e.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                this.setState({ rows: currentRows });
	            }
	        }
	    }, {
	        key: "handleCancelar",
	        value: function handleCancelar() {
	            this.setState(function (state) {
	                return {
	                    textarea: state.defaulttext,
	                    visible: false
	                };
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            if (this.props.saving == false && prevProps.saving == true) {
	                this.setState({
	                    defaulttext: "",
	                    textarea: "",
	                    visible: false,
	                    rows: 5,
	                    enable: true
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: css.formulario },
	                _react2.default.createElement(
	                    "form",
	                    { onSubmit: this.handleSubmit },
	                    _react2.default.createElement(
	                        "div",
	                        { className: css.mytextarea },
	                        _react2.default.createElement("textarea", {
	                            disabled: this.props.saving,
	                            ref: function ref(text) {
	                                return _this7.textArea = text;
	                            },
	                            onChange: this.handleChange,
	                            value: this.state.textarea,
	                            maxLength: 200,
	                            rows: this.state.rows,
	                            type: "text"
	                        })
	                    ),
	                    this.state.visible ? _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: this.props.saving, type: "submit", className: "btn btn-success btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-ok" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { disabled: this.props.saving, type: "button", onClick: this.handleCancelar, className: "btn btn-danger btn-xs" },
	                            _react2.default.createElement("i", { className: "glyphicon glyphicon-remove" })
	                        )
	                    ) : null,
	                    this.props.saving && _react2.default.createElement(
	                        "div",
	                        null,
	                        "Guardando..."
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormText;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ComentarioIG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"comentarios_popover":"comentariosIG__comentarios_popover___RD0pA","comentarios_container":"comentariosIG__comentarios_container___1SJuT","formulario":"comentariosIG__formulario___2lKcA","comentarios_mensaje":"comentariosIG__comentarios_mensaje___2kVdD","nombre":"comentariosIG__nombre___3BxAX","boton":"comentariosIG__boton___ZltQc","textoConTooltip":"comentariosIG__textoConTooltip___2zO_M","mytextarea":"comentariosIG__mytextarea___3AMWI","editar":"comentariosIG__editar___56uQ4","input_comentarios_editable":"comentariosIG__input_comentarios_editable___M6P_a","input_comentarios_pointer":"comentariosIG__input_comentarios_pointer___ZyVAV"};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDateRange = __webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	_moment2.default.locale('es');
	
	var SelectRange = function (_React$Component) {
	    _inherits(SelectRange, _React$Component);
	
	    function SelectRange(props) {
	        _classCallCheck(this, SelectRange);
	
	        var _this = _possibleConstructorReturn(this, (SelectRange.__proto__ || Object.getPrototypeOf(SelectRange)).call(this, props));
	
	        _this.state = {
	            visible: false,
	            startDate: _this.props.startDateSelected,
	            endDate: _this.props.endDateSelected
	        };
	
	        _this.onChangeDate = function (fechas) {
	            _this.setState({
	                startDate: fechas.startDate,
	                endDate: fechas.endDate
	            });
	        };
	        _this.toggleSelector = function () {
	            if (_this.state.visible) _this.onCancel();else _this._showSelector();
	        };
	        _this._showSelector = function () {
	            _this.setState({ visible: true });
	        };
	        _this._hideSelector = function () {
	            _this.setState({ visible: false });
	        };
	
	        _this.onAccept = function () {
	            _this._hideSelector();
	            _this.props.onRangeSelected(_this.state.startDate, _this.state.endDate);
	        };
	        _this.onCancel = function () {
	            _this._hideSelector();
	            // dejar el valor original
	            _this.setState({
	                startDate: _this.props.startDateSelected,
	                endDate: _this.props.endDateSelected
	            });
	        };
	        return _this;
	    }
	
	    _createClass(SelectRange, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.state = {
	                startDate: nextProps.startDateSelected,
	                endDate: nextProps.endDateSelected
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var textoFecha = this.state.startDate.format('YYYY') === this.state.endDate.format('YYYY') ? this.state.startDate.format('dddd DD MMMM') + ', a ' + this.state.endDate.format('dddd DD MMMM') : this.state.startDate.format('dddd DD MMMM YYYY') + ', a ' + this.state.endDate.format('dddd DD MMMM YYYY');
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-default',
	                        style: { width: "100%" },
	                        type: 'button',
	                        onClick: this.toggleSelector
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pull-left' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-calendar' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            textoFecha
	                        ),
	                        _react2.default.createElement('span', { className: 'caret' })
	                    )
	                ),
	                _react2.default.createElement(_reactDateRange.DateRange, {
	                    style: { display: this.state.visible ? 'block' : 'none' },
	                    theme: {
	                        DateRange: {
	                            position: 'absolute',
	                            width: '280px',
	                            zIndex: '99999999999999999'
	                        }
	                    },
	                    startDate: this.state.startDate,
	                    endDate: this.state.endDate,
	                    onChange: this.onChangeDate,
	                    calendars: 1
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            width: '280px',
	                            position: 'absolute',
	                            top: '355px',
	                            zIndex: '500'
	                        } },
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button',
	                            className: 'btn btn-default',
	                            style: {
	                                width: "50%",
	                                display: this.state.visible ? 'inline-block' : 'none'
	                            },
	                            onClick: this.onCancel
	                        },
	                        'Cancelar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary', type: 'button',
	                            style: {
	                                width: "50%",
	                                display: this.state.visible ? 'inline-block' : 'none'
	                            },
	                            onClick: this.onAccept
	                        },
	                        'Aceptar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectRange;
	}(_react2.default.Component);
	
	SelectRange.propTypes = {
	    // Objtos
	    startDateSelected: _react2.default.PropTypes.object.isRequired,
	    endDateSelected: _react2.default.PropTypes.object.isRequired,
	    // Funciones
	    onRangeSelected: _react2.default.PropTypes.func.isRequired
	    // SelectRange.defaultProps = {}
	
	};exports.default = SelectRange;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectRange.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _BlackBoxMensualAI = __webpack_require__(733);
	
	var _BlackBoxMensualAI2 = _interopRequireDefault(_BlackBoxMensualAI);
	
	var _FormularioAgregarAuditoria = __webpack_require__(734);
	
	var _RowAuditoriaMensual = __webpack_require__(736);
	
	var _RowAuditoriaMensual2 = _interopRequireDefault(_RowAuditoriaMensual);
	
	var _TablaMensualAI = __webpack_require__(738);
	
	var _TablaMensualAI2 = _interopRequireDefault(_TablaMensualAI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	
	_moment2.default.locale('es');
	
	// Component
	
	var ProgramacionAIMensual = function (_React$Component) {
	    _inherits(ProgramacionAIMensual, _React$Component);
	
	    function ProgramacionAIMensual(props) {
	        _classCallCheck(this, ProgramacionAIMensual);
	
	        var _this = _possibleConstructorReturn(this, (ProgramacionAIMensual.__proto__ || Object.getPrototypeOf(ProgramacionAIMensual)).call(this, props));
	
	        _this.blackbox = new _BlackBoxMensualAI2.default(_this.props.clientes);
	
	        // mostrar en el selector, los proximos 12 meses
	        var meses = [];
	        for (var desface = 0; desface < 12; desface++) {
	            var mes = (0, _moment2.default)().add(desface, 'month');
	            meses.push({
	                valor: mes.format('YYYY-MM-00'),
	                texto: mes.format('MMMM  YYYY')
	            });
	        }
	        _this.state = {
	            auditoriasFiltradas: [],
	            filtros: {},
	            meses: meses
	
	            // referencia a todos las entradas de fecha de los inventarios
	        };_this.rows = [];
	        return _this;
	    }
	
	    _createClass(ProgramacionAIMensual, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
	            this.rows = this.rows.filter(function (input) {
	                return input !== null;
	            });
	        }
	    }, {
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length - 1;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(nombreElemento);
	            } else if (index > ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero
	                this.rows[index % this.rows.length].focusElemento(nombreElemento);
	            } else {
	                // no es ni el ultimo, ni el primero
	                this.rows[index].focusElemento(nombreElemento);
	            }
	        }
	    }, {
	        key: 'crearGrupoInventarios',
	        value: function crearGrupoInventarios(nuevasAuditorias) {
	            var _this2 = this;
	
	            var promesasFetch = [];
	            nuevasAuditorias.forEach(function (nuevaAuditoria) {
	                // crear todos los locales (y sus nominas)
	                promesasFetch.push(_v2.default.auditoria.nuevo({
	                    idLocal: nuevaAuditoria.local_idLocal,
	                    fechaProgramada: nuevaAuditoria.aud_fechaProgramada || _this2.refFormularioAgregar.getOpcionesSeleccionadas().mes,
	                    idAuditor: nuevaAuditoria.aud_idAuditor
	                }).then(function (auditoriaCreada) {
	                    _this2.blackbox.actualizarDatosAuditoria(nuevaAuditoria.idDummy, auditoriaCreada);
	                    // actualizar los datos y el state de la app
	                    // actualizar los filtros, y la lista ordenada de locales
	                    // this.setState(this.blackbox.getListaFiltradaSinOrdenar())
	                    _this2.setState(_this2.blackbox.getListaFiltrada());
	                }));
	            });
	            // en algun momento las promesas se van a cumplior, entonces actualizar el estado
	            Promise.all(promesasFetch).then(function (locales) {
	                console.log('fetch de todos los locales correcto');
	                // actualizar los filtros, y la lista ordenada de locales
	                _this2.setState(_this2.blackbox.getListaFiltrada());
	            }).catch(function (datos) {
	                // Todo: agregar bluebird para que esto no ocurra nunca
	                // todo, al fallar UNA promesa, no se cumple el resto
	                alert('error al buscar la información de los locales, (AgregarGrupoInventarios desde Excel: fetch de todos los locales correcto)');
	                // actualizar los filtros, y la lista ordenada de locales
	                _this2.setState(_this2.blackbox.getListaFiltrada());
	            });
	        }
	    }, {
	        key: 'agregarAuditoria',
	        value: function agregarAuditoria(idCliente, numeroLocal, annoMesDia) {
	            var _this3 = this;
	
	            var _blackbox$crearDummy = this.blackbox.crearDummy(idCliente, numeroLocal, annoMesDia),
	                _blackbox$crearDummy2 = _slicedToArray(_blackbox$crearDummy, 2),
	                errores = _blackbox$crearDummy2[0],
	                auditoriaDummy = _blackbox$crearDummy2[1];
	
	            if (errores) return [errores, {}];
	
	            // agregar al listado
	            this.blackbox.addNuevo(auditoriaDummy);
	
	            // actualizar la vista de la lista
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	
	            // cuando se agregar un inventario, se crea automaticamente (junto a su nomina)
	            _v2.default.auditoria.nuevo({
	                idLocal: auditoriaDummy.local_idLocal,
	                fechaProgramada: this.refFormularioAgregar.getOpcionesSeleccionadas().mes
	            }).then(function (auditoriaCreada) {
	                _this3.blackbox.actualizarDatosAuditoria(auditoriaDummy.idDummy, auditoriaCreada);
	                // actualizar los datos y el state de la app
	                // actualizar los filtros, y la lista ordenada de locales
	                // this.setState(this.blackbox.getListaFiltradaSinOrdenar())
	                _this3.setState(_this3.blackbox.getListaFiltrada());
	            });
	            return [null, {}];
	        }
	
	        // Lista de inventarios que son "pegados desde excel"
	
	    }, {
	        key: 'agregarGrupoInventarios',
	        value: function agregarGrupoInventarios(datosAuditorias) {
	            var _this4 = this;
	
	            var pegadoConProblemas = [];
	            // se evalua y agrega cada uno de los elementos
	            var nuevosInventarios = [];
	            datosAuditorias.forEach(function (datos) {
	                var _blackbox$crearDummy3 = _this4.blackbox.crearDummy(datos.idCliente, datos.ceco, datos.fecha, datos.idAuditor),
	                    _blackbox$crearDummy4 = _slicedToArray(_blackbox$crearDummy3, 2),
	                    errores = _blackbox$crearDummy4[0],
	                    nuevoInventario = _blackbox$crearDummy4[1];
	
	                if (errores) {
	                    pegadoConProblemas.push(errores);
	                } else {
	                    // this.blackbox.addNuevo(nuevoInventario)
	                    nuevosInventarios.push(nuevoInventario);
	                }
	            });
	            // agregar el grupo completo de una vez (para hacer un poco mas rapido el proceso)
	            this.blackbox.addNuevos(nuevosInventarios);
	
	            // cuando terminen todos, se actualiza el state de la aplicacion
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	            this.crearGrupoInventarios(nuevosInventarios);
	
	            return {
	                pegadoConProblemas: pegadoConProblemas,
	                conteoTotal: datosAuditorias.length,
	                conteoCorrectos: datosAuditorias.length - pegadoConProblemas.length,
	                conteoProblemas: pegadoConProblemas.length
	            };
	        }
	
	        // Llamadas al API
	
	    }, {
	        key: 'buscarAuditorias',
	        value: function buscarAuditorias(annoMesDia, idCliente) {
	            var _this5 = this;
	
	            // obtener todos los inventarios realizados en el mes seleccionado
	            _v2.default.auditoria.getPorMesYCliente(annoMesDia, idCliente).then(function (auditorias) {
	                _this5.blackbox.reset();
	                auditorias.forEach(function (auditoria) {
	                    // crear un dummy
	                    var auditoriaDummy = _this5.blackbox.__crearDummy(annoMesDia, auditoria.local_idLocal);
	                    _this5.blackbox.addFinal(auditoriaDummy);
	
	                    // actualizar los datos del auditoria
	                    _this5.blackbox.actualizarDatosAuditoria(auditoriaDummy.idDummy, auditoria);
	                });
	                // actualizar los filtros, y la lista ordenada de locales
	                _this5.blackbox.ordenarLista();
	                _this5.setState(_this5.blackbox.getListaFiltrada());
	            });
	            //.catch(err=>console.error('error: ', err))
	        }
	    }, {
	        key: 'actualizarAuditoria',
	        value: function actualizarAuditoria(idAuditoria, formAuditoria, idDummy) {
	            var _this6 = this;
	
	            // Actualizar los datos del inventario
	            _v2.default.auditoria.actualizar(idAuditoria, formAuditoria).then(function (auditoriaActualizada) {
	                console.log('inventario actualizado correctamente');
	                // actualizar los datos y el state de la app
	                _this6.blackbox.actualizarDatosAuditoria(idDummy, auditoriaActualizada);
	                // actualizar los filtros, y la lista ordenada de locales
	                _this6.setState(_this6.blackbox.getListaFiltrada());
	            });
	        }
	    }, {
	        key: 'quitarAuditoria',
	        value: function quitarAuditoria(idDummy) {
	            this.blackbox.remove(idDummy);
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'eliminarAuditoria',
	        value: function eliminarAuditoria(auditoria) {
	            var _this7 = this;
	
	            console.log('eliminando ', auditoria);
	            _v2.default.auditoria.eliminar(auditoria.aud_idAuditoria).then(function (resp) {
	                _this7.blackbox.remove(auditoria.idDummy);
	                // actualizar los filtros, y la lista ordenada de locales
	                _this7.setState(_this7.blackbox.getListaFiltrada());
	            }).catch(function (resp) {
	                return console.error;
	            });
	        }
	
	        // Filtros
	
	    }, {
	        key: 'actualizarFiltro',
	        value: function actualizarFiltro(nombreFiltro, filtro) {
	            this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            // actualizar los filtros, y la lista ordenada de locales
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'ordenarAuditorias',
	        value: function ordenarAuditorias(evt) {
	            evt.preventDefault();
	            this.blackbox.ordenarLista();
	            this.setState(this.blackbox.getListaFiltrada());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            // refFormularioAgregar no esta definido antes del render
	            var opcionesSeleccionadas = this.refFormularioAgregar ? this.refFormularioAgregar.getOpcionesSeleccionadas() : {};
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Programaci\xF3n mensual AI'
	                ),
	                _react2.default.createElement(_FormularioAgregarAuditoria.FormularioAgregarAuditoria, {
	                    ref: function ref(_ref) {
	                        return _this8.refFormularioAgregar = _ref;
	                    },
	                    clientes: this.props.clientes,
	                    meses: this.state.meses,
	                    agregarAuditoria: this.agregarAuditoria.bind(this),
	                    agregarGrupoInventarios: this.agregarGrupoInventarios.bind(this),
	                    buscarAuditorias: this.buscarAuditorias.bind(this),
	                    puedeAgregar: this.props.puedeAgregar
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs pull-right',
	                            href: '/auditorias/descargar-excel-por-mes?mes=' + opcionesSeleccionadas.mes + '&idCliente=' + opcionesSeleccionadas.idCliente
	                        },
	                        'Exportar a Excel'
	                    ),
	                    _react2.default.createElement(
	                        _TablaMensualAI2.default,
	                        {
	                            filtros: this.state.filtros,
	                            actualizarFiltro: this.actualizarFiltro.bind(this),
	                            ordenarAuditorias: this.ordenarAuditorias.bind(this) },
	                        this.state.auditoriasFiltradas.length === 0 ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '13', style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'No hay auditorias para mostrar en este periodo.'
	                                )
	                            )
	                        ) : this.state.auditoriasFiltradas.map(function (auditoria, index) {
	                            var mostrarSeparador = false;
	                            var sgteAuditoria = _this8.state.auditoriasFiltradas[index + 1];
	                            if (sgteAuditoria) mostrarSeparador = auditoria.aud_fechaProgramada !== sgteAuditoria.aud_fechaProgramada;
	                            return _react2.default.createElement(_RowAuditoriaMensual2.default
	                            // Propiedades
	                            , { puedeModificar: _this8.props.puedeModificar,
	                                key: auditoria.aud_idAuditoria,
	                                index: index,
	                                ref: function ref(_ref2) {
	                                    return _this8.rows[index] = _ref2;
	                                },
	                                mostrarSeparador: mostrarSeparador,
	                                auditoria: auditoria,
	                                auditores: _this8.props.auditores
	                                // Metodos
	                                , actualizarAuditoria: _this8.actualizarAuditoria.bind(_this8),
	                                quitarAuditoria: _this8.quitarAuditoria.bind(_this8),
	                                eliminarAuditoria: _this8.eliminarAuditoria.bind(_this8),
	                                focusRow: _this8.focusRow.bind(_this8)
	                                //guardarOCrear={this.guardarOCrear.bind(this)}
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProgramacionAIMensual;
	}(_react2.default.Component);
	
	ProgramacionAIMensual.propTypes = {
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    puedeAgregar: _react2.default.PropTypes.bool.isRequired,
	    clientes: _react2.default.PropTypes.array.isRequired,
	    auditores: _react2.default.PropTypes.array.isRequired
	};
	
	exports.default = ProgramacionAIMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ProgramacionAIMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBox = function () {
	    function BlackBox(clientes) {
	        _classCallCheck(this, BlackBox);
	
	        this.clientes = clientes;
	        this.lista = [];
	        this.filtroFechas = [];
	        this.filtroClientes = [];
	        this.filtroCeco = [];
	        this.filtroRegiones = [];
	        this.filtroComunas = [];
	        this.filtroAuditores = [];
	        this.idDummy = 1; // valor unico, sirve para identificar un dummy cuando un idAuditoria no ha sido fijado
	    }
	    // Todo Modificar
	
	
	    _createClass(BlackBox, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroFechas = [];
	            this.filtroClientes = [];
	            this.filtroCeco = [];
	            this.filtroRegiones = [];
	            this.filtroComunas = [];
	            this.filtroAuditores = [];
	            this.idDummy = 1;
	        }
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'addNuevo',
	        value: function addNuevo(auditoria) {
	            // al agregar un elemento unico, se debe ubicar: DESPUES de los inventarios sin fecha, y ANTES que los inventarios con fecha
	            // buscar el indice del primer inventario con fecha
	            var indexConFecha = this.lista.findIndex(function (auditoria) {
	                var dia = auditoria.aud_fechaProgramada.split('-')[2];
	                return dia !== '00';
	            });
	            if (indexConFecha >= 0) {
	                // se encontro el indice
	                this.lista.splice(indexConFecha, 0, auditoria);
	            } else {
	                // no hay ninguno con fecha, agregar al final
	                this.lista.push(auditoria);
	            }
	        }
	        // igual que el anterior, pero con un arreglo
	
	    }, {
	        key: 'addNuevos',
	        value: function addNuevos(auditorias) {
	            // al agregar un elemento unico, se debe ubicar: DESPUES de los auditorias sin fecha, y ANTES que los auditorias con fecha
	            // buscar el indice del primer inventario con fecha
	            var indexConFecha = this.lista.findIndex(function (aud) {
	                var dia = aud.aud_fechaProgramada.split('-')[2];
	                return dia !== '00';
	            });
	            if (indexConFecha >= 0) {
	                var _lista;
	
	                // se encontro el indice
	                (_lista = this.lista).splice.apply(_lista, [indexConFecha, 0].concat(_toConsumableArray(auditorias)));
	            } else {
	                // no hay ninguno con fecha, agregar al final
	                this.lista = this.lista.concat(auditorias);
	            }
	        }
	    }, {
	        key: 'addInicio',
	        value: function addInicio(auditoria) {
	            // unshift agrega un elemento al inicio del array
	            this.lista.unshift(auditoria);
	        }
	    }, {
	        key: 'addFinal',
	        value: function addFinal(auditoria) {
	            this.lista.push(auditoria);
	        }
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'remove',
	        value: function remove(idDummy) {
	            var index = this.lista.findIndex(function (auditoria) {
	                return auditoria.idDummy === idDummy;
	            });
	            if (index >= 0) this.lista.splice(index, 1);
	        }
	    }, {
	        key: 'yaExiste',
	        value: function yaExiste(idLocal, annoMesDia) {
	            var auditoriaDelLocal = this.lista.filter(function (auditoria) {
	                return auditoria.local_idLocal === idLocal;
	            });
	            // buscar si se tiene inventarios para este local
	            if (auditoriaDelLocal.length === 0) {
	                return false;
	            }
	            // buscar si alguna fecha coincide
	            var existe = false;
	            auditoriaDelLocal.forEach(function (auditoria) {
	                if (auditoria.aud_idAuditoria === annoMesDia) {
	                    // se tiene el mismo local, con la misma fecha inventariado
	                    console.log('ya programado');
	                    existe = true;
	                    return true;
	                }
	            });
	            return existe;
	        }
	        // Metodos de alto nivel
	
	    }, {
	        key: '__crearDummy',
	        value: function __crearDummy(annoMesDia, idLocal, auditor) {
	            return {
	                idDummy: this.idDummy++, // asignar e incrementar
	                aud_idAuditoria: null,
	                aud_fechaProgramada: annoMesDia,
	                aud_fechaProgramadaFbreve: '',
	                aud_fechaProgramadaDOW: '',
	                aud_idAuditor: auditor,
	                local_idLocal: idLocal,
	                local_ceco: '-',
	                local_direccion: '',
	                local_comuna: '',
	                local_region: '',
	                local_nombre: '-',
	                local_stock: '',
	                local_horaApertura: '',
	                local_horaCierre: '',
	                local_fechaStock: '',
	                cliente_nombreCorto: ''
	            };
	        }
	    }, {
	        key: 'crearDummy',
	        value: function crearDummy(idCliente, numeroLocal, annoMesDia, auditor) {
	            // ########### Revisar Cliente ###########
	            // el usuario no selecciono uno en el formulario
	            if (idCliente === '-1' || idCliente === '' || !idCliente) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorIdCliente: 'Seleccione un Cliente'
	                }, null];
	            }
	            // dio un idCliente, pero no existe
	            var cliente = this.clientes.find(function (cliente) {
	                return cliente.idCliente == idCliente;
	            });
	            if (!cliente) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorIdCliente: 'Cliente no Existe'
	                }, null];
	            }
	
	            // ########### Revisar Local ###########
	            // revisar que el local exista
	            var local = cliente.locales.find(function (local) {
	                return local.numero == numeroLocal;
	            });
	            if (local === undefined) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorNumeroLocal: numeroLocal === '' ? 'Digite un numero de local.' : 'El local \'' + numeroLocal + '\' no existe.'
	                }, null];
	            }
	
	            // revisar que no exista en la lista
	            if (this.yaExiste(local.idLocal, annoMesDia)) {
	                return [{
	                    idCliente: idCliente,
	                    numeroLocal: numeroLocal,
	                    errorNumeroLocal: numeroLocal + ' ya ha sido agendado esa fecha.'
	                }, null];
	            }
	
	            // ########### ok, se puede crear el inventario "vacio" ###########
	            var dummy = this.__crearDummy(annoMesDia, local.idLocal, auditor);
	            return [null, dummy];
	        }
	
	        // Todo modificar el listado de clientes
	
	    }, {
	        key: 'actualizarDatosAuditoria',
	        value: function actualizarDatosAuditoria(idDummy, auditoriaActualizada) {
	            this.lista = this.lista.map(function (auditoria) {
	                if (auditoria.idDummy == idDummy) {
	                    auditoria = Object.assign(auditoria, auditoriaActualizada);
	                }
	                return auditoria;
	            });
	        }
	
	        /*** ################### FILTROS ################### ***/
	
	    }, {
	        key: 'ordenarLista',
	        value: function ordenarLista() {
	            var porFechaProgramada = function porFechaProgramada(auditoria) {
	                var dateA = new Date(auditoria.aud_fechaProgramada);
	                if (dateA == 'Invalid Date') {
	                    var _auditoria$aud_fechaP = auditoria.aud_fechaProgramada.split('-'),
	                        _auditoria$aud_fechaP2 = _slicedToArray(_auditoria$aud_fechaP, 3),
	                        annoA = _auditoria$aud_fechaP2[0],
	                        mesA = _auditoria$aud_fechaP2[1],
	                        diaA = _auditoria$aud_fechaP2[2];
	                    // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
	
	
	                    return new Date(annoA + '-' + mesA) - 1;
	                } else {
	                    return dateA;
	                }
	            };
	            var porAuditor = function porAuditor(auditoria) {
	                return auditoria.aud_auditor;
	            };
	            var porComuna = function porComuna(auditoria) {
	                return auditoria.local_cutComuna;
	            };
	
	            // ordenar por fechaprogramada, por auditor, y finalmente por comuna
	            this.lista = _lodash2.default.sortBy(this.lista, porFechaProgramada, porAuditor, porComuna);
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            // ##### Filtro fechas
	            this.filtroFechas = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_fechaProgramada;
	                var texto = auditoria.aud_fechaProgramadaFbreve;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFechas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro CECO (ordenado por numero)
	            this.filtroCeco = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.local_ceco;
	                var texto = '' + auditoria.local_ceco;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCeco, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).sortBy(function (ob) {
	                return ob.valor.length;
	            }, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
	            .value();
	
	            // ##### Filtro Clientes (ordenado por codRegion)
	            this.filtroClientes = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.cliente_idCliente;
	                var texto = auditoria.cliente_nombreCorto;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroClientes, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Regiones (ordenado por codRegion)
	            this.filtroRegiones = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.local_cutRegion;
	                var texto = auditoria.local_region;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroRegiones, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de region
	            .value();
	
	            // ##### Filtro Comunas (ordenado por codComuna)
	            this.filtroComunas = _lodash2.default.chain(this.lista)
	            // solo dejar las comunas en las que su respectiva region este seleccionada
	            .filter(function (auditoria) {
	                return _lodash2.default.find(_this.filtroRegiones, { 'valor': auditoria.local_cutRegion, 'seleccionado': true });
	            }).map(function (auditoria) {
	                var valor = auditoria.local_cutComuna;
	                var texto = auditoria.local_comuna;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroComunas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Auditores
	            this.filtroAuditores = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_idAuditor;
	                var texto = auditoria.aud_auditor;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroAuditores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	
	            return {
	                auditoriasFiltradas: _lodash2.default.chain(this.lista)
	                // Filtrar por Cliente
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroClientes, { 'valor': auditoria.cliente_idCliente, 'seleccionado': true });
	                })
	                // Filtrar por Ceco
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroCeco, { 'valor': '' + auditoria.local_ceco, 'seleccionado': true });
	                })
	                // Filtrar por Region
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroRegiones, { 'valor': auditoria.local_cutRegion, 'seleccionado': true });
	                })
	                // Filtrar por Comuna
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroComunas, { 'valor': auditoria.local_cutComuna, 'seleccionado': true });
	                })
	                // Filtrar por Auditor
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroAuditores, { 'valor': auditoria.aud_idAuditor, 'seleccionado': true });
	                })
	                // Filtrar por Fecha (dejar de lo ultimo, ya que es la mas lenta -comparacion de strings-)
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroFechas, { 'valor': auditoria.aud_fechaProgramada, 'seleccionado': true });
	                }).value(),
	                filtros: {
	                    filtroFechas: this.filtroFechas,
	                    filtroClientes: this.filtroClientes,
	                    filtroCeco: this.filtroCeco,
	                    filtroRegiones: this.filtroRegiones,
	                    filtroComunas: this.filtroComunas,
	                    filtroAuditores: this.filtroAuditores
	                }
	            };
	        }
	    }]);
	
	    return BlackBox;
	}();
	
	exports.default = BlackBox;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxMensualAI.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormularioAgregarAuditoria = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormularioAgregarAuditoria = __webpack_require__(735);
	
	var style = _interopRequireWildcard(_FormularioAgregarAuditoria);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	// Styles
	
	
	var FormularioAgregarAuditoria = exports.FormularioAgregarAuditoria = function (_React$Component) {
	    _inherits(FormularioAgregarAuditoria, _React$Component);
	
	    function FormularioAgregarAuditoria(props) {
	        _classCallCheck(this, FormularioAgregarAuditoria);
	
	        var _this = _possibleConstructorReturn(this, (FormularioAgregarAuditoria.__proto__ || Object.getPrototypeOf(FormularioAgregarAuditoria)).call(this, props));
	
	        _this.state = {
	            idClienteSeleccionado: 0,
	            mesSeleccionado: _this.props.meses[0].valor,
	            locales: [],
	            errores: {
	                errorIdCliente: '',
	                errorNumeroLocal: ''
	            },
	            pegados: {
	                pegadoConProblemas: [],
	                conteoTotal: 0,
	                conteoCorrectos: 0,
	                conteoProblemas: 0
	            },
	            inputPegar_error: '',
	            modoIngreso: 'manual' // 'manual'/'excel'
	        };
	        return _this;
	    }
	
	    _createClass(FormularioAgregarAuditoria, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.buscarAuditorias(this.state.mesSeleccionado, this.state.idClienteSeleccionado);
	        }
	
	        /**
	         * Cambio en los campos del formulario
	         */
	
	    }, {
	        key: 'setModoIngreso',
	        value: function setModoIngreso(modo) {
	            if (modo !== this.state.modoIngreso) {
	                this.setState({ modoIngreso: this.state.modoIngreso === 'manual' ? 'excel' : 'manual' });
	            }
	        }
	    }, {
	        key: 'selectMesChanged',
	        value: function selectMesChanged(evt) {
	            var annoMesDia = evt.target.value;
	            this.props.buscarAuditorias(annoMesDia, this.state.idClienteSeleccionado);
	            this.setState({
	                mesSeleccionado: annoMesDia
	            });
	        }
	    }, {
	        key: 'selectClienteChanged',
	        value: function selectClienteChanged(event) {
	            // al seleccionar un cliente, se deben cargar los locales el el <select> de clientes
	            var idClienteSeleccionado = event.target.value;
	
	            // descargar las auditorias del cliente
	            this.props.buscarAuditorias(this.state.mesSeleccionado, idClienteSeleccionado);
	
	            // buscamos el cliente seleccionado
	            var cliente = this.props.clientes.find(function (cliente) {
	                return cliente.idCliente == idClienteSeleccionado;
	            });
	
	            // lo marcados como seleccionado y mostramos la lista de locales
	            this.setState({
	                idClienteSeleccionado: idClienteSeleccionado,
	                locales: cliente ? cliente.locales : [], // mostrar la lista de locales que tiene el cliente seleccionado
	                errores: {}
	            });
	        }
	    }, {
	        key: 'inputNumeroLocalChanged',
	        value: function inputNumeroLocalChanged(evt) {
	            this.setState({
	                errores: { errorNumeroLocal: '' }
	            });
	        }
	    }, {
	        key: 'getOpcionesSeleccionadas',
	        value: function getOpcionesSeleccionadas() {
	            return {
	                idCliente: this.state.idClienteSeleccionado,
	                mes: this.state.mesSeleccionado
	            };
	        }
	
	        /**
	         * Agregar Locales
	         */
	
	    }, {
	        key: 'agregarLocalManualmente',
	        value: function agregarLocalManualmente(evt) {
	            evt.preventDefault();
	            if (!this.props.puedeAgregar) return alert("no tiene los permisos necesarios para agregar una auditoria");
	
	            var idCliente = this.inputIdCliente.value;
	            var numeroLocal = this.inputNumeroLocal.value;
	            var annoMesDia = this.inputAnnoMesDia.value;
	
	            this.inputNumeroLocal.value = '';
	
	            var _props$agregarAuditor = this.props.agregarAuditoria(idCliente, numeroLocal, annoMesDia),
	                _props$agregarAuditor2 = _slicedToArray(_props$agregarAuditor, 2),
	                errores = _props$agregarAuditor2[0],
	                objeto = _props$agregarAuditor2[1];
	
	            this.setState({
	                errores: errores || {}
	            });
	        }
	    }, {
	        key: 'agregarLocalesAlPegar',
	        value: function agregarLocalesAlPegar(event) {
	            var _this2 = this;
	
	            event.preventDefault();
	            if (!this.props.puedeAgregar) return alert("no tiene los permisos necesarios para agregar una auditoria");
	
	            // validar que exista un cliente seleccionado
	            var idCliente = this.inputIdCliente.value;
	            if (idCliente === '-1') {
	                this.setState({
	                    pegados: {
	                        conteoTotal: 0,
	                        conteoCorrectos: 0,
	                        conteoProblemas: 0,
	                        pegadoConProblemas: []
	                    },
	                    errores: {
	                        errorIdCliente: 'Seleccione un Cliente'
	                    },
	                    inputPegar_error: 'Seleccione un Cliente'
	                });
	                return;
	            }
	
	            // cuando se pegue un elemento, separar separar las filas por el "line feed" '\n'
	            event.clipboardData.items[0].getAsString(function (texto) {
	                // separar cada una de las filas '\n'
	                var rows = texto.trim().split('\n');
	                // quitar las filas vacias, y separar sus valores por el caracter tabulador
	                rows = rows.filter(function (row) {
	                    return row !== '';
	                });
	                var datosAuditorias = rows.map(function (row) {
	                    var datos = row.trim().split('\t');
	                    return {
	                        idCliente: idCliente,
	                        fecha: datos[0],
	                        ceco: datos[1],
	                        idAuditor: datos[2]
	                    };
	                });
	
	                var resultadoPegar = _this2.props.agregarGrupoInventarios(datosAuditorias);
	                // guardar el resultado de agregar los elementos
	                _this2.setState({
	                    pegados: resultadoPegar
	                });
	                console.log('FormularioAgregarAuditoria.... resultado:', resultadoPegar);
	            });
	        }
	    }, {
	        key: 'limpiarProblemas',
	        value: function limpiarProblemas() {
	            this.setState({
	                pegados: {
	                    conteoTotal: 0,
	                    conteoCorrectos: 0,
	                    conteoProblemas: 0,
	                    pegadoConProblemas: []
	                },
	                inputPegar_error: ''
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { marginBottom: '1em' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-offset-4 col-sm-3' },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-sm btn-default ' + (this.state.modoIngreso === 'manual' ? 'active' : ''), onClick: this.setModoIngreso.bind(this, 'manual') },
	                            'Manualmente'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-sm btn-default ' + (this.state.modoIngreso === 'excel' ? 'active' : ''), onClick: this.setModoIngreso.bind(this, 'excel') },
	                            'Desde Excel'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' + (this.state.errores.errorIdCliente ? 'has-error' : '') },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'cliente' },
	                            'Cliente'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'cliente',
	                                ref: function ref(_ref) {
	                                    return _this3.inputIdCliente = _ref;
	                                },
	                                value: this.state.idClienteSeleccionado,
	                                onChange: this.selectClienteChanged.bind(this) },
	                            _react2.default.createElement(
	                                'option',
	                                { value: '0' },
	                                'Todos'
	                            ),
	                            this.props.clientes.map(function (cliente, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: cliente.idCliente },
	                                    cliente.nombreCorto + ' - ' + cliente.nombre
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'help-block', style: { position: 'absolute' } },
	                            this.state.errores.errorIdCliente
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'fechaProgramada' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'fechaProgramada',
	                                ref: function ref(_ref2) {
	                                    return _this3.inputAnnoMesDia = _ref2;
	                                },
	                                value: this.state.mesSeleccionado,
	                                onChange: this.selectMesChanged.bind(this) },
	                            this.props.meses.map(function (mes, i) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: i, value: mes.valor },
	                                    mes.texto
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form', onSubmit: this.agregarLocalManualmente.bind(this), style: { display: this.state.modoIngreso === 'manual' ? '' : 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 form-group ' + (this.state.errores.errorNumeroLocal ? 'has-error' : '') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'locales' },
	                                'Local'
	                            ),
	                            _react2.default.createElement('input', { className: 'form-control', name: 'locales',
	                                ref: function ref(_ref3) {
	                                    return _this3.inputNumeroLocal = _ref3;
	                                },
	                                onChange: this.inputNumeroLocalChanged.bind(this),
	                                disabled: this.props.puedeAgregar ? '' : 'disabled' }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'help-block', style: { position: 'absolute' } },
	                                this.state.errores.errorNumeroLocal
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-2 form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label' },
	                                '\xA0'
	                            ),
	                            _react2.default.createElement('input', { type: 'submit', className: 'form-control btn btn-primary', value: 'Agregar local',
	                                disabled: this.props.puedeAgregar ? '' : 'disabled' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: this.state.modoIngreso === 'excel' ? '' : 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 form-group ' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'locales' },
	                                'Locales'
	                            ),
	                            _react2.default.createElement('input', { className: 'form-control', type: 'text', name: 'locales', placeholder: 'pegar aca los datos de Excel',
	                                onPaste: this.agregarLocalesAlPegar.bind(this),
	                                disabled: this.props.puedeAgregar ? '' : 'disabled' }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { marginTop: '1em' } },
	                                'Abra Excel, seleccione los datos de las columnas ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Fecha'
	                                ),
	                                ' y ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'CECO'
	                                ),
	                                ', ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'COPIE'
	                                ),
	                                ' el contendo y ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'PEGUELO'
	                                ),
	                                ' en la cuandro de texto. La fecha debe tener el formato ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'AAAA-MM-DD'
	                                ),
	                                '.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-5 form-group ' + (this.state.pegados.conteoTotal == 0 ? 'hide' : '') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'locales' },
	                                    'Resultado'
	                                ),
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-bordered table-condensed' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'Correctos'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                this.state.pegados.conteoCorrectos
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'Con Problemas'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                this.state.pegados.conteoProblemas
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'TOTAL'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    this.state.pegados.conteoTotal
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: "col-sm-7 " },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'locales' },
	                                    'Detalle'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-xs btn-primary pull-right', tabIndex: '-1', onClick: this.limpiarProblemas.bind(this) },
	                                    'Aceptar/Ocultar'
	                                ),
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-bordered table-condensed' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'CECO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Estado'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        this.state.pegados.pegadoConProblemas.length === 0 ? _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { colSpan: '2' },
	                                                'Sin problemas detectados'
	                                            )
	                                        ) : this.state.pegados.pegadoConProblemas.map(function (error, index) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: index },
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: style.tableCell },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        error.numeroLocal
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: style.tableCell },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'small',
	                                                            null,
	                                                            error.errorIdCliente || error.errorNumeroLocal
	                                                        )
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormularioAgregarAuditoria;
	}(_react2.default.Component);
	
	FormularioAgregarAuditoria.propTypes = {
	    puedeAgregar: _react2.default.PropTypes.bool.isRequired,
	    clientes: _react2.default.PropTypes.array.isRequired,
	    meses: _react2.default.PropTypes.array.isRequired,
	    // Metodos
	    agregarAuditoria: _react2.default.PropTypes.func.isRequired,
	    agregarGrupoInventarios: _react2.default.PropTypes.func.isRequired,
	    buscarAuditorias: _react2.default.PropTypes.func.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FormularioAgregarAuditoria.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableCell":"FormularioAgregarAuditoria__tableCell___2I6eY"};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputFecha = __webpack_require__(633);
	
	var _InputFecha2 = _interopRequireDefault(_InputFecha);
	
	var _Select = __webpack_require__(647);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _TablaMensualAI = __webpack_require__(737);
	
	var css = _interopRequireWildcard(_TablaMensualAI);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var RowAuditoriaMensual = function (_React$Component) {
	    _inherits(RowAuditoriaMensual, _React$Component);
	
	    function RowAuditoriaMensual() {
	        _classCallCheck(this, RowAuditoriaMensual);
	
	        return _possibleConstructorReturn(this, (RowAuditoriaMensual.__proto__ || Object.getPrototypeOf(RowAuditoriaMensual)).apply(this, arguments));
	    }
	
	    _createClass(RowAuditoriaMensual, [{
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            if (elemento === 'dia') {
	                this.inputFecha.focus();
	            } else {
	                console.error('focusElemento(): Elemento "' + elemento + '" no encontrado');
	            }
	        }
	    }, {
	        key: 'guardarAuditoria',
	        value: function guardarAuditoria() {
	            if (!this.props.puedeModificar) return alert('no tiene permisos para realizar esta acción');
	
	            var cambiosAuditoria = {};
	
	            // la FECHA es valida, y ha cambiado?
	            var estadoInputFecha = this.inputFecha.getEstado();
	            if (estadoInputFecha.valid && estadoInputFecha.dirty) {
	                cambiosAuditoria.fechaProgramada = estadoInputFecha.fecha;
	            } else if (estadoInputFecha.valid === false) {
	                return console.log('fecha ' + estadoInputFecha.fecha + ' invalida');
	            }
	
	            // el AUDITOR ha cambiado?
	            var estadoSelectAuditor = this.selectAuditor.getEstado();
	            if (estadoSelectAuditor.dirty) cambiosAuditoria.idAuditor = estadoSelectAuditor.seleccionUsuario;
	
	            // almenos uno de los ementos debe estar "dirty" para guardar los cambios
	            if (JSON.stringify(cambiosAuditoria) !== '{}') {
	                console.log('cambiosAuditoria ', cambiosAuditoria);
	                this.props.actualizarAuditoria(this.props.auditoria.aud_idAuditoria, cambiosAuditoria, this.props.auditoria.idDummy);
	            } else {
	                console.log('auditoria sin cambios, no se actualiza');
	            }
	        }
	    }, {
	        key: 'quitarAuditoria',
	        value: function quitarAuditoria() {
	            this.props.quitarAuditoria(this.props.auditoria.idDummy);
	        }
	    }, {
	        key: 'eliminarAuditoria',
	        value: function eliminarAuditoria() {
	            if (!this.props.puedeModificar) return alert('no tiene permisos para realizar esta acción');
	            this.props.eliminarAuditoria(this.props.auditoria);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var auditores = this.props.auditores.map(function (usuario) {
	                return { valor: usuario.id, texto: usuario.nombre1 + ' ' + usuario.apellidoPaterno };
	            });
	
	            return _react2.default.createElement(
	                'tr',
	                { className: this.props.mostrarSeparador ? css.trSeparador : '' },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCorrelativo },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    _react2.default.createElement(_InputFecha2.default, {
	                        puedeModificar: this.props.puedeModificar,
	                        ref: function ref(_ref) {
	                            return _this2.inputFecha = _ref;
	                        },
	                        diaSemana: this.props.auditoria.aud_fechaProgramadaDOW,
	                        fechaConProblemas: this.props.auditoria.local_topeFechaConInventario,
	                        fecha: this.props.auditoria.aud_fechaProgramada,
	                        onGuardar: this.guardarAuditoria.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this2.props.focusRow(_this2.props.index - 1, 'dia');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this2.props.focusRow(_this2.props.index + 1, 'dia');
	                        } })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            this.props.auditoria.cliente_nombreCorto
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        this.props.auditoria.local_ceco
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { margin: 0 } },
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            this.props.auditoria.local_region
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    this.props.auditoria.local_comuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                this.props.auditoria.local_nombre
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        this.props.auditoria.local_stockF,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Stock al ' + this.props.auditoria.local_fechaStock
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAuditor },
	                    _react2.default.createElement(_Select2.default, {
	                        ref: function ref(_ref2) {
	                            return _this2.selectAuditor = _ref2;
	                        },
	                        seleccionada: '' + this.props.auditoria.aud_idAuditor,
	                        onSelect: this.guardarAuditoria.bind(this),
	                        opciones: auditores,
	                        opcionNula: true,
	                        opcionNulaSeleccionable: true,
	                        puedeModificar: this.props.puedeModificar
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAperturaCierre },
	                    _react2.default.createElement('input', { type: 'time',
	                        value: this.props.auditoria.local_horaApertura,
	                        disabled: true })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAperturaCierre },
	                    _react2.default.createElement('input', { type: 'time',
	                        value: this.props.auditoria.local_horaCierre,
	                        disabled: true })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDireccion },
	                    this.props.auditoria.local_direccion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOpciones },
	                    this.props.puedeModificar === true ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-xs btn-primary',
	                            tabIndex: '-1',
	                            onClick: this.eliminarAuditoria.bind(this) },
	                        'Eliminar'
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return RowAuditoriaMensual;
	}(_react2.default.Component);
	
	RowAuditoriaMensual.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    index: _react2.default.PropTypes.number.isRequired,
	    auditoria: _react2.default.PropTypes.object.isRequired,
	    auditores: _react2.default.PropTypes.array.isRequired,
	    mostrarSeparador: _react2.default.PropTypes.bool.isRequired,
	    // Metodos
	    actualizarAuditoria: _react2.default.PropTypes.func.isRequired,
	    quitarAuditoria: _react2.default.PropTypes.func.isRequired,
	    eliminarAuditoria: _react2.default.PropTypes.func.isRequired,
	    focusRow: _react2.default.PropTypes.func.isRequired
	};
	RowAuditoriaMensual.defaultProps = {
	    mostrarSeparador: false
	};
	
	exports.default = RowAuditoriaMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowAuditoriaMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"TablaMensualAI__tableFixed___1j_Ow","trSeparador":"TablaMensualAI__trSeparador___35Z2z","thCorrelativo":"TablaMensualAI__thCorrelativo___2gK1u","tdCorrelativo":"TablaMensualAI__tdCorrelativo___WHOL3","thFecha":"TablaMensualAI__thFecha___2aUSN","tdFecha":"TablaMensualAI__tdFecha___3Qj7e","thCliente":"TablaMensualAI__thCliente___2_Z6P","tdCliente":"TablaMensualAI__tdCliente___319S2 TablaMensualAI__thCliente___2_Z6P","thCeco":"TablaMensualAI__thCeco___3xiwn","tdCeco":"TablaMensualAI__tdCeco___3k4dg TablaMensualAI__thCeco___3xiwn","thLocal":"TablaMensualAI__thLocal___3DMdJ","tdLocal":"TablaMensualAI__tdLocal___3awE9 TablaMensualAI__thLocal___3DMdJ","thZonaSei":"TablaMensualAI__thZonaSei___gK5u5","tdZonaSei":"TablaMensualAI__tdZonaSei___2QT6Q TablaMensualAI__thZonaSei___gK5u5","thRegion":"TablaMensualAI__thRegion___1q8zI","tdRegion":"TablaMensualAI__tdRegion___2o4hj TablaMensualAI__thRegion___1q8zI","thComuna":"TablaMensualAI__thComuna___11N1I","tdComuna":"TablaMensualAI__tdComuna___1eKgM TablaMensualAI__thComuna___11N1I","thAuditor":"TablaMensualAI__thAuditor___3q8mu","tdAuditor":"TablaMensualAI__tdAuditor___1ZTvQ","thStock":"TablaMensualAI__thStock___F9u7q","tdStock":"TablaMensualAI__tdStock___QJoie TablaMensualAI__thStock___F9u7q","thDotacion":"TablaMensualAI__thDotacion___1MeWw","tdDotacion":"TablaMensualAI__tdDotacion___8O57h TablaMensualAI__thDotacion___1MeWw","thEstado":"TablaMensualAI__thEstado___1w167","tdEstado":"TablaMensualAI__tdEstado___3ye3D","thAperturaCierre":"TablaMensualAI__thAperturaCierre___3a8lx","tdAperturaCierre":"TablaMensualAI__tdAperturaCierre___1t6hO","thDireccion":"TablaMensualAI__thDireccion___1-Dnk","tdDireccion":"TablaMensualAI__tdDireccion___3AGpx","thOpciones":"TablaMensualAI__thOpciones___DIm-p","tdOpciones":"TablaMensualAI__tdOpciones___380Ow","textoConTooltip":"TablaMensualAI__textoConTooltip___2qouF"};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(626);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _TablaMensualAI = __webpack_require__(737);
	
	var css = _interopRequireWildcard(_TablaMensualAI);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var TablaMensualAI = function (_React$Component) {
	    _inherits(TablaMensualAI, _React$Component);
	
	    function TablaMensualAI() {
	        _classCallCheck(this, TablaMensualAI);
	
	        return _possibleConstructorReturn(this, (TablaMensualAI.__proto__ || Object.getPrototypeOf(TablaMensualAI)).apply(this, arguments));
	    }
	
	    _createClass(TablaMensualAI, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _container2.default,
	                    { type: _react2.default.DOM.table, className: "table table-bordered table-condensed " + css.tableFixed },
	                    _react2.default.createElement(
	                        'colgroup',
	                        null,
	                        _react2.default.createElement('col', { className: css.thCorrelativo }),
	                        _react2.default.createElement('col', { className: css.thFecha }),
	                        _react2.default.createElement('col', { className: css.thCliente }),
	                        _react2.default.createElement('col', { className: css.thCeco }),
	                        _react2.default.createElement('col', { className: css.thRegion }),
	                        _react2.default.createElement('col', { className: css.thComuna }),
	                        _react2.default.createElement('col', { className: css.thLocal }),
	                        _react2.default.createElement('col', { className: css.thStock }),
	                        _react2.default.createElement('col', { className: css.thAuditor }),
	                        _react2.default.createElement('col', { className: css.thAperturaCierre }),
	                        _react2.default.createElement('col', { className: css.thAperturaCierre }),
	                        _react2.default.createElement('col', { className: css.thDireccion }),
	                        _react2.default.createElement('col', { className: css.thOpciones })
	                    ),
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            _sticky2.default,
	                            {
	                                topOffset: -50,
	                                type: _react2.default.DOM.tr,
	                                stickyStyle: { top: '50px' } },
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thCorrelativo },
	                                '#'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thFecha },
	                                _react2.default.createElement(_HeaderConFiltro2.default, {
	                                    nombre: 'Fecha',
	                                    filtro: this.props.filtros.filtroFechas || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroFechas'),
	                                    ordenarLista: this.props.ordenarAuditorias
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thCliente },
	                                _react2.default.createElement(_HeaderConFiltro2.default, { nombre: 'Cliente',
	                                    filtro: this.props.filtros.filtroClientes || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroClientes')
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thCeco },
	                                _react2.default.createElement(_HeaderConFiltro2.default, { nombre: 'CE',
	                                    filtro: this.props.filtros.filtroCeco || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroCeco'),
	                                    busquedaExacta: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thRegion },
	                                _react2.default.createElement(_HeaderConFiltro2.default, { nombre: 'Regi\xF3n',
	                                    filtro: this.props.filtros.filtroRegiones || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroRegiones'),
	                                    busquedaExacta: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thComuna },
	                                _react2.default.createElement(_HeaderConFiltro2.default, { nombre: 'Comuna',
	                                    filtro: this.props.filtros.filtroComunas || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroComunas')
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thLocal },
	                                'Local'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thStock },
	                                'Stock'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thAuditor },
	                                _react2.default.createElement(_HeaderConFiltro2.default, { nombre: 'Auditor',
	                                    filtro: this.props.filtros.filtroAuditores || [],
	                                    actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroAuditores')
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thAperturaCierre },
	                                'Hr.Apertura'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thAperturaCierre },
	                                'Hr.Cierre'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thDireccion },
	                                'Direcci\xF3n'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: css.thOpciones },
	                                'Opciones'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaMensualAI;
	}(_react2.default.Component);
	
	TablaMensualAI.propTypes = {
	    // Objetos
	    filtros: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.array).isRequired,
	    // Metodos
	    ordenarAuditorias: _react2.default.PropTypes.func.isRequired,
	    actualizarFiltro: _react2.default.PropTypes.func.isRequired
	};
	exports.default = TablaMensualAI;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaMensualAI.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _BlackBoxSemanal = __webpack_require__(740);
	
	var _BlackBoxSemanal2 = _interopRequireDefault(_BlackBoxSemanal);
	
	var _TablaAuditoriaSemanal = __webpack_require__(741);
	
	var _TablaAuditoriaSemanal2 = _interopRequireDefault(_TablaAuditoriaSemanal);
	
	var _RowAuditoriaSemanal = __webpack_require__(742);
	
	var _RowAuditoriaSemanal2 = _interopRequireDefault(_RowAuditoriaSemanal);
	
	var _SelectRange = __webpack_require__(731);
	
	var _SelectRange2 = _interopRequireDefault(_SelectRange);
	
	var _Modales = __webpack_require__(747);
	
	var _ResumenMensual = __webpack_require__(749);
	
	var _ResumenMensual2 = _interopRequireDefault(_ResumenMensual);
	
	var _FacturacionMensual = __webpack_require__(751);
	
	var _FacturacionMensual2 = _interopRequireDefault(_FacturacionMensual);
	
	var _CheckboxSensores = __webpack_require__(752);
	
	var _CheckboxSensores2 = _interopRequireDefault(_CheckboxSensores);
	
	var _ReporteRuta = __webpack_require__(614);
	
	var _ReporteRuta2 = _interopRequireDefault(_ReporteRuta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	_moment2.default.locale("es");
	// Componentes
	
	var format = "YYYY-MM-DD";
	
	var ProgramacionAISemanal = function (_React$Component) {
	  _inherits(ProgramacionAISemanal, _React$Component);
	
	  function ProgramacionAISemanal(props) {
	    _classCallCheck(this, ProgramacionAISemanal);
	
	    var _this = _possibleConstructorReturn(this, (ProgramacionAISemanal.__proto__ || Object.getPrototypeOf(ProgramacionAISemanal)).call(this, props));
	
	    _this.blackbox = new _BlackBoxSemanal2.default();
	
	    _this.state = {
	      idCliente: 0, // Seleccionar Todos por defecto
	      numeroLocal: "",
	      fechaInicialSeleccionada: (0, _moment2.default)().startOf("day"),
	      fechaFinalSeleccionada: (0, _moment2.default)().endOf("day"),
	      // Auditorias y Filtros
	      filtros: {},
	      auditoriasFiltradas: [],
	      isLoading: false,
	      loadingExcel: false
	    };
	
	    // referencia a todos las entradas de fecha de los inventarios
	    _this.rows = [];
	
	    return _this;
	  }
	
	  _createClass(ProgramacionAISemanal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      // // al montar el componente, seleccionar el primer mes
	      // this.seleccionarMes(this.state.meses[0].valor)
	      this.buscarAuditorias();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
	      this.rows = this.rows.filter(function (input) {
	        return input !== null;
	      });
	    }
	  }, {
	    key: "focusRow",
	    value: function focusRow(index, nombreElemento) {
	      var ultimoIndex = this.rows.length - 1;
	      if (index < 0) {
	        // al seleccionar "antes de la primera", se seleciona el ultimo
	        this.rows[ultimoIndex].focusElemento(nombreElemento);
	      } else if (index > ultimoIndex) {
	        // al seleccionar "despues de la ultima", se selecciona el primero
	        this.rows[index % this.rows.length].focusElemento(nombreElemento);
	      } else {
	        // no es ni el ultimo, ni el primero
	        this.rows[index].focusElemento(nombreElemento);
	      }
	    }
	
	    // Select de Cliente seleccionado
	
	  }, {
	    key: "onSelectClienteChanged",
	    value: function onSelectClienteChanged(evt) {
	      var _this2 = this;
	
	      this.setState({
	        idCliente: evt.target.value
	      }, function () {
	        _this2.buscarAuditorias();
	      });
	    }
	  }, {
	    key: "onSelectRangoChanged",
	    value: function onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal) {
	      var _this3 = this;
	
	      this.setState({
	        fechaInicialSeleccionada: momentumFechaInicio,
	        fechaFinalSeleccionada: momentumFechaFinal
	      }, function () {
	        var fechaInicio = _this3.state.fechaInicialSeleccionada.format("YYYY-MM-DD");
	        var fechaFinal = _this3.state.fechaFinalSeleccionada.format("YYYY-MM-DD");
	        console.log("rango seleccionado " + fechaInicio + " al " + fechaFinal);
	        // se llama al metodo seleccionar semana, que hace lo mismo
	        _this3.buscarAuditorias(fechaInicio, fechaFinal);
	      });
	    }
	
	    // Filtros
	
	  }, {
	    key: "actualizarFiltro",
	    value: function actualizarFiltro(nombreFiltro, filtro) {
	      this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	      // actualizar los filtros, y la lista ordenada de locales
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	  }, {
	    key: "ordenarAuditorias",
	    value: function ordenarAuditorias(evt) {
	      evt.preventDefault();
	      this.blackbox.ordenarLista();
	      this.setState(this.blackbox.getListaFiltrada());
	    }
	
	    // Llamadas al API
	    // Todo: recibir el idCliente desde los metodos que lo llamen
	
	  }, {
	    key: "buscarAuditorias",
	    value: function buscarAuditorias() {
	      var _this4 = this;
	
	      this.setState({ auditoriasFiltradas: [] });
	      this.setState({ isLoading: true });
	      var idCliente = this.state.idCliente;
	      var fechaInicio = this.state.fechaInicialSeleccionada.format(format);
	      var fechaFin = this.state.fechaFinalSeleccionada.format(format);
	      console.log("Buscando auditorias...");
	      _v2.default.auditoria.getPorRangoYCliente(fechaInicio, fechaFin, idCliente).then(function (auditorias) {
	        //console.log(`auditorias del rango ${fechaInicio} a ${fechaFin}, y cliente ${idCliente}`, auditorias)
	        _this4.blackbox.reset();
	        auditorias.forEach(function (auditoria) {
	          return _this4.blackbox.add(auditoria);
	        });
	
	        _this4.blackbox.ordenarLista();
	        _this4.setState(_this4.blackbox.getListaFiltrada()); // {auditoriasFiltradas: ...}
	        _this4.setState({ isLoading: false });
	      });
	    }
	  }, {
	    key: "guardarAuditoria",
	    value: function guardarAuditoria(idAuditoria, formInventario) {
	      var _this5 = this;
	
	      console.log(formInventario);
	      _v2.default.auditoria.actualizar(idAuditoria, formInventario).then(function (auditoriaActualizada) {
	        console.log("auditoria actualizada correctamente", formInventario);
	        // actualizar los datos y el state de la app
	        _this5.blackbox.actualizarAuditoria(auditoriaActualizada);
	        // actualizar los filtros, y la lista ordenada de locales
	        _this5.setState(_this5.blackbox.getListaFiltrada()); // {auditoriasFiltradas: ...}
	      });
	    }
	  }, {
	    key: "eliminarAuditoria",
	    value: function eliminarAuditoria(auditoria) {
	      var _this6 = this;
	
	      if (this.props.puedeModificar !== true) return alert("No tiene los permisos para eliminar la Auditoria");
	
	      console.log("eliminando ", auditoria);
	      _v2.default.auditoria.eliminar(auditoria.aud_idAuditoria).then(function (resp) {
	        _this6.blackbox.remove(auditoria.idAuditoria);
	        // actualizar los filtros, y la lista ordenada de locales
	        _this6.setState(_this6.blackbox.getListaFiltrada());
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    }
	  }, {
	    key: "onSelectAuditorMasivoChanged",
	    value: function onSelectAuditorMasivoChanged(evt) {
	      this.setState({
	        idAuditorMasivo: evt.target.value
	      });
	    }
	  }, {
	    key: "asignacionMasivaAuditor",
	    value: function asignacionMasivaAuditor(cambiosAuditoria) {
	      var _this7 = this;
	
	      var promesasFetch = [];
	      this.state.auditoriasFiltradas.forEach(function (auditoria) {
	        var data = _extends({}, cambiosAuditoria, {
	          perecible: auditoria.aud_perecible ? 1 : 0
	        });
	        promesasFetch.push(_v2.default.auditoria.actualizar(auditoria.aud_idAuditoria, data));
	      });
	      var request = Promise.all(promesasFetch).then(function (auditorias) {
	        auditorias.forEach(function (res) {
	          _this7.blackbox.actualizarAuditoria(res);
	        });
	        _this7.setState(_this7.blackbox.getListaFiltrada());
	      }).catch(function (auditorias) {
	        alert("error al actualizar las auditorias");
	      });
	      return request;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var fechaInicial = this.state.fechaInicialSeleccionada.format(format);
	      var fechaFinal = this.state.fechaFinalSeleccionada.format(format);
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Programaci\xF3n Semanal AI"
	          ),
	          this.props.puedeVerExcelFacturacion && _react2.default.createElement(_ReporteRuta2.default, { fechaInicio: this.state.fechaInicialSeleccionada })
	        ),
	        this.props.puedeRevisarCliente ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectCliente" },
	              "Cliente"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                name: "selectCliente",
	                ref: function ref(_ref) {
	                  return _this8.inputIdCliente = _ref;
	                },
	                value: this.state.idCliente,
	                onChange: this.onSelectClienteChanged.bind(this)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "0" },
	                "Todos"
	              ),
	              this.props.clientes.map(function (cliente, index) {
	                return _react2.default.createElement(
	                  "option",
	                  {
	                    key: index,
	                    value: cliente.idCliente
	                  },
	                  cliente.nombreCorto + " - " + cliente.nombre
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-3 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectSemana" },
	              "Rango de Fecha"
	            ),
	            _react2.default.createElement(_SelectRange2.default, {
	              startDateSelected: this.state.fechaInicialSeleccionada,
	              endDateSelected: this.state.fechaFinalSeleccionada,
	              onInit: function onInit() {
	                console.log("on init");
	              },
	              onRangeSelected: this.onSelectRangoChanged.bind(this)
	            })
	          )
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectCliente" },
	              "Cliente"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                name: "selectCliente",
	                ref: function ref(_ref2) {
	                  return _this8.inputIdCliente = _ref2;
	                },
	                value: this.state.idCliente,
	                onChange: this.onSelectClienteChanged.bind(this)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "0" },
	                "Todos"
	              ),
	              this.props.clientes.map(function (cliente, index) {
	                return _react2.default.createElement(
	                  "option",
	                  {
	                    key: index,
	                    value: cliente.idCliente
	                  },
	                  cliente.nombreCorto + " - " + cliente.nombre
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-3 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectSemana" },
	              "Rango de Fecha"
	            ),
	            _react2.default.createElement(_SelectRange2.default, {
	              startDateSelected: this.state.fechaInicialSeleccionada,
	              endDateSelected: this.state.fechaFinalSeleccionada,
	              onInit: function onInit() {
	                console.log("on init");
	              },
	              onRangeSelected: this.onSelectRangoChanged.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label", htmlFor: "selectCliente" },
	              "Asignaci\xF3n m\xFAltiple"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                name: "selectCliente",
	                value: this.state.idAuditorMasivo,
	                onChange: this.onSelectAuditorMasivoChanged.bind(this)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "" },
	                "--"
	              ),
	              this.props.auditores.map(function (auditor, index) {
	                return _react2.default.createElement(
	                  "option",
	                  {
	                    key: index,
	                    value: auditor.id
	                  },
	                  auditor.nombre1 + " " + auditor.apellidoPaterno
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-1 form-group " },
	            _react2.default.createElement(
	              "label",
	              { className: "control-label" },
	              "\xA0"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(BotonAuditorMasivo, {
	                auditoriasFiltradas: this.state.auditoriasFiltradas,
	                idAuditorMasivo: this.state.idAuditorMasivo,
	                auditorMultiple: this.asignacionMasivaAuditor.bind(this),
	                auditor: this.props.auditores.find(function (auditor) {
	                  return auditor.id === parseInt(_this8.state.idAuditorMasivo);
	                })
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", gap: "4px", alignItems: "center", justifyContent: 'space-between' } },
	          _react2.default.createElement(_CheckboxSensores2.default, {
	            nombre: "Tipo Auditorias",
	            filtro: this.state.filtros.filtroSensores || [],
	            actualizarFiltro: this.actualizarFiltro.bind(this, "filtroSensores")
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", gap: "2px", maxWidth: "300px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { padding: '2px' } },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-info btn-xs",
	                  target: "_blank",
	                  href: "/auditorias/detalles?cliente=" + this.state.idCliente + "&fechaInicio=" + fechaInicial + "&fechaFinal=" + fechaFinal
	                },
	                _react2.default.createElement("span", { className: "glyphicon glyphicon-list" }),
	                " Detalles"
	              ),
	              _react2.default.createElement(_ResumenMensual2.default, null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { padding: '2px' } },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "btn btn-success btn-xs",
	                  href: "/auditorias/descargar-excel-por-rango?fechaInicial=" + fechaInicial + "&fechaFinal=" + fechaFinal + "&idCliente=" + this.state.idCliente
	                },
	                "Exportar a Excel"
	              ),
	              this.props.puedeVerExcelFacturacion && _react2.default.createElement(_FacturacionMensual2.default, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _TablaAuditoriaSemanal2.default,
	          {
	            puedeRevisarCantidadMuestras: this.props.puedeRevisarCantidadMuestras,
	            ordenarAuditorias: this.ordenarAuditorias.bind(this),
	            filtros: this.state.filtros,
	            actualizarFiltro: this.actualizarFiltro.bind(this)
	          },
	          this.state.auditoriasFiltradas.length === 0 ? _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { colSpan: "17", style: { textAlign: "center" } },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    padding: "60px 0",
	                    fontSize: "18px",
	                    fontWeight: "bold"
	                  }
	                },
	                this.state.isLoading ? "Cargando Auditorias..." : "No hay auditorias para mostrar en este periodo."
	              )
	            )
	          ) : this.state.auditoriasFiltradas.map(function (auditoria, index) {
	            var mostrarSeparador = false;
	            var sgteInventario = _this8.state.auditoriasFiltradas[index + 1];
	            if (sgteInventario) mostrarSeparador = auditoria.aud_fechaProgramada !== sgteInventario.aud_fechaProgramada;
	            return _react2.default.createElement(_RowAuditoriaSemanal2.default
	            // Propiedades
	            , { puedeModificar: _this8.props.puedeModificar,
	              puedeRevisar: _this8.props.puedeRevisar,
	              puedeRevisarCantidadMuestras: _this8.props.puedeRevisarCantidadMuestras,
	              puedeVerExcelFacturacion: _this8.props.puedeVerExcelFacturacion,
	              key: auditoria.aud_idAuditoria,
	              index: index,
	              ref: function ref(_ref3) {
	                return _this8.rows[index] = _ref3;
	              },
	              mostrarSeparador: mostrarSeparador,
	              auditoria: auditoria,
	              auditores: _this8.props.auditores
	              // Metodos
	              , guardarAuditoria: _this8.guardarAuditoria.bind(_this8),
	              eliminarAuditoria: _this8.eliminarAuditoria.bind(_this8),
	              focusRow: _this8.focusRow.bind(_this8),
	              fcv: _this8.props.fcv
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProgramacionAISemanal;
	}(_react2.default.Component);
	
	ProgramacionAISemanal.propTypes = {
	  puedeModificar: _react2.default.PropTypes.bool.isRequired,
	  puedeRevisar: _react2.default.PropTypes.bool.isRequired,
	  puedeRevisarCliente: _react2.default.PropTypes.bool.isRequired,
	  puedeRevisarCantidadMuestras: _react2.default.PropTypes.bool.isRequired,
	  clientes: _react2.default.PropTypes.array.isRequired,
	  auditores: _react2.default.PropTypes.array.isRequired
	};
	
	exports.default = ProgramacionAISemanal;
	
	var BotonAuditorMasivo = function BotonAuditorMasivo(_ref4) {
	  var auditoriasFiltradas = _ref4.auditoriasFiltradas,
	      idAuditorMasivo = _ref4.idAuditorMasivo,
	      auditorMultiple = _ref4.auditorMultiple,
	      auditor = _ref4.auditor;
	  return _react2.default.createElement(
	    _Modales.ModalTrigger,
	    null,
	    function (isVisible, showModal, hideModal) {
	      return _react2.default.createElement(
	        "button",
	        { className: "btn btn-md btn-success", onClick: showModal },
	        _react2.default.createElement("span", { className: "glyphicon glyphicon-ok" }),
	        isVisible && _react2.default.createElement(_Modales.ModalAuditorMasivo, {
	          hideModal: hideModal,
	          totalAuditorias: auditoriasFiltradas.length,
	          auditorMultiple: auditorMultiple,
	          idAuditorMasivo: idAuditorMasivo ? "" + idAuditorMasivo : "",
	          auditor: auditor
	        })
	      );
	    }
	  );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ProgramacionAISemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBoxSemanal = function () {
	    function BlackBoxSemanal() {
	        _classCallCheck(this, BlackBoxSemanal);
	
	        this.lista = [];
	        this.filtroFacturables = [];
	        this.filtroFechas = [];
	        this.filtroCeco = [];
	        this.filtroRegiones = [];
	        this.filtroComunas = [];
	        this.filtroAuditores = [];
	        this.filtroFechaAuditoria = [];
	        this.filtroClientes = [];
	        this.filtroLink = [];
	        this.filtroDescargaIrd = [];
	        this.filtroSuspendidos = [];
	        this.filtroObservaciones = [];
	        this.filtroObservacionesCliente = [];
	        this.filtroZip = [];
	        this.filtroResultado = [];
	        this.filtroMuestraO = [];
	        this.filtroMuestraD = [];
	        this.filtroSensores = [];
	    }
	
	    _createClass(BlackBoxSemanal, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroFacturables = [];
	            this.filtroFechas = [];
	            this.filtroCeco = [];
	            this.filtroRegiones = [];
	            this.filtroComunas = [];
	            this.filtroAuditores = [];
	            this.filtroFechaAuditoria = [];
	            this.filtroClientes = [];
	            this.filtroLink = [];
	            this.filtroDescargaIrd = [];
	            this.filtroSuspendidos = [];
	            this.filtroObservaciones = [];
	            this.filtroObservacionesCliente = [];
	            this.filtroZip = [];
	            this.filtroResultado = [];
	            this.filtroMuestraO = [];
	            this.filtroMuestraD = [];
	            this.filtroSensores = [];
	        }
	        // Todo: Optimizar
	        // Todo Modificar: el listado de clientes
	
	    }, {
	        key: 'add',
	        value: function add(auditoria) {
	            this.lista.push(auditoria);
	        }
	    }, {
	        key: 'remove',
	        value: function remove(idAuditoria) {
	            var index = this.lista.findIndex(function (auditoria) {
	                return auditoria.idAuditoria === idAuditoria;
	            });
	            if (index >= 0) this.lista.splice(index, 1);
	        }
	
	        // Todo modificar el listado de clientes
	        // actualizarAuditoria(auditoriaActualizada){
	        //     this.lista = this.lista.map(auditoria=> {
	        //         if (auditoria.aud_idAuditoria == auditoriaActualizada.aud_idAuditoria) {
	        //             //auditoria = Object.assign(auditoria, auditoriaActualizada)
	        //             console.log(auditoriaActualizada)
	        //             auditoriaActualizada.aud_idAuditoriaOriginal = 0
	        //             return auditoriaActualizada
	        //         }
	        //         // Si tiene hay una auditoria de sensores vinculada, se actualiza
	        //         if((auditoria.aud_idAuditoriaOriginal == auditoriaActualizada.aud_idAuditoria) && auditoria.aud_fechaProgramada !== auditoriaActualizada.aud_fechaProgramada){
	        //             auditoria = {
	        //                 ...auditoria,
	        //                 aud_fechaProgramada: auditoriaActualizada.aud_fechaProgramada,
	        //                 aud_fechaProgramadaDOW: auditoriaActualizada.aud_fechaProgramadaDOW,
	        //                 aud_fechaProgramadaF: auditoriaActualizada.aud_fechaProgramadaF,
	        //                 aud_fechaProgramadaFbreve: auditoriaActualizada.aud_fechaProgramadaFbreve,
	        //             }
	        //             return auditoria
	        //         }
	
	        //         return auditoria
	        //     })
	        //     // una vez que se realizaron los cambios del inventario, se actualizan los filtros
	        //     this.actualizarFiltros()
	        // }
	
	    }, {
	        key: 'actualizarAuditoria',
	        value: function actualizarAuditoria(auditoriaActualizada) {
	            this.lista = this.lista.map(function (auditoria) {
	                if (auditoria.aud_idAuditoria == auditoriaActualizada.aud_idAuditoria) {
	                    //auditoria = Object.assign(auditoria, auditoriaActualizada)
	                    return auditoriaActualizada;
	                }
	                return auditoria;
	            });
	            // una vez que se realizaron los cambios del inventario, se actualizan los filtros
	            this.actualizarFiltros();
	        }
	
	        /*** ################### FILTROS ################### ***/
	
	    }, {
	        key: 'ordenarLista',
	        value: function ordenarLista() {
	            var porFechaProgramada = function porFechaProgramada(auditoria) {
	                var dateA = new Date(auditoria.aud_fechaProgramada);
	                if (dateA == 'Invalid Date') {
	                    var _auditoria$aud_fechaP = auditoria.aud_fechaProgramada.split('-'),
	                        _auditoria$aud_fechaP2 = _slicedToArray(_auditoria$aud_fechaP, 3),
	                        annoA = _auditoria$aud_fechaP2[0],
	                        mesA = _auditoria$aud_fechaP2[1],
	                        diaA = _auditoria$aud_fechaP2[2];
	                    // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
	
	
	                    return new Date(annoA + '-' + mesA) - 1;
	                } else {
	                    return dateA;
	                }
	            };
	            var porAuditor = function porAuditor(auditoria) {
	                return auditoria.aud_auditor;
	            };
	            var porComuna = function porComuna(auditoria) {
	                return auditoria.local_cutComuna;
	            };
	
	            // ordenar por fechaprogramada, por auditor, y finalmente por comuna
	            this.lista = _lodash2.default.sortBy(this.lista, porFechaProgramada, porAuditor, porComuna);
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            // ##### Filtro Facturables
	            this.filtroFacturables = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_facturable;
	                var texto = auditoria.aud_facturable == 1 ? 'Facturable' : 'No Facturable';
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFacturables, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro fechas
	            this.filtroFechas = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_fechaProgramada;
	                var texto = auditoria.aud_fechaProgramadaFbreve;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFechas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            // ###### Filtro CLIENTES
	            this.filtroClientes = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.cliente_idCliente;
	                var texto = inventario.cliente_nombreCorto;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroClientes, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de cliente
	            .value();
	
	            // ##### Filtro CECO (ordenado por numero)
	            this.filtroCeco = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.local_ceco;
	                var texto = '' + auditoria.local_ceco;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroCeco, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).sortBy(function (ob) {
	                return ob.valor.length;
	            }, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
	            .value();
	
	            // ##### Filtro Regiones (ordenado por codRegion)
	            this.filtroRegiones = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.local_cutRegion;
	                var texto = auditoria.local_region;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroRegiones, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor') // ordenado por numero de region
	            .value();
	
	            // ##### Filtro Comunas (ordenado por codComuna)
	            this.filtroComunas = _lodash2.default.chain(this.lista)
	            // solo dejar las comunas en las que su respectiva region este seleccionada
	            .filter(function (auditoria) {
	                return _lodash2.default.find(_this.filtroRegiones, { 'valor': auditoria.local_cutRegion, 'seleccionado': true });
	            }).map(function (auditoria) {
	                var valor = auditoria.local_cutComuna;
	                var texto = auditoria.local_comuna;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroComunas, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Auditores
	            this.filtroAuditores = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_idAuditor;
	                var texto = auditoria.aud_auditor;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroAuditores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	
	            // ##### Filtro Fecha Auditoria
	            this.filtroFechaAuditoria = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_fechaAuditoria;
	                var texto = auditoria.aud_fechaAuditoria === '0000-00-00' ? 'PENDIENTE' : auditoria.aud_fechaAuditoria;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroFechaAuditoria, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Link ejecutado
	            this.filtroLink = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_linkEjecutado;
	                var texto = auditoria.aud_linkEjecutado ? 'Ejecutado' : 'No Ejecutado';
	                var opcion = _lodash2.default.find(_this.filtroLink, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Descargar IRD
	            this.filtroDescargaIrd = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_descarga_ird;
	                var texto = auditoria.aud_descarga_ird > 0 ? 'SI' : 'NO';
	                var opcion = _lodash2.default.find(_this.filtroDescargaIrd, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Observaciones
	            this.filtroObservaciones = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.aud_observacion;
	                var texto = '' + auditoria.aud_observacion;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroObservaciones, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Observaciones CLIENTE
	            this.filtroObservacionesCliente = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = '' + auditoria.aud_observacion_cliente;
	                var texto = '' + auditoria.aud_observacion_cliente;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroObservacionesCliente, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	
	            // ##### Filtro Zip
	            this.filtroZip = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_estadoArchivoFinal;
	                var texto = auditoria.aud_estadoArchivoFinal;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroZip, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor')
	            //.sortBy('valor')
	            .value();
	
	            // ##### Filtro Resultado
	            this.filtroResultado = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_publicado;
	                var texto = auditoria.aud_publicado ? 'Publicado' : 'Por publicar';
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroResultado, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroMuestraO = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_mvencimientoDisponible;
	                var texto = auditoria.aud_mvencimientoDisponible;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroMuestraO, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroMuestraD = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_mvencimientoDiferencia;
	                var texto = auditoria.aud_mvencimientoDiferencia;
	
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroMuestraD, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroSuspendidos = _lodash2.default.chain([{ valor: 1, texto: 'No aplica' }, { valor: 2, texto: 'Remodelación' }, { valor: 3, texto: 'Falta Personal' }, { valor: 4, texto: 'Corte electricidad' }, { valor: 5, texto: 'QF suspende' }, { valor: 6, texto: 'Auditor no asiste' }, { valor: 9, texto: 'Pago 50%' }, { valor: 8, texto: 'Fase 2' }, { valor: 10, texto: 'Medición especial' }, { valor: 11, texto: 'No Pago' }, { valor: 7, texto: 'Otro' }]).map(function (item) {
	                var valor = item.valor,
	                    texto = item.texto;
	
	                var opcion = _lodash2.default.find(_this.filtroSuspendidos, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).value();
	            this.filtroSensores = _lodash2.default.chain(this.lista).map(function (auditoria) {
	                var valor = auditoria.aud_sensores;
	                var texto = auditoria.aud_sensores;
	                var opcion = _lodash2.default.find(_this.filtroSensores, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value(); // ¡Asegúrate de llamar a .value() aquí!        
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	            return {
	                auditoriasFiltradas: _lodash2.default.chain(this.lista)
	                // Filtrar por cliente
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroClientes, { 'valor': auditoria.cliente_idCliente, 'seleccionado': true });
	                })
	                // Filtrar por Facturable
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroFacturables, { 'valor': auditoria.aud_facturable, 'seleccionado': true });
	                })
	                // Filtrar por Fecha
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroFechas, { 'valor': auditoria.aud_fechaProgramada, 'seleccionado': true });
	                }).filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroLink, { 'valor': auditoria.aud_linkEjecutado, 'seleccionado': true });
	                })
	                // Filtrar Descarga Ird
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroDescargaIrd, { 'valor': auditoria.aud_descarga_ird, 'seleccionado': true });
	                }).filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroClientes, { 'valor': auditoria.cliente_idCliente, 'seleccionado': true });
	                })
	                // Filtrar por Ceco
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroCeco, { 'valor': '' + auditoria.local_ceco, 'seleccionado': true });
	                })
	                // Filtrar por Region
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroRegiones, { 'valor': auditoria.local_cutRegion, 'seleccionado': true });
	                })
	                // Filtrar por Comuna
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroComunas, { 'valor': auditoria.local_cutComuna, 'seleccionado': true });
	                })
	                // Filtrar por Auditor
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroAuditores, { 'valor': auditoria.aud_idAuditor, 'seleccionado': true });
	                })
	                // Filtrar por Fecha de Subida de Nomina
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroFechaAuditoria, { 'valor': auditoria.aud_fechaAuditoria, 'seleccionado': true });
	                })
	                // Filtrar por observaciones
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroObservaciones, { 'valor': auditoria.aud_observacion, 'seleccionado': true });
	                })
	                // Filtrar por observaciones CLIENTE
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroObservacionesCliente, { 'valor': auditoria.aud_observacion_cliente, 'seleccionado': true });
	                })
	                // Filtrar por estado zip
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroZip, { 'valor': auditoria.aud_estadoArchivoFinal, 'seleccionado': true });
	                })
	                // Filtrar por publicacion vencimiento
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroResultado, { 'valor': auditoria.aud_publicado, 'seleccionado': true });
	                })
	                // Filtrar por muestras obligatorias
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroMuestraO, { 'valor': auditoria.aud_mvencimientoDisponible, 'seleccionado': true });
	                })
	                // Filtrar por diferencias de muestras
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroMuestraD, { 'valor': auditoria.aud_mvencimientoDiferencia, 'seleccionado': true });
	                })
	                //filtro de auditorias vencimientos
	                .filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroSuspendidos, { 'valor': auditoria.aud_suspendida, 'seleccionado': true });
	                }).filter(function (auditoria) {
	                    return _lodash2.default.find(_this2.filtroSensores, { 'valor': auditoria.aud_sensores, 'seleccionado': true });
	                }).value(),
	                filtros: {
	                    filtroFacturables: this.filtroFacturables,
	                    filtroFechas: this.filtroFechas,
	                    filtroCeco: this.filtroCeco,
	                    filtroRegiones: this.filtroRegiones,
	                    filtroComunas: this.filtroComunas,
	                    filtroAuditores: this.filtroAuditores,
	                    filtroFechaAuditoria: this.filtroFechaAuditoria,
	                    filtroClientes: this.filtroClientes,
	                    filtroLink: this.filtroLink,
	                    filtroDescargaIrd: this.filtroDescargaIrd,
	                    filtroObservaciones: this.filtroObservaciones,
	                    filtroObservacionesCliente: this.filtroObservacionesCliente,
	                    filtroZip: this.filtroZip,
	                    filtroResultado: this.filtroResultado,
	                    filtroMuestraO: this.filtroMuestraO,
	                    filtroMuestraD: this.filtroMuestraD,
	                    filtroSuspendidos: this.filtroSuspendidos,
	                    filtroSensores: this.filtroSensores
	                }
	            };
	        }
	    }]);
	
	    return BlackBoxSemanal;
	}();
	
	exports.default = BlackBoxSemanal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxSemanal.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(626);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _TablaAuditoriaSemanal = __webpack_require__(615);
	
	var css = _interopRequireWildcard(_TablaAuditoriaSemanal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var TablaAuditoriaSemanal = function (_React$Component) {
	    _inherits(TablaAuditoriaSemanal, _React$Component);
	
	    function TablaAuditoriaSemanal() {
	        _classCallCheck(this, TablaAuditoriaSemanal);
	
	        return _possibleConstructorReturn(this, (TablaAuditoriaSemanal.__proto__ || Object.getPrototypeOf(TablaAuditoriaSemanal)).apply(this, arguments));
	    }
	
	    _createClass(TablaAuditoriaSemanal, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _container2.default,
	                { type: _react2.default.DOM.table, className: "table table-bordered table-condensed " + css.tableFixed },
	                _react2.default.createElement(
	                    'colgroup',
	                    null,
	                    _react2.default.createElement('col', { className: css.thCorrelativo }),
	                    _react2.default.createElement('col', { className: css.thCorrelativo2 }),
	                    _react2.default.createElement('col', { className: css.thFecha }),
	                    _react2.default.createElement('col', { className: css.thCliente }),
	                    _react2.default.createElement('col', { className: css.thCeco }),
	                    _react2.default.createElement('col', { className: css.thTienda }),
	                    _react2.default.createElement('col', { className: css.thRegion }),
	                    _react2.default.createElement('col', { className: css.thComuna }),
	                    _react2.default.createElement('col', { className: css.thDireccion }),
	                    _react2.default.createElement('col', { className: css.thAuditor }),
	                    _react2.default.createElement('col', { className: css.thCantidadMuestra }),
	                    _react2.default.createElement('col', { className: css.thCantidadMuestra }),
	                    _react2.default.createElement('col', { className: css.thSuspendido }),
	                    _react2.default.createElement('col', { className: css.thObservaciones }),
	                    _react2.default.createElement('col', { className: css.thLink }),
	                    _react2.default.createElement('col', { className: css.thLink }),
	                    _react2.default.createElement('col', { className: css.thLink })
	                ),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        _sticky2.default,
	                        {
	                            topOffset: -50,
	                            type: _react2.default.DOM.tr,
	                            stickyStyle: { top: '50px' } },
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCorrelativo },
	                            '#'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCorrelativo },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: '',
	                                filtro: this.props.filtros.filtroFacturables || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroFacturables')
	                                //ordenarLista={this.props.ordenarAuditorias}
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thFecha },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Fecha',
	                                filtro: this.props.filtros.filtroFechas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroFechas'),
	                                ordenarLista: this.props.ordenarAuditorias
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCliente },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'CL',
	                                filtro: this.props.filtros.filtroClientes || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroClientes'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thCeco },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'CE',
	                                filtro: this.props.filtros.filtroCeco || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroCeco'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thTienda },
	                            'Tienda'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thRegion },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'R',
	                                filtro: this.props.filtros.filtroRegiones || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroRegiones'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thComuna },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Comuna',
	                                filtro: this.props.filtros.filtroComunas || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroComunas')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thDireccion },
	                            'Direcci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thAuditor },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Auditor',
	                                filtro: this.props.filtros.filtroAuditores || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroAuditores')
	                            })
	                        ),
	                        this.props.puedeRevisarCantidadMuestras ? _react2.default.createElement(
	                            'th',
	                            { className: css.thCantidadMuestra },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Obl',
	                                filtro: this.props.filtros.filtroMuestraO || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroMuestraO')
	                            })
	                        ) : _react2.default.createElement(
	                            'th',
	                            { className: css.thCantidadMuestra },
	                            'Obl'
	                        ),
	                        this.props.puedeRevisarCantidadMuestras ? _react2.default.createElement(
	                            'th',
	                            { className: css.thCantidadMuestra },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Dif',
	                                filtro: this.props.filtros.filtroMuestraD || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroMuestraD')
	                            })
	                        ) : _react2.default.createElement(
	                            'th',
	                            { className: css.thCantidadMuestra },
	                            'Dif'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thSuspendido },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Suspendido',
	                                filtro: this.props.filtros.filtroSuspendidos || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroSuspendidos')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thObservaciones },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Observaciones',
	                                filtro: this.props.filtros.filtroObservaciones || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroObservaciones')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thDescargaIrd },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Baja',
	                                filtro: this.props.filtros.filtroDescargaIrd || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroDescargaIrd')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thLink },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Zip',
	                                filtro: this.props.filtros.filtroZip || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroZip')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thLink },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Acta',
	                                filtro: this.props.filtros.filtroResultado || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroResultado')
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return TablaAuditoriaSemanal;
	}(_react2.default.Component);
	
	TablaAuditoriaSemanal.propTypes = {
	    // Objetos
	    filtros: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.array).isRequired,
	    // Metodos
	    ordenarAuditorias: _react2.default.PropTypes.func.isRequired,
	    actualizarFiltro: _react2.default.PropTypes.func.isRequired
	};
	exports.default = TablaAuditoriaSemanal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaAuditoriaSemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputFecha = __webpack_require__(633);
	
	var _InputFecha2 = _interopRequireDefault(_InputFecha);
	
	var _Select = __webpack_require__(647);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _InputObservaciones = __webpack_require__(743);
	
	var _InputObservaciones2 = _interopRequireDefault(_InputObservaciones);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaAuditoriaSemanal = __webpack_require__(615);
	
	var css = _interopRequireWildcard(_TablaAuditoriaSemanal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ObservacionCliente = __webpack_require__(745);
	
	var _ObservacionCliente2 = _interopRequireDefault(_ObservacionCliente);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Componentes
	
	
	// Styles
	
	
	var cx = _bind2.default.bind(css);
	
	var RowAuditoriaSemanal = function (_React$Component) {
	    _inherits(RowAuditoriaSemanal, _React$Component);
	
	    function RowAuditoriaSemanal(props) {
	        _classCallCheck(this, RowAuditoriaSemanal);
	
	        var _this = _possibleConstructorReturn(this, (RowAuditoriaSemanal.__proto__ || Object.getPrototypeOf(RowAuditoriaSemanal)).call(this, props));
	
	        _this.state = {
	            facturable: _this.props.auditoria.aud_facturable
	        };
	        return _this;
	    }
	
	    _createClass(RowAuditoriaSemanal, [{
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            if (elemento === 'dia') {
	                this.inputFecha.focus();
	            } else {
	                console.error('focusElemento(): Elemento "' + elemento + '" no encontrado');
	            }
	        }
	    }, {
	        key: 'onChangeFacturable',
	        value: function onChangeFacturable(e) {
	            var _this2 = this;
	
	            var data = {};
	            data.facturable = e.target.value == 0 ? 1 : 0;
	            _v2.default.auditoria.actualizar(this.props.auditoria.aud_idAuditoria, data).then(function (response) {
	                _this2.setState({
	                    facturable: data.facturable
	                }).catch(function (error) {
	                    console.log(error);
	                });
	            });
	        }
	    }, {
	        key: 'guardarAuditoria',
	        value: function guardarAuditoria() {
	            var cambiosAuditoria = {};
	            console.log('guardando auditoria');
	            if (this.props.puedeModificar) {
	                // la FECHA es valida, y ha cambiado?
	                var estadoInputFecha = this.inputFecha.getEstado();
	                if (estadoInputFecha.valid && estadoInputFecha.dirty) {
	                    cambiosAuditoria.fechaProgramada = estadoInputFecha.fecha;
	                } else if (estadoInputFecha.valid === false) {
	                    return console.log('fecha ' + estadoInputFecha.fecha + ' invalida');
	                }
	
	                // el AUDITOR ha cambiado?
	                var estadoSelectAuditor = this.selectAuditor.getEstado();
	                if (estadoSelectAuditor.dirty) cambiosAuditoria.idAuditor = estadoSelectAuditor.seleccionUsuario;
	
	                var estadoSelectSuspendida = this.selectSuspendida.getEstado();
	                if (estadoSelectSuspendida.dirty) cambiosAuditoria.idEstadoSuspendido = estadoSelectSuspendida.seleccionUsuario;
	
	                var estadoInputObservacion = this.inputObservacion.getEstado();
	                if (estadoInputObservacion.dirty) cambiosAuditoria.observacion = estadoInputObservacion.valor;
	
	                var estadoInputObservacionCliente = this.inputObservacionCliente ? this.inputObservacionCliente.getEstado() : null;
	                if (estadoInputObservacionCliente && estadoInputObservacionCliente.dirty) cambiosAuditoria.observacion_cliente = estadoInputObservacionCliente.valor;
	
	                var perecible = this.props.auditoria.aud_perecible;
	                cambiosAuditoria.perecible = perecible;
	            }
	            // almenos uno de los ementos debe estar "dirty" para guardar los cambios
	            if (JSON.stringify(cambiosAuditoria) !== "{}") {
	                this.props.guardarAuditoria(this.props.auditoria.aud_idAuditoria, cambiosAuditoria);
	            } else {
	                console.log('auditoria sin cambios, no se actualiza');
	            }
	        }
	    }, {
	        key: 'eliminarAuditoria',
	        value: function eliminarAuditoria() {
	            if (!this.props.puedeModificar) return alert('no tiene permisos para realizar esta acción');
	            this.props.eliminarAuditoria(this.props.auditoria);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var auditor = this.props.auditoria.aud_auditor ? [{ valor: this.props.auditoria.aud_idAuditor, texto: this.props.auditoria.aud_auditor }] : [];
	            var Auditores = this.props.auditores.map(function (usuario) {
	                return { valor: usuario.id, texto: usuario.nombre1 + ' ' + usuario.apellidoPaterno };
	            });
	            var opcionesAuditores = auditor.concat(Auditores);
	            return _react2.default.createElement(
	                'tr',
	                { className: (this.props.mostrarSeparador ? css.trSeparador : '') + ' ', style: {
	                        backgroundColor: this.props.auditoria.aud_sensores ? 'rgb(224 242 254)' : this.props.auditoria.aud_smuBodega ? 'rgb(224 231 255)' : this.props.auditoria.aud_perecible ? 'rgb(220 183 245)' : 'white'
	                    } },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCorrelativo2 },
	                    _react2.default.createElement(
	                        'p',
	                        { title: this.props.auditoria.aud_idAuditoria },
	                        this.props.index + 1
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCorrelativo },
	                    this.props.auditoria.aud_sensores == 0 && this.props.auditoria.aud_smuBodega == 0 && !this.props.auditoria.aud_perecible && this.props.puedeVerExcelFacturacion ? _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', gap: '2px' } },
	                        _react2.default.createElement('input', { type: 'checkbox', value: this.state.facturable, checked: this.state.facturable == 1 ? true : false, onChange: this.onChangeFacturable.bind(this) }),
	                        _react2.default.createElement(_ObservacionCliente2.default, {
	                            refer: function refer(ref) {
	                                return _this3.inputObservacionCliente = ref;
	                            },
	                            idAuditoria: this.props.auditoria.aud_idAuditoria,
	                            observacion: this.props.auditoria.aud_observacion_cliente,
	                            onGuardar: this.guardarAuditoria.bind(this),
	                            puedeModificar: this.props.puedeModificar
	                        })
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    _react2.default.createElement(_InputFecha2.default, {
	                        puedeModificar: this.props.puedeModificar //this.props.auditoria.aud_idAuditoriaOriginal ? false : this.props.puedeModificar
	                        , ref: function ref(_ref) {
	                            return _this3.inputFecha = _ref;
	                        },
	                        diaSemana: this.props.auditoria.aud_fechaProgramadaDOW,
	                        fechaConProblemas: this.props.auditoria.local_topeFechaConInventario,
	                        fecha: this.props.auditoria.aud_fechaProgramada,
	                        onGuardar: this.guardarAuditoria.bind(this),
	                        focusRowAnterior: function focusRowAnterior() {
	                            return _this3.props.focusRow(_this3.props.index - 1, 'dia');
	                        },
	                        focusRowSiguiente: function focusRowSiguiente() {
	                            return _this3.props.focusRow(_this3.props.index + 1, 'dia');
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.auditoria.cliente_nombreCorto
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            this.props.auditoria.local_ceco
	                        ),
	                        this.props.auditoria.ultimas_ai ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: {
	                                        display: 'flex',
	                                        flexDirection: 'column',
	                                        alignItems: 'flex-start'
	                                    } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Ultima Auditoria:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '- Fecha: ',
	                                    this.props.auditoria.ultimas_ai.fecha
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '- Auditor: ',
	                                    this.props.auditoria.ultimas_ai.auditor
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '- Venc: ',
	                                    this.props.auditoria.ultimas_ai.muestra_venc
	                                )
	                            )
	                        ) : _react2.default.createElement(
	                            'span',
	                            null,
	                            'Sin registros'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTienda },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                this.props.auditoria.local_nombre
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.auditoria.local_region
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { margin: 0 } },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                this.props.auditoria.local_comuna
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDireccion },
	                    this.props.auditoria.local_gmap_latitud && this.props.auditoria.local_gmap_longitud ? _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.google.com/maps/search/?api=1&query=' + this.props.auditoria.local_gmap_latitud + ', ' + this.props.auditoria.local_gmap_longitud,
	                            target: '_blank' },
	                        this.props.auditoria.local_direccion,
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-map-marker' })
	                    ) : this.props.auditoria.local_direccion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAuditor },
	                    _react2.default.createElement(_Select2.default, {
	                        ref: function ref(_ref2) {
	                            return _this3.selectAuditor = _ref2;
	                        },
	                        seleccionada: this.props.auditoria.aud_idAuditor ? '' + this.props.auditoria.aud_idAuditor : '' // debe ser string
	                        , onSelect: this.guardarAuditoria.bind(this),
	                        opciones: opcionesAuditores,
	                        opcionNula: true,
	                        opcionNulaSeleccionable: true,
	                        puedeModificar: this.props.puedeModificar })
	                ),
	                this.props.puedeRevisarCantidadMuestras ? _react2.default.createElement(
	                    'td',
	                    { className: css.tdCantidadMuestra },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        this.props.auditoria.aud_mvencimientoDisponible,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'StocK: ',
	                            this.props.auditoria.local_stockF
	                        )
	                    )
	                ) : _react2.default.createElement('td', null),
	                this.props.puedeRevisarCantidadMuestras ? _react2.default.createElement(
	                    'td',
	                    { className: css.tdCantidadMuestra },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.textoConTooltip },
	                        this.props.auditoria.aud_mvencimientoDiferencia,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Stock: ',
	                            this.props.auditoria.local_stockF
	                        )
	                    )
	                ) : _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSuspendido },
	                    _react2.default.createElement(_Select2.default, {
	                        ref: function ref(_ref3) {
	                            return _this3.selectSuspendida = _ref3;
	                        },
	                        seleccionada: this.props.auditoria.aud_suspendida ? '' + this.props.auditoria.aud_suspendida : '',
	                        onSelect: this.guardarAuditoria.bind(this),
	                        opciones: [{ valor: '1', texto: 'No aplica' }, { valor: '2', texto: 'Remodelación' }, { valor: '3', texto: 'Falta Personal' }, { valor: '4', texto: 'Corte electricidad' }, { valor: '5', texto: 'QF suspende' }, { valor: '6', texto: 'Auditor no asiste' }, { valor: '9', texto: 'Pago 50%' }, { valor: '8', texto: 'Fase 2' }, { valor: '10', texto: 'Medición Especial' }, { valor: '11', texto: 'No Pago' }, { valor: '7', texto: 'Otro' }],
	                        puedeModificar: !this.props.auditoria.aud_perecible ? this.props.puedeModificar : false
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdObservaciones },
	                    _react2.default.createElement(_InputObservaciones2.default, {
	                        ref: function ref(_ref4) {
	                            return _this3.inputObservacion = _ref4;
	                        },
	                        asignada: this.props.auditoria.aud_observacion ? '' + this.props.auditoria.aud_observacion : '' // pide en string
	                        , tooltipText: 'Observaciones',
	                        onGuardar: this.guardarAuditoria.bind(this),
	                        puedeModificar: !this.props.auditoria.aud_perecible ? this.props.puedeModificar : false
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDescargaIrd },
	                    !this.props.auditoria.aud_sensores && this.props.auditoria.cliente_idCliente != 19 && (this.props.auditoria.aud_descarga_ird ? _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-xs btn-success' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok-circle' })
	                    ) : _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-xs btn-danger' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-dashboard' })
	                    ))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLink },
	                    _react2.default.createElement(ArchivoFinal, { auditoria: this.props.auditoria, fcv: this.props.fcv })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLink },
	                    _react2.default.createElement(Revision, { auditoria: this.props.auditoria, puedeModificar: this.props.puedeModificar })
	                )
	            );
	        }
	    }]);
	
	    return RowAuditoriaSemanal;
	}(_react2.default.Component);
	
	var Revision = function Revision(_ref5) {
	    var auditoria = _ref5.auditoria,
	        puedeModificar = _ref5.puedeModificar;
	
	    if (auditoria.cliente_idCliente == 19) {
	
	        if (auditoria.aud_revisada) {
	            return _react2.default.createElement(
	                'a',
	                { className: 'btn btn-xs btn-info', href: '/auditoriaSCF/' + auditoria.aud_idAuditoria + '/revision', target: '_blank' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	            );
	        }
	        if (!puedeModificar) {
	            return null;
	        }
	        return _react2.default.createElement(
	            'a',
	            {
	                className: auditoria.aud_estadoArchivoFinal == 'por publicar' ? "btn btn-xs btn-danger" : "btn btn-xs btn-success",
	                href: '/auditoriaSCF/' + auditoria.aud_idAuditoria + '/revision',
	                target: '_blank'
	            },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	        );
	    }
	
	    return auditoria.aud_realizadaInformada ? _react2.default.createElement(
	        'a',
	        { className: "btn btn-xs btn-info", href: '/auditoria/' + auditoria.aud_idAuditoria + '/revision', target: '_blank' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	    ) : _react2.default.createElement(
	        'a',
	        { className: auditoria.aud_estadoArchivoFinal == 'por publicar' ? "btn btn-xs btn-danger" : "btn btn-xs btn-success", href: '/auditoria/' + auditoria.aud_idAuditoria + '/revision', target: '_blank' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	    );
	};
	
	var ArchivoFinal = function ArchivoFinal(_ref6) {
	    var auditoria = _ref6.auditoria,
	        fcv = _ref6.fcv;
	
	
	    if (auditoria.cliente_idCliente == 19) {
	        return auditoria.aud_estadoArchivoFinal == 'por publicar' ? _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-danger', href: '/auditoriaSCF/' + auditoria.aud_idAuditoria + '/archivo-final', target: "_blank" },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	        ) : _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-success', href: '/auditoriaSCF/' + auditoria.aud_idAuditoria + '/archivo-final', target: '_blank' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-compressed' })
	        );
	    }
	
	    if (auditoria.aud_smuBodega || auditoria.aud_perecible) {
	        return auditoria.aud_estadoArchivoFinal == 'por publicar' ? _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-danger', href: '#' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	        ) : _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-success', href: '#' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-compressed' })
	        );
	    }
	
	    return auditoria.aud_estadoArchivoFinal == 'por publicar' ? _react2.default.createElement(
	        'a',
	        { className: 'btn btn-xs btn-danger', href: fcv ? null : '/auditoria/' + auditoria.aud_idAuditoria + '/' + (auditoria.aud_sensores ? 'archivo-final-sensores' : 'archivo-final'), target: fcv ? '' : "_blank" },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' })
	    ) : _react2.default.createElement(
	        'a',
	        { className: 'btn btn-xs btn-success', href: fcv && auditoria.aud_sensores ? null : '/auditoria/' + auditoria.aud_idAuditoria + '/' + (auditoria.aud_sensores ? 'archivo-final-sensores' : 'archivo-final'), target: '_blank' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-compressed' })
	    );
	};
	
	RowAuditoriaSemanal.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    puedeRevisar: _react2.default.PropTypes.bool.isRequired,
	    index: _react2.default.PropTypes.number.isRequired,
	    auditoria: _react2.default.PropTypes.object.isRequired,
	    auditores: _react2.default.PropTypes.array.isRequired,
	    mostrarSeparador: _react2.default.PropTypes.bool.isRequired,
	    // Metodos
	    guardarAuditoria: _react2.default.PropTypes.func.isRequired,
	    eliminarAuditoria: _react2.default.PropTypes.func.isRequired,
	    focusRow: _react2.default.PropTypes.func.isRequired
	};
	RowAuditoriaSemanal.defaultProps = {
	    mostrarSeparador: false
	};
	
	exports.default = RowAuditoriaSemanal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowAuditoriaSemanal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputObservaciones = __webpack_require__(744);
	
	var css = _interopRequireWildcard(_InputObservaciones);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	// Estilos
	
	
	var InputObservaciones = function (_React$Component) {
	    _inherits(InputObservaciones, _React$Component);
	
	    function InputObservaciones(props) {
	        _classCallCheck(this, InputObservaciones);
	
	        var _this = _possibleConstructorReturn(this, (InputObservaciones.__proto__ || Object.getPrototypeOf(InputObservaciones)).call(this, props));
	
	        _this.state = {
	            valor: '-',
	            dirty: false,
	            valid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputObservaciones, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                valor: this.props.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            this.setState({
	                valor: nextProps.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                //this.props.onGuardar()    // se guarda al perder el focus
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var valorUsuario = evt.target.value;
	            this.setState({
	                valor: valorUsuario,
	                dirty: this.props.asignada != valorUsuario,
	                valid: valorUsuario >= 0
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputStock.focus();
	            this.inputStock.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var classname = this.state.valid ? this.state.dirty ? css.inputStockDirty : css.inputStock : css.inputStockInvalida;
	            return _react2.default.createElement(
	                'div',
	                { className: css.divConTooltip },
	                _react2.default.createElement('input', {
	                    className: classname + " " + this.props.className,
	                    style: this.props.style,
	                    ref: function ref(_ref) {
	                        return _this2.inputStock = _ref;
	                    },
	                    type: 'text',
	                    value: this.state.valor,
	                    onKeyDown: this.inputOnKeyDown.bind(this),
	                    onChange: this.onInputChange.bind(this),
	                    onBlur: function onBlur() {
	                        return _this2.props.onGuardar();
	                    },
	                    onFocus: function onFocus() {
	                        _this2.inputStock.select();
	                    } // seleccionar el texto cuando se hace focus
	                    , disabled: this.props.puedeModificar ? '' : 'disabled'
	                }),
	                this.props.tooltipText ? _react2.default.createElement(
	                    'div',
	                    { className: css.tooltip },
	                    this.props.tooltipText
	                ) : null
	            );
	        }
	    }]);
	
	    return InputObservaciones;
	}(_react2.default.Component);
	
	InputObservaciones.propTypes = {
	    // Objetos
	    puedeModificar: _react2.default.PropTypes.bool.isRequired,
	    asignada: _react2.default.PropTypes.string.isRequired,
	    tooltipText: _react2.default.PropTypes.string,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func,
	    focusRowSiguiente: _react2.default.PropTypes.func,
	    onGuardar: _react2.default.PropTypes.func.isRequired
	};
	exports.default = InputObservaciones;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputObservaciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inputStock":"InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","inputStockDirty":"InputObservaciones__inputStockDirty___1kxvz InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","inputStockInvalida":"InputObservaciones__inputStockInvalida___2B40u InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","divConTooltip":"InputObservaciones__divConTooltip___326Gi","tooltip":"InputObservaciones__tooltip___2jalV"};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _ObservacionCliente = __webpack_require__(746);
	
	var css = _interopRequireWildcard(_ObservacionCliente);
	
	var _InputObservaciones = __webpack_require__(743);
	
	var _InputObservaciones2 = _interopRequireDefault(_InputObservaciones);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObservacionCliente = function (_Component) {
	    _inherits(ObservacionCliente, _Component);
	
	    function ObservacionCliente(props) {
	        _classCallCheck(this, ObservacionCliente);
	
	        var _this = _possibleConstructorReturn(this, (ObservacionCliente.__proto__ || Object.getPrototypeOf(ObservacionCliente)).call(this, props));
	
	        _this.state = {
	            show: false,
	            observacion: _this.props.observacion,
	            editando: false
	        };
	        return _this;
	    }
	
	    _createClass(ObservacionCliente, [{
	        key: "handleClick",
	        value: function handleClick(e) {
	            this.setState({
	                target: e.target,
	                show: !this.state.show
	            });
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: "cancelarEditar",
	        value: function cancelarEditar() {
	            this.setState({
	                editando: false,
	                input: ""
	            });
	        }
	
	        /*updateobservacion(observacion) {
	            this.setState({
	                observacion: observacion,
	                tiene: observacion.length > 0 ? true : false
	            })
	        }*/
	
	        /*traerLogistica(){
	            this.setState({
	                enableGet: false
	            });
	            api.logistica.getLogistica(this.props.idLocal)
	            .then(resp => {
	                this.setState({
	                    logistica: resp,
	                    enableGet: true,
	                })
	            })
	            .catch(err => {
	                console.log("Error al traer logistica")
	            })
	        }*/
	
	        /*componentDidUpdate(prevProps) {
	            if (prevProps.observacion !== this.props.observacion) {
	                this.setState({
	                    observacion: this.props.observacion,
	                    tiene: true
	                })
	            }
	        }*/
	
	    }, {
	        key: "render",
	        value: function render() {
	            var styles = this.state.observacion !== 'Sin observaciones' ? { color: '#337AB7', cursor: 'pointer', verticalAlign: 'middle', alignContent: 'center', marginLeft: '2px' } : { color: '#5CB85C', verticalAlign: 'middle', alignContent: 'center', marginLeft: '2px' };
	            return _react2.default.createElement(
	                "div",
	                { style: this.state.show ? { backgroundColor: "#17b485" } : {} },
	                _react2.default.createElement(
	                    "p",
	                    { onClick: this.handleClick.bind(this), style: styles },
	                    this.state.observacion !== 'Sin observaciones' ? _react2.default.createElement("i", { className: "glyphicon glyphicon-info-sign", style: styles }) : _react2.default.createElement("i", { className: "glyphicon glyphicon-plus", style: styles })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    {
	                        show: this.state.show,
	                        target: this.state.target,
	                        placement: "right",
	                        onHide: this.handleClose.bind(this),
	                        rootClose: true
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            id: this.props.idAuditoria,
	                            bsClass: css.observacion_popover + " popover"
	                        },
	                        _react2.default.createElement(_InputObservaciones2.default, {
	                            ref: this.props.refer,
	                            asignada: this.props.observacion // pide en string
	                            , onGuardar: this.props.onGuardar,
	                            puedeModificar: this.props.puedeModificar
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ObservacionCliente;
	}(_react.Component);
	
	exports.default = ObservacionCliente;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ObservacionCliente.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"observacion_popover":"ObservacionCliente__observacion_popover___3keg7","observacion_container":"ObservacionCliente__observacion_container___XToEl","formulario":"ObservacionCliente__formulario___1VBW9","observacion_mensaje":"ObservacionCliente__observacion_mensaje___10RFv","nombre":"ObservacionCliente__nombre___33yw0","boton":"ObservacionCliente__boton___2MD32","textoConTooltip":"ObservacionCliente__textoConTooltip___Dfi0x","mytextarea":"ObservacionCliente__mytextarea___2wL_G","editar":"ObservacionCliente__editar___2eDPk","input_observacion_editable":"ObservacionCliente__input_observacion_editable___34lO7","input_observacion_pointer":"ObservacionCliente__input_observacion_pointer___q6lH-"};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalAuditorMasivo = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(748);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalAuditorMasivo = exports.ModalAuditorMasivo = function (_React$Component2) {
	    _inherits(ModalAuditorMasivo, _React$Component2);
	
	    function ModalAuditorMasivo(props) {
	        _classCallCheck(this, ModalAuditorMasivo);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalAuditorMasivo.__proto__ || Object.getPrototypeOf(ModalAuditorMasivo)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false
	        };
	        _this2.confirmar = function () {
	            _this2.setState({ bloqueado: true });
	            var cambiosAuditoria = {};
	            cambiosAuditoria.idAuditor = _this2.props.idAuditorMasivo;
	            _this2.props.auditorMultiple(cambiosAuditoria).then(function () {
	                _this2.setState({ bloqueado: false });
	                _this2.props.hideModal();
	            }).catch(function (err) {
	                console.error(err.data);
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalAuditorMasivo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Favor confirmar la asignaci\xF3n multiple'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\xBFEsta seguro de asignar un total de ',
	                        this.props.totalAuditorias,
	                        ' auditorias a ',
	                        this.props.auditor ? this.props.auditor.nombre1 : 'SIN',
	                        ' ',
	                        this.props.auditor ? this.props.auditor.apellidoPaterno : 'AUDITOR',
	                        '?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.confirmar, disabled: this.state.bloqueado },
	                        'Agregar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAuditorMasivo;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modale":"modal__modale___13Nee","modalConfirmacion":"modal__modalConfirmacion___3L5xN","modalAmplio":"modal__modalAmplio___3iTRa","modalEnvioNominas":"modal__modalEnvioNominas___2f_cy","modalHistorialNomina":"modal__modalHistorialNomina___1qY40","modalAumentoDot":"modal__modalAumentoDot___2X3h-","modalCambioDot":"modal__modalCambioDot___IDxSe","modalCambiosNomina":"modal__modalCambiosNomina___74z9K","modalPublicacionIG":"modal__modalPublicacionIG___olPYH","modalAdminBilling":"modal__modalAdminBilling___2WgEN","modalPDALider":"modal__modalPDALider___klULA","modalCantidades":"modal__modalCantidades___D-dCz","modalApproveReview":"modal__modalApproveReview___2DzjR","headerColumn":"modal__headerColumn___1uAwz","headerColumnAumentoDot":"modal__headerColumnAumentoDot___2Mu4d","headerRow":"modal__headerRow___12C1T","evenRow":"modal__evenRow___LDnoj","oddRow":"modal__oddRow___284VP","modalPDADisponibles":"modal__modalPDADisponibles____6Gxm","modalPDATotales":"modal__modalPDATotales___FMlR4","modalPDATotalesBorde":"modal__modalPDATotalesBorde___3mkBL","modalPDATotalesRow":"modal__modalPDATotalesRow___3Q1t9","oprarioData":"modal__oprarioData___2Kj28","comentarioCambio":"modal__comentarioCambio___1a3-T","btnModal":"modal__btnModal___2k1Hy","glyphicon":"modal__glyphicon___3-tbx","labelCantidad":"modal__labelCantidad___1b7bs","panelHeading":"modal__panelHeading___37shf","trSeparator":"modal__trSeparator___1nE1c"};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaResumenMensual = __webpack_require__(750);
	
	var _TablaResumenMensual2 = _interopRequireDefault(_TablaResumenMensual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResumenMensual = function (_React$Component) {
	    _inherits(ResumenMensual, _React$Component);
	
	    function ResumenMensual(props) {
	        _classCallCheck(this, ResumenMensual);
	
	        var _this = _possibleConstructorReturn(this, (ResumenMensual.__proto__ || Object.getPrototypeOf(ResumenMensual)).call(this, props));
	
	        _this.state = {
	            visible: false,
	            data: {
	                auditorias: {
	                    totales: [],
	                    regiones: []
	                },
	                sensores: {
	                    totales: [],
	                    regiones: []
	                }
	            },
	            pestaña: "auditorias"
	        };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ResumenMensual, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _v2.default.auditoria.getResumenEstadoMesActual().then(function (response) {
	                console.log(response);
	                _this2.setState({
	                    data: {
	                        auditorias: {
	                            totales: response.auditorias.totales,
	                            regiones: response.auditorias.regiones
	                        },
	                        sensores: {
	                            totales: response.sensores.totales,
	                            regiones: response.sensores.regiones
	                        }
	                    }
	                });
	            }).catch(function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'cambiarPesta\xF1a',
	        value: function cambiarPestaA() {
	            this.setState({
	                pestaña: this.state.pestaña == "auditorias" ? "sensores" : "auditorias"
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-warning btn-xs', onClick: this.show },
	                    'Resumen Estado Mensual'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: this.state.visible, onHide: this.hide, bsSize: 'large' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: "flex", gap: "12px", alignItems: "center" } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Estado general de auditor\xEDas'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: this.cambiarPestaña.bind(this), style: { backgroundColor: "rgb(59 130 246)", color: "white", textTransform: "capitalize", padding: "4px 12px", borderRadius: "8px", border: "none" } },
	                                    'Ver ',
	                                    this.state.pestaña == "auditorias" ? "Resumen Sensores" : "Resumen Auditorias"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(_TablaResumenMensual2.default, { data: this.state.data[this.state.pestaña] })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResumenMensual;
	}(_react2.default.Component);
	
	exports.default = ResumenMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ResumenMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TablaResumenMensual = function (_React$Component) {
	  _inherits(TablaResumenMensual, _React$Component);
	
	  function TablaResumenMensual(props) {
	    _classCallCheck(this, TablaResumenMensual);
	
	    return _possibleConstructorReturn(this, (TablaResumenMensual.__proto__ || Object.getPrototypeOf(TablaResumenMensual)).call(this, props));
	  }
	
	  _createClass(TablaResumenMensual, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "table",
	        {
	          className: "table table-bordered table-condensed table-hover table-condensed",
	          style: {
	            fontSize: "11px",
	            textAlign: "center"
	          }
	        },
	        _react2.default.createElement(
	          "thead",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { colSpan: "3" }),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "Programadas"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "Suspendidas"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center", colSpan: "2" },
	              "Completadas"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center", colSpan: "2" },
	              "Pendientes"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "text-center", colSpan: "3" },
	              "Regiones"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "Total"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "Total"
	            ),
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "%"
	            ),
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "th",
	              { className: "text-center" },
	              "%"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tbody",
	          null,
	          this.props.data.regiones.length == 0 ? _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { colSpan: 6 },
	              "Cargando..."
	            )
	          ) : this.props.data.regiones.map(function (region, index) {
	            var label1 = region.terminadasPorcentaje <= 25 ? "danger" : region.terminadasPorcentaje <= 75 ? "warning" : "success";
	            var label2 = region.pendientesPorcentajeTerminar <= 25 ? "danger" : region.pendientesPorcentajeTerminar <= 75 ? "warning" : "success";
	            return _react2.default.createElement(
	              "tr",
	              { key: index },
	              _react2.default.createElement(
	                "td",
	                { colSpan: "3" },
	                region.nombreRegion
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  region.totalMes
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  region.suspendidas
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  region.terminadas
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { className: "label label-" + label1 },
	                  region.terminadasPorcentaje,
	                  "%"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  region.pendientesTerminar
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "label label-" + label2,
	                    style: {
	                      fontSize: "10px",
	                      width: "35px"
	                    }
	                  },
	                  region.pendientesPorcentajeTerminar,
	                  "%"
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "tfoot",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { colSpan: "3" },
	              _react2.default.createElement(
	                "b",
	                null,
	                "Total / Promedio"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.total
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.suspendidas
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.terminadas
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.terminadasPorcentaje,
	                "%"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.pendientesTerminar
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                this.props.data == 0 ? 0 : this.props.data.totales.pendientesPorcentajeTerminar,
	                "%"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TablaResumenMensual;
	}(_react2.default.Component);
	
	exports.default = TablaResumenMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaResumenMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(491);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacturacionMensual = function (_React$Component) {
	    _inherits(FacturacionMensual, _React$Component);
	
	    function FacturacionMensual(props) {
	        _classCallCheck(this, FacturacionMensual);
	
	        var _this = _possibleConstructorReturn(this, (FacturacionMensual.__proto__ || Object.getPrototypeOf(FacturacionMensual)).call(this, props));
	
	        _this.handleDownloadExcel = function (fechaMes) {
	            try {
	                var url = '/auditorias/excel-facturacion/' + fechaMes;
	                var link = document.createElement('a');
	                link.href = url;
	                link.setAttribute('download', 'facturacion_ird_' + fechaMes + '.xlsx');
	                document.body.appendChild(link);
	                link.click();
	                document.body.removeChild(link);
	            } catch (error) {
	                console.log(error);
	            }
	        };
	
	        _this.renderMonthsButtons = function () {
	            var currentDate = new Date();
	            var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	
	            var monthsInRange = [];
	            var year = currentDate.getFullYear();
	            var month = currentDate.getMonth();
	
	            for (var i = 0; i < 12; i++) {
	                monthsInRange.push({ month: month, year: year });
	                if (month === 0) {
	                    month = 11;
	                    year--;
	                } else {
	                    month--;
	                }
	            }
	
	            return monthsInRange.map(function (_ref, index) {
	                var month = _ref.month,
	                    year = _ref.year;
	
	                var mes = month + 1;
	                if (mes < 10) {
	                    mes = '0' + mes;
	                }
	                var fechaLink = year + '-' + mes + '-01';
	                var formattedDate = months[month] + ' ' + year;
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-4', key: index, style: { display: 'flex', justifyContent: 'center', marginBottom: '2px' } },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '/auditorias/excel-facturacion/' + fechaLink,
	                            className: 'btn btn-primary',
	                            style: { width: '150px' }
	                            //onClick={() => this.handleDownloadExcel(fechaLink)}
	                        },
	                        formattedDate
	                    )
	                );
	            });
	        };
	
	        _this.state = {
	            visible: false
	        };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(FacturacionMensual, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-success btn-xs', onClick: this.show },
	                    'Detalle Mensual'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { show: this.state.visible, onHide: this.hide },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: "flex", gap: "12px", alignItems: "center" } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Seleccione fecha para ver facturaci\xF3n'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            this.renderMonthsButtons()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FacturacionMensual;
	}(_react2.default.Component);
	
	exports.default = FacturacionMensual;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FacturacionMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var HeaderConFiltro = function (_React$Component) {
	  _inherits(HeaderConFiltro, _React$Component);
	
	  function HeaderConFiltro(props) {
	    _classCallCheck(this, HeaderConFiltro);
	
	    var _this = _possibleConstructorReturn(this, (HeaderConFiltro.__proto__ || Object.getPrototypeOf(HeaderConFiltro)).call(this, props));
	
	    _this.state = {
	      open: false,
	      filtro: []
	    };
	    return _this;
	  }
	
	  _createClass(HeaderConFiltro, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // actualizar el filtro cuando se reciban nuevas propiedades
	      this.setState({ filtro: nextProps.filtro });
	    }
	  }, {
	    key: "onSelect",
	    value: function onSelect(evt) {
	      var _this2 = this;
	
	      var valorSeleccionado = evt.target.value;
	      this.setState({
	        filtro: this.state.filtro.map(function (opcion) {
	          if (valorSeleccionado === "todas") {
	            return {
	              seleccionado: true,
	              texto: opcion.texto,
	              valor: opcion.valor
	            };
	          }
	          if (valorSeleccionado === "auditorias") {
	            return {
	              seleccionado: opcion.valor == 0,
	              texto: opcion.texto,
	              valor: opcion.valor
	            };
	          }
	          if (valorSeleccionado === "sensores") {
	            return {
	              seleccionado: opcion.valor > 0,
	              texto: opcion.texto,
	              valor: opcion.valor
	            };
	          }
	        })
	      }, function () {
	        return _this2.props.actualizarFiltro(_this2.state.filtro);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: { display: "flex", flexDirection: "column", width: "120px" }
	          },
	          _react2.default.createElement(
	            "b",
	            { className: "font-weight-bold" },
	            this.props.nombre
	          ),
	          _react2.default.createElement(
	            "select",
	            { className: "form-control", onChange: this.onSelect.bind(this) },
	            _react2.default.createElement(
	              "option",
	              { value: "todas" },
	              "Todas"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "auditorias" },
	              "Solo Auditorias"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "sensores" },
	              "Solo Sensores"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderConFiltro;
	}(_react2.default.Component);
	
	HeaderConFiltro.propTypes = {
	  nombre: PropTypes.string,
	  busquedaExacta: PropTypes.bool,
	  filtro: PropTypes.arrayOf(PropTypes.object).isRequired,
	  // Metodos
	  actualizarFiltro: PropTypes.func.isRequired,
	  ordenarLista: PropTypes.func
	};
	HeaderConFiltro.defaultProps = {
	  nombre: "[sin nombre]",
	  busquedaExacta: false,
	  ordenarLista: null
	};
	exports.default = HeaderConFiltro;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "CheckboxSensores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NominaIG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _nominaIG = __webpack_require__(754);
	
	var css = _interopRequireWildcard(_nominaIG);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormularioUsuario = __webpack_require__(755);
	
	var _PanelDatos = __webpack_require__(916);
	
	var _PanelEstados = __webpack_require__(925);
	
	var _PanelCaptador = __webpack_require__(928);
	
	var _Modales = __webpack_require__(955);
	
	var _Modales2 = __webpack_require__(918);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Services
	
	// Styles
	
	// Componentes
	
	
	var NominaIG = exports.NominaIG = function (_Component) {
	    _inherits(NominaIG, _Component);
	
	    function NominaIG(props) {
	        _classCallCheck(this, NominaIG);
	
	        var _this = _possibleConstructorReturn(this, (NominaIG.__proto__ || Object.getPrototypeOf(NominaIG)).call(this, props));
	
	        _this.abrirModalGPS = function () {
	            _this.setState({ modalGPS: true });
	        };
	
	        _this.state = {
	            alternateLeaders: [],
	            showModalNuevoUsuario: false,
	            showModalSuspendOperator: false,
	            showModalBlockOperador: false,
	            RUNbuscado: '',
	            operatorSuspend: '',
	            blockOperador: '',
	            idNomina: '',
	            esTitular: true,
	            nomina: _this.props.nomina,
	            quitarOperador: false,
	            nuevoOperador: false,
	            modalGPS: false,
	            showModalMasTiempo: false,
	            cantUserPermisoMall: 0
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                //CODIGO 420 DEL ENROQUE DE OPERADORES
	                if (err.status == 420) {
	                    var _msgs = _lodash2.default.values(err.data.error.idNomina);
	                    return _this.refs.notificator.error(errorTitle, _msgs, 4 * 1000);
	                }
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _lodash2.default.values(err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.cancelFormNewUser = function () {
	            _this.setState({ showModalNuevoUsuario: false });
	        };
	        _this.cancelSuspendOperator = function () {
	            _this.setState({ showModalSuspendOperator: false });
	        };
	        _this.cancelBlockOperador = function () {
	            _this.setState({ showModalBlockOperador: false });
	        };
	        _this.cancelModalGPS = function () {
	            _this.setState({ modalGPS: false });
	        };
	        _this.cancelModalMasTiempo = function () {
	            _this.setState({ showModalMasTiempo: false });
	        };
	        _this.onNewUser = function (datos) {
	            var banco = _this.props.bancos.find(function (banco) {
	                return banco.nombreCorto == datos.banco;
	            });
	            var tipoCuenta = _this.props.tipoCuentas.find(function (cuenta) {
	                return cuenta.nombreCuenta == datos.tipoCuenta;
	            });
	            datos.banco = banco.idBanco;
	            datos.tipoCuenta = tipoCuenta.idCuenta;
	
	            _v2.default.usuarios.nuevoOperador(datos).then(function (usuario) {
	                _v2.default.nomina(_this.props.nomina.idNomina).agregarOperador(usuario.usuarioRUN, _this.state.esTitular, 1).then(function (response) {
	                    var nominaActualizada = response.data;
	                    var statusCode = response.status;
	                    if (statusCode == 204) {
	                        console.log("RUN no existe, mostrando formulario");
	                        // this.setState({
	                        //     showModalNuevoUsuario: true,
	                        //     RUNbuscado: run,
	                        // })
	                        _this.refs.notificator.info("Nómina", "No existe Usuario", 4 * 1000);
	                    } else if (statusCode == 200) {
	                        _this.refs.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
	                        _this.setState({ nomina: nominaActualizada });
	                    } else if (statusCode == 205) {
	                        _this.refs.notificator.info("Nóminas", "Operador pendiente de aprobación", 4 * 1000);
	                        // this.setState({nomina: nominaActualizada})
	                    } else if (statusCode == 203) {
	                        _this.refs.notificator.info("Nóminas", "Operador pendiente de firma de contrato", 4 * 1000);
	                        // this.setState({nomina: nominaActualizada})
	                    } else if (statusCode == 206) {
	                        _this.refs.notificator.info("Nóminas", "Operador pendiente de firma de contrato", 4 * 1000);
	                        // this.setState({nomina: nominaActualizada})
	                    }
	                }).catch(_this.ajaxErrorHandler('Agregar Operador'));
	                _this.setState({ showModalNuevoUsuario: false });
	            }).catch(function (err) {
	                console.log(err);
	                alert(err.data);
	            });
	        };
	        _this.getAlternateLeaders = function () {
	            _v2.default.nomina(_this.state.nomina.idNomina).getAlternateLeaders().then(function (resp) {
	                _this.setState({
	                    alternateLeaders: resp
	                });
	            }).catch(function (errr) {
	                return console.log(errr);
	            });
	        };
	        // notify
	        _this.notifyStoreInMall = function () {
	            if (_this.props.nomina.local_mall) _this.refs.notificator.info("Atención", "Para su información el local se encuentra en un MALL.", 6 * 1000);
	        };
	        _this.notifyPendingApprovals = function () {
	            if (_this.state.nomina.operadoresPendientes && _this.state.nomina.idEstadoNomina == 4) _this.refs.notificator.info("Nómina", "La nómina tiene operadores pendientes de aprobación", 6 * 1000);
	        };
	        _this.notifyMoreTime = function () {
	            if (_this.state.nomina && _this.state.nomina.mas_tiempo.length > 0) _this.setState({ showModalMasTiempo: true });
	        };
	        // status lists functions
	        _this.sendList = function () {
	            var existeUsuarioConEstadoContrato1 = _this.state.nomina.captadorSEI.dotacionTitular.some(function (usuario) {
	                return usuario.idEstadoContrato !== 2;
	            });
	            // if (existeUsuarioConEstadoContrato1) {
	            //     console.log("Existe un usuario con contrato pendiente o expirado");
	            //     this.refs.notificator.error("Nómina", "La nómina tiene operadores con contrato no resuelto", 6 * 1000)
	            // } else {
	            return _v2.default.nomina(_this.state.nomina.idNomina).enviar().then(function (nomina) {
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('error al enviar nomina'));
	            // }
	        };
	        _this.approveList = function () {
	            return _v2.default.nomina(_this.state.nomina.idNomina).aprobar().then(function (nomina) {
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.state.nomina.operadoresPendientes ? _this.refs.notificator.info("Nómina", "La nómina tiene operadores pendientes de aprobación", 6 * 1000) : null;
	                });
	            }).catch(_this.ajaxErrorHandler('error al aprobar nomina'));
	        };
	        _this.rejectList = function () {
	            return _v2.default.nomina(_this.state.nomina.idNomina).rechazar().then(function (nomina) {
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('error al rechazar nomina'));
	        };
	        _this.reportList = function () {
	            return _v2.default.nomina(_this.state.nomina.idNomina).informar().then(function (nomina) {
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('Error al informar nomina'));
	        };
	        _this.completeWithoutEmail = function () {
	            return _v2.default.nomina(_this.state.nomina.idNomina).completarSinCorreo().then(function (nomina) {
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('Error al informar nomina sin correo'));
	        };
	        _this.rectifyList = function () {
	            return _v2.default.nomina(_this.state.nomina.idNomina).rectificar().then(function (nomina) {
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('Error al rectificar nomina'));
	        };
	        _this.suspendBy = function (idOperator, idReason) {
	            _v2.default.usuario(idOperator).suspend(idReason).then(function (resp) {
	                _this.removeOperator(idOperator, false);
	                _this.cancelSuspendOperator();
	            }).catch(_this.ajaxErrorHandler('error al suspender operador'));
	        };
	        _this.blockOperador = function (idOperator, idNomina) {}
	        /*api.usuario(idOperator).bloquearTitular(idNomina)
	            .then(nomina => {
	                //this.removeOperator(idOperator, true)
	                //this.bloqueoLog(idOperator)
	                this.cancelBlockOperador()
	                console.log('usuario bloqueado')
	                this.setState({nomina})
	            })
	            .catch(this.ajaxErrorHandler('Error al bloquear operador'))*/
	
	        /*this.bloqueoLog = (idOperator) => {
	            api.nomina(this.props.nomina.idNomina).bloqueoLog(idOperator)
	                .then(nomina=>{
	                    console.log('log creado')
	                    this.setState({nomina})
	                })
	                .catch(this.ajaxErrorHandler('error al crear log'))
	        }*/
	        ;_this.removeOperator = function (idOperator, isTitular) {
	            _v2.default.nomina(_this.props.nomina.idNomina).quitarOperador(idOperator, isTitular).then(function (nomina) {
	                console.log('dotacion actualizada');
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.calcularUsuariosPermisoMall();
	                });
	            }).catch(_this.ajaxErrorHandler('error al quitar el operador'));
	        };
	        _this.quitarOperadoresMasivo = function (data) {
	            var operadores = data.filter(function (operador) {
	                return operador.status == true;
	            });
	            console.log('quitar operadores masivo', operadores);
	            _v2.default.nomina(_this.props.nomina.idNomina).quitarOperadoresMasivo(operadores).then(function (nomina) {
	                console.log('dotacion actualizada');
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.calcularUsuariosPermisoMall();
	                });
	            }).catch(_this.ajaxErrorHandler('error al quitar el operador'));
	        };
	        _this.operadorTitularMasivo = function (data) {
	            var operadores = data.filter(function (operador) {
	                return operador.status == true;
	            });
	            console.log('operadores titulares masivo', operadores);
	            _v2.default.nomina(_this.props.nomina.idNomina).operadorTitularMasivo(operadores).then(function (nomina) {
	                console.log('dotacion actualizada');
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.calcularUsuariosPermisoMall();
	                });
	            }).catch(_this.ajaxErrorHandler('error al agregar de titular al operador'));
	        };
	        _this.enrocarOperadores = function (titulares, reemplazos) {
	            _v2.default.nomina(_this.props.nomina.idNomina).enrocarOperadores(titulares, reemplazos).then(function (nomina) {
	                console.log('enroque exitoso, dotacion actualizada');
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.calcularUsuariosPermisoMall();
	                });
	            }).catch(_this.ajaxErrorHandler('Enrocar operadores'));
	        };
	        _this.operadorEscondido = function (idUser) {
	            _v2.default.nomina(_this.props.nomina.idNomina).operadorEscondido(idUser).then(function (nomina) {
	                console.log('operador escondido exitoso, nomina actualizada');
	                _this.setState({ nomina: nomina }, function () {
	                    return _this.calcularUsuariosPermisoMall();
	                });
	            }).catch(_this.ajaxErrorHandler('Operador Escondido'));
	        };
	        _this.geolocalizacion = function (id, lat, lng) {
	            return _v2.default.nomina(_this.state.nomina.idNomina).agregarGPS(id, lat, lng).then(function (nomina) {
	                console.log('dirección guardada con exito, local actualizado');
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('Error al agregar GPS de local'));
	        };
	        _this.handleMasTiempo = function (id, confirma) {
	            return _v2.default.nomina(_this.state.nomina.idNomina).masTiempoConfirmacion(id, confirma).then(function (nomina) {
	                console.log('Operación exitosa');
	                _this.setState({ nomina: nomina });
	            }).catch(_this.ajaxErrorHandler('Error al asignar más tiempo para confirmar'));
	        };
	        _this.calcularUsuariosPermisoMall = function () {
	            var cantUserPermisoMall = 0;
	            if (_this.state.nomina.lider && _this.state.nomina.lider.incluir_permisomall) {
	                cantUserPermisoMall++;
	            }
	            if (_this.state.nomina.supervisor && _this.state.nomina.supervisor.incluir_permisomall) {
	                cantUserPermisoMall++;
	            }
	
	            _this.state.nomina.captadorSEI.dotacionTitular.map(function (operador) {
	                if (_this.state.nomina.lider != null && operador.id == _this.state.nomina.lider.id || _this.state.nomina.supervisor != null && operador.id == _this.state.nomina.supervisor.id) {
	                    return null;
	                }
	                if (operador.incluir_permisomall) {
	                    cantUserPermisoMall++;
	                }
	            });
	            _this.state.nomina.captadorSEI.dotacionReemplazo.map(function (operador) {
	                if (_this.state.nomina.lider != null && operador.id == _this.state.nomina.lider.id || _this.state.nomina.supervisor != null && operador.id == _this.state.nomina.supervisor.id) {
	                    return null;
	                }
	                if (operador.incluir_permisomall) {
	                    cantUserPermisoMall++;
	                }
	            });
	
	            /*this.state.nomina.captadorSEI.dotacionEscondida.map((operador) => {
	                if ((this.state.nomina.lider != null && operador.id == this.state.nomina.lider.id) || (this.state.nomina.supervisor != null && operador.id == this.state.nomina.supervisor.id)) {
	                    return null;
	                }
	                if (operador.incluir_permisomall) {
	                    cantUserPermisoMall++
	                }
	            });*/
	            _this.setState({ cantUserPermisoMall: cantUserPermisoMall });
	        };
	        return _this;
	    }
	    // Context API
	
	
	    _createClass(NominaIG, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                // modificar lider
	                agregarLider: function agregarLider(run) {
	                    if (run === '') return console.log('RUN vacio, no se hace nada');
	                    _v2.default.nomina(_this2.props.nomina.idNomina).agregarLider(run).then(function (nomina) {
	                        _this2.refs.notificator.success("Nómina", "Lider agregado", 4 * 1000);
	                        _this2.setState({ nomina: nomina });
	                    }).catch(_this2.ajaxErrorHandler('Error al asignar el Lider'));
	                },
	                quitarLider: function quitarLider() {
	                    _v2.default.nomina(_this2.props.nomina.idNomina).quitarLider().then(function (nomina) {
	                        console.log('lider quitado correctamente');
	                        _this2.setState({ nomina: nomina });
	                    }).catch(_this2.ajaxErrorHandler('Error al quitar el Lider'));
	                },
	                // modificar supervisor
	                agregarSupervisor: function agregarSupervisor(run) {
	                    if (run === '') return console.log('RUN vacio, no se hace nada');
	                    _v2.default.nomina(_this2.props.nomina.idNomina).agregarSupervisor(run).then(function (nomina) {
	                        _this2.refs.notificator.success("Nómina", "Supervisor agregado", 4 * 1000);
	                        _this2.setState({ nomina: nomina }, function () {
	                            return _this2.calcularUsuariosPermisoMall();
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Error al asignar el Supervisor'));
	                },
	                quitarSupervisor: function quitarSupervisor() {
	                    _v2.default.nomina(_this2.props.nomina.idNomina).quitarSupervisor().then(function (nomina) {
	                        console.log('dotacion actualizada');
	                        _this2.setState({ nomina: nomina }, function () {
	                            return _this2.calcularUsuariosPermisoMall();
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Error al quitar el Supervisor'));
	                },
	                // modificar dotacion
	                agregarOperador: function agregarOperador(esTitular, idCaptador, run) {
	                    console.log(esTitular, idCaptador, run);
	                    if (run === '') {
	                        return console.log('RUN vacio, no se hace nada');
	                    }
	                    var request = _v2.default.nomina(_this2.props.nomina.idNomina).agregarOperador(run, esTitular, idCaptador);
	                    request.then(function (response) {
	                        var nominaActualizada = response.data;
	                        var statusCode = response.status;
	
	                        // si no se encuentra el usuario, se debe mostrar el formulario para crear uno
	                        if (statusCode == 204) {
	                            console.log("RUN no existe, mostrando formulario");
	                            // this.setState({
	                            //     showModalNuevoUsuario: true,
	                            //     RUNbuscado: run,
	                            //     esTitular
	                            // })
	                            _this2.refs.notificator.error("Nómina", "Usuario no encontrado", 4 * 1000);
	                        }
	                        // else if (statusCode == 205) {
	                        //     this.refs.notificator.error("Nómina", "Usuario pendiente de aprobación", 4 * 1000);
	                        //     // this.setState({nomina: nominaActualizada})
	                        // }
	                        // else if (statusCode == 203) {
	                        //     this.refs.notificator.error("Nómina", "Operador pendiente de firmar contrato", 4 * 1000);
	                        //     // this.setState({nomina: nominaActualizada})
	                        // }
	                        else if (statusCode == 200) {
	                                console.log(response);
	                                _this2.refs.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
	                                _this2.setState({ nomina: nominaActualizada }, function () {
	                                    return _this2.calcularUsuariosPermisoMall();
	                                });
	                            }
	                    }).catch(_this2.ajaxErrorHandler('Agregar Operador'));
	                    return request;
	                },
	                addAlternateLeader: function addAlternateLeader(run) {
	                    if (run === '') {
	                        return console.log('RUN vacio, no se hace nada');
	                    }
	                    var request = _v2.default.nomina(_this2.props.nomina.idNomina).addAlternateLeader(run);
	                    request.then(function (response) {
	                        var nominaActualizada = response.data;
	                        _this2.refs.notificator.success("Nómina", "Lider suplente agregado correctamente", 4 * 1000);
	                        _this2.setState({ nomina: nominaActualizada });
	                    }).catch(_this2.ajaxErrorHandler('Agregar Lider Suplente'));
	                    return request;
	                },
	                quitarOperador: function quitarOperador(idUsuario, esTitular) {
	                    console.log('quitar usuario', idUsuario);
	                    _v2.default.nomina(_this2.props.nomina.idNomina).quitarOperador(idUsuario, esTitular).then(function (nomina) {
	                        console.log('dotacion actualizada');
	                        _this2.setState({ nomina: nomina }, function () {
	                            return _this2.calcularUsuariosPermisoMall();
	                        });
	                    }).catch(_this2.ajaxErrorHandler('error al quitar el operador'));
	                },
	                suspendOperator: function suspendOperator(operator) {
	                    _this2.setState({ showModalSuspendOperator: true, operatorSuspend: operator });
	                },
	                blockOperador: function blockOperador(operator, idNomina) {
	                    _this2.setState({ showModalBlockOperador: true, blockOperador: operator, idNomina: idNomina });
	                },
	                editarEmailContacto: function editarEmailContacto(emailContacto) {
	                    _v2.default.nomina(_this2.props.nomina.idNomina).actualizarEmailContacto(emailContacto).then(function (nomina) {
	                        return _this2.setState({ nomina: nomina });
	                    }).catch(function (error) {
	                        return console.error(error);
	                    });
	                },
	                cambiarDePanel: function cambiarDePanel(usuarioRun, esTitular, idCaptador) {
	                    var pendientes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	                    _v2.default.nomina(_this2.props.nomina.idNomina).cambiarDePanel(usuarioRun, esTitular, idCaptador, pendientes).then(function (nomina) {
	                        return _this2.setState({ nomina: nomina }, function () {
	                            return _this2.calcularUsuariosPermisoMall();
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Agregar Operador'));
	                },
	                cambiarDePanelPendientes: function cambiarDePanelPendientes(usuarioRun, esTitular, idCaptador) {
	                    var pendientes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	                    return _v2.default.nomina(_this2.props.nomina.idNomina).cambiarDePanel(usuarioRun, esTitular, idCaptador, pendientes).then(function (nomina) {
	                        _this2.setState({ nomina: nomina }, function () {
	                            return _this2.calcularUsuariosPermisoMall();
	                        });
	                        return "ok";
	                    });
	                }
	                // .catch(this.ajaxErrorHandler('Error al agregar operador'))
	
	                , cambioDotacion: function cambioDotacion(dotacion) {
	                    var datos = { 'dotacionOperadores': dotacion, 'desdeNomina': true };
	                    _v2.default.nomina(_this2.props.nomina.idNomina).actualizar(datos).then(function (nomina) {
	                        _this2.setState({ nomina: nomina }, function () {
	                            return _this2.refs.notificator.success("Nómina", "Dotación actualizada", 4 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.refs.notificator.error("Nómina", "Error al cambiar la dotación", 4 * 1000);
	                    });
	                },
	                //Get operadores disponibles
	                getOperadoresDisponibles: function getOperadoresDisponibles() {
	                    var request = _v2.default.nomina(_this2.props.nomina.idNomina).getOperadoresDisponibles();
	                    return request;
	                },
	
	                updateNomina: function updateNomina(nomina) {
	                    _this2.setState({ nomina: nomina });
	                },
	                quitarEscondido: function quitarEscondido(id) {
	                    _v2.default.nomina(_this2.props.nomina.idNomina).quitarEscondido(id).then(function (nomina) {
	                        _this2.setState({ nomina: nomina }, function () {
	                            _this2.refs.notificator.success("Nómina", "Dotación actualizada", 4 * 1000);
	                            _this2.calcularUsuariosPermisoMall();
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.refs.notificator.error("Nómina", "Error al quitar operador escondido", 4 * 1000);
	                    });
	                },
	                cambiarCaptador: function cambiarCaptador(idUser, idCaptador) {
	                    _v2.default.nomina(_this2.props.nomina.idNomina).cambiarCaptador(idUser, idCaptador).then(function (nomina) {
	                        return _this2.setState({ nomina: nomina });
	                    }).catch(_this2.ajaxErrorHandler('Cambio de Captador'));
	                },
	                updateNominaPermisoMall: function updateNominaPermisoMall(idUser, incluir, orden) {
	                    _this2.setState(function (prevState) {
	                        return {
	                            nomina: _extends({}, prevState.nomina, {
	                                lider: prevState.nomina.lider != null && prevState.nomina.lider.id == idUser ? _extends({}, prevState.nomina.lider, { incluir_permisomall: incluir }) : prevState.nomina.lider,
	                                supervisor: prevState.nomina.supervisor != null && prevState.nomina.supervisor.id == idUser ? _extends({}, prevState.nomina.supervisor, { incluir_permisomall: incluir }) : prevState.nomina.supervisor,
	                                captadorSEI: _extends({}, prevState.nomina.captadorSEI, {
	                                    dotacionTitular: prevState.nomina.captadorSEI.dotacionTitular.map(function (operador) {
	                                        return operador.id == idUser ? _extends({}, operador, { incluir_permisomall: incluir, orden_permisomall: orden }) : operador;
	                                    }),
	                                    dotacionReemplazo: prevState.nomina.captadorSEI.dotacionReemplazo.map(function (operador) {
	                                        return operador.id == idUser ? _extends({}, operador, { incluir_permisomall: incluir, orden_permisomall: orden }) : operador;
	                                    }),
	                                    dotacionEscondida: prevState.nomina.captadorSEI.dotacionEscondida.map(function (operador) {
	                                        return operador.id == idUser ? _extends({}, operador, { incluir_permisomall: incluir, orden_permisomall: orden }) : operador;
	                                    })
	                                })
	                            })
	                        };
	                    }, function () {
	                        return _this2.calcularUsuariosPermisoMall();
	                    });
	                },
	                setPermisosMallNomina: function setPermisosMallNomina(permisosMall) {
	                    _this2.setState(function (prevState) {
	                        return {
	                            nomina: _extends({}, prevState.nomina, {
	                                permisos_mall: prevState.nomina.permisos_mall.map(function (permiso) {
	                                    var permisoMall = permisosMall.find(function (pm) {
	                                        return pm.id == permiso.id;
	                                    });
	                                    return permisoMall ? permisoMall : permiso;
	                                })
	                            })
	                        };
	                    });
	                }
	            };
	        }
	
	        // Mount component
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAlternateLeaders();
	            this.notifyStoreInMall();
	            this.notifyPendingApprovals();
	            this.notifyMoreTime();
	            this.calcularUsuariosPermisoMall();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var sumaUnidades = this.state.nomina.sumaUnidades;
	            var sumaConteo = this.state.nomina.sumaConteo;
	            var nominaPendiente = this.state.nomina.idEstadoNomina == 2;
	            var operadoresAsignados = this.state.nomina.supervisor ? this.state.nomina.dotacionTitular.length + 1 : this.state.nomina.dotacionTitular.length;
	            var totalAsignados = this.state.nomina.lider ? operadoresAsignados + 1 : operadoresAsignados;
	            // la nomina tiene todos los captadores asignados? y el total corresponde a lo asignado?
	            var nominaCompleta = this.state.nomina.dotacionTotal == totalAsignados;
	            //Difenrencia entre el stock del local y las unidades contadas por los operadores
	            var diferenciaUnidades = this.state.nomina.diferenciaUnidades;
	            var diferenciaConteo = this.state.nomina.diferenciaConteo;
	            //Diferencia entre total operadores asignados y dotacion
	            var difOperadores = this.state.nomina.dotacionOperadores - this.state.nomina.dotacionTitular.length;
	
	            var nominaInformada = this.state.nomina.idEstadoNomina == 5;
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(ModalNewUser, {
	                    bancos: this.props.bancos,
	                    tipoCuentas: this.props.tipoCuentas,
	                    comunas: this.props.comunas,
	                    run: this.state.RUNbuscado,
	                    cssModal: css.modalAmplio,
	                    showModal: this.state.showModalNuevoUsuario,
	                    cancelModal: this.cancelFormNewUser,
	                    sendFormNewUser: this.onNewUser
	                }),
	                _react2.default.createElement(ModalSuspendOperator, {
	                    operator: this.state.operatorSuspend,
	                    showModal: this.state.showModalSuspendOperator,
	                    cancelModal: this.cancelSuspendOperator,
	                    suspendBy: this.suspendBy
	                }),
	                _react2.default.createElement(ModalBlockOperador, {
	                    operator: this.state.blockOperador,
	                    idNomina: this.state.idNomina,
	                    showModal: this.state.showModalBlockOperador,
	                    cancelModal: this.cancelBlockOperador,
	                    blockOperador: this.blockOperador.bind(this)
	                }),
	                this.state.modalGPS && _react2.default.createElement(_Modales.ModalDireccion, {
	                    hideModal: this.cancelModalGPS,
	                    direccion: this.state.nomina.local_direccion,
	                    comuna: this.state.nomina.local_comuna,
	                    id: this.state.nomina.local_id,
	                    onGuardar: this.geolocalizacion
	                }),
	                this.state.showModalMasTiempo && _react2.default.createElement(_Modales2.ModalMasTiempo, {
	                    hideModal: this.cancelModalMasTiempo,
	                    mas_tiempo: this.state.nomina.mas_tiempo,
	                    handleMasTiempo: this.handleMasTiempo
	                }),
	                _react2.default.createElement(_PanelDatos.PanelDatos, {
	                    verTodasNominas: this.props.permisos.verTodasNominas,
	                    verHistorialNomina: this.props.permisos.verHistorial,
	                    cambiarDotacion: this.props.permisos.cambiarDotacion,
	                    disminuirDotacion: this.props.permisos.disminuirDotacion,
	                    aprobarCambioDotacion: true,
	                    nomina: this.state.nomina
	                }),
	                this.props.permisos.verTodasNominas ? _react2.default.createElement(_PanelCaptador.PanelCaptadorSEI, {
	                    idNomina: this.state.nomina.idNomina,
	                    nivelConteo: this.state.nomina.nivelConteo,
	                    message: this.state.nomina.mensaje,
	                    captadorSEI: this.state.nomina.captadorSEI,
	                    lider: this.state.nomina.lider,
	                    alternateLeaders: this.state.alternateLeaders,
	                    supervisor: this.state.nomina.supervisor,
	                    maximoOperadores: this.state.nomina.dotacionOperadores,
	                    sumaUnidades: sumaUnidades,
	                    sumaConteo: sumaConteo,
	                    diferenciaUnidades: diferenciaUnidades,
	                    diferenciaConteo: diferenciaConteo,
	                    rectificada: this.state.nomina.rectificada,
	                    difOperadores: difOperadores,
	                    nuevoOperador: this.state.nuevoOperador,
	                    buscarOperadores: this.props.nomina.local_mall && this.state.nomina.rectificada
	                    // permisos (solo puede editar si esta pendente, y es un captador asignado o es un "captador SEI"
	                    , verNominaAvanzada: this.props.permisos.verNominaAvanzada,
	                    verPasajesNomina: this.props.permisos.verPasajesNomina,
	                    editarLiderSupervisor: nominaPendiente && this.props.permisos.cambiarLiderSupervisor,
	                    editarOperadores: nominaPendiente && this.props.permisos.editarTodasNominas,
	                    editarTodasNominas: this.props.permisos.editarTodasNominas,
	                    quitarOperadoresMasivo: this.quitarOperadoresMasivo.bind(this),
	                    operadorTitularMasivo: this.operadorTitularMasivo.bind(this),
	                    nominaInformada: nominaInformada,
	                    enrocarOperadores: this.enrocarOperadores.bind(this),
	                    nomina: this.state.nomina,
	                    cliente: this.state.nomina.idCliente,
	                    puedeAsignar: this.props.permisos.asignarOperadoresNuevos,
	                    operadorEscondido: this.operadorEscondido.bind(this),
	                    notificator: this.refs.notificator,
	                    administraPasajes: this.props.permisos.administraPasajes,
	                    cantUserPermisoMall: this.state.cantUserPermisoMall,
	                    maxUsuariosPermisosMall: this.state.nomina.max_usuarios_permisos_mall,
	                    puedeInformarDisponibilidad: this.props.permisos.informar
	                }) : null,
	                this.state.nomina.captadores.map(function (captador) {
	                    var esMiNomina = _this3.props.permisos.editarIdCaptador == captador.idCaptador;
	
	                    return _this3.props.permisos.verTodasNominas || esMiNomina ? _react2.default.createElement(_PanelCaptador.PanelDetainer, {
	                        nivelConteo: _this3.state.nomina.nivelConteo,
	                        message: _this3.state.nomina.mensaje,
	                        key: captador.idCaptador,
	                        captador: captador,
	                        rectificada: _this3.state.nomina.rectificada,
	                        difOperadores: difOperadores,
	                        sumaUnidades: sumaUnidades,
	                        sumaConteo: sumaConteo,
	                        diferenciaUnidades: diferenciaUnidades,
	                        diferenciaConteo: diferenciaConteo,
	                        buscarOperadores: _this3.props.nomina.local_mall && _this3.state.nomina.rectificada
	                        // permisos (solo puede editar si esta pendente, y es un captador asignado o es un "captador SEI"
	                        , editarLiderSupervisor: nominaPendiente && _this3.props.permisos.cambiarLiderSupervisor,
	                        editarOperadores: nominaPendiente && (_this3.props.permisos.editarTodasNominas || esMiNomina),
	                        editarTodasNominas: _this3.props.permisos.editarTodasNominas,
	                        nominaInformada: nominaInformada,
	                        enrocarOperadores: _this3.enrocarOperadores.bind(_this3),
	                        nomina: _this3.state.nomina,
	                        idNomina: _this3.state.nomina.idNomina
	                    }) : null;
	                }),
	                _react2.default.createElement(_PanelEstados.PanelEstados, {
	                    idEstado: this.state.nomina.idEstadoNomina,
	                    haSidoRectificada: this.state.nomina.rectificada,
	                    enviarNomina: this.sendList,
	                    aprobarNomina: this.approveList,
	                    rechazarNomina: this.rejectList,
	                    informarNomina: this.reportList,
	                    completarSinCorreo: this.completeWithoutEmail,
	                    rectificarNomina: this.rectifyList,
	                    nominaCompleta: nominaCompleta,
	                    operadoresPendientes: this.state.nomina.operadoresPendientes,
	                    rectificaSistema: this.state.nomina.rectificaSistema,
	                    cambio_lider: this.state.nomina.cambio_lider,
	                    tiene_gps: this.state.nomina.local_gmap_lat !== null && this.state.nomina.local_gmap_lng !== null,
	                    abrirModalGPS: this.abrirModalGPS
	                    // permisos
	                    , permisos: this.props.permisos
	                })
	            );
	        }
	    }]);
	
	    return NominaIG;
	}(_react.Component);
	
	NominaIG.propTypes = {
	    nomina: _react.PropTypes.object.isRequired,
	    comunas: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    // Permisos
	    permisos: _react.PropTypes.object.isRequired
	};
	
	NominaIG.childContextTypes = {
	    agregarLider: _react.PropTypes.func,
	    quitarLider: _react.PropTypes.func,
	    agregarSupervisor: _react.PropTypes.func,
	    quitarSupervisor: _react.PropTypes.func,
	    agregarOperador: _react.PropTypes.func,
	    quitarOperador: _react.PropTypes.func,
	    editarEmailContacto: _react.PropTypes.func,
	    cambiarDePanel: _react.PropTypes.func,
	    cambiarDePanelPendientes: _react.PropTypes.func,
	    cambioDotacion: _react.PropTypes.func,
	    getOperadoresDisponibles: _react.PropTypes.func,
	    addAlternateLeader: _react.PropTypes.func,
	    suspendOperator: _react.PropTypes.func,
	    blockOperador: _react.PropTypes.func,
	    updateNomina: _react.PropTypes.func,
	    quitarEscondido: _react.PropTypes.func,
	    cambiarCaptador: _react.PropTypes.func,
	    updateNominaPermisoMall: _react.PropTypes.func,
	    setPermisosMallNomina: _react.PropTypes.func
	};
	
	var ModalNewUser = function ModalNewUser(_ref) {
	    var bancos = _ref.bancos,
	        tipoCuentas = _ref.tipoCuentas,
	        comunas = _ref.comunas,
	        run = _ref.run,
	        cssModal = _ref.cssModal,
	        showModal = _ref.showModal,
	        cancelModal = _ref.cancelModal,
	        sendFormNewUser = _ref.sendFormNewUser;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        {
	            show: showModal,
	            onHide: cancelModal,
	            dialogClassName: cssModal
	        },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Nuevo Operador'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_FormularioUsuario.FormularioUsuario, {
	                bancos: bancos,
	                tipoCuentas: tipoCuentas,
	                comunas: comunas,
	                RUNbuscado: run,
	                enviarFormulario: sendFormNewUser,
	                cancelarFormulario: cancelModal
	            })
	        )
	    );
	};
	
	var ModalSuspendOperator = function ModalSuspendOperator(_ref2) {
	    var operator = _ref2.operator,
	        showModal = _ref2.showModal,
	        cancelModal = _ref2.cancelModal,
	        suspendBy = _ref2.suspendBy;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        {
	            show: showModal,
	            onHide: cancelModal
	        },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Indicar motivo de suspensi\xF3n operador ',
	                operator.nombreCorto
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'btn-group-vertical ' + css.divButtonsSuspend },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-warning', onClick: function onClick() {
	                            return suspendBy(operator.id, 1);
	                        } },
	                    'Faltas Reiteradas'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-warning', onClick: function onClick() {
	                            return suspendBy(operator.id, 2);
	                        } },
	                    'Inactividad'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-warning', onClick: function onClick() {
	                            return suspendBy(operator.id, 3);
	                        } },
	                    'Baja Producci\xF3n'
	                )
	            )
	        )
	    );
	};
	
	var ModalBlockOperador = function ModalBlockOperador(_ref3) {
	    var operator = _ref3.operator,
	        idNomina = _ref3.idNomina,
	        showModal = _ref3.showModal,
	        cancelModal = _ref3.cancelModal,
	        blockOperador = _ref3.blockOperador;
	
	    //console.log(idNomina)
	    return _react2.default.createElement(
	        _Modal2.default,
	        {
	            show: showModal,
	            onHide: cancelModal
	        },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Esta acci\xF3n bloquear\xE1 a ',
	                operator.nombreCorto
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h5',
	                    { style: { textAlign: 'center' } },
	                    'Es posible que el operador est\xE9 presente en futuras n\xF3minas y ser\xE1 eliminado de estas'
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'h5',
	                    { style: { textAlign: 'center' } },
	                    'Si alguna n\xF3mina estaba informada, esta volver\xE1 a estado pendiente'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'btn-group-vertical ' + css.divButtonsSuspend },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-success', onClick: function onClick() {
	                            return blockOperador(operator.id, idNomina);
	                        } },
	                    'Confirmar'
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "nominaIG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modalAmplio":"nominaIG__modalAmplio___g1Ubf","modalSmall":"nominaIG__modalSmall___1P66g","errorModal":"nominaIG__errorModal___1TqOB","divButtonsSuspend":"nominaIG__divButtonsSuspend___24_DW"};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormularioUsuario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ValidadorRUN = __webpack_require__(756);
	
	var _reactFormal = __webpack_require__(757);
	
	var _reactFormal2 = _interopRequireDefault(_reactFormal);
	
	var _reactFormalInputs = __webpack_require__(808);
	
	var _reactFormalInputs2 = _interopRequireDefault(_reactFormalInputs);
	
	var _yup = __webpack_require__(893);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormularioUsuario = __webpack_require__(914);
	
	var styles = _interopRequireWildcard(_FormularioUsuario);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Moment
	
	var momentLocalizer = __webpack_require__(915);
	momentLocalizer(_moment2.default);
	// Validador Rut
	
	// Forms
	
	_reactFormal2.default.addInputTypes(_reactFormalInputs2.default);
	// Componentes
	
	var cx = _bind2.default.bind(styles);
	
	var listaBancos = ['Banco Estado', 'Banco de Chile', 'Banco Internacional', 'Scotiank-Desarrollo', 'Banco de Credito e Inversiones', 'CorpBanca', 'Banco Bice', 'HSBC Bank Chile', 'Banco Santander', 'Banco Itaú', 'The Bank of Tokyo-Mitsubishi', 'Banco Security', 'Banco Falabella', 'Banco Ripley', 'Banco Consorcio', 'Banco Paris', 'Banco BBVA', 'Copeuch', 'Banco Penta', 'Scotiabank Chile', 'Deutsche Bank', 'Rabobank Chile'];
	var listaTipoCuentas = ['Cuenta Corriente', 'Cuenta Vista', 'Cuenta Ahorro', 'Chequera Electronica', 'Cuenta de Gastos', 'Cuenta RUT'];
	
	var FormularioUsuario = exports.FormularioUsuario = function (_React$Component) {
	    _inherits(FormularioUsuario, _React$Component);
	
	    function FormularioUsuario() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FormularioUsuario);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormularioUsuario.__proto__ || Object.getPrototypeOf(FormularioUsuario)).call.apply(_ref, [this].concat(args))), _this), _this.usuarioSchema = _yup2.default.object({
	            usuarioRUN: _yup2.default.string().default(_this.props.RUNbuscado).min(1, 'El RUN debe tener un minimo de 1 caracteres').max(8, 'El RUN debe tener un máximo de 8 caracteres'),
	            usuarioDV: _yup2.default.string()
	            //        .default(obtenerVerificador(this.props.RUNbuscado))
	            .default('').required('Ingrese el digito verificador del RUN').test('verificarUsuarioDV', 'El digito verificador es incorrecto', function (value) {
	                // Hack sucio... cuando se hace una validacion con delay, se sacan los valores de options, si no, de parent
	                var valores = this.options.value ? this.options.value : this.parent;
	                return (0, _ValidadorRUN.validarRUN)(valores.usuarioRUN, value);
	            }).max(1, 'El máximo es 1 digito'),
	            email: _yup2.default.string().default('').max(60, 'El máximo es 60 caracteres') // no obligatorio
	            //.email('Debe ser un email valido'),
	            .test('correo', 'Debe ingresar un email valido', function (value) {
	                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	                return value === '' || rEmail.test(value);
	            }),
	            emailPersonal: _yup2.default.string().default('').max(60, 'El máximo es 60 caracteres')
	            //.email('Debe ser un email valido'),
	            .required('Ingrese el email').test('correo', 'Debe ingresar un email valido', function (value) {
	                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	                return value === '' || rEmail.test(value);
	            }),
	            nombre1: _yup2.default.string().default('').required('Ingrese el primer nombre').min(3, 'El minimo es de 3 caracteres').max(15, 'El máximo es 15 caracteres'),
	            nombre2: _yup2.default.string().default('') // no obligatorio
	            .max(15, 'El máximo es 15 caracteres'),
	            apellidoPaterno: _yup2.default.string().default('').required('Ingrese el apellido').min(3, 'El minimo es de 3 caracteres').max(20, 'El máximo es 20 caracteres'),
	            apellidoMaterno: _yup2.default.string().default('').max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            telefono: _yup2.default.string().default('').required('Ingrese un número de celular').max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            telefonoEmergencia: _yup2.default.string().default('').max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            fechaNacimiento: _yup2.default.date() //.default(new Date('03-23-1987'))
	            //.max(new Date('03-23-2020')),
	            .required('Ingrese la fecha de nacimiento'),
	            nacionalidad: _yup2.default.string().default('').required('Ingrese la nacionalidad de la persona'),
	            sexo: _yup2.default.string().default('').required('Ingrese el sexo de la persona'),
	            direccion: _yup2.default.string().default('').max(150, 'El máximoes de 5 caracteres').required('Ingrese la dirección de la persona'),
	            // cutRegion: yup.number()
	            //     .required('Seleccione una Región'),
	            cutComuna: _yup2.default.string().required('Seleccione una Comuna'),
	            tipoContrato: _yup2.default.string().default('')
	            // .required('Escriba el Tipo de Contrato, o seleccionelo de la lista')
	            .max(30, 'El máximo es 30 caracteres'),
	            banco: _yup2.default.string().default('').required('Seleccione el Banco de la lista'),
	            //.max(30, 'El máximo es 30 caracteres'),
	            tipoCuenta: _yup2.default.string().default('').required('Seleccionelo el Tipo de Cuenta de la lista'),
	            numeroCuenta: _yup2.default.string().default('').required('Escriba el Número de Cuenta').max(30, 'El máximo es 30 caracteres')
	        }), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FormularioUsuario, [{
	        key: 'enviarFormulario',
	        value: function enviarFormulario(datos) {
	            this.props.enviarFormulario(datos);
	        }
	    }, {
	        key: 'enviarFormularioInvalido',
	        value: function enviarFormularioInvalido(datos) {
	            console.log('enviando invalido ', datos);
	        }
	    }, {
	        key: 'siguienteComponente',
	        value: function siguienteComponente(refComponente, evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                if (refComponente === 'refFechaNacimiento') {
	                    //this.refFechaNacimiento.refs.input.focus() // OK para el wrapper
	                    this.refFechaNacimiento.refs.input.focus(); // OK para el date2
	                } else if (refComponente === 'refComuna') {
	                    this.refComuna.refs.input.refs.inner.open(); // OK para el date2
	                } else {
	                    _reactDom2.default.findDOMNode(this[refComponente].refs.input).select();
	                }
	                // console.log( ReactDOM.findDOMNode(this.refNombre1).focus() ) // OK
	                // console.log( ReactDOM.findDOMNode(this.refNombre1.refs.input).focus() ) // OK
	                return;
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            console.log("mouint");
	            _reactDom2.default.findDOMNode(this['refUsuarioDV'].refs.input).select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactFormal2.default,
	                    {
	                        className: 'form-horizontal',
	                        schema: this.usuarioSchema,
	                        defaultValue: this.usuarioSchema.default()
	                        //delay={1000}
	                        //noValidate={true}
	                        , onSubmit: this.enviarFormulario.bind(this),
	                        onInvalidSubmit: this.enviarFormularioInvalido.bind(this) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-7' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Datos Personales'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'RUN (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                        name: 'usuarioRUN'
	                                        //                                                disabled={true}
	                                        , mapValue: {
	                                            usuarioRUN: function usuarioRUN(_usuarioRUN) {
	                                                return _usuarioRUN;
	                                            },
	                                            usuarioDV: function usuarioDV(usuarioRUN) {
	                                                return (0, _ValidadorRUN.obtenerVerificador)(usuarioRUN);
	                                            }
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refUsuarioDV')
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-2' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                        name: 'usuarioDV'
	                                        //disabled={true}
	                                        , ref: function ref(_ref2) {
	                                            return _this2.refUsuarioDV = _ref2;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNombre1')
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': ['usuarioRUN', 'usuarioDV'], errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Nombres (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Primer Nombre',
	                                        name: 'nombre1',
	                                        ref: function ref(_ref3) {
	                                            return _this2.refNombre1 = _ref3;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNombre2')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre1', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Segundo Nombre',
	                                        name: 'nombre2',
	                                        ref: function ref(_ref4) {
	                                            return _this2.refNombre2 = _ref4;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refApellidoPaterno')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre2', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Apellidos (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Apellido Paterno',
	                                        name: 'apellidoPaterno',
	                                        ref: function ref(_ref5) {
	                                            return _this2.refApellidoPaterno = _ref5;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refApellidoMaterno')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoPaterno', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Apellido Materno',
	                                        name: 'apellidoMaterno',
	                                        ref: function ref(_ref6) {
	                                            return _this2.refApellidoMaterno = _ref6;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refFechaNacimiento')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoMaterno', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Fecha Nacimiento (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'date2', time: false, errorClass: cx('form__field--error'), placeholder: 'Ej. 31-07-2016',
	                                        name: 'fechaNacimiento',
	                                        format: 'D-M-YYYY',
	                                        editFormat: 'D-M-YYYY',
	                                        ref: function ref(_ref7) {
	                                            return _this2.refFechaNacimiento = _ref7;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefono')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'fechaNacimiento', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Sexo (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { name: 'sexo', type: 'combobox',
	                                        data: ['Masculino', 'Femenino'],
	                                        duration: 0
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'sexo', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Nacionalidad (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Chilena',
	                                        name: 'nacionalidad',
	                                        ref: function ref(_ref8) {
	                                            return _this2.refNacionalidad = _ref8;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefono')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nacionalidad', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Contacto'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Telefono (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: '978164123',
	                                        name: 'telefono',
	                                        ref: function ref(_ref9) {
	                                            return _this2.refTelefono = _ref9;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefonoEmergencia')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefono', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Telefono de Emergencia',
	                                        name: 'telefonoEmergencia',
	                                        ref: function ref(_ref10) {
	                                            return _this2.refTelefonoEmergencia = _ref10;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refEmail')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefonoEmergencia', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Email'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Email SEI',
	                                        name: 'email',
	                                        ref: function ref(_ref11) {
	                                            return _this2.refEmail = _ref11;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refEmailPersonal')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'email', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { style: { 'display': 'inline-block', 'width': '90%' }, className: 'form-control', placeholder: 'Email personal',
	                                        name: 'emailPersonal',
	                                        ref: function ref(_ref12) {
	                                            return _this2.refEmailPersonal = _ref12;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refComuna')
	                                    }),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { style: { 'display': 'inline-block', 'width': '10%' }, className: 'control-label' },
	                                        '(*)'
	                                    ),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'emailPersonal', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comuna (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'cutComuna',
	                                        data: this.props.comunas,
	                                        valueField: 'cutComuna',
	                                        textField: 'nombre'
	                                        //groupBy='cutProvincia'
	                                        , filter: 'startsWith',
	                                        mapValue: { 'cutComuna': function cutComuna(comuna) {
	                                                return comuna.cutComuna;
	                                            } },
	                                        duration: 10,
	                                        ref: function ref(_ref13) {
	                                            return _this2.refComuna = _ref13;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refDireccion')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'cutComuna', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Direcci\xF3n (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Direcci\xF3n',
	                                        name: 'direccion',
	                                        ref: function ref(_ref14) {
	                                            return _this2.refDireccion = _ref14;
	                                        }
	                                        //onKeyPress={this.siguienteComponente.bind(this, 'refDireccion')}
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'direccion', errorClass: cx('form__message-error') })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Datos Laborales'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Tipo contrato'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { name: 'tipoContrato', type: 'combobox',
	                                        data: ['Plazo', 'Honorario'],
	                                        duration: 0
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'tipoContrato', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Fecha inicio contrato'
	                                ),
	                                _react2.default.createElement('div', { className: 'col-sm-8' })
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Pagos'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Banco (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'banco',
	                                        data: this.props.bancos.map(function (banco) {
	                                            return banco.nombreCorto;
	                                        }),
	                                        filter: 'startsWith',
	                                        duration: 10,
	                                        ref: function ref(_ref15) {
	                                            return _this2.refBanco = _ref15;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTipoCuenta')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'banco', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Tipo Cuenta (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'tipoCuenta',
	                                        filter: 'startsWith',
	                                        duration: 10,
	                                        data: this.props.tipoCuentas.map(function (cuentas) {
	                                            return cuentas.nombreCuenta;
	                                        }),
	                                        ref: function ref(_ref16) {
	                                            return _this2.refTipoCuenta = _ref16;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNumCuenta')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'tipoCuenta', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Numero Cuenta (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', name: 'numeroCuenta', placeholder: 'Ej. 123-456-789-9' }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'numeroCuenta', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Otros'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Certificado Antecedentes'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement('input', { id: 'input-1', type: 'file', className: 'file', disabled: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Fotografia'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement('input', { id: 'input-1', type: 'file', className: 'file', disabled: true })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx("col-sm-12", 'form__footer') },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-default', onClick: this.props.cancelarFormulario },
	                                'Close'
	                            ),
	                            _react2.default.createElement(
	                                _reactFormal2.default.Button,
	                                { type: 'submit', className: 'btn btn-primary' },
	                                'Agregar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormularioUsuario;
	}(_react2.default.Component);
	
	FormularioUsuario.propTypes = {
	    RUNbuscado: PropTypes.string.isRequired,
	    comunas: PropTypes.arrayOf(PropTypes.object).isRequired,
	    enviarFormulario: PropTypes.func.isRequired,
	    cancelarFormulario: PropTypes.func.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FormularioUsuario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	//const obtenerVerificador = (rutCompleto)=>{
	var obtenerVerificador = function obtenerVerificador(rutCompleto) {
	    // limpiar los caracteres innecesarios
	    var rut = rutCompleto.trim().split('.').join('');
	
	    // tomar cada uno de los valores y ponerlos al revez
	    var rutReverso = rut.split('').reverse();
	
	    // multiplicar los numeros por la serie 2, 3, 4, 5, 6, 7, repetir si faltan numeros
	    var serie = [2, 3, 4, 5, 6, 7];
	    var totalSuma = rutReverso.reduce(function (acumulado, actual, index) {
	        var nroSerie = serie[index % serie.length];
	        return acumulado + nroSerie * actual;
	    }, 0);
	
	    // calcular el modulo de 11, y con esto obtener el verificador
	    var restoSuma = totalSuma % 11;
	    var verificador = 11 - restoSuma;
	
	    if (verificador == 11) return '0';
	    if (verificador == 10) return 'K';
	    return '' + verificador;
	};
	
	var validarRUN = function validarRUN(rutCompleto, digitoVerificador) {
	    if (!rutCompleto || rutCompleto.trim() == '') return false;
	    if (!digitoVerificador || digitoVerificador.trim() == '') return false;
	    if (digitoVerificador === 'k') digitoVerificador = 'K';
	
	    var dv = obtenerVerificador(rutCompleto);
	    //console.log(`debug, el verificador es: '${rutCompleto}', '${digitoVerificador}'==${dv} : ${dv==digitoVerificador}`)
	    return dv == digitoVerificador;
	};
	
	exports.obtenerVerificador = obtenerVerificador;
	exports.validarRUN = validarRUN;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ValidadorRUN.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Form = __webpack_require__(758);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Field = __webpack_require__(787);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _FormContext = __webpack_require__(800);
	
	var _FormContext2 = _interopRequireDefault(_FormContext);
	
	var _reactInputMessageMessageTrigger = __webpack_require__(788);
	
	var _reactInputMessageMessageTrigger2 = _interopRequireDefault(_reactInputMessageMessageTrigger);
	
	var _ValidationMessage = __webpack_require__(801);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _ValidationSummary = __webpack_require__(804);
	
	var _ValidationSummary2 = _interopRequireDefault(_ValidationSummary);
	
	var _utilErrToJSON = __webpack_require__(778);
	
	var _utilErrToJSON2 = _interopRequireDefault(_utilErrToJSON);
	
	var _FormButton = __webpack_require__(805);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _addInputType = __webpack_require__(807);
	
	var _addInputType2 = _interopRequireDefault(_addInputType);
	
	var _config = __webpack_require__(797);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	_Form2['default'].Field = _Field2['default'];
	_Form2['default'].Message = _ValidationMessage2['default'];
	_Form2['default'].Summary = _ValidationSummary2['default'];
	_Form2['default'].Button = _FormButton2['default'];
	_Form2['default'].Context = _FormContext2['default'];
	_Form2['default'].Trigger = _reactInputMessageMessageTrigger2['default'];
	
	_Form2['default'].toErrors = function (err) {
	  var _json;
	
	  _invariant2['default'](err && err.name === 'ValidationError', '`toErrors()` only works with ValidationErrors.');
	
	  var json = _utilErrToJSON2['default'](err);
	
	  if (!err.inner.length) json = (_json = {}, _json[err.path || ''] = [json], _json);
	
	  return json;
	};
	
	_Form2['default'].addInputTypes = _addInputType2['default'];
	_Form2['default'].setDefaults = function () {
	  var defaults = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  _extends(_config2['default'], defaults);
	};
	
	module.exports = _Form2['default'];

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderFunction = __webpack_require__(759);
	
	var _reactPureRenderFunction2 = _interopRequireDefault(_reactPureRenderFunction);
	
	var _warning = __webpack_require__(761);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _yupLibUtilReach = __webpack_require__(762);
	
	var _yupLibUtilReach2 = _interopRequireDefault(_yupLibUtilReach);
	
	var _propertyExpr = __webpack_require__(763);
	
	var _propertyExpr2 = _interopRequireDefault(_propertyExpr);
	
	var _reactInputMessageValidator = __webpack_require__(771);
	
	var _reactInputMessageValidator2 = _interopRequireDefault(_reactInputMessageValidator);
	
	var _reactInputMessageMessageContainer = __webpack_require__(772);
	
	var _reactInputMessageMessageContainer2 = _interopRequireDefault(_reactInputMessageMessageContainer);
	
	var _uncontrollable = __webpack_require__(773);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _utilPaths = __webpack_require__(776);
	
	var _utilPaths2 = _interopRequireDefault(_utilPaths);
	
	var _utilContextType = __webpack_require__(777);
	
	var _utilContextType2 = _interopRequireDefault(_utilContextType);
	
	var _utilErrToJSON = __webpack_require__(778);
	
	var _utilErrToJSON2 = _interopRequireDefault(_utilErrToJSON);
	
	var _topeka = __webpack_require__(779);
	
	var BindingContext = _topeka.BindingContext.ControlledComponent;
	
	var done = function done(e) {
	  return setTimeout(function () {
	    throw e;
	  });
	};
	var getParent = function getParent(path) {
	  return _propertyExpr2['default'].join(_propertyExpr2['default'].split(path).slice(0, -1));
	};
	
	var isValidationError = function isValidationError(err) {
	  return err && err.name === 'ValidationError';
	};
	
	/**
	 * Form component renders a `value` to be updated and validated by child Fields.
	 * Forms can be thought of as `<input/>`s for complex values, or models. A Form aggregates
	 * a bunch of smaller inputs, each in charge of updating a small part of the overall model.
	 * The Form will integrate and validate each change and fire a single unified `onChange` with the new `value`.
	 *
	 * Validation messages can be displayed anywhere inside a Form with Message Components.
	 *
	 * ```editable
	 * var defaultStr = yup.string().default('')
	 *
	 * var customerSchema = yup
	 *   .object({
	 *     name: yup.object({
	 *       first: defaultStr
	 *         .required('please enter a first name'),
	 *
	 *       last: defaultStr
	 *         .required('please enter a surname'),
	 *     }),
	 *
	 *     dateOfBirth: yup.date()
	 *       .max(new Date(), "Are you a time traveler?!"),
	 *
	 *     colorId: yup.number()
	 *       .nullable()
	 *       .required('Please select a dank color')
	 *   });
	 *
	 * var form = (
	 *   <Form
	 *     schema={customerSchema}
	 *     defaultValue={customerSchema.default()}
	 *   >
	 *     <div>
	 *       {\/\*'grandchildren' are no problem \*\/}
	 *       <label>Name</label>
	 *
	 *       <Form.Field
	 *         name='name.first'
	 *         placeholder='First name'
	 *       />
	 *       <Form.Field
	 *         name='name.last'
	 *         placeholder='Surname'
	 *       />
	 *
	 *       <Form.Message for={['name.first', 'name.last']}/>
	 *     </div>
	 *
	 *     <label>Date of Birth</label>
	 *     <Form.Field name='dateOfBirth'/>
	 *     <Form.Message for='dateOfBirth'/>
	 *
	 *     <label>Favorite Color</label>
	 *     <Form.Field name='colorId' type='select'>
	 *       <option value={null}>Select a color...</option>
	 *       <option value={0}>Red</option>
	 *       <option value={1}>Yellow</option>
	 *       <option value={2}>Blue</option>
	 *       <option value={3}>other</option>
	 *     </Form.Field>
	 *     <Form.Message for='colorId'/>
	 *
	 *   <Form.Button type='submit'>
	 *     Submit
	 *   </Form.Button>
	 * </Form>)
	 * ReactDOM.render(form, mountNode);
	 * ```
	 */
	
	var Form = (function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  _createClass(Form, null, [{
	    key: 'propTypes',
	    value: {
	
	      /**
	       * Form value object, can be left [uncontrolled](/controllables);
	       * use the `defaultValue` prop to initialize an uncontrolled form.
	       */
	      value: _react2['default'].PropTypes.object,
	
	      /**
	       * Callback that is called when the `value` prop changes.
	       *
	       * ```js
	       * function(
	       *   value: object,
	       *   updatedPaths: array<string>
	       * )
	       * ```
	       */
	      onChange: _react2['default'].PropTypes.func,
	
	      /**
	       * An object hash of field errors for the form. The object should be keyed with paths
	       * with the values being an array of messages or message objects. Errors can be
	       * left [uncontrolled](/controllables) (use `defaultErrors` to set an initial value)
	       * or managed along with the `onError` callback. You can use any object shape you'd like for
	       * messages, as long as you provide the Form.Message component an `extract` prop that
	       * understands how to pull out the strings message. By default it understands strings and objects
	       * with a `'message'` property.
	       *
	       * ```js
	       * <Form errors={{
	       *  "name.first": [
	       *    'First names are required',
	       *    {
	       *    	message: "Names must be at least 2 characters long",
	       *    	type: 'min'
	       *    }
	       *  ],
	       * }}/>
	       * ```
	       */
	      errors: _react2['default'].PropTypes.object,
	
	      /**
	       * Callback that is called when a validation error occurs. It is called with an `errors` object
	       *
	       * ```editable
	       * <Form schema={modelSchema}
	       *   defaultValue={modelSchema.default()}
	       *   errors={this.state ? this.state.errors : {}}
	       *   onError={errors => {
	       *     if( errors.dateOfBirth )
	       *       errors.dateOfBirth = 'hijacked!'
	       *     this.setState({ errors })
	       *   }}>
	       *
	       *   <Form.Field name='dateOfBirth'/>
	       *   <Form.Message for='dateOfBirth'/>
	       *
	       *   <Form.Button type='submit'>Submit</Form.Button>
	       * </Form>
	       * ```
	       */
	      onError: _react2['default'].PropTypes.func,
	
	      /**
	       * Callback that is called whenever a validation is triggered.
	       * It is called _before_ the validation is actually run.
	       * ```js
	       * function onValidate(event){
	       *   let { type, fields, args } = event
	       * }
	       * ```
	       */
	      onValidate: _react2['default'].PropTypes.func,
	
	      /**
	       * Callback that is fired when the native onSubmit event is triggered. Only relevant when
	       * the `component` prop renders a `<form/>` tag. onSubmit will trigger only if the form is valid.
	       *
	       * ```js
	       * function onSubmit(formValue){
	       *   // do something with valid value
	       * }
	       * ```
	       */
	      onSubmit: _react2['default'].PropTypes.func,
	
	      /**
	       * Callback that is fired when the native onSubmit event is triggered. Only relevant when
	       * the `component` prop renders a `<form/>` tag. onInvalidSubmit will trigger only if the form is invalid.
	       *
	       * ```js
	       * function onInvalidSubmit(errors){
	       *   // do something with errors
	       * }
	       * ```
	       */
	      onInvalidSubmit: _react2['default'].PropTypes.func,
	
	      /**
	       * A value getter function. `getter` is called with `path` and `value` and
	       * should return the plain **javascript** value at the path.
	       *
	        * ```js
	       * function(
	       *  path: string,
	       *  value: any,
	       * ) -> object
	       * ```
	       */
	      getter: _react2['default'].PropTypes.func,
	
	      /**
	       * A value setter function. `setter` is called with `path`, the form `value` and the path `value`.
	       * The `setter` must return updated form `value`, which allows you to leave the original value unmutated.
	       *
	       * The default implementation uses the [react immutability helpers](http://facebook.github.io/react/docs/update.html),
	       * letting you treat the form `value` as immutable.
	       * ```js
	       * function(
	       *  path: string,
	       *  formValue: object,
	       *  pathValue: any
	       * ) -> object
	       * ```
	       */
	      setter: _react2['default'].PropTypes.func,
	
	      /**
	       * Time in milliseconds that validations should be debounced. Reduces the amount of validation calls
	       * made at the expense of a slight delay. Helpful for performance.
	       */
	      delay: _react2['default'].PropTypes.number,
	
	      /**
	       * Validations will be strict, making no attempt to coarce input values to the appropriate type.
	       */
	      strict: _react2['default'].PropTypes.bool,
	
	      /**
	       * Turns off input validation for the Form, value updates will continue to work.
	       */
	      noValidate: _react2['default'].PropTypes.bool,
	
	      /**
	       * A tag name or Component class the Form should render.
	       *
	       * If `null` are `false` the form will simply render it's child. In
	       * this instance there must only be one child.
	       */
	      component: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string, _react2['default'].PropTypes.oneOf([null, false])]).isRequired,
	
	      /**
	       * A Yup schema  that validates the Form `value` prop. Used to validate the form input values
	       * For more information about the yup api check out: https://github.com/jquense/yup/blob/master/README.md
	       * @type {YupSchema}
	       */
	      schema: function schema(props, name, componentName) {
	        var err = !props.noValidate && _react2['default'].PropTypes.any.isRequired(props, name, componentName);
	
	        if (props[name]) {
	          var schema = props[name];
	          if (!schema.__isYupSchema__ && !(schema.resolve && schema.validate)) err = new Error('`schema` must be a proper yup schema: (' + componentName + ')');
	        }
	
	        return err;
	      }
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: _extends({}, BindingContext.defaultProps, {
	      component: 'form',
	      strict: false,
	      delay: 300,
	      getter: function getter(path, model) {
	        return path ? _propertyExpr2['default'].getter(path, true)(model || {}) : model;
	      }
	    }),
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      reactFormalContext: _react2['default'].PropTypes.object
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: _utilContextType2['default'],
	    enumerable: true
	  }]);
	
	  function Form(props, context) {
	    var _this = this;
	
	    _classCallCheck(this, Form);
	
	    _React$Component.call(this, props, context);
	
	    this._queue = [];
	    this._pathOptions = Object.create(null);
	    this._handleValidationRequest = this._handleValidationRequest.bind(this);
	
	    this._schema = this._schema.bind(this);
	    this.submit = this.submit.bind(this);
	    // silence the real submit
	    var timer = undefined;
	    this.onSubmit = function (e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        return _this.submit()['catch'](done);
	      }, 0);
	    };
	
	    this._setPathOptions = function (path, options) {
	      _this._pathOptions[path] = options;
	    };
	
	    this.validator = new _reactInputMessageValidator2['default'](function (path, _ref) {
	      var props = _ref.props;
	
	      var model = props.value,
	          schema = _this._schema(path),
	          value = props.getter(path, model),
	          parent = props.getter(getParent(path), model) || {},
	          options = _this._pathOptions[path] || {};
	
	      return schema.validate(value, _extends({}, props, options, { parent: parent, path: path })).then(function () {
	        return void 0;
	      })['catch'](function (err) {
	        if (isValidationError(err)) return _utilErrToJSON2['default'](err);
	        throw err;
	      });
	    });
	
	    syncErrors(this.validator, props.errors || {});
	  }
	
	  Form.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    return _reactPureRenderFunction2['default'].call(this, nextProps, nextState);
	  };
	
	  Form.prototype.componentDidMount = function componentDidMount() {
	    this._registerWithContext();
	  };
	
	  Form.prototype.componentWillUnmount = function componentWillUnmount() {
	    var timers = this._timers || {};
	
	    this._unmounted = true;
	    for (var k in timers) if (has(timers, k)) clearTimeout(timers[k]);
	  };
	
	  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    this._registerWithContext(nextContext);
	
	    if (nextProps.schema !== this.props.schema) {
	      this._queueValidation({
	        fields: Object.keys(nextProps.errors || {})
	      });
	    }
	
	    syncErrors(this.validator, nextProps.errors || {});
	
	    //if (nextProps.value !== this.props.value)
	    this._flushValidations(nextProps.delay);
	  };
	
	  Form.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var noValidate = _props.noValidate;
	    var schema = _props.schema;
	
	    var context = this._context && this._context.reactFormalContext;
	
	    if (!context || context.noValidate !== noValidate || context.schema !== schema) this._context = {
	      reactFormalContext: {
	        noValidate: noValidate,
	        schema: this._schema,
	        onSubmit: this.onSubmit,
	        onOptions: this._setPathOptions,
	        submit: null
	      }
	    };
	
	    return this._context;
	  };
	
	  Form.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props;
	    var children = _props2.children;
	    var onChange = _props2.onChange;
	    var value = _props2.value;
	    var Element = _props2.component;
	    var getter = _props2.getter;
	    var setter = _props2.setter;
	
	    var props = _objectWithoutProperties(_props2, ['children', 'onChange', 'value', 'component', 'getter', 'setter']);
	
	    if (Element === 'form') props.noValidate = true; // disable html5 validation
	
	    props.onSubmit = this.onSubmit;
	
	    if (Element === null || Element === false) {
	      children = _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	    } else {
	      children = _react2['default'].createElement(
	        Element,
	        props,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      BindingContext,
	      {
	        value: value,
	        onChange: onChange,
	        getter: getter,
	        setter: setter
	      },
	      _react2['default'].createElement(
	        _reactInputMessageMessageContainer2['default'],
	        {
	          ref: function (ref) {
	            return _this2._container = ref;
	          },
	          messages: this.props.errors,
	          onValidationNeeded: this._handleValidationRequest
	        },
	        children
	      )
	    );
	  };
	
	  Form.prototype._handleValidationRequest = function _handleValidationRequest(e) {
	    if (this.props.noValidate) return;
	
	    this.notify('onValidate', e);
	    this._queueValidation(e);
	
	    if (e.type !== 'onChange') this._flushValidations(this.props.delay);
	  };
	
	  Form.prototype._processValidations = function _processValidations(fields, props) {
	    var _this3 = this;
	
	    return this._validate(fields, props).then(function (errors) {
	      _this3._maybeWarnDebug(props.debug, errors, 'field validation');
	      _this3.notify('onError', errors);
	    })['catch'](done);
	  };
	
	  Form.prototype._validate = function _validate(fields) {
	    var props = arguments.length <= 1 || arguments[1] === undefined ? this.props : arguments[1];
	
	    return this.validator.validate(fields, { props: props });
	  };
	
	  Form.prototype.validate = function validate(fields) {
	    return this._validate(fields);
	  };
	
	  Form.prototype.validateGroup = function validateGroup(groups) {
	    var fields = this._container.fieldsForGroup(groups);
	
	    return this._validate(fields);
	  };
	
	  Form.prototype.submit = function submit() {
	    var _this4 = this;
	
	    var _props3 = this.props;
	    var schema = _props3.schema;
	    var noValidate = _props3.noValidate;
	    var value = _props3.value;
	    var debug = _props3.debug;
	
	    var options = _objectWithoutProperties(_props3, ['schema', 'noValidate', 'value', 'debug']);
	
	    options.abortEarly = false;
	    options.strict = false;
	
	    if (noValidate) return this.notify('onSubmit', value);
	
	    var handleSubmit = function handleSubmit(validatedValue) {
	      return _this4.notify('onSubmit', validatedValue);
	    };
	
	    var handleError = function handleError(err) {
	      if (!isValidationError(err)) throw err;
	
	      var errors = _utilErrToJSON2['default'](err);
	
	      _this4._maybeWarnDebug(debug, errors, 'onSubmit');
	
	      _this4.notify('onError', errors);
	      _this4.notify('onInvalidSubmit', errors);
	    };
	
	    return schema.validate(value, options)
	    // no catch, we aren't interested in errors from onSubmit handlers
	    .then(handleSubmit, handleError);
	  };
	
	  Form.prototype.timeout = function timeout(key, fn, ms) {
	    this._timers || (this._timers = Object.create(null));
	
	    if (this._unmounted) return;
	
	    clearTimeout(this._timers[key]);
	    this._timers[key] = setTimeout(fn, ms);
	  };
	
	  Form.prototype._schema = function _schema(path) {
	    var _props4 = this.props;
	    var schema = _props4.schema;
	    var value = _props4.value;
	    var context = _props4.context;
	
	    return schema && path && _yupLibUtilReach2['default'](schema, path, value, context);
	  };
	
	  Form.prototype._queueValidation = function _queueValidation(e) {
	    this._queue = _utilPaths2['default'].reduce(uniq(this._queue.concat(e.fields)));
	  };
	
	  Form.prototype._flushValidations = function _flushValidations(delay) {
	    var _this5 = this;
	
	    this.timeout('flush-validations', function () {
	      var fields = _this5._queue;
	      _this5._queue = [];
	      if (fields.length) _this5._processValidations(fields, _this5.props);
	    }, delay);
	  };
	
	  Form.prototype._registerWithContext = function _registerWithContext() {
	    var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	
	    if (context.reactFormalContext) {
	      var registerSubmit = context.reactFormalContext.registerSubmit;
	
	      if (registerSubmit) registerSubmit(this.submit);
	    }
	  };
	
	  Form.prototype._maybeWarnDebug = function _maybeWarnDebug(debug, errors, target) {
	    if (!debug) return;
	
	    if (false) {
	      var keys = Object.keys(errors);
	      _warning2['default'](!keys.length, '[react-formal] (' + target + ') invalid fields: ' + keys.join(', '));
	    }
	  };
	
	  Form.prototype.notify = function notify(event) {
	    var _props5;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    this.props[event] && (_props5 = this.props)[event].apply(_props5, args);
	  };
	
	  return Form;
	})(_react2['default'].Component);
	
	module.exports = _uncontrollable2['default'](Form, { value: 'onChange', errors: 'onError' }, ['submit', 'validateGroup', 'validate']);
	
	function uniq(arr) {
	  return arr.filter(function (item, i) {
	    return arr.indexOf(item) === i;
	  });
	}
	
	function syncErrors(validator) {
	  var errors = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  validator._errors = {};
	  Object.keys(errors).forEach(function (key) {
	    if (errors[key] != null) validator._errors[key] = [].concat(errors[key]);
	  });
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(760);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(763);
	
	var forEach = _require.forEach;
	
	var _require2 = __webpack_require__(764);
	
	var has = _require2.has;
	
	
	var trim = function trim(part) {
	  return part.substr(0, part.length - 1).substr(1);
	};
	
	module.exports = function (obj, path, value, context) {
	  var parent = void 0,
	      lastPart = void 0;
	
	  // if only one "value" arg then use it for both
	  context = context || value;
	
	  forEach(path, function (_part, isBracket, isArray) {
	    var part = isBracket ? trim(_part) : _part;
	
	    if (isArray || has(obj, '_subType')) {
	      // we skipped an array
	      var idx = isArray ? parseInt(part, 10) : 0;
	      obj = obj.resolve({ context: context, parent: parent, value: value })._subType;
	
	      if (value) {
	
	        if (isArray && idx >= value.length) {
	          throw new Error('Yup.reach cannot resolve an array item at index: ' + _part + ', in the path: ' + path + '. ' + 'because there is no value at that index. ');
	        }
	        value = value[idx];
	      }
	    }
	
	    if (!isArray) {
	      obj = obj.resolve({ context: context, parent: parent, value: value });
	
	      if (!has(obj, 'fields') || !has(obj.fields, part)) throw new Error('The schema does not contain the path: ' + path + '. ' + ('(failed at: ' + lastPart + ' which is a type: "' + obj._type + '") '));
	
	      obj = obj.fields[part];
	
	      parent = value;
	      value = value && value[part];
	      lastPart = isBracket ? '[' + _part + ']' : '.' + _part;
	    }
	  });
	
	  return obj && obj.resolve({ context: context, parent: parent, value: value });
	};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	/**
	 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
	 */
	'use strict'
	
	function Cache(maxSize) {
	  this._maxSize = maxSize
	  this.clear()
	}
	Cache.prototype.clear = function() {
	  this._size = 0
	  this._values = {}
	}
	Cache.prototype.get = function(key) {
	  return this._values[key]
	}
	Cache.prototype.set = function(key, value) {
	  this._size >= this._maxSize && this.clear()
	  if (!this._values.hasOwnProperty(key)) {
	    this._size++
	  }
	  return this._values[key] = value
	}
	
	var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
	  DIGIT_REGEX = /^\d+$/,
	  LEAD_DIGIT_REGEX = /^\d/,
	  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
	  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
	  MAX_CACHE_SIZE = 512
	
	var contentSecurityPolicy = false,
	  pathCache = new Cache(MAX_CACHE_SIZE),
	  setCache = new Cache(MAX_CACHE_SIZE),
	  getCache = new Cache(MAX_CACHE_SIZE)
	
	try {
	  new Function('')
	} catch (error) {
	  contentSecurityPolicy = true
	}
	
	module.exports = {
	  Cache: Cache,
	
	  expr: expr,
	
	  split: split,
	
	  normalizePath: normalizePath,
	
	  setter: contentSecurityPolicy
	    ? function(path) {
	      var parts = normalizePath(path)
	      return function(data, value) {
	        return setterFallback(parts, data, value)
	      }
	    }
	    : function(path) {
	      return setCache.get(path) || setCache.set(
	        path,
	        new Function(
	          'data, value',
	          expr(path, 'data') + ' = value'
	        )
	      )
	    },
	
	  getter: contentSecurityPolicy
	    ? function(path, safe) {
	      var parts = normalizePath(path)
	      return function(data) {
	        return getterFallback(parts, safe, data)
	      }
	    }
	    : function(path, safe) {
	      var key = path + '_' + safe
	      return getCache.get(key) || getCache.set(
	        key,
	        new Function('data', 'return ' + expr(path, safe, 'data'))
	      )
	    },
	
	  join: function(segments) {
	    return segments.reduce(function(path, part) {
	      return (
	        path +
	        (isQuoted(part) || DIGIT_REGEX.test(part)
	          ? '[' + part + ']'
	          : (path ? '.' : '') + part)
	      )
	    }, '')
	  },
	
	  forEach: function(path, cb, thisArg) {
	    forEach(split(path), cb, thisArg)
	  }
	}
	
	function setterFallback(parts, data, value) {
	  var index = 0,
	    len = parts.length
	  while (index < len - 1) {
	    data = data[parts[index++]]
	  }
	  data[parts[index]] = value
	}
	
	function getterFallback(parts, safe, data) {
	  var index = 0,
	    len = parts.length
	  while (index < len) {
	    if (data != null || !safe) {
	      data = data[parts[index++]]
	    } else {
	      return
	    }
	  }
	  return data
	}
	
	function normalizePath(path) {
	  return pathCache.get(path) || pathCache.set(
	    path,
	    split(path).map(function(part) {
	      return part.replace(CLEAN_QUOTES_REGEX, '$2')
	    })
	  )
	}
	
	function split(path) {
	  return path.match(SPLIT_REGEX)
	}
	
	function expr(expression, safe, param) {
	  expression = expression || ''
	
	  if (typeof safe === 'string') {
	    param = safe
	    safe = false
	  }
	
	  param = param || 'data'
	
	  if (expression && expression.charAt(0) !== '[') expression = '.' + expression
	
	  return safe ? makeSafe(expression, param) : param + expression
	}
	
	function forEach(parts, iter, thisArg) {
	  var len = parts.length,
	    part,
	    idx,
	    isArray,
	    isBracket
	
	  for (idx = 0; idx < len; idx++) {
	    part = parts[idx]
	
	    if (part) {
	      if (shouldBeQuoted(part)) {
	        part = '"' + part + '"'
	      }
	
	      isBracket = isQuoted(part)
	      isArray = !isBracket && /^\d+$/.test(part)
	
	      iter.call(thisArg, part, isBracket, isArray, idx, parts)
	    }
	  }
	}
	
	function isQuoted(str) {
	  return (
	    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
	  )
	}
	
	function makeSafe(path, param) {
	  var result = param,
	    parts = split(path),
	    isLast
	
	  forEach(parts, function(part, isBracket, isArray, idx, parts) {
	    isLast = idx === parts.length - 1
	
	    part = isBracket || isArray ? '[' + part + ']' : '.' + part
	
	    result += part + (!isLast ? ' || {})' : ')')
	  })
	
	  return new Array(parts.length + 1).join('(') + result
	}
	
	function hasLeadingNumber(part) {
	  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
	}
	
	function hasSpecialChars(part) {
	  return SPEC_CHAR_REGEX.test(part)
	}
	
	function shouldBeQuoted(part) {
	  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
	}


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(765),
	    ValidationError = __webpack_require__(770);
	
	var toString = Object.prototype.toString;
	
	var isObject = function isObject(obj) {
	  return obj && toString.call(obj) === '[object Object]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
	  return isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;
	};
	
	var isDate = function isDate(obj) {
	  return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	var isSchema = function isSchema(obj) {
	  return obj && obj.__isYupSchema__;
	};
	
	function settled(promises) {
	  var settle = function settle(promise) {
	    return promise.then(function (value) {
	      return { fulfilled: true, value: value };
	    }, function (value) {
	      return { fulfilled: false, value: value };
	    });
	  };
	
	  return Promise.all(promises.map(settle));
	}
	
	function collectErrors(_ref) {
	  var validations = _ref.validations;
	  var value = _ref.value;
	  var path = _ref.path;
	  var _ref$errors = _ref.errors;
	  var errors = _ref$errors === undefined ? [] : _ref$errors;
	  var sort = _ref.sort;
	
	  // unwrap aggregate errors
	  errors = errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
	
	  return settled(validations).then(function (results) {
	    var nestedErrors = results.filter(function (r) {
	      return !r.fulfilled;
	    }).reduce(function (arr, r) {
	      return arr.concat(r.value);
	    }, []);
	
	    if (sort) nestedErrors.sort(sort);
	    //show parent errors after the nested ones: name.first, name
	    errors = nestedErrors.concat(errors);
	
	    if (errors.length) throw new ValidationError(errors, value, path);
	  });
	}
	
	function assign(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (has(source, key)) target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	function uniq(arr, iter) {
	  var seen = {};
	
	  return arr.filter(function (item, idx) {
	    var key = iter(item, idx);
	
	    if (has(seen, key)) return false;
	    return seen[key] = true;
	  });
	}
	
	function transform(obj, cb, seed) {
	  cb = cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {}));
	
	  if (Array.isArray(obj)) obj.forEach(cb);else for (var key in obj) {
	    if (has(obj, key)) cb(obj[key], key, obj);
	  }return seed;
	}
	
	function merge(target, source) {
	  for (var key in source) {
	    if (has(source, key)) {
	      var targetVal = target[key],
	          sourceVal = source[key];
	
	      if (sourceVal === undefined) continue;
	
	      if (isSchema(sourceVal)) {
	        target[key] = isSchema(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
	      } else if (isObject(sourceVal)) {
	        target[key] = isObject(targetVal) ? merge(targetVal, sourceVal) : sourceVal;
	      } else if (Array.isArray(sourceVal)) {
	        target[key] = Array.isArray(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
	      } else target[key] = source[key];
	    }
	  }return target;
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	function inherits(ctor, superCtor, spec) {
	  ctor.prototype = Object.create(superCtor.prototype, {
	    constructor: {
	      value: ctor,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  assign(ctor.prototype, spec);
	}
	
	module.exports = {
	  inherits: inherits, uniq: uniq, has: has,
	  assign: assign, merge: merge, transform: transform,
	  isSchema: isSchema, isObject: isObject, isPlainObject: isPlainObject, isDate: isDate,
	  settled: settled, collectErrors: collectErrors
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(766)


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(767)


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(768);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._65 = 1;
	  p._55 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._65 === 3) {
	            val = val._55;
	          }
	          if (val._65 === 1) return res(i, val._55);
	          if (val._65 === 2) reject(val._55);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(769);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._40 = 0;
	  this._65 = 0;
	  this._55 = null;
	  this._72 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._37 = null;
	Promise._87 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._65 === 3) {
	    self = self._55;
	  }
	  if (Promise._37) {
	    Promise._37(self);
	  }
	  if (self._65 === 0) {
	    if (self._40 === 0) {
	      self._40 = 1;
	      self._72 = deferred;
	      return;
	    }
	    if (self._40 === 1) {
	      self._40 = 2;
	      self._72 = [self._72, deferred];
	      return;
	    }
	    self._72.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._65 === 1) {
	        resolve(deferred.promise, self._55);
	      } else {
	        reject(deferred.promise, self._55);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._55);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._65 = 3;
	      self._55 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._65 = 1;
	  self._55 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._65 = 2;
	  self._55 = newValue;
	  if (Promise._87) {
	    Promise._87(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._40 === 1) {
	    handle(self, self._72);
	    self._72 = null;
	  }
	  if (self._40 === 2) {
	    for (var i = 0; i < self._72.length; i++) {
	      handle(self, self._72[i]);
	    }
	    self._72 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var strReg = /\$\{\s*(\w+)\s*\}/g;
	
	var replace = function replace(str) {
	  return function (params) {
	    return str.replace(strReg, function (_, key) {
	      return params[key] || '';
	    });
	  };
	};
	
	module.exports = ValidationError;
	
	function ValidationError(errors, value, field, type) {
	  var _this = this;
	
	  this.name = 'ValidationError';
	  this.value = value;
	  this.path = field;
	  this.type = type;
	  this.errors = [];
	  this.inner = [];
	
	  if (errors) [].concat(errors).forEach(function (err) {
	    _this.errors = _this.errors.concat(err.errors || err);
	
	    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
	  });
	
	  this.message = this.errors.length > 1 ? this.errors.length + ' errors occurred' : this.errors[0];
	
	  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
	}
	
	ValidationError.prototype = Object.create(Error.prototype);
	ValidationError.prototype.constructor = ValidationError;
	
	ValidationError.isError = function (err) {
	  return err && err.name === 'ValidationError';
	};
	
	ValidationError.formatError = function (message, params) {
	
	  if (typeof message === 'string') message = replace(message);
	
	  var fn = function fn(_ref) {
	    var path = _ref.path;
	    var label = _ref.label;
	
	    var params = _objectWithoutProperties(_ref, ['path', 'label']);
	
	    params.path = label || path || 'this';
	
	    return message(params);
	  };
	
	  return arguments.length === 1 ? fn : fn(params);
	};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var React = __webpack_require__(2),
	    Promise = __webpack_require__(765);
	
	var Validator = (function () {
	  function Validator(validate) {
	    _classCallCheck(this, Validator);
	
	    this._validator = validate;
	    this._errors = Object.create(null);
	  }
	
	  Validator.prototype.errors = function errors(names) {
	    var _this = this;
	
	    if (!names || !names.length) return _extends({}, this._errors);
	
	    return [].concat(names).reduce(function (o, name) {
	      if (_this._errors[name]) o[name] = _this._errors[name];
	
	      return o;
	    }, {});
	  };
	
	  Validator.prototype.isValid = function isValid(name) {
	    return !this._errors[name] || !this._errors[name].length;
	  };
	
	  Validator.prototype.validate = function validate(name, context) {
	    var _this2 = this;
	
	    var fields = [].concat(name).map(function (key) {
	      return _this2._validateField(key, context);
	    });
	
	    this._removeError(name);
	
	    return Promise.all(fields).then(function () {
	      return _this2.errors();
	    });
	  };
	
	  Validator.prototype._validateField = function _validateField(name, context) {
	    var _this3 = this;
	
	    return new Promise(function (resolve, reject) {
	      Promise.resolve(_this3._validator(name, context)).then(function (msgs) {
	        msgs = msgs == null ? [] : [].concat(msgs);
	        if (msgs.length) _this3._addError(name, msgs);
	        resolve(!msgs.length);
	      })['catch'](reject);
	    });
	  };
	
	  Validator.prototype._addError = function _addError(name, msgs) {
	    this._errors[name] = msgs;
	  };
	
	  Validator.prototype._removeError = function _removeError(fields) {
	    var _this4 = this;
	
	    [].concat(fields).forEach(function (field) {
	      return delete _this4._errors[field];
	    });
	  };
	
	  return Validator;
	})();
	
	module.exports = Validator;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var uniq = function uniq(array) {
	  return array.filter(function (item, idx) {
	    return array.indexOf(item) == idx;
	  });
	};
	
	var has = function has(obj, key) {
	  return obj && ({}).hasOwnProperty.call(obj, key);
	};
	
	module.exports = (function (_React$Component) {
	  _inherits(ValidationContainer, _React$Component);
	
	  _createClass(ValidationContainer, null, [{
	    key: 'defaultProps',
	    value: {
	      messages: Object.create(null)
	    },
	    enumerable: true
	  }, {
	    key: 'propTypes',
	    value: {
	      messages: React.PropTypes.object,
	      onValidationNeeded: React.PropTypes.func
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      messageContainer: React.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  function ValidationContainer(props, context) {
	    _classCallCheck(this, ValidationContainer);
	
	    _React$Component.call(this, props, context);
	    this._handlers = [];
	    this._groups = Object.create(null);
	
	    this._messages = this._messages.bind(this);
	  }
	
	  ValidationContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this._emit(nextProps);
	  };
	
	  ValidationContainer.prototype.getChildContext = function getChildContext() {
	    var _this = this;
	
	    return this._context || (this._context = {
	
	      messageContainer: {
	
	        subscribe: function subscribe(listener) {
	          _this._handlers.push(listener);
	          listener(_this._listenerContext(_this.props));
	          return function () {
	            return _this._handlers.splice(_this._handlers.indexOf(listener), 1);
	          };
	        },
	
	        addToGroup: function addToGroup(group, fields) {
	          if (group === undefined) group = '';
	
	          group = _this._groups[group] || (_this._groups[group] = []);
	          fields = [].concat(fields);
	
	          fields.forEach(function (f) {
	            if (group.indexOf(f) === -1) group.push(f);
	          });
	
	          return function () {
	            return fields.forEach(function (f) {
	              return group.splice(group.indexOf(f), 1);
	            });
	          };
	        },
	
	        onValidateFields: function onValidateFields(fields, type, args) {
	          _this.props.onValidationNeeded && _this.props.onValidationNeeded({ type: type, fields: fields, args: args });
	        },
	
	        onValidateGroup: function onValidateGroup(group, type, args) {
	          var fields = _this.fieldsForGroup(group);
	          _this.props.onValidationNeeded && _this.props.onValidationNeeded({ type: type, fields: fields, args: args });
	        }
	      }
	    });
	  };
	
	  ValidationContainer.prototype._listenerContext = function _listenerContext(props) {
	    return this._messages.bind(null, props.messages || {});
	  };
	
	  ValidationContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  ValidationContainer.prototype.fieldsForGroup = function fieldsForGroup() {
	    var _this2 = this;
	
	    var groups = arguments.length <= 0 || arguments[0] === undefined ? Object.keys(this._groups) : arguments[0];
	
	    groups = [].concat(groups);
	    return uniq(groups.reduce(function (fields, group) {
	      return fields.concat(_this2._groups[group]);
	    }, []));
	  };
	
	  ValidationContainer.prototype._emit = function _emit(props) {
	    var context = this._listenerContext(props);
	    this._handlers.forEach(function (fn) {
	      return fn(context);
	    });
	  };
	
	  ValidationContainer.prototype._messages = function _messages(messages, names, groups) {
	    if (!names || !names.length) {
	      if (!groups || !groups.length) return _extends({}, messages);
	
	      names = this.fieldsForGroup(groups);
	    }
	
	    return [].concat(names).reduce(function (o, name) {
	      if (messages[name]) o[name] = messages[name];
	
	      return o;
	    }, {});
	  };
	
	  return ValidationContainer;
	})(React.Component);

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(774);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(775);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        propTypes;
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'becasue they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        this._values = utils.transform(keys, function (values, key) {
	          values[key] = props[utils.defaultKey(key)];
	        }, {});
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        keys.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      render: function render() {
	        var _this2 = this;
	
	        var newProps = {};
	        var _props = this.props;
	        var valueLink = _props.valueLink;
	        var checkedLink = _props.checkedLink;
	
	        var props = _objectWithoutProperties(_props, ['valueLink', 'checkedLink']);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this2.props[propName];
	
	          if (linkPropName && !isProp(_this2.props, propName) && isProp(_this2.props, linkPropName)) {
	            prop = _this2.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this2._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this2, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.customPropType = customPropType;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.isReactComponent = isReactComponent;
	exports.has = has;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function customPropType(handler, propType, name) {
	
	  return function (props, propName) {
	
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	
	      return propType && propType(props, propName, name);
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      var type = basePropTypes[prop];
	
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = customPropType(handler, type, displayName);
	
	      if (type !== undefined) obj[defaultKey(prop)] = type;
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var prop = __webpack_require__(763);
	
	function inPath(pathA, pathB) {
	
	  if (pathA === pathB) return true;
	  if (pathB.indexOf(pathA) === 0) return true;
	
	  var partsA = prop.split(pathA),
	      partsB = prop.split(pathB);
	
	  if (partsA.length > partsB.length) return false;
	
	  return partsA.every(function (part, idx) {
	    return clean(part) === clean(partsB[idx]);
	  });
	}
	
	function clean(part) {
	  return isQuoted(part) ? part.substr(1, part.length - 2) : part;
	}
	
	function isQuoted(str) {
	  return typeof str === 'string' && str && (str[0] === '"' || str[0] === "'");
	}
	
	module.exports = {
	
	  inPath: inPath,
	
	  isQuoted: isQuoted,
	
	  clean: clean,
	
	  reduce: function reduce(paths) {
	    if (paths.length <= 1) return paths;
	
	    return paths.reduce(function (paths, current) {
	      paths = paths.filter(function (p) {
	        return !inPath(current, p);
	      });
	
	      if (!paths.some(function (p) {
	        return inPath(p, current);
	      })) paths.push(current);
	
	      return paths;
	    }, []);
	  }
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	exports['default'] = {
	  reactFormalContext: _react2['default'].PropTypes.shape({
	    noValidate: _react2['default'].PropTypes.bool,
	    schema: _react2['default'].PropTypes.func,
	    onSubmit: _react2['default'].PropTypes.func,
	    onOptions: _react2['default'].PropTypes.func
	  }).isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = errToJSON;
	
	function errToJSON(error) {
	  if (error.inner.length) return error.inner.reduce(function (list, inner) {
	    list[inner.path] = (list[inner.path] || []).concat(errToJSON(inner));
	
	    return list;
	  }, {});
	
	  return {
	    message: error.message,
	    values: error.params,
	    type: error.type
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _BindingContext = __webpack_require__(780);
	
	var _BindingContext2 = _interopRequireDefault(_BindingContext);
	
	var _Binding = __webpack_require__(785);
	
	var _Binding2 = _interopRequireDefault(_Binding);
	
	module.exports = {
	  Binding: _Binding2['default'],
	  BindingContext: _BindingContext2['default']
	};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(781);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _updateIn = __webpack_require__(784);
	
	var _updateIn2 = _interopRequireDefault(_updateIn);
	
	var _propertyExpr = __webpack_require__(763);
	
	var _propertyExpr2 = _interopRequireDefault(_propertyExpr);
	
	var BindingContext = (function (_React$Component) {
	  _inherits(BindingContext, _React$Component);
	
	  _createClass(BindingContext, null, [{
	    key: 'propTypes',
	    value: {
	      /**
	       * BindingContext value object, can be left uncontrolled;
	       * use the `defaultValue` prop to initialize an uncontrolled BindingContext.
	       *
	       * BindingContext assumes that `value` is immutable so you must provide a _new_ value
	       * object to trigger an update. The `<Binding/>` components do this by default.
	       */
	      value: _react2['default'].PropTypes.object,
	
	      /**
	       * Callback that is called when the `value` prop changes.
	       *
	       * ```js
	       * function(
	       * 	value: object,
	       * 	updatedPaths: array<string>
	       * )
	       * ```
	       */
	      onChange: _react2['default'].PropTypes.func,
	
	      /**
	       * A function used to extract value paths from the Context value.
	       * `getter` is called with `path` and `value` and should return the value at that path.
	       * `getter()` is used when a `<Binding/>` provides a string `accessor`.
	       *
	        * ```js
	       * function(
	       *  path: string,
	       *  value: any,
	       * ) -> object
	       * ```
	       */
	      getter: _react2['default'].PropTypes.func,
	
	      /**
	       * A value setter function. `setter` is called with `path`, the context `value` and the path `value`.
	       * The `setter` must return updated form `value`, which allows you to leave the original value unmutated.
	       *
	       * ```js
	       * function(
	       *  path: string,
	       *  formValue: object,
	       *  pathValue: any
	       * ) -> object
	       * ```
	       */
	      setter: _react2['default'].PropTypes.func
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      registerWithBindingContext: _react2['default'].PropTypes.func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      getter: function getter(path, model) {
	        return path ? _propertyExpr2['default'].getter(path, true)(model || {}) : model;
	      },
	      setter: function setter(path, model, val) {
	        return _updateIn2['default'](model, path, val);
	      }
	    },
	    enumerable: true
	  }]);
	
	  function BindingContext(props, context) {
	    _classCallCheck(this, BindingContext);
	
	    _React$Component.call(this, props, context);
	    this._handlers = [];
	  }
	
	  BindingContext.prototype.getChildContext = function getChildContext() {
	    var _this = this;
	
	    return this._context || (this._context = {
	
	      registerWithBindingContext: function registerWithBindingContext(listener) {
	        var remove = function remove() {
	          return _this._handlers.splice(_this._handlers.indexOf(listener), 1);
	        };
	
	        _this._handlers.push(listener);
	        listener(_this._listenerContext(_this.props));
	
	        return {
	          remove: remove,
	          onChange: function onChange(mapValue, args) {
	            return _this._update(mapValue, args);
	          }
	        };
	      }
	    });
	  };
	
	  BindingContext.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value !== this.props.value) this._emit(nextProps);
	  };
	
	  BindingContext.prototype.render = function render() {
	    return _react2['default'].Children.only(this.props.children);
	  };
	
	  BindingContext.prototype._update = function _update(mapValue, args) {
	    var model = this.props.value,
	        updater = this.props.setter,
	        paths = [];
	
	    if (false) updater = wrapSetter(updater);
	
	    for (var key in mapValue) if (mapValue.hasOwnProperty(key)) {
	      var field = mapValue[key],
	          value = undefined;
	
	      if (typeof field === 'function') value = field.apply(undefined, args);else if (field === '.' || field == null || args[0] == null) value = args[0];else {
	        value = _propertyExpr2['default'].getter(field, true)(args[0]);
	      }
	
	      if (paths.indexOf(key) === -1) paths.push(key);
	
	      model = updater(key, model, value);
	    }
	
	    this.props.onChange(model, paths);
	  };
	
	  BindingContext.prototype._emit = function _emit(props) {
	    var context = this._listenerContext(props);
	    this._handlers.forEach(function (fn) {
	      return fn(context);
	    });
	  };
	
	  BindingContext.prototype._listenerContext = function _listenerContext(props) {
	    return {
	      value: function value(pathOrAccessor) {
	        return typeof pathOrAccessor === 'function' ? pathOrAccessor(props.value, props.getter) : props.getter(pathOrAccessor, props.value);
	      }
	    };
	  };
	
	  return BindingContext;
	})(_react2['default'].Component);
	
	function wrapSetter(setter) {
	  return function () {
	    var result = setter.apply(undefined, arguments);
	    _invariant2['default'](result && typeof result === 'object', '`setter(..)` props must return the form value object after updating a value.');
	    return result;
	  };
	}
	
	exports['default'] = _uncontrollable2['default'](BindingContext, { value: 'onChange' });
	module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(782);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(783);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        propTypes;
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'becasue they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        this._values = utils.transform(keys, function (values, key) {
	          values[key] = props[utils.defaultKey(key)];
	        }, {});
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        keys.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      render: function render() {
	        var _this2 = this;
	
	        var newProps = {};
	        var _props = this.props;
	        var valueLink = _props.valueLink;
	        var checkedLink = _props.checkedLink;
	
	        var props = _objectWithoutProperties(_props, ['valueLink', 'checkedLink']);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this2.props[propName];
	
	          if (linkPropName && !isProp(_this2.props, propName) && isProp(_this2.props, linkPropName)) {
	            prop = _this2.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this2._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this2, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.customPropType = customPropType;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.isReactComponent = isReactComponent;
	exports.has = has;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function customPropType(handler, propType, name) {
	
	  return function (props, propName) {
	
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	
	      return propType && propType(props, propName, name);
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      var type = basePropTypes[prop];
	
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = customPropType(handler, type, displayName);
	
	      if (type !== undefined) obj[defaultKey(prop)] = type;
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = update;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _propertyExpr = __webpack_require__(763);
	
	var _propertyExpr2 = _interopRequireDefault(_propertyExpr);
	
	var IS_ARRAY = /^\d+$/;
	
	function update(model, path, value) {
	  var parts = _propertyExpr2['default'].split(path),
	      newModel = copy(model),
	      part,
	      islast;
	
	  if (newModel == null) newModel = IS_ARRAY.test(parts[0]) ? [] : {};
	
	  var current = newModel;
	
	  for (var idx = 0; idx < parts.length; idx++) {
	    islast = idx === parts.length - 1;
	    part = clean(parts[idx]);
	
	    if (islast) current[part] = value;else {
	      current = current[part] = current[part] == null ? IS_ARRAY.test(parts[idx + 1]) ? [] : {} : copy(current[part]);
	    }
	  }
	
	  return newModel;
	}
	
	function clean(part) {
	  return isQuoted(part) ? part.substr(1, part.length - 2) : part;
	}
	
	function isQuoted(str) {
	  return typeof str === 'string' && str && (str[0] === '"' || str[0] === "'");
	}
	
	function copy(value) {
	  return Array.isArray(value) ? value.concat() : value !== null && typeof value === 'object' ? _extends(new value.constructor(), value) : value;
	}
	module.exports = exports['default'];

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildBridge = __webpack_require__(786);
	
	var _ChildBridge2 = _interopRequireDefault(_ChildBridge);
	
	function mapValue(props, propName, componentName) {
	  var isOpaqueAccessor = typeof props.bindTo === 'function';
	
	  if (isOpaqueAccessor) {
	    if (typeof props[propName] === 'function') return new Error(propName + ' must be an Object or a String, when `bindTo` is a function');
	  }
	
	  return _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string, _react.PropTypes.func])(props, propName, componentName);
	}
	
	var Binding = (function (_React$Component) {
	  _inherits(Binding, _React$Component);
	
	  _createClass(Binding, null, [{
	    key: 'propTypes',
	    value: {
	      /**
	       * A callback prop name that the Binding should listen for changes on.
	       *
	       * ```js
	       * <Binding changeProp='onSelect'>
	       *   <MyDropDown />
	       * </Binding>
	       * ```
	       */
	      changeProp: _react.PropTypes.string.isRequired,
	
	      /**
	       * A prop name for the Binding to set from the BindingContext.
	       *
	       * ```js
	       * <Binding valueProp='selectedValue'>
	       *   <MyDropDown />
	       * </Binding>
	       * ```
	       */
	      valueProp: _react.PropTypes.string.isRequired,
	
	      /**
	       * An field name or accessor function, extracting the Binding value
	       * from the overall BindingContext value. If a function, it's called
	       * with the form value, and the current Form `getter`.
	       *
	       * ```js
	       * <Binding bindTo='details.name'>
	       *   <input />
	       * </Binding>
	       *
	       * <Binding
	       *   bindTo={(model, getter) => {
	       *     let [first, last] = getter(model, 'details.name').split(' ')
	       *     return { first, last }
	       *   }}
	       * >
	       *  <MyDropdown />
	       * </Binding>
	       * ```
	       */
	      bindTo: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	      /**
	       * Customize how the Binding return value maps to the overall BindingContext `value`.
	       * `mapValue` can be a a string property name or a function that returns a
	       * value to be set to the `bindTo` field.
	       *
	       * ```js
	       * <Binding
	       *   bindTo='name'
	       *   mapValue={dropdownValue =>
	       *     dropdownValue.first + ' ' + dropdownValue.last
	       *   }
	       * >
	       *  <MyDropdown />
	       * </Binding>
	       * ```
	       *
	       * You can also provide an object hash, mapping paths of the BindingContext `value`
	       * to fields in the Binding value using a string field name, or a function accessor.
	       *
	       * ```js
	       * <Binding
	       *   bindTo={model => {
	       *     let [first, last] = model.name.split(' ')
	       *     return { first, last }
	       *   }}
	       *   mapValue={{
	       *    name: dropdownValue =>
	       *      dropdownValue.first + ' ' + dropdownValue.last
	       *   }}
	       * >
	       *   <MyDropdown />
	       * </Binding>
	       * ```
	       */
	      mapValue: mapValue,
	
	      /**
	       * The element to be bound. You can also specify a function child for components
	       * that nest and alter children. Or need more nuanced control over the injection process.
	       *
	       * ```js
	       * let Surround = (props) => <div {...props}>{props.children}</div>
	       *
	       * <Binding>
	       * {(bind)=>
	       *   <Surround>
	       *     {bind(<input type='text'/>)}
	       *   </Surround>
	       * }
	       * </Binding>
	       * ```
	       */
	      children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]).isRequired,
	
	      /**
	       * Configures the change callback to fire _after_ the child's change handler,
	       * if there is one.
	       */
	      updateAfterChild: _react.PropTypes.bool
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      changeProp: 'onChange',
	      valueProp: 'value',
	      updateAfterChild: false
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      registerWithBindingContext: _react.PropTypes.func
	    },
	    enumerable: true
	  }]);
	
	  function Binding() {
	    _classCallCheck(this, Binding);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _React$Component.call.apply(_React$Component, [this].concat(args));
	    this._inject = this._inject.bind(this);
	    this._change = this._change.bind(this);
	  }
	
	  Binding.prototype.componentWillMount = function componentWillMount() {
	    this.registerWithBindingContext();
	  };
	
	  Binding.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, _, nextContext) {
	    this.registerWithBindingContext(nextProps, nextContext);
	  };
	
	  Binding.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	    if (this.bindingContext) {
	      this.bindingContext.remove();
	    }
	  };
	
	  Binding.prototype.render = function render() {
	    var _props = this.props;
	    var changeProp = _props.changeProp;
	    var children = _props.children;
	
	    return _react2['default'].createElement(
	      _ChildBridge2['default'],
	      {
	        inject: this._inject,
	        events: changeProp,
	        onEvent: this._change
	      },
	      children
	    );
	  };
	
	  Binding.prototype.registerWithBindingContext = function registerWithBindingContext() {
	    var _this = this;
	
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    var register = context.registerWithBindingContext,
	        first = true;
	
	    if (register && !this.bindingContext) this.bindingContext = register(function (bindingContext) {
	      var last = _this._value;
	      _this._value = bindingContext.value(props.bindTo);
	
	      if (!first && last !== _this._value && !_this.unmounted) _this.forceUpdate();
	
	      first = false;
	    });
	  };
	
	  Binding.prototype._inject = function _inject() {
	    var _ref;
	
	    var valueProp = this.props.valueProp;
	    var isRegistered = !!this.bindingContext;
	
	    // let the underlying child prop "shine"
	    // through in cases where we have nothing to override with
	    if (isRegistered) return _ref = {}, _ref[valueProp] = this._value, _ref;
	
	    return {};
	  };
	
	  Binding.prototype._change = function _change(event, childHandler) {
	    var _props2 = this.props;
	    var bindTo = _props2.bindTo;
	    var mapValue = _props2.mapValue;
	    var updateAfterChild = _props2.updateAfterChild;
	
	    if (typeof bindTo === 'string') {
	      var _mapValue;
	
	      if (typeof mapValue !== 'object') mapValue = (_mapValue = {}, _mapValue[bindTo] = mapValue, _mapValue);
	    }
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    if (!this.bindingContext || !mapValue) {
	      if (childHandler) childHandler.apply(undefined, args);
	      return;
	    }
	
	    if (updateAfterChild && childHandler) childHandler.apply(undefined, args);
	
	    this.bindingContext.onChange(mapValue, args);
	
	    if (!updateAfterChild && childHandler) childHandler.apply(undefined, args);
	  };
	
	  return Binding;
	})(_react2['default'].Component);
	
	exports['default'] = Binding;
	module.exports = exports['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var ChildBridge = (function (_React$Component) {
	  _inherits(ChildBridge, _React$Component);
	
	  function ChildBridge() {
	    var _this = this;
	
	    _classCallCheck(this, ChildBridge);
	
	    _React$Component.apply(this, arguments);
	
	    this.createChild = function (element) {
	      var inject = _this.props.inject;
	
	      _this.currentChild = element;
	
	      return _react.cloneElement(_react2['default'].Children.only(element), _extends({}, inject(element), _this.events));
	    };
	  }
	
	  ChildBridge.prototype.componentWillMount = function componentWillMount() {
	    this.events = {};
	    this.processEvents(this.props.events);
	  };
	
	  ChildBridge.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.processEvents(nextProps.events);
	  };
	
	  ChildBridge.prototype.processEvents = function processEvents(events) {
	    var _this2 = this;
	
	    [].concat(events).forEach(function (event) {
	      _this2.events[event] = _this2.events[event] || function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _this2.handleEvent(event, args);
	      };
	    });
	  };
	
	  ChildBridge.prototype.handleEvent = function handleEvent(event, args) {
	    var _props;
	
	    var handler = this.currentChild.props[event];
	    (_props = this.props).onEvent.apply(_props, [event, handler].concat(args));
	  };
	
	  ChildBridge.prototype.render = function render() {
	    var child = this.props.children;
	
	    if (typeof child === 'function') return child(this.createChild);
	
	    return this.createChild(child);
	  };
	
	  _createClass(ChildBridge, null, [{
	    key: 'propTypes',
	    value: {
	      events: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
	      onEvent: _react.PropTypes.func.isRequired,
	      inject: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      events: []
	    },
	    enumerable: true
	  }]);
	
	  return ChildBridge;
	})(_react2['default'].Component);
	
	exports['default'] = ChildBridge;
	module.exports = exports['default'];

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderShallowEqual = __webpack_require__(760);
	
	var _reactPureRenderShallowEqual2 = _interopRequireDefault(_reactPureRenderShallowEqual);
	
	var _reactInputMessageMessageTrigger = __webpack_require__(788);
	
	var _reactInputMessageMessageTrigger2 = _interopRequireDefault(_reactInputMessageMessageTrigger);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilTypes = __webpack_require__(791);
	
	var _utilTypes2 = _interopRequireDefault(_utilTypes);
	
	var _utilContextType = __webpack_require__(777);
	
	var _utilContextType2 = _interopRequireDefault(_utilContextType);
	
	var _config = __webpack_require__(797);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _inputsInput = __webpack_require__(792);
	
	var _inputsInput2 = _interopRequireDefault(_inputsInput);
	
	var _utilIsReactComponent = __webpack_require__(798);
	
	var _utilIsReactComponent2 = _interopRequireDefault(_utilIsReactComponent);
	
	var _classnames = __webpack_require__(799);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _topeka = __webpack_require__(779);
	
	var _options = { recurse: undefined };
	
	/**
	 * The Field Component renders a form control and handles input value updates and validations.
	 * Changes to the Field value are automatically propagated back up to the containing Form
	 * Component.
	 *
	 * Fields provide a light abstraction over normal input components where values and onChange handlers
	 * are take care of for you. Beyond that they just render the input for their type, Fields whille pass along
	 * any props and children to the input so you can easily configure new input types.
	 *
	 * ```editable
	 * <Form
	 *   noValidate
	 *   schema={modelSchema}
	 *   defaultValue={{
	 *     name: { first: 'Sally'},
	 *     colorID: 0
	 *   }}
	 * >
	 *   <label>Name</label>
	 *   <Form.Field
	 *     name='name.first'
	 *     placeholder='First name'
	 *   />
	 *
	 *   <label>Favorite Color</label>
	 *   <Form.Field name='colorId' type='select'>
	 *     <option value={0}>Red</option>
	 *     <option value={1}>Yellow</option>
	 *     <option value={2}>Blue</option>
	 *     <option value={3}>other</option>
	 *   </Form.Field>
	 *   <Form.Button type='submit'>Submit</Form.Button>
	 * </Form>
	 * ```
	 */
	
	var Field = (function (_React$Component) {
	  _inherits(Field, _React$Component);
	
	  _createClass(Field, null, [{
	    key: 'contextTypes',
	    value: _utilContextType2['default'],
	    enumerable: true
	  }, {
	    key: 'propTypes',
	    value: {
	      /**
	       * The Field name, which should be path corresponding to a specific form `value` path.
	       *
	       * ```js
	       * // given the form value
	       * value = {
	       *   name: { first: '' }
	       *   languages: ['english', 'spanish']
	       * }
	       *
	       * // the path "name.first" would update the "first" property of the form value
	       * <Form.Field name='name.first' />
	       *
	       * // use indexes for paths that cross arrays
	       * <Form.Field name='languages[0]' />
	       *
	       * ```
	       */
	      name: _react2['default'].PropTypes.string.isRequired,
	
	      /**
	       * Group Fields together with a common `group` name. Groups can be
	       * validated together, helpful for multi-part forms.
	       *
	       * ```editable
	       * <Form
	       *   schema={modelSchema}
	       *   defaultValue={modelSchema.default()}
	       * >
	       *
	       *   <Form.Field
	       *     name='name.first'
	       *     group='name'
	       *     placeholder='first'
	       *   />
	       *   <Form.Field
	       *     name='name.last'
	       *     group='name'
	       *     placeholder='surname'
	       *   />
	       *   <Form.Message for={['name.first', 'name.last']}/>
	       *
	       *   <Form.Field
	       *     name='dateOfBirth'
	       *     placeholder='dob'
	       *   />
	       *
	       *   <Form.Button group='name'>
	       *     Validate Name
	       *   </Form.Button>
	       * </Form>
	       * ```
	       */
	      group: _react2['default'].PropTypes.string,
	
	      /**
	       * The Component Input the form should render. You can sepcify a builtin type
	       * with a string name e.g `'text'`, `'datetime-local'`, etc. or provide a Component
	       * type class directly. When no type is provided the Field will attempt determine
	       * the correct input from the corresponding scheme. A Field corresponding to a `yup.number()`
	       * will render a `type='number'` input by default.
	       *
	       * ```editable
	       * <Form noValidate schema={modelSchema}>
	       *   Use the schema to determine type
	       *   <Form.Field
	       *     name='dateOfBirth'
	       *     placeholder='date'
	       *   />
	       *
	       *   Override it!
	       *   <Form.Field
	       *     name='dateOfBirth'
	       *     type='time'
	       *     placeholder='time only'
	       *   />
	       *
	       *   Use a custom Component
	       *   (need native 'datetime' support to see it)
	       *   <Form.Field
	       *     name='dateOfBirth'
	       *     type={MyDateInput}/>
	       *
	       * </Form>
	       * ```
	       * Custom Inputs should comply with the basic input api contract: set a value via a `value` prop and
	       * broadcast changes to that value via an `onChange` handler.
	       *
	       * You can also permenantly map Components to a string `type` name via the top-level
	       * `addInputType()` api.
	       */
	      type: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string]),
	
	      /**
	       * Event name or array of event names that the Field should trigger a validation.
	       */
	      events: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.string)]),
	
	      /**
	       * Customize how the Field value maps to the overall Form `value`.
	       * `mapValue` can be a a string property name or a function that returns a
	       * value for `name`'d path, allowing you to set commuted values from the Field.
	       *
	       * ```js
	       * <Form.Field name='name'
	       *   mapValue={fieldValue => fieldValue.first + ' ' + fieldValue.last}
	       * />
	       * ```
	       *
	       * You can also provide an object hash, mapping paths of the Form `value`
	       * to fields in the field value using a string field name, or a function accessor.
	       *
	       * ```editable
	       * <Form
	       *   schema={modelSchema}
	       *   defaultValue={modelSchema.default()}
	       * >
	       *   <label>Name</label>
	       *   <Form.Field
	       *     name='name.first'
	       *     placeholder='First name'
	       *   />
	       *
	       *   <label>Date of Birth</label>
	       *   <Form.Field name='dateOfBirth'
	       *     mapValue={{
	       *       'dateOfBirth': date => date,
	       *       'age': date =>
	       *         (new Date()).getFullYear() - date.getFullYear()
	       *   }}/>
	        *   <label>Age</label>
	       *   <Form.Field name='age'/>
	       *
	       *   <Form.Button type='submit'>Submit</Form.Button>
	       * </Form>
	       * ```
	       */
	      mapValue: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string, _react2['default'].PropTypes.object]),
	
	      /**
	       * The css class added to the Field Input when it fails validation
	       */
	      errorClass: _react2['default'].PropTypes.string,
	
	      /**
	       * Tells the Field to trigger validation for addition paths as well as its own (`name`).
	       * Useful when used in conjuction with a `mapValue` hash that updates more than one value, or
	       * if you want to trigger validation for the parent path as well.
	       *
	       * ```js
	       * <Form.Field name='name.first' alsoValidates={['name']}/>
	       * <Form.Field name='name.last' alsoValidates={['name']}/>
	       * ```
	       */
	      alsoValidates: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.string),
	
	      /**
	       * Specify whether the Field will recursively validate sub paths.
	       * The below example will also validate `name.first` and `name.last`. Generally you won't need to touch this
	       * as `react-formal` makes some intelligent choices about whether to recurse or not on any given path.
	       *
	       * ```js
	       * <Form.Field name='name' recursive={true}/>
	       * ```
	       */
	      recursive: _react2['default'].PropTypes.string,
	
	      /**
	       * Disables validation for the Field.
	       */
	      noValidate: _react2['default'].PropTypes.bool
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      type: ''
	    },
	    enumerable: true
	  }]);
	
	  function Field() {
	    _classCallCheck(this, Field);
	
	    _React$Component.call(this);
	    this._inject = this._inject.bind(this);
	  }
	
	  Field.prototype.componentWillMount = function componentWillMount() {
	    var name = this.props.name;
	    var context = this.context.reactFormalContext;
	
	    if (false) _invariant2['default'](context.noValidate || !name || this.schema(name), 'There is no corresponding schema defined for this field: "' + name + '" ' + 'Each Field\'s `name` prop must be a valid path defined by the parent Form schema');
	
	    context.onOptions(this.props.name, this.options(this.props));
	  };
	
	  Field.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var context = this.context.reactFormalContext;
	
	    context.onOptions(nextProps.name, this.options(nextProps));
	  };
	
	  Field.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _, nextContext) {
	    //return scu.call(this, nextProps, nextState)
	    var result = !_reactPureRenderShallowEqual2['default'](nextProps, this.props) || !_reactPureRenderShallowEqual2['default'](nextContext, this.context);
	
	    return result;
	  };
	
	  Field.prototype.render = function render() {
	    var _mapValue,
	        _this = this;
	
	    var _props = this.props;
	    var events = _props.events;
	    var group = _props.group;
	    var mapValue = _props.mapValue;
	    var name = _props.name;
	    var type = _props.type;
	    var valueAccessor = _props.valueAccessor;
	
	    var props = _objectWithoutProperties(_props, ['events', 'group', 'mapValue', 'name', 'type', 'valueAccessor']);
	
	    var schema = this.schema(name),
	        Widget = this.getComponent(type, schema, props);
	
	    if (valueAccessor && typeof mapValue !== 'object') mapValue = (_mapValue = {}, _mapValue[name] = mapValue, _mapValue);
	
	    var forProp = props.alsoValidates == null ? name : [name].concat(props.alsoValidates);
	
	    return _react2['default'].createElement(
	      _topeka.Binding,
	      {
	        bindTo: valueAccessor || name,
	        mapValue: mapValue
	      },
	      function (bind) {
	        return !_this.shouldValidate() ? bind(Widget) : _react2['default'].createElement(
	          _reactInputMessageMessageTrigger2['default'],
	          {
	            'for': forProp,
	            group: group,
	            events: events || _config2['default'].events,
	            inject: _this._inject
	          },
	          bind(Widget)
	        );
	      }
	    );
	  };
	
	  Field.prototype._inject = function _inject(child, isActive) {
	    var errorClass = this.props.errorClass !== undefined ? this.props.errorClass : _config2['default'].errorClass;
	
	    return {
	      className: _classnames2['default'](child.props.className, isActive && errorClass)
	    };
	  };
	
	  Field.prototype.options = function options(props) {
	    if (_options.recursive !== props.recursive) _options = { recursive: props.recursive };
	
	    return _options;
	  };
	
	  Field.prototype.getComponent = function getComponent(type, schema, props) {
	    if (!type && schema) {
	      var meta = schema.meta && schema.meta() || {};
	      type = meta[_config2['default'].metadataField] || schema._type;
	    }
	
	    var typeIsString = typeof type === 'string',
	        Widget = type;
	
	    if (typeIsString) {
	      Widget = _utilTypes2['default'][type.toLowerCase()] || _inputsInput2['default'];
	      props.type = type;
	    }
	
	    return _react2['default'].createElement(Widget, _extends({
	      ref: _utilIsReactComponent2['default'](Widget) ? 'input' : null
	    }, props, {
	      name: this.props.name
	    }));
	  };
	
	  Field.prototype.schema = function schema(path) {
	    var context = this.context.reactFormalContext;
	    var schema = undefined;
	    try {
	      schema = path && context.schema && context.schema(path);
	    } catch (err) {} // eslint-disable-line no-empty
	
	    return schema;
	  };
	
	  Field.prototype.shouldValidate = function shouldValidate() {
	    var context = this.context.reactFormalContext;
	    return !(this.props.noValidate || context.noValidate);
	  };
	
	  Field.prototype.inputInstance = function inputInstance() {
	    return this.refs.input;
	  };
	
	  return Field;
	})(_react2['default'].Component);
	
	module.exports = Field;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2),
	    Bridge = __webpack_require__(786),
	    connectToMessageContainer = __webpack_require__(789);
	
	var stringOrArrayOfStrings = React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.arrayOf(React.PropTypes.string)]);
	
	var MessageTrigger = (function (_React$Component) {
	  _inherits(MessageTrigger, _React$Component);
	
	  _createClass(MessageTrigger, null, [{
	    key: 'propTypes',
	    value: {
	      events: stringOrArrayOfStrings,
	      inject: React.PropTypes.func,
	
	      'for': stringOrArrayOfStrings,
	      group: stringOrArrayOfStrings
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      messageContainer: React.PropTypes.object
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      events: 'onChange'
	    },
	    enumerable: true
	  }]);
	
	  function MessageTrigger() {
	    _classCallCheck(this, MessageTrigger);
	
	    _React$Component.call(this);
	    this._inject = this._inject.bind(this);
	    this._notify = this._notify.bind(this);
	  }
	
	  MessageTrigger.prototype.componentWillMount = function componentWillMount() {
	    if (!this.context.messageContainer || !this.props['for'] || !this.props['for'].length) return;
	
	    this._removeFromGroup = this.context.messageContainer.addToGroup(this.props.group, this.props['for']);
	  };
	
	  MessageTrigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    this._removeFromGroup && this._removeFromGroup();
	
	    if (!nextContext.messageContainer || !nextProps['for'] || !nextProps['for'].length) return;
	
	    this._removeFromGroup = this.context.messageContainer.addToGroup(nextProps.group, nextProps['for']);
	  };
	
	  MessageTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._removeFromGroup && this._removeFromGroup();
	  };
	
	  MessageTrigger.prototype.render = function render() {
	    return React.createElement(
	      Bridge,
	      {
	        inject: this._inject,
	        events: this.props.events,
	        onEvent: this._notify
	      },
	      this.props.children
	    );
	  };
	
	  MessageTrigger.prototype._inject = function _inject(child) {
	    var active = this.props['for'] && this.props.active;
	
	    if (this.props.inject) return this.props.inject(child, !!active);
	  };
	
	  MessageTrigger.prototype._notify = function _notify(event, handler) {
	    var container = this.context.messageContainer,
	        forProps = this.props['for'] ? [].concat(this.props['for']) : [];
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    handler && handler.apply(this, args);
	
	    if (!container) return;
	    if (forProps.length) container.onValidateFields(forProps, event, args);else container.onValidateGroup(this.props.group, event, args);
	  };
	
	  return MessageTrigger;
	})(React.Component);
	
	module.exports = connectToMessageContainer(MessageTrigger);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var shallowEqual = __webpack_require__(790);
	
	var stringOrArrayofStrings = React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.arrayOf(React.PropTypes.string)]);
	
	module.exports = function (Component) {
	  return (function (_React$Component) {
	    _inherits(MessageListener, _React$Component);
	
	    function MessageListener() {
	      _classCallCheck(this, MessageListener);
	
	      _React$Component.apply(this, arguments);
	    }
	
	    MessageListener.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      if (!(nextContext || {}).messageContainer) return true;
	      if (!this.state && nextState) return true;
	      if (this.state && !nextState) return true;
	      if (this.state.active !== nextState.active) return true;
	
	      return !shallowEqual(this.state.messages, nextState.messages) || !shallowEqual(this.props, nextProps);
	    };
	
	    MessageListener.prototype.componentWillMount = function componentWillMount() {
	      var _this = this;
	
	      var container = this.context.messageContainer;
	
	      if (container) {
	        this.unsubscribe = container.subscribe(function (getMessages) {
	          _this.setState(_this._getValidationState(getMessages));
	        });
	      }
	    };
	
	    MessageListener.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.unsubscribe && this.unsubscribe();
	    };
	
	    MessageListener.prototype.render = function render() {
	      return React.createElement(Component, _extends({}, this.props, this.state));
	    };
	
	    MessageListener.prototype._getValidationState = function _getValidationState(getMessages) {
	      var messages = getMessages(this.props['for'], this.props.group);
	
	      return {
	        messages: messages,
	        active: !!(messages && Object.keys(messages).length)
	      };
	    };
	
	    _createClass(MessageListener, null, [{
	      key: 'DecoratedComponent',
	      value: Component,
	      enumerable: true
	    }, {
	      key: 'propTypes',
	      value: {
	        'for': stringOrArrayofStrings,
	        group: stringOrArrayofStrings
	      },
	      enumerable: true
	    }, {
	      key: 'contextTypes',
	      value: {
	        messageContainer: React.PropTypes.object
	      },
	      enumerable: true
	    }]);
	
	    return MessageListener;
	  })(React.Component);
	};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function isEql(a, b) {
	  if (a === b) return true;
	  if (typeof a !== typeof b) return false;
	
	  if (Array.isArray(a)) return !a.some(function (a, idx) {
	    return a !== b[idx];
	  });
	
	  return false;
	}
	
	function shallowEqual(objA, objB) {
	  var eql = arguments.length <= 2 || arguments[2] === undefined ? isEql : arguments[2];
	
	  if (objA === objB) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || !eql(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	exports['default'] = shallowEqual;
	module.exports = exports['default'];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2),
	    Input = __webpack_require__(792),
	    DateInput = __webpack_require__(793),
	    NumberInput = __webpack_require__(794),
	    BoolInput = __webpack_require__(795),
	    SelectInput = __webpack_require__(796);
	
	var localDt = 'datetime-local';
	
	var wrapWithDefaults = function wrapWithDefaults(Component, defaults) {
	  return (function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      _React$Component.apply(this, arguments);
	    }
	
	    _class.prototype.render = function render() {
	      return React.createElement(Component, _extends({}, defaults, this.props, {
	        type: defaults.type || this.props.type
	      }));
	    };
	
	    return _class;
	  })(React.Component);
	};
	
	var types = Object.create(null);
	
	types.string = wrapWithDefaults(Input, { type: 'text' });
	types.number = NumberInput;
	types.date = types.time = types.datetime = types[localDt] = DateInput;
	
	types.array = types.listbox = wrapWithDefaults(SelectInput, { multiple: true });
	
	types.bool = types.boolean = BoolInput;
	
	types.textarea = wrapWithDefaults(Input, { tagName: 'textarea' });
	
	types.select = SelectInput;
	
	exports['default'] = types;
	module.exports = exports['default'];

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	
	var Input = (function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Input.prototype.render = function render() {
	    var _props = this.props;
	    var _props$tagName = _props.tagName;
	    var Tag = _props$tagName === undefined ? 'input' : _props$tagName;
	
	    var props = _objectWithoutProperties(_props, ['tagName']);
	
	    return React.createElement(Tag, _extends({}, props, { onChange: function (e) {
	        return props.onChange(e.target.value);
	      } }));
	  };
	
	  return Input;
	})(React.Component);
	
	module.exports = Input;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(792);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var pad = function pad(n) {
	  return n < 10 ? '0' + n : n;
	};
	
	var isValid = function isValid(date) {
	  return date && !isNaN(date.getTime());
	};
	
	var toLocal = function toLocal(date) {
	  return new Date((date = new Date(date)).getTime() + date.getTimezoneOffset() * 60000);
	};
	
	var parse = function parse(date, org, type) {
	  return toLocal(type === 'time' ? toDateString(org || new Date(), 'date') + 'T' + date : date);
	};
	
	var localISOString = function localISOString(date) {
	  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds()) + '.000';
	};
	
	var toDateString = function toDateString(date, type) {
	  if (!isValid(date)) return null;
	  date = localISOString(date);
	  if (type === 'date') date = date.substr(0, 10);
	  if (type === 'time') date = date.substr(11);
	  return date;
	};
	
	var DateInput = (function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput() {
	    _classCallCheck(this, DateInput);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DateInput.prototype.render = function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var _props$type = _props.type;
	    var type = _props$type === undefined ? 'date' : _props$type;
	
	    var props = _objectWithoutProperties(_props, ['value', 'type']);
	
	    return _react2['default'].createElement(_Input2['default'], _extends({}, props, {
	      type: type,
	      value: toDateString(value, type),
	      onChange: function (e) {
	        return props.onChange(parse(e.target.value, value, type));
	      }
	    }));
	  };
	
	  _createClass(DateInput, null, [{
	    key: 'propTypes',
	    value: {
	      value: _react2['default'].PropTypes.instanceOf(Date)
	    },
	    enumerable: true
	  }]);
	
	  return DateInput;
	})(_react2['default'].Component);
	
	module.exports = DateInput;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(792);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var isValid = function isValid(num) {
	  return typeof num === 'number' && !isNaN(num);
	};
	
	var isAtDelimiter = function isAtDelimiter(num, str) {
	  var next = str.length <= 1 ? false : parseFloat(str.substr(0, str.length - 1));
	  return typeof next === 'number' && !isNaN(next) && next === num;
	};
	
	var NumberInput = (function (_React$Component) {
	  _inherits(NumberInput, _React$Component);
	
	  function NumberInput() {
	    _classCallCheck(this, NumberInput);
	
	    _React$Component.apply(this, arguments);
	
	    this.state = {};
	  }
	
	  NumberInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value;
	
	    value = value == null || isNaN(value) ? '' : '' + value;
	
	    this.setState({ value: value });
	  };
	
	  NumberInput.prototype.render = function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var value = _props.value;
	
	    var props = _objectWithoutProperties(_props, ['value']);
	
	    value = this.state.value || value;
	
	    return _react2['default'].createElement(_Input2['default'], _extends({}, props, {
	      type: 'number',
	      value: value,
	      onChange: function (e) {
	        return _this._change(e);
	      }
	    }));
	  };
	
	  NumberInput.prototype._change = function _change(value) {
	    var current = this.props.value,
	        number = parseFloat(value);
	
	    if (value == null || value.trim() === '' || !isValid(number)) return this.props.onChange(null);
	
	    if (isValid(number) && number !== current && !isAtDelimiter(number, value)) return this.props.onChange(number);
	
	    this.setState({ value: value });
	  };
	
	  _createClass(NumberInput, null, [{
	    key: 'propTypes',
	    value: {
	      value: _react2['default'].PropTypes.number
	    },
	    enumerable: true
	  }]);
	
	  return NumberInput;
	})(_react2['default'].Component);
	
	module.exports = NumberInput;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(792);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var BoolInput = (function (_React$Component) {
	  _inherits(BoolInput, _React$Component);
	
	  function BoolInput() {
	    _classCallCheck(this, BoolInput);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  BoolInput.prototype.render = function render() {
	    var props = this.props;
	
	    return _react2['default'].createElement(_Input2['default'], _extends({}, props, {
	      type: 'checkbox',
	      checked: !!props.value,
	      onChange: function () {
	        return props.onChange(!props.value);
	      }
	    }));
	  };
	
	  _createClass(BoolInput, null, [{
	    key: 'propTypes',
	    value: {
	      value: _react2['default'].PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  return BoolInput;
	})(_react2['default'].Component);
	
	module.exports = BoolInput;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _Input = __webpack_require__(792);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var childAt = function childAt(children, idx) {
	  var child;
	  if (children.length !== undefined) child = children[idx];else _react2['default'].Children.forEach(children, function (c, i) {
	    return !child && i === idx && (child = c);
	  });
	  return child;
	};
	
	var Select = (function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    _classCallCheck(this, Select);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Select.prototype.render = function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var _props$tagName = _props.tagName;
	    var tagName = _props$tagName === undefined ? 'select' : _props$tagName;
	
	    var props = _objectWithoutProperties(_props, ['children', 'tagName']);
	
	    return _react2['default'].createElement(
	      _Input2['default'],
	      _extends({}, props, {
	        tagName: tagName,
	        onChange: function () {
	          return _this.change();
	        }
	      }),
	      children
	    );
	  };
	
	  Select.prototype.change = function change() {
	    var node = _reactDom.findDOMNode(this);
	    var _props2 = this.props;
	    var onChange = _props2.onChange;
	    var children = _props2.children;
	    var values = [];
	
	    if (!this.props.multiple) return this.props.onChange(childAt(children, node.selectedIndex).props.value);[].forEach.call(node.options, function (option, i) {
	      return option.selected && values.push(childAt(children, i).props.value);
	    });
	
	    onChange(values);
	  };
	
	  return Select;
	})(_react2['default'].Component);
	
	module.exports = Select;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  metadataField: 'reactFormalType',
	  events: ['onChange', 'onBlur'],
	  errorClass: 'invalid-field'
	};
	module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isReactComponent;
	
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	
	function classNames() {
		var classes = '';
		var arg;
	
		for (var i = 0; i < arguments.length; i++) {
			arg = arguments[i];
			if (!arg) {
				continue;
			}
	
			if ('string' === typeof arg || 'number' === typeof arg) {
				classes += ' ' + arg;
			} else if (Object.prototype.toString.call(arg) === '[object Array]') {
				classes += ' ' + classNames.apply(null, arg);
			} else if ('object' === typeof arg) {
				for (var key in arg) {
					if (!arg.hasOwnProperty(key) || !arg[key]) {
						continue;
					}
					classes += ' ' + key;
				}
			}
		}
		return classes.substr(1);
	}
	
	// safely export classNames for node / browserify
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	}
	
	// safely export classNames for RequireJS
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	/**
	 * `<Form.Context />` provides declarative API similar in purpose to the
	 * HTML5 `.form` attribute. Sometimes it is necessary to trigger a form
	 * validation or submission from _outside_ a `<Form />`.
	 *
	 * One approach is to use the imperative API of capturing the `<Form />` instance in a ref
	 * and calling the `.submit()` method on it, but this can be troublesome with
	 * Higher order Components, used by your app or other libraries.
	 *
	 * An more "React" approach is to use `<Form.Context />` to wrap both your form and trigger.
	 *
	 * ```js
	 * <Form.Context>
	 *   <MyForm />
	 *   <Form.Button type='submit' />
	 * </Form.Context>
	 * ```
	 *
	 * @alias Context
	 */
	
	var FormContext = (function (_React$Component) {
	  _inherits(FormContext, _React$Component);
	
	  function FormContext() {
	    _classCallCheck(this, FormContext);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormContext.prototype.getChildContext = function getChildContext() {
	    var _this = this;
	
	    return this._context || (this._context = {
	      reactFormalContext: {
	        registerSubmit: function registerSubmit(fn) {
	          return _this.submit = fn;
	        },
	        onSubmit: function onSubmit() {
	          if (_this.submit) _this.submit();
	        }
	      }
	    });
	  };
	
	  FormContext.prototype.render = function render() {
	    var Tag = this.props.component || 'div';
	    return _react2['default'].Children.count(this.props.children) === 1 ? this.props.children : _react2['default'].createElement(Tag, this.props);
	  };
	
	  _createClass(FormContext, null, [{
	    key: 'propTypes',
	
	    /**
	     * the component the Context will render as it's root if necessary.
	     * If there is only one child defined the Context will just return that.
	     *
	     * @default 'div'
	    **/
	    value: {
	      component: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string])
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      reactFormalContext: _react2['default'].PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  return FormContext;
	})(_react2['default'].Component);
	
	exports['default'] = FormContext;
	module.exports = exports['default'];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderFunction = __webpack_require__(759);
	
	var _reactPureRenderFunction2 = _interopRequireDefault(_reactPureRenderFunction);
	
	var _reactInputMessageMessage = __webpack_require__(802);
	
	var _reactInputMessageMessage2 = _interopRequireDefault(_reactInputMessageMessage);
	
	var _classnames = __webpack_require__(799);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilUniqMessage = __webpack_require__(803);
	
	var _utilUniqMessage2 = _interopRequireDefault(_utilUniqMessage);
	
	/**
	 * Represents a Form validation error message. Only renders when the
	 * value that it is `for` is invalid.
	 *
	 * @alias Message
	 */
	
	var ValidationMessage = (function (_React$Component) {
	  _inherits(ValidationMessage, _React$Component);
	
	  function ValidationMessage() {
	    _classCallCheck(this, ValidationMessage);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ValidationMessage.prototype.shouldComponentUpdate = function shouldComponentUpdate(p, s, c) {
	    return _reactPureRenderFunction2['default'].call(this, p, s, c);
	  };
	
	  ValidationMessage.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var errorClass = _props.errorClass;
	
	    return _react2['default'].createElement(_reactInputMessageMessage2['default'], _extends({}, this.props, {
	      className: _classnames2['default'](className, errorClass)
	    }));
	  };
	
	  _createClass(ValidationMessage, null, [{
	    key: 'propTypes',
	    value: _extends({}, _reactInputMessageMessage2['default'].propTypes, {
	
	      component: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string]).isRequired,
	
	      /**
	       * A css class that should be always be applied to the Message container.
	       */
	      errorClass: _react2['default'].PropTypes.string,
	
	      /**
	       * Map the passed in message object for the field to a string to display
	       */
	      extract: _react2['default'].PropTypes.func
	    }),
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      component: 'span',
	      errorClass: 'validation-error',
	      filter: _utilUniqMessage2['default'],
	      extract: function extract(error) {
	        return error.message || error;
	      }
	    },
	    enumerable: true
	  }]);
	
	  return ValidationMessage;
	})(_react2['default'].Component);
	
	module.exports = ValidationMessage;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2),
	    connectToMessageContainer = __webpack_require__(789);
	
	var values = function values(obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	var flatten = function flatten(arr, next) {
	  return arr.concat(next);
	};
	
	var Message = (function (_React$Component) {
	  _inherits(Message, _React$Component);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Message.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.component;
	    var messages = _props.messages;
	    var active = _props.active;
	    var delim = _props.delim;
	    var extract = _props.extract;
	    var filter = _props.filter;
	    var fieldFor = _props['for'];
	
	    var props = _objectWithoutProperties(_props, ['component', 'messages', 'active', 'delim', 'extract', 'filter', 'for']);
	
	    if (!active) return null;
	
	    return React.createElement(
	      Component,
	      props,
	      values(messages).reduce(flatten, []).filter(function (v, i, l) {
	        return filter(v, i, l, extract);
	      }).map(extract).join(delim)
	    );
	  };
	
	  _createClass(Message, null, [{
	    key: 'defaultProps',
	    value: {
	      component: 'span',
	      delim: ', ',
	      extract: function extract(f) {
	        return f;
	      },
	      filter: function filter(f) {
	        return true;
	      }
	    },
	    enumerable: true
	  }]);
	
	  return Message;
	})(React.Component);
	
	module.exports = connectToMessageContainer(Message);
	module.exports._Message = Message;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = uniqMessage;
	
	function uniqMessage(msg, i, list) {
	  var idx = -1;
	  var extract = function extract(item) {
	    return item.message || item;
	  };
	
	  msg = extract(msg);
	
	  list.some(function (item, ii) {
	    if (extract(item) === msg) {
	      idx = ii;
	      return true;
	    }
	  });
	
	  return idx === i;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderFunction = __webpack_require__(759);
	
	var _reactPureRenderFunction2 = _interopRequireDefault(_reactPureRenderFunction);
	
	var _reactInputMessageConnectToMessageContainer = __webpack_require__(789);
	
	var _reactInputMessageConnectToMessageContainer2 = _interopRequireDefault(_reactInputMessageConnectToMessageContainer);
	
	var _classnames = __webpack_require__(799);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilUniqMessage = __webpack_require__(803);
	
	var _utilUniqMessage2 = _interopRequireDefault(_utilUniqMessage);
	
	var splat = function splat(obj) {
	  return obj == null ? [] : [].concat(obj);
	};
	
	module.exports = _reactInputMessageConnectToMessageContainer2['default'](
	/**
	 * Display all Form validation `errors` in a single summary list.
	 *
	 * ```editable
	 * <Form
	 *   schema={modelSchema}
	 *   defaultValue={modelSchema.default()}
	 * >
	 *   <Form.Summary/>
	 *
	 *   <Form.Field name='name.first' placeholder='first'/>
	 *   <Form.Field name='name.last' placeholder='surname'/>
	 *   <Form.Field name='dateOfBirth' placeholder='dob'/>
	 *
	 *   <Form.Button>Validate</Form.Button>
	 * </Form>
	 * ```
	 * @alias Summary
	 */
	(function (_React$Component) {
	  _inherits(ValidationSummary, _React$Component);
	
	  function ValidationSummary() {
	    _classCallCheck(this, ValidationSummary);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ValidationSummary.prototype.shouldComponentUpdate = function shouldComponentUpdate(p, s, c) {
	    return _reactPureRenderFunction2['default'].call(this, p, s, c);
	  };
	
	  ValidationSummary.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.component;
	    var messages = _props.messages;
	    var active = _props.active;
	    var filter = _props.filter;
	    var extract = _props.extract;
	    var fieldFor = _props['for'];
	
	    var props = _objectWithoutProperties(_props, ['component', 'messages', 'active', 'filter', 'extract', 'for']);
	
	    if (!active) return null;
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, props, {
	        className: _classnames2['default'](props.className, props.errorClass)
	      }),
	      Object.keys(messages).reduce(function (list, k) {
	        return list.concat(splat(messages[k]));
	      }, []).filter(function (v, i, l) {
	        return filter(v, i, l, extract);
	      }).map(extract).map(props.formatMessage)
	    );
	  };
	
	  _createClass(ValidationSummary, null, [{
	    key: 'propTypes',
	    value: {
	
	      /**
	       * An error message renderer, Should return a `ReactElement`
	       * ```
	       * function(
	       *   message: string,
	       *   idx: number,
	       *   messages: array
	       * ) -> ReactElement
	       * ```
	       */
	      formatMessage: _react2['default'].PropTypes.func.isRequired,
	
	      /**
	       * A DOM node tag name or Component class the Message should render as.
	       */
	      component: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.func, _react2['default'].PropTypes.string]).isRequired,
	
	      /**
	       * A css class that should be always be applied to the Summary container.
	       */
	      errorClass: _react2['default'].PropTypes.string,
	
	      /**
	       * Specify a group to show erros for, if empty all form errors will be shown in the Summary.
	       */
	      group: _react2['default'].PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      component: 'ul',
	      errorClass: 'validation-error',
	      filter: _utilUniqMessage2['default'],
	      extract: function extract(error) {
	        return error.message || error;
	      },
	      formatMessage: function formatMessage(message, idx) {
	        return _react2['default'].createElement(
	          'li',
	          { key: idx },
	          message
	        );
	      }
	    },
	    enumerable: true
	  }]);
	
	  return ValidationSummary;
	})(_react2['default'].Component));

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(761);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactInputMessageMessageTrigger = __webpack_require__(788);
	
	var _reactInputMessageMessageTrigger2 = _interopRequireDefault(_reactInputMessageMessageTrigger);
	
	var _chainFunction = __webpack_require__(806);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _utilContextType = __webpack_require__(777);
	
	var _utilContextType2 = _interopRequireDefault(_utilContextType);
	
	/**
	 * A Form Button, for triggering validations for specific Field groups
	 */
	
	var Button = (function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Button.prototype.render = function render() {
	    var _props = this.props;
	    var type = _props.type;
	    var group = _props.group;
	    var events = _props.events;
	    var Component = _props.component;
	
	    var props = _objectWithoutProperties(_props, ['type', 'group', 'events', 'component']);
	
	    var context = this.context.reactFormalContext;
	
	    _warning2['default'](!group || type.toLowerCase() !== 'submit', 'You have specified a `group` prop with type="submit" on this Form.Button component. ' + 'submit type buttons will automatically trigger a form wide validation. ' + 'to trigger validation for just the group: `' + group + '` use type="button" instead.');
	
	    if (type.toLowerCase() === 'submit') return _react2['default'].createElement(
	      Component,
	      _extends({}, props, { onClick: _chainFunction2['default'](props.onClick, context.onSubmit) }),
	      this.props.children
	    );
	
	    return _react2['default'].createElement(
	      _reactInputMessageMessageTrigger2['default'],
	      { group: group, events: events },
	      _react2['default'].createElement(
	        Component,
	        _extends({}, props, { type: type }),
	        this.props.children
	      )
	    );
	  };
	
	  _createClass(Button, null, [{
	    key: 'propTypes',
	    value: {
	      /**
	       * The `<button/>` type
	       */
	      type: _react2['default'].PropTypes.oneOf(['button', 'submit']),
	
	      /**
	       * Specify a group to validate, if empty the entire form will be validated.
	       * If the button type is 'submit' the group will be ignored and the
	       * entire form will be validated prior to submission.
	       */
	      group: _react2['default'].PropTypes.string,
	
	      component: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.func]),
	
	      /**
	       * An array of event names that trigger validation.
	       */
	      events: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.string)
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: _utilContextType2['default'],
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      type: 'button',
	      component: 'button',
	      events: ['onClick']
	    },
	    enumerable: true
	  }]);
	
	  return Button;
	})(_react2['default'].Component);
	
	module.exports = Button;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilTypes = __webpack_require__(791);
	
	var _utilTypes2 = _interopRequireDefault(_utilTypes);
	
	var addType = function addType(type, Component) {
	  var compType = typeof Component;
	
	  if (typeof type !== 'string') throw new TypeError('the `type` parameter must be a string');
	
	  if (compType !== 'string' && compType !== 'function') throw new TypeError('The `Component` parameter must be a valid React Component class or tag name');
	
	  _utilTypes2['default'][type] = Component;
	};
	
	exports['default'] = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 2) return addType.apply(undefined, args);
	
	  for (var key in args[0]) if (has(args[0], key)) addType(key, args[0][key]);
	};
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var React = __webpack_require__(2),
	    widgets = __webpack_require__(809);
	
	function wrapWithDefaults(Component, defaults) {
	    return React.createClass({
	        getDefaultProps: function getDefaultProps() {
	            return defaults;
	        },
	        render: function render() {
	            return React.createElement(Component, this.props);
	        }
	
	        //cuando se utiliza wrapWithDefault se pierde el focus del elemento....
	        // , focus: function(){
	        //     this.refs.referencia.focus()
	        // }
	    });
	}
	
	var types = Object.create(null);
	
	types.combobox = widgets.Combobox;
	types.dropdownlist = widgets.DropdownList;
	types.calendar = widgets.Calendar;
	types.selectlist = widgets.SelectList;
	
	types.date = types.datepicker = wrapWithDefaults(widgets.DateTimePicker, { time: false /*, ref: 'referencia'*/ });
	types.date2 = widgets.DateTimePicker; // FIX!!
	
	types.time = types.timepicker = wrapWithDefaults(widgets.DateTimePicker, { calendar: false });
	
	types.datetime = types['datetime-local'] = types.datetimepicker = widgets.DateTimePicker;
	
	types.number = types.numberpicker = widgets.NumberPicker;
	
	types.array = types.multiselect = widgets.Multiselect;
	
	//types.date2 = ()=> <input type="date" placeholder="fecha"/>
	
	module.exports = types;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "react-formal-inputs.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var configure = __webpack_require__(810);
	
	if (false) {
	  [Array.prototype.some, Array.prototype.filter, Array.prototype.reduce].forEach(function (method) {
	    if (!method) throw new Error('One or more ES5 features is not available to ReactWidgets: http://jquense.github.io/react-widgets/docs/#/getting-started/browser');
	  });
	}
	
	module.exports = _extends({}, configure, {
	  DropdownList: __webpack_require__(827),
	  Combobox: __webpack_require__(865),
	  Calendar: __webpack_require__(868),
	  DateTimePicker: __webpack_require__(883),
	  NumberPicker: __webpack_require__(886),
	  Multiselect: __webpack_require__(889),
	  SelectList: __webpack_require__(892),
	
	  utils: {
	    ReplaceTransitionGroup: __webpack_require__(881),
	    SlideTransition: __webpack_require__(880)
	  }
	});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _configuration = __webpack_require__(811);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _localizers = __webpack_require__(825);
	
	var localizers = _interopRequireWildcard(_localizers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setAnimate: function setAnimate(animatefn) {
	    _configuration2.default.animate = animatefn;
	  },
	  setLocalizers: function setLocalizers(_ref) {
	    var date = _ref.date,
	        number = _ref.number;
	
	    date && this.setDateLocalizer(date);
	    number && this.setNumberLocalizer(number);
	  },
	
	
	  setDateLocalizer: localizers.setDate,
	
	  setNumberLocalizer: localizers.setNumber
	};
	module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _animate = __webpack_require__(812);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { animate: _animate2.default };
	module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = animate;
	
	var _hyphenate = __webpack_require__(813);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	var _style = __webpack_require__(814);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _on = __webpack_require__(821);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(823);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _properties = __webpack_require__(824);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var has = Object.prototype.hasOwnProperty,
	    reset = {},
	    TRANSLATION_MAP = {
	  left: 'translateX',
	  right: 'translateX',
	  top: 'translateY',
	  bottom: 'translateY'
	};
	
	reset[_properties2.default.property] = reset[_properties2.default.duration] = reset[_properties2.default.delay] = reset[_properties2.default.timing] = '';
	
	animate.endEvent = _properties2.default.end;
	animate.transform = _properties2.default.transform;
	animate.TRANSLATION_MAP = TRANSLATION_MAP;
	
	// super lean animate function for transitions
	// doesn't support all translations to keep it matching the jquery API
	/**
	 * code in part from: Zepto 1.1.4 | zeptojs.com/license
	 */
	function animate(node, properties, duration, easing, callback) {
	  var cssProperties = [],
	      fakeEvent = { target: node, currentTarget: node },
	      cssValues = {},
	      transforms = '',
	      fired;
	
	  if (typeof easing === 'function') callback = easing, easing = null;
	
	  if (!_properties2.default.end) duration = 0;
	  if (duration === undefined) duration = 200;
	
	  for (var key in properties) {
	    if (has.call(properties, key)) {
	      if (/(top|bottom)/.test(key)) transforms += TRANSLATION_MAP[key] + '(' + properties[key] + ') ';else {
	        cssValues[key] = properties[key];
	        cssProperties.push((0, _hyphenate2.default)(key));
	      }
	    }
	  }if (transforms) {
	    cssValues[_properties2.default.transform] = transforms;
	    cssProperties.push(_properties2.default.transform);
	  }
	
	  if (duration > 0) {
	    cssValues[_properties2.default.property] = cssProperties.join(', ');
	    cssValues[_properties2.default.duration] = duration / 1000 + 's';
	    cssValues[_properties2.default.delay] = 0 + 's';
	    cssValues[_properties2.default.timing] = easing || 'linear';
	
	    (0, _on2.default)(node, _properties2.default.end, done);
	
	    setTimeout(function () {
	      if (!fired) done(fakeEvent);
	    }, duration + 500);
	  }
	
	  node.clientLeft; // trigger page reflow
	  (0, _style2.default)(node, cssValues);
	
	  if (duration <= 0) setTimeout(done.bind(null, fakeEvent), 0);
	
	  return {
	    cancel: function cancel() {
	      if (fired) return;
	      fired = true;
	      (0, _off2.default)(node, _properties2.default.end, done);
	      (0, _style2.default)(node, reset);
	    }
	  };
	
	  function done(event) {
	    if (event.target !== event.currentTarget) return;
	
	    fired = true;
	    (0, _off2.default)(event.target, _properties2.default.end, done);
	    (0, _style2.default)(node, reset);
	    callback && callback.call(this);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(815),
	    hyphenate = __webpack_require__(817),
	    _getComputedStyle = __webpack_require__(818),
	    removeStyle = __webpack_require__(820);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(816);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(813);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(819);
	
	var _utilCamelizeStyle = __webpack_require__(815);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(822);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(822);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(822);
	
	var has = Object.prototype.hasOwnProperty,
	    transform = 'transform',
	    transition = {},
	    transitionTiming,
	    transitionDuration,
	    transitionProperty,
	    transitionDelay;
	
	if (canUseDOM) {
	  transition = getTransitionProperties();
	
	  transform = transition.prefix + transform;
	
	  transitionProperty = transition.prefix + 'transition-property';
	  transitionDuration = transition.prefix + 'transition-duration';
	  transitionDelay = transition.prefix + 'transition-delay';
	  transitionTiming = transition.prefix + 'transition-timing-function';
	}
	
	module.exports = {
	  transform: transform,
	  end: transition.end,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	function getTransitionProperties() {
	  var endEvent,
	      prefix = '',
	      transitions = {
	    O: 'otransitionend',
	    Moz: 'transitionend',
	    Webkit: 'webkitTransitionEnd',
	    ms: 'MSTransitionEnd'
	  };
	
	  var element = document.createElement('div');
	
	  for (var vendor in transitions) if (has.call(transitions, vendor)) {
	    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-';
	      endEvent = transitions[vendor];
	      break;
	    }
	  }
	
	  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';
	
	  return { end: endEvent, prefix: prefix };
	}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.date = exports.number = exports.setNumber = undefined;
	exports.setDate = setDate;
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ = __webpack_require__(826);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localePropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);
	
	var REQUIRED_NUMBER_FORMATS = ['default'];
	
	var REQUIRED_DATE_FORMATS = ['default', 'date', 'time', 'header', 'footer', 'dayOfMonth', 'month', 'year', 'decade', 'century'];
	
	function _format(localizer, formatter, value, format, culture) {
	  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
	
	  (0, _invariant2.default)(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
	
	  return result;
	}
	
	function checkFormats(requiredFormats, formats) {
	  if (false) requiredFormats.forEach(function (f) {
	    return (0, _invariant2.default)((0, _.has)(formats, f), 'localizer missing required format: `%s`', f);
	  });
	}
	
	var _numberLocalizer = createWrapper('NumberPicker');
	
	function setNumber(_ref) {
	  var _format2 = _ref.format,
	      _parse = _ref.parse,
	      _ref$decimalChar = _ref.decimalChar,
	      decimalChar = _ref$decimalChar === undefined ? function () {
	    return '.';
	  } : _ref$decimalChar,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? function () {
	    return null;
	  } : _ref$precision,
	      formats = _ref.formats,
	      propType = _ref.propType;
	
	  (0, _invariant2.default)(typeof _format2 === 'function', 'number localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof _parse === 'function', 'number localizer `parse(..)` must be a function');
	
	  checkFormats(REQUIRED_NUMBER_FORMATS, formats);
	
	  formats.editFormat = formats.editFormat || function (str) {
	    return parseFloat(str);
	  };
	
	  _numberLocalizer = {
	    formats: formats,
	    precision: precision,
	    decimalChar: decimalChar,
	    propType: propType || localePropType,
	
	    format: function format(value, str, culture) {
	      return _format(this, _format2, value, str, culture);
	    },
	    parse: function parse(value, culture, format) {
	      var result = _parse.call(this, value, culture, format);
	      (0, _invariant2.default)(result == null || typeof result === 'number', 'number localizer `parse(..)` must return a number, null, or undefined');
	      return result;
	    }
	  };
	}
	
	exports.setNumber = setNumber;
	var _dateLocalizer = createWrapper('DateTimePicker');
	
	function setDate(spec) {
	  (0, _invariant2.default)(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.parse === 'function', 'date localizer `parse(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
	  checkFormats(REQUIRED_DATE_FORMATS, spec.formats);
	
	  _dateLocalizer = {
	    formats: spec.formats,
	    propType: spec.propType || localePropType,
	    startOfWeek: spec.firstOfWeek,
	    format: function format(value, str, culture) {
	      return _format(this, spec.format, value, str, culture);
	    },
	    parse: function parse(value, culture) {
	      var result = spec.parse.call(this, value, culture);
	      (0, _invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
	      return result;
	    }
	  };
	}
	
	var number = exports.number = {
	  propType: function propType() {
	    var _numberLocalizer2;
	
	    return (_numberLocalizer2 = _numberLocalizer).propType.apply(_numberLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _numberLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _numberLocalizer3;
	
	    return (_numberLocalizer3 = _numberLocalizer).parse.apply(_numberLocalizer3, arguments);
	  },
	  format: function format() {
	    var _numberLocalizer4;
	
	    return (_numberLocalizer4 = _numberLocalizer).format.apply(_numberLocalizer4, arguments);
	  },
	  decimalChar: function decimalChar() {
	    var _numberLocalizer5;
	
	    return (_numberLocalizer5 = _numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
	  },
	  precision: function precision() {
	    var _numberLocalizer6;
	
	    return (_numberLocalizer6 = _numberLocalizer).precision.apply(_numberLocalizer6, arguments);
	  }
	};
	
	var date = exports.date = {
	  propType: function propType() {
	    var _dateLocalizer2;
	
	    return (_dateLocalizer2 = _dateLocalizer).propType.apply(_dateLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _dateLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _dateLocalizer3;
	
	    return (_dateLocalizer3 = _dateLocalizer).parse.apply(_dateLocalizer3, arguments);
	  },
	  format: function format() {
	    var _dateLocalizer4;
	
	    return (_dateLocalizer4 = _dateLocalizer).format.apply(_dateLocalizer4, arguments);
	  },
	  startOfWeek: function startOfWeek() {
	    var _dateLocalizer5;
	
	    return (_dateLocalizer5 = _dateLocalizer).startOfWeek.apply(_dateLocalizer5, arguments);
	  }
	};
	
	exports.default = { number: number, date: date };
	
	
	function createWrapper() {
	  var dummy = {};
	
	  if (false) {
	    ['formats', 'parse', 'format', 'firstOfWeek', 'precision', 'propType'].forEach(function (name) {
	      return Object.defineProperty(dummy, name, {
	        enumerable: true,
	        get: function get() {
	          throw new Error('[React Widgets] You are attempting to use a widget that requires localization ' + '(Calendar, DateTimePicker, NumberPicker). ' + 'However there is no localizer set. Please configure a localizer. \n\n' + 'see http://jquense.github.io/react-widgets/docs/#/i18n for more info.');
	        }
	      });
	    });
	  }
	  return dummy;
	}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var idCount = 0;
	
	var _ = module.exports = {
	
	  has: has,
	
	  result: function result(value) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return typeof value === 'function' ? value.apply(undefined, args) : value;
	  },
	
	  isShallowEqual: function isShallowEqual(a, b) {
	    if (a === b) return true;
	    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object') return a === b;
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) return false;
	
	    return shallowEqual(a, b);
	  },
	  transform: function transform(obj, cb, seed) {
	    _.each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	    return seed;
	  },
	  each: function each(obj, cb, thisArg) {
	    if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	    for (var key in obj) {
	      if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	    }
	  },
	  pick: function pick(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) !== -1) mapped[key] = val;
	    }, {});
	  },
	  pickProps: function pickProps(props, componentClass) {
	    return _.pick(props, Object.keys(componentClass.propTypes));
	  },
	  omit: function omit(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) === -1) mapped[key] = val;
	    }, {});
	  },
	  omitOwnProps: function omitOwnProps(component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      others[_key2 - 1] = arguments[_key2];
	    }
	
	    var keys = others.reduce(function (arr, compClass) {
	      return arr.concat(Object.keys(compClass.propTypes));
	    }, Object.keys(component.constructor.propTypes));
	
	    return _.omit(component.props, keys);
	  },
	  find: function find(arr, cb, thisArg) {
	    var result;
	    if (Array.isArray(arr)) {
	      arr.every(function (val, idx) {
	        if (cb.call(thisArg, val, idx, arr)) return result = val, false;
	        return true;
	      });
	      return result;
	    } else for (var key in arr) {
	      if (has(arr, key)) if (cb.call(thisArg, arr[key], key, arr)) return arr[key];
	    }
	  },
	  chunk: function chunk(array, chunkSize) {
	    var index = 0,
	        length = array ? array.length : 0,
	        result = [];
	
	    chunkSize = Math.max(+chunkSize || 1, 1);
	
	    while (index < length) {
	      result.push(array.slice(index, index += chunkSize));
	    }return result;
	  },
	  splat: function splat(obj) {
	    return obj == null ? [] : [].concat(obj);
	  },
	  noop: function noop() {},
	  uniqueId: function uniqueId(prefix) {
	    return '' + ((prefix == null ? '' : prefix) + ++idCount);
	  }
	};
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	function eql(a, b) {
	  return a === b;
	}
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 */
	function shallowEqual(objA, objB) {
	
	  if (objA == null || objB == null) return false;
	
	  var keysA = Object.keys(objA),
	      keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!has(objB, keysA[i]) || !eql(objA[keysA[i]], objB[keysA[i]])) return false;
	  }return true;
	}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _activeElement = __webpack_require__(829);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(831);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Input = __webpack_require__(833);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Select = __webpack_require__(834);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _DropdownListInput = __webpack_require__(836);
	
	var _DropdownListInput2 = _interopRequireDefault(_DropdownListInput);
	
	var _Popup = __webpack_require__(840);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(845);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(851);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(853);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var result = _3.default.result;
	
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  //-- controlled props -----------
	  value: _propTypes2.default.any,
	  onChange: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func,
	  //------------------------------------
	
	  data: _propTypes2.default.array,
	  valueField: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	
	  valueComponent: _propTypes4.default.elementType,
	  itemComponent: _propTypes4.default.elementType,
	  listComponent: _propTypes4.default.elementType,
	
	  groupComponent: _propTypes4.default.elementType,
	  groupBy: _propTypes4.default.accessor,
	
	  onSelect: _propTypes2.default.func,
	  searchTerm: _propTypes2.default.string,
	  onSearch: _propTypes2.default.func,
	  busy: _propTypes2.default.bool,
	  delay: _propTypes2.default.number,
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number, //popup
	
	  disabled: _propTypes4.default.disabled.acceptsArray,
	  readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	  messages: _propTypes2.default.shape({
	    open: _propTypes4.default.message,
	    emptyList: _propTypes4.default.message,
	    emptyFilter: _propTypes4.default.message,
	    filterPlaceholder: _propTypes4.default.message
	  })
	});
	
	var DropdownList = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'DropdownList',
	
	  mixins: [__webpack_require__(854), __webpack_require__(855), __webpack_require__(856), __webpack_require__(857), __webpack_require__(858), __webpack_require__(863), __webpack_require__(850)(), __webpack_require__(864)({
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      delay: 500,
	      value: '',
	      open: false,
	      data: [],
	      searchTerm: '',
	      messages: msgs(),
	      ariaActiveDescendantKey: 'dropdownlist'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        open = _props.open,
	        filter = _props.filter,
	        value = _props.value,
	        data = _props.data,
	        searchTerm = _props.searchTerm,
	        valueField = _props.valueField;
	
	
	    var processed = filter ? this.filter(data, searchTerm) : data,
	        initialIdx = (0, _dataHelpers.dataIndexOf)(data, value, valueField);
	
	    return {
	      filteredData: open && filter ? processed : null,
	      selectedItem: processed[initialIdx],
	      focusedItem: processed[initialIdx] || data[0]
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    var open = props.open,
	        filter = props.filter,
	        value = props.value,
	        data = props.data,
	        searchTerm = props.searchTerm,
	        valueField = props.valueField;
	
	
	    var processed = filter ? this.filter(data, searchTerm) : data,
	        idx = (0, _dataHelpers.dataIndexOf)(data, value, valueField);
	
	    this.setState({
	      filteredData: open && filter ? processed : null,
	      selectedItem: processed[idx],
	      focusedItem: processed[!~idx ? 0 : idx]
	    });
	  },
	  renderFilter: function renderFilter(messages) {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'filterWrapper', className: 'rw-filter-input' },
	      _react2.default.createElement(_Select2.default, { component: 'span', icon: 'search' }),
	      _react2.default.createElement(_Input2.default, {
	        ref: 'filter',
	        value: this.props.searchTerm,
	        placeholder: _3.default.result(messages.filterPlaceholder, this.props),
	        onChange: function onChange(e) {
	          return (0, _widgetHelpers.notify)(_this.props.onSearch, e.target.value);
	        }
	      })
	    );
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props2 = this.props,
	        open = _props2.open,
	        filter = _props2.filter,
	        data = _props2.data;
	    var _state = this.state,
	        selectedItem = _state.selectedItem,
	        focusedItem = _state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      filter && this.renderFilter(messages),
	      _react2.default.createElement(List, _extends({}, listProps, {
	        ref: 'list',
	        id: id,
	        data: items,
	        'aria-live': open && 'polite',
	        'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	        'aria-hidden': !this.props.open,
	        selected: selectedItem,
	        focused: open ? focusedItem : null,
	        onSelect: this.handleSelect,
	        onMove: this._scrollTo,
	        messages: {
	          emptyList: data.length ? messages.emptyFilter : messages.emptyList
	        } }))
	    );
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        className = _props3.className,
	        tabIndex = _props3.tabIndex,
	        duration = _props3.duration,
	        valueField = _props3.valueField,
	        textField = _props3.textField,
	        groupBy = _props3.groupBy,
	        messages = _props3.messages,
	        data = _props3.data,
	        busy = _props3.busy,
	        dropUp = _props3.dropUp,
	        placeholder = _props3.placeholder,
	        value = _props3.value,
	        open = _props3.open,
	        valueComponent = _props3.valueComponent,
	        List = _props3.listComponent;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var focused = this.state.focused;
	
	
	    var disabled = (0, _interaction.isDisabled)(this.props),
	        readOnly = (0, _interaction.isReadOnly)(this.props),
	        valueItem = (0, _dataHelpers.dataItem)(data, value, valueField) // take value from the raw data
	    ,
	        listID = (0, _widgetHelpers.instanceId)(this, '__listbox');
	
	    var elementProps = _extends(_3.default.omitOwnProps(this, List), {
	      role: 'combobox',
	      tabIndex: tabIndex || 0,
	      'aria-owns': listID,
	      'aria-expanded': !!open,
	      'aria-haspopup': true,
	      'aria-busy': !!busy,
	      'aria-live': !open && 'polite',
	      'aria-autocomplete': 'list',
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly
	    });
	
	    var shouldRenderPopup = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        ref: 'input',
	        className: (0, _classnames2.default)(className, 'rw-dropdownlist'),
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress
	      }),
	      _react2.default.createElement(_Select2.default, {
	        busy: busy,
	        icon: 'caret-down',
	        component: 'span',
	        className: 'rw-dropdownlist-picker',
	        label: result(messages.open, this.props)
	      }),
	      _react2.default.createElement(_DropdownListInput2.default, {
	        value: valueItem,
	        textField: textField,
	        placeholder: placeholder,
	        valueComponent: valueComponent
	      }),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          open: open,
	          dropUp: dropUp,
	          duration: duration,
	          onOpen: function onOpen() {
	            return _this2.focus();
	          },
	          onOpening: function onOpening() {
	            return _this2.refs.list.forceUpdate();
	          }
	        },
	        this.renderList(List, listID, messages)
	      )
	    );
	  },
	  handleSelect: function handleSelect(data) {
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(data);
	    this.focus(this);
	  },
	  handleClick: function handleClick(e) {
	    var wrapper = this.refs.filterWrapper;
	
	    if (!this.props.filter || !this.props.open) this.toggle();else if (!(0, _contains2.default)(_compat2.default.findDOMNode(wrapper), e.target)) this.close();
	
	    (0, _widgetHelpers.notify)(this.props.onClick, e);
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _this3 = this;
	
	    var key = e.key,
	        alt = e.altKey,
	        list = this.refs.list,
	        filtering = this.props.filter,
	        focusedItem = this.state.focusedItem,
	        selectedItem = this.state.selectedItem,
	        isOpen = this.props.open,
	        closeWithFocus = function closeWithFocus() {
	      _this3.close(), _compat2.default.findDOMNode(_this3).focus();
	    };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    var change = function change(item, fromList) {
	      if (item == null) return;
	      fromList ? _this3.handleSelect(item) : _this3.change(item);
	    };
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      e.preventDefault();
	
	      if (isOpen) this.setState({ focusedItem: list.last() });else change(list.last());
	    } else if (key === 'Home') {
	      e.preventDefault();
	
	      if (isOpen) this.setState({ focusedItem: list.first() });else change(list.first());
	    } else if (key === 'Escape' && isOpen) {
	      e.preventDefault();
	      closeWithFocus();
	    } else if ((key === 'Enter' || key === ' ' && !filtering) && isOpen) {
	      e.preventDefault();
	      change(this.state.focusedItem, true);
	    } else if (key === ' ' && !filtering && !isOpen) {
	      e.preventDefault();
	      this.open();
	    } else if (key === 'ArrowDown') {
	      if (alt) this.open();else if (isOpen) this.setState({ focusedItem: list.next(focusedItem) });else change(list.next(selectedItem));
	      e.preventDefault();
	    } else if (key === 'ArrowUp') {
	      if (alt) closeWithFocus();else if (isOpen) this.setState({ focusedItem: list.prev(focusedItem) });else change(list.prev(selectedItem));
	      e.preventDefault();
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    var _this4 = this;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (!(this.props.filter && this.props.open)) this.search(String.fromCharCode(e.which), function (item) {
	      _this4._mounted && _this4.props.open ? _this4.setState({ focusedItem: item }) : item && _this4.change(item);
	    });
	  },
	  change: function change(data) {
	    if (!(0, _dataHelpers.valueMatcher)(data, this.props.value, this.props.valueField)) {
	      (0, _widgetHelpers.notify)(this.props.onChange, data);
	      (0, _widgetHelpers.notify)(this.props.onSearch, '');
	      this.close();
	    }
	  },
	  focus: function focus(target) {
	    var _props4 = this.props,
	        filter = _props4.filter,
	        open = _props4.open;
	
	    var inst = target || (filter && open ? this.refs.filter : this.refs.input);
	
	    inst = _compat2.default.findDOMNode(inst);
	
	    if ((0, _activeElement2.default)() !== inst) inst.focus();
	  },
	  _data: function _data() {
	    return this.state.filteredData || this.props.data.concat();
	  },
	  search: function search(character, cb) {
	    var _this5 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase();
	
	    if (!character) return;
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var list = _this5.refs.list,
	          key = _this5.props.open ? 'focusedItem' : 'selectedItem',
	          item = list.next(_this5.state[key], word);
	
	      _this5._searchTerm = '';
	      if (item) cb(item);
	    }, this.props.delay);
	  },
	  open: function open() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.props.open ? this.close() : this.open();
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleClick', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleClick'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj)), _obj));
	
	function msgs(msgs) {
	  return _extends({
	    open: 'open dropdown',
	    filterPlaceholder: '',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(DropdownList, { open: 'onToggle', value: 'onChange', searchTerm: 'onSearch' }, ['focus']);
	module.exports = exports['default'];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(33);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(819);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(830);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(822);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = (_temp = _class = function (_React$Component) {
	  _inherits(Widget, _React$Component);
	
	  function Widget() {
	    _classCallCheck(this, Widget);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Widget.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        tabIndex = _props.tabIndex,
	        open = _props.open,
	        dropUp = _props.dropUp,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        focused = _props.focused,
	        props = _objectWithoutProperties(_props, ['className', 'tabIndex', 'open', 'dropUp', 'disabled', 'readOnly', 'focused']);
	
	    var isRtl = !!this.context.isRtl;
	    var openClass = 'rw-open' + (dropUp ? '-up' : '');
	
	    tabIndex = tabIndex != null ? tabIndex : '-1';
	
	    return _react2.default.createElement('div', _extends({}, props, {
	      tabIndex: tabIndex,
	      className: (0, _classnames2.default)(className, 'rw-widget', isRtl && 'rw-rtl', open && openClass, focused && 'rw-state-focus', disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly')
	    }));
	  };
	
	  return Widget;
	}(_react2.default.Component), _class.propTypes = {
	  tabIndex: _propTypes2.default.node,
	  focused: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  dropUp: _propTypes2.default.bool
	}, _class.contextTypes = {
	  isRtl: _propTypes2.default.bool
	}, _temp);
	exports.default = Widget;
	module.exports = exports['default'];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Input.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        value = _props.value,
	        tabIndex = _props.tabIndex,
	        _props$component = _props.component,
	        Component = _props$component === undefined ? 'input' : _props$component,
	        props = _objectWithoutProperties(_props, ['className', 'disabled', 'readOnly', 'value', 'tabIndex', 'component']);
	
	    return _react2.default.createElement(Component, _extends({}, props, {
	      type: 'text',
	      tabIndex: tabIndex || 0,
	      autoComplete: 'off',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly,
	      value: value == null ? '' : value,
	      className: (0, _classnames2.default)(className, 'rw-input')
	    }));
	  };
	
	  return Input;
	}(_react2.default.Component);
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(835);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    _classCallCheck(this, Select);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Select.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2.default.createElement(_Button2.default, _extends({}, props, {
	      className: (0, _classnames2.default)(className, 'rw-select')
	    }));
	  };
	
	  return Select;
	}(_react2.default.Component);
	
	exports.default = Select;
	module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        disabled = _props.disabled,
	        label = _props.label,
	        icon = _props.icon,
	        busy = _props.busy,
	        active = _props.active,
	        children = _props.children,
	        _props$component = _props.component,
	        Tag = _props$component === undefined ? 'button' : _props$component,
	        props = _objectWithoutProperties(_props, ['className', 'disabled', 'label', 'icon', 'busy', 'active', 'children', 'component']);
	
	    var type = props.type;
	
	    if (Tag === 'button') type = type || 'button';
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({}, props, {
	        tabIndex: '-1',
	        title: label,
	        type: type,
	        disabled: disabled,
	        'aria-disabled': disabled,
	        'aria-label': label,
	        className: (0, _classnames2.default)(className, 'rw-btn', active && !disabled && 'rw-state-active')
	      }),
	      icon && _react2.default.createElement('span', {
	        'aria-hidden': true,
	        className: (0, _classnames2.default)('rw-i', 'rw-i-' + icon, busy && 'rw-loading')
	      }),
	      children
	    );
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _dataHelpers = __webpack_require__(839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownListInput = (_temp = _class = function (_React$Component) {
	  _inherits(DropdownListInput, _React$Component);
	
	  function DropdownListInput() {
	    _classCallCheck(this, DropdownListInput);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownListInput.prototype.render = function render() {
	    var _props = this.props,
	        placeholder = _props.placeholder,
	        value = _props.value,
	        textField = _props.textField,
	        Component = _props.valueComponent;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-input' },
	      !value && placeholder ? _react2.default.createElement(
	        'span',
	        { className: 'rw-placeholder' },
	        placeholder
	      ) : Component ? _react2.default.createElement(Component, { item: value }) : (0, _dataHelpers.dataText)(value, textField)
	    );
	  };
	
	  return DropdownListInput;
	}(_react2.default.Component), _class.propTypes = {
	  value: _propTypes2.default.any,
	  placeholder: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	  valueComponent: _propTypes4.default.elementType
	}, _temp);
	exports.default = DropdownListInput;
	module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localizers = __webpack_require__(825);
	
	var _localizers2 = _interopRequireDefault(_localizers);
	
	var _filter = __webpack_require__(838);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterTypes = Object.keys(_filter2.default).filter(function (i) {
	  return i !== 'filter';
	});
	
	function getInteractionPropType(key) {
	  var types = [_propTypes2.default.bool, _propTypes2.default.oneOf([key])],
	      propType = _propTypes2.default.oneOfType(types);
	
	  propType.acceptsArray = _propTypes2.default.oneOfType(types.concat(_propTypes2.default.array));
	
	  return propType;
	}
	
	module.exports = {
	
	  elementType: createChainableTypeChecker(function (props, propName, componentName) {
	
	    if (typeof props[propName] !== 'function') {
	      if (_react2.default.isValidElement(props[propName])) return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type`, not an actual Element');
	
	      if (typeof props[propName] !== 'string') return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type` such as a tag name or return value of createReactClass(...)');
	    }
	    return null;
	  }),
	
	  numberFormat: createChainableTypeChecker(function () {
	    var _localizers$number;
	
	    return (_localizers$number = _localizers2.default.number).propType.apply(_localizers$number, arguments);
	  }),
	
	  dateFormat: createChainableTypeChecker(function () {
	    var _localizers$date;
	
	    return (_localizers$date = _localizers2.default.date).propType.apply(_localizers$date, arguments);
	  }),
	
	  disabled: getInteractionPropType('disabled'),
	  readOnly: getInteractionPropType('readOnly'),
	
	  accessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  message: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	
	  filter: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool, _propTypes2.default.oneOf(filterTypes)])
	};
	
	function createChainableTypeChecker(validate) {
	
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	
	    for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      args[_key - 4] = arguments[_key];
	    }
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop `' + propName + '` was not specified in  `' + componentName + '`.');
	      }
	    } else return validate.apply(undefined, [props, propName, componentName].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var common = {
	  eq: function eq(a, b) {
	    return a === b;
	  },
	  neq: function neq(a, b) {
	    return a !== b;
	  },
	  gt: function gt(a, b) {
	    return a > b;
	  },
	  gte: function gte(a, b) {
	    return a >= b;
	  },
	  lt: function lt(a, b) {
	    return a < b;
	  },
	  lte: function lte(a, b) {
	    return a <= b;
	  },
	  contains: function contains(a, b) {
	    return a.indexOf(b) !== -1;
	  },
	  startsWith: function startsWith(a, b) {
	    return a.lastIndexOf(b, 0) === 0;
	  },
	  endsWith: function endsWith(a, b) {
	    var pos = a.length - b.length,
	        lastIndex = a.indexOf(b, pos);
	
	    return lastIndex !== -1 && lastIndex === pos;
	  }
	};
	
	exports.default = common;
	module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.dataValue = dataValue;
	exports.dataText = dataText;
	exports.dataIndexOf = dataIndexOf;
	exports.valueMatcher = valueMatcher;
	exports.dataItem = dataItem;
	
	var _ = __webpack_require__(826);
	
	function accessor(data, field) {
	  var value = data;
	
	  if (typeof field === 'function') value = field(data);else if (data == null) value = data;else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && field in data) value = data[field];
	
	  return value;
	}
	
	function dataValue(item, valueField) {
	  return valueField && item && (0, _.has)(item, valueField) ? item[valueField] : item;
	}
	
	function dataText(item, textField) {
	  var value = accessor(item, textField);
	  return value == null ? '' : value + '';
	}
	
	function dataIndexOf(data, item, valueField) {
	  var idx = -1,
	      len = data.length,
	      isValueEqual = function isValueEqual(datum) {
	    return valueMatcher(item, datum, valueField);
	  };
	
	  while (++idx < len) {
	    var datum = data[idx];
	    if (datum === item || isValueEqual(datum)) return idx;
	  }
	
	  return -1;
	}
	
	/**
	 * I don't know that the shallow equal makes sense here but am too afraid to
	 * remove it.
	 */
	function valueMatcher(a, b, valueField) {
	  return (0, _.isShallowEqual)(dataValue(a, valueField), dataValue(b, valueField));
	}
	
	function dataItem(data, item, valueField) {
	  var idx = dataIndexOf(data, dataValue(item, valueField), valueField);
	
	  if (idx !== -1) return data[idx];
	
	  return item;
	}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _OVERFLOW;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _style = __webpack_require__(814);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(841);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _camelizeStyle = __webpack_require__(815);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _configuration = __webpack_require__(811);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = (0, _camelizeStyle2.default)(_configuration2.default.animate.transform);
	
	var CLOSING = 0,
	    CLOSED = 1,
	    OPENING = 2,
	    OPEN = 3;
	
	function properties(prop, value) {
	  var _ref, _ref2;
	
	  var TRANSLATION_MAP = _configuration2.default.animate.TRANSLATION_MAP;
	
	  if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) return _ref = {}, _ref[transform] = TRANSLATION_MAP[prop] + '(' + value + ')', _ref;
	
	  return _ref2 = {}, _ref2[prop] = value, _ref2;
	}
	
	var OVERFLOW = (_OVERFLOW = {}, _OVERFLOW[CLOSED] = 'hidden', _OVERFLOW[CLOSING] = 'hidden', _OVERFLOW[OPENING] = 'hidden', _OVERFLOW);
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	
	  onClosing: _propTypes2.default.func,
	  onOpening: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'Popup',
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      initialRender: true,
	      status: this.props.open ? OPENING : CLOSED
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      duration: 200,
	      open: false,
	      onClosing: function onClosing() {},
	      onOpening: function onOpening() {},
	      onClose: function onClose() {},
	      onOpen: function onOpen() {}
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      contentChanged: childKey(nextProps.children) !== childKey(this.props.children)
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var isOpen = this.state.status === OPENING;
	
	    _compat2.default.batchedUpdates(function () {
	      _this.setState({ initialRender: false });
	      if (isOpen) {
	        _this.open();
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate(pvProps) {
	    var closing = pvProps.open && !this.props.open,
	        opening = !pvProps.open && this.props.open,
	        open = this.props.open,
	        status = this.state.status;
	
	    if (!!pvProps.dropUp !== !!this.props.dropUp) {
	      this.cancelNextCallback();
	      if (status === OPENING) this.open();
	      if (status === CLOSING) this.close();
	      return;
	    }
	
	    if (opening) this.open();else if (closing) this.close();else if (open) {
	      // this.height() returns a floating point number with the desired height
	      // for this popup. Because of potential rounding errors in floating point
	      // aritmetic we must allow an error margin when comparing to the current
	      // state, otherwise we can end up in an infinite loop where the height
	      // is never exactly equal to our target value.
	      var height = this.height(),
	          diff = Math.abs(height - this.state.height);
	      if (isNaN(diff) || diff > 0.1) this.setState({ height: height });
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        dropUp = _props.dropUp,
	        style = _props.style,
	        _state = this.state,
	        status = _state.status,
	        height = _state.height;
	
	
	    var overflow = OVERFLOW[status] || 'visible',
	        display = status === CLOSED ? 'none' : 'block';
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: _extends({
	          display: display,
	          overflow: overflow,
	          height: height
	        }, style),
	        className: (0, _classnames2.default)(className, 'rw-popup-container', dropUp && 'rw-dropup', this.isTransitioning() && 'rw-popup-animating')
	      },
	      this.renderChildren()
	    );
	  },
	  renderChildren: function renderChildren() {
	    if (!this.props.children) return _react2.default.createElement('span', { className: 'rw-popup rw-widget' });
	
	    var offset = this.getOffsetForStatus(this.state.status),
	        child = _react2.default.Children.only(this.props.children);
	
	    return (0, _react.cloneElement)(child, {
	      style: _extends({}, child.props.style, offset, {
	        position: this.isTransitioning() ? 'absolute' : undefined
	      }),
	      className: (0, _classnames2.default)(child.props.className, 'rw-popup rw-widget')
	    });
	  },
	  open: function open() {
	    var _this2 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onOpening();
	
	    this.safeSetState({ status: OPENING, height: height }, function () {
	      var offset = _this2.getOffsetForStatus(OPEN),
	          duration = _this2.props.duration;
	
	      _this2.animate(el, offset, duration, 'ease', function () {
	        _this2.safeSetState({ status: OPEN }, function () {
	          _this2.props.onOpen();
	        });
	      });
	    });
	  },
	  close: function close() {
	    var _this3 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onClosing();
	
	    this.safeSetState({ status: CLOSING, height: height }, function () {
	      var offset = _this3.getOffsetForStatus(CLOSED),
	          duration = _this3.props.duration;
	
	      _this3.animate(el, offset, duration, 'ease', function () {
	        return _this3.safeSetState({ status: CLOSED }, function () {
	          _this3.props.onClose();
	        });
	      });
	    });
	  },
	  getOffsetForStatus: function getOffsetForStatus(status) {
	    var _CLOSED$CLOSING$OPENI;
	
	    if (this.state.initialRender) return {};
	
	    var _in = properties('top', this.props.dropUp ? '100%' : '-100%'),
	        out = properties('top', 0);
	    return (_CLOSED$CLOSING$OPENI = {}, _CLOSED$CLOSING$OPENI[CLOSED] = _in, _CLOSED$CLOSING$OPENI[CLOSING] = out, _CLOSED$CLOSING$OPENI[OPENING] = _in, _CLOSED$CLOSING$OPENI[OPEN] = out, _CLOSED$CLOSING$OPENI)[status] || {};
	  },
	  height: function height() {
	    var container = _compat2.default.findDOMNode(this),
	        content = container.firstChild,
	        margin = parseInt((0, _style2.default)(content, 'margin-top'), 10) + parseInt((0, _style2.default)(content, 'margin-bottom'), 10);
	
	    var old = container.style.display,
	        height = void 0;
	
	    container.style.display = 'block';
	    height = ((0, _height2.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
	    container.style.display = old;
	    return height;
	  },
	  isTransitioning: function isTransitioning() {
	    return this.state.status === OPENING || this.state.status === CLOSED;
	  },
	  animate: function animate(el, props, dur, easing, cb) {
	    this._transition = _configuration2.default.animate(el, props, dur, easing, this.setNextCallback(cb));
	  },
	  cancelNextCallback: function cancelNextCallback() {
	    if (this._transition && this._transition.cancel) {
	      this._transition.cancel();
	      this._transition = null;
	    }
	    if (this.nextCallback) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  },
	  safeSetState: function safeSetState(nextState, callback) {
	    this.setState(nextState, this.setNextCallback(callback));
	  },
	  setNextCallback: function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      return active = false;
	    };
	    return this.nextCallback;
	  }
	});
	
	
	function childKey(children) {
	  var nextChildMapping = _react2.default.Children.map(children, function (c) {
	    return c;
	  });
	  for (var key in nextChildMapping) {
	    return key;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(842),
	    getWindow = __webpack_require__(843);
	
	module.exports = function height(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
	};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var contains = __webpack_require__(831),
	    getWindow = __webpack_require__(843),
	    ownerDocument = __webpack_require__(830);
	
	module.exports = function offset(node) {
	  var doc = ownerDocument(node),
	      win = getWindow(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!contains(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  if (box.width || box.height) {
	
	    box = {
	      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	      width: (box.width == null ? node.offsetWidth : box.width) || 0,
	      height: (box.height == null ? node.offsetHeight : box.height) || 0
	    };
	  }
	
	  return box;
	};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _version = _react2.default.version.split('.').map(parseFloat);
	
	module.exports = {
	  version: function version() {
	    return _version;
	  },
	  findDOMNode: function findDOMNode(component) {
	    return _reactDom2.default.findDOMNode(component);
	  },
	  batchedUpdates: function batchedUpdates(cb) {
	    _reactDom2.default.unstable_batchedUpdates(cb);
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ListOption = __webpack_require__(846);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _widgetHelpers = __webpack_require__(847);
	
	var _interaction = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(849), __webpack_require__(850)()],
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    onSelect: _propTypes2.default.func,
	    onMove: _propTypes2.default.func,
	
	    optionComponent: _propTypes4.default.elementType,
	    itemComponent: _propTypes4.default.elementType,
	
	    selected: _propTypes2.default.any,
	    focused: _propTypes2.default.any,
	    valueField: _propTypes4.default.accessor,
	    textField: _propTypes4.default.accessor,
	
	    disabled: _propTypes4.default.disabled.acceptsArray,
	    readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	    messages: _propTypes2.default.shape({
	      emptyList: _propTypes4.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'list',
	      data: [],
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var _props = this.props,
	        data = _props.data,
	        focused = _props.focused,
	        idx = data.indexOf(focused),
	        activeId = optionId((0, _widgetHelpers.instanceId)(this), idx);
	
	
	    this.ariaActiveDescendant(idx !== -1 ? activeId : null);
	
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props,
	        className = _props2.className,
	        role = _props2.role,
	        data = _props2.data,
	        textField = _props2.textField,
	        valueField = _props2.valueField,
	        focused = _props2.focused,
	        selected = _props2.selected,
	        messages = _props2.messages,
	        onSelect = _props2.onSelect,
	        ItemComponent = _props2.itemComponent,
	        Option = _props2.optionComponent;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        items = void 0;
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    items = !data.length ? _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    ) : data.map(function (item, idx) {
	      var currentId = optionId(id, idx),
	          isDisabled = (0, _interaction.isDisabledItem)(item, _this.props),
	          isReadOnly = (0, _interaction.isReadOnlyItem)(item, _this.props);
	
	      return _react2.default.createElement(
	        Option,
	        {
	          key: 'item_' + idx,
	          id: currentId,
	          dataItem: item,
	          disabled: isDisabled,
	          readOnly: isReadOnly,
	          focused: focused === item,
	          selected: selected === item,
	          onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	        },
	        ItemComponent ? _react2.default.createElement(ItemComponent, {
	          item: item,
	          value: (0, _dataHelpers.dataValue)(item, valueField),
	          text: (0, _dataHelpers.dataText)(item, textField),
	          disabled: isDisabled,
	          readOnly: isReadOnly
	        }) : (0, _dataHelpers.dataText)(item, textField)
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _data: function _data() {
	    return this.props.data;
	  },
	  move: function move() {
	    var list = _compat2.default.findDOMNode(this),
	        idx = this._data().indexOf(this.props.focused),
	        selected = list.children[idx];
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, list, this.props.focused]);
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListOption = (0, _createReactClass2.default)({
	  displayName: 'ListOption',
	
	  propTypes: {
	    dataItem: _propTypes2.default.any,
	    focused: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    readOnly: _propTypes2.default.bool
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        focused = _props.focused,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    var classes = {
	      'rw-state-focus': focused,
	      'rw-state-selected': selected,
	      'rw-state-disabled': disabled,
	      'rw-state-readonly': readOnly
	    };
	
	    return _react2.default.createElement(
	      'li',
	      _extends({
	        role: 'option',
	        tabIndex: !(disabled || readOnly) ? '-1' : undefined,
	        'aria-selected': !!selected,
	        className: (0, _classnames2.default)('rw-list-option', className, classes)
	      }, props),
	      children
	    );
	  }
	});
	
	exports.default = ListOption;
	module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.notify = notify;
	exports.instanceId = instanceId;
	exports.isFirstFocusedRender = isFirstFocusedRender;
	
	var _ = __webpack_require__(826);
	
	function notify(handler, args) {
	  handler && handler.apply(null, [].concat(args));
	}
	
	function instanceId(component) {
	  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  component.__id || (component.__id = (0, _.uniqueId)('rw_'));
	  return (component.props.id || component.__id) + suffix;
	}
	
	function isFirstFocusedRender(component) {
	  return component._firstFocus || component.state.focused && (component._firstFocus = true);
	}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.widgetEditable = exports.widgetEnabled = undefined;
	exports.isDisabled = isDisabled;
	exports.isReadOnly = isReadOnly;
	exports.isDisabledItem = isDisabledItem;
	exports.isReadOnlyItem = isReadOnlyItem;
	exports.contains = contains;
	exports.move = move;
	
	var _dataHelpers = __webpack_require__(839);
	
	function isDisabled(props) {
	  return props.disabled === true || props.disabled === 'disabled';
	}
	
	function isReadOnly(props) {
	  return props.readOnly === true || props.readOnly === 'readOnly';
	}
	
	function isDisabledItem(item, props) {
	  return isDisabled(props) || contains(item, props.disabled, props.valueField);
	}
	
	function isReadOnlyItem(item, props) {
	  return isReadOnly(props) || contains(item, props.readOnly, props.valueField);
	}
	
	function contains(item, values, valueField) {
	  return Array.isArray(values) ? values.some(function (value) {
	    return (0, _dataHelpers.valueMatcher)(item, value, valueField);
	  }) : (0, _dataHelpers.valueMatcher)(item, values, valueField);
	}
	
	function move(dir, item, props, list) {
	  var isDisabledOrReadonly = function isDisabledOrReadonly(item) {
	    return isDisabledItem(item, props) || isReadOnlyItem(item, props);
	  },
	      stop = dir === 'next' ? list.last() : list.first(),
	      next = list[dir](item);
	
	  while (next !== stop && isDisabledOrReadonly(next)) {
	    next = list[dir](next);
	  }return isDisabledOrReadonly(next) ? item : next;
	}
	
	var widgetEnabled = exports.widgetEnabled = interactionDecorator(true);
	
	var widgetEditable = exports.widgetEditable = interactionDecorator(false);
	
	function interactionDecorator(disabledOnly) {
	  function wrap(method) {
	    return function decoratedMethod() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (!(isDisabled(this.props) || !disabledOnly && isReadOnly(this.props))) return method.apply(this, args);
	    };
	  }
	
	  return function decorate(target, key, desc) {
	    if (desc.initializer) {
	      var init = desc.initializer;
	      desc.initializer = function () {
	        return wrap(init());
	      };
	    } else desc.value = wrap(desc.value);
	    return desc;
	  };
	}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _filter = __webpack_require__(838);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _propTypes = __webpack_require__(837);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _interaction = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMPTY_VALUE = {};
	
	var isDisabledOrReadonly = function isDisabledOrReadonly(item, props) {
	  return (0, _interaction.isDisabledItem)(item, props) || (0, _interaction.isReadOnlyItem)(item, props);
	};
	
	exports.default = {
	
	  propTypes: {
	    textField: _propTypes2.default.accessor,
	    valueField: _propTypes2.default.accessor,
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray
	  },
	
	  first: function first() {
	    return this.next(EMPTY_VALUE);
	  },
	  last: function last() {
	    var data = this._data(),
	        item = data[data.length - 1];
	
	    return isDisabledOrReadonly(item, this.props) ? this.prev(item) : item;
	  },
	  prev: function prev(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item),
	        matches = matcher(word, item, this.props.textField);
	
	    if (nextIdx < 0 || nextIdx == null) nextIdx = 0;
	
	    nextIdx--;
	
	    while (nextIdx > -1 && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx--;
	    }return nextIdx >= 0 ? data[nextIdx] : item;
	  },
	  next: function next(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item) + 1,
	        len = data.length,
	        matches = matcher(word, item, this.props.textField);
	
	    while (nextIdx < len && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx++;
	    }return nextIdx < len ? data[nextIdx] : item;
	  }
	};
	
	
	function matcher(word, item, textField) {
	  if (!word) return function () {
	    return true;
	  };
	
	  word = word.toLowerCase();
	  return function (item) {
	    return _filter2.default.startsWith((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word);
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (nodeOrComponent) {
	  var reconcileChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultReconcile;
	
	
	  return {
	    propTypes: {
	      ariaActiveDescendantKey: _propTypes2.default.string.isRequired
	    },
	
	    contextTypes: {
	      activeDescendants: shape
	    },
	
	    childContextTypes: {
	      activeDescendants: shape
	    },
	
	    ariaActiveDescendant: function ariaActiveDescendant(id) {
	      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.ariaActiveDescendantKey;
	      var activeDescendants = this.context.activeDescendants;
	
	      var current = this.__ariaActiveDescendantId;
	
	      if (id === undefined) return current;
	
	      id = reconcileChildren.call(this, key, id);
	
	      if (id === undefined) id = current;else {
	        this.__ariaActiveDescendantId = id;
	        flushAriaToNode(id, nodeOrComponent, this);
	      }
	
	      activeDescendants && activeDescendants.reconcile(key, id);
	    },
	    getChildContext: function getChildContext() {
	      var _this = this;
	
	      return this._context || (this._context = {
	        activeDescendants: {
	          reconcile: function reconcile(key, id) {
	            return _this.ariaActiveDescendant(id, key);
	          }
	        }
	      });
	    }
	  };
	};
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shape = _propTypes2.default.shape({
	  //setActive: PropTypes.func,
	  reconcile: _propTypes2.default.func
	});
	
	function defaultReconcile(key, id) {
	  return id;
	}
	
	function flushAriaToNode(id, nodeOrComponent, ctx) {
	  var node = typeof nodeOrComponent === 'function' ? nodeOrComponent(ctx) : typeof nodeOrComponent === 'string' ? ctx.refs[nodeOrComponent] : ctx;
	
	  if (node) {
	    if (id) _compat2.default.findDOMNode(node).setAttribute('aria-activedescendant', id);else _compat2.default.findDOMNode(node).removeAttribute('aria-activedescendant');
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ListOption = __webpack_require__(846);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _warning = __webpack_require__(852);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _widgetHelpers = __webpack_require__(847);
	
	var _interaction = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(849), __webpack_require__(850)()],
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    onSelect: _propTypes2.default.func,
	    onMove: _propTypes2.default.func,
	
	    optionComponent: _propTypes4.default.elementType,
	    itemComponent: _propTypes4.default.elementType,
	    groupComponent: _propTypes4.default.elementType,
	
	    selected: _propTypes2.default.any,
	    focused: _propTypes2.default.any,
	
	    valueField: _propTypes4.default.accessor,
	    textField: _propTypes4.default.accessor,
	
	    disabled: _propTypes4.default.disabled.acceptsArray,
	    readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	    groupBy: _propTypes4.default.accessor,
	
	    messages: _propTypes2.default.shape({
	      emptyList: _propTypes4.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      data: [],
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'groupedList',
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var keys = [];
	
	    return {
	      groups: this._group(this.props.groupBy, this.props.data, keys),
	
	      sortedKeys: keys
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var keys = [];
	
	    if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) this.setState({
	      groups: this._group(nextProps.groupBy, nextProps.data, keys),
	      sortedKeys: keys
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.ariaActiveDescendant(this._currentActiveID);
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        className = _props.className,
	        role = _props.role,
	        data = _props.data,
	        messages = _props.messages;
	    var _state = this.state,
	        sortedKeys = _state.sortedKeys,
	        groups = _state.groups;
	
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    var items = [],
	        idx = -1,
	        group = void 0;
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    this._currentActiveID = null;
	
	    if (data.length) {
	      items = sortedKeys.reduce(function (items, key) {
	        group = groups[key];
	        items.push(_this._renderGroupHeader(key));
	
	        for (var itemIdx = 0; itemIdx < group.length; itemIdx++) {
	          items.push(_this._renderItem(key, group[itemIdx], ++idx));
	        }return items;
	      }, []);
	    } else items = _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    );
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        ref: 'scrollable',
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list', 'rw-list-grouped'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _renderGroupHeader: function _renderGroupHeader(group) {
	    var GroupComponent = this.props.groupComponent,
	        id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      'li',
	      {
	        key: 'item_' + group,
	        tabIndex: '-1',
	        role: 'separator',
	        id: id + '_group_' + group,
	        className: 'rw-list-optgroup'
	      },
	      GroupComponent ? _react2.default.createElement(GroupComponent, { item: group }) : group
	    );
	  },
	  _renderItem: function _renderItem(group, item, idx) {
	    var _props2 = this.props,
	        focused = _props2.focused,
	        selected = _props2.selected,
	        onSelect = _props2.onSelect,
	        textField = _props2.textField,
	        valueField = _props2.valueField,
	        ItemComponent = _props2.itemComponent,
	        Option = _props2.optionComponent;
	
	
	    var currentID = optionId((0, _widgetHelpers.instanceId)(this), idx),
	        isDisabled = (0, _interaction.isDisabledItem)(item, this.props),
	        isReadOnly = (0, _interaction.isReadOnlyItem)(item, this.props);
	
	    if (focused === item) this._currentActiveID = currentID;
	
	    return _react2.default.createElement(
	      Option,
	      {
	        key: 'item_' + group + '_' + idx,
	        id: currentID,
	        dataItem: item,
	        focused: focused === item,
	        selected: selected === item,
	        disabled: isDisabled,
	        readOnly: isReadOnly,
	        onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	      },
	      ItemComponent ? _react2.default.createElement(ItemComponent, {
	        item: item,
	        value: (0, _dataHelpers.dataValue)(item, valueField),
	        text: (0, _dataHelpers.dataText)(item, textField),
	        disabled: isDisabled,
	        readOnly: isReadOnly
	      }) : (0, _dataHelpers.dataText)(item, textField)
	    );
	  },
	  _isIndexOf: function _isIndexOf(idx, item) {
	    return this.props.data[idx] === item;
	  },
	  _group: function _group(groupBy, data, keys) {
	    var iter = typeof groupBy === 'function' ? groupBy : function (item) {
	      return item[groupBy];
	    };
	
	    // the keys array ensures that groups are rendered in the order they came in
	    // which means that if you sort the data array it will render sorted,
	    // so long as you also sorted by group
	    keys = keys || [];
	
	    (0, _warning2.default)(typeof groupBy !== 'string' || !data.length || _3.default.has(data[0], groupBy), '[React Widgets] You seem to be trying to group this list by a ' + ('property `' + groupBy + '` that doesn\'t exist in the dataset items, this may be a typo'));
	
	    return data.reduce(function (grps, item) {
	      var group = iter(item);
	
	      _3.default.has(grps, group) ? grps[group].push(item) : (keys.push(group), grps[group] = [item]);
	
	      return grps;
	    }, {});
	  },
	  _data: function _data() {
	    var groups = this.state.groups;
	
	    return this.state.sortedKeys.reduce(function (flat, grp) {
	      return flat.concat(groups[grp]);
	    }, []);
	  },
	  move: function move() {
	    var selected = this.getItemDOMNode(this.props.focused);
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, _compat2.default.findDOMNode(this), this.props.focused]);
	  },
	  getItemDOMNode: function getItemDOMNode(item) {
	    var list = _compat2.default.findDOMNode(this),
	        groups = this.state.groups,
	        idx = -1,
	        itemIdx,
	        child;
	
	    this.state.sortedKeys.some(function (group) {
	      itemIdx = groups[group].indexOf(item);
	      idx++;
	
	      if (itemIdx !== -1) return !!(child = list.children[idx + itemIdx + 1]);
	
	      idx += groups[group].length;
	    });
	
	    return child;
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validateListComponent;
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS = ['next', 'prev', 'first', 'last'];
	
	function validateListComponent(list) {
	  if (false) {
	    METHODS.forEach(function (method) {
	      return (0, _invariant2.default)(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(826),
	    has = _require.has;
	
	module.exports = {
	  componentWillUnmount: function componentWillUnmount() {
	    var timers = this._timers || {};
	
	    this._unmounted = true;
	
	    for (var k in timers) {
	      if (has(timers, k)) this.clearTimeout(k);
	    }
	  },
	  clearTimeout: function clearTimeout(key) {
	    var timers = this._timers || {};
	    window.clearTimeout(timers[key]);
	  },
	  setTimeout: function setTimeout(key, cb, duration) {
	    var _this = this;
	
	    var timers = this._timers || (this._timers = Object.create(null));
	
	    if (this._unmounted) return;
	
	    this.clearTimeout(key);
	    timers[key] = window.setTimeout(function () {
	      if (!_this._unmounted) cb();
	    }, duration);
	  }
	};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  propTypes: {
	    autoFocus: _propTypes2.default.bool
	  },
	
	  componentDidMount: function componentDidMount() {
	    var autoFocus = this.props.autoFocus;
	
	
	    if (autoFocus) this.focus ? this.focus() : (0, _reactDom.findDOMNode)(this).focus();
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(826);
	
	//backport PureRenderEqual
	module.exports = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_.isShallowEqual(this.props, nextProps) || !_.isShallowEqual(this.state, nextState);
	  }
	};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _filter = __webpack_require__(838);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _dataHelpers = __webpack_require__(839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dflt = function dflt(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	module.exports = {
	
	  propTypes: {
	    data: _propTypes2.default.array,
	    value: _propTypes2.default.any,
	    filter: _propTypes4.default.filter,
	    caseSensitive: _propTypes2.default.bool,
	    minLength: _propTypes2.default.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      caseSensitive: false,
	      minLength: 1
	    };
	  },
	  filterIndexOf: function filterIndexOf(items, searchTerm) {
	    var idx = -1,
	        matches = typeof this.props.filter === 'function' ? this.props.filter : getFilter(_filter2.default[dflt(this.props.filter)], searchTerm, this);
	
	    if (!searchTerm || !searchTerm.trim() || this.props.filter && searchTerm.length < (this.props.minLength || 1)) return -1;
	
	    items.every(function (item, i) {
	      if (matches(item, searchTerm, i)) return idx = i, false;
	
	      return true;
	    });
	
	    return idx;
	  },
	  filter: function filter(items, searchTerm) {
	    var matches = typeof this.props.filter === 'string' ? getFilter(_filter2.default[this.props.filter], searchTerm, this) : this.props.filter;
	
	    if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (this.props.minLength || 1)) return items;
	
	    return items.filter(function (item, idx) {
	      return matches(item, searchTerm, idx);
	    });
	  }
	};
	
	function getFilter(matcher, searchTerm, ctx) {
	  searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
	
	  return function (item) {
	    var val = (0, _dataHelpers.dataText)(item, ctx.props.textField);
	
	    if (!ctx.props.caseSensitive) val = val.toLowerCase();
	
	    return matcher(val, searchTerm);
	  };
	}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _scrollTo2 = __webpack_require__(859);
	
	var _scrollTo3 = _interopRequireDefault(_scrollTo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  _scrollTo: function _scrollTo(selected, list, focused) {
	    var state = this._scrollState || (this._scrollState = {}),
	        handler = this.props.onMove,
	        lastVisible = state.visible,
	        lastItem = state.focused,
	        shown,
	        changed;
	
	    state.visible = !(!list.offsetWidth || !list.offsetHeight);
	    state.focused = focused;
	
	    changed = lastItem !== focused;
	    shown = state.visible && !lastVisible;
	
	    if (shown || state.visible && changed) {
	      if (handler) handler(selected, list, focused);else {
	        state.scrollCancel && state.scrollCancel();
	        state.scrollCancel = (0, _scrollTo3.default)(selected, list);
	      }
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getOffset = __webpack_require__(842),
	    height = __webpack_require__(841),
	    getScrollParent = __webpack_require__(860),
	    scrollTop = __webpack_require__(861),
	    raf = __webpack_require__(862),
	    getWindow = __webpack_require__(843);
	
	module.exports = function scrollTo(selected, scrollParent) {
	    var offset = getOffset(selected),
	        poff = { top: 0, left: 0 },
	        list,
	        listScrollTop,
	        selectedTop,
	        isWin,
	        selectedHeight,
	        listHeight,
	        bottom;
	
	    if (!selected) return;
	
	    list = scrollParent || getScrollParent(selected);
	    isWin = getWindow(list);
	    listScrollTop = scrollTop(list);
	
	    listHeight = height(list, true);
	    isWin = getWindow(list);
	
	    if (!isWin) poff = getOffset(list);
	
	    offset = {
	        top: offset.top - poff.top,
	        left: offset.left - poff.left,
	        height: offset.height,
	        width: offset.width
	    };
	
	    selectedHeight = offset.height;
	    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
	    bottom = selectedTop + selectedHeight;
	
	    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
	
	    var id = raf(function () {
	        return scrollTop(list, listScrollTop);
	    });
	
	    return function () {
	        return raf.cancel(id);
	    };
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var css = __webpack_require__(814),
	    height = __webpack_require__(841);
	
	module.exports = function scrollPrarent(node) {
	  var position = css(node, 'position'),
	      excludeStatic = position === 'absolute',
	      ownerDoc = node.ownerDocument;
	
	  if (position === 'fixed') return ownerDoc || document;
	
	  while ((node = node.parentNode) && node.nodeType !== 9) {
	
	    var isStatic = excludeStatic && css(node, 'position') === 'static',
	        style = css(node, 'overflow') + css(node, 'overflow-y') + css(node, 'overflow-x');
	
	    if (isStatic) continue;
	
	    if (/(auto|scroll)/.test(style) && height(node) < node.scrollHeight) return node;
	  }
	
	  return document;
	};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(843);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(822);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(413);
	
	module.exports = {
	
	  propTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  contextTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  childContextTypes: {
	    isRtl: PropTypes.bool
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      isRtl: !!(this.props.isRtl || this.context && this.context.isRtl)
	    };
	  },
	  isRtl: function isRtl() {
	    return !!(this.props.isRtl || this.context && this.context.isRtl);
	  }
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FocusMixin;
	
	var _widgetHelpers = __webpack_require__(847);
	
	var _interaction = __webpack_require__(848);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function FocusMixin(_ref) {
	  var _desc, _value, _obj;
	
	  var willHandle = _ref.willHandle,
	      didHandle = _ref.didHandle;
	
	  function _handleFocus(inst, focused, event) {
	    var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
	
	    if (handler && event) event.persist();
	
	    if (willHandle && willHandle.call(inst, focused, event) === false) return;
	
	    inst.setTimeout('focus', function () {
	      _compat2.default.batchedUpdates(function () {
	        if (didHandle) didHandle.call(inst, focused, event);
	
	        if (focused !== inst.state.focused) {
	          (0, _widgetHelpers.notify)(handler, event);
	          if (inst._mounted) inst.setState({ focused: focused });
	        }
	      });
	    });
	  }
	
	  return _obj = {
	    handleBlur: function handleBlur(event) {
	      _handleFocus(this, false, event);
	    },
	    handleFocus: function handleFocus(event) {
	      _handleFocus(this, true, event);
	    },
	    componentDidMount: function componentDidMount() {
	      this._mounted = true;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      this._mounted = false;
	    }
	  }, (_applyDecoratedDescriptor(_obj, 'handleBlur', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleBlur'), _obj), _applyDecoratedDescriptor(_obj, 'handleFocus', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleFocus'), _obj)), _obj;
	}
	module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _filter = __webpack_require__(838);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(840);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Select = __webpack_require__(834);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _ComboboxInput = __webpack_require__(866);
	
	var _ComboboxInput2 = _interopRequireDefault(_ComboboxInput);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(845);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(851);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(853);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var defaultSuggest = function defaultSuggest(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  //-- controlled props -----------
	  value: _propTypes2.default.any,
	  onChange: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func,
	  //------------------------------------
	
	  itemComponent: _propTypes4.default.elementType,
	  listComponent: _propTypes4.default.elementType,
	
	  groupComponent: _propTypes4.default.elementType,
	  groupBy: _propTypes4.default.accessor,
	
	  data: _propTypes2.default.array,
	  valueField: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	  name: _propTypes2.default.string,
	
	  onSelect: _propTypes2.default.func,
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled.acceptsArray,
	  readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	  suggest: _propTypes4.default.filter,
	  filter: _propTypes4.default.filter,
	
	  busy: _propTypes2.default.bool,
	
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	
	  placeholder: _propTypes2.default.string,
	
	  'aria-labelledby': _propTypes2.default.string,
	  'aria-describedby': _propTypes2.default.string,
	
	  messages: _propTypes2.default.shape({
	    open: _propTypes4.default.message,
	    emptyList: _propTypes4.default.message,
	    emptyFilter: _propTypes4.default.message
	  })
	});
	
	var ComboBox = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'ComboBox',
	
	  mixins: [__webpack_require__(854), __webpack_require__(857), __webpack_require__(858), __webpack_require__(863), __webpack_require__(850)('input'), __webpack_require__(864)({
	    willHandle: function willHandle(focused) {
	      // not suggesting anymore
	      !focused && this.refs.input.accept();
	    },
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        value = _props.value,
	        data = _props.data,
	        valueField = _props.valueField,
	        items = this.process(data, value),
	        idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField);
	
	
	    return {
	      selectedItem: items[idx],
	      focusedItem: items[!~idx ? 0 : idx],
	      processedData: items,
	      open: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: [],
	      value: '',
	      open: false,
	      suggest: false,
	      filter: false,
	      delay: 500,
	
	      messages: msgs(),
	      ariaActiveDescendantKey: 'combobox'
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var isSuggesting = this.refs.input && this.refs.input.isSuggesting(),
	        stateChanged = !_3.default.isShallowEqual(nextState, this.state),
	        valueChanged = !_3.default.isShallowEqual(nextProps, this.props);
	
	    return isSuggesting || stateChanged || valueChanged;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        data = nextProps.data,
	        valueField = nextProps.valueField,
	        textField = nextProps.textField;
	
	
	    var rawIdx = (0, _dataHelpers.dataIndexOf)(data, value, valueField),
	        valueItem = rawIdx === -1 ? nextProps.value : nextProps.data[rawIdx],
	        isSuggesting = this.refs.input && this.refs.input.isSuggesting();
	
	    var items = this.process(nextProps.data, nextProps.value, (rawIdx === -1 || isSuggesting) && (0, _dataHelpers.dataText)(valueItem, textField));
	
	    var idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField),
	        focused = this.filterIndexOf(items, (0, _dataHelpers.dataText)(valueItem, textField));
	
	    this._searchTerm = '';
	
	    this.setState({
	      processedData: items,
	      selectedItem: items[idx],
	      focusedItem: items[idx === -1 ? focused !== -1 ? focused : 0 // focus the closest match
	      : idx]
	    });
	  },
	  renderInput: function renderInput(listID) {
	    var _props2 = this.props,
	        suggest = _props2.suggest,
	        filter = _props2.filter,
	        textField = _props2.textField,
	        busy = _props2.busy,
	        name = _props2.name,
	        data = _props2.data,
	        value = _props2.value,
	        valueField = _props2.valueField,
	        autoFocus = _props2.autoFocus,
	        tabIndex = _props2.tabIndex,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly,
	        placeholder = _props2.placeholder,
	        open = _props2.open,
	        ariaLabelledby = _props2['aria-labelledby'],
	        ariaDescribedby = _props2['aria-describedby'];
	
	
	    var valueItem = (0, _dataHelpers.dataItem)(data, value, valueField); // take value from the raw data
	
	    var completeType = suggest ? filter ? 'both' : 'inline' : filter ? 'list' : '';
	
	    return _react2.default.createElement(_ComboboxInput2.default, {
	      ref: 'input',
	      id: (0, _widgetHelpers.instanceId)(this, '_input'),
	      autoFocus: autoFocus,
	      tabIndex: tabIndex,
	      suggest: suggest,
	      name: name,
	      role: 'combobox',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-owns': listID,
	      'aria-busy': !!busy,
	      'aria-autocomplete': completeType,
	      'aria-expanded': open,
	      'aria-haspopup': true,
	      'aria-describedby': ariaDescribedby,
	      'aria-labelledby': ariaLabelledby,
	      placeholder: placeholder,
	      value: (0, _dataHelpers.dataText)(valueItem, textField),
	      onChange: this.handleInputChange,
	      onKeyDown: this.handleInputKeyDown
	    });
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props3 = this.props,
	        open = _props3.open,
	        data = _props3.data;
	    var _state = this.state,
	        selectedItem = _state.selectedItem,
	        focusedItem = _state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(List, _extends({ ref: 'list'
	    }, listProps, {
	      id: id,
	      data: items,
	      selected: selectedItem,
	      focused: focusedItem,
	      'aria-hidden': !open,
	      'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	      'aria-live': open && 'polite',
	      onSelect: this.handleSelect,
	      onMove: this._scrollTo,
	      messages: {
	        emptyList: data.length ? messages.emptyFilter : messages.emptyList
	      }
	    }));
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props4 = this.props,
	        className = _props4.className,
	        duration = _props4.duration,
	        groupBy = _props4.groupBy,
	        messages = _props4.messages,
	        busy = _props4.busy,
	        dropUp = _props4.dropUp,
	        open = _props4.open,
	        List = _props4.listComponent;
	    var focused = this.state.focused;
	
	
	    var disabled = (0, _interaction.isDisabled)(this.props),
	        readOnly = (0, _interaction.isReadOnly)(this.props),
	        listID = (0, _widgetHelpers.instanceId)(this, '_listbox');
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	    var shouldRenderPopup = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-combobox')
	      }),
	      _react2.default.createElement(_Select2.default, {
	        onClick: this.toggle,
	        disabled: !!(disabled || readOnly),
	        busy: busy,
	        icon: 'caret-down',
	        label: _3.default.result(messages.open, this.props)
	      }),
	      this.renderInput(listID),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          open: open,
	          dropUp: dropUp,
	          duration: duration,
	          onOpening: function onOpening() {
	            return _this.refs.list.forceUpdate();
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderList(List, listID, messages)
	        )
	      )
	    );
	  },
	  handleSelect: function handleSelect(data) {
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(data);
	    this.focus();
	  },
	  handleInputKeyDown: function handleInputKeyDown(e) {
	    this._deleting = e.key === 'Backspace' || e.key === 'Delete';
	    this._isTyping = true;
	  },
	  handleInputChange: function handleInputChange(e) {
	    var _props5 = this.props,
	        data = _props5.data,
	        textField = _props5.textField;
	
	
	    var shouldSuggest = !!this.props.suggest,
	        strVal = e.target.value,
	        suggestion;
	
	    suggestion = this._deleting || !shouldSuggest ? strVal : this.suggest(this._data(), strVal);
	
	    suggestion = suggestion || strVal;
	
	    data = _3.default.find(data, function (item) {
	      return (0, _dataHelpers.dataText)(item, textField).toLowerCase() === suggestion.toLowerCase();
	    });
	
	    this.change(!this._deleting && data ? data : strVal, true);
	
	    this.open();
	  },
	  focus: function focus() {
	    this.refs.input && this.refs.input.focus();
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var self = this,
	        key = e.key,
	        alt = e.altKey,
	        list = this.refs.list,
	        focusedItem = this.state.focusedItem,
	        selectedItem = this.state.selectedItem,
	        isOpen = this.props.open;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      if (isOpen) this.setState({ focusedItem: list.last() });else select(list.last(), true);
	    } else if (key === 'Home') {
	      if (isOpen) this.setState({ focusedItem: list.first() });else select(list.first(), true);
	    } else if (key === 'Escape' && isOpen) this.close();else if (key === 'Enter' && isOpen) {
	      e.preventDefault();
	      select(this.state.focusedItem, true);
	    } else if (key === 'ArrowDown') {
	      if (alt) this.open();else {
	        if (isOpen) this.setState({ focusedItem: list.next(focusedItem) });else select(list.next(selectedItem), true);
	      }
	    } else if (key === 'ArrowUp') {
	      if (alt) this.close();else {
	        if (isOpen) this.setState({ focusedItem: list.prev(focusedItem) });else select(list.prev(selectedItem), true);
	      }
	    }
	
	    function select(item, fromList) {
	      if (!item) return self.change(_compat2.default.findDOMNode(self.refs.input).value, false);
	
	      self.refs.input.accept(true); //removes caret
	
	      if (fromList) return self.handleSelect(item);
	
	      self.change(item, false);
	    }
	  },
	  change: function change(data, typing) {
	    this._typedChange = !!typing;
	    (0, _widgetHelpers.notify)(this.props.onChange, data);
	  },
	  open: function open() {
	    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.focus();
	
	    this.props.open ? this.close() : this.open();
	  },
	  suggest: function suggest(data, value) {
	    var _props6 = this.props,
	        textField = _props6.textField,
	        suggest = _props6.suggest,
	        minLength = _props6.minLength;
	
	
	    var word = (0, _dataHelpers.dataText)(value, textField),
	        suggestion;
	
	    suggest = defaultSuggest(suggest);
	
	    if (!(word || '').trim() || word.length < (minLength || 1)) return '';
	
	    suggestion = typeof value === 'string' ? _3.default.find(data, getFilter(suggest, word, textField)) : value;
	
	    if (suggestion && (!this.state || !this.state.deleting)) return (0, _dataHelpers.dataText)(suggestion, textField);
	
	    return '';
	  },
	  _data: function _data() {
	    return this.state.processedData;
	  },
	  process: function process(data, values, searchTerm) {
	    if (this.props.filter && searchTerm) data = this.filter(data, searchTerm);
	
	    return data;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'toggle', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'toggle'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(ComboBox, { open: 'onToggle', value: 'onChange' }, ['focus']);
	
	
	function msgs(msgs) {
	  return _extends({
	    open: 'open combobox',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results'
	  }, msgs);
	}
	
	function getFilter(suggest, word, textField) {
	  return typeof suggest === 'string' ? function (item) {
	    return _filter2.default[suggest]((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word.toLowerCase());
	  } : function (item) {
	    return suggest(item, word);
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _caret = __webpack_require__(867);
	
	var _caret2 = _interopRequireDefault(_caret);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Input = __webpack_require__(833);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'ComboboxInput',
	
	  propTypes: {
	    value: _propTypes2.default.string,
	    suggest: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var input = _compat2.default.findDOMNode(this),
	        val = this.props.value;
	
	    if (this.isSuggesting()) {
	      var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length,
	          end = val.length - start;
	
	      if (start >= 0) {
	        (0, _caret2.default)(input, start, start + end);
	      }
	    }
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        onKeyDown = _props.onKeyDown,
	        props = _objectWithoutProperties(_props, ['onKeyDown']);
	
	    delete props.suggest;
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      onKeyDown: onKeyDown,
	      onChange: this.handleChange
	    }));
	  },
	  isSuggesting: function isSuggesting() {
	    var val = this.props.value,
	        isSuggestion = this._last != null && val.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
	
	    return this.props.suggest && isSuggestion;
	  },
	  accept: function accept(removeCaret) {
	    var val = _compat2.default.findDOMNode(this).value || '',
	        end = val.length;
	
	    this._last = null;
	    removeCaret && (0, _caret2.default)(_compat2.default.findDOMNode(this), end, end);
	  },
	  handleChange: function handleChange(e) {
	    var val = e.target.value,
	        pl = !!this.props.placeholder;
	
	    // IE fires input events when setting/unsetting placeholders.
	    // issue #112
	    if (pl && !val && val === (this.props.value || '')) return;
	
	    this._last = val;
	    this.props.onChange(e, val);
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = caret;
	/*eslint-disable no-empty */
	function caret(el, start, end) {
	  if (start === undefined) return get(el);
	
	  set(el, start, end);
	}
	
	function get(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function set(el, start, end) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(start, end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', start);
	      rangeEl.moveEnd('character', end - start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	module.exports = exports['default'];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _VIEW, _OPPOSITE_DIRECTION, _MULTIPLIER, _desc, _value2, _obj; //values, omit
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Header = __webpack_require__(869);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(871);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Month = __webpack_require__(872);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Year = __webpack_require__(877);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	var _Decade = __webpack_require__(878);
	
	var _Decade2 = _interopRequireDefault(_Decade);
	
	var _Century = __webpack_require__(879);
	
	var _Century2 = _interopRequireDefault(_Century);
	
	var _localizers = __webpack_require__(825);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _SlideTransition = __webpack_require__(880);
	
	var _SlideTransition2 = _interopRequireDefault(_SlideTransition);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _constants = __webpack_require__(876);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(847);
	
	var _interaction = __webpack_require__(848);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var dir = constants.directions,
	    values = function values(obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	},
	    invert = function invert(obj) {
	  return _3.default.transform(obj, function (o, val, key) {
	    o[val] = key;
	  }, {});
	};
	
	var views = constants.calendarViews,
	    VIEW_OPTIONS = values(views),
	    ALT_VIEW = invert(constants.calendarViewHierarchy),
	    NEXT_VIEW = constants.calendarViewHierarchy,
	    VIEW_UNIT = constants.calendarViewUnits,
	    VIEW = (_VIEW = {}, _VIEW[views.MONTH] = _Month2.default, _VIEW[views.YEAR] = _Year2.default, _VIEW[views.DECADE] = _Decade2.default, _VIEW[views.CENTURY] = _Century2.default, _VIEW);
	
	var ARROWS_TO_DIRECTION = {
	  ArrowDown: dir.DOWN,
	  ArrowUp: dir.UP,
	  ArrowRight: dir.RIGHT,
	  ArrowLeft: dir.LEFT
	};
	
	var OPPOSITE_DIRECTION = (_OPPOSITE_DIRECTION = {}, _OPPOSITE_DIRECTION[dir.LEFT] = dir.RIGHT, _OPPOSITE_DIRECTION[dir.RIGHT] = dir.LEFT, _OPPOSITE_DIRECTION);
	
	var MULTIPLIER = (_MULTIPLIER = {}, _MULTIPLIER[views.YEAR] = 1, _MULTIPLIER[views.DECADE] = 10, _MULTIPLIER[views.CENTURY] = 100, _MULTIPLIER);
	
	var format = function format(props, f) {
	  return _localizers.date.getFormat(f, props[f + 'Format']);
	};
	
	var propTypes = {
	
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly,
	
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.instanceOf(Date),
	
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	
	  currentDate: _propTypes2.default.instanceOf(Date),
	  onCurrentDateChange: _propTypes2.default.func,
	
	  view: _propTypes2.default.oneOf(VIEW_OPTIONS),
	  initialView: _propTypes2.default.oneOf(VIEW_OPTIONS),
	
	  finalView: function finalView(props, propName, componentName) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var err = _propTypes2.default.oneOf(VIEW_OPTIONS).apply(undefined, [props, propName, componentName].concat(args));
	
	    if (err) return err;
	    if (VIEW_OPTIONS.indexOf(props[propName]) < VIEW_OPTIONS.indexOf(props.initialView)) return new Error(('The `' + propName + '` prop: `' + props[propName] + '` cannot be \'lower\' than the `initialView`\n        prop. This creates a range that cannot be rendered.').replace(/\n\t/g, ''));
	  },
	
	
	  onViewChange: _propTypes2.default.func,
	  onNavigate: _propTypes2.default.func,
	  culture: _propTypes2.default.string,
	  footer: _propTypes2.default.bool,
	
	  dayComponent: _propTypes4.default.elementType,
	  headerFormat: _propTypes4.default.dateFormat,
	  footerFormat: _propTypes4.default.dateFormat,
	
	  dayFormat: _propTypes4.default.dateFormat,
	  dateFormat: _propTypes4.default.dateFormat,
	  monthFormat: _propTypes4.default.dateFormat,
	  yearFormat: _propTypes4.default.dateFormat,
	  decadeFormat: _propTypes4.default.dateFormat,
	  centuryFormat: _propTypes4.default.dateFormat,
	
	  messages: _propTypes2.default.shape({
	    moveBack: _propTypes2.default.string,
	    moveForward: _propTypes2.default.string
	  })
	};
	
	var Calendar = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'Calendar',
	
	  mixins: [__webpack_require__(854), __webpack_require__(855), __webpack_require__(856), __webpack_require__(863), __webpack_require__(850)(), __webpack_require__(864)({
	    willHandle: function willHandle() {
	      if (+this.props.tabIndex === -1) return false;
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: 0,
	      view: this.props.initialView || 'month'
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	
	      value: null,
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      currentDate: new Date(),
	
	      initialView: 'month',
	      finalView: 'century',
	
	      tabIndex: '0',
	      footer: false,
	
	      ariaActiveDescendantKey: 'calendar',
	      messages: msgs({})
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.changeCurrentDate(this.props.value);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var bottom = VIEW_OPTIONS.indexOf(nextProps.initialView),
	        top = VIEW_OPTIONS.indexOf(nextProps.finalView),
	        current = VIEW_OPTIONS.indexOf(this.state.view),
	        view = this.state.view,
	        val = this.inRangeValue(nextProps.value);
	
	    if (current < bottom) this.setState({ view: view = nextProps.initialView });else if (current > top) this.setState({ view: view = nextProps.finalView });
	
	    //if the value changes reset views to the new one
	    if (!_dates2.default.eq(val, dateOrNull(this.props.value), VIEW_UNIT[view])) {
	      this.changeCurrentDate(val, nextProps.currentDate);
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        className = _props.className,
	        value = _props.value,
	        footerFormat = _props.footerFormat,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        finalView = _props.finalView,
	        footer = _props.footer,
	        messages = _props.messages,
	        min = _props.min,
	        max = _props.max,
	        culture = _props.culture,
	        duration = _props.duration,
	        tabIndex = _props.tabIndex,
	        currentDate = _props.currentDate;
	    var _state = this.state,
	        view = _state.view,
	        slideDirection = _state.slideDirection,
	        focused = _state.focused;
	
	
	    var View = VIEW[view],
	        unit = VIEW_UNIT[view],
	        todaysDate = new Date(),
	        todayNotInRange = !_dates2.default.inRange(todaysDate, min, max, view);
	
	    unit = unit === 'day' ? 'date' : unit;
	
	    var viewID = (0, _widgetHelpers.instanceId)(this, '_calendar'),
	        labelID = (0, _widgetHelpers.instanceId)(this, '_calendar_label'),
	        key = view + '_' + _dates2.default[view](currentDate);
	
	    var elementProps = _3.default.omitOwnProps(this),
	        viewProps = _3.default.pickProps(this.props, View);
	
	    var isDisabled = disabled || readOnly;
	
	    messages = msgs(this.props.messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        role: 'group',
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        tabIndex: tabIndex || 0,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-calendar')
	      }),
	      _react2.default.createElement(_Header2.default, {
	        label: this._label(),
	        labelId: labelID,
	        messages: messages,
	        upDisabled: isDisabled || view === finalView,
	        prevDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.LEFT), min, max, view),
	        nextDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.RIGHT), min, max, view),
	        onViewChange: this.navigate.bind(null, dir.UP, null),
	        onMoveLeft: this.navigate.bind(null, dir.LEFT, null),
	        onMoveRight: this.navigate.bind(null, dir.RIGHT, null)
	      }),
	      _react2.default.createElement(
	        _SlideTransition2.default,
	        {
	          ref: 'animation',
	          duration: duration,
	          direction: slideDirection,
	          onAnimate: function onAnimate() {
	            return focused && _this.focus();
	          }
	        },
	        _react2.default.createElement(View, _extends({}, viewProps, {
	          key: key,
	          id: viewID,
	          value: value,
	          today: todaysDate,
	          focused: currentDate,
	          onChange: this.change,
	          onKeyDown: this.handleKeyDown,
	          'aria-labelledby': labelID,
	          ariaActiveDescendantKey: 'calendarView'
	        }))
	      ),
	      footer && _react2.default.createElement(_Footer2.default, {
	        value: todaysDate,
	        format: footerFormat,
	        culture: culture,
	        disabled: disabled || todayNotInRange,
	        readOnly: readOnly,
	        onClick: this.select
	      })
	    );
	  },
	  navigate: function navigate(direction, date) {
	    var view = this.state.view,
	        slideDir = direction === dir.LEFT || direction === dir.UP ? 'right' : 'left';
	
	    if (!date) date = [dir.LEFT, dir.RIGHT].indexOf(direction) !== -1 ? this.nextDate(direction) : this.props.currentDate;
	
	    if (direction === dir.DOWN) view = ALT_VIEW[view] || view;
	
	    if (direction === dir.UP) view = NEXT_VIEW[view] || view;
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      (0, _widgetHelpers.notify)(this.props.onNavigate, [date, slideDir, view]);
	      this.focus(true);
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  focus: function focus() {
	    if (+this.props.tabIndex > -1) _compat2.default.findDOMNode(this).focus();
	  },
	  change: function change(date) {
	    if (this.state.view === this.props.initialView) {
	      this.changeCurrentDate(date);
	      (0, _widgetHelpers.notify)(this.props.onChange, date);
	      this.focus();
	      return;
	    }
	
	    this.navigate(dir.DOWN, date);
	  },
	  changeCurrentDate: function changeCurrentDate(date) {
	    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.currentDate;
	
	    var inRangeDate = this.inRangeValue(date ? new Date(date) : currentDate);
	    if (_dates2.default.eq(inRangeDate, dateOrNull(currentDate), VIEW_UNIT[this.state.view])) return;
	    (0, _widgetHelpers.notify)(this.props.onCurrentDateChange, inRangeDate);
	  },
	  select: function select(date) {
	    var view = this.props.initialView,
	        slideDir = view !== this.state.view || _dates2.default.gt(date, this.state.currentDate) ? 'left' // move down to a the view
	    : 'right';
	
	    (0, _widgetHelpers.notify)(this.props.onChange, date);
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      this.focus();
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  nextDate: function nextDate(direction) {
	    var method = direction === dir.LEFT ? 'subtract' : 'add',
	        view = this.state.view,
	        unit = view === views.MONTH ? view : views.YEAR,
	        multi = MULTIPLIER[view] || 1;
	
	    return _dates2.default[method](this.props.currentDate, 1 * multi, unit);
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var ctrl = e.ctrlKey,
	        key = e.key,
	        direction = ARROWS_TO_DIRECTION[key],
	        current = this.props.currentDate,
	        view = this.state.view,
	        unit = VIEW_UNIT[view],
	        currentDate = current;
	
	    if (key === 'Enter') {
	      e.preventDefault();
	      return this.change(current);
	    }
	
	    if (direction) {
	      if (ctrl) {
	        e.preventDefault();
	        this.navigate(direction);
	      } else {
	        if (this.isRtl() && OPPOSITE_DIRECTION[direction]) direction = OPPOSITE_DIRECTION[direction];
	
	        currentDate = _dates2.default.move(currentDate, this.props.min, this.props.max, view, direction);
	
	        if (!_dates2.default.eq(current, currentDate, unit)) {
	          e.preventDefault();
	
	          if (_dates2.default.gt(currentDate, current, view)) this.navigate(dir.RIGHT, currentDate);else if (_dates2.default.lt(currentDate, current, view)) this.navigate(dir.LEFT, currentDate);else this.changeCurrentDate(currentDate);
	        }
	      }
	    }
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	  },
	  _label: function _label() {
	    var _props2 = this.props,
	        culture = _props2.culture,
	        props = _objectWithoutProperties(_props2, ['culture']),
	        view = this.state.view,
	        dt = this.props.currentDate;
	
	    if (view === 'month') return _localizers.date.format(dt, format(props, 'header'), culture);else if (view === 'year') return _localizers.date.format(dt, format(props, 'year'), culture);else if (view === 'decade') return _localizers.date.format(_dates2.default.startOf(dt, 'decade'), format(props, 'decade'), culture);else if (view === 'century') return _localizers.date.format(_dates2.default.startOf(dt, 'century'), format(props, 'century'), culture);
	  },
	  inRangeValue: function inRangeValue(_value) {
	    var value = dateOrNull(_value);
	
	    if (value === null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  },
	  isValidView: function isValidView(next) {
	    var bottom = VIEW_OPTIONS.indexOf(this.props.initialView),
	        top = VIEW_OPTIONS.indexOf(this.props.finalView),
	        current = VIEW_OPTIONS.indexOf(next);
	
	    return current >= bottom && current <= top;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'navigate', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'navigate'), _obj), _applyDecoratedDescriptor(_obj, 'change', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'change'), _obj), _applyDecoratedDescriptor(_obj, 'select', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'select'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj)), _obj));
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	
	function msgs(msgs) {
	  return _extends({
	    moveBack: 'navigate back',
	    moveForward: 'navigate forward'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(Calendar, {
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange',
	  view: 'onViewChange'
	}, ['focus']);
	module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Button = __webpack_require__(835);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	  displayName: 'Header',
	  propTypes: {
	    label: _propTypes2.default.string.isRequired,
	    labelId: _propTypes2.default.string,
	
	    upDisabled: _propTypes2.default.bool.isRequired,
	    prevDisabled: _propTypes2.default.bool.isRequired,
	    nextDisabled: _propTypes2.default.bool.isRequired,
	    onViewChange: _propTypes2.default.func.isRequired,
	    onMoveLeft: _propTypes2.default.func.isRequired,
	    onMoveRight: _propTypes2.default.func.isRequired,
	
	    messages: _propTypes2.default.shape({
	      moveBack: _propTypes2.default.string,
	      moveForward: _propTypes2.default.string
	    })
	  },
	
	  mixins: [__webpack_require__(856), __webpack_require__(870)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      messages: {
	        moveBack: 'navigate back',
	        moveForward: 'navigate forward'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        messages = _props.messages,
	        label = _props.label,
	        labelId = _props.labelId,
	        onMoveRight = _props.onMoveRight,
	        onMoveLeft = _props.onMoveLeft,
	        onViewChange = _props.onViewChange,
	        prevDisabled = _props.prevDisabled,
	        upDisabled = _props.upDisabled,
	        nextDisabled = _props.nextDisabled;
	
	
	    var rtl = this.isRtl();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-header' },
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-left',
	        onClick: onMoveLeft,
	        disabled: prevDisabled,
	        label: messages.moveBack,
	        icon: 'caret-' + (rtl ? 'right' : 'left')
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: labelId,
	          onClick: onViewChange,
	          className: 'rw-btn-view',
	          disabled: upDisabled,
	          'aria-live': 'polite',
	          'aria-atomic': 'true'
	        },
	        label
	      ),
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-right',
	        onClick: onMoveRight,
	        disabled: nextDisabled,
	        label: messages.moveForward,
	        icon: 'caret-' + (rtl ? 'left' : 'right')
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  contextTypes: {
	    isRtl: _propTypes2.default.bool
	  },
	
	  isRtl: function isRtl() {
	    return !!this.context.isRtl;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Button = __webpack_require__(835);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _localizers = __webpack_require__(825);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('footer', props.format);
	};
	
	module.exports = (0, _createReactClass2.default)({
	
	  displayName: 'Footer',
	
	  render: function render() {
	    var _props = this.props,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        value = _props.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-footer' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          disabled: !!(disabled || readOnly),
	          onClick: this.props.onClick.bind(null, value)
	        },
	        _localizers.date.format(value, format(this.props), this.props.culture)
	      )
	    );
	  }
	});

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(873);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(825);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayFormat = function dayFormat(props) {
	  return _localizers.date.getFormat('weekday', props.dayFormat);
	},
	    dateFormat = function dateFormat(props) {
	  return _localizers.date.getFormat('dayOfMonth', props.dateFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__month_' + _dates2.default.month(date) + '-' + _dates2.default.date(date);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  dayComponent: _propTypes4.default.elementType,
	  dayFormat: _propTypes4.default.dateFormat,
	  dateFormat: _propTypes4.default.dateFormat
	};
	
	var isEqual = function isEqual(dateA, dateB) {
	  return _dates2.default.eq(dateA, dateB, 'day');
	};
	
	var MonthView = (0, _createReactClass2.default)({
	
	  displayName: 'MonthView',
	
	  statics: {
	    isEqual: isEqual
	  },
	
	  mixins: [__webpack_require__(870), __webpack_require__(850)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId, null);
	  },
	  render: function render() {
	    var _props = this.props,
	        focused = _props.focused,
	        culture = _props.culture,
	        month = _dates2.default.visibleDays(focused, culture),
	        rows = _3.default.chunk(month, 7);
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.renderHeaders(rows[0], dayFormat(this.props), culture)
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        rows.map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props2 = this.props,
	        focused = _props2.focused,
	        today = _props2.today,
	        disabled = _props2.disabled,
	        onChange = _props2.onChange,
	        value = _props2.value,
	        culture = _props2.culture,
	        min = _props2.min,
	        max = _props2.max,
	        Day = _props2.dayComponent,
	        id = (0, _widgetHelpers.instanceId)(this),
	        labelFormat = _localizers.date.getFormat('footer');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var formattedDate = _localizers.date.format(date, dateFormat(_this.props), culture),
	            label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'day',
	            viewUnit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          Day ? _react2.default.createElement(Day, { date: date, label: formattedDate }) : formattedDate
	        );
	      })
	    );
	  },
	  renderHeaders: function renderHeaders(week, format, culture) {
	    return week.map(function (date) {
	      return _react2.default.createElement(
	        'th',
	        { key: 'header_' + _dates2.default.weekday(date, undefined, _localizers.date.startOfWeek(culture)) },
	        _localizers.date.format(date, format, culture)
	      );
	    });
	  }
	});
	
	exports.default = MonthView;
	module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIEW_UNITS = ['month', 'year', 'decade', 'century'];
	
	function clamp(date, min, max) {
	  return _dates2.default.max(_dates2.default.min(date, max), min);
	}
	
	var CalendarView = function (_React$Component) {
	  _inherits(CalendarView, _React$Component);
	
	  function CalendarView() {
	    _classCallCheck(this, CalendarView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CalendarView.prototype.render = function render() {
	    var className = this.props.className;
	
	
	    return _react2.default.createElement('table', _extends({}, this.props, {
	      role: 'grid',
	      tabIndex: '-1',
	      className: (0, _classnames2.default)(className, 'rw-nav-view', 'rw-calendar-grid')
	    }));
	  };
	
	  return CalendarView;
	}(_react2.default.Component);
	
	var CalendarViewCell = (_temp2 = _class = function (_React$Component2) {
	  _inherits(CalendarViewCell, _React$Component2);
	
	  function CalendarViewCell() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, CalendarViewCell);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleChange = function () {
	      var _this2$props = _this2.props,
	          onChange = _this2$props.onChange,
	          min = _this2$props.min,
	          max = _this2$props.max,
	          date = _this2$props.date;
	
	      onChange(clamp(date, min, max));
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  CalendarViewCell.prototype.isEqual = function isEqual(date) {
	    return _dates2.default.eq(this.props.date, date, this.props.unit);
	  };
	
	  CalendarViewCell.prototype.isEmpty = function isEmpty() {
	    var _props = this.props,
	        unit = _props.unit,
	        min = _props.min,
	        max = _props.max,
	        date = _props.date;
	
	    return !_dates2.default.inRange(date, min, max, unit);
	  };
	
	  CalendarViewCell.prototype.isNow = function isNow() {
	    return this.isEqual(this.props.now);
	  };
	
	  CalendarViewCell.prototype.isFocused = function isFocused() {
	    return this.isEqual(this.props.focused);
	  };
	
	  CalendarViewCell.prototype.isSelected = function isSelected() {
	    return this.isEqual(this.props.selected);
	  };
	
	  CalendarViewCell.prototype.isOffView = function isOffView() {
	    var _props2 = this.props,
	        viewUnit = _props2.viewUnit,
	        focused = _props2.focused,
	        date = _props2.date;
	
	    return viewUnit && _dates2.default[viewUnit](date) !== _dates2.default[viewUnit](focused);
	  };
	
	  CalendarViewCell.prototype.render = function render() {
	    var _props3 = this.props,
	        children = _props3.children,
	        id = _props3.id,
	        label = _props3.label,
	        disabled = _props3.disabled;
	
	
	    if (this.isEmpty()) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'rw-empty-cell', role: 'presentation' },
	        '\xA0'
	      );
	    }
	
	    return _react2.default.createElement(
	      'td',
	      {
	        role: 'gridcell',
	        id: id,
	        title: label,
	        'aria-label': label,
	        'aria-readonly': disabled,
	        'aria-selected': this.isSelected()
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          'aria-labelledby': id,
	          onClick: this.handleChange,
	          className: (0, _classnames2.default)('rw-btn', this.isNow() && 'rw-now', this.isOffView() && 'rw-off-range', this.isFocused() && 'rw-state-focus', this.isSelected() && 'rw-state-selected')
	        },
	        children
	      )
	    );
	  };
	
	  return CalendarViewCell;
	}(_react2.default.Component), _class.propTypes = {
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  selected: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  unit: _propTypes2.default.oneOf(['day'].concat(VIEW_UNITS)),
	  viewUnit: _propTypes2.default.oneOf(VIEW_UNITS),
	  onChange: _propTypes2.default.func.isRequired
	}, _temp2);
	
	
	CalendarView.Row = function (props) {
	  return _react2.default.createElement('tr', _extends({ role: 'row' }, props));
	};
	CalendarView.Cell = CalendarViewCell;
	
	exports.default = CalendarView;
	module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dateArithmetic = __webpack_require__(875);
	
	var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);
	
	var _constants = __webpack_require__(876);
	
	var _localizers = __webpack_require__(825);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dates = _extends({}, _dateArithmetic2.default, {
	  parse: function parse(date, format, culture) {
	    return _localizers.date.parse(date, format, culture);
	  },
	  format: function format(date, _format, culture) {
	    return _localizers.date.format(date, _format, culture);
	  },
	  monthsInYear: function monthsInYear(year) {
	    var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	        date = new Date(year, 0, 1);
	
	    return months.map(function (i) {
	      return dates.month(date, i);
	    });
	  },
	  firstVisibleDay: function firstVisibleDay(date, culture) {
	    var firstOfMonth = dates.startOf(date, 'month');
	    return dates.startOf(firstOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  lastVisibleDay: function lastVisibleDay(date, culture) {
	    var endOfMonth = dates.endOf(date, 'month');
	
	    return dates.endOf(endOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  visibleDays: function visibleDays(date, culture) {
	    var current = dates.firstVisibleDay(date, culture),
	        last = dates.lastVisibleDay(date, culture),
	        days = [];
	
	    while (dates.lte(current, last, 'day')) {
	      days.push(current);
	      current = dates.add(current, 1, 'day');
	    }
	
	    return days;
	  },
	  move: function move(date, min, max, unit, direction) {
	    var isMonth = unit === 'month',
	        isUpOrDown = direction === _constants.directions.UP || direction === _constants.directions.DOWN,
	        rangeUnit = _constants.calendarViewUnits[unit],
	        addUnit = isMonth && isUpOrDown ? 'week' : _constants.calendarViewUnits[unit],
	        amount = isMonth || !isUpOrDown ? 1 : 4,
	        newDate;
	
	    if (direction === _constants.directions.UP || direction === _constants.directions.LEFT) amount *= -1;
	
	    newDate = dates.add(date, amount, addUnit);
	
	    return dates.inRange(newDate, min, max, rangeUnit) ? newDate : date;
	  },
	  merge: function merge(date, time, defaultDate) {
	    if (time == null && date == null) return null;
	
	    if (time == null) time = defaultDate || new Date();
	    if (date == null) date = defaultDate || new Date();
	
	    date = dates.startOf(date, 'day');
	    date = dates.hours(date, dates.hours(time));
	    date = dates.minutes(date, dates.minutes(time));
	    date = dates.seconds(date, dates.seconds(time));
	    return dates.milliseconds(date, dates.milliseconds(time));
	  },
	  sameMonth: function sameMonth(dateA, dateB) {
	    return dates.eq(dateA, dateB, 'month');
	  },
	  today: function today() {
	    return this.startOf(new Date(), 'day');
	  },
	  yesterday: function yesterday() {
	    return this.add(this.startOf(new Date(), 'day'), -1, 'day');
	  },
	  tomorrow: function tomorrow() {
	    return this.add(this.startOf(new Date(), 'day'), 1, 'day');
	  }
	});
	
	exports.default = dates;
	module.exports = exports['default'];

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	var MILI    = 'milliseconds'
	  , SECONDS = 'seconds'
	  , MINUTES = 'minutes'
	  , HOURS   = 'hours'
	  , DAY     = 'day'
	  , WEEK    = 'week'
	  , MONTH   = 'month'
	  , YEAR    = 'year'
	  , DECADE  = 'decade'
	  , CENTURY = 'century';
	
	var dates = module.exports = {
	
	  add: function(date, num, unit) {
	    date = new Date(date)
	
	    switch (unit){
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case YEAR:
	        return dates[unit](date, dates[unit](date) + num)
	      case DAY:
	        return dates.date(date, dates.date(date) + num)
	      case WEEK:
	        return dates.date(date, dates.date(date) + (7 * num)) 
	      case MONTH:
	        return monthMath(date, num)
	      case DECADE:
	        return dates.year(date, dates.year(date) + (num * 10))
	      case CENTURY:
	        return dates.year(date, dates.year(date) + (num * 100))
	    }
	
	    throw new TypeError('Invalid units: "' + unit + '"')
	  },
	
	  subtract: function(date, num, unit) {
	    return dates.add(date, -num, unit)
	  },
	
	  startOf: function(date, unit, firstOfWeek) {
	    date = new Date(date)
	
	    switch (unit) {
	      case 'century':
	      case 'decade':
	      case 'year':
	          date = dates.month(date, 0);
	      case 'month':
	          date = dates.date(date, 1);
	      case 'week':
	      case 'day':
	          date = dates.hours(date, 0);
	      case 'hours':
	          date = dates.minutes(date, 0);
	      case 'minutes':
	          date = dates.seconds(date, 0);
	      case 'seconds':
	          date = dates.milliseconds(date, 0);
	    }
	
	    if (unit === DECADE) 
	      date = dates.subtract(date, dates.year(date) % 10, 'year')
	    
	    if (unit === CENTURY) 
	      date = dates.subtract(date, dates.year(date) % 100, 'year')
	
	    if (unit === WEEK) 
	      date = dates.weekday(date, 0, firstOfWeek);
	
	    return date
	  },
	
	
	  endOf: function(date, unit, firstOfWeek){
	    date = new Date(date)
	    date = dates.startOf(date, unit, firstOfWeek)
	    date = dates.add(date, 1, unit)
	    date = dates.subtract(date, 1, MILI)
	    return date
	  },
	
	  eq:  createComparer(function(a, b){ return a === b }),
	  neq: createComparer(function(a, b){ return a !== b }),
	  gt:  createComparer(function(a, b){ return a > b }),
	  gte: createComparer(function(a, b){ return a >= b }),
	  lt:  createComparer(function(a, b){ return a < b }),
	  lte: createComparer(function(a, b){ return a <= b }),
	
	  min: function(){
	    return new Date(Math.min.apply(Math, arguments))
	  },
	
	  max: function(){
	    return new Date(Math.max.apply(Math, arguments))
	  },
	  
	  inRange: function(day, min, max, unit){
	    unit = unit || 'day'
	
	    return (!min || dates.gte(day, min, unit))
	        && (!max || dates.lte(day, max, unit))
	  },
	
	  milliseconds:   createAccessor('Milliseconds'),
	  seconds:        createAccessor('Seconds'),
	  minutes:        createAccessor('Minutes'),
	  hours:          createAccessor('Hours'),
	  day:            createAccessor('Day'),
	  date:           createAccessor('Date'),
	  month:          createAccessor('Month'),
	  year:           createAccessor('FullYear'),
	
	  decade: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, DECADE))
	      : dates.add(date, val + 10, YEAR);
	  },
	
	  century: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, CENTURY))
	      : dates.add(date, val + 100, YEAR);
	  },
	
	  weekday: function (date, val, firstDay) {
	      var weekday = (dates.day(date) + 7 - (firstDay || 0) ) % 7;
	
	      return val === undefined 
	        ? weekday 
	        : dates.add(date, val - weekday, DAY);
	  },
	
	  diff: function (date1, date2, unit, asFloat) {
	    var dividend, divisor, result;
	
	    switch (unit) {
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case DAY:
	      case WEEK:
	        dividend = date2.getTime() - date1.getTime(); break;
	      case MONTH:
	      case YEAR:
	      case DECADE:
	      case CENTURY:
	        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1); break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    switch (unit) {
	      case MILI:
	          divisor = 1; break;
	      case SECONDS:
	          divisor = 1000; break;
	      case MINUTES:
	          divisor = 1000 * 60; break;
	      case HOURS:
	          divisor = 1000 * 60 * 60; break;
	      case DAY:
	          divisor = 1000 * 60 * 60 * 24; break;
	      case WEEK:
	          divisor = 1000 * 60 * 60 * 24 * 7; break;
	      case MONTH:
	          divisor = 1; break;
	      case YEAR:
	          divisor = 12; break;
	      case DECADE:
	          divisor = 120; break;
	      case CENTURY:
	          divisor = 1200; break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    result = dividend / divisor;
	
	    return asFloat ? result : absoluteFloor(result);
	  }
	};
	
	function absoluteFloor(number) {
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	function monthMath(date, val){
	  var current = dates.month(date)
	    , newMonth  = (current + val);
	
	    date = dates.month(date, newMonth)
	
	    while (newMonth < 0 ) newMonth = 12 + newMonth
	      
	    //month rollover
	    if ( dates.month(date) !== ( newMonth % 12))
	      date = dates.date(date, 0) //move to last of month
	
	    return date
	}
	
	function createAccessor(method){
	  return function(date, val){
	    if (val === undefined)
	      return date['get' + method]()
	
	    date = new Date(date)
	    date['set' + method](val)
	    return date
	  }
	}
	
	function createComparer(operator) {
	  return function (a, b, unit) {
	    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit))
	  };
	}


/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _calendarViewHierarch, _calendarViewUnits;
	
	var views = {
	  MONTH: 'month',
	  YEAR: 'year',
	  DECADE: 'decade',
	  CENTURY: 'century'
	};
	
	var directions = exports.directions = {
	  LEFT: 'LEFT',
	  RIGHT: 'RIGHT',
	  UP: 'UP',
	  DOWN: 'DOWN'
	};
	
	var datePopups = exports.datePopups = {
	  TIME: 'time',
	  CALENDAR: 'calendar'
	};
	
	var calendarViews = exports.calendarViews = views;
	
	var calendarViewHierarchy = exports.calendarViewHierarchy = (_calendarViewHierarch = {}, _calendarViewHierarch[views.MONTH] = views.YEAR, _calendarViewHierarch[views.YEAR] = views.DECADE, _calendarViewHierarch[views.DECADE] = views.CENTURY, _calendarViewHierarch);
	
	var calendarViewUnits = exports.calendarViewUnits = (_calendarViewUnits = {}, _calendarViewUnits[views.MONTH] = 'day', _calendarViewUnits[views.YEAR] = views.MONTH, _calendarViewUnits[views.DECADE] = views.YEAR, _calendarViewUnits[views.CENTURY] = views.DECADE, _calendarViewUnits);

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(873);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(825);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('month', props.monthFormat);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  monthFormat: _propTypes4.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__year_' + _dates2.default.year(date) + '-' + _dates2.default.month(date);
	};
	
	var YearView = (0, _createReactClass2.default)({
	
	  displayName: 'YearView',
	
	  mixins: [__webpack_require__(870), __webpack_require__(850)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused,
	        months = _dates2.default.monthsInYear(_dates2.default.year(focused));
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(months, 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        labelFormat = _localizers.date.getFormat('header');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          _localizers.date.format(date, format(_this.props), culture)
	        );
	      })
	    );
	  }
	});
	
	exports.default = YearView;
	module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(873);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(825);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	
	  yearFormat: _propTypes4.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__decade_' + _dates2.default.year(date);
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'DecadeView',
	
	  mixins: [__webpack_require__(856), __webpack_require__(870), __webpack_require__(850)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getDecadeYears(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        yearFormat = _props.yearFormat,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, _localizers.date.getFormat('year', yearFormat), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'year',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getDecadeYears(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'decade'), -2, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 1, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _CalendarView = __webpack_require__(873);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(825);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('decade', props.decadeFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__century_' + _dates2.default.year(date);
	};
	
	var propTypes = {
	  culture: _propTypes2.default.string,
	  today: _propTypes2.default.instanceOf(Date),
	  value: _propTypes2.default.instanceOf(Date),
	  focused: _propTypes2.default.instanceOf(Date),
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func.isRequired,
	  decadeFormat: _propTypes4.default.dateFormat
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'CenturyView',
	
	  mixins: [__webpack_require__(856), __webpack_require__(870), __webpack_require__(850)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getCenturyDecades(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props,
	        focused = _props.focused,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        value = _props.value,
	        today = _props.today,
	        culture = _props.culture,
	        min = _props.min,
	        max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this, '_century');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(_dates2.default.startOf(date, 'decade'), format(_this.props), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'decade',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getCenturyDecades(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'century'), -20, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 10, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ReplaceTransitionGroup = __webpack_require__(881);
	
	var _ReplaceTransitionGroup2 = _interopRequireDefault(_ReplaceTransitionGroup);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _style = __webpack_require__(814);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _width = __webpack_require__(882);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _configuration = __webpack_require__(811);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideChildGroup = (0, _createReactClass2.default)({
	  displayName: 'SlideChildGroup',
	
	
	  propTypes: {
	    direction: _propTypes2.default.oneOf(['left', 'right']),
	    duration: _propTypes2.default.number
	  },
	
	  componentWillEnter: function componentWillEnter(done) {
	    var _this = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? width : -width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', left: width + 'px', top: 0 });
	
	    _configuration2.default.animate(node, { left: 0 }, this.props.duration, function () {
	
	      (0, _style2.default)(node, {
	        position: _this.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    var _this2 = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? -width : width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', top: 0, left: 0 });
	
	    _configuration2.default.animate(node, { left: width + 'px' }, this.props.duration, function () {
	      (0, _style2.default)(node, {
	        position: _this2.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this2.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  render: function render() {
	    return _react2.default.Children.only(this.props.children);
	  }
	});
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'exports',
	
	
	  propTypes: {
	    direction: _propTypes2.default.oneOf(['left', 'right']),
	    duration: _propTypes2.default.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      direction: 'left',
	      duration: 250
	    };
	  },
	  _wrapChild: function _wrapChild(child, ref) {
	    return _react2.default.createElement(
	      SlideChildGroup,
	      { key: child.key, ref: ref,
	        direction: this.props.direction,
	        duration: this.props.duration },
	      child
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        children = _props.children;
	
	
	    style = _extends({}, style, {
	      position: 'relative',
	      overflow: 'hidden'
	    });
	
	    return _react2.default.createElement(
	      _ReplaceTransitionGroup2.default,
	      _extends({}, _3.default.omitOwnProps(this), {
	        ref: 'container',
	        component: 'div',
	        childFactory: this._wrapChild,
	        style: style
	      }),
	      children
	    );
	  }
	});

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _style = __webpack_require__(814);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(841);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _width = __webpack_require__(882);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A streamlined version of TransitionGroup built for managing at most two active children
	 * also provides additional hooks for animation start/end
	 * https://github.com/facebook/react/blob/master/src/addons/transitions/ReactTransitionGroup.js
	 * relevent code is licensed accordingly
	 */
	function getChild(children) {
	  return _react2.default.Children.only(children);
	}
	
	function key(child) {
	  return child && child.key;
	}
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'ReplaceTransitionGroup',
	
	  propTypes: {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
	    childFactory: _propTypes2.default.func,
	    onAnimating: _propTypes2.default.func,
	    onAnimate: _propTypes2.default.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      childFactory: function childFactory(a) {
	        return a;
	      },
	      onAnimating: _3.default.noop,
	      onAnimate: _3.default.noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      children: _3.default.splat(this.props.children)
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var nextChild = getChild(nextProps.children),
	        stack = this.state.children.slice(),
	        next = stack[1],
	        last = stack[0];
	
	    var isLastChild = last && key(last) === key(nextChild),
	        isNextChild = next && key(next) === key(nextChild);
	
	    //no children
	    if (!last) {
	      stack.push(nextChild);
	      this.entering = nextChild;
	    } else if (last && !next && !isLastChild) {
	      //new child
	      stack.push(nextChild);
	      this.leaving = last;
	      this.entering = nextChild;
	    } else if (last && next && !isLastChild && !isNextChild) {
	      // the child is not the current one, exit the current one, add the new one
	      //  - shift the stack down
	      stack.shift();
	      stack.push(nextChild);
	      this.leaving = next;
	      this.entering = nextChild;
	    }
	    //new child that just needs to be re-rendered
	    else if (isLastChild) stack.splice(0, 1, nextChild);else if (isNextChild) stack.splice(1, 1, nextChild);
	
	    if (this.state.children[0] !== stack[0] || this.state.children[1] !== stack[1]) this.setState({ children: stack });
	  },
	  componentWillMount: function componentWillMount() {
	    this.animatingKeys = {};
	    this.leaving = null;
	    this.entering = null;
	  },
	  componentDidMount: function componentDidMount() {
	    this._mounted = true;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._mounted = false;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var entering = this.entering,
	        leaving = this.leaving,
	        first = this.refs[key(entering) || key(leaving)],
	        node = _compat2.default.findDOMNode(this),
	        el = first && _compat2.default.findDOMNode(first);
	
	    if (el) (0, _style2.default)(node, {
	      overflow: 'hidden',
	      height: (0, _height2.default)(el) + 'px',
	      width: (0, _width2.default)(el) + 'px'
	    });
	
	    this.props.onAnimating();
	
	    this.entering = null;
	    this.leaving = null;
	
	    if (entering) this.performEnter(key(entering));
	    if (leaving) this.performLeave(key(leaving));
	  },
	  performEnter: function performEnter(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));else this._handleDoneEntering(key);
	  },
	  _tryFinish: function _tryFinish() {
	
	    if (this.isTransitioning()) return;
	
	    if (this._mounted) (0, _style2.default)(_compat2.default.findDOMNode(this), { overflow: 'visible', height: '', width: '' });
	
	    this.props.onAnimate();
	  },
	  _handleDoneEntering: function _handleDoneEntering(enterkey) {
	    var component = this.refs[enterkey];
	
	    if (component && component.componentDidEnter) component.componentDidEnter();
	
	    delete this.animatingKeys[enterkey];
	
	    if (key(this.props.children) !== enterkey) this.performLeave(enterkey); // This was removed before it had fully entered. Remove it.
	
	    this._tryFinish();
	  },
	  performLeave: function performLeave(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));else this._handleDoneLeaving(key);
	  },
	  _handleDoneLeaving: function _handleDoneLeaving(leavekey) {
	    var component = this.refs[leavekey];
	
	    if (component && component.componentDidLeave) component.componentDidLeave();
	
	    delete this.animatingKeys[leavekey];
	
	    if (key(this.props.children) === leavekey) this.performEnter(leavekey); // This entered again before it fully left. Add it again.
	
	    else if (this._mounted) this.setState({
	        children: this.state.children.filter(function (c) {
	          return key(c) !== leavekey;
	        })
	      });
	
	    this._tryFinish();
	  },
	  isTransitioning: function isTransitioning() {
	    return !!Object.keys(this.animatingKeys).length;
	  },
	  render: function render() {
	    var _this = this;
	
	    var Component = this.props.component;
	
	    return _react2.default.createElement(
	      Component,
	      _3.default.omitOwnProps(this),
	      this.state.children.map(function (c) {
	        return _this.props.childFactory(c, key(c));
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(842),
	    getWindow = __webpack_require__(843);
	
	module.exports = function width(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerWidth : client ? node.clientWidth : offset(node).width;
	};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //pick, omit, has
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _activeElement = __webpack_require__(829);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dates = __webpack_require__(874);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(825);
	
	var _constants = __webpack_require__(876);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(840);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Calendar = __webpack_require__(868);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _TimeList = __webpack_require__(884);
	
	var _TimeList2 = _interopRequireDefault(_TimeList);
	
	var _DateTimePickerInput = __webpack_require__(885);
	
	var _DateTimePickerInput2 = _interopRequireDefault(_DateTimePickerInput);
	
	var _Button = __webpack_require__(835);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Calendar = _Calendar2.default.ControlledComponent;
	
	var viewEnum = Object.keys(_constants.calendarViews).map(function (k) {
	  return _constants.calendarViews[k];
	});
	
	var propTypes = _extends({}, Calendar.propTypes, {
	
	  //-- controlled props -----------
	  value: _propTypes2.default.instanceOf(Date),
	  onChange: _propTypes2.default.func,
	  open: _propTypes2.default.oneOf([false, _constants.datePopups.TIME, _constants.datePopups.CALENDAR]),
	  onToggle: _propTypes2.default.func,
	  currentDate: _propTypes2.default.instanceOf(Date),
	  onCurrentDateChange: _propTypes2.default.func,
	  //------------------------------------
	
	  onSelect: _propTypes2.default.func,
	
	  min: _propTypes2.default.instanceOf(Date),
	  max: _propTypes2.default.instanceOf(Date),
	
	  culture: _propTypes2.default.string,
	
	  format: _propTypes4.default.dateFormat,
	  timeFormat: _propTypes4.default.dateFormat,
	  editFormat: _propTypes4.default.dateFormat,
	
	  calendar: _propTypes2.default.bool,
	  time: _propTypes2.default.bool,
	
	  timeComponent: _propTypes4.default.elementType,
	
	  //popup
	  dropUp: _propTypes2.default.bool,
	  duration: _propTypes2.default.number,
	
	  placeholder: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	
	  initialView: _propTypes2.default.oneOf(viewEnum),
	  finalView: _propTypes2.default.oneOf(viewEnum),
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly,
	
	  parse: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string, _propTypes2.default.func]),
	
	  'aria-labelledby': _propTypes2.default.string,
	  'aria-describedby': _propTypes2.default.string,
	
	  messages: _propTypes2.default.shape({
	    calendarButton: _propTypes2.default.string,
	    timeButton: _propTypes2.default.string
	  })
	});
	
	var DateTimePicker = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'DateTimePicker',
	
	  mixins: [__webpack_require__(854), __webpack_require__(856), __webpack_require__(858), __webpack_require__(863), __webpack_require__(864)({
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  }), __webpack_require__(850)('valueInput', function (key, id) {
	    var open = this.props.open,
	        current = this.ariaActiveDescendant(),
	        calIsActive = open === _constants.datePopups.CALENDAR && key === 'calendar',
	        timeIsActive = open === _constants.datePopups.TIME && key === 'timelist';
	
	
	    if (!current || timeIsActive || calIsActive) return id;
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      focused: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	
	    return {
	      value: null,
	      currentDate: new Date(),
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      calendar: true,
	      time: true,
	      open: false,
	
	      //calendar override
	      footer: true,
	
	      messages: {
	        calendarButton: 'Select Date',
	        timeButton: 'Select Time'
	      },
	
	      ariaActiveDescendantKey: 'dropdownlist'
	    };
	  },
	  renderInput: function renderInput(id, owns) {
	    var _props = this.props,
	        open = _props.open,
	        value = _props.value,
	        editFormat = _props.editFormat,
	        culture = _props.culture,
	        busy = _props.busy,
	        placeholder = _props.placeholder,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        name = _props.name,
	        tabIndex = _props.tabIndex,
	        autoFocus = _props.autoFocus,
	        ariaLabelledby = _props['aria-labelledby'],
	        ariaDescribedby = _props['aria-describedby'];
	    var focused = this.state.focused;
	
	
	    return _react2.default.createElement(_DateTimePickerInput2.default, {
	      id: id,
	      ref: 'valueInput',
	      role: 'combobox',
	      name: name,
	      tabIndex: tabIndex,
	      autoFocus: autoFocus,
	      placeholder: placeholder,
	      disabled: disabled,
	      readOnly: readOnly,
	      value: value,
	      format: getFormat(this.props),
	      editFormat: editFormat,
	      editing: focused,
	      culture: culture,
	      parse: this._parse,
	      onChange: this.handleChange,
	      'aria-haspopup': true,
	      'aria-labelledby': ariaLabelledby,
	      'aria-describedby': ariaDescribedby,
	      'aria-expanded': !!open,
	      'aria-busy': !!busy,
	      'aria-owns': owns
	    });
	  },
	  renderButtons: function renderButtons(messages) {
	    var _props2 = this.props,
	        calendar = _props2.calendar,
	        time = _props2.time,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly;
	
	
	    if (!calendar && !time) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'span',
	      { className: 'rw-select' },
	      calendar && _react2.default.createElement(_Button2.default, {
	        icon: 'calendar',
	        className: 'rw-btn-calendar',
	        label: messages.calendarButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.CALENDAR)
	      }),
	      time && _react2.default.createElement(_Button2.default, {
	        icon: 'clock-o',
	        className: 'rw-btn-time',
	        label: messages.timeButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.TIME)
	      })
	    );
	  },
	  renderCalendar: function renderCalendar(id, inputID) {
	    var _this = this;
	
	    var _props3 = this.props,
	        open = _props3.open,
	        value = _props3.value,
	        duration = _props3.duration,
	        dropUp = _props3.dropUp;
	
	
	    var calendarProps = _3.default.pickProps(this.props, Calendar);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.CALENDAR,
	        className: 'rw-calendar-popup'
	      },
	      _react2.default.createElement(Calendar, _extends({}, calendarProps, {
	        ref: 'calPopup',
	        id: id,
	        tabIndex: '-1',
	        value: value,
	        autoFocus: false,
	        onChange: this.handleDateSelect
	        // #75: need to aggressively reclaim focus from the calendar otherwise
	        // disabled header/footer buttons will drop focus completely from the widget
	        , onNavigate: function onNavigate() {
	          return _this.focus();
	        },
	        currentDate: this.props.currentDate,
	        onCurrentDateChange: this.props.onCurrentDateChange,
	        'aria-hidden': !open,
	        'aria-live': 'polite',
	        'aria-labelledby': inputID,
	        ariaActiveDescendantKey: 'calendar'
	      }))
	    );
	  },
	  renderTimeList: function renderTimeList(id, inputID) {
	    var _this2 = this;
	
	    var _props4 = this.props,
	        open = _props4.open,
	        value = _props4.value,
	        duration = _props4.duration,
	        dropUp = _props4.dropUp,
	        calendar = _props4.calendar,
	        timeFormat = _props4.timeFormat,
	        timeComponent = _props4.timeComponent;
	
	
	    var timeListProps = _3.default.pickProps(this.props, _TimeList2.default);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.TIME,
	        onOpening: function onOpening() {
	          return _this2.refs.timePopup.forceUpdate();
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TimeList2.default, _extends({}, timeListProps, {
	          ref: 'timePopup',
	          id: id,
	          format: timeFormat,
	          value: dateOrNull(value),
	          onMove: this._scrollTo,
	          onSelect: this.handleTimeSelect,
	          preserveDate: !!calendar,
	          itemComponent: timeComponent,
	          'aria-labelledby': inputID,
	          'aria-live': open && 'polite',
	          'aria-hidden': !open,
	          ariaActiveDescendantKey: 'timelist'
	        }))
	      )
	    );
	  },
	  render: function render() {
	    var _props5 = this.props,
	        className = _props5.className,
	        calendar = _props5.calendar,
	        time = _props5.time,
	        open = _props5.open,
	        messages = _props5.messages,
	        disabled = _props5.disabled,
	        readOnly = _props5.readOnly,
	        dropUp = _props5.dropUp;
	    var focused = this.state.focused;
	
	
	    var inputID = (0, _widgetHelpers.instanceId)(this, '_input'),
	        timeListID = (0, _widgetHelpers.instanceId)(this, '_time_listbox'),
	        dateListID = (0, _widgetHelpers.instanceId)(this, '_cal'),
	        owns = '';
	
	    var elementProps = _3.default.omitOwnProps(this, Calendar, _TimeList2.default);
	
	    var shouldRenderList = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    if (calendar) owns += dateListID;
	    if (time) owns += ' ' + timeListID;
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: !!open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress,
	        className: (0, _classnames2.default)(className, 'rw-datetimepicker', calendar && time && 'rw-has-both', !calendar && !time && 'rw-has-neither')
	      }),
	      this.renderInput(inputID, owns.trim()),
	      this.renderButtons(messages),
	      shouldRenderList && this.renderTimeList(timeListID, inputID),
	      shouldRenderList && this.renderCalendar(dateListID, inputID)
	    );
	  },
	  handleChange: function handleChange(date, str, constrain) {
	    var _props6 = this.props,
	        onChange = _props6.onChange,
	        value = _props6.value;
	
	
	    if (constrain) date = this.inRangeValue(date);
	
	    if (onChange) {
	      if (date == null || value == null) {
	        if (date != value) //eslint-disable-line eqeqeq
	          onChange(date, str);
	      } else if (!_dates2.default.eq(date, value)) {
	        onChange(date, str);
	      }
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _props7 = this.props,
	        open = _props7.open,
	        calendar = _props7.calendar,
	        time = _props7.time;
	
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (e.key === 'Escape' && open) this.close();else if (e.altKey) {
	      e.preventDefault();
	
	      if (e.key === 'ArrowDown') {
	        if (calendar && time) this.open(open === _constants.datePopups.CALENDAR ? _constants.datePopups.TIME : _constants.datePopups.CALENDAR);else if (time) this.open(_constants.datePopups.TIME);else if (calendar) this.open(_constants.datePopups.CALENDAR);
	      } else if (e.key === 'ArrowUp') this.close();
	    } else if (open) {
	      if (open === _constants.datePopups.CALENDAR) this.refs.calPopup.handleKeyDown(e);
	      if (open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyDown(e);
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (this.props.open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyPress(e);
	  },
	  focus: function focus() {
	    var valueInput = this.refs.valueInput;
	
	
	    if (valueInput && (0, _activeElement2.default)() !== _compat2.default.findDOMNode(valueInput)) valueInput.focus();
	  },
	  handleDateSelect: function handleDateSelect(date) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(date, this.props.value, this.props.currentDate),
	        dateStr = formatDate(date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  handleTimeSelect: function handleTimeSelect(datum) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(this.props.value, datum.date, this.props.currentDate),
	        dateStr = formatDate(datum.date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  _click: function _click(view, e) {
	    this.focus();
	    this.toggle(view, e);
	  },
	  _parse: function _parse(string) {
	    var format = getFormat(this.props, true),
	        editFormat = this.props.editFormat,
	        parse = this.props.parse,
	        formats = [];
	
	    if (typeof parse === 'function') return parse(string, this.props.culture);
	
	    if (typeof format === 'string') formats.push(format);
	
	    if (typeof editFormat === 'string') formats.push(editFormat);
	
	    if (parse) formats = formats.concat(this.props.parse);
	
	    (0, _invariant2.default)(formats.length, 'React Widgets: there are no specified `parse` formats provided and the `format` prop is a function. ' + 'the DateTimePicker is unable to parse `%s` into a dateTime, ' + 'please provide either a parse function or Globalize.js compatible string for `format`', string);
	
	    return formatsParser(formats, this.props.culture, string);
	  },
	  toggle: function toggle(view) {
	    this.props.open ? this.props.open !== view ? this.open(view) : this.close(view) : this.open(view);
	  },
	  open: function open(view) {
	    if (this.props.open !== view && this.props[view] === true) (0, _widgetHelpers.notify)(this.props.onToggle, view);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  inRangeValue: function inRangeValue(value) {
	    if (value == null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleChange', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleChange'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj), _applyDecoratedDescriptor(_obj, 'handleDateSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleDateSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleTimeSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleTimeSelect'), _obj), _applyDecoratedDescriptor(_obj, '_click', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, '_click'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(DateTimePicker, {
	  open: 'onToggle',
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange'
	}, ['focus']);
	
	
	function getFormat(props) {
	  var cal = props[_constants.datePopups.CALENDAR] != null ? props.calendar : true,
	      time = props[_constants.datePopups.TIME] != null ? props.time : true;
	
	  return props.format ? props.format : cal && time || !cal && !time ? _localizers.date.getFormat('default') : _localizers.date.getFormat(cal ? 'date' : 'time');
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && !isNaN(date.getTime())) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	
	function formatsParser(formats, culture, str) {
	  var date;
	
	  for (var i = 0; i < formats.length; i++) {
	    date = _localizers.date.parse(str, formats[i], culture);
	    if (date) return date;
	  }
	  return null;
	}
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _dates2 = __webpack_require__(874);
	
	var _dates3 = _interopRequireDefault(_dates2);
	
	var _List = __webpack_require__(845);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _localizers = __webpack_require__(825);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('time', props.format);
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'TimeList',
	
	  propTypes: {
	    value: _propTypes2.default.instanceOf(Date),
	    step: _propTypes2.default.number,
	    min: _propTypes2.default.instanceOf(Date),
	    max: _propTypes2.default.instanceOf(Date),
	    currentDate: _propTypes2.default.instanceOf(Date),
	
	    itemComponent: _propTypes4.default.elementType,
	    format: _propTypes4.default.dateFormat,
	    onSelect: _propTypes2.default.func,
	    preserveDate: _propTypes2.default.bool,
	    culture: _propTypes2.default.string,
	    delay: _propTypes2.default.number
	  },
	
	  mixins: [__webpack_require__(854)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      step: 30,
	      onSelect: function onSelect() {},
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      preserveDate: true,
	      delay: 300,
	      ariaActiveDescendantKey: 'timelist'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var data = this._dates(this.props),
	        focusedItem = this._closestDate(data, this.props.value || this.props.currentDate);
	
	    return {
	      focusedItem: focusedItem || data[0],
	      dates: data
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._mounted = true;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._mounted = false;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = this._dates(nextProps),
	        focusedItem = this._closestDate(data, nextProps.value || this.props.currentDate),
	        valChanged = !_dates3.default.eq(nextProps.value, this.props.value, 'minutes'),
	        minChanged = !_dates3.default.eq(nextProps.min, this.props.min, 'minutes'),
	        maxChanged = !_dates3.default.eq(nextProps.max, this.props.max, 'minutes'),
	        localeChanged = this.props.format !== nextProps.format || this.props.culture !== nextProps.culture;
	
	    if (valChanged || minChanged || maxChanged || localeChanged) {
	      this.setState({
	        focusedItem: focusedItem || data[0],
	        dates: data
	      });
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        value = _props.value,
	        onSelect = _props.onSelect,
	        itemComponent = _props.itemComponent;
	
	
	    var times = this.state.dates,
	        date = this._closestDate(times, value);
	
	    return _react2.default.createElement(_List2.default, _extends({}, _3.default.omitOwnProps(this), {
	      ref: 'list',
	      data: times,
	      textField: 'label',
	      valueField: 'date',
	      selected: date,
	      onSelect: onSelect,
	      focused: this.state.focusedItem,
	      itemComponent: itemComponent
	    }));
	  },
	  _closestDate: function _closestDate(times, date) {
	    var roundTo = 1000 * 60 * this.props.step,
	        inst = null,
	        label;
	
	    if (!date) return null;
	
	    date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
	    label = _localizers.date.format(date, format(this.props), this.props.culture);
	
	    times.some(function (time) {
	      if (time.label === label) return inst = time;
	    });
	
	    return inst;
	  },
	  _data: function _data() {
	    return this.state.dates;
	  },
	  _dates: function _dates(props) {
	    var times = [],
	        i = 0,
	        values = this._dateValues(props),
	        start = values.min,
	        startDay = _dates3.default.date(start);
	
	    while (_dates3.default.date(start) === startDay && _dates3.default.lte(start, values.max)) {
	      i++;
	      times.push({ date: start, label: _localizers.date.format(start, format(props), props.culture) });
	      start = _dates3.default.add(start, props.step || 30, 'minutes');
	    }
	    return times;
	  },
	  _dateValues: function _dateValues(props) {
	    var value = props.value || props.currentDate || _dates3.default.today(),
	        useDate = props.preserveDate,
	        min = props.min,
	        max = props.max,
	        start,
	        end;
	
	    //compare just the time regradless of whether they fall on the same day
	    if (!useDate) {
	      start = _dates3.default.startOf(_dates3.default.merge(new Date(), min, props.currentDate), 'minutes');
	      end = _dates3.default.startOf(_dates3.default.merge(new Date(), max, props.currentDate), 'minutes');
	
	      if (_dates3.default.lte(end, start) && _dates3.default.gt(max, min, 'day')) end = _dates3.default.tomorrow();
	
	      return {
	        min: start,
	        max: end
	      };
	    }
	
	    start = _dates3.default.today();
	    end = _dates3.default.tomorrow();
	    //date parts are equal
	    return {
	      min: _dates3.default.eq(value, min, 'day') ? _dates3.default.merge(start, min, props.currentDate) : start,
	      max: _dates3.default.eq(value, max, 'day') ? _dates3.default.merge(start, max, props.currentDate) : end
	    };
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var key = e.key,
	        focusedItem = this.state.focusedItem,
	        list = this.refs.list;
	
	    if (key === 'End') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.last() });
	    } else if (key === 'Home') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.first() });
	    } else if (key === 'Enter') this.props.onSelect(focusedItem);else if (key === 'ArrowDown') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.next(focusedItem) });
	    } else if (key === 'ArrowUp') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.prev(focusedItem) });
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    this.search(String.fromCharCode(e.which), function (item) {
	      _this._mounted && _this.setState({ focusedItem: item });
	    });
	  },
	  scrollTo: function scrollTo() {
	    this.refs.list.move && this.refs.list.move();
	  },
	  search: function search(character, cb) {
	    var _this2 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase();
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var list = _this2.refs.list,
	          item = list.next(_this2.state.focusedItem, word);
	
	      _this2._searchTerm = '';
	      if (item) cb(item);
	    }, this.props.delay);
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _Input = __webpack_require__(833);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _localizers = __webpack_require__(825);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'DateTimePickerInput',
	
	  propTypes: {
	    format: _propTypes4.default.dateFormat.isRequired,
	    editing: _propTypes2.default.bool,
	    editFormat: _propTypes4.default.dateFormat,
	    parse: _propTypes2.default.func.isRequired,
	
	    value: _propTypes2.default.instanceOf(Date),
	    onChange: _propTypes2.default.func.isRequired,
	    culture: _propTypes2.default.string
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        editing = nextProps.editing,
	        editFormat = nextProps.editFormat,
	        format = nextProps.format,
	        culture = nextProps.culture;
	
	
	    this.setState({
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    });
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        value = _props.value,
	        editing = _props.editing,
	        editFormat = _props.editFormat,
	        format = _props.format,
	        culture = _props.culture;
	
	
	    return {
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    };
	  },
	  render: function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly;
	    var textValue = this.state.textValue;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      type: 'text',
	      value: textValue,
	      disabled: disabled,
	      readOnly: readOnly,
	      onChange: this.handleChange,
	      onBlur: this.handleBlur
	    }));
	  },
	  handleChange: function handleChange(_ref) {
	    var value = _ref.target.value;
	
	    this._needsFlush = true;
	    this.setState({ textValue: value });
	  },
	  handleBlur: function handleBlur(event) {
	    var _props3 = this.props,
	        format = _props3.format,
	        culture = _props3.culture,
	        parse = _props3.parse,
	        onChange = _props3.onChange,
	        onBlur = _props3.onBlur;
	
	
	    onBlur && onBlur(event);
	
	    if (this._needsFlush) {
	      var date = parse(event.target.value);
	
	      this._needsFlush = false;
	      onChange(date, formatDate(date, format, culture));
	    }
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	
	
	function isValid(d) {
	  return !isNaN(d.getTime());
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && isValid(date)) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _desc, _value, _obj;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _constants = __webpack_require__(876);
	
	var _repeater = __webpack_require__(887);
	
	var _repeater2 = _interopRequireDefault(_repeater);
	
	var _localizers = __webpack_require__(825);
	
	var _NumberInput = __webpack_require__(888);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _Button = __webpack_require__(835);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var format = function format(props) {
	  return _localizers.number.getFormat('default', props.format);
	};
	
	var propTypes = {
	
	  // -- controlled props -----------
	  value: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  //------------------------------------
	
	  min: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	
	  precision: _propTypes2.default.number,
	
	  culture: _propTypes2.default.string,
	
	  format: _propTypes4.default.numberFormat,
	
	  name: _propTypes2.default.string,
	
	  parse: _propTypes2.default.func,
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly,
	
	  messages: _propTypes2.default.shape({
	    increment: _propTypes2.default.string,
	    decrement: _propTypes2.default.string
	  }),
	
	  placeholder: _propTypes2.default.string
	};
	
	var NumberPicker = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'NumberPicker',
	
	  mixins: [__webpack_require__(854), __webpack_require__(856), __webpack_require__(863), __webpack_require__(864)({
	    willHandle: function willHandle(focused) {
	      if (focused) this.focus();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      open: false,
	
	      min: -Infinity,
	      max: Infinity,
	      step: 1,
	
	      messages: {
	        increment: 'increment value',
	        decrement: 'decrement value'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      focused: false,
	      active: false
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var _$omitOwnProps = _3.default.omitOwnProps(this),
	        className = _$omitOwnProps.className,
	        onKeyPress = _$omitOwnProps.onKeyPress,
	        onKeyUp = _$omitOwnProps.onKeyUp,
	        props = _objectWithoutProperties(_$omitOwnProps, ['className', 'onKeyPress', 'onKeyUp']);
	
	    var val = this.constrainValue(this.props.value);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        ref: 'element',
	        onKeyDown: this._keyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-numberpicker', 'rw-widget', {
	          'rw-state-focus': this.state.focused,
	          'rw-state-disabled': this.props.disabled,
	          'rw-state-readonly': this.props.readOnly,
	          'rw-rtl': this.isRtl()
	        }) }),
	      _react2.default.createElement(
	        'span',
	        { className: 'rw-select' },
	        _react2.default.createElement(_Button2.default, {
	          icon: 'caret-up',
	          onClick: this.handleFocus,
	          label: this.props.messages.increment,
	          active: this.state.active === _constants.directions.UP,
	          disabled: val === this.props.max || this.props.disabled,
	          onMouseUp: function onMouseUp() {
	            return _this.handleMouseUp(_constants.directions.UP);
	          },
	          onMouseDown: function onMouseDown() {
	            return _this.handleMouseDown(_constants.directions.UP);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.handleMouseUp(_constants.directions.UP);
	          }
	        }),
	        _react2.default.createElement(_Button2.default, {
	          icon: 'caret-down',
	          onClick: this.handleFocus,
	          label: this.props.messages.decrement,
	          active: this.state.active === _constants.directions.DOWN,
	          disabled: val === this.props.min || this.props.disabled,
	          onMouseUp: function onMouseUp() {
	            return _this.handleMouseUp(_constants.directions.DOWN);
	          },
	          onMouseDown: function onMouseDown() {
	            return _this.handleMouseDown(_constants.directions.DOWN);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.handleMouseUp(_constants.directions.DOWN);
	          }
	        })
	      ),
	      _react2.default.createElement(_NumberInput2.default, {
	        ref: 'input',
	        tabIndex: props.tabIndex,
	        placeholder: this.props.placeholder,
	        value: val,
	        autoFocus: this.props.autoFocus,
	        editing: this.state.focused,
	        format: this.props.format,
	        parse: this.props.parse,
	        name: this.props.name,
	        role: 'spinbutton',
	        min: this.props.min,
	        'aria-valuenow': val,
	        'aria-valuemin': isFinite(this.props.min) ? this.props.min : null,
	        'aria-valuemax': isFinite(this.props.max) ? this.props.max : null,
	        'aria-disabled': this.props.disabled,
	        'aria-readonly': this.props.readonly,
	        disabled: this.props.disabled,
	        readOnly: this.props.readOnly,
	        onChange: this.change,
	        onKeyPress: onKeyPress,
	        onKeyUp: onKeyUp })
	    );
	  },
	  handleMouseDown: function handleMouseDown(dir) {
	    var method = dir === _constants.directions.UP ? this.increment : this.decrement;
	
	    this.setState({ active: dir });
	
	    var val = method.call(this);
	
	    if (!(dir === _constants.directions.UP && val === this.props.max || dir === _constants.directions.DOWN && val === this.props.min)) {
	      if (!this._cancelRepeater) this._cancelRepeater = (0, _repeater2.default)(this.handleMouseDown.bind(null, dir));
	    } else this.handleMouseUp();
	  },
	  handleMouseUp: function handleMouseUp() {
	    this.setState({ active: false });
	    this._cancelRepeater && this._cancelRepeater();
	    this._cancelRepeater = null;
	  },
	  _keyDown: function _keyDown(e) {
	    var key = e.key;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End' && isFinite(this.props.max)) this.change(this.props.max);else if (key === 'Home' && isFinite(this.props.min)) this.change(this.props.min);else if (key === 'ArrowDown') {
	      e.preventDefault();
	      this.decrement();
	    } else if (key === 'ArrowUp') {
	      e.preventDefault();
	      this.increment();
	    }
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this.refs.input).focus();
	  },
	  increment: function increment() {
	    return this.step(this.props.step);
	  },
	  decrement: function decrement() {
	    return this.step(-this.props.step);
	  },
	  step: function step(amount) {
	    var value = (this.props.value || 0) + amount;
	
	    var decimals = this.props.precision != null ? this.props.precision : _localizers.number.precision(format(this.props));
	
	    this.change(decimals != null ? round(value, decimals) : value);
	
	    return value;
	  },
	  change: function change(val) {
	    val = this.constrainValue(val);
	
	    if (this.props.value !== val) (0, _widgetHelpers.notify)(this.props.onChange, val);
	  },
	  constrainValue: function constrainValue(value) {
	    var max = this.props.max == null ? Infinity : this.props.max,
	        min = this.props.min == null ? -Infinity : this.props.min;
	
	    if (value == null || value === '') return null;
	
	    return Math.max(Math.min(value, max), min);
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleMouseDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleMouseDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleMouseUp', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleMouseUp'), _obj), _applyDecoratedDescriptor(_obj, '_keyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, '_keyDown'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(NumberPicker, { value: 'onChange' }, ['focus']);
	
	// thank you kendo ui core
	// https://github.com/telerik/kendo-ui-core/blob/master/src/kendo.core.js#L1036
	
	function round(value, precision) {
	  precision = precision || 0;
	
	  value = ('' + value).split('e');
	  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] + precision : precision)));
	
	  value = ('' + value).split('e');
	  value = +(value[0] + 'e' + (value[1] ? +value[1] - precision : -precision));
	
	  return value.toFixed(precision);
	}
	module.exports = exports['default'];

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Repeater;
	// my tests in ie11/chrome/FF indicate that keyDown repeats
	// at about 35ms+/- 5ms after an initial 500ms delay. callback fires on the leading edge
	function Repeater(callback) {
	  var id,
	      cancel = function cancel() {
	    return clearInterval(id);
	  };
	
	  id = setInterval(function () {
	    cancel();
	    id = setInterval(callback, 35);
	    callback(); //fire after everything in case the user cancels on the first call
	  }, 500);
	
	  return cancel;
	}
	module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _localizers = __webpack_require__(825);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFormat = function getFormat(props) {
	  return _localizers.number.getFormat('default', props.format);
	};
	
	var propTypes = {
	  value: _propTypes2.default.number,
	  editing: _propTypes2.default.bool,
	  placeholder: _propTypes2.default.string,
	
	  format: _propTypes4.default.numberFormat,
	
	  parse: _propTypes2.default.func,
	  culture: _propTypes2.default.string,
	
	  min: _propTypes2.default.number,
	
	  onChange: _propTypes2.default.func.isRequired,
	  onKeyDown: _propTypes2.default.func
	};
	
	exports.default = (0, _createReactClass2.default)({
	
	  displayName: 'NumberPickerInput',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      editing: false
	    };
	  },
	  getDefaultState: function getDefaultState() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    var value = props.value,
	        decimal = _localizers.number.decimalChar(null, props.culture),
	        format = getFormat(props);
	
	    if (value == null || isNaN(props.value)) value = '';else value = props.editing ? ('' + value).replace('.', decimal) : _localizers.number.format(value, format, props.culture);
	
	    return {
	      stringValue: '' + value
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getDefaultState();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getDefaultState(nextProps));
	  },
	  render: function render() {
	    var value = this.state.stringValue;
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement('input', _extends({}, props, {
	      type: 'text',
	      className: 'rw-input',
	      onChange: this._change,
	      onBlur: this._finish,
	      'aria-disabled': this.props.disabled,
	      'aria-readonly': this.props.readOnly,
	      disabled: this.props.disabled,
	      readOnly: this.props.readOnly,
	      placeholder: this.props.placeholder,
	      value: value
	    }));
	  },
	  _change: function _change(e) {
	    var val = e.target.value,
	        number = this._parse(e.target.value);
	
	    var isIntermediate = this.isIntermediateValue(number, val);
	
	    if (val == null || val.trim() === '') {
	      this.current('');
	      return this.props.onChange(null);
	    }
	
	    if (!isIntermediate) {
	      if (number !== this.props.value) {
	        return this.props.onChange(number);
	      }
	    } else {
	      this.current(e.target.value);
	    }
	  },
	  _finish: function _finish() {
	    var str = this.state.stringValue,
	        number = this._parse(str);
	
	    // if number is below the min
	    // we need to flush low values and decimal stops, onBlur means i'm done inputing
	    if (this.isIntermediateValue(number, str)) {
	      if (isNaN(number)) {
	        number = null;
	      }
	      this.props.onChange(number);
	    }
	  },
	  _parse: function _parse(strVal) {
	    var culture = this.props.culture,
	        delimChar = _localizers.number.decimalChar(null, culture),
	        userParse = this.props.parse;
	
	    if (userParse) return userParse(strVal, culture);
	
	    strVal = strVal.replace(delimChar, '.');
	    strVal = parseFloat(strVal);
	
	    return strVal;
	  },
	  isIntermediateValue: function isIntermediateValue(num, str) {
	    return !!(num < this.props.min || this.isSign(str) || this.isAtDelimiter(num, str) || this.isPaddedZeros(str));
	  },
	  isSign: function isSign(val) {
	    return (val || '').trim() === '-';
	  },
	  isPaddedZeros: function isPaddedZeros(str) {
	    var localeChar = _localizers.number.decimalChar(null, this.props.culture);
	
	    var _str$split = str.split(localeChar),
	        _ = _str$split[0],
	        decimals = _str$split[1];
	
	    return !!(decimals && decimals.match(/0+$/));
	  },
	  isAtDelimiter: function isAtDelimiter(num, str) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    var localeChar = _localizers.number.decimalChar(null, props.culture),
	        lastIndex = str.length - 1,
	        char;
	
	    if (str.length < 1) return false;
	
	    char = str[lastIndex];
	
	    return !!(char === localeChar && str.indexOf(char) === lastIndex);
	  },
	  isValid: function isValid(num) {
	    if (typeof num !== 'number' || isNaN(num)) return false;
	    return num >= this.props.min;
	  },
	
	
	  //this intermediate state is for when one runs into the decimal or are typing the number
	  current: function current(stringValue) {
	    this.setState({ stringValue: stringValue });
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(840);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _MultiselectInput = __webpack_require__(890);
	
	var _MultiselectInput2 = _interopRequireDefault(_MultiselectInput);
	
	var _MultiselectTagList = __webpack_require__(891);
	
	var _MultiselectTagList2 = _interopRequireDefault(_MultiselectTagList);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(845);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(851);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(853);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var compatCreate = function compatCreate(props, msgs) {
	  return typeof msgs.createNew === 'function' ? msgs.createNew(props) : [_react2.default.createElement(
	    'strong',
	    { key: 'dumb' },
	    '"' + props.searchTerm + '"'
	  ), ' ' + msgs.createNew];
	};
	
	var splat = _3.default.splat;
	
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  data: _propTypes2.default.array,
	  //-- controlled props --
	  value: _propTypes2.default.array,
	  onChange: _propTypes2.default.func,
	
	  searchTerm: _propTypes2.default.string,
	  onSearch: _propTypes2.default.func,
	
	  open: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func,
	  //-------------------------------------------
	
	  valueField: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	
	  tagComponent: _propTypes4.default.elementType,
	  itemComponent: _propTypes4.default.elementType,
	  listComponent: _propTypes4.default.elementType,
	
	  groupComponent: _propTypes4.default.elementType,
	  groupBy: _propTypes4.default.accessor,
	
	  createComponent: _propTypes4.default.elementType,
	
	  onSelect: _propTypes2.default.func,
	  onCreate: _propTypes2.default.oneOfType([_propTypes2.default.oneOf([false]), _propTypes2.default.func]),
	
	  inputSize: _propTypes2.default.func,
	
	  busy: _propTypes2.default.bool,
	  dropUp: _propTypes2.default.bool,
	
	  placeholder: _propTypes2.default.string,
	
	  autoFocus: _propTypes2.default.bool,
	  disabled: _propTypes4.default.disabled.acceptsArray,
	  readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	  messages: _propTypes2.default.shape({
	    open: _propTypes4.default.message,
	    emptyList: _propTypes4.default.message,
	    emptyFilter: _propTypes4.default.message,
	    createNew: _propTypes4.default.message
	  })
	});
	
	var Multiselect = (0, _createReactClass2.default)((_obj = {
	
	  displayName: 'Multiselect',
	
	  mixins: [__webpack_require__(854), __webpack_require__(857), __webpack_require__(858), __webpack_require__(863), __webpack_require__(864)({
	    willHandle: function willHandle(focused) {
	      focused && this.focus();
	    },
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	
	      if (!focused && this.refs.tagList) this.setState({ focusedTag: null });
	
	      if (focused && !this.props.open) this.open();
	    }
	  }), __webpack_require__(850)('input', function (key, id) {
	    var myKey = this.props.ariaActiveDescendantKey;
	
	
	    var createIsActive = (!this._data().length || this.state.focusedItem === null) && key === myKey;
	
	    var tagIsActive = this.state.focusedTag != null && key === 'taglist';
	    var listIsActive = this.state.focusedTag == null && key === 'list';
	
	    if (createIsActive || tagIsActive || listIsActive) return id;
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: [],
	      filter: 'startsWith',
	      value: [],
	      open: false,
	      searchTerm: '',
	      ariaActiveDescendantKey: 'multiselect',
	      messages: {
	        createNew: '(create new tag)',
	        emptyList: 'There are no items in this list',
	        emptyFilter: 'The filter returned no results',
	        tagsLabel: 'selected items',
	        selectedItems: 'selected items',
	        noneSelected: 'no selected items',
	        removeLabel: 'remove selected item'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props,
	        data = _props.data,
	        value = _props.value,
	        valueField = _props.valueField,
	        searchTerm = _props.searchTerm,
	        dataItems = splat(value).map(function (item) {
	      return (0, _dataHelpers.dataItem)(data, item, valueField);
	    }),
	        processedData = this.process(data, dataItems, searchTerm);
	
	
	    return {
	      focusedTag: null,
	      focusedItem: processedData[0],
	      processedData: processedData,
	      dataItems: dataItems
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.ariaActiveDescendant((0, _widgetHelpers.instanceId)(this, '__createlist_option'));
	
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = nextProps.data,
	        value = nextProps.value,
	        valueField = nextProps.valueField,
	        searchTerm = nextProps.searchTerm,
	        values = _3.default.splat(value),
	        current = this.state.focusedItem,
	        items = this.process(data, values, searchTerm);
	
	    this.setState({
	      processedData: items,
	      focusedItem: items.indexOf(current) === -1 ? items[0] : current,
	      dataItems: values.map(function (item) {
	        return (0, _dataHelpers.dataItem)(data, item, valueField);
	      })
	    });
	  },
	  renderCreateItem: function renderCreateItem(id, messages) {
	    var _this = this;
	
	    var searchTerm = this.props.searchTerm;
	    var focusedItem = this.state.focusedItem;
	
	
	    var createIsFocused = !this._data().length || focusedItem === null;
	    var optionID = (0, _widgetHelpers.instanceId)(this, '__createlist_option');
	
	    return _react2.default.createElement(
	      'ul',
	      {
	        id: id,
	        role: 'listbox',
	        className: 'rw-list rw-multiselect-create-tag'
	      },
	      _react2.default.createElement(
	        'li',
	        {
	          id: optionID,
	          role: 'option',
	          onClick: function onClick() {
	            return _this.handleCreate(searchTerm);
	          },
	          className: (0, _classnames2.default)('rw-list-option', 'rw-create-list-option', createIsFocused && 'rw-state-focus')
	        },
	        compatCreate(this.props, messages)
	      )
	    );
	  },
	  renderInput: function renderInput(owns) {
	    var _props2 = this.props,
	        searchTerm = _props2.searchTerm,
	        maxLength = _props2.maxLength,
	        tabIndex = _props2.tabIndex,
	        busy = _props2.busy,
	        open = _props2.open,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly;
	
	
	    return _react2.default.createElement(_MultiselectInput2.default, {
	      ref: 'input',
	      tabIndex: tabIndex || 0,
	      role: 'listbox',
	      'aria-expanded': !!open,
	      'aria-busy': !!busy,
	      autoFocus: this.props.autoFocus,
	      'aria-owns': owns,
	      'aria-haspopup': true,
	      value: searchTerm,
	      maxLength: maxLength,
	      disabled: disabled === true,
	      readOnly: readOnly === true,
	      placeholder: this.getPlaceholder(),
	      inputSize: this.props.inputSize,
	      onKeyDown: this.handleSearchKeyDown,
	      onKeyUp: this.handleSearchKeyUp,
	      onChange: this.handleInputChange,
	      onClick: this.handleInputInteraction,
	      onTouchEnd: this.handleInputInteraction
	    });
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props3 = this.props,
	        open = _props3.open,
	        disabled = _props3.disabled,
	        readOnly = _props3.readOnly;
	    var focusedItem = this.state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(List, _extends({ ref: 'list',
	      key: 0
	    }, listProps, {
	      readOnly: readOnly,
	      disabled: disabled,
	      id: id,
	      'aria-live': 'polite',
	      'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	      'aria-hidden': !open,
	      ariaActiveDescendantKey: 'list',
	      data: items,
	      focused: focusedItem,
	      onSelect: this.handleSelect,
	      onMove: this._scrollTo,
	      messages: {
	        emptyList: this._lengthWithoutValues ? messages.emptyFilter : messages.emptyList
	      }
	    }));
	  },
	  renderNotificationArea: function renderNotificationArea(id, messages) {
	    var textField = this.props.textField;
	    var _state = this.state,
	        focused = _state.focused,
	        dataItems = _state.dataItems;
	
	
	    return _react2.default.createElement(
	      'span',
	      {
	        id: id,
	        role: 'status',
	        className: 'rw-sr',
	        'aria-live': 'assertive',
	        'aria-atomic': 'true',
	        'aria-relevant': 'additions removals text'
	      },
	      focused && (dataItems.length ? messages.selectedItems + ': ' + dataItems.map(function (item) {
	        return (0, _dataHelpers.dataText)(item, textField);
	      }).join(', ') : messages.noneSelected)
	    );
	  },
	  renderTags: function renderTags(id, messages) {
	    var _props4 = this.props,
	        disabled = _props4.disabled,
	        readOnly = _props4.readOnly,
	        valueField = _props4.valueField,
	        textField = _props4.textField;
	    var _state2 = this.state,
	        focusedTag = _state2.focusedTag,
	        dataItems = _state2.dataItems;
	
	
	    var Component = this.props.tagComponent;
	
	    return _react2.default.createElement(_MultiselectTagList2.default, {
	      ref: 'tagList',
	      id: id,
	      valueField: valueField,
	      textField: textField,
	      'aria-label': messages.tagsLabel,
	      value: dataItems,
	      focused: focusedTag,
	      disabled: disabled,
	      readOnly: readOnly,
	      onDelete: this.handleDelete,
	      valueComponent: Component,
	      ariaActiveDescendantKey: 'taglist'
	    });
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props5 = this.props,
	        className = _props5.className,
	        groupBy = _props5.groupBy,
	        messages = _props5.messages,
	        busy = _props5.busy,
	        dropUp = _props5.dropUp,
	        open = _props5.open,
	        duration = _props5.duration,
	        disabled = _props5.disabled,
	        readOnly = _props5.readOnly,
	        List = _props5.listComponent;
	    var _state3 = this.state,
	        focused = _state3.focused,
	        dataItems = _state3.dataItems;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	
	    var shouldRenderTags = !!dataItems.length,
	        shouldRenderPopup = (0, _widgetHelpers.isFirstFocusedRender)(this) || open,
	        shouldShowCreate = this.shouldShowCreate();
	
	    var tagsID = (0, _widgetHelpers.instanceId)(this, '_taglist'),
	        listID = (0, _widgetHelpers.instanceId)(this, '__listbox'),
	        createID = (0, _widgetHelpers.instanceId)(this, '__createlist'),
	        notifyID = (0, _widgetHelpers.instanceId)(this, '__notify');
	
	    var inputOwns = listID + ' ' + notifyID + ' ' + (shouldRenderTags ? tagsID : '') + (shouldShowCreate ? createID : '');
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        id: (0, _widgetHelpers.instanceId)(this),
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled === true,
	        readOnly: readOnly === true,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onTouchEnd: this.handleFocus,
	        className: (0, _classnames2.default)(className, 'rw-multiselect')
	      }),
	      this.renderNotificationArea(notifyID, messages),
	      _react2.default.createElement(
	        'div',
	        { className: 'rw-multiselect-wrapper' },
	        busy && _react2.default.createElement('span', { className: 'rw-i rw-loading' }),
	        shouldRenderTags && this.renderTags(tagsID, messages),
	        this.renderInput(inputOwns)
	      ),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          dropUp: dropUp,
	          open: open,
	          duration: duration,
	          onOpening: function onOpening() {
	            return _this2.refs.list.forceUpdate();
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderList(List, listID, messages),
	          shouldShowCreate && this.renderCreateItem(createID, messages)
	        )
	      )
	    );
	  },
	  _data: function _data() {
	    return this.state.processedData;
	  },
	  handleDelete: function handleDelete(value) {
	    this.focus();
	    this.change(this.state.dataItems.filter(function (d) {
	      return d !== value;
	    }));
	  },
	  handleSearchKeyDown: function handleSearchKeyDown(e) {
	    if (e.key === 'Backspace' && e.target.value && !this._deletingText) this._deletingText = true;
	  },
	  handleSearchKeyUp: function handleSearchKeyUp(e) {
	    if (e.key === 'Backspace' && this._deletingText) this._deletingText = false;
	  },
	  handleInputChange: function handleInputChange(e) {
	    (0, _widgetHelpers.notify)(this.props.onSearch, [e.target.value]);
	    this.open();
	  },
	  handleInputInteraction: function handleInputInteraction() {
	    this.open();
	  },
	  handleSelect: function handleSelect(data) {
	    if (data === undefined) {
	      if (this.props.onCreate) this.handleCreate(this.props.searchTerm);
	
	      return;
	    }
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(this.state.dataItems.concat(data));
	
	    this.close();
	    this.focus();
	  },
	  handleCreate: function handleCreate(tag) {
	    if (tag.trim() === '') return;
	
	    (0, _widgetHelpers.notify)(this.props.onCreate, tag);
	    this.props.searchTerm && (0, _widgetHelpers.notify)(this.props.onSearch, ['']);
	
	    this.close();
	    this.focus();
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var key = e.key,
	        keyCode = e.keyCode,
	        altKey = e.altKey,
	        ctrlKey = e.ctrlKey,
	        noSearch = !this.props.searchTerm && !this._deletingText,
	        isOpen = this.props.open;
	    var _state4 = this.state,
	        focusedTag = _state4.focusedTag,
	        focusedItem = _state4.focusedItem;
	    var _refs = this.refs,
	        list = _refs.list,
	        tagList = _refs.tagList;
	
	    var nullTag = { focusedTag: null };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'ArrowDown') {
	      var next = list.next(focusedItem),
	          creating = this.shouldShowCreate() && focusedItem === next || focusedItem === null;
	
	      next = creating ? null : next;
	
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: next }, nullTag));else this.open();
	    } else if (key === 'ArrowUp') {
	      var prev = focusedItem === null ? list.last() : list.prev(focusedItem);
	
	      e.preventDefault();
	
	      if (altKey) this.close();else if (isOpen) this.setState(_extends({ focusedItem: prev }, nullTag));
	    } else if (key === 'End') {
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: list.last() }, nullTag));else tagList && this.setState({ focusedTag: tagList.last() });
	    } else if (key === 'Home') {
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: list.first() }, nullTag));else tagList && this.setState({ focusedTag: tagList.first() });
	    } else if (isOpen && keyCode === 13) {
	      // using keyCode to ignore enter for japanese IME
	      e.preventDefault();
	      ctrlKey && this.props.onCreate || focusedItem === null ? this.handleCreate(this.props.searchTerm) : this.handleSelect(this.state.focusedItem);
	    } else if (key === 'Escape') isOpen ? this.close() : tagList && this.setState(nullTag);else if (noSearch && key === 'ArrowLeft') tagList && this.setState({ focusedTag: tagList.prev(focusedTag) });else if (noSearch && key === 'ArrowRight') tagList && this.setState({ focusedTag: tagList.next(focusedTag) });else if (noSearch && key === 'Delete') tagList && tagList.remove(focusedTag);else if (noSearch && key === 'Backspace') tagList && tagList.removeNext();
	  },
	  change: function change(data) {
	    (0, _widgetHelpers.notify)(this.props.onChange, [data]);
	    (0, _widgetHelpers.notify)(this.props.onSearch, ['']);
	  },
	  focus: function focus() {
	    this.refs.input && this.refs.input.focus();
	  },
	  open: function open() {
	    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.props.open ? this.close() : this.open();
	  },
	  process: function process(data, values, searchTerm) {
	    var valueField = this.props.valueField;
	
	    var items = data.filter(function (i) {
	      return !values.some(function (v) {
	        return (0, _dataHelpers.valueMatcher)(i, v, valueField);
	      });
	    });
	
	    this._lengthWithoutValues = items.length;
	
	    if (searchTerm) items = this.filter(items, searchTerm);
	
	    return items;
	  },
	  shouldShowCreate: function shouldShowCreate() {
	    var _props6 = this.props,
	        textField = _props6.textField,
	        searchTerm = _props6.searchTerm,
	        onCreate = _props6.onCreate,
	        caseSensitive = _props6.caseSensitive;
	
	
	    if (!onCreate || !searchTerm) return false;
	
	    var lower = function lower(text) {
	      return caseSensitive ? text : text.toLowerCase();
	    };
	    var eq = function eq(v) {
	      return lower((0, _dataHelpers.dataText)(v, textField)) === lower(searchTerm);
	    };
	
	    // if there is an exact match on textFields: "john" => { name: "john" }, don't show
	    return !this._data().some(eq) && !this.state.dataItems.some(eq);
	  },
	  getPlaceholder: function getPlaceholder() {
	    return (this.props.value || []).length ? '' : this.props.placeholder || '';
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleInputInteraction', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleInputInteraction'), _obj), _applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleCreate', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleCreate'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'change', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'change'), _obj)), _obj));
	
	function msgs(msgs) {
	  return _extends({
	    createNew: '(create new tag)',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results',
	    tagsLabel: 'selected items',
	    selectedItems: 'selected items',
	    removeLabel: 'remove selected item'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(Multiselect, { open: 'onToggle', value: 'onChange', searchTerm: 'onSearch' }, ['focus']);
	module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiselectInput = (_temp = _class = function (_React$Component) {
	  _inherits(MultiselectInput, _React$Component);
	
	  function MultiselectInput() {
	    _classCallCheck(this, MultiselectInput);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MultiselectInput.prototype.render = function render() {
	    var _props = this.props,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        placeholder = _props.placeholder,
	        onChange = _props.onChange,
	        value = _props.value,
	        props = _objectWithoutProperties(_props, ['disabled', 'readOnly', 'placeholder', 'onChange', 'value']);
	
	    var size = props.inputSize ? props.inputSize(value || placeholder) : Math.max((value || placeholder).length, 1) + 1;
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement('input', _extends({}, elementProps, {
	      size: size,
	      className: 'rw-input',
	      autoComplete: 'off',
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly,
	      disabled: disabled,
	      readOnly: readOnly,
	      placeholder: placeholder,
	      onChange: onChange,
	      value: value
	    }));
	  };
	
	  MultiselectInput.prototype.focus = function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  };
	
	  return MultiselectInput;
	}(_react2.default.Component), _class.propTypes = {
	  value: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  maxLength: _propTypes2.default.number,
	  inputSize: _propTypes2.default.func,
	  onChange: _propTypes2.default.func.isRequired,
	
	  disabled: _propTypes4.default.disabled,
	  readOnly: _propTypes4.default.readOnly
	}, _temp);
	exports.default = MultiselectInput;
	module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _widgetHelpers = __webpack_require__(847);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _interaction = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = (0, _createReactClass2.default)({
	  displayName: 'MultiselectTagList',
	
	
	  mixins: [__webpack_require__(856), __webpack_require__(850)()],
	
	  propTypes: {
	    value: _propTypes2.default.array,
	    focused: _propTypes2.default.number,
	
	    valueField: _propTypes2.default.string,
	    textField: _propTypes4.default.accessor,
	
	    onDelete: _propTypes2.default.func.isRequired,
	    valueComponent: _propTypes2.default.func,
	
	    disabled: _propTypes4.default.disabled.acceptsArray,
	    readOnly: _propTypes4.default.readOnly.acceptsArray
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      ariaActiveDescendantKey: 'taglist'
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var focused = this.props.focused,
	        activeId = optionId((0, _widgetHelpers.instanceId)(this), focused);
	
	
	    this.ariaActiveDescendant(focused == null || (0, _interaction.isDisabledItem)(focused, this.props) ? null : activeId);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        focused = _props.focused,
	        value = _props.value,
	        textField = _props.textField,
	        ValueComponent = _props.valueComponent;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, props, {
	        role: 'listbox',
	        tabIndex: '-1',
	        className: 'rw-multiselect-taglist'
	      }),
	      value.map(function (item, i) {
	        var isDisabled = (0, _interaction.isDisabledItem)(item, _this.props),
	            isReadonly = (0, _interaction.isReadOnlyItem)(item, _this.props),
	            isFocused = !isDisabled && focused === i,
	            currentID = optionId(id, i);
	
	        return _react2.default.createElement(
	          'li',
	          {
	            key: i,
	            id: currentID,
	            tabIndex: '-1',
	            role: 'option',
	            className: (0, _classnames2.default)({
	              'rw-state-focus': isFocused,
	              'rw-state-disabled': isDisabled,
	              'rw-state-readonly': isReadonly
	            })
	          },
	          ValueComponent ? _react2.default.createElement(ValueComponent, { item: item }) : (0, _dataHelpers.dataText)(item, textField),
	          _react2.default.createElement(
	            'span',
	            {
	              tabIndex: '-1',
	              onClick: !(isDisabled || isReadonly) ? _this._delete.bind(null, item) : undefined,
	              'aria-disabled': isDisabled,
	              'aria-label': 'Unselect',
	              disabled: isDisabled
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'rw-tag-btn', 'aria-hidden': 'true' },
	              '\xD7'
	            )
	          )
	        );
	      })
	    );
	  },
	  _delete: function _delete(val) {
	    this.props.onDelete(val);
	  },
	  remove: function remove(idx) {
	    var val = this.props.value[idx];
	
	    if (val && !((0, _interaction.isDisabledItem)(val, this.props) || (0, _interaction.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
	  },
	  removeNext: function removeNext() {
	    var val = this.props.value[this.props.value.length - 1];
	
	    if (val && !((0, _interaction.isDisabledItem)(val, this.props) || (0, _interaction.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
	  },
	  clear: function clear() {
	    this.setState({ focused: null });
	  },
	  first: function first() {
	    var idx = 0,
	        value = this.props.value,
	        l = value.length;
	
	    while (idx < l && (0, _interaction.isDisabledItem)(value[idx], this.props)) {
	      idx++;
	    }return idx !== l ? idx : null;
	  },
	  last: function last() {
	    var value = this.props.value,
	        idx = value.length - 1;
	
	    while (idx > -1 && (0, _interaction.isDisabledItem)(value[idx], this.props)) {
	      idx--;
	    }return idx >= 0 ? idx : null;
	  },
	  next: function next(current) {
	    var nextIdx = current + 1,
	        value = this.props.value,
	        l = value.length;
	
	    while (nextIdx < l && (0, _interaction.isDisabledItem)(nextIdx, this.props)) {
	      nextIdx++;
	    }if (current === null || nextIdx >= l) return null;
	
	    return nextIdx;
	  },
	  prev: function prev(current) {
	    var nextIdx = current,
	        value = this.props.value;
	
	    if (nextIdx === null || nextIdx === 0) nextIdx = value.length;
	
	    nextIdx--;
	
	    while (nextIdx > -1 && (0, _interaction.isDisabledItem)(value[nextIdx], this.props)) {
	      nextIdx--;
	    }return nextIdx >= 0 ? nextIdx : null;
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _desc, _value, _obj;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(828);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _2 = __webpack_require__(826);
	
	var _3 = _interopRequireDefault(_2);
	
	var _classnames = __webpack_require__(401);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uncontrollable = __webpack_require__(521);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _compat = __webpack_require__(844);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes3 = __webpack_require__(837);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(845);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(851);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _ListOption = __webpack_require__(846);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _Widget = __webpack_require__(832);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _validateListInterface = __webpack_require__(853);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _scrollTo2 = __webpack_require__(859);
	
	var _scrollTo3 = _interopRequireDefault(_scrollTo2);
	
	var _dataHelpers = __webpack_require__(839);
	
	var _interaction = __webpack_require__(848);
	
	var _widgetHelpers = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var find = _3.default.find;
	
	
	var propTypes = {
	
	  data: _propTypes2.default.array,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.array]),
	  onChange: _propTypes2.default.func,
	  onMove: _propTypes2.default.func,
	
	  multiple: _propTypes2.default.bool,
	
	  itemComponent: _propTypes4.default.elementType,
	  listComponent: _propTypes4.default.elementType,
	
	  valueField: _propTypes2.default.string,
	  textField: _propTypes4.default.accessor,
	
	  busy: _propTypes2.default.bool,
	
	  filter: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	
	  disabled: _propTypes4.default.disabled.acceptsArray,
	  readOnly: _propTypes4.default.readOnly.acceptsArray,
	
	  messages: _propTypes2.default.shape({
	    emptyList: _propTypes2.default.string
	  })
	};
	
	function getFirstValue(props) {
	  var data = props.data,
	      value = props.value,
	      valueField = props.valueField;
	
	  value = _3.default.splat(value);
	
	  if (value.length) return find(data, function (d) {
	    return (0, _dataHelpers.dataIndexOf)(value, d, valueField) !== -1;
	  }) || null;
	
	  return null;
	}
	
	var SelectList = (0, _createReactClass2.default)((_obj = {
	  displayName: 'SelectList',
	
	
	  propTypes: propTypes,
	
	  mixins: [__webpack_require__(854), __webpack_require__(855), __webpack_require__(863), __webpack_require__(850)(), __webpack_require__(864)({
	    didHandle: function didHandle(focused) {
	      // the rigamarole here is to avoid flicker went clicking an item and
	      // gaining focus at the same time.
	      if (focused !== this.state.focused) {
	        if (!focused) this.setState({ focusedItem: null });else if (focused && !this._clicking) this.setState({
	          focusedItem: getFirstValue(this.props)
	        });
	        this._clicking = false;
	      }
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      delay: 250,
	      value: [],
	      data: [],
	      ariaActiveDescendantKey: 'selectlist',
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  getDefaultState: function getDefaultState(props) {
	    var data = props.data,
	        value = props.value,
	        valueField = props.valueField,
	        multiple = props.multiple;
	
	
	    return {
	      dataItems: multiple && _3.default.splat(value).map(function (item) {
	        return (0, _dataHelpers.dataItem)(data, item, valueField);
	      })
	    };
	  },
	  getInitialState: function getInitialState() {
	    var state = this.getDefaultState(this.props);
	
	    state.ListItem = getListItem(this);
	
	    return state;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    return this.setState(this.getDefaultState(nextProps));
	  },
	  componentDidMount: function componentDidMount() {
	    (0, _validateListInterface2.default)(this.refs.list);
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        tabIndex = _props.tabIndex,
	        busy = _props.busy,
	        groupBy = _props.groupBy,
	        List = _props.listComponent;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	    var listProps = _3.default.pickProps(this.props, List);
	
	    var _state = this.state,
	        ListItem = _state.ListItem,
	        focusedItem = _state.focusedItem,
	        focused = _state.focused;
	
	
	    var items = this._data();
	
	    focusedItem = focused && !(0, _interaction.isDisabled)(this.props) && !(0, _interaction.isReadOnly)(this.props) && focusedItem;
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress,
	        disabled: (0, _interaction.isDisabled)(this.props),
	        readOnly: (0, _interaction.isReadOnly)(this.props),
	        role: 'radiogroup',
	        'aria-busy': !!busy,
	        className: (0, _classnames2.default)(className, 'rw-selectlist', busy && 'rw-loading-mask')
	      }),
	      _react2.default.createElement(List, _extends({}, listProps, {
	        ref: 'list',
	        role: 'radiogroup',
	        tabIndex: tabIndex || '0',
	        id: (0, _widgetHelpers.instanceId)(this, '_listbox'),
	        data: items,
	        focused: focusedItem,
	        optionComponent: ListItem,
	        itemComponent: this.props.itemComponent,
	        onMove: this._scrollTo
	      }))
	    );
	  },
	  _scrollTo: function _scrollTo(selected, list) {
	    var handler = this.props.onMove;
	
	    if (handler) handler(selected, list);else {
	      this._scrollCancel && this._scrollCancel();
	      // default behavior is to scroll the whole page not just the widget
	      this._scrollCancel = (0, _scrollTo3.default)(selected);
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _this = this;
	
	    var key = e.key,
	        _props2 = this.props,
	        valueField = _props2.valueField,
	        multiple = _props2.multiple,
	        list = this.refs.list,
	        focusedItem = this.state.focusedItem;
	
	
	    var change = function change(item) {
	      if (item) _this.handleChange(item, multiple ? !(0, _interaction.contains)(item, _this._values(), valueField) // toggle value
	      : true);
	    };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      e.preventDefault();
	      focusedItem = list.last();
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'Home') {
	      e.preventDefault();
	      focusedItem = list.first();
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'Enter' || key === ' ') {
	      e.preventDefault();
	      change(focusedItem);
	    } else if (key === 'ArrowDown' || key === 'ArrowRight') {
	      e.preventDefault();
	      focusedItem = list.next(focusedItem);
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
	      e.preventDefault();
	      focusedItem = list.prev(focusedItem);
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (multiple && e.keyCode === 65 && e.ctrlKey) {
	      e.preventDefault();
	      this.selectAll();
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    this.search(String.fromCharCode(e.which));
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this.refs.list).focus();
	  },
	  selectAll: function selectAll() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        disabled = _props3.disabled,
	        readOnly = _props3.readOnly,
	        valueField = _props3.valueField,
	        values = this.state.dataItems,
	        data = this._data(),
	        blacklist;
	
	    disabled = disabled || readOnly;
	    disabled = Array.isArray(disabled) ? disabled : [];
	    //disabled values that are not selected
	    blacklist = disabled.filter(function (v) {
	      return !(0, _interaction.contains)(v, values, valueField);
	    });
	    data = data.filter(function (v) {
	      return !(0, _interaction.contains)(v, blacklist, valueField);
	    });
	
	    if (data.length === values.length) {
	      data = disabled.filter(function (item) {
	        return (0, _interaction.contains)(item, values, valueField);
	      });
	      data = data.map(function (item) {
	        return (0, _dataHelpers.dataItem)(_this2._data(), item, valueField);
	      });
	    }
	
	    (0, _widgetHelpers.notify)(this.props.onChange, [data]);
	  },
	  handleChange: function handleChange(item, checked) {
	    var multiple = this.props.multiple,
	        values = this.state.dataItems;
	
	
	    multiple = !!multiple;
	
	    this.clearTimeout('focusedItem');
	    this.setState({ focusedItem: item });
	
	    if (!multiple) return (0, _widgetHelpers.notify)(this.props.onChange, checked ? item : null);
	
	    values = checked ? values.concat(item) : values.filter(function (v) {
	      return v !== item;
	    });
	
	    (0, _widgetHelpers.notify)(this.props.onChange, [values || []]);
	  },
	  search: function search(character) {
	    var _this3 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase(),
	        list = this.refs.list,
	        multiple = this.props.multiple;
	
	    if (!character) return;
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var focusedItem = list.next(_this3.state.focusedItem, word);
	
	      _this3._searchTerm = '';
	
	      if (focusedItem) {
	        !multiple ? _this3.handleChange(focusedItem, true) : _this3.setState({ focusedItem: focusedItem });
	      }
	    }, this.props.delay);
	  },
	  _data: function _data() {
	    return this.props.data;
	  },
	  _values: function _values() {
	    return this.props.multiple ? this.state.dataItems : this.props.value;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj)), _obj));
	
	function getListItem(parent) {
	
	  return (0, _createReactClass2.default)({
	
	    displayName: 'SelectItem',
	
	    handleChange: function handleChange(e) {
	      var _props4 = this.props,
	          disabled = _props4.disabled,
	          readonly = _props4.readonly,
	          dataItem = _props4.dataItem;
	
	
	      if (!disabled && !readonly) parent.handleChange(dataItem, e.target.checked);
	    },
	    handleMouseDown: function handleMouseDown() {
	      parent._clicking = true;
	    },
	    render: function render() {
	      var _props5 = this.props,
	          children = _props5.children,
	          disabled = _props5.disabled,
	          readonly = _props5.readonly,
	          item = _props5.dataItem;
	      var _parent$props = parent.props,
	          multiple = _parent$props.multiple,
	          _parent$props$name = _parent$props.name,
	          name = _parent$props$name === undefined ? (0, _widgetHelpers.instanceId)(parent, '_name') : _parent$props$name;
	
	
	      var checked = (0, _interaction.contains)(item, parent._values(), parent.props.valueField),
	          type = multiple ? 'checkbox' : 'radio';
	
	      return _react2.default.createElement(
	        _ListOption2.default,
	        _extends({}, this.props, {
	          role: type,
	          'aria-checked': !!checked
	        }),
	        _react2.default.createElement(
	          'label',
	          { onMouseDown: this.handleMouseDown },
	          _react2.default.createElement('input', {
	            name: name,
	            type: type,
	            tabIndex: '-1',
	            role: 'presentation',
	            checked: checked,
	            disabled: disabled || readonly,
	            onChange: this.handleChange
	          }),
	          children
	        )
	      );
	    }
	  });
	}
	
	exports.default = (0, _uncontrollable2.default)(SelectList, { value: 'onChange' }, ['selectAll', 'focus']);
	module.exports = exports['default'];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var mixed = __webpack_require__(894),
	    bool = __webpack_require__(902),
	    Ref = __webpack_require__(900),
	    Lazy = __webpack_require__(903);
	
	var isSchema = function isSchema(schema) {
	  return schema && !!schema.__isYupSchema__;
	};
	
	module.exports = {
	  mixed: mixed,
	  string: __webpack_require__(904),
	  number: __webpack_require__(905),
	  boolean: bool,
	  bool: bool,
	  date: __webpack_require__(906),
	  object: __webpack_require__(908),
	  array: __webpack_require__(913),
	
	  reach: __webpack_require__(762),
	
	  ValidationError: __webpack_require__(770),
	  ref: function ref(key, options) {
	    return new Ref(key, options);
	  },
	  lazy: function lazy(fn) {
	    return new Lazy(fn);
	  },
	
	  isSchema: isSchema,
	
	  addMethod: function addMethod(schemaType, name, fn) {
	    if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
	
	    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
	    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
	
	    schemaType.prototype[name] = fn;
	  }
	};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Promise = __webpack_require__(765),
	    Condition = __webpack_require__(895),
	    locale = __webpack_require__(896).mixed,
	    _ = __webpack_require__(764),
	    isAbsent = __webpack_require__(897),
	    cloneDeep = __webpack_require__(898),
	    createValidation = __webpack_require__(899),
	    BadSet = __webpack_require__(901),
	    Ref = __webpack_require__(900);
	
	var notEmpty = function notEmpty(value) {
	  return !isAbsent(value);
	};
	
	function runValidations(validations, endEarly, value, path) {
	  return endEarly ? Promise.all(validations) : _.collectErrors({ validations: validations, value: value, path: path });
	}
	
	function extractTestParams(name, message, test, useCallback) {
	  var opts = name;
	
	  if (typeof message === 'function') test = message, message = locale.default, name = null;
	
	  if (typeof name === 'function') test = name, message = locale.default, name = null;
	
	  if (typeof name === 'string' || name === null) opts = { name: name, test: test, message: message, useCallback: useCallback, exclusive: false };
	
	  if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
	
	  return opts;
	}
	
	module.exports = SchemaType;
	
	function SchemaType() {
	  var _this = this;
	
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (!(this instanceof SchemaType)) return new SchemaType();
	
	  this._deps = [];
	  this._conditions = [];
	  this._options = { abortEarly: true, recursive: true };
	  this._exclusive = Object.create(null);
	  this._whitelist = new BadSet();
	  this._blacklist = new BadSet();
	  this.tests = [];
	  this.transforms = [];
	
	  this.withMutation(function () {
	    _this.typeError(locale.notType);
	  });
	
	  if (_.has(options, 'default')) this._defaultDefault = options.default;
	
	  this._type = options.type || 'mixed';
	}
	
	SchemaType.prototype = {
	
	  __isYupSchema__: true,
	
	  constructor: SchemaType,
	
	  clone: function clone() {
	    if (this._mutate) return this;
	
	    return cloneDeep(this);
	  },
	  label: function label(_label) {
	    var next = this.clone();
	    next._label = _label;
	    return next;
	  },
	  meta: function meta(obj) {
	    if (arguments.length === 0) return this._meta;
	
	    var next = this.clone();
	    next._meta = _extends(next._meta || {}, obj);
	    return next;
	  },
	  withMutation: function withMutation(fn) {
	    this._mutate = true;
	    var result = fn(this);
	    this._mutate = false;
	    return result;
	  },
	  concat: function concat(schema) {
	    if (!schema) return this;
	
	    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError('You cannot `concat()` schema\'s of different types: ' + this._type + ' and ' + schema._type);
	    var cloned = this.clone();
	    var next = _.merge(this.clone(), schema.clone());
	
	    // undefined isn't merged over, but is a valid value for default
	    if (schema._default === undefined && _.has(this, '_default')) next._default = schema._default;
	
	    next.tests = cloned.tests;
	    next._exclusive = cloned._exclusive;
	
	    // manually add the new tests to ensure
	    // the deduping logic is consistent
	    schema.tests.forEach(function (fn) {
	      next = next.test(fn.TEST);
	    });
	
	    next._type = schema._type;
	
	    return next;
	  },
	  isType: function isType(v) {
	    if (this._nullable && v === null) return true;
	    return !this._typeCheck || this._typeCheck(v);
	  },
	  resolve: function resolve(_ref) {
	    var context = _ref.context;
	    var parent = _ref.parent;
	
	    if (this._conditions.length) {
	      return this._conditions.reduce(function (schema, match) {
	        return match.resolve(schema, match.getValue(parent, context));
	      }, this);
	    }
	
	    return this;
	  },
	  cast: function cast(value) {
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var schema = this.resolve(opts);
	
	    return schema._cast(value, opts);
	  },
	  _cast: function _cast(_value) {
	    var _this2 = this;
	
	    var value = _value === undefined ? _value : this.transforms.reduce(function (value, transform) {
	      return transform.call(_this2, value, _value);
	    }, _value);
	
	    if (value === undefined && _.has(this, '_default')) {
	      value = this.default();
	    }
	
	    return value;
	  },
	  validate: function validate(value) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var cb = arguments[2];
	
	    if (typeof options === 'function') cb = options, options = {};
	
	    var schema = this.resolve(options);
	
	    return nodeify(schema._validate(value, options), cb);
	  },
	
	
	  //-- tests
	  _validate: function _validate(_value) {
	    var _this3 = this;
	
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var value = _value,
	        schema = void 0,
	        endEarly = void 0,
	        isStrict = void 0;
	
	    schema = this;
	    isStrict = this._option('strict', options);
	    endEarly = this._option('abortEarly', options);
	
	    var path = options.path;
	    var label = this._label;
	
	    if (!isStrict) {
	      value = this._cast(value, options, options);
	    }
	    // value is cast, we can check if it meets type requirements
	    var validationParams = { value: value, path: path, schema: this, options: options, label: label };
	    var initialTests = [];
	
	    if (schema._typeError) initialTests.push(this._typeError(validationParams));
	
	    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
	
	    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
	
	    return runValidations(initialTests, endEarly, value, path).then(function () {
	      return runValidations(_this3.tests.map(function (fn) {
	        return fn(validationParams);
	      }), endEarly, value, path);
	    }).then(function () {
	      return value;
	    });
	  },
	  isValid: function isValid(value, options, cb) {
	    if (typeof options === 'function') cb = options, options = {};
	
	    return nodeify(this.validate(value, options).then(function () {
	      return true;
	    }).catch(function (err) {
	      if (err.name === 'ValidationError') return false;
	
	      throw err;
	    }), cb);
	  },
	  getDefault: function getDefault(_ref2) {
	    var context = _ref2.context;
	    var parent = _ref2.parent;
	
	    return this._resolve(context, parent).default();
	  },
	  default: function _default(def) {
	    if (arguments.length === 0) {
	      var dflt = _.has(this, '_default') ? this._default : this._defaultDefault;
	      return typeof dflt === 'function' ? dflt.call(this) : cloneDeep(dflt);
	    }
	
	    var next = this.clone();
	    next._default = def;
	    return next;
	  },
	  strict: function strict() {
	    var next = this.clone();
	    next._options.strict = true;
	    return next;
	  },
	  required: function required(msg) {
	    return this.test('required', msg || locale.required, notEmpty);
	  },
	  nullable: function nullable(value) {
	    var next = this.clone();
	    next._nullable = value === false ? false : true;
	    return next;
	  },
	  transform: function transform(fn) {
	    var next = this.clone();
	    next.transforms.push(fn);
	    return next;
	  },
	
	
	  /**
	   * Adds a test function to the schema's queue of tests.
	   * tests can be exclusive or non-exclusive.
	   *
	   * - exclusive tests, will replace any existing tests of the same name.
	   * - non-exclusive: can be stacked
	   *
	   * If a non-exclusive test is added to a schema with an exclusive test of the same name
	   * the exclusive test is removed and further tests of the same name will be stacked.
	   *
	   * If an exclusive test is added to a schema with non-exclusive tests of the same name
	   * the previous tests are removed and further tests of the same name will replace each other.
	   */
	  test: function test(name, message, _test, useCallback) {
	    var opts = extractTestParams(name, message, _test, useCallback),
	        next = this.clone();
	
	    var validate = createValidation(opts);
	
	    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;
	
	    if (opts.exclusive && !opts.name) {
	      throw new TypeError('You cannot have an exclusive validation without a `name`');
	    }
	
	    next._exclusive[opts.name] = !!opts.exclusive;
	
	    next.tests = next.tests.filter(function (fn) {
	      if (fn.TEST_NAME === opts.name) {
	        if (isExclusive) return false;
	        if (fn.TEST.test === validate.TEST.test) return false;
	      }
	      return true;
	    });
	
	    next.tests.push(validate);
	
	    return next;
	  },
	  when: function when(keys, options) {
	    var next = this.clone(),
	        deps = [].concat(keys).map(function (key) {
	      return new Ref(key);
	    });
	
	    deps.forEach(function (dep) {
	      if (!dep.isContext) next._deps.push(dep.key);
	    });
	
	    next._conditions.push(new Condition(deps, options));
	
	    return next;
	  },
	  typeError: function typeError(message) {
	    var next = this.clone();
	
	    next._typeError = createValidation({
	      message: message,
	      name: 'typeError',
	      test: function test(value) {
	        if (value !== undefined && !this.schema.isType(value)) return this.createError({
	          params: {
	            type: this.schema._type
	          }
	        });
	        return true;
	      }
	    });
	    return next;
	  },
	  oneOf: function oneOf(enums) {
	    var message = arguments.length <= 1 || arguments[1] === undefined ? locale.oneOf : arguments[1];
	
	    var next = this.clone();
	
	    if (next.tests.length) throw new TypeError('Cannot specify values when there are validation rules specified');
	
	    enums.forEach(function (val) {
	      next._blacklist.delete(val);
	      next._whitelist.add(val);
	    });
	
	    next._whitelistError = createValidation({
	      message: message,
	      name: 'oneOf',
	      test: function test(value) {
	        var valids = this.schema._whitelist;
	        if (valids.length && !(value === undefined || valids.has(value))) return this.createError({
	          params: {
	            values: valids.values().join(', ')
	          }
	        });
	        return true;
	      }
	    });
	
	    return next;
	  },
	  notOneOf: function notOneOf(enums) {
	    var message = arguments.length <= 1 || arguments[1] === undefined ? locale.notOneOf : arguments[1];
	
	    var next = this.clone();
	
	    enums.forEach(function (val) {
	      next._whitelist.delete(val);
	      next._blacklist.add(val);
	    });
	
	    next._blacklistError = createValidation({
	      message: message,
	      name: 'notOneOf',
	      test: function test(value) {
	        var invalids = this.schema._blacklist;
	        if (invalids.length && invalids.has(value)) return this.createError({
	          params: {
	            values: invalids.values().join(', ')
	          }
	        });
	        return true;
	      }
	    });
	
	    return next;
	  },
	  strip: function strip() {
	    var _strip = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    var next = this.clone();
	    next._strip = _strip;
	    return next;
	  },
	  _option: function _option(key, overrides) {
	    return _.has(overrides, key) ? overrides[key] : this._options[key];
	  },
	  describe: function describe() {
	    var next = this.clone();
	
	    return {
	      type: next._type,
	      meta: next._meta,
	      label: next._label,
	      tests: next.tests.map(function (fn) {
	        return fn.TEST_NAME;
	      }, {})
	    };
	  }
	};
	
	var aliases = {
	  oneOf: ['equals', 'is'],
	  notOneOf: ['not', 'nope']
	};
	
	for (var method in aliases) {
	  if (_.has(aliases, method)) aliases[method].forEach(function (alias) {
	    return SchemaType.prototype[alias] = SchemaType.prototype[method];
	  });
	} //eslint-disable-line no-loop-func
	
	function nodeify(promise, cb) {
	  if (typeof cb !== 'function') return promise;
	
	  promise.then(function (val) {
	    return cb(null, val);
	  }, function (err) {
	    return cb(err);
	  });
	}
	
	// [{ value, exclude }]
	
	// values.every(({ value, exclude }) => {
	//   var isEql = eql(value, otherval)
	//   return (exclude && !isEql) || isEql
	// })

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(764);
	
	var transform = _require.transform;
	var has = _require.has;
	var isSchema = _require.isSchema;
	
	
	module.exports = Conditional;
	
	var Conditional = function () {
	  function Conditional(refs, options) {
	    var _this = this;
	
	    _classCallCheck(this, Conditional);
	
	    var is = options.is;
	    var then = options.then;
	    var otherwise = options.otherwise;
	
	
	    this.refs = [].concat(refs);
	
	    if (typeof options === 'function') this.fn = options;else {
	      (function () {
	        if (!has(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
	
	        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
	
	        var isFn = typeof is === 'function' ? is : function () {
	          for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	            values[_key] = arguments[_key];
	          }
	
	          return values.every(function (value) {
	            return value === is;
	          });
	        };
	
	        _this.fn = function () {
	          for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            values[_key2] = arguments[_key2];
	          }
	
	          var ctx = values.pop();
	          return isFn.apply(undefined, values) ? ctx.concat(then) : ctx.concat(otherwise);
	        };
	      })();
	    }
	  }
	
	  Conditional.prototype.getValue = function getValue(parent, context) {
	    var values = this.refs.map(function (r) {
	      return r.getValue(parent, context);
	    });
	
	    return values;
	  };
	
	  Conditional.prototype.resolve = function resolve(ctx, values) {
	    var schema = this.fn.apply(ctx, values.concat(ctx));
	
	    if (schema !== undefined && !isSchema(schema)) throw new TypeError('conditions must return a schema object');
	
	    return schema || ctx;
	  };
	
	  return Conditional;
	}();
	
	module.exports = Conditional;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  mixed: {
	    default: '${path} is invalid',
	    notType: '${path} (value: `${value}`) must be a `${type}` type',
	    required: '${path} is a required field',
	    oneOf: '${path} must be one the following values: ${values}',
	    notOneOf: '${path} must not be one the following values: ${values}'
	  },
	
	  string: {
	    required: '${path} is a required field',
	    min: '${path} must be at least ${min} characters',
	    max: '${path} must be at most ${max} characters',
	    matches: '${path} must match the following: "${regex}"',
	    email: '${path} must be a valid email',
	    url: '${path} must be a valid URL',
	    trim: '${path} must be a trimmed string',
	    lowercase: '${path} must be a lowercase string',
	    uppercase: '${path} must be a upper case string'
	  },
	
	  number: {
	    min: '${path} must be greater than or equal to ${min}',
	    max: '${path} must be less than or equal to ${max}',
	    positive: '${path} must be a positive number',
	    negative: '${path} must be a negative number',
	    integer: '${path} must be an integer'
	  },
	
	  date: {
	    min: '${path} field must be later than ${min}',
	    max: '${path} field must be at earlier than ${max}'
	  },
	
	  boolean: {},
	
	  object: {
	    noUnknown: '${path} field cannot have keys not specified in the object shape'
	  },
	
	  array: {
	    required: '${path} is a required field',
	    min: '${path} field must have at least ${min} items',
	    max: '${path} field must have less than ${max} items'
	  }
	};

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (value) {
	  return value == null;
	};

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	// Copyright (c) 2011-2014, Walmart and other contributors.
	// Copyright (c) 2011, Yahoo Inc.
	// All rights reserved. https://github.com/hapijs/hoek/blob/master/LICENSE
	
	var isSchema = function isSchema(schema) {
	  return schema && !!schema.__isYupSchema__;
	};
	
	module.exports = function clone(obj, seen) {
	  var isFirst = !seen,
	      isImmutable = isSchema(obj) && !isFirst;
	
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null || isImmutable) return obj;
	
	  // if (global.REPORT_CLONE && isFirst)
	  //   throw new Error() //console.log('clone')
	
	  seen = seen || { orig: [], copy: [] };
	
	  var lookup = seen.orig.indexOf(obj);
	
	  if (lookup !== -1) return seen.copy[lookup];
	
	  var newObj;
	  var cloneDeep = false;
	
	  if (!Array.isArray(obj)) {
	    if (obj instanceof Date) {
	      newObj = new Date(obj.getTime());
	    } else if (obj instanceof RegExp) {
	      newObj = new RegExp(obj);
	    } else {
	      var proto = Object.getPrototypeOf(obj);
	
	      if (proto !== null && !proto) {
	        newObj = obj;
	      } else {
	        newObj = Object.create(proto);
	        cloneDeep = true;
	      }
	    }
	  } else {
	    newObj = [];
	    cloneDeep = true;
	  }
	
	  seen.orig.push(obj);
	  seen.copy.push(newObj);
	
	  if (cloneDeep) {
	    var keys = Object.getOwnPropertyNames(obj);
	
	    for (var i = 0, il = keys.length; i < il; ++i) {
	      var key = keys[i];
	
	      var descriptor = Object.getOwnPropertyDescriptor(obj, key);
	
	      if (descriptor.get || descriptor.set) {
	        Object.defineProperty(newObj, key, descriptor);
	      } else {
	        newObj[key] = clone(obj[key], seen);
	      }
	    }
	  }
	
	  return newObj;
	};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Promise = __webpack_require__(765);
	var ValidationError = __webpack_require__(770);
	var Ref = __webpack_require__(900);
	
	var _require = __webpack_require__(764);
	
	var transform = _require.transform;
	
	
	var formatError = ValidationError.formatError;
	
	function resolveParams(oldParams, newParams, resolve) {
	  var start = _extends({}, oldParams, newParams);
	  return transform(start, function (obj, value, key) {
	    obj[key] = resolve(value);
	  });
	}
	
	function createErrorFactory(_ref) {
	  var value = _ref.value;
	  var label = _ref.label;
	  var resolve = _ref.resolve;
	
	  var opts = _objectWithoutProperties(_ref, ['value', 'label', 'resolve']);
	
	  return function createError() {
	    var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref2$path = _ref2.path;
	    var path = _ref2$path === undefined ? opts.path : _ref2$path;
	    var _ref2$message = _ref2.message;
	    var message = _ref2$message === undefined ? opts.message : _ref2$message;
	    var _ref2$type = _ref2.type;
	    var type = _ref2$type === undefined ? opts.name : _ref2$type;
	    var params = _ref2.params;
	
	    params = _extends({ path: path, value: value, label: label }, resolveParams(opts.params, params, resolve));
	
	    return _extends(new ValidationError(typeof message === 'string' ? formatError(message, params) : message, value, path, type), { params: params });
	  };
	}
	
	module.exports = function createValidation(options) {
	  var name = options.name;
	  var message = options.message;
	  var test = options.test;
	  var params = options.params;
	  var useCallback = options.useCallback;
	
	
	  function validate(_ref3) {
	    var value = _ref3.value;
	    var path = _ref3.path;
	    var label = _ref3.label;
	    var options = _ref3.options;
	
	    var rest = _objectWithoutProperties(_ref3, ['value', 'path', 'label', 'options']);
	
	    var parent = options.parent;
	    var resolve = function resolve(value) {
	      return Ref.isRef(value) ? value.getValue(parent, options.context) : value;
	    };
	
	    var createError = createErrorFactory({
	      message: message, path: path, value: value, params: params,
	      label: label, resolve: resolve, name: name
	    });
	
	    var ctx = _extends({ path: path, parent: parent, type: name, createError: createError, resolve: resolve, options: options }, rest);
	
	    return new Promise(function (resolve, reject) {
	      !useCallback ? resolve(test.call(ctx, value)) : test.call(ctx, value, function (err, valid) {
	        return err ? reject(err) : resolve(valid);
	      });
	    }).then(function (validOrError) {
	      if (ValidationError.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
	    });
	  }
	
	  validate.TEST_NAME = name;
	  validate.TEST_FN = test;
	  validate.TEST = options;
	
	  return validate;
	};
	
	module.exports.createErrorFactory = createErrorFactory;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getter = __webpack_require__(763).getter;
	
	var validateName = function validateName(d) {
	  if (typeof d !== 'string') throw new TypeError('ref\'s must be strings, got: ' + d);
	};
	
	var Ref = function () {
	  Ref.isRef = function isRef(value) {
	    return !!(value && (value.__isYupRef || value instanceof Ref));
	  };
	
	  function Ref(key, mapFn) {
	    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    _classCallCheck(this, Ref);
	
	    validateName(key);
	    var prefix = options.contextPrefix || '$';
	
	    if (typeof key === 'function') {
	      key = '.';
	    }
	
	    this.key = key.trim();
	    this.prefix = prefix;
	    this.isContext = this.key.indexOf(prefix) === 0;
	    this.isSelf = this.key === '.';
	
	    this.path = this.isContext ? this.key.slice(this.prefix.length) : this.key;
	    this._get = getter(this.path, true);
	    this.map = mapFn || function (value) {
	      return value;
	    };
	  }
	
	  Ref.prototype.cast = function cast(value, _ref) {
	    var parent = _ref.parent;
	    var context = _ref.context;
	
	    return this.getValue(parent, context);
	  };
	
	  Ref.prototype.getValue = function getValue(parent, context) {
	    var isContext = this.isContext;
	    var value = this._get(isContext ? context : parent || context || {});
	    return this.map(value);
	  };
	
	  return Ref;
	}();
	
	exports.default = Ref;
	
	
	Ref.prototype.__isYupRef = true;
	module.exports = exports['default'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(764);
	
	var _has = _require.has;
	
	
	module.exports = function () {
	  function BadSet() {
	    _classCallCheck(this, BadSet);
	
	    this._map = Object.create(null);
	    this._refs = Object.create(null);
	  }
	
	  BadSet.prototype.values = function values() {
	    var _this = this;
	
	    return Object.keys(this._map).map(function (v) {
	      return _this._map[v];
	    });
	  };
	
	  BadSet.prototype.add = function add(item) {
	    this._map[stringify(item)] = item;
	  };
	
	  BadSet.prototype.delete = function _delete(item) {
	    delete this._map[stringify(item)];
	  };
	
	  BadSet.prototype.has = function has(item) {
	    return _has(this._map, stringify(item));
	  };
	
	  _createClass(BadSet, [{
	    key: 'length',
	    get: function get() {
	      return Object.keys(this._map).length;
	    }
	  }]);
	
	  return BadSet;
	}();
	
	function stringify(item) {
	  return JSON.stringify(item);
	}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var MixedSchema = __webpack_require__(894),
	    inherits = __webpack_require__(764).inherits;
	
	module.exports = BooleanSchema;
	
	function BooleanSchema() {
	  var _this = this;
	
	  if (!(this instanceof BooleanSchema)) return new BooleanSchema();
	
	  MixedSchema.call(this, { type: 'boolean' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return value;
	      return (/true|1/i.test(value)
	      );
	    });
	  });
	}
	
	inherits(BooleanSchema, MixedSchema, {
	  _typeCheck: function _typeCheck(v) {
	    return typeof v === 'boolean' || (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v instanceof Boolean;
	  }
	});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(764);
	
	var isSchema = _require.isSchema;
	
	var Lazy = function () {
	  function Lazy(mapFn) {
	    _classCallCheck(this, Lazy);
	
	    this._resolve = function () {
	      var schema = mapFn.apply(undefined, arguments);
	      if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
	
	      return schema;
	    };
	  }
	
	  Lazy.prototype.resolve = function resolve(_ref) {
	    var value = _ref.value;
	
	    var rest = _objectWithoutProperties(_ref, ['value']);
	
	    return this._resolve(value, rest);
	  };
	
	  Lazy.prototype.cast = function cast(value, options) {
	    return this._resolve(value, options).cast(value, options);
	  };
	
	  Lazy.prototype.validate = function validate(value, options) {
	    return this._resolve(value, options).validate(value, options);
	  };
	
	  return Lazy;
	}();
	
	Lazy.prototype.__isYupSchema__ = true;
	
	exports.default = Lazy;
	module.exports = exports['default'];

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var MixedSchema = __webpack_require__(894);
	
	var _require = __webpack_require__(896);
	
	var mixed = _require.mixed;
	var locale = _require.string;
	var isAbsent = __webpack_require__(897);
	var inherits = __webpack_require__(764).inherits;
	
	var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	var rUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
	
	var hasLength = function hasLength(value) {
	  return !isAbsent(value) && value.length > 0;
	};
	var isTrimmed = function isTrimmed(value) {
	  return isAbsent(value) || value === value.trim();
	};
	
	module.exports = StringSchema;
	
	function StringSchema() {
	  var _this = this;
	
	  if (!(this instanceof StringSchema)) return new StringSchema();
	
	  MixedSchema.call(this, { type: 'string' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return value;
	      return value == null ? '' : value.toString ? value.toString() : '' + value;
	    });
	  });
	}
	
	inherits(StringSchema, MixedSchema, {
	  _typeCheck: function _typeCheck(value) {
	    return typeof value === 'string' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value instanceof String;
	  },
	  required: function required(msg) {
	    var next = MixedSchema.prototype.required.call(this, msg || mixed.required);
	
	    return next.test('required', msg || mixed.required, hasLength);
	  },
	  min: function min(_min, msg) {
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      message: msg || locale.min,
	      params: { min: _min },
	      test: function test(value) {
	        return isAbsent(value) || value.length >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      message: msg || locale.max,
	      params: { max: _max },
	      test: function test(value) {
	        return isAbsent(value) || value.length <= this.resolve(_max);
	      }
	    });
	  },
	  matches: function matches(regex, msg) {
	    return this.test({
	      message: msg || locale.matches,
	      params: { regex: regex },
	      test: function test(value) {
	        return isAbsent(value) || regex.test(value);
	      }
	    });
	  },
	  email: function email(msg) {
	    return this.matches(rEmail, msg || locale.email);
	  },
	  url: function url(msg) {
	    return this.matches(rUrl, msg || locale.url);
	  },
	
	
	  //-- transforms --
	  trim: function trim(msg) {
	    msg = msg || locale.trim;
	
	    return this.transform(function (val) {
	      return val != null ? val.trim() : val;
	    }).test('trim', msg, isTrimmed);
	  },
	  lowercase: function lowercase(msg) {
	    return this.transform(function (value) {
	      return !isAbsent(value) ? value.toLowerCase() : value;
	    }).test({
	      name: 'string_case',
	      exclusive: true,
	      message: msg || locale.lowercase,
	      test: function test(value) {
	        return isAbsent(value) || value === value.toLowerCase();
	      }
	    });
	  },
	  uppercase: function uppercase(msg) {
	    return this.transform(function (value) {
	      return !isAbsent(value) ? value.toUpperCase() : value;
	    }).test({
	      name: 'string_case',
	      exclusive: true,
	      message: msg || locale.uppercase,
	      test: function test(value) {
	        return isAbsent(value) || value === value.toUpperCase();
	      }
	    });
	  }
	});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var SchemaObject = __webpack_require__(894);
	var locale = __webpack_require__(896).number;
	var isAbsent = __webpack_require__(897);
	
	var _require = __webpack_require__(764);
	
	var isDate = _require.isDate;
	var inherits = _require.inherits;
	
	
	module.exports = NumberSchema;
	
	var isInteger = function isInteger(val) {
	  return isAbsent(val) || val === (val | 0);
	};
	
	function NumberSchema() {
	  var _this = this;
	
	  if (!(this instanceof NumberSchema)) return new NumberSchema();
	
	  SchemaObject.call(this, { type: 'number' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return value;
	      if (typeof value === 'boolean') return value ? 1 : 0;
	
	      return isDate(value) ? +value : parseFloat(value);
	    });
	  });
	}
	
	inherits(NumberSchema, SchemaObject, {
	  _typeCheck: function _typeCheck(v) {
	    if (typeof v === 'number' && !(v !== +v)) return true;
	    if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v instanceof Number) return true;
	
	    return false;
	  },
	  min: function min(_min, msg) {
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      params: { min: _min },
	      message: msg || locale.min,
	      test: function test(value) {
	        return isAbsent(value) || value >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      params: { max: _max },
	      message: msg || locale.max,
	      test: function test(value) {
	        return isAbsent(value) || value <= this.resolve(_max);
	      }
	    });
	  },
	  positive: function positive(msg) {
	    return this.min(0, msg || locale.positive);
	  },
	  negative: function negative(msg) {
	    return this.max(0, msg || locale.negative);
	  },
	  integer: function integer(msg) {
	    msg = msg || locale.integer;
	
	    return this.transform(function (value) {
	      return !isAbsent(value) ? value | 0 : value;
	    }).test('integer', msg, isInteger);
	  },
	  round: function round(method) {
	    var avail = ['ceil', 'floor', 'round'];
	    method = method && method.toLowerCase() || 'round';
	
	    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
	
	    return this.transform(function (value) {
	      return !isAbsent(value) ? Math[method](value) : value;
	    });
	  }
	});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MixedSchema = __webpack_require__(894);
	var isoParse = __webpack_require__(907);
	var locale = __webpack_require__(896).date;
	var isAbsent = __webpack_require__(897);
	var Ref = __webpack_require__(900);
	
	var _require = __webpack_require__(764);
	
	var isDate = _require.isDate;
	var inherits = _require.inherits;
	
	
	var invalidDate = new Date('');
	
	module.exports = DateSchema;
	
	function DateSchema() {
	  var _this = this;
	
	  if (!(this instanceof DateSchema)) return new DateSchema();
	
	  MixedSchema.call(this, { type: 'date' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return isDate(value) ? new Date(value) : value;
	
	      value = isoParse(value);
	      return value ? new Date(value) : invalidDate;
	    });
	  });
	}
	
	inherits(DateSchema, MixedSchema, {
	  _typeCheck: function _typeCheck(v) {
	    return isDate(v) && !isNaN(v.getTime());
	  },
	  min: function min(_min, msg) {
	    var limit = _min;
	
	    if (!Ref.isRef(limit)) {
	      limit = this.cast(_min);
	      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
	    }
	
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      message: msg || locale.min,
	      params: { min: _min },
	      test: function test(value) {
	        return isAbsent(value) || value >= this.resolve(limit);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    var limit = _max;
	
	    if (!Ref.isRef(limit)) {
	      limit = this.cast(_max);
	      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
	    }
	
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      message: msg || locale.max,
	      params: { max: _max },
	      test: function test(value) {
	        return isAbsent(value) || value <= this.resolve(limit);
	      }
	    });
	  }
	});

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
	 * NON-CONFORMANT EDITION.
	 * © 2011 Colin Snover <http://zetafleet.com>
	 * Released under MIT license.
	 */
	//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
	var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
	
	module.exports = function parseIsoDate(date) {
	  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
	      minutesOffset = 0,
	      timestamp,
	      struct;
	
	  if (struct = isoReg.exec(date)) {
	    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
	    for (var i = 0, k; k = numericKeys[i]; ++i) {
	      struct[k] = +struct[k] || 0;
	    } // allow undefined days and months
	    struct[2] = (+struct[2] || 1) - 1;
	    struct[3] = +struct[3] || 1;
	
	    // allow arbitrary sub-second precision beyond milliseconds
	    struct[7] = struct[7] ? +(struct[7] + "00").substr(0, 3) : 0;
	
	    // timestamps without timezone identifiers should be considered local time
	    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
	      if (struct[8] !== 'Z' && struct[9] !== undefined) {
	        minutesOffset = struct[10] * 60 + struct[11];
	
	        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
	      }
	
	      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
	    }
	  } else timestamp = Date.parse ? Date.parse(date) : NaN;
	
	  return timestamp;
	};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var MixedSchema = __webpack_require__(894);
	var Promise = __webpack_require__(765);
	var toposort = __webpack_require__(909);
	var locale = __webpack_require__(896).object;
	var split = __webpack_require__(763).split;
	var Ref = __webpack_require__(900);
	var c = __webpack_require__(910);
	var sortByFields = __webpack_require__(912);
	
	var _require = __webpack_require__(764);
	
	var isObject = _require.isObject;
	var transform = _require.transform;
	var inherits = _require.inherits;
	var collectErrors = _require.collectErrors;
	var isSchema = _require.isSchema;
	var has = _require.has;
	
	
	c.type('altCamel', function (str) {
	  var result = c.camel(str),
	      idx = str.search(/[^_]/);
	
	  return idx === 0 ? result : str.substr(0, idx) + result;
	});
	
	var scopeError = function scopeError(value) {
	  return function (err) {
	    err.value = value;
	    throw err;
	  };
	};
	
	module.exports = ObjectSchema;
	
	function ObjectSchema(spec) {
	  var _this2 = this;
	
	  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);
	
	  MixedSchema.call(this, { type: 'object', default: function _default() {
	      var _this = this;
	
	      var dft = transform(this._nodes, function (obj, key) {
	        obj[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
	      }, {});
	
	      return Object.keys(dft).length === 0 ? undefined : dft;
	    }
	  });
	
	  this.fields = Object.create(null);
	  this._nodes = [];
	  this._excludedEdges = [];
	
	  this.withMutation(function () {
	    _this2.transform(function coerce(value) {
	      if (typeof value === 'string') {
	        try {
	          value = JSON.parse(value);
	        } catch (err) {
	          value = null;
	        }
	      }
	      if (this.isType(value)) return value;
	      return null;
	    });
	
	    if (spec) _this2.shape(spec);
	  });
	}
	
	inherits(ObjectSchema, MixedSchema, {
	  _typeCheck: function _typeCheck(value) {
	    return isObject(value) || typeof value === 'function';
	  },
	  _cast: function _cast(_value) {
	    var _this3 = this;
	
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var value = MixedSchema.prototype._cast.call(this, _value, opts);
	
	    //should ignore nulls here
	    if (value === undefined) return this.default();
	
	    if (!this._typeCheck(value)) return value;
	
	    var fields = this.fields,
	        strip = this._option('stripUnknown', opts) === true,
	        extra = Object.keys(value).filter(function (v) {
	      return _this3._nodes.indexOf(v) === -1;
	    }),
	        props = this._nodes.concat(extra);
	
	    var innerOptions = _extends({}, opts, { parent: {}, __validating: false });
	
	    value = transform(props, function (obj, prop) {
	      var field = fields[prop];
	      var exists = has(value, prop);
	
	      if (field) {
	        var fieldValue = void 0;
	
	        var strict = field._options && field._options.strict;
	
	        if (field._strip === true) return;
	
	        fieldValue = !opts.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
	
	        if (fieldValue !== undefined) obj[prop] = fieldValue;
	      } else if (exists && !strip) obj[prop] = value[prop];
	    }, innerOptions.parent);
	
	    return value;
	  },
	  _validate: function _validate(_value) {
	    var _this4 = this;
	
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var errors = [],
	        endEarly,
	        recursive;
	
	    endEarly = this._option('abortEarly', opts);
	    recursive = this._option('recursive', opts);
	
	    opts = _extends({}, opts, { __validating: true });
	
	    return MixedSchema.prototype._validate.call(this, _value, opts).catch(endEarly ? null : function (err) {
	      errors.push(err);
	      return err.value;
	    }).then(function (value) {
	      if (!recursive || !isObject(value)) {
	        // only iterate though actual objects
	        if (errors.length) throw errors[0];
	        return value;
	      }
	
	      var validations = _this4._nodes.map(function (key) {
	        var path = (opts.path ? opts.path + '.' : '') + key,
	            field = _this4.fields[key],
	            innerOptions = _extends({}, opts, { key: key, path: path, parent: value });
	
	        if (field) {
	          // inner fields are always strict:
	          // 1. this isn't strict so we just cast the value leaving nested values already cast
	          // 2. this is strict in which case the nested values weren't cast either
	          innerOptions.strict = true;
	
	          if (field.validate) return field.validate(value[key], innerOptions);
	        }
	
	        return true;
	      });
	
	      validations = endEarly ? Promise.all(validations).catch(scopeError(value)) : collectErrors({ validations: validations, value: value, errors: errors,
	        path: opts.path,
	        sort: sortByFields(_this4)
	      });
	
	      return validations.then(function () {
	        return value;
	      });
	    });
	  },
	  concat: function concat(schema) {
	    var next = MixedSchema.prototype.concat.call(this, schema);
	
	    next._nodes = sortFields(next.fields, next._excludedEdges);
	
	    return next;
	  },
	  shape: function shape(schema) {
	    var excludes = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    var next = this.clone(),
	        fields = _extends(next.fields, schema);
	
	    if (!Array.isArray(excludes[0])) excludes = [excludes];
	
	    next.fields = fields;
	
	    if (excludes.length) next._excludedEdges = next._excludedEdges.concat(excludes.map(function (v) {
	      return v[0] + '-' + v[1];
	    })); // 'node-othernode'
	
	    next._nodes = sortFields(fields, next._excludedEdges);
	
	    return next;
	  },
	  from: function from(_from, to, alias) {
	    return this.transform(function (obj) {
	      var newObj = obj;
	
	      if (obj == null) return obj;
	
	      if (has(obj, _from)) {
	        newObj = transform(obj, function (o, val, key) {
	          return key !== _from && (o[key] = val);
	        }, {});
	        newObj[to] = obj[_from];
	
	        if (alias) newObj[_from] = obj[_from];
	      }
	
	      return newObj;
	    });
	  },
	  noUnknown: function noUnknown() {
	    var noAllow = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	    var message = arguments.length <= 1 || arguments[1] === undefined ? locale.noUnknown : arguments[1];
	
	    if (typeof noAllow === 'string') message = noAllow, noAllow = true;
	
	    var next = this.test({
	      name: 'noUnknown',
	      exclusive: true,
	      message: message,
	      test: function test(value) {
	        return value == null || !noAllow || unknown(this.schema, value).length === 0;
	      }
	    });
	
	    if (noAllow) next._options.stripUnknown = true;
	
	    return next;
	  },
	  camelcase: function camelcase() {
	    return this.transform(function (obj) {
	      return obj == null ? obj : transform(obj, function (newobj, val, key) {
	        return newobj[c.altCamel(key)] = val;
	      });
	    });
	  },
	  constantcase: function constantcase() {
	    return this.transform(function (obj) {
	      return obj == null ? obj : transform(obj, function (newobj, val, key) {
	        return newobj[c.constant(key)] = val;
	      });
	    });
	  }
	});
	
	function unknown(ctx, value) {
	  var known = Object.keys(ctx.fields);
	  return Object.keys(value).filter(function (key) {
	    return known.indexOf(key) === -1;
	  });
	}
	
	// ugly optimization avoiding a clone. clears default for recursive
	// cast and resets it below;
	// function tempClearDefault(schema, fn) {
	//   let hasDflt = has(schema, '_default')
	//     , dflt = schema._default;
	//
	//   fn(schema)
	//
	//   if (hasDflt) schema.default(dflt)
	//   else delete schema._default
	// }
	
	function sortFields(fields) {
	  var excludes = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	  var edges = [],
	      nodes = [];
	
	  for (var key in fields) {
	    if (has(fields, key)) {
	      var value = fields[key];
	
	      if (! ~nodes.indexOf(key)) nodes.push(key);
	
	      var addNode = function addNode(depPath) {
	        //eslint-disable-line no-loop-func
	        var node = split(depPath)[0];
	
	        if (! ~nodes.indexOf(node)) nodes.push(node);
	
	        if (! ~excludes.indexOf(key + '-' + node)) edges.push([key, node]);
	      };
	
	      if (Ref.isRef(value) && !value.isContext) addNode(value.path);else if (isSchema(value) && value._deps) value._deps.forEach(addNode);
	    }
	  }return toposort.array(nodes, edges).reverse();
	}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	
	/**
	 * Topological sorting function
	 *
	 * @param {Array} edges
	 * @returns {Array}
	 */
	
	module.exports = exports = function(edges){
	  return toposort(uniqueNodes(edges), edges)
	}
	
	exports.array = toposort
	
	function toposort(nodes, edges) {
	  var cursor = nodes.length
	    , sorted = new Array(cursor)
	    , visited = {}
	    , i = cursor
	
	  while (i--) {
	    if (!visited[i]) visit(nodes[i], i, [])
	  }
	
	  return sorted
	
	  function visit(node, i, predecessors) {
	    if(predecessors.indexOf(node) >= 0) {
	      throw new Error('Cyclic dependency: '+JSON.stringify(node))
	    }
	
	    if (visited[i]) return;
	    visited[i] = true
	
	    // outgoing edges
	    var outgoing = edges.filter(function(edge){
	      return edge[0] === node
	    })
	    if (i = outgoing.length) {
	      var preds = predecessors.concat(node)
	      do {
	        var child = outgoing[--i][1]
	        visit(child, nodes.indexOf(child), preds)
	      } while (i)
	    }
	
	    sorted[--cursor] = node
	  }
	}
	
	function uniqueNodes(arr){
	  var res = []
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i]
	    if (res.indexOf(edge[0]) < 0) res.push(edge[0])
	    if (res.indexOf(edge[1]) < 0) res.push(edge[1])
	  }
	  return res
	}


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Case - v1.6.2 - 2020-03-24
	* Copyright (c) 2020 Nathan Bubna; Licensed MIT, GPL */
	(function() {
	    "use strict";
	    var unicodes = function(s, prefix) {
	        prefix = prefix || '';
	        return s.replace(/(^|-)/g, '$1\\u'+prefix).replace(/,/g, '\\u'+prefix);
	    },
	    basicSymbols = unicodes('20-26,28-2F,3A-40,5B-60,7B-7E,A0-BF,D7,F7', '00'),
	    baseLowerCase = 'a-z'+unicodes('DF-F6,F8-FF', '00'),
	    baseUpperCase = 'A-Z'+unicodes('C0-D6,D8-DE', '00'),
	    improperInTitle = 'A|An|And|As|At|But|By|En|For|If|In|Of|On|Or|The|To|Vs?\\.?|Via',
	    regexps = function(symbols, lowers, uppers, impropers) {
	        symbols = symbols || basicSymbols;
	        lowers = lowers || baseLowerCase;
	        uppers = uppers || baseUpperCase;
	        impropers = impropers || improperInTitle;
	        return {
	            capitalize: new RegExp('(^|['+symbols+'])(['+lowers+'])', 'g'),
	            pascal: new RegExp('(^|['+symbols+'])+(['+lowers+uppers+'])', 'g'),
	            fill: new RegExp('['+symbols+']+(.|$)','g'),
	            sentence: new RegExp('(^\\s*|[\\?\\!\\.]+"?\\s+"?|,\\s+")(['+lowers+'])', 'g'),
	            improper: new RegExp('\\b('+impropers+')\\b', 'g'),
	            relax: new RegExp('([^'+uppers+'])(['+uppers+']*)(['+uppers+'])(?=[^'+uppers+']|$)', 'g'),
	            upper: new RegExp('^[^'+lowers+']+$'),
	            hole: /[^\s]\s[^\s]/,
	            apostrophe: /'/g,
	            room: new RegExp('['+symbols+']')
	        };
	    },
	    re = regexps(),
	    _ = {
	        re: re,
	        unicodes: unicodes,
	        regexps: regexps,
	        types: [],
	        up: String.prototype.toUpperCase,
	        low: String.prototype.toLowerCase,
	        cap: function(s) {
	            return _.up.call(s.charAt(0))+s.slice(1);
	        },
	        decap: function(s) {
	            return _.low.call(s.charAt(0))+s.slice(1);
	        },
	        deapostrophe: function(s) {
	            return s.replace(re.apostrophe, '');
	        },
	        fill: function(s, fill, deapostrophe) {
	            if (fill != null) {
	                s = s.replace(re.fill, function(m, next) {
	                    return next ? fill + next : '';
	                });
	            }
	            if (deapostrophe) {
	                s = _.deapostrophe(s);
	            }
	            return s;
	        },
	        prep: function(s, fill, pascal, upper) {
	            s = s == null ? '' : s + '';// force to string
	            if (!upper && re.upper.test(s)) {
	                s = _.low.call(s);
	            }
	            if (!fill && !re.hole.test(s)) {
	                var holey = _.fill(s, ' ');
	                if (re.hole.test(holey)) {
	                    s = holey;
	                }
	            }
	            if (!pascal && !re.room.test(s)) {
	                s = s.replace(re.relax, _.relax);
	            }
	            return s;
	        },
	        relax: function(m, before, acronym, caps) {
	            return before + ' ' + (acronym ? acronym+' ' : '') + caps;
	        }
	    },
	    Case = {
	        _: _,
	        of: function(s) {
	            for (var i=0,m=_.types.length; i<m; i++) {
	                if (Case[_.types[i]].apply(Case, arguments) === s){ return _.types[i]; }
	            }
	        },
	        flip: function(s) {
	            return s.replace(/\w/g, function(l) {
	                return (l == _.up.call(l) ? _.low : _.up).call(l);
	            });
	        },
	        random: function(s) {
	            return s.replace(/\w/g, function(l) {
	                return (Math.round(Math.random()) ? _.up : _.low).call(l);
	            });
	        },
	        type: function(type, fn) {
	            Case[type] = fn;
	            _.types.push(type);
	        }
	    },
	    types = {
	        lower: function(s, fill, deapostrophe) {
	            return _.fill(_.low.call(_.prep(s, fill)), fill, deapostrophe);
	        },
	        snake: function(s) {
	            return Case.lower(s, '_', true);
	        },
	        constant: function(s) {
	            return Case.upper(s, '_', true);
	        },
	        camel: function(s) {
	            return _.decap(Case.pascal(s));
	        },
	        kebab: function(s) {
	            return Case.lower(s, '-', true);
	        },
	        upper: function(s, fill, deapostrophe) {
	            return _.fill(_.up.call(_.prep(s, fill, false, true)), fill, deapostrophe);
	        },
	        capital: function(s, fill, deapostrophe) {
	            return _.fill(_.prep(s).replace(re.capitalize, function(m, border, letter) {
	                return border+_.up.call(letter);
	            }), fill, deapostrophe);
	        },
	        header: function(s) {
	            return Case.capital(s, '-', true);
	        },
	        pascal: function(s) {
	            return _.fill(_.prep(s, false, true).replace(re.pascal, function(m, border, letter) {
	                return _.up.call(letter);
	            }), '', true);
	        },
	        title: function(s) {
	            return Case.capital(s).replace(re.improper, function(small, p, i, s) {
	                return i > 0 && i < s.lastIndexOf(' ') ? _.low.call(small) : small;
	            });
	        },
	        sentence: function(s, names, abbreviations) {
	            s = Case.lower(s).replace(re.sentence, function(m, prelude, letter) {
	                return prelude + _.up.call(letter);
	            });
	            if (names) {
	                names.forEach(function(name) {
	                    s = s.replace(new RegExp('\\b'+Case.lower(name)+'\\b', "g"), _.cap);
	                });
	            }
	            if (abbreviations) {
	                abbreviations.forEach(function(abbr) {
	                    s = s.replace(new RegExp('(\\b'+Case.lower(abbr)+'\\. +)(\\w)'), function(m, abbrAndSpace, letter) {
	                        return abbrAndSpace + _.low.call(letter);
	                    });
	                });
	            }
	            return s;
	        }
	    };
	
	    // TODO: Remove "squish" in a future breaking release.
	    types.squish = types.pascal;
	    
	    // Allow import default
	    Case.default = Case;
	
	    for (var type in types) {
	        Case.type(type, types[type]);
	    }
	    // export Case (AMD, commonjs, or global)
	    var define = __webpack_require__(911);
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (typeof module === "object" && module.exports ? module.exports = Case : this.Case = Case), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	}).call(this);


/***/ }),
/* 911 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 912 */
/***/ (function(module, exports) {

	"use strict";
	
	function findIndex(arr, err) {
	  var idx = Infinity;
	  arr.some(function (key, ii) {
	    if (err.path.indexOf(key) !== -1) {
	      idx = ii;
	      return true;
	    }
	  });
	
	  return idx;
	}
	
	module.exports = function sortByFields(schema) {
	  var keys = Object.keys(schema.fields);
	  return function (a, b) {
	    return findIndex(keys, a) - findIndex(keys, b);
	  };
	};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var MixedSchema = __webpack_require__(894);
	var Promise = __webpack_require__(765);
	var isAbsent = __webpack_require__(897);
	
	var _require = __webpack_require__(896);
	
	var mixed = _require.mixed;
	var locale = _require.array;
	
	var _require2 = __webpack_require__(764);
	
	var inherits = _require2.inherits;
	var collectErrors = _require2.collectErrors;
	
	
	var scopeError = function scopeError(value) {
	  return function (err) {
	    err.value = value;
	    throw err;
	  };
	};
	
	var hasLength = function hasLength(value) {
	  return !isAbsent(value) && value.length > 0;
	};
	
	module.exports = ArraySchema;
	
	function ArraySchema(type) {
	  var _this = this;
	
	  if (!(this instanceof ArraySchema)) return new ArraySchema(type);
	
	  MixedSchema.call(this, { type: 'array' });
	
	  this._subType = null;
	
	  this.withMutation(function () {
	    _this.transform(function (values) {
	      if (typeof values === 'string') try {
	        values = JSON.parse(values);
	      } catch (err) {
	        values = null;
	      }
	
	      return this.isType(values) ? values : null;
	    });
	
	    if (type) _this.of(type);
	  });
	}
	
	inherits(ArraySchema, MixedSchema, {
	  _typeCheck: function _typeCheck(v) {
	    return Array.isArray(v);
	  },
	  _cast: function _cast(_value, _opts) {
	    var _this2 = this;
	
	    var value = MixedSchema.prototype._cast.call(this, _value, _opts);
	
	    //should ignore nulls here
	    if (!this._typeCheck(value) || !this._subType) return value;
	
	    return value.map(function (v) {
	      return _this2._subType.cast(v, _opts);
	    });
	  },
	  _validate: function _validate(_value) {
	    var _this3 = this;
	
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var errors = [],
	        subType,
	        endEarly,
	        recursive;
	
	    subType = this._subType;
	    endEarly = this._option('abortEarly', options);
	    recursive = this._option('recursive', options);
	
	    return MixedSchema.prototype._validate.call(this, _value, options).catch(endEarly ? null : function (err) {
	      errors = err;
	      return err.value;
	    }).then(function (value) {
	      if (!recursive || !subType || !_this3._typeCheck(value)) {
	        if (errors.length) throw errors[0];
	        return value;
	      }
	
	      var validations = value.map(function (item, key) {
	        var path = (options.path || '') + '[' + key + ']';
	
	        // object._validate note for isStrict explanation
	        var innerOptions = _extends({}, options, { path: path, key: key, strict: true, parent: value });
	
	        if (subType.validate) return subType.validate(item, innerOptions);
	
	        return true;
	      });
	
	      validations = endEarly ? Promise.all(validations).catch(scopeError(value)) : collectErrors({ validations: validations, value: value, errors: errors, path: options.path });
	
	      return validations.then(function () {
	        return value;
	      });
	    });
	  },
	  of: function of(schema) {
	    var next = this.clone();
	    next._subType = schema;
	    return next;
	  },
	  required: function required(msg) {
	    var next = MixedSchema.prototype.required.call(this, msg || mixed.required);
	
	    return next.test('required', msg || mixed.required, hasLength);
	  },
	  min: function min(_min, message) {
	    message = message || locale.min;
	
	    return this.test({
	      message: message,
	      name: 'min',
	      exclusive: true,
	      params: { min: _min },
	      test: function test(value) {
	        return isAbsent(value) || value.length >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, message) {
	    message = message || locale.max;
	    return this.test({
	      message: message,
	      name: 'max',
	      exclusive: true,
	      params: { max: _max },
	      test: function test(value) {
	        return isAbsent(value) || value.length <= this.resolve(_max);
	      }
	    });
	  },
	  ensure: function ensure() {
	    return this.default([]).transform(function (val) {
	      return val == null ? [] : [].concat(val);
	    });
	  },
	  compact: function compact(rejector) {
	    var reject = !rejector ? function (v) {
	      return !!v;
	    } : function (v, i, a) {
	      return !rejector(v, i, a);
	    };
	
	    return this.transform(function (values) {
	      return values != null ? values.filter(reject) : values;
	    });
	  }
	});

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form__control-label":"FormularioUsuario__form__control-label___1LJFS","form__footer":"FormularioUsuario__form__footer___158i7","form__message-error":"FormularioUsuario__form__message-error___1ucTe","form__field--error":"FormularioUsuario__form__field--error___1zatt"};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (moment) {
	  if (typeof moment !== 'function') throw new TypeError('You must provide a valid moment object');
	
	  var localField = typeof moment().locale === 'function' ? 'locale' : 'lang',
	      hasLocaleData = !!moment.localeData;
	
	  if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');
	
	  function getMoment(culture, value, format) {
	    return culture ? moment(value, format)[localField](culture) : moment(value, format);
	  }
	
	  function endOfDecade(date) {
	    return moment(date).add(10, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  function endOfCentury(date) {
	    return moment(date).add(100, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  var localizer = {
	    formats: {
	      date: 'L',
	      time: 'LT',
	      default: 'lll',
	      header: 'MMMM YYYY',
	      footer: 'LL',
	      weekday: 'dd',
	      dayOfMonth: 'DD',
	      month: 'MMM',
	      year: 'YYYY',
	
	      decade: function decade(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
	      },
	      century: function century(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
	      }
	    },
	
	    firstOfWeek: function firstOfWeek(culture) {
	      return moment.localeData(culture).firstDayOfWeek();
	    },
	    parse: function parse(value, format, culture) {
	      if (!value) return null;
	      var m = getMoment(culture, value, format);
	      if (m.isValid()) return m.toDate();
	      return null;
	    },
	    format: function format(value, _format, culture) {
	      return getMoment(culture, value).format(_format);
	    }
	  };
	
	  _configure2.default.setDateLocalizer(localizer);
	
	  return localizer;
	};
	
	var _configure = __webpack_require__(810);
	
	var _configure2 = _interopRequireDefault(_configure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelDatos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelDatos = __webpack_require__(917);
	
	var css = _interopRequireWildcard(_PanelDatos);
	
	var _Modales = __webpack_require__(918);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librearias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Modulos
	
	// Modales
	
	var PanelDatos = exports.PanelDatos = function (_React$Component) {
	    _inherits(PanelDatos, _React$Component);
	
	    function PanelDatos(props) {
	        _classCallCheck(this, PanelDatos);
	
	        var _this = _possibleConstructorReturn(this, (PanelDatos.__proto__ || Object.getPrototypeOf(PanelDatos)).call(this, props));
	
	        _this.state = {
	            editandoCorreo: false
	        };
	        _this.onClick_editarEmail = function (evt) {
	            console.log(evt);
	            _this.setState({
	                editandoCorreo: true
	            }, function () {
	                _this.refInputEmail.focus();
	            });
	        };
	        _this.finalizarEdicionEmail = function () {
	            _this.context.editarEmailContacto(_this.refInputEmail.value);
	            _this.setState({
	                editandoCorreo: false
	            });
	        };
	        _this.onKeyPress_editarEmail = function (evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                _this.finalizarEdicionEmail();
	            }
	        };
	        _this.disminuirDotacion = function () {
	            var nuevaDotacion = _this.props.nomina.dotacionOperadores - 1;
	            _this.context.cambioDotacion(nuevaDotacion);
	        };
	        _this.aumentarDotacion = function () {
	            var nuevaDotacion = _this.props.nomina.dotacionOperadores + 1;
	            _this.context.cambioDotacion(nuevaDotacion);
	        };
	        return _this;
	    }
	
	    _createClass(PanelDatos, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading ' + css.panelDatos_heading },
	                            'Inventario'
	                        ),
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-compact table-striped ' + css.tablaDatos },
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Cliente'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.cliente_nombreCorto
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Local'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        '(',
	                                        this.props.nomina.local_numero,
	                                        ') ',
	                                        this.props.nomina.local_nombre
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Fecha programada'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.inv_fechaProgramadaF
	                                    )
	                                ),
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Hr. llegada lider'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.horaPresentacionLiderF
	                                    )
	                                ) : _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Inicio Proceso'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.horaPresentacionLiderF
	                                    )
	                                ),
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Hr. llegada equipo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.horaPresentacionEquipoF
	                                    )
	                                ) : null,
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Operadores'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.idEstadoNomina === 2 && (this.props.disminuirDotacion || this.props.cambiarDotacion) ? _react2.default.createElement(
	                                            'span',
	                                            { className: "glyphicon glyphicon-minus " + css.disminuir, 'aria-hidden': 'true', onClick: function onClick() {
	                                                    return _this2.disminuirDotacion();
	                                                }, title: 'Disminuir Dotaci\xF3n' },
	                                            ' '
	                                        ) : null,
	                                        this.props.nomina.dotacionOperadores,
	                                        this.props.nomina.idEstadoNomina === 2 && this.props.cambiarDotacion ? _react2.default.createElement(
	                                            'span',
	                                            { className: "glyphicon glyphicon-plus " + css.aumentar, 'aria-hidden': 'true', onClick: function onClick() {
	                                                    return _this2.aumentarDotacion();
	                                                }, title: 'Aumentar Dotaci\xF3n' },
	                                            ' '
	                                        ) : null
	                                    )
	                                ) : null,
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Total'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.dotacionTotal
	                                    )
	                                ) : null
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading ' + css.panelDatos_heading },
	                            'Local'
	                        ),
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-compact ' + css.tablaDatos },
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Direcci\xF3n'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_direccion
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Comuna'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_comuna
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Regi\xF3n'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_region
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Formato'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_formato
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Horario'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Apertura: ',
	                                        this.props.nomina.local_horaAperturaF,
	                                        '  Cierre: ',
	                                        this.props.nomina.local_horaCierreF
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Tel\xE9fonos'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_telefono1,
	                                        ' ',
	                                        this.props.nomina.local_telefono2
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Correo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.state.editandoCorreo ? _react2.default.createElement('input', { type: 'text', className: css.inputEmail, ref: function ref(_ref) {
	                                                return _this2.refInputEmail = _ref;
	                                            },
	                                            defaultValue: this.props.nomina.local_emailContacto,
	                                            onBlur: this.finalizarEdicionEmail.bind(this),
	                                            onKeyPress: this.onKeyPress_editarEmail
	                                        }) : _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            this.props.nomina.local_emailContacto,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#', onClick: this.onClick_editarEmail.bind(this) },
	                                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit pull-right' })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading ' + css.panelDatos_heading },
	                            'N\xF3mina'
	                        ),
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-compact ' + css.tablaDatos },
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Turno'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.turno
	                                    )
	                                ),
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Excel'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/programacionIG/nomina/' + this.props.nomina.idNominaPublica + '/excel',
	                                                className: 'btn btn-xs' },
	                                            'Descargar'
	                                        )
	                                    )
	                                ) : null,
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Excel Cliente'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/api/nominas/clientes/' + this.props.nomina.idNominaPublica,
	                                                className: 'btn btn-xs' },
	                                            'Descargar'
	                                        )
	                                    )
	                                ) : null,
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        '1ra N\xF3mina informada'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/programacionIG/nomina/' + this.props.nomina.idNominaPublica + '/1ra-nomina',
	                                                className: 'btn btn-xs' },
	                                            'Descargar'
	                                        )
	                                    )
	                                ) : null,
	                                this.props.verTodasNominas ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'PDF'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/programacionIG/nomina/' + this.props.nomina.idNominaPublica + '/pdfLocalSIG', className: 'btn btn-xs' },
	                                            'Descargar'
	                                        )
	                                    )
	                                ) : null,
	                                this.props.verHistorialNomina && this.props.nomina.idEstadoNomina === 5 ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Planilla Cod19'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/api/covid/permission/excel-download-list?idList=' + this.props.nomina.idNomina, className: 'btn btn-xs' },
	                                            'Descargar'
	                                        )
	                                    )
	                                ) : null,
	                                this.props.verHistorialNomina ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Historial'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(BotonHistorial, {
	                                            nomina: this.props.nomina
	                                        })
	                                    )
	                                ) : null,
	                                this.props.verTodasNomina ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Ultimo env\xEDo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.lastDeliveryByEmail ? this.props.nomina.lastDeliveryByEmail.created_at : 'Nunca enviada'
	                                    )
	                                ) : null
	                            )
	                        )
	                    ),
	                    this.props.verTodasNominas ? _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading ' + css.panelDatos_heading },
	                            'Stock'
	                        ),
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-compact ' + css.tablaDatos },
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Informado'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_stock
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Fecha Stock'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_fechaStock
	                                    )
	                                ),
	                                this.props.nomina.idCliente == 1 || this.props.nomina.idCliente == 5 || this.props.nomina.idCliente == 2 || this.props.nomina.idCliente == 12 ? _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Sugerido'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        this.props.nomina.local_stock_sugerido
	                                    )
	                                ) : _react2.default.createElement('tr', null)
	                            )
	                        )
	                    ) : _react2.default.createElement('div', null)
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'col-sm-2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-primary' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading ' + css.panelDatos_heading },
	                            'Lider'
	                        ),
	                        this.props.nomina.lider && this.props.nomina.lider.imagenPerfil ? _react2.default.createElement('img', { className: "img-responsive center-block",
	                            src: '/imagenPerfil/' + this.props.nomina.lider.imagenPerfil, alt: '' }) : _react2.default.createElement(
	                            'p',
	                            null,
	                            'Sin imagen'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PanelDatos;
	}(_react2.default.Component);
	
	PanelDatos.propTypes = {
	    nomina: PropTypes.object.isRequired
	};
	PanelDatos.contextTypes = {
	    editarEmailContacto: PropTypes.func,
	    cambioDotacion: PropTypes.func
	};
	var BotonHistorial = function BotonHistorial(_ref2) {
	    var nomina = _ref2.nomina;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-xs btn-info', onClick: showModal },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
	                isVisible && _react2.default.createElement(_Modales.ModalHistorial, {
	                    hideModal: hideModal,
	                    nomina: nomina
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelDatos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panelDatos_heading":"PanelDatos__panelDatos_heading___1lJst","tablaDatos":"PanelDatos__tablaDatos___2owUO","inputEmail":"PanelDatos__inputEmail___2m8V7","disminuir":"PanelDatos__disminuir___1CTOO","aumentar":"PanelDatos__aumentar___2qpSn"};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalMasTiempo = exports.ModalPendientesRegion = exports.ModalReemplazoCaptador = exports.ModalReemplazoPorBaja = exports.ModalOperadorEscondido = exports.ModalEnrocarOperadores = exports.ModalAgregaOperador = exports.ModalHistorial = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _TablaOperario = __webpack_require__(919);
	
	var _EnrocarOperadores = __webpack_require__(923);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(924);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	var css = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Services
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_Component) {
	    _inherits(ModalTrigger, _Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react.Component);
	
	var ModalHistorial = exports.ModalHistorial = function (_Component2) {
	    _inherits(ModalHistorial, _Component2);
	
	    function ModalHistorial(props) {
	        _classCallCheck(this, ModalHistorial);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalHistorial.__proto__ || Object.getPrototypeOf(ModalHistorial)).call(this, props));
	
	        _this2.state = {
	            detalle: []
	        };
	        _this2.fetchHistorial = function () {
	            _v2.default.nomina(_this2.props.nomina.idNomina).historial().then(function (historial) {
	                _this2.setState({ detalle: historial });
	            }).catch(function (meh) {});
	        };
	        return _this2;
	    }
	
	    _createClass(ModalHistorial, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchHistorial();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalHistorialNomina'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
	                        ' Historial de n\xF3mina ',
	                        this.props.nomina.cliente_nombreCorto,
	                        ' ',
	                        this.props.nomina.local_numero
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(Historial, {
	                        detalle: this.state.detalle
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalHistorial;
	}(_react.Component);
	
	var ModalAgregaOperador = exports.ModalAgregaOperador = function (_Component3) {
	    _inherits(ModalAgregaOperador, _Component3);
	
	    function ModalAgregaOperador(props) {
	        _classCallCheck(this, ModalAgregaOperador);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalAgregaOperador.__proto__ || Object.getPrototypeOf(ModalAgregaOperador)).call(this, props));
	
	        _this3.state = {
	            operadores: [],
	            operadoresFiltrados: [],
	            busquedaRUN: '',
	            busquedaNombre: '',
	            busquedaComuna: ''
	        };
	        _this3.fetchOperadores = function () {
	            _this3.context.getOperadoresDisponibles().then(function (operadores) {
	                _this3.setState({ operadores: operadores }, _this3.filtrarUsuarios);
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this3.realizarBusqueda = function (campo, busquedaOriginal) {
	            var newState = {};
	            newState[campo] = busquedaOriginal.trim().toLowerCase();
	            _this3.setState(newState, _this3.filtrarUsuarios);
	        };
	        _this3.filtrarUsuarios = function () {
	            _this3.setState({
	                operadoresFiltrados: _this3.state.operadores.filter(function (us) {
	                    return us.RUN.indexOf(_this3.state.busquedaRUN) >= 0;
	                }).filter(function (us) {
	                    return us.nombre.toLowerCase().indexOf(_this3.state.busquedaNombre) >= 0;
	                }).filter(function (us) {
	                    return us.comuna.toLowerCase().indexOf(_this3.state.busquedaComuna) >= 0;
	                })
	            });
	        };
	        _this3.agregaOperador = function (titular, idCaptador, operarioRun) {
	            _this3.context.agregarOperador(titular, idCaptador, operarioRun);
	            _this3.props.hideModal();
	        };
	        return _this3;
	    }
	
	    _createClass(ModalAgregaOperador, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchOperadores();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalOperadoresDisponibles'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-user' }),
	                        ' Operadores Disponibles'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(_TablaOperario.TablaOperario, {
	                        operarios: this.state.operadoresFiltrados,
	                        agregaOperador: this.agregaOperador
	                        // busqueda
	                        , busquedaRUN: this.state.busquedaRUN,
	                        realizarBusquedaRUN: this.realizarBusqueda.bind(this, 'busquedaRUN'),
	                        busquedaNombre: this.state.busquedaNombre,
	                        realizarBusquedaNombre: this.realizarBusqueda.bind(this, 'busquedaNombre'),
	                        busquedaComuna: this.state.busquedaComuna,
	                        realizarBusquedaComuna: this.realizarBusqueda.bind(this, 'busquedaComuna')
	                    })
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel pull-right', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAgregaOperador;
	}(_react.Component);
	
	var ModalEnrocarOperadores = exports.ModalEnrocarOperadores = function (_React$Component) {
	    _inherits(ModalEnrocarOperadores, _React$Component);
	
	    function ModalEnrocarOperadores(props) {
	        _classCallCheck(this, ModalEnrocarOperadores);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalEnrocarOperadores.__proto__ || Object.getPrototypeOf(ModalEnrocarOperadores)).call(this, props));
	
	        _this4.state = {
	            bloqueado: false,
	            mensaje: "",
	            letra: "",
	            panelConteo: "",
	            nivelConteo: -1
	        };
	        _this4.confirmar = function () {
	            _this4.setState({ bloqueado: true });
	            var arrayT = [];
	            var arrayR = [];
	            _this4.props.titulares.forEach(function (titular) {
	                return arrayT.push(titular.id);
	            });
	            _this4.props.reemplazos.forEach(function (reemplazo) {
	                return arrayR.push(reemplazo.id);
	            });
	            _this4.props.enrocarOperadores(arrayT, arrayR);
	            _this4.props.cancelarEnroque();
	            /*.then((nomina)=>{
	                console.log('worked')
	                this.setState({bloqueado: false, nomina})
	                this.props.hideModal()
	            })
	            .catch(err=>{
	                console.error(err.data)
	            })*/
	        };
	
	        _this4.volver = function () {
	            _this4.props.hideModal();
	        };
	
	        _this4.actualizarEstadisticas = function (titulares, reemplazos) {
	            _v2.default.nomina(_this4.props.idNomina).actualizarEstadisticas(titulares, reemplazos).then(function (response) {
	                _this4.setState({
	                    panelConteo: response.panelConteo,
	                    mensaje: response.mensaje,
	                    letra: response.letra,
	                    nivelConteo: response.nivelConteo });
	                //this.props.hideModal()
	            }).catch(function (err) {
	                console.error(err.data);
	            });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalEnrocarOperadores, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.actualizarEstadisticas(this.props.titulares, this.props.reemplazos);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            //console.log(this.props.titulares)
	            if (this.props.titulares.length == this.props.reemplazos.length && this.props.titulares.length != 0) {
	                return _react2.default.createElement(
	                    _Modal2.default,
	                    { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                    _react2.default.createElement(
	                        _Modal2.default.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _Modal2.default.Title,
	                            null,
	                            'Favor confirmar el cambio de operadores'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Modal2.default.Body,
	                        null,
	                        _react2.default.createElement(_EnrocarOperadores.EnrocarOperadores
	                        //arraytitular={arraytitular}
	                        //arrayreemplazo={arrayreemplazo}
	                        , { titulares: this.props.titulares,
	                            reemplazos: this.props.reemplazos,
	                            letra: this.state.letra,
	                            panelConteo: this.state.panelConteo,
	                            enrocarOperadores: this.props.enrocarOperadores,
	                            mensaje: this.state.mensaje,
	                            sumaUnidades: this.props.sumaUnidades,
	                            stock: this.props.stock
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _Modal2.default.Footer,
	                        null,
	                        this.state.nivelConteo != -1 ? this.state.nivelConteo >= 2 ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-primary', onClick: this.confirmar, disabled: this.state.bloqueado },
	                            'Agregar'
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                { style: { textAlign: 'center', marginTop: '10px', fontSize: '20px' } },
	                                'PORCENTAJE CONTEO SUGERIDO DEBE SER MAYOR (86% HACIA ARRIBA)'
	                            ),
	                            ' ',
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-primary', onClick: this.volver, disabled: this.state.bloqueado },
	                                'VOLVER'
	                            ),
	                            ' '
	                        ) : _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-primary', style: { visibility: 'hidden' }, onClick: this.confirmar, disabled: this.state.bloqueado },
	                            'Agregar'
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    _Modal2.default,
	                    { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                    _react2.default.createElement(
	                        _Modal2.default.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _Modal2.default.Title,
	                            null,
	                            'Error al intentar enrocar operadores'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Modal2.default.Body,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            { style: { textAlign: 'center' } },
	                            'POR FAVOR DEBE SELECCIONAR LA MISMA CANTIDAD DE OPERADORES (TITULARES Y REEMPLAZOS) Y LA CANTIDAD DEBE SER MAYOR A 0'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Modal2.default.Footer,
	                        null,
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-primary', onClick: this.volver, disabled: this.state.bloqueado },
	                            'VOLVER'
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return ModalEnrocarOperadores;
	}(_react2.default.Component);
	
	var ModalOperadorEscondido = exports.ModalOperadorEscondido = function (_React$Component2) {
	    _inherits(ModalOperadorEscondido, _React$Component2);
	
	    function ModalOperadorEscondido(props) {
	        _classCallCheck(this, ModalOperadorEscondido);
	
	        var _this5 = _possibleConstructorReturn(this, (ModalOperadorEscondido.__proto__ || Object.getPrototypeOf(ModalOperadorEscondido)).call(this, props));
	
	        _this5.state = {};
	        _this5.confirmar = function () {
	            _this5.props.setEscondido(_this5.props.id);
	            _this5.props.hideModal();
	        };
	
	        _this5.volver = function () {
	            _this5.props.hideModal();
	        };
	        return _this5;
	    }
	
	    _createClass(ModalOperadorEscondido, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Operador escondido'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', fontSize: 'xl' } },
	                        '\xBFDesea mandar a ',
	                        this.props.operador,
	                        ' como operador escondido?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: this.confirmar },
	                        'Confirmar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.volver },
	                        'VOLVER'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalOperadorEscondido;
	}(_react2.default.Component);
	
	var ModalReemplazoPorBaja = exports.ModalReemplazoPorBaja = function (_React$Component3) {
	    _inherits(ModalReemplazoPorBaja, _React$Component3);
	
	    function ModalReemplazoPorBaja(props) {
	        _classCallCheck(this, ModalReemplazoPorBaja);
	
	        var _this6 = _possibleConstructorReturn(this, (ModalReemplazoPorBaja.__proto__ || Object.getPrototypeOf(ModalReemplazoPorBaja)).call(this, props));
	
	        _this6.state = {};
	        _this6.confirmar = function () {
	            _this6.props.cambiarPanel(_this6.props.id, false, _this6.props.captador);
	            _this6.props.hideModal();
	        };
	
	        _this6.volver = function () {
	            _this6.props.hideModal();
	        };
	        return _this6;
	    }
	
	    _createClass(ModalReemplazoPorBaja, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Operador de reemplazo por baja'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', fontSize: 'xl' } },
	                        '\xBFDesea de titular a ',
	                        this.props.operador,
	                        '? El operador tendr\xE1 un m\xE1ximo de 30 minutos a partir de la APROBACI\xD3N DE LA N\xD3MINA para aceptar el proceso, sino ser\xE1 quitado de titular.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: this.confirmar },
	                        'Confirmar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-danger', onClick: this.volver },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReemplazoPorBaja;
	}(_react2.default.Component);
	
	var ModalReemplazoCaptador = exports.ModalReemplazoCaptador = function (_React$Component4) {
	    _inherits(ModalReemplazoCaptador, _React$Component4);
	
	    function ModalReemplazoCaptador(props) {
	        _classCallCheck(this, ModalReemplazoCaptador);
	
	        var _this7 = _possibleConstructorReturn(this, (ModalReemplazoCaptador.__proto__ || Object.getPrototypeOf(ModalReemplazoCaptador)).call(this, props));
	
	        _this7.handleSelectChange = function (event) {
	            _this7.setState({ estadoCaptador: event.target.value });
	        };
	
	        _this7.state = {
	            estadoCaptador: null,
	            captadores: []
	        };
	        _this7.confirmar = function () {
	            _this7.props.cambiarPanel(_this7.props.id, false, _this7.state.estadoCaptador);
	            _this7.props.cambiarCaptador(_this7.props.id, _this7.state.estadoCaptador);
	            _this7.props.hideModal();
	        };
	
	        _this7.sei = function () {
	            _this7.props.cambiarPanel(_this7.props.id, false, 1);
	            _this7.props.hideModal();
	        };
	        return _this7;
	    }
	
	    _createClass(ModalReemplazoCaptador, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this8 = this;
	
	            fetch('/api/get-captadores').then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                var datos = data.filter(function (item) {
	                    return item.id != 658 && item.id != 1;
	                });
	                _this8.setState({ captadores: datos });
	            }).catch(function (error) {
	                return console.error('Error cargando captadores:', error);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalConfirmacion'), className: cx('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Captador operador'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', fontSize: 'xl' } },
	                        '\xBFDesea cambiarle el captador al operador ',
	                        this.props.operador,
	                        '?'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center', marginTop: '10px' } },
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', onChange: this.handleSelectChange, value: this.state.estadoCaptador || '', size: 6 },
	                            _react2.default.createElement(
	                                'option',
	                                { value: 0 },
	                                'Seleccione un captador'
	                            ),
	                            this.state.captadores.length > 0 ? this.state.captadores.map(function (captador) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: captador.id, value: captador.id },
	                                    captador.nombre1,
	                                    ' ',
	                                    captador.apellidoPaterno
	                                );
	                            }) : null
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: this.confirmar, disabled: !this.state.estadoCaptador || this.state.estadoCaptador == 0 },
	                        'Cambiar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-danger', onClick: this.sei },
	                        'Mantener SEI'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReemplazoCaptador;
	}(_react2.default.Component);
	
	var ModalPendientesRegion = exports.ModalPendientesRegion = function (_React$Component5) {
	    _inherits(ModalPendientesRegion, _React$Component5);
	
	    function ModalPendientesRegion(props) {
	        _classCallCheck(this, ModalPendientesRegion);
	
	        var _this9 = _possibleConstructorReturn(this, (ModalPendientesRegion.__proto__ || Object.getPrototypeOf(ModalPendientesRegion)).call(this, props));
	
	        _this9.state = {
	            data: [],
	            loading: false,
	            refresh: false
	        };
	
	        _this9.fetchData = function () {
	            _this9.setState({ loading: true });
	            _v2.default.nomina(_this9.props.idNomina).operadoresPendientesRegion().then(function (response) {
	                _this9.setState({ data: response, loading: false });
	            }).catch(function (error) {
	                console.error('Error al cargar los datos:', error);
	                _this9.setState({ loading: false });
	            });
	        };
	
	        _this9.handleRefresh = function () {
	            _this9.setState({ refresh: true });
	            _v2.default.nomina(_this9.props.idNomina).operadoresPendientesRegion().then(function (response) {
	                _this9.setState({ refresh: false, data: response });
	            }).catch(function (error) {
	                console.error('Error al cargar los datos:', error);
	                _this9.setState({ refresh: false });
	            });
	        };
	
	        _this9.pasarAReemplazo = function (idUser, idCaptador) {
	            var nuevaData = Object.values(_this9.state.data).filter(function (op) {
	                return op.id !== idUser;
	            });
	            _this9.props.cambiarDePanel(idUser, true, idCaptador, true).then(function (response) {
	                _this9.setState({ data: nuevaData });
	                _this9.props.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
	            }).catch(function (error) {
	                //console.log(error)
	                _this9.props.notificator.error("Error al agregar el operador", error.data.usuarioRUN, 4 * 1000);
	            });
	        };
	        return _this9;
	    }
	
	    _createClass(ModalPendientesRegion, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!prevProps.show && this.props.show) {
	                this.fetchData();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this10 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.show, onHide: this.props.hideModal, bsSize: 'large', dialogClassName: 'custom-modal' },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Operadores pendientes dentro de la regi\xF3n',
	                        this.state.loading ? null : _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-primary', style: { margin: '5px' }, disabled: this.state.refresh, onClick: function onClick() {
	                                    return _this10.handleRefresh();
	                                } },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-refresh' })
	                        ),
	                        this.state.refresh && "Actualizando..."
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center', marginTop: '10px', overflowY: 'auto', maxHeight: '70%' } },
	                        this.state.loading ? _react2.default.createElement(
	                            'p',
	                            { style: { fontSize: "large" } },
	                            'Cargando...'
	                        ) : _react2.default.createElement(
	                            'table',
	                            { className: 'table table-condensed', style: { overflowY: 'hidden' } },
	                            _react2.default.createElement(
	                                'thead',
	                                { style: { position: 'sticky', top: '0', backgroundColor: 'white' } },
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        '#'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'RUT'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Nombre'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Comuna'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Captador'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Exp.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Error'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Sug.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Real'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        '\xDAltimo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { textAlign: 'center' } },
	                                        'Ctto.'
	                                    ),
	                                    _react2.default.createElement('th', { style: { textAlign: 'center' } }),
	                                    _react2.default.createElement('th', { style: { textAlign: 'center' } })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                { style: { overflowY: 'hidden' } },
	                                this.state.data && Object.values(this.state.data).length > 0 ? Object.values(this.state.data).map(function (dato, index) {
	                                    var colorContrato = dato.idEstadoContrato == 2 && dato.isValido == 1 ? "rgb(95, 228, 255)" : dato.idEstadoContrato == 2 ? "rgba(98, 251, 141, 0.835)" : dato.idEstadoContrato == 1 ? "rgb(248, 87, 62)" : "rgb(252, 166, 135)";
	                                    return _react2.default.createElement(
	                                        'tr',
	                                        { style: { fontSize: '13px' }, key: index },
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'center', verticalAlign: 'middle' } },
	                                            index + 1
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'left', verticalAlign: 'middle' } },
	                                            dato.usuarioRUN + "-" + dato.usuarioDV
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'left', verticalAlign: 'middle' } },
	                                            dato.nombreCorto
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'left', verticalAlign: 'middle' } },
	                                            dato.comuna
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'left', verticalAlign: 'middle' } },
	                                            dato.captador
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'right', verticalAlign: 'middle' } },
	                                            dato.experienciaComoOperador.toLocaleString('es-CL')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'right', verticalAlign: 'middle' } },
	                                            dato.error
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'right', verticalAlign: 'middle' } },
	                                            dato.unidadesContadas.toLocaleString('es-CL')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'right', verticalAlign: 'middle' } },
	                                            dato.unidadesContadasReal.toLocaleString('es-CL')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'right', whiteSpace: 'nowrap', verticalAlign: 'middle' } },
	                                            dato.ultimo_inventario
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'center', verticalAlign: 'middle' } },
	                                            _react2.default.createElement('div', { style: { borderRadius: '50px', backgroundColor: colorContrato, textAlign: 'center', margin: 'auto', minWidth: '8px', minHeight: '12px', width: '40%' } })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { textAlign: 'center', verticalAlign: 'middle' } },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-info', title: 'Asignar a reemplazo', onClick: function onClick() {
	                                                        return _this10.pasarAReemplazo(dato.id, dato.idCaptador);
	                                                    } },
	                                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' })
	                                            )
	                                        )
	                                    );
	                                }) : _react2.default.createElement(
	                                    'tr',
	                                    { style: { padding: '6px' } },
	                                    _react2.default.createElement(
	                                        'td',
	                                        { colSpan: 13, style: { textAlign: 'center', verticalAlign: 'middle' } },
	                                        'No se encontraron registros.'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_Modal2.default.Footer, null)
	            );
	        }
	    }]);
	
	    return ModalPendientesRegion;
	}(_react2.default.Component);
	
	ModalAgregaOperador.contextTypes = {
	    getOperadoresDisponibles: _react.PropTypes.func,
	    agregarOperador: _react.PropTypes.func
	};
	
	var Historial = function Historial(_ref) {
	    var detalle = _ref.detalle;
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '40%' }, className: 'row' },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref2) {
	                var height = _ref2.height,
	                    width = _ref2.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table
	                    // general
	                    ,
	                    { height: height,
	                        width: width
	                        // headers
	                        , headerHeight: 30,
	                        headerClassName: css.headerColumn
	                        // rows
	                        , rowCount: detalle.length,
	                        rowGetter: function rowGetter(_ref3) {
	                            var index = _ref3.index;
	                            return detalle[index];
	                        },
	                        rowHeight: 30,
	                        rowClassName: function rowClassName(_ref4) {
	                            var index = _ref4.index;
	                            return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'titulo', label: 'TITULO',
	                        cellRenderer: function cellRenderer(_ref5) {
	                            var cellData = _ref5.cellData,
	                                columnData = _ref5.columnData,
	                                dataKey = _ref5.dataKey,
	                                rowData = _ref5.rowData,
	                                rowIndex = _ref5.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 210
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'texto', label: 'DESCRIPCION',
	                        cellRenderer: function cellRenderer(_ref6) {
	                            var cellData = _ref6.cellData,
	                                columnData = _ref6.columnData,
	                                dataKey = _ref6.dataKey,
	                                rowData = _ref6.rowData,
	                                rowIndex = _ref6.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 650
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'created_at', label: 'FECHA EVENTO',
	                        cellRenderer: function cellRenderer(_ref7) {
	                            var cellData = _ref7.cellData,
	                                columnData = _ref7.columnData,
	                                dataKey = _ref7.dataKey,
	                                rowData = _ref7.rowData,
	                                rowIndex = _ref7.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 200
	                    })
	                );
	            }
	        )
	    );
	};
	
	var ModalMasTiempo = exports.ModalMasTiempo = function (_React$Component6) {
	    _inherits(ModalMasTiempo, _React$Component6);
	
	    function ModalMasTiempo(props) {
	        _classCallCheck(this, ModalMasTiempo);
	
	        var _this11 = _possibleConstructorReturn(this, (ModalMasTiempo.__proto__ || Object.getPrototypeOf(ModalMasTiempo)).call(this, props));
	
	        _this11.state = {};
	        return _this11;
	    }
	
	    _createClass(ModalMasTiempo, [{
	        key: 'render',
	        value: function render() {
	            var _this12 = this;
	
	            var _props$mas_tiempo = this.props.mas_tiempo,
	                mas_tiempo = _props$mas_tiempo === undefined ? [] : _props$mas_tiempo;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                {
	                    show: true,
	                    onHide: this.props.hideModal,
	                    dialogClassName: cx('modalConfirmacion'),
	                    className: cx('modale')
	                },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Agregar M\xE1s Tiempo de Confirmaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', fontSize: '18px' } },
	                        'Seleccione la acci\xF3n para cada operador:'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: '15px' } },
	                        mas_tiempo.length === 0 ? _react2.default.createElement(
	                            'p',
	                            { style: { textAlign: "center" } },
	                            'No hay operadores disponibles.'
	                        ) : _react2.default.createElement(
	                            'ul',
	                            { className: 'list-group' },
	                            mas_tiempo.map(function (persona) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        key: persona.id,
	                                        className: 'list-group-item',
	                                        style: {
	                                            display: "flex",
	                                            justifyContent: "space-between",
	                                            alignItems: "center"
	                                        }
	                                    },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        persona.nombre
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: 'btn btn-success btn-sm',
	                                                style: { marginRight: "8px" },
	                                                onClick: function onClick() {
	                                                    return _this12.props.handleMasTiempo(persona.id, true);
	                                                }
	                                            },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-time' }),
	                                            ' 15 min.'
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: 'btn btn-danger btn-sm',
	                                                onClick: function onClick() {
	                                                    return _this12.props.handleMasTiempo(persona.id, false);
	                                                }
	                                            },
	                                            'Cancelar'
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-secondary', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalMasTiempo;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaOperario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _TablaOperario = __webpack_require__(922);
	
	var css = _interopRequireWildcard(_TablaOperario);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	var TablaOperario = exports.TablaOperario = function (_React$Component) {
	    _inherits(TablaOperario, _React$Component);
	
	    function TablaOperario() {
	        _classCallCheck(this, TablaOperario);
	
	        return _possibleConstructorReturn(this, (TablaOperario.__proto__ || Object.getPrototypeOf(TablaOperario)).apply(this, arguments));
	    }
	
	    _createClass(TablaOperario, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '65%' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table,
	                            {
	                                height: height,
	                                width: width,
	
	                                headerHeight: 30,
	                                headerClassName: css.headerColumn,
	
	                                rowCount: _this2.props.operarios.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.operarios[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowIndex = _ref4.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 25
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'RUN',
	                                label: 'RUN',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var rowData = _ref5.rowData,
	                                        dataKey = _ref5.dataKey;
	                                    return rowData[dataKey] + '-' + rowData['usuarioDV'];
	                                },
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'RUN',
	                                        busqueda: _this2.props.busquedaRUN,
	                                        realizarBusqueda: _this2.props.realizarBusquedaRUN
	                                    });
	                                },
	                                width: 80
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombre',
	                                label: 'Nombre',
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var rowData = _ref6.rowData,
	                                        dataKey = _ref6.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'nombre',
	                                        busqueda: _this2.props.busquedaNombre,
	                                        realizarBusqueda: _this2.props.realizarBusquedaNombre
	                                    });
	                                },
	                                width: 160
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'comuna',
	                                label: 'Comuna',
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var rowData = _ref7.rowData,
	                                        dataKey = _ref7.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'comuna',
	                                        busqueda: _this2.props.busquedaComuna,
	                                        realizarBusqueda: _this2.props.realizarBusquedaComuna
	                                    });
	                                },
	                                width: 80
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'telefono',
	                                label: 'Teléfono',
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var rowData = _ref8.rowData,
	                                        dataKey = _ref8.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                width: 80
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'unidadesContadas',
	                                label: 'Conteo',
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var rowData = _ref9.rowData,
	                                        dataKey = _ref9.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                width: 60
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'acciones',
	                                label: 'Agregar a dotación',
	                                cellRenderer: function cellRenderer(_ref10) {
	                                    var cellData = _ref10.cellData,
	                                        columnData = _ref10.columnData,
	                                        dataKey = _ref10.dataKey,
	                                        rowData = _ref10.rowData,
	                                        rowIndex = _ref10.rowIndex;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-6' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-xs btn-primary', onClick: function onClick() {
	                                                        return _this2.props.agregaOperador(true, rowData['idCaptador'], rowData['RUN']);
	                                                    } },
	                                                'Titular'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-6' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-xs btn-success', onClick: function onClick() {
	                                                        return _this2.props.agregaOperador(false, rowData['idCaptador'], rowData['RUN']);
	                                                    } },
	                                                'Reemplazo'
	                                            )
	                                        )
	                                    );
	                                },
	                                width: 200
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaOperario;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaOperario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HeaderConBusqueda = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderConBusqueda = __webpack_require__(921);
	
	var css = _interopRequireWildcard(_HeaderConBusqueda);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	// Styles
	
	var HeaderConBusqueda = exports.HeaderConBusqueda = function (_React$Component) {
	    _inherits(HeaderConBusqueda, _React$Component);
	
	    function HeaderConBusqueda(props) {
	        _classCallCheck(this, HeaderConBusqueda);
	
	        var _this = _possibleConstructorReturn(this, (HeaderConBusqueda.__proto__ || Object.getPrototypeOf(HeaderConBusqueda)).call(this, props));
	
	        _this.state = {
	            open: false,
	            busqueda: _this.props.busqueda
	        };
	        return _this;
	    }
	
	    _createClass(HeaderConBusqueda, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ busqueda: nextProps.busqueda });
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            // si el menu se oculta se descartan los cambios
	            if (this.state.open) this.cerrarMenu_descartarCambios();else this.setState({ open: true });
	        }
	    }, {
	        key: 'cerrarMenu_descartarCambios',
	        value: function cerrarMenu_descartarCambios() {
	            this.setState({
	                open: false,
	                busqueda: this.props.busqueda
	            });
	        }
	    }, {
	        key: 'cerrarMenu_aplicarCambios',
	        value: function cerrarMenu_aplicarCambios() {
	            // ocultar el menu e informar la actualizacion del filtro al padre
	            this.setState({ open: false, busqueda: '' });
	            this.props.realizarBusqueda(this.state.busqueda);
	        }
	
	        // Elementos seleccionados
	
	    }, {
	        key: 'destacarTriangulo',
	        value: function destacarTriangulo() {
	            return this.state.busqueda.trim() !== '';
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            this.setState({ busqueda: evt.target.value });
	        }
	    }, {
	        key: 'onKeyDownInputTexto',
	        value: function onKeyDownInputTexto(evt) {
	            if (evt.keyCode === 13) {
	                this.cerrarMenu_aplicarCambios();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: css.container,
	                    ref: function ref(_ref) {
	                        return _this2.node = _ref;
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: css.divTitulo,
	                        onClick: this.toggleMenu.bind(this) },
	                    this.props.nombre
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pull-right' },
	                    _react2.default.createElement('span', { className: (this.destacarTriangulo() ? css.filtroColoreado : '') + (this.state.open ? ' glyphicon glyphicon-triangle-top ' : ' glyphicon glyphicon-triangle-bottom '),
	                        onClick: this.toggleMenu.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: css.menu, style: { display: this.state.open ? '' : 'none' } },
	                    _react2.default.createElement('input', { type: 'text', className: css.inputTexto,
	                        placeholder: 'Buscar por...',
	                        value: this.state.busqueda,
	                        onChange: this.onInputChange.bind(this),
	                        onKeyDown: this.onKeyDownInputTexto.bind(this)
	                    }),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'btn btn-block btn-xs btn-primary',
	                            onClick: this.cerrarMenu_aplicarCambios.bind(this) },
	                        'Buscar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderConBusqueda;
	}(_react2.default.Component);
	
	HeaderConBusqueda.propTypes = {
	    nombre: PropTypes.string,
	    busqueda: PropTypes.string,
	    realizarBusqueda: PropTypes.func.isRequired
	};
	HeaderConBusqueda.defaultProps = {
	    nombre: '[sin nombre]'
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "HeaderConBusqueda.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"HeaderConBusqueda__container___3KJh5","divTitulo":"HeaderConBusqueda__divTitulo___3N-2l","menu":"HeaderConBusqueda__menu___uCBMN","inputTexto":"HeaderConBusqueda__inputTexto___1CK1y","filtroColoreado":"HeaderConBusqueda__filtroColoreado___3J53e"};

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerRow":"TablaOperario__headerRow___3rjYu","evenRow":"TablaOperario__evenRow___oBXFb","oddRow":"TablaOperario__oddRow___2d0qu","headerColumn":"TablaOperario__headerColumn___1QKOR","headerRowAPI":"TablaOperario__headerRowAPI___2qiWb","evenRowAPI":"TablaOperario__evenRowAPI___3mnVH","oddRowAPI":"TablaOperario__oddRowAPI___2CeMD","headerColumnAPI":"TablaOperario__headerColumnAPI___mzE61","celdaAPI":"TablaOperario__celdaAPI___1ak1l","celdaAPILider":"TablaOperario__celdaAPILider___38si7"};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EnrocarOperadores = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnrocarOperadores = exports.EnrocarOperadores = function (_Component) {
	    _inherits(EnrocarOperadores, _Component);
	
	    function EnrocarOperadores(props) {
	        _classCallCheck(this, EnrocarOperadores);
	
	        var _this = _possibleConstructorReturn(this, (EnrocarOperadores.__proto__ || Object.getPrototypeOf(EnrocarOperadores)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EnrocarOperadores, [{
	        key: 'render',
	        value: function render() {
	            var conteo_titular = 0;
	            var conteo_reemplazo = 0;
	            var diferencia = 0;
	            var stock_actual = this.props.stock.replace(',', '');
	            stock_actual = Math.abs(stock_actual);
	            var conteo_actual = this.props.sumaUnidades.replace(',', '');
	            this.props.titulares.map(function (suma) {
	                return conteo_titular += suma.conteo;
	            });
	            this.props.reemplazos.map(function (suma) {
	                return conteo_reemplazo += suma.conteo;
	            });
	            var conteo_total = conteo_actual - conteo_titular + conteo_reemplazo;
	            diferencia = conteo_total - stock_actual;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    { style: { textAlign: 'center', fontWeight: 'bold' } },
	                    'RESUMEN DEL ENROQUE'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6', style: { textAlign: 'center' } },
	                        'Entran a titulares',
	                        this.props.reemplazos.map(function (r, reemplazo) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: reemplazo, style: { textAlign: 'center', backgroundColor: '#33EE8B' } },
	                                r.nombre,
	                                ' - Conteo: ',
	                                r.conteo
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6', style: { textAlign: 'center' } },
	                        'Salen a reemplazo',
	                        this.props.titulares.map(function (t, titular) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: titular, style: { textAlign: 'center', backgroundColor: '#F96A6A' } },
	                                t.nombre,
	                                ' - Conteo: ',
	                                t.conteo
	                            );
	                        })
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', marginTop: '10px', fontWeight: 'bold' } },
	                        'NUEVO PORCENTAJE CONTEO SUGERIDO'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center', backgroundColor: this.props.panelConteo, color: this.props.letra } },
	                        this.props.mensaje
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            { style: { textAlign: 'center', marginTop: '10px', fontWeight: 'bold' } },
	                            'NUEVO CONTEO Y DIFERENCIA'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { textAlign: 'center' } },
	                            'Conteo: ',
	                            conteo_total.toLocaleString()
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { textAlign: 'center' } },
	                            'Diferencia: ',
	                            diferencia.toLocaleString('de-DE')
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EnrocarOperadores;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "EnrocarOperadores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modale":"modal__modale___8e7no","modalAmplio":"modal__modalAmplio___3vDwA","modalHistorialNomina":"modal__modalHistorialNomina___cUacU","modalOperadoresDisponibles":"modal__modalOperadoresDisponibles___3jSIG","headerColumn":"modal__headerColumn___2atyD","headerRow":"modal__headerRow___JrFTM","evenRow":"modal__evenRow___oOqoc","oddRow":"modal__oddRow___3ERJ4","custom-modal":"modal__custom-modal___LyrY4","modal-dialog":"modal__modal-dialog___2Qc0i"};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelEstados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Estado = __webpack_require__(926);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librearias
	
	// Modules
	
	
	var PanelEstados = exports.PanelEstados = function (_Component) {
	    _inherits(PanelEstados, _Component);
	
	    function PanelEstados() {
	        _classCallCheck(this, PanelEstados);
	
	        return _possibleConstructorReturn(this, (PanelEstados.__proto__ || Object.getPrototypeOf(PanelEstados)).apply(this, arguments));
	    }
	
	    _createClass(PanelEstados, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                idEstado = _props.idEstado,
	                tiene_gps = _props.tiene_gps;
	
	            var acciones = [];
	            if (tiene_gps) {
	                // acciones normales
	                acciones = [{
	                    texto: this.props.nominaCompleta ? 'Informar nómina por correo' : 'Revise Operadores y/o Total asignado',
	                    onclick: this.props.informarNomina,
	                    habilitado: idEstado == 4 && this.props.permisos.informar && this.props.nominaCompleta && !this.props.operadoresPendientes
	                }, {
	                    texto: 'Rechazar nómina',
	                    onclick: this.props.rechazarNomina,
	                    habilitado: idEstado == 4 && this.props.permisos.aprobar
	                }, {
	                    texto: 'Completar sin envio de correo',
	                    onclick: this.props.completarSinCorreo,
	                    habilitado: idEstado == 4 && this.props.permisos.rectificar && !this.props.operadoresPendientes,
	                    cambio_lider: this.props.cambio_lider
	                }];
	            } else {
	                // solo Agregar GPS y Rechazar nómina
	                acciones = [{
	                    texto: 'Agregar GPS',
	                    onclick: this.props.abrirModalGPS, // tu función
	                    habilitado: true
	                }, {
	                    texto: 'Rechazar nómina',
	                    onclick: this.props.rechazarNomina,
	                    habilitado: idEstado == 4 && this.props.permisos.aprobar
	                }];
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(_Estado.Estado, {
	                    titulo: 'Pendiente',
	                    descripcion: 'La n\xF3mina se encuentra pendiente',
	                    activo: idEstado == 2,
	                    acciones: [{
	                        texto: 'Enviar nómina', onclick: this.props.enviarNomina,
	                        habilitado: idEstado == 2 && this.props.permisos.enviar
	                    }]
	                }),
	                _react2.default.createElement(_Estado.Estado, {
	                    titulo: 'Recibida',
	                    descripcion: 'Dotaci\xF3n recibida por SEI',
	                    activo: idEstado == 3,
	                    acciones: [{
	                        texto: 'Aprobar nómina', onclick: this.props.aprobarNomina,
	                        habilitado: idEstado == 3 && this.props.permisos.aprobar,
	                        tooltip: true
	                    }, {
	                        texto: 'Rechazar nómina', onclick: this.props.rechazarNomina,
	                        habilitado: idEstado == 3 && this.props.permisos.aprobar
	                    }]
	                }),
	                _react2.default.createElement(_Estado.Estado, {
	                    titulo: 'Aprobada',
	                    descripcion: 'Dotaci\xF3n aprobada por SEI',
	                    activo: idEstado == 4,
	                    acciones: acciones
	                }),
	                _react2.default.createElement(_Estado.Estado, {
	                    titulo: this.props.haSidoRectificada == 1 ? "Informada (y rectificada)" : "Informada",
	                    descripcion: 'El cliente ha sido informado por correo',
	                    activo: idEstado == 5,
	                    acciones: [{
	                        texto: 'Rectificar Nómina', onclick: this.props.rectificarNomina,
	                        habilitado: idEstado == 5 && this.props.permisos.rectificar && !this.props.operadoresPendientes && this.props.rectificaSistema === 1 || idEstado == 5 && this.props.permisos.rectificarTodas
	                    }]
	                })
	            );
	        }
	    }]);
	
	    return PanelEstados;
	}(_react.Component);
	
	PanelEstados.propTypes = {
	    idEstado: _react.PropTypes.number.isRequired,
	    haSidoRectificada: _react.PropTypes.number.isRequired,
	    // Se espera que estos metodos retornen una promesa:
	    enviarNomina: _react.PropTypes.func.isRequired,
	    aprobarNomina: _react.PropTypes.func.isRequired,
	    rechazarNomina: _react.PropTypes.func.isRequired,
	    informarNomina: _react.PropTypes.func.isRequired,
	    completarSinCorreo: _react.PropTypes.func.isRequired,
	    rectificarNomina: _react.PropTypes.func.isRequired,
	    nominaCompleta: _react.PropTypes.bool.isRequired,
	    // Permisos
	    permisos: _react.PropTypes.object.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelEstados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Estado = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Estado = __webpack_require__(927);
	
	var css = _interopRequireWildcard(_Estado);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// Modulos
	
	var cx = _bind2.default.bind(css);
	
	var Estado = exports.Estado = function (_React$Component) {
	    _inherits(Estado, _React$Component);
	
	    function Estado(props) {
	        _classCallCheck(this, Estado);
	
	        var _this = _possibleConstructorReturn(this, (Estado.__proto__ || Object.getPrototypeOf(Estado)).call(this, props));
	
	        _this.state = {
	            bloqueado: false
	        };
	        return _this;
	    }
	
	    _createClass(Estado, [{
	        key: 'onClick',
	        value: function onClick(metodo) {
	            var _this2 = this;
	
	            // mientras no se reciba una respuesta del servidor, el control debe estar bloqueado
	            this.setState({ bloqueado: true });
	            var isAsync = function isAsync(fn) {
	                return fn.constructor.name === "AsyncFunction";
	            };
	            if (isAsync(metodo)) {
	                metodo().then(function (resp) {
	                    _this2.setState({ bloqueado: false });
	                }).catch(function (err) {
	                    _this2.setState({ bloqueado: false });
	                });
	            } else {
	                metodo();
	                this.setState({ bloqueado: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: cx('col-md-3', 'step') },
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('panel', this.props.activo ? 'panel-primary' : 'panel-default') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            this.props.titulo
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            this.props.descripcion
	                        )
	                    ),
	                    this.props.activo ? _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        this.props.acciones.map(function (accion, index) {
	                            return _react2.default.createElement(
	                                'button',
	                                { className: "btn btn-block btn-sm btn-primary " + (accion.tooltip ? css.textoConTooltip : ''),
	                                    key: index,
	                                    onClick: _this3.onClick.bind(_this3, accion.onclick)
	                                    // el boton esta deshabilitado si: la accion esta deshabilitada, o se
	                                    // esta esperando una respuesta del servidor
	                                    , disabled: accion.cambio_lider == 1 ? true : !accion.habilitado || _this3.state.bloqueado },
	                                accion.texto,
	                                ' ',
	                                accion.tooltip && _react2.default.createElement('p', { className: 'glyphicon glyphicon-info-sign' }),
	                                ' ',
	                                accion.tooltip ? _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Recordar que al aprobar n\xF3mina empieza el tiempo para confirmar'
	                                ) : null
	                            );
	                        })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return Estado;
	}(_react2.default.Component);
	
	Estado.propTypes = {
	    titulo: PropTypes.string.isRequired,
	    descripcion: PropTypes.string.isRequired,
	    activo: PropTypes.bool.isRequired,
	    acciones: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Estado.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"step":"Estado__step___1C5xm","textoConTooltip":"Estado__textoConTooltip___2J1Ua","tooltip":"Estado__tooltip___1Bj5H","tooltiptext":"Estado__tooltiptext___3DARU"};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BotonSubirPermisos = exports.PanelDetainer = exports.PanelCaptadorSEI = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _RowOperador = __webpack_require__(929);
	
	var _SelectAlternateLeader = __webpack_require__(931);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _Modales = __webpack_require__(918);
	
	var _PanelCaptador = __webpack_require__(713);
	
	var css = _interopRequireWildcard(_PanelCaptador);
	
	var _reactRedux = __webpack_require__(932);
	
	var _TarifaNomina = __webpack_require__(950);
	
	var _TarifaNomina2 = _interopRequireDefault(_TarifaNomina);
	
	var _Pasaje = __webpack_require__(953);
	
	var _Pasaje2 = _interopRequireDefault(_Pasaje);
	
	var _TurnoEmergencia = __webpack_require__(954);
	
	var _TurnoEmergencia2 = _interopRequireDefault(_TurnoEmergencia);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// CSS
	
	
	var panelConteo = ['panel-primary', 'panel-danger', 'panel-warning', 'panel-success', 'panel-info', 'panel-info', 'panel-primary'];
	
	var PanelCaptadorSEI = exports.PanelCaptadorSEI = function (_Component) {
	    _inherits(PanelCaptadorSEI, _Component);
	
	    function PanelCaptadorSEI(props) {
	        _classCallCheck(this, PanelCaptadorSEI);
	
	        var _this = _possibleConstructorReturn(this, (PanelCaptadorSEI.__proto__ || Object.getPrototypeOf(PanelCaptadorSEI)).call(this, props));
	
	        _this.state = {
	            substitutesOperatorsRaw: _this.props.captadorSEI.dotacionReemplazo,
	            substitutesOperators: [],
	            titularOperatorsRaw: _this.props.captadorSEI.dotacionTitular,
	            titularOperators: [],
	            valueSearchRUN: '',
	            valueSearchName: '',
	            valueSearchComuna: '',
	            checkOperadores: [],
	            checkOperadoresTitular: [],
	            enroque: false,
	            showPendientesRegion: false,
	            selectedPermisoId: "",
	            activarPermisoMall: false,
	            avisoReemplazosVisible: false
	        };
	
	        _this.searchingText = function (camp, originalSearch) {
	            var newState = {};
	            newState[camp] = originalSearch.trim().toLowerCase();
	            _this.setState(newState, _this.filterOperators);
	        };
	        _this.filterOperators = function () {
	            var titulares = _this.state.titularOperatorsRaw;
	            var substitutes = _this.state.substitutesOperatorsRaw.filter(function (us) {
	                return us.usuarioRUN.indexOf(_this.state.valueSearchRUN) >= 0;
	            }).filter(function (us) {
	                return us.nombreCorto.toLowerCase().indexOf(_this.state.valueSearchName) >= 0;
	            }).filter(function (us) {
	                return us.comuna.toLowerCase().indexOf(_this.state.valueSearchComuna) >= 0;
	            });
	            var listCheck = substitutes.map(function (operador) {
	                return { id: operador.id, status: false };
	            });
	            var listCheckTitular = titulares.map(function (operador) {
	                return { id: operador.id, status: false };
	            });
	            _this.setState({
	                substitutesOperators: substitutes,
	                checkOperadores: listCheck,
	                titularOperators: titulares,
	                checkOperadoresTitular: listCheckTitular
	            });
	        };
	        _this.setStatusCheckBox = function (idOperator, status) {
	            var lista = _this.state.checkOperadores.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status };
	                } else {
	                    return operador;
	                }
	            });
	            _this.setState({ checkOperadores: lista });
	        };
	
	        _this.setStatusCheckBoxAll = function (status) {
	            var lista = _this.state.checkOperadores.map(function (operador) {
	                return { id: operador.id, status: status };
	            });
	            _this.setState({ checkOperadores: lista });
	        };
	
	        _this.setStatusCheckBoxTitular = function (idOperator, status) {
	            var lista = _this.state.checkOperadoresTitular.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status };
	                } else {
	                    return operador;
	                }
	            });
	            _this.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this.setStatusCheckBoxAllTitular = function (status) {
	            var lista = _this.state.checkOperadoresTitular.map(function (operador) {
	                return { id: operador.id, status: status };
	            });
	            _this.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this.enrocarNomina = function () {
	            _this.setState({ enroque: true });
	        };
	
	        _this.cancelarEnroque = function () {
	            _this.setState({ enroque: false });
	            _this.setStatusCheckBoxAll(false);
	            _this.setStatusCheckBoxAllTitular(false);
	        };
	
	        _this.setStatusCheckBoxEnroqueTitular = function (idOperator, status, nombreCorto, unidadesContadas) {
	            var lista = _this.state.checkOperadoresTitular.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas };
	                } else {
	                    return operador;
	                }
	            });
	            _this.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this.setStatusCheckBoxEnroqueReemplazo = function (idOperator, status, nombreCorto, unidadesContadas) {
	            var lista = _this.state.checkOperadores.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas };
	                } else {
	                    return operador;
	                }
	            });
	            _this.setState({ checkOperadores: lista });
	        };
	
	        _this.showPendientesRegion = function () {
	            _this.setState({ showPendientesRegion: true });
	        };
	
	        _this.hidePendientesRegion = function () {
	            _this.setState({ showPendientesRegion: false });
	        };
	
	        _this.onChangeSelectedPemiso = function (e) {
	            _this.setState({ selectedPermisoId: e.target.value });
	        };
	
	        _this.onChangeActivarPermisoMall = function (e) {
	            _this.setState({ activarPermisoMall: e.target.checked });
	        };
	
	        _this.getPermisoSelected = function () {
	            var permisoMall = _this.props.nomina.permisos_mall.find(function (permiso) {
	                return permiso.id == _this.state.selectedPermisoId;
	            });
	            return permisoMall;
	        };
	
	        _this.getCantUsuariosPermiso = function (selectedPermisoId) {
	            var permisoMall = _this.props.nomina.permisos_mall.find(function (permiso) {
	                return permiso.id == selectedPermisoId;
	            });
	            var count = 0;
	            if (_this.props.nomina.lider != null) {
	                if (_this.props.nomina.lider.incluir_permisomall && _this.props.nomina.lider.incluir_permisomall == selectedPermisoId) {
	                    count++;
	                }
	            }
	
	            if (_this.props.nomina.supervisor != null) {
	                if (_this.props.nomina.supervisor.incluir_permisomall && _this.props.nomina.supervisor.incluir_permisomall == selectedPermisoId) {
	                    count++;
	                }
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = _this.props.captadorSEI.dotacionTitular[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _operador = _step.value;
	
	                    if (_operador.incluir_permisomall && _operador.incluir_permisomall == selectedPermisoId) {
	                        if (_this.props.nomina.lider != null && _operador.id == _this.props.nomina.lider.id) {
	                            continue;
	                        }
	                        if (_this.props.nomina.supervisor != null && _operador.id == _this.props.nomina.supervisor.id) {
	                            continue;
	                        }
	                        count++;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = _this.props.captadorSEI.dotacionReemplazo[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _operador2 = _step2.value;
	
	                    if (_operador2.incluir_permisomall && _operador2.incluir_permisomall == selectedPermisoId) {
	                        if (_this.props.nomina.lider != null && _operador2.id == _this.props.nomina.lider.id) {
	                            continue;
	                        }
	                        if (_this.props.nomina.supervisor != null && _operador2.id == _this.props.nomina.supervisor.id) {
	                            continue;
	                        }
	                        count++;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return count;
	        };
	
	        _this.calcularPermisoCompleto = function (selectedPermisoId) {
	            var permisoMall = _this.props.nomina.permisos_mall.find(function (permiso) {
	                return permiso.id == selectedPermisoId;
	            });
	            var max_usuarios = permisoMall ? permisoMall.tipo_permiso.max_usuarios : 0;
	            var count = _this.getCantUsuariosPermiso(selectedPermisoId);
	            return count >= max_usuarios;
	        };
	        _this.abrirAvisoReemplazos = function () {
	            _this.setState({ avisoReemplazosVisible: true });
	        };
	        _this.cerrarAvisoReemplazos = function () {
	            _this.setState({ avisoReemplazosVisible: false });
	        };
	        return _this;
	    }
	
	    _createClass(PanelCaptadorSEI, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (this.props !== nextProps) {
	                var sortedOperators = nextProps.captadorSEI.dotacionReemplazo.sort(function (a, b) {
	                    if (a.esLider && !b.esLider) return -1;
	                    if (!a.esLider && b.esLider) return 1;
	                    return a.nombreCorto.localeCompare(b.nombreCorto);
	                });
	
	                this.setState({ substitutesOperatorsRaw: sortedOperators }, function () {
	                    return _this2.filterOperators();
	                });
	                this.setState({ titularOperatorsRaw: nextProps.captadorSEI.dotacionTitular });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var totalAgregados = this.props.captadorSEI.dotacionTitular.length;
	            var rowsTitulares = this.props.maximoOperadores > totalAgregados ? this.props.maximoOperadores : totalAgregados;
	
	            var totalReemplazos = this.state.substitutesOperators.length;
	            var totalAlternativeLeaders = this.props.captadorSEI.alternativeLeaders.length;
	            var rowsReemplazo = totalReemplazos + 1;
	
	            var rowsEscondidos = this.props.captadorSEI.dotacionEscondida.length;
	            var stock = this.props.nomina.local_stock;
	
	            var isPermisoMall = this.props.nomina.local_mall && this.props.nomina.permisos_mall.length > 0;
	            var usersConPermisosMap = new Map();
	            this.props.nomina.permisos_mall.forEach(function (permiso) {
	                permiso.users_registrados.forEach(function (userRegistrado) {
	                    if (userRegistrado.user_id != null) {
	                        usersConPermisosMap.set(userRegistrado.user_id, userRegistrado);
	                    }
	                });
	            });
	
	            var ordenUserPermiso = new Map();
	            var orden = totalAgregados + rowsEscondidos + (this.props.supervisor ? 1 : 0) + 2; //+1 lider
	            [].concat(_toConsumableArray(this.props.captadorSEI.dotacionReemplazo)).sort(function (a, b) {
	                return a.orden_permisomall - b.orden_permisomall;
	            }).forEach(function (operador) {
	                if (operador.orden_permisomall <= 1 || !operador.incluir_permisomall) {} else {
	                    ordenUserPermiso.set(operador.id, orden);
	                    orden++;
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            this.props.captadorSEI.nombre,
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                ' ',
	                                totalAgregados,
	                                ' de ',
	                                this.props.maximoOperadores,
	                                ' operadores agregados '
	                            ),
	                            this.props.editarOperadores ? _react2.default.createElement(BotonAgregaOperador, {
	                                buscarOperadores: this.props.buscarOperadores
	                            }) : null
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3', style: { display: 'flex', gap: '2px' } },
	                        this.props.verNominaAvanzada ? _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: "25px" } },
	                            _react2.default.createElement(_TarifaNomina2.default, { nomina: this.props.nomina })
	                        ) : null,
	                        this.props.verPasajesNomina ? _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: "25px" } },
	                            _react2.default.createElement(_Pasaje2.default, { nomina: this.props.nomina, administraPasajes: this.props.administraPasajes })
	                        ) : null
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', gap: '4px', flexDirection: 'row', alignItems: 'flex-end' } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { fontSize: '18px' } },
	                                '(' + this.props.cantUserPermisoMall + '/' + this.props.maxUsuariosPermisosMall + ')'
	                            ),
	                            _react2.default.createElement(BotonSubirPermisos, {
	                                checked: this.state.activarPermisoMall,
	                                onChangeActivarPermisoMall: this.onChangeActivarPermisoMall,
	                                permisosMall: this.props.nomina.permisos_mall,
	                                idNomina: this.props.idNomina,
	                                notificator: this.props.notificator
	                            })
	                        )
	                    ) : _react2.default.createElement('div', { className: 'col-md-2' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2', style: { display: 'flex', gap: '2px', marginTop: "25px" } },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-primary',
	                                onClick: this.showPendientesRegion },
	                            'Pendientes'
	                        ),
	                        this.props.puedeInformarDisponibilidad ? _react2.default.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-success',
	                                    onClick: this.abrirAvisoReemplazos,
	                                    title: 'Informar la disponibilidad del servicio a los operadores de reemplazo'
	                                },
	                                'Avisar a reemplazos'
	                            ),
	                            this.state.avisoReemplazosVisible ? _react2.default.createElement(MiniAvisoReemplazos, {
	                                idNomina: this.props.idNomina,
	                                notificator: this.props.notificator,
	                                onCerrar: this.cerrarAvisoReemplazos
	                            }) : null
	                        ) : null,
	                        _react2.default.createElement(_Modales.ModalPendientesRegion, { show: this.state.showPendientesRegion,
	                            cambiarDePanel: this.context.cambiarDePanelPendientes,
	                            hideModal: this.hidePendientesRegion,
	                            idNomina: this.props.idNomina,
	                            notificator: this.props.notificator
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            PanelUsuarios,
	                            { isPermisoMall: isPermisoMall, titulo: 'Dotaci\xF3n T\xEDtular, ' + this.props.message, clase: panelConteo[this.props.nivelConteo] },
	                            _react2.default.createElement(_RowOperador.RowOperadorSEI, {
	                                editable: this.props.editarLiderSupervisor,
	                                correlativo: "L",
	                                personal: this.props.lider,
	                                cargo: 'Lider',
	                                agregarUsuario: this.context.agregarLider,
	                                quitarUsuario: this.context.quitarLider,
	                                isPermisoMall: isPermisoMall,
	                                tienePermisoMall: this.props.lider != null ? usersConPermisosMap.has(this.props.lider.id) : false,
	                                idNomina: this.props.nomina.idNomina,
	                                activarPermisoMall: this.state.activarPermisoMall
	                                //selectedPermisoId={this.state.selectedPermisoId}
	                                , permisoCompleto: this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall,
	                                notificator: this.props.notificator
	                            }),
	                            _react2.default.createElement(_RowOperador.RowOperadorSEI, {
	                                editable: this.props.editarLiderSupervisor,
	                                correlativo: "S",
	                                personal: this.props.supervisor,
	                                cargo: 'Supervisor',
	                                agregarUsuario: this.context.agregarSupervisor,
	                                quitarUsuario: this.context.quitarSupervisor,
	                                isPermisoMall: isPermisoMall,
	                                tienePermisoMall: this.props.supervisor != null ? usersConPermisosMap.has(this.props.supervisor.id) : false,
	                                idNomina: this.props.nomina.idNomina,
	                                activarPermisoMall: this.state.activarPermisoMall
	                                //selectedPermisoId={this.state.selectedPermisoId}
	                                , permisoCompleto: this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall,
	                                notificator: this.props.notificator
	                            }),
	                            _.range(0, rowsTitulares).map(function (index) {
	                                var operador = _this3.props.captadorSEI.dotacionTitular[index];
	                                var checkbox = _this3.state.checkOperadoresTitular[index];
	                                return _react2.default.createElement(_RowOperador.RowOperadorSEI
	                                //editarTodasNominas = {this.props.editarTodasNominas}
	                                , { editable: _this3.props.editarOperadores,
	                                    key: operador ? operador.id : 't' + index,
	                                    correlativo: '' + (index + 1),
	                                    personal: operador,
	                                    cargo: operador ? operador.role : "Operador",
	                                    checkboxStatus: checkbox ? checkbox.status : false,
	                                    setStatusCheckBoxEnroqueTitular: _this3.setStatusCheckBoxEnroqueTitular.bind(_this3),
	                                    agregarUsuario: _this3.context.agregarOperador.bind(_this3, true, _this3.props.captadorSEI.idCaptador),
	                                    quitarUsuario: _this3.context.quitarOperador,
	                                    cambiarDePanel: _this3.context.cambiarDePanel,
	                                    idCaptador: _this3.props.captadorSEI.idCaptador,
	                                    rectificada: _this3.props.rectificada,
	                                    operadorTitularId: _this3.props.operadorTitularId,
	                                    difOperadores: _this3.props.difOperadores,
	                                    nuevoOperador: _this3.props.nuevoOperador,
	                                    showSeleccionOperador: _this3.props.showSeleccionOperador,
	                                    buscarOperadores: _this3.props.buscarOperadores,
	                                    blockOperador: _this3.context.blockOperador
	                                    // idNomina={this.props.idNomina}
	                                    , enroque: _this3.state.enroque,
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false,
	                                    comunaInventario: _this3.props.nomina.local_comuna,
	                                    idNomina: _this3.props.nomina.idNomina,
	                                    activarPermisoMall: _this3.state.activarPermisoMall
	                                    //selectedPermisoId={this.state.selectedPermisoId}
	                                    , permisoCompleto: _this3.props.cantUserPermisoMall >= _this3.props.maxUsuariosPermisosMall,
	                                    notificator: _this3.props.notificator
	                                });
	                            }),
	                            this.props.nuevoOperador ? _react2.default.createElement(_RowOperador.RowOperadorSEI, {
	                                editable: true,
	                                nuevoOperador: true,
	                                correlativo: _react2.default.createElement('span', { className: 'glyphicon glyphicon-random', 'aria-hidden': 'true' }),
	                                rectificada: this.props.rectificada,
	                                agregarUsuario: this.context.agregarOperador.bind(this, true, this.props.captadorSEI.idCaptador),
	                                onCancelarAgregarOperador: this.props.onCancelarAgregarOperador,
	                                operadorTitularId: this.props.operadorTitularId,
	                                isPermisoMall: isPermisoMall,
	                                tienePermisoMall: usersConPermisosMap.has(operador.id)
	                            }) : null,
	                            _react2.default.createElement(_RowOperador.RowOperadorSEI, {
	                                editable: false,
	                                correlativo: "U",
	                                sumaUnidades: this.props.sumaUnidades,
	                                sumaConteo: this.props.sumaConteo,
	                                isPermisoMall: isPermisoMall
	                            }),
	                            _react2.default.createElement(_RowOperador.RowOperadorSEI, {
	                                editable: false,
	                                correlativo: "D",
	                                diferenciaUnidades: this.props.diferenciaUnidades,
	                                diferenciaConteo: this.props.diferenciaConteo,
	                                isPermisoMall: isPermisoMall
	                            }),
	                            rowsEscondidos > 0 ? _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '-'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    'Escondidos'
	                                )
	                            ) : null,
	                            _.range(0, rowsEscondidos).map(function (index) {
	                                var operador = _this3.props.captadorSEI.dotacionEscondida[index];
	                                var checkbox = _this3.state.checkOperadoresTitular[index];
	                                return _react2.default.createElement(_RowOperador.RowOperadorSEIEscondido
	                                //editarTodasNominas = {this.props.editarTodasNominas}
	                                , { editable: _this3.props.editarOperadores,
	                                    key: operador ? operador.id : 't' + index,
	                                    correlativo: '' + (index + 1),
	                                    personal: operador,
	                                    cargo: operador ? operador.role : "Operador",
	                                    checkboxStatus: checkbox ? checkbox.status : false,
	                                    setStatusCheckBoxEnroqueTitular: _this3.setStatusCheckBoxEnroqueTitular.bind(_this3),
	                                    quitarEscondido: _this3.context.quitarEscondido,
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false,
	                                    idNomina: _this3.props.nomina.idNomina,
	                                    activarPermisoMall: _this3.state.activarPermisoMall
	                                    //selectedPermisoId={this.state.selectedPermisoId}
	                                    , permisoCompleto: _this3.props.cantUserPermisoMall >= _this3.props.maxUsuariosPermisosMall,
	                                    notificator: _this3.props.notificator
	                                });
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            PanelUsuariosReemplazoSEI,
	                            {
	                                isPermisoMall: isPermisoMall,
	                                titulo: 'Dotaci\xF3n Reemplazo',
	                                clase: panelConteo[0],
	                                searchingRUN: this.searchingText.bind(this, 'valueSearchRUN'),
	                                searchingName: this.searchingText.bind(this, 'valueSearchName'),
	                                searchingComuna: this.searchingText.bind(this, 'valueSearchComuna'),
	                                valueSearchRUN: this.state.valueSearchRUN,
	                                valueSearchName: this.state.valueSearchName,
	                                valueSearchComuna: this.state.valueSearchComuna,
	                                setStatusCheckBoxAll: this.setStatusCheckBoxAll.bind(this),
	                                quitarOperadoresMasivo: this.props.quitarOperadoresMasivo.bind(this, this.state.checkOperadores),
	                                operadorTitularMasivo: this.props.operadorTitularMasivo.bind(this, this.state.checkOperadores),
	                                editable: this.props.editarOperadores
	                            },
	                            _.range(0, totalAlternativeLeaders).map(function (index) {
	                                var operador = _this3.props.captadorSEI.alternativeLeaders[index];
	                                var numOrden = ordenUserPermiso.has(operador.id) ? ordenUserPermiso.get(operador.id) : '';
	                                return _react2.default.createElement(_RowOperador.RowOperadorReemplazo, {
	                                    editable: _this3.props.editarOperadores,
	                                    key: operador ? operador.id : 'r' + index,
	                                    correlativo: 'LS',
	                                    personal: operador,
	                                    cargo: 'Lider Suplente',
	                                    agregarUsuario: _this3.context.agregarOperador.bind(_this3, false, _this3.props.captadorSEI.idCaptador),
	                                    quitarUsuario: _this3.context.quitarOperador,
	                                    suspendOperator: _this3.context.supendOperator,
	                                    cambiarDePanel: _this3.context.cambiarDePanel,
	                                    idCaptador: _this3.props.captadorSEI.idCaptador,
	                                    rectificada: _this3.props.rectificada,
	                                    buscarOperadores: _this3.props.buscarOperadores,
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false
	                                });
	                            }),
	                            _.range(0, rowsReemplazo).map(function (index) {
	                                var operador = _this3.state.substitutesOperators[index];
	                                var checkbox = _this3.state.checkOperadores[index];
	                                if (operador) {
	                                    operador = _extends({}, _this3.state.substitutesOperators[index], {
	                                        orden_permisomall: ordenUserPermiso.has(operador.id) ? ordenUserPermiso.get(operador.id) : ''
	                                    });
	                                }
	                                return _react2.default.createElement(_RowOperador.RowOperadorReemplazoSEI
	                                //editarTodasNominas = {this.props.editarTodasNominas}
	                                , { editable: _this3.props.editarOperadores,
	                                    key: operador ? operador.id : 'r' + index,
	                                    correlativo: '' + (index + 1),
	                                    personal: operador,
	                                    checkboxStatus: checkbox ? checkbox.status : false,
	                                    cargo: 'Operador',
	                                    setStatusCheckBox: _this3.setStatusCheckBox.bind(_this3),
	                                    setStatusCheckBoxEnroqueReemplazo: _this3.setStatusCheckBoxEnroqueReemplazo.bind(_this3),
	                                    agregarUsuario: _this3.context.agregarOperador.bind(_this3, false, _this3.props.captadorSEI.idCaptador),
	                                    quitarUsuario: _this3.context.quitarOperador,
	                                    suspendOperator: _this3.context.suspendOperator,
	                                    cambiarDePanel: _this3.context.cambiarDePanel,
	                                    idCaptador: _this3.props.captadorSEI.idCaptador,
	                                    rectificada: _this3.props.rectificada,
	                                    buscarOperadores: _this3.props.buscarOperadores,
	                                    enroque: _this3.state.enroque,
	                                    cliente: _this3.props.cliente,
	                                    puedeAsignar: _this3.props.puedeAsignar,
	                                    operadorEscondido: _this3.props.operadorEscondido.bind(_this3),
	                                    fechaInventario: _this3.props.nomina.inv_fechaProgramada,
	                                    cambiarCaptador: _this3.context.cambiarCaptador,
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false,
	                                    idNomina: _this3.props.nomina.idNomina,
	                                    activarPermisoMall: _this3.state.activarPermisoMall
	                                    //selectedPermisoId={this.state.selectedPermisoId}
	                                    , permisoCompleto: _this3.props.cantUserPermisoMall >= _this3.props.maxUsuariosPermisosMall,
	                                    notificator: _this3.props.notificator
	                                });
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PanelCaptadorSEI;
	}(_react.Component);
	
	PanelCaptadorSEI.contextTypes = {
	    agregarLider: _react.PropTypes.func,
	    quitarLider: _react.PropTypes.func,
	    agregarSupervisor: _react.PropTypes.func,
	    quitarSupervisor: _react.PropTypes.func,
	    agregarOperador: _react.PropTypes.func,
	    quitarOperador: _react.PropTypes.func,
	    cambiarDePanel: _react.PropTypes.func,
	    cambiarDePanelPendientes: _react.PropTypes.func,
	    getOperadoresDisponibles: _react.PropTypes.func,
	    addAlternateLeader: _react.PropTypes.func,
	    suspendOperator: _react.PropTypes.func,
	    blockOperador: _react.PropTypes.func,
	    enrocarNomina: _react.PropTypes.func,
	    changeTurnoAvanzada: _react.PropTypes.func,
	    quitarEscondido: _react.PropTypes.func,
	    cambiarCaptador: _react.PropTypes.func
	};
	
	var PanelDetainer = exports.PanelDetainer = function (_Component2) {
	    _inherits(PanelDetainer, _Component2);
	
	    function PanelDetainer(props) {
	        _classCallCheck(this, PanelDetainer);
	
	        var _this4 = _possibleConstructorReturn(this, (PanelDetainer.__proto__ || Object.getPrototypeOf(PanelDetainer)).call(this, props));
	
	        _this4.state = {
	            substitutesOperatorsRaw: _this4.props.captador.dotacionReemplazo,
	            substitutesOperators: [],
	            titularOperatorsRaw: _this4.props.captador.dotacionTitular,
	            titularOperators: [],
	            valueSearchRUN: '',
	            valueSearchName: '',
	            valueSearchComuna: '',
	            checkOperadores: [],
	            checkOperadoresTitular: [],
	            enroque: false
	        };
	        _this4.searchingText = function (camp, originalSearch) {
	            var newState = {};
	            newState[camp] = originalSearch.trim().toLowerCase();
	            _this4.setState(newState, _this4.filterOperators);
	        };
	        /*this.filterOperators = () => {
	            this.setState({
	                substitutesOperators: this.state.substitutesOperatorsRaw
	                    .filter(us => us.usuarioRUN.indexOf(this.state.valueSearchRUN) >= 0)
	                    .filter(us => us.nombreCorto.toLowerCase().indexOf(this.state.valueSearchName) >= 0)
	                    .filter(us => us.comuna.toLowerCase().indexOf(this.state.valueSearchComuna) >= 0)
	            })
	        }*/
	        _this4.filterOperators = function () {
	            var titulares = _this4.state.titularOperatorsRaw;
	            var substitutes = _this4.state.substitutesOperatorsRaw.filter(function (us) {
	                return us.usuarioRUN.indexOf(_this4.state.valueSearchRUN) >= 0;
	            }).filter(function (us) {
	                return us.nombreCorto.toLowerCase().indexOf(_this4.state.valueSearchName) >= 0;
	            }).filter(function (us) {
	                return us.comuna.toLowerCase().indexOf(_this4.state.valueSearchComuna) >= 0;
	            });
	            var listCheck = substitutes.map(function (operador) {
	                return { id: operador.id, status: false };
	            });
	            var listCheckTitular = titulares.map(function (operador) {
	                return { id: operador.id, status: false };
	            });
	            _this4.setState({
	                substitutesOperators: substitutes,
	                checkOperadores: listCheck,
	                titularOperators: titulares,
	                checkOperadoresTitular: listCheckTitular
	            });
	        };
	
	        _this4.setStatusCheckBox = function (idOperator, status) {
	            var lista = _this4.state.checkOperadores.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status };
	                } else {
	                    return operador;
	                }
	            });
	            _this4.setState({ checkOperadores: lista });
	        };
	
	        _this4.setStatusCheckBoxAll = function (status) {
	            var lista = _this4.state.checkOperadores.map(function (operador) {
	                return { id: operador.id, status: status };
	            });
	            _this4.setState({ checkOperadores: lista });
	        };
	
	        _this4.setStatusCheckBoxTitular = function (idOperator, status) {
	            var lista = _this4.state.checkOperadoresTitular.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status };
	                } else {
	                    return operador;
	                }
	            });
	            _this4.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this4.setStatusCheckBoxAllTitular = function (status) {
	            var lista = _this4.state.checkOperadoresTitular.map(function (operador) {
	                return { id: operador.id, status: status };
	            });
	            _this4.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this4.enrocarNomina = function () {
	            _this4.setState({ enroque: true });
	        };
	
	        _this4.cancelarEnroque = function () {
	            _this4.setState({ enroque: false });
	            _this4.setStatusCheckBoxAll(false);
	            _this4.setStatusCheckBoxAllTitular(false);
	        };
	
	        _this4.setStatusCheckBoxEnroqueTitular = function (idOperator, status, nombreCorto, unidadesContadas) {
	            var lista = _this4.state.checkOperadoresTitular.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas };
	                } else {
	                    return operador;
	                }
	            });
	            _this4.setState({ checkOperadoresTitular: lista });
	        };
	
	        _this4.setStatusCheckBoxEnroqueReemplazo = function (idOperator, status, nombreCorto, unidadesContadas) {
	            var lista = _this4.state.checkOperadores.map(function (operador) {
	                if (operador.id == idOperator) {
	                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas };
	                } else {
	                    return operador;
	                }
	            });
	            _this4.setState({ checkOperadores: lista });
	        };
	        return _this4;
	    }
	
	    _createClass(PanelDetainer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this5 = this;
	
	            if (this.props !== nextProps) {
	                this.setState({ substitutesOperatorsRaw: nextProps.captador.dotacionReemplazo.sort(function (a, b) {
	                        return a.nombreCorto.localeCompare(b.nombreCorto);
	                    }) }, function () {
	                    return _this5.filterOperators();
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var operadoresAsignados = this.props.captador.operadoresAsignados;
	            var totalAgregados = this.props.captador.dotacionTitular.length;
	            var rowsTitulares = operadoresAsignados > totalAgregados ? operadoresAsignados : totalAgregados;
	
	            var totalReemplazos = this.state.substitutesOperators.length;
	            var rowsReemplazo = totalReemplazos + 1;
	
	            var stock = this.props.nomina.local_stock;
	
	            var isPermisoMall = this.props.nomina.local_mall && this.props.nomina.permisos_mall.length > 0;
	            var usersConPermisosMap = new Map();
	            this.props.nomina.permisos_mall.forEach(function (permiso) {
	                permiso.users_registrados.forEach(function (userRegistrado) {
	                    if (userRegistrado.user_id != null) {
	                        usersConPermisosMap.set(userRegistrado.user_id, userRegistrado);
	                    }
	                });
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            this.props.captador.nombre,
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                ' ',
	                                totalAgregados,
	                                ' de ',
	                                operadoresAsignados,
	                                ' operadores agregados  '
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            PanelUsuarios,
	                            { isPermisoMall: isPermisoMall, titulo: 'Dotaci\xF3n T\xEDtular, ' + this.props.message, clase: panelConteo[this.props.nivelConteo] },
	                            _.range(0, rowsTitulares).map(function (index) {
	                                var operador = _this6.props.captador.dotacionTitular[index];
	                                var checkbox = _this6.state.checkOperadoresTitular[index];
	                                return _react2.default.createElement(_RowOperador.RowOperador
	                                //editarTodasNominas = {this.props.editarTodasNominas}
	                                , { editable: _this6.props.editarOperadores,
	                                    key: operador ? operador.id : 't' + index,
	                                    correlativo: '' + (index + 1),
	                                    personal: operador,
	                                    cargo: 'Operador',
	                                    agregarUsuario: _this6.context.agregarOperador.bind(_this6, true, _this6.props.captador.idCaptador),
	                                    quitarUsuario: _this6.context.quitarOperador,
	                                    cambiarDePanel: _this6.context.cambiarDePanel,
	                                    idCaptador: _this6.props.captador.idCaptador,
	                                    rectificada: _this6.props.rectificada,
	                                    difOperadores: _this6.props.difOperadores,
	                                    buscarOperadores: _this6.props.buscarOperadores,
	                                    enroque: _this6.state.enroque,
	                                    checkboxStatus: checkbox ? checkbox.status : false,
	                                    setStatusCheckBoxEnroqueTitular: _this6.setStatusCheckBoxEnroqueTitular.bind(_this6),
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false
	                                });
	                            }),
	                            _react2.default.createElement(_RowOperador.RowOperador, {
	                                editable: false,
	                                correlativo: "U",
	                                estado: this.props.captador.estado,
	                                sumaUnidades: this.props.sumaUnidades,
	                                isPermisoMall: isPermisoMall
	                            }),
	                            _react2.default.createElement(_RowOperador.RowOperador, {
	                                editable: false,
	                                correlativo: "D",
	                                diferenciaUnidades: this.props.diferenciaUnidades,
	                                isPermisoMall: isPermisoMall
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            PanelUsuariosReemplazo,
	                            {
	                                isPermisoMall: isPermisoMall,
	                                titulo: 'Dotaci\xF3n Reemplazo',
	                                clase: panelConteo[0],
	                                searchingRUN: this.searchingText.bind(this, 'valueSearchRUN'),
	                                searchingName: this.searchingText.bind(this, 'valueSearchName'),
	                                searchingComuna: this.searchingText.bind(this, 'valueSearchComuna'),
	                                valueSearchRUN: this.state.valueSearchRUN,
	                                valueSearchName: this.state.valueSearchName,
	                                valueSearchComuna: this.state.valueSearchComuna
	                            },
	                            _.range(0, rowsReemplazo).map(function (index) {
	                                var operador = _this6.state.substitutesOperators[index];
	                                var checkbox = _this6.state.checkOperadores[index];
	                                return _react2.default.createElement(_RowOperador.RowOperadorReemplazo
	                                //editarTodasNominas = {this.props.editarTodasNominas}
	                                , { editable: _this6.props.editarOperadores,
	                                    key: operador ? operador.id : 'r' + index,
	                                    correlativo: 'R',
	                                    personal: operador,
	                                    cargo: 'Operador',
	                                    agregarUsuario: _this6.context.agregarOperador.bind(_this6, false, _this6.props.captador.idCaptador),
	                                    quitarUsuario: _this6.context.quitarOperador,
	                                    suspendOperator: _this6.context.suspendOperator,
	                                    cambiarDePanel: _this6.context.cambiarDePanel,
	                                    idCaptador: _this6.props.captador.idCaptador,
	                                    rectificada: _this6.props.rectificada,
	                                    buscarOperadores: _this6.props.buscarOperadores,
	                                    enroque: _this6.state.enroque,
	                                    setStatusCheckBox: _this6.setStatusCheckBox.bind(_this6),
	                                    setStatusCheckBoxEnroqueReemplazo: _this6.setStatusCheckBoxEnroqueReemplazo.bind(_this6),
	                                    checkboxStatus: checkbox ? checkbox.status : false,
	                                    fechaInventario: _this6.props.nomina.inv_fechaProgramada,
	                                    isPermisoMall: isPermisoMall,
	                                    tienePermisoMall: operador ? usersConPermisosMap.has(operador.id) : false
	                                });
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PanelDetainer;
	}(_react.Component);
	
	PanelDetainer.contextTypes = {
	    agregarOperador: _react.PropTypes.func,
	    quitarOperador: _react.PropTypes.func,
	    cambiarDePanel: _react.PropTypes.func,
	    getOperadoresDisponibles: _react.PropTypes.func,
	    suspendOperator: _react.PropTypes.func
	};
	
	var PanelUsuarios = function PanelUsuarios(_ref) {
	    var _ref$isPermisoMall = _ref.isPermisoMall,
	        isPermisoMall = _ref$isPermisoMall === undefined ? false : _ref$isPermisoMall,
	        titulo = _ref.titulo,
	        children = _ref.children,
	        clase = _ref.clase;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel ' + clase },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading ' + css.panelHeading_compacto },
	            titulo
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion },
	            _react2.default.createElement(
	                'colgroup',
	                null,
	                _react2.default.createElement('col', { className: css.colCorrelativo }),
	                _react2.default.createElement('col', { className: css.colUsuarioRUN }),
	                _react2.default.createElement('col', { className: css.colUsuarioDV }),
	                _react2.default.createElement('col', { className: css.colNombre }),
	                _react2.default.createElement('col', { className: css.colCargo }),
	                _react2.default.createElement('col', { className: css.colComuna }),
	                _react2.default.createElement('col', { className: css.colCaptador }),
	                _react2.default.createElement('col', { className: css.colExp }),
	                _react2.default.createElement('col', { className: css.colError }),
	                _react2.default.createElement('col', { className: css.colConteo }),
	                _react2.default.createElement('col', { className: css.colConteoReal }),
	                _react2.default.createElement('col', { className: css.colEstado }),
	                _react2.default.createElement('col', { className: css.colEstadoCI }),
	                isPermisoMall ? _react2.default.createElement('col', { className: css.colPermisoMall }) : null,
	                _react2.default.createElement('col', { className: css.colOpciones }),
	                _react2.default.createElement('col', { className: css.colOpciones }),
	                _react2.default.createElement('col', { className: css.colIntercambio })
	            ),
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'N\xB0'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'RUN'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUsuarioDV },
	                        'DV'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Nombre'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Cargo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Comuna'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Captador'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Exp'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Error'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Sug.'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Real'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Contrato'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CI'
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'th',
	                        null,
	                        'Mall'
	                    ) : null,
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement('th', null)
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	var PanelUsuariosReemplazo = function PanelUsuariosReemplazo(_ref2) {
	    var _ref2$isPermisoMall = _ref2.isPermisoMall,
	        isPermisoMall = _ref2$isPermisoMall === undefined ? false : _ref2$isPermisoMall,
	        titulo = _ref2.titulo,
	        children = _ref2.children,
	        clase = _ref2.clase,
	        searchingRUN = _ref2.searchingRUN,
	        searchingName = _ref2.searchingName,
	        searchingComuna = _ref2.searchingComuna,
	        valueSearchRUN = _ref2.valueSearchRUN,
	        valueSearchName = _ref2.valueSearchName,
	        valueSearchComuna = _ref2.valueSearchComuna;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel ' + clase },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading ' + css.panelHeading_compacto },
	            titulo
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion },
	            _react2.default.createElement(
	                'colgroup',
	                null,
	                _react2.default.createElement('col', { className: css.colOpciones }),
	                _react2.default.createElement('col', { className: css.colIntercambio }),
	                _react2.default.createElement('col', { className: css.colIntercambio }),
	                _react2.default.createElement('col', { className: css.colUsuarioRUN }),
	                _react2.default.createElement('col', { className: css.colUsuarioDV }),
	                _react2.default.createElement('col', { className: css.colNombreCorto }),
	                _react2.default.createElement('col', { className: css.colComuna }),
	                _react2.default.createElement('col', { className: css.colCaptador }),
	                _react2.default.createElement('col', { className: css.colExp }),
	                _react2.default.createElement('col', { className: css.colError }),
	                _react2.default.createElement('col', { className: css.colConteo }),
	                _react2.default.createElement('col', { className: css.colConteoReal }),
	                _react2.default.createElement('col', { className: css.colEstado }),
	                _react2.default.createElement('col', { className: css.colEstadoCI }),
	                isPermisoMall ? _react2.default.createElement('col', { className: css.colPermisoMall }) : null
	            ),
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement('th', null),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'RUN',
	                            busqueda: valueSearchRUN,
	                            realizarBusqueda: searchingRUN
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUsuarioDV },
	                        'DV'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'Nombre',
	                            busqueda: valueSearchName,
	                            realizarBusqueda: searchingName
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'Comuna',
	                            busqueda: valueSearchComuna,
	                            realizarBusqueda: searchingComuna
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Captador'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Exp'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Error'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Sug.'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Real'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Contrato'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CI'
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'th',
	                        null,
	                        'Mall'
	                    ) : null
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	var PanelUsuariosReemplazoSEI = function PanelUsuariosReemplazoSEI(_ref3) {
	    var _ref3$isPermisoMall = _ref3.isPermisoMall,
	        isPermisoMall = _ref3$isPermisoMall === undefined ? false : _ref3$isPermisoMall,
	        operadorTitularMasivo = _ref3.operadorTitularMasivo,
	        quitarOperadoresMasivo = _ref3.quitarOperadoresMasivo,
	        setStatusCheckBoxAll = _ref3.setStatusCheckBoxAll,
	        titulo = _ref3.titulo,
	        children = _ref3.children,
	        clase = _ref3.clase,
	        searchingRUN = _ref3.searchingRUN,
	        searchingName = _ref3.searchingName,
	        searchingComuna = _ref3.searchingComuna,
	        valueSearchRUN = _ref3.valueSearchRUN,
	        valueSearchName = _ref3.valueSearchName,
	        valueSearchComuna = _ref3.valueSearchComuna,
	        editable = _ref3.editable,
	        puedeAsignar = _ref3.puedeAsignar;
	
	
	    var handleChange = function handleChange(event) {
	        setStatusCheckBoxAll(event.target.checked);
	    };
	
	    var handleClick = function handleClick() {
	        quitarOperadoresMasivo();
	    };
	
	    var handleClickTitular = function handleClickTitular() {
	        operadorTitularMasivo();
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel ' + clase },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading ' + css.panelHeading_compacto },
	            titulo
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion },
	            _react2.default.createElement(
	                'colgroup',
	                null,
	                _react2.default.createElement('col', { className: css.colCorrelativoSEI }),
	                _react2.default.createElement('col', { className: css.colOpciones }),
	                _react2.default.createElement('col', { className: css.colCheckbox }),
	                _react2.default.createElement('col', { className: css.colIntercambio }),
	                _react2.default.createElement('col', { className: css.colUsuarioRUN }),
	                _react2.default.createElement('col', { className: css.colUsuarioDV }),
	                _react2.default.createElement('col', { className: css.colNombreCorto }),
	                _react2.default.createElement('col', { className: css.colComuna }),
	                _react2.default.createElement('col', { className: css.colCaptador }),
	                _react2.default.createElement('col', { className: css.colExp }),
	                _react2.default.createElement('col', { className: css.colError }),
	                _react2.default.createElement('col', { className: css.colConteo }),
	                _react2.default.createElement('col', { className: css.colConteoReal }),
	                _react2.default.createElement('col', { className: css.colEstado }),
	                _react2.default.createElement('col', { className: css.colEstadoCI }),
	                isPermisoMall ? _react2.default.createElement('col', { className: css.colPermisoMall }) : null
	            ),
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-info glyphicon glyphicon-triangle-left',
	                            onClick: handleClickTitular,
	                            title: 'Cambiar a n\xF3mina titular'
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        editable ? _react2.default.createElement('input', { type: 'checkbox', onChange: handleChange }) : null
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-danger glyphicon glyphicon-remove',
	                            onClick: handleClick,
	                            title: 'Quitar Operador n\xF3mina reemplazo'
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'RUN',
	                            busqueda: valueSearchRUN,
	                            realizarBusqueda: searchingRUN
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUsuarioDV },
	                        'DV'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'Nombre',
	                            busqueda: valueSearchName,
	                            realizarBusqueda: searchingName
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                            nombre: 'Comuna',
	                            busqueda: valueSearchComuna,
	                            realizarBusqueda: searchingComuna
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Captador'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Exp'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Error'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Sug.'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Real'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Contrato'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CI'
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'th',
	                        null,
	                        'Mall'
	                    ) : null
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	var BotonAgregaOperador = function BotonAgregaOperador(_ref4) {
	    var buscarOperadores = _ref4.buscarOperadores;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-xs btn-success', disabled: buscarOperadores, onClick: showModal },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-search' }),
	                ' Buscar Operador',
	                isVisible && _react2.default.createElement(_Modales.ModalAgregaOperador, {
	                    hideModal: hideModal
	                })
	            );
	        }
	    );
	};
	
	var BotonEnrocarOperadores = function BotonEnrocarOperadores(_ref5) {
	    var titulares = _ref5.titulares,
	        reemplazos = _ref5.reemplazos,
	        enrocarOperadores = _ref5.enrocarOperadores,
	        cancelarEnroque = _ref5.cancelarEnroque,
	        mensaje = _ref5.mensaje,
	        nivelConteo = _ref5.nivelConteo,
	        idNomina = _ref5.idNomina,
	        sumaUnidades = _ref5.sumaUnidades,
	        stock = _ref5.stock;
	
	    var arraytitular = [];
	    titulares.map(function (op) {
	        if (op.status == true) {
	            return arraytitular.push({ id: op.id, nombre: op.nombre, conteo: op.conteo });
	        }
	    });
	    var arrayreemplazo = [];
	    reemplazos.map(function (op) {
	        if (op.status == true) {
	            return arrayreemplazo.push({ id: op.id, nombre: op.nombre, conteo: op.conteo });
	        }
	    });
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { style: { marginTop: "25px", marginRight: '5px' }, className: 'btn btn-success',
	                    onClick: showModal },
	                'Enrocar',
	                isVisible && _react2.default.createElement(_Modales.ModalEnrocarOperadores, {
	                    hideModal: hideModal,
	                    titulares: arraytitular,
	                    reemplazos: arrayreemplazo,
	                    enrocarOperadores: enrocarOperadores,
	                    cancelarEnroque: cancelarEnroque,
	                    mensaje: mensaje,
	                    nivelConteo: nivelConteo,
	                    idNomina: idNomina,
	                    sumaUnidades: sumaUnidades,
	                    stock: stock
	                })
	            );
	        }
	    );
	};
	
	var BotonSubirPermisos = exports.BotonSubirPermisos = function (_React$Component) {
	    _inherits(BotonSubirPermisos, _React$Component);
	
	    function BotonSubirPermisos(props) {
	        _classCallCheck(this, BotonSubirPermisos);
	
	        var _this7 = _possibleConstructorReturn(this, (BotonSubirPermisos.__proto__ || Object.getPrototypeOf(BotonSubirPermisos)).call(this, props));
	
	        _this7.subirPermisos = function () {
	            fetch('/api/nomina/subir-permisomall', {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    idNomina: _this7.props.idNomina
	                })
	            }).then(function (response) {
	                return response.json().then(function (json) {
	                    if (!response.ok) {
	                        throw json;
	                    }
	                    return json;
	                });
	            }).then(function (data) {
	                _this7.context.setPermisosMallNomina(data);
	                _this7.actualizarIntervaloPermisosMall();
	            }).catch(function (error) {
	                var message = error.message || 'Error al subir permisos';
	                _this7.props.notificator.error('Error al subir permisos', message, 4000);
	                _this7.setState({ error: 'Error al subir permisos' });
	            });
	        };
	
	        _this7.onClick = function () {
	            var confirmed = window.confirm('¿Estás seguro de subir los permisos?');
	
	            if (!confirmed) {
	                return;
	            }
	
	            _this7.subirPermisos();
	        };
	
	        _this7.actualizarIntervaloPermisosMall = function () {
	            var subiendo = _this7.props.permisosMall.filter(function (permiso) {
	                return permiso.subiendo_permiso;
	            }).length;
	            var completados = _this7.props.permisosMall.filter(function (permiso) {
	                return permiso.completado;
	            }).length;
	
	            if (subiendo === 0 || completados === _this7.props.permisosMall.length) {
	                console.log('[Permisos Mall] Deteniendo consulta periódica: no hay permisos subiendo');
	                clearInterval(_this7.permisosMallInterval);
	                _this7.permisosMallInterval = null;
	                return;
	            }
	
	            if (_this7.permisosMallInterval) {
	                return;
	            }
	
	            console.log('[Permisos Mall] Iniciando consulta periódica', { subiendo: subiendo });
	            _this7.permisosMallInterval = setInterval(function () {
	                console.log('[Permisos Mall] Consultando estado');
	                fetch('/api/nomina/status-permisosmall?idNomina=' + _this7.props.idNomina, {
	                    method: 'GET'
	                }).then(function (response) {
	                    return response.json().then(function (json) {
	                        if (!response.ok) {
	                            throw json;
	                        }
	                        return json;
	                    });
	                }).then(function (data) {
	                    console.log('[Permisos Mall] Estado recibido', data);
	                    _this7.context.setPermisosMallNomina(data);
	
	                    if (data.filter(function (permiso) {
	                        return permiso.completado;
	                    }).length == _this7.props.permisosMall.length) {
	                        _this7.props.notificator.success('Permisos subidos correctamente', 'Éxito', 4000);
	                    }
	                }).catch(function (error) {
	                    console.error('Error al consultar el estado de los permisos mall', error);
	                });
	            }, 10000);
	        };
	
	        _this7.state = {
	            error: null
	        };
	        return _this7;
	    }
	
	    _createClass(BotonSubirPermisos, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.permisosMall !== this.props.permisosMall) {
	                this.actualizarIntervaloPermisosMall();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.actualizarIntervaloPermisosMall();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            console.log('[Permisos Mall] Deteniendo consulta periódica: componente desmontado');
	            clearInterval(this.permisosMallInterval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.error) {
	                return _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-danger', disabled: true },
	                    this.state.error
	                );
	            }
	
	            var subiendo = this.props.permisosMall.filter(function (permiso) {
	                return permiso.subiendo_permiso;
	            }).length;
	            var completados = this.props.permisosMall.filter(function (permiso) {
	                return permiso.completado;
	            }).length;
	
	            var isSubiendoPermisos = subiendo > 0;
	            var isCompletados = completados == this.props.permisosMall.length;
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'column' } },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    _react2.default.createElement('input', { type: 'checkbox', checked: this.props.checked, onChange: this.props.onChangeActivarPermisoMall }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { marginLeft: '4px' } },
	                        'Nomina Permiso Mall'
	                    )
	                ),
	                isCompletados ? _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-success', disabled: true },
	                    'Permiso cargado',
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', style: { marginLeft: '5px' } })
	                ) : _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary', disabled: isSubiendoPermisos, onClick: this.onClick },
	                    isSubiendoPermisos ? 'Subiendo... (' + subiendo + '/' + this.props.permisosMall.length + ')' : 'Subir Permisos'
	                )
	            );
	        }
	    }]);
	
	    return BotonSubirPermisos;
	}(_react2.default.Component);
	
	BotonSubirPermisos.contextTypes = {
	    setPermisosMallNomina: _react.PropTypes.func
	
	    // Mini panel para informar la disponibilidad del servicio a los reemplazos.
	    // Consulta en vivo cuántos reemplazos hay disponibles para notificar (lista completa)
	    // y permite indicar cuántos cupos (vacantes) del servicio se informarán. Los cupos son
	    // independientes de la cantidad de usuarios notificados.
	};
	var MiniAvisoReemplazos = function (_Component3) {
	    _inherits(MiniAvisoReemplazos, _Component3);
	
	    function MiniAvisoReemplazos(props) {
	        _classCallCheck(this, MiniAvisoReemplazos);
	
	        var _this8 = _possibleConstructorReturn(this, (MiniAvisoReemplazos.__proto__ || Object.getPrototypeOf(MiniAvisoReemplazos)).call(this, props));
	
	        _this8.state = {
	            loading: true,
	            error: null,
	            data: null,
	            cupos: 0,
	            enviando: false
	        };
	        _this8.consultar = function () {
	            // El modal abre con cupos en 0: no se pre-carga el total de usuarios
	            // a notificar. El valor se setea solo cuando el usuario interactúa con
	            // el input. Al re-consultar se resetea para no arrastrar el valor anterior.
	            _this8.setState({ loading: true, error: null, cupos: 0 });
	            _v2.default.nomina(_this8.props.idNomina).disponibilidadReemplazos().then(function (data) {
	                _this8.setState({ loading: false, data: data });
	            }).catch(function () {
	                _this8.setState({ loading: false, error: 'No se pudo consultar la cantidad de reemplazos disponibles' });
	            });
	        };
	        _this8.onCupos = function (e) {
	            var val = parseInt(e.target.value, 10);
	            if (isNaN(val) || val < 0) val = 0;
	            _this8.setState({ cupos: val });
	        };
	        _this8.enviar = function () {
	            var _this8$state = _this8.state,
	                data = _this8$state.data,
	                cupos = _this8$state.cupos,
	                enviando = _this8$state.enviando;
	
	            if (!data || cupos <= 0 || enviando) return;
	            _this8.setState({ enviando: true, error: null });
	            _v2.default.nomina(_this8.props.idNomina).informarDisponibilidadReemplazos(cupos).then(function (data) {
	                var informados = data.informados ? data.informados.length : 0;
	                if (_this8.props.notificator) {
	                    _this8.props.notificator.success("Disponibilidad del servicio", data.mensaje || 'Se inform\xF3 la disponibilidad del servicio a ' + informados + ' reemplazo(s)', 5 * 1000);
	                }
	                _this8.props.onCerrar();
	            }).catch(function () {
	                _this8.setState({ enviando: false, error: 'Error al informar la disponibilidad del servicio' });
	            });
	        };
	        return _this8;
	    }
	
	    _createClass(MiniAvisoReemplazos, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.consultar();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                loading = _state.loading,
	                error = _state.error,
	                data = _state.data,
	                cupos = _state.cupos,
	                enviando = _state.enviando;
	
	            var disponibles = data && data.disponibles ? data.disponibles.length : 0;
	            var excluidos = data && data.excluidos ? data.excluidos.length : 0;
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'absolute', top: '100%', right: 0, zIndex: 1050, width: 340, marginTop: 6, background: '#fff', border: '1px solid #ccc', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: 12 } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: 13, fontWeight: 'bold', marginBottom: 8 } },
	                    'Informar disponibilidad del servicio'
	                ),
	                loading ? _react2.default.createElement(
	                    'div',
	                    { style: { color: '#777' } },
	                    'Consultando reemplazos disponibles...'
	                ) : null,
	                error ? _react2.default.createElement(
	                    'div',
	                    { style: { color: '#a94442' } },
	                    error
	                ) : null,
	                data && !loading ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            disponibles
	                        ),
	                        ' reemplazo(s) para notificar (lista completa)'
	                    ),
	                    excluidos > 0 ? _react2.default.createElement(
	                        'div',
	                        { style: { color: '#8a6d3b', fontSize: 12 } },
	                        'Se omiten ',
	                        excluidos,
	                        ' por estar como titular en otro servicio'
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 8 } },
	                        _react2.default.createElement(
	                            'label',
	                            { style: { fontWeight: 'normal' } },
	                            'Cantidad de cupos (vacantes) a informar:'
	                        ),
	                        _react2.default.createElement('input', { type: 'number', value: cupos, onChange: this.onCupos, style: { width: 70, marginLeft: 6 } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 10, display: 'flex', justifyContent: 'flex-end' } },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-default btn-sm', onClick: this.props.onCerrar, disabled: enviando, style: { marginRight: 6 } },
	                            'Cancelar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-success btn-sm', onClick: this.enviar, disabled: enviando || cupos <= 0 },
	                            enviando ? 'Enviando...' : 'Enviar'
	                        )
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return MiniAvisoReemplazos;
	}(_react.Component);
	
	MiniAvisoReemplazos.propTypes = {
	    idNomina: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	    notificator: _react.PropTypes.object,
	    onCerrar: _react.PropTypes.func.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelCaptador.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputOperadorPermisoMall = exports.RowOperadorReemplazoSEI = exports.RowOperadorReemplazo = exports.RowOperadorSEIEscondido = exports.RowOperadorSEI = exports.RowOperador = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelCaptador = __webpack_require__(713);
	
	var css = _interopRequireWildcard(_PanelCaptador);
	
	var _InputRun = __webpack_require__(930);
	
	var _Modales = __webpack_require__(918);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Validador Rut
	
	var MESSAGE = "OPERADOR NO PUEDE ASISTIR CON ESTE LIDER";
	
	var RowOperador = exports.RowOperador = function (_React$Component) {
	    _inherits(RowOperador, _React$Component);
	
	    function RowOperador(props) {
	        _classCallCheck(this, RowOperador);
	
	        var _this = _possibleConstructorReturn(this, (RowOperador.__proto__ || Object.getPrototypeOf(RowOperador)).call(this, props));
	
	        _this.state = { checkbox: _this.props.checkboxStatus };
	        return _this;
	    }
	
	    _createClass(RowOperador, [{
	        key: 'onPressEnter',
	        value: function onPressEnter(run) {
	            this.ref_usuarioDV.value = '';
	            this.props.agregarUsuario(run);
	        }
	    }, {
	        key: 'onRUNChange',
	        value: function onRUNChange(usuarioRUN, usuarioDV) {
	            // a medida que escriben el rut, se ira actualizando el DV
	            this.ref_usuarioDV.value = usuarioDV;
	        }
	    }, {
	        key: 'handleChangeTitular',
	        value: function handleChangeTitular(event) {
	            this.props.setStatusCheckBoxEnroqueTitular(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
	            this.setState({ checkbox: event.target.checked });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props !== nextProps) {
	                this.setState({ checkbox: nextProps.checkboxStatus });
	            }
	        }
	        // onColorAsistencia(asistencia) {
	        //     if (asistencia < 2) {
	        //         return css.asistencia_0;
	        //     }
	        //     if (asistencia >= 2) {
	        //         return css.asistencia_2;
	        //     }
	        // }
	
	        // onColorAsistencia2(asistencia) {
	        //     if (asistencia <= 2) {
	        //         return css.asistencia_0;
	        //     }
	        //     if (asistencia == 3) {
	        //         return css.asistencia_3;
	        //     }
	
	        //     if (asistencia == 4) {
	        //         return css.asistencia_4;
	        //     }
	        //     if (asistencia == 5) {
	        //         return css.asistencia_5;
	        //     }
	        // }
	
	    }, {
	        key: 'getIconAsistencia',
	        value: function getIconAsistencia(asistencia) {
	            if (asistencia < 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia >= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-check-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconAsistencia2',
	        value: function getIconAsistencia2(asistencia) {
	            if (asistencia <= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia == 3) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	
	            if (asistencia == 4) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	            if (asistencia == 5) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-shop', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconStyle',
	        value: function getIconStyle(asistencia) {
	            if (asistencia < 2) {
	                return { color: 'red' };
	            }
	            if (asistencia >= 2) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'getIconStyle2',
	        value: function getIconStyle2(asistencia) {
	            if (asistencia <= 2) {
	                return { color: 'red' };
	            }
	            if (asistencia == 3) {
	                return { color: 'red' };
	            }
	            if (asistencia == 4) {
	                return { color: 'green' };
	            }
	            if (asistencia == 5) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var isPermisoMall = this.props.isPermisoMall;
	            if (this.props.personal) {
	                var tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false;
	                // si el operador esta definido, mostrar sus datos
	                var isBaja = this.props.personal.asistencia == "-1";
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 1, style: { backgroundColor: isBaja ? '#fa9c9a' : '' } },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'darkviolet' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                MESSAGE
	                            )
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdNombre },
	                        _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCompleto, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.personal.comuna
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCaptador },
	                        this.props.personal.captador
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo == 'Lider' ? '' + this.props.personal.experienciaComoLider : '',
	                        this.props.cargo == 'Supervisor' ? '' + this.props.personal.experienciaComoSupervisor : '',
	                        this.props.cargo == 'Operador' ? '' + this.props.personal.experienciaComoOperador : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdError },
	                        this.props.personal.error ? this.props.personal.error >= 1 ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            this.props.personal.error
	                        ) : this.props.personal.error : 0
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteoReal },
	                        this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3 },
	                        this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { title: this.props.personal.estadoCI },
	                            this.props.personal.estadoCI === 'Vigente' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_verde },
	                                '\u2705'
	                            ),
	                            this.props.personal.estadoCI === 'Próximo a vencer' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_amarillo },
	                                '\u26A0\uFE0F'
	                            ),
	                            this.props.personal.estadoCI === 'Vencido' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_rojo },
	                                '\u274C'
	                            ),
	                            !['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_gris },
	                                '\u26AA'
	                            )
	                        )
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'td',
	                        null,
	                        tienePermisoMall ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok', style: { color: 'green', fontSize: '16px' } }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove', style: { color: 'red', fontSize: '16px' } })
	                    ) : null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-warning glyphicon glyphicon-remove',
	                            onClick: function onClick() {
	                                _this2.props.quitarUsuario(_this2.props.personal.id, true);
	                            },
	                            title: 'Quitar Operador'
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-info glyphicon glyphicon-triangle-right', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this2.props.cambiarDePanel(_this2.props.personal.id, true, _this2.props.idCaptador);
	                            }
	                        }) : this.props.enroque ? _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleChangeTitular.bind(this), checked: this.state.checkbox }) : _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' } },
	                            _react2.default.createElement(
	                                'i',
	                                { style: this.getIconStyle(this.props.personal.asistencia) },
	                                this.getIconAsistencia(this.props.personal.asistencia)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.editable && this.props.cargo == 'Operador' ? null : _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' } },
	                            _react2.default.createElement(
	                                'i',
	                                { style: this.getIconStyle2(this.props.personal.asistencia) },
	                                this.getIconAsistencia2(this.props.personal.asistencia)
	                            )
	                        )
	                    )
	                );
	            } else if (this.props.sumaUnidades) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 3 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Conteo'
	                        )
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.sumaUnidades
	                    ),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            } else if (this.props.diferenciaUnidades) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 4 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Direrencia'
	                        )
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdDiferencia },
	                        this.props.diferenciaUnidades
	                    ),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            } else {
	                // si no esta definido, mostrar el formulario para agregarlo
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 2 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.editable ? _react2.default.createElement(_InputRun.InputRun, { key: 1,
	                            onPressEnter: this.onPressEnter.bind(this),
	                            onRUNChange: this.onRUNChange.bind(this)
	                        }) : _react2.default.createElement('input', { type: 'text', key: 2, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        _react2.default.createElement('input', { type: 'text', value: '', disabled: true, ref: function ref(_ref) {
	                                return _this2.ref_usuarioDV = _ref;
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdNombre },
	                        _react2.default.createElement('input', { type: 'text', value: '', disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            }
	        }
	    }]);
	
	    return RowOperador;
	}(_react2.default.Component);
	
	RowOperador.propTypes = {
	    editable: PropTypes.bool.isRequired,
	    //editarTodasNominas: PropTypes.bool.isRequired,
	    correlativo: PropTypes.string.isRequired,
	    personal: PropTypes.object,
	    cargo: PropTypes.string,
	    enroque: PropTypes.bool
	};
	
	var RowOperadorSEI = exports.RowOperadorSEI = function (_React$Component2) {
	    _inherits(RowOperadorSEI, _React$Component2);
	
	    function RowOperadorSEI(props) {
	        _classCallCheck(this, RowOperadorSEI);
	
	        var _this3 = _possibleConstructorReturn(this, (RowOperadorSEI.__proto__ || Object.getPrototypeOf(RowOperadorSEI)).call(this, props));
	
	        _this3.state = { checkbox: _this3.props.checkboxStatus };
	        return _this3;
	    }
	
	    _createClass(RowOperadorSEI, [{
	        key: 'onPressEnter',
	        value: function onPressEnter(run) {
	            this.ref_usuarioDV.value = '';
	            this.props.agregarUsuario(run);
	        }
	    }, {
	        key: 'onRUNChange',
	        value: function onRUNChange(usuarioRUN, usuarioDV) {
	            // a medida que escriben el rut, se ira actualizando el DV
	            this.ref_usuarioDV.value = usuarioDV;
	        }
	    }, {
	        key: 'handleChangeTitular',
	        value: function handleChangeTitular(event) {
	            this.props.setStatusCheckBoxEnroqueTitular(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
	            this.setState({ checkbox: event.target.checked });
	        }
	        // onColorAsistencia(asistencia) {
	        //     /*if (asistencia == 0) {
	        //         return css.asistencia_0;
	        //     }
	        //     if (asistencia == 1) {
	        //         return css.asistencia_1;
	        //     }*/
	        //     if (asistencia < 2) {
	        //         return css.asistencia_0;
	        //     }
	        //     if (asistencia >= 2) {
	        //         return css.asistencia_2;
	        //     }
	        // }
	
	        // onColorAsistencia2(asistencia) {
	        //     if (asistencia <= 2) {
	        //         return css.asistencia_0;
	        //     }
	        //     if (asistencia == 3) {
	        //         return css.asistencia_3;
	        //     }
	
	        //     if (asistencia == 4) {
	        //         return css.asistencia_4;
	        //     }
	        //     if (asistencia == 5) {
	        //         return css.asistencia_5;
	        //     }
	        // }
	
	    }, {
	        key: 'getIconAsistencia',
	        value: function getIconAsistencia(asistencia) {
	            if (asistencia < 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia >= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-check-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconAsistencia2',
	        value: function getIconAsistencia2(asistencia) {
	            if (asistencia <= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia == 3) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	
	            if (asistencia == 4) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	            if (asistencia == 5) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-shop', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconStyle',
	        value: function getIconStyle(asistencia) {
	            if (asistencia < 2) {
	                return { color: 'red' };
	            }
	            if (asistencia >= 2) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'getIconStyle2',
	        value: function getIconStyle2(asistencia) {
	            if (asistencia <= 2) {
	                return { color: 'red' };
	            }
	            if (asistencia == 3) {
	                return { color: 'red' };
	            }
	            if (asistencia == 4) {
	                return { color: 'green' };
	            }
	            if (asistencia == 5) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props !== nextProps) {
	                this.setState({ checkbox: nextProps.checkboxStatus });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var isPermisoMall = this.props.isPermisoMall;
	            if (this.props.personal) {
	                var tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false;
	                // si el operador esta definido, mostrar sus datos
	                var isBaja = this.props.personal.asistencia == "-1";
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 1, style: { backgroundColor: isBaja ? '#fa9c9a' : '' } },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'darkviolet' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                MESSAGE
	                            )
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'darkviolet' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdNombre },
	                        _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCompleto, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                this.props.personal.comuna
	                            ),
	                            !this.props.personal.existeTarifa && this.props.cargo == "Operador" ? _react2.default.createElement(
	                                'div',
	                                { className: css.textoConTooltip },
	                                _react2.default.createElement('div', { className: 'glyphicon glyphicon-usd', style: { color: 'red', fontSize: 14 } }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { display: 'flex', flexDirection: 'row' } },
	                                        this.props.personal.comuna + '-' + this.props.comunaInventario + ': Tarifa no existe'
	                                    )
	                                )
	                            ) : null
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCaptador },
	                        this.props.personal.captador
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo == 'Lider' ? '' + this.props.personal.experienciaComoLider : '',
	                        this.props.cargo == 'Supervisor' ? '' + this.props.personal.experienciaComoSupervisor : '',
	                        this.props.cargo == 'Operador' ? '' + this.props.personal.experienciaComoOperador : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdError },
	                        this.props.personal.error ? this.props.personal.error >= 1 ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            this.props.personal.error
	                        ) : this.props.personal.error : 0
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteoReal },
	                        this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3 },
	                        this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { title: this.props.personal.estadoCI },
	                            this.props.personal.estadoCI === 'Vigente' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_verde },
	                                '\u2705'
	                            ),
	                            this.props.personal.estadoCI === 'Próximo a vencer' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_amarillo },
	                                '\u26A0\uFE0F'
	                            ),
	                            this.props.personal.estadoCI === 'Vencido' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_rojo },
	                                '\u274C'
	                            ),
	                            !['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_gris },
	                                '\u26AA'
	                            )
	                        )
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'td',
	                        null,
	                        tienePermisoMall ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok', style: { color: 'green', fontSize: '16px' } }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove', style: { color: 'red', fontSize: '16px' } })
	                    ) : null,
	                    this.props.activarPermisoMall ? _react2.default.createElement(
	                        'td',
	                        { key: 'A1', colSpan: '3' },
	                        _react2.default.createElement(InputOperadorPermisoMall, {
	                            disabled: tienePermisoMall,
	                            idNomina: this.props.idNomina,
	                            idOperador: this.props.personal.id,
	                            incluir_permisomall: this.props.personal.incluir_permisomall,
	                            selectedPermisoId: this.props.selectedPermisoId,
	                            permisoCompleto: this.props.permisoCompleto,
	                            notificator: this.props.notificator
	                        })
	                    ) : [_react2.default.createElement(
	                        'td',
	                        { key: 'B1' },
	                        this.props.editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-warning glyphicon glyphicon-remove',
	                            onClick: function onClick() {
	                                _this4.props.quitarUsuario(_this4.props.personal.id, true);
	                            },
	                            title: 'Quitar Operador'
	                        }) : null
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'B2' },
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-danger glyphicon glyphicon-ban-circle', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this4.props.blockOperador(_this4.props.personal, _this4.props.idNomina);
	                            },
	                            title: 'Bloquear Operador'
	                        }) : this.props.cargo == "Operador" ? _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' } },
	                            _react2.default.createElement(
	                                'i',
	                                { style: this.getIconStyle(this.props.personal.asistencia) },
	                                this.getIconAsistencia(this.props.personal.asistencia)
	                            )
	                        ) : null
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'B3' },
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-info glyphicon glyphicon-triangle-right', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this4.props.cambiarDePanel(_this4.props.personal.id, true, _this4.props.personal.idCaptador);
	                            }
	                        }) : this.props.enroque ? _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleChangeTitular.bind(this), checked: this.state.checkbox }) : this.props.cargo == "Operador" ? _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' } },
	                            _react2.default.createElement(
	                                'i',
	                                { style: this.getIconStyle2(this.props.personal.asistencia) },
	                                this.getIconAsistencia2(this.props.personal.asistencia)
	                            )
	                        ) : null
	                    )]
	                );
	            } else if (this.props.sumaUnidades) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 3 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Conteo'
	                        )
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.sumaUnidades
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.sumaConteo
	                    ),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            } else if (this.props.diferenciaUnidades) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 4 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Direrencia'
	                        )
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdDiferencia },
	                        this.props.diferenciaUnidades
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdDiferencia },
	                        this.props.diferenciaConteo
	                    ),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            } else {
	                // si no esta definido, mostrar el formulario para agregarlo
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 2 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.editable ? _react2.default.createElement(_InputRun.InputRun, { key: 1,
	                            onPressEnter: this.onPressEnter.bind(this),
	                            onRUNChange: this.onRUNChange.bind(this)
	                        }) : _react2.default.createElement('input', { type: 'text', key: 2, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        _react2.default.createElement('input', { type: 'text', value: '', disabled: true, ref: function ref(_ref2) {
	                                return _this4.ref_usuarioDV = _ref2;
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdNombre },
	                        _react2.default.createElement('input', { type: 'text', value: '', disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    isPermisoMall ? _react2.default.createElement('td', null) : null,
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            }
	        }
	    }]);
	
	    return RowOperadorSEI;
	}(_react2.default.Component);
	
	RowOperadorSEI.propTypes = {
	    editable: PropTypes.bool.isRequired,
	    //editarTodasNominas: PropTypes.bool.isRequired,
	    correlativo: PropTypes.string.isRequired,
	    personal: PropTypes.object,
	    cargo: PropTypes.string,
	    enroque: PropTypes.bool
	};
	
	var RowOperadorSEIEscondido = exports.RowOperadorSEIEscondido = function (_React$Component3) {
	    _inherits(RowOperadorSEIEscondido, _React$Component3);
	
	    function RowOperadorSEIEscondido(props) {
	        _classCallCheck(this, RowOperadorSEIEscondido);
	
	        var _this5 = _possibleConstructorReturn(this, (RowOperadorSEIEscondido.__proto__ || Object.getPrototypeOf(RowOperadorSEIEscondido)).call(this, props));
	
	        _this5.state = { checkbox: _this5.props.checkboxStatus };
	        return _this5;
	    }
	
	    _createClass(RowOperadorSEIEscondido, [{
	        key: 'getIconAsistencia',
	        value: function getIconAsistencia(asistencia) {
	            if (asistencia < 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia >= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-check-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconAsistencia2',
	        value: function getIconAsistencia2(asistencia) {
	            if (asistencia <= 2) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-x-circle-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' })
	                );
	            }
	            if (asistencia == 3) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	
	            if (asistencia == 4) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-car-front-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z' })
	                );
	            }
	            if (asistencia == 5) {
	                return _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', fill: 'currentColor', className: 'bi bi-shop', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z' })
	                );
	            }
	        }
	    }, {
	        key: 'getIconStyle',
	        value: function getIconStyle(asistencia) {
	            if (asistencia < 2) {
	                return { color: 'red' };
	            }
	            if (asistencia >= 2) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'getIconStyle2',
	        value: function getIconStyle2(asistencia) {
	            if (asistencia <= 2) {
	                return { color: 'red' };
	            }
	            if (asistencia == 3) {
	                return { color: 'red' };
	            }
	            if (asistencia == 4) {
	                return { color: 'green' };
	            }
	            if (asistencia == 5) {
	                return { color: 'green' };
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props !== nextProps) {
	                this.setState({ checkbox: nextProps.checkboxStatus });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var isPermisoMall = this.props.isPermisoMall;
	            if (this.props.personal) {
	                var tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false;
	                // si el operador esta definido, mostrar sus datos
	                var isBaja = this.props.personal.asistencia == "-1";
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 1, style: { backgroundColor: isBaja ? '#fa9c9a' : '' } },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'darkviolet' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                MESSAGE
	                            )
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'darkviolet' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdNombre },
	                        _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCompleto, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.personal.comuna
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCaptador },
	                        this.props.personal.captador
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo == 'Lider' ? '' + this.props.personal.experienciaComoLider : '',
	                        this.props.cargo == 'Supervisor' ? '' + this.props.personal.experienciaComoSupervisor : '',
	                        this.props.cargo == 'Operador' ? '' + this.props.personal.experienciaComoOperador : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdError },
	                        this.props.personal.error ? this.props.personal.error >= 1 ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            this.props.personal.error
	                        ) : this.props.personal.error : 0
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteoReal },
	                        this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3 },
	                        this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { title: this.props.personal.estadoCI },
	                            this.props.personal.estadoCI === 'Vigente' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_verde },
	                                '\u2705'
	                            ),
	                            this.props.personal.estadoCI === 'Próximo a vencer' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_amarillo },
	                                '\u26A0\uFE0F'
	                            ),
	                            this.props.personal.estadoCI === 'Vencido' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_rojo },
	                                '\u274C'
	                            ),
	                            !['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_gris },
	                                '\u26AA'
	                            )
	                        )
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'td',
	                        null,
	                        tienePermisoMall ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok', style: { color: 'green', fontSize: '16px' } }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove', style: { color: 'red', fontSize: '16px' } })
	                    ) : null,
	                    this.props.activarPermisoMall ? _react2.default.createElement(
	                        'td',
	                        { key: 'A1', colSpan: '3' },
	                        _react2.default.createElement(InputOperadorPermisoMall, {
	                            idNomina: this.props.idNomina,
	                            idOperador: this.props.personal.id,
	                            incluir_permisomall: this.props.personal.incluir_permisomall
	                            //selectedPermisoId={this.props.selectedPermisoId}
	                            , permisoCompleto: this.props.permisoCompleto,
	                            notificator: this.props.notificator
	                        })
	                    ) : [_react2.default.createElement('td', { key: 'B1' }), _react2.default.createElement('td', { key: 'B2' }), _react2.default.createElement(
	                        'td',
	                        { key: 'B3' },
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-info glyphicon glyphicon-triangle-right',
	                            onClick: function onClick() {
	                                _this6.props.quitarEscondido(_this6.props.personal.id);
	                            }
	                        }) : null
	                        // (this.props.enroque ?
	                        //     <input type="checkbox" onChange={this.handleChangeTitular.bind(this)} checked={this.state.checkbox} />
	                        //     : this.props.cargo == "Operador"
	                        //         ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
	                        //             <i style={this.getIconStyle2(this.props.personal.asistencia)}>
	                        //                 {this.getIconAsistencia2(this.props.personal.asistencia)}
	                        //             </i>
	                        //         </div>
	                        //         : null)
	
	                    )]
	                );
	            }
	        }
	    }]);
	
	    return RowOperadorSEIEscondido;
	}(_react2.default.Component);
	
	RowOperadorSEIEscondido.propTypes = {
	    editable: PropTypes.bool.isRequired,
	    //editarTodasNominas: PropTypes.bool.isRequired,
	    correlativo: PropTypes.string.isRequired,
	    personal: PropTypes.object,
	    cargo: PropTypes.string,
	    enroque: PropTypes.bool
	
	    // REEMPLAZOS
	
	};
	var RowOperadorReemplazo = exports.RowOperadorReemplazo = function (_React$Component4) {
	    _inherits(RowOperadorReemplazo, _React$Component4);
	
	    function RowOperadorReemplazo(props) {
	        _classCallCheck(this, RowOperadorReemplazo);
	
	        var _this7 = _possibleConstructorReturn(this, (RowOperadorReemplazo.__proto__ || Object.getPrototypeOf(RowOperadorReemplazo)).call(this, props));
	
	        _this7.state = { showModal: false };
	        return _this7;
	    }
	
	    _createClass(RowOperadorReemplazo, [{
	        key: 'handleClick',
	        value: function handleClick() {
	            var fechaInventario = new Date(this.props.fechaInventario + 'T09:00:00');
	            var fechaActual = new Date();
	            if (fechaInventario.toDateString() === fechaActual.toDateString() && fechaActual > fechaInventario) {
	                this.setState({ showModal: true });
	            } else {
	                this.setState({ showModal: false });
	                this.props.cambiarDePanel(this.props.personal.id, false, this.props.personal.idCaptador);
	            }
	        }
	    }, {
	        key: 'hideModal',
	        value: function hideModal() {
	            this.setState({ showModal: false });
	        }
	    }, {
	        key: 'onPressEnter',
	        value: function onPressEnter(run) {
	            this.ref_usuarioDV.value = '';
	            this.props.agregarUsuario(run);
	        }
	    }, {
	        key: 'onRUNChange',
	        value: function onRUNChange(usuarioRUN, usuarioDV) {
	            // a medida que escriben el rut, se ira actualizando el DV
	            this.ref_usuarioDV.value = usuarioDV;
	        }
	    }, {
	        key: 'handleChangeEnroque',
	        value: function handleChangeEnroque(event) {
	            this.props.setStatusCheckBoxEnroqueReemplazo(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
	            this.setState({ checkbox: event.target.checked });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props !== nextProps) {
	                this.setState({ checkbox: nextProps.checkboxStatus });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            if (this.props.personal) {
	                var isPermisoMall = this.props.isPermisoMall;
	                var tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false;
	                // console.log(this.props.personal);
	                // si el operador esta definido, mostrar sus datos
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 1 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.state.showModal && _react2.default.createElement(_Modales.ModalReemplazoPorBaja, { cambiarPanel: this.props.cambiarDePanel, id: this.props.personal.id,
	                            captador: this.props.idCaptador, hideModal: this.hideModal.bind(this), operador: this.props.personal.nombreCorto }),
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-success glyphicon glyphicon-triangle-left',
	                            onClick: this.handleClick.bind(this),
	                            title: 'Cambiar a n\xF3mina titular'
	                        }) : this.props.enroque ? _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleChangeEnroque.bind(this), checked: this.state.checkbox }) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-warning glyphicon glyphicon-remove', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this8.props.quitarUsuario(_this8.props.personal.id, false);
	                            },
	                            title: 'Quitar Operador n\xF3mina reemplazo'
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-warning glyphicon glyphicon-ban-circle', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this8.props.suspendOperator(_this8.props.personal);
	                            },
	                            title: 'Suspender operador'
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'darkviolet' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                MESSAGE
	                            )
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'darkviolet' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idnominatitular > 0 ? css.operadorEnOtraNominaMismoDia : css.tdNombre },
	                        this.props.personal.idnominatitular > 0 ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCorto, disabled: true }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.personal.datos_nomina_titular
	                            )
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCorto, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.personal.comuna
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCaptador },
	                        this.props.personal.captador
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo == 'Lider' ? '' + this.props.personal.experienciaComoLider : '',
	                        this.props.cargo == 'Supervisor' ? '' + this.props.personal.experienciaComoSupervisor : '',
	                        this.props.cargo == 'Operador' ? '' + this.props.personal.experienciaComoOperador : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdError },
	                        this.props.personal.error ? this.props.personal.error >= 1 ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            this.props.personal.error
	                        ) : this.props.personal.error : 0
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteoReal },
	                        this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3 },
	                        this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { title: this.props.personal.estadoCI },
	                            this.props.personal.estadoCI === 'Vigente' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_verde },
	                                '\u2705'
	                            ),
	                            this.props.personal.estadoCI === 'Próximo a vencer' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_amarillo },
	                                '\u26A0\uFE0F'
	                            ),
	                            this.props.personal.estadoCI === 'Vencido' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_rojo },
	                                '\u274C'
	                            ),
	                            !['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_gris },
	                                '\u26AA'
	                            )
	                        )
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'td',
	                        null,
	                        tienePermisoMall ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok', style: { color: 'green', fontSize: '16px' } }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove', style: { color: 'red', fontSize: '16px' } })
	                    ) : null
	                );
	            } else {
	                // si no esta definido, mostrar el formulario para agregarlo
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 2 },
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', { className: css.tdUsuarioRUN }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.editable ? _react2.default.createElement('input', { type: 'text', value: '', disabled: true, ref: function ref(_ref3) {
	                                return _this8.ref_usuarioDV = _ref3;
	                            } }) : null
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            }
	        }
	    }]);
	
	    return RowOperadorReemplazo;
	}(_react2.default.Component);
	
	RowOperadorReemplazo.propTypes = {
	    editable: PropTypes.bool.isRequired,
	    //editarTodasNominas: PropTypes.bool.isRequired,
	    correlativo: PropTypes.string.isRequired,
	    personal: PropTypes.object,
	    cargo: PropTypes.string
	};
	
	var RowOperadorReemplazoSEI = exports.RowOperadorReemplazoSEI = function (_React$Component5) {
	    _inherits(RowOperadorReemplazoSEI, _React$Component5);
	
	    function RowOperadorReemplazoSEI(props) {
	        _classCallCheck(this, RowOperadorReemplazoSEI);
	
	        var _this9 = _possibleConstructorReturn(this, (RowOperadorReemplazoSEI.__proto__ || Object.getPrototypeOf(RowOperadorReemplazoSEI)).call(this, props));
	
	        _this9.state = { checkbox: _this9.props.checkboxStatus, showModal: false, showModalCaptador: false };
	        return _this9;
	    }
	
	    _createClass(RowOperadorReemplazoSEI, [{
	        key: 'handleClick',
	        value: function handleClick() {
	            var fechaInventario = new Date(this.props.fechaInventario + 'T09:00:00');
	            var fechaActual = new Date();
	            if (fechaInventario.toDateString() === fechaActual.toDateString() && fechaActual > fechaInventario) {
	                this.setState({ showModal: true });
	            } else {
	                this.setState({ showModal: false });
	                if (this.props.personal.esLider == false && this.props.personal.idCaptador == 1) {
	                    this.setState({ showModalCaptador: true });
	                } else {
	                    this.props.cambiarDePanel(this.props.personal.id, false, this.props.personal.idCaptador);
	                }
	            }
	        }
	    }, {
	        key: 'hideModal',
	        value: function hideModal() {
	            this.setState({ showModal: false, showModalCaptador: false });
	        }
	    }, {
	        key: 'onPressEnter',
	        value: function onPressEnter(run) {
	            this.ref_usuarioDV.value = '';
	            this.props.agregarUsuario(run);
	        }
	    }, {
	        key: 'onRUNChange',
	        value: function onRUNChange(usuarioRUN, usuarioDV) {
	            // a medida que escriben el rut, se ira actualizando el DV
	            this.ref_usuarioDV.value = usuarioDV;
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            // console.log(event.target.disabled)
	            this.props.setStatusCheckBox(this.props.personal.id, event.target.checked);
	            this.setState({ checkbox: event.target.checked });
	        }
	    }, {
	        key: 'handleChangeEnroque',
	        value: function handleChangeEnroque(event) {
	            this.props.setStatusCheckBoxEnroqueReemplazo(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
	            this.setState({ checkbox: event.target.checked });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props !== nextProps) {
	                this.setState({ checkbox: nextProps.checkboxStatus });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this10 = this;
	
	            if (this.props.personal) {
	                var isPermisoMall = this.props.isPermisoMall;
	                var tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false;
	                // console.log('2', this.props.personal);
	                var condiciones = this.props.personal.experienciaComoOperador <= 4 || this.props.personal.error > 0.5;
	                var shouldDisable = this.props.puedeAsignar ? false : this.props.cliente == 12 || this.props.cliente == 24 ? condiciones : false;
	                // si el operador esta definido, mostrar sus datos
	                return _react2.default.createElement(
	                    'tr',
	                    { style: { backgroundColor: this.props.personal.asistencia == -1 ? 'rgb(243, 182, 182)' : this.props.personal.esLider ? 'rgb(233, 243, 252)' : '' } },
	                    this.props.activarPermisoMall ? [_react2.default.createElement(
	                        'td',
	                        { key: 'A1' },
	                        this.props.correlativo
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'A2', colSpan: '2' },
	                        _react2.default.createElement(InputOperadorPermisoMall, {
	                            disabled: tienePermisoMall,
	                            idNomina: this.props.idNomina,
	                            idOperador: this.props.personal.id,
	                            incluir_permisomall: this.props.personal.incluir_permisomall,
	                            orden_permisomall: this.props.personal.orden_permisomall
	                            //selectedPermisoId={this.props.selectedPermisoId}
	                            , permisoCompleto: this.props.permisoCompleto,
	                            notificator: this.props.notificator
	                        })
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'A3' },
	                        this.props.personal.incluir_permisomall ? this.props.personal.orden_permisomall : ""
	                    )] : [_react2.default.createElement(
	                        'td',
	                        { key: 'B1' },
	                        this.props.editable ? _react2.default.createElement(OperadorEscondido, { index: this.props.correlativo, idUser: this.props.personal.id,
	                            funcion: this.props.operadorEscondido, nombre: this.props.personal.nombreCorto }) : this.props.correlativo
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'B2' },
	                        this.state.showModal && _react2.default.createElement(_Modales.ModalReemplazoPorBaja, { cambiarPanel: this.props.cambiarDePanel, id: this.props.personal.id,
	                            captador: this.props.idCaptador, hideModal: this.hideModal.bind(this), operador: this.props.personal.nombreCorto }),
	                        this.state.showModalCaptador && _react2.default.createElement(_Modales.ModalReemplazoCaptador, { cambiarPanel: this.props.cambiarDePanel, id: this.props.personal.id,
	                            captador: this.props.personal.idCaptador, hideModal: this.hideModal.bind(this), operador: this.props.personal.nombreCorto, cambiarCaptador: this.props.cambiarCaptador }),
	                        this.props.editable && this.props.cargo == 'Operador' ? _react2.default.createElement('button', { className: 'btn btn-xs btn-success glyphicon glyphicon-triangle-left',
	                            onClick: this.handleClick.bind(this),
	                            title: 'Cambiar a n\xF3mina titular',
	                            disabled: shouldDisable
	                        }) : this.props.enroque ? _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleChangeEnroque.bind(this), checked: shouldDisable ? false : this.state.checkbox, disabled: shouldDisable }) : null
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'B3' },
	                        this.props.editable ? _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleChange.bind(this), checked: shouldDisable ? false : this.state.checkbox, disabled: shouldDisable }) : null
	                    ), _react2.default.createElement(
	                        'td',
	                        { key: 'B4' },
	                        this.props.editable ? _react2.default.createElement('button', { className: 'btn btn-xs btn-warning glyphicon glyphicon-remove', disabled: this.props.operadorTitularId,
	                            onClick: function onClick() {
	                                _this10.props.quitarUsuario(_this10.props.personal.id, false);
	                            },
	                            title: 'Quitar Operador n\xF3mina reemplazo'
	                        }) : null
	                    )],
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.personal.escondido ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'rgb(16, 138, 198)' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Operador Escondido'
	                            )
	                        ) : this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'darkviolet' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                MESSAGE
	                            )
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.bloqueadoLocal ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'rgb(16, 185, 129)' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                        ) : this.props.personal.incompatibles.length > 0 ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'strong',
	                                { style: { color: 'rgb(27, 36, 130)' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, style: { cursor: 'help' }, disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Incompatible con:',
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { display: 'block', marginTop: '8px' } },
	                                    this.props.personal.incompatibles.map(function (incompatible, index) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { key: index },
	                                            incompatible
	                                        );
	                                    })
	                                )
	                            )
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioRUN, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.personal.escondido ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'rgb(16, 138, 198)' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoLider ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'darkviolet' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueado ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoCliente ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'orange' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : this.props.personal.bloqueadoLocal ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'rgb(16, 185, 129)' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.usuarioDV, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idnominatitular > 0 ? css.operadorEnOtraNominaMismoDia : css.tdNombre },
	                        this.props.personal.idnominatitular > 0 ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCorto, disabled: true }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.personal.datos_nomina_titular
	                            )
	                        ) : this.props.personal.asistencia == -2 ? _react2.default.createElement(
	                            'p',
	                            { className: css.textoConTooltip, style: { overflow: 'hidden' } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative' } },
	                                _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCorto, disabled: true }),
	                                _react2.default.createElement('div', { className: 'glyphicon glyphicon-exclamation-sign', style: { position: 'absolute', top: 0, right: 0, color: 'orange' } })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Op. cancel\xF3 inventario'
	                            )
	                        ) : _react2.default.createElement('input', { type: 'text', value: this.props.personal.nombreCorto, disabled: true })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.personal.comuna
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCaptador },
	                        this.props.personal.captador
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.cargo == 'Lider' ? '' + this.props.personal.experienciaComoLider : '',
	                        this.props.cargo == 'Supervisor' ? '' + this.props.personal.experienciaComoSupervisor : '',
	                        this.props.cargo == 'Operador' ? '' + this.props.personal.experienciaComoOperador : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdError },
	                        this.props.personal.error ? this.props.personal.error >= 1 ? _react2.default.createElement(
	                            'strong',
	                            { style: { color: 'red' } },
	                            this.props.personal.error
	                        ) : this.props.personal.error : 0
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteo },
	                        this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdConteoReal },
	                        this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3 },
	                        this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { title: this.props.personal.estadoCI },
	                            this.props.personal.estadoCI === 'Vigente' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_verde },
	                                '\u2705'
	                            ),
	                            this.props.personal.estadoCI === 'Próximo a vencer' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_amarillo },
	                                '\u26A0\uFE0F'
	                            ),
	                            this.props.personal.estadoCI === 'Vencido' && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_rojo },
	                                '\u274C'
	                            ),
	                            !['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) && _react2.default.createElement(
	                                'span',
	                                { className: css.emoji_gris },
	                                '\u26AA'
	                            )
	                        )
	                    ),
	                    isPermisoMall ? _react2.default.createElement(
	                        'td',
	                        null,
	                        tienePermisoMall ? _react2.default.createElement('div', { className: 'glyphicon glyphicon-ok', style: { color: 'green', fontSize: '16px' } }) : _react2.default.createElement('div', { className: 'glyphicon glyphicon-remove', style: { color: 'red', fontSize: '16px' } })
	                    ) : null
	                );
	            } else {
	                // si no esta definido, mostrar el formulario para agregarlo
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 2 },
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioRUN },
	                        this.props.editable ? _react2.default.createElement(_InputRun.InputRun, { key: 1,
	                            onPressEnter: this.onPressEnter.bind(this),
	                            onRUNChange: this.onRUNChange.bind(this)
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUsuarioDV },
	                        this.props.editable ? _react2.default.createElement('input', { type: 'text', value: '', disabled: true, ref: function ref(_ref4) {
	                                return _this10.ref_usuarioDV = _ref4;
	                            } }) : null
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null)
	                );
	            }
	        }
	    }]);
	
	    return RowOperadorReemplazoSEI;
	}(_react2.default.Component);
	
	RowOperadorReemplazoSEI.propTypes = {
	    editable: PropTypes.bool.isRequired,
	    //editarTodasNominas: PropTypes.bool.isRequired,
	    correlativo: PropTypes.string.isRequired,
	    personal: PropTypes.object,
	    cargo: PropTypes.string,
	    enroque: PropTypes.bool
	};
	
	var OperadorEscondido = function OperadorEscondido(_ref5) {
	    var index = _ref5.index,
	        idUser = _ref5.idUser,
	        funcion = _ref5.funcion,
	        nombre = _ref5.nombre;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'div',
	                { onClick: showModal },
	                _react2.default.createElement(
	                    'div',
	                    { style: { cursor: 'pointer' } },
	                    index
	                ),
	                isVisible && _react2.default.createElement(_Modales.ModalOperadorEscondido, {
	                    operador: nombre,
	                    id: idUser,
	                    setEscondido: funcion,
	                    hideModal: hideModal
	                })
	            );
	        }
	    );
	};
	
	var InputOperadorPermisoMall = exports.InputOperadorPermisoMall = function (_React$Component6) {
	    _inherits(InputOperadorPermisoMall, _React$Component6);
	
	    function InputOperadorPermisoMall(props) {
	        _classCallCheck(this, InputOperadorPermisoMall);
	
	        var _this11 = _possibleConstructorReturn(this, (InputOperadorPermisoMall.__proto__ || Object.getPrototypeOf(InputOperadorPermisoMall)).call(this, props));
	
	        _this11.handleChange = function (event) {
	            var checked = event.target.checked;
	            //const selectedPermisoId = this.props.selectedPermisoId
	            _this11.setState({ checkbox: checked, loading: true });
	            if (checked) {
	                _this11.context.updateNominaPermisoMall(_this11.props.idOperador, checked, 0);
	            }
	            fetch('/api/nomina/incluir-permisomall', {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    idNomina: _this11.props.idNomina,
	                    idOperador: _this11.props.idOperador,
	                    incluir_permisomall: checked
	                    //selectedPermisoId: selectedPermisoId
	                })
	            }).then(function (response) {
	                return response.json().then(function (json) {
	                    if (!response.ok) {
	                        throw json;
	                    }
	                    return json;
	                });
	            }).then(function (dataResponse) {
	                var message = dataResponse.message,
	                    data = dataResponse.data;
	
	                _this11.context.updateNominaPermisoMall(_this11.props.idOperador, checked, data.orden);
	                _this11.props.notificator.success('Permiso mall actualizado', 'El permiso mall se actualizó correctamente', 4 * 1000);
	            }).catch(function (error) {
	                _this11.props.notificator.error('Error al actualizar el permiso mall', error, 4 * 1000);
	                _this11.setState({ checkbox: _this11.props.incluir_permisomall });
	            }).finally(function () {
	                _this11.setState({ loading: false });
	            });
	        };
	
	        _this11.state = {
	            checkbox: _this11.props.incluir_permisomall,
	            loading: false
	        };
	        return _this11;
	    }
	
	    _createClass(InputOperadorPermisoMall, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.incluir_permisomall != this.props.incluir_permisomall) {
	                var nextChecked = this.props.incluir_permisomall;
	                if (this.state.checkbox != nextChecked) {
	                    this.setState({ checkbox: nextChecked });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement('input', { type: 'checkbox',
	                    disabled: this.props.permisoCompleto && !this.state.checkbox || this.state.loading || this.props.disabled,
	                    checked: this.state.checkbox,
	                    onChange: this.handleChange,
	                    style: { height: '20px', width: '20px' }
	                })
	            );
	        }
	    }]);
	
	    return InputOperadorPermisoMall;
	}(_react2.default.Component);
	
	InputOperadorPermisoMall.propTypes = {
	    idNomina: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	    idOperador: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	    incluir_permisomall: PropTypes.oneOfType([PropTypes.bool]).isRequired
	    //selectedPermisoId: PropTypes.string,
	};
	
	InputOperadorPermisoMall.contextTypes = {
	    updateNominaPermisoMall: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowOperador.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputRun = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValidadorRUN = __webpack_require__(756);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// Validador Rut
	
	// Componentes
	
	var InputRun = exports.InputRun = function (_React$Component) {
	    _inherits(InputRun, _React$Component);
	
	    function InputRun(props) {
	        _classCallCheck(this, InputRun);
	
	        var _this = _possibleConstructorReturn(this, (InputRun.__proto__ || Object.getPrototypeOf(InputRun)).call(this, props));
	
	        _this.state = {
	            RUN: _this.props.rut ? _this.props.rut : '',
	            RV: ''
	        };
	        return _this;
	    }
	
	    _createClass(InputRun, [{
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var _this2 = this;
	
	            var RUN = evt.target.value;
	
	            // si los campos de textos no son validos, entonces no deja que los campos se modifiquen
	            if (RUN === '') {
	                this.setState({ RUN: '', DV: '' }, function () {
	                    _this2.props.onRUNChange('', '');
	                });
	            }
	            // es valido si tiene de 1 a 8 digitos
	            if (/^[0-9]{1,8}$/.test(RUN)) {
	                var DV = (0, _ValidadorRUN.obtenerVerificador)(RUN);
	                this.setState({ RUN: RUN, DV: DV }, function () {
	                    _this2.props.onRUNChange(RUN, DV);
	                });
	            }
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                this.props.onPressEnter(this.state.RUN);
	                this.setState({ RUN: '', DV: '' });
	                evt.preventDefault();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                this.props.onPressEnter(this.state.RUN);
	                this.setState({ RUN: '', DV: '' });
	                evt.preventDefault();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('input', { type: 'text',
	                className: this.props.className ? this.props.className : '',
	                value: this.state.RUN,
	                onChange: this.onInputChange.bind(this),
	                onKeyDown: this.inputOnKeyDown.bind(this)
	            });
	        }
	    }]);
	
	    return InputRun;
	}(_react2.default.Component);
	
	InputRun.propTypes = {
	    onPressEnter: PropTypes.func,
	    onRUNChange: PropTypes.func.isRequired
	};
	InputRun.defaultProps = {};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputRun.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectAlternateLeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectAlternateLeader = exports.SelectAlternateLeader = function (_Component) {
	    _inherits(SelectAlternateLeader, _Component);
	
	    function SelectAlternateLeader(props) {
	        _classCallCheck(this, SelectAlternateLeader);
	
	        var _this = _possibleConstructorReturn(this, (SelectAlternateLeader.__proto__ || Object.getPrototypeOf(SelectAlternateLeader)).call(this, props));
	
	        _this.state = {
	            defaultRutLeader: ""
	        };
	        _this.onSelectAlternateLeader = function (evt) {
	            var newValue = evt.target.value;
	            _this.setState({
	                defaultRutLeader: newValue
	            }, function () {
	                return _this.addAlternateLeader();
	            });
	        };
	        _this.addAlternateLeader = function () {
	            var defaultRutLeader = _this.state.defaultRutLeader;
	            _this.props.addAlternateLeader(defaultRutLeader);
	            _this.setState({ defaultRutLeader: "" });
	        };
	        return _this;
	    }
	
	    _createClass(SelectAlternateLeader, [{
	        key: "render",
	        value: function render() {
	            var alternateLeaders = this.props.alternateLeaders;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(SelectGeneric, {
	                    defaultValue: this.state.defaultRutLeader,
	                    options: alternateLeaders,
	                    action: this.onSelectAlternateLeader,
	                    title: "L\xEDderes Suplentes"
	                })
	            );
	        }
	    }]);
	
	    return SelectAlternateLeader;
	}(_react.Component);
	
	var SelectGeneric = function SelectGeneric(_ref) {
	    var defaultValue = _ref.defaultValue,
	        options = _ref.options,
	        action = _ref.action,
	        title = _ref.title;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "label",
	            { className: "control-label" },
	            title
	        ),
	        _react2.default.createElement(
	            "select",
	            { className: "form-control",
	                value: defaultValue,
	                onChange: action
	            },
	            _react2.default.createElement(
	                "option",
	                { key: 0, value: "" },
	                "Seleccionar"
	            ),
	            options.map(function (option, index) {
	                return _react2.default.createElement(
	                    "option",
	                    { key: index, value: option.usuarioRUN },
	                    option.nombreCorto + " - Ruta (" + option.numberRegion + ")"
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectAlternateLeader.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(933);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(936);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(934);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(935);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(934);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(937);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(938);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(935);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(939);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(949);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(451);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(481);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(940),
	    getPrototype = __webpack_require__(946),
	    isObjectLike = __webpack_require__(948);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(941),
	    getRawTag = __webpack_require__(944),
	    objectToString = __webpack_require__(945);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(942);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(943);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(941);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(947);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(26);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modales = __webpack_require__(918);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _tarifas = __webpack_require__(951);
	
	var _tarifas2 = _interopRequireDefault(_tarifas);
	
	var _Input = __webpack_require__(952);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TarifaNomina = function (_Component) {
	    _inherits(TarifaNomina, _Component);
	
	    function TarifaNomina(props) {
	        _classCallCheck(this, TarifaNomina);
	
	        var _this = _possibleConstructorReturn(this, (TarifaNomina.__proto__ || Object.getPrototypeOf(TarifaNomina)).call(this, props));
	
	        _this.state = {};
	
	        _this.updateOperadorNomina = function (operador) {
	            var nomina = _extends({}, _this.props.nomina, {
	                'captadorSEI': _extends({}, _this.props.nomina.captadorSEI, {
	                    'dotacionTitular': _this.props.nomina.captadorSEI.dotacionTitular.map(function (row) {
	                        return row.id == operador.id ? operador : row;
	                    })
	                })
	            });
	            return nomina;
	        };
	
	        _this.onChange = function (e) {
	            var checked = e.target.checked;
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzada(checked).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _extends({}, _this.props.nomina, {
	                "turno_avanzada": checked
	            });
	            _this.context.updateNomina(nomina);
	        };
	
	        _this.onChangeStatusOperador = function (rowOperador, e) {
	            var row_op = _extends({}, rowOperador, {
	                "turno_avanzada_solicitud": e.target.checked
	            });
	
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzadaOpSolicitud({
	                "operador_id": rowOperador.id,
	                "turno_avanzada": e.target.checked
	            }).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _this.updateOperadorNomina(row_op);
	            _this.context.updateNomina(nomina);
	        };
	
	        _this.onChangeHrsOperador = function (rowOperador, e) {
	            var row_op = _extends({}, rowOperador, {
	                "turno_avanzada_hrs": e.target.value
	            });
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzadaOpHrs({
	                "operador_id": rowOperador.id,
	                "turno_avanzada_hrs": e.target.value
	            }).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _this.updateOperadorNomina(row_op);
	            _this.context.updateNomina(nomina);
	        };
	        return _this;
	    }
	
	    _createClass(TarifaNomina, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var checked = this.props.nomina.turno_avanzada;
	            var titulares = this.props.nomina.captadorSEI.dotacionTitular;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: {
	                            display: 'inline-block',
	                            marginRight: '5px'
	                        } },
	                    _react2.default.createElement('input', { type: 'checkbox', checked: checked, onChange: this.onChange }),
	                    'Avanzada'
	                ),
	                _react2.default.createElement(
	                    _Modales.ModalTrigger,
	                    null,
	                    function (isVisible, showModal, hideModal) {
	                        return _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    display: 'inline-block'
	                                } },
	                            _react2.default.createElement(
	                                'button',
	                                { disabled: !checked, className: 'btn btn-success',
	                                    onClick: showModal },
	                                'Nomina'
	                            ),
	                            isVisible && _react2.default.createElement(ModalNomina, {
	                                hideModal: hideModal,
	                                titulares: titulares,
	                                onChangeStatusOperador: _this2.onChangeStatusOperador.bind(_this2),
	                                onChangeHrsOperador: _this2.onChangeHrsOperador.bind(_this2)
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TarifaNomina;
	}(_react.Component);
	
	exports.default = TarifaNomina;
	
	
	TarifaNomina.contextTypes = {
	    updateNomina: _react.PropTypes.func
	};
	
	var ModalNomina = function ModalNomina(_ref) {
	    var hideModal = _ref.hideModal,
	        titulares = _ref.titulares,
	        onChangeStatusOperador = _ref.onChangeStatusOperador,
	        onChangeHrsOperador = _ref.onChangeHrsOperador;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: _tarifas2.default.zIndex },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Turno avanzada'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'table',
	                    { className: _tarifas2.default.text_xs + " table" },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '#'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Operador'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Captador'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Turno'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        titulares.map(function (operador, index) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: operador.id, className: index % 2 == 0 ? _tarifas2.default.bgGray : "" },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.nombreCompleto
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.captador
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.comuna
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement('input', { type: 'checkbox', checked: operador.turno_avanzada_solicitud, onChange: function onChange(e) {
	                                            return onChangeStatusOperador(operador, e);
	                                        } })
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_Modal2.default.Footer, null)
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TarifaNomina.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"zIndex":"tarifas__zIndex___VG4ld","text_xs":"tarifas__text_xs___2aCRc","bgGray":"tarifas__bgGray___4CFiv"};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	    _inherits(Input, _Component);
	
	    function Input(props) {
	        _classCallCheck(this, Input);
	
	        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	        _this.state = {
	            value: _this.props.defaultValue
	        };
	
	        _this.onBlur = function (e) {
	            var value = e.target.value;
	            if (value != _this.props.defaultValue) {
	                console.log("es distinto");
	                _this.props.onChange(e);
	            } else {
	                console.log("es igual");
	            }
	        };
	
	        _this.onChange = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                value: value
	            });
	        };
	
	        return _this;
	    }
	
	    _createClass(Input, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", { onBlur: this.onBlur, onChange: this.onChange, type: "number", value: this.state.value, style: {
	                    width: '40px'
	                } });
	        }
	    }]);
	
	    return Input;
	}(_react.Component);
	
	exports.default = Input;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Input.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modales = __webpack_require__(918);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pasaje = function (_Component) {
	    _inherits(Pasaje, _Component);
	
	    function Pasaje(props) {
	        _classCallCheck(this, Pasaje);
	
	        var _this = _possibleConstructorReturn(this, (Pasaje.__proto__ || Object.getPrototypeOf(Pasaje)).call(this, props));
	
	        _this.state = {
	            fecha: '',
	            hora: '',
	            data: [],
	            origen: '',
	            destino: '',
	            comunasOrigen: [],
	            comunasDestino: [],
	            buscarOrigen: '',
	            buscarDestino: '',
	            archivo: '',
	            subiendo: false,
	            viendoPasaje: false,
	            rutaArchivo: ''
	        };
	
	        _this.onChangeFecha = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                fecha: value
	            });
	        };
	
	        _this.onChangeHora = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                hora: value
	            });
	        };
	
	        _this.onChangeComuna = function (e) {
	            var comuna = e.target.value;
	            var nombre = e.target.name;
	            if (nombre == 'origen') {
	                _this.setState({ origen: comuna });
	            } else if (nombre == 'destino') {
	                _this.setState({ destino: comuna });
	            }
	        };
	
	        _this.onChangeBuscarOrigen = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                buscarOrigen: value
	            });
	            if (value.length > 2) {
	                var filtrados = _this.state.data.comunas.filter(function (dato) {
	                    return dato.nombre.toLowerCase().startsWith(value.toLowerCase());
	                });
	                _this.setState({
	                    comunasOrigen: filtrados
	                });
	            } else {
	                _this.setState({
	                    comunasOrigen: []
	                });
	            }
	        };
	
	        _this.onChangeBuscarDestino = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                buscarDestino: value
	            });
	            if (value.length > 2) {
	                var filtrados = _this.state.data.comunas.filter(function (dato) {
	                    return dato.nombre.toLowerCase().startsWith(value.toLowerCase());
	                });
	                _this.setState({
	                    comunasDestino: filtrados
	                });
	            } else {
	                _this.setState({
	                    comunasDestino: []
	                });
	            }
	        };
	
	        _this.onChangeFile = function (e) {
	            _this.setState({
	                archivo: e.target.files[0]
	            });
	        };
	
	        _this.onClickPasaje = function (ruta, id) {
	            _this.setState({
	                viendoPasaje: id,
	                rutaArchivo: ruta
	            });
	        };
	
	        _this.cerrarModalArchivo = function () {
	            _this.setState({ viendoPasaje: false });
	        };
	
	        _this.onChangeRuta = function (ruta) {
	            _this.setState({
	                rutaArchivo: ruta
	            });
	        };
	
	        _this.onUploadRuta = function (id, archivo) {
	            var formData = new FormData();
	            formData.append("id", id);
	            formData.append("archivo", archivo);
	            _v2.default.nomina(_this.props.nomina.idNomina).editarPasaje(formData).then(function (response) {
	                var newData = Object.assign({}, _this.state.data);
	                newData.pasajes = response;
	                _this.setState({ data: newData });
	            }).catch(function (error) {
	                console.error("Error al cargar los datos:", error);
	            });
	        };
	
	        _this.onDeleteRuta = function (id) {
	            _v2.default.nomina(_this.props.nomina.idNomina).eliminarPasaje(id).then(function (response) {
	                var newData = Object.assign({}, _this.state.data);
	                newData.pasajes = response;
	                _this.setState({ data: newData });
	            }).catch(function (error) {
	                console.error("Error al cargar los datos:", error);
	            });
	        };
	
	        _this.fetchData = function () {
	            _v2.default.nomina(_this.props.nomina.idNomina).verPasajesLider().then(function (response) {
	                _this.setState({ data: response, origen: response.origen.cutComuna, destino: response.destino.cutComuna });
	            }).catch(function (error) {
	                console.error('Error al cargar los datos:', error);
	            });
	        };
	        _this.onSavePasaje = function () {
	            var logistica = _this.state.data.logistica.id;
	            _this.setState({ subiendo: true });
	            var _this$state = _this.state,
	                fecha = _this$state.fecha,
	                hora = _this$state.hora,
	                origen = _this$state.origen,
	                destino = _this$state.destino,
	                archivo = _this$state.archivo;
	
	            var data = new FormData();
	            data.append('fecha', fecha);
	            data.append('hora', hora);
	            data.append('origen', origen);
	            data.append('destino', destino);
	            data.append('archivo', archivo);
	            data.append('logistica', logistica);
	            _v2.default.nomina(_this.props.nomina.idNomina).subirPasajesLider(data).then(function (response) {
	                var nuevaData = Object.assign({}, _this.state.data, {
	                    pasajes: response
	                });
	
	                _this.setState({
	                    subiendo: false,
	                    data: nuevaData
	                });
	            }).catch(function (error) {
	                console.error('Error al guardar el pasaje:', error);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Pasaje, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Modales.ModalTrigger,
	                    null,
	                    function (isVisible, showModal, hideModal) {
	                        var handleShowModal = function handleShowModal() {
	                            showModal(); // Abre el modal
	                            _this2.fetchData(); // Carga los datos
	                        };
	                        var handleHideModal = function handleHideModal() {
	                            hideModal();
	                            _this2.setState({ comunas: [], viendoPasaje: false });
	                        };
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-info',
	                                    onClick: handleShowModal },
	                                'Pasaje'
	                            ),
	                            isVisible && _react2.default.createElement(ModalPasaje, {
	                                hideModal: handleHideModal,
	                                fecha: _this2.state.fecha,
	                                changeFecha: _this2.onChangeFecha.bind(_this2),
	                                hora: _this2.state.hora,
	                                changeHora: _this2.onChangeHora.bind(_this2),
	                                data: _this2.state.data,
	                                comunasOrigen: _this2.state.comunasOrigen,
	                                comunasDestino: _this2.state.comunasDestino,
	                                buscarOrigen: _this2.state.buscarOrigen,
	                                buscarDestino: _this2.state.buscarDestino,
	                                onBuscarOrigen: _this2.onChangeBuscarOrigen.bind(_this2),
	                                onBuscarDestino: _this2.onChangeBuscarDestino.bind(_this2),
	                                changeFile: _this2.onChangeFile.bind(_this2),
	                                changeComuna: _this2.onChangeComuna.bind(_this2),
	                                origen: _this2.state.origen,
	                                destino: _this2.state.destino,
	                                subir: _this2.onSavePasaje.bind(_this2),
	                                subiendo: _this2.state.subiendo,
	                                viendoPasaje: _this2.state.viendoPasaje,
	                                onClickPasaje: _this2.onClickPasaje.bind(_this2),
	                                rutaArchivo: _this2.state.rutaArchivo,
	                                onChangeRuta: _this2.onChangeRuta.bind(_this2),
	                                onUploadRuta: _this2.onUploadRuta.bind(_this2),
	                                onDeleteRuta: _this2.onDeleteRuta.bind(_this2),
	                                administraPasajes: _this2.props.administraPasajes
	                            }),
	                            _this2.state.viendoPasaje && _react2.default.createElement(ModalArchivo, {
	                                hideModal: _this2.cerrarModalArchivo,
	                                viendoPasaje: _this2.state.viendoPasaje,
	                                ruta: _this2.state.rutaArchivo
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return Pasaje;
	}(_react.Component);
	
	exports.default = Pasaje;
	
	
	var ModalPasaje = function ModalPasaje(_ref) {
	    var hideModal = _ref.hideModal,
	        fecha = _ref.fecha,
	        changeFecha = _ref.changeFecha,
	        hora = _ref.hora,
	        changeHora = _ref.changeHora,
	        data = _ref.data,
	        comunasOrigen = _ref.comunasOrigen,
	        comunasDestino = _ref.comunasDestino,
	        buscarOrigen = _ref.buscarOrigen,
	        buscarDestino = _ref.buscarDestino,
	        onBuscarOrigen = _ref.onBuscarOrigen,
	        onBuscarDestino = _ref.onBuscarDestino,
	        changeFile = _ref.changeFile,
	        changeComuna = _ref.changeComuna,
	        origen = _ref.origen,
	        destino = _ref.destino,
	        subir = _ref.subir,
	        subiendo = _ref.subiendo,
	        viendoPasaje = _ref.viendoPasaje,
	        onClickPasaje = _ref.onClickPasaje,
	        rutaArchivo = _ref.rutaArchivo,
	        onChangeRuta = _ref.onChangeRuta,
	        onUploadRuta = _ref.onUploadRuta,
	        onDeleteRuta = _ref.onDeleteRuta,
	        administraPasajes = _ref.administraPasajes;
	
	    var datos = data && Object.values(data).length > 0 ? Object.values(data.pasajes).sort(function (a, b) {
	        return a.orden - b.orden;
	    }) : data;
	    var handleClick = function handleClick(ruta, id) {
	        onClickPasaje(ruta, id);
	    };
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, bsSize: 'lg', style: {
	                width: viendoPasaje ? "60%" : "100%",
	                transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out"
	            } },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Pasajes'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', gap: '5px', width: 'full' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', width: '50%', marginBottom: '5px' } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Comuna Origen'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', placeholder: 'Buscar comuna origen', value: buscarOrigen, onChange: onBuscarOrigen, style: { width: '75%', padding: '2px', marginBottom: '1px' } }),
	                            _react2.default.createElement(
	                                'select',
	                                { value: origen, name: 'origen', onChange: changeComuna, style: { width: '75%', padding: '2px' }, size: 5 },
	                                data && Object.values(data).length > 0 ? _react2.default.createElement(
	                                    'optgroup',
	                                    { label: 'Comuna L\xEDder' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: data.origen.cutComuna },
	                                        data.origen.nombre
	                                    )
	                                ) : null,
	                                _react2.default.createElement(
	                                    'optgroup',
	                                    { label: 'Comunas' },
	                                    comunasOrigen.length > 0 ? comunasOrigen.map(function (comuna, index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: index, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    }) : data && Object.values(data).length > 0 ? data.comunas.map(function (comuna, index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: index, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    }) : null
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', width: '50%', marginBottom: '5px' } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Comuna Destino'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', placeholder: 'Buscar comuna destino', value: buscarDestino, onChange: onBuscarDestino, style: { width: '75%', padding: '2px', marginBottom: '1px' } }),
	                            _react2.default.createElement(
	                                'select',
	                                { value: destino, name: 'destino', onChange: changeComuna, style: { width: '75%', padding: '2px' }, size: 5 },
	                                data && Object.values(data).length > 0 ? _react2.default.createElement(
	                                    'optgroup',
	                                    { label: 'Comuna Inventario' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: data.destino.cutComuna },
	                                        data.destino.nombre
	                                    )
	                                ) : null,
	                                _react2.default.createElement(
	                                    'optgroup',
	                                    { label: 'Comunas' },
	                                    comunasDestino.length > 0 ? comunasDestino.map(function (comuna, index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: index, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    }) : data && Object.values(data).length > 0 ? data.comunas.map(function (comuna, index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: index, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    }) : null
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', gap: '5px', width: 'full' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', width: '50%', marginBottom: '5px' } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Fecha Pasaje'
	                            ),
	                            _react2.default.createElement('input', { type: 'date', value: fecha, onChange: changeFecha, style: { width: '75%', padding: '2px' } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', width: '50%', marginBottom: '5px' } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Hora Pasaje'
	                            ),
	                            _react2.default.createElement('input', { type: 'time', value: hora, onChange: changeHora, style: { width: '75%', padding: '2px' } })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', gap: '4px', width: 'full' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', width: '50%' } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Archivo Pasaje'
	                            ),
	                            _react2.default.createElement('input', { type: 'file', onChange: changeFile, style: { width: '75%', padding: '2px' } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', marginTop: '5px' } },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-success', onClick: subir, disabled: subiendo },
	                                'Subir'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '#'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Origen'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Destino'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Fecha'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Hora'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Subido por'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        datos && Object.values(datos).length > 0 ? Object.values(datos).map(function (pasaje, index) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    pasaje.origen
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    pasaje.destino
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    pasaje.fecha
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    pasaje.hora
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    pasaje.subido_por
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle', display: 'block' } },
	                                    !pasaje.pdf ? _react2.default.createElement('input', { type: 'file', onChange: function onChange(e) {
	                                            return onUploadRuta(pasaje.id, e.target.files[0]);
	                                        },
	                                        style: { width: '155px' } }) : _react2.default.createElement(
	                                        'button',
	                                        { className: viendoPasaje == pasaje.id ? 'btn btn-success' : 'btn btn-info', onClick: function onClick() {
	                                                return handleClick(pasaje.pdf, pasaje.id);
	                                            } },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	                                    )
	                                ),
	                                administraPasajes && _react2.default.createElement(
	                                    'td',
	                                    { style: { verticalAlign: 'middle' } },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-danger', onClick: function onClick() {
	                                                return onDeleteRuta(pasaje.id);
	                                            } },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-trash' })
	                                    )
	                                )
	                            );
	                        }) : null
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_Modal2.default.Footer, null)
	    );
	};
	
	var ModalArchivo = function ModalArchivo(_ref2) {
	    var hideModal = _ref2.hideModal,
	        viendoPasaje = _ref2.viendoPasaje,
	        ruta = _ref2.ruta;
	
	    console.log(ruta, "ruta en modal archivo");
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, style: {
	                width: "60%",
	                transform: viendoPasaje ? "translateX(75%)" : "translateX(0%)",
	                transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out"
	            } },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Pasaje'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { height: '70%' } },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { gap: '5px', width: 'full' } },
	                    _react2.default.createElement('iframe', { src: ruta, width: '100%', height: '100%',
	                        style: { border: 'none', display: 'flex' } })
	                )
	            )
	        ),
	        _react2.default.createElement(_Modal2.default.Footer, null)
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Pasaje.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TurnoEmergencia = function (_Component) {
	    _inherits(TurnoEmergencia, _Component);
	
	    function TurnoEmergencia(props) {
	        _classCallCheck(this, TurnoEmergencia);
	
	        var _this = _possibleConstructorReturn(this, (TurnoEmergencia.__proto__ || Object.getPrototypeOf(TurnoEmergencia)).call(this, props));
	
	        _this.state = {};
	
	        _this.onChange = function (e) {
	            var checked = e.target.checked;
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoEmergencia(checked).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	                var nomina = _extends({}, _this.props.nomina, {
	                    "turno_emergencia": !checked
	                });
	                _this.context.updateNomina(nomina);
	            });
	            var nomina = _extends({}, _this.props.nomina, {
	                "turno_emergencia": checked
	            });
	            _this.context.updateNomina(nomina);
	        };
	        return _this;
	    }
	
	    _createClass(TurnoEmergencia, [{
	        key: 'render',
	        value: function render() {
	            var checked = this.props.nomina.turno_emergencia;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: {
	                            display: 'inline-block',
	                            marginRight: '5px'
	                        } },
	                    _react2.default.createElement('input', { type: 'checkbox', checked: checked, onChange: this.onChange }),
	                    'Turno Emergencia'
	                )
	            );
	        }
	    }]);
	
	    return TurnoEmergencia;
	}(_react.Component);
	
	exports.default = TurnoEmergencia;
	
	
	TurnoEmergencia.contextTypes = {
	    updateNomina: _react.PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TurnoEmergencia.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalDireccion = exports.ModalPegarLocales = exports.ModalEditarLocal = exports.ModalAgregarLocal = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(956);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	var _mantenedorLocal = __webpack_require__(957);
	
	var cssTabla = _interopRequireWildcard(_mantenedorLocal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	// function as a children FTW! :D
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalAgregarLocal = exports.ModalAgregarLocal = function (_React$Component2) {
	    _inherits(ModalAgregarLocal, _React$Component2);
	
	    function ModalAgregarLocal(props) {
	        _classCallCheck(this, ModalAgregarLocal);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalAgregarLocal.__proto__ || Object.getPrototypeOf(ModalAgregarLocal)).call(this, props));
	
	        _this2.state = {
	            local: {
	                idCliente: _this2.props.idCliente,
	                nombre: '',
	                numero: '',
	                idFormatoLocal: 4,
	                idJornadaSugerida: 1,
	                horaApertura: '00:00',
	                horaCierre: '00:00',
	                emailContacto: '',
	                telefono1: '',
	                telefono2: '',
	                stock: 1,
	                cutComuna: 13101,
	                direccion: ''
	            },
	            error: {}
	        };
	        _this2.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.value;
	            _this2.setState({ local: Object.assign({}, _this2.state.local, actualizado) });
	        };
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState({ error: {} }, function () {
	                _this2.props.agregarLocal(_this2.state.local).then(function () {
	                    return _this2.props.hideModal();
	                }).catch(function (error) {
	                    _this2.setState({ error: error.data });
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalAgregarLocal, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Nuevo Local'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal', action: '', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Numero'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'CECO',
	                                    value: this.state.local.numero, onChange: this.onInputChange.bind(this, 'numero')
	                                }),
	                                this.state.error.numero && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.numero[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Nombre'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Nombre de local',
	                                    value: this.state.local.nombre, onChange: this.onInputChange.bind(this, 'nombre')
	                                }),
	                                this.state.error.nombre && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.nombre[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Formato'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.idFormatoLocal,
	                                        onChange: this.onInputChange.bind(this, 'idFormatoLocal')
	                                    },
	                                    this.props.formatoLocales.map(function (formato) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: formato.idFormatoLocal, value: formato.idFormatoLocal },
	                                            formato.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Jornada'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.idJornadaSugerida,
	                                        onChange: this.onInputChange.bind(this, 'idJornadaSugerida')
	                                    },
	                                    this.props.jornadas.map(function (jornada) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: jornada.idJornada, value: jornada.idJornada },
	                                            jornada.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Hora Apertura'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'time', className: 'form-control',
	                                    value: this.state.local.horaApertura, onChange: this.onInputChange.bind(this, 'horaApertura')
	                                }),
	                                this.state.error.horaApertura && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.horaApertura[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Hora Cierre'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'time', className: 'form-control',
	                                    value: this.state.local.horaCierre, onChange: this.onInputChange.bind(this, 'horaCierre')
	                                }),
	                                this.state.error.horaCierre && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.horaCierre[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Email'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.emailContacto, onChange: this.onInputChange.bind(this, 'emailContacto')
	                                }),
	                                this.state.error.emailContacto && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.emailContacto[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Telefonos'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.telefono1, onChange: this.onInputChange.bind(this, 'telefono1')
	                                }),
	                                this.state.error.telefono1 && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.telefono1[0]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.telefono2, onChange: this.onInputChange.bind(this, 'telefono2')
	                                }),
	                                this.state.error.telefono2 && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.telefono2[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Stock'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'number', className: 'form-control',
	                                    value: this.state.local.stock, onChange: this.onInputChange.bind(this, 'stock')
	                                }),
	                                this.state.error.stock && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.stock[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.cutComuna,
	                                        onChange: this.onInputChange.bind(this, 'cutComuna')
	                                    },
	                                    this.props.comunas.map(function (comuna) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: comuna.cutComuna, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Direcci\xF3n'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.direccion, onChange: this.onInputChange.bind(this, 'direccion')
	                                }),
	                                this.state.error.direccion && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.direccion[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'a',
	                                { className: cx("btn btn-block btn-default", 'btn-50-perc'), href: '#', onClick: this.props.hideModal },
	                                'Cancelar'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: cx("btn btn-block btn-primary", 'btn-50-perc'), type: 'submit' },
	                                'Agregar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAgregarLocal;
	}(_react2.default.Component);
	
	var ModalEditarLocal = exports.ModalEditarLocal = function (_React$Component3) {
	    _inherits(ModalEditarLocal, _React$Component3);
	
	    function ModalEditarLocal(props) {
	        _classCallCheck(this, ModalEditarLocal);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalEditarLocal.__proto__ || Object.getPrototypeOf(ModalEditarLocal)).call(this, props));
	
	        _this3.state = {
	            local: _this3.props.local,
	            error: {}
	        };
	        _this3.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
	            _this3.setState({ local: Object.assign({}, _this3.state.local, actualizado) });
	        };
	        _this3.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this3.setState({ error: {} }, function () {
	                _this3.props.actualizarLocal(_this3.state.local).then(function () {
	                    return _this3.props.hideModal();
	                }).catch(function (error) {
	                    _this3.setState({ error: error.data });
	                });
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalEditarLocal, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Editando local: ',
	                        this.props.local.cliente.nombreCorto,
	                        ' ',
	                        this.props.local.numero
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal', action: '', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Nombre'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Nombre de local',
	                                    value: this.state.local.nombre, onChange: this.onInputChange.bind(this, 'nombre')
	                                }),
	                                this.state.error.nombre && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.nombre[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Formato'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.idFormatoLocal,
	                                        onChange: this.onInputChange.bind(this, 'idFormatoLocal')
	                                    },
	                                    this.props.formatoLocales.map(function (formato) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: formato.idFormatoLocal, value: formato.idFormatoLocal },
	                                            formato.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Jornada'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.idJornadaSugerida,
	                                        onChange: this.onInputChange.bind(this, 'idJornadaSugerida')
	                                    },
	                                    this.props.jornadas.map(function (jornada) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: jornada.idJornada, value: jornada.idJornada },
	                                            jornada.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Hora Apertura'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'time', className: 'form-control',
	                                    value: this.state.local.horaApertura, onChange: this.onInputChange.bind(this, 'horaApertura')
	                                }),
	                                this.state.error.horaApertura && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.horaApertura[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Hora Cierre'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'time', className: 'form-control',
	                                    value: this.state.local.horaCierre, onChange: this.onInputChange.bind(this, 'horaCierre')
	                                }),
	                                this.state.error.horaCierre && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.horaCierre[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Email'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.emailContacto, onChange: this.onInputChange.bind(this, 'emailContacto')
	                                }),
	                                this.state.error.emailContacto && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.emailContacto[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Telefonos'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.telefono1, onChange: this.onInputChange.bind(this, 'telefono1')
	                                }),
	                                this.state.error.telefono1 && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.telefono1[0]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.telefono2, onChange: this.onInputChange.bind(this, 'telefono2')
	                                }),
	                                this.state.error.telefono2 && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.telefono2[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Stock'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'number', className: 'form-control',
	                                    value: this.state.local.stock, onChange: this.onInputChange.bind(this, 'stock')
	                                }),
	                                this.state.error.stock && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.stock[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'form-control',
	                                        value: this.state.local.cutComuna,
	                                        onChange: this.onInputChange.bind(this, 'cutComuna')
	                                    },
	                                    this.props.comunas.map(function (comuna) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: comuna.cutComuna, value: comuna.cutComuna },
	                                            comuna.nombre
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Direcci\xF3n'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    value: this.state.local.direccion, onChange: this.onInputChange.bind(this, 'direccion')
	                                }),
	                                this.state.error.direccion && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.direccion[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Restricci\xF3n Egreso'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'checkbox', className: 'form-control',
	                                    checked: this.state.local.cerrado, onChange: this.onInputChange.bind(this, 'cerrado')
	                                }),
	                                this.state.error.cerrado && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.cerrado[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                '\xBFEs mall?'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'checkbox', className: 'form-control',
	                                    checked: this.state.local.mall, onChange: this.onInputChange.bind(this, 'mall')
	                                }),
	                                this.state.error.mall && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.mall[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Tienda Web'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5' },
	                                _react2.default.createElement('input', { type: 'checkbox', className: 'form-control',
	                                    checked: this.state.local.tiendaWeb, onChange: this.onInputChange.bind(this, 'tiendaWeb')
	                                }),
	                                this.state.error.tiendaWeb && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.tiendaWeb[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'a',
	                                { className: cx("btn btn-block btn-default", 'btn-50-perc'), href: '#', onClick: this.props.hideModal },
	                                'Cancelar'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: cx("btn btn-block btn-primary", 'btn-50-perc'), type: 'submit' },
	                                'Actualizar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalEditarLocal;
	}(_react2.default.Component);
	
	var ModalPegarLocales = exports.ModalPegarLocales = function (_React$Component4) {
	    _inherits(ModalPegarLocales, _React$Component4);
	
	    function ModalPegarLocales(props) {
	        _classCallCheck(this, ModalPegarLocales);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalPegarLocales.__proto__ || Object.getPrototypeOf(ModalPegarLocales)).call(this, props));
	
	        _this4.state = {
	            locales: [],
	            todosValidos: false,
	            errores: ''
	        };
	        _this4.onPaste = function (evt) {
	            evt.preventDefault();
	            evt.clipboardData.items[0].getAsString(function (texto) {
	                var getTime = function getTime() {
	                    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00:00';
	                    return (/^[0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(string) ? string.replace(/:[0-9]{2}$/, '') : /^[0-9]{2}:[0-9]{2}$/.test(string) ? string : '00:00'
	                    );
	                };
	                var locales = texto.trim().split('\n').filter(function (row) {
	                    return row !== '';
	                }).map(function (row) {
	                    return row.trim().split('\t');
	                }).map(function (row) {
	                    return {
	                        idCliente: _this4.props.idCliente,
	                        numero: row[0] || '',
	                        nombre: row[1] || '',
	                        idJornadaSugerida: row[2] || 3,
	                        jornada: _this4.props.jornadas.find(function (jor) {
	                            return jor.idJornada == (row[2] || 3);
	                        }),
	                        idFormatoLocal: 4,
	                        horaApertura: getTime(row[3]),
	                        horaCierre: getTime(row[4]),
	                        emailContacto: row[5] || '',
	                        telefono1: row[6] || '',
	                        telefono2: row[7] || '',
	                        stock: 1,
	                        cutComuna: row[8] || 13101,
	                        comuna: _this4.props.comunas.find(function (com) {
	                            return com.cutComuna == (row[8] || 7301);
	                        }),
	                        direccion: row[9] || ''
	                    };
	                });
	                _this4.setState({
	                    locales: locales,
	                    todosValidos: locales.filter(function (local) {
	                        return !local.jornada || !local.comuna;
	                    }).length == 0 && locales.length > 0,
	                    errores: ''
	                });
	            });
	        };
	
	        _this4.agregarLocales = function () {
	            _this4.setState({
	                errores: ''
	            }, function () {
	                _this4.props.agregarLocales(_this4.state.locales).then(_this4.props.hideModal).catch(function (err) {
	                    _this4.setState({
	                        errores: err.data.join('. ')
	                    });
	                });
	            });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalPegarLocales, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refInputPaste.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var locales = this.state.locales;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPegarLocales') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        _react2.default.createElement(
	                            'small',
	                            { className: 'col-md-8' },
	                            'Pegar las columnas: Ceco, Nombre, Jornada, Hora Apertura, Hora Cierre, Email, telefono1, telefono2, CUT Comuna y Direccion desde excel'
	                        ),
	                        _react2.default.createElement('input', { className: 'col-md-3', type: 'text', value: '', onPaste: this.onPaste, ref: function ref(_ref) {
	                                return _this5.refInputPaste = _ref;
	                            } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    { className: cx('tabla-pegar-locales') },
	                    _react2.default.createElement(
	                        _reactVirtualized.AutoSizer,
	                        null,
	                        function (_ref2) {
	                            var height = _ref2.height,
	                                width = _ref2.width;
	                            return _react2.default.createElement(
	                                _reactVirtualized.Table
	                                // general
	                                ,
	                                { height: height,
	                                    width: width
	                                    // headers
	                                    , headerHeight: 30,
	                                    headerClassName: cssTabla.headerColumn
	                                    // rows
	                                    , rowCount: locales.length,
	                                    rowGetter: function rowGetter(_ref3) {
	                                        var index = _ref3.index;
	                                        return locales[index];
	                                    },
	                                    rowHeight: 40,
	                                    rowClassName: function rowClassName(_ref4) {
	                                        var index = _ref4.index;
	                                        return index < 0 ? cssTabla.headerRow : index % 2 === 0 ? cssTabla.evenRow : cssTabla.oddRow;
	                                    }
	                                },
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'numero', label: 'CECO',
	                                    cellRenderer: function cellRenderer(_ref5) {
	                                        var cellData = _ref5.cellData,
	                                            columnData = _ref5.columnData,
	                                            dataKey = _ref5.dataKey,
	                                            rowData = _ref5.rowData,
	                                            rowIndex = _ref5.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 40
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'nombre', label: 'Nombre',
	                                    cellRenderer: function cellRenderer(_ref6) {
	                                        var cellData = _ref6.cellData,
	                                            columnData = _ref6.columnData,
	                                            dataKey = _ref6.dataKey,
	                                            rowData = _ref6.rowData,
	                                            rowIndex = _ref6.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 120
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'idJornadaSugerida', label: 'Jornada',
	                                    cellRenderer: function cellRenderer(_ref7) {
	                                        var dataKey = _ref7.dataKey,
	                                            rowData = _ref7.rowData;
	                                        return rowData.jornada ? rowData.jornada.nombre : _react2.default.createElement(
	                                            'span',
	                                            { className: 'label label-danger' },
	                                            'INVALIDA'
	                                        );
	                                    },
	                                    width: 70
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'horaApertura', label: 'Apertura',
	                                    cellRenderer: function cellRenderer(_ref8) {
	                                        var cellData = _ref8.cellData,
	                                            columnData = _ref8.columnData,
	                                            dataKey = _ref8.dataKey,
	                                            rowData = _ref8.rowData,
	                                            rowIndex = _ref8.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 70
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'horaCierre', label: 'Cierre',
	                                    cellRenderer: function cellRenderer(_ref9) {
	                                        var cellData = _ref9.cellData,
	                                            columnData = _ref9.columnData,
	                                            dataKey = _ref9.dataKey,
	                                            rowData = _ref9.rowData,
	                                            rowIndex = _ref9.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 50
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'emailContacto', label: 'Email',
	                                    cellRenderer: function cellRenderer(_ref10) {
	                                        var cellData = _ref10.cellData,
	                                            columnData = _ref10.columnData,
	                                            dataKey = _ref10.dataKey,
	                                            rowData = _ref10.rowData,
	                                            rowIndex = _ref10.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 100
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'telefono1', label: 'Telefono1',
	                                    cellRenderer: function cellRenderer(_ref11) {
	                                        var cellData = _ref11.cellData,
	                                            columnData = _ref11.columnData,
	                                            dataKey = _ref11.dataKey,
	                                            rowData = _ref11.rowData,
	                                            rowIndex = _ref11.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 85
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'telefono2', label: 'Telefono2',
	                                    cellRenderer: function cellRenderer(_ref12) {
	                                        var cellData = _ref12.cellData,
	                                            columnData = _ref12.columnData,
	                                            dataKey = _ref12.dataKey,
	                                            rowData = _ref12.rowData,
	                                            rowIndex = _ref12.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 85
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'cutComuna', label: 'CUT Comuna',
	                                    cellRenderer: function cellRenderer(_ref13) {
	                                        var cellData = _ref13.cellData,
	                                            columnData = _ref13.columnData,
	                                            dataKey = _ref13.dataKey,
	                                            rowData = _ref13.rowData,
	                                            rowIndex = _ref13.rowIndex;
	                                        return rowData.comuna ? rowData.comuna.nombre : _react2.default.createElement(
	                                            'span',
	                                            { className: 'label label-danger' },
	                                            'INVALIDA'
	                                        );
	                                    },
	                                    width: 100
	                                }),
	                                _react2.default.createElement(_reactVirtualized.Column, {
	                                    dataKey: 'direccion', label: 'Direcci\xF3n',
	                                    cellRenderer: function cellRenderer(_ref14) {
	                                        var cellData = _ref14.cellData,
	                                            columnData = _ref14.columnData,
	                                            dataKey = _ref14.dataKey,
	                                            rowData = _ref14.rowData,
	                                            rowIndex = _ref14.rowIndex;
	                                        return rowData[dataKey];
	                                    },
	                                    width: 200,
	                                    flexGrow: 1
	                                })
	                            );
	                        }
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: "col-md-6 " + cssModal.textAlignLeft },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '* JORNADA, corresponde a: (1) No definido, (2) D\xEDa, (3) Noche, (4) D\xEDa y Noche'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '* CUT COMUNA, corresponde a un el C\xF3digo Unico Territorial. ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://historico.ine.cl/canales/chile_estadistico/territorio/division_politico_administrativa/xls/240111/codigoterr.xls' },
	                                'ver c\xF3digos'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        this.state.errores && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger' },
	                            this.state.errores
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 pull-right' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-default',
	                                onClick: this.props.hideModal
	                            },
	                            'Cancelar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-primary',
	                                disabled: this.state.todosValidos ? '' : 'disabled',
	                                onClick: this.agregarLocales
	                            },
	                            'Agregar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalPegarLocales;
	}(_react2.default.Component);
	
	var ModalDireccion = exports.ModalDireccion = function (_React$Component5) {
	    _inherits(ModalDireccion, _React$Component5);
	
	    function ModalDireccion(props) {
	        _classCallCheck(this, ModalDireccion);
	
	        var _this6 = _possibleConstructorReturn(this, (ModalDireccion.__proto__ || Object.getPrototypeOf(ModalDireccion)).call(this, props));
	
	        _this6.buscarDireccion = function () {
	            var _this6$state = _this6.state,
	                direccion = _this6$state.direccion,
	                comuna = _this6$state.comuna;
	
	            var fullAddress = direccion + ', ' + comuna;
	            var geocoder = new window.google.maps.Geocoder();
	
	            geocoder.geocode({ address: fullAddress }, function (results, status) {
	                if (status === 'OK' && results[0]) {
	                    var location = results[0].geometry.location;
	                    _this6.setState({
	                        lat: location.lat(),
	                        lng: location.lng(),
	                        mostrarMapa: true
	                    }, _this6.initMap);
	                } else {
	                    alert('No se pudo encontrar la dirección.');
	                }
	            });
	        };
	
	        _this6.initMap = function () {
	            if (!_this6.state.mapsLoaded || !_this6.mapaRef) return;
	
	            var _this6$state2 = _this6.state,
	                lat = _this6$state2.lat,
	                lng = _this6$state2.lng;
	
	            var center = { lat: lat, lng: lng };
	
	            _this6.map = new window.google.maps.Map(_this6.mapaRef, {
	                center: center,
	                zoom: 15
	            });
	
	            _this6.marker = new window.google.maps.Marker({
	                position: center,
	                map: _this6.map,
	                draggable: true
	            });
	
	            _this6.marker.addListener('dragend', function (e) {
	                var pos = e.latLng;
	                _this6.setState({
	                    lat: pos.lat(),
	                    lng: pos.lng()
	                });
	            });
	        };
	
	        _this6.handleGuardar = function () {
	            var _this6$state3 = _this6.state,
	                lat = _this6$state3.lat,
	                lng = _this6$state3.lng;
	
	            if (lat && lng) {
	                _this6.props.onGuardar(_this6.props.id, lat, lng).then(function () {
	                    _this6.props.hideModal();
	                }).catch(function (err) {
	                    alert('Error al guardar la ubicación: ' + err.message);
	                });
	                //this.props.hideModal();
	            }
	        };
	
	        _this6.state = {
	            direccion: props.direccion || '',
	            comuna: props.comuna || '',
	            lat: null,
	            lng: null,
	            mostrarMapa: false,
	            apiKey: null,
	            mapsLoaded: false
	        };
	        _this6.mapaRef = null;
	        _this6.map = null;
	        _this6.marker = null;
	        return _this6;
	    }
	
	    _createClass(ModalDireccion, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.obtenerApiKey();
	        }
	    }, {
	        key: 'obtenerApiKey',
	        value: function obtenerApiKey() {
	            var _this7 = this;
	
	            fetch('/api/maps-key').then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                var apiKey = data.key;
	                _this7.setState({ apiKey: apiKey }, function () {
	                    _this7.cargarGoogleMaps(apiKey);
	                });
	            }).catch(function (err) {
	                console.error('Error cargando la API key:', err);
	            });
	        }
	    }, {
	        key: 'cargarGoogleMaps',
	        value: function cargarGoogleMaps(apiKey) {
	            var _this8 = this;
	
	            if (window.google && window.google.maps) {
	                this.setState({ mapsLoaded: true });
	                return;
	            }
	
	            var script = document.createElement('script');
	            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey;
	            script.async = true;
	            script.defer = true;
	            script.onload = function () {
	                _this8.setState({ mapsLoaded: true });
	            };
	            document.body.appendChild(script);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this9 = this;
	
	            var _state = this.state,
	                direccion = _state.direccion,
	                comuna = _state.comuna,
	                lat = _state.lat,
	                lng = _state.lng,
	                mostrarMapa = _state.mostrarMapa;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPegarLocales') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Editar Direcci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group', style: { display: 'flex', items: 'center', justifyItems: 'center', gap: '8px' } },
	                        _react2.default.createElement(
	                            'label',
	                            { style: { margin: 'auto' } },
	                            'Direcci\xF3n:'
	                        ),
	                        _react2.default.createElement('input', {
	                            className: 'form-control',
	                            style: { width: '50%' },
	                            type: 'text',
	                            value: direccion,
	                            onChange: function onChange(e) {
	                                return _this9.setState({ direccion: e.target.value });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { style: { margin: 'auto' } },
	                            'Comuna:'
	                        ),
	                        _react2.default.createElement('input', {
	                            className: 'form-control',
	                            style: { width: '30%' },
	                            type: 'text',
	                            value: comuna,
	                            onChange: function onChange(e) {
	                                return _this9.setState({ comuna: e.target.value });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary', style: { margin: 'auto', display: 'flex' }, onClick: this.buscarDireccion },
	                        'Buscar en mapa'
	                    ),
	                    mostrarMapa && _react2.default.createElement('div', {
	                        ref: function ref(_ref15) {
	                            return _this9.mapaRef = _ref15;
	                        },
	                        style: { width: '100%', height: '300px', marginTop: '10px' }
	                    })
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    lat && lng && _react2.default.createElement(
	                        'div',
	                        { className: 'text-left pull-left' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Lat:'
	                        ),
	                        ' ',
	                        lat.toFixed(6),
	                        ' | ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Lng:'
	                        ),
	                        ' ',
	                        lng.toFixed(6)
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', onClick: this.props.hideModal },
	                        'Cerrar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'btn btn-success',
	                            onClick: this.handleGuardar,
	                            disabled: !lat || !lng
	                        },
	                        'Guardar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDireccion;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modalPegarLocales":"modal__modalPegarLocales___3UFyS","tabla-pegar-locales":"modal__tabla-pegar-locales___12P0T","btn-50-perc":"modal__btn-50-perc___erOt3","form__control-label":"modal__form__control-label___2idOu","form__error-message":"modal__form__error-message___3JK51","textAlignLeft":"modal__textAlignLeft___1Ce06"};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerColumn":"mantenedorLocal__headerColumn___AXoRl","evenRow":"mantenedorLocal__evenRow___2MMEI","oddRow":"mantenedorLocal__oddRow___3UbTL","tablaMantenedorLocales":"mantenedorLocal__tablaMantenedorLocales___1bQz3"};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DetalleProgramacionIG = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _select = __webpack_require__(959);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _modal = __webpack_require__(712);
	
	var css = _interopRequireWildcard(_modal);
	
	var _reactVirtualized = __webpack_require__(653);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// API
	
	// CSS
	
	// Componentes
	
	var DetalleProgramacionIG = exports.DetalleProgramacionIG = function (_React$Component) {
	  _inherits(DetalleProgramacionIG, _React$Component);
	
	  function DetalleProgramacionIG(props) {
	    _classCallCheck(this, DetalleProgramacionIG);
	
	    var _this = _possibleConstructorReturn(this, (DetalleProgramacionIG.__proto__ || Object.getPrototypeOf(DetalleProgramacionIG)).call(this, props));
	
	    _this.state = {
	      idCliente: "0",
	      cutRegion: [{
	        cutRegion: "0",
	        nombreCorto: 'Todas'
	      }],
	      clientes: _this.props.clientes,
	      regiones: _this.props.regiones,
	      fechaInicio: _this.props.fechaInicio,
	      fechaFin: _this.props.fechaFin,
	      detalle: [],
	      dividir: false,
	      show: false,
	      highlightedIndex: 0
	    };
	    _this.fetchDetalle = function () {
	      var regiones = _this.state.cutRegion.map(function (item) {
	        return item.cutRegion;
	      }).join('-');
	      _v2.default.inventario.getDetalle(_this.state.fechaInicio, _this.state.fechaFin, _this.state.idCliente, regiones).then(function (detalle) {
	        _this.setState({
	          detalle: detalle.datos
	        });
	      }).catch(function (meh) {});
	    };
	    _this.seleccionarRegion = function (option) {
	      var opcion = {
	        cutRegion: option.cutRegion,
	        nombreCorto: option.nombreCorto
	      };
	
	      var index = _this.state.cutRegion.findIndex(function (o) {
	        return o.cutRegion === opcion.cutRegion;
	      });
	
	      if (index !== -1) {
	        var newState = _this.state.cutRegion.slice();
	        newState.splice(index, 1);
	
	        if (newState.length > 0) {
	          _this.setState({
	            cutRegion: newState,
	            detalle: []
	          }, function () {
	            _this.fetchDetalle();
	          });
	        } else {
	          _this.setState({
	            cutRegion: [{
	              cutRegion: "0",
	              nombreCorto: 'Todas'
	            }],
	            detalle: []
	          }, function () {
	            _this.fetchDetalle();
	          });
	        }
	      } else {
	        var estado = _this.state.cutRegion.filter(function (c) {
	          return c.cutRegion !== "0";
	        });
	        var array = {
	          cutRegion: option.cutRegion,
	          nombreCorto: option.nombreCorto
	        };
	        estado.push(array);
	        _this.setState({
	          cutRegion: estado,
	          detalle: []
	        }, function () {
	          _this.fetchDetalle();
	        });
	      }
	    };
	    _this.seleccionarCliente = function (evt) {
	      var idCliente = evt.target.value;
	      _this.setState({
	        idCliente: idCliente,
	        detalle: []
	      }, function () {
	        _this.fetchDetalle();
	      });
	    };
	    _this.handleShow = function () {
	      _this.setState({
	        show: !_this.state.show
	      });
	    };
	    _this.handleShowBlur = function () {
	      _this.setState({
	        show: false
	      });
	    };
	    _this.clearOptions = function (e) {
	      e.stopPropagation();
	      _this.setState({
	        cutRegion: [{
	          cutRegion: "0",
	          nombreCorto: 'Todas'
	        }]
	      }, function () {
	        _this.fetchDetalle();
	      });
	    };
	    _this.isSelected = function (option) {
	      var op = {
	        cutRegion: option.cutRegion,
	        nombreCorto: option.nombreCorto
	      };
	      return _this.state.cutRegion.some(function (item) {
	        return item.cutRegion === op.cutRegion;
	      });
	    };
	    return _this;
	  }
	
	  _createClass(DetalleProgramacionIG, [{
	    key: "renderDivisionTablas",
	    value: function renderDivisionTablas() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6" },
	          _react2.default.createElement(Detalle, { detalle: this.state.coleccionUno })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6" },
	          _react2.default.createElement(Detalle, { detalle: this.state.coleccionDos })
	        )
	      );
	    }
	  }, {
	    key: "renderTablaNormal",
	    value: function renderTablaNormal() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6" },
	          _react2.default.createElement(Detalle, { detalle: this.state.detalle })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-1" },
	          _react2.default.createElement(
	            "table",
	            { style: { width: "100%" } },
	            _react2.default.createElement(
	              "thead",
	              null,
	              this.state.detalle.length > 0 && this.state.cutRegion[0].cutRegion != "0" ? _react2.default.createElement("tr", { style: { justifyContent: "center", textAlign: 'center', height: '30px' } }) : null
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              this.state.detalle.length > 0 && this.state.cutRegion[0].cutRegion != 0 ? this.state.detalle.map(function (d, index) {
	                return _react2.default.createElement(
	                  "tr",
	                  { className: index % 2 === 0 ? css.evenRow : css.oddRow, key: index },
	                  _react2.default.createElement(
	                    "td",
	                    { style: { height: "40px", textAlign: "center" } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: _select2.default.tooltipInicio },
	                      _react2.default.createElement("span", { style: { marginTop: '10px' }, className: "glyphicon glyphicon-info-sign" }),
	                      _react2.default.createElement(
	                        "span",
	                        { className: _select2.default.tooltiptextInicio },
	                        _react2.default.createElement(
	                          "p",
	                          { style: { textAlign: "left" } },
	                          d.fechaFormat == 'PROMEDIOS' ? "Resumen Promedios:" : d.fechaFormat == "TOTALES" ? "Resumen Totales:" : "Resumen Diario:"
	                        ),
	                        d.info.length > 1 ? d.info.map(function (a, index) {
	                          return _react2.default.createElement(
	                            "div",
	                            { style: { padding: "5px" } },
	                            _react2.default.createElement(
	                              "p",
	                              { style: { textAlign: "left" }, key: index },
	                              a
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          "p",
	                          { style: { textAlign: "left", padding: "5px" } },
	                          d.info
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : null
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchDetalle();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(SelectorCliente, {
	            idClienteSeleccionado: this.state.idCliente,
	            seleccionarCliente: this.seleccionarCliente,
	            clientes: this.state.clientes
	          }),
	          _react2.default.createElement(SelectorRegion, {
	            idRegionSeleccionada: this.state.cutRegion,
	            seleccionarRegion: this.seleccionarRegion.bind(this),
	            regiones: this.state.regiones,
	            show: this.state.show,
	            handleShow: this.handleShow,
	            handleShowBlur: this.handleShowBlur.bind(this),
	            clearOptions: this.clearOptions.bind(this),
	            highlightedIndex: this.state.highlightedIndex,
	            isSelected: this.isSelected.bind(this)
	          })
	        ),
	        this.state.dividir ? this.renderDivisionTablas() : this.renderTablaNormal()
	      );
	    }
	  }]);
	
	  return DetalleProgramacionIG;
	}(_react2.default.Component);
	
	var Detalle = function Detalle(_ref) {
	  var detalle = _ref.detalle;
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%" }, className: "row" },
	    _react2.default.createElement(
	      _reactVirtualized.AutoSizer,
	      null,
	      function (_ref2) {
	        var height = _ref2.height,
	            width = _ref2.width;
	        return _react2.default.createElement(
	          _reactVirtualized.Table
	          // general
	          ,
	          { height: height,
	            width: width
	            // headers
	            , headerHeight: 30,
	            headerClassName: css.headerColumn
	            // rows
	            , rowCount: detalle.length,
	            rowGetter: function rowGetter(_ref3) {
	              var index = _ref3.index;
	              return detalle[index];
	            },
	            rowHeight: 40,
	            rowClassName: function rowClassName(_ref4) {
	              var index = _ref4.index;
	              return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	            }
	          },
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "fechaFormat",
	            label: "Fechas",
	            cellRenderer: function cellRenderer(_ref5) {
	              var cellData = _ref5.cellData,
	                  columnData = _ref5.columnData,
	                  dataKey = _ref5.dataKey,
	                  rowData = _ref5.rowData,
	                  rowIndex = _ref5.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 145
	          }),
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "totalIG",
	            label: "Total IG",
	            cellRenderer: function cellRenderer(_ref6) {
	              var cellData = _ref6.cellData,
	                  columnData = _ref6.columnData,
	                  dataKey = _ref6.dataKey,
	                  rowData = _ref6.rowData,
	                  rowIndex = _ref6.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 70
	          }),
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "totalIGnoche",
	            label: "IG Noche",
	            cellRenderer: function cellRenderer(_ref7) {
	              var cellData = _ref7.cellData,
	                  columnData = _ref7.columnData,
	                  dataKey = _ref7.dataKey,
	                  rowData = _ref7.rowData,
	                  rowIndex = _ref7.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 80
	          }),
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "totalIGdia",
	            label: "IG D\xEDa",
	            cellRenderer: function cellRenderer(_ref8) {
	              var cellData = _ref8.cellData,
	                  columnData = _ref8.columnData,
	                  dataKey = _ref8.dataKey,
	                  rowData = _ref8.rowData,
	                  rowIndex = _ref8.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 80
	          }),
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "operadoresNoche",
	            label: "Operadores Noche",
	            cellRenderer: function cellRenderer(_ref9) {
	              var cellData = _ref9.cellData,
	                  columnData = _ref9.columnData,
	                  dataKey = _ref9.dataKey,
	                  rowData = _ref9.rowData,
	                  rowIndex = _ref9.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 140
	          }),
	          _react2.default.createElement(_reactVirtualized.Column, {
	            dataKey: "operadoresDia",
	            label: "Operadores D\xEDa",
	            cellRenderer: function cellRenderer(_ref10) {
	              var cellData = _ref10.cellData,
	                  columnData = _ref10.columnData,
	                  dataKey = _ref10.dataKey,
	                  rowData = _ref10.rowData,
	                  rowIndex = _ref10.rowIndex;
	              return rowData[dataKey];
	            },
	            width: 120
	          })
	        );
	      }
	    )
	  );
	};
	
	var SelectorCliente = function SelectorCliente(_ref11) {
	  var idClienteSeleccionado = _ref11.idClienteSeleccionado,
	      seleccionarCliente = _ref11.seleccionarCliente,
	      clientes = _ref11.clientes;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-sm-2 form-group " },
	    _react2.default.createElement(
	      "label",
	      { className: "control-label", htmlFor: "cliente" },
	      "Clientes"
	    ),
	    _react2.default.createElement(
	      "select",
	      {
	        className: "form-control",
	        name: "clientes",
	        value: idClienteSeleccionado,
	        onChange: seleccionarCliente
	      },
	      _react2.default.createElement(
	        "option",
	        { value: "0" },
	        "Todas"
	      ),
	      clientes.map(function (cliente) {
	        return _react2.default.createElement(
	          "option",
	          {
	            key: cliente.idCliente,
	            value: cliente.idCliente
	          },
	          "" + cliente.nombreCorto
	        );
	      })
	    )
	  );
	};
	var SelectorRegion = function SelectorRegion(_ref12) {
	  var idRegionSeleccionada = _ref12.idRegionSeleccionada,
	      seleccionarRegion = _ref12.seleccionarRegion,
	      regiones = _ref12.regiones,
	      show = _ref12.show,
	      handleShow = _ref12.handleShow,
	      handleShowBlur = _ref12.handleShowBlur,
	      clearOptions = _ref12.clearOptions,
	      highlightedIndex = _ref12.highlightedIndex,
	      isSelected = _ref12.isSelected,
	      clearOption = _ref12.clearOption;
	  return _react2.default.createElement(
	    "div",
	    { className: _select2.default.container + " col-sm-4" },
	    _react2.default.createElement(
	      "label",
	      null,
	      "Regiones"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _select2.default.margenContainer },
	      _react2.default.createElement(
	        "div",
	        { className: _select2.default.container2, onBlur: handleShowBlur, onClick: handleShow },
	        _react2.default.createElement(
	          "label",
	          { className: _select2.default.value, htmlFor: "regiones" },
	          idRegionSeleccionada.map(function (i) {
	            if (idRegionSeleccionada.length > 1) {
	              if (i.cutRegion !== "0") {
	                return _react2.default.createElement(
	                  "button",
	                  { key: i.cutRegion, className: _select2.default["option-badge"], onClick: function onClick(e) {
	                      e.stopPropagation();
	                      seleccionarRegion(i);
	                    } },
	                  i.nombreCorto,
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: _select2.default["remove-btn"] },
	                    "\xD7"
	                  )
	                );
	              }
	            } else {
	              if (i.cutRegion !== "0") {
	                return _react2.default.createElement(
	                  "button",
	                  { key: i.cutRegion, className: _select2.default["option-badge"], onClick: function onClick(e) {
	                      e.stopPropagation();
	                      seleccionarRegion(i);
	                    } },
	                  i.nombreCorto,
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: _select2.default["remove-btn"] },
	                    "\xD7"
	                  )
	                );
	              } else {
	                return _react2.default.createElement(
	                  "button",
	                  { key: i.cutRegion, className: _select2.default["option-badge"] },
	                  i.nombreCorto
	                );
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "button",
	          { className: _select2.default["clear-btn"], onClick: clearOptions },
	          "\xD7"
	        ),
	        _react2.default.createElement("div", { className: _select2.default.divider }),
	        _react2.default.createElement("div", { className: _select2.default.caret }),
	        _react2.default.createElement(
	          "ul",
	          { className: _select2.default.options + " " + (show ? _select2.default.show : '') },
	          regiones.map(function (region, index) {
	            return _react2.default.createElement(
	              "li",
	              {
	                key: region.cutRegion,
	                value: region.nombreCorto,
	                className: _select2.default.option + " \n              " + (isSelected(region) ? _select2.default.selected : '') + "\n              " + (index == highlightedIndex ? _select2.default.highlighted : ''),
	                onClick: function onClick() {
	                  return seleccionarRegion(region);
	                }
	              },
	              "" + region.nombreCorto
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	DetalleProgramacionIG.propTypes = {
	  regiones: PropTypes.arrayOf(PropTypes.object).isRequired,
	  clientes: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetalleProgramacionIG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"select__container___3Yn9A","container2":"select__container2___26d4d","margenContainer":"select__margenContainer___oSDnY","value":"select__value___1EaWg","check-btn":"select__check-btn___24FfV","clear-btn":"select__clear-btn___1dSwv","divider":"select__divider___1z7Qu","caret":"select__caret___19d64","options":"select__options___3qIKq","show":"select__show___1G7vG","option":"select__option___1gfE5","selected":"select__selected___2-QiU","option-badge":"select__option-badge___1WT25","tooltipInicio":"select__tooltipInicio___2tAqL","tooltiptextInicio":"select__tooltiptextInicio___26OkR"};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DetalleProgramacionAG = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _modal = __webpack_require__(748);
	
	var css = _interopRequireWildcard(_modal);
	
	var _reactVirtualized = __webpack_require__(653);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// API
	
	// CSS
	
	// Componentes
	
	var DetalleProgramacionAG = exports.DetalleProgramacionAG = function (_React$Component) {
	  _inherits(DetalleProgramacionAG, _React$Component);
	
	  function DetalleProgramacionAG(props) {
	    _classCallCheck(this, DetalleProgramacionAG);
	
	    var _this = _possibleConstructorReturn(this, (DetalleProgramacionAG.__proto__ || Object.getPrototypeOf(DetalleProgramacionAG)).call(this, props));
	
	    _this.state = {
	      idCliente: "0",
	      cutRegion: "0",
	      clientes: _this.props.clientes,
	      regiones: _this.props.regiones,
	      fechaInicio: _this.props.fechaInicio,
	      fechaFin: _this.props.fechaFin,
	      detalle: [],
	      dividir: false,
	      isLoading: true
	    };
	    _this.fetchDetalle = function () {
	      _this.setState({ detalle: [] });
	      _this.setState({ isLoading: true });
	      _v2.default.auditoria.getDetalle(_this.state.fechaInicio, _this.state.fechaFin, _this.state.idCliente, _this.state.cutRegion).then(function (detalle) {
	        var longitud = detalle.auditorias.length;
	        var ordenadasPorFecha = detalle.auditorias.sort(function (a, b) {
	          return new Date(a.fechaProgramada) - new Date(b.fechaProgramada);
	        });
	        var total = {
	          fechaProgramadaDia: "Total",
	          totalAG: Math.round(ordenadasPorFecha.reduce(function (prev, curr) {
	            return prev + curr.totalAG;
	          }, 0)),
	          totalOBL: Math.round(ordenadasPorFecha.reduce(function (prev, curr) {
	            return prev + curr.totalOBL;
	          }, 0))
	        };
	        var promedio = {
	          fechaProgramadaDia: "Promedio",
	          totalAG: Math.round(total.totalAG / longitud),
	          totalOBL: Math.round(total.totalOBL / longitud)
	        };
	        if (ordenadasPorFecha.length > 0) {
	          ordenadasPorFecha.push(promedio);
	          ordenadasPorFecha.push(total);
	        }
	        _this.setState({
	          detalle: ordenadasPorFecha
	        });
	        _this.setState({ isLoading: false });
	      }).catch(function (meh) {
	        _this.setState({ isLoading: false });
	      });
	    };
	    _this.seleccionarRegion = function (evt) {
	      var cutRegion = evt.target.value;
	      _this.setState({
	        cutRegion: cutRegion,
	        detalle: []
	      }, function () {
	        _this.fetchDetalle();
	      });
	    };
	    return _this;
	  }
	
	  _createClass(DetalleProgramacionAG, [{
	    key: "renderDivisionTablas",
	    value: function renderDivisionTablas() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6" },
	          _react2.default.createElement(Detalle, { detalle: this.state.coleccionUno })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6" },
	          _react2.default.createElement(Detalle, { detalle: this.state.coleccionDos })
	        )
	      );
	    }
	  }, {
	    key: "renderTablaNormal",
	    value: function renderTablaNormal() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12" },
	          _react2.default.createElement(Detalle, {
	            detalle: this.state.detalle,
	            isLoading: this.state.isLoading
	          })
	        )
	      );
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchDetalle();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(SelectorRegion, {
	            idRegionSeleccionada: this.state.idRegion,
	            seleccionarRegion: this.seleccionarRegion,
	            regiones: this.state.regiones
	          })
	        ),
	        this.state.dividir ? this.renderDivisionTablas() : this.renderTablaNormal()
	      );
	    }
	  }]);
	
	  return DetalleProgramacionAG;
	}(_react2.default.Component);
	
	var Detalle = function Detalle(_ref) {
	  var detalle = _ref.detalle,
	      isLoading = _ref.isLoading;
	
	  var Tabla = function Tabla() {
	    if (detalle.length > 0) {
	      return _react2.default.createElement(
	        _reactVirtualized.AutoSizer,
	        null,
	        function (_ref2) {
	          var height = _ref2.height,
	              width = _ref2.width;
	          return _react2.default.createElement(
	            _reactVirtualized.Table
	            // general
	            ,
	            { height: height,
	              width: width
	              // headers
	              , headerHeight: 30,
	              headerClassName: css.headerColumn
	              // rows
	              , rowCount: detalle.length,
	              rowGetter: function rowGetter(_ref3) {
	                var index = _ref3.index;
	                return detalle[index];
	              },
	              rowHeight: 30,
	              rowClassName: function rowClassName(_ref4) {
	                var index = _ref4.index;
	                return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	              }
	            },
	            _react2.default.createElement(_reactVirtualized.Column, {
	              dataKey: "fechaProgramadaDia",
	              label: "Fechas",
	              cellRenderer: function cellRenderer(_ref5) {
	                var cellData = _ref5.cellData,
	                    columnData = _ref5.columnData,
	                    dataKey = _ref5.dataKey,
	                    rowData = _ref5.rowData,
	                    rowIndex = _ref5.rowIndex;
	                return rowData[dataKey];
	              },
	              width: 145
	            }),
	            _react2.default.createElement(_reactVirtualized.Column, {
	              dataKey: "totalAG",
	              label: "Total AG",
	              cellRenderer: function cellRenderer(_ref6) {
	                var cellData = _ref6.cellData,
	                    columnData = _ref6.columnData,
	                    dataKey = _ref6.dataKey,
	                    rowData = _ref6.rowData,
	                    rowIndex = _ref6.rowIndex;
	                return rowData[dataKey];
	              },
	              width: 145
	            }),
	            _react2.default.createElement(_reactVirtualized.Column, {
	              dataKey: "totalOBL",
	              label: "OBLIGATORIOS",
	              cellRenderer: function cellRenderer(_ref7) {
	                var cellData = _ref7.cellData,
	                    columnData = _ref7.columnData,
	                    dataKey = _ref7.dataKey,
	                    rowData = _ref7.rowData,
	                    rowIndex = _ref7.rowIndex;
	                return rowData[dataKey];
	              },
	              width: 120
	            })
	          );
	        }
	      );
	    } else {
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "col-md-12 bg-warning",
	          style: {
	            padding: "20px",
	            fontWeight: "bold",
	            marginLeft: "15px",
	            marginRight: "15px"
	          }
	        },
	        "No se encontraron auditorias en este rango de fechas"
	      );
	    }
	  };
	  var TablaLoading = function TablaLoading() {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "col-md-12 bg-warning",
	        style: {
	          padding: "20px",
	          fontWeight: "bold",
	          marginLeft: "15px",
	          marginRight: "15px"
	        }
	      },
	      "Cargando..."
	    );
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%" }, className: "row" },
	    isLoading ? _react2.default.createElement(TablaLoading, null) : _react2.default.createElement(Tabla, null)
	  );
	};
	
	var SelectorRegion = function SelectorRegion(_ref8) {
	  var idRegionSeleccionada = _ref8.idRegionSeleccionada,
	      seleccionarRegion = _ref8.seleccionarRegion,
	      regiones = _ref8.regiones;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-sm-2 form-group " },
	    _react2.default.createElement(
	      "label",
	      { className: "control-label", htmlFor: "cliente" },
	      "Regiones"
	    ),
	    _react2.default.createElement(
	      "select",
	      {
	        className: "form-control",
	        name: "regiones",
	        value: idRegionSeleccionada,
	        onChange: seleccionarRegion
	      },
	      _react2.default.createElement(
	        "option",
	        { value: "0" },
	        "Todas"
	      ),
	      regiones.map(function (region) {
	        return _react2.default.createElement(
	          "option",
	          {
	            key: region.cutRegion,
	            value: region.cutRegion
	          },
	          "" + region.nombreCorto
	        );
	      })
	    )
	  );
	};
	
	DetalleProgramacionAG.propTypes = {
	  regiones: PropTypes.arrayOf(PropTypes.object).isRequired,
	  clientes: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetalleProgramacionAG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ProgramacionPublicada = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _BlackBoxIGSemanal = __webpack_require__(639);
	
	var _BlackBoxIGSemanal2 = _interopRequireDefault(_BlackBoxIGSemanal);
	
	var _InformativoPublicados = __webpack_require__(963);
	
	var _TablaPublicados = __webpack_require__(964);
	
	var _SelectRangeVirtualTable = __webpack_require__(703);
	
	var _SelectRangeVirtualTable2 = _interopRequireDefault(_SelectRangeVirtualTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// API
	
	// MOMENT
	
	_moment2.default.locale('es');
	// CSS
	
	var cx = _bind2.default.bind(css);
	// COMPONENTES
	
	// FORMAT FECHA
	var format = 'YYYY-MM-DD';
	
	var ProgramacionPublicada = exports.ProgramacionPublicada = function (_React$Component) {
	    _inherits(ProgramacionPublicada, _React$Component);
	
	    function ProgramacionPublicada(props) {
	        _classCallCheck(this, ProgramacionPublicada);
	
	        var _this = _possibleConstructorReturn(this, (ProgramacionPublicada.__proto__ || Object.getPrototypeOf(ProgramacionPublicada)).call(this, props));
	
	        _this.buscarInventarios = function () {
	            var _this$setState;
	
	            var fechaInicio = _this.state.fechaInicialSeleccionada.format(format);
	            var fechaFin = _this.state.fechaFinalSeleccionada.format(format);
	            var idCliente = _this.state.idCliente;
	            _this.setState((_this$setState = { inventariosFiltrados: [], totalUnidadesContar: 0, sobredotadas: 0, vacias: 0, peligro: 0 }, _defineProperty(_this$setState, 'peligro', 0), _defineProperty(_this$setState, 'noInformadas', 0), _defineProperty(_this$setState, 'totalInventarios', 0), _this$setState));
	            _v2.default.inventario.buscarResumido(fechaInicio, fechaFin, idCliente).then(function (result) {
	                _this.blackbox.reset();
	                result.inventarios.forEach(function (inventario) {
	                    return _this.blackbox.add(inventario);
	                });
	                _this.blackbox.ordenarLista();
	                _this.setState(_this.blackbox.getListaFiltrada());
	                _this.setState({ sobredotadas: result.totalNominasSobreDotacion, vacias: result.totalNominasVacias, peligro: result.totalNominasPeligro,
	                    noInformadas: result.totalNoInformadas, totalInventarios: result.totalInventarios, totalUnidadesContar: result.totalAcontar,
	                    totalEnCambio: result.totalEnCambio });
	            });
	        };
	
	        _this.actualizarFiltro = function (nombreFiltro, filtro) {
	            _this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            _this.setState(_this.blackbox.getListaFiltrada());
	        };
	
	        _this.onSelectRangoChanged = function (momentumFechaInicio, momentumFechaFinal) {
	            _this.setState({
	                fechaInicialSeleccionada: momentumFechaInicio,
	                fechaFinalSeleccionada: momentumFechaFinal
	            }, function () {
	                _this.buscarInventarios();
	            });
	        };
	
	        _this.onSelectClienteChanged = function (evt) {
	            _this.setState({
	                idCliente: evt.target.value
	            }, function () {
	                _this.buscarInventarios();
	            });
	        };
	
	        _this.blackbox = new _BlackBoxIGSemanal2.default();
	        _this.state = {
	            idCliente: 0,
	            filtros: {},
	            inventariosFiltrados: [],
	            fechaInicialSeleccionada: (0, _moment2.default)().subtract(1, 'days'),
	            fechaFinalSeleccionada: (0, _moment2.default)().endOf('week'),
	            totalUnidadesContar: 0,
	            sobredotadas: 0,
	            vacias: 0,
	            peligro: 0,
	            noInformadas: 0,
	            totalInventarios: 0
	        };
	        return _this;
	    }
	
	    _createClass(ProgramacionPublicada, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'page-header row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'tituloAuditoria') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-3", 'divTitulo') },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-certificate' }),
	                                        ' Inventarios publicados'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(SelectorCliente, {
	                                        onSelectClienteChanged: this.onSelectClienteChanged,
	                                        clientes: this.props.clientes,
	                                        idCliente: this.state.idCliente
	                                    }),
	                                    _react2.default.createElement(SelectorRango, {
	                                        fechaInicial: this.state.fechaInicialSeleccionada,
	                                        fechaFinal: this.state.fechaFinalSeleccionada,
	                                        onSelectRangoChanged: this.onSelectRangoChanged
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(ButtonShowChange, {
	                                        totalEnCambio: this.state.totalEnCambio
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_InformativoPublicados.InformativoPublicados, {
	                            sobredotadas: this.state.sobredotadas,
	                            peligro: this.state.peligro,
	                            noInformadas: this.state.noInformadas,
	                            vacias: this.state.vacias,
	                            totalInventarios: this.state.totalInventarios,
	                            totalUnidadesContar: this.state.totalUnidadesContar
	                        }),
	                        _react2.default.createElement(_TablaPublicados.TablaPublicadosCompleta, {
	                            inventarios: this.state.inventariosFiltrados,
	                            filtros: this.state.filtros,
	                            actualizarFiltro: this.actualizarFiltro.bind(this)
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProgramacionPublicada;
	}(_react2.default.Component);
	
	var SelectorRango = function SelectorRango(_ref) {
	    var fechaInicial = _ref.fechaInicial,
	        fechaFinal = _ref.fechaFinal,
	        onSelectRangoChanged = _ref.onSelectRangoChanged;
	    return _react2.default.createElement(
	        'div',
	        { className: cx("col-md-9", 'divNavBar') },
	        _react2.default.createElement(_SelectRangeVirtualTable2.default, {
	            startDateSelected: fechaInicial,
	            endDateSelected: fechaFinal,
	            onInit: function onInit() {
	                console.log("on init");
	            },
	            onRangeSelected: onSelectRangoChanged.bind(undefined)
	        })
	    );
	};
	var SelectorCliente = function SelectorCliente(_ref2) {
	    var idCliente = _ref2.idCliente,
	        clientes = _ref2.clientes,
	        onSelectClienteChanged = _ref2.onSelectClienteChanged;
	    return _react2.default.createElement(
	        'div',
	        { className: cx("col-md-3", 'divNavBar') },
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: idCliente,
	                onChange: onSelectClienteChanged.bind(undefined) },
	            _react2.default.createElement(
	                'option',
	                { value: '0' },
	                'Clientes'
	            ),
	            clientes.map(function (cliente, index) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: index, value: cliente.idCliente },
	                    cliente.nombreCorto + ' - ' + cliente.nombre
	                );
	            })
	        )
	    );
	};
	var ButtonShowChange = function ButtonShowChange(_ref3) {
	    var totalEnCambio = _ref3.totalEnCambio;
	    return _react2.default.createElement(
	        'div',
	        { className: cx("col-md-12", 'divNavBar') },
	        _react2.default.createElement(
	            'button',
	            { className: 'btn btn-xs btn-info pull-right' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-th-list' }),
	            ' En modificaci\xF3n ',
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                totalEnCambio
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ProgramacionPublicada.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"PanelAuditoria__tableFixed___3QqgY","trSeparador":"PanelAuditoria__trSeparador___ZH5NM","colIndex":"PanelAuditoria__colIndex___12SQI","thIndex":"PanelAuditoria__thIndex___26WT8","tdIndex":"PanelAuditoria__tdIndex___2twJo","colFechaAuditoria":"PanelAuditoria__colFechaAuditoria___1SOLn","thFechaAuditoria":"PanelAuditoria__thFechaAuditoria___2N23r","tdFechaAuditoria":"PanelAuditoria__tdFechaAuditoria___1GGfU","colSku":"PanelAuditoria__colSku___3HoOd","thSku":"PanelAuditoria__thSku___Pr0Dp","tdSku":"PanelAuditoria__tdSku___FJq49","colBarra":"PanelAuditoria__colBarra___3HECJ","thBarra":"PanelAuditoria__thBarra___DJwkk","tdBarra":"PanelAuditoria__tdBarra___1FQQQ","colDescriptor":"PanelAuditoria__colDescriptor___1tAa2","thDescriptor":"PanelAuditoria__thDescriptor___1VXo9","tdDescriptor":"PanelAuditoria__tdDescriptor___nC9e_","colLaboratorio":"PanelAuditoria__colLaboratorio___TKQA5","thLaboratorio":"PanelAuditoria__thLaboratorio___15box","tdLaboratorio":"PanelAuditoria__tdLaboratorio___1Rk8l","colItems":"PanelAuditoria__colItems___3asSG","thItems":"PanelAuditoria__thItems___16mcT","thItems_derecho":"PanelAuditoria__thItems_derecho___3A3d_","tdItems":"PanelAuditoria__tdItems___283iE","colTotalConteo":"PanelAuditoria__colTotalConteo___EpVgo","thTotalConteo":"PanelAuditoria__thTotalConteo___nwUzc","tdTotalConteo":"PanelAuditoria__tdTotalConteo___4aN9s","colStockNo":"PanelAuditoria__colStockNo___3isAY","thStockNo":"PanelAuditoria__thStockNo___5cUa0","tdStockNo":"PanelAuditoria__tdStockNo___2wRf3","colSinRespaldo":"PanelAuditoria__colSinRespaldo___32b1l","thSinRespaldo":"PanelAuditoria__thSinRespaldo___AeNCf","tdSinRespaldo":"PanelAuditoria__tdSinRespaldo___1LsEQ","colEliminar":"PanelAuditoria__colEliminar___1j-fY","thEliminar":"PanelAuditoria__thEliminar___1RNcG","tdEliminar":"PanelAuditoria__tdEliminar___3QG0o","colLote":"PanelAuditoria__colLote___3-JcO","thLote":"PanelAuditoria__thLote___2hS3L","tdLote":"PanelAuditoria__tdLote___ID7t7","colVendedor":"PanelAuditoria__colVendedor___3Qrpm","thVendedor":"PanelAuditoria__thVendedor___30vxu","tdVendedor":"PanelAuditoria__tdVendedor___3rCGB","colFechExp":"PanelAuditoria__colFechExp___1gEqF","thFechExp":"PanelAuditoria__thFechExp___1n3Bv","tdFechExp":"PanelAuditoria__tdFechExp___2UOlG","colVencido":"PanelAuditoria__colVencido___RnxWV","thVencido":"PanelAuditoria__thVencido___3ktmT","tdVencido":"PanelAuditoria__tdVencido___1Pnf0","colStock":"PanelAuditoria__colStock___3z3yt","thStock":"PanelAuditoria__thStock___VXgit","tdStock":"PanelAuditoria__tdStock___1rosk","glyphiconStock":"PanelAuditoria__glyphiconStock___71iVN","colTeorico":"PanelAuditoria__colTeorico___2QB6W","thTeorico":"PanelAuditoria__thTeorico___315Ta","tdTeorico":"PanelAuditoria__tdTeorico___cQbqz","colMalEnfocado":"PanelAuditoria__colMalEnfocado___O6Ohe","thMalEnfocado":"PanelAuditoria__thMalEnfocado___8sO_h","tdMalEnfocado":"PanelAuditoria__tdMalEnfocado___YddyQ","colPolitica":"PanelAuditoria__colPolitica___1aaMP","thPolitica":"PanelAuditoria__thPolitica___xIAHJ","tdPolitica":"PanelAuditoria__tdPolitica___2gss5","colImagen":"PanelAuditoria__colImagen___1MMTI","thImagen":"PanelAuditoria__thImagen___2HcLu","tdImagen":"PanelAuditoria__tdImagen___18elA","imgVencimiento":"PanelAuditoria__imgVencimiento___3OG8u","verImagen":"PanelAuditoria__verImagen___1rYzH","colBorrosa":"PanelAuditoria__colBorrosa___Y3rWO","thBorrosa":"PanelAuditoria__thBorrosa___3GRlu","tdBorrosa":"PanelAuditoria__tdBorrosa___3MdQN","colModificaciones":"PanelAuditoria__colModificaciones___2sA8W","thModificaciones":"PanelAuditoria__thModificaciones___3EuZA","tdModificaciones":"PanelAuditoria__tdModificaciones___1vBsm","inputCaptura":"PanelAuditoria__inputCaptura___2WscS","inputFechaExp":"PanelAuditoria__inputFechaExp___wshrE","inputLote":"PanelAuditoria__inputLote___YDAz0","rowEditado":"PanelAuditoria__rowEditado___3W6tV","rowRevisado":"PanelAuditoria__rowRevisado___27jJX","rowEliminado":"PanelAuditoria__rowEliminado___30kGw","btnGuardar":"PanelAuditoria__btnGuardar___1lkeX","btnRevisado":"PanelAuditoria__btnRevisado___Gkm2a","labelHeading":"PanelAuditoria__labelHeading___EwTJZ","tituloAuditoria":"PanelAuditoria__tituloAuditoria___Z7Ov5","navRevision":"PanelAuditoria__navRevision___1baec","btnRevision":"PanelAuditoria__btnRevision___b3_KE","alerta":"PanelAuditoria__alerta___tmNRI","mensajesPendientes":"PanelAuditoria__mensajesPendientes___lvPeM","btnRevisionRed":"PanelAuditoria__btnRevisionRed___2Nn6v","divTitulo":"PanelAuditoria__divTitulo___3_xj_","divNavBar":"PanelAuditoria__divNavBar___2Rp-0","iconoEspejo":"PanelAuditoria__iconoEspejo___1SarN","btnPublicar":"PanelAuditoria__btnPublicar___2qXDd","btnEstadosCaptura":"PanelAuditoria__btnEstadosCaptura___zBuxz","tooltip":"PanelAuditoria__tooltip___LO04r","tooltiptext":"PanelAuditoria__tooltiptext___2XIuX","tooltipInicio":"PanelAuditoria__tooltipInicio___2MXv-","tooltiptextInicio":"PanelAuditoria__tooltiptextInicio___3m9Kf","imagenStock":"PanelAuditoria__imagenStock___1ks6F","imagenInicio":"PanelAuditoria__imagenInicio___1msPj","android_pda":"PanelAuditoria__android_pda___3p92F","noandroid_pda":"PanelAuditoria__noandroid_pda___2FIn6","linkEjecutado":"PanelAuditoria__linkEjecutado___RwjjR","linkNoEjecutado":"PanelAuditoria__linkNoEjecutado___1NJ29","divConTooltip":"PanelAuditoria__divConTooltip___rj-sC","tablaTooltip":"PanelAuditoria__tablaTooltip___1Gxoo","rowSelect":"PanelAuditoria__rowSelect___2D0p9","btn-file":"PanelAuditoria__btn-file___2I5cD","div-option-file":"PanelAuditoria__div-option-file___R2XyO","labelPanel":"PanelAuditoria__labelPanel___1lJgR","camposPanel":"PanelAuditoria__camposPanel___1TgIz","localCeco":"PanelAuditoria__localCeco___eKzde","accionesCentradas":"PanelAuditoria__accionesCentradas___1pMEE","accionLado":"PanelAuditoria__accionLado___ZP4Uv","accionLadoDerecho":"PanelAuditoria__accionLadoDerecho___3F9IW","accionGrupo":"PanelAuditoria__accionGrupo___3EncX","accionCentrada":"PanelAuditoria__accionCentrada___2P4nW"};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InformativoPublicados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// CSS
	
	
	var cx = _bind2.default.bind(css);
	
	var InformativoPublicados = exports.InformativoPublicados = function (_React$Component) {
	    _inherits(InformativoPublicados, _React$Component);
	
	    function InformativoPublicados(props) {
	        _classCallCheck(this, InformativoPublicados);
	
	        return _possibleConstructorReturn(this, (InformativoPublicados.__proto__ || Object.getPrototypeOf(InformativoPublicados)).call(this, props));
	    }
	
	    _createClass(InformativoPublicados, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'N\xF3minas sin informar: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.noInformadas
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'N\xF3minas peligro: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.peligro
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'N\xF3minas sobredotadas: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.sobredotadas
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'N\xF3minas Vac\xEDas: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.vacias
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'Cantidad inventarios: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.totalInventarios
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-3 control-label' },
	                                'Unidades a contar: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.totalUnidadesContar.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InformativoPublicados;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InformativoPublicados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaPublicadosCompleta = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _RowPublicado = __webpack_require__(965);
	
	var _ProgramacionPublicada = __webpack_require__(966);
	
	var css = _interopRequireWildcard(_ProgramacionPublicada);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// CSS
	
	var TablaPublicadosCompleta = exports.TablaPublicadosCompleta = function (_React$Component) {
	    _inherits(TablaPublicadosCompleta, _React$Component);
	
	    function TablaPublicadosCompleta(props) {
	        _classCallCheck(this, TablaPublicadosCompleta);
	
	        var _this = _possibleConstructorReturn(this, (TablaPublicadosCompleta.__proto__ || Object.getPrototypeOf(TablaPublicadosCompleta)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TablaPublicadosCompleta, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            TablaPublicadosTodo,
	                            {
	                                filtros: this.props.filtros,
	                                actualizarFiltro: this.props.actualizarFiltro
	                            },
	                            _.range(0, totalInventarios).map(function (index) {
	                                var inventario = _this2.props.inventarios[index];
	                                return _react2.default.createElement(_RowPublicado.RowPublicadoCompleto, {
	                                    key: index,
	                                    index: index,
	                                    inventario: inventario,
	                                    correlativo: '' + (index + 1)
	                                });
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaPublicadosCompleta;
	}(_react2.default.Component);
	
	TablaPublicadosCompleta.contextTypes = {};
	var TablaPublicadosTodo = function TablaPublicadosTodo(_ref) {
	    var children = _ref.children,
	        filtros = _ref.filtros,
	        actualizarFiltro = _ref.actualizarFiltro;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed table-bordered " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colFecha }),
	            _react2.default.createElement('col', { className: css.colCliente }),
	            _react2.default.createElement('col', { className: css.colCeco }),
	            _react2.default.createElement('col', { className: css.colRegion }),
	            _react2.default.createElement('col', { className: css.colComuna }),
	            _react2.default.createElement('col', { className: css.colTienda }),
	            _react2.default.createElement('col', { className: css.colDireccion }),
	            _react2.default.createElement('col', { className: css.colStock }),
	            _react2.default.createElement('col', { className: css.colDotacion }),
	            _react2.default.createElement('col', { className: css.colTurno }),
	            _react2.default.createElement('col', { className: css.colLider }),
	            _react2.default.createElement('col', { className: css.colLider }),
	            _react2.default.createElement('col', { className: css.colHora }),
	            _react2.default.createElement('col', { className: css.colHora }),
	            _react2.default.createElement('col', { className: css.colNomina }),
	            _react2.default.createElement('col', { className: css.colEstadoNomina })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thFecha },
	                    'FECHA'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thCliente },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'CL',
	                        filtro: filtros.filtroClientes || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroClientes'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thCeco },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'CE',
	                        filtro: filtros.filtroCeco || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroCeco'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thRegion },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'RG',
	                        filtro: filtros.filtroRegiones || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroRegiones'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thComuna },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'COMUNA',
	                        filtro: filtros.filtroComunas || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroComunas'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTienda },
	                    'TIENDA'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDireccion },
	                    'DIR'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thStock },
	                    'STOCK'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDotacion },
	                    'DOT'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTurno },
	                    'TURNO'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLider },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'LIDER',
	                        filtro: filtros.filtroLideres || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroLideres')
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLider },
	                    'SUPERVISOR'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thHora },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'LIDER',
	                        filtro: filtros.filtroHoraLider || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroHoraLider')
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thHora },
	                    'EQUIPO'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thNomina },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'NOMINA',
	                        filtro: filtros.filtroNominas || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroNominas')
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thEstadoNomina },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: '',
	                        filtro: filtros.filtroNominasEstado || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroNominasEstado'),
	                        busquedaExacta: false
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaPublicados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowPublicadoCompleto = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProgramacionPublicada = __webpack_require__(966);
	
	var css = _interopRequireWildcard(_ProgramacionPublicada);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	var cx = _bind2.default.bind(css);
	
	var RowPublicadoCompleto = exports.RowPublicadoCompleto = function (_React$Component) {
	    _inherits(RowPublicadoCompleto, _React$Component);
	
	    function RowPublicadoCompleto(props) {
	        _classCallCheck(this, RowPublicadoCompleto);
	
	        var _this = _possibleConstructorReturn(this, (RowPublicadoCompleto.__proto__ || Object.getPrototypeOf(RowPublicadoCompleto)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(RowPublicadoCompleto, [{
	        key: 'render',
	        value: function render() {
	            var inv = this.props.inventario;
	            var labelNominas = ['label-default', 'label-default', 'label-default', 'label-success', 'label-info', 'label-primary'];
	            var estadoNominas = ['-', 'Deshabilitada', 'Pendiente', 'Recibida', 'Aprobada', 'Informada'];
	            var estadoConteo = ['SC', 'PE', 'PR', 'OP', 'SD', 'SO'];
	            var labelConteo = ['label-default', 'label-danger', 'label-warning', 'label-success', 'label-info', 'label-primary'];
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFechaProgramada },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: true,
	                        value: inv.inv_fechaProgramadaC,
	                        valorPadre: inv.inv_fechaProgramadaPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    inv.cliente_nombreCorto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    inv.local_ceco
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    inv.local_region
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    inv.local_comuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    inv.local_nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDireccion },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.tooltip },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-search" }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.tooltiptext },
	                            inv.local_direccion
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    inv.inv_stockTeorico.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDotacion },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoDia,
	                        value: inv.ndia_dotOperadores,
	                        valorPadre: inv.ndia_dotOperadoresPadre
	                    }),
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        value: inv.nnoche_dotOperadores,
	                        valorPadre: inv.nnoche_dotOperadoresPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTurno },
	                    inv.inv_jornada
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLider },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoDia,
	                        value: inv.ndia_lider,
	                        valorPadre: inv.ndia_liderPadre
	                    }),
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        value: inv.nnoche_lider,
	                        valorPadre: inv.nnoche_liderPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLider },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoDia,
	                        value: inv.ndia_supervisor,
	                        valorPadre: inv.ndia_supervisorPadre
	                    }),
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        value: inv.nnoche_supervisor,
	                        valorPadre: inv.nnoche_supervisorPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHora },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoDia,
	                        value: inv.ndia_hrLider,
	                        valorPadre: inv.ndia_hrLiderPadre
	                    }),
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        value: inv.nnoche_hrLider,
	                        valorPadre: inv.nnoche_hrLiderPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHora },
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoDia,
	                        value: inv.ndia_hrEquipo,
	                        valorPadre: inv.ndia_hrEquipoPadre
	                    }),
	                    _react2.default.createElement(TextoconTooltip, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        value: inv.nnoche_hrEquipo,
	                        valorPadre: inv.nnoche_hrEquipoPadre
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNomina },
	                    _react2.default.createElement(BotonNomina, {
	                        visible: inv.inv_tieneTurnoDia,
	                        idNomina: inv.ndia_idNomina,
	                        label: labelNominas[inv.ndia_idEstadoNomina],
	                        texto: estadoNominas[inv.ndia_idEstadoNomina]
	                    }),
	                    _react2.default.createElement(BotonNomina, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        idNomina: inv.nnoche_idNomina,
	                        label: labelNominas[inv.nnoche_idEstadoNomina],
	                        texto: estadoNominas[inv.nnoche_idEstadoNomina]
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNomina },
	                    _react2.default.createElement(BotonEstadoNomina, {
	                        visible: inv.inv_tieneTurnoDia,
	                        label: labelConteo[inv.ndia_calificacionNomina],
	                        texto: estadoConteo[inv.ndia_calificacionNomina],
	                        mensaje: inv.ndia_mensaje,
	                        stockSugerido: inv.ndia_stockSugerido,
	                        stockTeorico: inv.inv_stockTeorico,
	                        conteoSugerido: inv.ndia_conteoSugerido,
	                        totalTitulares: inv.ndia_totalTitulares,
	                        totalAgregados: inv.ndia_dotOperadores
	
	                    }),
	                    _react2.default.createElement(BotonEstadoNomina, {
	                        visible: inv.inv_tieneTurnoNoche,
	                        label: labelConteo[inv.nnoche_calificacionNomina],
	                        texto: estadoConteo[inv.nnoche_calificacionNomina],
	                        mensaje: inv.nnoche_mensaje,
	                        stockSugerido: inv.nnoche_stockSugerido,
	                        stockTeorico: inv.inv_stockTeorico,
	                        conteoSugerido: inv.nnoche_conteoSugerido,
	                        totalTitulares: inv.nnoche_totalTitulares,
	                        totalAgregados: inv.nnoche_dotOperadores
	                    })
	                )
	            );
	        }
	    }]);
	
	    return RowPublicadoCompleto;
	}(_react2.default.Component);
	
	RowPublicadoCompleto.contextTypes = {};
	var BotonNomina = function BotonNomina(_ref) {
	    var visible = _ref.visible,
	        idNomina = _ref.idNomina,
	        label = _ref.label,
	        texto = _ref.texto;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'a',
	            { href: '/nomina/' + idNomina,
	                className: cx('label', label, visible ? 'center-block' : 'hide'),
	                target: '_blank' },
	            texto
	        )
	    );
	};
	var BotonEstadoNomina = function BotonEstadoNomina(_ref2) {
	    var visible = _ref2.visible,
	        label = _ref2.label,
	        texto = _ref2.texto,
	        mensaje = _ref2.mensaje,
	        stockSugerido = _ref2.stockSugerido,
	        stockTeorico = _ref2.stockTeorico,
	        conteoSugerido = _ref2.conteoSugerido,
	        totalTitulares = _ref2.totalTitulares,
	        totalAgregados = _ref2.totalAgregados;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'p',
	            { className: css.tooltip },
	            _react2.default.createElement(
	                'a',
	                {
	                    className: cx('label', label, visible ? 'center-block' : 'hide'),
	                    target: '_blank' },
	                texto
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: css.tooltiptext },
	                '-',
	                mensaje,
	                '.',
	                _react2.default.createElement('br', null),
	                '-Stock Promedio Local: ',
	                stockSugerido,
	                _react2.default.createElement('br', null),
	                '-Stock Informado: ',
	                stockTeorico,
	                _react2.default.createElement('br', null),
	                '-Conteo Sugerido: ',
	                conteoSugerido,
	                _react2.default.createElement('br', null),
	                '-Operadores: ',
	                totalTitulares + ' de ' + totalAgregados
	            )
	        )
	    );
	};
	var Texto = function Texto(_ref3) {
	    var visible = _ref3.visible,
	        value = _ref3.value;
	    return _react2.default.createElement(
	        'div',
	        { className: visible ? '' : 'hidden' },
	        value
	    );
	};
	var TextoconTooltip = function TextoconTooltip(_ref4) {
	    var visible = _ref4.visible,
	        value = _ref4.value,
	        valorPadre = _ref4.valorPadre;
	    return _react2.default.createElement(
	        'div',
	        { className: visible ? '' : 'hidden' },
	        valorPadre ? _react2.default.createElement(
	            'div',
	            { className: css.tdFechaEnMovimiento },
	            _react2.default.createElement(
	                'p',
	                { className: css.tooltip },
	                value,
	                _react2.default.createElement(
	                    'span',
	                    { className: css.tooltiptext },
	                    'IG Semanal: ' + valorPadre
	                )
	            )
	        ) : _react2.default.createElement(
	            'div',
	            { className: css.tdFecha },
	            value
	        )
	    );
	};
	var Dotacion = function Dotacion(_ref5) {
	    var visible = _ref5.visible,
	        className = _ref5.className,
	        value = _ref5.value;
	    return _react2.default.createElement(
	        'div',
	        { className: visible ? '' : 'hidden' },
	        _react2.default.createElement(
	            'p',
	            { className: className },
	            value
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowPublicado.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"ProgramacionPublicada__tableFixed___1JAyp","colIndex":"ProgramacionPublicada__colIndex___2x4z6","tdIndex":"ProgramacionPublicada__tdIndex___33A6u","thIndex":"ProgramacionPublicada__thIndex___2-J37","colFecha":"ProgramacionPublicada__colFecha___2FPU-","tdFecha":"ProgramacionPublicada__tdFecha___1utVv","tdFechaEnMovimiento":"ProgramacionPublicada__tdFechaEnMovimiento___2O0Lv","tdHidden":"ProgramacionPublicada__tdHidden___3AQAs","thFecha":"ProgramacionPublicada__thFecha___3enlv","colCliente":"ProgramacionPublicada__colCliente___1t5wN","tdCliente":"ProgramacionPublicada__tdCliente___2A8Mu","thCliente":"ProgramacionPublicada__thCliente___2x4Uc","colCeco":"ProgramacionPublicada__colCeco___JfQvz","tdCeco":"ProgramacionPublicada__tdCeco___2n4jI","thCeco":"ProgramacionPublicada__thCeco___2eW6r","colRegion":"ProgramacionPublicada__colRegion___1znBT","tdRegion":"ProgramacionPublicada__tdRegion___1uUNm","thRegion":"ProgramacionPublicada__thRegion___3Arm2","colComuna":"ProgramacionPublicada__colComuna___3HnLA","tdComuna":"ProgramacionPublicada__tdComuna___2FiEd","thComuna":"ProgramacionPublicada__thComuna___2RN-0","colTienda":"ProgramacionPublicada__colTienda___cGSP5","tdTienda":"ProgramacionPublicada__tdTienda___1MPix","thTienda":"ProgramacionPublicada__thTienda___Vv7Vy","colDireccion":"ProgramacionPublicada__colDireccion___3b53u","thDireccion":"ProgramacionPublicada__thDireccion___286dG","tdDireccion":"ProgramacionPublicada__tdDireccion___29RzE","colStock":"ProgramacionPublicada__colStock___2CcrQ","tdStock":"ProgramacionPublicada__tdStock___N3FGp","thStock":"ProgramacionPublicada__thStock___H0klX","colDotacion":"ProgramacionPublicada__colDotacion___3w3-c","tdDotacion":"ProgramacionPublicada__tdDotacion___2_6kJ","thDotacion":"ProgramacionPublicada__thDotacion___52ENY","colTurno":"ProgramacionPublicada__colTurno___wMC1W","tdTurno":"ProgramacionPublicada__tdTurno___sEJCV","thTurno":"ProgramacionPublicada__thTurno___I-cVJ","colLider":"ProgramacionPublicada__colLider___1ghU8","tdLider":"ProgramacionPublicada__tdLider___3b8Ij","thLider":"ProgramacionPublicada__thLider___15TFQ","colHora":"ProgramacionPublicada__colHora___2S1V4","tdHora":"ProgramacionPublicada__tdHora___2Z-dT","thHora":"ProgramacionPublicada__thHora___a1_cJ","colNomina":"ProgramacionPublicada__colNomina___3P5so","tdNomina":"ProgramacionPublicada__tdNomina___2cClm","thNomina":"ProgramacionPublicada__thNomina___2zS-b","colEstadoNomina":"ProgramacionPublicada__colEstadoNomina___1GhgT","thEstadoNomina":"ProgramacionPublicada__thEstadoNomina___3o9no","tdEstadoNomina":"ProgramacionPublicada__tdEstadoNomina___11mZg","tooltip":"ProgramacionPublicada__tooltip___3V4Z3","tooltiptext":"ProgramacionPublicada__tooltiptext___1tPpt"};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorHospedajes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaHospedajes = __webpack_require__(968);
	
	var _Modales = __webpack_require__(971);
	
	var _MantenedorHospedajes = __webpack_require__(969);
	
	var css = _interopRequireWildcard(_MantenedorHospedajes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var MantenedorHospedajes = exports.MantenedorHospedajes = function (_React$Component) {
	    _inherits(MantenedorHospedajes, _React$Component);
	
	    function MantenedorHospedajes(props) {
	        _classCallCheck(this, MantenedorHospedajes);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorHospedajes.__proto__ || Object.getPrototypeOf(MantenedorHospedajes)).call(this, props));
	
	        _this.state = {
	            hospedajes: []
	        };
	        _this.getHospedajes = function () {
	            _v2.default.hospedajes().getHospedajes().then(function (hospedajes) {
	                _this.setState({ hospedajes: hospedajes });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorHospedajes, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                guardaHospedaje: function guardaHospedaje(datos) {
	                    var request = _v2.default.hospedajes().nuevoHospedaje(datos);
	                    request.then(function (hospedaje) {
	                        _this2.getHospedajes();
	                    }).catch(function (err) {});
	                    return request;
	                },
	                getComunas: function getComunas() {
	                    return _v2.default.otros.comunas();
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.getHospedajes();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Mantenedor Hospedajes'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-1 pull-right form-group' },
	                    _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'btn btn-md btn-primary', onClick: showModal },
	                                    'Nuevo'
	                                ),
	                                isVisible && _react2.default.createElement(_Modales.ModalHospedaje, {
	                                    hideModal: hideModal,
	                                    nuevo: 1
	                                })
	                            );
	                        }
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(_TablaHospedajes.TablaHospedajes, {
	                        hospedajes: this.state.hospedajes
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MantenedorHospedajes;
	}(_react2.default.Component);
	
	MantenedorHospedajes.childContextTypes = {
	    guardaHospedaje: PropTypes.func,
	    getComunas: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorHospedajes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaHospedajes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MantenedorHospedajes = __webpack_require__(969);
	
	var css = _interopRequireWildcard(_MantenedorHospedajes);
	
	var _RowHospedajes = __webpack_require__(970);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var TablaHospedajes = exports.TablaHospedajes = function (_React$Component) {
	    _inherits(TablaHospedajes, _React$Component);
	
	    function TablaHospedajes(props) {
	        _classCallCheck(this, TablaHospedajes);
	
	        var _this = _possibleConstructorReturn(this, (TablaHospedajes.__proto__ || Object.getPrototypeOf(TablaHospedajes)).call(this, props));
	
	        _this.rows = [];
	        return _this;
	    }
	
	    _createClass(TablaHospedajes, [{
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length;
	            var elemento = nombreElemento;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(elemento);
	            } else if (index >= ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
	                if (elemento === 'inputColacion') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputMedioViatico';else if (elemento === 'inputMedioViatico') elemento = 'inputIdComunaOrigen';else if (elemento === 'inputIdComunaOrigen') elemento = 'inputIdComunaSecundaria';else if (elemento === 'inputIdComunaSecundaria') elemento = 'inputColacion';
	                this.rows[0].focusElemento(elemento);
	            } else {
	                // no es ni el ultimo, ni el primero
	                this.rows[index].focusElemento(elemento);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadHospedajes = this.props.hospedajes.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                cantidadHospedajes > 0 ? _react2.default.createElement(
	                    TablaHospedaje,
	                    null,
	                    _.range(0, cantidadHospedajes).map(function (index) {
	                        var hospedaje = _this2.props.hospedajes[index];
	                        return _react2.default.createElement(_RowHospedajes.RowHospedajes, {
	                            key: index,
	                            index: index,
	                            ref: function ref(_ref) {
	                                return _this2.rows[index] = _ref;
	                            },
	                            focusRow: _this2.focusRow.bind(_this2),
	                            hospedaje: hospedaje
	                        });
	                    })
	                ) : _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cargando hospedajes...'
	                )
	            );
	        }
	    }]);
	
	    return TablaHospedajes;
	}(_react2.default.Component);
	
	var TablaHospedaje = function TablaHospedaje(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-default' },
	        _react2.default.createElement(
	            'table',
	            { className: "panel-body table table-bordered table-condensed table-striped " + css.tableFixed },
	            _react2.default.createElement(
	                'colgroup',
	                null,
	                _react2.default.createElement('col', { className: css.colIndex }),
	                _react2.default.createElement('col', { className: css.colNombre }),
	                _react2.default.createElement('col', { className: css.colCiudad }),
	                _react2.default.createElement('col', { className: css.colPrioridad }),
	                _react2.default.createElement('col', { className: css.colMailPrincipal }),
	                _react2.default.createElement('col', { className: css.colTelefonoFijo }),
	                _react2.default.createElement('col', { className: css.colCelular }),
	                _react2.default.createElement('col', { className: css.colCelularWsp }),
	                _react2.default.createElement('col', { className: css.colDireccion }),
	                _react2.default.createElement('col', { className: css.colSingleConBano }),
	                _react2.default.createElement('col', { className: css.colDobleConBano }),
	                _react2.default.createElement('col', { className: css.colAcciones })
	            ),
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thIndex },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombre },
	                        'Nombre'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCiudad },
	                        'Ciudad'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thPrioridad },
	                        'Prioridad'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thMailPrincipal },
	                        'Mail Principal'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thTelefonoFijo },
	                        'Telefono Fijo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCelular },
	                        'Celular'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCelularWsp },
	                        'Whatsapp'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDireccion },
	                        'Direcci\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thSingleConBano },
	                        'Single'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDobleConBano },
	                        'Doble'
	                    ),
	                    _react2.default.createElement('th', { className: css.thAcciones })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaHospedajes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"MantenedorHospedajes__tableFixed___34fgY","trSeparador":"MantenedorHospedajes__trSeparador___2j1kT","colIndex":"MantenedorHospedajes__colIndex___1Hk4C","thIndex":"MantenedorHospedajes__thIndex___1DOxT","tdIndex":"MantenedorHospedajes__tdIndex___3fkRl","colNombre":"MantenedorHospedajes__colNombre___2Z3df","thNombre":"MantenedorHospedajes__thNombre___182TH","tdNombre":"MantenedorHospedajes__tdNombre___2iu_j","colCiudad":"MantenedorHospedajes__colCiudad___37lmt","thCiudad":"MantenedorHospedajes__thCiudad___22xNE","tdCiudad":"MantenedorHospedajes__tdCiudad___nTPbI","colPrioridad":"MantenedorHospedajes__colPrioridad___23j-M","thPrioridad":"MantenedorHospedajes__thPrioridad___1VJx9","tdPrioridad":"MantenedorHospedajes__tdPrioridad___2bcJ6","colMailPrincipal":"MantenedorHospedajes__colMailPrincipal___12dNZ","thMailPrincipal":"MantenedorHospedajes__thMailPrincipal___35kmS","tdMailPrincipal":"MantenedorHospedajes__tdMailPrincipal___3f7fy","colMailSecundario":"MantenedorHospedajes__colMailSecundario___3os5m","thMailSecundario":"MantenedorHospedajes__thMailSecundario___1PLRH","tdMailSecundario":"MantenedorHospedajes__tdMailSecundario___2IiTm","colTelefonoFijo":"MantenedorHospedajes__colTelefonoFijo___19tQ2","thTelefonoFijo":"MantenedorHospedajes__thTelefonoFijo___-lyg_","tdTelefonoFijo":"MantenedorHospedajes__tdTelefonoFijo___2KExP","colCelular":"MantenedorHospedajes__colCelular___3DhJA","thCelular":"MantenedorHospedajes__thCelular___38-aN","tdCelular":"MantenedorHospedajes__tdCelular___-LaFW","colCelularWsp":"MantenedorHospedajes__colCelularWsp___1hCcE","thCelularWsp":"MantenedorHospedajes__thCelularWsp___2sj_J","tdCelularWsp":"MantenedorHospedajes__tdCelularWsp___PAA6w","colDireccion":"MantenedorHospedajes__colDireccion___3F74i","thDireccion":"MantenedorHospedajes__thDireccion___2ErcI","tdDireccion":"MantenedorHospedajes__tdDireccion___3FhQ7","colGeoReferencia":"MantenedorHospedajes__colGeoReferencia___12SHQ","thGeoReferencia":"MantenedorHospedajes__thGeoReferencia___AXD-r","tdGeoReferencia":"MantenedorHospedajes__tdGeoReferencia___1BnIW","colSingleSinBano":"MantenedorHospedajes__colSingleSinBano___2GF-L","thSingleSinBano":"MantenedorHospedajes__thSingleSinBano___3Rxs4","tdSingleSinBano":"MantenedorHospedajes__tdSingleSinBano___uwwaF","colSingleConBano":"MantenedorHospedajes__colSingleConBano___15v_X","thSingleConBano":"MantenedorHospedajes__thSingleConBano___1WalW","tdSingleConBano":"MantenedorHospedajes__tdSingleConBano___1LBI8","colDobleSinBano":"MantenedorHospedajes__colDobleSinBano___YmOWb","thDobleSinBano":"MantenedorHospedajes__thDobleSinBano___3RuwR","tdDobleSinBano":"MantenedorHospedajes__tdDobleSinBano___EQrou","colDobleConBano":"MantenedorHospedajes__colDobleConBano___1AEOd","thDobleConBano":"MantenedorHospedajes__thDobleConBano___J_0TQ","tdDobleConBano":"MantenedorHospedajes__tdDobleConBano___3f1iO","colCuadrupleConBano":"MantenedorHospedajes__colCuadrupleConBano___2Uxlz","thCuadrupleConBano":"MantenedorHospedajes__thCuadrupleConBano___dAPmc","tdCuadrupleConBano":"MantenedorHospedajes__tdCuadrupleConBano___23ka1","colCuadrupleSinBano":"MantenedorHospedajes__colCuadrupleSinBano___3Y3Ii","thCuadrupleSinBano":"MantenedorHospedajes__thCuadrupleSinBano___XXEXh","tdCuadrupleSinBano":"MantenedorHospedajes__tdCuadrupleSinBano___LKF8l","colAcciones":"MantenedorHospedajes__colAcciones___2Sxzq","thAcciones":"MantenedorHospedajes__thAcciones___1zVky","tdAcciones":"MantenedorHospedajes__tdAcciones___10wQM"};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowHospedajes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MantenedorHospedajes = __webpack_require__(969);
	
	var css = _interopRequireWildcard(_MantenedorHospedajes);
	
	var _Modales = __webpack_require__(971);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowHospedajes = exports.RowHospedajes = function (_React$Component) {
	    _inherits(RowHospedajes, _React$Component);
	
	    function RowHospedajes(props) {
	        _classCallCheck(this, RowHospedajes);
	
	        return _possibleConstructorReturn(this, (RowHospedajes.__proto__ || Object.getPrototypeOf(RowHospedajes)).call(this, props));
	    }
	
	    _createClass(RowHospedajes, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNombre },
	                    this.props.hospedaje.nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCiudad },
	                    this.props.hospedaje.nombreComuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdPrioridad },
	                    this.props.hospedaje.prioridad
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdMailPrincipal },
	                    this.props.hospedaje.mail_principal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTelefonoFijo },
	                    this.props.hospedaje.telefono_fijo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCelular },
	                    this.props.hospedaje.celular
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCelularWsp },
	                    this.props.hospedaje.celular_wsp
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDireccion },
	                    this.props.hospedaje.direccion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSingleConBano },
	                    this.props.hospedaje.single_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDobleConBano },
	                    this.props.hospedaje.doble_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAcciones },
	                    _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('span', { className: 'btn btn-xs btn-success glyphicon glyphicon-pencil', onClick: showModal }),
	                                isVisible && _react2.default.createElement(_Modales.ModalHospedaje, {
	                                    hideModal: hideModal,
	                                    hospedaje: _this2.props.hospedaje,
	                                    nuevo: 0
	                                })
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowHospedajes;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowHospedajes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalHospedaje = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(972);
	
	var css = _interopRequireWildcard(_Modales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalHospedaje = exports.ModalHospedaje = function (_React$Component2) {
	    _inherits(ModalHospedaje, _React$Component2);
	
	    function ModalHospedaje(props) {
	        _classCallCheck(this, ModalHospedaje);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalHospedaje.__proto__ || Object.getPrototypeOf(ModalHospedaje)).call(this, props));
	
	        _this2.buscarComuna = _this2.buscarComuna.bind(_this2);
	        _this2.state = {
	            hospedaje: [],
	            comunas: [],
	            error: []
	        };
	        _this2.onInputChange = function (key, evt) {
	            var actualizado = {};
	            if (key === 'idComuna') {
	                actualizado[key] = _this2.buscarComuna(evt.target.value);
	                actualizado.nombreComuna = evt.target.value;
	            } else {
	                actualizado[key] = evt.target.value;
	            }
	            actualizado['editado'] = 1;
	            _this2.setState({ hospedaje: Object.assign({}, _this2.state.hospedaje, actualizado) });
	        };
	        _this2.guardarHospedaje = function () {
	            _this2.context.guardaHospedaje(_this2.state.hospedaje).then(function (hospedaje) {
	                _this2.setState({
	                    hospedaje: hospedaje,
	                    error: []
	                }, function () {
	                    return _this2.props.hideModal();
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this2.setState({
	                    error: err.data
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalHospedaje, [{
	        key: 'buscarComuna',
	        value: function buscarComuna(nombre) {
	            for (var i = 0; i < this.state.comunas.length; i++) {
	                if (this.state.comunas[i].nombre === nombre) {
	                    return this.state.comunas[i].cutComuna;
	                }
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            this.context.getComunas().then(function (comunas) {
	                _this3.setState({
	                    comunas: comunas,
	                    hospedaje: !_this3.props.nuevo ? _this3.props.hospedaje : []
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalHospedaje'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Hospedaje'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel panel-info' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'panel-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4' },
	                                            'Nombre'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Nombre',
	                                                value: this.state.hospedaje.nombre, onChange: this.onInputChange.bind(this, 'nombre')
	                                            }),
	                                            this.state.error.nombre && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.nombre
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Comuna'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'text', list: 'comunas', placeholder: 'Comuna',
	                                                className: 'form-control',
	                                                value: this.state.hospedaje.nombreComuna,
	                                                onChange: this.onInputChange.bind(this, 'idComuna') }),
	                                            _react2.default.createElement(
	                                                'datalist',
	                                                { id: 'comunas' },
	                                                this.state.comunas.map(function (comuna, index) {
	                                                    return _react2.default.createElement('option', { key: comuna.cutComuna, value: comuna.nombre });
	                                                })
	                                            ),
	                                            this.state.error.idComuna && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.idComuna
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Prioridad'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Prioridad',
	                                                value: this.state.hospedaje.prioridad, onChange: this.onInputChange.bind(this, 'prioridad')
	                                            }),
	                                            this.state.error.prioridad && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.prioridad
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Tel. Fijo'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Tel\xE9fono Fijo',
	                                                value: this.state.hospedaje.telefono_fijo, onChange: this.onInputChange.bind(this, 'telefono_fijo')
	                                            }),
	                                            this.state.error.telefono_fijo && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.telefono_fijo
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Celular'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Celular', defaultValue: '569',
	                                                value: this.state.hospedaje.celular, onChange: this.onInputChange.bind(this, 'celular')
	                                            }),
	                                            this.state.error.celular && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.celular
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Whatsapp'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Whatsapp', defaultValue: '569',
	                                                value: this.state.hospedaje.celular_wsp, onChange: this.onInputChange.bind(this, 'celular_wsp')
	                                            }),
	                                            this.state.error.celular_wsp && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.celular_wsp
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-6 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Email Principal'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Email Principal',
	                                                value: this.state.hospedaje.mail_principal, onChange: this.onInputChange.bind(this, 'mail_principal')
	                                            }),
	                                            this.state.error.mail_principal && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.mail_principal
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-6 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Email Secundario'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Email Secundario',
	                                                value: this.state.hospedaje.mail_secundario, onChange: this.onInputChange.bind(this, 'mail_secundario')
	                                            }),
	                                            this.state.error.mail_secundario && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.mail_secundario
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-7 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-2 control-label' },
	                                            'Direcci\xF3n'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-10' },
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Direcci\xF3n',
	                                                value: this.state.hospedaje.direccion, onChange: this.onInputChange.bind(this, 'direccion')
	                                            }),
	                                            this.state.error.direccion && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.direccion
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-5 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'GeoReferencia'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'GeoReferencia', disabled: true,
	                                                value: this.state.hospedaje.georeferencia, onChange: this.onInputChange.bind(this, 'georeferencia')
	                                            }),
	                                            this.state.error.georeferencia && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.georeferencia
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel panel-info' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'panel-heading' },
	                                    'Habitaciones'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'panel-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Single'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Single',
	                                                value: this.state.hospedaje.single_con_bano, onChange: this.onInputChange.bind(this, 'single_con_bano')
	                                            }),
	                                            this.state.error.single_con_bano && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.single_con_bano
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Doble'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Doble',
	                                                value: this.state.hospedaje.doble_con_bano, onChange: this.onInputChange.bind(this, 'doble_con_bano')
	                                            }),
	                                            this.state.error.doble_con_bano && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.doble_con_bano
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx('col-md-4 form-group', 'form__control-label') },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4 control-label' },
	                                            'Cu\xE1druple'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'Cu\xE1druple',
	                                                value: this.state.hospedaje.cuadruple_con_bano, onChange: this.onInputChange.bind(this, 'cuadruple_con_bano')
	                                            }),
	                                            this.state.error.cuadruple_con_bano && _react2.default.createElement(
	                                                'span',
	                                                { className: cx('form__error-message') },
	                                                this.state.error.cuadruple_con_bano
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2 pull-left' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-primary', onClick: this.guardarHospedaje },
	                            'Guardar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 pull-right' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalHospedaje;
	}(_react2.default.Component);
	
	ModalHospedaje.contextTypes = {
	    guardaHospedaje: PropTypes.func,
	    getComunas: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"Modales__modal___3_OZU","modalHospedaje":"Modales__modalHospedaje___2Tx9t","form__error-message":"Modales__form__error-message___3Zd6q","form__control-label":"Modales__form__control-label___2tP5L"};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _store = __webpack_require__(974);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(981);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentPartnersIndex(props) {
	    return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(_App2.default, { recruiters: props.recruiters,
	            clients: props.clients })
	    );
	}
	
	exports.default = PaymentPartnersIndex;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PaymentPartnersIndex.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(481);
	
	var _reducers = __webpack_require__(975);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(980);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxLogger2.default)));
	
	exports.default = store;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(481);
	
	var _payrollReducer = __webpack_require__(976);
	
	var _payrollReducer2 = _interopRequireDefault(_payrollReducer);
	
	var _partnerReducer = __webpack_require__(977);
	
	var _partnerReducer2 = _interopRequireDefault(_partnerReducer);
	
	var _dateReducer = __webpack_require__(978);
	
	var _dateReducer2 = _interopRequireDefault(_dateReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    payrollState: _payrollReducer2.default,
	    partnerState: _partnerReducer2.default,
	    dateState: _dateReducer2.default
	});
	
	exports.default = rootReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INITIAL_STATE = {
	    payrolls: []
	};
	
	var payrollReducer = function payrollReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_PAYROLLS':
	            return _extends({}, state, {
	                payrolls: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = payrollReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "payrollReducer.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INITIAL_STATE = {
	    partnersRaw: [],
	    recruiterId: 0,
	    sectionActive: "Control",
	    clientId: 0,
	    ceco: 0
	};
	
	var partnerReducer = function partnerReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_PARTNERS':
	            return _extends({}, state, {
	                partnersRaw: action.payload
	            });
	        case 'SET_RECRUITER':
	            return _extends({}, state, {
	                recruiterId: action.payload
	            });
	        case 'SET_SECTION':
	            return _extends({}, state, {
	                sectionActive: action.payload
	            });
	        case 'SET_CLIENT':
	            return _extends({}, state, {
	                clientId: action.payload
	            });
	        case 'SET_CECO':
	            return _extends({}, state, {
	                ceco: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = partnerReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "partnerReducer.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _consts = __webpack_require__(979);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_STATE = {
	    selectedStartDate: (0, _moment2.default)().startOf('month'),
	    selectedFinalDate: (0, _moment2.default)().date(14)
	};
	
	var dateReducer = function dateReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_SELECTED_START_DATE':
	            return _extends({}, state, {
	                selectedStartDate: action.payload
	            });
	        case 'SET_SELECTED_FINAL_DATE':
	            return _extends({}, state, {
	                selectedFinalDate: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = dateReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "dateReducer.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FORMAT_DATE = exports.FORMAT_DATE = 'YYYY-MM-DD';
	var FORMAT_PAYMENT_DATE = exports.FORMAT_PAYMENT_DATE = 'DD-MM-YYYY';
	var FORMAT_START_DATE = exports.FORMAT_START_DATE = 'YYYY-MM-01';
	var API_URI = exports.API_URI = '/api/treasury/';
	var STATUS_LABEL_DETAIL = exports.STATUS_LABEL_DETAIL = ['label-default', 'label-warning', 'label-success', 'label-warning', 'label-success'];
	var TEXT_LABEL_DETAIL = exports.TEXT_LABEL_DETAIL = ['', 'Pendiente', 'Pagado', 'Pendiente', 'Aprobado'];
	var TEXT_LABEL_SUMMARY = exports.TEXT_LABEL_SUMMARY = ['Pendiente', 'Generada', 'Pagado', 'Pendiente', 'Aprobado'];
	var TEXT_LABEL_FEETICKET = exports.TEXT_LABEL_FEETICKET = ['Pendiente', 'Diferencia', 'Generada'];
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(982);
	
	var _PaymentPartners = __webpack_require__(996);
	
	var _PaymentPartners2 = _interopRequireDefault(_PaymentPartners);
	
	var _Payrolls = __webpack_require__(1013);
	
	var _Payrolls2 = _interopRequireDefault(_Payrolls);
	
	var _Layout = __webpack_require__(1017);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(props) {
	    return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(
	            _Layout2.default,
	            null,
	            _react2.default.createElement(
	                _reactRouterDom.Switch,
	                null,
	                _react2.default.createElement(
	                    _reactRouterDom.Route,
	                    { exact: true, path: '/tesoreria/nominas-pago' },
	                    _react2.default.createElement(_PaymentPartners2.default, { recruiters: props.recruiters,
	                        clients: props.clients })
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Route,
	                    { exact: true, path: '/tesoreria/nominas-creadas' },
	                    _react2.default.createElement(_Payrolls2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = App;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "App.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(983);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(984),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(986);__webpack_require__(413),__webpack_require__(992);var invariant=_interopDefault(__webpack_require__(993));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(985);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2)),PropTypes=_interopDefault(__webpack_require__(413)),history=__webpack_require__(986);__webpack_require__(992);var invariant=_interopDefault(__webpack_require__(993)),pathToRegexp=_interopDefault(__webpack_require__(994));__webpack_require__(26);var hoistStatics=_interopDefault(__webpack_require__(949));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(987);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(988)),valueEqual=_interopDefault(__webpack_require__(990));__webpack_require__(992);var invariant=_interopDefault(__webpack_require__(993));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(989);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ }),
/* 989 */
/***/ (function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(991);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(995)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 995 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(932);
	
	var _actions = __webpack_require__(997);
	
	var _consts = __webpack_require__(979);
	
	var _paymentPartnersService = __webpack_require__(998);
	
	var _paymentPartnersService2 = _interopRequireDefault(_paymentPartnersService);
	
	var _SelectRecruiters = __webpack_require__(999);
	
	var _SelectRecruiters2 = _interopRequireDefault(_SelectRecruiters);
	
	var _SelectClients = __webpack_require__(1000);
	
	var _SelectClients2 = _interopRequireDefault(_SelectClients);
	
	var _SelectCeco = __webpack_require__(1001);
	
	var _SelectCeco2 = _interopRequireDefault(_SelectCeco);
	
	var _SelectRangeVirtualTable = __webpack_require__(703);
	
	var _SelectRangeVirtualTable2 = _interopRequireDefault(_SelectRangeVirtualTable);
	
	var _ButtonsGroup = __webpack_require__(1002);
	
	var _ButtonsGroup2 = _interopRequireDefault(_ButtonsGroup);
	
	var _Partners = __webpack_require__(1010);
	
	var _Partners2 = _interopRequireDefault(_Partners);
	
	var _ButtonsTotals = __webpack_require__(1012);
	
	var _ButtonsTotals2 = _interopRequireDefault(_ButtonsTotals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentPartners = function (_Component) {
	    _inherits(PaymentPartners, _Component);
	
	    function PaymentPartners(props) {
	        _classCallCheck(this, PaymentPartners);
	
	        var _this = _possibleConstructorReturn(this, (PaymentPartners.__proto__ || Object.getPrototypeOf(PaymentPartners)).call(this, props));
	
	        _this.state = {
	            paymentDate: (0, _moment2.default)().format(_consts.FORMAT_PAYMENT_DATE),
	            partners: [],
	            searchRun: '',
	            searchName: '',
	            searchCaptador: '',
	            searchApprovedStatus: '',
	            searchPayrollStatus: '',
	            filterPendingStatus: [{
	                valor: 0,
	                texto: 'No Pendientes',
	                seleccionado: true
	            }, {
	                valor: 1,
	                texto: 'Pendientes',
	                seleccionado: true
	            }],
	            total: 0,
	            totalPending: 0,
	            totalRecruited: 0,
	            countPendingApproval: 0,
	            countFeeTicketsPending: 0,
	            countFeeTicketsDiff: 0,
	            loading: false,
	            cecos: [],
	            showCECO: false
	        };
	
	        _this.getPartners = function () {
	            return _paymentPartnersService2.default.getPartners(_this.props.selectedStartDate.format('YYYY-MM-DD'), _this.props.selectedFinalDate.format('YYYY-MM-DD'), _this.props.recruiterId, _this.props.clientId, _this.props.ceco).then(function (res) {
	                var response = res.data;
	                _this.props.setPartners(response.partners);
	                _this.setState({
	                    total: response.totals.total,
	                    totalPending: response.totals.totalPending,
	                    totalRecruited: response.totals.totalRecruited,
	                    countPendingApproval: response.counts.countPendingApproval,
	                    countFeeTicketsPending: response.counts.countFeeTicketsPending,
	                    countFeeTicketsDiff: response.counts.countFeeTicketsDiff
	                }, function () {
	                    return _this.filterPartners();
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.filterPartners = function () {
	            var _this$state = _this.state,
	                searchRun = _this$state.searchRun,
	                searchName = _this$state.searchName,
	                searchCaptador = _this$state.searchCaptador,
	                searchApprovedStatus = _this$state.searchApprovedStatus,
	                searchPayrollStatus = _this$state.searchPayrollStatus,
	                filterPendingStatus = _this$state.filterPendingStatus;
	
	            var filterPendig = 0;
	            if (filterPendingStatus[0].seleccionado == true && filterPendingStatus[1].seleccionado == true) {
	                filterPendig = 0;
	            } else if (filterPendingStatus[0].seleccionado == false && filterPendingStatus[1].seleccionado == false) {
	                filterPendig = 3;
	            } else if (filterPendingStatus[0].seleccionado == false) {
	                filterPendig = 2;
	            } else {
	                filterPendig = 1;
	            }
	            _this.setState({
	                partners: _this.props.partnersRaw.filter(function (us) {
	                    return us.usuarioRUN.indexOf(searchRun) >= 0;
	                }).filter(function (us) {
	                    return us.nombreCompleto.toLowerCase().indexOf(searchName) >= 0;
	                }).filter(function (us) {
	                    return us.recruiterName.toLowerCase().indexOf(searchCaptador) >= 0;
	                }).filter(function (us) {
	                    return us.approvedStatus.toString().indexOf(searchApprovedStatus) >= 0;
	                }).filter(function (us) {
	                    return us.payrollStatus.toString().indexOf(searchPayrollStatus) >= 0;
	                }).filter(function (us) {
	                    return filterPendig == 0 ? us.pendientes >= 0 : filterPendig == 1 ? us.pendientes === 0 : filterPendig == 3 ? us.pendientes < 0 : us.pendientes > 0;
	                })
	            });
	        };
	
	        _this.onChangeFilter = function (field, originalSearch) {
	            var value = typeof originalSearch === 'number' ? originalSearch : (typeof originalSearch === 'undefined' ? 'undefined' : _typeof(originalSearch)) === "object" ? originalSearch : originalSearch.trim().toLowerCase();
	            _this.setState(_defineProperty({}, field, value), function () {
	                return _this.filterPartners();
	            });
	        };
	
	        _this.generatePayroll = function () {
	            var _this$props = _this.props,
	                selectedStartDate = _this$props.selectedStartDate,
	                selectedFinalDate = _this$props.selectedFinalDate,
	                recruiterId = _this$props.recruiterId,
	                clientId = _this$props.clientId;
	
	            var inPayroll = 0;
	            var isApproved = 1;
	            if (selectedStartDate == '' || selectedFinalDate == '' || recruiterId == '') return;
	
	            var request = _paymentPartnersService2.default.createPayroll(recruiterId, selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), inPayroll, isApproved);
	            request.then(function (res) {
	                console.log('nómina creada correctamente');
	            }).catch(function (error) {
	                return console.log(error);
	            });
	
	            return request;
	        };
	
	        _this.cleanFilters = function () {
	            _this.setState({
	                searchRun: '',
	                searchName: '',
	                searchCaptador: '',
	                filterPendingStatus: ''
	            }, function () {
	                return _this.filterPartners();
	            });
	        };
	
	        _this.onSelectRecruiterChange = function (recruiterId) {
	            _this.props.setRecruiterId(recruiterId);
	        };
	
	        _this.onSelectClientChange = function (clientId) {
	            _this.props.setClientId(clientId);
	            if (clientId != 0) {
	                var _this$props2 = _this.props,
	                    selectedStartDate = _this$props2.selectedStartDate,
	                    selectedFinalDate = _this$props2.selectedFinalDate;
	
	                var request = _paymentPartnersService2.default.getCeco(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), clientId);
	                request.then(function (res) {
	                    _this.setState({
	                        cecos: res.data,
	                        showCECO: true
	                    });
	                }).catch(function (error) {
	                    return console.log(error);
	                });
	            } else {
	                _this.setState({
	                    showCECO: false,
	                    cecos: []
	                });
	            }
	        };
	
	        _this.onSelectCecoChange = function (ceco) {
	            _this.props.setCeco(ceco);
	        };
	
	        _this.updateCecos = function (selectedStartDate, selectedFinalDate, clientId) {
	            var request = _paymentPartnersService2.default.getCeco(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), clientId);
	            request.then(function (res) {
	                _this.setState({
	                    cecos: res.data,
	                    showCECO: _this.props.clientId != 0 ? true : false
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.onSelectUpdateRecruiter = function (idPartner, recruiterId) {
	            return _paymentPartnersService2.default.updateRecruiterPartner(idPartner, recruiterId).then(alert('captador se ha modificado correctamente')).catch(function (error) {
	                return alert('ocurrio un error al modificar el captador ' + error);
	            });
	        };
	
	        _this.onSelectRangoChanged = function (selectedStartDate, selectedFinalDate) {
	            _this.props.setSelectedStartDate(selectedStartDate);
	            _this.props.setSelectedFinalDate(selectedFinalDate);
	            _this.updateCecos(selectedStartDate, selectedFinalDate, _this.props.clientId);
	        };
	        return _this;
	    }
	
	    _createClass(PaymentPartners, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _this2 = this;
	
	            if (prevProps.selectedStartDate !== this.props.selectedStartDate || prevProps.recruiterId !== this.props.recruiterId || prevProps.clientId !== this.props.clientId || prevProps.ceco !== this.props.ceco) {
	                this.setState({
	                    loading: true
	                });
	                this.getPartners().then(function () {
	                    _this2.setState({
	                        loading: false
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            this.setState({
	                loading: true
	            });
	            this.getPartners().then(function () {
	                _this3.setState({
	                    loading: false
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                partners = _state.partners,
	                searchRun = _state.searchRun,
	                searchName = _state.searchName,
	                searchCaptador = _state.searchCaptador,
	                searchApprovedStatus = _state.searchApprovedStatus,
	                searchPayrollStatus = _state.searchPayrollStatus,
	                filterPendingStatus = _state.filterPendingStatus,
	                total = _state.total,
	                totalPending = _state.totalPending,
	                totalRecruited = _state.totalRecruited,
	                countPendingApproval = _state.countPendingApproval,
	                countFeeTicketsPending = _state.countFeeTicketsPending,
	                countFeeTicketsDiff = _state.countFeeTicketsDiff;
	
	            var cantidad_op_pendientes = partners.filter(function (partner) {
	                return partner.pendientes > 0;
	            });
	
	            var isTodosPendientes = cantidad_op_pendientes.length == partners.length;
	            var isTodosAprobados = cantidad_op_pendientes.length == 0;
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_SelectRecruiters2.default, {
	                            classname: 'col-md-2',
	                            recruiters: this.props.recruiters,
	                            onSelectRecruiterChange: this.onSelectRecruiterChange,
	                            recruiterId: this.props.recruiterId,
	                            label: 'Captador',
	                            disabledAll: false
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-1' },
	                        _react2.default.createElement(_SelectClients2.default, {
	                            clients: this.props.clients,
	                            onSelectClientChange: this.onSelectClientChange,
	                            clientId: this.props.clientId,
	                            label: 'Cliente',
	                            disabledAll: false
	                        })
	                    ),
	                    this.state.showCECO && _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-1' },
	                        _react2.default.createElement(_SelectCeco2.default, {
	                            cecos: this.state.cecos,
	                            onSelectCecoChange: this.onSelectCecoChange,
	                            ceco: this.props.ceco,
	                            label: 'CECO',
	                            disabledAll: false
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectWeek' },
	                            'Rango de Fecha'
	                        ),
	                        _react2.default.createElement(_SelectRangeVirtualTable2.default, {
	                            startDateSelected: this.props.selectedStartDate,
	                            endDateSelected: this.props.selectedFinalDate,
	                            onRangeSelected: this.onSelectRangoChanged
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectWeek' },
	                            'Estado aprobados'
	                        ),
	                        _react2.default.createElement('div', { style: {
	                                border: '1px solid black',
	                                backgroundColor: isTodosPendientes ? 'red' : isTodosAprobados ? 'green' : 'orange',
	                                borderRadius: '100%',
	                                height: '20px',
	                                width: '20px'
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-md-offset-1' },
	                        _react2.default.createElement(_ButtonsGroup2.default, {
	                            cleanFilters: this.cleanFilters,
	                            pendingApproval: partners.filter(function (partner) {
	                                return partner.approvedStatus === 3;
	                            }).length > 0,
	                            pendingPayroll: partners.filter(function (partner) {
	                                return partner.payrollStatus === 1;
	                            }).length > 0,
	                            notInPayroll: partners.filter(function (partner) {
	                                return partner.notInPayroll > 0;
	                            }).length > 0,
	                            total: total,
	                            getPartners: this.getPartners,
	                            generatePayroll: this.generatePayroll
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-9' },
	                    _react2.default.createElement(_Partners2.default, {
	                        partners: partners,
	                        searchRun: searchRun,
	                        searchName: searchName,
	                        searchCaptador: searchCaptador,
	                        filterPendingStatus: filterPendingStatus,
	                        onChangeFilterRun: this.onChangeFilter.bind(this, 'searchRun'),
	                        onChangeFilterName: this.onChangeFilter.bind(this, 'searchName'),
	                        onChangeFilterCaptador: this.onChangeFilter.bind(this, 'searchCaptador'),
	                        onChangeFilterPending: this.onChangeFilter.bind(this, 'filterPendingStatus'),
	                        selectedStartDate: this.props.selectedStartDate,
	                        selectedFinalDate: this.props.selectedFinalDate,
	                        recruiters: this.props.recruiters,
	                        onSelectUpdateRecruiter: this.onSelectUpdateRecruiter,
	                        getPartners: this.getPartners,
	                        loading: this.state.loading,
	                        clientId: this.props.clientId,
	                        ceco: this.props.ceco,
	                        recruiterId: this.props.recruiterId
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-3', style: { paddingTop: "38px", paddingLeft: "40px" } },
	                    _react2.default.createElement(_ButtonsTotals2.default, {
	                        total: total,
	                        totalPending: totalPending,
	                        totalRecruited: totalRecruited,
	                        countPendingApproval: countPendingApproval,
	                        countFeeTicketsPending: countFeeTicketsPending,
	                        countFeeTicketsDiff: countFeeTicketsDiff,
	                        onChangeFilter: this.onChangeFilter,
	                        searchApprovedStatus: searchApprovedStatus,
	                        searchPayrollStatus: searchPayrollStatus
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PaymentPartners;
	}(_react.Component);
	
	PaymentPartners.propTypes = {
	    recruiters: _react.PropTypes.array.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        partnersRaw: state.partnerState.partnersRaw,
	        selectedStartDate: state.dateState.selectedStartDate,
	        selectedFinalDate: state.dateState.selectedFinalDate,
	        recruiterId: state.partnerState.recruiterId,
	        clientId: state.partnerState.clientId,
	        ceco: state.partnerState.ceco
	    };
	};
	
	var mapDispatchToProps = {
	    setPartners: _actions.setPartners,
	    setSelectedFinalDate: _actions.setSelectedFinalDate,
	    setSelectedStartDate: _actions.setSelectedStartDate,
	    setRecruiterId: _actions.setRecruiterId,
	    setClientId: _actions.setClientId,
	    setCeco: _actions.setCeco
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentPartners);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PaymentPartners.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var setPartners = exports.setPartners = function setPartners(payload) {
	    return {
	        type: 'SET_PARTNERS',
	        payload: payload
	    };
	};
	
	var setSection = exports.setSection = function setSection(payload) {
	    return {
	        type: 'SET_SECTION',
	        payload: payload
	    };
	};
	
	var setRecruiterId = exports.setRecruiterId = function setRecruiterId(payload) {
	    return {
	        type: 'SET_RECRUITER',
	        payload: payload
	    };
	};
	
	var setClientId = exports.setClientId = function setClientId(payload) {
	    return {
	        type: "SET_CLIENT",
	        payload: payload
	    };
	};
	
	var setCeco = exports.setCeco = function setCeco(payload) {
	    return {
	        type: "SET_CECO",
	        payload: payload
	    };
	};
	
	var setPayrolls = exports.setPayrolls = function setPayrolls(payload) {
	    return {
	        type: 'SET_PAYROLLS',
	        payload: payload
	    };
	};
	
	var setSelectedStartDate = exports.setSelectedStartDate = function setSelectedStartDate(payload) {
	    return {
	        type: 'SET_SELECTED_START_DATE',
	        payload: payload
	    };
	};
	
	var setSelectedFinalDate = exports.setSelectedFinalDate = function setSelectedFinalDate(payload) {
	    return {
	        type: 'SET_SELECTED_FINAL_DATE',
	        payload: payload
	    };
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _consts = __webpack_require__(979);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPartners = function getPartners(initDate, finishDate, recruiterId, clientId, ceco) {
	    return _axios2.default.get(_consts.API_URI + 'search-operators?initDate=' + initDate + '&finishDate=' + finishDate + '&recruiterId=' + recruiterId + '&clientId=' + clientId + '&ceco=' + ceco);
	};
	
	var getDetailsPayment = function getDetailsPayment(initDate, finishDate, partnerId, clientId, ceco) {
	    return _axios2.default.get(_consts.API_URI + 'details-payment?initDate=' + initDate + '&finishDate=' + finishDate + '&partnerId=' + partnerId + '&clientId=' + clientId + '&ceco=' + ceco);
	};
	
	var getCeco = function getCeco(initDate, finishDate, clientId) {
	    return _axios2.default.get(_consts.API_URI + 'cecos-available?initDate=' + initDate + '&finishDate=' + finishDate + '&clientId=' + clientId);
	};
	
	var updateApprovePayment = function updateApprovePayment(idPartner, idList, status) {
	    return _axios2.default.post(_consts.API_URI + 'status-payment', {
	        idPartner: idPartner,
	        idList: idList,
	        status: status
	    });
	};
	
	var updateRecruiterPartner = function updateRecruiterPartner(idPartner, idRecruiter) {
	    return _axios2.default.put('/api/personal/' + idPartner + '/recruiter-update', {
	        idRecruiter: idRecruiter
	    });
	};
	
	var createPayroll = function createPayroll(recruiterId, initDate, finishDate, inPayroll, isApproved) {
	    return _axios2.default.post(_consts.API_URI + 'create-payroll', {
	        recruiterId: recruiterId,
	        initDate: initDate,
	        finishDate: finishDate,
	        inPayroll: inPayroll,
	        isApproved: isApproved
	    });
	};
	
	var createVoucherPayroll = function createVoucherPayroll(data) {
	    return _axios2.default.post(_consts.API_URI + 'create-voucher', data);
	};
	
	var getPayrolls = function getPayrolls(recruiterId, selectedStartDate, selectedFinalDate) {
	    return _axios2.default.get(_consts.API_URI + 'search-payrolls?initDate=' + selectedStartDate + '&finishDate=' + selectedFinalDate + '&recruiterId=' + recruiterId);
	};
	
	var deletePayroll = function deletePayroll(payrollId) {
	    return _axios2.default.delete(_consts.API_URI + 'delete-payroll/' + payrollId);
	};
	
	var updateDtoAddReason = function updateDtoAddReason(partnerId, listId, value, reason) {
	    return _axios2.default.put(_consts.API_URI + 'update-payment', {
	        partnerId: partnerId,
	        listId: listId,
	        value: value,
	        reason: reason
	    });
	};
	
	var updateBasePriceServices = function updateBasePriceServices(partnerId) {
	    return _axios2.default.post(_consts.API_URI + 'base-price-services', {
	        partnerId: partnerId
	    });
	};
	
	exports.default = {
	    getPartners: getPartners,
	    getDetailsPayment: getDetailsPayment,
	    getCeco: getCeco,
	    updateApprovePayment: updateApprovePayment,
	    updateRecruiterPartner: updateRecruiterPartner,
	    createPayroll: createPayroll,
	    getPayrolls: getPayrolls,
	    deletePayroll: deletePayroll,
	    createVoucherPayroll: createVoucherPayroll,
	    updateDtoAddReason: updateDtoAddReason,
	    updateBasePriceServices: updateBasePriceServices
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "paymentPartnersService.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectRecruiters = function (_Component) {
	    _inherits(SelectRecruiters, _Component);
	
	    function SelectRecruiters(props) {
	        _classCallCheck(this, SelectRecruiters);
	
	        var _this = _possibleConstructorReturn(this, (SelectRecruiters.__proto__ || Object.getPrototypeOf(SelectRecruiters)).call(this, props));
	
	        _this.state = {
	            recruiterId: _this.props.recruiterId
	        };
	
	        _this.handleChange = function (event) {
	            var recruiterId = event.target.value;
	            _this.props.onSelectRecruiterChange(recruiterId);
	            _this.setState({ recruiterId: recruiterId });
	        };
	        return _this;
	    }
	
	    _createClass(SelectRecruiters, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                recruiters = _props.recruiters,
	                title = _props.title,
	                classname = _props.classname,
	                label = _props.label,
	                disabledAll = _props.disabledAll;
	
	            return _react2.default.createElement(
	                "div",
	                { className: classname },
	                _react2.default.createElement(
	                    "label",
	                    { className: "control-label", htmlFor: "selectRecruiter" },
	                    label
	                ),
	                _react2.default.createElement(
	                    "select",
	                    { className: "form-control", value: this.state.recruiterId, onChange: this.handleChange, title: title },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "0", disabled: disabledAll },
	                        "Todos"
	                    ),
	                    recruiters.map(function (recruiter) {
	                        var nameRecruiter = recruiter.nombre1 + " " + recruiter.apellidoPaterno;
	                        return _react2.default.createElement(
	                            "option",
	                            { key: recruiter.id, value: recruiter.id },
	                            nameRecruiter
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SelectRecruiters;
	}(_react.Component);
	
	exports.default = SelectRecruiters;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectRecruiters.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectClients = function (_Component) {
	    _inherits(SelectClients, _Component);
	
	    function SelectClients(props) {
	        _classCallCheck(this, SelectClients);
	
	        var _this = _possibleConstructorReturn(this, (SelectClients.__proto__ || Object.getPrototypeOf(SelectClients)).call(this, props));
	
	        _this.state = {
	            clientId: _this.props.clientId
	        };
	
	        _this.handleChange = function (event) {
	            var clientId = event.target.value;
	            _this.props.onSelectClientChange(clientId);
	            _this.setState({ clientId: clientId });
	        };
	        return _this;
	    }
	
	    _createClass(SelectClients, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                clients = _props.clients,
	                title = _props.title,
	                classname = _props.classname,
	                label = _props.label,
	                disabledAll = _props.disabledAll;
	
	            return _react2.default.createElement(
	                "div",
	                { className: classname },
	                _react2.default.createElement(
	                    "label",
	                    { className: "control-label", htmlFor: "selectClient" },
	                    label
	                ),
	                _react2.default.createElement(
	                    "select",
	                    { className: "form-control", value: this.state.clientId, onChange: this.handleChange, title: title },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "0", disabled: disabledAll },
	                        "Todos"
	                    ),
	                    clients.map(function (client) {
	                        var nameClient = "" + client.nombreCorto;
	                        return _react2.default.createElement(
	                            "option",
	                            { key: client.idCliente, value: client.idCliente },
	                            nameClient
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SelectClients;
	}(_react.Component);
	
	exports.default = SelectClients;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectClients.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paymentPartnersService = __webpack_require__(998);
	
	var _paymentPartnersService2 = _interopRequireDefault(_paymentPartnersService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectCeco = function (_Component) {
	    _inherits(SelectCeco, _Component);
	
	    function SelectCeco(props) {
	        _classCallCheck(this, SelectCeco);
	
	        var _this = _possibleConstructorReturn(this, (SelectCeco.__proto__ || Object.getPrototypeOf(SelectCeco)).call(this, props));
	
	        _this.state = {
	            ceco: _this.props.ceco
	        };
	
	        _this.handleChange = function (event) {
	            var ceco = event.target.value;
	            _this.props.onSelectCecoChange(ceco);
	            _this.setState({ ceco: ceco });
	        };
	        return _this;
	    }
	
	    _createClass(SelectCeco, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                classname = _props.classname,
	                label = _props.label,
	                disabledAll = _props.disabledAll,
	                cecos = _props.cecos;
	
	            return _react2.default.createElement(
	                'div',
	                { className: classname },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-label', htmlFor: 'selectCeco' },
	                    label
	                ),
	                _react2.default.createElement(
	                    'select',
	                    { className: 'form-control', style: { maxHeight: '30px' }, value: this.state.ceco, onChange: this.handleChange, title: title },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '0', disabled: disabledAll },
	                        'Todos'
	                    ),
	                    cecos.length > 0 ? cecos.map(function (local) {
	                        var ceco = '' + local.numero;
	                        return _react2.default.createElement(
	                            'option',
	                            { key: local.idLocal, value: ceco },
	                            ceco
	                        );
	                    }) : "Cargando..."
	                )
	            );
	        }
	    }]);
	
	    return SelectCeco;
	}(_react.Component);
	
	exports.default = SelectCeco;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectCeco.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _consts = __webpack_require__(979);
	
	var _Modals = __webpack_require__(1003);
	
	var _ButtonModal = __webpack_require__(1009);
	
	var _ButtonModal2 = _interopRequireDefault(_ButtonModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonsGroup = function ButtonsGroup(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'btn-group pull-right' },
	        _react2.default.createElement(
	            _ButtonModal2.default,
	            {
	                getPartners: props.getPartners,
	                btnClassName: 'btn btn-xs btn-warning',
	                glyphiconBtn: 'glyphicon glyphicon-floppy-saved',
	                btnText: 'Generar N\xF3mina',
	                isEnabled: props.recruiterId !== 0 && props.pendingPayroll && props.total !== 0 && props.notInPayroll
	            },
	            _react2.default.createElement(_Modals.ModalGeneratePayroll, {
	                pendingApproval: props.pendingApproval,
	                generatePayroll: props.generatePayroll
	            })
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-success', href: _consts.API_URI + 'excel-fee-ticket?initDate=' + props.selectedStartDate.format('YYYY-MM-DD') + '&finishDate=' + props.selectedFinalDate.format('YYYY-MM-DD') + '&recruiterId=' + props.recruiterId + '&inPayroll=1' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' }),
	            ' Resumen Boletas'
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'btn btn-xs btn-info', href: '/api/tesoreria/operadores?fechaInicio=' + props.selectedStartDate.format('YYYY-MM-DD') + '&fechaFin=' + props.selectedFinalDate.format('YYYY-MM-DD') },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' }),
	            ' Operadores'
	        )
	    );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        selectedStartDate: state.dateState.selectedStartDate,
	        selectedFinalDate: state.dateState.selectedFinalDate,
	        recruiterId: state.partnerState.recruiterId
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(ButtonsGroup);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ButtonsGroup.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalVoucher = exports.ModalGeneratePayroll = exports.ModalDetailsPayment = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paymentPartnersService = __webpack_require__(998);
	
	var _paymentPartnersService2 = _interopRequireDefault(_paymentPartnersService);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Modals = __webpack_require__(1004);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _consts = __webpack_require__(979);
	
	var _DetailsPayment = __webpack_require__(1005);
	
	var _DetailsPayment2 = _interopRequireDefault(_DetailsPayment);
	
	var _SelectRecruiters = __webpack_require__(999);
	
	var _SelectRecruiters2 = _interopRequireDefault(_SelectRecruiters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTrigger = exports.ModalTrigger = function (_Component) {
	    _inherits(ModalTrigger, _Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false }, function () {
	                return _this.props.getPartners();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react.Component);
	
	;
	
	var ModalDetailsPayment = exports.ModalDetailsPayment = function ModalDetailsPayment(props) {
	    var updateRecruiterPartner = function updateRecruiterPartner(idRecruiter) {
	        return props.onSelectUpdateRecruiter(props.partner.id, idRecruiter);
	    };
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: props.hideModal, dialogClassName: _Modals2.default.ModalDetailsPayment_modalDialog, className: _Modals2.default.Modal },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Inventarios de operador ',
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                props.partner.nombreCompleto
	                            ),
	                            ' Comuna: ',
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                props.partner.comuna
	                            ),
	                            ' R: ',
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                props.partner.region
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_SelectRecruiters2.default, {
	                        classname: 'col-md-2 col-md-offset-1',
	                        recruiters: props.recruiters,
	                        recruiterId: props.recruiterId,
	                        onSelectRecruiterChange: updateRecruiterPartner,
	                        title: 'Modifica el captador actual del operador',
	                        disabledAll: true
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_DetailsPayment2.default, {
	                idPartner: props.partner.id,
	                clientId: props.clientId,
	                ceco: props.ceco
	            })
	        )
	    );
	};
	
	var ModalGeneratePayroll = exports.ModalGeneratePayroll = function (_Component2) {
	    _inherits(ModalGeneratePayroll, _Component2);
	
	    function ModalGeneratePayroll(props) {
	        _classCallCheck(this, ModalGeneratePayroll);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalGeneratePayroll.__proto__ || Object.getPrototypeOf(ModalGeneratePayroll)).call(this, props));
	
	        _this2.state = {
	            isLoading: false,
	            showDownloadBtn: false,
	            payroll: {}
	        };
	
	        _this2.handleGeneratePayroll = function () {
	            _this2.setState({ isLoading: true });
	            _this2.props.generatePayroll().then(function (res) {
	                _this2.setState({ showDownloadBtn: true, payroll: res.data });
	            }).catch(function (error) {
	                _this2.setState({ isLoading: false });
	                console.log(error);
	            });
	        };
	
	        return _this2;
	    }
	
	    _createClass(ModalGeneratePayroll, [{
	        key: 'render',
	        value: function render() {
	            var pendingApproval = this.props.pendingApproval;
	            var _state = this.state,
	                isLoading = _state.isLoading,
	                showDownloadBtn = _state.showDownloadBtn,
	                payroll = _state.payroll;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: _Modals2.default.Modal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Generar N\xF3mina de pago'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    pendingApproval ? _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'text-warning' },
	                            'Atenci\xF3n, existen operadores con servicios pendientes de aprobar, favor revisar si lo amerita.'
	                        )
	                    ) : _react2.default.createElement(
	                        'h4',
	                        null,
	                        '\xBFEst\xE1 seguro de generar la n\xF3mina de pago?'
	                    ),
	                    showDownloadBtn ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Se ha generado la n\xF3mina de pago exitosamente.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-xs btn-success', href: _consts.API_URI + 'excel-bank-download?payrollId=' + payroll.id + '&bankId=37' },
	                            'Santander'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-xs btn-success', href: _consts.API_URI + 'excel-bank-download?payrollId=' + payroll.id + '&bankId=14' },
	                            'Scotiabank'
	                        )
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    pendingApproval ? _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-warning', onClick: this.handleGeneratePayroll, disabled: isLoading },
	                        'Continuar'
	                    ) : _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.handleGeneratePayroll, disabled: isLoading },
	                        'Generar N\xF3mina'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', onClick: this.props.hideModal, className: 'btn btn-secondary' },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalGeneratePayroll;
	}(_react.Component);
	
	var ModalVoucher = exports.ModalVoucher = function (_Component3) {
	    _inherits(ModalVoucher, _Component3);
	
	    function ModalVoucher(props) {
	        _classCallCheck(this, ModalVoucher);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalVoucher.__proto__ || Object.getPrototypeOf(ModalVoucher)).call(this, props));
	
	        _this3.state = {
	            isLoading: false,
	            showDownloadBtn: false,
	            voucherNumber: '',
	            voucherTotal: '',
	            voucherFile: null,
	            showPartners: false,
	            partnersWithProblems: []
	        };
	
	        _this3.handleChangeCheckBox = function (evt, partner) {
	            if (evt.target.checked) {
	                _this3.setState({ partnersWithProblems: [].concat(_toConsumableArray(_this3.state.partnersWithProblems), [partner]) });
	            } else {
	                var filter = _this3.state.partnersWithProblems.filter(function (p) {
	                    return p.id !== partner.id;
	                });
	                _this3.setState({ partnersWithProblems: filter });
	            }
	        };
	
	        _this3.handleOnSubmit = function (evt) {
	            evt.preventDefault();
	            var _this3$state = _this3.state,
	                voucherNumber = _this3$state.voucherNumber,
	                voucherTotal = _this3$state.voucherTotal,
	                voucherFile = _this3$state.voucherFile;
	
	            if (voucherNumber === '' && voucherTotal === '' && !voucherFile) return;
	
	            _this3.setState({ isLoading: true });
	
	            var totalWithProblems = _this3.state.partnersWithProblems.reduce(function (accumulator, item) {
	                return accumulator + item.amount;
	            }, 0);
	
	            var totalAllPartners = _this3.props.payroll.partners.reduce(function (accumulator, item) {
	                return accumulator + item.amount;
	            }, 0);
	
	            var total = totalAllPartners - totalWithProblems;
	
	            if (voucherTotal !== _this3.props.payroll.total && voucherTotal != total) {
	                _this3.setState({ showPartners: true });
	                _this3.setState({ isLoading: false });
	            } else {
	                _this3.setState({ showPartners: false });
	                var withProblems = JSON.stringify(_this3.state.partnersWithProblems);
	                var formData = new FormData();
	                formData.append('voucherFile', voucherFile);
	                formData.append('payrollId', _this3.props.payroll.payrollId);
	                formData.append('voucherNumber', voucherNumber);
	                formData.append('voucherTotal', voucherTotal);
	                formData.append('partnersWithProblems', withProblems);
	                _paymentPartnersService2.default.createVoucherPayroll(formData).then(_this3.props.hideModal).catch(function (error) {
	                    return console.log(error);
	                });
	            }
	        };
	
	        _this3.handleChange = function (evt) {
	            var _evt$target = evt.target,
	                value = _evt$target.value,
	                name = _evt$target.name;
	
	            _this3.setState(_defineProperty({}, name, value));
	        };
	
	        _this3.handleChangeFile = function (evt) {
	            if (evt.target.files[0]) {
	                var file = evt.target.files[0];
	                _this3.setState({ voucherFile: file });
	            }
	        };
	        return _this3;
	    }
	
	    _createClass(ModalVoucher, [{
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Subir comprobante dep\xF3sito'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    this.state.showPartners && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'El total del voucher presenta diferencias, por favor indique los operadores que presentaron problemas para dejar pendiente el pago.'
	                        ),
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table' },
	                            _react2.default.createElement(
	                                'thead',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { scope: 'col' },
	                                        '#'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { scope: 'col' },
	                                        'Nombre'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { scope: 'col' },
	                                        'RUT'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { scope: 'col' },
	                                        'Monto'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                this.props.payroll.partners.map(function (partner, idx) {
	                                    return _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            idx + 1
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            partner.name
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            partner.rutDV
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            partner.amount
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                onChange: function onChange(evt) {
	                                                    return _this4.handleChangeCheckBox(evt, partner);
	                                                }
	                                            })
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    this.props.vouchers.length > 0 ? this.props.vouchers.map(function (voucher, idx) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: _Modals2.default.ModalVoucher__divListVouchers, key: idx },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Voucher ',
	                                idx + 1
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Cargado por:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        voucher.uploadBy
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Fecha:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        voucher.dateTimeUpload
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-xs btn-success', disabled: true },
	                                        'Descargar'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'C\xF3digo:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        voucher.codeTransaction
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Total:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        voucher.total.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                                    )
	                                )
	                            )
	                        );
	                    }) : _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleOnSubmit },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Nuevo Voucher'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'C\xF3digo Transacci\xF3n'
	                            ),
	                            _react2.default.createElement('input', {
	                                type: 'number',
	                                onChange: this.handleChange,
	                                className: 'form-control',
	                                name: 'voucherNumber',
	                                value: this.state.voucherNumber,
	                                placeholder: 'Ingresa n\xFAmero de voucher',
	                                required: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Total Voucher'
	                            ),
	                            _react2.default.createElement('input', {
	                                type: 'number',
	                                onChange: this.handleChange,
	                                className: 'form-control',
	                                name: 'voucherTotal',
	                                value: this.state.voucherTotal,
	                                placeholder: 'Ingresa total voucher',
	                                required: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Adjuntar Voucher'
	                            ),
	                            _react2.default.createElement('input', {
	                                type: 'file',
	                                onChange: this.handleChangeFile,
	                                className: 'form-control-file',
	                                name: 'fileVoucher',
	                                required: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.isLoading },
	                            'Guardar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalVoucher;
	}(_react.Component);
	
	;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modals.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Modal":"Modals__Modal___3IXys","ModalDetailsPayment_modalDialog":"Modals__ModalDetailsPayment_modalDialog___ONDI9","ModalVoucher__divListVouchers":"Modals__ModalVoucher__divListVouchers___3CXVp"};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _paymentPartnersService = __webpack_require__(998);
	
	var _paymentPartnersService2 = _interopRequireDefault(_paymentPartnersService);
	
	var _DetailsPayment = __webpack_require__(1006);
	
	var _DetailsPayment2 = _interopRequireDefault(_DetailsPayment);
	
	var _RowDetailPayment = __webpack_require__(1007);
	
	var _RowDetailPayment2 = _interopRequireDefault(_RowDetailPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailsPayment = function (_Component) {
	    _inherits(DetailsPayment, _Component);
	
	    function DetailsPayment(props) {
	        _classCallCheck(this, DetailsPayment);
	
	        var _this = _possibleConstructorReturn(this, (DetailsPayment.__proto__ || Object.getPrototypeOf(DetailsPayment)).call(this, props));
	
	        _this.state = {
	            lists: [],
	            recruiter: '',
	            statusAllChecked: false,
	            showDetailsTotal: false
	        };
	
	        _this.fetchNominas = function () {
	            var _this$props = _this.props,
	                selectedStartDate = _this$props.selectedStartDate,
	                selectedFinalDate = _this$props.selectedFinalDate,
	                idPartner = _this$props.idPartner,
	                clientId = _this$props.clientId,
	                ceco = _this$props.ceco;
	
	            _paymentPartnersService2.default.getDetailsPayment(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), idPartner, clientId, ceco).then(function (res) {
	                var data = res.data;
	                _this.setState({ lists: data.lists, recruiter: data.recruiter });
	                _this.checkValueAllCheckbox();
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.checkValueAllCheckbox = function () {
	            var status = _this.state.lists.filter(function (list) {
	                return list.deterioroId == null;
	            }).every(function (list) {
	                return list.serviceStatusApproved === 4;
	            });
	            _this.setState({ statusAllChecked: status });
	        };
	
	        _this.approvePayment = function (idPartner, idList, status, callAllList) {
	            return _paymentPartnersService2.default.updateApprovePayment(idPartner, idList, status).then(function () {
	                return callAllList ? _this.fetchNominas() : null;
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.updateDtoAddReason = function (idPartner, idList, value, reason) {
	            _paymentPartnersService2.default.updateDtoAddReason(idPartner, idList, value, reason).then(function () {
	                return _this.fetchNominas();
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.showDetailsTotal = function () {
	            _this.setState(function (prevState) {
	                return { showDetailsTotal: !prevState.showDetailsTotal };
	            });
	        };
	
	        _this.handleChangeAll = function (evt) {
	            var lists = _this.state.lists;
	
	            var filterLists = lists.filter(function (list) {
	                return !list.payrollStatus;
	            });
	            var promises = filterLists.map(function (list) {
	                return _this.approvePayment(_this.props.idPartner, list.listId, evt.target.checked, false);
	            });
	
	            Promise.all(promises).then(function () {
	                return _this.fetchNominas();
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(DetailsPayment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fetchNominas();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var total = 0;
	            var ids = this.state.lists.filter(function (list) {
	                return list.serviceStatusApproved == 4;
	            }).map(function (list) {
	                return list.lisId;
	            });
	            return _react2.default.createElement(
	                'table',
	                { className: 'table ' + _DetailsPayment2.default.DetailsPayment },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'Fecha Inventario'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'CL'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'R'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'Comuna'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'Local'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'Base'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _DetailsPayment2.default.DetailsPayment__thDtoAdd, style: { display: this.state.showDetailsTotal ? '' : 'none' } },
	                            'Dto/Add'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _DetailsPayment2.default.DetailsPayment__thComment, style: { display: this.state.showDetailsTotal ? '' : 'none' } },
	                            'Motivo'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            'Lider'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col', onClick: this.showDetailsTotal },
	                            'Monto ',
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _DetailsPayment2.default.DetailsPayment__thStatus },
	                            'N\xF3mina'
	                        ),
	                        _react2.default.createElement('th', { className: _DetailsPayment2.default.DetailsPayment__thStatus }),
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'col' },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                onClick: this.handleChangeAll,
	                                checked: this.state.statusAllChecked,
	                                disabled: !this.state.lists.filter(function (list) {
	                                    return !list.payrollStatus;
	                                }).length > 0
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Operador'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.state.lists.map(function (list, idx) {
	                        if (list.deterioroId != null) {
	                            total -= list.deterioro.valor_imputable;
	                            return _react2.default.createElement(_RowDetailPayment.RowDetailDeterioro, { key: idx,
	                                idx: idx,
	                                list: list });
	                        }
	
	                        if (list.serviceStatusApproved == 4) {
	                            total += list.amount;
	                        }
	                        return _react2.default.createElement(_RowDetailPayment2.default, {
	                            key: idx,
	                            idx: idx,
	                            list: list,
	                            idPartner: _this2.props.idPartner,
	                            approvePayment: _this2.approvePayment,
	                            showDetailsTotal: _this2.state.showDetailsTotal,
	                            updateDtoAddReason: _this2.updateDtoAddReason
	                        });
	                    })
	                ),
	                _react2.default.createElement(
	                    'tfoot',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('td', { colSpan: 7 }),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            total.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetailsPayment;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        selectedStartDate: state.dateState.selectedStartDate,
	        selectedFinalDate: state.dateState.selectedFinalDate
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DetailsPayment);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetailsPayment.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DetailsPayment":"DetailsPayment__DetailsPayment___3kgWz","DetailsPayment__thDtoAdd":"DetailsPayment__DetailsPayment__thDtoAdd___rwFf5","DetailsPayment__tdDtoAdd":"DetailsPayment__DetailsPayment__tdDtoAdd___2vsGN","DetailsPayment__thComment":"DetailsPayment__DetailsPayment__thComment___E-_Fd","DetailsPayment__thStatus":"DetailsPayment__DetailsPayment__thStatus___3dqAQ","DetailsPayment__tdComment":"DetailsPayment__DetailsPayment__tdComment___3SA6R"};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowDetailDeterioro = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _consts = __webpack_require__(979);
	
	var _CheckBoxApproval = __webpack_require__(1008);
	
	var _CheckBoxApproval2 = _interopRequireDefault(_CheckBoxApproval);
	
	var _DetailsPayment = __webpack_require__(1006);
	
	var _DetailsPayment2 = _interopRequireDefault(_DetailsPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowDetailPayment = function (_Component) {
	    _inherits(RowDetailPayment, _Component);
	
	    function RowDetailPayment(props) {
	        _classCallCheck(this, RowDetailPayment);
	
	        var _this = _possibleConstructorReturn(this, (RowDetailPayment.__proto__ || Object.getPrototypeOf(RowDetailPayment)).call(this, props));
	
	        _this.state = {
	            idPartner: _this.props.idPartner,
	            list: _this.props.list,
	            dtoAdd: _this.props.list.dtoAdd,
	            reason: _this.props.list.reasonDtoAdd
	        };
	
	        _this.handleCheckboxChange = function (evt) {
	            var status = evt.target.checked;
	            var _this$state = _this.state,
	                idPartner = _this$state.idPartner,
	                list = _this$state.list;
	
	            _this.props.approvePayment(idPartner, list.listId, status, true);
	        };
	
	        _this.handleChange = function (evt) {
	            var _evt$target = evt.target,
	                value = _evt$target.value,
	                name = _evt$target.name;
	
	            _this.setState(_defineProperty({}, name, value));
	        };
	
	        _this.onSaveDtoAddReason = function () {
	            var _this$state2 = _this.state,
	                idPartner = _this$state2.idPartner,
	                list = _this$state2.list,
	                dtoAdd = _this$state2.dtoAdd,
	                reason = _this$state2.reason;
	
	            if (reason === '' || dtoAdd === 0) _this.dtoAddInput.focus();
	
	            _this.props.updateDtoAddReason(idPartner, list.listId, dtoAdd, reason);
	        };
	
	        _this.styleStoreIsClosed = function (data) {
	            if (typeof data !== 'undefined') {
	                if (data.estado_inventario == 3) {
	                    return {
	                        backgroundColor: '#F4CCCC'
	                    };
	                }
	                if (data.deterioroId != null) {
	                    return {
	                        backgroundColor: '#DCC6E0'
	                    };
	                }
	                if (data.storeIsClosed) {
	                    return {
	                        backgroundColor: '#D9E9F9'
	                    };
	                }
	            }
	        };
	        return _this;
	    }
	
	    _createClass(RowDetailPayment, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                idx = _props.idx,
	                list = _props.list;
	            var leader = list.leader,
	                base = list.base,
	                amount = list.amount,
	                inventoryFormatDate = list.inventoryFormatDate,
	                clientName = list.clientName,
	                storeName = list.storeName,
	                storeRegion = list.storeRegion,
	                storeComuna = list.storeComuna,
	                payrollStatus = list.payrollStatus,
	                serviceStatusApproved = list.serviceStatusApproved;
	
	
	            return _react2.default.createElement(
	                'tr',
	                { key: idx, style: this.styleStoreIsClosed(list) },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    inventoryFormatDate
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    clientName
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    storeRegion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    storeComuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    storeName
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    base.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _DetailsPayment2.default.DetailsPayment__tdDtoAdd, style: { display: this.props.showDetailsTotal ? '' : 'none' } },
	                    _react2.default.createElement('input', {
	                        type: 'number',
	                        name: 'dtoAdd',
	                        value: this.state.dtoAdd,
	                        ref: function ref(input) {
	                            _this2.dtoAddInput = input;
	                        },
	                        onChange: this.handleChange,
	                        onBlur: this.onSaveDtoAddReason,
	                        disabled: this.state.reason === '' || payrollStatus
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _DetailsPayment2.default.DetailsPayment__tdComment, style: { display: this.props.showDetailsTotal ? '' : 'none' } },
	                    _react2.default.createElement('input', {
	                        type: 'text',
	                        name: 'reason',
	                        value: this.state.reason,
	                        onChange: this.handleChange,
	                        onBlur: this.onSaveDtoAddReason,
	                        disabled: payrollStatus
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    leader.nombreCorto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    amount.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "center" } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label ' + _consts.STATUS_LABEL_DETAIL[payrollStatus ? payrollStatus : 0] },
	                        _consts.TEXT_LABEL_SUMMARY[payrollStatus ? payrollStatus : 0]
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "center" } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label ' + _consts.STATUS_LABEL_DETAIL[serviceStatusApproved] },
	                        _consts.TEXT_LABEL_SUMMARY[serviceStatusApproved]
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(_CheckBoxApproval2.default, {
	                        id: idx,
	                        handleCheckboxChange: this.handleCheckboxChange,
	                        isChecked: serviceStatusApproved === 4
	                        //isDisabled={payrollStatus}
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "center" } },
	                    this.state.list.servicio_aprobado_op == 1 ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok text-success' }) : _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove text-danger' })
	                )
	            );
	        }
	    }]);
	
	    return RowDetailPayment;
	}(_react.Component);
	
	exports.default = RowDetailPayment;
	
	var RowDetailDeterioro = exports.RowDetailDeterioro = function (_Component2) {
	    _inherits(RowDetailDeterioro, _Component2);
	
	    function RowDetailDeterioro(props) {
	        _classCallCheck(this, RowDetailDeterioro);
	
	        var _this3 = _possibleConstructorReturn(this, (RowDetailDeterioro.__proto__ || Object.getPrototypeOf(RowDetailDeterioro)).call(this, props));
	
	        _this3.state = {
	            idPartner: _this3.props.idPartner,
	            list: _this3.props.list
	        };
	
	        _this3.styleStoreIsClosed = function (data) {
	            if (typeof data !== 'undefined') {
	                if (data.estado_inventario == 3) {
	                    return {
	                        backgroundColor: '#F4CCCC'
	                    };
	                }
	                if (data.deterioroId != null) {
	                    return {
	                        backgroundColor: '#DCC6E0'
	                    };
	                }
	                if (data.storeIsClosed) {
	                    return {
	                        backgroundColor: '#D9E9F9'
	                    };
	                }
	            }
	        };
	        return _this3;
	    }
	
	    _createClass(RowDetailDeterioro, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                idx = _props2.idx,
	                list = _props2.list;
	            var leader = list.leader,
	                base = list.base,
	                amount = list.amount,
	                inventoryFormatDate = list.inventoryFormatDate,
	                clientName = list.clientName,
	                storeName = list.storeName,
	                storeRegion = list.storeRegion,
	                storeComuna = list.storeComuna,
	                payrollStatus = list.payrollStatus,
	                serviceStatusApproved = list.serviceStatusApproved,
	                deterioro = list.deterioro;
	            var sku = deterioro.sku,
	                valor_imputable = deterioro.valor_imputable,
	                cantidad_producto = deterioro.cantidad_producto,
	                valor_producto = deterioro.valor_producto,
	                comentario = deterioro.comentario;
	
	
	            return _react2.default.createElement(
	                'tr',
	                { key: idx, style: this.styleStoreIsClosed(list) },
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: 2 },
	                    'Deterioro'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    comentario
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: 1 },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'SKU: ' + sku
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Cant: ' + cantidad_producto
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        valor_producto.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        (valor_producto * cantidad_producto).toLocaleString("es-CL", { style: "currency", currency: "clp" }) + ' (x' + cantidad_producto + ') '
	                    )
	                ),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { style: { color: 'red' } },
	                    '-' + valor_imputable.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                ),
	                _react2.default.createElement('td', { style: { textAlign: "center" } }),
	                _react2.default.createElement('td', { style: { textAlign: "center" } }),
	                _react2.default.createElement('td', null),
	                _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: "center" } },
	                    this.state.list.servicio_aprobado_op == 1 ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok text-success' }) : _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove text-danger' })
	                )
	            );
	        }
	    }]);
	
	    return RowDetailDeterioro;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowDetailPayment.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckBoxApproval = function CheckBoxApproval(_ref) {
	    var id = _ref.id,
	        handleCheckboxChange = _ref.handleCheckboxChange,
	        isChecked = _ref.isChecked,
	        isDisabled = _ref.isDisabled;
	    return _react2.default.createElement("input", { key: id, onClick: handleCheckboxChange, type: "checkbox", checked: isChecked, disabled: isDisabled });
	};
	
	exports.default = CheckBoxApproval;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "CheckBoxApproval.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modals = __webpack_require__(1003);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonModal = function ButtonModal(props) {
	    return _react2.default.createElement(
	        _Modals.ModalTrigger,
	        { getPartners: props.getPartners },
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    onClick: showModal,
	                    className: props.btnClassName,
	                    disabled: !props.isEnabled
	                },
	                _react2.default.createElement('span', { className: props.glyphiconBtn }),
	                ' ' + props.btnText,
	                isVisible && _react2.default.createElement(
	                    'div',
	                    null,
	                    (0, _react.cloneElement)(props.children, { isVisible: isVisible, showModal: showModal, hideModal: hideModal })
	                )
	            );
	        }
	    );
	};
	exports.default = ButtonModal;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ButtonModal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _consts = __webpack_require__(979);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _Modals = __webpack_require__(1003);
	
	var _ButtonModal = __webpack_require__(1009);
	
	var _ButtonModal2 = _interopRequireDefault(_ButtonModal);
	
	var _Partners = __webpack_require__(1011);
	
	var _Partners2 = _interopRequireDefault(_Partners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Partners = function Partners(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '70%', paddingTop: '35px' } },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref) {
	                var height = _ref.height,
	                    width = _ref.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table,
	                    {
	                        noRowsRenderer: function noRowsRenderer() {
	                            return props.loading ? _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: "center", paddingTop: "20px", fontSize: "20px", color: 'black' } },
	                                'Cargando...'
	                            ) : _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: "center", paddingTop: "20px", fontSize: "20px", color: 'black' } },
	                                'Sin registros'
	                            );
	                        },
	                        height: height,
	                        width: width,
	                        headerHeight: 30,
	                        headerClassName: _Partners2.default.Partners_headerColumn,
	                        rowCount: props.loading ? 0 : props.partners.length,
	                        rowGetter: function rowGetter(_ref2) {
	                            var index = _ref2.index;
	                            return props.partners[index];
	                        },
	                        rowHeight: 40,
	                        rowClassName: function rowClassName(_ref3) {
	                            var index = _ref3.index;
	                            return index < 0 ? _Partners2.default.Partners_headerRow : index % 2 === 0 ? _Partners2.default.Partners_evenRow : _Partners2.default.Partners_oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: '#',
	                        label: '#',
	                        disableSort: true,
	                        cellRenderer: function cellRenderer(_ref4) {
	                            var rowIndex = _ref4.rowIndex;
	                            return rowIndex + 1;
	                        },
	                        width: 30
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'usuarioRUN', label: 'RUT',
	                        cellRenderer: function cellRenderer(_ref5) {
	                            var cellData = _ref5.cellData,
	                                columnData = _ref5.columnData,
	                                dataKey = _ref5.dataKey,
	                                rowData = _ref5.rowData,
	                                rowIndex = _ref5.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        headerRenderer: function headerRenderer() {
	                            return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                nombre: 'RUN',
	                                busqueda: props.searchRun,
	                                realizarBusqueda: props.onChangeFilterRun
	                            });
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'nombreCompleto', label: 'Nombre',
	                        cellRenderer: function cellRenderer(_ref6) {
	                            var cellData = _ref6.cellData,
	                                columnData = _ref6.columnData,
	                                dataKey = _ref6.dataKey,
	                                rowData = _ref6.rowData,
	                                rowIndex = _ref6.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        headerRenderer: function headerRenderer() {
	                            return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                nombre: 'NOMBRE',
	                                busqueda: props.searchName,
	                                realizarBusqueda: props.onChangeFilterName
	                            });
	                        },
	                        width: 160
	                    }),
	                    props.recruiterId == 0 && _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'recruiterName', label: 'Captador',
	                        cellRenderer: function cellRenderer(_ref7) {
	                            var cellData = _ref7.cellData,
	                                columnData = _ref7.columnData,
	                                dataKey = _ref7.dataKey,
	                                rowData = _ref7.rowData,
	                                rowIndex = _ref7.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        headerRenderer: function headerRenderer() {
	                            return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                nombre: 'CAPTADOR',
	                                busqueda: props.searchCaptador,
	                                realizarBusqueda: props.onChangeFilterCaptador
	                            });
	                        },
	                        width: 160
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'cuenta', label: 'Cuenta',
	                        cellRenderer: function cellRenderer(_ref8) {
	                            var cellData = _ref8.cellData,
	                                columnData = _ref8.columnData,
	                                dataKey = _ref8.dataKey,
	                                rowData = _ref8.rowData,
	                                rowIndex = _ref8.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'totalInventarios', label: 'IG',
	                        cellRenderer: function cellRenderer(_ref9) {
	                            var cellData = _ref9.cellData,
	                                columnData = _ref9.columnData,
	                                dataKey = _ref9.dataKey,
	                                rowData = _ref9.rowData,
	                                rowIndex = _ref9.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 20
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'totalFormat', label: 'A GIRAR',
	                        cellRenderer: function cellRenderer(_ref10) {
	                            var cellData = _ref10.cellData,
	                                columnData = _ref10.columnData,
	                                dataKey = _ref10.dataKey,
	                                rowData = _ref10.rowData,
	                                rowIndex = _ref10.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 70
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'payrollStatus', label: 'NOMINA',
	                        cellRenderer: function cellRenderer(_ref11) {
	                            var cellData = _ref11.cellData,
	                                columnData = _ref11.columnData,
	                                dataKey = _ref11.dataKey,
	                                rowData = _ref11.rowData,
	                                rowIndex = _ref11.rowIndex;
	                            return _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: "12px" },
	                                    className: 'label ' + _consts.STATUS_LABEL_DETAIL[rowData[dataKey]] },
	                                _consts.TEXT_LABEL_DETAIL[rowData[dataKey]]
	                            );
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'boleta_subida', label: 'BOLETA',
	                        cellRenderer: function cellRenderer(_ref12) {
	                            var cellData = _ref12.cellData,
	                                columnData = _ref12.columnData,
	                                dataKey = _ref12.dataKey,
	                                rowData = _ref12.rowData,
	                                rowIndex = _ref12.rowIndex;
	
	                            var index_color = rowData[dataKey] ? 2 : 0;
	                            var index_label = rowData[dataKey] ? 2 : 0;
	                            console.log(rowData);
	                            return _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: "12px" },
	                                    className: 'label ' + _consts.STATUS_LABEL_DETAIL[index_color] },
	                                _consts.TEXT_LABEL_FEETICKET[index_label]
	                            );
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'no_aprobados', label: 'PEND',
	                        cellRenderer: function cellRenderer(_ref13) {
	                            var cellData = _ref13.cellData,
	                                columnData = _ref13.columnData,
	                                dataKey = _ref13.dataKey,
	                                rowData = _ref13.rowData,
	                                rowIndex = _ref13.rowIndex;
	
	                            var aprobados = rowData['aprobados'];
	                            var pendientes = rowData['pendientes'];
	                            return _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: "center" } },
	                                pendientes
	                            );
	                        },
	                        headerRenderer: function headerRenderer() {
	                            return _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'PEND',
	                                filtro: props.filterPendingStatus,
	                                actualizarFiltro: props.onChangeFilterPending
	                            });
	                        },
	                        width: 60
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'approvedStatus', label: 'ALTA',
	                        cellRenderer: function cellRenderer(_ref14) {
	                            var cellData = _ref14.cellData,
	                                columnData = _ref14.columnData,
	                                dataKey = _ref14.dataKey,
	                                rowData = _ref14.rowData,
	                                rowIndex = _ref14.rowIndex;
	                            return _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: "12px" },
	                                    className: 'label ' + _consts.STATUS_LABEL_DETAIL[rowData[dataKey]] },
	                                _consts.TEXT_LABEL_DETAIL[rowData[dataKey]]
	                            );
	                        },
	                        width: 80
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'opciones',
	                        cellRenderer: function cellRenderer(_ref15) {
	                            var cellData = _ref15.cellData,
	                                columnData = _ref15.columnData,
	                                dataKey = _ref15.dataKey,
	                                rowData = _ref15.rowData,
	                                rowIndex = _ref15.rowIndex;
	                            return _react2.default.createElement(
	                                _ButtonModal2.default,
	                                {
	                                    getPartners: props.getPartners,
	                                    btnClassName: 'btn btn-xs btn-info',
	                                    glyphiconBtn: 'glyphicon glyphicon-search',
	                                    btnText: '',
	                                    isEnabled: true
	                                },
	                                _react2.default.createElement(_Modals.ModalDetailsPayment, {
	                                    partner: rowData,
	                                    recruiters: props.recruiters,
	                                    recruiterId: rowData.recruiterId,
	                                    onSelectUpdateRecruiter: props.onSelectUpdateRecruiter,
	                                    getPartners: props.getPartners,
	                                    clientId: props.clientId,
	                                    ceco: props.ceco
	                                })
	                            );
	                        },
	                        width: 30
	                    })
	                );
	            }
	        )
	    );
	};
	
	exports.default = Partners;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Partners.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Partners_headerRow":"Partners__Partners_headerRow___3deaf","Partners_evenRow":"Partners__Partners_evenRow___2WUeb","Partners_oddRow":"Partners__Partners_oddRow___2YGBz","Partners_headerColumn":"Partners__Partners_headerColumn___3JIbz"};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonsTotals = function ButtonsTotals(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "list-group" },
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: "list-group-item list-group-item-action" },
	            "Total Captaciones ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.totalRecruited
	            )
	        ),
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: "list-group-item list-group-item-action" },
	            "Total a Pagar ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.total.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	            )
	        ),
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: "list-group-item list-group-item-action" },
	            "Total sin Aprobar ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.totalPending.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	            )
	        ),
	        _react2.default.createElement(
	            "button",
	            {
	                type: "button",
	                className: "list-group-item list-group-item-action " + (props.searchApprovedStatus === '' ? '' : 'active'),
	                onClick: function onClick() {
	                    return props.onChangeFilter('searchApprovedStatus', props.searchApprovedStatus === '' ? 3 : '');
	                }
	            },
	            "Operadores Pendientes ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.countPendingApproval
	            )
	        ),
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: "list-group-item list-group-item-action" },
	            "Boletas No Emitidas ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.countFeeTicketsPending
	            )
	        ),
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: "list-group-item list-group-item-action" },
	            "Boletas Con Diferencias ",
	            _react2.default.createElement(
	                "span",
	                { className: "badge badge-light" },
	                props.countFeeTicketsDiff
	            )
	        )
	    );
	};
	
	exports.default = ButtonsTotals;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ButtonsTotals.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _actions = __webpack_require__(997);
	
	var _paymentPartnersService = __webpack_require__(998);
	
	var _paymentPartnersService2 = _interopRequireDefault(_paymentPartnersService);
	
	var _PayrollList = __webpack_require__(1014);
	
	var _PayrollList2 = _interopRequireDefault(_PayrollList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Payrolls = function (_Component) {
	    _inherits(Payrolls, _Component);
	
	    function Payrolls(props) {
	        _classCallCheck(this, Payrolls);
	
	        var _this = _possibleConstructorReturn(this, (Payrolls.__proto__ || Object.getPrototypeOf(Payrolls)).call(this, props));
	
	        _this.state = {};
	
	        _this.getPayrolls = function () {
	            var _this$props = _this.props,
	                recruiterId = _this$props.recruiterId,
	                selectedStartDate = _this$props.selectedStartDate,
	                selectedFinalDate = _this$props.selectedFinalDate;
	
	            return _paymentPartnersService2.default.getPayrolls(recruiterId, selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD')).then(function (res) {
	                var response = res.data;
	                _this.props.setPayrolls(response.payrolls);
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.deletePayroll = function (payrollId) {
	            return _paymentPartnersService2.default.deletePayroll(payrollId).then(function (res) {
	                _this.getPayrolls();
	            }).catch(function (error) {
	                return console.log("ocurrió un error");
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Payrolls, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getPayrolls();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_PayrollList2.default, {
	                payrolls: this.props.payrolls,
	                deletePayroll: this.deletePayroll,
	                getPayrolls: this.getPayrolls
	            });
	        }
	    }]);
	
	    return Payrolls;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        payrolls: state.payrollState.payrolls,
	        selectedStartDate: state.dateState.selectedStartDate,
	        selectedFinalDate: state.dateState.selectedFinalDate,
	        recruiterId: state.partnerState.recruiterId
	    };
	};
	
	var mapDispatchToProps = {
	    setPayrolls: _actions.setPayrolls
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Payrolls);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Payrolls.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _RowPayroll = __webpack_require__(1015);
	
	var _RowPayroll2 = _interopRequireDefault(_RowPayroll);
	
	var _PayrollList = __webpack_require__(1016);
	
	var _PayrollList2 = _interopRequireDefault(_PayrollList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PayrollList = function PayrollList(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { className: 'table ' + _PayrollList2.default.PayrollList },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thRecruiter },
	                        'Captador'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thDate },
	                        'Desde'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thDate },
	                        'Hasta'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thGenerationDate },
	                        'Hora Creaci\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thRecruiter },
	                        'Creado Por'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thTotalPartners },
	                        'Total Op.'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _PayrollList2.default.PayrollList__thTotal },
	                        'Total'
	                    ),
	                    _react2.default.createElement('th', { className: _PayrollList2.default.PayrollList__thStatus }),
	                    _react2.default.createElement('th', { className: _PayrollList2.default.PayrollList__thOption })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                props.payrolls.length > 0 ? props.payrolls.map(function (payroll) {
	                    return _react2.default.createElement(_RowPayroll2.default, { payroll: payroll, key: payroll.payrollId, deletePayroll: props.deletePayroll, getPayrolls: props.getPayrolls });
	                }) : _react2.default.createElement(
	                    'td',
	                    { colSpan: '9', style: { textAlign: "center" } },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'No se encontraron n\xF3minas de pago'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = PayrollList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PayrollList.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PayrollList = __webpack_require__(1016);
	
	var _PayrollList2 = _interopRequireDefault(_PayrollList);
	
	var _ButtonModal = __webpack_require__(1009);
	
	var _ButtonModal2 = _interopRequireDefault(_ButtonModal);
	
	var _Modals = __webpack_require__(1003);
	
	var _consts = __webpack_require__(979);
	
	var _consts2 = __webpack_require__(979);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RowPayroll = function RowPayroll(props) {
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            props.payroll.recruiter
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            props.payroll.startPeriod
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            props.payroll.endPeriod
	        ),
	        _react2.default.createElement(
	            "td",
	            { style: { textAlign: "center" } },
	            props.payroll.generationDate
	        ),
	        _react2.default.createElement(
	            "td",
	            { style: { textAlign: "center" } },
	            props.payroll.createdBy
	        ),
	        _react2.default.createElement(
	            "td",
	            { style: { textAlign: "right" } },
	            props.payroll.totalPartners
	        ),
	        _react2.default.createElement(
	            "td",
	            { style: { textAlign: "right" } },
	            props.payroll.total.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _PayrollList2.default.PayrollList__tdStatus },
	            _react2.default.createElement(
	                "span",
	                { className: "label " + _consts2.STATUS_LABEL_DETAIL[props.payroll.status] },
	                _consts2.TEXT_LABEL_SUMMARY[props.payroll.status]
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                "a",
	                { className: "btn btn-xs btn-success", href: _consts.API_URI + "excel-bank-download?payrollId=" + props.payroll.payrollId + "&bankId=37" },
	                "Santander"
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: "btn btn-xs btn-success", href: _consts.API_URI + "excel-bank-download?payrollId=" + props.payroll.payrollId + "&bankId=14" },
	                "Scotiabank"
	            ),
	            _react2.default.createElement(
	                _ButtonModal2.default,
	                {
	                    getPartners: props.getPayrolls,
	                    btnClassName: "btn btn-xs btn-info",
	                    btnText: "Voucher",
	                    isEnabled: true
	                },
	                _react2.default.createElement(_Modals.ModalVoucher, {
	                    payroll: props.payroll,
	                    vouchers: props.payroll.vouchers
	                })
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    className: "btn btn-xs btn-warning",
	                    onClick: function onClick() {
	                        return props.deletePayroll(props.payroll.payrollId);
	                    },
	                    disabled: props.payroll.status === 2 },
	                "Eliminar"
	            )
	        )
	    );
	};
	
	exports.default = RowPayroll;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowPayroll.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PayrollList":"PayrollList__PayrollList___3G9JZ","PayrollList__thRecruiter":"PayrollList__PayrollList__thRecruiter___laEL4","PayrollList__thDate":"PayrollList__PayrollList__thDate___2N1pI","PayrollList__thTotal":"PayrollList__PayrollList__thTotal___3z7DP","PayrollList__thGenerationDate":"PayrollList__PayrollList__thGenerationDate___6ApYD","PayrollList__thStatus":"PayrollList__PayrollList__thStatus___3egbX","PayrollList__thOption":"PayrollList__PayrollList__thOption___1tQhJ","PayrollList__thTotalPartners":"PayrollList__PayrollList__thTotalPartners___2WiZK","PayrollList__tdStatus":"PayrollList__PayrollList__tdStatus___1L0TX"};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(1018);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Header2.default, null),
	        children
	    );
	};
	
	exports.default = Layout;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Layout.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _reactRouterDom = __webpack_require__(982);
	
	var _actions = __webpack_require__(997);
	
	var _Header = __webpack_require__(1019);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: _Header2.default.Header },
	        _react2.default.createElement(
	            "ul",
	            { className: "nav nav-tabs" },
	            _react2.default.createElement(
	                "li",
	                { role: "presentation", className: props.sectionActive === "Control" ? "active" : "", onClick: function onClick() {
	                        return props.setSection("Control");
	                    } },
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/tesoreria/nominas-pago" },
	                    "An\xE1lisis"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                { role: "presentation", className: props.sectionActive === "Payroll" ? "active" : "", onClick: function onClick() {
	                        return props.setSection("Payroll");
	                    } },
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/tesoreria/nominas-creadas" },
	                    "N\xF3minas Generadas"
	                )
	            )
	        )
	    );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        sectionActive: state.partnerState.sectionActive
	    };
	};
	
	var mapDispatchToProps = {
	    setSection: _actions.setSection
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Header.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"Header__Header___x5p6e"};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AsignacionFondos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaInventarios = __webpack_require__(1021);
	
	var _Modales = __webpack_require__(1024);
	
	var _Totales = __webpack_require__(1026);
	
	var _TablaFondos = __webpack_require__(1027);
	
	var _Fondos = __webpack_require__(1023);
	
	var _Fondos2 = _interopRequireDefault(_Fondos);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Moment
	_moment2.default.locale('es');
	var PropTypes = _react2.default.PropTypes;
	//Notify
	
	//Services axios
	
	//Componentes
	
	//CSS
	
	var cx = _bind2.default.bind(_Fondos2.default);
	
	var AsignacionFondos = exports.AsignacionFondos = function (_React$Component) {
	    _inherits(AsignacionFondos, _React$Component);
	
	    function AsignacionFondos(props) {
	        _classCallCheck(this, AsignacionFondos);
	
	        var _this = _possibleConstructorReturn(this, (AsignacionFondos.__proto__ || Object.getPrototypeOf(AsignacionFondos)).call(this, props));
	
	        _this.guardarFondoGeneral = _this.guardarFondoGeneral.bind(_this);
	        _this.sumaTotales = _this.sumaTotales.bind(_this);
	        _this.getLideresSemana = _this.getLideresSemana.bind(_this);
	        _this.state = {
	            lideres: [],
	            idRendicion: 0,
	            estado_rendicion: 0,
	            idLiderSeleccionado: 0,
	            year: '',
	            numero_semana: 0,
	            semanaSeleccionada: '',
	            semana: [],
	            inventarios: [],
	            fondoSemana: [],
	            semanaServicios: [],
	            viaticosLiquidacion: 0,
	            fondosRendir: 0,
	            fondoPendiente: 0,
	            fondoGirar: 0,
	            comunaInicio: 0,
	            totalColacionNocturna: 0,
	            totalViatico: 0,
	            totalAlojamiento: 0,
	            totalAcercmientos: 0,
	            totalTraslados: 0,
	            totalPasajeOperador: 0,
	            totalOtros: 0,
	            cargando: false,
	            totales: {
	                viaticosLiquidacion: 0,
	                fondosRendir: 0,
	                fondoPendiente: 0,
	                fondoGirar: 0
	            },
	            error: []
	        };
	        return _this;
	    }
	
	    _createClass(AsignacionFondos, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                inputChange: function inputChange(index, servicio) {
	                    var semanaServicios = _this2.state.semanaServicios;
	                    semanaServicios[index] = servicio;
	                    _this2.setState({ semanaServicios: semanaServicios }, function () {
	                        return _this2.sumaTotales();
	                    });
	                },
	                subirComprobante: function subirComprobante(index, servicio) {
	                    console.log(servicio.comprobante, "idRendicion", _this2.state.idRendicion);
	                    var semanaServicios = _this2.state.semanaServicios;
	                    var data = new FormData();
	                    data.append(servicio.dia, servicio.comprobante);
	                    var request = _v2.default.fondos().guardarPasaje(_this2.state.idRendicion, servicio.dia, data);
	                    request.then(function (resp) {
	                        semanaServicios[index] = servicio;
	                        semanaServicios[index].idBoletoPasaje = resp.idBoletoPasaje;
	                        semanaServicios[index].nombre_comprobante = resp.nombre;
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    _this2.setState({ semanaServicios: semanaServicios }, function () {
	                        return _this2.sumaTotales();
	                    });
	                    return request;
	                },
	                saldoLiderChange: function saldoLiderChange(fondoPendiente) {
	                    _this2.setState({ fondoPendiente: fondoPendiente }, function () {
	                        return _this2.sumaTotales();
	                    });
	                },
	                publicarFondos: function publicarFondos(numero_comprobante, total) {
	                    var request = _v2.default.fondos().publicarFondos(_this2.state.idRendicion, numero_comprobante, total);
	                    request.then(function (resp) {
	                        _this2.refs.notificator.info("Fondos", "Fondos Publicados", 5 * 1000);
	                    }).catch(function () {});
	                    _v2.default.fondos().guardaFondoGeneral(_this2.state.idRendicion, _this2.state.idLiderSeleccionado, _this2.state.numero_semana, _this2.state.semanaServicios, _this2.state.totales).then(function (resp) {
	                        console.log(resp);
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    return request;
	                },
	                guardarFondo: function guardarFondo(servicio) {
	                    _v2.default.fondos().guardaFondo(_this2.state.idRendicion, _this2.state.idLiderSeleccionado, _this2.state.numero_semana, servicio, _this2.state.totales).then(function (resp) {
	                        console.log(resp);
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                },
	                comprobantesDeposito: function comprobantesDeposito() {
	                    return _v2.default.fondos().comprobantesDeposito(_this2.state.idRendicion);
	                },
	                buscarHospedajes: function buscarHospedajes(idComuna) {
	                    return _v2.default.hospedajes().getBuscarHospedajes(idComuna);
	                },
	                guardarDetalleHospedaje: function guardarDetalleHospedaje(index, detalleHospedaje, servicio) {
	                    var request = _v2.default.fondos().guardarDetalleHospedaje(_this2.state.idRendicion, servicio, detalleHospedaje);
	                    request.then(function (resp) {
	                        var semanaServicios = _this2.state.semanaServicios;
	                        semanaServicios[index].idDetalleHospedaje = resp.idDetalleHospedaje;
	                        semanaServicios[index].idHospedaje = resp.hospedaje;
	                        _this2.setState({ semanaServicios: semanaServicios }, function () {
	                            return _this2.state.semanaServicios;
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    return request;
	                },
	                guardaDatosPasaje: function guardaDatosPasaje(index, idBoletoPasaje, datosPasaje) {
	                    var request = _v2.default.fondos().guardaDatosPasaje(_this2.state.idRendicion, idBoletoPasaje, datosPasaje).then(function (resp) {
	                        var semanaServicios = _this2.state.semanaServicios;
	                        semanaServicios[index].boletoPasaje = resp;
	                        _this2.setState({ semanaServicios: semanaServicios }, function () {
	                            return console.log(_this2.state.semanaServicios);
	                        });
	                    }).catch(function (err) {});
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'onSelectLiderChanged',
	        value: function onSelectLiderChanged(evt) {
	            var _this3 = this;
	
	            this.setState({
	                idLiderSeleccionado: evt.target.value,
	                inventarios: [],
	                semanaServicios: [],
	                semana: [],
	                cargando: true
	            }, function () {
	                return _this3.onGenerarFondos();
	            });
	        }
	    }, {
	        key: 'onWeekChange',
	        value: function onWeekChange(evt) {
	            var _this4 = this;
	
	            var _evt$target$value$spl = evt.target.value.split('-W'),
	                _evt$target$value$spl2 = _slicedToArray(_evt$target$value$spl, 2),
	                year = _evt$target$value$spl2[0],
	                week = _evt$target$value$spl2[1];
	
	            this.setState({
	                semanaSeleccionada: evt.target.value,
	                year: year,
	                numero_semana: week,
	                inventarios: [],
	                semanaServicios: [],
	                semana: [],
	                idLiderSeleccionado: 0,
	                cargando: true
	            }, function () {
	                return _this4.getLideresSemana();
	            });
	        }
	    }, {
	        key: 'getLideresSemana',
	        value: function getLideresSemana() {
	            var _this5 = this;
	
	            if (this.state.numero_semana) {
	                var fechaInicio = (0, _moment2.default)(this.state.year + '-W' + this.state.numero_semana).startOf('isoWeek').format('YYYY-MM-DD');
	                var fechaFin = (0, _moment2.default)(this.state.year + '-W' + this.state.numero_semana).endOf('isoWeek').format('YYYY-MM-DD');
	
	                _v2.default.fondos().getLideresInventarios(fechaInicio, fechaFin).then(function (lideres) {
	                    _this5.setState({
	                        lideres: lideres,
	                        cargando: false
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        }
	    }, {
	        key: 'onGenerarFondos',
	        value: function onGenerarFondos() {
	            var _this6 = this;
	
	            if (!this.state.idLiderSeleccionado || !this.state.numero_semana) {
	                this.refs.notificator.error("Fondos", "Seleccione Lider y Semana", 5 * 1000);
	            }
	            var fechaInicio = (0, _moment2.default)(this.state.year + '-W' + this.state.numero_semana).startOf('isoWeek').format('YYYY-MM-DD');
	            var fechaFin = (0, _moment2.default)(this.state.year + '-W' + this.state.numero_semana).endOf('isoWeek').format('YYYY-MM-DD');
	
	            _v2.default.fondos().getInventariosLider(this.state.idLiderSeleccionado, fechaInicio, fechaFin).then(function (resp) {
	                if (resp.inventarios.length > 0) {
	                    _this6.setState({
	                        idRendicion: resp.idRendicion,
	                        estado_rendicion: resp.estado_rendicion,
	                        comunaInicio: resp.comunaInicio,
	                        fondoPendiente: resp.saldoLider,
	                        inventarios: resp.inventarios,
	                        semanaServicios: resp.semanaServicios,
	                        error: [],
	                        cargando: false
	                    }, function () {
	                        return _this6.sumaTotales();
	                    });
	                } else {
	                    _this6.refs.notificator.info("Fondos", "No hay inventarios en la semana seleccionada.", 5 * 1000);
	                }
	            }).catch(function (err) {
	                console.log(err);
	                _this6.setState({ error: err.data });
	            });
	        }
	    }, {
	        key: 'onCancel',
	        value: function onCancel() {
	            this.setState({
	                inventarios: [],
	                semanaServicios: [],
	                semana: [],
	                idLiderSeleccionado: 0
	            });
	        }
	    }, {
	        key: 'sumaTotales',
	        value: function sumaTotales() {
	            var viaticosLiquidacion = 0;
	            var fondosRendir = 0;
	            var totalColacionNocturna = 0;
	            var totalViatico = 0;
	            var totalAlojamiento = 0;
	            var totalAcercmientos = 0;
	            var totalTraslados = 0;
	            var totalPasajeOperador = 0;
	            var totalOtros = 0;
	            var semanaServicios = this.state.semanaServicios;
	
	            semanaServicios.forEach(function (servicio) {
	                if (servicio.colacion_nocturna && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.colacion_nocturna) + viaticosLiquidacion;
	                    totalColacionNocturna = parseInt(servicio.colacion_nocturna) + totalColacionNocturna;
	                }
	                if (servicio.viatico && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.viatico) + viaticosLiquidacion;
	                    totalViatico = parseInt(servicio.viatico) + totalViatico;
	                }
	                if (servicio.acercamientos && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.acercamientos) + fondosRendir;
	                    totalAcercmientos = parseInt(servicio.acercamientos) + totalAcercmientos;
	                }
	                if (servicio.alojamiento && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.alojamiento) + viaticosLiquidacion;
	                    totalAlojamiento = parseInt(servicio.alojamiento) + totalAlojamiento;
	                }
	                if (servicio.traslados && servicio.diaTrabajado && !servicio.pasajeSei) {
	                    fondosRendir = parseInt(servicio.traslados) + fondosRendir;
	                    totalTraslados = parseInt(servicio.traslados) + totalTraslados;
	                }
	                if (servicio.pasajeOperador && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.pasajeOperador) + fondosRendir;
	                    totalPasajeOperador = parseInt(servicio.pasajeOperador) + totalPasajeOperador;
	                }
	                if (servicio.otros && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.otros) + fondosRendir;
	                    totalOtros = parseInt(servicio.otros) + totalOtros;
	                }
	            });
	
	            var totales = {
	                viaticosLiquidacion: viaticosLiquidacion,
	                fondosRendir: fondosRendir,
	                fondoPendiente: this.state.fondoPendiente,
	                fondoGirar: fondosRendir + viaticosLiquidacion - (this.state.fondoPendiente ? this.state.fondoPendiente : 0)
	            };
	
	            this.setState({
	                totales: totales,
	                totalColacionNocturna: totalColacionNocturna,
	                totalViatico: totalViatico,
	                totalAlojamiento: totalAlojamiento,
	                totalAcercmientos: totalAcercmientos,
	                totalTraslados: totalTraslados,
	                totalPasajeOperador: totalPasajeOperador,
	                totalOtros: totalOtros
	            });
	        }
	    }, {
	        key: 'guardarFondoGeneral',
	        value: function guardarFondoGeneral() {
	            var _this7 = this;
	
	            this.refs.notificator.info("Fondos", "Guardando fondos...", 5 * 1000);
	            _v2.default.fondos().guardaFondoGeneral(this.state.idRendicion, this.state.idLiderSeleccionado, this.state.numero_semana, this.state.semanaServicios, this.state.totales).then(function (resp) {
	                console.log(resp);
	                _this7.refs.notificator.success("Fondos", "Fondos Guardados correctamente", 5 * 1000);
	            }).catch(function (err) {
	                console.log(err);
	                _this7.refs.notificator.error("Fondos", "Ocurrió un error al guardar los fondos", 5 * 1000);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'page-header row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'titleFinance') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-10", 'divTitle') },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-usd' }),
	                                        ' Asignaci\xF3n de fondos'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-1", 'divNavBar') },
	                                    _react2.default.createElement(
	                                        _Modales.ModalTrigger,
	                                        null,
	                                        function (isVisible, showModal, hideModal) {
	                                            return _react2.default.createElement(
	                                                'button',
	                                                { className: "btn btn-md btn-info", onClick: showModal },
	                                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' }),
	                                                ' Publicar',
	                                                isVisible && _react2.default.createElement(_Modales.PublicarFondos, {
	                                                    hideModal: hideModal,
	                                                    index: _this8.props.index,
	                                                    estado_rendicion: _this8.state.estado_rendicion,
	                                                    total: _this8.state.totales.fondoGirar
	                                                })
	                                            );
	                                        }
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-1", 'divNavBar') },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-md btn-success',
	                                            href: '/api/rendiciones/fondos/' + this.state.numero_semana + '/' + this.state.year + '/descargar-excel' },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' }),
	                                        ' Excel'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 form-group ' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'selectSemana' },
	                                    'Seleccionar Semana'
	                                ),
	                                _react2.default.createElement('input', { type: 'week', className: "form-control " + _Fondos2.default.inputGeneral,
	                                    value: this.state.semanaSeleccionada,
	                                    onChange: this.onWeekChange.bind(this) }),
	                                this.state.error.fechas && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.fechas
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-3 form-group ' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label' },
	                                    'Lideres'
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: "form-control " + _Fondos2.default.inputGeneral,
	                                        value: this.state.idLiderSeleccionado,
	                                        onChange: this.onSelectLiderChanged.bind(this) },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '0' },
	                                        'Seleccione Lider'
	                                    ),
	                                    this.state.lideres.map(function (lider, index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: index, value: lider.idLider },
	                                            lider.nombre
	                                        );
	                                    })
	                                ),
	                                this.state.error.idLider && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.idLider
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 form-group ' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'control-label' },
	                                    '\xA0'
	                                ),
	                                this.state.idLiderSeleccionado ? _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-md btn-primary',
	                                        onClick: this.guardarFondoGeneral,
	                                        disabled: this.state.cargando },
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-saved' }),
	                                    ' Guardar'
	                                ) : null
	                            )
	                        ),
	                        this.state.inventarios.length === 0 ? null : _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-12", 'divFinance') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-11' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: _Fondos2.default.textInformation },
	                                        'Listado de servicios a realizar en la semana seleccionada*'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-9' },
	                                    _react2.default.createElement(_TablaInventarios.TablaInventarios, {
	                                        inventarios: this.state.inventarios
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(_Totales.Totales, {
	                                        totales: this.state.totales
	                                    })
	                                )
	                            )
	                        ),
	                        this.state.inventarios.length === 0 ? null : _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-12", 'divFinance') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-11' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: _Fondos2.default.textInformation },
	                                        'Listado de fondos asignados a trabajador*'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(_TablaFondos.TablaFondos, {
	                                    semanaServicios: this.state.semanaServicios,
	                                    totalColacionNocturna: this.state.totalColacionNocturna,
	                                    totalViatico: this.state.totalViatico,
	                                    totalAlojamiento: this.state.totalAlojamiento,
	                                    totalAcercmientos: this.state.totalAcercmientos,
	                                    totalTraslados: this.state.totalTraslados,
	                                    totalPasajeOperador: this.state.totalPasajeOperador,
	                                    totalOtros: this.state.totalOtros,
	                                    puedeModificar: true
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AsignacionFondos;
	}(_react2.default.Component);
	
	AsignacionFondos.childContextTypes = {
	    inputChange: PropTypes.func,
	    saldoLiderChange: PropTypes.func,
	    publicarFondos: PropTypes.func,
	    subirComprobante: PropTypes.func,
	    guardarFondo: PropTypes.func,
	    comprobantesDeposito: PropTypes.func,
	    buscarHospedajes: PropTypes.func,
	    guardarDetalleHospedaje: PropTypes.func,
	    guardaDatosPasaje: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "AsignacionFondos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowInventarios = __webpack_require__(1022);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var TablaInventarios = exports.TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios(props) {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).call(this, props));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Inventarios'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaInventario,
	                        null,
	                        _.range(0, totalInventarios).map(function (index) {
	                            var inventario = _this2.props.inventarios[index];
	                            return _react2.default.createElement(_RowInventarios.RowInventarios, {
	                                key: index,
	                                index: index,
	                                inventario: inventario
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	var TablaInventario = function TablaInventario(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed + " " + css.panelDetalleInventarios },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colFecha }),
	            _react2.default.createElement('col', { className: css.colCliente }),
	            _react2.default.createElement('col', { className: css.colLocal }),
	            _react2.default.createElement('col', { className: css.colComuna }),
	            _react2.default.createElement('col', { className: css.colRegion }),
	            _react2.default.createElement('col', { className: css.colJornada }),
	            _react2.default.createElement('col', { className: css.colDotacion }),
	            _react2.default.createElement('col', { className: css.colHrLider })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thFecha },
	                    'Fecha'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thCliente },
	                    'CLI'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLocal },
	                    'Local'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thComuna },
	                    'Comuna'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thRegion },
	                    'Regi\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thJornada },
	                    'Jornada'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDotacion },
	                    'Dotaci\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thHrLider },
	                    'Hr Lider'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	_moment2.default.locale('es');
	
	var RowInventarios = exports.RowInventarios = function (_React$Component) {
	    _inherits(RowInventarios, _React$Component);
	
	    function RowInventarios(props) {
	        _classCallCheck(this, RowInventarios);
	
	        return _possibleConstructorReturn(this, (RowInventarios.__proto__ || Object.getPrototypeOf(RowInventarios)).call(this, props));
	    }
	
	    _createClass(RowInventarios, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex, title: this.props.inventario.idInventario },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    (0, _moment2.default)(this.props.inventario.fechaProgramada).format('DD-MM-YYYY')
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    this.props.inventario.nombreCliente
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.inventario.nombreLocal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    this.props.inventario.comuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    this.props.inventario.region
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdJornada },
	                    this.props.inventario.jornada
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDotacion },
	                    this.props.inventario.dotacion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHrLider },
	                    this.props.inventario.hrLider
	                )
	            );
	        }
	    }]);
	
	    return RowInventarios;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"titleFinance":"Fondos__titleFinance___jH-ps","divTitle":"Fondos__divTitle___OdlxF","divNavBar":"Fondos__divNavBar___wqW1Z","divFinance":"Fondos__divFinance___3ZXbQ","textInformation":"Fondos__textInformation___1O-L7","navRevision":"Fondos__navRevision___3TAv-","form__error-message":"Fondos__form__error-message___-KQbA","tableFixed":"Fondos__tableFixed___20L35","trSeparador":"Fondos__trSeparador___aACBK","colIndex":"Fondos__colIndex___2X5Qj","thIndex":"Fondos__thIndex___2zo8k","tdIndex":"Fondos__tdIndex___3Ffu2","colFecha":"Fondos__colFecha___27qDl","thFecha":"Fondos__thFecha___2u7nc","tdFecha":"Fondos__tdFecha___1ouo1","colCliente":"Fondos__colCliente___3tG7N","thCliente":"Fondos__thCliente___34Yxx","tdCliente":"Fondos__tdCliente___2WYO0","colLocal":"Fondos__colLocal___1v9ra","thLocal":"Fondos__thLocal___1-LxX","tdLocal":"Fondos__tdLocal___3lr8g","colComuna":"Fondos__colComuna___1xjVZ","thComuna":"Fondos__thComuna___2jeC5","tdComuna":"Fondos__tdComuna___2tDXn","colRegion":"Fondos__colRegion___25E-l","thRegion":"Fondos__thRegion___1BKkM","tdRegion":"Fondos__tdRegion___3o5Xk","colDireccion":"Fondos__colDireccion___2bh8D","thDireccion":"Fondos__thDireccion___2aBt4","tdDireccion":"Fondos__tdDireccion___DJe8S","colJornada":"Fondos__colJornada___1G0Yv","thJornada":"Fondos__thJornada___17t4u","tdJornada":"Fondos__tdJornada___2ru6Y","colDotacion":"Fondos__colDotacion___LhlT-","thDotacion":"Fondos__thDotacion___az6e0","tdDotacion":"Fondos__tdDotacion___2nwKm","colHrLider":"Fondos__colHrLider____WKzC","thHrLider":"Fondos__thHrLider___1cyqP","tdHrLider":"Fondos__tdHrLider___3cQJ-","colHrEquipo":"Fondos__colHrEquipo___U3s3T","thHrEquipo":"Fondos__thHrEquipo___15WuV","tdHrEquipo":"Fondos__tdHrEquipo___25yXG","colStock":"Fondos__colStock___1ObfL","thStock":"Fondos__thStock___1W42Y","tdStock":"Fondos__tdStock___2F3eC","colConcepto":"Fondos__colConcepto___1I1_M","thConcepto":"Fondos__thConcepto___3bxZg","tdConcepto":"Fondos__tdConcepto___1WFcX","colBuscar":"Fondos__colBuscar___XCgyF","thBuscar":"Fondos__thBuscar___2B6ci","tdBuscar":"Fondos__tdBuscar___1hc45","colValor":"Fondos__colValor___HjBbO","thValor":"Fondos__thValor___3FuzY","tdValor":"Fondos__tdValor___1xxv1","colDesde":"Fondos__colDesde___3ZB3N","thDesde":"Fondos__thDesde___12Eye","tdDesde":"Fondos__tdDesde___2WVL2","colHasta":"Fondos__colHasta___2ICF_","thHasta":"Fondos__thHasta___21fFK","tdHasta":"Fondos__tdHasta___3gYYg","colIndicacion":"Fondos__colIndicacion___1GMhz","thIndicacion":"Fondos__thIndicacion___8O2Je","tdIndicacion":"Fondos__tdIndicacion___25xR3","colRendible":"Fondos__colRendible___3pKrg","thRendible":"Fondos__thRendible___3d-7b","tdRendible":"Fondos__tdRendible___1pQ5Q","inputDetalle":"Fondos__inputDetalle___2iVLC","panelHeadingCustom":"Fondos__panelHeadingCustom___2JYrU","rowSelecionada":"Fondos__rowSelecionada___3WuLG","btnQuitar":"Fondos__btnQuitar___ThiWr","btnAgregar":"Fondos__btnAgregar___V9DMz","selectCustom":"Fondos__selectCustom___35IxZ","inputCustom":"Fondos__inputCustom___3Ruxv","panelHeadingDetalle":"Fondos__panelHeadingDetalle___mE2at","panelDetalleInventarios":"Fondos__panelDetalleInventarios___1hI1O","panelInventarios":"Fondos__panelInventarios___15tjY","panelDetalles":"Fondos__panelDetalles___100aq","panelDetalleFondos":"Fondos__panelDetalleFondos___2VYo6","panelTotales":"Fondos__panelTotales___1AcaK","panelBodyScroll":"Fondos__panelBodyScroll___1vM0h","panelBodyTotales":"Fondos__panelBodyTotales___188Tn","colDiaTrabajado":"Fondos__colDiaTrabajado___1J2jh","thDiaTrabajado":"Fondos__thDiaTrabajado___3Md-Q","tdDiaTrabajado":"Fondos__tdDiaTrabajado___pxATi","colDia":"Fondos__colDia___3U1w2","thDia":"Fondos__thDia___3dhIc","tdDia":"Fondos__tdDia___1z9yo","colServicios":"Fondos__colServicios___sNHK9","thServicios":"Fondos__thServicios___2SES5","tdServicios":"Fondos__tdServicios___3ZGb0","colSnack":"Fondos__colSnack___DuKi5","thSnack":"Fondos__thSnack___1SFi7","tdSnack":"Fondos__tdSnack___1TULJ","colColNoche":"Fondos__colColNoche___3N7qe","thColNoche":"Fondos__thColNoche___16KKN","tdColNoche":"Fondos__tdColNoche___3QxgB","colViatico":"Fondos__colViatico___34hQW","thViatico":"Fondos__thViatico___3tWx2","tdViatico":"Fondos__tdViatico___2_ymC","colAlojamiento":"Fondos__colAlojamiento___1dxhD","thAlojamiento":"Fondos__thAlojamiento___W24sE","tdAlojamiento":"Fondos__tdAlojamiento___2FFH9","colAcercamiento":"Fondos__colAcercamiento___v-yvk","thAcercamiento":"Fondos__thAcercamiento___I3Mjt","tdAcercamiento":"Fondos__tdAcercamiento___3aGEf","colTraslado":"Fondos__colTraslado___tPiHS","thTraslado":"Fondos__thTraslado___3Le-S","tdTraslado":"Fondos__tdTraslado___214hh","colPasajeOperador":"Fondos__colPasajeOperador___1jLOK","thPasajeOperador":"Fondos__thPasajeOperador___3eXdO","tdPasajeOperador":"Fondos__tdPasajeOperador___lSyLU","colOtros":"Fondos__colOtros___2GVnR","thOtros":"Fondos__thOtros___3cS9o","tdOtros":"Fondos__tdOtros___1Q7IC","colPasajeSei":"Fondos__colPasajeSei___uhbfm","thPasajeSei":"Fondos__thPasajeSei___1PDJ9","tdPasajeSei":"Fondos__tdPasajeSei___1yofm","inputFondos":"Fondos__inputFondos___Tw8ao","inputGeneral":"Fondos__inputGeneral___2ngBr","panelBodyCustom":"Fondos__panelBodyCustom___1pGs5","totales":"Fondos__totales___2x0_G","inputFileReact":"Fondos__inputFileReact___25IlL","btnExcel":"Fondos__btnExcel___3IDVn","btnAlojamiento":"Fondos__btnAlojamiento___1PmPp","colFoto":"Fondos__colFoto___1RU88","thFoto":"Fondos__thFoto___lCj45"};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalPasaje = exports.ModalAlojamiento = exports.PublicarFondos = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1025);
	
	var cssModal = _interopRequireWildcard(_Modales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(cssModal);
	
	var PropTypes = _react2.default.PropTypes;
	var estados = ['-', ' Publicar', ' Publicado', ' Modificado', ' Modificado y Publicado'];
	var tipoHabitacion = ['-', ' Single', ' Doble', ' Cuádruple'];
	var habitacion = ['-', 'single_con_bano', 'doble_con_bano', 'cuadruple_con_bano'];
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var PublicarFondos = exports.PublicarFondos = function (_React$Component2) {
	    _inherits(PublicarFondos, _React$Component2);
	
	    function PublicarFondos(props) {
	        _classCallCheck(this, PublicarFondos);
	
	        var _this2 = _possibleConstructorReturn(this, (PublicarFondos.__proto__ || Object.getPrototypeOf(PublicarFondos)).call(this, props));
	
	        _this2.focusNComprobante = _this2.focusNComprobante.bind(_this2);
	        _this2.state = {
	            nComprobante: '',
	            total: '',
	            totalGeneral: 0,
	            comprobantes: []
	        };
	        _this2.onInputChange = function (key, evt) {
	            _this2.setState(_defineProperty({}, key, evt.target.value));
	        };
	        _this2.publicarFondos = function () {
	            _this2.refs.notificator.info("Fondos", "Publicando fondos...", 5 * 1000);
	            _this2.context.publicarFondos(_this2.state.nComprobante, _this2.state.total).then(function (resp) {
	                _this2.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	                _this2.refs.notificator.error("Fondos", "Ocurrió un error al publicar, reintente", 5 * 1000);
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(PublicarFondos, [{
	        key: 'focusNComprobante',
	        value: function focusNComprobante() {
	            this.inputNComprobante.focus();
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            this.context.comprobantesDeposito().then(function (resp) {
	                _this3.setState({
	                    comprobantes: resp.comprobantes,
	                    totalGeneral: resp.total,
	                    total: _this3.props.total - resp.total
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.focusNComprobante();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPublicar'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        '\xBFDesea p\xFAblicar los fondos?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            'Los fondos ser\xE1n informados al lider y quedar\xE1n disponibles para realizar la rendici\xF3n.'
	                        ),
	                        _react2.default.createElement('p', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            this.state.comprobantes ? _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Comprobantes Anteriores '
	                                ),
	                                this.state.comprobantes.map(function (comprobante) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12', key: comprobante.idComprobanteDeposito },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-6' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'N\xB0 Comprobante: '
	                                            ),
	                                            comprobante.numero_comprobante
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-6' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Total: '
	                                            ),
	                                            ' ',
	                                            comprobante.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                        )
	                                    );
	                                }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6 pull-right' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Total girado semana: '
	                                    ),
	                                    this.state.totalGeneral.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                )
	                            ) : null
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Comprobante Nuevo '
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'N\xFAmero Comprobante '
	                                ),
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    ref: function ref(nComprobante) {
	                                        _this4.inputNComprobante = nComprobante;
	                                    },
	                                    value: this.state.nComprobante,
	                                    onFocus: function onFocus() {
	                                        _this4.inputNComprobante.select();
	                                    },
	                                    onChange: this.onInputChange.bind(this, 'nComprobante')
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Total nuevo giro '
	                                ),
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                    ref: function ref(total) {
	                                        _this4.inputTotal = total;
	                                    },
	                                    value: this.state.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
	                                    onFocus: function onFocus() {
	                                        _this4.inputTotal.select();
	                                    },
	                                    onChange: this.onInputChange.bind(this, 'total')
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: this.props.estado_rendicion === 1 || this.props.estado_rendicion === 3 ? "btn btn-md btn-primary pull-left" : "btn btn-md btn-success pull-left",
	                                onClick: function onClick() {
	                                    return _this4.publicarFondos();
	                                } },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                            ' Publicar',
	                            estados[this.props.estado_rendicion]
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                            ' Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PublicarFondos;
	}(_react2.default.Component);
	
	PublicarFondos.contextTypes = {
	    publicarFondos: PropTypes.func,
	    comprobantesDeposito: PropTypes.func
	};
	
	var ModalAlojamiento = exports.ModalAlojamiento = function (_React$Component3) {
	    _inherits(ModalAlojamiento, _React$Component3);
	
	    function ModalAlojamiento(props) {
	        _classCallCheck(this, ModalAlojamiento);
	
	        var _this5 = _possibleConstructorReturn(this, (ModalAlojamiento.__proto__ || Object.getPrototypeOf(ModalAlojamiento)).call(this, props));
	
	        _this5.state = {
	            hospedajes: [],
	            nombreComuna: '',
	            hora_llegada: '',
	            idHospedajeSeleccionado: 0,
	            tipoHabitacion: 0
	        };
	        _this5.seleccionarHospedaje = function (idHospedaje) {
	            var detalleHospedaje = {
	                'idDetalleHospedaje': 0,
	                'idHospedaje': idHospedaje,
	                'hora_llegada': _this5.state.hora_llegada,
	                'estado': 1,
	                'confirmacion_lider': 1,
	                'tipo_habitacion': _this5.state.tipoHabitacion
	            };
	
	            _this5.context.guardarDetalleHospedaje(_this5.props.index, detalleHospedaje, _this5.props.servicio).then(function (resp) {
	                console.log(resp);
	                _this5.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this5.selecTipoHabitacion = function (tipoHabitacion) {
	            _this5.setState({ tipoHabitacion: tipoHabitacion });
	        };
	        return _this5;
	    }
	
	    _createClass(ModalAlojamiento, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this6 = this;
	
	            if (this.props.idHospedaje === 0 || this.props.idHospedaje === null) {
	                this.context.buscarHospedajes(this.props.comuna).then(function (resp) {
	                    _this6.setState({
	                        nombreComuna: resp.nombreComuna,
	                        hospedajes: resp.hospedajes
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else {
	                this.context.buscarHospedajes(this.props.comuna).then(function (resp) {
	                    _this6.setState({
	                        nombreComuna: resp.nombreComuna,
	                        hospedajes: resp.hospedajes,
	                        idHospedajeSeleccionado: _this6.props.idHospedaje.idHospedaje
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var cantidadHospedajes = this.state.hospedajes.length;
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: this.props.idHospedaje === 0 || this.props.idHospedaje === null ? cx('modalAlojamiento') : cx('modalShowAlojamiento'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        this.props.idHospedaje === 0 || this.props.idHospedaje === null ? "Hospedajes en " + this.state.nombreComuna : "Hospedaje Seleccionado"
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            cantidadHospedajes > 0 && (this.props.idHospedaje === 0 || this.props.idHospedaje === null) ? _react2.default.createElement(
	                                TablaHospedaje,
	                                null,
	                                _.range(0, cantidadHospedajes).map(function (index) {
	                                    var hospedaje = _this7.state.hospedajes[index];
	                                    return _react2.default.createElement(
	                                        'tr',
	                                        { key: index },
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdIndex },
	                                            index + 1
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdNombre },
	                                            hospedaje.nombre
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdPrioridad },
	                                            hospedaje.prioridad
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdMailPrincipal },
	                                            hospedaje.mail_principal
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdMailSecundario },
	                                            hospedaje.mail_secundario
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdTelefonoFijo },
	                                            hospedaje.telefono_fijo
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdCelular },
	                                            hospedaje.celular
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdCelularWsp },
	                                            hospedaje.celular_wsp
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdDireccion },
	                                            hospedaje.direccion
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdSingleConBano },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                hospedaje.single_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                _react2.default.createElement('input', { type: 'checkbox',
	                                                    checked: _this7.state.tipoHabitacion === 1 ? true : false,
	                                                    onChange: function onChange() {
	                                                        return _this7.selecTipoHabitacion(1);
	                                                    } })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdDobleConBano },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                hospedaje.doble_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                _react2.default.createElement('input', { type: 'checkbox',
	                                                    checked: _this7.state.tipoHabitacion === 2 ? true : false,
	                                                    onChange: function onChange() {
	                                                        return _this7.selecTipoHabitacion(2);
	                                                    } })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdCuadrupleConBano },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                hospedaje.cuadruple_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6' },
	                                                _react2.default.createElement('input', { type: 'checkbox',
	                                                    checked: _this7.state.tipoHabitacion === 3 ? true : false,
	                                                    onChange: function onChange() {
	                                                        return _this7.selecTipoHabitacion(3);
	                                                    } })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { className: cssModal.tdAcciones },
	                                            _react2.default.createElement('button', { className: _this7.state.idHospedajeSeleccionado === hospedaje.idHospedaje ? "btn btn-xs btn-primary glyphicon glyphicon-ok" : "btn btn-xs btn-success glyphicon glyphicon-ok",
	                                                disabled: _this7.state.idHospedajeSeleccionado > 0 || _this7.state.tipoHabitacion === 0,
	                                                onClick: function onClick() {
	                                                    return _this7.seleccionarHospedaje(hospedaje.idHospedaje);
	                                                },
	                                                title: _this7.state.idHospedajeSeleccionado })
	                                        )
	                                    );
	                                })
	                            ) : _react2.default.createElement(
	                                'div',
	                                null,
	                                this.props.idHospedaje === 0 || this.props.idHospedaje === null ? _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'No se encontraron hospedajes en la ciudad'
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Nombre: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.props.idHospedaje.nombre
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Ciudad: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.state.nombreComuna
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Direcci\xF3n: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.props.idHospedaje.direccion
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Celular: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.props.idHospedaje.celular
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Tipo Habitaci\xF3n: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                tipoHabitacion[this.props.idDetalleHospedaje.tipo_habitacion]
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Valor: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.props.idHospedaje[habitacion[this.props.idDetalleHospedaje.tipo_habitacion]].toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Estado Reserva: '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                this.props.idDetalleHospedaje.estado === 1 ? "Enviada" : "Confirmada"
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAlojamiento;
	}(_react2.default.Component);
	
	ModalAlojamiento.contextTypes = {
	    buscarHospedajes: PropTypes.func,
	    guardarDetalleHospedaje: PropTypes.func
	};
	var TablaHospedaje = function TablaHospedaje(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed table-striped " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: cssModal.colIndex }),
	            _react2.default.createElement('col', { className: cssModal.colNombre }),
	            _react2.default.createElement('col', { className: cssModal.colPrioridad }),
	            _react2.default.createElement('col', { className: cssModal.colMailPrincipal }),
	            _react2.default.createElement('col', { className: cssModal.colMailSecundario }),
	            _react2.default.createElement('col', { className: cssModal.colTelefonoFijo }),
	            _react2.default.createElement('col', { className: cssModal.colCelular }),
	            _react2.default.createElement('col', { className: cssModal.colCelularWsp }),
	            _react2.default.createElement('col', { className: cssModal.colDireccion }),
	            _react2.default.createElement('col', { className: cssModal.colSingleConBano }),
	            _react2.default.createElement('col', { className: cssModal.colDobleConBano }),
	            _react2.default.createElement('col', { className: cssModal.colCuadrupleConBano }),
	            _react2.default.createElement('col', { className: cssModal.colAcciones })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thNombre },
	                    'Nombre'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thPrioridad },
	                    'Prioridad'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thMailPrincipal },
	                    'Mail Principal'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thMailSecundario },
	                    'Mail Secundario'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thTelefonoFijo },
	                    'Tel. Fijo'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thCelular },
	                    'Celular'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thCelularWsp },
	                    'Whatsapp'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thDireccion },
	                    'Direcci\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thSingleConBano },
	                    'Single'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thDobleConBano },
	                    'Doble'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: cssModal.thCuadrupleConBano },
	                    'Cu\xE1druple'
	                ),
	                _react2.default.createElement('th', { className: cssModal.thAcciones })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	var ModalPasaje = exports.ModalPasaje = function (_React$Component4) {
	    _inherits(ModalPasaje, _React$Component4);
	
	    function ModalPasaje(props) {
	        _classCallCheck(this, ModalPasaje);
	
	        var _this8 = _possibleConstructorReturn(this, (ModalPasaje.__proto__ || Object.getPrototypeOf(ModalPasaje)).call(this, props));
	
	        _this8.state = {
	            comprobante: '',
	            hora_pasaje: '',
	            bus: '',
	            codigo_pasaje: '',
	            se_imprime: false,
	            error: []
	        };
	        _this8.onInputChange = function (key, evt) {
	            _this8.setState(_defineProperty({}, key, evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value));
	        };
	        _this8.guardaPasaje = function () {
	            var actualizado = _this8.props.servicio;
	            actualizado.comprobante = _this8.state.comprobante;
	            _this8.context.subirComprobante(_this8.props.index, actualizado).then(function (resp) {
	                var datosPasaje = {
	                    'horario_pasaje': _this8.state.hora_pasaje,
	                    'bus': _this8.state.bus,
	                    'codigo_pasaje': _this8.state.codigo_pasaje,
	                    'se_imprime': _this8.state.se_imprime
	                };
	                _this8.setState({
	                    error: []
	                });
	                _this8.context.guardaDatosPasaje(_this8.props.index, resp.idBoletoPasaje, datosPasaje).then(function (resp) {
	                    _this8.setState({
	                        error: []
	                    });
	                    _this8.props.hideModal();
	                }).catch(function (err) {
	                    console.log(err);
	                    _this8.setState({
	                        error: err.data
	                    });
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this8.setState({
	                    error: err.data
	                });
	            });
	        };
	        return _this8;
	    }
	
	    _createClass(ModalPasaje, [{
	        key: 'onComprobanteChange',
	        value: function onComprobanteChange(evt) {
	            this.setState({
	                comprobante: evt.target.files[0]
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.servicio.boletoPasaje) {
	                this.setState({
	                    comprobante: this.props.servicio.boletoPasaje.nombre,
	                    hora_pasaje: this.props.servicio.boletoPasaje.horario_pasaje,
	                    bus: this.props.servicio.boletoPasaje.bus,
	                    codigo_pasaje: this.props.servicio.boletoPasaje.codigo_pasaje,
	                    se_imprime: this.props.servicio.boletoPasaje.se_imprime
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPasaje'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Pasajes'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Hora Pasaje '
	                                    ),
	                                    _react2.default.createElement('input', { type: 'time', className: 'form-control',
	                                        value: this.state.hora_pasaje,
	                                        onChange: this.onInputChange.bind(this, 'hora_pasaje'),
	                                        disabled: this.props.servicio.boletoPasaje
	                                    }),
	                                    this.state.error.hora_pasaje && _react2.default.createElement(
	                                        'span',
	                                        { className: cx('form__error-message') },
	                                        this.state.error.hora_pasaje
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Bus '
	                                    ),
	                                    _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                        value: this.state.bus,
	                                        onChange: this.onInputChange.bind(this, 'bus'),
	                                        disabled: this.props.servicio.boletoPasaje
	                                    }),
	                                    this.state.error.bus && _react2.default.createElement(
	                                        'span',
	                                        { className: cx('form__error-message') },
	                                        this.state.error.bus
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'C\xF3digo Pasaje '
	                                    ),
	                                    _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                        value: this.state.codigo_pasaje,
	                                        onChange: this.onInputChange.bind(this, 'codigo_pasaje'),
	                                        disabled: this.props.servicio.boletoPasaje
	                                    }),
	                                    this.state.error.codigo_pasaje && _react2.default.createElement(
	                                        'span',
	                                        { className: cx('form__error-message') },
	                                        this.state.error.codigo_pasaje
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '\xBFSe Imprime? '
	                                    ),
	                                    _react2.default.createElement('input', { type: 'checkbox', className: 'form-control',
	                                        checked: this.state.se_imprime,
	                                        onChange: this.onInputChange.bind(this, 'se_imprime'),
	                                        disabled: this.props.servicio.boletoPasaje
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-3' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Comprobante'
	                                ),
	                                _react2.default.createElement('input', { id: 'subirComprobante', type: 'file',
	                                    onChange: this.onComprobanteChange.bind(this),
	                                    disabled: !this.props.servicio.diaTrabajado || this.props.servicio.boletoPasaje,
	                                    title: 'Seleccionar Comprobante' }),
	                                this.state.error.comprobante && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.comprobante
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-2 pull-left' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-d btn-primary',
	                                    onClick: this.guardaPasaje,
	                                    disabled: this.props.servicio.boletoPasaje },
	                                'Guardar'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-10 pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                                'Cancelar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalPasaje;
	}(_react2.default.Component);
	
	ModalPasaje.contextTypes = {
	    subirComprobante: PropTypes.func,
	    guardarDetalleHospedaje: PropTypes.func,
	    guardaDatosPasaje: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"Modales__modal___2FfSQ","modalConcepto":"Modales__modalConcepto___3ZzsB","modalPublicar":"Modales__modalPublicar___2CXwv","modalAlojamiento":"Modales__modalAlojamiento___1DVse","modalShowAlojamiento":"Modales__modalShowAlojamiento___2B4iw","modalPasaje":"Modales__modalPasaje___3dcHa","form__error-message":"Modales__form__error-message___UBF5o","colIndex":"Modales__colIndex___1HJDg","thIndex":"Modales__thIndex___3NZt1","tdIndex":"Modales__tdIndex___9tAk9","colNombre":"Modales__colNombre___iCoxT","thNombre":"Modales__thNombre___17CZI","tdNombre":"Modales__tdNombre___1hjWj","colCiudad":"Modales__colCiudad___1mQKl","thCiudad":"Modales__thCiudad___34Gxc","tdCiudad":"Modales__tdCiudad___2ZD0W","colPrioridad":"Modales__colPrioridad___1HKgy","thPrioridad":"Modales__thPrioridad___XJsos","tdPrioridad":"Modales__tdPrioridad___3y5z5","colMailPrincipal":"Modales__colMailPrincipal___3lT1W","thMailPrincipal":"Modales__thMailPrincipal___2DNtx","tdMailPrincipal":"Modales__tdMailPrincipal___ij3Ki","colMailSecundario":"Modales__colMailSecundario___-Tx4c","thMailSecundario":"Modales__thMailSecundario___Y_-2f","tdMailSecundario":"Modales__tdMailSecundario___2X5MF","colTelefonoFijo":"Modales__colTelefonoFijo___1RjS-","thTelefonoFijo":"Modales__thTelefonoFijo___W677b","tdTelefonoFijo":"Modales__tdTelefonoFijo___1zN1f","colCelular":"Modales__colCelular___2kKf3","thCelular":"Modales__thCelular___L0IF7","tdCelular":"Modales__tdCelular___2O2b6","colCelularWsp":"Modales__colCelularWsp___2ejEp","thCelularWsp":"Modales__thCelularWsp___359ql","tdCelularWsp":"Modales__tdCelularWsp___1VTGi","colDireccion":"Modales__colDireccion___XBOM8","thDireccion":"Modales__thDireccion___1fKNf","tdDireccion":"Modales__tdDireccion___1Yj8n","colGeoReferencia":"Modales__colGeoReferencia___1TyRN","thGeoReferencia":"Modales__thGeoReferencia___3cFgr","tdGeoReferencia":"Modales__tdGeoReferencia___gttV9","colSingleSinBano":"Modales__colSingleSinBano___N0s97","thSingleSinBano":"Modales__thSingleSinBano___2Ne7D","tdSingleSinBano":"Modales__tdSingleSinBano___290_B","colSingleConBano":"Modales__colSingleConBano___1P19d","thSingleConBano":"Modales__thSingleConBano___2YoR3","tdSingleConBano":"Modales__tdSingleConBano___3PVHF","colDobleSinBano":"Modales__colDobleSinBano___3EffU","thDobleSinBano":"Modales__thDobleSinBano___2NJ2T","tdDobleSinBano":"Modales__tdDobleSinBano___uYUXI","colDobleConBano":"Modales__colDobleConBano___2iyAp","thDobleConBano":"Modales__thDobleConBano___lgxRw","tdDobleConBano":"Modales__tdDobleConBano___2J0nm","colCuadrupleConBano":"Modales__colCuadrupleConBano___1tTNw","thCuadrupleConBano":"Modales__thCuadrupleConBano___3fxJc","tdCuadrupleConBano":"Modales__tdCuadrupleConBano___fndyM","colCuadrupleSinBano":"Modales__colCuadrupleSinBano___3fpBH","thCuadrupleSinBano":"Modales__thCuadrupleSinBano___26jMc","tdCuadrupleSinBano":"Modales__tdCuadrupleSinBano___20KjK","colAcciones":"Modales__colAcciones___2l-tl","thAcciones":"Modales__thAcciones___1NA3l","tdAcciones":"Modales__tdAcciones___1x-Ao"};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Totales = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var Totales = exports.Totales = function (_React$Component) {
	    _inherits(Totales, _React$Component);
	
	    function Totales(props) {
	        _classCallCheck(this, Totales);
	
	        var _this = _possibleConstructorReturn(this, (Totales.__proto__ || Object.getPrototypeOf(Totales)).call(this, props));
	
	        _this.state = {
	            fondoPendiente: 0
	        };
	        _this.onFondoPendienteChange = function (evt) {
	            _this.setState({ fondoPendiente: evt.target.value }, function () {
	                return _this.context.saldoLiderChange(_this.state.fondoPendiente);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Totales, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-info " + css.panelTotales },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Totales'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyTotales },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Viaticos'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.viaticosLiquidacion.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Fondo por Rendir'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.fondosRendir.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Saldo Lider'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement('input', { type: 'number', className: "form-control " + css.inputFondos,
	                            ref: function ref(fondoPendiente) {
	                                _this2.inputFondoPendiente = fondoPendiente;
	                            },
	                            onFocus: function onFocus() {
	                                _this2.inputFondoPendiente.select();
	                            },
	                            value: this.props.totales.fondoPendiente,
	                            onChange: this.onFondoPendienteChange })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Saldo por Girar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.fondoGirar.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Totales;
	}(_react2.default.Component);
	
	Totales.contextTypes = {
	    saldoLiderChange: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Totales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaFondos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowFondos = __webpack_require__(1028);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var TablaFondos = exports.TablaFondos = function (_React$Component) {
	    _inherits(TablaFondos, _React$Component);
	
	    function TablaFondos(props) {
	        _classCallCheck(this, TablaFondos);
	
	        var _this = _possibleConstructorReturn(this, (TablaFondos.__proto__ || Object.getPrototypeOf(TablaFondos)).call(this, props));
	
	        _this.rows = [];
	        return _this;
	    }
	
	    _createClass(TablaFondos, [{
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length - 1;
	            var elemento = nombreElemento;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(elemento);
	            } else if (index >= ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
	                if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                if (this.rows[0][elemento].disabled) {
	                    this.rows[1].focusElemento(elemento);
	                } else {
	                    this.rows[0].focusElemento(elemento);
	                }
	            } else {
	                // no es ni el ultimo, ni el primero
	                if (this.rows[index][elemento].disabled) {
	                    if (index + 1 >= ultimoIndex) {
	                        if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                        if (this.rows[0][elemento].disabled) {
	                            this.rows[1].focusElemento(elemento);
	                        } else {
	                            this.rows[0].focusElemento(elemento);
	                        }
	                    } else {
	                        if (this.rows[index + 1][elemento].disabled) {
	                            if (index + 2 >= ultimoIndex) {
	                                if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                                if (this.rows[0][elemento].disabled) {
	                                    this.rows[1].focusElemento(elemento);
	                                } else {
	                                    this.rows[0].focusElemento(elemento);
	                                }
	                            } else {
	                                this.rows[index + 2].focusElemento(elemento);
	                            }
	                        } else {
	                            this.rows[index + 1].focusElemento(elemento);
	                        }
	                    }
	                } else {
	                    this.rows[index].focusElemento(elemento);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadFondos = this.props.semanaServicios.length + 1;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Fondos'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaFondo,
	                        null,
	                        _.range(0, cantidadFondos).map(function (index) {
	                            var servicio = _this2.props.semanaServicios[index];
	                            var totales = _this2.props.semanaServicios.length === index ? true : false;
	                            return _react2.default.createElement(_RowFondos.RowFondos, {
	                                key: index,
	                                index: index,
	                                ref: function ref(_ref) {
	                                    return _this2.rows[index] = _ref;
	                                },
	                                focusRow: _this2.focusRow.bind(_this2),
	                                servicio: servicio,
	                                totales: totales,
	                                totalColacionNocturna: _this2.props.totalColacionNocturna,
	                                totalViatico: _this2.props.totalViatico,
	                                totalAlojamiento: _this2.props.totalAlojamiento,
	                                totalAcercmientos: _this2.props.totalAcercmientos,
	                                totalTraslados: _this2.props.totalTraslados,
	                                totalPasajeOperador: _this2.props.totalPasajeOperador,
	                                totalOtros: _this2.props.totalOtros,
	                                puedeModificar: _this2.props.puedeModificar
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaFondos;
	}(_react2.default.Component);
	
	var TablaFondo = function TablaFondo(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed + " " + css.panelDetalleInventarios },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colDiaTrabajado }),
	            _react2.default.createElement('col', { className: css.colDia }),
	            _react2.default.createElement('col', { className: css.colServicios }),
	            _react2.default.createElement('col', { className: css.colColNoche }),
	            _react2.default.createElement('col', { className: css.colViatico }),
	            _react2.default.createElement('col', { className: css.colAcercamiento }),
	            _react2.default.createElement('col', { className: css.colTraslado }),
	            _react2.default.createElement('col', { className: css.colPasajeOperador }),
	            _react2.default.createElement('col', { className: css.colOtros }),
	            _react2.default.createElement('col', { className: css.colPasajeSei }),
	            _react2.default.createElement('col', { className: css.colAlojamiento })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDiaTrabajado },
	                    'D-T'
	                ),
	                _react2.default.createElement('th', { className: css.thDia }),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thServicios },
	                    'Cant. Serv.'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thColNoche },
	                    'Colaci\xF3n Noc.'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thViatico },
	                    'Vi\xE1tico'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thAcercamiento },
	                    'Acercamientos'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTraslado },
	                    'Traslados'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thPasajeOperador },
	                    'Pasje Operador'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thOtros },
	                    'Otros'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thPasajeSei },
	                    'Pasaje SEI'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thAlojamiento },
	                    'Alojamiento'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaFondos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowFondos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Modales = __webpack_require__(1024);
	
	var _Fondos = __webpack_require__(1023);
	
	var _Fondos2 = _interopRequireDefault(_Fondos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_moment2.default.locale('es');
	var PropTypes = _react2.default.PropTypes;
	
	var RowFondos = exports.RowFondos = function (_React$Component) {
	    _inherits(RowFondos, _React$Component);
	
	    function RowFondos(props) {
	        _classCallCheck(this, RowFondos);
	
	        var _this = _possibleConstructorReturn(this, (RowFondos.__proto__ || Object.getPrototypeOf(RowFondos)).call(this, props));
	
	        _this.inputOnKeyDown = _this.inputOnKeyDown.bind(_this);
	        _this.state = {
	            servicio: [],
	            comprobante: ''
	        };
	        _this.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
	            actualizado.dirty = 1;
	            _this.setState({ servicio: Object.assign({}, _this.state.servicio, actualizado) }, function () {
	                return _this.context.inputChange(_this.props.index, _this.state.servicio);
	            });
	        };
	        _this.onInputBlur = function () {
	            if (_this.state.servicio.dirty) _this.context.guardarFondo(_this.state.servicio);
	        };
	        return _this;
	    }
	
	    _createClass(RowFondos, [{
	        key: 'onComprobanteChange',
	        value: function onComprobanteChange(evt) {
	            var _this2 = this;
	
	            if (evt.target.files[0]) {
	                var actualizado = {};
	                actualizado.comprobante = evt.target.files[0];
	                this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado) }, function () {
	                    return _this2.context.subirComprobante(_this2.props.index, _this2.state.servicio);
	                });
	            }
	        }
	    }, {
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            this[elemento].focus();
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(key, evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.focusRow(this.props.index + 1, key);
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                this.props.focusRow(this.props.index - 1, key);
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                servicio: this.props.servicio
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdDiaTrabajado },
	                    this.props.totales ? null : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement('input', { type: 'checkbox', placeholder: 'Dia Trabajado', id: this.props.index,
	                                ref: function ref(diaTrabajado) {
	                                    _this3.inputDiaTrabajado = diaTrabajado;
	                                },
	                                checked: this.state.servicio.diaTrabajado
	                                //onFocus={()=>{ this.inputDiaTrabajado.select() }}
	                                , onKeyDown: this.inputOnKeyDown.bind(this, 'diaTrabajado'),
	                                onChange: this.onInputChange.bind(this, 'diaTrabajado'),
	                                disabled: !this.props.puedeModificar
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdDia },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.totales ? null : (0, _moment2.default)(this.state.servicio.dia).format('dddd D MMM')
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdServicios },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        this.props.totales ? _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Totales'
	                        ) : this.state.servicio.cantidad_servicios
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdColNoche },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalColacionNocturna.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(colacion_nocturna) {
	                            _this3.inputColacion_nocturna = colacion_nocturna;
	                        },
	                        min: '0',
	                        value: this.state.servicio.colacion_nocturna,
	                        disabled: !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputColacion_nocturna.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputColacion_nocturna'),
	                        onChange: this.onInputChange.bind(this, 'colacion_nocturna'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdViatico },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalViatico.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(viatico) {
	                            _this3.inputViatico = viatico;
	                        },
	                        min: '0',
	                        value: this.state.servicio.viatico,
	                        disabled: !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputViatico.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputViatico'),
	                        onChange: this.onInputChange.bind(this, 'viatico'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdAcercamiento },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalAcercmientos.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(acercamientos) {
	                            _this3.inputAcercamientos = acercamientos;
	                        },
	                        min: '0',
	                        value: this.state.servicio.acercamientos,
	                        disabled: !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputAcercamientos.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputAcercamientos'),
	                        onChange: this.onInputChange.bind(this, 'acercamientos'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdTraslado },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalTraslados.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(traslados) {
	                            _this3.inputTraslados = traslados;
	                        },
	                        min: '0',
	                        value: this.state.servicio.traslados,
	                        disabled: this.state.servicio.pasajeSei || !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputTraslados.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputTraslados'),
	                        onChange: this.onInputChange.bind(this, 'traslados'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdPasajeOperador },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalPasajeOperador.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(pasajeOperador) {
	                            _this3.inputPasajeOperador = pasajeOperador;
	                        },
	                        min: '0',
	                        value: this.state.servicio.pasajeOperador,
	                        disabled: !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputPasajeOperador.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputPasajeOperador'),
	                        onChange: this.onInputChange.bind(this, 'pasajeOperador'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdOtros },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalOtros.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement('input', _defineProperty({ type: 'number', className: "form-control " + _Fondos2.default.inputFondos,
	                        ref: function ref(otros) {
	                            _this3.inputOtros = otros;
	                        },
	                        min: '0',
	                        value: this.state.servicio.otros,
	                        disabled: !this.state.servicio.diaTrabajado
	                        //onFocus={()=>{ this.inputOtros.select() }}
	                        , onKeyDown: this.inputOnKeyDown.bind(this, 'inputOtros'),
	                        onChange: this.onInputChange.bind(this, 'otros'),
	                        onBlur: this.onInputBlur
	                    }, 'disabled', !this.props.puedeModificar))
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdPasajeSei },
	                    this.props.totales ? null : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 text-center' },
	                            _react2.default.createElement('input', _defineProperty({ type: 'checkbox', placeholder: 'Pasaje SEI', id: this.props.index, className: "form-control " + _Fondos2.default.inputFondos,
	                                ref: function ref(pasajeSei) {
	                                    _this3.inputPasajeSei = pasajeSei;
	                                },
	                                checked: this.state.servicio.pasajeSei,
	                                disabled: !this.state.servicio.diaTrabajado,
	                                onKeyDown: this.inputOnKeyDown.bind(this, 'inputPasajeSei'),
	                                onChange: this.onInputChange.bind(this, 'pasajeSei'),
	                                onBlur: this.onInputBlur
	                            }, 'disabled', !this.props.puedeModificar))
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: "col-md-6 pull-left " + _Fondos2.default.inputFondos },
	                            this.state.servicio.pasajeSei ? _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(
	                                        _Modales.ModalTrigger,
	                                        null,
	                                        function (isVisible, showModal, hideModal) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement('span', { className: 'btn btn-xs btn-success glyphicon glyphicon-open-file',
	                                                    onClick: showModal,
	                                                    disabled: !_this3.state.servicio.diaTrabajado && !_this3.props.puedeModificar,
	                                                    title: 'Subir pasaje' }),
	                                                isVisible && _react2.default.createElement(_Modales.ModalPasaje, {
	                                                    hideModal: hideModal,
	                                                    index: _this3.props.index,
	                                                    servicio: _this3.state.servicio,
	                                                    boletoPasaje: _this3.state.servicio.boletoPasaje
	                                                })
	                                            );
	                                        }
	                                    )
	                                )
	                            ) : null
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _Fondos2.default.tdAlojamiento },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-center " + _Fondos2.default.totales },
	                        _react2.default.createElement('strong', null)
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement('span', { className: _this3.state.servicio.pedirAlojamiento ? "btn btn-xs btn-success glyphicon glyphicon-search" : "btn btn-xs btn-warning glyphicon glyphicon-search",
	                                            onClick: showModal,
	                                            disabled: !_this3.state.servicio.diaTrabajado,
	                                            title: _this3.state.servicio.pedirAlojamiento ? "Ciudad de inventario es distinta a cuidad de origen de lider" : "Ciudad de inventario es igual a cuidad de origen de lider" }),
	                                        isVisible && _react2.default.createElement(_Modales.ModalAlojamiento, {
	                                            hideModal: hideModal,
	                                            comuna: _this3.state.servicio.comunaInventarioActual,
	                                            idDetalleHospedaje: _this3.state.servicio.idDetalleHospedaje,
	                                            idHospedaje: _this3.state.servicio.idHospedaje,
	                                            index: _this3.props.index,
	                                            servicio: _this3.state.servicio
	                                        })
	                                    );
	                                }
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowFondos;
	}(_react2.default.Component);
	
	RowFondos.contextTypes = {
	    inputChange: PropTypes.func,
	    subirComprobante: PropTypes.func,
	    guardarFondo: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowFondos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RevisionRendiciones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _TableRendiciones = __webpack_require__(1030);
	
	var _Fondos = __webpack_require__(1023);
	
	var _Fondos2 = _interopRequireDefault(_Fondos);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	//CSS
	
	
	var cx = _bind2.default.bind(_Fondos2.default);
	_moment2.default.locale('es');
	
	var RevisionRendiciones = exports.RevisionRendiciones = function (_React$Component) {
	    _inherits(RevisionRendiciones, _React$Component);
	
	    function RevisionRendiciones(props) {
	        _classCallCheck(this, RevisionRendiciones);
	
	        var _this = _possibleConstructorReturn(this, (RevisionRendiciones.__proto__ || Object.getPrototypeOf(RevisionRendiciones)).call(this, props));
	
	        _this.state = {
	            rendiciones: [],
	            selectedWeek: '',
	            numberWeek: 0,
	            idLeader: 0,
	            error: []
	        };
	        _this.onWeekChange = function (evt) {
	            _this.setState({
	                selectedWeek: evt.target.value,
	                numberWeek: evt.target.value.substring(6, 8),
	                idLeader: 0
	            }, function () {
	                return _this.getRendiciones();
	            });
	        };
	        _this.onSelectLeaderChange = function (evt) {
	            _this.setState({
	                idLeader: evt.target.value
	            }, function () {
	                return _this.getRendiciones();
	            });
	        };
	        _this.getRendiciones = function () {
	            if (_this.state.numberWeek) {
	                _v2.default.rendiciones().getRendiciones(_this.state.idLeader, _this.state.numberWeek).then(function (resp) {
	                    _this.setState({
	                        rendiciones: resp
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        return _this;
	    }
	
	    _createClass(RevisionRendiciones, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'page-header row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'titleFinance') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-10", 'divTitle') },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Rendiciones enviadas por trabajadores'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-1", 'divNavBar') },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-md btn-success',
	                                            href: '/api/rendiciones/fondos/' + this.state.numero_semana + '/descargar-excel' },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' }),
	                                        ' Excel'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 form-group ' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'control-label', htmlFor: 'selectSemana' },
	                                    'Seleccionar Semana'
	                                ),
	                                _react2.default.createElement('input', { type: 'week', className: "form-control " + _Fondos2.default.inputGeneral,
	                                    value: this.state.semanaSeleccionada,
	                                    onChange: this.onWeekChange }),
	                                this.state.error.fechas && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.fechas
	                                )
	                            )
	                        ),
	                        this.state.rendiciones.length === 0 ? null : _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-12", 'divFinance') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-11' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: _Fondos2.default.textInformation },
	                                        'Rendiciones encontradas en la semana seleccionada*'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(_TableRendiciones.TableRendiciones, {
	                                    rendiciones: this.state.rendiciones
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RevisionRendiciones;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RevisionRendiciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableRendiciones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowRendiciones = __webpack_require__(1031);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var TableRendiciones = exports.TableRendiciones = function (_React$Component) {
	    _inherits(TableRendiciones, _React$Component);
	
	    function TableRendiciones(props) {
	        _classCallCheck(this, TableRendiciones);
	
	        return _possibleConstructorReturn(this, (TableRendiciones.__proto__ || Object.getPrototypeOf(TableRendiciones)).call(this, props));
	    }
	
	    _createClass(TableRendiciones, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalRendiciones = this.props.rendiciones.length;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Rendiciones'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaRendiciones,
	                        null,
	                        _.range(0, totalRendiciones).map(function (index) {
	                            var rendicion = _this2.props.rendiciones[index];
	                            return _react2.default.createElement(_RowRendiciones.RowRendiciones, {
	                                key: index,
	                                index: index,
	                                rendicion: rendicion
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TableRendiciones;
	}(_react2.default.Component);
	
	var TablaRendiciones = function TablaRendiciones(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed + " " + css.panelDetalleInventarios },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null)
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Origen'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Desde'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Hasta'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Total Vi\xE1tico'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Total a Rendir'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Total Gastado'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Diferencia'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Detalles'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TableRendiciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowRendiciones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	_moment2.default.locale('es');
	
	var RowRendiciones = exports.RowRendiciones = function (_React$Component) {
	    _inherits(RowRendiciones, _React$Component);
	
	    function RowRendiciones(props) {
	        _classCallCheck(this, RowRendiciones);
	
	        return _possibleConstructorReturn(this, (RowRendiciones.__proto__ || Object.getPrototypeOf(RowRendiciones)).call(this, props));
	    }
	
	    _createClass(RowRendiciones, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.rendicion.rendidor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.rendicion.fecha_inicial
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.rendicion.fecha_final
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.rendicion.fondos_viatico
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    this.props.rendicion.fondos_rendir
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    this.props.rendicion.total_gastos
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdJornada },
	                    this.props.rendicion.diferencia
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDotacion },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-xs btn-info',
	                            href: '/rendicion/' + this.props.rendicion.idRendicion + '/detalle', target: '_blank' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowRendiciones;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowRendiciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DetailsRendicion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _TableDetails = __webpack_require__(1033);
	
	var _InformativoRendicion = __webpack_require__(1036);
	
	var _Fondos = __webpack_require__(1023);
	
	var _Fondos2 = _interopRequireDefault(_Fondos);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	//Componentes
	
	
	//CSS
	
	var cx = _bind2.default.bind(_Fondos2.default);
	_moment2.default.locale('es');
	
	var DetailsRendicion = exports.DetailsRendicion = function (_React$Component) {
	    _inherits(DetailsRendicion, _React$Component);
	
	    function DetailsRendicion(props) {
	        _classCallCheck(this, DetailsRendicion);
	
	        var _this = _possibleConstructorReturn(this, (DetailsRendicion.__proto__ || Object.getPrototypeOf(DetailsRendicion)).call(this, props));
	
	        _this.state = {
	            rendicion: _this.props.rendicion,
	            gastos: _this.props.gastos,
	            cambio: false
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        return _this;
	    }
	
	    _createClass(DetailsRendicion, [{
	        key: 'cerrarRendicion',
	        value: function cerrarRendicion() {
	            var _this2 = this;
	
	            _v2.default.fondos().cerrarFondo(this.state.rendicion.idRendicion).then(function (rendicion) {
	                _this2.refs.notificator.success("Rendicion", "Rendición cerrada correctamente", 4 * 1000);
	            }).catch(this.ajaxErrorHandler('Error al intentar cerrar la rendición'));
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this3 = this;
	
	            return {
	                aprobarGasto: function aprobarGasto(idGasto) {
	                    _v2.default.gastos().aprobarGasto(idGasto).then(function (gasto) {
	                        _this3.refs.notificator.success("Gasto", "Gasto aprobado", 4 * 1000);
	                    }).catch(_this3.ajaxErrorHandler('Error al aprobar gasto'));
	                },
	                rechazarGasto: function rechazarGasto(idGasto) {
	                    var request = _v2.default.gastos().rechazarGasto(idGasto);
	                    request.then(function (gasto) {
	                        _this3.refs.notificator.success("Gasto", "Gasto rechazado", 4 * 1000);
	                    }).catch(_this3.ajaxErrorHandler('Error al rechazar gasto'));
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'page-header row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'titleFinance') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-9", 'divTitle') },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-list' }),
	                                        ' Detalle de rendici\xF3n'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-2", 'divNavBar') },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-md btn-warning',
	                                            onClick: this.cerrarRendicion.bind(this)
	                                        },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-bookmark' }),
	                                        ' Cerrar Rendici\xF3n'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_InformativoRendicion.InformativoRendicion, {
	                            fondo: this.state.rendicion
	                        }),
	                        this.state.gastos.length === 0 ? null : _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-12", 'divFinance') },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-10' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: _Fondos2.default.textInformation },
	                                        'Gastos asociados a la rendici\xF3n*'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: "col-md-2" },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-md btn-info pull-right',
	                                            href: '/#' },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                                        ' Aprobar Todos'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(_TableDetails.TableDetails, {
	                                    gastos: this.state.gastos
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetailsRendicion;
	}(_react2.default.Component);
	
	DetailsRendicion.propTypes = {
	    rendicion: PropTypes.object.isRequired,
	    gastos: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	DetailsRendicion.childContextTypes = {
	    aprobarGasto: PropTypes.func,
	    rechazarGasto: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetailsRendicion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableDetails = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowDetail = __webpack_require__(1034);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var TableDetails = exports.TableDetails = function (_React$Component) {
	    _inherits(TableDetails, _React$Component);
	
	    function TableDetails(props) {
	        _classCallCheck(this, TableDetails);
	
	        return _possibleConstructorReturn(this, (TableDetails.__proto__ || Object.getPrototypeOf(TableDetails)).call(this, props));
	    }
	
	    _createClass(TableDetails, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalGastos = this.props.gastos.length;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Listado de gastos'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaRendiciones,
	                        null,
	                        _.range(0, totalGastos).map(function (index) {
	                            var gasto = _this2.props.gastos[index];
	                            return _react2.default.createElement(_RowDetail.RowDetail, {
	                                key: index,
	                                index: index,
	                                gasto: gasto
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TableDetails;
	}(_react2.default.Component);
	
	var TablaRendiciones = function TablaRendiciones(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed + " " + css.panelDetalleInventarios },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', null),
	            _react2.default.createElement('col', { className: css.colFoto }),
	            _react2.default.createElement('col', { className: css.colFoto })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: 'thIndex' },
	                    '#'
	                ),
	                _react2.default.createElement('th', null),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Fecha'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Total'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Documento'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Clasificaci\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Glosa'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Foto'
	                ),
	                _react2.default.createElement('th', { className: css.thFoto }),
	                _react2.default.createElement('th', { className: css.thFoto })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TableDetails.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowDetail = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Fondos = __webpack_require__(1023);
	
	var css = _interopRequireWildcard(_Fondos);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var csx = _interopRequireWildcard(_PanelAuditoria);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1035);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(css);
	
	var PropTypes = _react2.default.PropTypes;
	_moment2.default.locale('es');
	
	var labelEstado = ['label-default', 'label-info', 'label-success', 'label-warning'];
	var textoEstado = ['', 'Pendiente', 'Aprobado', 'Rechazado'];
	
	var RowDetail = exports.RowDetail = function (_React$Component) {
	    _inherits(RowDetail, _React$Component);
	
	    function RowDetail(props) {
	        _classCallCheck(this, RowDetail);
	
	        return _possibleConstructorReturn(this, (RowDetail.__proto__ || Object.getPrototypeOf(RowDetail)).call(this, props));
	    }
	
	    _createClass(RowDetail, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: cx('label', labelEstado[this.props.gasto.id_estado_gasto])
	                        },
	                        textoEstado[this.props.gasto.id_estado_gasto]
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.gasto.fecha_emision
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.gasto.total_format
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.gasto.tipo_documento
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.gasto.tipo_gasto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.gasto.glosa
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    _react2.default.createElement(
	                        'p',
	                        { className: csx.tooltip },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-search " + csx.glyphiconStock }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: csx.tooltiptext },
	                            _react2.default.createElement('img', { src: '' + this.props.gasto.foto_documento, className: csx.imagenStock })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button', className: 'btn btn-xs btn-success',
	                            onClick: function onClick() {
	                                return _this2.context.aprobarGasto(_this2.props.gasto.idGastoRendicion);
	                            }
	                        },
	                        'Aprobar'
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'button',
	                                { className: "btn btn-xs btn-danger", onClick: showModal },
	                                'Rechazar',
	                                isVisible && _react2.default.createElement(_Modales.RechazarGasto, {
	                                    hideModal: hideModal,
	                                    idGasto: _this2.props.gasto.idGastoRendicion
	                                })
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowDetail;
	}(_react2.default.Component);
	
	RowDetail.contextTypes = {
	    aprobarGasto: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowDetail.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RechazarGasto = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1025);
	
	var cssModal = _interopRequireWildcard(_Modales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var RechazarGasto = exports.RechazarGasto = function (_React$Component2) {
	    _inherits(RechazarGasto, _React$Component2);
	
	    function RechazarGasto(props) {
	        _classCallCheck(this, RechazarGasto);
	
	        var _this2 = _possibleConstructorReturn(this, (RechazarGasto.__proto__ || Object.getPrototypeOf(RechazarGasto)).call(this, props));
	
	        _this2.state = {};
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.context.rechazarGasto(_this2.props.idGasto).then(function (resp) {
	                _this2.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(RechazarGasto, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalPublicar'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        '\xBFEsta seguro de rechazar este gasto?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'col-md-12 col-sm-12 form-horizontal', action: '', onSubmit: this.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'exampleFormControlTextarea1' },
	                                    'Favor indicar el motivo de su rechazo'
	                                ),
	                                _react2.default.createElement('textarea', { className: 'form-control', id: 'exampleFormControlTextarea1', rows: '2' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6  pull-left' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-md btn-success', type: 'submit' },
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                                    ' Aceptar'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6  pull-right' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                                    ' Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RechazarGasto;
	}(_react2.default.Component);
	
	RechazarGasto.contextTypes = {
	    rechazarGasto: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InformativoRendicion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// CSS
	
	
	var cx = _bind2.default.bind(css);
	
	var InformativoRendicion = exports.InformativoRendicion = function (_React$Component) {
	    _inherits(InformativoRendicion, _React$Component);
	
	    function InformativoRendicion(props) {
	        _classCallCheck(this, InformativoRendicion);
	
	        return _possibleConstructorReturn(this, (InformativoRendicion.__proto__ || Object.getPrototypeOf(InformativoRendicion)).call(this, props));
	    }
	
	    _createClass(InformativoRendicion, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Fondos de: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.rendidor
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Desde: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.fecha_inicial
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Hasta: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.fecha_final
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Por Rendir: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.fondos_rendir
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Gastado: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.total_gastos
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                'Diferencia: ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'badge badge-secondary' },
	                                    this.props.fondo.diferencia
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InformativoRendicion;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InformativoRendicion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelDatosActa = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputTexto = __webpack_require__(1038);
	
	var _InputNumber = __webpack_require__(1040);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _PanelDatosActa = __webpack_require__(1041);
	
	var css = _interopRequireWildcard(_PanelDatosActa);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Libs
	
	// Styles
	
	var cx = _bind2.default.bind(css);
	
	var PanelDatosActa = exports.PanelDatosActa = function (_React$Component) {
	    _inherits(PanelDatosActa, _React$Component);
	
	    function PanelDatosActa(props) {
	        _classCallCheck(this, PanelDatosActa);
	
	        var _this = _possibleConstructorReturn(this, (PanelDatosActa.__proto__ || Object.getPrototypeOf(PanelDatosActa)).call(this, props));
	
	        _this.state = {
	            acta: {},
	            editandoActa: false
	        };
	        return _this;
	    }
	
	    _createClass(PanelDatosActa, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                iniciarEdicion: function iniciarEdicion() {
	                    return _this2.setState({ editandoActa: true });
	                },
	                finalizarEdicion: function finalizarEdicion() {
	                    return _this2.setState({ editandoActa: false });
	                },
	                publicar: function publicar() {
	                    _v2.default.inventario.acta.publicar(_this2.props.idInventario).then(function (actaActualizada) {
	                        console.log(actaActualizada);
	                        _this2.setState({ acta: actaActualizada });
	                    });
	                },
	                despublicar: function despublicar() {
	                    _v2.default.inventario.acta.despublicar(_this2.props.idInventario).then(function (actaActualizada) {
	                        console.log(actaActualizada);
	                        _this2.setState({ acta: actaActualizada });
	                    });
	                },
	                actualizarActa: function actualizarActa(campo, estado, tres) {
	                    console.log('editando acta ', campo, estado);
	                    if (estado.dirty && estado.valid) {
	                        var datos = {};
	                        datos[campo] = estado.valor;
	                        _v2.default.inventario.acta.actualizar(_this2.props.idInventario, datos).then(function (actaActualizada) {
	                            console.log(actaActualizada);
	                            _this2.setState({ acta: actaActualizada });
	                        });
	                        // catch
	                    }
	                },
	                reprocesar: function reprocesar() {
	                    _v2.default.inventario.acta.reprocesar(_this2.state.acta.archivo_idArchivo).then(function (actaActualizada) {
	                        console.log(actaActualizada);
	                        _this2.setState({ acta: actaActualizada });
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            _v2.default.inventario.acta.get(this.props.idInventario).then(function (acta) {
	                console.log('acta: ', acta);
	                _this3.setState({ acta: acta });
	            });
	            // catch
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel-default' },
	                _react2.default.createElement(PanelHeading, {
	                    actaConDatos: this.state.acta.inv_idInventario != undefined,
	                    publicada: this.state.acta.publicada,
	                    publicadaPor: this.state.acta.publicadaPor,
	                    fechaPublicacion: this.state.acta.fechaPublicacion,
	                    puedeEditar: this.props.puedeEditar,
	                    editandoActa: this.state.editandoActa
	                }),
	                _react2.default.createElement(PanelBody, {
	                    acta: this.state.acta,
	                    editar: this.state.editandoActa
	                })
	            );
	        }
	    }]);
	
	    return PanelDatosActa;
	}(_react2.default.Component);
	
	PanelDatosActa.propTypes = {
	    idInventario: PropTypes.number.isRequired
	    // numero: PropTypes.number.isRequired,
	    // texto: PropTypes.string.isRequired,
	    // objeto: PropTypes.object.isRequired,
	    // arreglo: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	PanelDatosActa.childContextTypes = {
	    iniciarEdicion: _react2.default.PropTypes.func,
	    finalizarEdicion: _react2.default.PropTypes.func,
	    publicar: _react2.default.PropTypes.func,
	    despublicar: _react2.default.PropTypes.func,
	    actualizarActa: _react2.default.PropTypes.func,
	    reprocesar: _react2.default.PropTypes.func
	};
	
	var PanelHeading = function PanelHeading(_ref, context) {
	    var puedeEditar = _ref.puedeEditar,
	        publicada = _ref.publicada,
	        publicadaPor = _ref.publicadaPor,
	        fechaPublicacion = _ref.fechaPublicacion,
	        editandoActa = _ref.editandoActa,
	        actaConDatos = _ref.actaConDatos;
	
	    return _react2.default.createElement(
	        'div',
	        { className: cx("panel-heading", 'panel-heading') },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-stats' }),
	        ' \xA0',
	        publicada ? 'Acta Inventario publicada por ' + publicadaPor + ' el ' + fechaPublicacion : 'Acta Inventario pendiente de publicaci\xF3n',
	        _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            editandoActa ? _react2.default.createElement(
	                'button',
	                { className: cx('btn btn-primary btn-xs', 'opcion-edicion'),
	                    disabled: puedeEditar == false || actaConDatos == false, onClick: context.finalizarEdicion },
	                'Finalizar Edici\xF3n'
	            ) : _react2.default.createElement(
	                'button',
	                { className: cx('btn btn-default btn-xs', 'opcion-edicion'),
	                    disabled: puedeEditar == false || actaConDatos == false, onClick: context.iniciarEdicion },
	                'Editar Acta'
	            ),
	            publicada ? _react2.default.createElement(
	                'button',
	                { className: cx("btn btn-default btn-xs", 'opcion-publicacion'),
	                    disabled: puedeEditar == false || actaConDatos == false, onClick: context.despublicar },
	                'Despublicar'
	            ) : _react2.default.createElement(
	                'button',
	                { className: cx("btn btn-primary btn-xs", 'opcion-publicacion'),
	                    disabled: puedeEditar == false || actaConDatos == false, onClick: context.publicar },
	                'Publicar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: cx("btn btn-default btn-xs", 'opcion-publicacion'),
	                    disabled: puedeEditar == false, onClick: context.reprocesar },
	                'Reprocesar'
	            )
	        )
	    );
	};
	PanelHeading.contextTypes = {
	    iniciarEdicion: _react2.default.PropTypes.func,
	    finalizarEdicion: _react2.default.PropTypes.func,
	    publicar: _react2.default.PropTypes.func,
	    despublicar: _react2.default.PropTypes.func,
	    reprocesar: _react2.default.PropTypes.func
	};
	
	var PanelBody = function PanelBody(_ref2, ctx) {
	    var acta = _ref2.acta,
	        editar = _ref2.editar;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        acta.inv_idInventario ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-3' },
	                ' ',
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('tabla-datos') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'HITOS IMPORTANTES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'fecha_toma\'' },
	                            'Fecha Inventario'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.fechaTomaInventario,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'fechaTomaInventario') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'nombre_empresa\'' },
	                            'Cliente'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.cliente,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'cliente') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'cod_local\'' },
	                            'CECO'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.ceco,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'ceco') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'usuario\'' },
	                            'Supervisor'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.supervisor,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'supervisor') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'administrador\'' },
	                            'QF'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.qf,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'qf') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'captura_uno\'' },
	                            'Inicio Conteo'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.inicioConteo,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'inicioConteo') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'fin_captura\'' },
	                            'Fin Conteo'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.finConteo,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'finConteo') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'fecha_revision_grilla\'' },
	                            'Fin Proceso'
	                        ),
	                        _react2.default.createElement(Texto, { editarCampo: editar, valor: acta.finProceso,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'finProceso') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'DURACI\xD3N'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'Inicio Conteo a Fin Conteo' },
	                            'Duraci\xF3n Conteo'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            acta.duracionConteo
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'Fin Conteo a Fin Proceso' },
	                            'Duraci\xF3n Revisi\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            acta.duracionRevision
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'Inicio Conteo a Fin Proceso' },
	                            'Duraci\xF3n Total Proceso'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            acta.duracionTotalProceso
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-3' },
	                ' ',
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('tabla-datos') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'DOTACIONES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'presupuesto\'' },
	                            'Dotaci\xF3n Presupuestada'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.dotacionPresupuestada,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'dotacionPresupuestada')
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'efectiva\'' },
	                            'Dotaci\xF3n Efectiva'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.dotacionEfectiva,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'dotacionEfectiva') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'UNIDADES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'unidades\'' },
	                            'Unidades Inventariadas'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.unidadesInventariadas,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'unidadesInventariadas') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'teorico_unidades\'' },
	                            'Unidades Teoricas'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.unidadesTeoricas,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'unidadesTeoricas') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'calculo: \'unidades\'-\'teorico_unidades\'' },
	                            'Unidades Diff Neto'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: false, valor: acta.unidadesDiferenciaNeto,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'unidadesDiferenciaNeto') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'diferencia_unid_absoluta\'' },
	                            'Unidades Diff Abs.'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.unidadesDiferenciaAbsoluta,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'unidadesDiferenciaAbsoluta') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'EVALUACIONES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'nota1\'' },
	                            'Nota Presentaci\xF3n'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.notaPresentacion,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'notaPresentacion') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'nota2\'' },
	                            'Nota Supervisor'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.notaSupervisor,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'notaSupervisor') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'nota2\'' },
	                            'Nota Conteo'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.notaConteo,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'notaConteo') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'promedio de nota1, nota2 y nota3' },
	                            'Nota Promedio'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            acta.notaPromedio
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'CONSOLIDADO AUDITORIA'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'aud1\'' },
	                            'Consolidado Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.consolidadoPatentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'consolidadoPatentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'aud3\'' },
	                            'Consolidado Unidades'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.consolidadoUnidades,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'consolidadoUnidades') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'aud2\'' },
	                            'Consolidado \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.consolidadoItems,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'consolidadoItems') })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-3' },
	                ' ',
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('tabla-datos') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'AUDITORIA QF'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'PTT Revisadas QF\' o \'QF Total Patentes\'' },
	                            'Auditoria QF Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaQFPatentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaQFPatentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'QF Total Unidades\'' },
	                            'Auditoria QF Unidades'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaQFUnidades,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaQFUnidades') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'Items Revisadas QF\' o \'QF Total Items' },
	                            'Auditoria QF \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaQFItems,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaQFItems') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'AUDITORIA APOYO 1'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'PTT Rev. Apoyo 1\' o \'A1 Total Patentes\'' },
	                            'Auditoria Apoyo1 Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo1Patentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo1Patentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'A1 Total Unidades\'' },
	                            'Auditoria Apoyo1 Unidades'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo1Unidades,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo1Unidades') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'Items Rev. Apoyo 1\' o \'A1 Total Items\'' },
	                            'Auditoria Apoyo1 \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo1Items,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo1Items') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'AUDITORIA APOYO 2'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'PTT Rev. Apoyo 2\' o \'A2 Total Patentes\'' },
	                            'Auditoria Apoyo2 Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo2Patentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo2Patentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'A2 Total Unidades\'' },
	                            'Auditoria Apoyo2 Unidades'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo2Unidades,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo2Unidades') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'Items Rev. Apoyo 2\' o \'A2 Total Items\'' },
	                            'Auditoria Apoyo2 \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaApoyo2Items,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaApoyo2Items') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'AUDITORIA SUPERVISOR FCV'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'PTT Rev. Sup. FCV\' o \'SUP CV Total Patentes\'' },
	                            'Auditoria Superv. FCV Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaSupervisorPatentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaSupervisorPatentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'SUP CV Total Unidades\'' },
	                            'Auditoria Superv. FCV Unidades'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaSupervisorUnidades,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaSupervisorUnidades') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'SUP CV Total Items\'' },
	                            'Auditoria Superv. FCV \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.auditoriaSupervisorItems,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'auditoriaSupervisorItems') })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-3' },
	                ' ',
	                _react2.default.createElement(
	                    'div',
	                    { className: cx('tabla-datos') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'CORRECCI\xD3N AUDITOR\xCDA'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'aud4\'' },
	                            'Correccion Patentes'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.correccionPatentes,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'correccionPatentes') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'aud5\'' },
	                            'Correccion \xCDtems'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.correccionItems,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'correccionItems') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'Unidades Neto corregido Auditoria\' o \'aud6\'' },
	                            'Correccion Unidades Neto'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.correccionUnidadesNeto,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'correccionUnidadesNeto') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'unid_absoluto_corregido_auditoria\'' },
	                            'Correccion Unidades Abolutas'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.correccionUnidadesAbsolutas,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'correccionUnidadesAbsolutas') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'PORCENTAJE ERROR AUDITORIA'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'(formula....)\'' },
	                            'Porcentaje error SEI'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.porcentajeErrorSEI,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'porcentajeErrorSEI') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'(% Error QF CV)\'' },
	                            'Porcentaje error QF'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.porcentajeErrorQF,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'porcentajeErrorQF') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'VARIACI\xD3N GRILLA'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'% Variacion Ajuste Neto (Grilla)\'' },
	                            'Porcentaje variaci\xF3n'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.porcentajeVariacionGrilla,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'porcentajeVariacionGrilla') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'TOTALES INVENTARIO'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'Cantidad PTT Inventariadas\' o \'tot2\'' },
	                            'Patentes iventariadas'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.patentesInventariadas,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'patentesInventariadas') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'total_items_inventariados\'' },
	                            'Items Totales'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.itemTotalInventariados,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'itemTotalInventariados') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'se procesa desde \'captura inventario estandar punto\'' },
	                            'SKU unicos'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.skuUnicosInventariados,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'skuUnicosInventariados') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-header') },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'PORCENTAJE CUMPLIMIENTO'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'ESTANDAR SEI\'' },
	                            'Est\xE1ndar SEI'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.estandarSEI,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'estandarSEI') })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('tr-datos') },
	                        _react2.default.createElement(
	                            'p',
	                            { className: cx('td-label'), title: 'en acta: \'ESTANDAR CL\'' },
	                            'Est\xE1ndar Cliente'
	                        ),
	                        _react2.default.createElement(Numero, { editarCampo: editar, valor: acta.estandarCliente,
	                            actualizarActa: ctx.actualizarActa.bind(undefined, 'estandarCliente') })
	                    )
	                )
	            )
	        ) : _react2.default.createElement(
	            'div',
	            null,
	            'Sin datos en el acta'
	        )
	    );
	};
	PanelBody.contextTypes = {
	    actualizarActa: _react2.default.PropTypes.func
	};
	
	var Texto = function Texto(_ref3) {
	    var valor = _ref3.valor,
	        editarCampo = _ref3.editarCampo,
	        actualizarActa = _ref3.actualizarActa;
	
	    return editarCampo ? _react2.default.createElement(_InputTexto.InputTexto, {
	        className: cx('td-inputTexto'),
	        asignada: valor,
	        onGuardar: actualizarActa,
	        focusRowAnterior: function focusRowAnterior() {},
	        focusRowSiguiente: function focusRowSiguiente() {},
	        editable: editarCampo
	    }) : _react2.default.createElement(
	        'p',
	        { className: cx('td-dato') },
	        valor
	    );
	};
	var Numero = function Numero(_ref4) {
	    var valor = _ref4.valor,
	        editarCampo = _ref4.editarCampo,
	        actualizarActa = _ref4.actualizarActa;
	
	    return editarCampo ? _react2.default.createElement(_InputNumber.InputNumber, {
	        className: cx('td-inputNumero'),
	        asignada: valor,
	        onGuardar: actualizarActa,
	        focusRowAnterior: function focusRowAnterior() {},
	        focusRowSiguiente: function focusRowSiguiente() {},
	        editable: editarCampo
	    }) : _react2.default.createElement(
	        'p',
	        { className: cx('td-dato') },
	        valor
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelDatosActa.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputTexto = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputs = __webpack_require__(1039);
	
	var css = _interopRequireWildcard(_inputs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Estilos
	
	
	var InputTexto = exports.InputTexto = function (_React$Component) {
	    _inherits(InputTexto, _React$Component);
	
	    function InputTexto(props) {
	        _classCallCheck(this, InputTexto);
	
	        var _this = _possibleConstructorReturn(this, (InputTexto.__proto__ || Object.getPrototypeOf(InputTexto)).call(this, props));
	
	        _this.state = {
	            valor: '',
	            dirty: false,
	            valid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputTexto, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                valor: this.props.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            var valor2 = nextProps.asignada;
	            this.setState({
	                valor: valor2,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                this.props.focusRowAnterior();
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var valorUsuario = evt.target.value;
	            this.setState({
	                valor: valorUsuario,
	                dirty: this.props.asignada != valorUsuario,
	                valid: this.props.validador(valorUsuario)
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputText.focus();
	            this.inputText.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // prioridad del style: valido > dirty > input
	            var classname = this.state.valid ? this.state.dirty ? css.inputDirty : css.input : css.inputInvalido;
	
	            return _react2.default.createElement('input', {
	                className: classname + " " + this.props.className,
	                style: this.props.style,
	                ref: function ref(_ref) {
	                    return _this2.inputText = _ref;
	                },
	                type: 'text',
	                value: this.state.valor,
	                onKeyDown: this.inputOnKeyDown.bind(this),
	                onChange: this.onInputChange.bind(this),
	                onBlur: function onBlur() {
	                    return _this2.props.onGuardar(_this2.state);
	                },
	                onFocus: function onFocus() {
	                    _this2.inputText.select();
	                } // seleccionar el texto cuando se hace focus
	                , disabled: this.props.editable ? '' : 'disabled'
	            });
	        }
	    }]);
	
	    return InputTexto;
	}(_react2.default.Component);
	
	InputTexto.propTypes = {
	    // Objetos
	    editable: _react2.default.PropTypes.bool.isRequired,
	    asignada: _react2.default.PropTypes.string.isRequired,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func.isRequired,
	    focusRowSiguiente: _react2.default.PropTypes.func.isRequired,
	    onGuardar: _react2.default.PropTypes.func.isRequired,
	    validador: _react2.default.PropTypes.func.isRequired
	};
	InputTexto.defaultProps = {
	    editable: false,
	    validador: function validador(texto) {
	        return true;
	    } // por defecto, el texto siempre es valido
	};
	exports.default = InputTexto;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputTexto.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"inputs__input____mJSs","inputDirty":"inputs__inputDirty___8C_J8 inputs__input____mJSs","inputInvalido":"inputs__inputInvalido___3CQMv inputs__input____mJSs"};

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputNumber = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputs = __webpack_require__(1039);
	
	var css = _interopRequireWildcard(_inputs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Estilos
	
	
	var InputNumber = exports.InputNumber = function (_React$Component) {
	    _inherits(InputNumber, _React$Component);
	
	    function InputNumber(props) {
	        _classCallCheck(this, InputNumber);
	
	        var _this = _possibleConstructorReturn(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call(this, props));
	
	        _this.state = {
	            valor: '',
	            dirty: false,
	            valid: true
	        };
	        return _this;
	    }
	
	    _createClass(InputNumber, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                valor: this.props.asignada,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            var valor2 = nextProps.asignada;
	            this.setState({
	                valor: valor2,
	                dirty: false,
	                valid: true
	            });
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.focusRowSiguiente();
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                this.props.focusRowAnterior();
	            }
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(evt) {
	            var valorUsuario = evt.target.value;
	            this.setState({
	                valor: valorUsuario,
	                dirty: this.props.asignada != valorUsuario,
	                valid: this.props.validador(valorUsuario)
	            });
	        }
	    }, {
	        key: 'getEstado',
	        value: function getEstado() {
	            return this.state;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputText.focus();
	            this.inputText.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // prioridad del style: valido > dirty > input
	            var classname = this.state.valid ? this.state.dirty ? css.inputDirty : css.input : css.inputInvalido;
	
	            return _react2.default.createElement('input', {
	                className: classname + " " + this.props.className,
	                style: this.props.style,
	                ref: function ref(_ref) {
	                    return _this2.inputText = _ref;
	                },
	                type: 'number',
	                value: this.state.valor,
	                onKeyDown: this.inputOnKeyDown.bind(this),
	                onChange: this.onInputChange.bind(this),
	                onBlur: function onBlur() {
	                    return _this2.props.onGuardar(_this2.state);
	                },
	                onFocus: function onFocus() {
	                    _this2.inputText.select();
	                } // seleccionar el texto cuando se hace focus
	                , disabled: this.props.editable ? '' : 'disabled'
	            });
	        }
	    }]);
	
	    return InputNumber;
	}(_react2.default.Component);
	
	InputNumber.propTypes = {
	    // Objetos
	    editable: _react2.default.PropTypes.bool.isRequired,
	    asignada: _react2.default.PropTypes.number.isRequired,
	    // Metodos
	    focusRowAnterior: _react2.default.PropTypes.func.isRequired,
	    focusRowSiguiente: _react2.default.PropTypes.func.isRequired,
	    onGuardar: _react2.default.PropTypes.func.isRequired,
	    validador: _react2.default.PropTypes.func.isRequired
	};
	InputNumber.defaultProps = {
	    editable: false,
	    validador: function validador(texto) {
	        return true;
	    } // por defecto, el texto siempre es valido
	};
	exports.default = InputNumber;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputNumber.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel-heading":"PanelDatosActa__panel-heading___Q8Kdp","opcion-edicion":"PanelDatosActa__opcion-edicion___31Hvi","opcion-publicacion":"PanelDatosActa__opcion-publicacion___H9EcF","tabla-datos":"PanelDatosActa__tabla-datos___3CBNX","tr-header":"PanelDatosActa__tr-header___3morD","tr-datos":"PanelDatosActa__tr-datos___19kbF","td-label":"PanelDatosActa__td-label___3INdZ","td-inputTexto":"PanelDatosActa__td-inputTexto___3K1fb","td-inputNumero":"PanelDatosActa__td-inputNumero___1mpga","td-dato":"PanelDatosActa__td-dato___30Woh","opciones-acta":"PanelDatosActa__opciones-acta___4BM-N"};

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ConsolidadosDisponibles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaArchivos = __webpack_require__(1043);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// COMPONENTES
	
	// API
	
	var ConsolidadosDisponibles = exports.ConsolidadosDisponibles = function (_React$Component) {
	    _inherits(ConsolidadosDisponibles, _React$Component);
	
	    function ConsolidadosDisponibles(props) {
	        _classCallCheck(this, ConsolidadosDisponibles);
	
	        var _this = _possibleConstructorReturn(this, (ConsolidadosDisponibles.__proto__ || Object.getPrototypeOf(ConsolidadosDisponibles)).call(this, props));
	
	        _this.state = {
	            mes: _this.props.meses[0]['value'],
	            tipo: _this.props.tipos[0]['value'],
	            archivos: []
	        };
	        _this.buscarArchivos = function () {
	            var mes = _this.state.mes;
	            var tipo = _this.state.tipo;
	            _v2.default.auditorias().getArchivosConsolidados(mes, tipo).then(function (archivos) {
	                _this.setState({ archivos: archivos });
	            });
	        };
	        _this.onSelectMesChanged = function (evt) {
	            _this.setState({
	                mes: evt.target.value
	            }, function () {
	                _this.buscarArchivos();
	            });
	        };
	        _this.onSelectTipoChanged = function (evt) {
	            _this.setState({
	                tipo: evt.target.value
	            }, function () {
	                _this.buscarArchivos();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(ConsolidadosDisponibles, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarArchivos();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectMes',
	                                ref: function ref(_ref) {
	                                    return _this2.inputMes = _ref;
	                                },
	                                value: this.state.mes,
	                                onChange: this.onSelectMesChanged.bind(this) },
	                            '>',
	                            this.props.meses.map(function (mes, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: mes['value'] },
	                                    '' + mes['text']
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Tipo'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectTipo',
	                                ref: function ref(_ref2) {
	                                    return _this2.inputTipo = _ref2;
	                                },
	                                value: this.state.tipo,
	                                onChange: this.onSelectTipoChanged.bind(this) },
	                            '>',
	                            this.props.tipos.map(function (tipo, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: tipo['value'] },
	                                    '' + tipo['text']
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(_TablaArchivos.TablaArchivos, {
	                    archivos: this.state.archivos
	                })
	            );
	        }
	    }]);
	
	    return ConsolidadosDisponibles;
	}(_react2.default.Component);
	
	ConsolidadosDisponibles.propTypes = {
	    meses: PropTypes.arrayOf(PropTypes.object),
	    tipos: PropTypes.arrayOf(PropTypes.arrayOf)
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ConsolidadosDisponibles.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaArchivos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaArchivos = __webpack_require__(1044);
	
	var css = _interopRequireWildcard(_TablaArchivos);
	
	var _RowArchivo = __webpack_require__(1045);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componente
	
	var TablaArchivos = exports.TablaArchivos = function (_React$Component) {
	    _inherits(TablaArchivos, _React$Component);
	
	    function TablaArchivos() {
	        _classCallCheck(this, TablaArchivos);
	
	        return _possibleConstructorReturn(this, (TablaArchivos.__proto__ || Object.getPrototypeOf(TablaArchivos)).apply(this, arguments));
	    }
	
	    _createClass(TablaArchivos, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.archivos.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaArch,
	                    null,
	                    _.range(0, totalInventarios).map(function (index) {
	                        var archivo = _this2.props.archivos[index];
	                        return _react2.default.createElement(_RowArchivo.RowArchivo, {
	                            ref: index,
	                            key: archivo ? archivo.cons_id : index,
	                            archivo: archivo,
	                            correlativo: index + 1
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaArchivos;
	}(_react2.default.Component);
	
	TablaArchivos.propTypes = {};
	var TablaArch = function TablaArch(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Archivos consolidados disponibles'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaArchivos },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombre },
	                        'Archivo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thTipo },
	                        'Tipo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUsuario },
	                        'Subido por'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha subida'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thResultado },
	                        'Resultado'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thBoton },
	                        'Descargar'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaArchivos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tablaArchivos":"TablaArchivos__tablaArchivos___Z6z_B","thCorrelativo":"TablaArchivos__thCorrelativo___1ye3_","thNombre":"TablaArchivos__thNombre___1OPrH","thTipo":"TablaArchivos__thTipo___3GF2h","thUsuario":"TablaArchivos__thUsuario___1VIMf","thFecha":"TablaArchivos__thFecha___1UP2n","thResultado":"TablaArchivos__thResultado___2iDpE","thBoton":"TablaArchivos__thBoton___2UUVa","tdNombre":"TablaArchivos__tdNombre___10x_w","tdTipo":"TablaArchivos__tdTipo___2dJZ9","tdUsuario":"TablaArchivos__tdUsuario___3CWSe","tdFecha":"TablaArchivos__tdFecha___3m4tU","tdResultado":"TablaArchivos__tdResultado___3Wwzd"};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowArchivo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaArchivos = __webpack_require__(1044);
	
	var css = _interopRequireWildcard(_TablaArchivos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	var RowArchivo = exports.RowArchivo = function (_React$Component) {
	    _inherits(RowArchivo, _React$Component);
	
	    function RowArchivo(props) {
	        _classCallCheck(this, RowArchivo);
	
	        var _this = _possibleConstructorReturn(this, (RowArchivo.__proto__ || Object.getPrototypeOf(RowArchivo)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(RowArchivo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNombre },
	                    this.props.archivo.cons_nombreOriginal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTipo },
	                    this.props.archivo.cons_tipo == 1 ? 'IRD' : 'Vencimiento'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUsuario },
	                    this.props.archivo.cons_subidoPor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.archivo.cons_created_at
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdResultado },
	                    this.props.archivo.cons_resultado
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdBoton },
	                    _react2.default.createElement(BotonDescarga, {
	                        idArchivo: this.props.archivo.cons_id
	                    })
	                )
	            );
	        }
	    }]);
	
	    return RowArchivo;
	}(_react2.default.Component);
	
	RowArchivo.propTypes = {
	    archivo: PropTypes.object,
	    correlativo: PropTypes.number
	};
	var BotonDescarga = function BotonDescarga(_ref) {
	    var idArchivo = _ref.idArchivo;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-success pull-right',
	            href: '/archivos/consolidado/' + idArchivo },
	        'Consolidado'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowArchivo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RevisionArchivoFinal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _BlackBoxCapturas = __webpack_require__(1047);
	
	var _BlackBoxCapturas2 = _interopRequireDefault(_BlackBoxCapturas);
	
	var _PanelAuditoria = __webpack_require__(1048);
	
	var _TablaCaptura = __webpack_require__(1050);
	
	var _Modales = __webpack_require__(1052);
	
	var _panelVencimiento = __webpack_require__(1049);
	
	var _PanelAuditoria2 = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria2);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// React Notify
	
	// API
	
	// Componentes
	
	// Formato del Panel Vencimiento (auditor en mayúsculas, rut QF con 'K' final)
	
	// CSS
	
	var cx = _bind2.default.bind(css);
	
	var RevisionArchivoFinal = exports.RevisionArchivoFinal = function (_React$Component) {
	    _inherits(RevisionArchivoFinal, _React$Component);
	
	    function RevisionArchivoFinal(props) {
	        _classCallCheck(this, RevisionArchivoFinal);
	
	        var _this = _possibleConstructorReturn(this, (RevisionArchivoFinal.__proto__ || Object.getPrototypeOf(RevisionArchivoFinal)).call(this, props));
	
	        _this.blackbox = new _BlackBoxCapturas2.default();
	        _this.state = {
	            auditoria: [],
	            capturaIRDFiltrada: [],
	            capturaVencimientoFiltrada: [],
	            capturaNoEncontradosFiltrada: [],
	            listaIRD: [],
	            listaVencimiento: [],
	            listaNoEncontrados: [],
	            filtrosIRD: {},
	            filtrosVencimiento: {},
	            filtrosNoEncontrados: {},
	            error: [],
	            showIRD: false,
	            showVencimiento: false,
	            showNoEncontrados: false,
	            enviando: false,
	            estado_vencimiento: 0,
	            bloqueado: false
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 5 * 1000);
	            };
	        };
	        _this.mostrarIRD = function () {
	            _this.setState({
	                showIRD: true,
	                showVencimiento: false,
	                showNoEncontrados: false
	            }, function () {
	                return _this.getCapturaIRD();
	            });
	        };
	        _this.mostrarVencimiento = function () {
	            _this.setState({
	                showIRD: false,
	                showNoEncontrados: false,
	                showVencimiento: true
	            }, function () {
	                return _this.getCapturaVencimiento();
	            });
	        };
	        _this.mostrarNoEncontrados = function () {
	            if (_this.state.listaNoEncontrados.length > 0) {
	                _this.setState({
	                    showIRD: false,
	                    showNoEncontrados: true,
	                    showVencimiento: false
	                }, function () {
	                    return _this.getCapturaNoEncontrados();
	                });
	            } else {
	                _this.refs.notificator.error("Sin registros", "No hay registros de no encontrados.", 5 * 1000);
	            }
	        };
	        _this.onInputChange = function (actualizado) {
	            _this.setState({ auditoria: Object.assign({}, _this.state.auditoria, actualizado) });
	        };
	
	        _this.onInputChangeVenc = function (actualizado) {
	            _this.setState({ auditoria: _extends({}, _this.state.auditoria, {
	                    panel_venc: Object.assign({}, _this.state.auditoria.panel_venc, actualizado)
	                })
	            });
	        };
	        _this.getCapturaIRD = function () {
	            _this.blackbox.reset();
	            var capturasIRD = _this.state.listaIRD;
	            capturasIRD.forEach(function (captura) {
	                return _this.blackbox.addIRD(captura);
	            });
	            _this.blackbox.ordenarListaIRD();
	            _this.setState(_this.blackbox.getListaFiltradaIRD());
	        };
	        _this.getCapturaVencimiento = function () {
	            _this.blackbox.reset();
	            var capturasVencimiento = _this.state.listaVencimiento;
	            capturasVencimiento.forEach(function (captura) {
	                return _this.blackbox.addVencimiento(captura);
	            });
	            _this.blackbox.ordenarListaVencimiento();
	            _this.setState(_this.blackbox.getListaFiltradaVencimiento());
	        };
	        _this.getCapturaNoEncontrados = function () {
	            _this.blackbox.reset();
	            var capturasNoEncontrados = _this.state.listaNoEncontrados;
	            capturasNoEncontrados.forEach(function (captura) {
	                return _this.blackbox.addNoEncontrado(captura);
	            });
	            _this.blackbox.ordenarListaNoEncontrados();
	            _this.setState(_this.blackbox.getListaFiltradaNoEncontrados());
	        };
	        _this.actualizarFiltroIRD = function (nombreFiltro, filtro) {
	            _this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            _this.setState(_this.blackbox.getListaFiltradaIRD());
	        };
	        _this.actualizarFiltroVencimiento = function (nombreFiltro, filtro) {
	            _this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            _this.setState(_this.blackbox.getListaFiltradaVencimiento());
	        };
	        _this.actualizarFiltroNoEncontrados = function (nombreFiltro, filtro) {
	            _this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            _this.setState(_this.blackbox.getListaFiltradaNoEncontrados());
	        };
	        _this.ordenarListaIRD = function (evt) {
	            evt.preventDefault();
	            _this.blackbox.ordenarListaIRD();
	            _this.setState(_this.blackbox.getListaFiltradaIRD());
	        };
	        _this.ordenarListaVencimiento = function (evt) {
	            evt.preventDefault();
	            _this.blackbox.ordenarListaVencimiento();
	            _this.setState(_this.blackbox.getListaFiltradaVencimiento());
	        };
	        _this.informarResultado = function () {
	            var request = _v2.default.capturasAuditoria(_this.state.auditoria.idAuditoria).informarResultado().then(function (resp) {
	                _this.setState({
	                    auditoria: resp
	                }, function () {
	                    return _this.refs.notificator.success("Auditoria", "Se ha informado correctamente actas pdf por correo.", 5 * 1000);
	                });
	            }).catch(function (err) {
	                _this.ajaxErrorHandler('Error al informar actas pdf por correo.');
	            });
	            return request;
	        };
	        return _this;
	    }
	
	    _createClass(RevisionArchivoFinal, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                actualizaDatosAuditoria: function actualizaDatosAuditoria() {
	                    _this2.setState({ enviando: true });
	                    // El Panel Vencimiento se guarda con el nombre del auditor en mayúsculas y
	                    // el rut QF con la 'K' final en mayúsculas (ver panelVencimiento.js)
	                    var datos = Object.assign({}, _this2.state.auditoria);
	                    if (datos.panel_venc) datos.panel_venc = (0, _panelVencimiento.normalizarPanelVenc)(datos.panel_venc);
	                    var request = _v2.default.capturasAuditoria(datos.idAuditoria).actualizarDatosAuditoria(datos);
	                    request.then(function (auditoria) {
	                        _this2.setState({
	                            auditoria: auditoria,
	                            enviando: false
	                        }, function () {
	                            return _this2.refs.notificator.success("Auditoria", "datos auditoria actualizados.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar auditoria.');
	                        _this2.setState({ enviando: false });
	                    });
	                    return request;
	                },
	                getImagenesReemplazo: function getImagenesReemplazo(idCaptura, sku, lote, fecha_exp) {
	                    var request = _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).buscarImagenRemplazo(idCaptura, sku, lote, fecha_exp);
	                    return request;
	                },
	                reemplazarImagen: function reemplazarImagen(idCapturaVencimientoOriginal, idArchivoImagen) {
	                    var request = _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).postRemplazoImagen(idCapturaVencimientoOriginal, idArchivoImagen);
	
	                    return request;
	                },
	                getVencimientos: function getVencimientos() {
	                    return _this2.blackbox.getListaFiltradaVencimiento().capturaVencimientoFiltrada;
	                },
	                actualizaCapturaVencimiento: function actualizaCapturaVencimiento(captura) {
	                    var request = _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).actualizarVencimiento(captura.idCapturaAuditoriaVencimiento, captura);
	                    request.then(function (resp) {
	                        _this2.blackbox.actualizaCapturaVencimiento(resp);
	                        _this2.blackbox.ordenarListaVencimiento();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento());
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura Vencimiento.');
	                    });
	                    return request;
	                },
	                actualizaCapturaIRD: function actualizaCapturaIRD(captura) {
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).actualizarIRD(captura.idCapturaAuditoriaIrd, captura).then(function (resp) {
	                        _this2.blackbox.actualizaCapturaIRD(resp);
	                        _this2.blackbox.ordenarListaIRD();
	                        _this2.setState(_this2.blackbox.getListaFiltradaIRD());
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura IRD.');
	                    });
	                },
	                actualizarNoEncontrado: function actualizarNoEncontrado(captura) {
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).actualizarNoEncontrado(captura.idCapturaNoEncontrado, captura).then(function (resp) {
	                        _this2.blackbox.actualizaCapturaNoEncontrado(resp);
	                        _this2.blackbox.ordenarListaNoEncontrados();
	                        _this2.setState(_this2.blackbox.getListaFiltradaNoEncontrados());
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura IRD.');
	                    });
	                },
	                //Se devuelve la promesa para que el modal de confirmación de la fila
	                //espere al backend antes de cerrarse (y bloquee el doble click).
	                //La captura IRD no se borra: queda en estado 3 (no válida) y se puede
	                //restaurar con el botón de la misma celda.
	                eliminarCapturaIRD: function eliminarCapturaIRD(idCapturaAuditoriaIrd) {
	                    return _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).eliminarCapturaIRD(idCapturaAuditoriaIrd).then(function (resp) {
	                        _this2.blackbox.actualizaCapturaIRD(resp);
	                        _this2.blackbox.ordenarListaIRD();
	                        _this2.setState(_this2.blackbox.getListaFiltradaIRD(), function () {
	                            return _this2.refs.notificator.info("Auditoria", "captura marcada como no válida.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura IRD.');
	                    });
	                },
	                restaurarCapturaIRD: function restaurarCapturaIRD(idCapturaAuditoriaIrd) {
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).restaurarCapturaIRD(idCapturaAuditoriaIrd).then(function (resp) {
	                        _this2.blackbox.actualizaCapturaIRD(resp);
	                        _this2.blackbox.ordenarListaIRD();
	                        _this2.setState(_this2.blackbox.getListaFiltradaIRD(), function () {
	                            return _this2.refs.notificator.success("Auditoria", "captura marcada como restaurada.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura IRD.');
	                    });
	                },
	                eliminarCapturaVencimiento: function eliminarCapturaVencimiento(idCapturaAuditoriaVencimiento) {
	                    return _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).eliminarCapturaVencimiento(idCapturaAuditoriaVencimiento).then(function (resp) {
	                        _this2.setState({ estado_vencimiento: resp.estado_vencimiento });
	                        _this2.blackbox.actualizaCapturaVencimiento(resp.captura_vencimiento);
	                        _this2.blackbox.ordenarListaVencimiento();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento(), function () {
	                            return _this2.refs.notificator.info("Auditoria", "captura marcada como no válida.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura Vencimiento.');
	                    });
	                },
	                restaurarCapturaVencimiento: function restaurarCapturaVencimiento(idCapturaAuditoriaVencimiento) {
	                    return _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).restaurarCapturaVencimiento(idCapturaAuditoriaVencimiento).then(function (resp) {
	                        _this2.setState({ estado_vencimiento: resp.estado_vencimiento });
	                        _this2.blackbox.actualizaCapturaVencimiento(resp.captura_vencimiento);
	                        _this2.blackbox.ordenarListaVencimiento();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento(), function () {
	                            return _this2.refs.notificator.success("Auditoria", "captura marcada como restaurada.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura Vencimiento.');
	                    });
	                },
	                subirImagenVencimiento: function subirImagenVencimiento(idCapturaAuditoriaVencimiento, file) {
	                    var data = new FormData();
	                    data.append('imagen', file);
	                    var request = _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).subirNuevaImagen(idCapturaAuditoriaVencimiento, data);
	                    return request;
	                },
	                eliminarCaptura: function eliminarCaptura() {
	                    _this2.refs.notificator.info("Auditoria", "eliminando capturas", 5 * 1000);
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).setEliminarCaptura(3).then(function (resp) {
	                        _this2.setState({
	                            estado_vencimiento: resp.estado_vencimiento
	                        });
	                        var capturasVencimiento = resp.captura_vencimiento;
	                        capturasVencimiento.forEach(function (captura) {
	                            return _this2.blackbox.actualizaCapturaVencimiento(captura);
	                        });
	                        _this2.blackbox.ordenarListaVencimiento();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento());
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura.');
	                    });
	                },
	                eliminarCapturaDefinitivo: function eliminarCapturaDefinitivo() {
	                    _this2.refs.notificator.info("Auditoria", "Espere eliminando capturas", 5 * 1000);
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).eliminarCapturasDefinitvo().then(function (resp) {
	                        _this2.blackbox.reset();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento());
	                        _this2.refs.notificator.success("Auditoria", "Capturas eliminadas correctamente.", 5 * 1000);
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.setState({ enviando: false });
	                        _this2.ajaxErrorHandler('Error al publicar auditoria.');
	                    });
	                },
	                restaurarCaptura: function restaurarCaptura() {
	                    _this2.refs.notificator.info("Auditoria", "restaurando capturas", 5 * 1000);
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).setRestaurarCaptura(1).then(function (resp) {
	                        _this2.setState({
	                            estado_vencimiento: resp.estado_vencimiento
	                        });
	                        var capturasVencimiento = resp.captura_vencimiento;
	                        capturasVencimiento.forEach(function (captura) {
	                            return _this2.blackbox.actualizaCapturaVencimiento(captura);
	                        });
	                        _this2.blackbox.ordenarListaVencimiento();
	                        _this2.setState(_this2.blackbox.getListaFiltradaVencimiento());
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura.');
	                    });
	                },
	                publicarAuditoriaVencimiento: function publicarAuditoriaVencimiento() {
	                    _this2.setState({ enviando: true });
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).publicarAuditoriaVencimiento().then(function (resp) {
	                        _this2.setState({
	                            auditoria: resp,
	                            enviando: false
	                        }, function () {
	                            return _this2.refs.notificator.info("Auditoria", "Resultados de vencimiento publicados exitosamente.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.setState({ enviando: false });
	                        _this2.ajaxErrorHandler('Error al publicar auditoria.');
	                    });
	                },
	                publicarAuditoriaIrd: function publicarAuditoriaIrd() {
	                    _this2.setState({ enviando: true });
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).publicarAuditoriaIrd().then(function (resp) {
	                        _this2.setState({
	                            auditoria: resp,
	                            enviando: false
	                        }, function () {
	                            return _this2.refs.notificator.info("Auditoria", "Resultados de ird publicados exitosamente.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.setState({ enviando: false });
	                        _this2.ajaxErrorHandler('Error al publicar auditoria.');
	                    });
	                },
	                publicarAuditoriaNoEncontrados: function publicarAuditoriaNoEncontrados() {
	                    _this2.setState({ enviando: true });
	                    _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).publicarAuditoriaNoEncontrados().then(function (resp) {
	                        _this2.setState({
	                            auditoria: resp,
	                            enviando: false
	                        }, function () {
	                            return _this2.refs.notificator.info("Auditoria", "Resultados de no encontrados publicados exitosamente.", 5 * 1000);
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.setState({ enviando: false });
	                        _this2.ajaxErrorHandler('Error al publicar auditoria.');
	                    });
	                },
	                pegarCapturasVencimiento: function pegarCapturasVencimiento(data) {
	                    var promesasFetch = [];
	                    data.forEach(function (nuevaCaptura) {
	                        promesasFetch.push(_v2.default.auditoria.nuevaCapturaVencimiento(nuevaCaptura));
	                    });
	                    Promise.all(promesasFetch).then(function (capturas) {
	                        _v2.default.capturasAuditoria(_this2.props.idAuditoria).getAuditoria().then(function (resp) {
	                            console.log("correcto");
	                            _this2.setState({
	                                auditoria: resp,
	                                estado_vencimiento: resp.estado_vencimiento,
	                                listaIRD: resp.captura_ird,
	                                listaVencimiento: resp.captura_vencimiento,
	                                listaNoEncontrados: resp.captura_no_encontrado
	                            });
	                            _this2.getCapturaVencimiento();
	                            _this2.refs.notificator.success("Auditoria", "Capturas pegadas correctamente.", 5 * 1000);
	                        }).catch(function (err) {
	                            console.log(err);
	                            _this2.ajaxErrorHandler('Error al cargar auditoria.');
	                        });
	                    }).catch(function (capturas) {
	                        alert('error al buscar la información de los las capturas, (AgregarCapturas desde Excel: fetch todas las capturas correctas)');
	                    });
	                },
	                //Se devuelve la promesa (recarga de la auditoría incluida) para que el
	                //modal de confirmación de la fila espere al backend antes de cerrarse.
	                //Ojo: el backend elimina el registro (no se puede restaurar).
	                eliminarCapturaNoEncontrado: function eliminarCapturaNoEncontrado(idNoEncontrado) {
	                    return _v2.default.capturasAuditoria(_this2.state.auditoria.idAuditoria).eliminarCapturaNoEncontrado(idNoEncontrado).then(function (resp) {
	                        _v2.default.capturasAuditoria(_this2.props.idAuditoria).getAuditoria().then(function (resp) {
	                            console.log("correcto");
	                            _this2.setState({
	                                auditoria: resp,
	                                estado_vencimiento: resp.estado_vencimiento,
	                                listaIRD: resp.captura_ird,
	                                listaVencimiento: resp.captura_vencimiento,
	                                listaNoEncontrados: resp.captura_no_encontrado
	                            });
	                            _this2.getCapturaNoEncontrados();
	                            _this2.refs.notificator.success("Auditoria", "No Encontrado eliminado correctamente.", 5 * 1000);
	                        }).catch(function (err) {
	                            console.log(err);
	                            _this2.ajaxErrorHandler('Error al cargar auditoria.');
	                        });
	                    }).catch(function (err) {
	                        console.log(err);
	                        _this2.ajaxErrorHandler('Error al actualizar captura IRD.');
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            _v2.default.capturasAuditoria(this.props.idAuditoria).getAuditoria().then(function (resp) {
	                _this3.setState({
	                    auditoria: resp,
	                    estado_vencimiento: resp.estado_vencimiento,
	                    listaIRD: resp.captura_ird,
	                    listaVencimiento: resp.captura_vencimiento,
	                    listaNoEncontrados: resp.captura_no_encontrado
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this3.ajaxErrorHandler('Error al cargar auditoria.');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var listaV = this.state.listaVencimiento.length > 0 ? this.state.listaVencimiento.filter(function (ven) {
	                return ven.vencido == 1;
	            }) : [];
	
	            var btnVencimientoClass = cx("btnRevision", {
	                "active": this.state.showVencimiento,
	                "alerta": listaV.length > 0 && !this.state.auditoria.realizada_informada
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-header row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx("col-md-12", 'tituloAuditoria') },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-3", 'divTitulo') },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Auditoria ',
	                                this.state.auditoria.local_cliente,
	                                ': ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    this.state.auditoria.local_ceco
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-8", 'divNavBar') },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: cx("nav nav-pills navbar-right", 'navRevision') },
	                                _react2.default.createElement(
	                                    'li',
	                                    { role: 'presentation', className: cx(this.state.showIRD ? "active" : null, 'btnRevision') },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { onClick: this.mostrarIRD },
	                                        'Revisar IRD'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { role: 'presentation', className: btnVencimientoClass },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { onClick: this.mostrarVencimiento },
	                                        'Revisar Vencimiento'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { role: 'presentation', className: cx(this.state.showNoEncontrados ? "active" : null, 'btnRevision') },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { onClick: this.mostrarNoEncontrados },
	                                        'Revisar No Encontrados'
	                                    )
	                                )
	                            ),
	                            !this.props.fcv ? _react2.default.createElement(BotonInformar, {
	                                estadoInformada: this.state.auditoria.realizada_informada,
	                                onClick: this.informarResultado
	                            }) : null,
	                            listaV.length > 0 && !this.state.auditoria.realizada_informada ? _react2.default.createElement(
	                                'label',
	                                { className: cx('mensajesPendientes') },
	                                'Revisar Vencimiento'
	                            ) : null
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    this.state.showVencimiento || this.state.showNoEncontrados ? _react2.default.createElement(_PanelAuditoria.PanelAuditoria, {
	                        datosAuditoria: this.state.auditoria.panel_venc ? this.state.auditoria.panel_venc : [],
	                        onInputChange: this.onInputChangeVenc,
	                        linkEjecutado: this.state.auditoria.linkEjecutado,
	                        foto_acta: this.state.auditoria.ruta_acta,
	                        title: 'Panel Vencimiento',
	                        esVencimiento: true,
	                        canChange: this.state.auditoria.cambiarImagen,
	                        usuario_android: this.state.auditoria.usuario_android,
	                        fcv: this.props.fcv,
	                        auditoria: this.state.auditoria
	                    }) : _react2.default.createElement(_PanelAuditoria.PanelAuditoria, {
	                        datosAuditoria: this.state.auditoria,
	                        onInputChange: this.onInputChange,
	                        linkEjecutado: this.state.auditoria.linkEjecutado,
	                        foto_acta: this.state.auditoria.ruta_acta,
	                        title: 'Panel IRD',
	                        canChange: this.state.auditoria.cambiarImagen,
	                        usuario_android: this.state.auditoria.usuario_android,
	                        fcv: this.props.fcv
	                    })
	                ),
	                this.state.showIRD && !this.state.enviando ? _react2.default.createElement(_TablaCaptura.TablaIRD, {
	                    filtros: this.state.filtrosIRD,
	                    actualizarFiltro: this.actualizarFiltroIRD.bind(this),
	                    capturaIRDFiltrada: this.state.capturaIRDFiltrada,
	                    revisado: this.state.auditoria.ird_revisado,
	                    fcv: this.props.fcv
	                }) : null,
	                this.state.showVencimiento && !this.state.enviando ? _react2.default.createElement(_TablaCaptura.TablaVencimiento, {
	                    filtros: this.state.filtrosVencimiento,
	                    actualizarFiltro: this.actualizarFiltroVencimiento.bind(this),
	                    capturaVencimientoFiltrada: this.state.capturaVencimientoFiltrada,
	                    estado_vencimiento: this.state.estado_vencimiento,
	                    revisado: this.state.auditoria.vencimiento_revisado,
	                    local: this.state.auditoria.local_ceco,
	                    auditor: this.state.auditoria.auditor,
	                    idArchivoFinalAuditoria: this.state.auditoria.idArchivoFinalAuditoria,
	                    idAuditoria: this.state.auditoria.idAuditoria,
	                    fcv: this.props.fcv
	                }) : null,
	                this.state.showNoEncontrados && !this.state.enviando ? _react2.default.createElement(_TablaCaptura.TablaNoEncontrados, {
	                    filtros: this.state.filtrosNoEncontrados,
	                    actualizarFiltro: this.actualizarFiltroNoEncontrados.bind(this),
	                    capturaNoEncontradosFiltrada: this.state.capturaNoEncontradosFiltrada,
	                    local: this.state.auditoria.local_ceco,
	                    auditor: this.state.auditoria.auditor,
	                    revisado: this.state.auditoria.no_encontrados_revisado,
	                    fcv: this.props.fcv
	                }) : null
	            );
	        }
	    }]);
	
	    return RevisionArchivoFinal;
	}(_react2.default.Component);
	
	RevisionArchivoFinal.childContextTypes = {
	    actualizaDatosAuditoria: PropTypes.func,
	    getImagenesReemplazo: PropTypes.func,
	    reemplazarImagen: PropTypes.func,
	    getVencimientos: PropTypes.func,
	    actualizaCapturaIRD: PropTypes.func,
	    actualizaCapturaVencimiento: PropTypes.func,
	    eliminarCapturaIRD: PropTypes.func,
	    restaurarCapturaIRD: PropTypes.func,
	    eliminarCapturaVencimiento: PropTypes.func,
	    restaurarCapturaVencimiento: PropTypes.func,
	    eliminarCaptura: PropTypes.func,
	    eliminarCapturaDefinitivo: PropTypes.func,
	    restaurarCaptura: PropTypes.func,
	    publicarAuditoriaVencimiento: PropTypes.func,
	    publicarAuditoriaIrd: PropTypes.func,
	    publicarAuditoriaNoEncontrados: PropTypes.func,
	    subirImagenVencimiento: PropTypes.func,
	    actualizarNoEncontrado: PropTypes.func,
	    pegarCapturasVencimiento: PropTypes.func,
	    eliminarCapturaNoEncontrado: PropTypes.func
	};
	var BotonInformar = function BotonInformar(_ref) {
	    var onClick = _ref.onClick,
	        estadoInformada = _ref.estadoInformada;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: cx(estadoInformada ? 'btn btn-md btn-success' : 'btn btn-md btn-warning', 'btnGuardar'), onClick: showModal, disabled: false },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' }),
	                estadoInformada ? ' Informada' : ' Informar Resultados',
	                isVisible && _react2.default.createElement(_Modales.ModalInformarResultado, {
	                    hideModal: hideModal,
	                    onClick: onClick
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RevisionArchivoFinal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var estadoCambio = ['-', 'Sin Cambios', 'Cambios Críticos', 'Cambios Intrascendentes', 'Cambios Aprobados'];
	
	var BlackBoxCapturas = function () {
	    function BlackBoxCapturas() {
	        _classCallCheck(this, BlackBoxCapturas);
	
	        this.listaIRD = [];
	        this.listaVencimiento = [];
	        this.listaNoEncontrados = [];
	        this.filtroCritico = [];
	        this.filtroNoMedible = [];
	        this.filtroSKU = [];
	        this.filtroBarra = [];
	        this.filtroDescriptor = [];
	        this.filtroLaboratorio = [];
	        this.filtroItems = [];
	        this.filtroStock = [];
	        this.filtroDiferencia = [];
	        this.filtroTotalConteo = [];
	        this.filtroMalEnfocado = [];
	        this.filtroLote = [];
	        this.filtroVencido = [];
	        this.filtroVencidoPolitica = [];
	        this.filtroFechaVencimiento = [];
	        this.filtroVendedor = [];
	    }
	
	    _createClass(BlackBoxCapturas, [{
	        key: 'reset',
	        value: function reset() {
	            this.listaIRD = [];
	            this.listaVencimiento = [];
	            this.listaNoEncontrados = [];
	            this.filtroCritico = [];
	            this.filtroNoMedible = [];
	            this.filtroSKU = [];
	            this.filtroBarra = [];
	            this.filtroDescriptor = [];
	            this.filtroLaboratorio = [];
	            this.filtroItems = [];
	            this.filtroStock = [];
	            this.filtroDiferencia = [];
	            this.filtroTotalConteo = [];
	            this.filtroMalEnfocado = [];
	            this.filtroLote = [];
	            this.filtroVencido = [];
	            this.filtroVencidoPolitica = [];
	            this.filtroFechaVencimiento = [];
	            this.filtroVendedor = [];
	        }
	    }, {
	        key: 'addIRD',
	        value: function addIRD(capturaIRD) {
	            this.listaIRD.push(capturaIRD);
	        }
	    }, {
	        key: 'addVencimiento',
	        value: function addVencimiento(capturaVencimiento) {
	            this.listaVencimiento.push(capturaVencimiento);
	        }
	    }, {
	        key: 'addNoEncontrado',
	        value: function addNoEncontrado(capturaNoEncontrado) {
	            this.listaNoEncontrados.push(capturaNoEncontrado);
	        }
	    }, {
	        key: 'removeIRD',
	        value: function removeIRD(idCapturaAuditoriaIrd) {
	            var index = this.listaIRD.findIndex(function (captura) {
	                return captura.idCapturaAuditoriaIrd === idCapturaAuditoriaIrd;
	            });
	            if (index >= 0) this.listaIRD.splice(index, 1);
	        }
	    }, {
	        key: 'removeVencimiento',
	        value: function removeVencimiento(idCapturaAuditoriaVencimiento) {
	            var index = this.listaVencimiento.findIndex(function (captura) {
	                return captura.idCapturaAuditoriaVencimiento === idCapturaAuditoriaVencimiento;
	            });
	            if (index >= 0) this.listaVencimiento.splice(index, 1);
	        }
	    }, {
	        key: 'actualizaCapturaIRD',
	        value: function actualizaCapturaIRD(capturaIRDActualizada) {
	            this.listaIRD = this.listaIRD.map(function (captura) {
	                if (captura.idCapturaAuditoriaIrd == capturaIRDActualizada.idCapturaAuditoriaIrd) {
	                    return capturaIRDActualizada;
	                }
	                return captura;
	            });
	            this.actualizarFiltrosIRD();
	        }
	    }, {
	        key: 'actualizaCapturaVencimiento',
	        value: function actualizaCapturaVencimiento(capturaVencimientoActualizada) {
	            this.listaVencimiento = this.listaVencimiento.map(function (captura) {
	                if (captura.idCapturaAuditoriaVencimiento == capturaVencimientoActualizada.idCapturaAuditoriaVencimiento) {
	                    return capturaVencimientoActualizada;
	                }
	                return captura;
	            });
	            this.actualizarFiltrosVencimiento();
	        }
	    }, {
	        key: 'actualizaCapturaNoEncontrado',
	        value: function actualizaCapturaNoEncontrado(capturaNoEncontradoActualizada) {
	            this.listaNoEncontrados = this.listaNoEncontrados.map(function (captura) {
	                if (captura.idCapturaNoEncontrado == capturaNoEncontradoActualizada.idCapturaNoEncontrado) {
	                    return capturaNoEncontradoActualizada;
	                }
	                return captura;
	            });
	            this.actualizarFiltrosNoEncontrados();
	        }
	    }, {
	        key: 'ordenarListaIRD',
	        value: function ordenarListaIRD() {
	            var porItems = function porItems(captura) {
	                return captura.items;
	            };
	
	            this.listaIRD = _lodash2.default.sortBy(this.listaIRD, porItems);
	        }
	    }, {
	        key: 'ordenarListaVencimiento',
	        value: function ordenarListaVencimiento() {
	            var porItems = function porItems(captura) {
	                return captura.items;
	            };
	
	            this.listaVencimiento = _lodash2.default.sortBy(this.listaVencimiento, porItems);
	        }
	    }, {
	        key: 'ordenarListaNoEncontrados',
	        value: function ordenarListaNoEncontrados() {
	            var porVendedor = function porVendedor(captura) {
	                return captura.cod_vendedor;
	            };
	            var porSku = function porSku(captura) {
	                return captura.sku;
	            };
	            this.listaNoEncontrados = _lodash2.default.orderBy(this.listaNoEncontrados, [porVendedor, porSku], ['asc', 'asc']);
	        }
	    }, {
	        key: 'actualizarFiltrosIRD',
	        value: function actualizarFiltrosIRD() {
	            var _this = this;
	
	            this.filtroCritico = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.critico;
	                var texto = estadoCambio[captura.critico];
	                var opcion = _lodash2.default.find(_this.filtroCritico, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroSKU = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.sku;
	                var texto = captura.sku;
	
	                var opcion = _lodash2.default.find(_this.filtroSKU, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroBarra = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.barra;
	                var texto = captura.barra;
	
	                var opcion = _lodash2.default.find(_this.filtroBarra, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroDescriptor = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.descriptor;
	                var texto = captura.descriptor;
	
	                var opcion = _lodash2.default.find(_this.filtroDescriptor, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroLaboratorio = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.laboratorio;
	                var texto = captura.laboratorio;
	
	                var opcion = _lodash2.default.find(_this.filtroLaboratorio, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroItems = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.items;
	                var texto = captura.items;
	
	                var opcion = _lodash2.default.find(_this.filtroItems, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroStock = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.stock;
	                var texto = captura.stock;
	
	                var opcion = _lodash2.default.find(_this.filtroStock, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroDiferencia = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.diferencia;
	                var texto = captura.diferencia;
	
	                var opcion = _lodash2.default.find(_this.filtroDiferencia, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroTotalConteo = _lodash2.default.chain(this.listaIRD).map(function (captura) {
	                var valor = captura.total_conteo;
	                var texto = captura.total_conteo;
	
	                var opcion = _lodash2.default.find(_this.filtroTotalConteo, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	        }
	    }, {
	        key: 'actualizarFiltrosVencimiento',
	        value: function actualizarFiltrosVencimiento() {
	            var _this2 = this;
	
	            this.filtroCritico = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.critico;
	                var texto = estadoCambio[captura.critico]; //'-- NO ASIGNADO --'
	                var opcion = _lodash2.default.find(_this2.filtroCritico, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroSKU = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.sku;
	                var texto = captura.sku;
	
	                var opcion = _lodash2.default.find(_this2.filtroSKU, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroBarra = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.barra;
	                var texto = captura.barra;
	
	                var opcion = _lodash2.default.find(_this2.filtroBarra, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroDescriptor = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.descriptor;
	                var texto = captura.descriptor;
	
	                var opcion = _lodash2.default.find(_this2.filtroDescriptor, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroLaboratorio = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.laboratorio;
	                var texto = captura.laboratorio;
	
	                var opcion = _lodash2.default.find(_this2.filtroLaboratorio, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroItems = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.items;
	                var texto = captura.items;
	
	                var opcion = _lodash2.default.find(_this2.filtroItems, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroLote = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.lote;
	                var texto = captura.lote;
	
	                var opcion = _lodash2.default.find(_this2.filtroLote, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroVencido = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.vencido;
	                var texto = captura.vencido ? 'Si' : 'No';
	
	                var opcion = _lodash2.default.find(_this2.filtroVencido, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroVencidoPolitica = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.vencido_politica;
	                var texto = captura.vencido_politica ? 'Si' : 'No';
	
	                var opcion = _lodash2.default.find(_this2.filtroVencidoPolitica, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroFechaVencimiento = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.fecha_vencimiento;
	                var texto = captura.fecha_vencimiento;
	
	                var opcion = _lodash2.default.find(_this2.filtroFechaVencimiento, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroMalEnfocado = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.malEnfocado;
	                var texto = captura.malEnfocado ? 'Si' : 'No';
	
	                var opcion = _lodash2.default.find(_this2.filtroMalEnfocado, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroNoMedible = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.noMedible;
	                var texto = captura.noMedible ? 'Si' : 'No';
	
	                var opcion = _lodash2.default.find(_this2.filtroNoMedible, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroVendedor = _lodash2.default.chain(this.listaVencimiento).map(function (captura) {
	                var valor = captura.cod_vendedor;
	                var texto = captura.cod_vendedor;
	
	                var opcion = _lodash2.default.find(_this2.filtroVendedor, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	        }
	    }, {
	        key: 'actualizarFiltrosNoEncontrados',
	        value: function actualizarFiltrosNoEncontrados() {
	            var _this3 = this;
	
	            this.filtroSKU = _lodash2.default.chain(this.listaNoEncontrados).map(function (captura) {
	                var valor = captura.sku;
	                var texto = captura.sku;
	
	                var opcion = _lodash2.default.find(_this3.filtroSKU, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	            this.filtroVendedor = _lodash2.default.chain(this.listaNoEncontrados).map(function (captura) {
	                var valor = captura.cod_vendedor;
	                var texto = captura.cod_vendedor;
	
	                var opcion = _lodash2.default.find(_this3.filtroVendedor, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe');
	            }
	        }
	    }, {
	        key: 'getListaFiltradaIRD',
	        value: function getListaFiltradaIRD() {
	            var _this4 = this;
	
	            this.actualizarFiltrosIRD();
	
	            return {
	                capturaIRDFiltrada: _lodash2.default.chain(this.listaIRD).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroCritico, { 'valor': captura.critico, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroSKU, { 'valor': captura.sku, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroBarra, { 'valor': captura.barra, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroDescriptor, { 'valor': captura.descriptor, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroLaboratorio, { 'valor': captura.laboratorio, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroItems, { 'valor': captura.items, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroStock, { 'valor': captura.stock, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroDiferencia, { 'valor': captura.diferencia, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this4.filtroTotalConteo, { 'valor': captura.total_conteo, 'seleccionado': true });
	                }).value(),
	                filtrosIRD: {
	                    filtroCritico: this.filtroCritico,
	                    filtroSKU: this.filtroSKU,
	                    filtroBarra: this.filtroBarra,
	                    filtroDescriptor: this.filtroDescriptor,
	                    filtroLaboratorio: this.filtroLaboratorio,
	                    filtroItems: this.filtroItems,
	                    filtroStock: this.filtroStock,
	                    filtroDiferencia: this.filtroDiferencia,
	                    filtroTotalConteo: this.filtroTotalConteo
	                },
	                listaIRD: this.listaIRD
	            };
	        }
	    }, {
	        key: 'getListaFiltradaVencimiento',
	        value: function getListaFiltradaVencimiento() {
	            var _this5 = this;
	
	            this.actualizarFiltrosVencimiento();
	
	            return {
	                capturaVencimientoFiltrada: _lodash2.default.chain(this.listaVencimiento).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroCritico, { 'valor': captura.critico, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroSKU, { 'valor': captura.sku, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroBarra, { 'valor': captura.barra, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroDescriptor, { 'valor': captura.descriptor, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroLaboratorio, { 'valor': captura.laboratorio, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroItems, { 'valor': captura.items, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroLote, { 'valor': captura.lote, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroVencido, { 'valor': captura.vencido, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroVencidoPolitica, { 'valor': captura.vencido_politica, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroFechaVencimiento, { 'valor': captura.fecha_vencimiento, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroMalEnfocado, { 'valor': captura.malEnfocado, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroNoMedible, { 'valor': captura.noMedible, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this5.filtroVendedor, { 'valor': captura.cod_vendedor, 'seleccionado': true });
	                }).value(),
	                filtrosVencimiento: {
	                    filtroCritico: this.filtroCritico,
	                    filtroSKU: this.filtroSKU,
	                    filtroBarra: this.filtroBarra,
	                    filtroDescriptor: this.filtroDescriptor,
	                    filtroLaboratorio: this.filtroLaboratorio,
	                    filtroItems: this.filtroItems,
	                    filtroLote: this.filtroLote,
	                    filtroVencido: this.filtroVencido,
	                    filtroVencidoPolitica: this.filtroVencidoPolitica,
	                    filtroFechaVencimiento: this.filtroFechaVencimiento,
	                    filtroMalEnfocado: this.filtroMalEnfocado,
	                    filtroNoMedible: this.filtroNoMedible,
	                    filtroVendedor: this.filtroVendedor
	                },
	                listaVencimiento: this.listaVencimiento
	            };
	        }
	    }, {
	        key: 'getListaFiltradaNoEncontrados',
	        value: function getListaFiltradaNoEncontrados() {
	            var _this6 = this;
	
	            this.actualizarFiltrosNoEncontrados();
	            return {
	                capturaNoEncontradosFiltrada: _lodash2.default.chain(this.listaNoEncontrados).filter(function (captura) {
	                    return _lodash2.default.find(_this6.filtroSKU, { 'valor': captura.sku, 'seleccionado': true });
	                }).filter(function (captura) {
	                    return _lodash2.default.find(_this6.filtroVendedor, { 'valor': captura.cod_vendedor, 'seleccionado': true });
	                }).value(),
	                filtrosNoEncontrados: {
	                    filtroSKU: this.filtroSKU,
	                    filtroVendedor: this.filtroVendedor
	                },
	                listaNoEncontrados: this.listaNoEncontrados
	            };
	        }
	    }]);
	
	    return BlackBoxCapturas;
	}();
	
	exports.default = BlackBoxCapturas;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxCapturas.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelAuditoria = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _panelVencimiento = __webpack_require__(1049);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	//Componentes
	
	// Formato del Panel Vencimiento: auditor en mayúsculas y rut QF con 'K' final
	
	var cx = _bind2.default.bind(css);
	
	var PanelAuditoria = exports.PanelAuditoria = function (_React$Component) {
	    _inherits(PanelAuditoria, _React$Component);
	
	    function PanelAuditoria(props) {
	        _classCallCheck(this, PanelAuditoria);
	
	        var _this = _possibleConstructorReturn(this, (PanelAuditoria.__proto__ || Object.getPrototypeOf(PanelAuditoria)).call(this, props));
	
	        _this.state = {
	            error: [],
	            enviando: false,
	            fotoCambio: '',
	            cambiada: false
	        };
	        _this.onInputChange = function (key, evt) {
	            var actualizado = {};
	            // En el Panel Vencimiento el auditor y el rut QF se guardan ya normalizados
	            // (ver panelVencimiento.js). En el Panel IRD se conserva el valor tal cual.
	            actualizado[key] = _this.props.esVencimiento ? (0, _panelVencimiento.normalizarCampoPanelVenc)(key, evt.target.value) : evt.target.value;
	            _this.props.onInputChange(actualizado);
	        };
	        _this.guardarRevision = function () {
	            _this.setState({ enviando: true });
	            _this.context.actualizaDatosAuditoria().then(function () {
	                _this.setState({
	                    enviando: false
	                });
	            }).catch(function (err) {
	                console.log(err);
	                _this.setState({ enviando: false });
	            });
	        };
	        _this.onChangeImage = function (e) {
	            _this.setState({
	                fotoCambio: e.target.files[0]
	            }, function () {
	                return _this.cambiarImagen(_this.props.datosAuditoria.idAuditoria, _this.state.fotoCambio);
	            });
	        };
	        _this.cambiarImagen = function (idAuditoria, file) {
	            var data = new FormData();
	            data.append('imagen', file);
	            _v2.default.capturasAuditoria(idAuditoria).cambiarImagen(data).then(function (response) {
	                console.log(response);
	                _this.setState({
	                    cambiada: true
	                });
	            }).catch(function (error) {
	                console.log(error);
	            });
	        };
	        _this.handleRecharge = function () {
	            window.location.reload();
	        };
	        return _this;
	    }
	
	    _createClass(PanelAuditoria, [{
	        key: 'render',
	        value: function render() {
	            var uniqueTime = new Date().getTime();
	            // El Panel Vencimiento muestra el nombre del auditor siempre en mayúsculas y
	            // el rut QF con el dígito verificador 'k' en mayúsculas (ver panelVencimiento.js)
	            var esVencimiento = !!this.props.esVencimiento;
	            var auditor = this.props.datosAuditoria.auditor;
	            var rutQf = this.props.datosAuditoria.rut_qf;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        this.props.title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body form-horizontal' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'camposPanel') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Fecha Captura:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement('input', { type: 'date', className: 'form-control', placeholder: 'Fecha Captura', disabled: this.state.enviando || this.props.fcv,
	                                    value: this.props.datosAuditoria.fecha_captura || '', onChange: this.onInputChange.bind(this, 'fecha_captura')
	                                }),
	                                this.state.error.fecha_captura && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.fecha_captura[0]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-1 control-label' },
	                                'Rut Aud:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Rut Auditor', disabled: this.state.enviando || this.props.fcv,
	                                    value: this.props.datosAuditoria.rut_auditor || '', onChange: this.onInputChange.bind(this, 'rut_auditor')
	                                }),
	                                this.state.error.rut_auditor && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.rut_auditor[0]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Auditor:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Auditor', disabled: this.state.enviando || this.props.fcv,
	                                    value: (esVencimiento ? (0, _panelVencimiento.normalizarNombreAuditor)(auditor) : auditor) || '', onChange: this.onInputChange.bind(this, 'auditor')
	                                }),
	                                this.state.error.auditor && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.auditor[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'camposPanel') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Ceco:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: css.localCeco },
	                                    this.props.esVencimiento ? this.props.auditoria.local_ceco : this.props.datosAuditoria.local_ceco
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-1 control-label' },
	                                'Rut QF:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Rut QF', disabled: this.state.enviando || this.props.fcv
	                                    // onBlur={this.guardarRevision}
	                                    , value: (esVencimiento ? (0, _panelVencimiento.normalizarRutQf)(rutQf) : rutQf) || '', onChange: this.onInputChange.bind(this, 'rut_qf')
	                                }),
	                                this.state.error.rut_qf && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.rut_qf[0]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'QF:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'QF', disabled: this.state.enviando || this.props.fcv,
	                                    value: this.props.datosAuditoria.qf || '', onChange: this.onInputChange.bind(this, 'qf')
	                                }),
	                                this.state.error.qf && _react2.default.createElement(
	                                    'span',
	                                    { className: cx('form__error-message') },
	                                    this.state.error.qf[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'accionesCentradas') },
	                            _react2.default.createElement('div', { className: cx('accionLado') }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx('accionGrupo') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('accionCentrada') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'control-label' },
	                                        'ANDROID'
	                                    ),
	                                    _react2.default.createElement('span', { className: this.props.usuario_android ? "glyphicon glyphicon-phone " + css.android_pda : "glyphicon glyphicon-phone " + css.noandroid_pda })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('accionCentrada') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'control-label' },
	                                        'Acta:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: css.tooltipInicio },
	                                        _react2.default.createElement('span', { className: "glyphicon glyphicon-eye-open " + css.linkEjecutado }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: css.tooltiptextInicio },
	                                            this.props.foto_acta ? _react2.default.createElement('img', { src: this.props.foto_acta + '?v=' + uniqueTime, className: css.imagenStock }) : null
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx('accionLado', 'accionLadoDerecho') },
	                                !this.props.fcv ? _react2.default.createElement(
	                                    'button',
	                                    { className: cx("btn btn-md btn-primary", 'btnGuardar'), onClick: this.guardarRevision, disabled: this.state.enviando },
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-floppy-disk', 'aria-hidden': 'true' }),
	                                    ' Guardar'
	                                ) : null
	                            )
	                        ),
	                        this.props.canChange ? _react2.default.createElement(
	                            'div',
	                            { className: cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'div-option-file', 'camposPanel') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Imagen:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: cx('btn btn-success', 'btn-file'), title: 'Cambiar Imagen' },
	                                    _react2.default.createElement('span', { className: "glyphicon glyphicon-picture" }),
	                                    _react2.default.createElement('input', { type: 'file', accept: 'image/*', onChange: this.onChangeImage })
	                                )
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PanelAuditoria;
	}(_react2.default.Component);
	
	PanelAuditoria.contextTypes = {
	    actualizaDatosAuditoria: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PanelAuditoria.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* Normalización de los campos de texto del Panel Vencimiento (auditorías de
	 * vencimiento).
	 *
	 * Reglas de operación:
	 *  - Nombre del auditor: siempre en mayúsculas.
	 *  - Rut QF: si termina en 'k', el dígito verificador se muestra en mayúsculas ('K').
	 *
	 * Aplica sólo al panel de Vencimiento (title "Panel Vencimiento", datos
	 * `auditoria.panel_venc`); el Panel IRD conserva el valor tal como se ingresa.
	 */
	
	// null/undefined => '' para que los inputs controlados nunca reciban undefined
	var aTexto = function aTexto(valor) {
	    return valor === null || valor === undefined ? '' : String(valor);
	};
	
	// 'Juan Pérez' => 'JUAN PÉREZ'
	var normalizarNombreAuditor = exports.normalizarNombreAuditor = function normalizarNombreAuditor(valor) {
	    return aTexto(valor).toUpperCase();
	};
	
	// '12345678-k' => '12345678-K' (si no termina en k se devuelve sin cambios)
	var normalizarRutQf = exports.normalizarRutQf = function normalizarRutQf(valor) {
	    var rut = aTexto(valor);
	    return (/k$/i.test(rut) ? rut.slice(0, -1) + 'K' : rut
	    );
	};
	
	// Normaliza el campo que se está editando en el Panel Vencimiento
	var normalizarCampoPanelVenc = exports.normalizarCampoPanelVenc = function normalizarCampoPanelVenc(campo, valor) {
	    if (campo === 'auditor') return normalizarNombreAuditor(valor);
	    if (campo === 'rut_qf') return normalizarRutQf(valor);
	    return valor;
	};
	
	// {auditor, rut_qf, ...} => copia con los campos normalizados (no muta el original)
	var normalizarPanelVenc = exports.normalizarPanelVenc = function normalizarPanelVenc(panel) {
	    if (!panel) return panel;
	    var normalizado = Object.assign({}, panel);
	    if (normalizado.auditor !== undefined) normalizado.auditor = normalizarNombreAuditor(normalizado.auditor);
	    if (normalizado.rut_qf !== undefined) normalizado.rut_qf = normalizarRutQf(normalizado.rut_qf);
	    return normalizado;
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "panelVencimiento.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaNoEncontrados = exports.TablaVencimiento = exports.TablaIRD = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _RowCaptura = __webpack_require__(1051);
	
	var _FormularioAgregarCapturas = __webpack_require__(1058);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	var TablaIRD = exports.TablaIRD = function (_React$Component) {
	    _inherits(TablaIRD, _React$Component);
	
	    function TablaIRD(props) {
	        _classCallCheck(this, TablaIRD);
	
	        var _this = _possibleConstructorReturn(this, (TablaIRD.__proto__ || Object.getPrototypeOf(TablaIRD)).call(this, props));
	
	        _this.state = {};
	        _this.publicarAuditoriaIrd = function () {
	            _this.context.publicarAuditoriaIrd();
	        };
	        return _this;
	    }
	
	    _createClass(TablaIRD, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalCapturas = this.props.capturaIRDFiltrada.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Captura IRD'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-1' },
	                        !this.props.fcv ? _react2.default.createElement(
	                            'button',
	                            { className: this.props.revisado ? "btn btn-xs btn-danger " + css.btnPublicar : "btn btn-xs btn-success " + css.btnPublicar,
	                                onClick: this.publicarAuditoriaIrd
	                            },
	                            _react2.default.createElement('span', { className: this.props.revisado ? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file" }),
	                            this.props.revisado ? " Despublicar" : " Publicar"
	                        ) : null
	                    )
	                ),
	                _react2.default.createElement(
	                    TablaCapturaIRD,
	                    {
	                        filtros: this.props.filtros,
	                        actualizarFiltro: this.props.actualizarFiltro
	                    },
	                    _.range(0, totalCapturas).map(function (index) {
	                        var capturaIRD = _this2.props.capturaIRDFiltrada[index];
	                        return _react2.default.createElement(_RowCaptura.RowIRD, {
	                            key: index,
	                            index: index,
	                            capturaIRD: capturaIRD,
	                            fcv: _this2.props.fcv
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaIRD;
	}(_react2.default.Component);
	
	TablaIRD.contextTypes = {
	    publicarAuditoriaIrd: PropTypes.func
	};
	var TablaCapturaIRD = function TablaCapturaIRD(_ref) {
	    var filtros = _ref.filtros,
	        actualizarFiltro = _ref.actualizarFiltro,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-bordered table-condensed " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colModificaciones }),
	            _react2.default.createElement('col', { className: css.colSku }),
	            _react2.default.createElement('col', { className: css.colBarra }),
	            _react2.default.createElement('col', { className: css.colDescriptor }),
	            _react2.default.createElement('col', { className: css.colLaboratorio }),
	            _react2.default.createElement('col', { className: css.colItems }),
	            _react2.default.createElement('col', { className: css.colTotalConteo }),
	            _react2.default.createElement('col', { className: css.colTotalConteo }),
	            _react2.default.createElement('col', { className: css.colStock }),
	            _react2.default.createElement('col', { className: css.colStock }),
	            _react2.default.createElement('col', { className: css.colTeorico }),
	            _react2.default.createElement('col', { className: css.colSinRespaldo }),
	            _react2.default.createElement('col', { className: css.colEliminar })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thModificaciones },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: '',
	                        filtro: filtros.filtroCritico || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroCritico')
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thSku },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'SKU',
	                        filtro: filtros.filtroSKU || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroSKU'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thBarra },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Barra',
	                        filtro: filtros.filtroBarra || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroBarra'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDescriptor },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Descriptor',
	                        filtro: filtros.filtroDescriptor || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroDescriptor'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLaboratorio },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Laboratorio',
	                        filtro: filtros.filtroLaboratorio || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroLaboratorio'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thItems },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Items',
	                        filtro: filtros.filtroItems || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroItems'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTotalConteo },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'F\xEDsico',
	                        filtro: filtros.filtroTotalConteo || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroTotalConteo'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTotalConteo },
	                    'Link'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thStock },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Pantalla',
	                        filtro: filtros.filtroStock || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroStock'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thStock },
	                    'Pantalla'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTeorico },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Dif.',
	                        filtro: filtros.filtroDiferencia || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroDiferencia'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thSinRespaldo },
	                    'Sin Respaldo'
	                ),
	                _react2.default.createElement('th', { className: css.thEliminar })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	var TablaVencimiento = exports.TablaVencimiento = function (_React$Component2) {
	    _inherits(TablaVencimiento, _React$Component2);
	
	    function TablaVencimiento(props) {
	        _classCallCheck(this, TablaVencimiento);
	
	        var _this3 = _possibleConstructorReturn(this, (TablaVencimiento.__proto__ || Object.getPrototypeOf(TablaVencimiento)).call(this, props));
	
	        _this3.state = {};
	        _this3.eliminarCaptura = function () {
	            _this3.context.eliminarCaptura();
	        };
	        _this3.eliminarCapturaDefinitivo = function () {
	            _this3.context.eliminarCapturaDefinitivo();
	        };
	        _this3.restaurarCaptura = function () {
	            _this3.context.restaurarCaptura();
	        };
	        _this3.publicarAuditoriaVencimiento = function () {
	            _this3.context.publicarAuditoriaVencimiento();
	        };
	        return _this3;
	    }
	
	    _createClass(TablaVencimiento, [{
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var totalCapturas = this.props.capturaVencimientoFiltrada.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Captura Vencimiento'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-1' },
	                        !this.props.fcv ? _react2.default.createElement(
	                            'button',
	                            { className: this.props.revisado ? "btn btn-xs btn-danger " + css.btnPublicar : "btn btn-xs btn-success " + css.btnPublicar,
	                                onClick: this.publicarAuditoriaVencimiento
	                            },
	                            _react2.default.createElement('span', { className: this.props.revisado ? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file" }),
	                            this.props.revisado ? " Despublicar" : " Publicar"
	                        ) : null
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    !this.props.fcv ? _react2.default.createElement(
	                        'button',
	                        { className: "btn btn-xs btn-info pull-right " + css.btnEstadosCaptura, onClick: this.restaurarCaptura, disabled: this.props.estado_vencimiento === 1 },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-share-alt " + css.iconoEspejo }),
	                        ' Restaurar Todas'
	                    ) : null,
	                    !this.props.fcv ? _react2.default.createElement(
	                        'button',
	                        { className: "btn btn-xs btn-warning pull-right " + css.btnEstadosCaptura, onClick: this.eliminarCaptura, disabled: this.props.estado_vencimiento === 3 },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ban-circle' }),
	                        ' Deshabilitar Todas'
	                    ) : null,
	                    !this.props.fcv ? _react2.default.createElement(
	                        'button',
	                        { className: "btn btn-xs btn-danger pull-right " + css.btnEstadosCaptura, onClick: this.eliminarCapturaDefinitivo, disabled: true },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                        ' Eliminar Todas'
	                    ) : null,
	                    !this.props.fcv ? _react2.default.createElement(_FormularioAgregarCapturas.FormularioAgregarCapturas, {
	                        puedeAgregar: true,
	                        idAuditoria: this.props.idAuditoria,
	                        idArchivoFinalAuditoria: this.props.idArchivoFinalAuditoria
	                    }) : null
	                ),
	                _react2.default.createElement(
	                    TablaCapturaVencimiento,
	                    {
	                        filtros: this.props.filtros,
	                        actualizarFiltro: this.props.actualizarFiltro
	                    },
	                    _.range(0, totalCapturas).map(function (index) {
	                        var capturaVencimiento = _this4.props.capturaVencimientoFiltrada[index];
	                        return _react2.default.createElement(_RowCaptura.RowVencimiento, {
	                            key: index,
	                            index: index,
	                            capturaVencimiento: capturaVencimiento,
	                            local: _this4.props.local,
	                            auditor: _this4.props.auditor,
	                            fcv: _this4.props.fcv
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaVencimiento;
	}(_react2.default.Component);
	
	TablaVencimiento.contextTypes = {
	    eliminarCaptura: PropTypes.func,
	    eliminarCapturaDefinitivo: PropTypes.func,
	    restaurarCaptura: PropTypes.func,
	    publicarAuditoriaVencimiento: PropTypes.func,
	    pegarCapturasVencimiento: PropTypes.func
	};
	var TablaCapturaVencimiento = function TablaCapturaVencimiento(_ref2) {
	    var filtros = _ref2.filtros,
	        actualizarFiltro = _ref2.actualizarFiltro,
	        children = _ref2.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-bordered table-condensed " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colModificaciones }),
	            _react2.default.createElement('col', { className: css.colSku }),
	            _react2.default.createElement('col', { className: css.colBarra }),
	            _react2.default.createElement('col', { className: css.colDescriptor }),
	            _react2.default.createElement('col', { className: css.colLaboratorio }),
	            _react2.default.createElement('col', { className: css.colVendedor }),
	            _react2.default.createElement('col', { className: css.colItems }),
	            _react2.default.createElement('col', { className: css.colLote }),
	            _react2.default.createElement('col', { className: css.colFechExp }),
	            _react2.default.createElement('col', { className: css.colVencido }),
	            _react2.default.createElement('col', { className: css.colPolitica }),
	            _react2.default.createElement('col', { className: css.colMalEnfocado }),
	            _react2.default.createElement('col', { className: css.colMalEnfocado }),
	            _react2.default.createElement('col', { className: css.colImagen }),
	            _react2.default.createElement('col', { className: css.colEliminar })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thModificaciones },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: '',
	                        filtro: filtros.filtroCritico || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroCritico')
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thSku },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'SKU',
	                        filtro: filtros.filtroSKU || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroSKU'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thBarra },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Barra',
	                        filtro: filtros.filtroBarra || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroBarra'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDescriptor },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Descriptor',
	                        filtro: filtros.filtroDescriptor || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroDescriptor'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLaboratorio },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Laboratorio',
	                        filtro: filtros.filtroLaboratorio || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroLaboratorio'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thVendedor },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Vendedor',
	                        filtro: filtros.filtroVendedor || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroVendedor'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thItems },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Items',
	                        filtro: filtros.filtroItems || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroItems'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLote },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Lote',
	                        filtro: filtros.filtroLote || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroLote'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thFechExp },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Fecha. Venc.',
	                        filtro: filtros.filtroFechaVencimiento || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroFechaVencimiento'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thVencido },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Venc.',
	                        filtro: filtros.filtroVencido || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroVencido'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thPolitica },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Pol.',
	                        filtro: filtros.filtroVencidoPolitica || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroVencidoPolitica'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thMalEnfocado },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'SR',
	                        filtro: filtros.filtroMalEnfocado || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroMalEnfocado'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thMalEnfocado },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'SV',
	                        filtro: filtros.filtroNoMedible || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroNoMedible'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thImagen },
	                    'Ver'
	                ),
	                _react2.default.createElement('th', { className: css.thEliminar })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	var TablaNoEncontrados = exports.TablaNoEncontrados = function (_React$Component3) {
	    _inherits(TablaNoEncontrados, _React$Component3);
	
	    function TablaNoEncontrados(props) {
	        _classCallCheck(this, TablaNoEncontrados);
	
	        var _this5 = _possibleConstructorReturn(this, (TablaNoEncontrados.__proto__ || Object.getPrototypeOf(TablaNoEncontrados)).call(this, props));
	
	        _this5.state = {};
	        _this5.publicarAuditoriaNoEncontrados = function () {
	            _this5.context.publicarAuditoriaNoEncontrados();
	        };
	        return _this5;
	    }
	
	    _createClass(TablaNoEncontrados, [{
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var totalCapturas = this.props.capturaNoEncontradosFiltrada.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-9' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Productos NO encontrados en auditor\xEDa vencimiento'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-1' },
	                        !this.props.fcv ? _react2.default.createElement(
	                            'button',
	                            { className: this.props.revisado ? "btn btn-xs btn-danger " + css.btnPublicar : "btn btn-xs btn-success " + css.btnPublicar,
	                                onClick: this.publicarAuditoriaNoEncontrados
	                            },
	                            _react2.default.createElement('span', { className: this.props.revisado ? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file" }),
	                            this.props.revisado ? " Despublicar" : " Publicar"
	                        ) : null
	                    )
	                ),
	                _react2.default.createElement(
	                    TablaCapturaNoEncontrados,
	                    {
	                        filtros: this.props.filtros,
	                        actualizarFiltro: this.props.actualizarFiltro
	                    },
	                    _.range(0, totalCapturas).map(function (index) {
	                        var capturaNoEncontrado = _this6.props.capturaNoEncontradosFiltrada[index];
	                        return _react2.default.createElement(_RowCaptura.RowNoEncontrado, {
	                            key: index,
	                            index: index,
	                            capturaNoEncontrado: capturaNoEncontrado,
	                            local: _this6.props.local,
	                            auditor: _this6.props.auditor,
	                            fcv: _this6.props.fcv
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaNoEncontrados;
	}(_react2.default.Component);
	
	TablaNoEncontrados.contextTypes = {
	    eliminarCaptura: PropTypes.func,
	    restaurarCaptura: PropTypes.func,
	    publicarAuditoriaNoEncontrados: PropTypes.func
	};
	var TablaCapturaNoEncontrados = function TablaCapturaNoEncontrados(_ref3) {
	    var filtros = _ref3.filtros,
	        actualizarFiltro = _ref3.actualizarFiltro,
	        children = _ref3.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-bordered table-condensed " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colModificaciones }),
	            _react2.default.createElement('col', { className: css.colSku }),
	            _react2.default.createElement('col', { className: css.colDescriptor }),
	            _react2.default.createElement('col', { className: css.colLaboratorio }),
	            _react2.default.createElement('col', { className: css.colSku }),
	            _react2.default.createElement('col', { className: css.colVencido }),
	            _react2.default.createElement('col', { className: css.colStockNo }),
	            _react2.default.createElement('col', { className: css.colImagen }),
	            _react2.default.createElement('col', { className: css.colBorrosa }),
	            _react2.default.createElement('col', { className: css.colEliminar })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement('th', { className: css.thModificaciones }),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thSku },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'SKU',
	                        filtro: filtros.filtroSKU || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroSKU'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDescriptor },
	                    'Descriptor'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLaboratorio },
	                    'Laboratorio'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thSku },
	                    _react2.default.createElement(_HeaderConFiltro2.default, {
	                        nombre: 'Vendedor',
	                        filtro: filtros.filtroVendedor || [],
	                        actualizarFiltro: actualizarFiltro.bind(undefined, 'filtroVendedor'),
	                        busquedaExacta: true
	                    })
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thVencido },
	                    'Estado'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thStockNo },
	                    'Stock'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thImagen },
	                    'Ver'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thBorrosa },
	                    'Desenfocada'
	                ),
	                _react2.default.createElement('th', { className: css.thEliminar })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaCaptura.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowNoEncontrado = exports.RowVencimiento = exports.RowIRD = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelAuditoria = __webpack_require__(962);
	
	var css = _interopRequireWildcard(_PanelAuditoria);
	
	var _Modales = __webpack_require__(1052);
	
	var _fechasVencimiento = __webpack_require__(1057);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowIRD = exports.RowIRD = function (_React$Component) {
	    _inherits(RowIRD, _React$Component);
	
	    function RowIRD(props) {
	        _classCallCheck(this, RowIRD);
	
	        var _this = _possibleConstructorReturn(this, (RowIRD.__proto__ || Object.getPrototypeOf(RowIRD)).call(this, props));
	
	        _this.state = {
	            capturaIRD: _this.props.capturaIRD
	        };
	        _this.onInputChange = function (key) {
	            var actualizado = _this.props.capturaIRD;
	            actualizado[key] = _this.inputTotalConteo.value;
	            actualizado['editado'] = 1;
	            _this.setState({ capturaIRD: Object.assign({}, _this.state.capturaIRD, actualizado) });
	        };
	        _this.onInputChangeFisico = function (key) {
	            var actualizado = _this.props.capturaIRD;
	            actualizado[key] = _this.inputTotalFisico.value;
	            actualizado['editado'] = 1;
	            _this.setState({ capturaIRD: Object.assign({}, _this.state.capturaIRD, actualizado) });
	        };
	        _this.onInputChangeStock = function (key) {
	            var actualizado = _this.props.capturaIRD;
	            actualizado[key] = _this.inputTotalStock.value;
	            actualizado['editado'] = 1;
	            _this.setState({ capturaIRD: Object.assign({}, _this.state.capturaIRD, actualizado) });
	        };
	        _this.cambioCheckbox = function (evt) {
	            var actualizado = {};
	            var estado = evt.target.checked;
	            actualizado['malEnfocado'] = estado;
	            actualizado['editado'] = 1;
	            _this.setState({ capturaIRD: Object.assign({}, _this.state.capturaIRD, actualizado) }, function () {
	                return _this.guardaCaptura();
	            });
	        };
	        _this.guardaCaptura = function (key) {
	            if (_this.state.capturaIRD.editado) _this.context.actualizaCapturaIRD(_this.state.capturaIRD);
	        };
	        //Devuelve la promesa para que el modal de confirmación de la fila espere
	        //la respuesta del backend antes de cerrarse (y bloquee el doble click).
	        _this.eliminarCapturaIRD = function () {
	            return _this.context.eliminarCapturaIRD(_this.props.capturaIRD.idCapturaAuditoriaIrd);
	        };
	        _this.restaurarCaptura = function () {
	            _this.context.restaurarCapturaIRD(_this.props.capturaIRD.idCapturaAuditoriaIrd);
	        };
	        _this._colorFila = function () {
	            var cap = _this.props.capturaIRD;
	            var alerta = cap.critico == 2;
	            if (alerta) return "#F2F5A9";else return "white";
	        };
	        return _this;
	    }
	
	    _createClass(RowIRD, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index, className: css.rowSelect, style: { background: this._colorFila() } },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex, title: this.props.capturaIRD.idCapturaAuditoriaIrd },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdModificaciones },
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.divConTooltip },
	                        this.props.capturaIRD.trazabilidad.length > 0 ? _react2.default.createElement('span', { className: "glyphicon glyphicon-list" }) : _react2.default.createElement('null', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: css.tooltip },
	                            _react2.default.createElement(
	                                'table',
	                                { className: css.tablaTooltip },
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    this.props.capturaIRD.trazabilidad.map(function (trazabilidad, index) {
	                                        return _react2.default.createElement(
	                                            'tr',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'Cambio n\xB0',
	                                                index + 1,
	                                                ': ',
	                                                trazabilidad.descripcion
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSku },
	                    this.props.capturaIRD.sku
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdBarra },
	                    this.props.capturaIRD.barra
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDescriptor },
	                    this.props.capturaIRD.descriptor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLaboratorio },
	                    this.props.capturaIRD.laboratorio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdItems },
	                    this.props.capturaIRD.items
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotalConteo },
	                    _react2.default.createElement('input', { type: 'text', className: "form-control " + css.inputCaptura, placeholder: 'Total Stock F\xEDsico',
	                        id: this.props.index,
	                        ref: function ref(_ref) {
	                            return _this2.inputTotalFisico = _ref;
	                        },
	                        value: this.props.capturaIRD.total_conteo,
	                        onChange: this.onInputChangeFisico.bind(this, 'total_conteo'),
	                        onBlur: this.guardaCaptura,
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotalConteo },
	                    this.props.capturaIRD.teorico_link
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotalConteo },
	                    _react2.default.createElement('input', { type: 'text', className: "form-control " + css.inputCaptura, placeholder: 'Total Stock Pantalla',
	                        id: this.props.index,
	                        ref: function ref(_ref2) {
	                            return _this2.inputTotalStock = _ref2;
	                        },
	                        value: this.props.capturaIRD.teorico,
	                        onChange: this.onInputChangeStock.bind(this, 'teorico'),
	                        onBlur: this.guardaCaptura,
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.tooltip },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-search " + css.glyphiconStock }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.tooltiptext },
	                            _react2.default.createElement('img', { src: '' + this.props.capturaIRD.ruta_imagen, className: css.imagenStock })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTeorico },
	                    this.props.capturaIRD.diferencia
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSinRespaldo },
	                    _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.state.capturaIRD.malEnfocado,
	                        onChange: this.cambioCheckbox.bind(this),
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEliminar },
	                    !this.props.fcv ? this.props.capturaIRD.estado !== 3 ? _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: "btn btn-xs btn-danger",
	                                        onClick: showModal,
	                                        title: "Eliminar Captura"
	                                    },
	                                    _react2.default.createElement('span', { className: "glyphicon glyphicon-remove" })
	                                ),
	                                isVisible && _react2.default.createElement(_Modales.ModalConfirmarEliminarCaptura, {
	                                    titulo: 'Eliminar captura IRD',
	                                    detalle: [{ etiqueta: 'SKU', valor: _this2.props.capturaIRD.sku }, { etiqueta: 'Barra', valor: _this2.props.capturaIRD.barra }, { etiqueta: 'Descriptor', valor: _this2.props.capturaIRD.descriptor }, { etiqueta: 'Laboratorio', valor: _this2.props.capturaIRD.laboratorio }, { etiqueta: 'Total conteo', valor: _this2.props.capturaIRD.total_conteo }],
	                                    mensaje: '¿Está seguro de marcar esta captura IRD como no válida?',
	                                    mensajeConfirmacion: 'La captura quedará invalidada (puede restaurarla después). ¿Confirma?',
	                                    onConfirmar: _this2.eliminarCapturaIRD,
	                                    hideModal: hideModal
	                                })
	                            );
	                        }
	                    ) : _react2.default.createElement(
	                        'button',
	                        { className: "btn btn-xs btn-info", onClick: this.restaurarCaptura, title: "Restaurar Captura" },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-share-alt " + css.iconoEspejo })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return RowIRD;
	}(_react2.default.Component);
	
	RowIRD.contextTypes = {
	    actualizaCapturaIRD: PropTypes.func,
	    eliminarCapturaIRD: PropTypes.func,
	    restaurarCapturaIRD: PropTypes.func
	};
	
	var RowVencimiento = exports.RowVencimiento = function (_React$Component2) {
	    _inherits(RowVencimiento, _React$Component2);
	
	    function RowVencimiento(props) {
	        _classCallCheck(this, RowVencimiento);
	
	        var _this3 = _possibleConstructorReturn(this, (RowVencimiento.__proto__ || Object.getPrototypeOf(RowVencimiento)).call(this, props));
	
	        _this3.state = {
	            capturaVencimiento: []
	        };
	        _this3.onLoteChange = function (key) {
	            var actualizado = _this3.props.capturaVencimiento;
	            actualizado[key] = _this3.inputLote.value;
	            actualizado['editado'] = 1;
	            _this3.setState({ capturaVencimiento: Object.assign({}, _this3.state.capturaVencimiento, actualizado) });
	        };
	        //Al corregir la Fecha Vencimiento (date) se recalcula en simultáneo la Fecha Juliana (fecha_venc)
	        _this3.onFechaExpChange = function () {
	            var actualizado = _this3.props.capturaVencimiento;
	            Object.assign(actualizado, (0, _fechasVencimiento.sincronizarDesdeFechaExp)(_this3.inputFechaExp.value));
	            _this3.setState({ capturaVencimiento: Object.assign({}, _this3.state.capturaVencimiento, actualizado) });
	        };
	        _this3.guardaCaptura = function () {
	            if (_this3.state.capturaVencimiento.editado) _this3.context.actualizaCapturaVencimiento(_this3.state.capturaVencimiento);
	        };
	        //El botón de eliminar de la fila (al lado del ojo "ver captura") pide confirmación
	        //en un modal antes de eliminar, para no invalidar una captura por un click accidental.
	        //Devuelve la promesa para que el modal se cierre cuando responde el backend.
	        //El botón de restaurar (misma celda, captura en estado 3) no se confirma.
	        _this3.eliminarCapturaVencimiento = function () {
	            return _this3.context.eliminarCapturaVencimiento(_this3.props.capturaVencimiento.idCapturaAuditoriaVencimiento);
	        };
	        _this3.restaurarCaptura = function () {
	            _this3.context.restaurarCapturaVencimiento(_this3.props.capturaVencimiento.idCapturaAuditoriaVencimiento);
	        };
	        _this3._colorFila = function () {
	            var cap = _this3.props.capturaVencimiento;
	            var alerta = cap.critico == 2;
	            if (alerta) return "#F2F5A9";else return "white";
	        };
	        return _this3;
	    }
	
	    _createClass(RowVencimiento, [{
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index, className: css.rowSelect, style: { background: this._colorFila() } },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex, title: this.props.capturaVencimiento.idCapturaAuditoriaVencimiento },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdModificaciones },
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.divConTooltip },
	                        this.props.capturaVencimiento.trazabilidad.length > 0 ? _react2.default.createElement('span', { className: "glyphicon glyphicon-list" }) : _react2.default.createElement('null', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: css.tooltip },
	                            _react2.default.createElement(
	                                'table',
	                                { className: css.tablaTooltip },
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    this.props.capturaVencimiento.trazabilidad.map(function (trazabilidad, index) {
	                                        return _react2.default.createElement(
	                                            'tr',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'Cambio n\xB0',
	                                                index + 1,
	                                                ': ',
	                                                trazabilidad.descripcion
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSku },
	                    this.props.capturaVencimiento.sku
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdBarra },
	                    this.props.capturaVencimiento.barra
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDescriptor },
	                    this.props.capturaVencimiento.descriptor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLaboratorio },
	                    this.props.capturaVencimiento.laboratorio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSku },
	                    this.props.capturaVencimiento.cod_vendedor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdItems },
	                    this.props.capturaVencimiento.items
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLote },
	                    _react2.default.createElement('input', { type: 'text', className: "form-control " + css.inputLote, placeholder: 'Lote',
	                        id: this.props.index,
	                        ref: function ref(_ref3) {
	                            return _this4.inputLote = _ref3;
	                        },
	                        value: this.props.capturaVencimiento.lote,
	                        onChange: this.onLoteChange.bind(this, 'lote'),
	                        onBlur: this.guardaCaptura,
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFechExp },
	                    _react2.default.createElement('input', { type: 'date', className: "form-control " + css.inputFechaExp, placeholder: 'Fecha Vencimiento',
	                        id: this.props.index,
	                        ref: function ref(_ref4) {
	                            return _this4.inputFechaExp = _ref4;
	                        },
	                        value: this.props.capturaVencimiento.fecha_exp,
	                        onChange: this.onFechaExpChange,
	                        onBlur: this.guardaCaptura,
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdVencido },
	                    this.props.capturaVencimiento.vencido ? "Si" : "No"
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdPolitica },
	                    this.props.capturaVencimiento.vencido_politica ? "Si" : "No"
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdMalEnfocado },
	                    this.props.capturaVencimiento.malEnfocado ? "Si" : "No"
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdMalEnfocado },
	                    this.props.capturaVencimiento.noMedible ? "Si" : "No"
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdImagen },
	                    _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('span', { className: "glyphicon glyphicon-eye-open " + css.verImagen, onClick: showModal }),
	                                isVisible && _react2.default.createElement(_Modales.ModalRevisarVencimiento, {
	                                    hideModal: hideModal,
	                                    index: _this4.props.index,
	                                    capturaVencimiento: _this4.props.capturaVencimiento,
	                                    local: _this4.props.local,
	                                    auditor: _this4.props.auditor,
	                                    fcv: _this4.props.fcv
	                                })
	                            );
	                        }
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEliminar },
	                    !this.props.fcv ? this.props.capturaVencimiento.estado === 3 ? _react2.default.createElement(
	                        'button',
	                        { className: "btn btn-xs btn-info",
	                            onClick: this.restaurarCaptura,
	                            title: "Restaurar Captura"
	                        },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-share-alt " + css.iconoEspejo })
	                    ) : _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: "btn btn-xs btn-danger",
	                                        onClick: showModal,
	                                        title: "Eliminar Captura"
	                                    },
	                                    _react2.default.createElement('span', { className: "glyphicon glyphicon-remove" })
	                                ),
	                                isVisible && _react2.default.createElement(_Modales.ModalConfirmarEliminarCaptura, {
	                                    capturaVencimiento: _this4.props.capturaVencimiento,
	                                    onConfirmar: _this4.eliminarCapturaVencimiento,
	                                    hideModal: hideModal
	                                })
	                            );
	                        }
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return RowVencimiento;
	}(_react2.default.Component);
	
	RowVencimiento.contextTypes = {
	    actualizaCapturaVencimiento: PropTypes.func,
	    eliminarCapturaVencimiento: PropTypes.func,
	    restaurarCapturaVencimiento: PropTypes.func
	};
	
	var RowNoEncontrado = exports.RowNoEncontrado = function (_React$Component3) {
	    _inherits(RowNoEncontrado, _React$Component3);
	
	    function RowNoEncontrado(props) {
	        _classCallCheck(this, RowNoEncontrado);
	
	        var _this5 = _possibleConstructorReturn(this, (RowNoEncontrado.__proto__ || Object.getPrototypeOf(RowNoEncontrado)).call(this, props));
	
	        _this5.state = {
	            noEncontrado: _this5.props.capturaNoEncontrado
	        };
	        _this5.onInputChange = function (key) {
	            var actualizado = {};
	            actualizado[key] = _this5.inputStock.value;
	            actualizado['editado'] = 1;
	            _this5.setState({ noEncontrado: Object.assign({}, _this5.state.noEncontrado, actualizado) });
	        };
	        _this5.cambioCheckbox = function (evt) {
	            var actualizado = {};
	            var estado = evt.target.checked;
	            actualizado['malEnfocado'] = estado;
	            actualizado['editado'] = 1;
	            _this5.setState({ noEncontrado: Object.assign({}, _this5.state.noEncontrado, actualizado) }, function () {
	                return _this5.guardaCaptura();
	            });
	        };
	        _this5.guardaCaptura = function () {
	            if (_this5.state.noEncontrado.editado) _this5.context.actualizarNoEncontrado(_this5.state.noEncontrado);
	        };
	        //Devuelve la promesa para que el modal de confirmación de la fila espere
	        //la respuesta del backend (recarga de la auditoría incluida) antes de
	        //cerrarse y así bloquear el doble click.
	        _this5.eliminarCapturaNoEncontrado = function () {
	            return _this5.context.eliminarCapturaNoEncontrado(_this5.props.capturaNoEncontrado.idCapturaNoEncontrado);
	        };
	        return _this5;
	    }
	
	    _createClass(RowNoEncontrado, [{
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdModificaciones },
	                    _react2.default.createElement(
	                        'div',
	                        { className: css.divConTooltip },
	                        this.props.capturaNoEncontrado.trazabilidad.length > 0 ? _react2.default.createElement('span', { className: "glyphicon glyphicon-list" }) : _react2.default.createElement('null', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: css.tooltip },
	                            _react2.default.createElement(
	                                'table',
	                                { className: css.tablaTooltip },
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    this.props.capturaNoEncontrado.trazabilidad.map(function (trazabilidad, index) {
	                                        return _react2.default.createElement(
	                                            'tr',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'Cambio n\xB0',
	                                                index + 1,
	                                                ': ',
	                                                trazabilidad.descripcion
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSku },
	                    this.props.capturaNoEncontrado.sku
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDescriptor },
	                    this.props.capturaNoEncontrado.descriptor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLaboratorio },
	                    this.props.capturaNoEncontrado.laboratorio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdSku },
	                    this.props.capturaNoEncontrado.cod_vendedor
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdVencido },
	                    this.props.capturaNoEncontrado.estado ? "Obligatorio" : "Reserva"
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStockNo },
	                    _react2.default.createElement('input', { type: 'text', className: "form-control " + css.inputCaptura, placeholder: 'Total Stock',
	                        id: this.props.index,
	                        ref: function ref(_ref5) {
	                            return _this6.inputStock = _ref5;
	                        },
	                        value: this.state.noEncontrado.stock,
	                        onChange: this.onInputChange.bind(this, 'stock'),
	                        onBlur: this.guardaCaptura,
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdStock },
	                    _react2.default.createElement(
	                        'p',
	                        { className: css.tooltip },
	                        _react2.default.createElement('span', { className: "glyphicon glyphicon-search " + css.glyphiconStock }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.tooltiptext },
	                            _react2.default.createElement('img', { src: '' + this.state.noEncontrado.ruta_imagen, className: css.imagenStock })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdBorrosa },
	                    _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.state.noEncontrado.malEnfocado,
	                        onChange: this.cambioCheckbox.bind(this),
	                        disabled: this.props.fcv
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEliminar },
	                    !this.props.fcv ? _react2.default.createElement(
	                        _Modales.ModalTrigger,
	                        null,
	                        function (isVisible, showModal, hideModal) {
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: "btn btn-xs btn-danger",
	                                        onClick: showModal,
	                                        title: "Eliminar Captura"
	                                    },
	                                    _react2.default.createElement('span', { className: "glyphicon glyphicon-remove" })
	                                ),
	                                isVisible && _react2.default.createElement(_Modales.ModalConfirmarEliminarCaptura, {
	                                    titulo: 'Eliminar No Encontrado',
	                                    detalle: [{ etiqueta: 'SKU', valor: _this6.props.capturaNoEncontrado.sku }, { etiqueta: 'Descriptor', valor: _this6.props.capturaNoEncontrado.descriptor }, { etiqueta: 'Laboratorio', valor: _this6.props.capturaNoEncontrado.laboratorio }, { etiqueta: 'Vendedor', valor: _this6.props.capturaNoEncontrado.cod_vendedor }, { etiqueta: 'Estado', valor: _this6.props.capturaNoEncontrado.estado ? "Obligatorio" : "Reserva" }, { etiqueta: 'Stock', valor: _this6.state.noEncontrado.stock }],
	                                    mensaje: '¿Está seguro de eliminar este producto NO encontrado?',
	                                    mensajeConfirmacion: 'Esta eliminación es definitiva y no se puede restaurar. ¿Confirma?',
	                                    onConfirmar: _this6.eliminarCapturaNoEncontrado,
	                                    hideModal: hideModal
	                                })
	                            );
	                        }
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return RowNoEncontrado;
	}(_react2.default.Component);
	
	RowNoEncontrado.contextTypes = {
	    actualizarNoEncontrado: PropTypes.func,
	    eliminarCapturaNoEncontrado: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowCaptura.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalRevisarVencimiento = exports.ModalConfirmarEliminarCaptura = exports.ModalInformarResultado = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ReemplazoIMG = __webpack_require__(1053);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _ZoomImagenVencimiento = __webpack_require__(1055);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1054);
	
	var css = _interopRequireWildcard(_Modales);
	
	var _fechasVencimiento = __webpack_require__(1057);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	// ---------------------------------------------------------------------------
	// Conversión Fecha Vencimiento (fecha_exp) <-> Fecha Juliana (fecha_venc)
	// Los helpers están en fechasVencimiento.js para compartirlos con RowCaptura.jsx
	// ---------------------------------------------------------------------------
	
	// Tipos de input en los que las flechas mueven el cursor/valor propio en lugar de navegar
	var TIPOS_INPUT_CON_CURSOR = ['text', 'search', 'url', 'tel', 'email', 'password', 'number', 'date', 'time', 'datetime-local', 'month', 'week'];
	
	// true si el elemento es un campo donde las flechas deben editar texto/fecha
	var esCampoEditable = function esCampoEditable(elemento) {
	    if (!elemento) {
	        return false;
	    }
	    if (elemento.isContentEditable || elemento.tagName === 'TEXTAREA') {
	        return true;
	    }
	    return elemento.tagName === 'INPUT' && TIPOS_INPUT_CON_CURSOR.indexOf(String(elemento.type || 'text').toLowerCase()) > -1;
	};
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalInformarResultado = exports.ModalInformarResultado = function (_React$Component2) {
	    _inherits(ModalInformarResultado, _React$Component2);
	
	    function ModalInformarResultado(props) {
	        _classCallCheck(this, ModalInformarResultado);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalInformarResultado.__proto__ || Object.getPrototypeOf(ModalInformarResultado)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false
	        };
	        _this2.handleSubmit = function (evt) {
	            _this2.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState(function () {
	                _this2.props.onClick().then(function () {
	                    _this2.setState({ bloqueado: false });
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalInformarResultado, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informar resultado de auditor\xEDa'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Se informar\xE1n los resultados de la auditor\xEDa por correo. \xBFEst\xE1 seguro de proceder con esta acci\xF3n?.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado },
	                            'Informar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalInformarResultado;
	}(_react2.default.Component);
	
	ModalInformarResultado.contextTypes = {};
	//Confirmación de la eliminación de una captura (reemplaza el window.confirm que
	//usaba la fila): muestra el mismo mensaje en un modal junto con el detalle de la
	//captura que se invalidará. Mientras el backend responde los botones quedan
	//bloqueados, para evitar un doble click.
	//La eliminación tiene doble confirmación: el primer click en Eliminar no
	//elimina, sólo muestra el texto de advertencia junto al botón y cambia su texto
	//a Confirmar; recién ese segundo click invalida la captura.
	//Se usa en las tres tablas del panel de revisión: vencimientos (RowVencimiento),
	//IRD (RowIRD) y No Encontrados (RowNoEncontrado), cada una con su propio detalle
	//y mensaje; en IRD/No Encontrados el id que se elimina es el de la captura de la
	//fila, por eso el modal sólo confirma y delega en el onConfirmar de la fila.
	
	var ModalConfirmarEliminarCaptura = exports.ModalConfirmarEliminarCaptura = function (_React$Component3) {
	    _inherits(ModalConfirmarEliminarCaptura, _React$Component3);
	
	    function ModalConfirmarEliminarCaptura(props) {
	        _classCallCheck(this, ModalConfirmarEliminarCaptura);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalConfirmarEliminarCaptura.__proto__ || Object.getPrototypeOf(ModalConfirmarEliminarCaptura)).call(this, props));
	
	        _this3.state = {
	            bloqueado: false,
	            confirmando: false
	            //El modal vive dentro de la fila de la tabla: si la lista se recarga
	            //(por ejemplo al eliminar en No Encontrados) la fila se desmonta antes
	            //de que responda el backend, así que no se debe tocar el estado después.
	        };_this3._montado = true;
	        //Primer click en Eliminar: no elimina, sólo pide la confirmación final
	        _this3.pedirConfirmacion = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            if (_this3.state.bloqueado || !_this3._montado) {
	                return;
	            }
	            _this3.setState({ confirmando: true });
	        };
	        //Segundo click (el botón ya dice Confirmar): aquí sí se elimina la captura
	        _this3.confirmar = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            if (_this3.state.bloqueado) {
	                return;
	            }
	            _this3.setState({ bloqueado: true }, function () {
	                Promise.resolve(_this3.props.onConfirmar()).then(function () {
	                    //Si la fila ya no existe (lista recargada) no hay nada que actualizar
	                    if (!_this3._montado) {
	                        return;
	                    }
	                    _this3.setState({ bloqueado: false });
	                    _this3.props.hideModal();
	                }).catch(function (error) {
	                    console.log(error);
	                    if (_this3._montado) {
	                        _this3.setState({ bloqueado: false });
	                    }
	                });
	            });
	        };
	        //Texto del botón principal según el paso en que va la eliminación
	        _this3._textoBoton = function () {
	            return _this3.state.bloqueado ? 'Eliminando...' : _this3.state.confirmando ? 'Confirmar' : 'Eliminar';
	        };
	        //Cancelar (o cerrar el modal) vuelve al primer paso, para que al abrirlo
	        //nuevamente se pida otra vez la doble confirmación
	        _this3._cancelar = function (evt) {
	            if (evt) {
	                evt.preventDefault();
	                evt.stopPropagation();
	            }
	            if (!_this3._montado) {
	                return;
	            }
	            _this3.setState({ confirmando: false }, function () {
	                return _this3.props.hideModal();
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalConfirmarEliminarCaptura, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this._montado = false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var captura = this.props.capturaVencimiento || {};
	            //Por defecto (capturas de vencimiento) se muestra el detalle de la captura;
	            //las otras tablas (IRD y No Encontrados) pasan su propio arreglo de
	            //{etiqueta, valor} para mostrar los campos que corresponden a su tabla.
	            var detalle = this.props.detalle || [{ etiqueta: 'SKU', valor: captura.sku }, { etiqueta: 'Descriptor', valor: captura.descriptor }, { etiqueta: 'Lote', valor: captura.lote }, { etiqueta: 'Fecha Vencimiento', valor: captura.fecha_exp }];
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this._cancelar, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        this.props.titulo
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.mensaje
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('detalleCaptura') },
	                        detalle.map(function (fila, index) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    fila.etiqueta,
	                                    ': '
	                                ),
	                                fila.valor
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    { className: cx('pieEliminar') },
	                    this.state.confirmando && _react2.default.createElement(
	                        'span',
	                        { className: cx('alertaConfirmar') },
	                        this.props.mensajeConfirmacion
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-danger', disabled: this.state.bloqueado,
	                            onClick: this.state.confirmando ? this.confirmar : this.pedirConfirmacion },
	                        this._textoBoton()
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-default', disabled: this.state.bloqueado, onClick: this._cancelar },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalConfirmarEliminarCaptura;
	}(_react2.default.Component);
	
	ModalConfirmarEliminarCaptura.propTypes = {
	    capturaVencimiento: PropTypes.object,
	    //Detalle de la captura a eliminar: arreglo de {etiqueta, valor}. Si no se
	    //envía se muestra el detalle de vencimientos (capturaVencimiento).
	    detalle: PropTypes.array,
	    titulo: PropTypes.string,
	    mensaje: PropTypes.string,
	    mensajeConfirmacion: PropTypes.string,
	    // Metodos
	    onConfirmar: PropTypes.func.isRequired,
	    hideModal: PropTypes.func.isRequired
	};
	ModalConfirmarEliminarCaptura.defaultProps = {
	    titulo: 'Eliminar captura',
	    mensaje: '¿Está seguro de eliminar esta captura?',
	    mensajeConfirmacion: '¿Está seguro de eliminar la captura?'
	};
	
	var ModalRevisarVencimiento = exports.ModalRevisarVencimiento = function (_React$Component4) {
	    _inherits(ModalRevisarVencimiento, _React$Component4);
	
	    function ModalRevisarVencimiento(props) {
	        _classCallCheck(this, ModalRevisarVencimiento);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalRevisarVencimiento.__proto__ || Object.getPrototypeOf(ModalRevisarVencimiento)).call(this, props));
	
	        _this4.state = {
	            index: 0,
	            capturaVencimiento: [],
	            capturaVencimientoRAW: [],
	            error: '',
	            reemplazos: [],
	            showReemplazoImagen: false,
	            primeraCaptura: false,
	            ultimaCaptura: false,
	            mostrarFotoDuracion: false
	        };
	        _this4.escFunction = _this4.escFunction.bind(_this4);
	        _this4.focusFecha = _this4.focusFecha.bind(_this4);
	        _this4.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
	            actualizado['editado'] = 1;
	            _this4.setState({ capturaVencimiento: Object.assign({}, _this4.state.capturaVencimiento, actualizado) });
	        };
	        //Guarda o limpia el mensaje de error de la Fecha Juliana. Los errores se
	        //manejan con el mismo formato que devuelve el backend: {campo: [mensajes]}
	        _this4.setErrorJuliano = function (mensaje) {
	            var errores = Object.assign({}, _this4.state.error);
	            if (mensaje) {
	                errores.fecha_venc = [mensaje];
	            } else {
	                delete errores.fecha_venc;
	            }
	            _this4.setState({ error: errores });
	        };
	        //true si la Fecha Juliana escrita a mano quedó inválida.
	        //La Fecha Vencimiento no se valida: al ser un input type="date" el navegador
	        //sólo entrega fechas existentes y dentro de su rango permitido
	        _this4.hayErrorJuliano = function () {
	            return !!_this4.state.error.fecha_venc;
	        };
	        //Avisa y detiene la acción que persistiría la captura cuando la Fecha Juliana es inválida
	        _this4.detenerPorJulianoInvalido = function (accion) {
	            if (!_this4.hayErrorJuliano()) {
	                return false;
	            }
	            _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), accion + '. Corrija la fecha juliana marcada', 5 * 1000);
	            return true;
	        };
	        //Captura a persistir: descarta la Fecha Juliana que no pasó la validación, de modo
	        //que un valor que no es fecha nunca llegue a la base de datos
	        _this4.capturaParaGuardar = function () {
	            if (_this4.state.error.fecha_venc) {
	                var copia = Object.assign({}, _this4.state.capturaVencimiento);
	                delete copia.fecha_venc;
	                return copia;
	            }
	            return _this4.state.capturaVencimiento;
	        };
	        //Al corregir la Fecha Vencimiento (date) se recalcula en simultáneo la Fecha Juliana (mes + año).
	        //Este campo no requiere validación propia: type="date" sólo admite fechas existentes
	        _this4.onFechaExpChange = function (evt) {
	            var actualizado = (0, _fechasVencimiento.sincronizarDesdeFechaExp)(evt.target.value);
	            //Si la fecha elegida es válida la Fecha Juliana queda recalculada y su error previo ya no aplica
	            if (actualizado.fecha_venc) {
	                _this4.setErrorJuliano(null);
	            }
	            _this4.setState({ capturaVencimiento: Object.assign({}, _this4.state.capturaVencimiento, actualizado) });
	        };
	        //Al corregir la Fecha Juliana (mes + año) se recalcula en simultáneo la Fecha Vencimiento (date)
	        _this4.onFechaVencChange = function (evt) {
	            var mensaje = (0, _fechasVencimiento.validarFechaJuliano)(evt.target.value);
	            _this4.setErrorJuliano(mensaje);
	            //El texto escrito a mano se mantiene en el input (aunque esté incompleto o sea
	            //inválido) para poder corregirlo, pero mientras haya error guardarCaptura y
	            //handleSubmit quedan bloqueados; sincronizarDesdeFechaVenc sólo actualiza
	            //fecha_exp cuando la Fecha Juliana es válida
	            var actualizado = (0, _fechasVencimiento.sincronizarDesdeFechaVenc)(evt.target.value);
	            _this4.setState({ capturaVencimiento: Object.assign({}, _this4.state.capturaVencimiento, actualizado) });
	        };
	        _this4.guardarCaptura = function () {
	            if (_this4.detenerPorJulianoInvalido('No se guardó')) {
	                return false;
	            }
	            if (_this4.state.capturaVencimiento.editado) {
	                _this4.context.actualizaCapturaVencimiento(_this4.capturaParaGuardar());
	            }
	            return true;
	        };
	        //Captura que se muestra después de eliminar, restaurar o reemplazar una imagen: se
	        //mantiene el índice actual sobre la lista ya recargada. Al eliminar la última captura
	        //de la lista el índice queda fuera de rango, así que se apunta a la última disponible;
	        //si ya no queda ninguna captura se cierra el modal, porque la captura que se estaba
	        //revisando ya no existe y no hay nada que mostrar.
	        _this4.setUPDVencimiento = function () {
	            var capturas = _this4.state.capturaVencimientoRAW || [];
	            if (!capturas.length) {
	                _this4.props.hideModal();
	                return;
	            }
	            var index = Math.min(_this4.state.index, capturas.length - 1);
	            //Al mostrar otra captura el error de la Fecha Juliana anterior ya no aplica y los
	            //paneles de reemplazo/foto duración vuelven a su estado inicial, igual que al
	            //navegar con las flechas (sus datos eran de la captura anterior)
	            _this4.setState({
	                index: index,
	                primeraCaptura: index === 0,
	                ultimaCaptura: index === capturas.length - 1,
	                capturaVencimiento: capturas[index],
	                error: '',
	                showReemplazoImagen: false,
	                mostrarFotoDuracion: false
	            });
	        };
	        _this4.setVencimiento = function () {
	            var captura = _this4.state.capturaVencimientoRAW[_this4.state.index];
	            //Cambiar de imagen con las flechas no mueve el foco a los campos de captura:
	            //la navegación y la edición de texto son independientes
	            //Al mostrar otra captura el error de la Fecha Juliana anterior ya no aplica
	            _this4.setState({ capturaVencimiento: captura, error: '' });
	        };
	        _this4.capturaSiguiente = function () {
	            //Si la Fecha Juliana es inválida no se navega: primero debe corregirse
	            if (!_this4.guardarCaptura()) {
	                return;
	            }
	
	            _this4.setState({
	                index: _this4.state.index < _this4.state.capturaVencimientoRAW.length - 1 ? _this4.state.index + 1 : _this4.state.index,
	                primeraCaptura: false,
	                ultimaCaptura: _this4.state.index < _this4.state.capturaVencimientoRAW.length - 1 ? false : true,
	                showReemplazoImagen: false,
	                mostrarFotoDuracion: false
	            }, function () {
	                return _this4.setVencimiento();
	            });
	        };
	        _this4.capturaPrevia = function () {
	            //Si la Fecha Juliana es inválida no se navega: primero debe corregirse
	            if (!_this4.guardarCaptura()) {
	                return;
	            }
	
	            _this4.setState({
	                index: _this4.state.index > 0 ? _this4.state.index - 1 : _this4.state.index,
	                primeraCaptura: _this4.state.index > 0 ? false : true,
	                ultimaCaptura: false,
	                showReemplazoImagen: false,
	                mostrarFotoDuracion: false
	            }, function () {
	                return _this4.setVencimiento();
	            });
	        };
	        _this4.handleSubmit = function () {
	            //No se guarda con una Fecha Juliana inválida escrita a mano (se indica bajo el campo)
	            if (_this4.detenerPorJulianoInvalido('No se guardó')) {
	                return;
	            }
	            if (_this4.state.capturaVencimiento.editado) {
	                _this4.context.actualizaCapturaVencimiento(_this4.capturaParaGuardar()).then(function () {
	                    _this4.setState({
	                        capturaVencimientoRAW: _this4.context.getVencimientos()
	                    }, function () {
	                        return _this4.refs.notificator.success('Captura ' + (_this4.state.index + 1), 'Actualizada correctamente', 4 * 1000);
	                    });
	                }).catch(function (err) {
	                    _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), 'no actualizada', 4 * 1000);
	                });
	            }
	        };
	        _this4.onCancel = function () {
	            _this4.props.hideModal();
	        };
	        _this4.hideReemplazo = function () {
	            _this4.setState({ showReemplazoImagen: false });
	        };
	        _this4.showReemplazoImagen = function () {
	            if (_this4.state.showReemplazoImagen) {
	                _this4.hideReemplazo();
	            } else {
	                _this4.context.getImagenesReemplazo(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento, _this4.state.capturaVencimiento.sku, _this4.state.capturaVencimiento.lote, _this4.state.capturaVencimiento.fecha_exp).then(function (reemplazos) {
	                    _this4.setState({
	                        reemplazos: reemplazos,
	                        showReemplazoImagen: true
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                    _this4.setState({
	                        reemplazos: [],
	                        showReemplazoImagen: true
	                    });
	                });
	            }
	        };
	        //Devuelve la promesa para que el modal de confirmación espere la respuesta del backend
	        //antes de cerrarse (y así bloquea el doble click mientras se elimina)
	        _this4.eliminarCaptura = function () {
	            if (_this4.state.capturaVencimiento.editado) {
	                //Se persiste la captura sin la Fecha Juliana inválida (si la hubiera) antes de eliminarla
	
	                return _this4.context.actualizaCapturaVencimiento(_this4.capturaParaGuardar()).then(function () {
	                    _this4.setState({
	                        capturaVencimientoRAW: _this4.context.getVencimientos()
	                    }, function () {
	                        return _this4.context.eliminarCapturaVencimiento(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento).then(function () {
	                            _this4.setState({
	                                capturaVencimientoRAW: _this4.context.getVencimientos()
	                            }, function () {
	                                return _this4.setUPDVencimiento();
	                            });
	                        }).catch(function () {
	                            _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), 'no eliminada', 4 * 1000);
	                        });
	                    });
	                }).catch(function (err) {
	                    _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), 'no actualizada', 4 * 1000);
	                });
	            } else {
	
	                return _this4.context.eliminarCapturaVencimiento(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento).then(function () {
	                    _this4.setState({
	                        capturaVencimientoRAW: _this4.context.getVencimientos()
	                    }, function () {
	                        return _this4.setUPDVencimiento();
	                    });
	                }).catch(function () {
	                    _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), 'no eliminada', 4 * 1000);
	                });
	            }
	        };
	        _this4.restaurarCaptura = function () {
	            if (_this4.state.capturaVencimiento.editado) {
	                //Se persiste la captura sin la Fecha Juliana inválida (si la hubiera) antes de restaurarla
	                _this4.context.actualizaCapturaVencimiento(_this4.capturaParaGuardar()).then(function () {
	                    _this4.setState({
	                        capturaVencimientoRAW: _this4.context.getVencimientos()
	                    }, function () {
	                        return _this4.context.restaurarCapturaVencimiento(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento).then(function () {
	                            _this4.setState({
	                                capturaVencimientoRAW: _this4.context.getVencimientos()
	                            }, function () {
	                                return _this4.setUPDVencimiento();
	                            });
	                        }).catch(function (err) {
	                            console.log(err);
	                        });
	                    });
	                }).catch(function (err) {
	                    _this4.refs.notificator.error('Captura ' + (_this4.state.index + 1), 'no actualizada', 4 * 1000);
	                });
	            } else {
	                _this4.context.restaurarCapturaVencimiento(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento).then(function () {
	                    _this4.setState({
	                        capturaVencimientoRAW: _this4.context.getVencimientos()
	                    }, function () {
	                        return _this4.setUPDVencimiento();
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        _this4.reemplazarImagen = function (idArchivoImagen) {
	            _this4.context.reemplazarImagen(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento, idArchivoImagen).then(function (resp) {
	                _this4.context.actualizaCapturaVencimiento(resp).then(function () {
	                    _this4.setState({ capturaVencimientoRAW: _this4.context.getVencimientos() }, function () {
	                        return _this4.setUPDVencimiento();
	                    });
	                }).catch(function () {});
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this4.cambiarFoto = function () {
	            _this4.setState({
	                mostrarFotoDuracion: !_this4.state.mostrarFotoDuracion
	            });
	        };
	        _this4.onSubirImagen = function (evt) {
	            if (evt.target.files[0]) {
	                var file = evt.target.files[0];
	                _this4.context.subirImagenVencimiento(_this4.state.capturaVencimiento.idCapturaAuditoriaVencimiento, file).then(function (resp) {
	                    _this4.context.actualizaCapturaVencimiento(resp).then(function () {
	                        _this4.setState({ capturaVencimientoRAW: _this4.context.getVencimientos() }, function () {
	                            return _this4.setUPDVencimiento();
	                        });
	                    }).catch(function () {});
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        return _this4;
	    }
	    //Set Focus a Input de lote
	
	
	    _createClass(ModalRevisarVencimiento, [{
	        key: 'focusFecha',
	        value: function focusFecha() {
	            this.fechaInput.focus();
	        }
	    }, {
	        key: 'escFunction',
	        value: function escFunction(evt) {
	            //Si el foco está en un campo de captura (Fecha Vencimiento, Fecha Juliana, Lote, ...)
	            //las flechas deben mover el cursor dentro del campo y no cambiar de imagen
	            if (esCampoEditable(evt.target) || esCampoEditable(document.activeElement)) {
	                return;
	            }
	            //Con teclas modificadoras las flechas conservan la función del navegador
	            if (evt.altKey || evt.ctrlKey || evt.metaKey) {
	                return;
	            }
	            //Flecha Izquierda Presionada
	            //Reduce el index para mostar captura previa
	            if (evt.keyCode === 37) {
	                this.capturaPrevia();
	            }
	            //Flecha Derecha Presionada
	            //Aumenta el index para mostar captura siguiente
	            if (evt.keyCode === 39) {
	                this.capturaSiguiente();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener("keydown", this.escFunction, false);
	            this.focusFecha();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.escFunction, false);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                index: this.props.index,
	                primeraCaptura: this.props.index === 0 ? true : false,
	                capturaVencimiento: this.props.capturaVencimiento,
	                capturaVencimientoRAW: this.context.getVencimientos()
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalVencimiento'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Captura Venc. Local ',
	                        this.props.local,
	                        ' Auditor ',
	                        this.props.auditor,
	                        ', ',
	                        this.state.index + 1,
	                        ' de ',
	                        this.state.capturaVencimientoRAW.length,
	                        ', ITEM ',
	                        this.state.capturaVencimiento.items,
	                        ', ',
	                        _react2.default.createElement(
	                            'span',
	                            { className: css.sku },
	                            'SKU ',
	                            this.state.capturaVencimiento.sku
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5 col-md-offset-1' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        this.state.capturaVencimiento.descriptor,
	                                        ' Lab. ',
	                                        this.state.capturaVencimiento.laboratorio
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12', style: { textAlign: 'center' } },
	                                _react2.default.createElement(_ZoomImagenVencimiento.ZoomImagenVencimiento, {
	                                    ruta_imagen: this.state.capturaVencimiento.ruta_imagen[this.state.mostrarFotoDuracion ? 1 : 0].ruta
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5' },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: 'col-md-12',
	                                    style: {
	                                        display: 'flex',
	                                        justifyContent: 'center',
	                                        marginBottom: 15
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    'nav',
	                                    { 'aria-label': 'Navegaci\xF3n de capturas' },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        {
	                                            className: 'pager',
	                                            style: {
	                                                margin: 0,
	                                                display: 'flex',
	                                                alignItems: 'center',
	                                                gap: 8
	                                            }
	                                        },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    className: cx('btnPrevio'),
	                                                    style: { userSelect: 'none' },
	                                                    onClick: this.capturaPrevia
	                                                },
	                                                this.state.primeraCaptura ? null : _react2.default.createElement('span', {
	                                                    className: 'glyphicon glyphicon-arrow-left',
	                                                    'aria-hidden': 'true'
	                                                }),
	                                                this.state.primeraCaptura ? " Primera Captura" : " Previa"
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    className: cx('btnSiguiente'),
	                                                    style: { userSelect: 'none' },
	                                                    onClick: this.capturaSiguiente
	                                                },
	                                                this.state.ultimaCaptura ? "Última Captura " : "Siguiente ",
	                                                this.state.ultimaCaptura ? null : _react2.default.createElement('span', {
	                                                    className: 'glyphicon glyphicon-arrow-right',
	                                                    'aria-hidden': 'true'
	                                                })
	                                            )
	                                        ),
	                                        this.state.capturaVencimiento.doble_foto === 1 && _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    className: cx('btnSiguiente'),
	                                                    style: { userSelect: 'none' },
	                                                    onClick: this.cambiarFoto
	                                                },
	                                                this.state.mostrarFotoDuracion ? 'Elaboración ' : 'Duración ',
	                                                _react2.default.createElement('span', {
	                                                    className: 'glyphicon glyphicon-refresh',
	                                                    'aria-hidden': 'true'
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: cx('col-md-12 form-group', 'form__control-label'),
	                                    style: { marginBottom: 12 }
	                                },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Fecha Vencimiento'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', {
	                                        ref: function ref(input) {
	                                            _this5.fechaInput = input;
	                                        },
	                                        type: 'text',
	                                        className: 'form-control',
	                                        placeholder: 'Fecha Juliana',
	                                        id: this.state.index,
	                                        disabled: this.props.fcv,
	                                        value: this.state.capturaVencimiento.fecha_venc,
	                                        onChange: this.onFechaVencChange
	                                    }),
	                                    this.state.error.fecha_venc && _react2.default.createElement(
	                                        'span',
	                                        { className: cx('form__error-message') },
	                                        this.state.error.fecha_venc[0]
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', {
	                                        type: 'date',
	                                        className: 'form-control',
	                                        placeholder: 'Fecha Vencimiento',
	                                        id: this.state.index,
	                                        value: this.state.capturaVencimiento.fecha_exp,
	                                        onChange: this.onFechaExpChange,
	                                        disabled: this.props.fcv,
	                                        readOnly: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: cx('col-md-12 form-group', 'form__control-label'),
	                                    style: { marginBottom: 12 }
	                                },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Lote'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement('input', {
	                                        type: 'text',
	                                        className: 'form-control',
	                                        placeholder: 'Lote',
	                                        id: this.state.index,
	                                        disabled: this.props.fcv,
	                                        value: this.state.capturaVencimiento.lote,
	                                        onChange: this.onInputChange.bind(this, 'lote')
	                                    }),
	                                    this.state.error.lote && _react2.default.createElement(
	                                        'span',
	                                        { className: cx('form__error-message') },
	                                        this.state.error.lote[0]
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: 'col-md-12',
	                                    style: {
	                                        display: 'flex',
	                                        justifyContent: 'center',
	                                        flexWrap: 'wrap',
	                                        gap: 16,
	                                        marginBottom: 15
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    'label',
	                                    {
	                                        style: {
	                                            fontWeight: 'normal',
	                                            fontSize: 12,
	                                            display: 'flex',
	                                            alignItems: 'center',
	                                            gap: 6,
	                                            margin: 0
	                                        }
	                                    },
	                                    _react2.default.createElement('input', {
	                                        type: 'checkbox',
	                                        disabled: this.props.fcv,
	                                        checked: !!this.state.capturaVencimiento.malEnfocado,
	                                        onChange: this.onInputChange.bind(this, 'malEnfocado')
	                                    }),
	                                    '\xBFFoto sin respaldo?'
	                                ),
	                                _react2.default.createElement(
	                                    'label',
	                                    {
	                                        style: {
	                                            fontWeight: 'normal',
	                                            fontSize: 12,
	                                            display: 'flex',
	                                            alignItems: 'center',
	                                            gap: 6,
	                                            margin: 0
	                                        }
	                                    },
	                                    _react2.default.createElement('input', {
	                                        type: 'checkbox',
	                                        disabled: this.props.fcv,
	                                        checked: !!this.state.capturaVencimiento.noMedible,
	                                        onChange: this.onInputChange.bind(this, 'noMedible')
	                                    }),
	                                    '\xBFSin expiraci\xF3n?'
	                                ),
	                                _react2.default.createElement(
	                                    'label',
	                                    {
	                                        style: {
	                                            fontWeight: 'normal',
	                                            fontSize: 12,
	                                            display: 'flex',
	                                            alignItems: 'center',
	                                            gap: 6,
	                                            margin: 0
	                                        }
	                                    },
	                                    _react2.default.createElement('input', {
	                                        type: 'checkbox',
	                                        disabled: true,
	                                        checked: !!this.state.capturaVencimiento.vencido_politica,
	                                        readOnly: true
	                                    }),
	                                    '\xBFFuera Pol\xEDtica?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: 'col-md-12',
	                                    style: {
	                                        display: 'flex',
	                                        justifyContent: 'center',
	                                        alignItems: 'center',
	                                        flexWrap: 'wrap',
	                                        gap: 8,
	                                        marginBottom: 15
	                                    }
	                                },
	                                !this.props.fcv && _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: cx("btn btn-sm btn-primary", 'btnModal'),
	                                        onClick: this.handleSubmit
	                                    },
	                                    _react2.default.createElement('span', {
	                                        className: 'glyphicon glyphicon-floppy-disk',
	                                        'aria-hidden': 'true'
	                                    }),
	                                    ' ',
	                                    'Guardar'
	                                ),
	                                !this.props.fcv && (this.state.capturaVencimiento.estado === 3 ? _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: cx("btn btn-sm btn-info", 'btnModal'),
	                                        onClick: this.restaurarCaptura
	                                    },
	                                    _react2.default.createElement('span', {
	                                        className: "glyphicon glyphicon-share-alt " + css.iconoEspejo,
	                                        'aria-hidden': 'true'
	                                    }),
	                                    ' ',
	                                    'Restaurar'
	                                ) : _react2.default.createElement(
	                                    ModalTrigger,
	                                    null,
	                                    function (isVisible, showModal, hideModal) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    className: cx("btn btn-sm btn-danger", 'btnModal'),
	                                                    onClick: showModal
	                                                },
	                                                _react2.default.createElement('span', {
	                                                    className: 'glyphicon glyphicon-remove',
	                                                    'aria-hidden': 'true'
	                                                }),
	                                                ' ',
	                                                'Eliminar'
	                                            ),
	                                            isVisible && _react2.default.createElement(ModalConfirmarEliminarCaptura, {
	                                                capturaVencimiento: _this5.state.capturaVencimiento,
	                                                onConfirmar: _this5.eliminarCaptura,
	                                                hideModal: hideModal
	                                            })
	                                        );
	                                    }
	                                )),
	                                !this.props.fcv && _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: cx("btn btn-sm btn-info", 'btnModal'),
	                                        onClick: this.showReemplazoImagen
	                                    },
	                                    _react2.default.createElement('span', {
	                                        className: 'glyphicon glyphicon-random',
	                                        'aria-hidden': 'true'
	                                    }),
	                                    ' ',
	                                    'Reemplazo'
	                                ),
	                                !this.props.fcv && _react2.default.createElement(
	                                    'label',
	                                    {
	                                        htmlFor: 'subirFoto',
	                                        style: { margin: 0 }
	                                    },
	                                    _react2.default.createElement(
	                                        'li',
	                                        {
	                                            className: cx("btn btn-sm btn-primary", 'btnModal'),
	                                            title: 'Seleccionar Foto',
	                                            style: { listStyle: 'none' }
	                                        },
	                                        _react2.default.createElement('span', {
	                                            className: 'glyphicon glyphicon-picture',
	                                            'aria-hidden': 'true'
	                                        }),
	                                        ' ',
	                                        'Nueva'
	                                    ),
	                                    _react2.default.createElement('input', {
	                                        className: cx('inputFileReact'),
	                                        id: 'subirFoto',
	                                        type: 'file',
	                                        onChange: this.onSubirImagen.bind(this)
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: cx("btn btn-sm btn-cancel", 'btnModal'),
	                                        onClick: this.onCancel
	                                    },
	                                    _react2.default.createElement('span', {
	                                        className: 'glyphicon glyphicon-remove-circle',
	                                        'aria-hidden': 'true'
	                                    }),
	                                    ' ',
	                                    'Cerrar'
	                                )
	                            ),
	                            !this.props.fcv && this.state.showReemplazoImagen && _react2.default.createElement(_ReemplazoIMG.ReemplazoIMG, {
	                                posibles: this.state.capturaVencimiento.posibles,
	                                reemplazos: this.state.reemplazos,
	                                reemplazarImagen: this.reemplazarImagen,
	                                hideReemplazo: this.hideReemplazo
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalRevisarVencimiento;
	}(_react2.default.Component);
	
	ModalRevisarVencimiento.contextTypes = {
	    getVencimientos: PropTypes.func,
	    actualizaCapturaVencimiento: PropTypes.func,
	    getImagenesReemplazo: PropTypes.func,
	    reemplazarImagen: PropTypes.func,
	    capturaVencimientoMalEnfocada: PropTypes.func,
	    eliminarCapturaVencimiento: PropTypes.func,
	    restaurarCapturaVencimiento: PropTypes.func,
	    subirImagenVencimiento: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReemplazoIMG = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1054);
	
	var css = _interopRequireWildcard(_Modales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	var ReemplazoIMG = exports.ReemplazoIMG = function (_React$Component) {
	    _inherits(ReemplazoIMG, _React$Component);
	
	    function ReemplazoIMG(props) {
	        _classCallCheck(this, ReemplazoIMG);
	
	        var _this = _possibleConstructorReturn(this, (ReemplazoIMG.__proto__ || Object.getPrototypeOf(ReemplazoIMG)).call(this, props));
	
	        _this.state = {
	            index: 0,
	            IMG: '',
	            reemplazo: [],
	            cantReemplazos: 0
	        };
	        _this.previa = function () {
	            _this.setState({
	                index: _this.state.index > 0 ? _this.state.index - 1 : _this.state.index
	            }, function () {
	                return _this.setImagen();
	            });
	        };
	        _this.siguiente = function () {
	            _this.setState({
	                index: _this.state.index < _this.state.cantReemplazos - 1 ? _this.state.index + 1 : _this.state.index
	            }, function () {
	                return _this.setImagen();
	            });
	        };
	        _this.setImagen = function () {
	            _this.setState({
	                reemplazo: _this.props.reemplazos[_this.state.index]
	            });
	        };
	        _this.seleccionarImagen = function () {
	            _this.props.reemplazarImagen(_this.state.reemplazo.idArchivoImagen);
	            _this.props.hideReemplazo();
	        };
	        return _this;
	    }
	
	    _createClass(ReemplazoIMG, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setImagen();
	            this.setState({
	                cantReemplazos: Object.keys(this.props.reemplazos).length
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-10' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h5',
	                            { className: cx("panel-title", 'panelTitleCustom') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-md-8' },
	                                'Posibles Reemplazos'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: cx("btn btn-xs", 'btnSeleccionar'), onClick: this.seleccionarImagen, disabled: this.props.reemplazos.length === 0 ? true : false },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' }),
	                                ' Seleccionar'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx("col-md-12", 'divCenter') },
	                            this.props.reemplazos.length === 0 ? _react2.default.createElement(
	                                'div',
	                                { colSpan: '21', style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'No se encontraron coincidencias'
	                                )
	                            ) : _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement('img', { src: '' + this.state.reemplazo.ruta_imagen, className: cx('imagenPosible') }),
	                                this.state.reemplazo.original ? _react2.default.createElement(
	                                    'label',
	                                    { className: cx('labelOriginal') },
	                                    'Imagen Original'
	                                ) : null
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'nav',
	                                { 'aria-label': '...' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'pager' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { className: cx('btnPrevio'), onClick: this.previa, disabled: this.props.reemplazos.length === 0 ? true : false },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-left', 'aria-hidden': 'true' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { className: cx('btnSiguiente'), onClick: this.siguiente, disabled: this.props.reemplazos.length === 0 ? true : false },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-right', 'aria-hidden': 'true' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReemplazoIMG;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ReemplazoIMG.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"Modales__modal___33N-I","modalAmplio":"Modales__modalAmplio___2vtTc","modalVencimiento":"Modales__modalVencimiento___20Fbc","selectCliente":"Modales__selectCliente___1F7Ky","bloquearUsuario_footer":"Modales__bloquearUsuario_footer___2Gt0k","cambiarContrasena_footer":"Modales__cambiarContrasena_footer___26ROz","editarUsuario_footer":"Modales__editarUsuario_footer___3WFLT","btn-50-perc":"Modales__btn-50-perc___fa8lY","form__control-label":"Modales__form__control-label___pBVG1","form__error-message":"Modales__form__error-message___1rfUc","warning-custom":"Modales__warning-custom___16fzE","imagenVencimiento":"Modales__imagenVencimiento___20QIJ","imagenPosible":"Modales__imagenPosible___CUC56","divCenter":"Modales__divCenter___zkyBe","divBtn":"Modales__divBtn___2In78","btnPrevio":"Modales__btnPrevio___2H2go","btnSiguiente":"Modales__btnSiguiente___3keP1","hoverPage":"Modales__hoverPage___vpDZK","glyphicon":"Modales__glyphicon___DLXjz","btnSeleccionar":"Modales__btnSeleccionar___1gTIo","btnModal":"Modales__btnModal___27IrI","panelTitleCustom":"Modales__panelTitleCustom___7NJiL","labelOriginal":"Modales__labelOriginal___CJfOI","inputFileReact":"Modales__inputFileReact___1fJRd","sku":"Modales__sku___1iwiP","detalleCaptura":"Modales__detalleCaptura___18KH4","pieEliminar":"Modales__pieEliminar___3y7r9","alertaConfirmar":"Modales__alertaConfirmar___GjIpb"};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ZoomImagenVencimiento = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ZoomImagenVencimiento = __webpack_require__(1056);
	
	var css = _interopRequireWildcard(_ZoomImagenVencimiento);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* Factor de aumento del zoom */
	var FACTOR_ZOOM = 3;
	
	/* Componente exclusivo del modal de revisión de vencimientos (frontEnd/auditorias/revision/Modales.jsx).
	 * Es una copia del componente ZoomImagen (frontEnd/components/ZoomImagen/ZoomImagen.jsx) para poder
	 * modificarlo sin afectar a las otras vistas que utilizan el componente original.
	 *
	 * Diferencias con el componente original:
	 *  - La imagen se limita al tamaño de la pantalla del usuario (nunca es más grande que el viewport).
	 *  - El zoom es fijo de 3x y se realiza sobre la zona de la imagen por donde pasa el mouse. */
	
	var ZoomImagenVencimiento = exports.ZoomImagenVencimiento = function (_React$Component) {
	    _inherits(ZoomImagenVencimiento, _React$Component);
	
	    function ZoomImagenVencimiento(props) {
	        _classCallCheck(this, ZoomImagenVencimiento);
	
	        var _this = _possibleConstructorReturn(this, (ZoomImagenVencimiento.__proto__ || Object.getPrototypeOf(ZoomImagenVencimiento)).call(this, props));
	
	        _this.state = {
	            zoomActivo: false,
	            anchoImagen: 0,
	            altoImagen: 0,
	            origenX: 0,
	            origenY: 0
	        };
	        _this.mouseEnterImagen = function (evt) {
	            _this.actualizarZoom(evt);
	        };
	        _this.mouseMoveImagen = function (evt) {
	            if (_this.state.zoomActivo) {
	                _this.actualizarZoom(evt);
	            }
	        };
	        _this.mouseLeaveImagen = function () {
	            _this.setState({ zoomActivo: false });
	        };
	        //Guarda las medidas de la imagen (para el tamaño de la ventana de zoom) y la posición
	        //de la imagen señalada por el mouse (para el origen del zoom)
	        _this.actualizarZoom = function (evt) {
	            var rect = evt.target.getBoundingClientRect();
	            if (!rect.width || !rect.height) {
	                return;
	            }
	            _this.setState({
	                zoomActivo: true,
	                anchoImagen: rect.width,
	                altoImagen: rect.height,
	                origenX: _this.acotar(evt.clientX - rect.left, rect.width),
	                origenY: _this.acotar(evt.clientY - rect.top, rect.height)
	            });
	        };
	        //Limita un valor dentro del rango 0 - máximo
	        _this.acotar = function (valor, maximo) {
	            return Math.round(Math.min(Math.max(valor, 0), maximo));
	        };
	        //Centra en la ventana de zoom el punto de la imagen señalado por el mouse,
	        //sin dejar espacios vacíos en los bordes de la ventana
	        _this.centrarZoom = function (origenZoom, tamanoZoom, tamanoVentana) {
	            var centrado = tamanoVentana / 2 - origenZoom;
	            var minimo = tamanoVentana - tamanoZoom;
	            return Math.round(Math.min(0, Math.max(minimo, centrado)));
	        };
	        return _this;
	    }
	    //Al cambiar la foto (elaboración / duración) se oculta el zoom para recalcular las medidas
	
	
	    _createClass(ZoomImagenVencimiento, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ruta_imagen !== this.props.ruta_imagen) {
	                this.setState({ zoomActivo: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var zoom = this.state;
	            var anchoZoom = zoom.anchoImagen * FACTOR_ZOOM;
	            var altoZoom = zoom.altoImagen * FACTOR_ZOOM;
	            return _react2.default.createElement(
	                'div',
	                { className: css.contenedor },
	                _react2.default.createElement('img', {
	                    src: '' + this.props.ruta_imagen,
	                    className: css.imagenOriginal,
	                    onMouseEnter: this.mouseEnterImagen,
	                    onMouseMove: this.mouseMoveImagen,
	                    onMouseLeave: this.mouseLeaveImagen
	                }),
	                zoom.zoomActivo ? _react2.default.createElement(
	                    'div',
	                    { className: css.ventanaZoom, style: { width: zoom.anchoImagen, height: zoom.altoImagen } },
	                    _react2.default.createElement('img', {
	                        src: '' + this.props.ruta_imagen,
	                        className: css.imagenZoom,
	                        style: {
	                            width: anchoZoom,
	                            height: altoZoom,
	                            left: this.centrarZoom(zoom.origenX * FACTOR_ZOOM, anchoZoom, zoom.anchoImagen),
	                            top: this.centrarZoom(zoom.origenY * FACTOR_ZOOM, altoZoom, zoom.altoImagen)
	                        }
	                    })
	                ) : null
	            );
	        }
	    }]);
	
	    return ZoomImagenVencimiento;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ZoomImagenVencimiento.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contenedor":"ZoomImagenVencimiento__contenedor___3ZXmF","imagenOriginal":"ZoomImagenVencimiento__imagenOriginal___INbZC","ventanaZoom":"ZoomImagenVencimiento__ventanaZoom___3OyIz","imagenZoom":"ZoomImagenVencimiento__imagenZoom___oXn8f"};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// ---------------------------------------------------------------------------
	// Conversión entre Fecha Vencimiento (fecha_exp, formato 'AAAA-MM-DD') y
	// Fecha Juliana (fecha_venc, formato mes-año)
	//
	// Módulo compartido por ModalRevisarVencimiento (Modales.jsx) y por
	// RowVencimiento (RowCaptura.jsx), de modo que ambos mantengan los dos campos
	// sincronizados con exactamente las mismas reglas.
	// ---------------------------------------------------------------------------
	
	// Formato con el que se escribe la Fecha Juliana
	// Opciones: 'MM-AAAA' (ej. 12-2029) | 'MM-AA' (ej. 12-29) | 'MMAA' (ej. 1229) | 'MM/AA' | 'MM/AAAA'
	var FORMATO_JULIANO = exports.FORMATO_JULIANO = 'MM-AAAA';
	
	// Día que se asigna a la Fecha Vencimiento cuando sólo se conoce mes y año.
	// Se usa 'ultimo' (último día del mes) porque la Fecha Juliana indica el mes/año
	// en que expira el producto: éste sigue vigente hasta el último día de ese mes.
	// Aplica al apartado Vencimiento de las auditorías (modal Revisar Vencimiento y
	// fila de la tabla de vencimientos). El backend resuelve la Fecha Juliana con
	// este mismo criterio (último día del mes): la importación de capturas en
	// ResultadoAuditoriaService::_getDateExp() y el alta manual / pegado desde Excel en
	// ResultadoAuditoriaController::api_nueva_captura_venc -> FechaHelper::formato().
	// Opciones: 'primero' (día 1) | 'ultimo' (fin de mes)
	var DIA_VENCIMIENTO_JULIANO = exports.DIA_VENCIMIENTO_JULIANO = 'ultimo';
	
	// Cantidad de dígitos esperada según el formato configurado (mes + año)
	var DIGITOS_JULIANO = exports.DIGITOS_JULIANO = {
	    'MM-AAAA': 6,
	    'MM/AAAA': 6,
	    'MMAAAA': 6,
	    'MM-AA': 4,
	    'MM/AA': 4,
	    'MMAA': 4
	};
	
	var dosDigitos = exports.dosDigitos = function dosDigitos(numero) {
	    return String(numero).length < 2 ? '0' + numero : String(numero);
	};
	
	// 'AAAA-MM-DD' => {anio, mes, dia} | null si la fecha no es válida o está incompleta
	var leerFecha = exports.leerFecha = function leerFecha(valor) {
	    var partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(valor == null ? '' : valor).trim());
	    if (!partes) {
	        return null;
	    }
	    var fecha = {
	        anio: parseInt(partes[1], 10),
	        mes: parseInt(partes[2], 10),
	        dia: parseInt(partes[3], 10)
	    };
	    var valida = fecha.anio > 0 && fecha.mes >= 1 && fecha.mes <= 12 && fecha.dia >= 1 && fecha.dia <= 31;
	    return valida ? fecha : null;
	};
	
	// 'MM-AAAA' | 'MMAA' | 'MM-AA' | 'MM/AA' | 'MM/AAAA' => {anio, mes} | null
	var leerJuliano = exports.leerJuliano = function leerJuliano(valor) {
	    var digitos = String(valor == null ? '' : valor).replace(/\D/g, '');
	    //Sólo se sincroniza cuando la captura está completa (evita valores parciales como '12-20')
	    var digitosEsperados = DIGITOS_JULIANO[FORMATO_JULIANO] || 4;
	    if (digitos.length !== digitosEsperados) {
	        return null;
	    }
	    var mes = parseInt(digitos.substring(0, 2), 10);
	    var anio = parseInt(digitos.substring(2), 10);
	    if (!(mes >= 1 && mes <= 12) || isNaN(anio)) {
	        return null;
	    }
	    //Con 4 dígitos se asume que el año es de 2 dígitos (2000 + AA)
	    return { mes: mes, anio: digitosEsperados === 4 ? 2000 + anio : anio };
	};
	
	var escribirJuliano = exports.escribirJuliano = function escribirJuliano(mes, anio) {
	    switch (FORMATO_JULIANO) {
	        case 'MM-AAAA':
	            return dosDigitos(mes) + '-' + anio;
	        case 'MM-AA':
	            return dosDigitos(mes) + '-' + dosDigitos(anio % 100);
	        case 'MMAAAA':
	            return dosDigitos(mes) + anio;
	        case 'MM/AA':
	            return dosDigitos(mes) + '/' + dosDigitos(anio % 100);
	        case 'MM/AAAA':
	            return dosDigitos(mes) + '/' + anio;
	        default:
	            return dosDigitos(mes) + dosDigitos(anio % 100);
	    }
	};
	
	// {mes, anio} => 'AAAA-MM-DD' (usa el día configurado en DIA_VENCIMIENTO_JULIANO:
	// día 1 o último día del mes)
	var escribirFecha = exports.escribirFecha = function escribirFecha(mes, anio) {
	    var dia = DIA_VENCIMIENTO_JULIANO === 'primero' ? 1 : new Date(anio, mes, 0).getDate();
	    return anio + '-' + dosDigitos(mes) + '-' + dosDigitos(dia);
	};
	
	// Expresión regular de la Fecha Juliana según el formato configurado. Se exige la
	// forma completa (mes + separador + año) para que el usuario no pueda guardar un
	// texto que no sea interpretable como fecha juliana.
	var REGEX_JULIANO = {
	    'MM-AAAA': /^\d{2}-\d{4}$/,
	    'MM-AA': /^\d{2}-\d{2}$/,
	    'MMAAAA': /^\d{6}$/,
	    'MM/AA': /^\d{2}\/\d{2}$/,
	    'MM/AAAA': /^\d{2}\/\d{4}$/
	};
	var REGEX_JULIANO_FORMATO = REGEX_JULIANO[FORMATO_JULIANO] || /^\d+$/;
	
	// Mensaje corto que se muestra bajo el input de Fecha Juliana cuando el texto
	// escrito a mano no es una fecha interpretable (mes + año).
	// La Fecha Vencimiento no se valida: es un input type="date", por lo que el
	// navegador ya restringe las fechas posibles a su rango y no admite textos.
	var MENSAJE_JULIANO_INVALIDO = exports.MENSAJE_JULIANO_INVALIDO = 'Fecha ingresada fuera de rango';
	
	// Verificador de la Fecha Juliana escrita a mano en el input (mes + año).
	// Devuelve el mensaje de error si la fecha no es válida, o null si lo es.
	var validarFechaJuliano = exports.validarFechaJuliano = function validarFechaJuliano(valor) {
	    var texto = String(valor == null ? '' : valor).trim();
	    //Sin texto, con un formato distinto al configurado (FORMATO_JULIANO) o con
	    //mes/año fuera de rango: la captura no es interpretable como fecha juliana
	    if (texto === '' || !REGEX_JULIANO_FORMATO.test(texto) || !leerJuliano(texto)) {
	        return MENSAJE_JULIANO_INVALIDO;
	    }
	    return null;
	};
	
	// Campos a actualizar en la captura cuando se corrige la Fecha Vencimiento
	// (date, 'AAAA-MM-DD'). La Fecha Juliana se recalcula en simultáneo.
	var sincronizarDesdeFechaExp = exports.sincronizarDesdeFechaExp = function sincronizarDesdeFechaExp(valor) {
	    var actualizado = {
	        fecha_exp: valor,
	        editado: 1
	    };
	    var fecha = leerFecha(valor);
	    if (fecha) {
	        actualizado.fecha_venc = escribirJuliano(fecha.mes, fecha.anio);
	    }
	    return actualizado;
	};
	
	// Campos a actualizar en la captura cuando se corrige la Fecha Juliana
	// (fecha_venc, mes + año). La Fecha Vencimiento se recalcula en simultáneo con
	// el día configurado en DIA_VENCIMIENTO_JULIANO (último día del mes), siempre y
	// cuando la juliano esté completa.
	var sincronizarDesdeFechaVenc = exports.sincronizarDesdeFechaVenc = function sincronizarDesdeFechaVenc(valor) {
	    var actualizado = {
	        fecha_venc: valor,
	        editado: 1
	    };
	    var juliano = leerJuliano(valor);
	    if (juliano) {
	        //Siempre se recalcula la fecha (aunque el mes/año coincida con el que ya
	        //tenía), para que la vista y la base de datos guarden el mismo día: el
	        //configurado en DIA_VENCIMIENTO_JULIANO (último día del mes)
	        actualizado.fecha_exp = escribirFecha(juliano.mes, juliano.anio);
	    }
	    return actualizado;
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "fechasVencimiento.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormularioAgregarCapturas = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormularioAgregarAuditoria = __webpack_require__(735);
	
	var style = _interopRequireWildcard(_FormularioAgregarAuditoria);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	
	var PropTypes = _react2.default.PropTypes;
	// Styles
	
	var FormularioAgregarCapturas = exports.FormularioAgregarCapturas = function (_React$Component) {
	    _inherits(FormularioAgregarCapturas, _React$Component);
	
	    function FormularioAgregarCapturas(props) {
	        _classCallCheck(this, FormularioAgregarCapturas);
	
	        var _this = _possibleConstructorReturn(this, (FormularioAgregarCapturas.__proto__ || Object.getPrototypeOf(FormularioAgregarCapturas)).call(this, props));
	
	        _this.state = {
	            locales: [],
	            errores: {
	                errorIdCliente: '',
	                errorNumeroLocal: ''
	            },
	            pegados: {
	                pegadoConProblemas: [],
	                conteoTotal: 0,
	                conteoCorrectos: 0,
	                conteoProblemas: 0
	            },
	            inputPegar_error: '',
	            mostrarExcel: false
	        };
	        _this.mostrarPegarExcel = function () {
	            _this.setState({
	                mostrarExcel: true
	            });
	        };
	        _this.ocultarPegarExcel = function () {
	            _this.setState({
	                mostrarExcel: false
	            });
	        };
	        return _this;
	    }
	    /**
	     * Cambio en los campos del formulario
	     */
	
	
	    _createClass(FormularioAgregarCapturas, [{
	        key: 'setModoIngreso',
	        value: function setModoIngreso(modo) {
	            if (modo !== this.state.modoIngreso) {
	                this.setState({ modoIngreso: this.state.modoIngreso === 'manual' ? 'excel' : 'manual' });
	            }
	        }
	    }, {
	        key: 'getOpcionesSeleccionadas',
	        value: function getOpcionesSeleccionadas() {
	            return {
	                idCliente: this.state.idClienteSeleccionado,
	                mes: this.state.mesSeleccionado
	            };
	        }
	    }, {
	        key: 'agregarLocalesAlPegar',
	        value: function agregarLocalesAlPegar(event) {
	            var _this2 = this;
	
	            event.preventDefault();
	            // cuando se pegue un elemento, separar separar las filas por el "line feed" '\n'
	            event.clipboardData.items[0].getAsString(function (texto) {
	                // separar cada una de las filas '\n'
	                var rows = texto.trim().split('\n');
	                rows = rows.filter(function (row) {
	                    return row !== '';
	                });
	                var datosCapturas = rows.map(function (row) {
	                    var datos = row.trim().split('\t');
	                    return {
	                        idArchivoFinalAuditoria: _this2.props.idArchivoFinalAuditoria,
	                        idAuditoria: _this2.props.idAuditoria,
	                        tienda: datos[0],
	                        fecha_auditoria: datos[1],
	                        auditor: datos[2],
	                        rut_auditor: datos[3],
	                        qf: datos[4],
	                        rut_qf: datos[5],
	                        items: datos[6],
	                        sku: datos[7],
	                        barra: datos[8],
	                        descriptor: datos[9],
	                        laboratorio: datos[10],
	                        lote: datos[11],
	                        fecha_venc: datos[12],
	                        imagen: datos[13],
	                        fecha_captura: datos[14],
	                        hora_captura: datos[15],
	                        doble_foto: datos[16],
	                        revalidado: datos[17],
	                        cod_vendedor: datos[18],
	                        estado: datos[19]
	                    };
	                });
	                _this2.context.pegarCapturasVencimiento(datosCapturas);
	                _this2.setState({
	                    mostrarExcel: false
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'form' },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'btn btn-xs btn-success pull-right', onClick: this.state.mostrarExcel === false ? this.mostrarPegarExcel : this.ocultarPegarExcel, disabled: true },
	                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-paste' }),
	                    ' Pegar Desde Excel'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: this.state.mostrarExcel ? '' : 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-10 form-group ' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'locales' },
	                                'Pega tus capturas aqu\xED'
	                            ),
	                            _react2.default.createElement('input', { className: 'form-control', type: 'text', name: 'locales', placeholder: 'pegar ac\xE1 los datos de la captura vencimiento',
	                                onPaste: this.agregarLocalesAlPegar.bind(this)
	                                //disabled={this.props.puedeAgregar? '':'disabled'}/>
	                            }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { marginTop: '1em' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'TIENDA'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'FECHA AUDITORIA (DD-MM-YYYY)'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'AUDITOR'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'RUT AUDITOR'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'QF'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'RUT QF'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'ITEM'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'SKU'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'BARRA'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'DESCRIPTOR'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'LABORATORIO'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'LOTE'
	                                ),
	                                ' -',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'FECHA VENCIMIENTO (MM-AAAA)'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'IMAGEN'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'FECHA CAPTURA (DD-MM-YYYY)'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'HORA CAPTURA'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'DOBLE FOTO(0 \xF3 1)'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'REVALIDADO(0 \xF3 1)'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'RUT VENDEDOR'
	                                ),
	                                ' - ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'ESTADO(OBLIGATORIO o RESERVA)'
	                                ),
	                                '.'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormularioAgregarCapturas;
	}(_react2.default.Component);
	
	FormularioAgregarCapturas.contextTypes = {
	    pegarCapturasVencimiento: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FormularioAgregarCapturas.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modales = __webpack_require__(955);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _mantenedorLocal = __webpack_require__(957);
	
	var css = _interopRequireWildcard(_mantenedorLocal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	// Componentes
	
	// Styles
	
	
	var MantenedorLocales2 = function (_React$Component) {
	    _inherits(MantenedorLocales2, _React$Component);
	
	    function MantenedorLocales2(props) {
	        _classCallCheck(this, MantenedorLocales2);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorLocales2.__proto__ || Object.getPrototypeOf(MantenedorLocales2)).call(this, props));
	
	        _this.state = {
	            idCliente: "1",
	            localesRaw: [],
	            locales: [],
	            busquedaComuna: ''
	        };
	        _this.seleccionarCliente = function (evt) {
	            var idCliente = evt.target.value;
	            _this.setState({
	                idCliente: idCliente,
	                localesRaw: [],
	                locales: []
	            }, function () {
	                _this.fetchLocales();
	            });
	        };
	        _this.fetchLocales = function () {
	            _v2.default.cliente(_this.state.idCliente).getLocales().then(function (locales) {
	                _this.setState({ locales: locales, localesRaw: locales });
	            }).catch(function (meh) {});
	        };
	        _this.actualizarLocal = function (local) {
	            var request = _v2.default.local.actualizar(local.idLocal, local);
	            request.then(function () {
	                return _this.fetchLocales();
	            }).catch(function (meh) {});
	            return request;
	        };
	        _this.agregarLocal = function (local) {
	            var request = _v2.default.local.nuevo(local);
	            request.then(function () {
	                return _this.fetchLocales();
	            }).catch(function (meh) {});
	            return request;
	        };
	        _this.agregarLocalesPegar = function (locales) {
	            var request = _v2.default.local.nuevos(locales);
	            request.then(_this.fetchLocales).catch(function (err) {});
	            return request;
	        };
	        _this.realizarBusqueda = function (field, originalSearch) {
	            var value = typeof originalSearch === 'number' ? originalSearch : originalSearch.trim().toLowerCase();
	            _this.setState(_defineProperty({}, field, value), function () {
	                return _this.filtrarLocales();
	            });
	        };
	        _this.guardarGeolocalizacion = function (idLocal, lat, long) {
	            var request = _v2.default.local.geolocalizacion(idLocal, lat, long);
	            request.then(function () {
	                return _this.fetchLocales();
	            }).catch(function (meh) {});
	            return request;
	        };
	        _this.filtrarLocales = function () {
	            _this.setState({
	                locales: _this.state.localesRaw
	                //.filter(us=> us.RUN.indexOf(this.state.busquedaRUN)>=0)
	                //.filter(us=> us.apellidoPaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0  || us.apellidoMaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0)
	                //.filter(us=> us.nombre1.toLowerCase().indexOf(this.state.busquedaNombre)>=0  || us.nombre2.toLowerCase().indexOf(this.state.busquedaNombre)>=0)
	                //.filter(us=> us.captador.toLowerCase().indexOf(this.state.busquedaCaptador)>=0)
	                //.filter(us=> us.vigencia.toLowerCase().indexOf(this.state.busquedaVigencia)>=0)
	                //.filter(us=> us.isContractFile.toLowerCase().indexOf(this.state.searchStatusContract)>=0)
	                .filter(function (lo) {
	                    return lo.comuna_nombre.toLowerCase().indexOf(_this.state.busquedaComuna) >= 0;
	                })
	            });
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorLocales2, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchLocales();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var busquedaComuna = this.state.busquedaComuna;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Mantenedor de Locales'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right', style: { marginTop: '25px' } },
	                            _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-success', onClick: showModal },
	                                        'Agregar Local',
	                                        isVisible && _react2.default.createElement(_Modales.ModalAgregarLocal, {
	                                            agregarLocal: _this2.agregarLocal,
	                                            hideModal: hideModal,
	                                            idCliente: _this2.state.idCliente,
	                                            jornadas: _this2.props.jornadas,
	                                            comunas: _this2.props.comunas,
	                                            formatoLocales: _this2.props.formatoLocales
	                                        })
	                                    );
	                                }
	                            ),
	                            _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-success', onClick: showModal },
	                                        'Pegar Locales',
	                                        isVisible && _react2.default.createElement(_Modales.ModalPegarLocales, {
	                                            agregarLocales: _this2.agregarLocalesPegar,
	                                            hideModal: hideModal,
	                                            idCliente: _this2.state.idCliente,
	                                            jornadas: _this2.props.jornadas,
	                                            comunas: _this2.props.comunas,
	                                            formatoLocales: _this2.props.formatoLocales
	                                        })
	                                    );
	                                }
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(SelectorCliente, {
	                    idClienteSeleccionado: this.state.idCliente,
	                    seleccionarCliente: this.seleccionarCliente,
	                    clientes: this.props.clientes
	                }),
	                _react2.default.createElement(Locales, {
	                    locales: this.state.locales,
	                    jornadas: this.props.jornadas,
	                    formatoLocales: this.props.formatoLocales,
	                    comunas: this.props.comunas,
	                    actualizarLocal: this.actualizarLocal,
	                    busquedaComuna: busquedaComuna,
	                    realizarBusqueda: this.realizarBusqueda.bind(this, 'busquedaComuna'),
	                    guardar: this.guardarGeolocalizacion
	                })
	            );
	        }
	    }]);
	
	    return MantenedorLocales2;
	}(_react2.default.Component);
	
	exports.default = MantenedorLocales2;
	
	
	var SelectorCliente = function SelectorCliente(_ref) {
	    var idClienteSeleccionado = _ref.idClienteSeleccionado,
	        seleccionarCliente = _ref.seleccionarCliente,
	        clientes = _ref.clientes;
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-sm-3 form-group ' },
	            _react2.default.createElement(
	                'label',
	                { className: 'control-label', htmlFor: 'cliente' },
	                'Cliente'
	            ),
	            _react2.default.createElement(
	                'select',
	                { className: 'form-control', name: 'cliente',
	                    value: idClienteSeleccionado,
	                    onChange: seleccionarCliente
	                },
	                _react2.default.createElement(
	                    'option',
	                    { value: '-1', disabled: true },
	                    '--'
	                ),
	                clientes.map(function (cliente) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: cliente.idCliente, value: cliente.idCliente },
	                        cliente.nombreCorto + ' - ' + cliente.nombre
	                    );
	                })
	            )
	        )
	    );
	};
	
	var Locales = function Locales(_ref2) {
	    var locales = _ref2.locales,
	        jornadas = _ref2.jornadas,
	        formatoLocales = _ref2.formatoLocales,
	        comunas = _ref2.comunas,
	        actualizarLocal = _ref2.actualizarLocal,
	        busquedaComuna = _ref2.busquedaComuna,
	        realizarBusqueda = _ref2.realizarBusqueda,
	        guardar = _ref2.guardar;
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '80%' }, className: css.tablaMantenedorLocales },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref3) {
	                var height = _ref3.height,
	                    width = _ref3.width;
	                return _react2.default.createElement(
	                    _reactVirtualized.Table
	
	                    // general
	                    ,
	                    { height: height,
	                        width: width
	                        // headers
	                        , headerHeight: 30,
	                        headerClassName: css.headerColumn
	                        // rows
	                        , rowCount: locales.length,
	                        rowGetter: function rowGetter(_ref4) {
	                            var index = _ref4.index;
	                            return locales[index];
	                        },
	                        rowHeight: 30,
	                        rowClassName: function rowClassName(_ref5) {
	                            var index = _ref5.index;
	                            return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                        }
	                    },
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'cliente', label: 'CL',
	                        cellRenderer: function cellRenderer(_ref6) {
	                            var cellData = _ref6.cellData,
	                                columnData = _ref6.columnData,
	                                dataKey = _ref6.dataKey,
	                                rowData = _ref6.rowData,
	                                rowIndex = _ref6.rowIndex;
	                            return rowData.cliente.nombreCorto;
	                        },
	                        width: 40
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'numero', label: 'CECO',
	                        cellRenderer: function cellRenderer(_ref7) {
	                            var cellData = _ref7.cellData,
	                                columnData = _ref7.columnData,
	                                dataKey = _ref7.dataKey,
	                                rowData = _ref7.rowData,
	                                rowIndex = _ref7.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 40
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'nombre', label: 'Nombre',
	                        cellRenderer: function cellRenderer(_ref8) {
	                            var cellData = _ref8.cellData,
	                                columnData = _ref8.columnData,
	                                dataKey = _ref8.dataKey,
	                                rowData = _ref8.rowData,
	                                rowIndex = _ref8.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 120
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'formatoLocal_nombre', label: 'Formato',
	                        cellRenderer: function cellRenderer(_ref9) {
	                            var cellData = _ref9.cellData,
	                                columnData = _ref9.columnData,
	                                dataKey = _ref9.dataKey,
	                                rowData = _ref9.rowData,
	                                rowIndex = _ref9.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 120
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'jornadaSugerida', label: 'Jornada',
	                        cellRenderer: function cellRenderer(_ref10) {
	                            var cellData = _ref10.cellData,
	                                columnData = _ref10.columnData,
	                                dataKey = _ref10.dataKey,
	                                rowData = _ref10.rowData,
	                                rowIndex = _ref10.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 70
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'horaApertura', label: 'Apertura',
	                        cellRenderer: function cellRenderer(_ref11) {
	                            var cellData = _ref11.cellData,
	                                columnData = _ref11.columnData,
	                                dataKey = _ref11.dataKey,
	                                rowData = _ref11.rowData,
	                                rowIndex = _ref11.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 70
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'horaCierre', label: 'Cierre',
	                        cellRenderer: function cellRenderer(_ref12) {
	                            var cellData = _ref12.cellData,
	                                columnData = _ref12.columnData,
	                                dataKey = _ref12.dataKey,
	                                rowData = _ref12.rowData,
	                                rowIndex = _ref12.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 50
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'emailContacto', label: 'Email',
	                        cellRenderer: function cellRenderer(_ref13) {
	                            var cellData = _ref13.cellData,
	                                columnData = _ref13.columnData,
	                                dataKey = _ref13.dataKey,
	                                rowData = _ref13.rowData,
	                                rowIndex = _ref13.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'telefono1', label: 'Telefono',
	                        cellRenderer: function cellRenderer(_ref14) {
	                            var cellData = _ref14.cellData,
	                                columnData = _ref14.columnData,
	                                dataKey = _ref14.dataKey,
	                                rowData = _ref14.rowData,
	                                rowIndex = _ref14.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 85
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'telefono2', label: '',
	                        cellRenderer: function cellRenderer(_ref15) {
	                            var cellData = _ref15.cellData,
	                                columnData = _ref15.columnData,
	                                dataKey = _ref15.dataKey,
	                                rowData = _ref15.rowData,
	                                rowIndex = _ref15.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 85
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'stock', label: 'Stock',
	                        cellRenderer: function cellRenderer(_ref16) {
	                            var cellData = _ref16.cellData,
	                                columnData = _ref16.columnData,
	                                dataKey = _ref16.dataKey,
	                                rowData = _ref16.rowData,
	                                rowIndex = _ref16.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        width: 50
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'comuna_nombre', label: 'Comuna',
	                        cellRenderer: function cellRenderer(_ref17) {
	                            var cellData = _ref17.cellData,
	                                columnData = _ref17.columnData,
	                                dataKey = _ref17.dataKey,
	                                rowData = _ref17.rowData,
	                                rowIndex = _ref17.rowIndex;
	                            return rowData[dataKey];
	                        },
	                        headerRenderer: function headerRenderer() {
	                            return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                nombre: 'Comuna',
	                                busqueda: busquedaComuna,
	                                realizarBusqueda: realizarBusqueda
	                            });
	                        },
	                        width: 100
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'direccion', label: 'Direcci\xF3n',
	                        width: 200,
	                        flexGrow: 1,
	                        cellRenderer: function cellRenderer(_ref18) {
	                            var rowData = _ref18.rowData;
	                            var direccion = rowData.direccion,
	                                gmap_lat = rowData.gmap_lat,
	                                gmap_long = rowData.gmap_long,
	                                comuna_nombre = rowData.comuna_nombre,
	                                idLocal = rowData.idLocal;
	
	                            if (gmap_lat && gmap_long) {
	                                var url = 'https://www.google.com/maps?q=' + gmap_lat + ',' + gmap_long;
	                                return _react2.default.createElement(
	                                    'a',
	                                    { href: url, target: '_blank', rel: 'noopener noreferrer' },
	                                    direccion,
	                                    ' ',
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-map-marker' })
	                                );
	                            }
	                            return _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { style: { cursor: 'pointer' }, onClick: showModal },
	                                        direccion,
	                                        isVisible && _react2.default.createElement(_Modales.ModalDireccion, {
	                                            hideModal: hideModal,
	                                            direccion: direccion,
	                                            comuna: comuna_nombre,
	                                            id: idLocal,
	                                            onGuardar: guardar
	                                        })
	                                    );
	                                }
	                            );
	                        }
	                    }),
	                    _react2.default.createElement(_reactVirtualized.Column, {
	                        dataKey: 'direccion', label: 'Opciones',
	                        cellRenderer: function cellRenderer(_ref19) {
	                            var cellData = _ref19.cellData,
	                                columnData = _ref19.columnData,
	                                dataKey = _ref19.dataKey,
	                                rowData = _ref19.rowData,
	                                rowIndex = _ref19.rowIndex;
	                            return _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-xs btn-primary', onClick: showModal },
	                                        'Editar',
	                                        isVisible && _react2.default.createElement(_Modales.ModalEditarLocal, {
	                                            local: rowData,
	                                            hideModal: hideModal,
	                                            jornadas: jornadas,
	                                            comunas: comunas,
	                                            formatoLocales: formatoLocales,
	                                            actualizarLocal: actualizarLocal
	                                        })
	                                    );
	                                }
	                            );
	                        },
	                        width: 80
	                    })
	                );
	            }
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorLocales2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LiderDetalles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaLiderDetalles = __webpack_require__(1061);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var LiderDetalles = exports.LiderDetalles = function (_React$Component) {
	    _inherits(LiderDetalles, _React$Component);
	
	    function LiderDetalles(props) {
	        _classCallCheck(this, LiderDetalles);
	
	        var _this = _possibleConstructorReturn(this, (LiderDetalles.__proto__ || Object.getPrototypeOf(LiderDetalles)).call(this, props));
	
	        _this.state = {
	            lideres: [],
	            comunas: []
	        };
	        _this.getComunas = function () {
	            _v2.default.otros.comunas().then(function (comunas) {
	                _this.setState({ comunas: comunas });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(LiderDetalles, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                guardarDetalle: function guardarDetalle(idLiderDetalle, datos) {
	                    return _v2.default.fondos().nuevoDetalleLider(idLiderDetalle, datos);
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            _v2.default.fondos().getLideres().then(function (lideres) {
	                _v2.default.otros.comunas().then(function (comunas) {
	                    _this2.setState({ comunas: comunas, lideres: lideres });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 form-group' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Mantenedor Lideres'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(_TablaLiderDetalles.TablaLiderDetalles, {
	                        lideres: this.state.lideres,
	                        comunas: this.state.comunas
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LiderDetalles;
	}(_react2.default.Component);
	
	LiderDetalles.childContextTypes = {
	    guardarDetalle: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "LiderDetalles.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaLiderDetalles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LiderDetalles = __webpack_require__(1062);
	
	var css = _interopRequireWildcard(_LiderDetalles);
	
	var _RowLiderDetalles = __webpack_require__(1063);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var TablaLiderDetalles = exports.TablaLiderDetalles = function (_React$Component) {
	    _inherits(TablaLiderDetalles, _React$Component);
	
	    function TablaLiderDetalles(props) {
	        _classCallCheck(this, TablaLiderDetalles);
	
	        var _this = _possibleConstructorReturn(this, (TablaLiderDetalles.__proto__ || Object.getPrototypeOf(TablaLiderDetalles)).call(this, props));
	
	        _this.rows = [];
	        return _this;
	    }
	
	    _createClass(TablaLiderDetalles, [{
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length;
	            var elemento = nombreElemento;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(elemento);
	            } else if (index >= ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
	                if (elemento === 'inputColacion') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputMedioViatico';else if (elemento === 'inputMedioViatico') elemento = 'inputIdComunaOrigen';else if (elemento === 'inputIdComunaOrigen') elemento = 'inputIdComunaSecundaria';else if (elemento === 'inputIdComunaSecundaria') elemento = 'inputColacion';
	                this.rows[0].focusElemento(elemento);
	            } else {
	                // no es ni el ultimo, ni el primero
	                this.rows[index].focusElemento(elemento);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadLideres = this.props.lideres.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                cantidadLideres > 0 ? _react2.default.createElement(
	                    TablaLiderDetalle,
	                    null,
	                    _.range(0, cantidadLideres).map(function (index) {
	                        var lider = _this2.props.lideres[index];
	                        return _react2.default.createElement(_RowLiderDetalles.RowLiderDetalles, {
	                            key: index,
	                            index: index,
	                            ref: function ref(_ref) {
	                                return _this2.rows[index] = _ref;
	                            },
	                            focusRow: _this2.focusRow.bind(_this2),
	                            lider: lider,
	                            comunas: _this2.props.comunas
	                        });
	                    })
	                ) : _react2.default.createElement(
	                    'label',
	                    null,
	                    'Cargando l\xEDderes...'
	                )
	            );
	        }
	    }]);
	
	    return TablaLiderDetalles;
	}(_react2.default.Component);
	
	var TablaLiderDetalle = function TablaLiderDetalle(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-list' }),
	            ' Detalles'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'table',
	                { className: "table table-bordered table-condensed table-striped" + css.tableFixed },
	                _react2.default.createElement(
	                    'colgroup',
	                    null,
	                    _react2.default.createElement('col', { className: css.colRut }),
	                    _react2.default.createElement('col', { className: css.colNombre }),
	                    _react2.default.createElement('col', { className: css.colColacion }),
	                    _react2.default.createElement('col', { className: css.colViatico }),
	                    _react2.default.createElement('col', { className: css.colViatico }),
	                    _react2.default.createElement('col', { className: css.colOrigen }),
	                    _react2.default.createElement('col', { className: css.colOrigen })
	                ),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thRut },
	                            'Rut'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thNombre },
	                            'Nombre'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thColacion },
	                            'Colaci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.tdViatico },
	                            'Vi\xE1tico 100%'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.tdViatico },
	                            'Vi\xE1tico 50%'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thOrigen },
	                            'Origen 1'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thOrigen },
	                            'Origen 2'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    children
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaLiderDetalles.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"LiderDetalles__tableFixed___NuCV_","trSeparador":"LiderDetalles__trSeparador___1Nrd0","colRut":"LiderDetalles__colRut___F3DMd","thRut":"LiderDetalles__thRut___1dJee","tdRut":"LiderDetalles__tdRut___1pfDX","colNombre":"LiderDetalles__colNombre___t-3j3","thNombre":"LiderDetalles__thNombre___1sMzg","tdNombre":"LiderDetalles__tdNombre___1i31h","colColacion":"LiderDetalles__colColacion___3rgzW","thColacion":"LiderDetalles__thColacion___15904","tdColacion":"LiderDetalles__tdColacion___3n2Px","colViatico":"LiderDetalles__colViatico___rTMAO","thViatico":"LiderDetalles__thViatico___WrBGj","tdViatico":"LiderDetalles__tdViatico___1w2sM","colOrigen":"LiderDetalles__colOrigen___zmsff","thOrigen":"LiderDetalles__thOrigen___705GX","tdOrigen":"LiderDetalles__tdOrigen___3cLzt","inputGeneral":"LiderDetalles__inputGeneral___1Me6S"};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowLiderDetalles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LiderDetalles = __webpack_require__(1062);
	
	var css = _interopRequireWildcard(_LiderDetalles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowLiderDetalles = exports.RowLiderDetalles = function (_React$Component) {
	    _inherits(RowLiderDetalles, _React$Component);
	
	    function RowLiderDetalles(props) {
	        _classCallCheck(this, RowLiderDetalles);
	
	        var _this = _possibleConstructorReturn(this, (RowLiderDetalles.__proto__ || Object.getPrototypeOf(RowLiderDetalles)).call(this, props));
	
	        _this.inputOnKeyDown = _this.inputOnKeyDown.bind(_this);
	        _this.buscarComuna = _this.buscarComuna.bind(_this);
	        _this.state = {
	            detalleLider: [],
	            comunas: []
	        };
	        _this.onInputChange = function (key, evt) {
	            var actualizado = {};
	            if (key === 'idComunaOrigen') {
	                actualizado[key] = _this.buscarComuna(evt.target.value);
	                actualizado.nombreComunaOrigen = evt.target.value;
	            } else if (key === 'idComunaSecundaria') {
	                actualizado[key] = _this.buscarComuna(evt.target.value);
	                actualizado.nombreComunaSecundaria = evt.target.value;
	            } else {
	                actualizado[key] = evt.target.value;
	            }
	
	            if (key == 'viatico' && evt.target.value) actualizado.medioViatico = evt.target.value / 2;
	            actualizado.dirty = 1;
	            _this.setState({ detalleLider: Object.assign({}, _this.state.detalleLider, actualizado) });
	        };
	        _this.onInputBlur = function () {
	            if (_this.state.detalleLider.dirty) {
	                _this.context.guardarDetalle(_this.state.detalleLider.idLiderDetalle, _this.state.detalleLider).then(function (resp) {
	                    console.log(resp);
	                    var detalleLider = _this.state.detalleLider;
	                    detalleLider.idLiderDetalle = resp;
	                    _this.setState({
	                        detalleLider: detalleLider
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        return _this;
	    }
	
	    _createClass(RowLiderDetalles, [{
	        key: 'buscarComuna',
	        value: function buscarComuna(nombre) {
	            for (var i = 0; i < this.state.comunas.length; i++) {
	                if (this.state.comunas[i].nombre === nombre) {
	                    return this.state.comunas[i].cutComuna;
	                }
	            }
	        }
	    }, {
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            this[elemento].focus();
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(key, evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.focusRow(this.props.index + 1, key);
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                this.props.focusRow(this.props.index - 1, key);
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                comunas: this.props.comunas,
	                detalleLider: this.props.lider
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRut, title: this.props.index },
	                    this.state.detalleLider.usuarioRUN + "-" + this.state.detalleLider.usuarioDV
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNombre },
	                    this.state.detalleLider.nombreCorto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdColacion },
	                    _react2.default.createElement('input', { type: 'number', className: "form-control " + css.inputGeneral,
	                        ref: function ref(colacion) {
	                            _this2.inputColacion = colacion;
	                        },
	                        min: '0',
	                        value: this.state.detalleLider.colacion,
	                        disabled: !this.state.detalleLider.estado_lider,
	                        onFocus: function onFocus() {
	                            _this2.inputColacion.select();
	                        },
	                        onKeyDown: this.inputOnKeyDown.bind(this, 'inputColacion'),
	                        onChange: this.onInputChange.bind(this, 'colacion'),
	                        onBlur: this.onInputBlur })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdViatico },
	                    _react2.default.createElement('input', { type: 'number', className: "form-control " + css.inputGeneral,
	                        ref: function ref(viatico) {
	                            _this2.inputViatico = viatico;
	                        },
	                        min: '0',
	                        value: this.state.detalleLider.viatico,
	                        disabled: !this.state.detalleLider.estado_lider,
	                        onFocus: function onFocus() {
	                            _this2.inputViatico.select();
	                        },
	                        onKeyDown: this.inputOnKeyDown.bind(this, 'inputViatico'),
	                        onChange: this.onInputChange.bind(this, 'viatico'),
	                        onBlur: this.onInputBlur })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdViatico },
	                    _react2.default.createElement('input', { type: 'number', className: "form-control " + css.inputGeneral,
	                        ref: function ref(medioViatico) {
	                            _this2.inputMedioViatico = medioViatico;
	                        },
	                        min: '0',
	                        value: this.state.detalleLider.medioViatico,
	                        disabled: !this.state.detalleLider.estado_lider,
	                        onFocus: function onFocus() {
	                            _this2.inputMedioViatico.select();
	                        },
	                        onKeyDown: this.inputOnKeyDown.bind(this, 'inputMedioViatico'),
	                        onChange: this.onInputChange.bind(this, 'medioViatico'),
	                        onBlur: this.onInputBlur })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOrigen },
	                    _react2.default.createElement('input', { type: 'text', list: 'comunas', placeholder: 'Buscar comuna',
	                        className: "form-control " + css.inputGeneral,
	                        ref: function ref(idComunaOrigen) {
	                            _this2.inputIdComunaOrigen = idComunaOrigen;
	                        },
	                        value: this.state.detalleLider.nombreComunaOrigen,
	                        disabled: !this.state.detalleLider.estado_lider,
	                        onKeyDown: this.inputOnKeyDown.bind(this, 'inputIdComunaOrigen'),
	                        onChange: this.onInputChange.bind(this, 'idComunaOrigen'),
	                        onBlur: this.onInputBlur }),
	                    _react2.default.createElement(
	                        'datalist',
	                        { id: 'comunas' },
	                        this.state.comunas.map(function (comuna, index) {
	                            return _react2.default.createElement('option', { key: comuna.cutComuna, value: comuna.nombre });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOrigen },
	                    _react2.default.createElement('input', { type: 'text', list: 'comunas', placeholder: 'Buscar comuna',
	                        className: "form-control " + css.inputGeneral,
	                        ref: function ref(idComunaSecundaria) {
	                            _this2.inputIdComunaSecundaria = idComunaSecundaria;
	                        },
	                        value: this.state.detalleLider.nombreComunaSecundaria,
	                        disabled: !this.state.detalleLider.estado_lider,
	                        onKeyDown: this.inputOnKeyDown.bind(this, 'inputIdComunaSecundaria'),
	                        onChange: this.onInputChange.bind(this, 'idComunaSecundaria'),
	                        onBlur: this.onInputBlur }),
	                    _react2.default.createElement(
	                        'datalist',
	                        { id: 'comunas' },
	                        this.state.comunas.map(function (comuna, index) {
	                            return _react2.default.createElement('option', { key: comuna.cutComuna, value: comuna.nombre });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowLiderDetalles;
	}(_react2.default.Component);
	
	RowLiderDetalles.contextTypes = {
	    guardarDetalle: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowLiderDetalles.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StockStores = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _stockService = __webpack_require__(1065);
	
	var _stockService2 = _interopRequireDefault(_stockService);
	
	var _Header = __webpack_require__(1066);
	
	var _PendingStores = __webpack_require__(1068);
	
	var _ResultUpdate = __webpack_require__(1070);
	
	var _SelectClient = __webpack_require__(1071);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// service
	
	// components
	
	
	var StockStores = exports.StockStores = function (_Component) {
	    _inherits(StockStores, _Component);
	
	    function StockStores(props) {
	        _classCallCheck(this, StockStores);
	
	        var _this = _possibleConstructorReturn(this, (StockStores.__proto__ || Object.getPrototypeOf(StockStores)).call(this, props));
	
	        _this.state = {
	            error: '',
	            resultado: [],
	            storesPending: [],
	            idClient: _this.props.clients[0].idCliente,
	            realizandoPeticion: false,
	            showModalPasteStock: false,
	            showResultUpdate: false,
	            showPendingStores: true
	        };
	
	        _this.cancelModalPasteStock = function () {
	            _this.setState({ showModalPasteStock: false });
	        };
	
	        _this.showModalPasteStock = function () {
	            _this.setState({ showModalPasteStock: true });
	        };
	
	        _this.onPasteData = function (evt) {
	            _this.setState({
	                resultado: [],
	                realizandoPeticion: true
	            });
	            evt.preventDefault();
	            evt.clipboardData.items[0].getAsString(function (texto) {
	                var rows_texto = texto.trim().split('\n');
	                rows_texto = rows_texto.filter(function (row) {
	                    return row !== '';
	                });
	
	                var rows_array = rows_texto.map(function (row) {
	                    var _row = row.trim().split('\t');
	                    if (_row.length < 2) return null;
	                    return {
	                        'numero': _row[0],
	                        'stock': _row[1].replace('.', '')
	                    };
	                }).filter(function (row) {
	                    return row != null;
	                });
	
	                _this.sendStock(rows_array);
	            });
	        };
	
	        _this.sendStock = function (data) {
	            _v2.default.local.enviarPegarStock(_this.state.idClient, data).then(function (datos) {
	                _this.setState({
	                    realizandoPeticion: false,
	                    resultado: datos,
	                    error: ''
	                });
	                _this.cancelModalPasteStock();
	                _this.showResultUpdate();
	                _this.fetchPendingStores();
	            }).catch(function (err) {
	                var data = err.data;
	                var mensajeError = data.error ? data.error : "Ocurrio un error al cargar el archivo";
	                _this.setState({
	                    realizandoPeticion: false,
	                    error: mensajeError
	                });
	                _this.refs.notificator.error("Error", mensajeError, 4 * 1000);
	            });
	        };
	
	        _this.showResultUpdate = function () {
	            _this.setState({
	                showResultUpdate: true,
	                showPendingStores: false
	            });
	        };
	
	        _this.showPendingStores = function () {
	            _this.setState({
	                showResultUpdate: false,
	                showPendingStores: true
	            });
	        };
	
	        _this.fetchPendingStores = function () {
	            _stockService2.default.stock.pendingStores(_this.state.idClient).then(function (storesPending) {
	                _this.setState({ storesPending: storesPending });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	
	        _this.onSelectClientChanged = function (idClient) {
	            _this.setState({ idClient: idClient }, function () {
	                return _this.fetchPendingStores();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(StockStores, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fetchPendingStores();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                realizandoPeticion = _state.realizandoPeticion,
	                showModalPasteStock = _state.showModalPasteStock,
	                showResultUpdate = _state.showResultUpdate,
	                showPendingStores = _state.showPendingStores,
	                storesPending = _state.storesPending,
	                resultado = _state.resultado;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(ModalPasteStock, {
	                    onProcess: realizandoPeticion,
	                    showModal: showModalPasteStock,
	                    cancelModal: this.cancelModalPasteStock,
	                    onPasteData: this.onPasteData
	                }),
	                _react2.default.createElement(_Header.Header, {
	                    clients: this.props.clients,
	                    showModalPasteStock: this.showModalPasteStock,
	                    showResultUpdate: this.showResultUpdate,
	                    showPendingStores: this.showPendingStores,
	                    isShowResultUpdate: showResultUpdate,
	                    isShowPendingStores: showPendingStores
	                }),
	                this.props.canShowSelect ? _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_SelectClient.SelectClient, {
	                        clients: this.props.clients,
	                        onSelectClientChanged: this.onSelectClientChanged
	                    })
	                ) : null,
	                showPendingStores ? _react2.default.createElement(_PendingStores.PendingStores, { storesPending: storesPending }) : null,
	                showResultUpdate ? _react2.default.createElement(_ResultUpdate.ResultUpdate, { result: resultado }) : null
	            );
	        }
	    }]);
	
	    return StockStores;
	}(_react.Component);
	
	StockStores.propTypes = {
	    clients: _react.PropTypes.array.isRequired,
	    canShowSelect: _react.PropTypes.bool.isRequired
	
	};
	
	var ModalPasteStock = function ModalPasteStock(_ref) {
	    var showModal = _ref.showModal,
	        cancelModal = _ref.cancelModal,
	        onPasteData = _ref.onPasteData,
	        onProcess = _ref.onProcess;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: showModal, onHide: cancelModal },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Pegar stock de locales'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Copia la columna correspondiente a ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'n\xFAmero local'
	                ),
	                ' y ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'stock'
	                ),
	                ' de su planilla excel y p\xE9galos en el siguiente recuadro.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', {
	                type: 'text',
	                className: 'form-control',
	                placeholder: 'Pega aqu\xED n\xFAmero local y stock',
	                onPaste: onPasteData,
	                onKeyDown: function onKeyDown(evt) {
	                    if (!(evt.ctrlKey && evt.keyCode == 86)) evt.preventDefault();
	                },
	                disabled: onProcess
	            }),
	            onProcess ? _react2.default.createElement(
	                'h6',
	                null,
	                'Favor espere, el Pop up desaparecer\xE1 autom\xE1ticamente cuando termine el proceso.'
	            ) : null
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "StockStores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	var axiosRaw = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response.message);
	    } else {
	        return Promise.resolve(response.data);
	    }
	});
	axiosRaw.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response);
	    } else {
	        return Promise.resolve(response);
	    }
	});
	
	exports.default = {
	    stock: {
	        pendingStores: function pendingStores(idClient) {
	            return axios.get('/api/stock/' + idClient + '/pending-stores');
	        }
	
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "stockService.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(1067);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header(_ref) {
	    var isShowPendingStores = _ref.isShowPendingStores,
	        isShowResultUpdate = _ref.isShowResultUpdate,
	        showPendingStores = _ref.showPendingStores,
	        showResultUpdate = _ref.showResultUpdate,
	        showModalPasteStock = _ref.showModalPasteStock;
	    return _react2.default.createElement(
	        'div',
	        { className: 'page-header ' + _Header2.default.Header_pageHeader },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-9' },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Stock de locales ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    'actualizaci\xF3n'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-pills ' + _Header2.default.Header_navPills },
	            _react2.default.createElement(
	                'li',
	                { role: 'presentation', className: isShowPendingStores ? 'active' : '' },
	                _react2.default.createElement(
	                    'a',
	                    { onClick: showPendingStores },
	                    'Pendientes'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { role: 'presentation', className: isShowResultUpdate ? 'active' : '' },
	                _react2.default.createElement(
	                    'a',
	                    { onClick: showResultUpdate },
	                    'Resultado'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { role: 'presentation' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-md btn-info', onClick: showModalPasteStock },
	                    'Actualizar'
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Header.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header_pageHeader":"Header__Header_pageHeader___2oYUK","Header_navPills":"Header__Header_navPills___1G-yA"};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PendingStores = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PendingStores = __webpack_require__(1069);
	
	var _PendingStores2 = _interopRequireDefault(_PendingStores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingStores = exports.PendingStores = function PendingStores(_ref) {
	    var storesPending = _ref.storesPending;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-warning' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Locales con inventarios cercanos y con stock desactualizado',
	            _react2.default.createElement('span', { className: 'pull-right glyphicon glyphicon-warning-sign' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body ' + _PendingStores2.default.PendingStores_panelBody },
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped table-hover ' + _PendingStores2.default.PendingStores_table },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PendingStores2.default.PendingStores_thIndex },
	                                '#'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'CECO'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Local'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: _PendingStores2.default.PendingStores_thAddress },
	                                'Direcci\xF3n'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Stock'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Fecha Stock'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Pr\xF3ximo Inventario'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        storesPending.length === 0 ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '8', style: { textAlign: 'center' } },
	                                'No se encontraron registros'
	                            )
	                        ) : null,
	                        storesPending.map(function (data, index) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PendingStores2.default.PendingStores_tdNumbers },
	                                    data.store_ceco
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    data.store_name
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    data.store_comuna
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    data.store_address
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _PendingStores2.default.PendingStores_tdNumbers },
	                                    data.inventory_stock.toLocaleString("es-CL")
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    data.inventory_stock_date
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    data.inventory_date
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PendingStores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PendingStores_table":"PendingStores__PendingStores_table___10y9O","PendingStores_panelBody":"PendingStores__PendingStores_panelBody___1tVy5","PendingStores_tdNumbers":"PendingStores__PendingStores_tdNumbers___3IDL-","PendingStores_thAddress":"PendingStores__PendingStores_thAddress___1QrUl","PendingStores_thCeco":"PendingStores__PendingStores_thCeco___2jTHb"};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResultUpdate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PendingStores = __webpack_require__(1069);
	
	var _PendingStores2 = _interopRequireDefault(_PendingStores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ResultUpdate = exports.ResultUpdate = function ResultUpdate(_ref) {
	    var result = _ref.result;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-info' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Resultado actualizaci\xF3n stocks de locales',
	            _react2.default.createElement('span', { className: 'pull-right glyphicon glyphicon-info-sign' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body ' + _PendingStores2.default.PendingStores_panelBody },
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped table-hover ' + _PendingStores2.default.PendingStores_table },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Local'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Inventario'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Resultado'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        result.length === 0 ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '3', style: { textAlign: 'center' } },
	                                'No se encontraron registros'
	                            )
	                        ) : null,
	                        result.map(function (local, index) {
	                            // construir el row con el resultado del local
	                            var localTR = _react2.default.createElement(
	                                'tr',
	                                { key: index, className: local.error ? 'danger' : '' },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    local.cliente,
	                                    ' - ',
	                                    local.local
	                                ),
	                                _react2.default.createElement('td', null),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    local.error ? local.error : local.estado
	                                )
	                            );
	                            if (local.inventarios.length == 0) return localTR;
	
	                            // construir el row con el resultado de los inventarios asociados al local
	                            var inventariosTR = local.inventarios.map(function (inv, index2) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: index + '--' + index2, className: inv.error ? 'success' : '' },
	                                    _react2.default.createElement('td', null),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        inv.fechaProgramada
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        inv.error ? inv.error : inv.estado
	                                    )
	                                );
	                            });
	                            return [localTR].concat(_toConsumableArray(inventariosTR));
	                        })
	                    )
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ResultUpdate.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectClient = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectClient = __webpack_require__(1072);
	
	var _SelectClient2 = _interopRequireDefault(_SelectClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectClient = exports.SelectClient = function (_Component) {
	    _inherits(SelectClient, _Component);
	
	    function SelectClient(props) {
	        _classCallCheck(this, SelectClient);
	
	        var _this = _possibleConstructorReturn(this, (SelectClient.__proto__ || Object.getPrototypeOf(SelectClient)).call(this, props));
	
	        _this.state = {
	            idClientDefault: 1
	        };
	
	        _this.onSelectClientChanged = function (evt) {
	            var idClient = evt.target.value;
	            _this.setState({ idClientDefault: idClient });
	            _this.props.onSelectClientChanged(idClient);
	        };
	        return _this;
	    }
	
	    _createClass(SelectClient, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-2 ' + _SelectClient2.default.SelectClient_div },
	                _react2.default.createElement(
	                    'select',
	                    { className: 'form-control', name: 'selectCliente',
	                        value: this.state.idClientDefault,
	                        onChange: this.onSelectClientChanged
	                    },
	                    this.props.clients.map(function (client, index) {
	                        return _react2.default.createElement(
	                            'option',
	                            { key: index, value: client.idCliente },
	                            client.nombre
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SelectClient;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SelectClient.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SelectClient_div":"SelectClient__SelectClient_div___2BpWD"};

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorPersonal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _TablaPersonal = __webpack_require__(1074);
	
	var _Modales = __webpack_require__(1075);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// ReactNotify
	
	// Componentes
	
	var MantenedorPersonal = exports.MantenedorPersonal = function (_React$Component) {
	    _inherits(MantenedorPersonal, _React$Component);
	
	    function MantenedorPersonal(props) {
	        _classCallCheck(this, MantenedorPersonal);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorPersonal.__proto__ || Object.getPrototypeOf(MantenedorPersonal)).call(this, props));
	
	        _this.state = {
	            usuariosRAW: [],
	            usuarios: [],
	            comunas: [],
	            bancos: [],
	            busquedaComuna: '',
	            busquedaRUN: '',
	            busquedaNombre: '',
	            busquedaApellido: '',
	            busquedaCaptador: '',
	            busquedaVigencia: '',
	            searchStatusContract: '',
	            idDocumentationState: 0
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.nuevoUsuario = function (datos) {
	            var request = _v2.default.usuarios.nuevoUsuario(datos);
	            request.then(function (resp) {
	                _this.fetchUsuarios();
	            });
	            return request;
	        };
	        _this.actualizarUsuario = function (idUsuario, usuarioActualizado) {
	            // fechaNacimiento viene como date, se debe convertir a texto
	            var request = _v2.default.usuario(idUsuario).actualizar(usuarioActualizado);
	            request.then(_this.fetchUsuarios); // no es necesario actualizar la lista completa... pero da lo mismo
	            return request;
	        };
	        _this.fetchUsuarios = function () {
	            _this.setState({
	                usuariosRaw: []
	            });
	            var idState = _this.state.idDocumentationState;
	            _v2.default.usuarios.fetch(idState).then(function (usuarios) {
	                _this.setState({
	                    usuariosRAW: usuarios
	                }, _this.filtrarUsuarios);
	            });
	        };
	        _this.realizarBusqueda = function (campo, busquedaOriginal) {
	            var newState = {};
	            newState[campo] = busquedaOriginal.trim().toLowerCase();
	            _this.setState(newState, _this.filtrarUsuarios);
	        };
	        _this.filtrarUsuarios = function () {
	            _this.setState({
	                usuarios: _this.state.usuariosRAW.filter(function (us) {
	                    return us.RUN.indexOf(_this.state.busquedaRUN) >= 0;
	                }).filter(function (us) {
	                    return us.apellidoPaterno.toLowerCase().indexOf(_this.state.busquedaApellido) >= 0 || us.apellidoMaterno.toLowerCase().indexOf(_this.state.busquedaApellido) >= 0;
	                }).filter(function (us) {
	                    return us.nombre1.toLowerCase().indexOf(_this.state.busquedaNombre) >= 0 || us.nombre2.toLowerCase().indexOf(_this.state.busquedaNombre) >= 0;
	                }).filter(function (us) {
	                    return us.captador.toLowerCase().indexOf(_this.state.busquedaCaptador) >= 0;
	                }).filter(function (us) {
	                    return us.vigencia.toLowerCase().indexOf(_this.state.busquedaVigencia) >= 0;
	                }).filter(function (us) {
	                    return us.isContractFile.toLowerCase().indexOf(_this.state.searchStatusContract) >= 0;
	                }).filter(function (us) {
	                    return us.comuna.toLowerCase().indexOf(_this.state.busquedaComuna) >= 0;
	                })
	            });
	        };
	        _this.bloquearUsuario = function (idUsuario) {
	            _v2.default.usuario(idUsuario).bloquear().then(_this.fetchUsuarios);
	        };
	        _this.desbloquearUsuario = function (idUsuario) {
	            _v2.default.usuario(idUsuario).desbloquear().then(_this.fetchUsuarios);
	        };
	        _this.cambiarContrasena = function (idUsuario, contrasena) {
	            _v2.default.usuario(idUsuario).cambiarContrasena(contrasena);
	        };
	        _this.verHistorial = function (idUsuario) {
	            return _v2.default.usuario(idUsuario).historial();
	        };
	        _this.bloquearUsuarioCliente = function (idUsuario, usuarioActualizado) {
	            var request = _v2.default.usuario(idUsuario).bloquearCliente(usuarioActualizado);
	            request.then(function () {
	                return console.log("cambio realizado");
	            }).catch(function (meh) {});
	            return request;
	        };
	        _this.changeStatusDocumentation = function (idUser, status) {
	            var request = _v2.default.usuario(idUser).changeStatusDocumentation(status);
	            request.then(function (response) {
	                _this.refs.notificator.success("Estado documentación", "El estado de la documentación ha cambiado", 4 * 1000);
	                _this.fetchUsuarios();
	            }).catch(_this.ajaxErrorHandler('Error al intentar aprobar documentos de usuario'));
	            return request;
	        };
	        _this.onSelectDocumentationState = function (evt) {
	            _this.setState({
	                idDocumentationState: evt.target.value
	            }, function () {
	                _this.fetchUsuarios();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorPersonal, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                uploadDNIFront: function uploadDNIFront(idUser, file) {
	                    var data = new FormData();
	                    data.append('DNIFront', file);
	                    var request = _v2.default.usuario(idUser).uploadPersonalFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CARNET", "Foto frontal agregada correctamente", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Error al subir foto frontal carnet'));
	                    return request;
	                },
	                uploadDNIBack: function uploadDNIBack(idUser, file) {
	                    var data = new FormData();
	                    data.append('DNIBack', file);
	                    var request = _v2.default.usuario(idUser).uploadPersonalFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CARNET", "Foto posterior agregada correctamente", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Error al subir foto posterior carnet'));
	                    return request;
	                },
	                uploadCertificate: function uploadCertificate(idUser, file) {
	                    var data = new FormData();
	                    data.append('certificate', file);
	                    var request = _v2.default.usuario(idUser).uploadPersonalFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CERTIFICADO", "Cerficado antecedentes agregado correctamente", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Error al subir certificado antecedentes'));
	                    return request;
	                },
	                uploadContract: function uploadContract(idUser, file) {
	                    var data = new FormData();
	                    data.append('contract', file);
	                    var request = _v2.default.usuario(idUser).uploadPersonalFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CONTRATO", "Contrato de trabajo agregado correctamente", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Error al subir contrato de trabajo'));
	                    return request;
	                },
	                uploadCredential: function uploadCredential(idUser, file) {
	                    var data = new FormData();
	                    data.append('credential', file);
	                    var request = _v2.default.usuario(idUser).uploadPersonalFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CREDENCIAL", "Credencial agregada correctamente", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Error al subir credencial de operador'));
	                    return request;
	                },
	                progressStatusDocumentation: function progressStatusDocumentation(idUser, status) {
	                    var request = _v2.default.usuario(idUser).changeStatusDocumentation(status);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("Estado documentación", "El estado de la documentación ha cambiado", 4 * 1000);
	                        _this2.fetchUsuarios();
	                    }).catch(_this2.ajaxErrorHandler('Error al intentar aprobar documentos de usuario'));
	                    return request;
	                },
	                isWrongFile: function isWrongFile(idFile, status) {
	                    var request = _v2.default.documentUser(idFile).isWrongFile(status);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("Estado documento", "Ha cambiado el estado del documento", 4 * 1000);
	                        _this2.fetchUsuarios();
	                    }).catch(_this2.ajaxErrorHandler('Error al intentar cambiar el estado del documento'));
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            this.fetchUsuarios();
	            _v2.default.otros.comunas().then(function (comunas) {
	                _this3.setState({ comunas: comunas });
	            });
	            _v2.default.otros.bancos().then(function (bancos) {
	                _this3.setState({ bancos: bancos });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Mantenedor de Personal'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(SelectStatusDoc, {
	                            idDocumentationState: this.state.idDocumentationState,
	                            documentationStates: this.props.documentationStatus,
	                            onSelectDocumentationState: this.onSelectDocumentationState
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                _Modales.ModalTrigger,
	                                null,
	                                function (isVisible, showModal, hideModal) {
	                                    return _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-primary', onClick: showModal },
	                                        'Agregar usuario',
	                                        isVisible && _react2.default.createElement(_Modales.ModalAgregarUsuario, {
	                                            hideModal: hideModal,
	                                            nuevoUsuario: _this4.nuevoUsuario,
	                                            comunas: _this4.state.comunas,
	                                            datosbancos: _this4.state.bancos,
	                                            fetchUsuarios: _this4.fetchUsuarios
	                                        })
	                                    );
	                                }
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-sm btn-success pull-right',
	                                    href: '/api/usuarios/exportar-excel'
	                                },
	                                'Exportar'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_TablaPersonal.TablaPersonal, {
	                    usuarios: this.state.usuarios,
	                    comunas: this.state.comunas,
	                    datosbancos: this.state.bancos,
	                    actualizarUsuario: this.actualizarUsuario,
	                    bloquearUsuario: this.bloquearUsuario,
	                    desbloquearUsuario: this.desbloquearUsuario,
	                    cambiarContrasena: this.cambiarContrasena,
	                    verHistorial: this.verHistorial,
	                    bloquearUsuarioCliente: this.bloquearUsuarioCliente,
	                    onApproveFiles: this.changeStatusDocumentation,
	                    perms: this.props.perms
	
	                    // busqueda
	                    , busquedaComuna: this.state.busquedaComuna,
	                    realizarBusquedaComuna: this.realizarBusqueda.bind(this, 'busquedaComuna'),
	                    busquedaRUN: this.state.busquedaRUN,
	                    realizarBusquedaRUN: this.realizarBusqueda.bind(this, 'busquedaRUN'),
	                    busquedaNombre: this.state.busquedaNombre,
	                    realizarBusquedaNombre: this.realizarBusqueda.bind(this, 'busquedaNombre'),
	                    busquedaApellido: this.state.busquedaApellido,
	                    realizarBusquedaApellido: this.realizarBusqueda.bind(this, 'busquedaApellido'),
	                    busquedaCaptador: this.state.busquedaCaptador,
	                    realizarBusquedaCaptador: this.realizarBusqueda.bind(this, 'busquedaCaptador'),
	                    busquedaVigencia: this.state.busquedaVigencia,
	                    realizarBusquedaVigencia: this.realizarBusqueda.bind(this, 'busquedaVigencia'),
	                    seachStatusContract: this.state.searchStatusContract,
	                    searchingStatusContract: this.realizarBusqueda.bind(this, 'searchStatusContract'),
	                    clientes: this.props.clientes,
	                    fetchUsuarios: this.fetchUsuarios
	                })
	            );
	        }
	    }]);
	
	    return MantenedorPersonal;
	}(_react2.default.Component);
	
	MantenedorPersonal.propTypes = {
	    clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
	    documentationStatus: PropTypes.arrayOf(PropTypes.object).isRequired,
	    perms: PropTypes.object.isRequired
	};
	MantenedorPersonal.childContextTypes = {
	    uploadDNIFront: PropTypes.func,
	    uploadDNIBack: PropTypes.func,
	    uploadCertificate: PropTypes.func,
	    uploadContract: PropTypes.func,
	    uploadCredential: PropTypes.func,
	    progressStatusDocumentation: PropTypes.func,
	    isWrongFile: PropTypes.func
	};
	
	var SelectStatusDoc = function SelectStatusDoc(_ref) {
	    var idDocumentationState = _ref.idDocumentationState,
	        documentationStates = _ref.documentationStates,
	        onSelectDocumentationState = _ref.onSelectDocumentationState;
	    return _react2.default.createElement(
	        'div',
	        { className: 'dropdown col-md-offset-4 col-md-4' },
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: idDocumentationState,
	                onChange: onSelectDocumentationState },
	            _react2.default.createElement(
	                'option',
	                { value: '0' },
	                'Filtro Documentaci\xF3n'
	            ),
	            documentationStates.map(function (documentationState, index) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: index, value: documentationState.idDocumentationStatus },
	                    documentationState.name
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorPersonal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaPersonal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modales = __webpack_require__(1075);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _tablaPersonal = __webpack_require__(716);
	
	var css = _interopRequireWildcard(_tablaPersonal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Styles
	
	var cx = _bind2.default.bind(css);
	
	var TablaPersonal = exports.TablaPersonal = function (_React$Component) {
	    _inherits(TablaPersonal, _React$Component);
	
	    function TablaPersonal() {
	        _classCallCheck(this, TablaPersonal);
	
	        return _possibleConstructorReturn(this, (TablaPersonal.__proto__ || Object.getPrototypeOf(TablaPersonal)).apply(this, arguments));
	    }
	
	    _createClass(TablaPersonal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.usuarios.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.usuarios[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowIndex = _ref4.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 25
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'RUN',
	                                label: 'RUN',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var rowData = _ref5.rowData,
	                                        dataKey = _ref5.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'RUN',
	                                        busqueda: _this2.props.busquedaRUN,
	                                        realizarBusqueda: _this2.props.realizarBusquedaRUN
	                                    });
	                                },
	                                width: 70
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombres',
	                                label: 'nombres',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Nombres',
	                                        busqueda: _this2.props.busquedaNombre,
	                                        realizarBusqueda: _this2.props.realizarBusquedaNombre
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var rowData = _ref6.rowData;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.nombre1
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.nombre2
	                                        )
	                                    );
	                                },
	                                width: 130
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'apellidos',
	                                label: 'Apellidos',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Apellidos',
	                                        busqueda: _this2.props.busquedaApellido,
	                                        realizarBusqueda: _this2.props.realizarBusquedaApellido
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var rowData = _ref7.rowData;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.apellidoPaterno
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.apellidoMaterno
	                                        )
	                                    );
	                                },
	                                width: 130
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'comuna',
	                                label: 'Comuna',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Comunas',
	                                        busqueda: _this2.props.busquedaComuna,
	                                        realizarBusqueda: _this2.props.realizarBusquedaComuna
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 90
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'captador',
	                                label: 'Captador',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Captador',
	                                        busqueda: _this2.props.busquedaCaptador,
	                                        realizarBusqueda: _this2.props.realizarBusquedaCaptador
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var dataKey = _ref9.dataKey,
	                                        rowData = _ref9.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 100
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'vigencia',
	                                label: 'Vigencia',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Vigencia',
	                                        busqueda: _this2.props.busquedaVigencia,
	                                        realizarBusqueda: _this2.props.realizarBusquedaVigencia
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref10) {
	                                    var dataKey = _ref10.dataKey,
	                                        rowData = _ref10.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 85
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'bloqueado',
	                                label: 'bloqueo',
	                                cellRenderer: function cellRenderer(_ref11) {
	                                    var dataKey = _ref11.dataKey,
	                                        rowData = _ref11.rowData;
	                                    return rowData[dataKey] ? 'Bloqueado' : '';
	                                },
	                                width: 90
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'isContractFile',
	                                label: 'Contrato',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Contrato',
	                                        busqueda: _this2.props.seachStatusContract,
	                                        realizarBusqueda: _this2.props.searchingStatusContract
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref12) {
	                                    var dataKey = _ref12.dataKey,
	                                        rowData = _ref12.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 100
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '',
	                                label: '',
	                                cellRenderer: function cellRenderer(_ref13) {
	                                    var cellData = _ref13.cellData,
	                                        columnData = _ref13.columnData,
	                                        dataKey = _ref13.dataKey,
	                                        rowData = _ref13.rowData,
	                                        rowIndex = _ref13.rowIndex;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(BotonEditar, {
	                                            datosbancos: _this2.props.datosbancos,
	                                            usuario: rowData,
	                                            comunas: _this2.props.comunas,
	                                            fetchUsuarios: _this2.props.fetchUsuarios
	                                            //actualizarUsuario={this.props.actualizarUsuario.bind(rowData.id)}
	                                        }),
	                                        _react2.default.createElement(BotonBloquear, {
	                                            idUsuario: rowData.id,
	                                            estaBloqueado: rowData.bloqueado,
	                                            bloquearUsuario: _this2.props.bloquearUsuario,
	                                            desbloquearUsuario: _this2.props.desbloquearUsuario
	                                        }),
	                                        _react2.default.createElement(BotonBloquearCliente, {
	                                            usuario: rowData,
	                                            bloquearUsuarioCliente: _this2.props.bloquearUsuarioCliente.bind(rowData.id),
	                                            clientes: _this2.props.clientes
	                                        }),
	                                        _react2.default.createElement(BotonCambiarContrasena, {
	                                            idUsuario: rowData.id,
	                                            cambiarContrasena: _this2.props.cambiarContrasena
	                                        }),
	                                        _react2.default.createElement(BotonVerHistorial, {
	                                            idUsuario: rowData.id,
	                                            verHistorial: _this2.props.verHistorial.bind(_this2, rowData.id)
	                                        }),
	                                        _react2.default.createElement(ButtonUploadFiles, {
	                                            user: rowData,
	                                            idUsuario: rowData.id,
	                                            statusFiles: rowData.statusFiles
	                                        }),
	                                        _react2.default.createElement(ButtonDownloadFiles, {
	                                            idUsuario: rowData.id
	                                        }),
	                                        _react2.default.createElement(ButtonReviewFiles, {
	                                            user: rowData,
	                                            statusFiles: rowData.statusFiles,
	                                            canApproveFiles: _this2.props.perms.canApproveFiles
	                                        }),
	                                        _react2.default.createElement(ButtonApproveFiles, {
	                                            idUser: rowData.id,
	                                            statusFiles: rowData.statusFiles,
	                                            onApproveFiles: _this2.props.onApproveFiles,
	                                            canApproveFiles: _this2.props.perms.canApproveFiles
	                                        })
	                                    );
	                                },
	                                width: 360
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaPersonal;
	}(_react2.default.Component);
	
	TablaPersonal.propTypes = {
	    usuarios: PropTypes.arrayOf(PropTypes.object).isRequired,
	    // Metodos
	    bloquearUsuario: PropTypes.func.isRequired,
	    desbloquearUsuario: PropTypes.func.isRequired,
	    onApproveFiles: PropTypes.func.isRequired,
	    cambiarContrasena: PropTypes.func.isRequired,
	    fetchUsuarios: PropTypes.func.isRequired
	};
	
	var BotonEditar = function BotonEditar(_ref14) {
	    var usuario = _ref14.usuario,
	        comunas = _ref14.comunas,
	        fetchUsuarios = _ref14.fetchUsuarios,
	        datosbancos = _ref14.datosbancos;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Editar datos de operador' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit' }),
	                isVisible && _react2.default.createElement(_Modales.ModalEditarUsuario, {
	                    usuario: usuario,
	                    comunas: comunas,
	                    hideModal: hideModal,
	                    fetchUsuarios: fetchUsuarios,
	                    datosbancos: datosbancos
	                })
	            );
	        }
	    );
	};
	
	var BotonBloquearCliente = function BotonBloquearCliente(_ref15) {
	    var usuario = _ref15.usuario,
	        bloquearUsuarioCliente = _ref15.bloquearUsuarioCliente,
	        clientes = _ref15.clientes;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Bloqueo de operador por cliente' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                isVisible && _react2.default.createElement(_Modales.ModalBloquearCliente, {
	                    usuario: usuario,
	                    bloquearUsuarioCliente: bloquearUsuarioCliente,
	                    clientes: clientes,
	                    hideModal: hideModal
	                })
	            );
	        }
	    );
	};
	
	var BotonBloquear = function BotonBloquear(_ref16) {
	    var idUsuario = _ref16.idUsuario,
	        estaBloqueado = _ref16.estaBloqueado,
	        bloquearUsuario = _ref16.bloquearUsuario,
	        desbloquearUsuario = _ref16.desbloquearUsuario;
	    return estaBloqueado == false ? _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-success', onClick: showModal, title: 'Bloquear operador' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-ban-circle' }),
	                isVisible && _react2.default.createElement(_Modales.ModalBloquearUsuario, {
	                    hideModal: hideModal,
	                    onBloquear: function onBloquear() {
	                        hideModal();
	                        bloquearUsuario(idUsuario);
	                    }
	                })
	            );
	        }
	    ) : _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-danger', onClick: showModal, title: 'Desbloquear operador' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-ban-circle' }),
	                isVisible && _react2.default.createElement(_Modales.ModalDesbloquearUsuario, {
	                    hideModal: hideModal,
	                    onDesbloquear: function onDesbloquear() {
	                        hideModal();
	                        desbloquearUsuario(idUsuario);
	                    }
	                })
	            );
	        }
	    );
	};
	
	var BotonCambiarContrasena = function BotonCambiarContrasena(_ref17) {
	    var idUsuario = _ref17.idUsuario,
	        cambiarContrasena = _ref17.cambiarContrasena;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Cambiar contrase\xF1a de usuario' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-lock' }),
	                isVisible && _react2.default.createElement(_Modales.ModalCambiarContrasena, {
	                    hideModal: hideModal,
	                    onAceptar: function onAceptar(contrasena) {
	                        hideModal();
	                        cambiarContrasena(idUsuario, contrasena);
	                    }
	                })
	            );
	        }
	    );
	};
	
	var ButtonReviewFiles = function ButtonReviewFiles(_ref18) {
	    var user = _ref18.user,
	        statusFiles = _ref18.statusFiles,
	        canApproveFiles = _ref18.canApproveFiles;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Revisar documentaci\xF3n de usuario' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' }),
	                isVisible && _react2.default.createElement(_Modales.ModalReviewFiles, {
	                    hideModal: hideModal,
	                    user: user,
	                    statusFiles: statusFiles,
	                    canApproveFiles: canApproveFiles
	                })
	            );
	        }
	    );
	};
	
	var BotonVerHistorial = function BotonVerHistorial(_ref19) {
	    var idUsuario = _ref19.idUsuario,
	        verHistorial = _ref19.verHistorial;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Historial inventarios de operador' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-stats' }),
	                isVisible && _react2.default.createElement(_Modales.ModalHistorial, {
	                    hideModal: hideModal,
	                    verHistorial: verHistorial
	                })
	            );
	        }
	    );
	};
	
	var ButtonUploadFiles = function ButtonUploadFiles(_ref20) {
	    var user = _ref20.user,
	        idUsuario = _ref20.idUsuario,
	        statusFiles = _ref20.statusFiles;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary', onClick: showModal, title: 'Subir documentos de operador', disabled: statusFiles === 'Aprobados' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-upload' }),
	                isVisible && _react2.default.createElement(_Modales.ModalUploadFiles, {
	                    hideModal: hideModal,
	                    user: user,
	                    idUsuario: idUsuario,
	                    statusFiles: statusFiles
	                })
	            );
	        }
	    );
	};
	
	var ButtonDownloadFiles = function ButtonDownloadFiles(_ref21) {
	    var idUsuario = _ref21.idUsuario;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-primary', title: 'Descargar documentos de operador',
	            href: '/api/usuario/' + idUsuario + '/download/personal-files' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-download' })
	    );
	};
	
	var ButtonApproveFiles = function ButtonApproveFiles(_ref22) {
	    var idUser = _ref22.idUser,
	        statusFiles = _ref22.statusFiles,
	        _onApproveFiles = _ref22.onApproveFiles,
	        canApproveFiles = _ref22.canApproveFiles;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: statusFiles === 'Aprobados' ? 'btn btn-md btn-success' : 'btn btn-md btn-warning', onClick: showModal, title: 'Aprobar revisi\xF3n de documentos', disabled: !canApproveFiles },
	                _react2.default.createElement('span', { className: statusFiles === 'Aprobados' ? 'glyphicon glyphicon-ok-sign' : 'glyphicon glyphicon-hourglass' }),
	                isVisible && _react2.default.createElement(_Modales.ModalApproveFiles, {
	                    hideModal: hideModal,
	                    statusFiles: statusFiles,
	                    onApproveFiles: function onApproveFiles() {
	                        hideModal();
	                        _onApproveFiles(idUser, statusFiles === 'Aprobados' ? 3 : 4);
	                    }
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaPersonal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalHistorial = exports.ModalReviewFiles = exports.ModalUploadFiles = exports.ModalCambiarContrasena = exports.ModalApproveFiles = exports.ModalDesbloquearUsuario = exports.ModalBloquearUsuario = exports.ModalBloquearCliente = exports.ModalEditarUsuario = exports.ModalAgregarUsuario = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormularioUsuario = __webpack_require__(1076);
	
	var _ZoomImagen = __webpack_require__(1078);
	
	var _InputRun = __webpack_require__(930);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1080);
	
	var css = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Notify
	
	// Style
	
	var cx = _bind2.default.bind(css);
	
	// function as a children FTW! :D
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalAgregarUsuario = exports.ModalAgregarUsuario = function (_React$Component2) {
	    _inherits(ModalAgregarUsuario, _React$Component2);
	
	    function ModalAgregarUsuario(props) {
	        _classCallCheck(this, ModalAgregarUsuario);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalAgregarUsuario.__proto__ || Object.getPrototypeOf(ModalAgregarUsuario)).call(this, props));
	
	        _this2.state = {
	            usuario: {
	                id: 0,
	                usuarioRUN: '',
	                usuarioDV: '',
	                nombre1: '',
	                nombre2: '',
	                apellidoPaterno: '',
	                apellidoMaterno: '',
	                email: '',
	                emailPersonal: '',
	                telefono: '',
	                telefonoEmergencia: '',
	                fechaNacimiento: '0000-00-00',
	                sexo: '',
	                nacionalidad: '',
	                direccion: '',
	                cutComuna: 7301,
	                tipoContrato: '',
	                banco: '',
	                tipoCuenta: '',
	                numeroCuenta: ''
	            }
	        };
	        _this2.nuevoUsuario = function (datos) {
	            var banco = _this2.props.datosbancos.bancos.find(function (banco) {
	                return banco.nombreCorto == datos.banco;
	            });
	            var tipoCuenta = _this2.props.datosbancos.tipo_cuentas.find(function (cuenta) {
	                return cuenta.nombreCuenta == datos.tipoCuenta;
	            });
	            datos.banco = banco.idBanco;
	            datos.tipoCuenta = tipoCuenta.idCuenta;
	            _v2.default.usuarios.nuevoUsuario(datos).then(function (resp) {
	                _this2.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	                var errores = err.data;
	                var mensaje = '';
	                for (var i in errores) {
	                    mensaje += i + ": " + errores[i][0] + '\n';
	                }
	                alert(errores);
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalAgregarUsuario, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal'), dialogClassName: cx('modalUser') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Nuevo usuario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(_FormularioUsuario.FormularioUsuario, {
	                        usuario: this.state.usuario,
	                        enviarFormulario: this.nuevoUsuario,
	                        cancelarFormulario: this.props.hideModal,
	                        comunas: this.props.comunas,
	                        bancos: this.props.datosbancos.bancos,
	                        tiposcuentas: this.props.datosbancos.tipo_cuentas,
	                        btnTexto: "Guardar"
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalAgregarUsuario;
	}(_react2.default.Component);
	
	var ModalEditarUsuario = exports.ModalEditarUsuario = function (_React$Component3) {
	    _inherits(ModalEditarUsuario, _React$Component3);
	
	    function ModalEditarUsuario(props) {
	        _classCallCheck(this, ModalEditarUsuario);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalEditarUsuario.__proto__ || Object.getPrototypeOf(ModalEditarUsuario)).call(this, props));
	
	        _this3.state = {
	            usuario: _this3.props.usuario
	        };
	        _this3.editarUsuario = function (datos) {
	            var banco = _this3.props.datosbancos.bancos.find(function (banco) {
	                return banco.nombreCorto == datos.banco;
	            });
	            var tipoCuenta = _this3.props.datosbancos.tipo_cuentas.find(function (cuenta) {
	                return cuenta.nombreCuenta == datos.tipoCuenta;
	            });
	            datos.banco = banco.idBanco;
	            datos.tipoCuenta = tipoCuenta.idCuenta;
	            _v2.default.usuario(_this3.state.usuario.id).actualizar(datos).then(function (resp) {
	                _this3.props.fetchUsuarios();
	                _this3.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalEditarUsuario, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal'), dialogClassName: cx('modalUser') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Editando a : ',
	                        this.state.usuario.nombre1,
	                        ' ',
	                        this.state.usuario.apellidoPaterno
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(_FormularioUsuario.FormularioUsuario, {
	                        usuario: this.state.usuario,
	                        enviarFormulario: this.editarUsuario,
	                        cancelarFormulario: this.props.hideModal,
	                        comunas: this.props.comunas,
	                        bancos: this.props.datosbancos.bancos,
	                        tiposcuentas: this.props.datosbancos.tipo_cuentas,
	                        btnTexto: "Modificar"
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ModalEditarUsuario;
	}(_react2.default.Component);
	
	var ModalBloquearCliente = exports.ModalBloquearCliente = function (_React$Component4) {
	    _inherits(ModalBloquearCliente, _React$Component4);
	
	    function ModalBloquearCliente(props) {
	        _classCallCheck(this, ModalBloquearCliente);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalBloquearCliente.__proto__ || Object.getPrototypeOf(ModalBloquearCliente)).call(this, props));
	
	        _this4.state = {
	            // CMT POR DEFECTO
	            cliente: 7,
	            usuario: _this4.props.usuario,
	            clientes: _this4.props.clientes,
	            error: {},
	            isChecked: false
	        };
	        _this4.fetchEstado = function (cliente) {
	            _v2.default.nominas.getEstado(_this4.state.usuario.id, cliente).then(function (estado) {
	                _this4.setState({ isChecked: estado });
	            }).catch(function (meh) {});
	        };
	        _this4.onInputChange = function (key, evt) {
	            var actualizado = {};
	            var target = evt.target;
	            //actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
	            actualizado[key] = target.value;
	            _this4.setState({ usuario: Object.assign({}, _this4.state.usuario, actualizado) });
	            _this4.setState(_defineProperty({}, target.name, actualizado[key]), function () {
	                return _this4.fetchEstado(_this4.state.cliente);
	            });
	        };
	        _this4.onCheckChange = function (key, evt) {
	            var actualizado = {};
	            var target = evt.target;
	            actualizado[key] = target.checked;
	            _this4.setState({ usuario: Object.assign({}, _this4.state.usuario, actualizado) });
	            _this4.setState(_defineProperty({}, target.name, actualizado[key]));
	        };
	        _this4.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	
	            _this4.setState({ error: {} }, function () {
	                _this4.props.bloquearUsuarioCliente(_this4.state.usuario.id, _this4.state.usuario).then(function () {
	                    _this4.props.hideModal();
	                }).catch(function (error) {
	                    _this4.setState({ error: error.data });
	                });
	            });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalBloquearCliente, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            //CLIENTE CMT POR DEFECTO
	            this.fetchEstado(this.state.cliente);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Bloqueando por cliente a : ',
	                        this.state.usuario.nombre1,
	                        ' ',
	                        this.state.usuario.apellidoPaterno,
	                        ' '
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-inline', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'selectCliente') },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Seleccionar Cliente'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { className: 'form-control',
	                                    name: 'cliente',
	                                    onChange: this.onInputChange.bind(this, 'idCliente'),
	                                    value: this.state.cliente
	                                },
	                                this.props.clientes.map(function (cliente) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: cliente.idCliente, value: cliente.idCliente },
	                                        cliente.nombreCorto
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkbox' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement('input', { type: 'checkbox', name: 'isChecked', checked: this.state.isChecked, onChange: this.onCheckChange.bind(this, 'estado') }),
	                                '  Bloquear?'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-danger' },
	                            'Aceptar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-default', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalBloquearCliente;
	}(_react2.default.Component);
	
	var ModalBloquearUsuario = exports.ModalBloquearUsuario = function ModalBloquearUsuario(_ref) {
	    var hideModal = _ref.hideModal,
	        onBloquear = _ref.onBloquear;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: cx('modal') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                '\xBFEsta seguro que desea bloquear al usuario?'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            { className: cx('bloquearUsuario_footer') },
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-default', onClick: hideModal },
	                'Cancelar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-danger', onClick: onBloquear },
	                'Bloquear usuario'
	            )
	        )
	    );
	};
	
	var ModalDesbloquearUsuario = exports.ModalDesbloquearUsuario = function ModalDesbloquearUsuario(_ref2) {
	    var hideModal = _ref2.hideModal,
	        onDesbloquear = _ref2.onDesbloquear;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: cx('modal') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                '\xBFEsta seguro que desea desbloquear al usuario?'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            { className: cx('bloquearUsuario_footer') },
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-default', onClick: hideModal },
	                'Cancelar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-success', onClick: onDesbloquear },
	                'Desbloquear usuario'
	            )
	        )
	    );
	};
	
	var ModalApproveFiles = exports.ModalApproveFiles = function ModalApproveFiles(_ref3) {
	    var hideModal = _ref3.hideModal,
	        onApproveFiles = _ref3.onApproveFiles,
	        statusFiles = _ref3.statusFiles;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: cx('modal') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                '\xBFEsta seguro de ',
	                statusFiles === 'Aprobados' ? 'DESAPROBAR ' : 'APROBAR ',
	                ' la documentaci\xF3n del usuario?'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            { className: cx('bloquearUsuario_footer') },
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-default', onClick: hideModal },
	                'Cancelar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-success', onClick: onApproveFiles },
	                'Aceptar'
	            )
	        )
	    );
	};
	
	var ModalCambiarContrasena = exports.ModalCambiarContrasena = function ModalCambiarContrasena(_ref4) {
	    var hideModal = _ref4.hideModal,
	        onAceptar = _ref4.onAceptar;
	
	    var refContrasena = null;
	    var onCambiar = function onCambiar() {
	        onAceptar(refContrasena.value);
	    };
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: cx('modal') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Cambio de contrase\xF1a'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'form',
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'password', className: 'col-sm-2 control-label' },
	                        'Contrase\xF1a'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-10' },
	                        _react2.default.createElement('input', { className: 'form-control', type: 'text',
	                            ref: function ref(_ref5) {
	                                return refContrasena = _ref5;
	                            },
	                            onKeyDown: function onKeyDown(evt) {
	                                if (evt.keyCode == 13) {
	                                    onCambiar();
	                                    evt.preventDefault();
	                                    return;
	                                }
	                            }
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            { className: cx('cambiarContrasena_footer') },
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-default', onClick: hideModal },
	                'Cancelar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-success', onClick: onCambiar },
	                'Cambiar'
	            )
	        )
	    );
	};
	
	var ModalUploadFiles = exports.ModalUploadFiles = function (_React$Component5) {
	    _inherits(ModalUploadFiles, _React$Component5);
	
	    function ModalUploadFiles(props) {
	        _classCallCheck(this, ModalUploadFiles);
	
	        var _this5 = _possibleConstructorReturn(this, (ModalUploadFiles.__proto__ || Object.getPrototypeOf(ModalUploadFiles)).call(this, props));
	
	        _this5.state = {
	            frontDNI: '',
	            backDNI: '',
	            certificatePersonalHistory: '',
	            contract: '',
	            credential: '',
	            completededDocumentation: _this5.props.statusFiles === 'Cargados',
	            existingContract: _this5.props.user.existingContract,
	            existingCarnetFront: _this5.props.user.existingCarnetFront,
	            existingCarnetBack: _this5.props.user.existingCarnetBack,
	            existingCertificateA: _this5.props.user.existingCertificateA,
	            existingCredential: _this5.props.user.existingCredential
	        };
	        _this5.onChangeDNIFront = function (evt) {
	            _this5.setState({
	                frontDNI: evt.target.files[0]
	            }, function () {
	                return _this5.context.uploadDNIFront(_this5.props.idUsuario, _this5.state.frontDNI);
	            });
	        };
	        _this5.onChangeDNIBack = function (evt) {
	            _this5.setState({
	                backDNI: evt.target.files[0]
	            }, function () {
	                return _this5.context.uploadDNIBack(_this5.props.idUsuario, _this5.state.backDNI);
	            });
	        };
	        _this5.onChangeCertificate = function (evt) {
	            _this5.setState({
	                certificatePersonalHistory: evt.target.files[0]
	            }, function () {
	                return _this5.context.uploadCertificate(_this5.props.idUsuario, _this5.state.certificatePersonalHistory);
	            });
	        };
	        _this5.onChangeContract = function (evt) {
	            _this5.setState({
	                contract: evt.target.files[0]
	            }, function () {
	                return _this5.context.uploadContract(_this5.props.idUsuario, _this5.state.contract);
	            });
	        };
	        _this5.onChangeCredential = function (evt) {
	            _this5.setState({
	                credential: evt.target.files[0]
	            }, function () {
	                return _this5.context.uploadCredential(_this5.props.idUsuario, _this5.state.credential);
	            });
	        };
	        _this5.onChangeProgress = function () {
	            var status = !_this5.state.completededDocumentation;
	            var request = _this5.context.progressStatusDocumentation(_this5.props.idUsuario, status);
	            request.then(function (files) {
	                _this5.setState({ completededDocumentation: status });
	            }).catch(function () {
	                console.log("error");
	            });
	        };
	        return _this5;
	    }
	
	    _createClass(ModalUploadFiles, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Subiendo archivos de usuario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('btn-group-vertical', 'div-option-file') },
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.state.existingCertificateA ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.state.existingCertificateA ? 'Reemplazar ' : 'Subir ',
	                            'Certificado Antecedentes',
	                            _react2.default.createElement('input', { type: 'file', onChange: this.onChangeCertificate })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.state.existingCarnetFront ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.state.existingCarnetFront ? 'Reemplazar ' : 'Subir ',
	                            'Carnet Frontal',
	                            _react2.default.createElement('input', { type: 'file', onChange: this.onChangeDNIFront })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.state.existingCarnetBack ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.state.existingCarnetBack ? 'Reemplazar ' : 'Subir ',
	                            'Carnet Posterior',
	                            _react2.default.createElement('input', { type: 'file', onChange: this.onChangeDNIBack })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.state.existingContract ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.state.existingContract ? 'Reemplazar ' : 'Subir ',
	                            'Contrato PDF',
	                            _react2.default.createElement('input', { type: 'file', onChange: this.onChangeContract })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.state.existingCredential ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.state.existingCredential ? 'Reemplazar ' : 'Subir ',
	                            'Fotograf\xEDa Credencial',
	                            _react2.default.createElement('input', { type: 'file', onChange: this.onChangeCredential })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: this.state.completededDocumentation ? 'btn btn-success' : 'btn btn-warning', onClick: this.onChangeProgress },
	                            this.state.completededDocumentation ? 'Publicado' : 'Pendiente de publicación'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-btn-default', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalUploadFiles;
	}(_react2.default.Component);
	
	ModalUploadFiles.contextTypes = {
	    uploadDNIFront: PropTypes.func,
	    uploadDNIBack: PropTypes.func,
	    uploadCertificate: PropTypes.func,
	    uploadContract: PropTypes.func,
	    uploadCredential: PropTypes.func,
	    progressStatusDocumentation: PropTypes.func
	};
	
	var ModalReviewFiles = exports.ModalReviewFiles = function (_React$Component6) {
	    _inherits(ModalReviewFiles, _React$Component6);
	
	    function ModalReviewFiles(props) {
	        _classCallCheck(this, ModalReviewFiles);
	
	        var _this6 = _possibleConstructorReturn(this, (ModalReviewFiles.__proto__ || Object.getPrototypeOf(ModalReviewFiles)).call(this, props));
	
	        _this6.state = {
	            index: 0,
	            files: [],
	            user: _this6.props.user
	        };
	        _this6.onRutChange = function (usuarioRUN, usuarioDV) {
	            _this6.ref_usuarioDV.value = usuarioDV;
	            var updated = {};
	            updated['usuarioRUN'] = usuarioRUN;
	            updated['usuarioDV'] = usuarioDV;
	            updated['edit'] = 1;
	            _this6.setState({ user: Object.assign({}, _this6.state.user, updated) });
	        };
	        _this6.onInputChange = function (key, evt) {
	            var updated = {};
	            updated[key] = evt.target.value;
	            updated['edit'] = 1;
	            _this6.setState({ user: Object.assign({}, _this6.state.user, updated) });
	        };
	        _this6.onIsWrong = function (evt) {
	            var status = evt.target.checked;
	            var idFile = _this6.state.files[_this6.state.index].idFileUser;
	            var request = _this6.context.isWrongFile(idFile, status);
	            request.then(function (resp) {
	                _this6.refs.notificator.success('Actualización', 'Se ha actualizado correctamente', 2 * 1000);
	                _this6.getDocumentation();
	            }).catch(function () {
	                _this6.refs.notificator.error('Actualización', 'Surgieron problemas en la actualización', 4 * 1000);
	            });
	        };
	        _this6.onDeleteFile = function () {
	            var idFile = _this6.state.files[_this6.state.index].idFileUser;
	            var request = _v2.default.documentUser(idFile).deleteFile();
	            request.then(function (resp) {
	                _this6.setState({ index: 0 });
	                _this6.getDocumentation();
	            }).catch(function () {
	                console.log("error");
	            });
	        };
	        _this6.getDocumentation = function () {
	            var request = _v2.default.usuario(_this6.props.user.id).getDocumentation();
	            request.then(function (files) {
	                _this6.setState({ files: files });
	            }).catch(function () {
	                console.log("error");
	            });
	        };
	        _this6.handleSubmit = function () {
	            if (_this6.state.user.edit) {
	                _v2.default.usuario(_this6.state.user.id).actualizar(_this6.state.user).then(function (resp) {
	                    _this6.refs.notificator.success('Actualización', 'Usuario actualizado correctamente', 2 * 1000);
	                }).catch(function (err) {
	                    _this6.refs.notificator.error('Actualización', 'Surgieron problemas en la actualización', 4 * 1000);
	                });
	            }
	        };
	        _this6.nextFile = function () {
	            _this6.setState({
	                index: _this6.state.index < _this6.state.files.length - 1 ? _this6.state.index + 1 : _this6.state.index
	            });
	        };
	        _this6.previusFile = function () {
	            _this6.setState({
	                index: _this6.state.index > 0 ? _this6.state.index - 1 : _this6.state.index
	            });
	        };
	        _this6.onKeyPressed = function (evt) {
	            switch (evt.key) {
	                case "ArrowLeft":
	                    _this6.previusFile();
	                    break;
	                case "ArrowRight":
	                    _this6.nextFile();
	                    break;
	            }
	        };
	        return _this6;
	    }
	
	    _createClass(ModalReviewFiles, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener("keydown", this.onKeyPressed);
	            this.getDocumentation();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.onKeyPressed);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalReviewFiles'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Revisando documentaci\xF3n de ' + this.props.user.nombre1 + ' ' + this.props.user.apellidoPaterno + ', RUT: ' + this.props.user.usuarioRUN + '-' + this.props.user.usuarioDV
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    this.state.files.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                        this.state.files[this.state.index].name_document === 'Carnet frontal' ? _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: css.textInfo },
	                                        'Tipo Documento: ',
	                                        this.state.files[this.state.index].name_document
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(_ZoomImagen.ZoomImagen, {
	                                        ruta_imagen: this.state.files[this.state.index].path
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12' },
	                                    _react2.default.createElement(
	                                        'nav',
	                                        { 'aria-label': '...' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'pager' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { className: css.btnModal, onClick: function onClick() {
	                                                            return _this7.previusFile();
	                                                        } },
	                                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-left', 'aria-hidden': 'true' }),
	                                                    'Anterior'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { className: css.btnModal, onClick: function onClick() {
	                                                            return _this7.nextFile();
	                                                        } },
	                                                    'Siguiente',
	                                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-right', 'aria-hidden': 'true' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '\xA0'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5 col-md-offset-1' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('col-md-12 form-group', 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-3 control-label' },
	                                        'RUT'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-6' },
	                                        _react2.default.createElement(_InputRun.InputRun, { key: 1,
	                                            onRUNChange: this.onRutChange,
	                                            rut: this.state.user.usuarioRUN,
	                                            className: 'form-control'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-3' },
	                                        _react2.default.createElement('input', { ref: function ref(_ref6) {
	                                                return _this7.ref_usuarioDV = _ref6;
	                                            }, value: this.state.user.usuarioDV, type: 'text', className: 'form-control', disabled: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('col-md-12 form-group', 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-3 control-label' },
	                                        'Nombres'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-8 col-md-4' },
	                                        _react2.default.createElement('input', {
	                                            type: 'text',
	                                            className: 'form-control',
	                                            placeholder: 'Primer nombre',
	                                            onChange: this.onInputChange.bind(this, 'nombre1'),
	                                            value: this.state.user.nombre1
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-8 col-md-4' },
	                                        _react2.default.createElement('input', {
	                                            type: 'text', className: 'form-control',
	                                            placeholder: 'Segudo Nombre',
	                                            onChange: this.onInputChange.bind(this, 'nombre2'),
	                                            value: this.state.user.nombre2
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('col-md-12 form-group', 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-3 control-label' },
	                                        'Apellidos'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-8 col-md-4' },
	                                        _react2.default.createElement('input', {
	                                            type: 'text',
	                                            className: 'form-control',
	                                            placeholder: 'Apellido Paterno',
	                                            onChange: this.onInputChange.bind(this, 'apellidoPaterno'),
	                                            value: this.state.user.apellidoPaterno
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-8 col-md-4' },
	                                        _react2.default.createElement('input', { type: 'text',
	                                            className: 'form-control',
	                                            placeholder: 'Apellido Materno',
	                                            onChange: this.onInputChange.bind(this, 'apellidoMaterno'),
	                                            value: this.state.user.apellidoMaterno
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('col-md-12 form-group', 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-3 control-label' },
	                                        'Nacimiento'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-8 col-md-7' },
	                                        _react2.default.createElement('input', {
	                                            type: 'date',
	                                            className: 'form-control',
	                                            onChange: this.onInputChange.bind(this, 'fechaNacimiento'),
	                                            value: this.state.user.fechaNacimiento
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx('col-md-12 form-group', 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 col-md-3 control-label' },
	                                        '\xBFFoto inservible?'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-2 col-md-2' },
	                                        _react2.default.createElement('input', {
	                                            className: 'form-control',
	                                            type: 'checkbox',
	                                            id: this.state.index,
	                                            onChange: this.onIsWrong,
	                                            checked: this.state.files[this.state.index].is_wrong,
	                                            disabled: this.props.statusFiles === 'Aprobados' || !this.props.canApproveFiles
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-3' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: cx("btn btn-sm btn-primary", 'btnModal'), onClick: this.handleSubmit },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-floppy-disk', 'aria-hidden': 'true' }),
	                                            ' Guardar'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-3' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: cx("btn btn-sm btn-danger", 'btnModal'), onClick: function onClick() {
	                                                    return _this7.onDeleteFile();
	                                                }, disabled: this.props.statusFiles === 'Aprobados' },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' }),
	                                            ' Eliminar'
	                                        )
	                                    )
	                                )
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5' },
	                                _react2.default.createElement(
	                                    'h5',
	                                    { className: css.textInfo },
	                                    'Tipo Documento: ',
	                                    this.state.files[this.state.index].name_document
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4' },
	                                _react2.default.createElement('input', {
	                                    className: 'form-check-input',
	                                    type: 'checkbox',
	                                    id: this.state.index,
	                                    onChange: this.onIsWrong,
	                                    checked: this.state.files[this.state.index].is_wrong,
	                                    disabled: this.props.statusFiles === 'Aprobados' || !this.props.canApproveFiles
	                                }),
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'form-check-label', htmlFor: 'autoSizingCheck' },
	                                    'Marque si la imagen no corresponde'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-3' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: cx("btn btn-sm btn-danger pull-right", 'btnModal'), onClick: function onClick() {
	                                            return _this7.onDeleteFile();
	                                        }, disabled: this.props.statusFiles === 'Aprobados' },
	                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' }),
	                                    ' Eliminar'
	                                )
	                            ),
	                            _react2.default.createElement('img', { src: '' + this.state.files[this.state.index].path, className: css.originalImage }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'nav',
	                                    { 'aria-label': '...' },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'pager' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { className: css.btnModal, onClick: function onClick() {
	                                                        return _this7.previusFile();
	                                                    } },
	                                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-left', 'aria-hidden': 'true' }),
	                                                'Anterior'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { className: css.btnModal, onClick: function onClick() {
	                                                        return _this7.nextFile();
	                                                    } },
	                                                'Siguiente',
	                                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-arrow-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/imagen_404.png', className: css.originalImage })
	                    ),
	                    _react2.default.createElement('div', { className: 'row', onKeyDown: this.onKeyPressed, tabIndex: '0' })
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-btn-default', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReviewFiles;
	}(_react2.default.Component);
	
	ModalReviewFiles.contextTypes = {
	    isWrongFile: PropTypes.func
	};
	
	var ModalHistorial = exports.ModalHistorial = function (_React$Component7) {
	    _inherits(ModalHistorial, _React$Component7);
	
	    function ModalHistorial(props) {
	        _classCallCheck(this, ModalHistorial);
	
	        var _this8 = _possibleConstructorReturn(this, (ModalHistorial.__proto__ || Object.getPrototypeOf(ModalHistorial)).call(this, props));
	
	        _this8.state = {
	            nominas: [],
	            nombre: '',
	            done: false
	        };
	        return _this8;
	    }
	
	    _createClass(ModalHistorial, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this9 = this;
	
	            this.props.verHistorial().then(function (historial) {
	                _this9.setState({
	                    nombre: historial.nombre,
	                    nominas: historial.nominas,
	                    done: true
	                });
	            }).catch(function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Historial de nominas ',
	                        this.state.nombre != '' ? ' de ' + this.state.nombre : ''
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    '#'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Fecha'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Cargo'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Local'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            this.state.done ? this.state.nominas.length > 0 ? this.state.nominas.map(function (nom, index) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        index + 1
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        nom.fecha
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        nom.role
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        nom.inventario
	                                    )
	                                );
	                            }) : _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    'No tiene inventarios registrados'
	                                )
	                            ) : _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    'Cargando..'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-btn-default', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalHistorial;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormularioUsuario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ValidadorRUN = __webpack_require__(756);
	
	var _reactFormal = __webpack_require__(757);
	
	var _reactFormal2 = _interopRequireDefault(_reactFormal);
	
	var _reactFormalInputs = __webpack_require__(808);
	
	var _reactFormalInputs2 = _interopRequireDefault(_reactFormalInputs);
	
	var _yup = __webpack_require__(893);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _formularioUsuario = __webpack_require__(1077);
	
	var styles = _interopRequireWildcard(_formularioUsuario);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	//let PropTypes = React.PropTypes
	// Moment
	
	
	var momentLocalizer = __webpack_require__(915);
	momentLocalizer(_moment2.default);
	// Validador Rut
	
	// Forms
	
	_reactFormal2.default.addInputTypes(_reactFormalInputs2.default);
	// Componentes
	
	var cx = _bind2.default.bind(styles);
	
	
	var listaBancos = ['Banco Estado', 'Banco de Chile', 'Banco Internacional', 'Scotiank-Desarrollo', 'Banco de Credito e Inversiones', 'CorpBanca', 'Banco Bice', 'HSBC Bank Chile', 'Banco Santander', 'Banco Itaú', 'The Bank of Tokyo-Mitsubishi', 'Banco Security', 'Banco Falabella', 'Banco Ripley', 'Banco Consorcio', 'Banco Paris', 'Banco BBVA', 'Copeuch', 'Banco Penta', 'Scotiabank Chile', 'Deutsche Bank', 'Rabobank Chile'];
	var listaTipoCuentas = ['Cuenta Corriente', 'Cuenta Vista', 'Cuenta Ahorro', 'Chequera Electronica', 'Cuenta de Gastos', 'Cuenta RUT'];
	
	var FormularioUsuario = exports.FormularioUsuario = function (_React$Component) {
	    _inherits(FormularioUsuario, _React$Component);
	
	    function FormularioUsuario() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FormularioUsuario);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormularioUsuario.__proto__ || Object.getPrototypeOf(FormularioUsuario)).call.apply(_ref, [this].concat(args))), _this), _this.usuarioSchema = _yup2.default.object({
	            usuarioRUN: _yup2.default.string().default(_this.props.usuario.usuarioRUN).min(1, 'El RUN debe tener un minimo de 1 caracteres').max(8, 'El RUN debe tener un máximo de 8 caracteres'),
	            usuarioDV: _yup2.default.string().default(_this.props.usuario.usuarioDV).required('Ingrese el digito verificador del RUN').test('verificarUsuarioDV', 'El digito verificador es incorrecto', function (value) {
	                // Hack sucio... cuando se hace una validacion con delay, se sacan los valores de options, si no, de parent
	                var valores = this.options.value ? this.options.value : this.parent;
	                return (0, _ValidadorRUN.validarRUN)(valores.usuarioRUN, value);
	            }).max(1, 'El máximo es 1 digito'),
	            email: _yup2.default.string().default(_this.props.usuario.email).max(60, 'El máximo es 60 caracteres')
	            //.email('Debe ser un email valido'),
	            .test('correo', 'Debe ingresar un email valido', function (value) {
	                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	                return value === '' || rEmail.test(value);
	            }),
	            emailPersonal: _yup2.default.string().default(_this.props.usuario.emailPersonal).max(60, 'El máximo es 60 caracteres')
	            //.email('Debe ser un email valido'),
	            .required('Ingrese el email').test('correo', 'Debe ingresar un email valido', function (value) {
	                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	                return value === '' || rEmail.test(value);
	            }),
	            nombre1: _yup2.default.string().default(_this.props.usuario.nombre1).required('Ingrese el primer nombre').min(3, 'El minimo es de 3 caracteres').max(15, 'El máximo es 15 caracteres'),
	            nombre2: _yup2.default.string().default(_this.props.usuario.nombre2).max(15, 'El máximo es 15 caracteres'),
	            apellidoPaterno: _yup2.default.string().default(_this.props.usuario.apellidoPaterno).required('Ingrese el apellido').min(3, 'El minimo es de 3 caracteres').max(20, 'El máximo es 20 caracteres'),
	            apellidoMaterno: _yup2.default.string().default(_this.props.usuario.apellidoMaterno).max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            telefono: _yup2.default.string().default(_this.props.usuario.telefono).max(20, 'El máximo es 20 caracteres').required('Ingrese el teléfono de la persona'),
	            telefonoEmergencia: _yup2.default.string().default(_this.props.usuario.telefonoEmergencia).max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            // TODO: este validador no permite que existan fechas "invalidas" como un string vacio, arreglar esto eventualmente....
	            fechaNacimiento: _yup2.default.date().default(_this.props.usuario.fechaNacimiento === '0000-00-00' ? null : new Date(_this.props.usuario.fechaNacimiento.replace(/-/g, '\/').replace(/T.+/, ''))).test('fechaNacimiento', 'Mensaje de error', function () {
	                return true;
	            }),
	            //.required('Ingrese la fecha de nacimiento'),
	            sexo: _yup2.default.string().default(_this.props.usuario.sexo).required('Ingrese el sexo de la persona'),
	            nacionalidad: _yup2.default.string().default(_this.props.usuario.nacionalidad).required('Ingrese la nacionalidad de la persona'),
	            direccion: _yup2.default.string().default(_this.props.usuario.direccion).max(150, 'El máximoes de 5 caracteres').required('Ingrese la dirección de la persona'),
	            // cutRegion: yup.number()
	            //     .required('Seleccione una Región'),
	            cutComuna: _yup2.default.number().default(parseInt(_this.props.usuario.cutComuna)) // es un number, pero lo retornan como string
	            .required('Seleccione una Comuna'),
	            tipoContrato: _yup2.default.string().default(_this.props.usuario.tipoContrato)
	            // .required('Escriba el Tipo de Contrato, o seleccionelo de la lista')
	            .max(30, 'El máximo es 30 caracteres'),
	            banco: _yup2.default.string().default(_this.props.usuario.banco).required('Seleccione el Banco de la lista'),
	            //.max(30, 'El máximo es 30 caracteres'),
	            tipoCuenta: _yup2.default.string().default(_this.props.usuario.tipoCuenta).required('Seleccionelo el Tipo de Cuenta de la lista'),
	            //.max(30, 'El máximo es 30 caracteres'),
	            numeroCuenta: _yup2.default.string().default(_this.props.usuario.numeroCuenta).required('Escriba el Número de Cuenta').max(30, 'El máximo es 30 caracteres')
	        }), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FormularioUsuario, [{
	        key: 'enviarFormularioInvalido',
	        value: function enviarFormularioInvalido(datos) {
	            console.log('enviando invalido ', datos);
	        }
	    }, {
	        key: 'siguienteComponente',
	        value: function siguienteComponente(refComponente, evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                if (refComponente === 'refFechaNacimiento') {
	                    //this.refFechaNacimiento.refs.input.focus() // OK para el wrapper
	                    this.refFechaNacimiento.refs.input.focus(); // OK para el date2
	                } else if (refComponente === 'refComuna') {
	                    this.refComuna.refs.input.refs.inner.open(); // OK para el date2
	                } else {
	                    _reactDom2.default.findDOMNode(this[refComponente].refs.input).select();
	                }
	                // console.log( ReactDOM.findDOMNode(this.refNombre1).focus() ) // OK
	                // console.log( ReactDOM.findDOMNode(this.refNombre1.refs.input).focus() ) // OK
	                return;
	            }
	        }
	
	        // componentDidMount(){
	        //     // seleccionar DV al mostrar el componente
	        //     ReactDOM.findDOMNode(this['refUsuarioDV'].refs.input).select()
	        // }
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactFormal2.default,
	                    {
	                        className: 'form-horizontal',
	                        schema: this.usuarioSchema,
	                        defaultValue: this.usuarioSchema.default()
	                        //delay={1000}
	                        //noValidate={true}
	                        , onSubmit: this.props.enviarFormulario.bind(this),
	                        onInvalidSubmit: this.enviarFormularioInvalido.bind(this) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-7' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Datos Personales'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'RUN (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                        name: 'usuarioRUN'
	                                        //disabled={true}
	                                        , mapValue: {
	                                            usuarioRUN: function usuarioRUN(_usuarioRUN) {
	                                                return _usuarioRUN;
	                                            },
	                                            usuarioDV: function usuarioDV(usuarioRUN) {
	                                                return (0, _ValidadorRUN.obtenerVerificador)(usuarioRUN);
	                                            }
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refUsuarioDV')
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-2' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                        name: 'usuarioDV',
	                                        disabled: true,
	                                        ref: function ref(_ref2) {
	                                            return _this2.refUsuarioDV = _ref2;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNombre1')
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': ['usuarioRUN', 'usuarioDV'], errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Nombres (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Primer Nombre',
	                                        name: 'nombre1',
	                                        ref: function ref(_ref3) {
	                                            return _this2.refNombre1 = _ref3;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNombre2')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre1', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Segundo Nombre',
	                                        name: 'nombre2',
	                                        ref: function ref(_ref4) {
	                                            return _this2.refNombre2 = _ref4;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refApellidoPaterno')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre2', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Apellidos (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Apellido Paterno',
	                                        name: 'apellidoPaterno',
	                                        ref: function ref(_ref5) {
	                                            return _this2.refApellidoPaterno = _ref5;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refApellidoMaterno')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoPaterno', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Apellido Materno',
	                                        name: 'apellidoMaterno',
	                                        ref: function ref(_ref6) {
	                                            return _this2.refApellidoMaterno = _ref6;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refFechaNacimiento')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoMaterno', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Fecha Nacimiento (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'date2', time: false, errorClass: cx('form__field--error'), placeholder: 'Ej. 31-07-2016',
	                                        name: 'fechaNacimiento',
	                                        format: 'D-M-YYYY',
	                                        editFormat: 'D-M-YYYY',
	                                        ref: function ref(_ref7) {
	                                            return _this2.refFechaNacimiento = _ref7;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefono')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'fechaNacimiento', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Sexo (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { name: 'sexo', type: 'combobox',
	                                        data: ['Masculino', 'Femenino'],
	                                        duration: 0
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'sexo', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Nacionalidad (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Chilena',
	                                        name: 'nacionalidad',
	                                        ref: function ref(_ref8) {
	                                            return _this2.refNacionalidad = _ref8;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefono')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nacionalidad', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Contacto'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Telefono (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: '978164162',
	                                        name: 'telefono',
	                                        ref: function ref(_ref9) {
	                                            return _this2.refTelefono = _ref9;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTelefonoEmergencia')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefono', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Telefono de Emergencia',
	                                        name: 'telefonoEmergencia',
	                                        ref: function ref(_ref10) {
	                                            return _this2.refTelefonoEmergencia = _ref10;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refEmail')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefonoEmergencia', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Email'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Email SEI',
	                                        name: 'email',
	                                        ref: function ref(_ref11) {
	                                            return _this2.refEmail = _ref11;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refEmailPersonal')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'email', errorClass: cx('form__message-error') })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { style: { 'display': 'inline-block', 'width': '90%' }, className: 'form-control', placeholder: 'Email personal',
	                                        name: 'emailPersonal',
	                                        ref: function ref(_ref12) {
	                                            return _this2.refEmailPersonal = _ref12;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refComuna')
	                                    }),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { style: { 'display': 'inline-block', 'width': '10%' }, className: 'control-label' },
	                                        '(*)'
	                                    ),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'emailPersonal', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comuna (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'cutComuna',
	                                        data: this.props.comunas,
	                                        valueField: 'cutComuna',
	                                        textField: 'nombre'
	                                        //groupBy='cutProvincia'
	                                        , filter: 'startsWith',
	                                        mapValue: { 'cutComuna': function cutComuna(comuna) {
	                                                return comuna.cutComuna;
	                                            } },
	                                        duration: 10,
	                                        ref: function ref(_ref13) {
	                                            return _this2.refComuna = _ref13;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refDireccion')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'cutComuna', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Direcci\xF3n (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Direcci\xF3n',
	                                        name: 'direccion',
	                                        ref: function ref(_ref14) {
	                                            return _this2.refDireccion = _ref14;
	                                        }
	                                        //onKeyPress={this.siguienteComponente.bind(this, 'refDireccion')}
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'direccion', errorClass: cx('form__message-error') })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Datos Laborales'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Tipo contrato'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { name: 'tipoContrato', type: 'combobox',
	                                        data: ['Plazo', 'Honorario'],
	                                        duration: 0
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'tipoContrato', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Pagos'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Banco (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'banco',
	                                        data: this.props.bancos.map(function (banco) {
	                                            return banco.nombreCorto;
	                                        }),
	                                        filter: 'startsWith',
	                                        duration: 10,
	                                        ref: function ref(_ref15) {
	                                            return _this2.refBanco = _ref15;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refTipoCuenta')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'banco', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Tipo Cuenta (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                        name: 'tipoCuenta',
	                                        filter: 'startsWith',
	                                        duration: 10,
	                                        data: this.props.tiposcuentas.map(function (cuentas) {
	                                            return cuentas.nombreCuenta;
	                                        }),
	                                        ref: function ref(_ref16) {
	                                            return _this2.refTipoCuenta = _ref16;
	                                        },
	                                        onKeyPress: this.siguienteComponente.bind(this, 'refNumCuenta')
	                                    }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'tipoCuenta', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Numero Cuenta (*)'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', name: 'numeroCuenta', placeholder: 'Ej. 123-456-789-9' }),
	                                    _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'numeroCuenta', errorClass: cx('form__message-error') })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Otros'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Certificado Antecedentes'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement('input', { id: 'input-1', type: 'file', className: 'file', disabled: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-4 control-label' },
	                                    'Fotografia'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-8' },
	                                    _react2.default.createElement('input', { id: 'input-1', type: 'file', className: 'file', disabled: true })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx("col-sm-12", 'form__footer') },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-default', onClick: this.props.cancelarFormulario },
	                                'Cancelar'
	                            ),
	                            _react2.default.createElement(
	                                _reactFormal2.default.Button,
	                                { type: 'submit', className: 'btn btn-primary' },
	                                this.props.btnTexto
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FormularioUsuario;
	}(_react2.default.Component);
	
	FormularioUsuario.propTypes = {
	    usuario: _propTypes2.default.object,
	    enviarFormulario: _propTypes2.default.func,
	    cancelarFormulario: _propTypes2.default.func,
	    comunas: _propTypes2.default.array,
	    bancos: _propTypes2.default.array,
	    btnTexto: _propTypes2.default.string
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FormularioUsuario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form__control-label":"formularioUsuario__form__control-label___YgZEc","form__footer":"formularioUsuario__form__footer___ktSrR","form__message-error":"formularioUsuario__form__message-error___2WCrY","form__field--error":"formularioUsuario__form__field--error___3chYO"};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ZoomImagen = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ZoomImagen = __webpack_require__(1079);
	
	var css = _interopRequireWildcard(_ZoomImagen);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var zoomImagen = [css.imagenZoom, css.imagenZoom1, css.imagenZoom2, css.imagenZoom3, css.imagenZoom4];
	
	var ZoomImagen = exports.ZoomImagen = function (_React$Component) {
	    _inherits(ZoomImagen, _React$Component);
	
	    function ZoomImagen(props) {
	        _classCallCheck(this, ZoomImagen);
	
	        var _this = _possibleConstructorReturn(this, (ZoomImagen.__proto__ || Object.getPrototypeOf(ZoomImagen)).call(this, props));
	
	        _this.state = {
	            countScroll: 0,
	            zoomActivo: false
	        };
	        _this.preventDefault = _this.preventDefault.bind(_this);
	        //Función para volver a mover el scrollbar con la rueda de el mouse
	        _this.enableScroll = function () {
	            document.removeEventListener('wheel', _this.preventDefault, false);
	        };
	        //Función para evitar que se mueva el scrollbar con la rueda de el mouse al realizar el zoom
	        _this.disableScroll = function () {
	            document.addEventListener('wheel', _this.preventDefault, {
	                passive: false
	            });
	        };
	        //Setea la variable de scroll para activar el zoom y llama al evento de deshabilitar la scrollbar
	        //Se activa cuando se ubica el puntero de el mouse sobre la imagen
	        _this.mouseEnterImagen = function () {
	            _this.setState({
	                countScroll: 0,
	                zoomActivo: true
	            }, function () {
	                return _this.disableScroll();
	            });
	        };
	        //Setea la variable de scroll para desactivar el zoom y llama al evento de habilitar la scrollbar
	        //Se activa cuando se quita el puntero de el mouse sobre la imagen
	        _this.mouseLeaveImagen = function () {
	            _this.setState({
	                countScroll: 0,
	                zoomActivo: false
	            }, function () {
	                return _this.enableScroll();
	            });
	        };
	        return _this;
	    }
	    //Evento para cambiar el contador de el zoom cuando de mueva la rueda de el mouse
	    //si evt.detay > 0 disminuye zoom sino lo aumenta
	
	
	    _createClass(ZoomImagen, [{
	        key: 'preventDefault',
	        value: function preventDefault(evt) {
	            evt = evt || window.event;
	            if (evt.preventDefault) {
	                evt.preventDefault();
	            }
	            evt.returnValue = false;
	            //Obtener valor actual de el scroll
	            var countScroll = this.state.countScroll;
	            if (this.state.zoomActivo) {
	                if (evt.deltaY > 0) {
	                    this.setState({
	                        countScroll: countScroll > 0 ? countScroll - 1 : countScroll
	                    });
	                } else {
	                    this.setState({
	                        countScroll: countScroll < 4 ? countScroll + 1 : countScroll
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    { className: css.tooltip },
	                    _react2.default.createElement('img', { src: '' + this.props.ruta_imagen, className: css.imagenOriginal }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: css.tooltiptext },
	                        _react2.default.createElement('img', {
	                            src: '' + this.props.ruta_imagen,
	                            className: zoomImagen[this.state.countScroll],
	                            onMouseEnter: this.mouseEnterImagen,
	                            onMouseLeave: this.mouseLeaveImagen
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ZoomImagen;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ZoomImagen.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imagenOriginal":"ZoomImagen__imagenOriginal___2Ixk2","tooltip":"ZoomImagen__tooltip___E0-Hn","tooltiptext":"ZoomImagen__tooltiptext___2rERd","imagenZoom":"ZoomImagen__imagenZoom___38dUk","imagenZoom1":"ZoomImagen__imagenZoom1___3fhhm","imagenZoom2":"ZoomImagen__imagenZoom2___VOxz3","imagenZoom3":"ZoomImagen__imagenZoom3___2E7y9","imagenZoom4":"ZoomImagen__imagenZoom4___3EvCe"};

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"modal__modal___3JAlj","modalUser":"modal__modalUser___1VFH1","modalReviewFiles":"modal__modalReviewFiles___3-FMU","btnPreviewNext":"modal__btnPreviewNext___zl_rR","textInfo":"modal__textInfo___2HM88","selectCliente":"modal__selectCliente___2iaXy","bloquearUsuario_footer":"modal__bloquearUsuario_footer___3293n","cambiarContrasena_footer":"modal__cambiarContrasena_footer___1-qqy","editarUsuario_footer":"modal__editarUsuario_footer___3G0l9","btn-50-perc":"modal__btn-50-perc___lD8Li","btn-file":"modal__btn-file___2JQmV","btnModal":"modal__btnModal___4rd6J","div-option-file":"modal__div-option-file___1rM6L","originalImage":"modal__originalImage___2NuCY"};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorCorreos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _mantenedorCorreos = __webpack_require__(1082);
	
	var _mantenedorCorreos2 = _interopRequireDefault(_mantenedorCorreos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Libs
	
	// Styles
	
	
	var MantenedorCorreos = exports.MantenedorCorreos = function (_React$Component) {
	    _inherits(MantenedorCorreos, _React$Component);
	
	    function MantenedorCorreos(props) {
	        _classCallCheck(this, MantenedorCorreos);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorCorreos.__proto__ || Object.getPrototypeOf(MantenedorCorreos)).call(this, props));
	
	        _this.state = {
	            idCliente: 2,
	            correos: [],
	            nuevoCorreo: '',
	            nuevoNombre: ''
	        };
	        _this.seleccionarCliente = function (evt) {
	            var idCliente = evt.target.value;
	            _this.setState({
	                idCliente: idCliente,
	                locales: []
	            }, function () {
	                _this.fetchCorreos();
	            });
	        };
	        _this.fetchCorreos = function () {
	            _v2.default.cliente(_this.state.idCliente).getCorreos().then(function (correos) {
	                _this.setState({
	                    correos: correos,
	                    nuevoCorreo: '',
	                    nuevoNombre: ''
	                });
	            }).catch(function (meh) {});
	        };
	        _this.quitarCorreo = function (idCorreo) {
	            _v2.default.cliente(_this.state.idCliente).quitarCorreo(idCorreo).then(function () {
	                return _this.fetchCorreos();
	            });
	        };
	        // agregar correo
	        _this.onNuevoCorreoChange = function (evt) {
	            return _this.setState({ nuevoCorreo: evt.target.value });
	        };
	        _this.onNuevoNombreChange = function (evt) {
	            return _this.setState({ nuevoNombre: evt.target.value });
	        };
	
	        _this.agregarCorreo = function () {
	            if (_this.state.nuevoCorreo == '' || _this.state.nuevoNombre == '') return;
	            _v2.default.cliente(_this.state.idCliente).agregarCorreo({
	                correo: _this.state.nuevoCorreo,
	                nombre: _this.state.nuevoNombre
	            }).then(_this.fetchCorreos).catch(function (meh) {});
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorCorreos, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchCorreos();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Correos de clientes'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-3 col-sm-offset-1' },
	                        _react2.default.createElement(SelectorCliente, {
	                            idClienteSeleccionado: this.state.idCliente,
	                            seleccionarCliente: this.seleccionarCliente,
	                            clientes: this.props.clientes
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group ' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'control-label', htmlFor: 'cliente' },
	                                'Correos'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'list-group' },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'list-group-item' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _mantenedorCorreos2.default.fixedWidth },
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            'Correo'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _mantenedorCorreos2.default.fixedWidth },
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            'Nombre'
	                                        )
	                                    )
	                                ),
	                                this.state.correos.map(function (correo) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: correo.idCorreo, className: 'list-group-item' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: _mantenedorCorreos2.default.fixedWidth },
	                                            correo.correo
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: _mantenedorCorreos2.default.fixedWidth },
	                                            correo.nombre
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'btn btn-xs btn-danger pull-right',
	                                                onClick: _this2.quitarCorreo.bind(_this2, correo.idCorreo)
	                                            },
	                                            'Eliminar'
	                                        )
	                                    );
	                                }),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'list-group-item' },
	                                    _react2.default.createElement('input', { type: 'text', className: "control-form " + _mantenedorCorreos2.default.fixedWidth,
	                                        value: this.state.nuevoCorreo,
	                                        onChange: this.onNuevoCorreoChange,
	                                        onKeyDown: function onKeyDown(evt) {
	                                            if (evt.keyCode == 13) _this2.refNombre.focus();
	                                        }
	                                    }),
	                                    _react2.default.createElement('input', { type: 'text', className: "control-form " + _mantenedorCorreos2.default.fixedWidth,
	                                        value: this.state.nuevoNombre,
	                                        ref: function ref(_ref) {
	                                            return _this2.refNombre = _ref;
	                                        },
	                                        onChange: this.onNuevoNombreChange,
	                                        onKeyDown: function onKeyDown(evt) {
	                                            if (evt.keyCode == 13) _this2.agregarCorreo();
	                                        }
	                                    }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-xs btn-success pull-right',
	                                            onClick: this.agregarCorreo
	                                        },
	                                        'Agregar'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MantenedorCorreos;
	}(_react2.default.Component);
	
	var SelectorCliente = function SelectorCliente(_ref2) {
	    var idClienteSeleccionado = _ref2.idClienteSeleccionado,
	        seleccionarCliente = _ref2.seleccionarCliente,
	        clientes = _ref2.clientes;
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-group ' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label', htmlFor: 'cliente' },
	            'Cliente'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control', name: 'cliente',
	                value: idClienteSeleccionado,
	                onChange: seleccionarCliente
	            },
	            _react2.default.createElement(
	                'option',
	                { value: '-1', disabled: true },
	                '--'
	            ),
	            clientes.map(function (cliente) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: cliente.idCliente, value: cliente.idCliente },
	                    cliente.nombreCorto + ' - ' + cliente.nombre
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "mantenedor-correos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fixedWidth":"mantenedor-correos__fixedWidth___Z8_Pv"};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorCaptadoresZonas = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaZonas = __webpack_require__(1084);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	/*Nombre de clase debe ser igual a la definida en boot-client*/
	var MantenedorCaptadoresZonas = exports.MantenedorCaptadoresZonas = function (_React$Component) {
	    _inherits(MantenedorCaptadoresZonas, _React$Component);
	
	    function MantenedorCaptadoresZonas(props) {
	        _classCallCheck(this, MantenedorCaptadoresZonas);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorCaptadoresZonas.__proto__ || Object.getPrototypeOf(MantenedorCaptadoresZonas)).call(this, props));
	
	        _this.state = {
	            captadores: _this.props.captadores,
	            comunasSelect: _this.props.comunas,
	            // Por defecto seleccionar SEI SEI
	            idCaptador: "1",
	            // Por defecto seleccionar Algarrobo
	            // Valor defecto es 0
	            valor: 0,
	            cutComuna: "5602",
	            comunas: [],
	            operadores: [],
	            editandoValor: false,
	            error: {}
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.seleccionarCaptador = function (evt) {
	            var idCaptador = evt.target.value;
	            _this.setState({
	                idCaptador: idCaptador,
	                comunas: []
	            }, function () {
	                _this.fetchZonas();
	            });
	        };
	        _this.seleccionarComuna = function (evt) {
	            var cutComuna = evt.target.value;
	            _this.setState({
	                cutComuna: cutComuna
	            });
	        };
	        _this.onChangeValor = function (evt) {
	            var valor = evt.target.value;
	            _this.setState({
	                valor: valor
	            });
	        };
	        _this.fetchZonas = function () {
	            _v2.default.captador(_this.state.idCaptador).getZonas().then(function (data) {
	                _this.setState({ comunas: data });
	            }).catch(_this.ajaxErrorHandler('Error al buscar zonas'));
	        };
	        _this.editarValor = function (zona, valor) {
	            var request = _v2.default.captador(_this.state.idCaptador).actualizarValor(zona, valor);
	            request.then(function () {
	                return _this.fetchZonas();
	            }, _this.refs.notificator.success("Cambio en valor", "Valor editado correctamente", 4 * 1000)).catch(_this.ajaxErrorHandler('Error al editar valor'));
	            return request;
	        };
	        _this.asociarZona = function () {
	            var request = _v2.default.captador(_this.state.idCaptador).asociarZona(_this.state.cutComuna, _this.state.valor);
	            request.then(function () {
	                return _this.fetchZonas();
	            }).catch(_this.ajaxErrorHandler('Error al asociar zona'));
	            return request;
	        };
	        _this.guardar = function (evt) {
	            evt.preventDefault();
	            _this.setState(function () {
	                _this.asociarZona().then(function () {
	                    _this.refs.notificator.success("Asociar zona", "Zona asociada correctamente", 4 * 1000);
	                }).catch(function (error) {
	                    _this.setState({ error: error.data });
	                });
	            });
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorCaptadoresZonas, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchZonas();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-offset-4 col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Captadores por zonas'
	                        )
	                    )
	                ),
	                _react2.default.createElement(SelectorCaptador, {
	                    idCaptadorSeleccionado: this.state.idCaptador,
	                    seleccionarCaptador: this.seleccionarCaptador,
	                    captadores: this.state.captadores
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Zonas de captador'
	                        ),
	                        _react2.default.createElement(_TablaZonas.TablaZonas, {
	                            zonas: this.state.comunas,
	                            editarValor: this.editarValor
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2 col-md-offset-2' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Asociar nueva Comuna'
	                        ),
	                        _react2.default.createElement(NuevaZona, {
	                            comunas: this.state.comunasSelect,
	                            seleccionarComuna: this.seleccionarComuna,
	                            onChangeValor: this.onChangeValor,
	                            valorDefecto: this.state.valor,
	                            guardar: this.guardar
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MantenedorCaptadoresZonas;
	}(_react2.default.Component);
	
	var SelectorCaptador = function SelectorCaptador(_ref) {
	    var idCaptadorSeleccionado = _ref.idCaptadorSeleccionado,
	        seleccionarCaptador = _ref.seleccionarCaptador,
	        captadores = _ref.captadores;
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-sm-2 form-group ' },
	            _react2.default.createElement(
	                'label',
	                { className: 'control-label', htmlFor: 'captador' },
	                'Seleccione Captador'
	            ),
	            _react2.default.createElement(
	                'select',
	                { className: 'form-control', name: 'captador',
	                    value: idCaptadorSeleccionado,
	                    onChange: seleccionarCaptador
	                },
	                captadores.map(function (captador) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: captador.id, value: captador.id },
	                        captador.nombre1 + ' ' + captador.apellidoPaterno
	                    );
	                })
	            )
	        )
	    );
	};
	
	var NuevaZona = function NuevaZona(_ref2) {
	    var comunas = _ref2.comunas,
	        seleccionarComuna = _ref2.seleccionarComuna,
	        onChangeValor = _ref2.onChangeValor,
	        valorDefecto = _ref2.valorDefecto,
	        guardar = _ref2.guardar;
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: guardar },
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: undefined,
	                onChange: seleccionarComuna
	            },
	            comunas.map(function (comuna) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: comuna.cutComuna, value: comuna.cutComuna },
	                    '' + comuna.nombre
	                );
	            })
	        ),
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label' },
	            'Precio:',
	            _react2.default.createElement('input', { type: 'number', className: 'form-control', onChange: onChangeValor, value: valorDefecto })
	        ),
	        _react2.default.createElement('input', { type: 'submit', value: 'Guardar', className: 'btn btn-success' })
	    );
	};
	MantenedorCaptadoresZonas.propTypes = {
	    captadores: PropTypes.array,
	    provincias: PropTypes.array
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "captadoresZonas.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaZonas = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _tablaPersonal = __webpack_require__(716);
	
	var css = _interopRequireWildcard(_tablaPersonal);
	
	var _Modales = __webpack_require__(1085);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Styles
	
	var TablaZonas = exports.TablaZonas = function (_React$Component) {
	    _inherits(TablaZonas, _React$Component);
	
	    function TablaZonas() {
	        _classCallCheck(this, TablaZonas);
	
	        return _possibleConstructorReturn(this, (TablaZonas.__proto__ || Object.getPrototypeOf(TablaZonas)).apply(this, arguments));
	    }
	
	    _createClass(TablaZonas, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '70%' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.zonas.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.zonas[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowIndex = _ref4.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 30
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombreComuna', label: 'Comuna',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var cellData = _ref5.cellData,
	                                        columnData = _ref5.columnData,
	                                        dataKey = _ref5.dataKey,
	                                        rowData = _ref5.rowData,
	                                        rowIndex = _ref5.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 120
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'numeroRegion', label: 'Region',
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var cellData = _ref6.cellData,
	                                        columnData = _ref6.columnData,
	                                        dataKey = _ref6.dataKey,
	                                        rowData = _ref6.rowData,
	                                        rowIndex = _ref6.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 100
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombreRegion', label: 'Nombre',
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var cellData = _ref7.cellData,
	                                        columnData = _ref7.columnData,
	                                        dataKey = _ref7.dataKey,
	                                        rowData = _ref7.rowData,
	                                        rowIndex = _ref7.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 270
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'valor', label: 'Valor',
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var cellData = _ref8.cellData,
	                                        columnData = _ref8.columnData,
	                                        dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData,
	                                        rowIndex = _ref8.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 270
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'opciones',
	                                label: 'Editar',
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var cellData = _ref9.cellData,
	                                        columnData = _ref9.columnData,
	                                        dataKey = _ref9.dataKey,
	                                        rowData = _ref9.rowData,
	                                        rowIndex = _ref9.rowIndex;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(BotonEditar, {
	                                            zona: rowData.cutComuna,
	                                            actualizarValor: _this2.props.editarValor,
	                                            valorZona: rowData.valorZona
	                                        })
	                                    );
	                                },
	                                width: 130
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaZonas;
	}(_react2.default.Component);
	
	var BotonEditar = function BotonEditar(_ref10) {
	    var zona = _ref10.zona,
	        actualizarValor = _ref10.actualizarValor,
	        captador = _ref10.captador,
	        valorZona = _ref10.valorZona;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-xs btn-primary', onClick: showModal },
	                'Editar Precio',
	                isVisible && _react2.default.createElement(_Modales.ModalEditarUsuario, {
	                    zona: zona,
	                    actualizarValor: actualizarValor,
	                    captador: captador,
	                    hideModal: hideModal,
	                    valorZona: valorZona
	                })
	            );
	        }
	    );
	};
	var BotonEliminar = function BotonEliminar(_ref11) {
	    _objectDestructuringEmpty(_ref11);
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-xs btn-danger', onClick: showModal, disabled: true },
	                'Eliminar Zona',
	                isVisible && _react2.default.createElement(_Modales.ModalEliminarZona, null)
	            );
	        }
	    );
	};
	TablaZonas.propTypes = {
	    zonas: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaZonas.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalEliminarZona = exports.ModalEditarUsuario = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1086);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalEditarUsuario = exports.ModalEditarUsuario = function (_React$Component2) {
	    _inherits(ModalEditarUsuario, _React$Component2);
	
	    function ModalEditarUsuario(props) {
	        _classCallCheck(this, ModalEditarUsuario);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalEditarUsuario.__proto__ || Object.getPrototypeOf(ModalEditarUsuario)).call(this, props));
	
	        _this2.state = {
	            zona: _this2.props.zona,
	            captador: _this2.props.captador,
	            error: {},
	            valorZona: _this2.props.valorZona
	        };
	        _this2.onPrecioChange = function (key, evt) {
	            _this2.setState({ valorZona: evt.target.value });
	        };
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState({ error: {} }, function () {
	                _this2.props.actualizarValor(_this2.state.zona, _this2.state.valorZona).then(function () {
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    _this2.setState({ error: error.data });
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalEditarUsuario, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Ind\xEDque el nuevo valor'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Valor Actual'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.valorZona,
	                                    onChange: this.onPrecioChange.bind(this, 'valorZona') })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('editarUsuario_footer') },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', className: cx("btn btn-block btn-default", 'btn-50-perc'), onClick: this.props.hideModal },
	                                'Cancelar'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'submit', className: cx("btn btn-block btn-primary", 'btn-50-perc') },
	                                'Modificar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalEditarUsuario;
	}(_react2.default.Component);
	
	var ModalEliminarZona = exports.ModalEliminarZona = function ModalEliminarZona(_ref) {
	    var hideModal = _ref.hideModal,
	        onBloquear = _ref.onBloquear;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: cx('modal') },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                '\xBFEsta seguro que desea eliminar la relaci\xF3n con esta zona?'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            { className: cx('bloquearUsuario_footer') },
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-default', onClick: hideModal },
	                'Cancelar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-block btn-danger', onClick: onBloquear },
	                'Eliminar Relaci\xF3n'
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"modal__modal___2RR3K","modalMostrar":"modal__modalMostrar___3GdVm","tabla-pegar-locales":"modal__tabla-pegar-locales___3bPSM","btn-50-perc":"modal__btn-50-perc___3Qagm","form__control-label":"modal__form__control-label___1s-go","form__error-message":"modal__form__error-message___29ZRj","textAlignLeft":"modal__textAlignLeft___u4vSJ","editarUsuario_footer":"modal__editarUsuario_footer___ZTrWW"};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorProducciones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaProducciones = __webpack_require__(1088);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var MantenedorProducciones = exports.MantenedorProducciones = function (_React$Component) {
	    _inherits(MantenedorProducciones, _React$Component);
	
	    function MantenedorProducciones(props) {
	        _classCallCheck(this, MantenedorProducciones);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorProducciones.__proto__ || Object.getPrototypeOf(MantenedorProducciones)).call(this, props));
	
	        _this.state = {
	            clientes: _this.props.clientes,
	            // Por defecto seleccionar PUC
	            idCliente: "1",
	            // Por defecto jornada noche
	            idJornada: "3",
	            editandoValor: false,
	            producciones: [],
	            error: {}
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.seleccionarCliente = function (evt) {
	            var idCliente = evt.target.value;
	            _this.setState({
	                idCliente: idCliente
	            }, function () {
	                _this.fetchProducciones();
	            });
	        };
	        _this.seleccionarJornada = function (evt) {
	            var idJornada = evt.target.value;
	            _this.setState({
	                idJornada: idJornada
	            }, function () {
	                _this.fetchProducciones();
	            });
	        };
	        _this.fetchProducciones = function () {
	            _v2.default.produccion(_this.state.idCliente, _this.state.idJornada).getProducciones().then(function (producciones) {
	                _this.setState({ producciones: producciones });
	            }).catch(_this.ajaxErrorHandler('Error al buscar las producciones'));
	        };
	        _this.editarValor = function (idProduccion, valor) {
	            var request = _v2.default.produccion(_this.state.idCliente, _this.state.idJornada).actualizarProduccion(idProduccion, valor);
	            request.then(function () {
	                return _this.fetchProducciones();
	            }, _this.refs.notificator.success("Cambio en producción", "Producción editada correctamente", 4 * 1000)).catch(_this.ajaxErrorHandler('Error al editar producción'));
	            return request;
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorProducciones, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchProducciones();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-offset-4 col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Producciones por regi\xF3n'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(SelectorCliente, {
	                        idClienteSeleccionado: this.state.idCliente,
	                        seleccionarCliente: this.seleccionarCliente,
	                        clientes: this.state.clientes
	                    }),
	                    _react2.default.createElement(SelectorJornada, {
	                        idJornadaSeleccionada: this.state.idJornada,
	                        seleccionarJornada: this.seleccionarJornada
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Producciones del cliente'
	                        ),
	                        _react2.default.createElement(_TablaProducciones.TablaProducciones, {
	                            producciones: this.state.producciones,
	                            editarValor: this.editarValor
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MantenedorProducciones;
	}(_react2.default.Component);
	
	var SelectorCliente = function SelectorCliente(_ref) {
	    var idClienteSeleccionado = _ref.idClienteSeleccionado,
	        seleccionarCliente = _ref.seleccionarCliente,
	        clientes = _ref.clientes;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2 form-group ' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label', htmlFor: 'cliente' },
	            'Seleccione cliente'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control', name: 'cliente',
	                value: idClienteSeleccionado,
	                onChange: seleccionarCliente
	            },
	            clientes.map(function (cliente) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: cliente.idCliente, value: cliente.idCliente },
	                    '' + cliente.nombreCorto
	                );
	            })
	        )
	    );
	};
	var SelectorJornada = function SelectorJornada(_ref2) {
	    var idJornadaSeleccionada = _ref2.idJornadaSeleccionada,
	        seleccionarJornada = _ref2.seleccionarJornada;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2 form-group ' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label', htmlFor: 'cliente' },
	            'Seleccione jornada'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control', name: 'cliente',
	                value: idJornadaSeleccionada,
	                onChange: seleccionarJornada
	            },
	            _react2.default.createElement(
	                'option',
	                { key: '2', value: '2' },
	                'D\xEDa'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: '3', value: '3' },
	                'Noche'
	            )
	        )
	    );
	};
	MantenedorProducciones.propTypes = {
	    clientes: PropTypes.array
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "producciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaProducciones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modales = __webpack_require__(1089);
	
	var _tablaPersonal = __webpack_require__(716);
	
	var css = _interopRequireWildcard(_tablaPersonal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Styles
	
	var TablaProducciones = exports.TablaProducciones = function (_React$Component) {
	    _inherits(TablaProducciones, _React$Component);
	
	    function TablaProducciones() {
	        _classCallCheck(this, TablaProducciones);
	
	        return _possibleConstructorReturn(this, (TablaProducciones.__proto__ || Object.getPrototypeOf(TablaProducciones)).apply(this, arguments));
	    }
	
	    _createClass(TablaProducciones, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '80%' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.producciones.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.producciones[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowIndex = _ref4.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 30
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombre', label: 'Nombre',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var cellData = _ref5.cellData,
	                                        columnData = _ref5.columnData,
	                                        dataKey = _ref5.dataKey,
	                                        rowData = _ref5.rowData,
	                                        rowIndex = _ref5.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 190
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'descripcion', label: 'Descripci\xF3n',
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var cellData = _ref6.cellData,
	                                        columnData = _ref6.columnData,
	                                        dataKey = _ref6.dataKey,
	                                        rowData = _ref6.rowData,
	                                        rowIndex = _ref6.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 600
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'produccionFormateada', label: 'Producci\xF3n',
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var cellData = _ref7.cellData,
	                                        columnData = _ref7.columnData,
	                                        dataKey = _ref7.dataKey,
	                                        rowData = _ref7.rowData,
	                                        rowIndex = _ref7.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'produccionReal', label: 'Real',
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var cellData = _ref8.cellData,
	                                        columnData = _ref8.columnData,
	                                        dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData,
	                                        rowIndex = _ref8.rowIndex;
	                                    return rowData[dataKey];
	                                },
	                                width: 130
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'opciones',
	                                label: 'Editar',
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var cellData = _ref9.cellData,
	                                        columnData = _ref9.columnData,
	                                        dataKey = _ref9.dataKey,
	                                        rowData = _ref9.rowData,
	                                        rowIndex = _ref9.rowIndex;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(BotonEditar, {
	                                            idProduccion: rowData.idProduccion,
	                                            actualizarValor: _this2.props.editarValor,
	                                            produccion: rowData.produccion
	                                        })
	                                    );
	                                },
	                                width: 90
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaProducciones;
	}(_react2.default.Component);
	
	var BotonEditar = function BotonEditar(_ref10) {
	    var idProduccion = _ref10.idProduccion,
	        actualizarValor = _ref10.actualizarValor,
	        produccion = _ref10.produccion;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-xs btn-primary', onClick: showModal },
	                'Edici\xF3n',
	                isVisible && _react2.default.createElement(_Modales.ModalEditarProduccion, {
	                    idProduccion: idProduccion,
	                    actualizarValor: actualizarValor,
	                    hideModal: hideModal,
	                    produccion: produccion
	                })
	            );
	        }
	    );
	};
	TablaProducciones.propTypes = {
	    producciones: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaProducciones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalEditarProduccion = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1090);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// Componentes
	
	// Style
	
	
	var cx = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalEditarProduccion = exports.ModalEditarProduccion = function (_React$Component2) {
	    _inherits(ModalEditarProduccion, _React$Component2);
	
	    function ModalEditarProduccion(props) {
	        _classCallCheck(this, ModalEditarProduccion);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalEditarProduccion.__proto__ || Object.getPrototypeOf(ModalEditarProduccion)).call(this, props));
	
	        _this2.state = {
	            idProduccion: _this2.props.idProduccion,
	            error: {},
	            produccion: _this2.props.produccion
	        };
	        _this2.onPrecioChange = function (key, evt) {
	            _this2.setState({ produccion: evt.target.value });
	        };
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState({ error: {} }, function () {
	                _this2.props.actualizarValor(_this2.state.idProduccion, _this2.state.produccion).then(function () {
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    _this2.setState({ error: error.data });
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalEditarProduccion, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Ind\xEDque el nuevo valor de la producci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('form-group', 'form__control-label') },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2 control-label' },
	                                'Valor Actual'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.produccion,
	                                    onChange: this.onPrecioChange.bind(this, 'valorZona')
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('editarUsuario_footer') },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', className: cx("btn btn-block btn-default", 'btn-50-perc'), onClick: this.props.hideModal },
	                                'Cancelar'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'submit', className: cx("btn btn-block btn-primary", 'btn-50-perc') },
	                                'Modificar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalEditarProduccion;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"modal__modal___1LrSB","selectCliente":"modal__selectCliente___3RjYu","bloquearUsuario_footer":"modal__bloquearUsuario_footer___2TVX2","cambiarContrasena_footer":"modal__cambiarContrasena_footer___dl8Rq","editarUsuario_footer":"modal__editarUsuario_footer___3i-MX","btn-50-perc":"modal__btn-50-perc___3EQmw","form__control-label":"modal__form__control-label___2HlyG","form__error-message":"modal__form__error-message___kxtJ3"};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorDistancias = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaDistancias = __webpack_require__(1092);
	
	var _BlackBoxDistancia = __webpack_require__(1095);
	
	var _BlackBoxDistancia2 = _interopRequireDefault(_BlackBoxDistancia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var PropTypes = _react2.default.PropTypes;
	_moment2.default.locale('es');
	
	var MantenedorDistancias = exports.MantenedorDistancias = function (_React$Component) {
	    _inherits(MantenedorDistancias, _React$Component);
	
	    function MantenedorDistancias(props) {
	        _classCallCheck(this, MantenedorDistancias);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorDistancias.__proto__ || Object.getPrototypeOf(MantenedorDistancias)).call(this, props));
	
	        _this.blackbox = new _BlackBoxDistancia2.default();
	        _this.getCuidadesZonas = _this.getCuidadesZonas.bind(_this);
	        _this.state = {
	            comunas: [],
	            comunasRow: [],
	            comunasHeader: [],
	            zonas: [],
	            filtrosComunas: [],
	            semanaSeleccionada: '',
	            numero_semana: 0
	        };
	        _this.onInputChange = function (key, evt) {
	            console.log(evt.target.value);
	            _this.setState(_defineProperty({}, key, evt.target.value));
	        };
	        _this.onSelectZona = function (index) {
	            var zonas = _this.state.zonas;
	            zonas[index].seleccionado = zonas[index].seleccionado ? 0 : 1;
	            _this.setState({
	                zonas: zonas
	            }, function () {
	                return _this.getCuidadesZonas();
	            });
	        };
	        _this.actualizarFiltro = function (nombreFiltro, filtro) {
	            _this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	            _this.setState(_this.blackbox.getListaFiltrada());
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorDistancias, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                guardaDestino: function guardaDestino(idComunaDistancia, idComunaOrigen, idComunaDestino, valor) {
	                    console.log('guardaDestinos');
	                    _v2.default.fondos().guardaDestinos(idComunaDistancia, idComunaOrigen, idComunaDestino, valor).then(function (resp) {
	                        console.log(resp);
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            _v2.default.otros.zonas().then(function (zonas) {
	                _this2.setState({ zonas: zonas });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'onWeekChange',
	        value: function onWeekChange(evt) {
	            var _this3 = this;
	
	            this.setState({
	                semanaSeleccionada: evt.target.value,
	                numero_semana: evt.target.value.substring(6, 8)
	            }, function () {
	                return _this3.getLideresSemana();
	            });
	        }
	    }, {
	        key: 'getCuidadesZonas',
	        value: function getCuidadesZonas() {
	            var _this4 = this;
	
	            var zonasSeleccionadas = [];
	            var i = 0;
	            this.blackbox.reset();
	            this.setState({
	                comunasRow: [],
	                semanaSeleccionada: '0000-W00',
	                comunasHeader: []
	            });
	
	            this.state.zonas.forEach(function (zona) {
	                if (zona.seleccionado) {
	                    zonasSeleccionadas[i] = zona.idZona;
	                    i++;
	                }
	            });
	            _v2.default.otros.comunasZonas(zonasSeleccionadas).then(function (comunas) {
	                comunas.forEach(function (comuna) {
	                    return _this4.blackbox.add(comuna);
	                });
	                _this4.blackbox.ordenar();
	                _this4.setState(_this4.blackbox.getListaFiltrada());
	                _this4.setState({
	                    comunasHeader: comunas
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'getLideresSemana',
	        value: function getLideresSemana() {
	            var _this5 = this;
	
	            _v2.default.otros.zonas().then(function (zonas) {
	                _this5.setState({
	                    zonas: zonas,
	                    comunasRow: [],
	                    comunasHeader: []
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	            this.blackbox.reset();
	
	            if (this.state.numero_semana) {
	                var fechaInicio = (0, _moment2.default)().day("Lunes").week(this.state.numero_semana).format('YYYY-MM-DD');
	                var fechaFin = (0, _moment2.default)().day("Domingo").week(this.state.numero_semana).format('YYYY-MM-DD');
	
	                _v2.default.fondos().getCiudadesInventarios(fechaInicio, fechaFin).then(function (comunas) {
	                    comunas.forEach(function (comuna) {
	                        return _this5.blackbox.add(comuna);
	                    });
	                    _this5.blackbox.ordenar();
	                    _this5.setState(_this5.blackbox.getListaFiltrada());
	                    _this5.setState({
	                        comunasHeader: comunas
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 form-group' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Mantenedor Distancias'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-info' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Buscar Por Zonas'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12' },
	                                    this.state.zonas.map(function (zona, index) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-3', key: zona.idZona },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement('input', { type: 'checkbox',
	                                                    checked: zona.seleccionado,
	                                                    title: zona.nombre,
	                                                    onChange: _this6.onSelectZona.bind(_this6, index) }),
	                                                zona.nombre
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-info' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Buscar por Semana de inventario'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6 form-group ' },
	                                _react2.default.createElement('input', { type: 'week', className: "form-control",
	                                    value: this.state.semanaSeleccionada,
	                                    onChange: this.onWeekChange.bind(this) })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(_TablaDistancias.TablaDistancias, {
	                            filtros: this.state.filtrosComunas,
	                            actualizarFiltro: this.actualizarFiltro.bind(this),
	                            comunasHeader: this.state.comunasHeader,
	                            comunasRow: this.state.comunasRow
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MantenedorDistancias;
	}(_react2.default.Component);
	
	MantenedorDistancias.childContextTypes = {
	    guardaDestino: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorDistancias.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaDistancias = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MantenedorDistancias = __webpack_require__(1093);
	
	var css = _interopRequireWildcard(_MantenedorDistancias);
	
	var _RowDistancias = __webpack_require__(1094);
	
	var _sticky = __webpack_require__(621);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(626);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var TablaDistancias = exports.TablaDistancias = function (_React$Component) {
	    _inherits(TablaDistancias, _React$Component);
	
	    function TablaDistancias(props) {
	        _classCallCheck(this, TablaDistancias);
	
	        var _this = _possibleConstructorReturn(this, (TablaDistancias.__proto__ || Object.getPrototypeOf(TablaDistancias)).call(this, props));
	
	        _this.rows = [];
	        _this.state = {
	            inputDistancia: []
	        };
	        return _this;
	    }
	
	    _createClass(TablaDistancias, [{
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length - 1;
	            var elemento = nombreElemento;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(elemento);
	            } else if (index >= ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero de la columna
	                this.rows[0].focusElemento(elemento);
	            } else {
	                // no es ni el ultimo, ni el primero
	                this.rows[index].focusElemento(elemento);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadComunasRow = this.props.comunasRow.length;
	            var cantidadComunasHeader = this.props.comunasHeader.length;
	            return _react2.default.createElement(
	                _container2.default,
	                { type: _react2.default.DOM.table, className: "table table-bordered table-condensed " + css.tableFixed },
	                _react2.default.createElement(
	                    'colgroup',
	                    null,
	                    _react2.default.createElement('col', { className: css.colIndex }),
	                    _react2.default.createElement('col', { className: css.colComuna }),
	                    this.props.comunasHeader.map(function (comunaHeader) {
	                        return _react2.default.createElement('col', { key: comunaHeader.cutComuna, className: css.colComuna });
	                    })
	                ),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        _sticky2.default,
	                        {
	                            topOffset: -50,
	                            type: _react2.default.DOM.tr,
	                            stickyStyle: { top: '50px' } },
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thIndex },
	                            '#'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: css.thComuna },
	                            _react2.default.createElement(_HeaderConFiltro2.default, {
	                                nombre: 'Comunas',
	                                filtro: this.props.filtros.filtroComuna || [],
	                                actualizarFiltro: this.props.actualizarFiltro.bind(this, 'filtroComuna'),
	                                busquedaExacta: true
	                            })
	                        ),
	                        this.props.comunasHeader.map(function (comunaHeader) {
	                            return _react2.default.createElement(
	                                'th',
	                                { key: comunaHeader.cutComuna, className: css.thComuna },
	                                comunaHeader.nombre
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _.range(0, cantidadComunasRow).map(function (index) {
	                        var comunaRow = _this2.props.comunasRow[index];
	                        return _react2.default.createElement(_RowDistancias.RowDistancias, {
	                            key: index,
	                            index: index,
	                            ref: function ref(_ref) {
	                                return _this2.rows[index] = _ref;
	                            },
	                            focusRow: _this2.focusRow.bind(_this2),
	                            comunaRow: comunaRow,
	                            cantidadComunasHeader: cantidadComunasHeader,
	                            comunasHeader: _this2.props.comunasHeader
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaDistancias;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaDistancias.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tableFixed":"MantenedorDistancias__tableFixed___2-ImK","trSeparador":"MantenedorDistancias__trSeparador___1BRD6","colIndex":"MantenedorDistancias__colIndex___1Ao9j","thIndex":"MantenedorDistancias__thIndex___36Bhr","tdIndex":"MantenedorDistancias__tdIndex___1Ig5Q","colComuna":"MantenedorDistancias__colComuna___2zesy","thComuna":"MantenedorDistancias__thComuna___Tqhd-","tdComuna":"MantenedorDistancias__tdComuna___2Ix80"};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowDistancias = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MantenedorDistancias = __webpack_require__(1093);
	
	var css = _interopRequireWildcard(_MantenedorDistancias);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowDistancias = exports.RowDistancias = function (_React$Component) {
	    _inherits(RowDistancias, _React$Component);
	
	    function RowDistancias(props) {
	        _classCallCheck(this, RowDistancias);
	
	        var _this = _possibleConstructorReturn(this, (RowDistancias.__proto__ || Object.getPrototypeOf(RowDistancias)).call(this, props));
	
	        _this.inputOnKeyDown = _this.inputOnKeyDown.bind(_this);
	        _this.state = {
	            inputDistancia: [{ valor: '', origen: '', destino: '' }]
	        };
	        _this.onInputChange = function (index, evt) {
	            console.log(index);
	            var inputDistancia = _this.state.inputDistancia;
	            inputDistancia.destinos[index].valor = evt.target.value;
	            inputDistancia.destinos[index].dirty = 1;
	            inputDistancia.dirty = 1;
	            _this.setState({
	                inputDistancia: inputDistancia
	            });
	        };
	        _this.onBlurInput = function (index) {
	            if (_this.state.inputDistancia.destinos[index].dirty) _this.context.guardaDestino(_this.state.inputDistancia.destinos[index].idComunaDistancia, _this.props.comunaRow.cutComuna, _this.state.inputDistancia.destinos[index].idComunaDestino, _this.state.inputDistancia.destinos[index].valor);
	        };
	        return _this;
	    }
	
	    _createClass(RowDistancias, [{
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            this[elemento].focus();
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(key, evt) {
	            console.log("enter");
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                //this.props.focusRow(this.props.index+1, key)
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                //this.props.focusRow(this.props.index-1, key)
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                inputDistancia: this.props.comunaRow
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                inputDistancia: nextProps.comunaRow
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex, title: this.props.comunaRow.cutComuna },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    this.props.comunaRow.nombre
	                ),
	                this.state.inputDistancia != [] ? _.range(0, this.state.inputDistancia.destinos.length).map(function (index) {
	                    return _react2.default.createElement(
	                        'td',
	                        { key: index },
	                        _react2.default.createElement('input', { type: 'number', className: 'form-control',
	                            placeholder: _this2.props.comunaRow.nombre + "-" + _this2.state.inputDistancia.destinos[index].nombreDestino,
	                            title: _this2.props.comunaRow.nombre + "-" + _this2.state.inputDistancia.destinos[index].nombreDestino,
	                            ref: function ref(valor) {
	                                _this2.inputValor = valor;
	                            },
	                            onChange: _this2.onInputChange.bind(_this2, index),
	                            onBlur: _this2.onBlurInput.bind(_this2, index),
	                            value: _this2.state.inputDistancia.destinos[index].valor === 0 ? '' : _this2.state.inputDistancia.destinos[index].valor })
	                    );
	                }) : null
	            );
	        }
	    }]);
	
	    return RowDistancias;
	}(_react2.default.Component);
	
	RowDistancias.contextTypes = {
	    guardaDestino: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowDistancias.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBoxDistancia = function () {
	    function BlackBoxDistancia() {
	        _classCallCheck(this, BlackBoxDistancia);
	
	        this.listaComuna = [];
	        this.filtroComuna = [];
	    }
	
	    _createClass(BlackBoxDistancia, [{
	        key: 'reset',
	        value: function reset() {
	            this.listaComuna = [];
	            this.filtroComuna = [];
	        }
	    }, {
	        key: 'add',
	        value: function add(comunasRow) {
	            this.listaComuna.push(comunasRow);
	        }
	    }, {
	        key: 'ordenar',
	        value: function ordenar() {
	            var porComuna = function porComuna(comuna) {
	                return comuna.nombre;
	            };
	            this.listaComuna = _lodash2.default.orderBy(this.listaComuna, [porComuna], ['asc']);
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            this.filtroComuna = _lodash2.default.chain(this.listaComuna).map(function (comuna) {
	                var valor = comuna.cutComuna;
	                var texto = comuna.nombre;
	
	                var opcion = _lodash2.default.find(_this.filtroComuna, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('texto').value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	
	            return {
	                comunasRow: _lodash2.default.chain(this.listaComuna).filter(function (comuna) {
	                    return _lodash2.default.find(_this2.filtroComuna, { 'valor': comuna.cutComuna, 'seleccionado': true });
	                }).value(),
	                filtrosComunas: {
	                    filtroComuna: this.filtroComuna
	                },
	                listaComuna: this.listaComuna
	            };
	        }
	    }]);
	
	    return BlackBoxDistancia;
	}();
	
	exports.default = BlackBoxDistancia;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxDistancia.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _SelectRangeVirtualTable = __webpack_require__(703);
	
	var _SelectRangeVirtualTable2 = _interopRequireDefault(_SelectRangeVirtualTable);
	
	var _tablaUsuariosPendientes = __webpack_require__(1097);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	_moment2.default.locale('es');
	var format = 'YYYY-MM-DD';
	// api
	
	// Componentes
	
	var usuariosPendientes = function (_React$Component) {
	    _inherits(usuariosPendientes, _React$Component);
	
	    function usuariosPendientes(props) {
	        _classCallCheck(this, usuariosPendientes);
	
	        var _this = _possibleConstructorReturn(this, (usuariosPendientes.__proto__ || Object.getPrototypeOf(usuariosPendientes)).call(this, props));
	
	        _this.state = {
	            fechaFinalSeleccionada: (0, _moment2.default)(),
	            fechaInicialSeleccionada: (0, _moment2.default)().add(-7, 'days'),
	            usuariosRAW: []
	        };
	        return _this;
	    }
	
	    _createClass(usuariosPendientes, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarUsuariosPendienes();
	        }
	    }, {
	        key: 'onSelectRangoChanged',
	        value: function onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal) {
	            var _this2 = this;
	
	            this.setState({
	                fechaInicialSeleccionada: momentumFechaInicio,
	                fechaFinalSeleccionada: momentumFechaFinal
	            }, function () {
	                var fechaInicio = _this2.state.fechaInicialSeleccionada.format('YYYY-MM-DD');
	                var fechaFinal = _this2.state.fechaFinalSeleccionada.format('YYYY-MM-DD');
	                console.log('rango seleccionado ' + fechaInicio + ' al ' + fechaFinal);
	                // se llama al metodo seleccionar semana, que hace lo mismo
	                _this2.buscarUsuariosPendienes(fechaInicio, fechaFinal);
	            });
	        }
	    }, {
	        key: 'buscarUsuariosPendienes',
	        value: function buscarUsuariosPendienes() {
	            var _this3 = this;
	
	            var fechaInicio = this.state.fechaInicialSeleccionada.format(format);
	            var fechaFin = this.state.fechaFinalSeleccionada.format(format);
	
	            _v2.default.nominas.usuariosPendientes(fechaInicio, fechaFin).then(function (nominas) {
	                _this3.setState({ usuariosRAW: nominas });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var fechaInicial = this.state.fechaInicialSeleccionada.format(format);
	            var fechaFinal = this.state.fechaFinalSeleccionada.format(format);
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Usuarios pendientes a agregar'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectSemana' },
	                            'Rango de Fecha'
	                        ),
	                        _react2.default.createElement(_SelectRangeVirtualTable2.default, {
	                            startDateSelected: this.state.fechaInicialSeleccionada,
	                            endDateSelected: this.state.fechaFinalSeleccionada,
	                            onInit: function onInit() {
	                                console.log("on init");
	                            },
	                            onRangeSelected: this.onSelectRangoChanged.bind(this)
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(_tablaUsuariosPendientes.TablaUsuariosPendientes, {
	                            usuariosPendientes: this.state.usuariosRAW
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return usuariosPendientes;
	}(_react2.default.Component);
	
	exports.default = usuariosPendientes;
	
	usuariosPendientes.propTypes = {
	    clientes: PropTypes.array
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "usuariosPendientes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaUsuariosPendientes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _ValidadorRUN = __webpack_require__(756);
	
	var _tablaPersonal = __webpack_require__(716);
	
	var css = _interopRequireWildcard(_tablaPersonal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Styles
	
	var cx = _bind2.default.bind(css);
	
	var TablaUsuariosPendientes = exports.TablaUsuariosPendientes = function (_React$Component) {
	    _inherits(TablaUsuariosPendientes, _React$Component);
	
	    function TablaUsuariosPendientes() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TablaUsuariosPendientes);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TablaUsuariosPendientes.__proto__ || Object.getPrototypeOf(TablaUsuariosPendientes)).call.apply(_ref, [this].concat(args))), _this), _this.renderLink = function (cellData) {
	            return _react2.default.createElement(
	                'a',
	                { className: 'btn btn-xs btn-primary', href: '/nomina/' + cellData, target: '_blank' },
	                'Nomina'
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TablaUsuariosPendientes, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '70%' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref2) {
	                        var height = _ref2.height,
	                            width = _ref2.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.usuariosPendientes.length,
	                                rowGetter: function rowGetter(_ref3) {
	                                    var index = _ref3.index;
	                                    return _this2.props.usuariosPendientes[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref4) {
	                                    var index = _ref4.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var rowIndex = _ref5.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 25
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'RUN',
	                                label: 'RUN',
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var dataKey = _ref6.dataKey,
	                                        rowData = _ref6.rowData;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData[dataKey],
	                                            '-',
	                                            (0, _ValidadorRUN.obtenerVerificador)(rowData[dataKey])
	                                        )
	                                    );
	                                },
	                                width: 90
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'fechaProgramada',
	                                label: 'FECHA INVENTARIO',
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var dataKey = _ref7.dataKey,
	                                        rowData = _ref7.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 190
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombreCorto',
	                                label: 'CLIENTE',
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 90
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'numero',
	                                label: 'CECO',
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var dataKey = _ref9.dataKey,
	                                        rowData = _ref9.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 90
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombre',
	                                label: 'LOCAL',
	                                cellRenderer: function cellRenderer(_ref10) {
	                                    var dataKey = _ref10.dataKey,
	                                        rowData = _ref10.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 190
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'region',
	                                label: 'REGION',
	                                cellRenderer: function cellRenderer(_ref11) {
	                                    var dataKey = _ref11.dataKey,
	                                        rowData = _ref11.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 150
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'ciudad',
	                                label: 'CIUDAD',
	                                cellRenderer: function cellRenderer(_ref12) {
	                                    var dataKey = _ref12.dataKey,
	                                        rowData = _ref12.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 150
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'idNomina',
	                                label: 'NOMINA',
	                                cellRenderer: function cellRenderer(_ref13) {
	                                    var dataKey = _ref13.dataKey,
	                                        rowData = _ref13.rowData;
	                                    return _this2.renderLink(rowData[dataKey]);
	                                },
	                                width: 70
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaUsuariosPendientes;
	}(_react2.default.Component);
	
	TablaUsuariosPendientes.propTypes = {
	    usuariosPendientes: PropTypes.arrayOf(PropTypes.object).isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tablaUsuariosPendientes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalendarMaintainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(638);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Header = __webpack_require__(1099);
	
	var _Filters = __webpack_require__(1101);
	
	var _TableCalendar = __webpack_require__(1102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CalendarMaintainer = exports.CalendarMaintainer = function (_Component) {
	    _inherits(CalendarMaintainer, _Component);
	
	    function CalendarMaintainer(props) {
	        _classCallCheck(this, CalendarMaintainer);
	
	        var _this = _possibleConstructorReturn(this, (CalendarMaintainer.__proto__ || Object.getPrototypeOf(CalendarMaintainer)).call(this, props));
	
	        _this.state = {
	            days: [],
	            optionsStatus: [{ value: 1, text: 'Todos' }, { value: 2, text: 'Laborables' }, { value: 3, text: 'No Laborables' }],
	            defaultMonth: _this.props.months[0].value,
	            defaultStatus: "1"
	        };
	        _this.searchingData = function (month, statusDays) {
	            _v2.default.admin.calendar.getDays(month, statusDays).then(function (response) {
	                _this.setState({
	                    days: response,
	                    defaultMonth: month,
	                    defaultStatus: statusDays
	                });
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	        _this.onChangeStatusDay = function (day, evt) {
	            var newStatus = evt.target.checked;
	            _v2.default.admin.calendar.updateStatusDay(day, newStatus).then(function () {
	                _this.searchingData(_this.state.defaultMonth, _this.state.defaultStatus);
	            }).catch(function (err) {});
	        };
	        _this.onSaveCommentDay = function (day, value) {
	            _v2.default.admin.calendar.updateCommentDay(day, value).then(function () {
	                _this.searchingData(_this.state.defaultMonth, _this.state.defaultStatus);
	            }).catch(function (err) {});
	        };
	        return _this;
	    }
	
	    _createClass(CalendarMaintainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.searchingData(this.state.defaultMonth, this.state.defaultStatus);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_Header.Header, {
	                    title: 'Administraci\xF3n calendario',
	                    glyphicon: 'glyphicon glyphicon-calendar'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-primary' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-th-list' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                _react2.default.createElement(_TableCalendar.TableCalendar, {
	                                    days: this.state.days,
	                                    onChangeStatusDay: this.onChangeStatusDay,
	                                    onSaveCommentDay: this.onSaveCommentDay
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        _react2.default.createElement(_Filters.SelectFilter, {
	                            months: this.props.months,
	                            optionsStatus: this.state.optionsStatus,
	                            defaultMonth: this.state.defaultMonth,
	                            defaultStatus: this.state.defaultStatus,
	                            searchingData: this.searchingData
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CalendarMaintainer;
	}(_react.Component);
	
	CalendarMaintainer.proptypes = {
	    months: _react.PropTypes.object.isRequired
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "CalendarMaintainer.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(1100);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header(_ref) {
	    var title = _ref.title,
	        glyphicon = _ref.glyphicon;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'page-header row ' + _Header2.default.Header_calendarMantainer },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-9' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement('span', { className: glyphicon }),
	                ' ',
	                title
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Header.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header_calendarMantainer":"Header__Header_calendarMantainer___2c-rW"};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectFilter = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFilter = exports.SelectFilter = function (_Component) {
	    _inherits(SelectFilter, _Component);
	
	    function SelectFilter(props) {
	        _classCallCheck(this, SelectFilter);
	
	        var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));
	
	        _this.state = {
	            defaultMonth: _this.props.defaultMonth,
	            defaultStatus: _this.props.defaultStatus
	        };
	        _this.onSelectMonthChange = function (evt) {
	            var newValue = evt.target.value;
	            _this.setState({
	                defaultMonth: newValue
	            }, function () {
	                _this.search();
	            });
	        };
	        _this.onSelectStatusChange = function (evt) {
	            var newValue = evt.target.value;
	            _this.setState({
	                defaultStatus: newValue
	            }, function () {
	                _this.search();
	            });
	        };
	        _this.search = function () {
	            var month = _this.state.defaultMonth;
	            var statusDays = _this.state.defaultStatus;
	            _this.props.searchingData(month, statusDays);
	        };
	        return _this;
	    }
	
	    _createClass(SelectFilter, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                months = _props.months,
	                optionsStatus = _props.optionsStatus;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(SelectGeneric, {
	                    defaultValue: this.state.defaultMonth,
	                    options: months,
	                    action: this.onSelectMonthChange,
	                    title: "Meses"
	                }),
	                _react2.default.createElement(SelectGeneric, {
	                    defaultValue: this.state.defaultStatus,
	                    options: optionsStatus,
	                    action: this.onSelectStatusChange,
	                    title: "Estado"
	                })
	            );
	        }
	    }]);
	
	    return SelectFilter;
	}(_react.Component);
	
	SelectFilter.proptypes = {
	    months: _react.PropTypes.object.isRequired,
	    optionsStatus: _react.PropTypes.object.isRequired
	};
	var SelectGeneric = function SelectGeneric(_ref) {
	    var defaultValue = _ref.defaultValue,
	        options = _ref.options,
	        action = _ref.action,
	        title = _ref.title;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "col-sm-12 form-group " },
	        _react2.default.createElement(
	            "label",
	            { className: "control-label" },
	            title
	        ),
	        _react2.default.createElement(
	            "select",
	            { className: "form-control",
	                value: defaultValue,
	                onChange: action
	            },
	            options.map(function (option, index) {
	                return _react2.default.createElement(
	                    "option",
	                    { key: index, value: option.value },
	                    "" + option.text
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Filters.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableCalendar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableCalendar = __webpack_require__(1103);
	
	var _TableCalendar2 = _interopRequireDefault(_TableCalendar);
	
	var _InputText = __webpack_require__(1104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableCalendar = exports.TableCalendar = function TableCalendar(_ref) {
	    var days = _ref.days,
	        onChangeStatusDay = _ref.onChangeStatusDay,
	        onSaveCommentDay = _ref.onSaveCommentDay;
	
	    return _react2.default.createElement(
	        'table',
	        { className: 'table table-striped ' + _TableCalendar2.default.TableCalendar },
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: _TableCalendar2.default.TableCalendar_thDate },
	                    'Fecha'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: _TableCalendar2.default.TableCalendar_thComment },
	                    'Comentario'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: _TableCalendar2.default.TableCalendar_thBusinessDay },
	                    'Laborable'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            days.map(function (day) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: day.date, className: !day.business_day ? _TableCalendar2.default.TableCalendar_trIsNotBusinessDay : '' },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        day.format_date
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(_InputText.InputText, {
	                            day: day,
	                            onSaveCommentDay: onSaveCommentDay
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _TableCalendar2.default.TableCalendar_tdCheckBox },
	                        _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            className: 'form-check-input',
	                            checked: day.business_day,
	                            onChange: function onChange(evt) {
	                                return onChangeStatusDay(day.date, evt);
	                            }
	                        })
	                    )
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TableCalendar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TableCalendar":"TableCalendar__TableCalendar___fGm7Z","TableCalendar_thDate":"TableCalendar__TableCalendar_thDate___27R7q","TableCalendar_tdDate":"TableCalendar__TableCalendar_tdDate___2FFgS","TableCalendar_thComment":"TableCalendar__TableCalendar_thComment___34F4o","TableCalendar_thBusinessDay":"TableCalendar__TableCalendar_thBusinessDay___1ySG2","TableCalendar_tdCheckBox":"TableCalendar__TableCalendar_tdCheckBox___27mr6","TableCalendar_trIsNotBusinessDay":"TableCalendar__TableCalendar_trIsNotBusinessDay___cxaXs"};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputText = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputText = exports.InputText = function (_Component) {
	    _inherits(InputText, _Component);
	
	    function InputText(props) {
	        _classCallCheck(this, InputText);
	
	        var _this = _possibleConstructorReturn(this, (InputText.__proto__ || Object.getPrototypeOf(InputText)).call(this, props));
	
	        _this.state = {
	            text: _this.props.day.comment
	        };
	        _this.onChangeText = function (evt) {
	            var newValue = evt.target.value;
	            _this.setState({
	                text: newValue
	            });
	        };
	        _this.onSaveValue = function () {
	            _this.props.onSaveCommentDay(_this.props.day.date, _this.state.text);
	        };
	        return _this;
	    }
	
	    _createClass(InputText, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement("input", {
	                defaultValue: this.state.text,
	                type: "text",
	                className: "form-control",
	                onChange: function onChange(evt) {
	                    return _this2.onChangeText(evt);
	                },
	                onBlur: this.onSaveValue
	            });
	        }
	    }]);
	
	    return InputText;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputText.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorDiferencias = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaInventarios = __webpack_require__(1106);
	
	var _BlackBoxInventarios = __webpack_require__(1111);
	
	var _BlackBoxInventarios2 = _interopRequireDefault(_BlackBoxInventarios);
	
	var _Modales = __webpack_require__(1112);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// NOTIFICACIONES
	
	_moment2.default.locale('es');
	// API
	
	// COMPONENTES
	
	// MODALES
	
	var MantenedorDiferencias = exports.MantenedorDiferencias = function (_React$Component) {
	    _inherits(MantenedorDiferencias, _React$Component);
	
	    function MantenedorDiferencias(props) {
	        _classCallCheck(this, MantenedorDiferencias);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorDiferencias.__proto__ || Object.getPrototypeOf(MantenedorDiferencias)).call(this, props));
	
	        _this.blackbox = new _BlackBoxInventarios2.default();
	        _this.state = {
	            mes: _this.props.meses[0]['value'],
	            fechaInicialSeleccionada: (0, _moment2.default)().startOf('month'),
	            fechaFinalSeleccionada: (0, _moment2.default)().endOf('month'),
	            inventariosFiltrados: [],
	            filtros: {}
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.buscarInventarios = function () {
	            var mes = _this.state.mes;
	            _v2.default.inventario.getInventariosDif(mes).then(function (inventarios) {
	                _this.blackbox.reset();
	                inventarios.forEach(function (inventario) {
	                    return _this.blackbox.add(inventario);
	                });
	                _this.setState(_this.blackbox.getListaFiltrada());
	            });
	        };
	        _this.onSelectMesChanged = function (evt) {
	            _this.setState({
	                mes: evt.target.value
	            }, function () {
	                _this.buscarInventarios();
	            });
	        };
	        _this.generarFacturaTxt = function () {
	            var request = _v2.default.facturacionSaldo().generarSaldo(_this.state.mes);
	            request.then(function () {
	                return _this.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4 * 1000);
	            }).catch(_this.ajaxErrorHandler('Generar factura'));
	            return request;
	        };
	        _this.generarCorreoSEI = function (total) {
	            console.log(total);
	            var request = _v2.default.facturacion(2).generarCorreoIG(_this.state.mes, total);
	            request.then(function () {
	                return _this.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4 * 1000);
	            }).catch(_this.ajaxErrorHandler('Aprobacion inventarios'));
	            return request;
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorDiferencias, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                aprobacionCliente: function aprobacionCliente(idInventario, _aprobacionCliente) {
	                    _v2.default.inv(idInventario).actualizarAprobacionFCV(_aprobacionCliente).then(function (inventarioActualizado) {
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                aprobacionSei: function aprobacionSei(idInventario, _aprobacionSei) {
	                    _v2.default.inv(idInventario).actualizarAprobacionSei(_aprobacionSei).then(function (inventarioActualizado) {
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                stockCliente: function stockCliente(idInventario, unidadesFCV) {
	                    _v2.default.inv(idInventario).actualizarStockFCV(unidadesFCV).then(function (inventarioActualizado) {
	                        console.log('inventario actualizado correctamente');
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                observacionCliente: function observacionCliente(idInventario, _observacionCliente) {
	                    _v2.default.inv(idInventario).actualizarObservacion(_observacionCliente).then(function (inventarioActualizado) {
	                        console.log('inventario actualizado correctamente');
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                actualizarFiltro: function actualizarFiltro(nombreFiltro, filtro) {
	                    _this2.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	                    _this2.setState(_this2.blackbox.getListaFiltrada());
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectMes',
	                                ref: function ref(_ref) {
	                                    return _this3.inputMes = _ref;
	                                },
	                                value: this.state.mes,
	                                onChange: this.onSelectMesChanged.bind(this) },
	                            '>',
	                            this.props.meses.map(function (mes, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: mes['value'] },
	                                    '' + mes['text']
	                                );
	                            })
	                        )
	                    ),
	                    this.props.permisos.aprobarUndSEI ? _react2.default.createElement(BotonFacturar, {
	                        permisos: this.props.permisos,
	                        generarFactura: this.generarFacturaTxt,
	                        mes: this.state.mes,
	                        generarCorreoSEI: this.generarCorreoSEI
	                    }) : _react2.default.createElement(BotonDetalles, {
	                        permisos: this.props.permisos,
	                        generarFactura: this.generarFacturaTxt,
	                        mes: this.state.mes,
	                        generarCorreoSEI: this.generarCorreoSEI
	                    }),
	                    _react2.default.createElement(BotonExcel, {
	                        mes: this.state.mes
	                    })
	                ),
	                _react2.default.createElement(_TablaInventarios.TablaInventarios, {
	                    permisos: this.props.permisos,
	                    inventarios: this.state.inventariosFiltrados,
	                    filtros: this.state.filtros
	                })
	            );
	        }
	    }]);
	
	    return MantenedorDiferencias;
	}(_react2.default.Component);
	
	MantenedorDiferencias.propTypes = {
	    meses: PropTypes.arrayOf(PropTypes.object),
	    // Permisos
	    permisos: PropTypes.object.isRequired
	};
	MantenedorDiferencias.childContextTypes = {
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func,
	    stockCliente: PropTypes.func,
	    observacionCliente: PropTypes.func,
	    actualizarFiltro: PropTypes.func
	};
	var BotonFacturar = function BotonFacturar(_ref2) {
	    var permisos = _ref2.permisos,
	        generarFactura = _ref2.generarFactura,
	        mes = _ref2.mes,
	        generarCorreoSEI = _ref2.generarCorreoSEI;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                permisos.aprobarUndCliente ? 'Detalles' : 'Facturar',
	                isVisible && _react2.default.createElement(_Modales.ModalDetalle, {
	                    permisos: permisos,
	                    mes: mes,
	                    hideModal: hideModal,
	                    generarFactura: generarFactura,
	                    generarCorreoSEI: generarCorreoSEI
	                })
	            );
	        }
	    );
	};
	var BotonDetalles = function BotonDetalles(_ref3) {
	    var permisos = _ref3.permisos,
	        generarFactura = _ref3.generarFactura,
	        mes = _ref3.mes,
	        generarCorreoSEI = _ref3.generarCorreoSEI;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                permisos.aprobarUndCliente ? 'Detalles' : 'Facturar',
	                isVisible && _react2.default.createElement(_Modales.ModalDetalleCliente, {
	                    permisos: permisos,
	                    mes: mes,
	                    hideModal: hideModal,
	                    generarFactura: generarFactura,
	                    generarCorreoSEI: generarCorreoSEI
	                })
	            );
	        }
	    );
	};
	var BotonExcel = function BotonExcel(_ref4) {
	    var mes = _ref4.mes;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-success pull-right',
	            href: '/inventarios/diferencia/descargar-excel-mes?mes=' + mes },
	        'Datos Excel'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorDiferencias.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1107);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _RowInventario = __webpack_require__(1108);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componentes
	
	var TablaInventarios = exports.TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios() {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).apply(this, arguments));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaInv,
	                    { filtro: this.props.filtros.filtroAprobacionSei, actualizarFiltros: this.context.actualizarFiltro },
	                    _.range(0, totalInventarios).map(function (index) {
	                        var inventario = _this2.props.inventarios[index];
	                        return _react2.default.createElement(_RowInventario.RowInventario, {
	                            permisos: _this2.props.permisos,
	                            ref: index,
	                            key: inventario ? inventario.inv_idInventario : index,
	                            inventario: inventario,
	                            correlativo: index + 1,
	                            stockCliente: _this2.context.stockCliente.bind(_this2),
	                            aprobacionCliente: _this2.context.aprobacionCliente.bind(_this2),
	                            aprobacionSei: _this2.context.aprobacionSei.bind(_this2),
	                            observacionCliente: _this2.context.observacionCliente.bind(_this2)
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	TablaInventarios.propTypes = {
	    filtros: PropTypes.objectOf(PropTypes.array).isRequired
	};
	TablaInventarios.contextTypes = {
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func,
	    stockCliente: PropTypes.func,
	    observacionCliente: PropTypes.func,
	    actualizarFiltro: PropTypes.func
	};
	var TablaInv = function TablaInv(_ref) {
	    var filtro = _ref.filtro,
	        actualizarFiltros = _ref.actualizarFiltros,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Aprobaci\xF3n unidades inventarios'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaInventariosFCV },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumeroLocal },
	                        'Ceco'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreLocal },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndInf },
	                        'Und. Inf. FCV'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Discrepancia'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Conteo Unidades SEI'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndCliente },
	                        'Und. FCV aprobadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDiferencia },
	                        'Diferencia Conteo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thObservacion },
	                        'Observaciones'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thOk },
	                        'Aprobaci\xF3n Unidades Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thOkSEI },
	                        _react2.default.createElement(_HeaderConFiltro2.default, {
	                            nombre: 'Aprobaci\xF3n Unidades SEI',
	                            filtro: filtro || [],
	                            actualizarFiltro: actualizarFiltros.bind(undefined, 'filtroAprobacionSei')
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tablaInventariosFCV":"TablaInventarios__tablaInventariosFCV___tpchU","thCorrelativo":"TablaInventarios__thCorrelativo___KCzbK","thFecha":"TablaInventarios__thFecha___1-6O2","thNumeroLocal":"TablaInventarios__thNumeroLocal___1UaiT","thNombreLocal":"TablaInventarios__thNombreLocal___13dB2","thComuna":"TablaInventarios__thComuna___eVjMF","thUndSEI":"TablaInventarios__thUndSEI___105g4","thUndInf":"TablaInventarios__thUndInf___25Ck1","thUndCliente":"TablaInventarios__thUndCliente___2sp3J","thUndClientes":"TablaInventarios__thUndClientes___3hjSJ","thDiferencia":"TablaInventarios__thDiferencia___3DMUT","thObservacion":"TablaInventarios__thObservacion___206QB","thOk":"TablaInventarios__thOk___2U0va","thAprobacion":"TablaInventarios__thAprobacion___2-LYG","thOkSEI":"TablaInventarios__thOkSEI___9z0em","thFacturado":"TablaInventarios__thFacturado___2S-pE","tdUnidadSEI":"TablaInventarios__tdUnidadSEI___2V_sI","tdFecha":"TablaInventarios__tdFecha___3A1dL","tdInf":"TablaInventarios__tdInf___1jObC","tdCeco":"TablaInventarios__tdCeco___rF2t5","tdUnidadCliente":"TablaInventarios__tdUnidadCliente___1B8Sw","tdDiferencia":"TablaInventarios__tdDiferencia___g___m","tdOk":"TablaInventarios__tdOk___1vIWe","tdFacturado":"TablaInventarios__tdFacturado___JtvOK","tdObservacion":"TablaInventarios__tdObservacion___379tN"};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1107);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _InputOkCliente = __webpack_require__(1109);
	
	var _InputOkSei = __webpack_require__(1110);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowInventario = exports.RowInventario = function (_React$Component) {
	    _inherits(RowInventario, _React$Component);
	
	    function RowInventario(props) {
	        _classCallCheck(this, RowInventario);
	
	        var _this = _possibleConstructorReturn(this, (RowInventario.__proto__ || Object.getPrototypeOf(RowInventario)).call(this, props));
	
	        _this.state = {
	            editando: false,
	            editandoObservacion: false
	        };
	        _this.onClick_editar = function () {
	            _this.setState({
	                editando: true
	            }, function () {
	                _this.inputStock.focus();
	            });
	        };
	        _this.onClick_editarObservacion = function () {
	            _this.setState({
	                editandoObservacion: true
	            }, function () {
	                _this.inputObservacion.focus();
	            });
	        };
	        _this.finalizarEdicion = function () {
	            _this.props.stockCliente(_this.props.inventario.inv_idInventario, _this.inputStock.value);
	            _this.setState({
	                editando: false
	            });
	        };
	        _this.finalizarEdicionObservacion = function () {
	            _this.props.observacionCliente(_this.props.inventario.inv_idInventario, _this.inputObservacion.value);
	            _this.setState({
	                editandoObservacion: false
	            });
	        };
	        _this.onKeyPress_editarStock = function (evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                _this.finalizarEdicion();
	            }
	        };
	        _this.onKeyPress_editarObservacion = function (evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                _this.finalizarEdicionObservacion();
	            }
	        };
	        return _this;
	    }
	
	    _createClass(RowInventario, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.inv_fechaProgramadaF
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    this.props.inventario.local_ceco
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.local_nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdInf },
	                    this.props.inventario.inv_unidadesInformadas
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_diferenciaInfReal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_unidadesReales
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadCliente },
	                    this.state.editando ? _react2.default.createElement('input', { type: 'number',
	                        ref: function ref(_ref) {
	                            return _this2.inputStock = _ref;
	                        },
	                        defaultValue: this.props.inventario.inv_unidadesSegunCliente,
	                        onKeyPress: this.onKeyPress_editarStock,
	                        onBlur: this.finalizarEdicion.bind(this)
	                    }) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.inventario.inv_aprobacionCliente == false ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_unidadesSegunClienteFormato,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.onClick_editar.bind(this) },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit pull-right' })
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_unidadesSegunClienteFormato
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDiferencia },
	                    this.props.inventario.inv_diferenciaSEIClienteFormat
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdObservacion },
	                    this.state.editandoObservacion ? _react2.default.createElement('input', { type: 'text',
	                        ref: function ref(_ref2) {
	                            return _this2.inputObservacion = _ref2;
	                        },
	                        defaultValue: this.props.inventario.inv_observacionDiferencia,
	                        onKeyPress: this.onKeyPress_editarObservacion,
	                        onBlur: this.finalizarEdicionObservacion.bind(this)
	                    }) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.inventario.inv_aprobacionCliente == false ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_observacionDiferencia,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.onClick_editarObservacion.bind(this) },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit pull-right' })
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_observacionDiferencia
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOk },
	                    this.props.permisos.aprobarUndCliente ? _react2.default.createElement(_InputOkCliente.InputOkCliente, {
	                        permisos: this.props.permisos,
	                        inventario: this.props.inventario,
	                        aprobacionCliente: this.props.aprobacionCliente
	                    }) : _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.props.inventario.inv_aprobacionCliente,
	                        disabled: 'true'
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOk },
	                    this.props.permisos.aprobarUndSEI ? _react2.default.createElement(_InputOkSei.InputOkSei, {
	                        inventario: this.props.inventario,
	                        aprobacionSei: this.props.aprobacionSei
	                    }) : _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.props.inventario.inv_aprobacionSEI,
	                        disabled: 'true'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return RowInventario;
	}(_react2.default.Component);
	
	RowInventario.propTypes = {
	    inventario: PropTypes.object,
	    correlativo: PropTypes.number,
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputOkCliente = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var InputOkCliente = exports.InputOkCliente = function (_React$Component) {
	    _inherits(InputOkCliente, _React$Component);
	
	    function InputOkCliente(props) {
	        _classCallCheck(this, InputOkCliente);
	
	        var _this = _possibleConstructorReturn(this, (InputOkCliente.__proto__ || Object.getPrototypeOf(InputOkCliente)).call(this, props));
	
	        _this.state = {
	            valor: _this.props.inventario.inv_aprobacionCliente,
	            facturado: _this.props.inventario.inv_facturado
	        };
	        _this.cambioCheckbox = function (evt) {
	            var estado = evt.target.checked;
	            _this.finalizarEdicion(estado);
	            evt.preventDefault();
	            _this.setState({
	                valor: estado
	            });
	        };
	        _this.finalizarEdicion = function (estado) {
	            _this.props.aprobacionCliente(_this.props.inventario.inv_idInventario, estado);
	        };
	        return _this;
	    }
	
	    _createClass(InputOkCliente, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", {
	                type: "checkbox",
	                checked: this.state.valor,
	                onChange: this.cambioCheckbox.bind(this),
	                disabled: this.state.facturado
	            });
	        }
	    }]);
	
	    return InputOkCliente;
	}(_react2.default.Component);
	
	InputOkCliente.propTypes = {
	    inventario: PropTypes.object
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputOkCliente.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputOkSei = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var InputOkSei = exports.InputOkSei = function (_React$Component) {
	    _inherits(InputOkSei, _React$Component);
	
	    function InputOkSei(props) {
	        _classCallCheck(this, InputOkSei);
	
	        var _this = _possibleConstructorReturn(this, (InputOkSei.__proto__ || Object.getPrototypeOf(InputOkSei)).call(this, props));
	
	        _this.state = {
	            valor: _this.props.inventario.inv_aprobacionSEI,
	            facturado: _this.props.inventario.inv_facturado
	        };
	        _this.cambioCheckbox = function (evt) {
	            var estado = evt.target.checked;
	            _this.finalizarEdicion(estado);
	            evt.preventDefault();
	            _this.setState({
	                valor: estado
	            });
	        };
	        _this.finalizarEdicion = function (estado) {
	            _this.props.aprobacionSei(_this.props.inventario.inv_idInventario, estado);
	        };
	        return _this;
	    }
	
	    _createClass(InputOkSei, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
	            this.setState({
	                valor: nextProps.inventario.inv_aprobacionSEI
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", {
	                type: "checkbox",
	                checked: this.state.valor,
	                onChange: this.cambioCheckbox.bind(this),
	                disabled: this.state.facturado
	            });
	        }
	    }]);
	
	    return InputOkSei;
	}(_react2.default.Component);
	
	InputOkSei.propTypes = {
	    inventario: PropTypes.object
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InputOkSei.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(619);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlackBoxInventarios = function () {
	    function BlackBoxInventarios() {
	        _classCallCheck(this, BlackBoxInventarios);
	
	        this.lista = [];
	        this.filtroAprobacionSei = [];
	    }
	
	    _createClass(BlackBoxInventarios, [{
	        key: 'reset',
	        value: function reset() {
	            this.lista = [];
	            this.filtroAprobacionSei = [];
	        }
	    }, {
	        key: 'add',
	        value: function add(inventario) {
	            this.lista.push(inventario);
	        }
	    }, {
	        key: 'actualizarInventario',
	        value: function actualizarInventario(inventarioActualizado) {
	            console.log(inventarioActualizado);
	            this.lista = this.lista.map(function (inventario) {
	                if (inventario.inv_idInventario == inventarioActualizado.inv_idInventario) {
	                    return inventarioActualizado;
	                }
	                return inventario;
	            });
	            this.actualizarFiltros();
	        }
	    }, {
	        key: 'actualizarFiltros',
	        value: function actualizarFiltros() {
	            var _this = this;
	
	            this.filtroAprobacionSei = _lodash2.default.chain(this.lista).map(function (inventario) {
	                var valor = inventario.inv_aprobacionSEI;
	                var texto = inventario.inv_aprobacionSEITexto;
	                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
	                var opcion = _lodash2.default.find(_this.filtroAprobacionSei, { 'valor': valor });
	                return opcion ? opcion : { valor: valor, texto: texto, seleccionado: true };
	            }).uniqBy('valor').sortBy('valor').value();
	        }
	    }, {
	        key: 'reemplazarFiltro',
	        value: function reemplazarFiltro(nombreFiltro, filtroActualizado) {
	            if (this[nombreFiltro]) {
	                this[nombreFiltro] = filtroActualizado;
	            } else {
	                console.error('Filtro ' + nombreFiltro + ' no existe.');
	            }
	        }
	    }, {
	        key: 'getListaFiltrada',
	        value: function getListaFiltrada() {
	            var _this2 = this;
	
	            this.actualizarFiltros();
	            return {
	                inventariosFiltrados: _lodash2.default.chain(this.lista).filter(function (inventario) {
	                    return _lodash2.default.find(_this2.filtroAprobacionSei, { 'valor': inventario.inv_aprobacionSEI, 'seleccionado': true });
	                }).value(),
	                filtros: {
	                    filtroAprobacionSei: this.filtroAprobacionSei
	                }
	
	            };
	        }
	    }]);
	
	    return BlackBoxInventarios;
	}();
	
	exports.default = BlackBoxInventarios;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BlackBoxInventarios.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalDetalleCliente = exports.ModalDetalle = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1113);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// API
	
	// Componentes
	
	// Style
	
	
	var css = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalDetalle = exports.ModalDetalle = function (_React$Component2) {
	    _inherits(ModalDetalle, _React$Component2);
	
	    function ModalDetalle(props) {
	        _classCallCheck(this, ModalDetalle);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalDetalle.__proto__ || Object.getPrototypeOf(ModalDetalle)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false,
	            unidades: '',
	            notaCredito: false,
	            total: '',
	            totalAnterior: '',
	            sumaCliente: '',
	            unidadesAnterior: '',
	            totalConIVA: '',
	            mes: _this2.props.mes,
	            aprobadoFacturar: false
	        };
	        _this2.fetchDetalleFactura = function () {
	            _v2.default.facturacionSaldo().getDetalleSaldo(_this2.state.mes).then(function (detalle) {
	                _this2.setState({ unidades: detalle.unidades });
	                _this2.setState({ total: detalle.total });
	                _this2.setState({ totalAnterior: detalle.totalAnterior });
	                _this2.setState({ sumaCliente: detalle.sumaCliente });
	                _this2.setState({ unidadesAnterior: detalle.unidadesAnterior });
	                _this2.setState({ notaCredito: detalle.notaCredito });
	                _this2.setState({ totalConIVA: detalle.totalConIVA });
	                _this2.setState({ aprobadoFacturar: detalle.aprobadoFacturar });
	            }).catch(function (error) {
	                console.log("error");
	            });
	        };
	        _this2.handleSubmit = function (evt) {
	            _this2.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState(function () {
	                _this2.props.generarFactura().then(function () {
	                    _this2.setState({ bloqueado: false });
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalDetalle, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalleFactura();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unidades'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidadesAnterior
	                            ),
	                            'Unidades facturadas anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.sumaCliente
	                            ),
	                            'Total unidades contadas'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidades
	                            ),
	                            'Saldo unidades a facturar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Valores'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalAnterior
	                            ),
	                            'Valor facturado anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.total
	                            ),
	                            this.state.notaCredito ? 'Valor de nota de credito' : 'Valor neto'
	                        ),
	                        this.state.notaCredito ? _react2.default.createElement('div', null) : _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalConIVA
	                            ),
	                            'Valor bruto'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    this.props.permisos.aprobarUndSEI ? _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: !!(this.state.bloqueado == true || this.state.aprobadoFacturar == false) },
	                            'Facturar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: !!(this.state.bloqueado == true || this.state.notaCredito == false) },
	                            'Nota Credito'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    ) : _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDetalle;
	}(_react2.default.Component);
	
	var ModalDetalleCliente = exports.ModalDetalleCliente = function (_React$Component3) {
	    _inherits(ModalDetalleCliente, _React$Component3);
	
	    function ModalDetalleCliente(props) {
	        _classCallCheck(this, ModalDetalleCliente);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalDetalleCliente.__proto__ || Object.getPrototypeOf(ModalDetalleCliente)).call(this, props));
	
	        _this3.state = {
	            bloqueado: false,
	            aprobacionInformar: false,
	            unidades: '',
	            notaCredito: false,
	            total: '',
	            totalAnterior: '',
	            sumaCliente: '',
	            unidadesAnterior: '',
	            totalConIVA: '',
	            mes: _this3.props.mes,
	            aprobadoFacturar: false
	        };
	        _this3.fetchDetalleFactura = function () {
	            _v2.default.facturacionSaldo().getDetalleSaldo(_this3.state.mes).then(function (detalle) {
	                _this3.setState({ unidades: detalle.unidades });
	                _this3.setState({ total: detalle.total });
	                _this3.setState({ totalAnterior: detalle.totalAnterior });
	                _this3.setState({ sumaCliente: detalle.sumaCliente });
	                _this3.setState({ unidadesAnterior: detalle.unidadesAnterior });
	                _this3.setState({ notaCredito: detalle.notaCredito });
	                _this3.setState({ totalConIVA: detalle.totalConIVA });
	                _this3.setState({ aprobadoFacturar: detalle.aprobadoFacturar });
	                _this3.setState({ aprobacionInformar: detalle.aprobacionInformar });
	            }).catch(function (error) {
	                console.log("error");
	            });
	        };
	        _this3.handleSubmit = function (evt) {
	            _this3.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this3.setState(function () {
	                _this3.props.generarCorreoSEI(_this3.state.total).then(function () {
	                    _this3.setState({ bloqueado: false });
	                    _this3.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalDetalleCliente, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalleFactura();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unidades'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidadesAnterior
	                            ),
	                            'Unidades facturadas anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.sumaCliente
	                            ),
	                            'Total unidades contadas'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidades
	                            ),
	                            'Saldo unidades a facturar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Valores'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalAnterior
	                            ),
	                            'Valor facturado anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.total
	                            ),
	                            this.state.notaCredito ? 'Valor de nota de credito' : 'Valor neto'
	                        ),
	                        this.state.notaCredito ? _react2.default.createElement('div', null) : _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalConIVA
	                            ),
	                            'Valor bruto'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    this.props.permisos.aprobarUndCliente ? _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: !!(this.state.bloqueado == true || this.state.aprobacionInformar == false) },
	                            'Informar aprobación'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    ) : _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                        'Cerrar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDetalleCliente;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modale":"modal__modale___3pqjx","panelDatos_heading":"modal__panelDatos_heading___jsm__","tablaDatos":"modal__tablaDatos___22ax2"};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MantenedorResumenMensual = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaRegiones = __webpack_require__(1115);
	
	var _Indicadores = __webpack_require__(1118);
	
	var _Aprobacion = __webpack_require__(1119);
	
	var _Modales = __webpack_require__(1120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// NOTIFICACIONES
	
	_moment2.default.locale('es');
	// API
	
	// Componentes
	
	var MantenedorResumenMensual = exports.MantenedorResumenMensual = function (_React$Component) {
	    _inherits(MantenedorResumenMensual, _React$Component);
	
	    function MantenedorResumenMensual(props) {
	        _classCallCheck(this, MantenedorResumenMensual);
	
	        var _this = _possibleConstructorReturn(this, (MantenedorResumenMensual.__proto__ || Object.getPrototypeOf(MantenedorResumenMensual)).call(this, props));
	
	        _this.state = {
	            mes: _this.props.meses[0]['value'],
	            regionesAuditorias: [],
	            totales: '',
	            diferencia: ''
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.buscarAuditorias = function () {
	            var mes = _this.state.mes;
	            _v2.default.auditoria.getResumenMes(mes).then(function (auditoria) {
	                _this.setState({ regionesAuditorias: auditoria.regiones });
	                _this.setState({ total: auditoria.totales });
	                _this.setState({ diferencia: auditoria.diferencia });
	                _this.setState({ totalFacturaAnterior: auditoria.totalFacturaAnteriorFormat });
	                _this.setState({ estadoCliente: auditoria.aprobacionCliente });
	                _this.setState({ estadoSEI: auditoria.aprobacionSEI });
	                _this.setState({ facturado: auditoria.facturado });
	            });
	        };
	        _this.onSelectMesChanged = function (evt) {
	            _this.setState({
	                mes: evt.target.value
	            }, function () {
	                _this.buscarAuditorias();
	            });
	        };
	        _this.generarFacturaTxt = function () {
	            var request = _v2.default.facturacionSaldo().generarSaldoAuditorias(_this.state.mes);
	            request.then(function () {
	                return _this.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4 * 1000);
	            }).catch(_this.ajaxErrorHandler('Generar factura'));
	            return request;
	        };
	        _this.aprobacionCliente = function (aprobacionCliente) {
	            var request = _v2.default.aud().actualizarAprobacionFCV(aprobacionCliente, _this.state.mes);
	            request.then(function () {
	                return _this.refs.notificator.success("Proceso satisfactorio", "Estado de aprobación actualizado", 4 * 1000);
	            }).catch(_this.ajaxErrorHandler('Aprobación auditorías'));
	            return request;
	        };
	        _this.correoSEI = function () {
	            var request = _v2.default.facturacion(2).generarCorreoAud(_this.state.mes);
	            request.then(function () {
	                return _this.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4 * 1000);
	            }).catch(_this.ajaxErrorHandler('Aprobacion auditorias'));
	            return request;
	        };
	        return _this;
	    }
	
	    _createClass(MantenedorResumenMensual, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarAuditorias();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectMes',
	                                ref: function ref(_ref) {
	                                    return _this2.inputMes = _ref;
	                                },
	                                value: this.state.mes,
	                                onChange: this.onSelectMesChanged.bind(this) },
	                            '>',
	                            this.props.meses.map(function (mes, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: mes['value'] },
	                                    '' + mes['text']
	                                );
	                            })
	                        )
	                    ),
	                    this.props.permisos.facturar ? _react2.default.createElement(BotonFacturar, {
	                        generarFactura: this.generarFacturaTxt,
	                        valorActual: this.state.total,
	                        diferencia: this.state.diferencia,
	                        totalFacturaAnterior: this.state.totalFacturaAnterior
	                    }) : _react2.default.createElement(BotonDetalles, {
	                        generarCorreo: this.correoSEI,
	                        valorActual: this.state.total,
	                        diferencia: this.state.diferencia,
	                        totalFacturaAnterior: this.state.totalFacturaAnterior
	                    }),
	                    _react2.default.createElement(BotonExcel, {
	                        mes: this.state.mes
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(_TablaRegiones.TablaRegiones, {
	                            mes: this.state.mes,
	                            regiones: this.state.regionesAuditorias
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        _react2.default.createElement(_Indicadores.Indicadores, {
	                            valorActual: this.state.total,
	                            diferencia: this.state.diferencia,
	                            totalFacturaAnterior: this.state.totalFacturaAnterior
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MantenedorResumenMensual;
	}(_react2.default.Component);
	
	MantenedorResumenMensual.propTypes = {
	    meses: PropTypes.arrayOf(PropTypes.object),
	    permisos: PropTypes.object.isRequired
	};
	var BotonFacturar = function BotonFacturar(_ref2) {
	    var generarFactura = _ref2.generarFactura,
	        valorActual = _ref2.valorActual,
	        diferencia = _ref2.diferencia,
	        totalFacturaAnterior = _ref2.totalFacturaAnterior;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                'Facturar',
	                isVisible && _react2.default.createElement(_Modales.ModalDetalle, {
	                    valorActual: valorActual,
	                    diferencia: diferencia,
	                    totalFacturaAnterior: totalFacturaAnterior,
	                    hideModal: hideModal,
	                    generarFactura: generarFactura
	                })
	            );
	        }
	    );
	};
	var BotonDetalles = function BotonDetalles(_ref3) {
	    var generarCorreo = _ref3.generarCorreo,
	        valorActual = _ref3.valorActual,
	        diferencia = _ref3.diferencia,
	        totalFacturaAnterior = _ref3.totalFacturaAnterior;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                'Aprobar Facturación',
	                isVisible && _react2.default.createElement(_Modales.ModalDetalleCliente, {
	                    valorActual: valorActual,
	                    diferencia: diferencia,
	                    totalFacturaAnterior: totalFacturaAnterior,
	                    hideModal: hideModal,
	                    generarCorreo: generarCorreo
	                })
	            );
	        }
	    );
	};
	var BotonExcel = function BotonExcel(_ref4) {
	    var mes = _ref4.mes;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-success pull-right',
	            href: '/auditorias/descargar-excel-regiones/?mes=' + mes },
	        'Datos Excel'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MantenedorResumenMensual.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaRegiones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaRegiones = __webpack_require__(1116);
	
	var css = _interopRequireWildcard(_TablaRegiones);
	
	var _HeaderConFiltro = __webpack_require__(627);
	
	var _HeaderConFiltro2 = _interopRequireDefault(_HeaderConFiltro);
	
	var _RowRegiones = __webpack_require__(1117);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componentes
	
	var TablaRegiones = exports.TablaRegiones = function (_React$Component) {
	    _inherits(TablaRegiones, _React$Component);
	
	    function TablaRegiones() {
	        _classCallCheck(this, TablaRegiones);
	
	        return _possibleConstructorReturn(this, (TablaRegiones.__proto__ || Object.getPrototypeOf(TablaRegiones)).apply(this, arguments));
	    }
	
	    _createClass(TablaRegiones, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalRegiones = this.props.regiones.length;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    TablaReg,
	                    null,
	                    _.range(0, totalRegiones).map(function (index) {
	                        var region = _this2.props.regiones[index];
	                        return _react2.default.createElement(_RowRegiones.RowRegiones, {
	                            ref: index,
	                            key: region ? region.cutRegion : index,
	                            region: region,
	                            mes: _this2.props.mes,
	                            correlativo: index + 1
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaRegiones;
	}(_react2.default.Component);
	
	TablaRegiones.propTypes = {};
	var TablaReg = function TablaReg(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Resumen mensual auditorias'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaInventariosFCV },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumero },
	                        'RG'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombre },
	                        'Region'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thPrecio },
	                        'Precio'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thRealizadas },
	                        'Realizadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thTotal },
	                        'Total'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thOpcion },
	                        'Descargar'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaRegiones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tablaInventariosFCV":"TablaRegiones__tablaInventariosFCV___1b-Wc","thCorrelativo":"TablaRegiones__thCorrelativo___2CWjo","thNumero":"TablaRegiones__thNumero___w3kMs","thNombre":"TablaRegiones__thNombre___3cldE","thPrecio":"TablaRegiones__thPrecio___3uw9o","thRealizadas":"TablaRegiones__thRealizadas___11h4z","thTotal":"TablaRegiones__thTotal___4eUmY","thOpcion":"TablaRegiones__thOpcion___1w_fA","tdNombre":"TablaRegiones__tdNombre___3sOol","tdRealizadas":"TablaRegiones__tdRealizadas___BYD1k","tdTotal":"TablaRegiones__tdTotal___1oJNA","tdOpcion":"TablaRegiones__tdOpcion___kz5cL"};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowRegiones = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaRegiones = __webpack_require__(1116);
	
	var css = _interopRequireWildcard(_TablaRegiones);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowRegiones = exports.RowRegiones = function (_React$Component) {
	    _inherits(RowRegiones, _React$Component);
	
	    function RowRegiones(props) {
	        _classCallCheck(this, RowRegiones);
	
	        var _this = _possibleConstructorReturn(this, (RowRegiones.__proto__ || Object.getPrototypeOf(RowRegiones)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(RowRegiones, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.region.numeroRegion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNombre },
	                    this.props.region.nombreRegion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRealizadas },
	                    this.props.region.precio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRealizadas },
	                    this.props.region.totalMes
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotal },
	                    this.props.region.totalPrecioFormat
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOpcion },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs',
	                            href: '/auditorias/descargar/' + this.props.mes + '/' + this.props.region.cutRegion },
	                        'Exportar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowRegiones;
	}(_react2.default.Component);
	
	RowRegiones.propTypes = {
	    region: PropTypes.object,
	    correlativo: PropTypes.number
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowRegiones.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Indicadores = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Indicadores = exports.Indicadores = function (_React$Component) {
	    _inherits(Indicadores, _React$Component);
	
	    function Indicadores() {
	        _classCallCheck(this, Indicadores);
	
	        return _possibleConstructorReturn(this, (Indicadores.__proto__ || Object.getPrototypeOf(Indicadores)).apply(this, arguments));
	    }
	
	    _createClass(Indicadores, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel-primary' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-heading' },
	                    'Resumen mensual auditorias'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'list-group' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            '$',
	                            this.props.totalFacturaAnterior
	                        ),
	                        'Valor factura anterior'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            '$',
	                            this.props.valorActual
	                        ),
	                        'Valor real'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            '$',
	                            this.props.diferencia
	                        ),
	                        'Valor a facturar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Indicadores;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Indicadores.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Aprobacion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var Aprobacion = exports.Aprobacion = function (_React$Component) {
	    _inherits(Aprobacion, _React$Component);
	
	    function Aprobacion(props) {
	        _classCallCheck(this, Aprobacion);
	
	        var _this = _possibleConstructorReturn(this, (Aprobacion.__proto__ || Object.getPrototypeOf(Aprobacion)).call(this, props));
	
	        _this.state = {
	            estadoCl: false,
	            aprobacionSEI: _this.props.aprobacionSEI,
	            bloqueado: false
	        };
	        _this.cambioCheckboxCliente = function (evt) {
	            var estado = evt.target.checked;
	            _this.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this.setState(function () {
	                _this.props.aprobacionCliente(estado).then(function () {
	                    _this.setState({ bloqueado: false });
	                    _this.setState({
	                        estadoCl: estado
	                    });
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Aprobacion, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ estadoCl: this.props.aprobacionCl });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel-primary' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-heading' },
	                    'Aprobaci\xF3n mensual auditor\xEDas',
	                    this.props.aprobacionCl
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'list-group' },
	                    this.props.permisos.cliente ? _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            _react2.default.createElement('input', {
	                                checked: this.state.estadoCl,
	                                type: 'checkbox',
	                                onChange: this.cambioCheckboxCliente.bind(this),
	                                disabled: this.state.bloqueado
	                            })
	                        ),
	                        'Aprobaci\xF3n cliente'
	                    ) : _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            _react2.default.createElement('input', { type: 'checkbox', disabled: true })
	                        ),
	                        'Aprobaci\xF3n SEI'
	                    ),
	                    this.props.permisos.facturar ? _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            _react2.default.createElement('input', { type: 'checkbox', disabled: true })
	                        ),
	                        'Aprobaci\xF3n SEI'
	                    ) : _react2.default.createElement(
	                        'li',
	                        { className: 'list-group-item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'badge' },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                checked: this.state.aprobacionSEI,
	                                value: this.state.aprobacionSEI
	                                //onChange={this.cambioCheckboxSEI.bind(this)}
	                                , disabled: true
	                            })
	                        ),
	                        'Aprobaci\xF3n SEI'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Aprobacion;
	}(_react2.default.Component);
	
	Aprobacion.propTypes = {
	    aprobacionCl: PropTypes.bool
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Aprobacion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalDetalleCliente = exports.ModalDetalle = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1113);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	// API
	
	// Componentes
	
	// Style
	
	
	var css = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalDetalle = exports.ModalDetalle = function (_React$Component2) {
	    _inherits(ModalDetalle, _React$Component2);
	
	    function ModalDetalle(props) {
	        _classCallCheck(this, ModalDetalle);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalDetalle.__proto__ || Object.getPrototypeOf(ModalDetalle)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false
	        };
	        _this2.handleSubmit = function (evt) {
	            _this2.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState(function () {
	                _this2.props.generarFactura().then(function () {
	                    _this2.setState({ bloqueado: false });
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalDetalle, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Valores'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.totalFacturaAnterior
	                            ),
	                            'Valor facturadas anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.valorActual
	                            ),
	                            'Valor realizadas'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.diferencia
	                            ),
	                            'Diferencia a facturar'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado },
	                            this.state.notaCredito ? 'Nota Credito' : 'Facturar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDetalle;
	}(_react2.default.Component);
	
	var ModalDetalleCliente = exports.ModalDetalleCliente = function (_React$Component3) {
	    _inherits(ModalDetalleCliente, _React$Component3);
	
	    function ModalDetalleCliente(props) {
	        _classCallCheck(this, ModalDetalleCliente);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalDetalleCliente.__proto__ || Object.getPrototypeOf(ModalDetalleCliente)).call(this, props));
	
	        _this3.state = {
	            bloqueado: false
	        };
	        _this3.handleSubmit = function (evt) {
	            _this3.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this3.setState(function () {
	                _this3.props.generarCorreo().then(function () {
	                    _this3.setState({ bloqueado: false });
	                    _this3.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalDetalleCliente, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Valores'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.totalFacturaAnterior
	                            ),
	                            'Valor facturado anteriormente'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.valorActual
	                            ),
	                            'Valor mes'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.diferencia
	                            ),
	                            'Diferencia a facturar neto'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado },
	                            'Informar aprobación'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDetalleCliente;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InventariosFacturacion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _BlackBoxInventarios = __webpack_require__(1111);
	
	var _BlackBoxInventarios2 = _interopRequireDefault(_BlackBoxInventarios);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaInventarios = __webpack_require__(1122);
	
	var _Modales = __webpack_require__(1124);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var InventariosFacturacion = exports.InventariosFacturacion = function (_React$Component) {
	    _inherits(InventariosFacturacion, _React$Component);
	
	    function InventariosFacturacion(props) {
	        _classCallCheck(this, InventariosFacturacion);
	
	        var _this = _possibleConstructorReturn(this, (InventariosFacturacion.__proto__ || Object.getPrototypeOf(InventariosFacturacion)).call(this, props));
	
	        _this.blackbox = new _BlackBoxInventarios2.default();
	        _this.state = {
	            mes: _this.props.meses[0]['value'],
	            inventariosFiltrados: [],
	            filtros: {}
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.buscarInventarios = function () {
	            var mes = _this.state.mes;
	            _v2.default.inventario.getRealizadosMesCliente(mes, 12).then(function (inventarios) {
	                _this.blackbox.reset();
	                inventarios.inventariosFormato.forEach(function (inventario) {
	                    return _this.blackbox.add(inventario);
	                });
	                _this.setState(_this.blackbox.getListaFiltrada());
	            });
	        };
	        _this.onSelectMesChanged = function (evt) {
	            _this.setState({
	                mes: evt.target.value
	            }, function () {
	                _this.buscarInventarios();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(InventariosFacturacion, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                aprobacionCliente: function aprobacionCliente(idInventario, _aprobacionCliente) {
	                    _v2.default.inv(idInventario).actualizarAprobacionFCV(_aprobacionCliente).then(function (inventarioActualizado) {
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                aprobacionSei: function aprobacionSei(idInventario, _aprobacionSei) {
	                    _v2.default.inv(idInventario).actualizarAprobacionSei(_aprobacionSei).then(function (inventarioActualizado) {
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                stockCliente: function stockCliente(idInventario, unidadesFCV) {
	                    _v2.default.inv(idInventario).actualizarStockFCV(unidadesFCV).then(function (inventarioActualizado) {
	                        console.log('inventario actualizado correctamente');
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                observacionCliente: function observacionCliente(idInventario, _observacionCliente) {
	                    _v2.default.inv(idInventario).actualizarObservacion(_observacionCliente).then(function (inventarioActualizado) {
	                        console.log('inventario actualizado correctamente');
	                        _this2.blackbox.actualizarInventario(inventarioActualizado);
	                        _this2.setState(_this2.blackbox.getListaFiltrada());
	                    });
	                },
	                actualizarFiltro: function actualizarFiltro(nombreFiltro, filtro) {
	                    _this2.blackbox.reemplazarFiltro(nombreFiltro, filtro);
	                    _this2.setState(_this2.blackbox.getListaFiltrada());
	                },
	                correoSEI: function correoSEI() {
	                    var request = _v2.default.facturacion(12).generarCorreoSei(_this2.state.mes);
	                    request.then(function () {
	                        return _this2.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Aprobacion inventarios'));
	                    return request;
	                },
	                generarFacturaTxt: function generarFacturaTxt() {
	                    var request = _v2.default.facturacion(12).generarFactura(_this2.state.mes);
	                    request.then(function () {
	                        return _this2.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Generar factura'));
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectMes',
	                                ref: function ref(_ref) {
	                                    return _this3.inputMes = _ref;
	                                },
	                                value: this.state.mes,
	                                onChange: this.onSelectMesChanged.bind(this) },
	                            '>',
	                            this.props.meses.map(function (mes, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: mes['value'] },
	                                    '' + mes['text']
	                                );
	                            })
	                        )
	                    ),
	                    this.props.permisos.aprobarUndCliente ? _react2.default.createElement(BotonDetalles, {
	                        mes: this.state.mes
	                    }) : _react2.default.createElement(BotonFacturacion, {
	                        mes: this.state.mes
	                    }),
	                    _react2.default.createElement(BotonExcel, {
	                        mes: this.state.mes
	                    })
	                ),
	                _react2.default.createElement(_TablaInventarios.TablaInventarios, {
	                    permisos: this.props.permisos,
	                    inventarios: this.state.inventariosFiltrados,
	                    filtros: this.state.filtros
	                })
	            );
	        }
	    }]);
	
	    return InventariosFacturacion;
	}(_react2.default.Component);
	
	InventariosFacturacion.propTypes = {
	    meses: PropTypes.arrayOf(PropTypes.object),
	    // Permisos
	    permisos: PropTypes.object.isRequired,
	    clientes: PropTypes.array.isRequired
	};
	InventariosFacturacion.childContextTypes = {
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func,
	    stockCliente: PropTypes.func,
	    observacionCliente: PropTypes.func,
	    actualizarFiltro: PropTypes.func,
	    correoSEI: PropTypes.func,
	    generarFacturaTxt: PropTypes.func
	};
	var BotonDetalles = function BotonDetalles(_ref2) {
	    var mes = _ref2.mes;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                'Detalles',
	                isVisible && _react2.default.createElement(_Modales.ModalDetalle, {
	                    hideModal: hideModal,
	                    mes: mes
	                })
	            );
	        }
	    );
	};
	var BotonFacturacion = function BotonFacturacion(_ref3) {
	    var mes = _ref3.mes;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                'Facturar',
	                isVisible && _react2.default.createElement(_Modales.ModalFacturacion, {
	                    hideModal: hideModal,
	                    mes: mes
	                })
	            );
	        }
	    );
	};
	var BotonExcel = function BotonExcel(_ref4) {
	    var mes = _ref4.mes;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-success pull-right',
	            href: '/api/resumen/descargar-excel-mes?mes=' + mes + '&idCliente=' + 12 },
	        'Datos Excel'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "InventariosFacturacion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1107);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _RowInventario = __webpack_require__(1123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componente
	
	var TablaInventarios = exports.TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios() {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).apply(this, arguments));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaInv,
	                    null,
	                    _.range(0, totalInventarios).map(function (index) {
	                        var inventario = _this2.props.inventarios[index];
	                        return _react2.default.createElement(_RowInventario.RowInventario, {
	                            permisos: _this2.props.permisos,
	                            ref: index,
	                            key: inventario ? inventario.inv_idInventario : index,
	                            inventario: inventario,
	                            correlativo: index + 1,
	                            stockCliente: _this2.context.stockCliente.bind(_this2),
	                            aprobacionCliente: _this2.context.aprobacionCliente.bind(_this2),
	                            aprobacionSei: _this2.context.aprobacionSei.bind(_this2),
	                            observacionCliente: _this2.context.observacionCliente.bind(_this2)
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	TablaInventarios.propTypes = {};
	TablaInventarios.contextTypes = {
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func,
	    stockCliente: PropTypes.func,
	    observacionCliente: PropTypes.func,
	    actualizarFiltro: PropTypes.func,
	    correoSEI: PropTypes.func
	};
	var TablaInv = function TablaInv(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Aprobaci\xF3n inventarios'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaInventariosFCV },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumeroLocal },
	                        'Ceco'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreLocal },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndInf },
	                        'Und. Inf. Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Discrepancia'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Conteo Unidades SEI'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndClientes },
	                        'Und. Cliente Aprobadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDiferencia },
	                        'Diferencia Conteo'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thObservacion },
	                        'Observaciones'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'HES'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thOk },
	                        'Aprobaci\xF3n Inventario Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thOkSEI },
	                        'Aprobaci\xF3n Inventario SEI'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1107);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _InputOkCliente = __webpack_require__(1109);
	
	var _InputOkSei = __webpack_require__(1110);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowInventario = exports.RowInventario = function (_React$Component) {
	    _inherits(RowInventario, _React$Component);
	
	    function RowInventario(props) {
	        _classCallCheck(this, RowInventario);
	
	        var _this = _possibleConstructorReturn(this, (RowInventario.__proto__ || Object.getPrototypeOf(RowInventario)).call(this, props));
	
	        _this.state = {
	            editando: false,
	            editandoObservacion: false
	        };
	        _this.onClick_editar = function () {
	            _this.setState({
	                editando: true
	            }, function () {
	                _this.inputStock.focus();
	            });
	        };
	        _this.onClick_editarObservacion = function () {
	            _this.setState({
	                editandoObservacion: true
	            }, function () {
	                _this.inputObservacion.focus();
	            });
	        };
	        _this.finalizarEdicion = function () {
	            _this.props.stockCliente(_this.props.inventario.inv_idInventario, _this.inputStock.value);
	            _this.setState({
	                editando: false
	            });
	        };
	        _this.finalizarEdicionObservacion = function () {
	            _this.props.observacionCliente(_this.props.inventario.inv_idInventario, _this.inputObservacion.value);
	            _this.setState({
	                editandoObservacion: false
	            });
	        };
	        _this.onKeyPress_editarStock = function (evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                _this.finalizarEdicion();
	            }
	        };
	        _this.onKeyPress_editarObservacion = function (evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                _this.finalizarEdicionObservacion();
	            }
	        };
	        return _this;
	    }
	
	    _createClass(RowInventario, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.inv_fechaProgramadaF
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    this.props.inventario.local_ceco
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.local_nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdInf },
	                    this.props.inventario.inv_unidadesInformadas
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_diferenciaInfReal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_unidadesReales
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadCliente },
	                    this.state.editando ? _react2.default.createElement('input', { type: 'number',
	                        ref: function ref(_ref) {
	                            return _this2.inputStock = _ref;
	                        },
	                        defaultValue: this.props.inventario.inv_unidadesSegunCliente,
	                        onKeyPress: this.onKeyPress_editarStock,
	                        onBlur: this.finalizarEdicion.bind(this)
	                    }) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.inventario.inv_aprobacionCliente == false ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_unidadesSegunClienteFormato,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.onClick_editar.bind(this) },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit pull-right' })
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_unidadesSegunClienteFormato
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDiferencia },
	                    this.props.inventario.inv_diferenciaSEIClienteFormat
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdObservacion },
	                    this.state.editandoObservacion ? _react2.default.createElement('input', { type: 'text',
	                        ref: function ref(_ref2) {
	                            return _this2.inputObservacion = _ref2;
	                        },
	                        defaultValue: this.props.inventario.inv_observacionDiferencia,
	                        onKeyPress: this.onKeyPress_editarObservacion,
	                        onBlur: this.finalizarEdicionObservacion.bind(this)
	                    }) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.inventario.inv_aprobacionCliente == false ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_observacionDiferencia,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.onClick_editarObservacion.bind(this) },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-edit pull-right' })
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.inventario.inv_observacionDiferencia
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.inv_hes
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOk },
	                    this.props.permisos.aprobarUndCliente ? _react2.default.createElement(_InputOkCliente.InputOkCliente, {
	                        permisos: this.props.permisos,
	                        inventario: this.props.inventario,
	                        aprobacionCliente: this.props.aprobacionCliente
	                    }) : _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.props.inventario.inv_aprobacionCliente,
	                        disabled: 'true'
	                    })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdOk },
	                    this.props.permisos.aprobarUndSEI ? _react2.default.createElement(_InputOkSei.InputOkSei, {
	                        inventario: this.props.inventario,
	                        aprobacionSei: this.props.aprobacionSei
	                    }) : _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: this.props.inventario.inv_aprobacionSEI,
	                        disabled: 'true'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return RowInventario;
	}(_react2.default.Component);
	
	RowInventario.propTypes = {
	    inventario: PropTypes.object,
	    correlativo: PropTypes.number,
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalFacturacion = exports.ModalDetalle = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1113);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// API
	
	// Componentes
	
	// Style
	
	var css = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalDetalle = exports.ModalDetalle = function (_React$Component2) {
	    _inherits(ModalDetalle, _React$Component2);
	
	    function ModalDetalle(props) {
	        _classCallCheck(this, ModalDetalle);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalDetalle.__proto__ || Object.getPrototypeOf(ModalDetalle)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false,
	            aprobadoFacturar: false
	        };
	        _this2.fetchDetalleFactura = function () {
	            var mes = _this2.props.mes;
	            _v2.default.inventario.getAprobadosMesCliente(mes, 12).then(function (detalle) {
	                _this2.setState({ unidades: detalle.sumaUnidades });
	                _this2.setState({ total: detalle.total });
	                _this2.setState({ totalNeto: detalle.totalNeto });
	                _this2.setState({ aprobadoFacturar: detalle.aprobadoFacturar });
	            }).catch(function (error) {
	                console.log("error");
	            });
	        };
	        _this2.handleSubmit = function (evt) {
	            _this2.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState(function () {
	                _this2.context.correoSEI().then(function () {
	                    _this2.setState({ bloqueado: false });
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalDetalle, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalleFactura();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unidades'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidades
	                            ),
	                            'Total unidades aprobadas'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Valores'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.total
	                            ),
	                            'Valor neto'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalNeto
	                            ),
	                            'Valor bruto'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado || this.state.aprobadoFacturar == false },
	                            'Aprobar Facturaci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalDetalle;
	}(_react2.default.Component);
	
	ModalDetalle.contextTypes = {
	    correoSEI: PropTypes.func
	};
	
	var ModalFacturacion = exports.ModalFacturacion = function (_React$Component3) {
	    _inherits(ModalFacturacion, _React$Component3);
	
	    function ModalFacturacion(props) {
	        _classCallCheck(this, ModalFacturacion);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalFacturacion.__proto__ || Object.getPrototypeOf(ModalFacturacion)).call(this, props));
	
	        _this3.state = {
	            bloqueado: false,
	            aprobadoFacturar: false
	        };
	        _this3.fetchDetalleFactura = function () {
	            var mes = _this3.props.mes;
	            _v2.default.inventario.getAprobadosSEIMesCliente(mes, 12).then(function (detalle) {
	                _this3.setState({ unidades: detalle.sumaUnidades });
	                _this3.setState({ total: detalle.total });
	                _this3.setState({ totalNeto: detalle.totalNeto });
	                _this3.setState({ aprobadoFacturar: detalle.aprobadoFacturar });
	            }).catch(function (error) {
	                console.log("error");
	            });
	        };
	        _this3.handleSubmit = function (evt) {
	            _this3.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this3.setState(function () {
	                _this3.context.generarFacturaTxt().then(function () {
	                    _this3.setState({ bloqueado: false });
	                    _this3.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this3;
	    }
	
	    _createClass(ModalFacturacion, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchDetalleFactura();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unidades'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.state.unidades
	                            ),
	                            'Total unidades aprobadas'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Valores'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.total
	                            ),
	                            'Valor neto'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.state.totalNeto
	                            ),
	                            'Valor bruto'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado || this.state.aprobadoFacturar == false },
	                            'Generar Facturar'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                            'Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalFacturacion;
	}(_react2.default.Component);
	
	ModalFacturacion.contextTypes = {
	    generarFacturaTxt: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PeticionOC = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaInventarios = __webpack_require__(1126);
	
	var _Modales = __webpack_require__(1129);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var PeticionOC = exports.PeticionOC = function (_React$Component) {
	    _inherits(PeticionOC, _React$Component);
	
	    function PeticionOC(props) {
	        _classCallCheck(this, PeticionOC);
	
	        var _this = _possibleConstructorReturn(this, (PeticionOC.__proto__ || Object.getPrototypeOf(PeticionOC)).call(this, props));
	
	        _this.state = {};
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        return _this;
	    }
	
	    _createClass(PeticionOC, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                agregarOrdenCompra: function agregarOrdenCompra(numeroOC) {
	                    var request = _v2.default.facturacion(_this2.props.cliente).agregarOrdenCompra(_this2.props.fechaInicial, _this2.props.fechaFinal, numeroOC);
	                    request.then(function () {
	                        return _this2.refs.notificator.success("Proceso satisfactorio", "Número orden de compra agregado correctamente.", 4 * 1000);
	                    }).catch(_this2.ajaxErrorHandler('Agregar orden compra'));
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(BotonGenerarOC, {
	                        sumaUnidades: this.props.sumaUnidades,
	                        valorBruto: this.props.valorBruto,
	                        valorNeto: this.props.valorNeto
	                    }),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Favor pulse el bot\xF3n "AGREGAR OC" para indicar orden de compra de los siguientes inventarios realizados'
	                    )
	                ),
	                _react2.default.createElement(_TablaInventarios.TablaInventarios, {
	                    sumaUnidades: this.props.sumaUnidades,
	                    valorNeto: this.props.valorNeto,
	                    inventarios: this.props.inventarios
	                })
	            );
	        }
	    }]);
	
	    return PeticionOC;
	}(_react2.default.Component);
	
	PeticionOC.propTypes = {
	    // Permisos
	    //permisos: PropTypes.object.isRequired
	    inventarios: PropTypes.arrayOf(PropTypes.object),
	    sumaUnidades: PropTypes.string,
	    valorBruto: PropTypes.string,
	    valorNeto: PropTypes.string,
	    cliente: PropTypes.number,
	    fechaInicial: PropTypes.string,
	    fechaFinal: PropTypes.string
	};
	PeticionOC.childContextTypes = {
	    agregarOrdenCompra: PropTypes.func
	};
	var BotonGenerarOC = function BotonGenerarOC(_ref) {
	    var sumaUnidades = _ref.sumaUnidades,
	        valorBruto = _ref.valorBruto,
	        valorNeto = _ref.valorNeto;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-primary pull-right', onClick: showModal },
	                isVisible && _react2.default.createElement(_Modales.ModalGenerarOC, {
	                    sumaUnidades: sumaUnidades,
	                    valorBruto: valorBruto,
	                    valorNeto: valorNeto,
	                    hideModal: hideModal
	                }),
	                'AGREGAR OC'
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "PeticionOC.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1127);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _RowInventario = __webpack_require__(1128);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componente
	
	var TablaInventarios = exports.TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios() {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).apply(this, arguments));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaInv,
	                    null,
	                    _.range(0, totalInventarios).map(function (index) {
	                        var inventario = _this2.props.inventarios[index];
	                        return _react2.default.createElement(_RowInventario.RowInventario, {
	                            ref: index,
	                            key: inventario ? inventario.inv_idInventario : index,
	                            inventario: inventario,
	                            correlativo: '' + (index + 1)
	                        });
	                    }),
	                    _react2.default.createElement(_RowInventario.RowInventario, {
	                        correlativo: "T",
	                        valorNeto: this.props.valorNeto
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	TablaInventarios.propTypes = {};
	var TablaInv = function TablaInv(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	            ' Servicios realizados'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaInventariosFCV },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha IG'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreCliente },
	                        'Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumeroLocal },
	                        'Ceco'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreLocal },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Disc. Te\xF3rico'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndInf },
	                        'Und. Informadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndInf },
	                        'Und. Contadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        '$ Unitario'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Total Servicio'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tablaInventariosFCV":"TablaInventarios__tablaInventariosFCV___1gNHZ","thCorrelativo":"TablaInventarios__thCorrelativo___3Ks7c","thFecha":"TablaInventarios__thFecha___2J1k5","thNumeroLocal":"TablaInventarios__thNumeroLocal___2cTUT","thNombreLocal":"TablaInventarios__thNombreLocal___12-Jw","thNombreCliente":"TablaInventarios__thNombreCliente___-cSJS","thComuna":"TablaInventarios__thComuna___1Ejtz","thStockValorizado":"TablaInventarios__thStockValorizado___2cOpg","thCosto":"TablaInventarios__thCosto___278YU","thUndSEI":"TablaInventarios__thUndSEI___17YcS","thUndInf":"TablaInventarios__thUndInf___3mXlX","thUndCliente":"TablaInventarios__thUndCliente___3C2IM","thUndClientes":"TablaInventarios__thUndClientes___1PvI-","thDiferencia":"TablaInventarios__thDiferencia___rJYrP","thObservacion":"TablaInventarios__thObservacion___2hPuD","thOk":"TablaInventarios__thOk___3IJr0","thOkSEI":"TablaInventarios__thOkSEI___1IGc2","thFacturado":"TablaInventarios__thFacturado___TxwKm","thHESOC":"TablaInventarios__thHESOC___22P6n","tdUnidadSEI":"TablaInventarios__tdUnidadSEI___3ii_g","tdInf":"TablaInventarios__tdInf___GFNI8","tdCeco":"TablaInventarios__tdCeco___2fmdk","tdUnidadCliente":"TablaInventarios__tdUnidadCliente___O9PUE","tdDiferencia":"TablaInventarios__tdDiferencia___1RZz1","tdOk":"TablaInventarios__tdOk___24I6t","tdFacturado":"TablaInventarios__tdFacturado___8vm1W","tdObservacion":"TablaInventarios__tdObservacion___2o1tY","tdPorcentajeVal":"TablaInventarios__tdPorcentajeVal___3h_85","tdFacturar":"TablaInventarios__tdFacturar___3HTjP","tdHESOC":"TablaInventarios__tdHESOC___1hfu1","tdSubirArchivo":"TablaInventarios__tdSubirArchivo___2vEi7","thSubirArchivo":"TablaInventarios__thSubirArchivo___2J7H0","thFacturar":"TablaInventarios__thFacturar___23Iuv"};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1127);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowInventario = exports.RowInventario = function (_React$Component) {
	    _inherits(RowInventario, _React$Component);
	
	    function RowInventario(props) {
	        _classCallCheck(this, RowInventario);
	
	        var _this = _possibleConstructorReturn(this, (RowInventario.__proto__ || Object.getPrototypeOf(RowInventario)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(RowInventario, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.inventario) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 1 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.inventario.inv_fechaProgramadaF
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.inventario.cliente_nombre
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdCeco },
	                        this.props.inventario.local_ceco
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.inventario.local_nombre
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUnidadSEI },
	                        this.props.inventario.inv_diferenciaInfReal.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdInf },
	                        this.props.inventario.inv_unidadesInformadas.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdInf },
	                        this.props.inventario.inv_unidadesReal.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUnidadSEI },
	                        this.props.inventario.precio_unidad
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUnidadSEI },
	                        this.props.inventario.total_servicio.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
	                    )
	                );
	            } else if (this.props.valorNeto) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 2 },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.props.correlativo
	                    ),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement('td', null),
	                    _react2.default.createElement(
	                        'td',
	                        { className: css.tdUnidadSEI },
	                        this.props.valorNeto
	                    )
	                );
	            }
	        }
	    }]);
	
	    return RowInventario;
	}(_react2.default.Component);
	
	RowInventario.propTypes = {
	    inventario: PropTypes.object,
	    correlativo: PropTypes.string,
	    sumaUnidades: PropTypes.string,
	    valor: PropTypes.string,
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalGenerarOC = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1113);
	
	var cssModal = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// API
	
	// Componentes
	
	// Style
	
	var css = _bind2.default.bind(cssModal);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalGenerarOC = exports.ModalGenerarOC = function (_React$Component2) {
	    _inherits(ModalGenerarOC, _React$Component2);
	
	    function ModalGenerarOC(props) {
	        _classCallCheck(this, ModalGenerarOC);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalGenerarOC.__proto__ || Object.getPrototypeOf(ModalGenerarOC)).call(this, props));
	
	        _this2.state = {
	            bloqueado: false,
	            numeroOC: ''
	        };
	        _this2.onNumeroChange = function (key, evt) {
	            _this2.setState({ numeroOC: evt.target.value });
	        };
	        _this2.handleSubmit = function (evt) {
	            _this2.setState({ bloqueado: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState(function () {
	                _this2.context.agregarOrdenCompra(_this2.state.numeroOC).then(function () {
	                    _this2.setState({ bloqueado: false });
	                    _this2.props.hideModal();
	                }).catch(function (error) {
	                    console.log("error");
	                });
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalGenerarOC, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: css('modale') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informaci\xF3n de facturaci\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Unidades'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                this.props.sumaUnidades
	                            ),
	                            'Total unidades'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Valores'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.props.valorNeto
	                            ),
	                            'Valor neto'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                '$',
	                                this.props.valorBruto
	                            ),
	                            'Valor final'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: this.handleSubmit },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Ind\xEDque n\xFAmero orden de compra'
	                            ),
	                            _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'N\xFAmero orden compra',
	                                value: this.state.numeroOC,
	                                onChange: this.onNumeroChange.bind(this, 'numeroOC'),
	                                required: true
	                            }),
	                            _react2.default.createElement('div', null),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Se enviar\xE1 una copia de esta confirmaci\xF3n a los siguientes correos'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'list-group' },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'list-group-item' },
	                                    'crivera@sb.cl, ptejeda@sb.cl, paviles@sb.cl, rmunozp@sb.cl'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'list-group-item' },
	                                    'mgamboa@seiconsultores.cl, gbriones@seiconsultores.cl'
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'submit', className: 'btn btn-primary', disabled: this.state.bloqueado },
	                                'Enviar OC'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-secondary', onClick: this.props.hideModal },
	                                'Cancelar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalGenerarOC;
	}(_react2.default.Component);
	
	ModalGenerarOC.contextTypes = {
	    agregarOrdenCompra: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ServiciosRealizados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaInventarios = __webpack_require__(1131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// COMPONENTES
	
	var ServiciosRealizados = exports.ServiciosRealizados = function (_React$Component) {
	    _inherits(ServiciosRealizados, _React$Component);
	
	    function ServiciosRealizados(props) {
	        _classCallCheck(this, ServiciosRealizados);
	
	        var _this = _possibleConstructorReturn(this, (ServiciosRealizados.__proto__ || Object.getPrototypeOf(ServiciosRealizados)).call(this, props));
	
	        _this.state = {
	            mes: _this.props.meses[0]['value'],
	            inventarios: []
	        };
	        _this.buscarInventarios = function () {
	            var mes = _this.state.mes;
	            _v2.default.facturacion(_this.props.cliente).getServiciosSalcobrand(mes).then(function (inventarios) {
	                _this.setState({ inventarios: inventarios });
	            }).catch(function (meh) {});
	        };
	        _this.onSelectMesChanged = function (evt) {
	            _this.setState({
	                mes: evt.target.value
	            }, function () {
	                _this.buscarInventarios();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(ServiciosRealizados, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label', htmlFor: 'selectMes' },
	                            'Mes'
	                        ),
	                        _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', name: 'selectMes',
	                                ref: function ref(_ref) {
	                                    return _this2.inputMes = _ref;
	                                },
	                                value: this.state.mes,
	                                onChange: this.onSelectMesChanged.bind(this) },
	                            '>',
	                            this.props.meses.map(function (mes, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: index, value: mes['value'] },
	                                    '' + mes['text']
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(BotonExcel, {
	                        mes: this.state.mes,
	                        cliente: this.props.cliente
	                    })
	                ),
	                _react2.default.createElement(_TablaInventarios.TablaInventarios, {
	                    inventarios: this.state.inventarios
	                })
	            );
	        }
	    }]);
	
	    return ServiciosRealizados;
	}(_react2.default.Component);
	
	ServiciosRealizados.propTypes = {
	    meses: PropTypes.arrayOf(PropTypes.object),
	    cliente: PropTypes.number
	    // Permisos
	};
	var BotonExcel = function BotonExcel(_ref2) {
	    var mes = _ref2.mes,
	        cliente = _ref2.cliente;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-success pull-right',
	            href: '/api/consolidado/mes/' + mes + '/' + cliente },
	        'Consolidado'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ServiciosRealizados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1127);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	var _RowInventario = __webpack_require__(1132);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componente
	
	var TablaInventarios = exports.TablaInventarios = function (_React$Component) {
	    _inherits(TablaInventarios, _React$Component);
	
	    function TablaInventarios() {
	        _classCallCheck(this, TablaInventarios);
	
	        return _possibleConstructorReturn(this, (TablaInventarios.__proto__ || Object.getPrototypeOf(TablaInventarios)).apply(this, arguments));
	    }
	
	    _createClass(TablaInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaInv,
	                    null,
	                    _.range(0, totalInventarios).map(function (index) {
	                        var inventario = _this2.props.inventarios[index];
	                        return _react2.default.createElement(_RowInventario.RowInventario, {
	                            ref: index,
	                            key: inventario ? inventario.inv_idInventario : index,
	                            inventario: inventario,
	                            correlativo: index + 1
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaInventarios;
	}(_react2.default.Component);
	
	TablaInventarios.propTypes = {};
	var TablaInv = function TablaInv(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Inventarios realizados'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaInventariosFCV },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha IG'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreCliente },
	                        'Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumeroLocal },
	                        'Ceco'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNombreLocal },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndInf },
	                        'Und. Contadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Disc. Teorico'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'N\xB0 OC'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thUndSEI },
	                        'Total Servicio'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaInventarios = __webpack_require__(1107);
	
	var css = _interopRequireWildcard(_TablaInventarios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowInventario = exports.RowInventario = function (_React$Component) {
	    _inherits(RowInventario, _React$Component);
	
	    function RowInventario(props) {
	        _classCallCheck(this, RowInventario);
	
	        return _possibleConstructorReturn(this, (RowInventario.__proto__ || Object.getPrototypeOf(RowInventario)).call(this, props));
	    }
	
	    _createClass(RowInventario, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.inventario.inv_fechaProgramadaF
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.cliente_nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCeco },
	                    this.props.inventario.local_ceco
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.inventario.local_nombre
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdInf },
	                    this.props.inventario.inv_unidadesReal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_diferenciaInfReal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.inv_hes
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdUnidadSEI },
	                    this.props.inventario.total_servicio
	                )
	            );
	        }
	    }]);
	
	    return RowInventario;
	}(_react2.default.Component);
	
	RowInventario.propTypes = {
	    inventario: PropTypes.object,
	    correlativo: PropTypes.number,
	    aprobacionCliente: PropTypes.func,
	    aprobacionSei: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MisFacturas = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SelectRange = __webpack_require__(731);
	
	var _SelectRange2 = _interopRequireDefault(_SelectRange);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaFacturas = __webpack_require__(1134);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	// NOTIFICACIONES
	
	// MOMENT
	
	_moment2.default.locale('es');
	// CALENDARIO
	
	// API
	
	// COMPONENTES
	
	var format = 'YYYY-MM-DD';
	
	var MisFacturas = exports.MisFacturas = function (_React$Component) {
	    _inherits(MisFacturas, _React$Component);
	
	    function MisFacturas(props) {
	        _classCallCheck(this, MisFacturas);
	
	        var _this = _possibleConstructorReturn(this, (MisFacturas.__proto__ || Object.getPrototypeOf(MisFacturas)).call(this, props));
	
	        _this.state = {
	            fechaInicialSeleccionada: (0, _moment2.default)().startOf('month'),
	            fechaFinalSeleccionada: (0, _moment2.default)().endOf('week'),
	            facturasFiltradas: []
	        };
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4 * 1000);
	                // en otro error, buscar el cuerpo del mensaje
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.buscarFacturas = function () {
	            var fechaInicio = _this.state.fechaInicialSeleccionada.format(format);
	            var fechaFin = _this.state.fechaFinalSeleccionada.format(format);
	            _v2.default.facturacion(_this.props.cliente).disponiblesCliente(fechaInicio, fechaFin).then(function (facturas) {
	                _this.setState({ facturasFiltradas: facturas });
	            });
	        };
	        _this.onSelectRangoChanged = function (momentumFechaInicio, momentumFechaFinal) {
	            _this.setState({
	                fechaInicialSeleccionada: momentumFechaInicio,
	                fechaFinalSeleccionada: momentumFechaFinal
	            }, function () {
	                _this.buscarFacturas();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(MisFacturas, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.buscarFacturas();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-3 form-group ' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            'Rango de Fecha'
	                        ),
	                        _react2.default.createElement(_SelectRange2.default, {
	                            startDateSelected: this.state.fechaInicialSeleccionada,
	                            endDateSelected: this.state.fechaFinalSeleccionada,
	                            onInit: function onInit() {
	                                console.log("on init");
	                            },
	                            onRangeSelected: this.onSelectRangoChanged.bind(this)
	                        })
	                    )
	                ),
	                _react2.default.createElement(_TablaFacturas.TablaFacturas, {
	                    facturas: this.state.facturasFiltradas
	                })
	            );
	        }
	    }]);
	
	    return MisFacturas;
	}(_react2.default.Component);
	
	MisFacturas.propTypes = {
	    cliente: PropTypes.number
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "MisFacturas.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaFacturas = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaFacturas = __webpack_require__(1135);
	
	var css = _interopRequireWildcard(_TablaFacturas);
	
	var _RowFactura = __webpack_require__(1136);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// CSS
	
	// Componente
	
	var TablaFacturas = exports.TablaFacturas = function (_React$Component) {
	    _inherits(TablaFacturas, _React$Component);
	
	    function TablaFacturas() {
	        _classCallCheck(this, TablaFacturas);
	
	        return _possibleConstructorReturn(this, (TablaFacturas.__proto__ || Object.getPrototypeOf(TablaFacturas)).apply(this, arguments));
	    }
	
	    _createClass(TablaFacturas, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalFacturas = this.props.facturas.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    TablaFactoring,
	                    null,
	                    _.range(0, totalFacturas).map(function (index) {
	                        var factura = _this2.props.facturas[index];
	                        return _react2.default.createElement(_RowFactura.RowFactura, {
	                            ref: index,
	                            key: factura ? factura.fac_idFactura : index,
	                            factura: factura,
	                            correlativo: index + 1
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaFacturas;
	}(_react2.default.Component);
	
	TablaFacturas.propTypes = {};
	var TablaFactoring = function TablaFactoring(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-primary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Facturas disponibles para descargar'
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped table-hover no-margin table-condensed ' + css.tablaFacturas },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thCorrelativo },
	                        '#'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDocumento },
	                        'Documento'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thNumero },
	                        'Folio'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha Emisi\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFecha },
	                        'Fecha Vencimiento'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thMonto },
	                        'Monto Neto'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thMonto },
	                        'Monto Bruto'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thDescarga },
	                        'Descarga'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaFacturas.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tablaFacturas":"TablaFacturas__tablaFacturas___2qp9H","thCorrelativo":"TablaFacturas__thCorrelativo___fE2V-","thDocumento":"TablaFacturas__thDocumento___zO4VG","thFecha":"TablaFacturas__thFecha___2wr0Y","thMonto":"TablaFacturas__thMonto___2gilD","thNumero":"TablaFacturas__thNumero___1fK7Q","thDescarga":"TablaFacturas__thDescarga___oXymp","tdDocumento":"TablaFacturas__tdDocumento___2fgXc","tdNumero":"TablaFacturas__tdNumero___1nzAI","tdMonto":"TablaFacturas__tdMonto___iu7bz","tdFecha":"TablaFacturas__tdFecha___1_fB5","tdDescarga":"TablaFacturas__tdDescarga___1KkJE"};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowFactura = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TablaFacturas = __webpack_require__(1135);
	
	var css = _interopRequireWildcard(_TablaFacturas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	
	var RowFactura = exports.RowFactura = function (_React$Component) {
	    _inherits(RowFactura, _React$Component);
	
	    function RowFactura(props) {
	        _classCallCheck(this, RowFactura);
	
	        var _this = _possibleConstructorReturn(this, (RowFactura.__proto__ || Object.getPrototypeOf(RowFactura)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(RowFactura, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: 1 },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    this.props.correlativo
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDocumento },
	                    this.props.factura.fac_tipoDocumento
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdNumero },
	                    this.props.factura.fac_folio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.factura.fac_fechaEmision
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    this.props.factura.fac_fechaVencimiento
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdMonto },
	                    '$' + this.props.factura.fac_totalNeto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdMonto },
	                    '$' + this.props.factura.fac_totalBruto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDescarga },
	                    _react2.default.createElement(BotonDescarga, {
	                        publicID: this.props.factura.fac_idFacturaPublic
	                    })
	                )
	            );
	        }
	    }]);
	
	    return RowFactura;
	}(_react2.default.Component);
	
	RowFactura.propTypes = {
	    factura: PropTypes.object,
	    correlativo: PropTypes.number
	};
	var BotonDescarga = function BotonDescarga(_ref) {
	    var publicID = _ref.publicID;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-sm btn-success pull-right',
	            href: '/facturacion/' + publicID + '/descargar/pdf' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-link' }),
	        ' DESCARGA PDF'
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowFactura.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ManagementOC = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(638);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _ManagementOC = __webpack_require__(1138);
	
	var css = _interopRequireWildcard(_ManagementOC);
	
	var _constants = __webpack_require__(1139);
	
	var _Panels = __webpack_require__(1140);
	
	var _DataTable = __webpack_require__(1141);
	
	var _OptionRequest = __webpack_require__(1143);
	
	var _Modales = __webpack_require__(1144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// API
	
	// CSS
	
	// Const
	
	// Components 
	
	
	var ManagementOC = exports.ManagementOC = function (_Component) {
	    _inherits(ManagementOC, _Component);
	
	    function ManagementOC(props) {
	        _classCallCheck(this, ManagementOC);
	
	        var _this = _possibleConstructorReturn(this, (ManagementOC.__proto__ || Object.getPrototypeOf(ManagementOC)).call(this, props));
	
	        _this.state = {
	            servicesToBilling: [],
	            billingRequest: {},
	            statusAll: 0,
	            totalNeto: 0,
	            iva: 0,
	            total: 0
	        };
	        _this.getServicesForBilling = function () {
	            var idBillingRequest = _this.props.idBillingRequest;
	
	            _v2.default.billing().getServicesBillingFsb(idBillingRequest).then(function (response) {
	                _this.setState({
	                    servicesToBilling: response.services,
	                    statusAll: response.status_all,
	                    totalNeto: response.total_neto,
	                    iva: response.iva,
	                    total: response.total
	                });
	                _this.getBillingRequestData(response.services[0].billing_request_id);
	            }).catch(function (err) {});
	        };
	        _this.getBillingRequestData = function (idBillingRequest) {
	            _v2.default.billing().getBillingRequest(idBillingRequest).then(function (response) {
	                _this.setState({
	                    billingRequest: response
	                });
	            }).catch(function (err) {});
	        };
	        _this.statusPaymentService = function (idService, evt) {
	            var statusClient = evt.target.checked;
	            _v2.default.billing().setStatusPaymentService(idService, statusClient).then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	        };
	        _this.statusPaymentAll = function (evt) {
	            var statusClient = evt.target.checked;
	            var idBillingRequest = _this.props.idBillingRequest;
	
	            _v2.default.billing().setStatusPaymentAllService(idBillingRequest, statusClient).then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	        };
	        _this.dischargeServices = function () {
	            var request = _v2.default.billing().dischargeServices(_this.state.billingRequest.idBillingRequest);
	            request.then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	            return request;
	        };
	        _this.dischargeOC = function () {
	            var request = _v2.default.billing().dischargeOC(_this.state.billingRequest.idBillingRequest);
	            request.then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	            return request;
	        };
	        _this.assignOC = function (numberOC, file) {
	            var data = new FormData();
	            data.append('pdfOC', file);
	            data.append('numberOC', numberOC);
	            var request = _v2.default.billing().assignOC(_this.state.billingRequest.idBillingRequest, data);
	            request.then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	            return request;
	        };
	        _this.rejectRequest = function (msg) {
	            var idBillingRequest = _this.props.idBillingRequest;
	
	            var request = _v2.default.billing().rejectRequest(idBillingRequest, msg);
	            request.then(function (response) {
	                _this.getServicesForBilling();
	            }).catch(function (err) {});
	            return request;
	        };
	        return _this;
	    }
	
	    _createClass(ManagementOC, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getServicesForBilling();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                idBillingRequest = _props.idBillingRequest,
	                idClient = _props.idClient;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-header row ' + css.headerManagementOC },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-info-sign' }),
	                            ' Requerimiento orden de compra ',
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'label label-info' },
	                                    _constants.NAME_REQUEST_BILLING[this.state.billingRequest.status]
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 ' + css.divExcelButton },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-success btn-md pull-right',
	                                href: '/api/billing/export/excel-oc-fsb?id_billing_request=' + idBillingRequest + '&billable=true&only_approve_client=true' },
	                            'Exportar ',
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' })
	                        ),
	                        _react2.default.createElement(ButtonAdminEmails, {
	                            idClient: idClient
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        _react2.default.createElement(_Panels.PanelDataVendor, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Gesti\xF3n Autorizaci\xF3n Servicios'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                _react2.default.createElement(_Panels.PanelDataRequest, null),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'btn-group' },
	                                    _react2.default.createElement(_OptionRequest.OptionRequestServices, {
	                                        status: this.state.billingRequest.status,
	                                        dischargeServices: this.dischargeServices,
	                                        rejectRequest: this.rejectRequest,
	                                        data: {
	                                            servicesApprove: this.state.servicesToBilling.filter(function (service) {
	                                                return service.approve_client == 1;
	                                            }),
	                                            servicesNotApprove: this.state.servicesToBilling.filter(function (service) {
	                                                return service.approve_client == 0;
	                                            }),
	                                            cantServices: this.state.servicesToBilling.length,
	                                            totalNeto: this.state.totalNeto,
	                                            iva: this.state.iva,
	                                            total: this.state.total
	                                        },
	                                        perms: this.props.perms
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Gesti\xF3n Orden de Compra'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                _react2.default.createElement(_Panels.PanelDataDocument, {
	                                    status: this.state.billingRequest.status,
	                                    creationDate: this.state.billingRequest.creation_date,
	                                    lastUpdate: this.state.billingRequest.last_update
	                                }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'btn-group' },
	                                    _react2.default.createElement(_OptionRequest.OptionRequestOC, {
	                                        status: this.state.billingRequest.status,
	                                        dischargeOC: this.dischargeOC,
	                                        assignOC: this.assignOC,
	                                        data: {
	                                            servicesApprove: this.state.servicesToBilling.filter(function (service) {
	                                                return service.approve_client == 1;
	                                            }),
	                                            servicesNotApprove: this.state.servicesToBilling.filter(function (service) {
	                                                return service.approve_client == 0;
	                                            }),
	                                            cantServices: this.state.servicesToBilling.length,
	                                            totalNeto: this.state.totalNeto,
	                                            iva: this.state.iva,
	                                            total: this.state.total
	                                        },
	                                        perms: this.props.perms
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-primary' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Servicios realizados'
	                            ),
	                            _react2.default.createElement(_DataTable.TableServices, {
	                                services: this.state.servicesToBilling,
	                                statusAll: this.state.statusAll,
	                                totalNeto: this.state.totalNeto,
	                                iva: this.state.iva,
	                                total: this.state.total,
	                                statusPaymentService: this.statusPaymentService,
	                                statusPaymentAll: this.statusPaymentAll,
	                                canUpdateServices: this.state.billingRequest.status === 1 && this.props.perms.approveServices
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ManagementOC;
	}(_react.Component);
	
	ManagementOC.propTypes = {
	    idBillingRequest: _react.PropTypes.number.isRequired,
	    idClient: _react.PropTypes.number.isRequired,
	    perms: _react.PropTypes.object.isRequired
	};
	var ButtonAdminEmails = function ButtonAdminEmails(_ref) {
	    var idClient = _ref.idClient;
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: 'btn btn-md btn-info pull-right',
	                    onClick: showModal
	                },
	                'Destinatarios ',
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
	                isVisible && _react2.default.createElement(_Modales.ModalAdminEmails, {
	                    hideModal: hideModal,
	                    idClient: idClient
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ManagementOC.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"divExcelButton":"ManagementOC__divExcelButton___nBN66","headerManagementOC":"ManagementOC__headerManagementOC___3EjUH","listGroupItem":"ManagementOC__listGroupItem___3Z-Q9","navChangeData":"ManagementOC__navChangeData___mhiDu","divOptionsRequest":"ManagementOC__divOptionsRequest___1RMMF","divData":"ManagementOC__divData___3RSCh","tdHidden":"ManagementOC__tdHidden___2cDqx"};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var NAME_REQUEST_BILLING = exports.NAME_REQUEST_BILLING = ['', 'Pendiente', 'Servicios Autorizados', 'Orden de Compra Autorizada', 'Orden de Compra Asignada', 'Solicitud Rechazada'];
	var LABEL_STATUS_REQUEST = exports.LABEL_STATUS_REQUEST = ['', 'btn-info', 'btn-secondary', 'btn-primary', 'btn-success', 'btn-danger'];
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "constants.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PanelDataDocument = exports.PanelDataRequest = exports.PanelDataVendor = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ManagementOC = __webpack_require__(1138);
	
	var css = _interopRequireWildcard(_ManagementOC);
	
	var _constants = __webpack_require__(1139);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	// Const
	
	
	var PanelDataVendor = exports.PanelDataVendor = function PanelDataVendor(_ref) {
	    _objectDestructuringEmpty(_ref);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'panel panel-info' },
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            'Datos Proveedor'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'list-group' },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'list-group-item ' + css.listGroupItem },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'badge' },
	                        '76.312.497-5'
	                    ),
	                    'Rut'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'list-group-item ' + css.listGroupItem },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'badge' },
	                        'SEI Ingenieria y Servicios SPA.'
	                    ),
	                    'Empresa'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'list-group-item ' + css.listGroupItem },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'badge' },
	                        'mgamboa@seiconsultores.cl'
	                    ),
	                    'Correo'
	                )
	            )
	        )
	    );
	};
	var PanelDataRequest = exports.PanelDataRequest = function PanelDataRequest(_ref2) {
	    _objectDestructuringEmpty(_ref2);
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'list-group' },
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                'Rodrigo Mu\xF1oz'
	            ),
	            'Responsable Aprobaci\xF3n OC'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                'Clara Rivera Villagr\xE1n'
	            ),
	            'Nombre Solicitante'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                '13.235.458-8'
	            ),
	            'Rut Solicitante'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                'Control de Inventarios y Existencias'
	            ),
	            'Nombre Area'
	        )
	    );
	};
	var PanelDataDocument = exports.PanelDataDocument = function PanelDataDocument(_ref3) {
	    var status = _ref3.status,
	        creationDate = _ref3.creationDate,
	        lastUpdate = _ref3.lastUpdate;
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'list-group' },
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                creationDate
	            ),
	            'Fecha solicitud'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                'Orden de compra standar'
	            ),
	            'Tipo Orden de Compra'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                _constants.NAME_REQUEST_BILLING[status]
	            ),
	            'Estado Actual'
	        ),
	        _react2.default.createElement(
	            'li',
	            { className: 'list-group-item ' + css.listGroupItem },
	            _react2.default.createElement(
	                'span',
	                { className: 'badge' },
	                lastUpdate
	            ),
	            'Ultima Actualizaci\xF3n'
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Panels.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableServices = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DataTable = __webpack_require__(1142);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableServices = exports.TableServices = function TableServices(_ref) {
	    var services = _ref.services,
	        statusAll = _ref.statusAll,
	        totalNeto = _ref.totalNeto,
	        iva = _ref.iva,
	        total = _ref.total,
	        statusPaymentService = _ref.statusPaymentService,
	        statusPaymentAll = _ref.statusPaymentAll,
	        canUpdateServices = _ref.canUpdateServices;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped ' + _DataTable2.default.DataTable },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Fecha Servicio'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CECO'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _DataTable2.default.DataTable_thNameStore },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Regi\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Comuna'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Und Contadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Valor Unidad'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Valor Afecto'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Acta Pdf'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            className: 'form-check-input',
	                            checked: statusAll,
	                            onChange: function onChange(evt) {
	                                return statusPaymentAll(evt);
	                            },
	                            disabled: !canUpdateServices
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                services.map(function (service) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: service.service_id },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.service_date
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdNameClient },
	                            service.client_name
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdCeco },
	                            service.store_ceco
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdNameStore },
	                            service.store_name
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.store_region
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.store_comuna
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            service.units_counted.toLocaleString("es-CL")
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            "$" + service.unit_value
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            service.total_billing.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-success btn-xs',
	                                    href: '/inventario/archivo-final/' + service.final_file_id + '/descargar-acta' },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-download' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', { type: 'checkbox', className: 'form-check-input', checked: service.approve_client, onChange: function onChange(evt) {
	                                    return statusPaymentService(service.service_id, evt);
	                                }, disabled: !canUpdateServices })
	                        )
	                    );
	                }),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'Valor Neto'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'IVA'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        iva.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'Total'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        total.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                )
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DataTable.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DataTable":"DataTable__DataTable___2nulQ","DataTable_tdNameClient":"DataTable__DataTable_tdNameClient___2t9wd","DataTable_tdCeco":"DataTable__DataTable_tdCeco___3RksM","DataTable_tdNameStore":"DataTable__DataTable_tdNameStore___2DBlB","DataTable_tdTotalService":"DataTable__DataTable_tdTotalService___1v7dU","DataTable_thGlosa":"DataTable__DataTable_thGlosa___2WALk","DataTable_thNameStore":"DataTable__DataTable_thNameStore___XZKRt","DataTable_tdFinalTotals":"DataTable__DataTable_tdFinalTotals___ciJLf","DataTable_tdFinalTotalsText":"DataTable__DataTable_tdFinalTotalsText___3clXH"};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OptionRequestOC = exports.OptionRequestServices = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modales = __webpack_require__(1144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionRequestServices = exports.OptionRequestServices = function OptionRequestServices(_ref) {
	    var status = _ref.status,
	        dischargeServices = _ref.dischargeServices,
	        rejectRequest = _ref.rejectRequest,
	        data = _ref.data,
	        perms = _ref.perms;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(ButtonConfirmTotals, {
	            data: data,
	            title: '1.Autorizo solicitud servicios',
	            info: 'Para su conocimiento, enviaremos la información de esta confirmación via email a las casillas de correos definidas.',
	            classBtn: status >= 2 && status != 5 ? 'btn-success' : 'btn-info',
	            glyphicon: status >= 2 && status != 5 ? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time',
	            action: dischargeServices,
	            enabled: status == 1 && data.servicesApprove.length > 0 && perms.approveServices
	        }),
	        _react2.default.createElement(ButtonCancelRequest, {
	            classBtn: 'btn-warning',
	            glyphicon: 'glyphicon glyphicon-ban-circle',
	            action: rejectRequest,
	            enabled: status < 4 && perms.cancelRequest,
	            isServicesApprove: data.servicesApprove.length > 0
	        })
	    );
	};
	
	var OptionRequestOC = exports.OptionRequestOC = function OptionRequestOC(_ref2) {
	    var status = _ref2.status,
	        dischargeOC = _ref2.dischargeOC,
	        assignOC = _ref2.assignOC,
	        data = _ref2.data,
	        perms = _ref2.perms;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(ButtonConfirmTotals, {
	            data: data,
	            title: '2.Autorizo solicitud orden de compra',
	            info: 'Para su conocimiento, enviaremos la información de esta autorización via email a las casillas de correos definidas.',
	            classBtn: status >= 3 && status != 5 ? 'btn-success' : 'btn-info',
	            glyphicon: status >= 3 && status != 5 ? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time',
	            action: dischargeOC,
	            enabled: status == 2 && perms.approveOC
	        }),
	        _react2.default.createElement(ButtonAssignNumberOC, {
	            data: data,
	            title: '3.Asignar orden de compra',
	            info: 'Atención se enviará información a SEI para generar factura',
	            classBtn: status >= 4 && status != 5 ? 'btn-success' : 'btn-info',
	            glyphicon: status >= 4 && status != 5 ? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time',
	            action: assignOC,
	            enabled: status == 3 && perms.attachOC
	        })
	    );
	};
	
	var ButtonConfirmTotals = function ButtonConfirmTotals(_ref3) {
	    var data = _ref3.data,
	        title = _ref3.title,
	        info = _ref3.info,
	        classBtn = _ref3.classBtn,
	        glyphicon = _ref3.glyphicon,
	        action = _ref3.action,
	        enabled = _ref3.enabled;
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: 'btn ' + classBtn,
	                    onClick: showModal,
	                    disabled: !enabled
	                },
	                title,
	                ' ',
	                _react2.default.createElement('span', { className: 'glyphicon ' + glyphicon }),
	                isVisible && _react2.default.createElement(_Modales.ModalConfirmTotals, {
	                    data: data,
	                    title: title,
	                    info: info,
	                    hideModal: hideModal,
	                    action: action
	                })
	            );
	        }
	    );
	};
	
	var ButtonAssignNumberOC = function ButtonAssignNumberOC(_ref4) {
	    var data = _ref4.data,
	        title = _ref4.title,
	        info = _ref4.info,
	        classBtn = _ref4.classBtn,
	        glyphicon = _ref4.glyphicon,
	        action = _ref4.action,
	        enabled = _ref4.enabled;
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: 'btn ' + classBtn,
	                    onClick: showModal,
	                    disabled: !enabled
	                },
	                title,
	                ' ',
	                _react2.default.createElement('span', { className: 'glyphicon ' + glyphicon }),
	                isVisible && _react2.default.createElement(_Modales.ModalAssignNumberOC, {
	                    data: data,
	                    title: title,
	                    info: info,
	                    hideModal: hideModal,
	                    action: action
	                })
	            );
	        }
	    );
	};
	
	var ButtonCancelRequest = function ButtonCancelRequest(_ref5) {
	    var classBtn = _ref5.classBtn,
	        glyphicon = _ref5.glyphicon,
	        action = _ref5.action,
	        enabled = _ref5.enabled,
	        isServicesApprove = _ref5.isServicesApprove;
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: 'btn ' + classBtn,
	                    onClick: showModal,
	                    disabled: !enabled
	                },
	                'Rechazar',
	                ' ',
	                _react2.default.createElement('span', { className: 'glyphicon ' + glyphicon }),
	                isVisible && _react2.default.createElement(_Modales.ModalCancelRequest, {
	                    hideModal: hideModal,
	                    action: action,
	                    isServicesApprove: isServicesApprove
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "OptionRequest.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalAdminEmails = exports.ModalAssignNumberOC = exports.ModalCancelRequest = exports.ModalConfirmTotals = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Modales = __webpack_require__(1145);
	
	var _Modales2 = _interopRequireDefault(_Modales);
	
	var _v = __webpack_require__(638);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _v3 = __webpack_require__(488);
	
	var _v4 = _interopRequireDefault(_v3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTrigger = exports.ModalTrigger = function (_Component) {
	    _inherits(ModalTrigger, _Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = {
	            visible: false
	        };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react.Component);
	
	var ModalConfirmTotals = exports.ModalConfirmTotals = function (_Component2) {
	    _inherits(ModalConfirmTotals, _Component2);
	
	    function ModalConfirmTotals(props) {
	        _classCallCheck(this, ModalConfirmTotals);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalConfirmTotals.__proto__ || Object.getPrototypeOf(ModalConfirmTotals)).call(this, props));
	
	        _this2.state = {
	            continue: false,
	            servicesNotApprove: _this2.props.data.servicesNotApprove
	        };
	        _this2.generate = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.props.action().then(function () {
	                _this2.props.hideModal();
	            }).catch(function (error) {
	                console.log("error");
	            });
	        };
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState({
	                continue: !_this2.state.continue
	            });
	        };
	        _this2.addCommentToService = function (comment, idService) {
	            _v4.default.inv(idService).actualizarObservacion(comment).then(function () {
	                console.log("se ha actualizado el comentario del servicio");
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        };
	        _this2.renderServiceNotApprove = function () {
	            var _this2$props = _this2.props,
	                title = _this2$props.title,
	                hideModal = _this2$props.hideModal;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: _this2.handleSubmit },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _this2.state.servicesNotApprove.map(function (service) {
	                                return _react2.default.createElement(TextAreaModal, {
	                                    service: service,
	                                    key: service.service_id,
	                                    addCommentToService: _this2.addCommentToService
	                                });
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-12 text-right' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'submit', className: 'btn btn-success' },
	                                    'Aceptar'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', className: 'btn btn-warning', onClick: _this2.props.hideModal },
	                                    'Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        };
	        _this2.renderConfirmTotals = function () {
	            var _this2$props2 = _this2.props,
	                data = _this2$props2.data,
	                title = _this2$props2.title,
	                info = _this2$props2.info,
	                hideModal = _this2$props2.hideModal;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Detalle'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.servicesApprove.length + ' de ' + data.cantServices
	                            ),
	                            'Cantidad de servicios aprobados'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Valor neto'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.iva.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Valor IVA'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.total.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Total'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'text',
	                        { className: _Modales2.default.ModalManagementOC_infoMsg },
	                        info
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: function onClick(evt) {
	                                return _this2.generate(evt);
	                            } },
	                        'Autorizar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-warning', onClick: hideModal },
	                        'Cancelar'
	                    )
	                )
	            );
	        };
	        return _this2;
	    }
	
	    _createClass(ModalConfirmTotals, [{
	        key: 'render',
	        value: function render() {
	            var data = this.props.data;
	
	            return data.servicesNotApprove.length > 0 && !this.state.continue ? this.renderServiceNotApprove() : this.renderConfirmTotals();
	        }
	    }]);
	
	    return ModalConfirmTotals;
	}(_react.Component);
	
	var ModalCancelRequest = exports.ModalCancelRequest = function (_Component3) {
	    _inherits(ModalCancelRequest, _Component3);
	
	    function ModalCancelRequest(props) {
	        _classCallCheck(this, ModalCancelRequest);
	
	        var _this3 = _possibleConstructorReturn(this, (ModalCancelRequest.__proto__ || Object.getPrototypeOf(ModalCancelRequest)).call(this, props));
	
	        _this3.state = {
	            visible: false,
	            blockButton: false,
	            comment: ''
	        };
	        _this3.onChangeComment = function (evt) {
	            var comment = evt.target.value;
	            _this3.setState({ comment: comment });
	        };
	        _this3.handleSubmit = function (evt) {
	            _this3.setState({ blockButton: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this3.props.action(_this3.state.comment).then(function () {
	                _this3.setState({ blockButton: false });
	                _this3.props.hideModal();
	            }).catch(function (error) {
	                console.log(error);
	            });
	        };
	        _this3.renderWithServicesApprove = function () {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: _this3.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Rechazar solicitud orden de compra'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'text',
	                            { className: _Modales2.default.ModalManagementOC_infoMsg },
	                            'No puede rechazar la solicitud si se encuentran servicios tickeados'
	                        )
	                    )
	                )
	            );
	        };
	        _this3.normalRender = function () {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: _this3.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Rechazar solicitud orden de compra'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: _this3.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-12' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Debe indicar los motivos de su rechazo'
	                                    ),
	                                    _react2.default.createElement('textarea', { className: 'form-control', placeholder: 'Indique aqu\xED los motivos por el cual rechaza esta petici\xF3n',
	                                        value: _this3.state.comment,
	                                        onChange: function onChange(evt) {
	                                            return _this3.onChangeComment(evt);
	                                        },
	                                        required: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 text-right' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-success', disabled: _this3.state.bloqueado },
	                                        'Aceptar'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: 'btn btn-warning', onClick: _this3.props.hideModal },
	                                        'Cancelar'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'text',
	                        { className: _Modales2.default.ModalManagementOC_infoMsg },
	                        'Para su informaci\xF3n sus motivos ser\xE1n enviados via email a las partes implicadas'
	                    )
	                )
	            );
	        };
	        return _this3;
	    }
	
	    _createClass(ModalCancelRequest, [{
	        key: 'render',
	        value: function render() {
	            return this.props.isServicesApprove ? this.renderWithServicesApprove() : this.normalRender();
	        }
	    }]);
	
	    return ModalCancelRequest;
	}(_react.Component);
	
	var ModalAssignNumberOC = exports.ModalAssignNumberOC = function (_Component4) {
	    _inherits(ModalAssignNumberOC, _Component4);
	
	    function ModalAssignNumberOC(props) {
	        _classCallCheck(this, ModalAssignNumberOC);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalAssignNumberOC.__proto__ || Object.getPrototypeOf(ModalAssignNumberOC)).call(this, props));
	
	        _this4.state = {
	            visible: false,
	            blockButton: false,
	            numberOC: '',
	            filePDF: null
	        };
	        _this4.onChangeNumberOC = function (evt) {
	            var numberOC = evt.target.value;
	            _this4.setState({ numberOC: numberOC });
	        };
	        _this4.onChangeFile = function (evt) {
	            var file = evt.target.files[0];
	            _this4.setState({ filePDF: file });
	        };
	        _this4.handleSubmit = function (evt) {
	            _this4.setState({ blockButton: true });
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this4.props.action(_this4.state.numberOC, _this4.state.filePDF).then(function () {
	                _this4.setState({ blockButton: false });
	                _this4.props.hideModal();
	            }).catch(function (error) {
	                console.log(error);
	            });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalAssignNumberOC, [{
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props = this.props,
	                data = _props.data,
	                title = _props.title;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Detalle'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.servicesApprove.length + ' de ' + data.cantServices
	                            ),
	                            'Cantidad de servicios aprobados'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Valor neto'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.iva.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Valor IVA'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'badge' },
	                                data.total.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                            ),
	                            'Total'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: this.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'N\xFAmero orden de compra generado'
	                                    ),
	                                    _react2.default.createElement('input', { type: 'number', className: 'form-control', placeholder: 'N\xFAmero orden compra',
	                                        value: this.state.numeroOC,
	                                        onChange: function onChange(evt) {
	                                            return _this5.onChangeNumberOC(evt);
	                                        },
	                                        required: true
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-6' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Ajdunte PDF orden de compra'
	                                    ),
	                                    _react2.default.createElement('input', { type: 'file', className: 'form-control-file', onChange: function onChange(evt) {
	                                            return _this5.onChangeFile(evt);
	                                        }, required: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 text-right' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-success', disabled: this.state.bloqueado },
	                                        'Aceptar'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: 'btn btn-warning', onClick: this.props.hideModal },
	                                        'Cancelar'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAssignNumberOC;
	}(_react.Component);
	
	var ModalAdminEmails = exports.ModalAdminEmails = function (_Component5) {
	    _inherits(ModalAdminEmails, _Component5);
	
	    function ModalAdminEmails(props) {
	        _classCallCheck(this, ModalAdminEmails);
	
	        var _this6 = _possibleConstructorReturn(this, (ModalAdminEmails.__proto__ || Object.getPrototypeOf(ModalAdminEmails)).call(this, props));
	
	        _this6.state = {
	            emailsBilling: [],
	            newEmail: '',
	            newName: ''
	        };
	        _this6.getEmailsBilling = function () {
	            _v2.default.client(_this6.props.idClient).getEmailsBilling().then(function (response) {
	                _this6.setState({
	                    emailsBilling: response,
	                    newEmail: '',
	                    newName: ''
	                });
	            }).catch(function (err) {});
	        };
	        _this6.addNewEmail = function () {
	            if (_this6.state.newEmail == '' || _this6.state.newName == '') return;
	            _v2.default.client(_this6.props.idClient).addEmailBilling({
	                email: _this6.state.newEmail,
	                name: _this6.state.newName
	            }).then(_this6.getEmailsBilling).catch(function (meh) {});
	        };
	        _this6.deleteEmail = function (idEmail) {
	            _v2.default.client(_this6.props.idClient).deleteEmailBilling(idEmail).then(_this6.getEmailsBilling).catch(function (meh) {});
	        };
	        _this6.onNewEmail = function (evt) {
	            var email = evt.target.value;
	            _this6.setState({ newEmail: email });
	        };
	        _this6.onNewName = function (evt) {
	            var name = evt.target.value;
	            _this6.setState({ newName: name });
	        };
	        return _this6;
	    }
	
	    _createClass(ModalAdminEmails, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getEmailsBilling();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Administra tus destinatarios'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        { className: _Modales2.default.ModalManagementOC_infoMsg },
	                        'Atenci\xF3n, las casillas que aparezcan en este listado ser\xE1n incluidas como destinatarios en los procesos de correos automatizados.'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: _Modales2.default.ModalManagementOC_fixedWidth },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Correo'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: _Modales2.default.ModalManagementOC_fixedWidth },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Nombre'
	                                )
	                            )
	                        ),
	                        this.state.emailsBilling.map(function (email) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: email.idEmail, className: 'list-group-item' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _Modales2.default.ModalManagementOC_fixedWidth },
	                                    email.email
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _Modales2.default.ModalManagementOC_fixedWidth },
	                                    email.name
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-xs btn-danger pull-right',
	                                        onClick: function onClick() {
	                                            return _this7.deleteEmail(email.idEmail);
	                                        }
	                                    },
	                                    'Eliminar'
	                                )
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'list-group-item' },
	                            _react2.default.createElement('input', { type: 'text',
	                                value: this.state.newEmail,
	                                onChange: this.onNewEmail,
	                                required: true,
	                                onKeyDown: function onKeyDown(evt) {
	                                    if (evt.keyCode == 13) _this7.refName.focus();
	                                },
	                                placeholder: 'nombre@email.com'
	                            }),
	                            _react2.default.createElement('input', { type: 'text',
	                                value: this.state.newName,
	                                ref: function ref(_ref) {
	                                    return _this7.refName = _ref;
	                                },
	                                onChange: this.onNewName,
	                                required: true,
	                                onKeyDown: function onKeyDown(evt) {
	                                    if (evt.keyCode == 13) _this7.addNewEmail();
	                                },
	                                placeholder: 'Juan Correa'
	                            }),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-xs btn-success pull-right',
	                                    onClick: this.addNewEmail
	                                },
	                                'Agregar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalAdminEmails;
	}(_react.Component);
	
	var TextAreaModal = function (_Component6) {
	    _inherits(TextAreaModal, _Component6);
	
	    function TextAreaModal(props) {
	        _classCallCheck(this, TextAreaModal);
	
	        var _this8 = _possibleConstructorReturn(this, (TextAreaModal.__proto__ || Object.getPrototypeOf(TextAreaModal)).call(this, props));
	
	        _this8.state = {
	            clientComment: _this8.props.service.client_comment
	        };
	        _this8.onChangeComment = function (evt) {
	            var comment = evt.target.value;
	            _this8.setState({ clientComment: comment });
	        };
	        _this8.onSaveComment = function () {
	            _this8.props.addCommentToService(_this8.state.clientComment, _this8.props.service.service_id);
	        };
	        return _this8;
	    }
	
	    _createClass(TextAreaModal, [{
	        key: 'render',
	        value: function render() {
	            var _this9 = this;
	
	            var service = this.props.service;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    service.store_ceco + ' ' + service.store_name
	                ),
	                _react2.default.createElement('textarea', {
	                    className: 'form-control',
	                    value: this.state.clientComment,
	                    onChange: function onChange(evt) {
	                        return _this9.onChangeComment(evt);
	                    },
	                    onBlur: this.onSaveComment,
	                    placeholder: 'Indique motivo por el cual no aprueba este servicio',
	                    required: true
	                })
	            );
	        }
	    }]);
	
	    return TextAreaModal;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ModalManagementOC":"Modales__ModalManagementOC___2CiEc","ModalManagementOC_infoMsg":"Modales__ModalManagementOC_infoMsg___1NXL3","ModalManagementOC_button_accept":"Modales__ModalManagementOC_button_accept___v4-Q9","ModalManagementOC_fixedWidth":"Modales__ModalManagementOC_fixedWidth___B0ktH"};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BillingServices = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(638);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _ManagementOC = __webpack_require__(1138);
	
	var css = _interopRequireWildcard(_ManagementOC);
	
	var _DataTable = __webpack_require__(1147);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillingServices = exports.BillingServices = function (_Component) {
	    _inherits(BillingServices, _Component);
	
	    function BillingServices(props) {
	        _classCallCheck(this, BillingServices);
	
	        var _this = _possibleConstructorReturn(this, (BillingServices.__proto__ || Object.getPrototypeOf(BillingServices)).call(this, props));
	
	        _this.state = {
	            services: [],
	            totalNeto: 0,
	            iva: 0,
	            total: 0,
	            month: _this.props.monthsDate[0]['value'],
	            idClient: 5
	        };
	        _this.fetchServices = function () {
	            _v2.default.billing().getServicesByMonthAndClient(_this.state.idClient, _this.state.month).then(function (response) {
	                _this.setState({
	                    services: response.services,
	                    totalNeto: response.total_neto,
	                    iva: response.iva,
	                    total: response.total
	                });
	            }).catch(function (err) {});
	        };
	        _this.onChangeMonth = function (evt) {
	            _this.setState({
	                month: evt.target.value
	            }, function () {
	                return _this.fetchServices();
	            });
	        };
	        _this.onChangeClient = function (evt) {
	            _this.setState({
	                idClient: evt.target.value
	            }, function () {
	                return _this.fetchServices();
	            });
	        };
	        return _this;
	    }
	
	    _createClass(BillingServices, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fetchServices();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-header row ' + css.headerManagementOC },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-9' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-th-list' }),
	                            ' Servicios grupo Salcobrand'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 ' + css.divExcelButton },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-success btn-md pull-right',
	                                disabled: 'true' },
	                            'Exportar ',
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-export' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(SelectClient, {
	                    idClient: this.state.idClient,
	                    onChangeClient: this.onChangeClient
	                }),
	                _react2.default.createElement(SelectMonth, {
	                    month: this.state.month,
	                    onChangeMonth: this.onChangeMonth,
	                    monthsDate: this.props.monthsDate
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-primary' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Servicios realizados'
	                            ),
	                            _react2.default.createElement(_DataTable.TableServices, {
	                                services: this.state.services,
	                                totalNeto: this.state.totalNeto,
	                                iva: this.state.iva,
	                                total: this.state.total
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BillingServices;
	}(_react.Component);
	
	BillingServices.propTypes = {
	    monthsDate: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired
	};
	var SelectMonth = function SelectMonth(_ref) {
	    var month = _ref.month,
	        onChangeMonth = _ref.onChangeMonth,
	        monthsDate = _ref.monthsDate;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2 form-group' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label' },
	            'Mes'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: month,
	                onChange: onChangeMonth },
	            '>',
	            monthsDate.map(function (month, index) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: index, value: month['value'] },
	                    '' + month['text']
	                );
	            })
	        )
	    );
	};
	
	var SelectClient = function SelectClient(_ref2) {
	    var idClient = _ref2.idClient,
	        onChangeClient = _ref2.onChangeClient;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2 form-group' },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label' },
	            'Cliente'
	        ),
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: idClient,
	                onChange: onChangeClient },
	            '>',
	            _react2.default.createElement(
	                'option',
	                { key: 1, value: 1 },
	                'PUC'
	            ),
	            _react2.default.createElement(
	                'option',
	                { key: 5, value: 5 },
	                'FSB'
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "BillingServices.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableServices = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DataTable = __webpack_require__(1148);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _constants = __webpack_require__(1139);
	
	var _Modales = __webpack_require__(1149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableServices = exports.TableServices = function TableServices(_ref) {
	    var services = _ref.services,
	        totalNeto = _ref.totalNeto,
	        iva = _ref.iva,
	        total = _ref.total;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped ' + _DataTable2.default.DataTable },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Fecha Servicio'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Cliente'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CECO'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: _DataTable2.default.DataTable_thNameStore },
	                        'Local'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Regi\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Comuna'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Und Contadas'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Valor Unidad'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Total'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Solicitud'
	                    ),
	                    _react2.default.createElement('th', { className: _DataTable2.default.DataTable_thCommentClient })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                services.map(function (service) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: service.service_id },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.service_date
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdNameClient },
	                            service.client_name
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdCeco },
	                            service.store_ceco
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdNameStore },
	                            service.store_name
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.store_region
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.store_comuna
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            service.units_counted.toLocaleString("es-CL")
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            "$" + service.unit_value
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: _DataTable2.default.DataTable_tdTotalService },
	                            service.total_billing.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.pub_billing_req_id ? _react2.default.createElement(ButtonRequestBilling, {
	                                publicIdBillingRequest: service.pub_billing_req_id,
	                                number: service.billing_request_num,
	                                className: _constants.LABEL_STATUS_REQUEST[service.billing_request_status]
	                            }) : _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-xs btn-warning' },
	                                'No Enviada'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            service.client_comment === '' ? null : _react2.default.createElement(ButtonCommentClient, {
	                                service: service
	                            })
	                        )
	                    );
	                }),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'Neto Aprobado'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'IVA Aprobado'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        iva.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'success' },
	                    _react2.default.createElement('td', { colSpan: '7' }),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotalsText },
	                        'Total Aprobado'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: _DataTable2.default.DataTable_tdFinalTotals },
	                        total.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
	                    ),
	                    _react2.default.createElement('td', { colSpan: '2' })
	                )
	            )
	        )
	    );
	};
	var ButtonRequestBilling = function ButtonRequestBilling(_ref2) {
	    var publicIdBillingRequest = _ref2.publicIdBillingRequest,
	        number = _ref2.number,
	        className = _ref2.className;
	
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-xs ' + className, href: '/billing/oc/management?id_billing_request=' + publicIdBillingRequest, target: '_blank' },
	        number
	    );
	};
	var ButtonCommentClient = function ButtonCommentClient(_ref3) {
	    var service = _ref3.service;
	
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: 'btn btn-warning',
	                    onClick: showModal
	                },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-inbox' }),
	                isVisible && _react2.default.createElement(_Modales.ModalCommentClient, {
	                    service: service,
	                    hideModal: hideModal
	                })
	            );
	        }
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DataTable.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DataTable":"DataTable__DataTable___QceWc","DataTable_tdNameClient":"DataTable__DataTable_tdNameClient___13WW8","DataTable_tdCeco":"DataTable__DataTable_tdCeco___DVhLI","DataTable_tdNameStore":"DataTable__DataTable_tdNameStore___3300o","DataTable_tdTotalService":"DataTable__DataTable_tdTotalService___3vJTS","DataTable_thGlosa":"DataTable__DataTable_thGlosa___3_Pwh","DataTable_thNameStore":"DataTable__DataTable_thNameStore___2z9DK","DataTable_thCommentClient":"DataTable__DataTable_thCommentClient___2WDLC","DataTable_tdFinalTotals":"DataTable__DataTable_tdFinalTotals___1fA2W","DataTable_tdFinalTotalsText":"DataTable__DataTable_tdFinalTotalsText___3XYqX"};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalCommentClient = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTrigger = exports.ModalTrigger = function (_Component) {
	    _inherits(ModalTrigger, _Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = {
	            visible: false
	        };
	        _this.show = function () {
	            return _this.setState({ visible: true });
	        };
	        _this.hide = function () {
	            return _this.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react.Component);
	
	var ModalCommentClient = exports.ModalCommentClient = function ModalCommentClient(_ref) {
	    var service = _ref.service,
	        hideModal = _ref.hideModal;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Comentario de cliente, motivo de rechazo'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    service.store_ceco + ' ' + service.store_name
	                ),
	                _react2.default.createElement('textarea', { readonly: true,
	                    className: 'form-control',
	                    value: service.client_comment
	
	                })
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReporteInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modales = __webpack_require__(1151);
	
	var _TablaReportes = __webpack_require__(1153);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ReporteInventario = __webpack_require__(1155);
	
	var css = _interopRequireWildcard(_ReporteInventario);
	
	var _TarifaNomina = __webpack_require__(1156);
	
	var _TarifaNomina2 = _interopRequireDefault(_TarifaNomina);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	var ReporteInventario = exports.ReporteInventario = function (_React$Component) {
	    _inherits(ReporteInventario, _React$Component);
	
	    function ReporteInventario(props) {
	        _classCallCheck(this, ReporteInventario);
	
	        var _this = _possibleConstructorReturn(this, (ReporteInventario.__proto__ || Object.getPrototypeOf(ReporteInventario)).call(this, props));
	
	        _this.state = {
	            idInventario: _this.props.idInventario,
	            nomina: _this.props.nomina,
	            inventario: [],
	            reportes: [],
	            totalReportes: 0,
	            dotacion: 0
	        };
	        _this.fetchInventario = function () {
	            _v2.default.api().misInventariosDia(_this.state.idInventario).then(function (resp) {
	                _this.setState({ inventario: resp.result[0] });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this.fetchReportes = function () {
	            _v2.default.api().misReportesInventario(_this.state.idInventario).then(function (resp) {
	                _this.setState({
	                    reportes: resp.result,
	                    dotacion: resp.result[0] ? resp.result[0].dotacion : 0,
	                    totalReportes: resp.result.length
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(ReporteInventario, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                nuevaMarca: function nuevaMarca(datos) {
	                    var request = _v2.default.api().misReportesNuevo(datos.idInventario, datos.tipo, datos.hora, datos.dotacion, datos.avance, datos.error, datos.comentario, datos.auditoria, datos.idDescripcionReportesIG, datos.idDescripcionReportesLocal);
	                    request.then(function (resp) {
	                        _this2.fetchReportes();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    return request;
	                },
	                descripcionReportes: function descripcionReportes(tipo, subTipo) {
	                    var request = _v2.default.api().descripcionReportes(tipo, subTipo);
	                    request.then(function (resp) {
	                        _this2.fetchReportes();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    return request;
	                },
	                nuevoAnexoMarca: function nuevoAnexoMarca(idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance) {
	                    var request = _v2.default.api().nuevoAnexoMarca(idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance);
	                    request.then(function (resp) {
	                        _this2.fetchReportes();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                    return request;
	                },
	                updateNomina: function updateNomina(nomina) {
	                    _this2.setState({ nomina: nomina });
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchInventario();
	            this.fetchReportes();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-sm-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-primary' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Detalle Inventario'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form-group-padding') },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-4 control-label' },
	                                            'Fecha Programada:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.fechaProgramada
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-4 control-label' },
	                                            'Turno:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.jornada
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-2 control-label' },
	                                            'Hr. Llegada:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.hrLider
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-2 control-label' },
	                                            'Hr. Llegada Equipo:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.hrEquipo
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-2 control-label' },
	                                            'Dotaci\xF3n:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.dotacion
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-2 control-label' },
	                                            'Stock Te\xF3rico:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.stockTeorico
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-7 col-sm-2 control-label' },
	                                            'Cliente:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-5 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.nombreCliente
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-2 col-sm-2 control-label' },
	                                            'Local:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-10 col-sm-2 ", 'label-text') },
	                                            this.state.inventario.nombreLocal
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 col-sm-12' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-3 col-sm-2 control-label' },
	                                            'Direcci\xF3n:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-6 col-sm-6 ", 'label-text') },
	                                            this.state.inventario.direccionLocal
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 col-sm-12' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-3 col-sm-1 control-label' },
	                                            'Regi\xF3n:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-3 col-sm-1 ", 'label-text') },
	                                            this.state.inventario.region
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-3 col-sm-1 control-label' },
	                                            'Provincia:'
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: cx("col-md-3 col-sm-3 ", 'label-text') },
	                                            this.state.inventario.provincia
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-sm-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-info' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-heading' },
	                            'Mis Reportes'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(_TablaReportes.TablaReportes, {
	                                reportes: this.state.reportes
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: cx("col-md-12 col-sm-12", 'center-btn') },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginRight: 10 } },
	                        _react2.default.createElement(_TarifaNomina2.default, { nomina: this.state.nomina }),
	                        ' '
	                    ),
	                    _react2.default.createElement(BotonReporte, {
	                        idInventario: this.state.idInventario,
	                        totalReportes: this.state.totalReportes,
	                        dotacion: this.state.dotacion
	                    }),
	                    _react2.default.createElement(
	                        'a',
	                        { className: cx("btn btn-default btn-md", 'btn-cancel'), href: '/' },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReporteInventario;
	}(_react2.default.Component);
	
	var BotonReporte = function BotonReporte(_ref) {
	    var idInventario = _ref.idInventario,
	        totalReportes = _ref.totalReportes,
	        dotacion = _ref.dotacion;
	
	    if (totalReportes == 0) {
	        return _react2.default.createElement(
	            _Modales.ModalTrigger,
	            null,
	            function (isVisible, showModal, hideModal) {
	                return _react2.default.createElement(
	                    'button',
	                    { className: cx("btn btn-md btn-primary", 'btn-reporte'), onClick: showModal },
	                    'Reporte Inicial',
	                    isVisible && _react2.default.createElement(_Modales.ModalReporteInicial, {
	                        hideModal: hideModal,
	                        idInventario: idInventario
	                    })
	                );
	            }
	        );
	    } else if (totalReportes == 1) {
	        return _react2.default.createElement(
	            _Modales.ModalTrigger,
	            null,
	            function (isVisible, showModal, hideModal) {
	                return _react2.default.createElement(
	                    'button',
	                    { className: cx("btn btn-md btn-primary", 'btn-reporte'), onClick: showModal },
	                    'Reportar Avance',
	                    isVisible && _react2.default.createElement(_Modales.ModalReporteAvance, {
	                        hideModal: hideModal,
	                        idInventario: idInventario,
	                        dotacion: dotacion
	                    })
	                );
	            }
	        );
	    } else if (totalReportes == 2) {
	        return _react2.default.createElement(
	            _Modales.ModalTrigger,
	            null,
	            function (isVisible, showModal, hideModal) {
	                return _react2.default.createElement(
	                    'button',
	                    { className: cx("btn btn-md btn-primary", 'btn-reporte'), onClick: showModal },
	                    'Reporte Final',
	                    isVisible && _react2.default.createElement(_Modales.ModalReporteFinal, {
	                        hideModal: hideModal,
	                        idInventario: idInventario,
	                        dotacion: dotacion
	                    })
	                );
	            }
	        );
	    } else {
	        return _react2.default.createElement(
	            'button',
	            { className: cx("btn btn-md btn-default", 'btn-reporte') },
	            'Reportes Finalizados'
	        );
	    }
	};
	
	ReporteInventario.childContextTypes = {
	    nuevaMarca: PropTypes.func,
	    descripcionReportes: PropTypes.func,
	    nuevoAnexoMarca: PropTypes.func,
	    updateNomina: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ReporteInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalReporteFinal = exports.ModalReporteAvance = exports.ModalReporteInicial = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Modales = __webpack_require__(1152);
	
	var css = _interopRequireWildcard(_Modales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var cx = _bind2.default.bind(css);
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalReporteInicial = exports.ModalReporteInicial = function (_React$Component2) {
	    _inherits(ModalReporteInicial, _React$Component2);
	
	    function ModalReporteInicial(props) {
	        _classCallCheck(this, ModalReporteInicial);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalReporteInicial.__proto__ || Object.getPrototypeOf(ModalReporteInicial)).call(this, props));
	
	        _this2.state = {
	            marcas: {
	                idInventario: _this2.props.idInventario,
	                tipo: 1,
	                hora: '',
	                dotacion: 0,
	                avance: 0,
	                error: 0,
	                comentario: '',
	                auditoria: 0,
	                idDescripcionReportesIG: null,
	                idDescripcionReportesLocal: null
	            },
	            error: '',
	            enviando: false,
	            descripcionesIG: [],
	            descripcionesLocal: [],
	            defaulttext: "",
	            rows: 2
	        };
	        _this2.onHoraChange = function (evt) {
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { hora: evt.target.value }) });
	        };
	        _this2.onDotacionChange = function (evt) {
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { dotacion: evt.target.value }) });
	        };
	        _this2.onComentarioIGChange = function (evt) {
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { idDescripcionReportesIG: evt.target.value }) });
	        };
	        _this2.onComentarioLocalChange = function (evt) {
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { idDescripcionReportesLocal: evt.target.value }) });
	        };
	        _this2.handleChange = function (evt) {
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { comentario: evt.target.value }) });
	            var currentRows = evt.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                _this2.setState({ rows: currentRows });
	            }
	        };
	        _this2.horaInicial = function () {
	            var horas = new Date().getHours();
	            var minutos = new Date().getMinutes();
	            if (horas < 10) horas = '0' + horas;
	
	            if (minutos < 10) minutos = '0' + minutos;
	
	            _this2.setState({ marcas: Object.assign({}, _this2.state.marcas, { hora: horas + ':' + minutos }) });
	        };
	        _this2.fetchDescripcionesReportes = function () {
	            _this2.context.descripcionReportes(1, 1).then(function (resp) {
	                console.log(resp);
	                _this2.setState({ descripcionesIG: resp.result });
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            _this2.context.descripcionReportes(1, 2).then(function (resp) {
	                _this2.setState({ descripcionesLocal: resp.result });
	                console.log(resp);
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this2.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this2.setState({ enviando: true });
	            if (_this2.state.marcas.hora && _this2.state.marcas.dotacion > 0 && _this2.state.marcas.idDescripcionReportesLocal && _this2.state.marcas.idDescripcionReportesIG) {
	                _this2.context.nuevaMarca(_this2.state.marcas).then(function (resp) {
	                    _this2.props.hideModal();
	                }).catch(function (err) {
	                    console.log(err);
	                    _this2.setState({
	                        error: err.data.error,
	                        enviando: false
	                    });
	                });
	            } else {
	                _this2.setState({
	                    error: 'Complete todos los campos.',
	                    enviando: false
	                });
	            }
	        };
	        return _this2;
	    }
	
	    _createClass(ModalReporteInicial, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.horaInicial();
	            this.fetchDescripcionesReportes();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Reportar Inicio'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        this.state.error && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger', role: 'alert' },
	                            this.state.error
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'col-md-12 col-sm-12 form-horizontal', action: '', onSubmit: this.state.enviando ? null : this.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Hora'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    _react2.default.createElement('input', { type: 'time', className: 'form-control', placeholder: 'Hora',
	                                        value: this.state.marcas.hora, onChange: this.onHoraChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Dotaci\xF3n'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    _react2.default.createElement('input', { type: 'number', min: 0, className: 'form-control', placeholder: 'Dotaci\xF3n',
	                                        value: this.state.marcas.dotacion, onChange: this.onDotacionChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentario IG'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(SelectorComentarioPrimero, {
	                                        idComentario: this.state.marcas.idDescripcionReportesIG,
	                                        comentarioChange: this.onComentarioIGChange,
	                                        comentarios: this.state.descripcionesIG
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentario Local'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(SelectorComentarioPrimero, {
	                                        idComentario: this.state.marcas.idDescripcionReportesLocal,
	                                        comentarioChange: this.onComentarioLocalChange,
	                                        comentarios: this.state.descripcionesLocal
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentarios Adicionales'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement('textarea', {
	                                        ref: function ref(text) {
	                                            return _this3.textArea = text;
	                                        },
	                                        onChange: this.handleChange,
	                                        value: this.state.marcas.comentario,
	                                        maxLength: 500,
	                                        rows: this.state.rows,
	                                        type: 'text',
	                                        name: 'comentarios'
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-10 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc'), type: 'submit', disabled: this.state.enviando },
	                                    this.state.enviando ? 'Enviando Reporte' : 'Enviar Reporte'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: cx("col-md-4 btn btn-block btn-default", 'btn-50-perc'), href: '#', onClick: this.state.enviando ? null : this.props.hideModal },
	                                    'Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReporteInicial;
	}(_react2.default.Component);
	
	ModalReporteInicial.contextTypes = {
	    nuevaMarca: PropTypes.func,
	    descripcionReportes: PropTypes.func
	};
	
	var ModalReporteAvance = exports.ModalReporteAvance = function (_React$Component3) {
	    _inherits(ModalReporteAvance, _React$Component3);
	
	    function ModalReporteAvance(props) {
	        _classCallCheck(this, ModalReporteAvance);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalReporteAvance.__proto__ || Object.getPrototypeOf(ModalReporteAvance)).call(this, props));
	
	        _this4.state = {
	            marcas: {
	                idInventario: _this4.props.idInventario,
	                tipo: 2,
	                hora: '',
	                dotacion: _this4.props.dotacion,
	                avance: 0,
	                error: 0,
	                comentario: '',
	                auditoria: 0,
	                idDescripcionReportesIG: null,
	                idDescripcionReportesLocal: null
	            },
	            error: '',
	            enviando: false,
	            warningAI: '',
	            warningError: '',
	            defaulttext: "",
	            rows: 2
	        };
	        _this4.onHoraChange = function (evt) {
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { hora: evt.target.value }) });
	        };
	        _this4.onAvanceChange = function (evt) {
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { avance: evt.target.value }) });
	        };
	        _this4.onErrorChange = function (evt) {
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { error: evt.target.value }) });
	        };
	        _this4.onAuditoriaChange = function (evt) {
	            _this4.setState({
	                warningAI: evt.target.value < 25 ? 'Insuficiente' : '',
	                warningError: evt.target.value < 25 ? 'No representativo' : ''
	            });
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { auditoria: evt.target.value }) });
	        };
	        _this4.horaInicial = function () {
	            var horas = new Date().getHours();
	            var minutos = new Date().getMinutes();
	            if (horas < 10) horas = '0' + horas;
	
	            if (minutos < 10) minutos = '0' + minutos;
	
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { hora: horas + ':' + minutos }) });
	        };
	        _this4.handleChange = function (evt) {
	            _this4.setState({ marcas: Object.assign({}, _this4.state.marcas, { comentario: evt.target.value }) });
	            var currentRows = evt.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                _this4.setState({ rows: currentRows });
	            }
	        };
	        _this4.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this4.setState({ enviando: true });
	            if (_this4.state.marcas.hora && _this4.state.marcas.avance && _this4.state.marcas.error && _this4.state.marcas.auditoria) {
	                if (_this4.state.marcas.error > 4 || _this4.state.marcas.avance > 100 || _this4.state.marcas.auditoria > 100) {
	                    _this4.setState({
	                        error: 'Existen campos con error.',
	                        enviando: false
	                    });
	                } else {
	                    _this4.context.nuevaMarca(_this4.state.marcas).then(function (resp) {
	                        _this4.props.hideModal();
	                    }).catch(function (err) {
	                        _this4.setState({
	                            error: err.data.error,
	                            enviando: false
	                        });
	                    });
	                }
	            } else {
	                _this4.setState({
	                    error: 'Complete todos los campos.',
	                    enviando: false
	                });
	            }
	        };
	        return _this4;
	    }
	
	    _createClass(ModalReporteAvance, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.horaInicial();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Reportar Avance'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        this.state.error && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger', role: 'alert' },
	                            this.state.error
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'col-md-12 col-sm-12 form-horizontal', action: '', onSubmit: this.state.enviando ? null : this.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Hora'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', { type: 'time', className: 'form-control', placeholder: 'Hora',
	                                        value: this.state.marcas.hora, onChange: this.onHoraChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Avance'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', { type: 'number', step: 0.1, max: 100, min: 0, className: 'form-control', placeholder: 'Avance',
	                                        value: this.state.marcas.avance, onChange: this.onAvanceChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Auditoria'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', { type: 'number', step: 0.1, max: 100, min: 0, className: 'form-control', placeholder: 'Auditoria',
	                                        value: this.state.marcas.auditoria, onChange: this.onAuditoriaChange
	                                    }),
	                                    this.state.warningAI && _react2.default.createElement(
	                                        'div',
	                                        { className: cx("alert alert-warning", 'warning-custom'), role: 'alert' },
	                                        this.state.warningAI
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Error'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement('input', { type: 'number', step: 0.1, max: 4, min: 0, className: 'form-control', placeholder: 'Error',
	                                        value: this.state.marcas.error, onChange: this.onErrorChange
	                                    }),
	                                    this.state.warningError && _react2.default.createElement(
	                                        'div',
	                                        { className: cx("alert alert-warning", 'warning-custom'), role: 'alert' },
	                                        this.state.warningError
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentarios Adicionales'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement('textarea', {
	                                        ref: function ref(text) {
	                                            return _this5.textArea = text;
	                                        },
	                                        onChange: this.handleChange,
	                                        value: this.state.marcas.comentario,
	                                        maxLength: 500,
	                                        rows: this.state.rows,
	                                        type: 'text',
	                                        name: 'comentarios'
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-10 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc'), type: 'submit', disabled: this.state.enviando },
	                                    this.state.enviando ? 'Enviando Reporte' : 'Enviar Reporte'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: cx("col-md-4 btn btn-block btn-default", 'btn-50-perc'), href: '#', onClick: this.state.enviando ? null : this.props.hideModal },
	                                    'Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReporteAvance;
	}(_react2.default.Component);
	
	ModalReporteAvance.contextTypes = {
	    nuevaMarca: PropTypes.func,
	    descripcionReportes: PropTypes.func
	};
	
	var ModalReporteFinal = exports.ModalReporteFinal = function (_React$Component4) {
	    _inherits(ModalReporteFinal, _React$Component4);
	
	    function ModalReporteFinal(props) {
	        _classCallCheck(this, ModalReporteFinal);
	
	        var _this6 = _possibleConstructorReturn(this, (ModalReporteFinal.__proto__ || Object.getPrototypeOf(ModalReporteFinal)).call(this, props));
	
	        _this6.state = {
	            marcas: {
	                idInventario: _this6.props.idInventario,
	                tipo: 3,
	                hora: '',
	                dotacion: _this6.props.dotacion,
	                avance: 0,
	                error: 0,
	                comentario: '',
	                auditoria: 0,
	                idDescripcionReportesIG: null,
	                idDescripcionReportesLocal: null
	            },
	            error: '',
	            enviando: false,
	            descripcionesIG: [],
	            descripcionesCheckList: [],
	            deterioro: false,
	            cancelado: false,
	            cantDeterioros: 1,
	            deterioros: [],
	            defaulttext: "",
	            rows: 2
	        };
	        _this6.createInputDeterioros = function () {
	            var deterioros = [];
	            for (var index = 0; index < _this6.state.cantDeterioros; index++) {
	                deterioros[index] = { id: index, sku: "", cancelado: false };
	            }
	            _this6.setState({ deterioros: deterioros });
	        };
	        _this6.onHoraChange = function (evt) {
	            _this6.setState({ marcas: Object.assign({}, _this6.state.marcas, { hora: evt.target.value }) });
	        };
	        _this6.onComentarioIGChange = function (evt) {
	            _this6.setState({ marcas: Object.assign({}, _this6.state.marcas, { idDescripcionReportesIG: evt.target.value }) });
	        };
	        _this6.onComentarioCheckListChange = function (evt) {
	            _this6.setState({ marcas: Object.assign({}, _this6.state.marcas, { idDescripcionReportesLocal: evt.target.value }) });
	        };
	        _this6.onDeterioroChange = function (evt) {
	            _this6.setState({
	                deterioro: !_this6.state.deterioro,
	                cancelado: false
	            });
	            _this6.createInputDeterioros();
	        };
	        _this6.onCantDeterioroChange = function (evt) {
	            _this6.setState({ cantDeterioros: evt.target.value }, function () {
	                return _this6.createInputDeterioros();
	            });
	        };
	        _this6.onSKUChange = function (evt) {
	            evt.preventDefault();
	            evt.persist();
	            var nuevoDeterioro = _this6.state.deterioros;
	            nuevoDeterioro[evt.target.id].sku = evt.target.value;
	            _this6.setState({ deterioros: nuevoDeterioro });
	        };
	        _this6.onCanceladoChange = function (evt) {
	            _this6.setState({ cancelado: !_this6.state.cancelado });
	        };
	        _this6.horaInicial = function () {
	            var horas = new Date().getHours();
	            var minutos = new Date().getMinutes();
	            if (horas < 10) horas = '0' + horas;
	
	            if (minutos < 10) minutos = '0' + minutos;
	
	            _this6.setState({ marcas: Object.assign({}, _this6.state.marcas, { hora: horas + ':' + minutos }) });
	        };
	        _this6.fetchDescripcionesReportes = function () {
	            _this6.context.descripcionReportes(3, 1).then(function (resp) {
	                console.log(resp);
	                _this6.setState({ descripcionesIG: resp.result });
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            _this6.context.descripcionReportes(3, 2).then(function (resp) {
	                _this6.setState({ descripcionesCheckList: resp.result });
	                console.log(resp);
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this6.handleChange = function (evt) {
	            _this6.setState({ marcas: Object.assign({}, _this6.state.marcas, { comentario: evt.target.value }) });
	            var currentRows = evt.target.scrollHeight / 17;
	            if (currentRows <= 5) {
	                _this6.setState({ rows: currentRows });
	            }
	        };
	        _this6.handleSubmit = function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            _this6.setState({ enviando: true });
	            var skuVacio = false;
	            _this6.state.deterioros.map(function (deterioro) {
	                if (deterioro.sku === "" && _this6.state.deterioro) {
	                    skuVacio = true;
	                }
	            });
	            if (_this6.state.marcas.hora && _this6.state.marcas.idDescripcionReportesIG && _this6.state.marcas.idDescripcionReportesLocal && skuVacio == false) {
	                if (_this6.state.marcas.error > 4 || _this6.state.marcas.avance > 100 || _this6.state.marcas.auditoria > 100) {
	                    _this6.setState({
	                        error: 'Existen campos con error.',
	                        enviando: false
	                    });
	                } else {
	                    _this6.context.nuevaMarca(_this6.state.marcas).then(function (resp) {
	                        _this6.state.deterioros.map(function (deterioro) {
	                            _this6.context.nuevoAnexoMarca(resp.msg, true, deterioro.sku, _this6.state.cancelado, null);
	                        });
	                        _this6.props.hideModal();
	                    }).catch(function (err) {
	                        _this6.setState({
	                            error: err.data,
	                            enviando: false
	                        });
	                    });
	                }
	            } else {
	                _this6.setState({
	                    error: 'Complete todos los campos.',
	                    enviando: false
	                });
	            }
	        };
	        return _this6;
	    }
	
	    _createClass(ModalReporteFinal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.horaInicial();
	            this.fetchDescripcionesReportes();
	            this.createInputDeterioros();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Reportar T\xE9rmino'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        this.state.error && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger', role: 'alert' },
	                            this.state.error
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'col-md-12 col-sm-12 form-horizontal', action: '', onSubmit: this.state.enviando ? null : this.handleSubmit },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Hora'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    _react2.default.createElement('input', { type: 'time', className: 'form-control', placeholder: 'Hora',
	                                        value: this.state.marcas.hora, onChange: this.onHoraChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentario IG'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(SelectorComentarioPrimero, {
	                                        idComentario: this.state.marcas.idDescripcionReportesIG,
	                                        comentarioChange: this.onComentarioIGChange,
	                                        comentarios: this.state.descripcionesIG
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentario CheckList'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement(SelectorComentarioPrimero, {
	                                        idComentario: this.state.marcas.idDescripcionReportesLocal,
	                                        comentarioChange: this.onComentarioCheckListChange,
	                                        comentarios: this.state.descripcionesCheckList
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Comentarios Adicionales'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-10' },
	                                    _react2.default.createElement('textarea', {
	                                        ref: function ref(text) {
	                                            return _this7.textArea = text;
	                                        },
	                                        onChange: this.handleChange,
	                                        value: this.state.marcas.comentario,
	                                        maxLength: 500,
	                                        rows: this.state.rows,
	                                        type: 'text',
	                                        name: 'comentarios'
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                this.state.deterioro && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-2 control-label' },
	                                    'Cant. Deterioros'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    this.state.deterioro && _react2.default.createElement('input', { type: 'number', max: 100, min: 1, className: 'form-control', placeholder: 'Cantidad de Deterioros',
	                                        value: this.state.cantDeterioros, onChange: this.onCantDeterioroChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                this.state.deterioro && this.state.deterioros.map(function (deterioro) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { key: deterioro.id, className: 'col-sm-4' },
	                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'SKU',
	                                            id: deterioro.id, value: deterioro.sku, onChange: _this7.onSKUChange
	                                        })
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12 col-sm-12 form-group", 'form__control-label') },
	                                this.state.deterioro && _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        '\xBFCancelado?'
	                                    ),
	                                    _react2.default.createElement('input', { type: 'checkbox', className: 'form-control', placeholder: 'Cancelado',
	                                        value: this.state.cancelado, onChange: this.onCanceladoChange
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-10 form-group", 'form__control-label') },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc'), type: 'submit', disabled: this.state.enviando },
	                                    this.state.enviando ? 'Enviando Reporte' : 'Enviar Reporte'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: cx("col-md-4 btn btn-block btn-default", 'btn-50-perc'), href: '#', onClick: this.state.enviando ? null : this.props.hideModal },
	                                    'Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalReporteFinal;
	}(_react2.default.Component);
	
	ModalReporteFinal.contextTypes = {
	    nuevaMarca: PropTypes.func,
	    descripcionReportes: PropTypes.func,
	    nuevoAnexoMarca: PropTypes.func
	};
	var SelectorComentarioPrimero = function SelectorComentarioPrimero(_ref) {
	    var idComentario = _ref.idComentario,
	        comentarioChange = _ref.comentarioChange,
	        comentarios = _ref.comentarios;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12 form-group ' },
	        _react2.default.createElement(
	            'select',
	            { className: 'form-control',
	                value: idComentario,
	                onChange: comentarioChange
	            },
	            _react2.default.createElement(
	                'option',
	                { key: "--", value: "--" },
	                'Seleccione comentario'
	            ),
	            comentarios.map(function (comentario) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: comentario.idDescripcionReportes, value: comentario.idDescripcionReportes },
	                    '' + comentario.tituloDescripcion
	                );
	            })
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"Modales__modal___ZXNV6","selectCliente":"Modales__selectCliente___Ydhi_","bloquearUsuario_footer":"Modales__bloquearUsuario_footer___pqO6t","cambiarContrasena_footer":"Modales__cambiarContrasena_footer___b1jfY","editarUsuario_footer":"Modales__editarUsuario_footer___3Dbuc","btn-50-perc":"Modales__btn-50-perc___2OI2C","form__control-label":"Modales__form__control-label___1zmC3","form__error-message":"Modales__form__error-message___AQkZ5","warning-custom":"Modales__warning-custom___3FA5M"};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaReportes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _TablaReportes = __webpack_require__(1154);
	
	var css = _interopRequireWildcard(_TablaReportes);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(css);
	
	var TablaReportes = exports.TablaReportes = function (_React$Component) {
	    _inherits(TablaReportes, _React$Component);
	
	    function TablaReportes() {
	        _classCallCheck(this, TablaReportes);
	
	        return _possibleConstructorReturn(this, (TablaReportes.__proto__ || Object.getPrototypeOf(TablaReportes)).apply(this, arguments));
	    }
	
	    _createClass(TablaReportes, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '150px', marginLeft: '-10px', marginRight: '-10px' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table,
	                            {
	                                height: height,
	                                width: width,
	                                headerHeight: 0,
	                                headerClassName: css.headerColumn,
	                                rowCount: _this2.props.reportes.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.reportes[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'idMarca',
	                                label: '',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowData = _ref4.rowData,
	                                        dataKey = _ref4.dataKey;
	                                    return rowData['tipo'] == 1 ? _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: cx("col-md-12 col-sm-12", 'div-reportes') },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-4 col-sm-4 control-label", 'label-top') },
	                                                'Hora: ',
	                                                rowData['hora']
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-4 col-sm-4 control-label", 'label-top') },
	                                                'Dotaci\xF3n: ',
	                                                rowData['dotacion']
	                                            )
	                                        )
	                                    ) : _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: cx("col-md-12 col-sm-12", 'div-reportes') },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-3 col-sm-2 control-label", 'label-top') },
	                                                'Hr:',
	                                                rowData['hora']
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-3 col-sm-2 control-label", 'label-top') },
	                                                'Avance: ',
	                                                rowData['avance'],
	                                                '%'
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-3 col-sm-2 control-label", 'label-top') },
	                                                'Aud.: ',
	                                                rowData['auditoria'],
	                                                '%'
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: cx("col-md-3 col-sm-2 control-label", 'label-top') },
	                                                'Err: ',
	                                                rowData['error'],
	                                                '%'
	                                            )
	                                        )
	                                    );
	                                },
	                                width: width
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaReportes;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaReportes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerRow":"TablaReportes__headerRow___3rl-n","evenRow":"TablaReportes__evenRow___3x2Dz","oddRow":"TablaReportes__oddRow___3UJm4","headerColumn":"TablaReportes__headerColumn___1ltKQ","headerRowAPI":"TablaReportes__headerRowAPI___15aUm","evenRowAPI":"TablaReportes__evenRowAPI___3I6DI","oddRowAPI":"TablaReportes__oddRowAPI___1CDzD","headerColumnAPI":"TablaReportes__headerColumnAPI___3MWjZ","celdaAPI":"TablaReportes__celdaAPI___1L8Y9","celdaAPILider":"TablaReportes__celdaAPILider___ZwkJZ","label-top":"TablaReportes__label-top___1FjtR","label-bot":"TablaReportes__label-bot___1qFau","div-reportes":"TablaReportes__div-reportes___1o4k8"};

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"label-text":"ReporteInventario__label-text___2bV_q","btn-reporte":"ReporteInventario__btn-reporte___3q_4n","btn-cancel":"ReporteInventario__btn-cancel___10Bp_","div-detalle":"ReporteInventario__div-detalle___1UeAA","center-btn":"ReporteInventario__center-btn___39xPm","form-group-padding":"ReporteInventario__form-group-padding___Gm0OX"};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _tarifas = __webpack_require__(1157);
	
	var _tarifas2 = _interopRequireDefault(_tarifas);
	
	var _Input = __webpack_require__(1158);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modales = __webpack_require__(918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TarifaNomina = function (_Component) {
	    _inherits(TarifaNomina, _Component);
	
	    function TarifaNomina(props) {
	        _classCallCheck(this, TarifaNomina);
	
	        var _this = _possibleConstructorReturn(this, (TarifaNomina.__proto__ || Object.getPrototypeOf(TarifaNomina)).call(this, props));
	
	        _this.state = {};
	
	        _this.updateOperadorNomina = function (operador) {
	            var nomina = _extends({}, _this.props.nomina, {
	                'captadorSEI': _extends({}, _this.props.nomina.captadorSEI, {
	                    'dotacionTitular': _this.props.nomina.captadorSEI.dotacionTitular.map(function (row) {
	                        return row.id == operador.id ? operador : row;
	                    })
	                })
	            });
	            return nomina;
	        };
	
	        _this.onChange = function (e) {
	            var checked = e.target.checked;
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzada(checked).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _extends({}, _this.props.nomina, {
	                "turno_avanzada": checked
	            });
	            _this.context.updateNomina(nomina);
	        };
	
	        _this.onChangeStatusOperador = function (rowOperador, e) {
	            var row_op = _extends({}, rowOperador, {
	                "turno_avanzada": e.target.checked
	            });
	
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzadaOp({
	                "operador_id": rowOperador.id,
	                "turno_avanzada": e.target.checked
	            }).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _this.updateOperadorNomina(row_op);
	            _this.context.updateNomina(nomina);
	        };
	
	        _this.onChangeHrsOperador = function (rowOperador, e) {
	            var row_op = _extends({}, rowOperador, {
	                "turno_avanzada_hrs": e.target.value
	            });
	            _v2.default.nomina(_this.props.nomina.idNomina).changeTurnoAvanzadaOpHrs({
	                "operador_id": rowOperador.id,
	                "turno_avanzada_hrs": e.target.value
	            }).then(function (response) {
	                console.log(response);
	            }).catch(function (error) {
	                console.log(error);
	            });
	            var nomina = _this.updateOperadorNomina(row_op);
	            _this.context.updateNomina(nomina);
	        };
	        return _this;
	    }
	
	    _createClass(TarifaNomina, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var checked = this.props.nomina.turno_avanzada;
	            var titulares = this.props.nomina.captadorSEI.dotacionTitular;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Modales.ModalTrigger,
	                    null,
	                    function (isVisible, showModal, hideModal) {
	                        return _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    display: 'inline-block'
	                                } },
	                            _react2.default.createElement(
	                                'button',
	                                { disabled: !checked, className: 'btn btn-success',
	                                    onClick: showModal },
	                                'Nomina Turno Avanzada'
	                            ),
	                            isVisible && _react2.default.createElement(ModalNomina, {
	                                hideModal: hideModal,
	                                titulares: titulares,
	                                onChangeStatusOperador: _this2.onChangeStatusOperador.bind(_this2),
	                                onChangeHrsOperador: _this2.onChangeHrsOperador.bind(_this2)
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TarifaNomina;
	}(_react.Component);
	
	exports.default = TarifaNomina;
	
	
	TarifaNomina.contextTypes = {
	    updateNomina: _react.PropTypes.func
	};
	
	var ModalNomina = function ModalNomina(_ref) {
	    var hideModal = _ref.hideModal,
	        titulares = _ref.titulares,
	        onChangeStatusOperador = _ref.onChangeStatusOperador,
	        onChangeHrsOperador = _ref.onChangeHrsOperador;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { show: true, onHide: hideModal, className: _tarifas2.default.zIndex },
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                'Turno avanzada'
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'table',
	                    { className: _tarifas2.default.text_xs + " table" },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '#'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Operador'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Captador'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Comuna'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Turno'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Hrs'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        titulares.map(function (operador, index) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: operador.id, className: index % 2 == 0 ? _tarifas2.default.bgGray : "" },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.nombreCompleto
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.captador
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    operador.comuna
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement('input', { type: 'checkbox', checked: operador.turno_avanzada, onChange: function onChange(e) {
	                                            return onChangeStatusOperador(operador, e);
	                                        } })
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(_Input2.default, {
	                                        defaultValue: operador.turno_avanzada_hrs,
	                                        onChange: function onChange(e) {
	                                            return onChangeHrsOperador(operador, e);
	                                        } })
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_Modal2.default.Footer, null)
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TarifaNomina.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"zIndex":"tarifas__zIndex___1UQtb","text_xs":"tarifas__text_xs___1lRYC","bgGray":"tarifas__bgGray___ck0_F"};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	    _inherits(Input, _Component);
	
	    function Input(props) {
	        _classCallCheck(this, Input);
	
	        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	        _this.state = {
	            value: _this.props.defaultValue
	        };
	
	        _this.onBlur = function (e) {
	            var value = e.target.value;
	            if (value != _this.props.defaultValue) {
	                console.log("es distinto");
	                _this.props.onChange(e);
	            } else {
	                console.log("es igual");
	            }
	        };
	
	        _this.onChange = function (e) {
	            var value = e.target.value;
	            _this.setState({
	                value: value
	            });
	        };
	
	        return _this;
	    }
	
	    _createClass(Input, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", { onBlur: this.onBlur, onChange: this.onChange, type: "number", value: this.state.value, style: {
	                    width: '40px'
	                } });
	        }
	    }]);
	
	    return Input;
	}(_react.Component);
	
	exports.default = Input;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Input.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FondosAsignados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var _FondosAsignados2 = _interopRequireDefault(_FondosAsignados);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _TablaFondosAsignados = __webpack_require__(1161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Service axios
	
	//CSS
	
	
	var cx = _bind2.default.bind(_FondosAsignados2.default);
	//Componentes
	
	var FondosAsignados = exports.FondosAsignados = function (_React$Component) {
	    _inherits(FondosAsignados, _React$Component);
	
	    function FondosAsignados(props) {
	        _classCallCheck(this, FondosAsignados);
	
	        var _this = _possibleConstructorReturn(this, (FondosAsignados.__proto__ || Object.getPrototypeOf(FondosAsignados)).call(this, props));
	
	        _this.state = {
	            fondos: []
	        };
	        return _this;
	    }
	
	    _createClass(FondosAsignados, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            _v2.default.rendiciones().misRendiciones().then(function (fondos) {
	                _this2.setState({ fondos: fondos });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-header row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-12", 'titleMyFinancing') },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx("col-md-10", 'divTitle') },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-briefcase' }),
	                                            ' Fondos Asignados'
	                                        )
	                                    )
	                                )
	                            ),
	                            this.state.fondos.length === 0 ? null : _react2.default.createElement(
	                                'div',
	                                { className: cx("row", 'divFinancing') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: _FondosAsignados2.default.textInformation },
	                                        'Listado de fondos asignados*'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12' },
	                                    _react2.default.createElement(_TablaFondosAsignados.TablaFondosAsignados, {
	                                        fondos: this.state.fondos
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FondosAsignados;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FondosAsignados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"titleMyFinancing":"FondosAsignados__titleMyFinancing___3Y1do","textInformation":"FondosAsignados__textInformation___SJuA1","divTitle":"FondosAsignados__divTitle___1RFMi","divFinancing":"FondosAsignados__divFinancing___qGGyU","tableFixed":"FondosAsignados__tableFixed___1s0iu","colIndex":"FondosAsignados__colIndex___22--E","thIndex":"FondosAsignados__thIndex___r9zvX","tdIndex":"FondosAsignados__tdIndex___33wEQ","colNSemana":"FondosAsignados__colNSemana___2cyui","thNSemana":"FondosAsignados__thNSemana___1EqVT","tdNSemana":"FondosAsignados__tdNSemana___zMOuL","colEstado":"FondosAsignados__colEstado___2usK_","thEstado":"FondosAsignados__thEstado___2kBVF","tdEstado":"FondosAsignados__tdEstado___3UV8K","colCantGasto":"FondosAsignados__colCantGasto___SfDeQ","thCantGasto":"FondosAsignados__thCantGasto___3BJqU","tdCantGasto":"FondosAsignados__tdCantGasto___20rwY","colRendir":"FondosAsignados__colRendir___1e5uV","thRendir":"FondosAsignados__thRendir___1Eeew","tdRendir":"FondosAsignados__tdRendir___3WZ19","colTotalGasto":"FondosAsignados__colTotalGasto___3z5Zf","thTotalGasto":"FondosAsignados__thTotalGasto___29Cm0","tdTotalGasto":"FondosAsignados__tdTotalGasto___2Dnw4","colDiferencia":"FondosAsignados__colDiferencia___12e4c","thDiferencia":"FondosAsignados__thDiferencia___2YKCi","tdDiferencia":"FondosAsignados__tdDiferencia___1osWP","colAcciones":"FondosAsignados__colAcciones___v6OMj","thAcciones":"FondosAsignados__thAcciones___3qcd4","tdAcciones":"FondosAsignados__tdAcciones___2IG4x","modal":"FondosAsignados__modal___3xsPe","modalGasto":"FondosAsignados__modalGasto___1g4IJ","colTipoDocumento":"FondosAsignados__colTipoDocumento___17nnM","thTipoDocumento":"FondosAsignados__thTipoDocumento___1jFJ5","tdTipoDocumento":"FondosAsignados__tdTipoDocumento___2Mzyd","colTipoGasto":"FondosAsignados__colTipoGasto___3EmNu","thTipoGasto":"FondosAsignados__thTipoGasto___2zmj_","tdTipoGasto":"FondosAsignados__tdTipoGasto___38sPn","colEstadoGasto":"FondosAsignados__colEstadoGasto___2wAM_","thEstadoGasto":"FondosAsignados__thEstadoGasto___2GoDZ","tdEstadoGasto":"FondosAsignados__tdEstadoGasto___39FUa","colFechaGasto":"FondosAsignados__colFechaGasto___228cV","thFechaGasto":"FondosAsignados__thFechaGasto___2WmFJ","tdFechaGasto":"FondosAsignados__tdFechaGasto___1gTCW","colNDocumento":"FondosAsignados__colNDocumento___10Esw","thNDocumento":"FondosAsignados__thNDocumento___Ni7hE","tdNDocumento":"FondosAsignados__tdNDocumento___2F7cz","colGlosa":"FondosAsignados__colGlosa___3lFqB","thGlosa":"FondosAsignados__thGlosa___2G3Kc","tdGlosa":"FondosAsignados__tdGlosa___e7OQ6","colTotal":"FondosAsignados__colTotal___173lU","thTotal":"FondosAsignados__thTotal___1P8Lz","tdTotal":"FondosAsignados__tdTotal___Mnam2","imagenOriginal":"FondosAsignados__imagenOriginal___36hdW","panelBodyCustom":"FondosAsignados__panelBodyCustom___2QChB","panelInventarios":"FondosAsignados__panelInventarios___dRjnV","panelDetalles":"FondosAsignados__panelDetalles___1iF-c"};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaFondosAsignados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	var _RowFondosAsignados = __webpack_require__(1162);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//CSS
	
	//Componentes
	
	
	var TablaFondosAsignados = exports.TablaFondosAsignados = function (_React$Component) {
	    _inherits(TablaFondosAsignados, _React$Component);
	
	    function TablaFondosAsignados(props) {
	        _classCallCheck(this, TablaFondosAsignados);
	
	        return _possibleConstructorReturn(this, (TablaFondosAsignados.__proto__ || Object.getPrototypeOf(TablaFondosAsignados)).call(this, props));
	    }
	
	    _createClass(TablaFondosAsignados, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadFondosAsignados = this.props.fondos.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel-default' },
	                _react2.default.createElement(
	                    TableFondoA,
	                    null,
	                    _.range(0, cantidadFondosAsignados).map(function (index) {
	                        var fondo = _this2.props.fondos[index];
	                        return _react2.default.createElement(_RowFondosAsignados.RowFondosAsignados, {
	                            key: index,
	                            index: index,
	                            fondo: fondo
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TablaFondosAsignados;
	}(_react2.default.Component);
	
	var TableFondoA = function TableFondoA(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colNSemana }),
	            _react2.default.createElement('col', { className: css.colEstado }),
	            _react2.default.createElement('col', { className: css.colEstado }),
	            _react2.default.createElement('col', { className: css.colRendir }),
	            _react2.default.createElement('col', { className: css.colRendir }),
	            _react2.default.createElement('col', { className: css.colTotalGasto }),
	            _react2.default.createElement('col', { className: css.colDiferencia }),
	            _react2.default.createElement('col', { className: css.colAcciones }),
	            _react2.default.createElement('col', { className: css.colAcciones })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thNSemana },
	                    'Semana'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thEstado },
	                    'A\xF1o'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thEstado },
	                    'Estado'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thRendir },
	                    'Total Deposito'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thRendir },
	                    'Total a Rendir'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTotalGasto },
	                    'Total Gastos'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDiferencia },
	                    'Diferencia'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thAcciones },
	                    'Voucher'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thAcciones },
	                    'Detalle'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaFondosAsignados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowFondosAsignados = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//CSS
	
	
	var RowFondosAsignados = exports.RowFondosAsignados = function (_React$Component) {
	    _inherits(RowFondosAsignados, _React$Component);
	
	    function RowFondosAsignados(props) {
	        _classCallCheck(this, RowFondosAsignados);
	
	        return _possibleConstructorReturn(this, (RowFondosAsignados.__proto__ || Object.getPrototypeOf(RowFondosAsignados)).call(this, props));
	    }
	
	    _createClass(RowFondosAsignados, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-xs " + css.tdNSemana },
	                    this.props.fondo.fecha_inicial + " a " + this.props.fondo.fecha_final
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-sm hidden-md hidden-lg " + css.tdNSemana },
	                    this.props.fondo.numero_semana
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEstado },
	                    this.props.fondo.anio
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEstado },
	                    this.props.fondo.estado
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRendir },
	                    this.props.fondo.total_girado ? this.props.fondo.total_girado.toLocaleString("es-CL", { style: "currency", currency: "clp" }) : 0
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotalGasto },
	                    this.props.fondo.fondos_rendir ? this.props.fondo.fondos_rendir.toLocaleString("es-CL", { style: "currency", currency: "clp" }) : 0
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDiferencia },
	                    this.props.fondo.total_gastos ? this.props.fondo.total_gastos.toLocaleString("es-CL", { style: "currency", currency: "clp" }) : 0
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDiferencia },
	                    this.props.fondo.diferencia ? this.props.fondo.diferencia.toLocaleString("es-CL", { style: "currency", currency: "clp" }) : 0
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAcciones },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-sm btn-success',
	                            href: '/api/fondo/' + this.props.fondo.idFondoPublica + '/boucher-download' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-link' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdAcciones },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-sm btn-info',
	                            href: '/fondo/' + this.props.fondo.idRendicion,
	                            target: '_blank' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowFondosAsignados;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowFondosAsignados.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DetalleFondo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modales = __webpack_require__(1164);
	
	var _DetalleTotales = __webpack_require__(1165);
	
	var _TablaDetalleInventarios = __webpack_require__(1166);
	
	var _TablaDetalleFondo = __webpack_require__(1168);
	
	var _TablaGastos = __webpack_require__(1170);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var _FondosAsignados2 = _interopRequireDefault(_FondosAsignados);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	//Notify
	
	//Service axios
	
	//Componentes
	
	//CSS
	
	var cx = _bind2.default.bind(_FondosAsignados2.default);
	
	var DetalleFondo = exports.DetalleFondo = function (_React$Component) {
	    _inherits(DetalleFondo, _React$Component);
	
	    function DetalleFondo(props) {
	        _classCallCheck(this, DetalleFondo);
	
	        var _this = _possibleConstructorReturn(this, (DetalleFondo.__proto__ || Object.getPrototypeOf(DetalleFondo)).call(this, props));
	
	        _this.state = {
	            rendicion: {},
	            gastos: [],
	            lideres: [],
	            idRendicion: 0,
	            estado_rendicion: 0,
	            idLiderSeleccionado: 0,
	            numero_semana: 0,
	            semanaSeleccionada: '',
	            semana: [],
	            inventarios: [],
	            fondoSemana: [],
	            semanaServicios: [],
	            viaticosLiquidacion: 0,
	            fondosRendir: 0,
	            fondoPendiente: 0,
	            fondoGirar: 0,
	            comunaInicio: 0,
	            totalColacionNocturna: 0,
	            totalViatico: 0,
	            totalAlojamiento: 0,
	            totalAcercmientos: 0,
	            totalTraslados: 0,
	            totalPasajeOperador: 0,
	            totalOtros: 0,
	            cargando: false,
	            totales: {
	                viaticosLiquidacion: 0,
	                fondosRendir: 0,
	                fondoPendiente: 0,
	                fondoGirar: 0
	            },
	            error: []
	        };
	        _this.getRendicion = function () {
	            //Get Rendicion
	            _v2.default.rendiciones().detalleRendicion(_this.props.idRendicion).then(function (resp) {
	                _this.setState({
	                    rendicion: resp.rendicion,
	                    gastos: resp.gastos
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this.getFondosInventarios = function () {
	            _v2.default.fondos().getInventariosLider(_this.props.idLider, _this.props.fechaInicial, _this.props.fechaFinal).then(function (resp) {
	                if (resp.inventarios.length > 0) {
	                    _this.setState({
	                        idRendicion: resp.idRendicion,
	                        estado_rendicion: resp.estado_rendicion,
	                        comunaInicio: resp.comunaInicio,
	                        fondoPendiente: resp.saldoLider,
	                        inventarios: resp.inventarios,
	                        semanaServicios: resp.semanaServicios,
	                        error: [],
	                        cargando: false
	                    }, function () {
	                        return _this.sumaTotales();
	                    });
	                } else {
	                    _this.refs.notificator.info("Fondos", "No hay inventarios en la semana seleccionada.", 5 * 1000);
	                }
	            }).catch(function (err) {
	                console.log(err);
	                _this.setState({ error: err.data });
	            });
	        };
	        return _this;
	    }
	
	    _createClass(DetalleFondo, [{
	        key: 'sumaTotales',
	        value: function sumaTotales() {
	            var viaticosLiquidacion = 0;
	            var fondosRendir = 0;
	            var totalColacionNocturna = 0;
	            var totalViatico = 0;
	            var totalAlojamiento = 0;
	            var totalAcercmientos = 0;
	            var totalTraslados = 0;
	            var totalPasajeOperador = 0;
	            var totalOtros = 0;
	            var semanaServicios = this.state.semanaServicios;
	
	            semanaServicios.forEach(function (servicio) {
	                if (servicio.colacion_nocturna && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.colacion_nocturna) + viaticosLiquidacion;
	                    totalColacionNocturna = parseInt(servicio.colacion_nocturna) + totalColacionNocturna;
	                }
	                if (servicio.viatico && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.viatico) + viaticosLiquidacion;
	                    totalViatico = parseInt(servicio.viatico) + totalViatico;
	                }
	                if (servicio.acercamientos && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.acercamientos) + fondosRendir;
	                    totalAcercmientos = parseInt(servicio.acercamientos) + totalAcercmientos;
	                }
	                if (servicio.alojamiento && servicio.diaTrabajado) {
	                    viaticosLiquidacion = parseInt(servicio.alojamiento) + viaticosLiquidacion;
	                    totalAlojamiento = parseInt(servicio.alojamiento) + totalAlojamiento;
	                }
	                if (servicio.traslados && servicio.diaTrabajado && !servicio.pasajeSei) {
	                    fondosRendir = parseInt(servicio.traslados) + fondosRendir;
	                    totalTraslados = parseInt(servicio.traslados) + totalTraslados;
	                }
	                if (servicio.pasajeOperador && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.pasajeOperador) + fondosRendir;
	                    totalPasajeOperador = parseInt(servicio.pasajeOperador) + totalPasajeOperador;
	                }
	                if (servicio.otros && servicio.diaTrabajado) {
	                    fondosRendir = parseInt(servicio.otros) + fondosRendir;
	                    totalOtros = parseInt(servicio.otros) + totalOtros;
	                }
	            });
	
	            var totales = {
	                viaticosLiquidacion: viaticosLiquidacion,
	                fondosRendir: fondosRendir,
	                fondoPendiente: this.state.fondoPendiente,
	                fondoGirar: fondosRendir + viaticosLiquidacion - (this.state.fondoPendiente ? this.state.fondoPendiente : 0)
	            };
	
	            this.setState({
	                totales: totales,
	                totalColacionNocturna: totalColacionNocturna,
	                totalViatico: totalViatico,
	                totalAlojamiento: totalAlojamiento,
	                totalAcercmientos: totalAcercmientos,
	                totalTraslados: totalTraslados,
	                totalPasajeOperador: totalPasajeOperador,
	                totalOtros: totalOtros
	            });
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                nuevoGasto: function nuevoGasto(gasto) {
	                    var request = _v2.default.gastos().nuevoGasto(_this2.state.rendicion.idRendicion, gasto);
	                    request.then(function (resp) {
	                        _this2.getRendicion();
	                        _this2.refs.notificator.info("Rendiciones", "Gasto creado correctamente", 5 * 1000);
	                    }).catch(function (err) {});
	                    return request;
	                },
	                getGasto: function getGasto(idGasto) {
	                    return _v2.default.gastos().getGasto(idGasto);
	                },
	                modificarGasto: function modificarGasto(gasto) {
	                    var request = _v2.default.gastos().modificarGasto(gasto.idGastoRendicion, gasto);
	                    request.then(function (resp) {
	                        _this2.getRendicion();
	                        _this2.refs.notificator.info("Rendiciones", "Gasto actualizado correctamente", 5 * 1000);
	                    }).catch(function (err) {});
	                    return request;
	                },
	                subirFotoGasto: function subirFotoGasto(foto) {
	                    var data = new FormData();
	                    data.append('fotoGasto', foto);
	                    return _v2.default.gastos().subirFotoGasto(data);
	                },
	                getTipoDocumentos: function getTipoDocumentos() {
	                    return _v2.default.gastos().getTipoDocumentos();
	                },
	                getTipoGastos: function getTipoGastos() {
	                    return _v2.default.gastos().getTipoGastos();
	                }
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.getRendicion();
	            this.getFondosInventarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel panel-default' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-header row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("col-md-12", 'titleMyFinancing') },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: cx("col-md-12", 'divTitle') },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-usd' }),
	                                            ' Fondo',
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                ' Semana ',
	                                                this.state.rendicion.numero_semana,
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    this.state.rendicion.fecha_inicial + " a " + this.state.rendicion.fecha_final
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            this.state.inventarios.length === 0 ? null : _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'divFinancing') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-11' },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            { className: _FondosAsignados2.default.textInformation },
	                                            'Distribuci\xF3n de locales a inventariar*'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-9' },
	                                        _react2.default.createElement(_TablaDetalleInventarios.TablaDetalleInventarios, {
	                                            inventarios: this.state.inventarios
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-3' },
	                                        _react2.default.createElement(_DetalleTotales.DetalleTotales, {
	                                            totales: this.state.totales
	                                        })
	                                    )
	                                )
	                            ),
	                            this.state.inventarios.length === 0 ? null : _react2.default.createElement(
	                                'div',
	                                { className: cx("col-md-12", 'divFinance') },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-11' },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            { className: _FondosAsignados2.default.textInformation },
	                                            'Distribuci\xF3n de fondos a utilizar*'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(_TablaDetalleFondo.TablaDetalleFondo, {
	                                        semanaServicios: this.state.semanaServicios,
	                                        totalColacionNocturna: this.state.totalColacionNocturna,
	                                        totalViatico: this.state.totalViatico,
	                                        totalAlojamiento: this.state.totalAlojamiento,
	                                        totalAcercmientos: this.state.totalAcercmientos,
	                                        totalTraslados: this.state.totalTraslados,
	                                        totalPasajeOperador: this.state.totalPasajeOperador,
	                                        totalOtros: this.state.totalOtros,
	                                        puedeModificar: false
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetalleFondo;
	}(_react2.default.Component);
	
	DetalleFondo.childContextTypes = {
	    nuevoGasto: PropTypes.func,
	    getGasto: PropTypes.func,
	    modificarGasto: PropTypes.func,
	    subirFotoGasto: PropTypes.func,
	    getTipoDocumentos: PropTypes.func,
	    getTipoGastos: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetalleFondo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalInformarGastos = exports.VerFotoGasto = exports.ModalGasto = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(css);
	var PropTypes = _react2.default.PropTypes;
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalGasto = exports.ModalGasto = function (_React$Component2) {
	    _inherits(ModalGasto, _React$Component2);
	
	    function ModalGasto(props) {
	        _classCallCheck(this, ModalGasto);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalGasto.__proto__ || Object.getPrototypeOf(ModalGasto)).call(this, props));
	
	        _this2.state = {
	            gasto: {},
	            nuevo: 1,
	            fotoGasto: '',
	            tipoDocumentos: [{ idTipoDocumento: 1, nombre: 'Factura' }, { idTipoDocumento: 2, nombre: 'Boleta' }],
	            tipoGastos: [{ idTipoGasto: 1, nombre: 'Traslado' }, { idTipoGasto: 2, nombre: 'Acercamientos' }],
	            error: []
	        };
	        _this2.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.value;
	            actualizado.idEstado = 1;
	            _this2.setState({ gasto: Object.assign({}, _this2.state.gasto, actualizado) });
	        };
	        _this2.onComprobanteChange = function (evt) {
	            if (evt.target.files[0]) {
	                var fotoGasto = {};
	                var gasto = _this2.state.gasto;
	                fotoGasto = evt.target.files[0];
	                _this2.context.subirFotoGasto(fotoGasto).then(function (resp) {
	                    console.log(resp);
	                    gasto.idFotoDocumento = resp;
	                    _this2.setState({
	                        fotoGasto: fotoGasto,
	                        gasto: gasto
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        _this2.guardarGasto = function () {
	            if (_this2.state.nuevo) {
	                _this2.context.nuevoGasto(_this2.state.gasto).then(function (resp) {
	                    _this2.props.hideModal();
	                }).catch(function (err) {
	                    console.log(err);
	                    _this2.setState({
	                        error: err.data
	                    });
	                });
	            } else {
	                _this2.context.modificarGasto(_this2.state.gasto).then(function (resp) {
	                    console.log(resp);
	                    _this2.props.hideModal();
	                }).catch(function (err) {
	                    console.log(err);
	                    _this2.setState({
	                        error: err.data
	                    });
	                });
	            }
	        };
	        _this2.getTipoDocumentos = function () {
	            _this2.context.getTipoDocumentos().then(function (tipoDocumentos) {
	                _this2.setState({ tipoDocumentos: tipoDocumentos });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this2.getTipoGastos = function () {
	            _this2.context.getTipoGastos().then(function (tipoGastos) {
	                _this2.setState({ tipoGastos: tipoGastos });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalGasto, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            this.getTipoDocumentos();
	            this.getTipoGastos();
	            if (this.props.idGastoRendicion) {
	                this.context.getGasto(this.props.idGastoRendicion).then(function (gasto) {
	                    _this3.setState({
	                        gasto: gasto,
	                        nuevo: 0
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.inputFecha.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalGasto'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        this.state.nuevo ? "Creando un nuevo gasto a la rendición" : "Editando gasto de la rendición"
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Fecha '
	                                        ),
	                                        _react2.default.createElement('input', { type: 'date', className: 'form-control',
	                                            ref: function ref(fecha) {
	                                                _this4.inputFecha = fecha;
	                                            },
	                                            value: this.state.gasto.fechaEmision,
	                                            onFocus: function onFocus() {
	                                                _this4.inputFecha.select();
	                                            },
	                                            onChange: this.onInputChange.bind(this, 'fechaEmision')
	                                        }),
	                                        this.state.error.fechaEmision && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.fechaEmision
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Tipo Documento'
	                                        ),
	                                        _react2.default.createElement(
	                                            'select',
	                                            { className: "form-control",
	                                                value: this.state.gasto.idTipoDocumento,
	                                                onChange: this.onInputChange.bind(this, 'idTipoDocumento') },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '0' },
	                                                'Tipo Documento'
	                                            ),
	                                            this.state.tipoDocumentos.map(function (tipoDocumento, index) {
	                                                return _react2.default.createElement(
	                                                    'option',
	                                                    { key: index, value: tipoDocumento.idTipoDocumento },
	                                                    tipoDocumento.nombre
	                                                );
	                                            })
	                                        ),
	                                        this.state.error.idTipoDocumento && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.idTipoDocumento
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Tipo Gasto'
	                                        ),
	                                        _react2.default.createElement(
	                                            'select',
	                                            { className: "form-control",
	                                                value: this.state.gasto.idTipoGasto,
	                                                onChange: this.onInputChange.bind(this, 'idTipoGasto') },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '0' },
	                                                'Tipo Gasto'
	                                            ),
	                                            this.state.tipoGastos.map(function (tipoGasto, index) {
	                                                return _react2.default.createElement(
	                                                    'option',
	                                                    { key: index, value: tipoGasto.idTipoGasto },
	                                                    tipoGasto.nombre
	                                                );
	                                            })
	                                        ),
	                                        this.state.error.idTipoGasto && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.idTipoGasto
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'N\xFAmero Comprobante '
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                                            ref: function ref(numero_documento) {
	                                                _this4.inputNumero_Documento = numero_documento;
	                                            },
	                                            value: this.state.gasto.numero_documento,
	                                            onFocus: function onFocus() {
	                                                _this4.inputNumero_Documento.select();
	                                            },
	                                            onChange: this.onInputChange.bind(this, 'numero_documento')
	                                        }),
	                                        this.state.error.numero_documento && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.numero_documento
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Total '
	                                        ),
	                                        _react2.default.createElement('input', { type: 'number', className: 'form-control',
	                                            ref: function ref(total) {
	                                                _this4.inputTotal = total;
	                                            },
	                                            value: this.state.gasto.total,
	                                            onFocus: function onFocus() {
	                                                _this4.inputTotal.select();
	                                            },
	                                            onChange: this.onInputChange.bind(this, 'total')
	                                        }),
	                                        this.state.error.total && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.total
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Subir Foto'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { htmlFor: 'subirFoto' },
	                                                _react2.default.createElement(
	                                                    'i',
	                                                    { className: this.state.gasto.idFotoDocumento ? "btn btn-xs btn-primary" : "btn btn-xs btn-success  ",
	                                                        title: 'Seleccionar Foto' },
	                                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-open-file' }),
	                                                    ' ',
	                                                    this.state.gasto.idFotoDocumento ? "Reemplazar Foto" : "Seleccione Archivo"
	                                                ),
	                                                _react2.default.createElement('input', { id: 'subirFoto', type: 'file',
	                                                    onChange: this.onComprobanteChange })
	                                            )
	                                        ),
	                                        this.state.error.foto_documento && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.foto_documento
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 col-xs-12 form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Glosa '
	                                        ),
	                                        _react2.default.createElement('textarea', { className: 'form-control', rows: '2',
	                                            ref: function ref(glosa) {
	                                                _this4.inputGlosa = glosa;
	                                            },
	                                            value: this.state.gasto.glosa,
	                                            onFocus: function onFocus() {
	                                                _this4.inputGlosa.select();
	                                            },
	                                            onChange: this.onInputChange.bind(this, 'glosa') }),
	                                        this.state.error.glosa && _react2.default.createElement(
	                                            'span',
	                                            { className: cx('form__error-message') },
	                                            this.state.error.glosa
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-primary pull-left',
	                                onClick: this.guardarGasto },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                            ' Guardar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                            ' Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalGasto;
	}(_react2.default.Component);
	
	ModalGasto.contextTypes = {
	    nuevoGasto: PropTypes.func,
	    getGasto: PropTypes.func,
	    modificarGasto: PropTypes.func,
	    subirFotoGasto: PropTypes.func,
	    getTipoDocumentos: PropTypes.func,
	    getTipoGastos: PropTypes.func
	};
	
	var VerFotoGasto = exports.VerFotoGasto = function (_React$Component3) {
	    _inherits(VerFotoGasto, _React$Component3);
	
	    function VerFotoGasto(props) {
	        _classCallCheck(this, VerFotoGasto);
	
	        return _possibleConstructorReturn(this, (VerFotoGasto.__proto__ || Object.getPrototypeOf(VerFotoGasto)).call(this, props));
	    }
	
	    _createClass(VerFotoGasto, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalGasto'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Foto Gasto'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement('img', { src: '' + this.props.ruta_imagen, className: cx('imagenOriginal') })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-primary pull-left',
	                                onClick: this.guardarGasto },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                            ' Guardar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                            ' Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VerFotoGasto;
	}(_react2.default.Component);
	
	var ModalInformarGastos = exports.ModalInformarGastos = function (_React$Component4) {
	    _inherits(ModalInformarGastos, _React$Component4);
	
	    function ModalInformarGastos(props) {
	        _classCallCheck(this, ModalInformarGastos);
	
	        return _possibleConstructorReturn(this, (ModalInformarGastos.__proto__ || Object.getPrototypeOf(ModalInformarGastos)).call(this, props));
	    }
	
	    _createClass(ModalInformarGastos, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: true, onHide: this.props.hideModal, dialogClassName: cx('modalGasto'), className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Informar m\xEDs gastos'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'ATENCI\xD3N, informar\xE1 la rendici\xF3n a los administradores, si realiza esta acci\xF3n no podr\xE1 volver a modificar su rendici\xF3n mientras est\xE1 siendo revisada, \xBFDesea proceder?'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-warning pull-left',
	                                onClick: this.guardarGasto },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-envelope' }),
	                            ' Informar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-md btn-cancel', onClick: this.props.hideModal },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' }),
	                            ' Cancelar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalInformarGastos;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DetalleTotales = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetalleTotales = exports.DetalleTotales = function (_React$Component) {
	    _inherits(DetalleTotales, _React$Component);
	
	    function DetalleTotales(props) {
	        _classCallCheck(this, DetalleTotales);
	
	        var _this = _possibleConstructorReturn(this, (DetalleTotales.__proto__ || Object.getPrototypeOf(DetalleTotales)).call(this, props));
	
	        _this.state = {
	            fondoPendiente: 0
	        };
	        return _this;
	    }
	
	    _createClass(DetalleTotales, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-info " + css.panelTotales },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Total Fondo Asignado'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyTotales },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Viaticos'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.viaticosLiquidacion.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'A Rendir'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.fondosRendir.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Mi Saldo'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.fondoPendiente.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Total Dep\xF3sito'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.totales.fondoGirar.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetalleTotales;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "DetalleTotales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaDetalleInventarios = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RowDetalleInventario = __webpack_require__(1167);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var TablaDetalleInventarios = exports.TablaDetalleInventarios = function (_React$Component) {
	    _inherits(TablaDetalleInventarios, _React$Component);
	
	    function TablaDetalleInventarios(props) {
	        _classCallCheck(this, TablaDetalleInventarios);
	
	        return _possibleConstructorReturn(this, (TablaDetalleInventarios.__proto__ || Object.getPrototypeOf(TablaDetalleInventarios)).call(this, props));
	    }
	
	    _createClass(TablaDetalleInventarios, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var totalInventarios = this.props.inventarios.length;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Inventarios'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaInventario,
	                        null,
	                        _.range(0, totalInventarios).map(function (index) {
	                            var inventario = _this2.props.inventarios[index];
	                            return _react2.default.createElement(_RowDetalleInventario.RowDetalleInventario, {
	                                key: index,
	                                index: index,
	                                inventario: inventario
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaDetalleInventarios;
	}(_react2.default.Component);
	
	var TablaInventario = function TablaInventario(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colIndex }),
	            _react2.default.createElement('col', { className: css.colFecha }),
	            _react2.default.createElement('col', { className: css.colCliente }),
	            _react2.default.createElement('col', { className: css.colLocal }),
	            _react2.default.createElement('col', { className: css.colComuna }),
	            _react2.default.createElement('col', { className: css.colRegion }),
	            _react2.default.createElement('col', { className: css.colJornada }),
	            _react2.default.createElement('col', { className: css.colDotacion }),
	            _react2.default.createElement('col', { className: css.colHrLider })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thIndex },
	                    '#'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thFecha },
	                    'Fecha'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thCliente },
	                    'CLI'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thLocal },
	                    'Local'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thComuna },
	                    'Comuna'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thRegion },
	                    'Regi\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thJornada },
	                    'Jornada'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDotacion },
	                    'Dotaci\xF3n'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thHrLider },
	                    'Hr Lider'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaDetalleInventarios.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowDetalleInventario = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	_moment2.default.locale('es');
	
	var RowDetalleInventario = exports.RowDetalleInventario = function (_React$Component) {
	    _inherits(RowDetalleInventario, _React$Component);
	
	    function RowDetalleInventario(props) {
	        _classCallCheck(this, RowDetalleInventario);
	
	        return _possibleConstructorReturn(this, (RowDetalleInventario.__proto__ || Object.getPrototypeOf(RowDetalleInventario)).call(this, props));
	    }
	
	    _createClass(RowDetalleInventario, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdIndex, title: this.props.inventario.idInventario },
	                    this.props.index + 1
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFecha },
	                    (0, _moment2.default)(this.props.inventario.fechaProgramada).format('DD-MM-YYYY')
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdCliente },
	                    this.props.inventario.nombreCliente
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdLocal },
	                    this.props.inventario.nombreLocal
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdComuna },
	                    this.props.inventario.comuna
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdRegion },
	                    this.props.inventario.region
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdJornada },
	                    this.props.inventario.jornada
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdDotacion },
	                    this.props.inventario.dotacion
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdHrLider },
	                    this.props.inventario.hrLider
	                )
	            );
	        }
	    }]);
	
	    return RowDetalleInventario;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowDetalleInventario.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaDetalleFondo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	var _RowDetalleFondo = __webpack_require__(1169);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	//CSS
	
	//COMPONENTS
	
	var TablaDetalleFondo = exports.TablaDetalleFondo = function (_React$Component) {
	    _inherits(TablaDetalleFondo, _React$Component);
	
	    function TablaDetalleFondo(props) {
	        _classCallCheck(this, TablaDetalleFondo);
	
	        var _this = _possibleConstructorReturn(this, (TablaDetalleFondo.__proto__ || Object.getPrototypeOf(TablaDetalleFondo)).call(this, props));
	
	        _this.rows = [];
	        return _this;
	    }
	
	    _createClass(TablaDetalleFondo, [{
	        key: 'focusRow',
	        value: function focusRow(index, nombreElemento) {
	            var ultimoIndex = this.rows.length - 1;
	            var elemento = nombreElemento;
	            if (index < 0) {
	                // al seleccionar "antes de la primera", se seleciona el ultimo
	                this.rows[ultimoIndex].focusElemento(elemento);
	            } else if (index >= ultimoIndex) {
	                // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
	                if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                if (this.rows[0][elemento].disabled) {
	                    this.rows[1].focusElemento(elemento);
	                } else {
	                    this.rows[0].focusElemento(elemento);
	                }
	            } else {
	                // no es ni el ultimo, ni el primero
	                if (this.rows[index][elemento].disabled) {
	                    if (index + 1 >= ultimoIndex) {
	                        if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                        if (this.rows[0][elemento].disabled) {
	                            this.rows[1].focusElemento(elemento);
	                        } else {
	                            this.rows[0].focusElemento(elemento);
	                        }
	                    } else {
	                        if (this.rows[index + 1][elemento].disabled) {
	                            if (index + 2 >= ultimoIndex) {
	                                if (elemento === 'inputColacion_nocturna') elemento = 'inputViatico';else if (elemento === 'inputViatico') elemento = 'inputAlojamiento';else if (elemento === 'inputAlojamiento') elemento = 'inputAcercamientos';else if (elemento === 'inputAcercamientos') elemento = 'inputTraslados';else if (elemento === 'inputTraslados') elemento = 'inputPasajeOperador';else if (elemento === 'inputPasajeOperador') elemento = 'inputOtros';else if (elemento === 'inputOtros') elemento = 'inputPasajeSei';else if (elemento === 'inputPasajeSei') elemento = 'inputColacion_nocturna';
	
	                                if (this.rows[0][elemento].disabled) {
	                                    this.rows[1].focusElemento(elemento);
	                                } else {
	                                    this.rows[0].focusElemento(elemento);
	                                }
	                            } else {
	                                this.rows[index + 2].focusElemento(elemento);
	                            }
	                        } else {
	                            this.rows[index + 1].focusElemento(elemento);
	                        }
	                    }
	                } else {
	                    this.rows[index].focusElemento(elemento);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadFondos = this.props.semanaServicios.length + 1;
	            return _react2.default.createElement(
	                'div',
	                { className: "panel panel-default " + css.panelInventarios },
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-heading " + css.panelHeadingDetalle },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Fondos'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "panel-body " + css.panelBodyCustom },
	                    _react2.default.createElement(
	                        TablaFondo,
	                        null,
	                        _.range(0, cantidadFondos).map(function (index) {
	                            var servicio = _this2.props.semanaServicios[index];
	                            var totales = _this2.props.semanaServicios.length === index ? true : false;
	                            return _react2.default.createElement(_RowDetalleFondo.RowDetalleFondo, {
	                                key: index,
	                                index: index,
	                                ref: function ref(_ref) {
	                                    return _this2.rows[index] = _ref;
	                                },
	                                focusRow: _this2.focusRow.bind(_this2),
	                                servicio: servicio,
	                                totales: totales,
	                                totalColacionNocturna: _this2.props.totalColacionNocturna,
	                                totalViatico: _this2.props.totalViatico,
	                                totalAlojamiento: _this2.props.totalAlojamiento,
	                                totalAcercmientos: _this2.props.totalAcercmientos,
	                                totalTraslados: _this2.props.totalTraslados,
	                                totalPasajeOperador: _this2.props.totalPasajeOperador,
	                                totalOtros: _this2.props.totalOtros,
	                                puedeModificar: _this2.props.puedeModificar
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TablaDetalleFondo;
	}(_react2.default.Component);
	
	var TablaFondo = function TablaFondo(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        'table',
	        { className: "table table-condensed " + css.tableFixed + " " + css.panelDetalleInventarios },
	        _react2.default.createElement(
	            'colgroup',
	            null,
	            _react2.default.createElement('col', { className: css.colDia }),
	            _react2.default.createElement('col', { className: css.colServicios }),
	            _react2.default.createElement('col', { className: css.colColNoche }),
	            _react2.default.createElement('col', { className: css.colViatico }),
	            _react2.default.createElement('col', { className: css.colAcercamiento }),
	            _react2.default.createElement('col', { className: css.colTraslado }),
	            _react2.default.createElement('col', { className: css.colPasajeOperador }),
	            _react2.default.createElement('col', { className: css.colOtros })
	        ),
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thDia },
	                    'D\xEDa'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thServicios },
	                    'Cant. Serv.'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thColNoche },
	                    'Colaci\xF3n Noc.'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thViatico },
	                    'Vi\xE1tico'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thAcercamiento },
	                    'Acercamientos'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thTraslado },
	                    'Traslados'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thPasajeOperador },
	                    'Pasje Operador'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    { className: css.thOtros },
	                    'Otros'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaDetalleFondo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowDetalleFondo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var _FondosAsignados2 = _interopRequireDefault(_FondosAsignados);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_moment2.default.locale('es');
	var PropTypes = _react2.default.PropTypes;
	
	var RowDetalleFondo = exports.RowDetalleFondo = function (_React$Component) {
	    _inherits(RowDetalleFondo, _React$Component);
	
	    function RowDetalleFondo(props) {
	        _classCallCheck(this, RowDetalleFondo);
	
	        var _this = _possibleConstructorReturn(this, (RowDetalleFondo.__proto__ || Object.getPrototypeOf(RowDetalleFondo)).call(this, props));
	
	        _this.inputOnKeyDown = _this.inputOnKeyDown.bind(_this);
	        _this.state = {
	            servicio: [],
	            comprobante: ''
	        };
	        _this.onInputChange = function (key, evt) {
	            var actualizado = {};
	            actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
	            actualizado.dirty = 1;
	            _this.setState({ servicio: Object.assign({}, _this.state.servicio, actualizado) }, function () {
	                return _this.context.inputChange(_this.props.index, _this.state.servicio);
	            });
	        };
	        _this.onInputBlur = function () {
	            if (_this.state.servicio.dirty) _this.context.guardarFondo(_this.state.servicio);
	        };
	        return _this;
	    }
	
	    _createClass(RowDetalleFondo, [{
	        key: 'onComprobanteChange',
	        value: function onComprobanteChange(evt) {
	            var _this2 = this;
	
	            if (evt.target.files[0]) {
	                var actualizado = {};
	                actualizado.comprobante = evt.target.files[0];
	                this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado) }, function () {
	                    return _this2.context.subirComprobante(_this2.props.index, _this2.state.servicio);
	                });
	            }
	        }
	    }, {
	        key: 'focusElemento',
	        value: function focusElemento(elemento) {
	            this[elemento].focus();
	        }
	    }, {
	        key: 'inputOnKeyDown',
	        value: function inputOnKeyDown(key, evt) {
	            if (evt.keyCode === 9 && evt.shiftKey === false || evt.keyCode === 40 || evt.keyCode === 13) {
	                // 9 = tab, flechaAbajo = 40,  13 = enter
	                evt.preventDefault();
	                this.props.focusRow(this.props.index + 1, key);
	            } else if (evt.keyCode === 9 && evt.shiftKey === true || evt.keyCode === 38) {
	                // flechaArriba = 38, shift+tab
	                evt.preventDefault();
	                this.props.focusRow(this.props.index - 1, key);
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                servicio: this.props.servicio
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index },
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdDia },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.totales ? null : (0, _moment2.default)(this.state.servicio.dia).format('dddd D MMM')
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdServicios },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        this.props.totales ? _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Totales'
	                        ) : this.state.servicio.cantidad_servicios
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdColNoche },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalColacionNocturna.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.colacion_nocturna.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdViatico },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalViatico.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.viatico.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdAcercamiento },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalAcercmientos.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.acercamientos.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdTraslado },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalTraslados.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.traslados.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdPasajeOperador },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalPasajeOperador.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.pasajeOperador.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: _FondosAsignados2.default.tdOtros },
	                    this.props.totales ? _react2.default.createElement(
	                        'div',
	                        { className: "text-left " + _FondosAsignados2.default.totales },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.props.totalOtros.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.servicio.otros.toLocaleString("es-CL", { style: "currency", currency: "clp" })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RowDetalleFondo;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowDetalleFondo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaGastos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	var _RowGastos = __webpack_require__(1171);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Componentes
	
	
	var TablaGastos = exports.TablaGastos = function (_React$Component) {
	    _inherits(TablaGastos, _React$Component);
	
	    function TablaGastos(props) {
	        _classCallCheck(this, TablaGastos);
	
	        return _possibleConstructorReturn(this, (TablaGastos.__proto__ || Object.getPrototypeOf(TablaGastos)).call(this, props));
	    }
	
	    _createClass(TablaGastos, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cantidadGastos = this.props.gastos.length;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                cantidadGastos > 0 ? _react2.default.createElement(
	                    TablaGasto,
	                    null,
	                    _.range(0, cantidadGastos).map(function (index) {
	                        var gasto = _this2.props.gastos[index];
	                        return _react2.default.createElement(_RowGastos.RowGastos, {
	                            key: index,
	                            index: index,
	                            gasto: gasto
	                        });
	                    })
	                ) : null
	            );
	        }
	    }]);
	
	    return TablaGastos;
	}(_react2.default.Component);
	
	var TablaGasto = function TablaGasto(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { className: "table table-condensed " + css.tableFixed },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('th', { className: css.thIndex }),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thFechaGasto },
	                        'Emisi\xF3n'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: "hidden-xs " + css.thTipoGasto },
	                        'Tipo Gasto'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thEstadoGasto },
	                        'Estado'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: "hidden-xs " + css.thGlosa },
	                        'Comentarios'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: css.thTotal },
	                        'Total'
	                    ),
	                    _react2.default.createElement('th', { className: "hidden-xs " + css.thAcciones })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaGastos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RowGastos = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FondosAsignados = __webpack_require__(1160);
	
	var css = _interopRequireWildcard(_FondosAsignados);
	
	var _Modales = __webpack_require__(1164);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Componentes
	
	
	var RowGastos = exports.RowGastos = function (_React$Component) {
	    _inherits(RowGastos, _React$Component);
	
	    function RowGastos(props) {
	        _classCallCheck(this, RowGastos);
	
	        var _this = _possibleConstructorReturn(this, (RowGastos.__proto__ || Object.getPrototypeOf(RowGastos)).call(this, props));
	
	        _this.state = {
	            showModalGasto: false,
	            showModalFoto: false
	        };
	        _this.showModalGasto = function () {
	            _this.setState({
	                showModalGasto: true
	            });
	        };
	        _this.hideModalGasto = function () {
	            _this.setState({
	                showModalGasto: false
	            });
	        };
	        return _this;
	    }
	
	    _createClass(RowGastos, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'tr',
	                { key: this.props.index, onClick: this.showModal },
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-xs " + css.tdIndex },
	                    _react2.default.createElement('img', { src: this.props.gasto.foto_documento, width: '100', height: '50' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdFechaGasto },
	                    this.props.gasto.fecha_emision
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-xs " + css.tdTipoGasto },
	                    this.props.gasto.tipo_gasto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdEstadoGasto },
	                    this.props.gasto.estado_gasto
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-xs " + css.tdGlosa },
	                    this.props.gasto.glosa
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: css.tdTotal },
	                    this.props.gasto.total ? this.props.gasto.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: "hidden-xs " + css.tdAcciones },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-xs-6' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-xs btn btn-md btn-info', onClick: this.showModalGasto },
	                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-pencil' }),
	                            ' '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-xs-6' },
	                        _react2.default.createElement(
	                            _Modales.ModalTrigger,
	                            null,
	                            function (isVisible, showModal, hideModal) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: "btn btn-md btn-info pull-right", onClick: showModal },
	                                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-eye-open', title: 'Ver Imagen' }),
	                                        ' '
	                                    ),
	                                    isVisible && _react2.default.createElement(_Modales.VerFotoGasto, {
	                                        hideModal: hideModal,
	                                        index: _this2.props.index,
	                                        ruta_imagen: _this2.props.gasto.foto_documento
	                                    })
	                                );
	                            }
	                        )
	                    )
	                ),
	                this.state.showModalGasto && _react2.default.createElement(_Modales.ModalGasto, {
	                    hideModal: this.hideModalGasto,
	                    index: this.props.index,
	                    idGastoRendicion: this.props.gasto.idGastoRendicion
	                })
	            );
	        }
	    }]);
	
	    return RowGastos;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "RowGastos.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _store = __webpack_require__(1173);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CollectivePermission = __webpack_require__(1176);
	
	var _CollectivePermission2 = _interopRequireDefault(_CollectivePermission);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CollectivePermissionIndex() {
	    return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(_CollectivePermission2.default, null)
	    );
	}
	
	exports.default = CollectivePermissionIndex;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(481);
	
	var _reducers = __webpack_require__(1174);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(980);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxLogger2.default)));
	
	exports.default = store;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(481);
	
	var _filesReducer = __webpack_require__(1175);
	
	var _filesReducer2 = _interopRequireDefault(_filesReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    filesState: _filesReducer2.default
	});
	
	exports.default = rootReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INITIAL_STATE = {
	    files: []
	};
	
	var filesReducer = function filesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_FILES':
	            return _extends({}, state, {
	                files: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = filesReducer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "filesReducer.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(932);
	
	var _actions = __webpack_require__(1177);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _SearchRutForm = __webpack_require__(1178);
	
	var _SearchRutForm2 = _interopRequireDefault(_SearchRutForm);
	
	var _FilesPermsList = __webpack_require__(1179);
	
	var _FilesPermsList2 = _interopRequireDefault(_FilesPermsList);
	
	var _collectivePermissionService = __webpack_require__(1181);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectivePermission = function (_Component) {
	    _inherits(CollectivePermission, _Component);
	
	    function CollectivePermission(props) {
	        _classCallCheck(this, CollectivePermission);
	
	        var _this = _possibleConstructorReturn(this, (CollectivePermission.__proto__ || Object.getPrototypeOf(CollectivePermission)).call(this, props));
	
	        _this.state = {};
	
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Lo sentimos ocurrió un error inesperado.", 4 * 1000);
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	
	        _this.getFiles = function (rut) {
	            return (0, _collectivePermissionService.getFilesByRut)(rut).then(function (res) {
	                var response = res.data;
	                _this.props.setFiles(response.files);
	            }).catch(_this.ajaxErrorHandler('Búsqueda de personal'));
	        };
	
	        return _this;
	    }
	
	    _createClass(CollectivePermission, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(_reactNotify2.default, { ref: "notificator", className: ReactNotifyCSS }),
	                _react2.default.createElement(_SearchRutForm2.default, { getFiles: this.getFiles }),
	                _react2.default.createElement(_FilesPermsList2.default, { files: this.props.files })
	            );
	        }
	    }]);
	
	    return CollectivePermission;
	}(_react.Component);
	
	var mapDispatchToProps = {
	    setFiles: _actions.setFiles
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        files: state.filesState.files
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CollectivePermission);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "CollectivePermission.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var setFiles = exports.setFiles = function setFiles(payload) {
	    return {
	        type: 'SET_FILES',
	        payload: payload
	    };
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputRun = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchRutForm = function (_Component) {
	    _inherits(SearchRutForm, _Component);
	
	    function SearchRutForm(props) {
	        _classCallCheck(this, SearchRutForm);
	
	        var _this = _possibleConstructorReturn(this, (SearchRutForm.__proto__ || Object.getPrototypeOf(SearchRutForm)).call(this, props));
	
	        _this.state = { rut: '', dv: '', btnDisabled: false };
	
	        _this.onRutChange = function (rut, dv) {
	            _this.setState({ rut: rut });
	            _this.setState({ dv: dv });
	        };
	
	        _this.searchingFiles = function (rut) {
	            if (_this.state.rut === '') return;
	            _this.setState({ btnDisabled: true });
	            props.getFiles(rut).then(_this.setState({ btnDisabled: false })).catch(function (error) {
	                console.log(error);
	                _this.setState({ btnDisabled: false });
	            });
	        };
	        return _this;
	    }
	
	    _createClass(SearchRutForm, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "input-group" },
	                _react2.default.createElement(_InputRun.InputRun, {
	                    onPressEnter: this.searchingFiles,
	                    onRUNChange: this.onRutChange,
	                    className: "form-control"
	                }),
	                _react2.default.createElement(
	                    "span",
	                    { className: "input-group-btn" },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            className: "btn btn-default",
	                            disabled: true
	                        },
	                        this.state.dv !== "" ? this.state.dv : "DV"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            onClick: function onClick() {
	                                return _this2.searchingFiles(_this2.state.rut);
	                            },
	                            type: "button",
	                            className: "btn btn-default",
	                            disabled: this.state.btnDisabled
	                        },
	                        "Buscar"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchRutForm;
	}(_react.Component);
	
	exports.default = SearchRutForm;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "SearchRutForm.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _consts = __webpack_require__(1180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilesPermsList = function FilesPermsList(props) {
	    return _react2.default.createElement(
	        "ul",
	        { className: "list-group", style: { paddingTop: "20px" } },
	        props.files.length === 0 ? _react2.default.createElement(
	            "li",
	            { className: "list-group-item list-group-item-info", key: 1 },
	            "No se encontraron resultados"
	        ) : props.files.map(function (file) {
	            return _react2.default.createElement(
	                "li",
	                { className: "list-group-item list-group-item-info", key: file.id },
	                _react2.default.createElement(
	                    "a",
	                    { className: "btn btn-success btn-xs pull-right",
	                        href: _consts.API_URI + "download-perm?fileId=" + file.id },
	                    _react2.default.createElement("span", { className: "glyphicon glyphicon-download" })
	                ),
	                file.name
	            );
	        })
	    );
	};
	
	exports.default = FilesPermsList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "FilesPermsList.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URI = exports.API_URI = '/api/covid/';
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFilesByRut = undefined;
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _consts = __webpack_require__(1180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFilesByRut = exports.getFilesByRut = function getFilesByRut(partnerRut) {
	    return _axios2.default.get(_consts.API_URI + 'search-files?partnerRut=' + partnerRut);
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "collectivePermissionService.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RegistroOperador = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ValidadorRUN = __webpack_require__(756);
	
	var _reactFormal = __webpack_require__(757);
	
	var _reactFormal2 = _interopRequireDefault(_reactFormal);
	
	var _reactFormalInputs = __webpack_require__(808);
	
	var _reactFormalInputs2 = _interopRequireDefault(_reactFormalInputs);
	
	var _yup = __webpack_require__(893);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _formularioUsuario = __webpack_require__(1183);
	
	var styles = _interopRequireWildcard(_formularioUsuario);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes = __webpack_require__(413);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modals = __webpack_require__(1184);
	
	var _esDeRegion = __webpack_require__(1186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	//let PropTypes = React.PropTypes
	// Moment
	
	
	var momentLocalizer = __webpack_require__(915);
	momentLocalizer(_moment2.default);
	// Validador Rut
	
	// Forms
	
	_reactFormal2.default.addInputTypes(_reactFormalInputs2.default);
	// ReactNotify
	
	// Componentes
	
	var cx = _bind2.default.bind(styles);
	
	
	var listaBancos = ['Banco Estado', 'Banco de Chile', 'Banco Internacional', 'Scotiank-Desarrollo', 'Banco de Credito e Inversiones', 'CorpBanca', 'Banco Bice', 'HSBC Bank Chile', 'Banco Santander', 'Banco Itaú', 'The Bank of Tokyo-Mitsubishi', 'Banco Security', 'Banco Falabella', 'Banco Ripley', 'Banco Consorcio', 'Banco Paris', 'Banco BBVA', 'Copeuch', 'Banco Penta', 'Scotiabank Chile', 'Deutsche Bank', 'Rabobank Chile'];
	var listaTipoCuentas = ['Cuenta Corriente', 'Cuenta Vista', 'Cuenta Ahorro', 'Chequera Electronica', 'Cuenta de Gastos', 'Cuenta RUT'];
	var SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
	
	var RegistroOperador = exports.RegistroOperador = function (_React$Component) {
	    _inherits(RegistroOperador, _React$Component);
	
	    function RegistroOperador(props) {
	        _classCallCheck(this, RegistroOperador);
	
	        var _this = _possibleConstructorReturn(this, (RegistroOperador.__proto__ || Object.getPrototypeOf(RegistroOperador)).call(this, props));
	
	        _this.usuarioSchema = _yup2.default.object({
	            usuarioRUN: _yup2.default.string().default(_this.props.usuario.usuarioRUN).min(1, 'El RUN debe tener un minimo de 1 caracteres').max(8, 'El RUN debe tener un máximo de 8 caracteres'),
	            usuarioDV: _yup2.default.string().default((0, _ValidadorRUN.obtenerVerificador)(_this.props.usuario.usuarioRUN)).required('Ingrese el digito verificador del RUN').test('verificarUsuarioDV', 'El digito verificador es incorrecto', function (value) {
	                // Hack sucio... cuando se hace una validacion con delay, se sacan los valores de options, si no, de parent
	                var valores = this.options.value ? this.options.value : this.parent;
	                return (0, _ValidadorRUN.validarRUN)(valores.usuarioRUN, value);
	            }).max(1, 'El máximo es 1 digito'),
	            emailPersonal: _yup2.default.string().default(_this.props.usuario.emailPersonal).max(60, 'El máximo es 60 caracteres')
	            //.email('Debe ser un email valido'),
	            .required('Ingrese el email').test('correo', 'Debe ingresar un email valido', function (value) {
	                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	                return value === '' || rEmail.test(value);
	            }),
	            nombre1: _yup2.default.string().default(_this.props.usuario.nombre1).required('Ingrese el primer nombre').min(3, 'El minimo es de 3 caracteres').max(20, 'El máximo es 20 caracteres'),
	            nombre2: _yup2.default.string().default(_this.props.usuario.nombre2).max(20, 'El máximo es 20 caracteres'),
	            apellidoPaterno: _yup2.default.string().default(_this.props.usuario.apellidoPaterno).required('Ingrese el apellido').min(3, 'El minimo es de 3 caracteres').max(20, 'El máximo es 20 caracteres'),
	            apellidoMaterno: _yup2.default.string().default(_this.props.usuario.apellidoMaterno).max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            telefono: _yup2.default.string().default("").max(20, 'El máximo es 20 caracteres').required('Ingrese el teléfono de la persona'),
	            telefonoEmergencia: _yup2.default.string().default("").max(20, 'El máximo es 20 caracteres'), // no obligatorio
	            // TODO: este validador no permite que existan fechas "invalidas" como un string vacio, arreglar esto eventualmente....
	            fechaNacimiento: _yup2.default.date().default(_this.props.usuario.fechaNacimiento ? _this.props.usuario.fechaNacimiento === '0000-00-00' ? null : new Date(_this.props.usuario.fechaNacimiento.replace(/-/g, '\/').replace(/T.+/, '')) : null).test('fechaNacimiento', 'Mensaje de error', function () {
	                return true;
	            }),
	            //.required('Ingrese la fecha de nacimiento'),
	            sexo: _yup2.default.string().default(_this.props.usuario.sexo).required('Ingrese el sexo de la persona'),
	            nacionalidad: _yup2.default.string().default(_this.props.usuario.nacionalidad).required('Ingrese la nacionalidad de la persona'),
	            direccion: _yup2.default.string().default(_this.props.usuario.direccion).max(150, 'El máximo es de 150 carácteres').required('Ingrese la dirección de la persona'),
	            // cutRegion: yup.number()
	            //     .required('Seleccione una Región'),
	            cutComuna: _this.props.usuario.cutComuna != 0 ? _yup2.default.number().default(parseInt(_this.props.usuario.cutComuna)) // es un number, pero lo retornan como string
	            .required('Seleccione una Comuna') : _yup2.default.string() // es un number, pero lo retornan como string
	            .required('Seleccione una Comuna'),
	            idBanco: _this.props.usuario.banco != 0 ? _yup2.default.number().default(parseInt(_this.props.usuario.banco)).required('Seleccione el Banco de la lista') : _yup2.default.string().required('Seleccione el Banco de la lista'),
	            //.max(30, 'El máximo es 30 caracteres'),
	            idTipoCuenta: _this.props.usuario.cuenta != 0 ? _yup2.default.number().default(parseInt(_this.props.usuario.cuenta)).required('Seleccione el Tipo de Cuenta de la lista') : _yup2.default.string().required('Seleccione el Tipo de Cuenta de la lista'),
	            //.max(30, 'El máximo es 30 caracteres'),
	            numeroCuenta: _yup2.default.string().default(_this.props.usuario.numeroCuenta).required('Escriba el Número de Cuenta').max(30, 'El máximo es 30 caracteres'),
	            idCaptador: _this.props.usuario.idCaptador != 0 ? _yup2.default.number().default(parseInt(_this.props.usuario.idCaptador)).required('Seleccione su Captador') : _yup2.default.string().required('Seleccione su Captador'),
	            cutRegion: _this.props.usuario.cutRegion != 0 ? _yup2.default.number().default(parseInt(_this.props.usuario.cutRegion)).required('Seleccione una Region') : _yup2.default.string().required('Seleccione una Region'),
	            otraNacionalidad: _yup2.default.string().required('Ingrese la nacionalidad de la persona')
	            /*DNIFront: yup.mixed()
	                .required('Suba el archivo correspondiente'),*/
	        });
	
	        _this.state = {
	            showModal: false,
	            datos: [],
	            region: "",
	            comuna: "",
	            captador: "",
	            banco: "",
	            cuenta: "",
	            bcoEstado: false,
	            ctaRut: false,
	            comunas: [],
	            captadores: [],
	            cambioRegion: false,
	            inputNacion: false,
	            modalDNI: false,
	            user: [],
	            checkDNIFront: false,
	            checkDNIBack: false,
	            chekcFechaVenc: false,
	            btnDocs: false,
	            confirmando: false
	        };
	        console.log(_this.props.usuario);
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.bcoEstado = function (event) {
	            if (event.idBanco == 3) {
	                _this.setState({
	                    bcoEstado: true
	                });
	            } else {
	                _this.setState({
	                    bcoEstado: false
	                });
	            }
	        };
	        _this.cuentaRut = function (event) {
	            if (event.idCuenta == 5) {
	                _this.setState({
	                    ctaRut: true
	                });
	            } else {
	                _this.setState({
	                    ctaRut: false
	                });
	            }
	        };
	        _this.changeRegion = function (event) {
	
	            var comunasNuevas = _this.props.usuario.comunas.filter(function (co) {
	                return co.cutRegion == event.cutRegion;
	            });
	            if (event.cutRegion == 1) {
	                var captadoresNuevos = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Manuel  Mely';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: captadoresNuevos,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 2) {
	                var captador1 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Cristina  Valencia ';
	                });
	                var captador2 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Manuel  Mely';
	                });
	                var _captadoresNuevos = captador1.concat(captador2);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 3) {
	                var _captadoresNuevos2 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Manuel  Mely';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos2,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 4) {
	                var _captadoresNuevos3 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Manuel  Mely';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos3,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 5) {
	                var _captadoresNuevos4 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Ana Torres';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos4,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 6) {
	                var _captadoresNuevos5 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos5,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 7) {
	                var _captador = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'RMaule VII';
	                });
	                var _captador2 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                var _captadoresNuevos6 = _captador.concat(_captador2);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos6,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 8) {
	                //console.log(this.props.usuario.captadores);
	                var _captador3 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'SEI Concepción';
	                });
	                var _captador4 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Pamela Aedo';
	                });
	                var captador3 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                var _captadoresNuevos7 = _captador3.concat(_captador4, captador3);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos7,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 9) {
	                var _captadoresNuevos8 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Pamela Aedo';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos8,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 10) {
	                var _captador5 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'SEI SUR ';
	                });
	                var _captador6 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Pamela Aedo';
	                });
	                var _captador7 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                var _captadoresNuevos9 = _captador5.concat(_captador6, _captador7);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos9,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 11) {
	                var _captador8 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'SEI Coyhaique';
	                });
	                var _captador9 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                var _captadoresNuevos10 = _captador8.concat(_captador9);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos10,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 12) {
	                var _captadoresNuevos11 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos11,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 13) {
	                var _captadoresNuevos12 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Región Metropolitana';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos12,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 14) {
	                var _captador10 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'SEI SUR ';
	                });
	                var _captador11 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Pamela Aedo';
	                });
	                var _captador12 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Marcia Espinoza';
	                });
	                var _captadoresNuevos13 = _captador10.concat(_captador11, _captador12);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos13,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 15) {
	                var _captadoresNuevos14 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Manuel  Mely';
	                });
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos14,
	                    cambioRegion: true
	                });
	            }
	            if (event.cutRegion == 16) {
	                var _captador13 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Nicolle Ortega';
	                });
	                var _captador14 = _this.props.usuario.captadores.filter(function (ca) {
	                    return ca.nombre == 'Alicia Ríos';
	                });
	                var _captadoresNuevos15 = _captador13.concat(_captador14);
	                _this.setState({
	                    comunas: comunasNuevas,
	                    captadores: _captadoresNuevos15,
	                    cambioRegion: true
	                });
	            }
	        };
	        _this.changeNacionalidad = function (event) {
	            if (event == 'Otra') {
	                _this.setState({
	                    inputNacion: true
	                });
	            } else {
	                _this.setState({
	                    inputNacion: false
	                });
	            }
	        };
	        _this.mostrarModal = function (datos) {
	            if (!datos.idBanco || !datos.idTipoCuenta || !datos.sexo) {
	                alert('NO OLVIDE LLENAR TODOS LOS CAMPOS');
	            } else {
	                var comuna = _this.props.usuario.comunas.find(function (c) {
	                    return c.cutComuna == datos.cutComuna;
	                });
	                var banco = _this.props.usuario.bancos.find(function (b) {
	                    return b.idBanco == datos.idBanco;
	                });
	                var cuenta = _this.props.usuario.cuentas.find(function (t) {
	                    return t.idCuenta == datos.idTipoCuenta;
	                });
	                var region = _this.props.usuario.regiones.find(function (r) {
	                    return r.cutRegion == datos.cutRegion;
	                });
	                var captador = _this.props.usuario.captadores.find(function (ca) {
	                    return ca.idCaptador == datos.idCaptador;
	                });
	                if (_this.state.bcoEstado && _this.state.ctaRut) {
	                    datos.numeroCuenta = datos.usuarioRUN;
	                }
	                _this.setState({
	                    showModal: true,
	                    datos: datos,
	                    comuna: comuna,
	                    banco: banco,
	                    cuenta: cuenta,
	                    region: region,
	                    captador: captador
	                });
	            }
	            //console.log(datos)
	        };
	        _this.showModalDocs = function () {
	            _this.setState({
	                modalDNI: true,
	                showModal: false
	            });
	        };
	        _this.cancelModal = function () {
	            _this.setState({
	                showModal: false,
	                datos: [],
	                comuna: "",
	                banco: "",
	                cuenta: "",
	                confirmando: false
	            });
	        };
	        _this.cancelModalDNI = function () {
	            _this.setState({
	                modalDNI: false,
	                user: []
	            });
	        };
	        _this.nuevoUsuario = function (datos) {
	            _this.setState({
	                confirmando: true
	            });
	            var banco = _this.props.usuario.bancos.find(function (banco) {
	                return banco.idBanco == datos.idBanco;
	            });
	            var tipoCuenta = _this.props.usuario.cuentas.find(function (cuenta) {
	                return cuenta.idCuenta == datos.idTipoCuenta;
	            });
	            if (datos.nacionalidad == 'Otra') {
	                datos.nacionalidad = datos.otraNacionalidad;
	            }
	            datos.idBanco = banco.idBanco;
	            datos.idTipoCuenta = tipoCuenta.idCuenta;
	            _v2.default.usuarios.registrarOperador(datos).then(function (resp) {
	                console.log(resp);
	                _this.setState({
	                    checkDNIFront: resp.existingCarnetFront ? true : false,
	                    checkDNIBack: resp.existingCarnetBack ? true : false,
	                    showModal: false,
	                    datos: [],
	                    comuna: "",
	                    banco: "",
	                    cuenta: "",
	                    modalDNI: true,
	                    user: resp,
	                    btnDocs: true,
	                    confirmando: false
	                });
	            }).catch(function (err) {
	                console.log(err);
	                var errores = err.data;
	                var mensaje = '';
	                for (var i in errores) {
	                    mensaje += i + ": " + errores[i][0] + '\n';
	                }
	                alert(errores);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(RegistroOperador, [{
	        key: 'enviarFormularioInvalido',
	        value: function enviarFormularioInvalido(datos) {
	            console.log('enviando invalido ', datos);
	        }
	    }, {
	        key: 'siguienteComponente',
	        value: function siguienteComponente(refComponente, evt) {
	            if (evt.key == 'Enter') {
	                evt.preventDefault();
	                if (refComponente === 'refFechaNacimiento') {
	                    //this.refFechaNacimiento.refs.input.focus() // OK para el wrapper
	                    this.refFechaNacimiento.refs.input.focus(); // OK para el date2
	                } else if (refComponente === 'refComuna') {
	                    this.refComuna.refs.input.refs.inner.open(); // OK para el date2
	                } else if (refComponente === 'refSexo') {
	                    this.refSexo.refs.input.focus();
	                    this.refSexo.refs.input.refs.inner.open();
	                } else if (refComponente === 'refIdBanco') {
	                    this.refIdBanco.refs.input.focus();
	                    this.refIdBanco.refs.input.refs.inner.open();
	                } else if (refComponente === 'refIdTipoCuenta') {
	                    this.refIdTipoCuenta.refs.input.focus();
	                    this.refIdTipoCuenta.refs.input.refs.inner.open();
	                } else if (refComponente === 'refRegion') {
	                    this.refRegion.refs.input.focus();
	                    this.refRegion.refs.input.refs.inner.open();
	                } else if (refComponente === 'refOtraNacionalidad') {
	                    this.refOtraNacionalidad.refs.input.focus();
	                    this.refOtraNacionalidad.refs.input.refs.inner.open();
	                } else if (refComponente === 'refIdCaptador') {
	                    this.refIdCaptador.refs.input.focus();
	                    this.refIdCaptador.refs.input.refs.inner.open();
	                } else {
	                    _reactDom2.default.findDOMNode(this[refComponente].refs.input).select();
	                }
	                // console.log( ReactDOM.findDOMNode(this.refNombre1).focus() ) // OK
	                // console.log( ReactDOM.findDOMNode(this.refNombre1.refs.input).focus() ) // OK
	                return;
	            }
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                uploadDNIFront: function uploadDNIFront(idUser, file) {
	                    var data = new FormData();
	                    data.append('DNIFront', file);
	                    var request = _v2.default.usuario(idUser).uploadOperadorFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CARNET", "Foto frontal agregada correctamente", 4 * 1000);
	                        _this2.setState({
	                            checkDNIFront: true
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Error al subir foto frontal carnet'));
	                    return request;
	                },
	                uploadDNIBack: function uploadDNIBack(idUser, file) {
	                    var data = new FormData();
	                    data.append('DNIBack', file);
	                    var request = _v2.default.usuario(idUser).uploadOperadorFile(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CARNET", "Foto posterior agregada correctamente", 4 * 1000);
	                        _this2.setState({
	                            checkDNIBack: true
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Error al subir foto posterior carnet'));
	                    return request;
	                },
	                uploadFechaVenc: function uploadFechaVenc(idUser, fecha, event) {
	                    var data = new FormData();
	                    data.append('fecha', fecha);
	                    //console.log(fecha)
	                    event.preventDefault();
	                    var request = _v2.default.usuario(idUser).uploadFechaVenc(data);
	                    request.then(function (response) {
	                        _this2.refs.notificator.success("CARNET", "Fecha de vencimiento agregada correctamente", 4 * 1000);
	                        _this2.setState({
	                            chekcFechaVenc: true
	                        });
	                    }).catch(_this2.ajaxErrorHandler('Error al subir fecha de vencimiento carnet'));
	                    return request;
	                }
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            //console.log(this.props.usuario)
	            var arrayCaptadores = this.props.usuario.idCaptador != 658 ? this.props.usuario.captadores.filter(function (cap) {
	                return cap.idCaptador != 658;
	            }) : this.props.usuario.captadores;
	            var bancoEstado = this.props.usuario.bancos.filter(function (b) {
	                return b.nombreCorto == 'Banco Estado';
	            });
	            var otrosBancos = this.props.usuario.bancos.filter(function (b) {
	                return b.nombreCorto != 'Banco Estado';
	            });
	            var bancosSorted = bancoEstado.concat(otrosBancos);
	            var regionesSorted = this.props.usuario.regiones.filter(function (r) {
	                return r.cutRegion < 20;
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                    _react2.default.createElement(_Modals.ModalConfirmar, {
	                        showModal: this.state.showModal,
	                        cancelModal: this.cancelModal,
	                        confirmar: this.nuevoUsuario,
	                        datos: this.state.datos,
	                        comuna: this.state.comuna,
	                        banco: this.state.banco,
	                        cuenta: this.state.cuenta,
	                        region: this.state.region,
	                        captador: this.state.captador,
	                        confirmando: this.state.confirmando
	                    }),
	                    _react2.default.createElement(_Modals.ModalUploadFiles, {
	                        user: this.state.user,
	                        showModal: this.state.modalDNI,
	                        cancelModal: this.cancelModalDNI,
	                        checkFront: this.state.checkDNIFront,
	                        checkBack: this.state.checkDNIBack,
	                        checkFechaVenc: this.state.chekcFechaVenc
	                    }),
	                    _react2.default.createElement(
	                        _reactFormal2.default,
	                        {
	                            className: 'form-horizontal',
	                            schema: this.usuarioSchema,
	                            defaultValue: this.usuarioSchema.default(),
	                            delay: 1000,
	                            noValidate: true,
	                            onSubmit: this.mostrarModal,
	                            onInvalidSubmit: this.enviarFormularioInvalido.bind(this)
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { textAlign: 'center' } },
	                                    'Datos Personales'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'RUN (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-3' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                            name: 'usuarioRUN'
	                                            //disabled={true}
	                                            , mapValue: {
	                                                usuarioRUN: function usuarioRUN(_usuarioRUN) {
	                                                    return _usuarioRUN;
	                                                },
	                                                usuarioDV: function usuarioDV(usuarioRUN) {
	                                                    return (0, _ValidadorRUN.obtenerVerificador)(usuarioRUN);
	                                                }
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refNombre1'),
	                                            required: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-2' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'),
	                                            name: 'usuarioDV',
	                                            disabled: true,
	                                            ref: function ref(_ref) {
	                                                return _this3.refUsuarioDV = _ref;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refNombre1'),
	                                            required: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': ['usuarioRUN', 'usuarioDV'], errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Nombres (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Primer Nombre',
	                                            name: 'nombre1',
	                                            ref: function ref(_ref2) {
	                                                return _this3.refNombre1 = _ref2;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'nombre2'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre1', errorClass: cx('form__message-error') })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Segundo Nombre',
	                                            name: 'nombre2',
	                                            ref: function ref(_ref3) {
	                                                return _this3.refNombre2 = _ref3;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refApellidoPaterno'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nombre2', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Apellidos (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', errorClass: cx('form__field--error'), placeholder: 'Apellido Paterno',
	                                            name: 'apellidoPaterno',
	                                            ref: function ref(_ref4) {
	                                                return _this3.refApellidoPaterno = _ref4;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refApellidoMaterno'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoPaterno', errorClass: cx('form__message-error') })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Apellido Materno',
	                                            name: 'apellidoMaterno',
	                                            ref: function ref(_ref5) {
	                                                return _this3.refApellidoMaterno = _ref5;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refFechaNacimiento'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'apellidoMaterno', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Fecha Nacimiento (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'date2', time: false, errorClass: cx('form__field--error'), placeholder: 'Ej. 31-07-2016',
	                                            name: 'fechaNacimiento',
	                                            format: 'D-M-YYYY',
	                                            editFormat: 'D-M-YYYY',
	                                            ref: function ref(_ref6) {
	                                                return _this3.refFechaNacimiento = _ref6;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refSexo'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'fechaNacimiento', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Sexo (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { name: 'sexo', errorClass: cx('form__field--error'),
	                                            type: 'dropdownlist',
	                                            data: ['Masculino', 'Femenino', 'Otro'],
	                                            duration: 0,
	                                            ref: function ref(_ref7) {
	                                                return _this3.refSexo = _ref7;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refNacionalidad'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'sexo', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Nacionalidad (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'nacionalidad',
	                                            data: ['Chilena', 'Venezolana', 'Otra'],
	                                            ref: function ref(_ref8) {
	                                                return _this3.refNacionalidad = _ref8;
	                                            },
	                                            duration: 10,
	                                            onKeyPress: this.state.inputNacion ? this.siguienteComponente.bind(this, 'refOtraNacionalidad') : this.siguienteComponente.bind(this, 'refTelefono'),
	                                            onChange: function onChange(e) {
	                                                return _this3.changeNacionalidad(e);
	                                            },
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nacionalidad', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                this.state.inputNacion ? _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Nacionalidad (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Escriba su nacionalidad',
	                                            name: 'otraNacionalidad',
	                                            ref: function ref(_ref9) {
	                                                return _this3.refOtraNacionalidad = _ref9;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refCarnetFrente'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'otraNacionalidad', errorClass: cx('form__message-error') })
	                                    )
	                                ) : null
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { textAlign: 'center' } },
	                                    'Contacto'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("telefonos") },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Pedimos que los tel\xE9fonos ingresados sean ver\xEDdicos, ya que esta informaci\xF3n ser\xE1 utilizada m\xE1s adelante.'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Telefonos (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5', style: { display: 'flex', flexDirection: 'row' } },
	                                        _react2.default.createElement('input', { className: 'form-control', type: 'text', disabled: true, readOnly: true, value: '+56', style: { textAlign: 'center' } }),
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: '978164162',
	                                            name: 'telefono',
	                                            ref: function ref(_ref10) {
	                                                return _this3.refTelefono = _ref10;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refTelefonoEmergencia'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefono', errorClass: cx('form__message-error') })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5', style: { display: 'flex', flexDirection: 'row' } },
	                                        _react2.default.createElement('input', { className: 'form-control', type: 'text', disabled: true, readOnly: true, value: '+56', style: { textAlign: 'center' } }),
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Telefono Emergencia',
	                                            name: 'telefonoEmergencia',
	                                            ref: function ref(_ref11) {
	                                                return _this3.refTelefonoEmergencia = _ref11;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refEmailPersonal'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'telefonoEmergencia', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Email (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Email personal',
	                                            name: 'emailPersonal',
	                                            ref: function ref(_ref12) {
	                                                return _this3.refEmailPersonal = _ref12;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refRegion'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'emailPersonal', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Region (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'cutRegion',
	                                            data: regionesSorted,
	                                            valueField: 'cutRegion',
	                                            textField: 'nombre'
	                                            //filter='startsWith'
	                                            , mapValue: { 'cutRegion': function cutRegion(region) {
	                                                    return region.cutRegion;
	                                                } },
	                                            duration: 10,
	                                            ref: function ref(_ref13) {
	                                                return _this3.refRegion = _ref13;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refComuna'),
	                                            onChange: function onChange(r) {
	                                                return _this3.changeRegion(r);
	                                            },
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'cutRegion', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Comuna (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'cutComuna',
	                                            data: this.state.comunas.length > 0 ? this.state.comunas : this.props.usuario.comunas,
	                                            valueField: 'cutComuna',
	                                            textField: 'nombre'
	                                            //groupBy='cutProvincia'
	                                            , filter: 'startsWith',
	                                            mapValue: { 'cutComuna': function cutComuna(comuna) {
	                                                    return comuna.cutComuna;
	                                                } },
	                                            duration: 10,
	                                            ref: function ref(_ref14) {
	                                                return _this3.refComuna = _ref14;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refDireccion'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'cutComuna', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Direcci\xF3n (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-10' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', placeholder: 'Direcci\xF3n',
	                                            name: 'direccion',
	                                            ref: function ref(_ref15) {
	                                                return _this3.refDireccion = _ref15;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refIdCaptador'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'direccion', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Captador (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'idCaptador',
	                                            data: this.state.captadores.length > 0 ? this.state.captadores : arrayCaptadores
	                                            //data={this.state.captadores.length > 0 ? this.state.captadores : captadoresFinal}
	                                            , valueField: 'idCaptador',
	                                            textField: 'nombre'
	                                            //groupBy='cutProvincia'
	                                            , filter: 'startsWith',
	                                            mapValue: { 'idCaptador': function idCaptador(captador) {
	                                                    return captador.idCaptador ? captador.idCaptador : "";
	                                                } },
	                                            ref: function ref(_ref16) {
	                                                return _this3.refIdCaptador = _ref16;
	                                            },
	                                            duration: 10,
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refIdBanco'),
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'nacionalidad', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { textAlign: 'center' } },
	                                    'Datos Bancarios'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Banco (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-6' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'idBanco',
	                                            data: bancosSorted,
	                                            valueField: 'idBanco',
	                                            textField: 'nombreCorto',
	                                            filter: 'startsWith',
	                                            mapValue: { 'idBanco': function idBanco(banco) {
	                                                    return banco.idBanco;
	                                                } },
	                                            duration: 10,
	                                            ref: function ref(_ref17) {
	                                                return _this3.refIdBanco = _ref17;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refIdTipoCuenta'),
	                                            onChange: function onChange(c) {
	                                                return _this3.bcoEstado(c);
	                                            },
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'idBanco', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Tipo Cuenta (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-6' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { type: 'dropdownlist', errorClass: cx('form__field--error'),
	                                            name: 'idTipoCuenta',
	                                            data: this.props.usuario.cuentas,
	                                            valueField: 'idCuenta',
	                                            textField: 'nombreCuenta',
	                                            filter: 'startsWith',
	                                            mapValue: { 'idTipoCuenta': function idTipoCuenta(cuenta) {
	                                                    return cuenta.idCuenta;
	                                                } },
	                                            duration: 10,
	                                            ref: function ref(_ref18) {
	                                                return _this3.refIdTipoCuenta = _ref18;
	                                            },
	                                            onKeyPress: this.siguienteComponente.bind(this, 'refNumeroCuenta'),
	                                            onChange: function onChange(c) {
	                                                return _this3.cuentaRut(c);
	                                            },
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'tipoCuenta', errorClass: cx('form__message-error') })
	                                    )
	                                ),
	                                this.state.bcoEstado && this.state.ctaRut ? null : _react2.default.createElement(
	                                    'div',
	                                    { className: cx("form-group", 'form__control-label') },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-2 control-label' },
	                                        'Numero Cuenta (*)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-6' },
	                                        _react2.default.createElement(_reactFormal2.default.Field, { className: 'form-control', name: 'numeroCuenta', placeholder: 'Ej. 123-456-789-9',
	                                            ref: function ref(_ref19) {
	                                                return _this3.refNumeroCuenta = _ref19;
	                                            },
	                                            required: true
	                                        }),
	                                        _react2.default.createElement(_reactFormal2.default.Message, { 'for': 'numeroCuenta', errorClass: cx('form__message-error') })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: cx("col-sm-12", 'form__footer') },
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-default', href: '/operadores' },
	                                    'Cancelar'
	                                ),
	                                _react2.default.createElement(
	                                    _reactFormal2.default.Button,
	                                    { type: 'submit', className: 'btn btn-primary' },
	                                    'Confirmar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RegistroOperador;
	}(_react2.default.Component);
	
	RegistroOperador.propTypes = {
	    usuario: _propTypes2.default.object,
	    enviarFormulario: _propTypes2.default.func,
	    cancelarFormulario: _propTypes2.default.func,
	    comunas: _propTypes2.default.array,
	    captadores: _propTypes2.default.array,
	    bancos: _propTypes2.default.array,
	    cuentas: _propTypes2.default.array,
	    regiones: _propTypes2.default.array,
	    btnTexto: _propTypes2.default.string
	};
	
	RegistroOperador.childContextTypes = {
	    uploadDNIFront: _propTypes2.default.func,
	    uploadDNIBack: _propTypes2.default.func,
	    uploadFechaVenc: _propTypes2.default.func,
	    //uploadCertificate: PropTypes.func,
	    //uploadContract: PropTypes.func,
	    //uploadCredential: PropTypes.func,
	    progressStatusDocumentation: _propTypes2.default.func,
	    isWrongFile: _propTypes2.default.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "registro.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form__control-label":"formularioUsuario__form__control-label___3gYmq","form__footer":"formularioUsuario__form__footer___3iuIH","form__message-error":"formularioUsuario__form__message-error___3vAYi","form__field--error":"formularioUsuario__form__field--error___TZGSz","telefonos":"formularioUsuario__telefonos___XzGMp"};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalUploadFiles = exports.ModalConfirmar = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1185);
	
	var css = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Style
	
	var cx = _bind2.default.bind(css);
	
	// function as a children FTW! :D
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalConfirmar = exports.ModalConfirmar = function (_React$Component2) {
	    _inherits(ModalConfirmar, _React$Component2);
	
	    function ModalConfirmar(props) {
	        _classCallCheck(this, ModalConfirmar);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalConfirmar.__proto__ || Object.getPrototypeOf(ModalConfirmar)).call(this, props));
	
	        _this2.state = {};
	        return _this2;
	    }
	
	    _createClass(ModalConfirmar, [{
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal /*className={cx('modal')} dialogClassName={cx('modalUser')}*/ },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Favor confirme su registro'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        { style: { textAlign: 'center' } },
	                        'Verifique si sus datos son correctos antes de confirmar'
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('tab') },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'RUN:'
	                            ),
	                            ' ',
	                            this.props.datos.usuarioRUN,
	                            '-',
	                            this.props.datos.usuarioDV,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Nombre:'
	                            ),
	                            ' ',
	                            this.props.datos.nombre1 + " " + this.props.datos.nombre2 + " " + this.props.datos.apellidoPaterno + " " + this.props.datos.apellidoMaterno,
	                            _react2.default.createElement('br', null)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('tab') },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Fecha nacimiento:'
	                            ),
	                            ' ',
	                            this.props.datos.fechaNacimiento ? this.props.datos.fechaNacimiento.toLocaleDateString() : this.props.datos.fechaNacimiento,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Sexo:'
	                            ),
	                            ' ',
	                            this.props.datos.sexo,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Nacionalidad:'
	                            ),
	                            ' ',
	                            this.props.datos.otraNacionalidad ? this.props.datos.otraNacionalidad : this.props.datos.nacionalidad
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: cx('tab') },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Tel\xE9fono:'
	                            ),
	                            ' ',
	                            this.props.datos.telefonoEmergencia != "" ? this.props.datos.telefono + " - " + this.props.datos.telefonoEmergencia : this.props.datos.telefono,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Email:'
	                            ),
	                            ' ',
	                            this.props.datos.emailPersonal,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Comuna:'
	                            ),
	                            ' ',
	                            this.props.comuna.nombre,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Regi\xF3n:'
	                            ),
	                            ' ',
	                            this.props.region.nombre,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Direcci\xF3n:'
	                            ),
	                            ' ',
	                            this.props.datos.direccion,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Captador:'
	                            ),
	                            ' ',
	                            this.props.captador.nombre
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Banco:'
	                            ),
	                            ' ',
	                            this.props.banco.nombreCorto,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Tipo cuenta:'
	                            ),
	                            ' ',
	                            this.props.cuenta.nombreCuenta,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'N\xFAmero cuenta:'
	                            ),
	                            ' ',
	                            this.props.datos.numeroCuenta
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center' } },
	                        'Despu\xE9s de confirmar, podr\xE1 subir fotos o im\xE1genes de su documento de identidad'
	                    ),
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-warning', onClick: this.props.cancelModal },
	                        'Cancelar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: function onClick() {
	                                return _this3.props.confirmar(_this3.props.datos);
	                            }, disabled: this.props.confirmando },
	                        'Confirmar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalConfirmar;
	}(_react2.default.Component);
	
	var ModalUploadFiles = exports.ModalUploadFiles = function (_React$Component3) {
	    _inherits(ModalUploadFiles, _React$Component3);
	
	    function ModalUploadFiles(props) {
	        _classCallCheck(this, ModalUploadFiles);
	
	        var _this4 = _possibleConstructorReturn(this, (ModalUploadFiles.__proto__ || Object.getPrototypeOf(ModalUploadFiles)).call(this, props));
	
	        _this4.state = {
	            frontDNI: '',
	            backDNI: '',
	            fechaVenc: '',
	            fecha: '',
	            boton: false,
	            certificatePersonalHistory: '',
	            contract: '',
	            credential: '',
	            completededDocumentation: _this4.props.user.statusFiles === 'Cargados',
	            existingCarnetFront: _this4.props.user.existingCarnetFront,
	            existingCarnetBack: _this4.props.user.existingCarnetBack
	        };
	        _this4.onChangeDNIFront = function (evt) {
	            _this4.setState({
	                frontDNI: evt.target.files[0]
	            }, function () {
	                return _this4.context.uploadDNIFront(_this4.props.user.id, _this4.state.frontDNI);
	            });
	        };
	        _this4.onChangeDNIBack = function (evt) {
	            _this4.setState({
	                backDNI: evt.target.files[0]
	            }, function () {
	                return _this4.context.uploadDNIBack(_this4.props.user.id, _this4.state.backDNI);
	            });
	        };
	        _this4.fechaDNI = function (evt) {
	            evt.preventDefault();
	            _this4.setState({
	                fechaVenc: _this4.state.fecha
	            }, function () {
	                return _this4.context.uploadFechaVenc(_this4.props.user.id, _this4.state.fechaVenc, evt);
	            });
	        };
	        _this4.onChangeCertificate = function (evt) {
	            _this4.setState({
	                certificatePersonalHistory: evt.target.files[0]
	            }, function () {
	                return _this4.context.uploadCertificate(_this4.props.idUsuario, _this4.state.certificatePersonalHistory);
	            });
	        };
	        _this4.onChangeContract = function (evt) {
	            _this4.setState({
	                contract: evt.target.files[0]
	            }, function () {
	                return _this4.context.uploadContract(_this4.props.idUsuario, _this4.state.contract);
	            });
	        };
	        _this4.onChangeCredential = function (evt) {
	            _this4.setState({
	                credential: evt.target.files[0]
	            }, function () {
	                return _this4.context.uploadCredential(_this4.props.idUsuario, _this4.state.credential);
	            });
	        };
	        _this4.onChangeProgress = function () {
	            var status = !_this4.state.completededDocumentation;
	            var request = _this4.context.progressStatusDocumentation(_this4.props.idUsuario, status);
	            request.then(function (files) {
	                _this4.setState({ completededDocumentation: status });
	            }).catch(function () {
	                console.log("error");
	            });
	        };
	        _this4.handleFecha = function (event) {
	            _this4.setState({ fecha: event.target.value, boton: true });
	        };
	        return _this4;
	    }
	
	    _createClass(ModalUploadFiles, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal, className: cx('modal') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Subir documentos de usuario'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: cx('btn-group-vertical', 'div-option-file') },
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.props.checkFront ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.props.checkFront ? 'Reemplazar ' : 'Subir ',
	                            'Imagen Carnet Frontal',
	                            _react2.default.createElement('input', { type: 'file', accept: 'image/*', onChange: this.onChangeDNIFront })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: cx(this.props.checkBack ? 'btn btn-success' : 'btn btn-warning', 'btn-file'), disabled: this.state.completededDocumentation },
	                            this.props.checkBack ? 'Reemplazar ' : 'Subir ',
	                            'Imagen Carnet Posterior',
	                            _react2.default.createElement('input', { type: 'file', accept: 'image/*', onChange: this.onChangeDNIBack })
	                        )
	                    ),
	                    //this.props.checkFront && this.props.checkBack ? 
	                    _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center', marginTop: '5px' } },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: this.fechaDNI },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Fecha de Vencimiento: '
	                            ),
	                            _react2.default.createElement('input', { type: 'date', value: this.state.fecha, onChange: this.handleFecha, format: 'D-M-YYYY', style: { margin: '5px' } }),
	                            _react2.default.createElement('input', { type: 'submit', value: 'Subir Fecha', style: { margin: '5px' }, disabled: !this.state.boton })
	                        )
	                    ) //: null
	
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/', style: { color: 'white' } },
	                            'Finalizar Registro'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalUploadFiles;
	}(_react2.default.Component);
	
	ModalUploadFiles.contextTypes = {
	    uploadDNIFront: PropTypes.func,
	    uploadDNIBack: PropTypes.func,
	    uploadFechaVenc: PropTypes.func,
	    uploadCertificate: PropTypes.func,
	    uploadContract: PropTypes.func,
	    uploadCredential: PropTypes.func,
	    progressStatusDocumentation: PropTypes.func
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modals.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"modal__modal___2g_Aa","modalUser":"modal__modalUser___2IPaH","modalReviewFiles":"modal__modalReviewFiles___gCF5a","btnPreviewNext":"modal__btnPreviewNext___9A4vz","textInfo":"modal__textInfo____wBKt","selectCliente":"modal__selectCliente___3LLWC","bloquearUsuario_footer":"modal__bloquearUsuario_footer___5AQrn","cambiarContrasena_footer":"modal__cambiarContrasena_footer___2SZvB","editarUsuario_footer":"modal__editarUsuario_footer___2WzH_","btn-50-perc":"modal__btn-50-perc___6_gpH","btn-file":"modal__btn-file___1kqDN","btnModal":"modal__btnModal___124Gw","div-option-file":"modal__div-option-file___1tEQj","originalImage":"modal__originalImage___15vKE","tab":"modal__tab___3JHm9"};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EsDeRegion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var EsDeRegion = exports.EsDeRegion = function (_React$Component) {
	    _inherits(EsDeRegion, _React$Component);
	
	    function EsDeRegion(props) {
	        _classCallCheck(this, EsDeRegion);
	
	        var _this = _possibleConstructorReturn(this, (EsDeRegion.__proto__ || Object.getPrototypeOf(EsDeRegion)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EsDeRegion, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container', style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-10 col-md-offset-1' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-danger' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading' },
	                                'Sin permisos'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                'Lo sentimos, esta funcionalidad de momento est\xE1 disponible s\xF3lo para usuarios de ciertas regiones, si est\xE1 viendo esto es probable que su regi\xF3n no est\xE9 disponible actualmente, lamentamos cualquier incoveniente y agradecemos su paciencia.'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/', style: { color: 'white' } },
	                        'Volver'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EsDeRegion;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "esDeRegion.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OperadoresPendientes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _TablaPendientes = __webpack_require__(1188);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	
	// ReactNotify
	
	var OperadoresPendientes = exports.OperadoresPendientes = function (_React$Component) {
	    _inherits(OperadoresPendientes, _React$Component);
	
	    function OperadoresPendientes(props) {
	        _classCallCheck(this, OperadoresPendientes);
	
	        var _this = _possibleConstructorReturn(this, (OperadoresPendientes.__proto__ || Object.getPrototypeOf(OperadoresPendientes)).call(this, props));
	
	        _this.state = {
	            usuariosRAW: [],
	            usuarios: [],
	            busquedaComuna: '',
	            busquedaRUN: '',
	            busquedaNombre: '',
	            busquedaApellido: '',
	            busquedaCaptador: '',
	            checked: false,
	            canceled: false
	        };
	
	        _this.ajaxErrorHandler = function (errorTitle) {
	            return function (err) {
	                if (err.status == 500) return _this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
	                var msgs = _.values(err.data).join('. ');
	                console.log(err);
	                console.log(errorTitle, err.data);
	                _this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
	            };
	        };
	        _this.fetchUsuarios = function () {
	            _this.setState({
	                usuariosRaw: []
	            });
	            _v2.default.usuarios.fetchPendientes().then(function (usuarios) {
	                _this.setState({
	                    usuariosRAW: usuarios
	                }, _this.filtrarUsuarios);
	            });
	        };
	        _this.confirmarOperador = function (data) {
	            _v2.default.usuarios.confirmarOperador(data).then(function (usuarios) {
	                _this.filtrarUsuarios;
	                _this.setState({
	                    checked: true
	                });
	            });
	        };
	        _this.realizarBusqueda = function (campo, busquedaOriginal) {
	            var newState = {};
	            newState[campo] = busquedaOriginal.trim().toLowerCase();
	            _this.setState(newState, _this.filtrarUsuarios);
	        };
	        _this.filtrarUsuarios = function () {
	            _this.setState({
	                usuarios: _this.state.usuariosRAW.filter(function (us) {
	                    return us.RUN.indexOf(_this.state.busquedaRUN) >= 0;
	                }).filter(function (us) {
	                    return us.apellidoPaterno.toLowerCase().indexOf(_this.state.busquedaApellido) >= 0 || us.apellidoMaterno.toLowerCase().indexOf(_this.state.busquedaApellido) >= 0;
	                }).filter(function (us) {
	                    return us.nombre1.toLowerCase().indexOf(_this.state.busquedaNombre) >= 0 || us.nombre2.toLowerCase().indexOf(_this.state.busquedaNombre) >= 0;
	                }).filter(function (us) {
	                    return us.captador.toLowerCase().indexOf(_this.state.busquedaCaptador) >= 0;
	                }).filter(function (us) {
	                    return us.comuna.toLowerCase().indexOf(_this.state.busquedaComuna) >= 0;
	                })
	            });
	        };
	        return _this;
	    }
	
	    _createClass(OperadoresPendientes, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchUsuarios();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                console.log(this.state.usuarios),
	                _react2.default.createElement(_reactNotify2.default, { ref: 'notificator', className: ReactNotifyCSS }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Operadores Pendientes'
	                        )
	                    )
	                ),
	                _react2.default.createElement(_TablaPendientes.TablaPendientes, {
	                    usuarios: this.state.usuarios,
	                    perms: this.props.perms
	                    // busqueda
	                    , busquedaComuna: this.state.busquedaComuna,
	                    realizarBusquedaComuna: this.realizarBusqueda.bind(this, 'busquedaComuna'),
	                    busquedaRUN: this.state.busquedaRUN,
	                    realizarBusquedaRUN: this.realizarBusqueda.bind(this, 'busquedaRUN'),
	                    busquedaNombre: this.state.busquedaNombre,
	                    realizarBusquedaNombre: this.realizarBusqueda.bind(this, 'busquedaNombre'),
	                    busquedaApellido: this.state.busquedaApellido,
	                    realizarBusquedaApellido: this.realizarBusqueda.bind(this, 'busquedaApellido'),
	                    busquedaCaptador: this.state.busquedaCaptador,
	                    realizarBusquedaCaptador: this.realizarBusqueda.bind(this, 'busquedaCaptador'),
	                    fetchUsuarios: this.fetchUsuarios,
	                    confirmarOperador: this.confirmarOperador,
	                    checked: this.state.checked,
	                    canceled: this.state.canceled
	                })
	            );
	        }
	    }]);
	
	    return OperadoresPendientes;
	}(_react2.default.Component);
	/*OperadoresPendientes.childContextTypes = {
	    uploadDNIFront: PropTypes.func,
	    uploadDNIBack: PropTypes.func,
	    uploadCertificate: PropTypes.func,
	    uploadContract: PropTypes.func,
	    uploadCredential: PropTypes.func,
	    progressStatusDocumentation: PropTypes.func,
	    isWrongFile: PropTypes.func,
	}*/

	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "OperadoresPendientes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TablaPendientes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(653);
	
	var _HeaderConBusqueda = __webpack_require__(920);
	
	var _Modales = __webpack_require__(1189);
	
	var _TablaPendientes = __webpack_require__(1191);
	
	var css = _interopRequireWildcard(_TablaPendientes);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Styles
	
	var cx = _bind2.default.bind(css);
	
	var TablaPendientes = exports.TablaPendientes = function (_React$Component) {
	    _inherits(TablaPendientes, _React$Component);
	
	    function TablaPendientes() {
	        _classCallCheck(this, TablaPendientes);
	
	        return _possibleConstructorReturn(this, (TablaPendientes.__proto__ || Object.getPrototypeOf(TablaPendientes)).apply(this, arguments));
	    }
	
	    _createClass(TablaPendientes, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '50%', alignItems: 'center' } },
	                _react2.default.createElement(
	                    _reactVirtualized.AutoSizer,
	                    null,
	                    function (_ref) {
	                        var height = _ref.height,
	                            width = _ref.width;
	                        return _react2.default.createElement(
	                            _reactVirtualized.Table
	                            // general
	                            ,
	                            { height: height,
	                                width: width
	                                // headers
	                                , headerHeight: 30,
	                                headerClassName: css.headerColumn
	                                // rows
	                                , rowCount: _this2.props.usuarios.length,
	                                rowGetter: function rowGetter(_ref2) {
	                                    var index = _ref2.index;
	                                    return _this2.props.usuarios[index];
	                                },
	                                rowHeight: 40,
	                                rowClassName: function rowClassName(_ref3) {
	                                    var index = _ref3.index;
	                                    return index < 0 ? css.headerRow : index % 2 === 0 ? css.evenRow : css.oddRow;
	                                }
	                            },
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '#',
	                                label: '#',
	                                disableSort: true,
	                                cellRenderer: function cellRenderer(_ref4) {
	                                    var rowIndex = _ref4.rowIndex;
	                                    return rowIndex + 1;
	                                },
	                                width: 30
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'RUN',
	                                label: 'RUN',
	                                cellRenderer: function cellRenderer(_ref5) {
	                                    var rowData = _ref5.rowData,
	                                        dataKey = _ref5.dataKey;
	                                    return rowData[dataKey];
	                                },
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'RUN',
	                                        busqueda: _this2.props.busquedaRUN,
	                                        realizarBusqueda: _this2.props.realizarBusquedaRUN
	                                    });
	                                },
	                                width: 80
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'nombres',
	                                label: 'nombres',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Nombres',
	                                        busqueda: _this2.props.busquedaNombre,
	                                        realizarBusqueda: _this2.props.realizarBusquedaNombre
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref6) {
	                                    var rowData = _ref6.rowData;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.nombre1
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.nombre2
	                                        )
	                                    );
	                                },
	                                width: 140
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'apellidos',
	                                label: 'Apellidos',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Apellidos',
	                                        busqueda: _this2.props.busquedaApellido,
	                                        realizarBusqueda: _this2.props.realizarBusquedaApellido
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref7) {
	                                    var rowData = _ref7.rowData;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.apellidoPaterno
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { margin: 0 } },
	                                            rowData.apellidoMaterno
	                                        )
	                                    );
	                                },
	                                width: 140
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'comuna',
	                                label: 'Comuna',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Comunas',
	                                        busqueda: _this2.props.busquedaComuna,
	                                        realizarBusqueda: _this2.props.realizarBusquedaComuna
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref8) {
	                                    var dataKey = _ref8.dataKey,
	                                        rowData = _ref8.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 100
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: 'captador',
	                                label: 'Captador',
	                                headerRenderer: function headerRenderer() {
	                                    return _react2.default.createElement(_HeaderConBusqueda.HeaderConBusqueda, {
	                                        nombre: 'Captador',
	                                        busqueda: _this2.props.busquedaCaptador,
	                                        realizarBusqueda: _this2.props.realizarBusquedaCaptador
	                                    });
	                                },
	                                cellRenderer: function cellRenderer(_ref9) {
	                                    var dataKey = _ref9.dataKey,
	                                        rowData = _ref9.rowData;
	                                    return rowData[dataKey];
	                                },
	                                width: 100
	                            }),
	                            _react2.default.createElement(_reactVirtualized.Column, {
	                                dataKey: '',
	                                label: '',
	                                cellRenderer: function cellRenderer(_ref10) {
	                                    var cellData = _ref10.cellData,
	                                        columnData = _ref10.columnData,
	                                        dataKey = _ref10.dataKey,
	                                        rowData = _ref10.rowData,
	                                        rowIndex = _ref10.rowIndex;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { style: { marginLeft: '20px' } },
	                                        _react2.default.createElement(BotonAprobar, {
	                                            usuario: { rowData: rowData },
	                                            confirmar: _this2.props.confirmarOperador,
	                                            fetchUsuarios: _this2.props.fetchUsuarios
	                                        }),
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'btn btn-danger', title: 'Rechazar operador' },
	                                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove' })
	                                        ),
	                                        _react2.default.createElement(ButtonDownloadFiles, {
	                                            idUsuario: rowData.id
	                                        })
	                                    );
	                                },
	                                width: 360
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TablaPendientes;
	}(_react2.default.Component);
	
	TablaPendientes.propTypes = {
	    usuarios: PropTypes.arrayOf(PropTypes.object).isRequired,
	    // Metodos
	    fetchUsuarios: PropTypes.func.isRequired
	};
	
	var BotonAprobar = function BotonAprobar(_ref11) {
	    var usuario = _ref11.usuario,
	        confirmar = _ref11.confirmar,
	        fetchUsuarios = _ref11.fetchUsuarios;
	    return _react2.default.createElement(
	        _Modales.ModalTrigger,
	        null,
	        function (isVisible, showModal, hideModal) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-md btn-success', onClick: showModal, title: 'Aprobar operador' },
	                _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok' }),
	                isVisible && _react2.default.createElement(_Modales.ModalConfirmar, {
	                    usuario: usuario,
	                    confirmar: confirmar,
	                    hideModal: hideModal,
	                    fetchUsuarios: fetchUsuarios
	                })
	            );
	        }
	    );
	};
	
	var ButtonDownloadFiles = function ButtonDownloadFiles(_ref12) {
	    var idUsuario = _ref12.idUsuario;
	    return _react2.default.createElement(
	        'a',
	        { className: 'btn btn-md btn-primary', title: 'Descargar documentos de operador',
	            href: '/api/usuario/' + idUsuario + '/download/personal-files' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-download' })
	    );
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "TablaPendientes.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalConfirmar = exports.ModalTrigger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(488);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ZoomImagen = __webpack_require__(1078);
	
	var _InputRun = __webpack_require__(930);
	
	var _reactNotify = __webpack_require__(459);
	
	var _reactNotify2 = _interopRequireDefault(_reactNotify);
	
	var _ReactNotify = __webpack_require__(316);
	
	var ReactNotifyCSS = _interopRequireWildcard(_ReactNotify);
	
	var _bind = __webpack_require__(651);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _modal = __webpack_require__(1190);
	
	var css = _interopRequireWildcard(_modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Librerias
	
	
	var PropTypes = _react2.default.PropTypes;
	// Componentes
	
	// Notify
	
	// Style
	
	var cx = _bind2.default.bind(css);
	
	// function as a children FTW! :D
	
	var ModalTrigger = exports.ModalTrigger = function (_React$Component) {
	    _inherits(ModalTrigger, _React$Component);
	
	    function ModalTrigger(props) {
	        _classCallCheck(this, ModalTrigger);
	
	        var _this = _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, props));
	
	        _this.state = { visible: false };
	        var self = _this;
	        _this.show = function () {
	            return self.setState({ visible: true });
	        };
	        _this.hide = function () {
	            self.setState({ visible: false });
	        };
	        return _this;
	    }
	
	    _createClass(ModalTrigger, [{
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.state.visible, this.show, this.hide);
	        }
	    }]);
	
	    return ModalTrigger;
	}(_react2.default.Component);
	
	var ModalConfirmar = exports.ModalConfirmar = function (_React$Component2) {
	    _inherits(ModalConfirmar, _React$Component2);
	
	    function ModalConfirmar(props) {
	        _classCallCheck(this, ModalConfirmar);
	
	        var _this2 = _possibleConstructorReturn(this, (ModalConfirmar.__proto__ || Object.getPrototypeOf(ModalConfirmar)).call(this, props));
	
	        _this2.state = {
	            usuario: _this2.props.usuario,
	            show: true
	        };
	        _this2.editarUsuario = function (datos) {
	            var banco = _this2.props.datosbancos.bancos.find(function (banco) {
	                return banco.nombreCorto == datos.banco;
	            });
	            var tipoCuenta = _this2.props.datosbancos.tipo_cuentas.find(function (cuenta) {
	                return cuenta.nombreCuenta == datos.tipoCuenta;
	            });
	            datos.banco = banco.idBanco;
	            datos.tipoCuenta = tipoCuenta.idCuenta;
	            _v2.default.usuario(_this2.state.usuario.id).actualizar(datos).then(function (resp) {
	                _this2.props.fetchUsuarios();
	                _this2.props.hideModal();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        };
	        _this2.confirmar = function (datos) {
	            _this2.props.confirmar(datos);
	            _this2.setState({
	                show: false
	            });
	        };
	        return _this2;
	    }
	
	    _createClass(ModalConfirmar, [{
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.state.show, onHide: this.props.hideModal, className: cx('modal'), dialogClassName: cx('modalUser') },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        'Confirmando a operador(a): ',
	                        this.props.usuario.rowData.nombre1,
	                        ' ',
	                        this.props.usuario.rowData.apellidoPaterno
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    console.log(this.props.usuario, this.state.usuario),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Nombre: '
	                        ),
	                        this.props.usuario.rowData.nombre1,
	                        ' ',
	                        this.props.usuario.rowData.nombre2,
	                        ' ',
	                        this.props.usuario.rowData.apellidoPaterno,
	                        ' ',
	                        this.props.usuario.rowData.apellidoMaterno,
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'RUN: '
	                        ),
	                        this.props.usuario.rowData.RUN
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Region: '
	                        ),
	                        this.props.usuario.rowData.region,
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Comuna: '
	                        ),
	                        this.props.usuario.rowData.comuna,
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Captador: '
	                        ),
	                        this.props.usuario.rowData.captador
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success', onClick: function onClick() {
	                                return _this3.confirmar(_this3.props.usuario.rowData);
	                            } },
	                        'Aceptar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-danger', onClick: this.props.hideModal },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalConfirmar;
	}(_react2.default.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modales.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"modal__modal___1Q_7q","modalUser":"modal__modalUser___1iFmR","modalReviewFiles":"modal__modalReviewFiles___3OaTZ","btnPreviewNext":"modal__btnPreviewNext___3P0vE","textInfo":"modal__textInfo___3nCNm","selectCliente":"modal__selectCliente___mB1xm","bloquearUsuario_footer":"modal__bloquearUsuario_footer___38n5u","cambiarContrasena_footer":"modal__cambiarContrasena_footer___3taeh","editarUsuario_footer":"modal__editarUsuario_footer___2Yg-I","btn-50-perc":"modal__btn-50-perc___1L0yb","btn-file":"modal__btn-file___3SyG5","btnModal":"modal__btnModal___2uPiz","div-option-file":"modal__div-option-file___1peKo","originalImage":"modal__originalImage___LCJYw"};

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerRow":"TablaPendientes__headerRow___2r3wG","evenRow":"TablaPendientes__evenRow___2zv3I","oddRow":"TablaPendientes__oddRow___mybS5","headerColumn":"TablaPendientes__headerColumn___3Md5k","headerRowAPI":"TablaPendientes__headerRowAPI___1216p","evenRowAPI":"TablaPendientes__evenRowAPI___2ggJJ","oddRowAPI":"TablaPendientes__oddRowAPI___mrl7V","headerColumnAPI":"TablaPendientes__headerColumnAPI___3mi2T","celdaAPI":"TablaPendientes__celdaAPI___2AGFu","celdaAPILider":"TablaPendientes__celdaAPILider___3YwAA"};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Global = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _services = __webpack_require__(1193);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _moment = __webpack_require__(175);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Modal = __webpack_require__(1194);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Global = exports.Global = function (_Component) {
	    _inherits(Global, _Component);
	
	    function Global(props) {
	        _classCallCheck(this, Global);
	
	        var _this = _possibleConstructorReturn(this, (Global.__proto__ || Object.getPrototypeOf(Global)).call(this, props));
	
	        _this.cerrarModal = function () {
	            var hoy = (0, _moment2.default)().format('YYYY-MM-DD');
	            _services2.default.birthday.markAsViewed().catch(function (error) {
	                console.error(error);
	            }).then(function () {
	                sessionStorage.setItem('cumpleanosVisto', hoy);
	                _this.setState({
	                    showModal: false
	                });
	            });
	        };
	
	        _this.state = {
	            personas: [],
	            showModal: false
	        };
	        _this.fetchData = function () {
	            _services2.default.birthday.getBirthdayNotifications().then(function (response) {
	                if (!response.show) {
	                    return;
	                }
	                _this.setState({
	                    showModal: true,
	                    personas: response.personas
	                });
	            }).catch(function (error) {
	                console.error(error);
	            });
	        };
	        return _this;
	    }
	
	    _createClass(Global, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var hoy = (0, _moment2.default)().format('YYYY-MM-DD');
	            if (sessionStorage.getItem('cumpleanosVisto') === hoy) {
	                return;
	            }
	            this.fetchData();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_Modal2.default, {
	                showModal: this.state.showModal,
	                cancelModal: this.cerrarModal,
	                personas: this.state.personas
	            });
	        }
	    }]);
	
	    return Global;
	}(_react.Component);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Global.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	var axiosRaw = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response.message);
	    } else {
	        return Promise.resolve(response.data);
	    }
	});
	
	axiosRaw.interceptors.response.use(function (response) {
	    if (response instanceof Error) {
	        return Promise.reject(response);
	    } else {
	        return Promise.resolve(response);
	    }
	});
	
	exports.default = {
	    birthday: {
	        getBirthdayNotifications: function getBirthdayNotifications() {
	            return axios.get('/api/birthday-notifications');
	        },
	        markAsViewed: function markAsViewed() {
	            return axios.post('/api/birthday-notifications/visto');
	        }
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "services.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(317);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalNotificacion = function (_React$Component) {
	    _inherits(ModalNotificacion, _React$Component);
	
	    function ModalNotificacion(props) {
	        _classCallCheck(this, ModalNotificacion);
	
	        var _this = _possibleConstructorReturn(this, (ModalNotificacion.__proto__ || Object.getPrototypeOf(ModalNotificacion)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ModalNotificacion, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { show: this.props.showModal, onHide: this.props.cancelModal },
	                _react2.default.createElement(
	                    _Modal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _Modal2.default.Title,
	                        null,
	                        '\uD83C\uDF89 \xA1Hoy estamos de cumplea\xF1os!'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default.Body,
	                    null,
	                    this.props.personas.length === 0 ? _react2.default.createElement(
	                        'p',
	                        null,
	                        'No hay cumplea\xF1os para mostrar.'
	                    ) : _react2.default.createElement(
	                        'table',
	                        { className: 'table table-striped table-hover' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Nombre'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Rol'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Correo'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Tel\xE9fono'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            this.props.personas.map(function (persona) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: persona.id },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        persona.nombre
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        persona.rol
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        persona.correo || '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        persona.telefono || '-'
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalNotificacion;
	}(_react2.default.Component);
	
	exports.default = ModalNotificacion;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "Modal.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.listenLogout = exports.listenForegroundNotifications = exports.registerPushToken = exports.initFcm = undefined;
	
	var _services = __webpack_require__(1196);
	
	var _services2 = _interopRequireDefault(_services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initFcm = exports.initFcm = function initFcm(config) {
	
	    if (!config) return;
	
	    var firebaseConfig = {
	        apiKey: config.api_key,
	        authDomain: config.auth_domain,
	        projectId: config.project_id,
	        storageBucket: config.storage_bucket,
	        messagingSenderId: config.messaging_sender_id,
	        appId: config.app_id
	    };
	
	    var firebase = window.firebase;
	
	    if (firebase && !firebase.apps.length) {
	
	        firebase.initializeApp(firebaseConfig);
	    }
	
	    var isSupported = typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window && 'PushManager' in window;
	
	    if (!isSupported) return;
	
	    var swParams = new URLSearchParams(firebaseConfig).toString();
	
	    navigator.serviceWorker.register('/firebase-messaging-sw.js?' + swParams).then(function () {
	
	        if (Notification.permission === 'granted') {
	
	            registerPushToken(config.vapid_key);
	            listenForegroundNotifications();
	
	            return;
	        }
	
	        if (Notification.permission === 'default') {
	
	            document.addEventListener('click', function () {
	
	                Notification.requestPermission().then(function (permission) {
	
	                    if (permission !== 'granted') return;
	
	                    registerPushToken(config.vapid_key);
	                    listenForegroundNotifications();
	                });
	            }, { once: true });
	        }
	    }).catch(function (err) {
	
	        console.error('Service Worker register error', err);
	    });
	
	    listenLogout();
	};
	
	var registerPushToken = exports.registerPushToken = function registerPushToken(vapidKey) {
	
	    var firebase = window.firebase;
	
	    if (!firebase || !firebase.messaging) return;
	
	    var messaging = firebase.messaging();
	
	    navigator.serviceWorker.ready.then(function (registration) {
	
	        return messaging.getToken({ vapidKey: vapidKey, serviceWorkerRegistration: registration });
	    }).then(function (token) {
	
	        if (token) {
	
	            var data = { token: token, device_id: getDeviceId() };
	
	            return _services2.default.notifications.registerPushToken(data);
	        }
	    }).catch(function (err) {
	
	        console.error('Get fcm token error:', err);
	    });
	};
	
	var getDeviceId = function getDeviceId() {
	
	    var deviceId = localStorage.getItem('device_id');
	
	    if (!deviceId) {
	
	        deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	
	            var r = Math.random() * 16 | 0;
	            var v = c === 'x' ? r : r & 0x3 | 0x8;
	
	            return v.toString(16);
	        });
	
	        localStorage.setItem('device_id', deviceId);
	    }
	
	    return deviceId;
	};
	
	var listenForegroundNotifications = exports.listenForegroundNotifications = function listenForegroundNotifications() {
	
	    var firebase = window.firebase;
	
	    if (!firebase || !firebase.messaging) return;
	
	    var messaging = firebase.messaging();
	
	    messaging.onMessage(function (payload) {
	
	        if (document.hidden) return;
	
	        try {
	
	            var notification = payload && payload.notification ? payload.notification : {};
	            var data = payload && payload.data ? payload.data : {};
	
	            var title = notification.title || '';
	            var body = notification.body || '';
	            var path = data && data.path ? data.path : null;
	
	            if (Notification.permission === 'granted') {
	
	                var _notification = new Notification(title, { body: body, data: data });
	
	                _notification.onclick = function (e) {
	
	                    e.preventDefault();
	
	                    window.focus();
	
	                    if (path) window.location.href = path;
	
	                    _notification.close();
	                };
	            }
	        } catch (err) {
	
	            console.error('Notification error:', err);
	        }
	    });
	};
	
	var listenLogout = exports.listenLogout = function listenLogout() {
	
	    var logoutBtn = document.getElementById('logout-btn');
	
	    if (!logoutBtn) return;
	
	    logoutBtn.addEventListener('click', function (e) {
	
	        e.preventDefault();
	
	        var logoutUrl = logoutBtn.getAttribute('href');
	        var deviceId = localStorage.getItem('device_id');
	
	        if (!deviceId) {
	
	            window.location.href = logoutUrl;
	
	            return;
	        }
	
	        _services2.default.notifications.deactivatePushToken({ device_id: deviceId }).catch(function (err) {
	
	            console.log('Deactivate push token error', err);
	        }).finally(function () {
	
	            window.location.href = logoutUrl;
	        });
	    });
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "fcmService.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/var/www/sig/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/var/www/sig/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(461);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create();
	
	axios.interceptors.response.use(function (response) {
	
	    if (response instanceof Error) {
	
	        return Promise.reject(response.message);
	    } else {
	
	        return Promise.resolve(response.data);
	    }
	});
	
	exports.default = {
	    notifications: {
	        registerPushToken: function registerPushToken(data) {
	            return axios.post('/api/register-push-token', data);
	        },
	        deactivatePushToken: function deactivatePushToken(data) {
	            return axios.post('/api/deactivate-push-token', data);
	        }
	    }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/var/www/sig/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "services.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery v2.2.1 | (c) jQuery Foundation | jquery.org/license */
	!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.1",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!k.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=R.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c}catch(e){}O.set(a,b,c);
	}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.rnamespace||a.rnamespace.test(g.namespace))&&(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(b,c,e){var f=!0,g="width"===c?b.offsetWidth:b.offsetHeight,h=Ca(b),i="border-box"===n.css(b,"boxSizing",!1,h);if(d.msFullscreenElement&&a.top!==a&&b.getClientRects().length&&(g=Math.round(100*b.getBoundingClientRect()[c])),0>=g||null==g){if(g=Fa(b,c,h),(0>g||null==g)&&(g=b.style[c]),Ba.test(g))return g;f=i&&(l.boxSizingReliable()||g===b.style[c]),g=parseFloat(g)||0}return g+Oa(b,c,e||(i?"border":"content"),f,h)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,
	e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(void 0===a||"boolean"===c)&&(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){return n.trim(a.value)}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var hb=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!hb.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,hb.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b),d.isDefaultPrevented()&&c.preventDefault()}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var ib=a.location,jb=n.now(),kb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return(!c||c.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+b),c};var lb=/#.*$/,mb=/([?&])_=[^&]*/,nb=/^(.*?):[ \t]*([^\r\n]*)$/gm,ob=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,pb=/^(?:GET|HEAD)$/,qb=/^\/\//,rb={},sb={},tb="*/".concat("*"),ub=d.createElement("a");ub.href=ib.href;function vb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function wb(a,b,c,d){var e={},f=a===sb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function xb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function yb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function zb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:ib.href,type:"GET",isLocal:ob.test(ib.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":tb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?xb(xb(a,n.ajaxSettings),b):xb(n.ajaxSettings,a)},ajaxPrefilter:vb(rb),ajaxTransport:vb(sb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=nb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||ib.href)+"").replace(lb,"").replace(qb,ib.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=ub.protocol+"//"+ub.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),wb(rb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!pb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(kb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=mb.test(f)?f.replace(mb,"$1_="+jb++):f+(kb.test(f)?"&":"?")+"_="+jb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+tb+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=wb(sb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=yb(m,x,d)),u=zb(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,(b||!y)&&(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Ab=/%20/g,Bb=/\[\]$/,Cb=/\r?\n/g,Db=/^(?:submit|button|image|reset|file)$/i,Eb=/^(?:input|select|textarea|keygen)/i;function Fb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Bb.test(a)?d(a,e):Fb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Fb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Fb(c,a[c],b,e);return d.join("&").replace(Ab,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Eb.test(this.nodeName)&&!Db.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Cb,"\r\n")}}):{name:b.name,value:c.replace(Cb,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Gb={0:200,1223:204},Hb=n.ajaxSettings.xhr();l.cors=!!Hb&&"withCredentials"in Hb,l.ajax=Hb=!!Hb,n.ajaxTransport(function(b){var c,d;return l.cors||Hb&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Gb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Ib=[],Jb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Ib.pop()||n.expando+"_"+jb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Jb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Jb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Jb,"$1"+e):b.jsonp!==!1&&(b.url+=(kb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Ib.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),l.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||(l.createHTMLDocument?d.implementation.createHTMLDocument(""):d);var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Kb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Kb)return Kb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(g,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Lb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Lb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Lb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"=="function"&&__webpack_require__(1198)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return n}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Mb=a.jQuery,Nb=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Nb),b&&a.jQuery===n&&(a.jQuery=Mb),n},b||(a.jQuery=a.$=n),n});


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.3.6 (http://getbootstrap.com)
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>2)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.6",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a(f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.6",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),a(c.target).is('input[type="radio"]')||a(c.target).is('input[type="checkbox"]')||c.preventDefault()}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));return a>this.$items.length-1||0>a?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.6",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.6",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),c.isInStateTrue()?void 0:(clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide())},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);return this.$element.trigger(g),g.isDefaultPrevented()?void 0:(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=d?{top:0,left:0}:b.offset(),g={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},h=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,g,h,f)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.6",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.6",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");
	d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.6",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return c>e?"top":!1;if("bottom"==this.affixed)return null!=c?e+this.unpin<=f.top?!1:"bottom":a-d>=e+g?!1:"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&c>=e?"top":null!=d&&i+j>=a-d?"bottom":!1},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js